/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_17_0_0 = 'https://yapi.gogpay.cn/mock/2095' as any
const devUrl_0_17_0_0 = '' as any
const prodUrl_0_17_0_0 = '' as any
const dataKey_0_17_0_0 = 'data' as any

/**
 * 接口 [获取微信配置↗](https://yapi.gogpay.cn/project/2095/interface/api/34865) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [公共分类↗](https://yapi.gogpay.cn/project/2095/interface/api/cat_8965)
 * @请求头 `POST /basicThirdApi/api/wx/config`
 */
export interface ApiBasicThirdApiWxConfigRequest {
  /**
   * 当前页面地址
   */
  url: string
}

/**
 * 接口 [获取微信配置↗](https://yapi.gogpay.cn/project/2095/interface/api/34865) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [公共分类↗](https://yapi.gogpay.cn/project/2095/interface/api/cat_8965)
 * @请求头 `POST /basicThirdApi/api/wx/config`
 */
export interface ApiBasicThirdApiWxConfigResponse {
  /**
   * 是否开启debug模式
   */
  debug?: boolean
  /**
   * 微信应用Id
   */
  appId?: string
  /**
   * 时间戳
   */
  timestamp?: string
  /**
   * 请求字符
   */
  nonceStr?: string
  /**
   * 签名
   */
  signature?: string
  /**
   * js sdk接口权限列表
   */
  jsApiList?: string[]
  /**
   * js 开放标签列表
   */
  openTagList?: string[]
}

/**
 * 接口 [获取微信配置↗](https://yapi.gogpay.cn/project/2095/interface/api/34865) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [公共分类↗](https://yapi.gogpay.cn/project/2095/interface/api/cat_8965)
 * @请求头 `POST /basicThirdApi/api/wx/config`
 */
type ApiBasicThirdApiWxConfigRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2095',
    '',
    '',
    '/basicThirdApi/api/wx/config',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取微信配置↗](https://yapi.gogpay.cn/project/2095/interface/api/34865) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [公共分类↗](https://yapi.gogpay.cn/project/2095/interface/api/cat_8965)
 * @请求头 `POST /basicThirdApi/api/wx/config`
 */
const apiBasicThirdApiWxConfigRequestConfig: ApiBasicThirdApiWxConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_17_0_0,
    devUrl: devUrl_0_17_0_0,
    prodUrl: prodUrl_0_17_0_0,
    path: '/basicThirdApi/api/wx/config',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_17_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicThirdApiWxConfig',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取微信配置', author: '成龙' },
  }

/**
 * 接口 [获取微信配置↗](https://yapi.gogpay.cn/project/2095/interface/api/34865) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [公共分类↗](https://yapi.gogpay.cn/project/2095/interface/api/cat_8965)
 * @请求头 `POST /basicThirdApi/api/wx/config`
 */
export const apiBasicThirdApiWxConfig = /*#__PURE__*/ (
  requestData: ApiBasicThirdApiWxConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicThirdApiWxConfigResponse>(
    prepare(apiBasicThirdApiWxConfigRequestConfig, requestData),
    ...args,
  )
}

apiBasicThirdApiWxConfig.requestConfig = apiBasicThirdApiWxConfigRequestConfig

const mockUrl_0_12_0_0 = 'https://yapi.gogpay.cn/mock/771' as any
const devUrl_0_12_0_0 = '' as any
const prodUrl_0_12_0_0 = '' as any
const dataKey_0_12_0_0 = 'data' as any

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/95422) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/getDefault`
 */
export interface ApiBasicAddressImsApiGetDefaultRequest {
  /**
   * 多彩宝用户id
   */
  dcbUserId: string
  /**
   * 判断地址是否在服务范围内,如传入(520115,520102,),则返回列表的对应这两个地址的serviceFlag为1,不在服务范围内
   */
  districtCode?: string
}

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/95422) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/getDefault`
 */
export interface ApiBasicAddressImsApiGetDefaultResponse {
  /**
   * 二级行政区名称
   */
  city?: string
  /**
   * 二级行政区区划编码
   */
  cityCode?: string
  /**
   * 三级行政区名称
   */
  county?: string
  /**
   * 多彩宝用户id
   */
  dcbUserId?: string
  /**
   * 是否默认地址 0否1是
   */
  defaultFlag?: number
  /**
   * 详细地址及门牌号
   */
  detail?: string
  /**
   * 三级行政区区划编码
   */
  districtCode?: string
  /**
   * 主键id
   */
  id?: string
  /**
   * 手机号
   */
  phoneNo?: string
  /**
   * 一级行政区名称
   */
  province?: string
  /**
   * 一级行政区区划编码
   */
  provinceCode?: string
  /**
   * 收件人名称
   */
  receiver?: string
  /**
   * 是否在服务范围内 0否1是
   */
  serviceFlag?: number
}

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/95422) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/getDefault`
 */
type ApiBasicAddressImsApiGetDefaultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/imsApi/getDefault',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/95422) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/getDefault`
 */
const apiBasicAddressImsApiGetDefaultRequestConfig: ApiBasicAddressImsApiGetDefaultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_0,
    devUrl: devUrl_0_12_0_0,
    prodUrl: prodUrl_0_12_0_0,
    path: '/basicAddress/imsApi/getDefault',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressImsApiGetDefault',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取默认地址', author: '史博文' },
  }

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/95422) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/getDefault`
 */
export const apiBasicAddressImsApiGetDefault = /*#__PURE__*/ (
  requestData: ApiBasicAddressImsApiGetDefaultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressImsApiGetDefaultResponse>(
    prepare(apiBasicAddressImsApiGetDefaultRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressImsApiGetDefault.requestConfig =
  apiBasicAddressImsApiGetDefaultRequestConfig

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/95428) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/list`
 */
export interface ApiBasicAddressImsApiListRequest {
  /**
   * 多彩宝用户id
   */
  dcbUserId: string
  /**
   * 判断地址是否在服务范围内,如传入(520115,520102,),则返回列表的对应这两个地址的serviceFlag为1,不在服务范围内
   */
  districtCode?: string
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/95428) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/list`
 */
export interface ApiBasicAddressImsApiListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 二级行政区名称
     */
    city?: string
    /**
     * 二级行政区区划编码
     */
    cityCode?: string
    /**
     * 三级行政区名称
     */
    county?: string
    /**
     * 多彩宝用户id
     */
    dcbUserId?: string
    /**
     * 是否默认地址 0否1是
     */
    defaultFlag?: number
    /**
     * 详细地址及门牌号
     */
    detail?: string
    /**
     * 三级行政区区划编码
     */
    districtCode?: string
    /**
     * 主键id
     */
    id?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 一级行政区名称
     */
    province?: string
    /**
     * 一级行政区区划编码
     */
    provinceCode?: string
    /**
     * 收件人名称
     */
    receiver?: string
    /**
     * 是否在服务范围内 0否1是
     */
    serviceFlag?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/95428) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/list`
 */
type ApiBasicAddressImsApiListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/imsApi/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/95428) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/list`
 */
const apiBasicAddressImsApiListRequestConfig: ApiBasicAddressImsApiListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_0,
    devUrl: devUrl_0_12_0_0,
    prodUrl: prodUrl_0_12_0_0,
    path: '/basicAddress/imsApi/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressImsApiList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取收货地址列表', author: '史博文' },
  }

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/95428) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [服务间调用-地址控制层↗](https://yapi.gogpay.cn/project/771/interface/api/cat_21174)
 * @请求头 `POST /basicAddress/imsApi/list`
 */
export const apiBasicAddressImsApiList = /*#__PURE__*/ (
  requestData: ApiBasicAddressImsApiListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressImsApiListResponse>(
    prepare(apiBasicAddressImsApiListRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressImsApiList.requestConfig = apiBasicAddressImsApiListRequestConfig

const mockUrl_0_12_0_1 = 'https://yapi.gogpay.cn/mock/771' as any
const devUrl_0_12_0_1 = '' as any
const prodUrl_0_12_0_1 = '' as any
const dataKey_0_12_0_1 = 'data' as any

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19673) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/save`
 */
export interface ApiBasicAddressSaveRequest {
  /**
   * 详细地址及门牌号
   */
  detail: string
  /**
   * 是否是默认地址 0→否 1→是
   */
  defaultFlag: number
  /**
   * 一级省级行政区(省、自治区、直辖市、特别行政区)
   */
  province: string
  /**
   * 二级地级行政区(地级市、地区、自治州、盟)
   */
  city: string
  /**
   * 三级县级行政区(市辖区、县级市、县、自治县、旗、自治旗、林区、特区)
   */
  county: string
  /**
   * 区划编码
   */
  districtCode: string
  /**
   * 收件人
   */
  receiver: string
  /**
   * 手机号
   */
  phoneNo: string
  /**
   * 地址id,新增的时候不传,修改的时候必传
   */
  id?: string
}

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19673) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/save`
 */
export interface ApiBasicAddressSaveResponse {}

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19673) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/save`
 */
type ApiBasicAddressSaveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/api/save',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19673) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/save`
 */
const apiBasicAddressSaveRequestConfig: ApiBasicAddressSaveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_1,
    devUrl: devUrl_0_12_0_1,
    prodUrl: prodUrl_0_12_0_1,
    path: '/basicAddress/api/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressSave',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '(新增/修改)收货地址', author: '史博文' },
  }

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19673) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/save`
 */
export const apiBasicAddressSave = /*#__PURE__*/ (
  requestData: ApiBasicAddressSaveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressSaveResponse>(
    prepare(apiBasicAddressSaveRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressSave.requestConfig = apiBasicAddressSaveRequestConfig

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19675) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/delete`
 */
export interface ApiBasicAddressDeleteRequest {
  /**
   * 地址id
   */
  id: string
}

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19675) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/delete`
 */
export interface ApiBasicAddressDeleteResponse {}

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19675) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/delete`
 */
type ApiBasicAddressDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/api/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19675) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/delete`
 */
const apiBasicAddressDeleteRequestConfig: ApiBasicAddressDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_1,
    devUrl: devUrl_0_12_0_1,
    prodUrl: prodUrl_0_12_0_1,
    path: '/basicAddress/api/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除收货地址', author: '史博文' },
  }

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/771/interface/api/19675) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/delete`
 */
export const apiBasicAddressDelete = /*#__PURE__*/ (
  requestData: ApiBasicAddressDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressDeleteResponse>(
    prepare(apiBasicAddressDeleteRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressDelete.requestConfig = apiBasicAddressDeleteRequestConfig

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/19678) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/list`
 */
export interface ApiBasicAddressListRequest {
  /**
   * 区划编码,多个编码用","隔开,不限制则不传
   */
  districtCode: string
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/19678) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/list`
 */
export interface ApiBasicAddressListResponse {
  list?: {
    /**
     * 二级行政单位
     */
    city: string
    /**
     * 三级行政单位
     */
    county: string
    /**
     * 平台用户id
     */
    dcbUserId: string
    /**
     * 是否默认地址 0:否 1:是
     */
    defaultFlag: number
    /**
     * 地址详情及门牌号
     */
    detail: string
    /**
     * 区/县级区划编码
     */
    districtCode: string
    /**
     * 地址id
     */
    id: string
    /**
     * 收货人联系方式
     */
    phoneNo: string
    /**
     * 一级行政单位
     */
    province: string
    /**
     * 收货人
     */
    receiver: string
    /**
     * 是否在服务范围内 0:否 1:是
     */
    serviceFlag: number
    /**
     * 省级区划编码
     */
    provinceCode: string
    /**
     * 市级区划编码
     */
    cityCode: string
  }[]
  total?: number
  totalPage?: number
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/19678) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/list`
 */
type ApiBasicAddressListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/api/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/19678) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/list`
 */
const apiBasicAddressListRequestConfig: ApiBasicAddressListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_1,
    devUrl: devUrl_0_12_0_1,
    prodUrl: prodUrl_0_12_0_1,
    path: '/basicAddress/api/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取收货地址列表', author: '史博文' },
  }

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/771/interface/api/19678) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/list`
 */
export const apiBasicAddressList = /*#__PURE__*/ (
  requestData: ApiBasicAddressListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressListResponse>(
    prepare(apiBasicAddressListRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressList.requestConfig = apiBasicAddressListRequestConfig

/**
 * 接口 [获取区划列表及热门城市↗](https://yapi.gogpay.cn/project/771/interface/api/19692) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDistrictList`
 */
export interface ApiBasicAddressGetDistrictListRequest {
  /**
   * 上一级获取,level为1的时候不传
   */
  districtCode?: string
  /**
   * 区划等级
   */
  level: number
}

/**
 * 接口 [获取区划列表及热门城市↗](https://yapi.gogpay.cn/project/771/interface/api/19692) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDistrictList`
 */
export interface ApiBasicAddressGetDistrictListResponse {
  /**
   * 热门城市
   */
  hotDistrict?: {
    /**
     * 祖级区划代码
     */
    ancestorCode: string
    /**
     * 祖级区划名称
     */
    ancestorName: string
    /**
     * 区划代码
     */
    districtCode: string
    /**
     * 区划名称
     */
    districtSimpleName: string
    /**
     * 区划等级
     */
    level: number
    /**
     * 父级区划代码
     */
    parentCode: string
    /**
     * 父级区划名称
     */
    parentName: string
  }[]
  list?: {
    /**
     * 区划代码
     */
    districtCode: string
    /**
     * 区划名称
     */
    districtSimpleName: string
  }[]
  total?: number
  totalPage?: number
}

/**
 * 接口 [获取区划列表及热门城市↗](https://yapi.gogpay.cn/project/771/interface/api/19692) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDistrictList`
 */
type ApiBasicAddressGetDistrictListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/api/getDistrictList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取区划列表及热门城市↗](https://yapi.gogpay.cn/project/771/interface/api/19692) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDistrictList`
 */
const apiBasicAddressGetDistrictListRequestConfig: ApiBasicAddressGetDistrictListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_1,
    devUrl: devUrl_0_12_0_1,
    prodUrl: prodUrl_0_12_0_1,
    path: '/basicAddress/api/getDistrictList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressGetDistrictList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取区划列表及热门城市', author: '史博文' },
  }

/**
 * 接口 [获取区划列表及热门城市↗](https://yapi.gogpay.cn/project/771/interface/api/19692) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDistrictList`
 */
export const apiBasicAddressGetDistrictList = /*#__PURE__*/ (
  requestData: ApiBasicAddressGetDistrictListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressGetDistrictListResponse>(
    prepare(apiBasicAddressGetDistrictListRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressGetDistrictList.requestConfig =
  apiBasicAddressGetDistrictListRequestConfig

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/22715) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDefault`
 */
export interface ApiBasicAddressGetDefaultRequest {
  /**
   * 区划编码,多个编码用","隔开,不限制则不传
   */
  districtCode?: string
}

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/22715) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDefault`
 */
export interface ApiBasicAddressGetDefaultResponse {
  /**
   * 二级行政单位
   */
  city?: string
  /**
   * 三级行政单位
   */
  county?: string
  /**
   * 平台用户id
   */
  dcbUserId?: string
  /**
   * 是否默认地址 0:否 1:是
   */
  defaultFlag?: number
  /**
   * 地址详情及门牌号
   */
  detail?: string
  /**
   * 三级行政单位区划代码
   */
  districtCode?: string
  /**
   * 地址id
   */
  id?: string
  /**
   * 收货人联系方式
   */
  phoneNo?: string
  /**
   * 一级行政单位
   */
  province?: string
  /**
   * 收货人
   */
  receiver?: string
  /**
   * 是否在服务范围内 0:否 1:是
   */
  serviceFlag?: number
  /**
   * 省级区划编码
   */
  provinceCode: string
  /**
   * 市级区划编码
   */
  cityCode: string
}

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/22715) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDefault`
 */
type ApiBasicAddressGetDefaultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/771',
    '',
    '',
    '/basicAddress/api/getDefault',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/22715) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDefault`
 */
const apiBasicAddressGetDefaultRequestConfig: ApiBasicAddressGetDefaultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_12_0_1,
    devUrl: devUrl_0_12_0_1,
    prodUrl: prodUrl_0_12_0_1,
    path: '/basicAddress/api/getDefault',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_12_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicAddressGetDefault',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取默认地址', author: '史博文' },
  }

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/771/interface/api/22715) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端↗](https://yapi.gogpay.cn/project/771/interface/api/cat_4307)
 * @请求头 `POST /basicAddress/api/getDefault`
 */
export const apiBasicAddressGetDefault = /*#__PURE__*/ (
  requestData: ApiBasicAddressGetDefaultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicAddressGetDefaultResponse>(
    prepare(apiBasicAddressGetDefaultRequestConfig, requestData),
    ...args,
  )
}

apiBasicAddressGetDefault.requestConfig = apiBasicAddressGetDefaultRequestConfig

const mockUrl_0_19_0_1 = 'https://yapi.gogpay.cn/mock/1023' as any
const devUrl_0_19_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_19_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_19_0_1 = 'data' as any

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/1023/interface/api/29265) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/calcPostFee`
 */
export interface ApiTradeSecKillTradeSeckillCalcPostFeeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/1023/interface/api/29265) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/calcPostFee`
 */
export interface ApiTradeSecKillTradeSeckillCalcPostFeeResponse {
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费类型
       */
      postType?: string
      /**
       * 购买数量
       */
      quantity?: number
      /**
       * skuid
       */
      skuId?: string
    }[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
  }[]
}

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/1023/interface/api/29265) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/calcPostFee`
 */
type ApiTradeSecKillTradeSeckillCalcPostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1023',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeSecKill/api/trade/seckill/calcPostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/1023/interface/api/29265) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/calcPostFee`
 */
const apiTradeSecKillTradeSeckillCalcPostFeeRequestConfig: ApiTradeSecKillTradeSeckillCalcPostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_19_0_1,
    devUrl: devUrl_0_19_0_1,
    prodUrl: prodUrl_0_19_0_1,
    path: '/tradeSecKill/api/trade/seckill/calcPostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_19_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeSecKillTradeSeckillCalcPostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '计算订单的邮费', author: '成龙' },
  }

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/1023/interface/api/29265) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/calcPostFee`
 */
export const apiTradeSecKillTradeSeckillCalcPostFee = /*#__PURE__*/ (
  requestData: ApiTradeSecKillTradeSeckillCalcPostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeSecKillTradeSeckillCalcPostFeeResponse>(
    prepare(apiTradeSecKillTradeSeckillCalcPostFeeRequestConfig, requestData),
    ...args,
  )
}

apiTradeSecKillTradeSeckillCalcPostFee.requestConfig =
  apiTradeSecKillTradeSeckillCalcPostFeeRequestConfig

/**
 * 接口 [确认抢单结果↗](https://yapi.gogpay.cn/project/1023/interface/api/29269) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/confirmResult`
 */
export interface ApiTradeSecKillTradeSeckillConfirmResultRequest {}

/**
 * 接口 [确认抢单结果↗](https://yapi.gogpay.cn/project/1023/interface/api/29269) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/confirmResult`
 */
export interface ApiTradeSecKillTradeSeckillConfirmResultResponse {
  /**
   * 抢单确认状态 0正在抢单 1抢单成功 2抢单失败
   */
  confirmState?: number
  /**
   * 抢单结果提示文案
   */
  msg?: string
  /**
   * 结果数据，抢单成功才会返回。预下单和交易下单返回各自对应的数据结构
   */
  result?: {}
}

/**
 * 接口 [确认抢单结果↗](https://yapi.gogpay.cn/project/1023/interface/api/29269) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/confirmResult`
 */
type ApiTradeSecKillTradeSeckillConfirmResultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1023',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeSecKill/api/trade/seckill/confirmResult',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [确认抢单结果↗](https://yapi.gogpay.cn/project/1023/interface/api/29269) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/confirmResult`
 */
const apiTradeSecKillTradeSeckillConfirmResultRequestConfig: ApiTradeSecKillTradeSeckillConfirmResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_19_0_1,
    devUrl: devUrl_0_19_0_1,
    prodUrl: prodUrl_0_19_0_1,
    path: '/tradeSecKill/api/trade/seckill/confirmResult',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_19_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeSecKillTradeSeckillConfirmResult',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '确认抢单结果', author: '成龙' },
  }

/**
 * 接口 [确认抢单结果↗](https://yapi.gogpay.cn/project/1023/interface/api/29269) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/confirmResult`
 */
export const apiTradeSecKillTradeSeckillConfirmResult = /*#__PURE__*/ (
  requestData?: ApiTradeSecKillTradeSeckillConfirmResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeSecKillTradeSeckillConfirmResultResponse>(
    prepare(apiTradeSecKillTradeSeckillConfirmResultRequestConfig, requestData),
    ...args,
  )
}

apiTradeSecKillTradeSeckillConfirmResult.requestConfig =
  apiTradeSecKillTradeSeckillConfirmResultRequestConfig

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29273) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/preOrder`
 */
export interface ApiTradeSecKillTradeSeckillPreOrderRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 预下单类型 1购物车下单 2直接下单 3秒杀下单
   */
  preOrderType: '1' | '2' | '3'
  /**
   * 场次Id
   */
  sessionId: string
  /**
   * 购买信息
   */
  skuInfo: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 购买数量
     */
    count: number
    /**
     * SKU ID
     */
    skuId: string
  }[]
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29273) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/preOrder`
 */
export interface ApiTradeSecKillTradeSeckillPreOrderResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29273) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/preOrder`
 */
type ApiTradeSecKillTradeSeckillPreOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1023',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeSecKill/api/trade/seckill/preOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29273) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/preOrder`
 */
const apiTradeSecKillTradeSeckillPreOrderRequestConfig: ApiTradeSecKillTradeSeckillPreOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_19_0_1,
    devUrl: devUrl_0_19_0_1,
    prodUrl: prodUrl_0_19_0_1,
    path: '/tradeSecKill/api/trade/seckill/preOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_19_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeSecKillTradeSeckillPreOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预下单', author: '成龙' },
  }

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29273) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/preOrder`
 */
export const apiTradeSecKillTradeSeckillPreOrder = /*#__PURE__*/ (
  requestData: ApiTradeSecKillTradeSeckillPreOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeSecKillTradeSeckillPreOrderResponse>(
    prepare(apiTradeSecKillTradeSeckillPreOrderRequestConfig, requestData),
    ...args,
  )
}

apiTradeSecKillTradeSeckillPreOrder.requestConfig =
  apiTradeSecKillTradeSeckillPreOrderRequestConfig

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29281) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/tradeOrder`
 */
export interface ApiTradeSecKillTradeSeckillTradeOrderRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 支付方式 4微信 可不传
   */
  payType?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29281) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/tradeOrder`
 */
export interface ApiTradeSecKillTradeSeckillTradeOrderResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29281) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/tradeOrder`
 */
type ApiTradeSecKillTradeSeckillTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1023',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeSecKill/api/trade/seckill/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29281) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/tradeOrder`
 */
const apiTradeSecKillTradeSeckillTradeOrderRequestConfig: ApiTradeSecKillTradeSeckillTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_19_0_1,
    devUrl: devUrl_0_19_0_1,
    prodUrl: prodUrl_0_19_0_1,
    path: '/tradeSecKill/api/trade/seckill/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_19_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeSecKillTradeSeckillTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交易下单', author: '成龙' },
  }

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/1023/interface/api/29281) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [trade-controller↗](https://yapi.gogpay.cn/project/1023/interface/api/cat_7180)
 * @请求头 `POST /tradeSecKill/api/trade/seckill/tradeOrder`
 */
export const apiTradeSecKillTradeSeckillTradeOrder = /*#__PURE__*/ (
  requestData: ApiTradeSecKillTradeSeckillTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeSecKillTradeSeckillTradeOrderResponse>(
    prepare(apiTradeSecKillTradeSeckillTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiTradeSecKillTradeSeckillTradeOrder.requestConfig =
  apiTradeSecKillTradeSeckillTradeOrderRequestConfig

const mockUrl_0_2_0_0 = 'https://yapi.gogpay.cn/mock/963' as any
const devUrl_0_2_0_0 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_2_0_0 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_2_0_0 = 'data' as any

/**
 * 接口 [添加店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104116) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/add`
 */
export interface ApiCollectionStoreAddRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [添加店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104116) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/add`
 */
export interface ApiCollectionStoreAddResponse {}

/**
 * 接口 [添加店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104116) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/add`
 */
type ApiCollectionStoreAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/store/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104116) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/add`
 */
const apiCollectionStoreAddRequestConfig: ApiCollectionStoreAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/collection/api/store/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加店铺收藏', author: '杨大鑫' },
  }

/**
 * 接口 [添加店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104116) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/add`
 */
export const apiCollectionStoreAdd = /*#__PURE__*/ (
  requestData: ApiCollectionStoreAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreAddResponse>(
    prepare(apiCollectionStoreAddRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreAdd.requestConfig = apiCollectionStoreAddRequestConfig

/**
 * 接口 [取消店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104122) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/cancel`
 */
export interface ApiCollectionStoreCancelRequest {
  /**
   * 店铺ID列表
   */
  storeIds: string[]
}

/**
 * 接口 [取消店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104122) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/cancel`
 */
export interface ApiCollectionStoreCancelResponse {}

/**
 * 接口 [取消店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104122) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/cancel`
 */
type ApiCollectionStoreCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/store/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104122) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/cancel`
 */
const apiCollectionStoreCancelRequestConfig: ApiCollectionStoreCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/collection/api/store/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消店铺收藏', author: '杨大鑫' },
  }

/**
 * 接口 [取消店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/104122) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/cancel`
 */
export const apiCollectionStoreCancel = /*#__PURE__*/ (
  requestData: ApiCollectionStoreCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreCancelResponse>(
    prepare(apiCollectionStoreCancelRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreCancel.requestConfig = apiCollectionStoreCancelRequestConfig

/**
 * 接口 [获取店铺收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/104128) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/list`
 */
export interface ApiCollectionStoreListRequest {
  headerChannel?: string[]
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取店铺收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/104128) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/list`
 */
export interface ApiCollectionStoreListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 距离
     */
    distance?: number
    /**
     * 距离文案
     */
    distanceText?: string
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 子机构编号(店铺编号)
     */
    unitOrgCode?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbums?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 营业起始时间(HH:mm)
     */
    openStartTime?: string
    /**
     * 营业结束时间(HH:mm)
     */
    openEndTime?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 省级编码
     */
    provinceCode?: string
    /**
     * 省级名称
     */
    provinceName?: string
    /**
     * 地市编码
     */
    cityCode?: string
    /**
     * 地市名称
     */
    cityName?: string
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 乡镇街道编码
     */
    townCode?: string
    /**
     * 乡镇街道名称
     */
    townName?: string
    /**
     * 村居社区编码
     */
    communityCode?: string
    /**
     * 村居社区名称
     */
    communityName?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 店铺状态名称
     */
    storeStatusName?: string
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 推荐语
     */
    recommendWord?: string
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 好评率
     */
    praiseRate?: string
    /**
     * 店铺类型：1-标准电商,2-标准核销
     */
    storeType?: number
    /**
     * 店铺类型名称
     */
    storeTypeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 所属运营渠道ID
     */
    businessChannelId?: string
    /**
     * 所属运营渠道名称
     */
    businessChannelName?: string
    /**
     * 店铺分类
     */
    classifyList?: {
      /**
       * 店铺分类ID
       */
      storeClassifyId?: string
      /**
       * 店铺分类名称
       */
      storeClassifyName?: string
    }[][]
    storeSettlementInfo?: {
      /**
       * 结算方式：1-代收代付 2-自营
       */
      settlementMethod: number
      /**
       * 清分机构：1-见证宝 2-NC
       */
      distributionOrg: number
      /**
       * 结算逻辑：1-订单支付成功后结算 2-订单完结后进行结算
       */
      settlementLogic: number
    }
    leader?: {
      /**
       * 钉钉id
       */
      dingTalkId: string
      /**
       * 用户id
       */
      staffId: string
      /**
       * 用户名
       */
      staffName: string
      /**
       * 钉钉手机号
       */
      staffPhone: string
    }
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取店铺收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/104128) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/list`
 */
type ApiCollectionStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/store/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/104128) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/list`
 */
const apiCollectionStoreListRequestConfig: ApiCollectionStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/collection/api/store/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺收藏列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取店铺收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/104128) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/list`
 */
export const apiCollectionStoreList = /*#__PURE__*/ (
  requestData: ApiCollectionStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreListResponse>(
    prepare(apiCollectionStoreListRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreList.requestConfig = apiCollectionStoreListRequestConfig

/**
 * 接口 [获取店铺收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/104134) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/status`
 */
export interface ApiCollectionStoreStatusRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [获取店铺收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/104134) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/status`
 */
export interface ApiCollectionStoreStatusResponse {
  /**
   * 店铺收藏状态；1-已收藏，0-未收藏
   */
  status: number
}

/**
 * 接口 [获取店铺收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/104134) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/status`
 */
type ApiCollectionStoreStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/store/status',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/104134) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/status`
 */
const apiCollectionStoreStatusRequestConfig: ApiCollectionStoreStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: '/collection/api/store/status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺收藏状态', author: '杨大鑫' },
  }

/**
 * 接口 [获取店铺收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/104134) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22140)
 * @请求头 `POST /collection/api/store/status`
 */
export const apiCollectionStoreStatus = /*#__PURE__*/ (
  requestData: ApiCollectionStoreStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreStatusResponse>(
    prepare(apiCollectionStoreStatusRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreStatus.requestConfig = apiCollectionStoreStatusRequestConfig

const mockUrl_0_2_0_1 = 'https://yapi.gogpay.cn/mock/963' as any
const devUrl_0_2_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_2_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_2_0_1 = 'data' as any

/**
 * 接口 [添加店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104140) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/add`
 */
export interface ApiCollectionStoreBizAddRequest {
  /**
   * 店铺ID
   */
  storeId: string
  /**
   * 多彩宝用户ID
   */
  userId: string
}

/**
 * 接口 [添加店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104140) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/add`
 */
export interface ApiCollectionStoreBizAddResponse {}

/**
 * 接口 [添加店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104140) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/add`
 */
type ApiCollectionStoreBizAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/storeBiz/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104140) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/add`
 */
const apiCollectionStoreBizAddRequestConfig: ApiCollectionStoreBizAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/collection/api/storeBiz/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreBizAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加店铺收藏【BIZ】', author: '杨大鑫' },
  }

/**
 * 接口 [添加店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104140) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/add`
 */
export const apiCollectionStoreBizAdd = /*#__PURE__*/ (
  requestData: ApiCollectionStoreBizAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreBizAddResponse>(
    prepare(apiCollectionStoreBizAddRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreBizAdd.requestConfig = apiCollectionStoreBizAddRequestConfig

/**
 * 接口 [取消店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104146) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/cancel`
 */
export interface ApiCollectionStoreBizCancelRequest {
  /**
   * 店铺ID列表
   */
  storeIds: string[]
  /**
   * 多彩宝用户ID
   */
  userId: string
}

/**
 * 接口 [取消店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104146) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/cancel`
 */
export interface ApiCollectionStoreBizCancelResponse {}

/**
 * 接口 [取消店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104146) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/cancel`
 */
type ApiCollectionStoreBizCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/storeBiz/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104146) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/cancel`
 */
const apiCollectionStoreBizCancelRequestConfig: ApiCollectionStoreBizCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/collection/api/storeBiz/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreBizCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消店铺收藏【BIZ】', author: '杨大鑫' },
  }

/**
 * 接口 [取消店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104146) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/cancel`
 */
export const apiCollectionStoreBizCancel = /*#__PURE__*/ (
  requestData: ApiCollectionStoreBizCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreBizCancelResponse>(
    prepare(apiCollectionStoreBizCancelRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreBizCancel.requestConfig =
  apiCollectionStoreBizCancelRequestConfig

/**
 * 接口 [获取店铺收藏列表【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104152) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/list`
 */
export interface ApiCollectionStoreBizListRequest {
  /**
   * 运营渠道ID
   */
  channelId?: string[]
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 多彩宝用户ID
   */
  userId: string
}

/**
 * 接口 [获取店铺收藏列表【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104152) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/list`
 */
export interface ApiCollectionStoreBizListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 距离
     */
    distance?: number
    /**
     * 距离文案
     */
    distanceText?: string
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 子机构编号(店铺编号)
     */
    unitOrgCode?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbums?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 营业起始时间(HH:mm)
     */
    openStartTime?: string
    /**
     * 营业结束时间(HH:mm)
     */
    openEndTime?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 省级编码
     */
    provinceCode?: string
    /**
     * 省级名称
     */
    provinceName?: string
    /**
     * 地市编码
     */
    cityCode?: string
    /**
     * 地市名称
     */
    cityName?: string
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 乡镇街道编码
     */
    townCode?: string
    /**
     * 乡镇街道名称
     */
    townName?: string
    /**
     * 村居社区编码
     */
    communityCode?: string
    /**
     * 村居社区名称
     */
    communityName?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 店铺状态名称
     */
    storeStatusName?: string
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 推荐语
     */
    recommendWord?: string
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 好评率
     */
    praiseRate?: string
    /**
     * 店铺类型：1-标准电商,2-标准核销
     */
    storeType?: number
    /**
     * 店铺类型名称
     */
    storeTypeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 所属运营渠道ID
     */
    businessChannelId?: string
    /**
     * 所属运营渠道名称
     */
    businessChannelName?: string
    /**
     * 店铺分类
     */
    classifyList?: {
      /**
       * 店铺分类ID
       */
      storeClassifyId?: string
      /**
       * 店铺分类名称
       */
      storeClassifyName?: string
    }[][]
    storeSettlementInfo?: {
      /**
       * 结算方式：1-代收代付 2-自营
       */
      settlementMethod: number
      /**
       * 清分机构：1-见证宝 2-NC
       */
      distributionOrg: number
      /**
       * 结算逻辑：1-订单支付成功后结算 2-订单完结后进行结算
       */
      settlementLogic: number
    }
    leader?: {
      /**
       * 钉钉id
       */
      dingTalkId: string
      /**
       * 用户id
       */
      staffId: string
      /**
       * 用户名
       */
      staffName: string
      /**
       * 钉钉手机号
       */
      staffPhone: string
    }
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取店铺收藏列表【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104152) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/list`
 */
type ApiCollectionStoreBizListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/storeBiz/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺收藏列表【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104152) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/list`
 */
const apiCollectionStoreBizListRequestConfig: ApiCollectionStoreBizListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/collection/api/storeBiz/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreBizList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺收藏列表【BIZ】', author: '杨大鑫' },
  }

/**
 * 接口 [获取店铺收藏列表【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104152) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/list`
 */
export const apiCollectionStoreBizList = /*#__PURE__*/ (
  requestData: ApiCollectionStoreBizListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreBizListResponse>(
    prepare(apiCollectionStoreBizListRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreBizList.requestConfig = apiCollectionStoreBizListRequestConfig

/**
 * 接口 [获取店铺收藏状态【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104158) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/status`
 */
export interface ApiCollectionStoreBizStatusRequest {
  /**
   * 店铺ID
   */
  storeId: string
  /**
   * 多彩宝用户ID
   */
  userId: string
}

/**
 * 接口 [获取店铺收藏状态【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104158) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/status`
 */
export interface ApiCollectionStoreBizStatusResponse {
  /**
   * 店铺收藏状态；1-已收藏，0-未收藏
   */
  status: number
}

/**
 * 接口 [获取店铺收藏状态【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104158) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/status`
 */
type ApiCollectionStoreBizStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/storeBiz/status',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺收藏状态【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104158) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/status`
 */
const apiCollectionStoreBizStatusRequestConfig: ApiCollectionStoreBizStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: '/collection/api/storeBiz/status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionStoreBizStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺收藏状态【BIZ】', author: '杨大鑫' },
  }

/**
 * 接口 [获取店铺收藏状态【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/104158) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [店铺收藏【BIZ】↗](https://yapi.gogpay.cn/project/963/interface/api/cat_22143)
 * @请求头 `POST /collection/api/storeBiz/status`
 */
export const apiCollectionStoreBizStatus = /*#__PURE__*/ (
  requestData: ApiCollectionStoreBizStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionStoreBizStatusResponse>(
    prepare(apiCollectionStoreBizStatusRequestConfig, requestData),
    ...args,
  )
}

apiCollectionStoreBizStatus.requestConfig =
  apiCollectionStoreBizStatusRequestConfig

const mockUrl_0_2_0_3 = 'https://yapi.gogpay.cn/mock/963' as any
const devUrl_0_2_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_2_0_3 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_2_0_3 = 'data' as any

/**
 * 接口 [添加商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30289) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/add`
 */
export interface ApiCollectionCommodityGroupAddRequest {
  /**
   * 商品分组ID
   */
  commodityGroupId: string
}

/**
 * 接口 [添加商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30289) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/add`
 */
export interface ApiCollectionCommodityGroupAddResponse {}

/**
 * 接口 [添加商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30289) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/add`
 */
type ApiCollectionCommodityGroupAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodityGroup/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30289) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/add`
 */
const apiCollectionCommodityGroupAddRequestConfig: ApiCollectionCommodityGroupAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/collection/api/commodityGroup/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityGroupAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加商品分组收藏', author: '杨大鑫' },
  }

/**
 * 接口 [添加商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30289) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/add`
 */
export const apiCollectionCommodityGroupAdd = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityGroupAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityGroupAddResponse>(
    prepare(apiCollectionCommodityGroupAddRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityGroupAdd.requestConfig =
  apiCollectionCommodityGroupAddRequestConfig

/**
 * 接口 [取消商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30293) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/cancel`
 */
export interface ApiCollectionCommodityGroupCancelRequest {
  /**
   * 商品分组ID列表
   */
  commodityGroupIdList: string[]
}

/**
 * 接口 [取消商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30293) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/cancel`
 */
export interface ApiCollectionCommodityGroupCancelResponse {}

/**
 * 接口 [取消商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30293) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/cancel`
 */
type ApiCollectionCommodityGroupCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodityGroup/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30293) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/cancel`
 */
const apiCollectionCommodityGroupCancelRequestConfig: ApiCollectionCommodityGroupCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/collection/api/commodityGroup/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityGroupCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消商品分组收藏', author: '杨大鑫' },
  }

/**
 * 接口 [取消商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30293) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/cancel`
 */
export const apiCollectionCommodityGroupCancel = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityGroupCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityGroupCancelResponse>(
    prepare(apiCollectionCommodityGroupCancelRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityGroupCancel.requestConfig =
  apiCollectionCommodityGroupCancelRequestConfig

/**
 * 接口 [获取商品分组收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30297) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/list`
 */
export interface ApiCollectionCommodityGroupListRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取商品分组收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30297) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/list`
 */
export interface ApiCollectionCommodityGroupListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品分组ID
     */
    commodityGroupId: string
    /**
     * 商品分组封面图
     */
    commodityGroupPic: string
    /**
     * 商品分组子标题
     */
    commodityGroupSubTitle: string
    /**
     * 商品分组标题
     */
    commodityGroupTitle: string
    /**
     * 商品分组收藏ID
     */
    id: string
    /**
     * 商品分组下商品数量
     */
    quantity: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取商品分组收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30297) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/list`
 */
type ApiCollectionCommodityGroupListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodityGroup/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品分组收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30297) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/list`
 */
const apiCollectionCommodityGroupListRequestConfig: ApiCollectionCommodityGroupListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/collection/api/commodityGroup/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityGroupList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品分组收藏列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取商品分组收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30297) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/list`
 */
export const apiCollectionCommodityGroupList = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityGroupListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityGroupListResponse>(
    prepare(apiCollectionCommodityGroupListRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityGroupList.requestConfig =
  apiCollectionCommodityGroupListRequestConfig

/**
 * 接口 [获取商品分组收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30301) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/status`
 */
export interface ApiCollectionCommodityGroupStatusRequest {
  /**
   * 商品分组ID
   */
  commodityGroupId: string
}

/**
 * 接口 [获取商品分组收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30301) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/status`
 */
export interface ApiCollectionCommodityGroupStatusResponse {
  /**
   * 商品收藏状态；1-已收藏，0-未收藏
   */
  status: number
}

/**
 * 接口 [获取商品分组收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30301) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/status`
 */
type ApiCollectionCommodityGroupStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodityGroup/status',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品分组收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30301) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/status`
 */
const apiCollectionCommodityGroupStatusRequestConfig: ApiCollectionCommodityGroupStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: '/collection/api/commodityGroup/status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityGroupStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品分组收藏状态', author: '杨大鑫' },
  }

/**
 * 接口 [获取商品分组收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30301) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品分组收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7224)
 * @请求头 `POST /collection/api/commodityGroup/status`
 */
export const apiCollectionCommodityGroupStatus = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityGroupStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityGroupStatusResponse>(
    prepare(apiCollectionCommodityGroupStatusRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityGroupStatus.requestConfig =
  apiCollectionCommodityGroupStatusRequestConfig

const mockUrl_0_2_0_4 = 'https://yapi.gogpay.cn/mock/963' as any
const devUrl_0_2_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_2_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_2_0_4 = 'data' as any

/**
 * 接口 [取消商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30273) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/cancel`
 */
export interface ApiCollectionCommodityCancelRequest {
  /**
   * sku唯一标识列表
   */
  skuIdList: string[]
}

/**
 * 接口 [取消商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30273) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/cancel`
 */
export interface ApiCollectionCommodityCancelResponse {}

/**
 * 接口 [取消商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30273) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/cancel`
 */
type ApiCollectionCommodityCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30273) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/cancel`
 */
const apiCollectionCommodityCancelRequestConfig: ApiCollectionCommodityCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消商品收藏', author: '杨大鑫' },
  }

/**
 * 接口 [取消商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30273) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/cancel`
 */
export const apiCollectionCommodityCancel = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityCancelResponse>(
    prepare(apiCollectionCommodityCancelRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityCancel.requestConfig =
  apiCollectionCommodityCancelRequestConfig

/**
 * 接口 [获取商品收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30277) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/list`
 */
export interface ApiCollectionCommodityListRequest {
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取商品收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30277) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/list`
 */
export interface ApiCollectionCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品自动下架日期
     */
    autoDownDate?: string
    /**
     * 起售数量
     */
    beginSaleQuantity?: number
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品种类：0-套餐券 1-代金券
     */
    commodityClassifyType?: '0' | '1'
    /**
     * 商品合同标题
     */
    commodityContractTitle?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品标签
     */
    commodityLabel?: string[]
    /**
     * 商品参数json
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 商品规格
     */
    commoditySpecs?: {
      /**
       * sku属性名称
       */
      attributeName: string
      /**
       * 属性下拉参数
       */
      options: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 选中下拉参数
       */
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * sku属性ID
       */
      skuAttributeId: string
    }[]
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
     */
    commodityTradeType?: number
    /**
     * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
     */
    commodityType?: number
    /**
     * 优惠券列表
     */
    couponList?: string[]
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 当前商品价格
     */
    currentPrice: number
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 所属商城ID
     */
    martId?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 包邮类型: 1-包邮 2-运费模板
     */
    postType?: number
    /**
     * 预览路由
     */
    previewUrl?: string
    /**
     * 最低价(2.0之后用lowestPrice代替)
     */
    price?: number
    /**
     * 是否提供发票
     */
    provideInvoiceFlag?: number
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 购买须知ID
     */
    purchaseNotesId?: string
    /**
     * 类目ID
     */
    refCategoryId?: string
    /**
     * 运费模板ID
     */
    refDeliverTemplateId?: string
    /**
     * 运营渠道Id
     */
    refUserGroupId?: string
    /**
     * 售后服务: 1-换货  2-仅退款 3-退货退款
     */
    saleAfterServiceType?: number[]
    saleAfterServiceTypeSwitch?: {
      /**
       * 是否关闭换货申请 0-否 1-是
       */
      exchangeCloseFlag?: number
      /**
       * 是否关闭退货退款申请 0-否 1-是
       */
      refundAndReturnCloseFlag?: number
      /**
       * 是否关闭仅退款申请 0-否 1-是
       */
      refundOnlyCloseFlag?: number
    }
    /**
     * 销量
     */
    sales?: number
    /**
     * 搜索词
     */
    searchWord?: string[]
    /**
     * 销售渠道ID
     */
    sellChannelId?: string
    /**
     * 价格区间
     */
    sellPrices?: number[]
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType?: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases?: number
    /**
     * 发货/服务（小时内）时间
     */
    sippingOrServiceTime?: number
    /**
     * sku唯一标识
     */
    skuId: string
    /**
     * 商品规格详情
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 成本价
       */
      commoditySkuCost: number
      /**
       * SKU价格
       */
      commoditySkuPrice: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * SKU商品图
       */
      skuPic: string
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * SKU状态:0-无效 1-有效
       */
      skuStatus: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量(千克)
       */
      weight: number
    }[]
    /**
     * sku规格
     */
    skuSpecs: string
    /**
     * 库存预警
     */
    stockAlertCount?: number
    /**
     * 库存类型： 0-标准库存 3-日期库存
     */
    stockType: number
    taxRateDetail?: {
      /**
       * 税率名称
       */
      taxName: string
      /**
       * 税率编号
       */
      taxNo: string
      /**
       * 税率
       */
      taxRate: string
    }
    /**
     * 是否涉税：0-否 1-是
     */
    texFlag?: number
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
    /**
     * 上下架状态 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 上架时间
     */
    upShelfTime?: string
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases?: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 商品有效状态；1-有效，0-无效
     */
    validFlag: number
    /**
     * 失效原因
     */
    validReason?: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3'
    /**
     * 可配送范围
     */
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取商品收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30277) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/list`
 */
type ApiCollectionCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30277) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/list`
 */
const apiCollectionCommodityListRequestConfig: ApiCollectionCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品收藏列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取商品收藏列表↗](https://yapi.gogpay.cn/project/963/interface/api/30277) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/list`
 */
export const apiCollectionCommodityList = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityListResponse>(
    prepare(apiCollectionCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityList.requestConfig =
  apiCollectionCommodityListRequestConfig

/**
 * 接口 [获取收藏中降价商品数量↗](https://yapi.gogpay.cn/project/963/interface/api/30281) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/reducePriceQuantity`
 */
export interface ApiCollectionCommodityReducePriceQuantityRequest {}

/**
 * 接口 [获取收藏中降价商品数量↗](https://yapi.gogpay.cn/project/963/interface/api/30281) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/reducePriceQuantity`
 */
export interface ApiCollectionCommodityReducePriceQuantityResponse {
  /**
   * 收藏中降价商品数量
   */
  quantity: number
}

/**
 * 接口 [获取收藏中降价商品数量↗](https://yapi.gogpay.cn/project/963/interface/api/30281) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/reducePriceQuantity`
 */
type ApiCollectionCommodityReducePriceQuantityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/reducePriceQuantity',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取收藏中降价商品数量↗](https://yapi.gogpay.cn/project/963/interface/api/30281) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/reducePriceQuantity`
 */
const apiCollectionCommodityReducePriceQuantityRequestConfig: ApiCollectionCommodityReducePriceQuantityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/reducePriceQuantity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityReducePriceQuantity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取收藏中降价商品数量', author: '杨大鑫' },
  }

/**
 * 接口 [获取收藏中降价商品数量↗](https://yapi.gogpay.cn/project/963/interface/api/30281) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/reducePriceQuantity`
 */
export const apiCollectionCommodityReducePriceQuantity = /*#__PURE__*/ (
  requestData?: ApiCollectionCommodityReducePriceQuantityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityReducePriceQuantityResponse>(
    prepare(
      apiCollectionCommodityReducePriceQuantityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCollectionCommodityReducePriceQuantity.requestConfig =
  apiCollectionCommodityReducePriceQuantityRequestConfig

/**
 * 接口 [获取商品收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30285) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/status`
 */
export interface ApiCollectionCommodityStatusRequest {
  /**
   * sku唯一标识
   */
  skuId: string
}

/**
 * 接口 [获取商品收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30285) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/status`
 */
export interface ApiCollectionCommodityStatusResponse {
  /**
   * 商品收藏状态；1-已收藏，0-未收藏
   */
  status: number
}

/**
 * 接口 [获取商品收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30285) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/status`
 */
type ApiCollectionCommodityStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/status',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30285) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/status`
 */
const apiCollectionCommodityStatusRequestConfig: ApiCollectionCommodityStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品收藏状态', author: '杨大鑫' },
  }

/**
 * 接口 [获取商品收藏状态↗](https://yapi.gogpay.cn/project/963/interface/api/30285) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/status`
 */
export const apiCollectionCommodityStatus = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityStatusResponse>(
    prepare(apiCollectionCommodityStatusRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityStatus.requestConfig =
  apiCollectionCommodityStatusRequestConfig

/**
 * 接口 [添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30705) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/add`
 */
export interface ApiCollectionCommodityAddRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 来源于购物车状态；1-是，0-否
   */
  fromShoppingCartFlag?: number
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * sku唯一标识
   */
  skuId: string
}

/**
 * 接口 [添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30705) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/add`
 */
export interface ApiCollectionCommodityAddResponse {}

/**
 * 接口 [添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30705) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/add`
 */
type ApiCollectionCommodityAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30705) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/add`
 */
const apiCollectionCommodityAddRequestConfig: ApiCollectionCommodityAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加商品收藏', author: '杨大鑫' },
  }

/**
 * 接口 [添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30705) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/add`
 */
export const apiCollectionCommodityAdd = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityAddResponse>(
    prepare(apiCollectionCommodityAddRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityAdd.requestConfig = apiCollectionCommodityAddRequestConfig

/**
 * 接口 [批量添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30713) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/batchAdd`
 */
export interface ApiCollectionCommodityBatchAddRequest {
  /**
   * 商品列表
   */
  commodityList: {
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 来源于购物车状态；1-是，0-否
     */
    fromShoppingCartFlag?: number
    /**
     * 销售渠道ID
     */
    sellChannelId?: string
    /**
     * sku唯一标识
     */
    skuId: string
  }[]
}

/**
 * 接口 [批量添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30713) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/batchAdd`
 */
export interface ApiCollectionCommodityBatchAddResponse {}

/**
 * 接口 [批量添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30713) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/batchAdd`
 */
type ApiCollectionCommodityBatchAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/batchAdd',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30713) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/batchAdd`
 */
const apiCollectionCommodityBatchAddRequestConfig: ApiCollectionCommodityBatchAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/batchAdd',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityBatchAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量添加商品收藏', author: '杨大鑫' },
  }

/**
 * 接口 [批量添加商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/30713) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `POST /collection/api/commodity/batchAdd`
 */
export const apiCollectionCommodityBatchAdd = /*#__PURE__*/ (
  requestData: ApiCollectionCommodityBatchAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityBatchAddResponse>(
    prepare(apiCollectionCommodityBatchAddRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityBatchAdd.requestConfig =
  apiCollectionCommodityBatchAddRequestConfig

/**
 * 接口 [刷新商品运营渠道↗](https://yapi.gogpay.cn/project/963/interface/api/104062) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `GET /collection/api/commodity/channel`
 */
export interface ApiCollectionCommodityChannelRequest {}

/**
 * 接口 [刷新商品运营渠道↗](https://yapi.gogpay.cn/project/963/interface/api/104062) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `GET /collection/api/commodity/channel`
 */
export type ApiCollectionCommodityChannelResponse = string

/**
 * 接口 [刷新商品运营渠道↗](https://yapi.gogpay.cn/project/963/interface/api/104062) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `GET /collection/api/commodity/channel`
 */
type ApiCollectionCommodityChannelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/963',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/collection/api/commodity/channel',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [刷新商品运营渠道↗](https://yapi.gogpay.cn/project/963/interface/api/104062) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `GET /collection/api/commodity/channel`
 */
const apiCollectionCommodityChannelRequestConfig: ApiCollectionCommodityChannelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: '/collection/api/commodity/channel',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCollectionCommodityChannel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '刷新商品运营渠道', author: '杨大鑫' },
  }

/**
 * 接口 [刷新商品运营渠道↗](https://yapi.gogpay.cn/project/963/interface/api/104062) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品收藏↗](https://yapi.gogpay.cn/project/963/interface/api/cat_7225)
 * @请求头 `GET /collection/api/commodity/channel`
 */
export const apiCollectionCommodityChannel = /*#__PURE__*/ (
  requestData?: ApiCollectionCommodityChannelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCollectionCommodityChannelResponse>(
    prepare(apiCollectionCommodityChannelRequestConfig, requestData),
    ...args,
  )
}

apiCollectionCommodityChannel.requestConfig =
  apiCollectionCommodityChannelRequestConfig

const mockUrl_0_15_0_1 = 'https://yapi.gogpay.cn/mock/813' as any
const devUrl_0_15_0_1 = '' as any
const prodUrl_0_15_0_1 = '' as any
const dataKey_0_15_0_1 = 'data' as any

/**
 * 接口 [根据经纬度或者地区编码获取地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20125) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictInfo`
 */
export interface ApiBasicZoneLocationGetDistrictInfoRequest {
  /**
   * 纬度
   */
  lat: string
  /**
   * 经度
   */
  lng: string
}

/**
 * 接口 [根据经纬度或者地区编码获取地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20125) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictInfo`
 */
export interface ApiBasicZoneLocationGetDistrictInfoResponse {
  /**
   * 市级编码
   */
  cityCode: string
  /**
   * 市级名称
   */
  cityName: string
  /**
   * 国家编码
   */
  countryCode: string
  /**
   * 国家名称
   */
  countryName: string
  /**
   * 区县编码
   */
  districtCode: string
  /**
   * 区县名称
   */
  districtName: string
  /**
   * 省级编码
   */
  provinceCode: string
  /**
   * 省级名称
   */
  provinceName: string
}

/**
 * 接口 [根据经纬度或者地区编码获取地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20125) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictInfo`
 */
type ApiBasicZoneLocationGetDistrictInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/813',
    '',
    '',
    '/basicZoneLocation/api/getDistrictInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据经纬度或者地区编码获取地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20125) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictInfo`
 */
const apiBasicZoneLocationGetDistrictInfoRequestConfig: ApiBasicZoneLocationGetDistrictInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_15_0_1,
    devUrl: devUrl_0_15_0_1,
    prodUrl: prodUrl_0_15_0_1,
    path: '/basicZoneLocation/api/getDistrictInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_15_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicZoneLocationGetDistrictInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '根据经纬度或者地区编码获取地区信息',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [根据经纬度或者地区编码获取地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20125) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictInfo`
 */
export const apiBasicZoneLocationGetDistrictInfo = /*#__PURE__*/ (
  requestData: ApiBasicZoneLocationGetDistrictInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicZoneLocationGetDistrictInfoResponse>(
    prepare(apiBasicZoneLocationGetDistrictInfoRequestConfig, requestData),
    ...args,
  )
}

apiBasicZoneLocationGetDistrictInfo.requestConfig =
  apiBasicZoneLocationGetDistrictInfoRequestConfig

/**
 * 接口 [根据地区编码查询所有地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20126) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictList`
 */
export interface ApiBasicZoneLocationGetDistrictListRequest {
  /**
   * 地区编码
   */
  districtCode?: string
  /**
   * 是否需要孙子节点；1=需要(默认)，0=不需要
   */
  needSubList?: number
  /**
   * 版本号
   */
  version?: string
}

/**
 * 接口 [根据地区编码查询所有地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20126) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictList`
 */
export interface ApiBasicZoneLocationGetDistrictListResponse {
  /**
   * 区划列表
   */
  list: {
    /**
     * 子节点
     */
    childList: string[]
    /**
     * 区县编码
     */
    code: string
    /**
     * 级别；1:省级,2:市级,3:区/县级,4:镇/乡级,5:村级
     */
    level: number
    /**
     * 区县名称
     */
    name: string
    /**
     * 父级id
     */
    parentCode: string
    /**
     * 区县简称
     */
    simpleName: string
  }[]
  /**
   * 当前区划版本号
   */
  version: string
  /**
   * 是否显示省外区划；true-是，false-否
   */
  outsideProvinceFlag: boolean
}

/**
 * 接口 [根据地区编码查询所有地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20126) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictList`
 */
type ApiBasicZoneLocationGetDistrictListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/813',
    '',
    '',
    '/basicZoneLocation/api/getDistrictList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据地区编码查询所有地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20126) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictList`
 */
const apiBasicZoneLocationGetDistrictListRequestConfig: ApiBasicZoneLocationGetDistrictListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_15_0_1,
    devUrl: devUrl_0_15_0_1,
    prodUrl: prodUrl_0_15_0_1,
    path: '/basicZoneLocation/api/getDistrictList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_15_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicZoneLocationGetDistrictList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '根据地区编码查询所有地区信息', author: '杨大鑫' },
  }

/**
 * 接口 [根据地区编码查询所有地区信息↗](https://yapi.gogpay.cn/project/813/interface/api/20126) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictList`
 */
export const apiBasicZoneLocationGetDistrictList = /*#__PURE__*/ (
  requestData: ApiBasicZoneLocationGetDistrictListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicZoneLocationGetDistrictListResponse>(
    prepare(apiBasicZoneLocationGetDistrictListRequestConfig, requestData),
    ...args,
  )
}

apiBasicZoneLocationGetDistrictList.requestConfig =
  apiBasicZoneLocationGetDistrictListRequestConfig

/**
 * 接口 [根据地区编码查询所有地区信息（贵人服务）↗](https://yapi.gogpay.cn/project/813/interface/api/29073) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictListByGov`
 */
export interface ApiBasicZoneLocationGetDistrictListByGovRequest {
  /**
   * 地区编码
   */
  districtCode?: string
  /**
   * 是否需要孙子节点；1=需要(默认)，0=不需要
   */
  needSubList?: number
  /**
   * 版本号
   */
  version?: string
}

/**
 * 接口 [根据地区编码查询所有地区信息（贵人服务）↗](https://yapi.gogpay.cn/project/813/interface/api/29073) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictListByGov`
 */
export interface ApiBasicZoneLocationGetDistrictListByGovResponse {
  /**
   * 区划列表
   */
  list: {
    /**
     * 子节点
     */
    childList: string[]
    /**
     * 区县编码
     */
    code: string
    /**
     * 级别；1:省级,2:市级,3:区/县级,4:镇/乡级,5:村级
     */
    level: number
    /**
     * 区县名称
     */
    name: string
    /**
     * 父级id
     */
    parentCode: string
    /**
     * 区县简称
     */
    simpleName: string
  }[]
  /**
   * 当前区划版本号
   */
  version: string
  /**
   * 是否显示省外区划；true-是，false-否
   */
  outsideProvinceFlag: boolean
}

/**
 * 接口 [根据地区编码查询所有地区信息（贵人服务）↗](https://yapi.gogpay.cn/project/813/interface/api/29073) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictListByGov`
 */
type ApiBasicZoneLocationGetDistrictListByGovRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/813',
    '',
    '',
    '/basicZoneLocation/api/getDistrictListByGov',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据地区编码查询所有地区信息（贵人服务）↗](https://yapi.gogpay.cn/project/813/interface/api/29073) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictListByGov`
 */
const apiBasicZoneLocationGetDistrictListByGovRequestConfig: ApiBasicZoneLocationGetDistrictListByGovRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_15_0_1,
    devUrl: devUrl_0_15_0_1,
    prodUrl: prodUrl_0_15_0_1,
    path: '/basicZoneLocation/api/getDistrictListByGov',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_15_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBasicZoneLocationGetDistrictListByGov',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '根据地区编码查询所有地区信息（贵人服务）',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [根据地区编码查询所有地区信息（贵人服务）↗](https://yapi.gogpay.cn/project/813/interface/api/29073) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端—区划定位↗](https://yapi.gogpay.cn/project/813/interface/api/cat_5140)
 * @请求头 `POST /basicZoneLocation/api/getDistrictListByGov`
 */
export const apiBasicZoneLocationGetDistrictListByGov = /*#__PURE__*/ (
  requestData: ApiBasicZoneLocationGetDistrictListByGovRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBasicZoneLocationGetDistrictListByGovResponse>(
    prepare(apiBasicZoneLocationGetDistrictListByGovRequestConfig, requestData),
    ...args,
  )
}

apiBasicZoneLocationGetDistrictListByGov.requestConfig =
  apiBasicZoneLocationGetDistrictListByGovRequestConfig

const mockUrl_0_14_0_1 = 'https://yapi.gogpay.cn/mock/2113' as any
const devUrl_0_14_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_14_0_1 = '' as any
const dataKey_0_14_0_1 = 'data' as any

/**
 * 接口 [查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/34985) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detail`
 */
export interface ApiHouseholdElectricProductDetailRequest {
  /**
   * 购买数量
   */
  buyCount: number
  /**
   * 区划：区/县编码
   */
  countyCode: string
  /**
   * 商品id
   */
  productId: string
}

/**
 * 接口 [查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/34985) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detail`
 */
export interface ApiHouseholdElectricProductDetailResponse {
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品资源ID
   */
  commodityResourceId?: string
  /**
   * 商品卖点
   */
  commoditySellingPoint?: string
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品总库存(1.2.0弃用)
   */
  commodityTotalStock?: number
  /**
   * 商品交易类型: 0-中台下单 1-业务下单
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 分润比例（1.2.0弃用）
   */
  distributionProfitRatio?: number
  /**
   * 主视频
   */
  majorVideo?: string
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 包邮类型 0-不包邮 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 价格
   */
  price?: number
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 订购须知正文
   */
  purchasePromptText?: string
  /**
   * 订购须知标题
   */
  purchasePromptTitle?: string
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 所属分组
   */
  refUserGroupId?: string
  /**
   * 售后规则正文
   */
  saleAfterRuleText?: string
  /**
   * 售后规则标题
   */
  saleAfterRuleTitle?: string
  /**
   * 售后服务 0-七天无理由退货退款 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 是否参与秒杀 0-否 1-是
   */
  secondKillFlag?: number
  /**
   * 分享描述
   */
  shareDescription?: string
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 库存预警
   */
  stockAlertCount?: number
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
}

/**
 * 接口 [查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/34985) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detail`
 */
type ApiHouseholdElectricProductDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/product/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/34985) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detail`
 */
const apiHouseholdElectricProductDetailRequestConfig: ApiHouseholdElectricProductDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_1,
    devUrl: devUrl_0_14_0_1,
    prodUrl: prodUrl_0_14_0_1,
    path: '/householdElectric/api/product/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricProductDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品详情', author: '324号开发' },
  }

/**
 * 接口 [查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/34985) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detail`
 */
export const apiHouseholdElectricProductDetail = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricProductDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricProductDetailResponse>(
    prepare(apiHouseholdElectricProductDetailRequestConfig, requestData),
    ...args,
  )
}

apiHouseholdElectricProductDetail.requestConfig =
  apiHouseholdElectricProductDetailRequestConfig

/**
 * 接口 [批量查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/35001) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detailMore`
 */
export interface ApiHouseholdElectricProductDetailMoreRequest {
  /**
   * 查询参数集合
   */
  queryFormList: {
    /**
     * 购买数量
     */
    buyCount: number
    /**
     * 区划：区/县编码
     */
    countyCode: string
    /**
     * 商品id
     */
    productId: string
  }[]
}

/**
 * 接口 [批量查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/35001) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detailMore`
 */
export type ApiHouseholdElectricProductDetailMoreResponse = {
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品资源ID
   */
  commodityResourceId?: string
  /**
   * 商品卖点
   */
  commoditySellingPoint?: string
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品总库存(1.2.0弃用)
   */
  commodityTotalStock?: number
  /**
   * 商品交易类型: 0-中台下单 1-业务下单
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 分润比例（1.2.0弃用）
   */
  distributionProfitRatio?: number
  /**
   * 主视频
   */
  majorVideo?: string
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 包邮类型 0-不包邮 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 价格
   */
  price?: number
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 订购须知正文
   */
  purchasePromptText?: string
  /**
   * 订购须知标题
   */
  purchasePromptTitle?: string
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 所属分组
   */
  refUserGroupId?: string
  /**
   * 售后规则正文
   */
  saleAfterRuleText?: string
  /**
   * 售后规则标题
   */
  saleAfterRuleTitle?: string
  /**
   * 售后服务 0-七天无理由退货退款 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 是否参与秒杀 0-否 1-是
   */
  secondKillFlag?: number
  /**
   * 分享描述
   */
  shareDescription?: string
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 库存预警
   */
  stockAlertCount?: number
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
}[]

/**
 * 接口 [批量查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/35001) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detailMore`
 */
type ApiHouseholdElectricProductDetailMoreRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/product/detailMore',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/35001) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detailMore`
 */
const apiHouseholdElectricProductDetailMoreRequestConfig: ApiHouseholdElectricProductDetailMoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_1,
    devUrl: devUrl_0_14_0_1,
    prodUrl: prodUrl_0_14_0_1,
    path: '/householdElectric/api/product/detailMore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricProductDetailMore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量查询商品详情', author: '324号开发' },
  }

/**
 * 接口 [批量查询商品详情↗](https://yapi.gogpay.cn/project/2113/interface/api/35001) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/detailMore`
 */
export const apiHouseholdElectricProductDetailMore = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricProductDetailMoreRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricProductDetailMoreResponse>(
    prepare(apiHouseholdElectricProductDetailMoreRequestConfig, requestData),
    ...args,
  )
}

apiHouseholdElectricProductDetailMore.requestConfig =
  apiHouseholdElectricProductDetailMoreRequestConfig

/**
 * 接口 [根据商品id查询sku列表，库存及价格↗](https://yapi.gogpay.cn/project/2113/interface/api/35317) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/querySkuList`
 */
export interface ApiHouseholdElectricProductQuerySkuListRequest {
  /**
   * 购买数量
   */
  buyCount: number
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 区划：区/县编码
   */
  countyCode: string
}

/**
 * 接口 [根据商品id查询sku列表，库存及价格↗](https://yapi.gogpay.cn/project/2113/interface/api/35317) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/querySkuList`
 */
export type ApiHouseholdElectricProductQuerySkuListResponse = {
  /**
   * 成本价
   */
  commoditySkuCost: number
  /**
   * 原价或秒杀价
   */
  commoditySkuPrice: number
  /**
   * sku库存
   */
  commodityStock: number
  /**
   * 分润比例（%）
   */
  distributionProfitRatio: number
  /**
   * SKU主键
   */
  id: string
  /**
   * SKU最低价(1.0.0已经弃用)
   */
  lowestPrice: number
  /**
   * 原价
   */
  price: number
  /**
   * 商品ID
   */
  refCommodityId: string
  /**
   * 单日限购量
   */
  singleDayLimitPurchases: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键
       */
      key: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * 总库存(1.0.0已经弃用)
   */
  totalStock: number
  /**
   * 虚拟销量
   */
  virtualSales: number
  /**
   * 重量(克)
   */
  weight: number
}[]

/**
 * 接口 [根据商品id查询sku列表，库存及价格↗](https://yapi.gogpay.cn/project/2113/interface/api/35317) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/querySkuList`
 */
type ApiHouseholdElectricProductQuerySkuListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/product/querySkuList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据商品id查询sku列表，库存及价格↗](https://yapi.gogpay.cn/project/2113/interface/api/35317) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/querySkuList`
 */
const apiHouseholdElectricProductQuerySkuListRequestConfig: ApiHouseholdElectricProductQuerySkuListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_1,
    devUrl: devUrl_0_14_0_1,
    prodUrl: prodUrl_0_14_0_1,
    path: '/householdElectric/api/product/querySkuList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricProductQuerySkuList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '根据商品id查询sku列表，库存及价格',
      author: '324号开发',
    },
  }

/**
 * 接口 [根据商品id查询sku列表，库存及价格↗](https://yapi.gogpay.cn/project/2113/interface/api/35317) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--商品信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8985)
 * @请求头 `POST /householdElectric/api/product/querySkuList`
 */
export const apiHouseholdElectricProductQuerySkuList = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricProductQuerySkuListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricProductQuerySkuListResponse>(
    prepare(apiHouseholdElectricProductQuerySkuListRequestConfig, requestData),
    ...args,
  )
}

apiHouseholdElectricProductQuerySkuList.requestConfig =
  apiHouseholdElectricProductQuerySkuListRequestConfig

const mockUrl_0_14_0_2 = 'https://yapi.gogpay.cn/mock/2113' as any
const devUrl_0_14_0_2 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_14_0_2 = '' as any
const dataKey_0_14_0_2 = 'data' as any

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34981) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/preOrder`
 */
export interface ApiHouseholdElectricOrderPreOrderRequest {
  /**
   * 区划：区/县编码
   */
  countyCode: string
  /**
   * 预下单类型 1购物车下单 2直接下单 3秒杀下单
   */
  preOrderType: number
  /**
   * 购买信息
   */
  skuInfo: {
    /**
     * 业务系统传入商成本价格，不传则使用中台价格计算
     */
    bizCostPrice: number
    /**
     * 业务系统传入商品单价，不传则使用中台价格计算
     */
    bizUnitPrice: number
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 购买数量
     */
    count: number
    /**
     * SKU ID
     */
    skuId: string
  }[]
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34981) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/preOrder`
 */
export interface ApiHouseholdElectricOrderPreOrderResponse {
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 成本价，业务下单才会返回
       */
      costPrice?: number
      /**
       * 购买数量
       */
      count?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费类型
       */
      postType?: string
      /**
       * 购买数量
       */
      quantity?: number
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 重量（克）
       */
      weight?: number
    }[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
  }[]
  orderType?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34981) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/preOrder`
 */
type ApiHouseholdElectricOrderPreOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/order/preOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34981) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/preOrder`
 */
const apiHouseholdElectricOrderPreOrderRequestConfig: ApiHouseholdElectricOrderPreOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_2,
    devUrl: devUrl_0_14_0_2,
    prodUrl: prodUrl_0_14_0_2,
    path: '/householdElectric/api/order/preOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricOrderPreOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预下单', author: '324号开发' },
  }

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34981) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/preOrder`
 */
export const apiHouseholdElectricOrderPreOrder = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricOrderPreOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricOrderPreOrderResponse>(
    prepare(apiHouseholdElectricOrderPreOrderRequestConfig, requestData),
    ...args,
  )
}

apiHouseholdElectricOrderPreOrder.requestConfig =
  apiHouseholdElectricOrderPreOrderRequestConfig

/**
 * 接口 [计算运费↗](https://yapi.gogpay.cn/project/2113/interface/api/34989) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/calcPostFee`
 */
export interface ApiHouseholdElectricOrderCalcPostFeeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [计算运费↗](https://yapi.gogpay.cn/project/2113/interface/api/34989) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/calcPostFee`
 */
export interface ApiHouseholdElectricOrderCalcPostFeeResponse {
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 成本价，业务下单才会返回
       */
      costPrice?: number
      /**
       * 购买数量
       */
      count?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费类型
       */
      postType?: string
      /**
       * 购买数量
       */
      quantity?: number
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 重量（克）
       */
      weight?: number
    }[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
  }[]
}

/**
 * 接口 [计算运费↗](https://yapi.gogpay.cn/project/2113/interface/api/34989) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/calcPostFee`
 */
type ApiHouseholdElectricOrderCalcPostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/order/calcPostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [计算运费↗](https://yapi.gogpay.cn/project/2113/interface/api/34989) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/calcPostFee`
 */
const apiHouseholdElectricOrderCalcPostFeeRequestConfig: ApiHouseholdElectricOrderCalcPostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_2,
    devUrl: devUrl_0_14_0_2,
    prodUrl: prodUrl_0_14_0_2,
    path: '/householdElectric/api/order/calcPostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricOrderCalcPostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '计算运费', author: '324号开发' },
  }

/**
 * 接口 [计算运费↗](https://yapi.gogpay.cn/project/2113/interface/api/34989) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/calcPostFee`
 */
export const apiHouseholdElectricOrderCalcPostFee = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricOrderCalcPostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricOrderCalcPostFeeResponse>(
    prepare(apiHouseholdElectricOrderCalcPostFeeRequestConfig, requestData),
    ...args,
  )
}

apiHouseholdElectricOrderCalcPostFee.requestConfig =
  apiHouseholdElectricOrderCalcPostFeeRequestConfig

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34993) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/tradeOrder`
 */
export interface ApiHouseholdElectricOrderTradeOrderRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName: string
  /**
   * 收货人手机号
   */
  consigneeTel: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34993) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/tradeOrder`
 */
export interface ApiHouseholdElectricOrderTradeOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单Id
   */
  orderId?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 商城中台的订单Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 业务系统传入商成本价格，不传则使用中台价格计算
       */
      bizCostPrice: number
      /**
       * 业务系统传入商品单价，不传则使用中台价格计算
       */
      bizUnitPrice: number
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      /**
       * SKU ID
       */
      skuId: string
    }[]
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34993) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/tradeOrder`
 */
type ApiHouseholdElectricOrderTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/order/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34993) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/tradeOrder`
 */
const apiHouseholdElectricOrderTradeOrderRequestConfig: ApiHouseholdElectricOrderTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_2,
    devUrl: devUrl_0_14_0_2,
    prodUrl: prodUrl_0_14_0_2,
    path: '/householdElectric/api/order/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricOrderTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交易下单', author: '324号开发' },
  }

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2113/interface/api/34993) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--订单信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_8990)
 * @请求头 `POST /householdElectric/api/order/tradeOrder`
 */
export const apiHouseholdElectricOrderTradeOrder = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricOrderTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricOrderTradeOrderResponse>(
    prepare(apiHouseholdElectricOrderTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiHouseholdElectricOrderTradeOrder.requestConfig =
  apiHouseholdElectricOrderTradeOrderRequestConfig

const mockUrl_0_14_0_3 = 'https://yapi.gogpay.cn/mock/2113' as any
const devUrl_0_14_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_14_0_3 = '' as any
const dataKey_0_14_0_3 = 'data' as any

/**
 * 接口 [申请补开发票↗](https://yapi.gogpay.cn/project/2113/interface/api/35313) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端--发票信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_9130)
 * @请求头 `POST /householdElectric/api/invoice/applyInvoiceInfo`
 */
export interface ApiHouseholdElectricInvoiceApplyInvoiceInfoRequest {
  /**
   * 企业地址
   */
  address?: string
  /**
   * 银行账号
   */
  bankAccount?: string
  /**
   * 开户银行
   */
  bankName?: string
  /**
   * 发票邮箱地址
   */
  email?: string
  /**
   * 商户id
   */
  merchantId: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 纳税人识别号
   */
  taxPayerNumber?: string
  /**
   * 发票抬头
   */
  title: string
  /**
   * 抬头类型 1个人 2企业
   */
  titleType: number
}

/**
 * 接口 [申请补开发票↗](https://yapi.gogpay.cn/project/2113/interface/api/35313) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端--发票信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_9130)
 * @请求头 `POST /householdElectric/api/invoice/applyInvoiceInfo`
 */
export interface ApiHouseholdElectricInvoiceApplyInvoiceInfoResponse {}

/**
 * 接口 [申请补开发票↗](https://yapi.gogpay.cn/project/2113/interface/api/35313) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端--发票信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_9130)
 * @请求头 `POST /householdElectric/api/invoice/applyInvoiceInfo`
 */
type ApiHouseholdElectricInvoiceApplyInvoiceInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2113',
    'https://mall-gw.duotest.cn',
    '',
    '/householdElectric/api/invoice/applyInvoiceInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请补开发票↗](https://yapi.gogpay.cn/project/2113/interface/api/35313) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端--发票信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_9130)
 * @请求头 `POST /householdElectric/api/invoice/applyInvoiceInfo`
 */
const apiHouseholdElectricInvoiceApplyInvoiceInfoRequestConfig: ApiHouseholdElectricInvoiceApplyInvoiceInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_14_0_3,
    devUrl: devUrl_0_14_0_3,
    prodUrl: prodUrl_0_14_0_3,
    path: '/householdElectric/api/invoice/applyInvoiceInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_14_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiHouseholdElectricInvoiceApplyInvoiceInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请补开发票', author: '324号开发' },
  }

/**
 * 接口 [申请补开发票↗](https://yapi.gogpay.cn/project/2113/interface/api/35313) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端--发票信息↗](https://yapi.gogpay.cn/project/2113/interface/api/cat_9130)
 * @请求头 `POST /householdElectric/api/invoice/applyInvoiceInfo`
 */
export const apiHouseholdElectricInvoiceApplyInvoiceInfo = /*#__PURE__*/ (
  requestData: ApiHouseholdElectricInvoiceApplyInvoiceInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiHouseholdElectricInvoiceApplyInvoiceInfoResponse>(
    prepare(
      apiHouseholdElectricInvoiceApplyInvoiceInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiHouseholdElectricInvoiceApplyInvoiceInfo.requestConfig =
  apiHouseholdElectricInvoiceApplyInvoiceInfoRequestConfig

const mockUrl_0_21_0_1 = 'https://yapi.gogpay.cn/mock/2447' as any
const devUrl_0_21_0_1 = '' as any
const prodUrl_0_21_0_1 = '' as any
const dataKey_0_21_0_1 = 'data' as any

/**
 * 接口 [分组商品列表↗](https://yapi.gogpay.cn/project/2447/interface/api/83817) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/commodityList`
 */
export interface ApiGroupBuyingActivityCommodityListRequest {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 分组Id
   */
  groupId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [分组商品列表↗](https://yapi.gogpay.cn/project/2447/interface/api/83817) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/commodityList`
 */
export interface ApiGroupBuyingActivityCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityImage?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品类型:0-标准电商 1-派单核销 2-标准虚拟
     */
    commodityType?: number
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 拼团价格
     */
    groupPrice?: number
    /**
     * 拼团类型 NORMAL:普通 LADDER：阶梯团
     */
    groupType?: 'NORMAL' | 'LADDER'
    /**
     * 成团人数
     */
    groupUserCount?: number
    /**
     * 商品价格
     */
    price?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [分组商品列表↗](https://yapi.gogpay.cn/project/2447/interface/api/83817) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/commodityList`
 */
type ApiGroupBuyingActivityCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/activity/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分组商品列表↗](https://yapi.gogpay.cn/project/2447/interface/api/83817) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/commodityList`
 */
const apiGroupBuyingActivityCommodityListRequestConfig: ApiGroupBuyingActivityCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_1,
    devUrl: devUrl_0_21_0_1,
    prodUrl: prodUrl_0_21_0_1,
    path: '/groupBuying/api/activity/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingActivityCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分组商品列表', author: '成龙' },
  }

/**
 * 接口 [分组商品列表↗](https://yapi.gogpay.cn/project/2447/interface/api/83817) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/commodityList`
 */
export const apiGroupBuyingActivityCommodityList = /*#__PURE__*/ (
  requestData: ApiGroupBuyingActivityCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingActivityCommodityListResponse>(
    prepare(apiGroupBuyingActivityCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingActivityCommodityList.requestConfig =
  apiGroupBuyingActivityCommodityListRequestConfig

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2447/interface/api/83822) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/index`
 */
export interface ApiGroupBuyingActivityIndexRequest {
  /**
   * 活动Id
   */
  activityId: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2447/interface/api/83822) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/index`
 */
export interface ApiGroupBuyingActivityIndexResponse {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 活动背景图
   */
  backgroundImg?: string
  /**
   * 默认分组的第一页商品列表
   */
  commodityList?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityImage?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品类型:0-标准电商 1-派单核销 2-标准虚拟
     */
    commodityType?: number
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 拼团价格
     */
    groupPrice?: number
    /**
     * 拼团类型 NORMAL:普通 LADDER：阶梯团
     */
    groupType?: 'NORMAL' | 'LADDER'
    /**
     * 成团人数
     */
    groupUserCount?: number
    /**
     * 商品价格
     */
    price?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  /**
   * 分组列表
   */
  groupList?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品数量
     */
    commodityCount?: number
    /**
     * 分组Id
     */
    groupId?: string
    /**
     * 分组图片
     */
    groupImage?: string
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 活动是否有效
   */
  hasActivity: boolean
  /**
   * 活动规则地址
   */
  ruleUrl?: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2447/interface/api/83822) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/index`
 */
type ApiGroupBuyingActivityIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/activity/index',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2447/interface/api/83822) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/index`
 */
const apiGroupBuyingActivityIndexRequestConfig: ApiGroupBuyingActivityIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_1,
    devUrl: devUrl_0_21_0_1,
    prodUrl: prodUrl_0_21_0_1,
    path: '/groupBuying/api/activity/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingActivityIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '活动首页', author: '成龙' },
  }

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2447/interface/api/83822) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动信息↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19369)
 * @请求头 `POST /groupBuying/api/activity/index`
 */
export const apiGroupBuyingActivityIndex = /*#__PURE__*/ (
  requestData: ApiGroupBuyingActivityIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingActivityIndexResponse>(
    prepare(apiGroupBuyingActivityIndexRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingActivityIndex.requestConfig =
  apiGroupBuyingActivityIndexRequestConfig

const mockUrl_0_21_0_2 = 'https://yapi.gogpay.cn/mock/2447' as any
const devUrl_0_21_0_2 = '' as any
const prodUrl_0_21_0_2 = '' as any
const dataKey_0_21_0_2 = 'data' as any

/**
 * 接口 [计算邮费↗](https://yapi.gogpay.cn/project/2447/interface/api/83902) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/calcPostFee`
 */
export interface ApiGroupBuyingTradeCalcPostFeeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [计算邮费↗](https://yapi.gogpay.cn/project/2447/interface/api/83902) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/calcPostFee`
 */
export interface ApiGroupBuyingTradeCalcPostFeeResponse {
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 成本价，业务下单才会返回
       */
      costPrice?: number
      /**
       * 购买数量
       */
      count?: number
      discountActivity?: {
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 活动名称
         */
        name?: string
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 购买数量
       */
      quantity?: number
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 可配送区域
       */
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }[]
    }[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
  }[]
}

/**
 * 接口 [计算邮费↗](https://yapi.gogpay.cn/project/2447/interface/api/83902) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/calcPostFee`
 */
type ApiGroupBuyingTradeCalcPostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/trade/calcPostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [计算邮费↗](https://yapi.gogpay.cn/project/2447/interface/api/83902) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/calcPostFee`
 */
const apiGroupBuyingTradeCalcPostFeeRequestConfig: ApiGroupBuyingTradeCalcPostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_2,
    devUrl: devUrl_0_21_0_2,
    prodUrl: prodUrl_0_21_0_2,
    path: '/groupBuying/api/trade/calcPostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingTradeCalcPostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '计算邮费', author: '成龙' },
  }

/**
 * 接口 [计算邮费↗](https://yapi.gogpay.cn/project/2447/interface/api/83902) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/calcPostFee`
 */
export const apiGroupBuyingTradeCalcPostFee = /*#__PURE__*/ (
  requestData: ApiGroupBuyingTradeCalcPostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingTradeCalcPostFeeResponse>(
    prepare(apiGroupBuyingTradeCalcPostFeeRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingTradeCalcPostFee.requestConfig =
  apiGroupBuyingTradeCalcPostFeeRequestConfig

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83907) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/preOrder`
 */
export interface ApiGroupBuyingTradePreOrderRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 参团订单Id，不传则为新建团
   */
  groupOrderId?: string
  /**
   * 预下单类型 1购物车下单 2直接下单 3秒杀下单
   */
  preOrderType: '1' | '2' | '3'
  /**
   * 购买信息
   */
  skuInfo: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 购买数量
     */
    count: number
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 销售渠道Id
     */
    sellChannelId?: string
    /**
     * SKU ID
     */
    skuId: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 购买日期 格式 yyyy-MM-dd
     */
    stockDate?: string
    /**
     * 购买结束日期 格式 yyyy-MM-dd
     */
    stockEndDate?: string
  }[]
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83907) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/preOrder`
 */
export interface ApiGroupBuyingTradePreOrderResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 业务类型
   */
  businessType?: string
  /**
   * 是否计算过邮费
   */
  calcPostFeeFlag?: boolean
  /**
   * 积分抵扣项目列表
   */
  channelActivityItems?: {
    /**
     * 余额
     */
    balance?: string
    /**
     * 余额单位
     */
    balanceUnit?: string
    /**
     * 是否可抵扣
     */
    deduction?: boolean
    /**
     * 活动Id
     */
    id?: string
    /**
     * 是否需要密码
     */
    needPassword?: boolean
    /**
     * 不支持抵扣原因
     */
    noDeductionReason?: string
    passwordKeyboard?: {
      /**
       * 密码值列表
       */
      keys?: {
        /**
         * 密码数字
         */
        key?: number
        /**
         * 密码数字混淆值
         */
        keySlat?: number
        /**
         * 密码值
         */
        value?: string
      }[]
    }
    /**
     * 渠道名称
     */
    title?: string
  }[]
  closeOrderValue?: number
  /**
   * 折扣优惠消费ticket
   */
  discountActivityTicket?: string
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 团单Id
   */
  groupOrderId?: string
  /**
   * 团单类型 NORMAL:普通团  LADDER：阶梯团
   */
  groupType?: 'NORMAL' | 'LADDER'
  /**
   * 是否可以选择核销店铺
   */
  hasChooseWriteOffStore?: boolean
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 是否需要收货地址
   */
  needAddress?: boolean
  /**
   * 是否需要使用日期
   */
  needUseDate?: boolean
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 活动名称
         */
        name?: string
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      /**
       * 可配送区域
       */
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  orderType?: number
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
   */
  preOrderContentType?: '1' | '2' | '4' | '5' | '3'
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
  /**
   * 规则地址
   */
  ruleUrl?: string
  /**
   * 是否支持积分支付
   */
  supportPayType?: boolean
  /**
   * 是否为翼支付支付：true-是，false否
   */
  supportYiPay?: boolean
  /**
   * 提示信息
   */
  tips?: string
  /**
   * 订单包含的子机构编码
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83907) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/preOrder`
 */
type ApiGroupBuyingTradePreOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/trade/preOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83907) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/preOrder`
 */
const apiGroupBuyingTradePreOrderRequestConfig: ApiGroupBuyingTradePreOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_2,
    devUrl: devUrl_0_21_0_2,
    prodUrl: prodUrl_0_21_0_2,
    path: '/groupBuying/api/trade/preOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingTradePreOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预下单', author: '成龙' },
  }

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83907) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/preOrder`
 */
export const apiGroupBuyingTradePreOrder = /*#__PURE__*/ (
  requestData: ApiGroupBuyingTradePreOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingTradePreOrderResponse>(
    prepare(apiGroupBuyingTradePreOrderRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingTradePreOrder.requestConfig =
  apiGroupBuyingTradePreOrderRequestConfig

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83912) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/tradeOrder`
 */
export interface ApiGroupBuyingTradeTradeOrderRequest {
  clientType?: '1' | '2' | '3'
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  headerChannel?: string[]
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '18'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
    /**
     * 核销门店Id
     */
    writeOffStoreId?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83912) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/tradeOrder`
 */
export interface ApiGroupBuyingTradeTradeOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 团单Id
   */
  groupOrderId?: string
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83912) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/tradeOrder`
 */
type ApiGroupBuyingTradeTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/trade/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83912) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/tradeOrder`
 */
const apiGroupBuyingTradeTradeOrderRequestConfig: ApiGroupBuyingTradeTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_2,
    devUrl: devUrl_0_21_0_2,
    prodUrl: prodUrl_0_21_0_2,
    path: '/groupBuying/api/trade/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingTradeTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交易下单', author: '成龙' },
  }

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/83912) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19405)
 * @请求头 `POST /groupBuying/api/trade/tradeOrder`
 */
export const apiGroupBuyingTradeTradeOrder = /*#__PURE__*/ (
  requestData: ApiGroupBuyingTradeTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingTradeTradeOrderResponse>(
    prepare(apiGroupBuyingTradeTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingTradeTradeOrder.requestConfig =
  apiGroupBuyingTradeTradeOrderRequestConfig

const mockUrl_0_21_0_3 = 'https://yapi.gogpay.cn/mock/2447' as any
const devUrl_0_21_0_3 = '' as any
const prodUrl_0_21_0_3 = '' as any
const dataKey_0_21_0_3 = 'data' as any

/**
 * 接口 [获取团单基本信息↗](https://yapi.gogpay.cn/project/2447/interface/api/83897) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderInfo`
 */
export interface ApiGroupBuyingOrderGroupOrderInfoRequest {
  /**
   * 订单Id
   */
  orderId: string
}

/**
 * 接口 [获取团单基本信息↗](https://yapi.gogpay.cn/project/2447/interface/api/83897) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderInfo`
 */
export interface ApiGroupBuyingOrderGroupOrderInfoResponse {
  /**
   * 团单是否属于当前用户发起
   */
  belongToCurrentUser?: boolean
  commodityInfo?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityImage?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品类型:0-标准电商 1-派单核销 2-标准虚拟
     */
    commodityType?: number
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 拼团价格
     */
    groupPrice?: number
    /**
     * 拼团类型 NORMAL:普通 LADDER：阶梯团
     */
    groupType?: 'NORMAL' | 'LADDER'
    /**
     * 成团人数
     */
    groupUserCount?: number
    /**
     * 商品价格
     */
    price?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }
  groupData?: {
    /**
     * 团单关联商品Id
     */
    commodityId?: string
    /**
     * 拼团倒计时,groupStatus=（0,1时返回）
     */
    countDownTime?: number
    /**
     * 团单状态 0拼团中 1已成团 2拼团完成 3拼团失败 4已售罄 5已下架
     */
    groupStatus?: number
    /**
     * 是否包含退款差价金额
     */
    hasRefund?: boolean
    /**
     * 团员头像列表，最多5个，第一个一定为团长
     */
    headImgs?: string[]
    /**
     * 更多团员数字，为0表示没有更多团员
     */
    moreCount?: number
    /**
     * 下一阶段成团人数差距，groupStatus=(0,1)时返回
     */
    nextLevelCount?: number
    /**
     * 下一阶段退还金额,groupStatus=1时返回
     */
    nextLevelReturnAmount?: number
    otherOrders?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
  }
  /**
   * 当前用户是否已经参与团单中
   */
  inGroup?: boolean
  /**
   * 团长手机号
   */
  leaderUserPhone?: string
  /**
   * 中台订单编号
   */
  mallOrderNo?: string
  /**
   * 团单订单Id
   */
  orderId?: string
  /**
   * 用户参与订单Id,当inGroup=true时返回
   */
  userOrderId?: string
}

/**
 * 接口 [获取团单基本信息↗](https://yapi.gogpay.cn/project/2447/interface/api/83897) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderInfo`
 */
type ApiGroupBuyingOrderGroupOrderInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/groupOrderInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取团单基本信息↗](https://yapi.gogpay.cn/project/2447/interface/api/83897) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderInfo`
 */
const apiGroupBuyingOrderGroupOrderInfoRequestConfig: ApiGroupBuyingOrderGroupOrderInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/groupOrderInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderGroupOrderInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取团单基本信息', author: '成龙' },
  }

/**
 * 接口 [获取团单基本信息↗](https://yapi.gogpay.cn/project/2447/interface/api/83897) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderInfo`
 */
export const apiGroupBuyingOrderGroupOrderInfo = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderGroupOrderInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderGroupOrderInfoResponse>(
    prepare(apiGroupBuyingOrderGroupOrderInfoRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderGroupOrderInfo.requestConfig =
  apiGroupBuyingOrderGroupOrderInfoRequestConfig

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/84202) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/list`
 */
export interface ApiGroupBuyingOrderListRequest {
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单状态 0待支付  2拼团中  3拼团成功   4拼团失败 不传则是全部
   */
  orderStatus?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/84202) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/list`
 */
export interface ApiGroupBuyingOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 倒计时，如果是待支付订单则是关闭订单时间，如果是待成团则是结束时间
     */
    countDownTime?: number
    /**
     * 距成团人数差距
     */
    differCount?: number
    /**
     * 团单Id
     */
    groupOrderId?: string
    /**
     * 团单类型 NORMAL：普通   LADDER：阶梯团
     */
    groupType?: 'NORMAL' | 'LADDER'
    /**
     * 是否已成团
     */
    grouped?: boolean
    /**
     * 商城中台订单编号，仅拼团成功才返回
     */
    mallOrderNo?: string
    /**
     * 店铺Id
     */
    merchantId?: string
    /**
     * 店铺名称
     */
    merchantName?: string
    /**
     * 店铺图片
     */
    merchantPic?: string
    /**
     * 订单总价
     */
    orderAmount?: number
    /**
     * 订单Id
     */
    orderId?: string
    /**
     * 购买数量
     */
    quantity?: number
    /**
     * 可返金额，可返金额为0时表示没有返回金额
     */
    returnAmount?: number
    /**
     * 规格描述
     */
    skuDesc?: string
    /**
     * 规格Id
     */
    skuId?: string
    /**
     * 订单状态 0待支付  2拼团中  3拼团成功   4拼团失败
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 商品单价
     */
    unitPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/84202) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/list`
 */
type ApiGroupBuyingOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/84202) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/list`
 */
const apiGroupBuyingOrderListRequestConfig: ApiGroupBuyingOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表', author: '成龙' },
  }

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/84202) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/list`
 */
export const apiGroupBuyingOrderList = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderListResponse>(
    prepare(apiGroupBuyingOrderListRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderList.requestConfig = apiGroupBuyingOrderListRequestConfig

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/84211) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/detail`
 */
export interface ApiGroupBuyingOrderDetailRequest {
  /**
   * 订单Id
   */
  orderId: string
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/84211) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/detail`
 */
export interface ApiGroupBuyingOrderDetailResponse {
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  /**
   * 倒计时，如果是待支付订单则是关闭订单时间，如果是待成团则是结束时间
   */
  countDownTime?: number
  groupData?: {
    /**
     * 团单关联商品Id
     */
    commodityId?: string
    /**
     * 拼团倒计时,groupStatus=（0,1时返回）
     */
    countDownTime?: number
    /**
     * 团单状态 0拼团中 1已成团 2拼团完成 3拼团失败 4已售罄 5已下架
     */
    groupStatus?: number
    /**
     * 是否包含退款差价金额
     */
    hasRefund?: boolean
    /**
     * 团员头像列表，最多5个，第一个一定为团长
     */
    headImgs?: string[]
    /**
     * 更多团员数字，为0表示没有更多团员
     */
    moreCount?: number
    /**
     * 下一阶段成团人数差距，groupStatus=(0,1)时返回
     */
    nextLevelCount?: number
    /**
     * 下一阶段退还金额,groupStatus=1时返回
     */
    nextLevelReturnAmount?: number
    otherOrders?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
  }
  /**
   * 团单Id
   */
  groupOrderId?: string
  /**
   * 配送方式
   */
  logisticsMethod?: string
  /**
   * 商城中台订单编号，仅拼团成功才返回
   */
  mallOrderNo?: string
  /**
   * 店铺Id
   */
  merchantId?: string
  /**
   * 店铺名称
   */
  merchantName?: string
  /**
   * 店铺图片
   */
  merchantPic?: string
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 需支付金额
   */
  payAmount?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 支付方式
   */
  payTypeStatus?: number
  /**
   * 运费
   */
  postFee?: number
  /**
   * 购买数量
   */
  quantity?: number
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 规格描述
   */
  skuDesc?: string
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 订单状态 0待支付  2拼团中  3拼团成功   4拼团失败
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 商品单价
   */
  unitPrice?: number
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/84211) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/detail`
 */
type ApiGroupBuyingOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/84211) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/detail`
 */
const apiGroupBuyingOrderDetailRequestConfig: ApiGroupBuyingOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单详情', author: '成龙' },
  }

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/84211) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/detail`
 */
export const apiGroupBuyingOrderDetail = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderDetailResponse>(
    prepare(apiGroupBuyingOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderDetail.requestConfig = apiGroupBuyingOrderDetailRequestConfig

/**
 * 接口 [获取最新待成团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85786) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getLastOrders`
 */
export interface ApiGroupBuyingOrderGetLastOrdersRequest {
  /**
   * 商品Id
   */
  commodityId?: string
  userId?: string
}

/**
 * 接口 [获取最新待成团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85786) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getLastOrders`
 */
export interface ApiGroupBuyingOrderGetLastOrdersResponse {
  /**
   * 团单信息
   */
  groupItems?: {
    /**
     * 团单购买商品Id
     */
    commodityId?: string
    /**
     * 拼团倒计时（秒),groupStatus=（0,1时返回）
     */
    finishCountDown?: number
    /**
     * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
     */
    groupStatus?: number
    /**
     * 头像
     */
    headImg?: string
    /**
     * 下一阶段成团人数差距，groupStatus=(0,1)时返回
     */
    nextLevelCount?: number
    /**
     * 下一阶段退还金额,groupStatus=1时返回
     */
    nextLevelReturnAmount?: number
    /**
     * 团单订单Id
     */
    orderId?: string
    /**
     * 手机号码
     */
    userPhone?: string
  }[]
  /**
   * 正在拼单人数
   */
  userCount?: number
}

/**
 * 接口 [获取最新待成团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85786) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getLastOrders`
 */
type ApiGroupBuyingOrderGetLastOrdersRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/getLastOrders',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取最新待成团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85786) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getLastOrders`
 */
const apiGroupBuyingOrderGetLastOrdersRequestConfig: ApiGroupBuyingOrderGetLastOrdersRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/getLastOrders',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderGetLastOrders',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取最新待成团订单', author: '成龙' },
  }

/**
 * 接口 [获取最新待成团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85786) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getLastOrders`
 */
export const apiGroupBuyingOrderGetLastOrders = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderGetLastOrdersRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderGetLastOrdersResponse>(
    prepare(apiGroupBuyingOrderGetLastOrdersRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderGetLastOrders.requestConfig =
  apiGroupBuyingOrderGetLastOrdersRequestConfig

/**
 * 接口 [获取用户订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85795) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getUserOrders`
 */
export interface ApiGroupBuyingOrderGetUserOrdersRequest {}

/**
 * 接口 [获取用户订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85795) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getUserOrders`
 */
export type ApiGroupBuyingOrderGetUserOrdersResponse = {
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 倒计时，如果是待支付订单则是关闭订单时间，如果是待成团则是结束时间
   */
  countDownTime?: number
  /**
   * 距成团人数差距
   */
  differCount?: number
  /**
   * 团单Id
   */
  groupOrderId?: string
  /**
   * 团单类型 NORMAL：普通   LADDER：阶梯团
   */
  groupType?: 'NORMAL' | 'LADDER'
  /**
   * 是否已成团
   */
  grouped?: boolean
  /**
   * 商城中台订单编号，仅拼团成功才返回
   */
  mallOrderNo?: string
  /**
   * 店铺Id
   */
  merchantId?: string
  /**
   * 店铺名称
   */
  merchantName?: string
  /**
   * 店铺图片
   */
  merchantPic?: string
  /**
   * 订单总价
   */
  orderAmount?: number
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 购买数量
   */
  quantity?: number
  /**
   * 可返金额，可返金额为0时表示没有返回金额
   */
  returnAmount?: number
  /**
   * 规格描述
   */
  skuDesc?: string
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 订单状态 0待支付  2拼团中  3拼团成功   4拼团失败
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 商品单价
   */
  unitPrice?: number
}[]

/**
 * 接口 [获取用户订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85795) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getUserOrders`
 */
type ApiGroupBuyingOrderGetUserOrdersRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/getUserOrders',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取用户订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85795) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getUserOrders`
 */
const apiGroupBuyingOrderGetUserOrdersRequestConfig: ApiGroupBuyingOrderGetUserOrdersRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/getUserOrders',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderGetUserOrders',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户订单', author: '成龙' },
  }

/**
 * 接口 [获取用户订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85795) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getUserOrders`
 */
export const apiGroupBuyingOrderGetUserOrders = /*#__PURE__*/ (
  requestData?: ApiGroupBuyingOrderGetUserOrdersRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderGetUserOrdersResponse>(
    prepare(apiGroupBuyingOrderGetUserOrdersRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderGetUserOrders.requestConfig =
  apiGroupBuyingOrderGetUserOrdersRequestConfig

/**
 * 接口 [支付订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85804) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/pay`
 */
export interface ApiGroupBuyingOrderPayRequest {
  /**
   * 微信openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId: string
  /**
   * 直接调用微信支付时传 4
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '18'
}

/**
 * 接口 [支付订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85804) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/pay`
 */
export interface ApiGroupBuyingOrderPayResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 团单Id
   */
  groupOrderId?: string
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [支付订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85804) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/pay`
 */
type ApiGroupBuyingOrderPayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/pay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [支付订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85804) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/pay`
 */
const apiGroupBuyingOrderPayRequestConfig: ApiGroupBuyingOrderPayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderPay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '支付订单', author: '成龙' },
  }

/**
 * 接口 [支付订单↗](https://yapi.gogpay.cn/project/2447/interface/api/85804) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/pay`
 */
export const apiGroupBuyingOrderPay = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderPayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderPayResponse>(
    prepare(apiGroupBuyingOrderPayRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderPay.requestConfig = apiGroupBuyingOrderPayRequestConfig

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86524) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/cancel`
 */
export interface ApiGroupBuyingOrderCancelRequest {
  /**
   * 订单Id
   */
  orderId: string
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86524) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/cancel`
 */
export interface ApiGroupBuyingOrderCancelResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86524) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/cancel`
 */
type ApiGroupBuyingOrderCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86524) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/cancel`
 */
const apiGroupBuyingOrderCancelRequestConfig: ApiGroupBuyingOrderCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消订单', author: '成龙' },
  }

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86524) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/cancel`
 */
export const apiGroupBuyingOrderCancel = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderCancelResponse>(
    prepare(apiGroupBuyingOrderCancelRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderCancel.requestConfig = apiGroupBuyingOrderCancelRequestConfig

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86533) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/delete`
 */
export interface ApiGroupBuyingOrderDeleteRequest {
  /**
   * 订单Id
   */
  orderId: string
}

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86533) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/delete`
 */
export interface ApiGroupBuyingOrderDeleteResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86533) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/delete`
 */
type ApiGroupBuyingOrderDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86533) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/delete`
 */
const apiGroupBuyingOrderDeleteRequestConfig: ApiGroupBuyingOrderDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除订单', author: '成龙' },
  }

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/2447/interface/api/86533) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/delete`
 */
export const apiGroupBuyingOrderDelete = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderDeleteResponse>(
    prepare(apiGroupBuyingOrderDeleteRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderDelete.requestConfig = apiGroupBuyingOrderDeleteRequestConfig

/**
 * 接口 [获取团单SKU信息↗](https://yapi.gogpay.cn/project/2447/interface/api/86551) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderSkuInfo`
 */
export interface ApiGroupBuyingOrderGroupOrderSkuInfoRequest {
  /**
   * 订单Id
   */
  orderId: string
}

/**
 * 接口 [获取团单SKU信息↗](https://yapi.gogpay.cn/project/2447/interface/api/86551) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderSkuInfo`
 */
export interface ApiGroupBuyingOrderGroupOrderSkuInfoResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 团单Id
   */
  groupOrderId?: string
  /**
   * 规格列表
   */
  skuInfos?: {
    /**
     * 阶梯配置
     */
    ladderConfig?: {
      /**
       * 阶梯：1-一阶 2-...
       */
      ladder?: number
      /**
       * 阶梯价格
       */
      ladderPrice?: number
      /**
       * 阶梯人数
       */
      userNum?: number
    }[]
    /**
     * 最高价格
     */
    maxPrice?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
}

/**
 * 接口 [获取团单SKU信息↗](https://yapi.gogpay.cn/project/2447/interface/api/86551) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderSkuInfo`
 */
type ApiGroupBuyingOrderGroupOrderSkuInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/groupOrderSkuInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取团单SKU信息↗](https://yapi.gogpay.cn/project/2447/interface/api/86551) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderSkuInfo`
 */
const apiGroupBuyingOrderGroupOrderSkuInfoRequestConfig: ApiGroupBuyingOrderGroupOrderSkuInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/groupOrderSkuInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderGroupOrderSkuInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取团单SKU信息', author: '成龙' },
  }

/**
 * 接口 [获取团单SKU信息↗](https://yapi.gogpay.cn/project/2447/interface/api/86551) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/groupOrderSkuInfo`
 */
export const apiGroupBuyingOrderGroupOrderSkuInfo = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderGroupOrderSkuInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderGroupOrderSkuInfoResponse>(
    prepare(apiGroupBuyingOrderGroupOrderSkuInfoRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderGroupOrderSkuInfo.requestConfig =
  apiGroupBuyingOrderGroupOrderSkuInfoRequestConfig

/**
 * 接口 [获取特定团单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/376464) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getGroupOrderList`
 */
export interface ApiGroupBuyingOrderGetGroupOrderListRequest {
  /**
   * 拼团订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 订单Id
   */
  userId?: string
}

/**
 * 接口 [获取特定团单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/376464) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getGroupOrderList`
 */
export interface ApiGroupBuyingOrderGetGroupOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 倒计时，如果是待支付订单则是关闭订单时间，如果是待成团则是结束时间
     */
    countDownTime?: number
    /**
     * 距成团人数差距
     */
    differCount?: number
    /**
     * 团单Id
     */
    groupOrderId?: string
    /**
     * 团单类型 NORMAL：普通   LADDER：阶梯团
     */
    groupType?: 'NORMAL' | 'LADDER'
    /**
     * 是否已成团
     */
    grouped?: boolean
    /**
     * 商城中台订单编号，仅拼团成功才返回
     */
    mallOrderNo?: string
    /**
     * 店铺Id
     */
    merchantId?: string
    /**
     * 店铺名称
     */
    merchantName?: string
    /**
     * 店铺图片
     */
    merchantPic?: string
    /**
     * 订单总价
     */
    orderAmount?: number
    /**
     * 订单Id
     */
    orderId?: string
    /**
     * 购买数量
     */
    quantity?: number
    /**
     * 可返金额，可返金额为0时表示没有返回金额
     */
    returnAmount?: number
    /**
     * 规格描述
     */
    skuDesc?: string
    /**
     * 规格Id
     */
    skuId?: string
    /**
     * 订单状态 0待支付  2拼团中  3拼团成功   4拼团失败
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 商品单价
     */
    unitPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取特定团单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/376464) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getGroupOrderList`
 */
type ApiGroupBuyingOrderGetGroupOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/getGroupOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取特定团单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/376464) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getGroupOrderList`
 */
const apiGroupBuyingOrderGetGroupOrderListRequestConfig: ApiGroupBuyingOrderGetGroupOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/getGroupOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderGetGroupOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取特定团单列表', author: '333号开发' },
  }

/**
 * 接口 [获取特定团单列表↗](https://yapi.gogpay.cn/project/2447/interface/api/376464) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/getGroupOrderList`
 */
export const apiGroupBuyingOrderGetGroupOrderList = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderGetGroupOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderGetGroupOrderListResponse>(
    prepare(apiGroupBuyingOrderGetGroupOrderListRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderGetGroupOrderList.requestConfig =
  apiGroupBuyingOrderGetGroupOrderListRequestConfig

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/376467) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/writeOffDetail`
 */
export interface ApiGroupBuyingOrderWriteOffDetailRequest {
  /**
   * 订单Id
   */
  orderId: string
}

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/376467) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/writeOffDetail`
 */
export interface ApiGroupBuyingOrderWriteOffDetailResponse {
  /**
   * 券码列表
   */
  codeList?: {
    /**
     * 券码
     */
    code?: string
    /**
     * 售后Id，券码状态=13或者14时有值
     */
    saleId?: string
    /**
     * 券码状态 11待使用  12已使用  13退款中  14已退款 15已过期
     */
    status?: number
    /**
     * 券码状态文案
     */
    statusName?: string
  }[]
  /**
   * 券码使用类型 1多张券码   2单券码多次使用  3外部核销
   */
  codeType?: number
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: number
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  /**
   * 倒计时，如果是待支付订单则是关闭订单时间，如果是待成团则是结束时间
   */
  countDownTime?: number
  /**
   * 当前可用券码
   */
  currentCode?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluationStatus?: number
  expireDate?: string
  /**
   * 有效期
   */
  expireTime?: string
  groupData?: {
    /**
     * 团单关联商品Id
     */
    commodityId?: string
    /**
     * 拼团倒计时,groupStatus=（0,1时返回）
     */
    countDownTime?: number
    /**
     * 团单状态 0拼团中 1已成团 2拼团完成 3拼团失败 4已售罄 5已下架
     */
    groupStatus?: number
    /**
     * 是否包含退款差价金额
     */
    hasRefund?: boolean
    /**
     * 团员头像列表，最多5个，第一个一定为团长
     */
    headImgs?: string[]
    /**
     * 更多团员数字，为0表示没有更多团员
     */
    moreCount?: number
    /**
     * 下一阶段成团人数差距，groupStatus=(0,1)时返回
     */
    nextLevelCount?: number
    /**
     * 下一阶段退还金额,groupStatus=1时返回
     */
    nextLevelReturnAmount?: number
    otherOrders?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
  }
  /**
   * 拼团团单号
   */
  groupOrderId?: string
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  /**
   * 商城中台订单号
   */
  mallOrderNo?: string
  /**
   * 门店详细地址
   */
  merchantAddress?: string
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 营业时间
   */
  merchantOpenPeriod?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 订单金额(优惠前)
   */
  orderAmount?: number
  /**
   * 订单分类  2标准核销 5组合订单
   */
  orderClassify?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 支付/待支付金额（优惠后)
   */
  payAmount?: number
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '18'
  /**
   * 支付类型编号
   */
  payTypeStatus?: number
  /**
   * 温馨提示
   */
  purchaseNotesDetail?: string
  /**
   * 核销二维码数据（兼容)
   */
  qrCodeData?: string
  /**
   * 核销二维码生成数据
   */
  qrCodeDataList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
    /**
     * 二维码数据
     */
    qrCodeData?: string
  }[]
  /**
   * 数量
   */
  quantity?: number
  /**
   * 备注
   */
  remark?: string
  /**
   * 退款状态 0未申请 1已申请 2已使用
   */
  saleStatus?: number
  /**
   * 规格信息
   */
  skuDesc?: string
  /**
   * sku id
   */
  skuId?: string
  /**
   * 订单状态 0待支付
   * 300待使用900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 使用日期/库存日期
   */
  stockDate?: string
  /**
   * 剩余券码可用数量
   */
  surplusCodeCount?: number
  /**
   * 拼团团单单价
   */
  unitPrice?: number
  /**
   * 游玩用户信息
   */
  userInfoList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
  }[]
  writeOffStores?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic?: string
  }[]
  /**
   * 消费时间
   */
  writeOffTime?: string
  /**
   * 经度
   */
  merchantLongitude?: string
  /**
   * 纬度
   */
  merchantLatitude?: string
}

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/376467) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/writeOffDetail`
 */
type ApiGroupBuyingOrderWriteOffDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2447',
    '',
    '',
    '/groupBuying/api/order/writeOffDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/376467) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/writeOffDetail`
 */
const apiGroupBuyingOrderWriteOffDetailRequestConfig: ApiGroupBuyingOrderWriteOffDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_21_0_3,
    devUrl: devUrl_0_21_0_3,
    prodUrl: prodUrl_0_21_0_3,
    path: '/groupBuying/api/order/writeOffDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_21_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiGroupBuyingOrderWriteOffDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销订单详情', author: '333号开发' },
  }

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/2447/interface/api/376467) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [拼团订单↗](https://yapi.gogpay.cn/project/2447/interface/api/cat_19411)
 * @请求头 `POST /groupBuying/api/order/writeOffDetail`
 */
export const apiGroupBuyingOrderWriteOffDetail = /*#__PURE__*/ (
  requestData: ApiGroupBuyingOrderWriteOffDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiGroupBuyingOrderWriteOffDetailResponse>(
    prepare(apiGroupBuyingOrderWriteOffDetailRequestConfig, requestData),
    ...args,
  )
}

apiGroupBuyingOrderWriteOffDetail.requestConfig =
  apiGroupBuyingOrderWriteOffDetailRequestConfig

const mockUrl_0_20_0_1 = 'https://yapi.gogpay.cn/mock/2313' as any
const devUrl_0_20_0_1 = '' as any
const prodUrl_0_20_0_1 = '' as any
const dataKey_0_20_0_1 = 'data' as any

/**
 * 接口 [盲盒详情↗](https://yapi.gogpay.cn/project/2313/interface/api/62056) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/detail`
 */
export interface ApiBlindBoxBoxDetailRequest {
  /**
   * 盲盒Id
   */
  id: string
  /**
   * 微信OPenId
   */
  openId?: string
}

/**
 * 接口 [盲盒详情↗](https://yapi.gogpay.cn/project/2313/interface/api/62056) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/detail`
 */
export interface ApiBlindBoxBoxDetailResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 盲盒Id
   */
  boxId?: string
  /**
   * 盲盒名称
   */
  boxName?: string
  /**
   * 盲盒图片
   */
  boxPic?: string
  /**
   * 商品列表
   */
  commodityList?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 盲盒Id
     */
    boxId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品价格
     */
    price?: number
    /**
     * 概率
     */
    probability?: number
    /**
     * 是否已售罄
     */
    sellOut?: boolean
    /**
     * sku规格信息
     */
    skuDesc?: string
  }[]
  /**
   * 商品价格
   */
  price?: number
  /**
   * 盲盒回收价格
   */
  recoverPrice?: number
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 剩余库存
   */
  surplusStock?: number
}

/**
 * 接口 [盲盒详情↗](https://yapi.gogpay.cn/project/2313/interface/api/62056) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/detail`
 */
type ApiBlindBoxBoxDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/box/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [盲盒详情↗](https://yapi.gogpay.cn/project/2313/interface/api/62056) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/detail`
 */
const apiBlindBoxBoxDetailRequestConfig: ApiBlindBoxBoxDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_1,
    devUrl: devUrl_0_20_0_1,
    prodUrl: prodUrl_0_20_0_1,
    path: '/blindBox/api/box/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxBoxDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '盲盒详情', author: '成龙' },
  }

/**
 * 接口 [盲盒详情↗](https://yapi.gogpay.cn/project/2313/interface/api/62056) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/detail`
 */
export const apiBlindBoxBoxDetail = /*#__PURE__*/ (
  requestData: ApiBlindBoxBoxDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxBoxDetailResponse>(
    prepare(apiBlindBoxBoxDetailRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxBoxDetail.requestConfig = apiBlindBoxBoxDetailRequestConfig

/**
 * 接口 [获取试玩次数↗](https://yapi.gogpay.cn/project/2313/interface/api/62062) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/getTryCount`
 */
export interface ApiBlindBoxBoxGetTryCountRequest {
  /**
   * 盲盒Id
   */
  id: string
  /**
   * 微信OPenId
   */
  openId?: string
}

/**
 * 接口 [获取试玩次数↗](https://yapi.gogpay.cn/project/2313/interface/api/62062) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/getTryCount`
 */
export type ApiBlindBoxBoxGetTryCountResponse = number

/**
 * 接口 [获取试玩次数↗](https://yapi.gogpay.cn/project/2313/interface/api/62062) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/getTryCount`
 */
type ApiBlindBoxBoxGetTryCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/box/getTryCount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取试玩次数↗](https://yapi.gogpay.cn/project/2313/interface/api/62062) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/getTryCount`
 */
const apiBlindBoxBoxGetTryCountRequestConfig: ApiBlindBoxBoxGetTryCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_1,
    devUrl: devUrl_0_20_0_1,
    prodUrl: prodUrl_0_20_0_1,
    path: '/blindBox/api/box/getTryCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxBoxGetTryCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取试玩次数', author: '成龙' },
  }

/**
 * 接口 [获取试玩次数↗](https://yapi.gogpay.cn/project/2313/interface/api/62062) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/getTryCount`
 */
export const apiBlindBoxBoxGetTryCount = /*#__PURE__*/ (
  requestData: ApiBlindBoxBoxGetTryCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxBoxGetTryCountResponse>(
    prepare(apiBlindBoxBoxGetTryCountRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxBoxGetTryCount.requestConfig = apiBlindBoxBoxGetTryCountRequestConfig

/**
 * 接口 [试玩↗](https://yapi.gogpay.cn/project/2313/interface/api/62068) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/tryOpen`
 */
export interface ApiBlindBoxBoxTryOpenRequest {
  /**
   * 盲盒Id
   */
  id: string
  /**
   * 微信OPenId
   */
  openId?: string
}

/**
 * 接口 [试玩↗](https://yapi.gogpay.cn/project/2313/interface/api/62068) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/tryOpen`
 */
export interface ApiBlindBoxBoxTryOpenResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 盲盒Id
   */
  boxId?: string
  /**
   * 商品id
   */
  commodityId?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品类型 1标电 2标销
   */
  commodityType?: number
  /**
   * 是否跳转到失败详情页
   */
  jumpToDetail?: boolean
  /**
   * 匹配概率
   */
  matchProbability?: number
  /**
   * 是否开盒成功
   */
  openSuccess?: boolean
  /**
   * 商品价格
   */
  price?: number
  /**
   * 回收价格
   */
  recoverPrice?: number
  /**
   * 回收比例
   */
  recoverScale?: number
  /**
   * 规格信息
   */
  skuDesc?: string
  /**
   * sku Id
   */
  skuId?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
}

/**
 * 接口 [试玩↗](https://yapi.gogpay.cn/project/2313/interface/api/62068) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/tryOpen`
 */
type ApiBlindBoxBoxTryOpenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/box/tryOpen',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [试玩↗](https://yapi.gogpay.cn/project/2313/interface/api/62068) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/tryOpen`
 */
const apiBlindBoxBoxTryOpenRequestConfig: ApiBlindBoxBoxTryOpenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_1,
    devUrl: devUrl_0_20_0_1,
    prodUrl: prodUrl_0_20_0_1,
    path: '/blindBox/api/box/tryOpen',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxBoxTryOpen',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '试玩', author: '成龙' },
  }

/**
 * 接口 [试玩↗](https://yapi.gogpay.cn/project/2313/interface/api/62068) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/tryOpen`
 */
export const apiBlindBoxBoxTryOpen = /*#__PURE__*/ (
  requestData: ApiBlindBoxBoxTryOpenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxBoxTryOpenResponse>(
    prepare(apiBlindBoxBoxTryOpenRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxBoxTryOpen.requestConfig = apiBlindBoxBoxTryOpenRequestConfig

/**
 * 接口 [中奖记录列表↗](https://yapi.gogpay.cn/project/2313/interface/api/385404) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/prizeRecords`
 */
export interface ApiBlindBoxBoxPrizeRecordsRequest {
  /**
   * 盲盒Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [中奖记录列表↗](https://yapi.gogpay.cn/project/2313/interface/api/385404) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/prizeRecords`
 */
export interface ApiBlindBoxBoxPrizeRecordsResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 盲盒Id
     */
    boxId?: string
    /**
     * 商品id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品类型 1标电 2标销
     */
    commodityType?: number
    /**
     * 规格信息
     */
    skuDesc?: string
    /**
     * 用户名
     */
    userName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [中奖记录列表↗](https://yapi.gogpay.cn/project/2313/interface/api/385404) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/prizeRecords`
 */
type ApiBlindBoxBoxPrizeRecordsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/box/prizeRecords',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中奖记录列表↗](https://yapi.gogpay.cn/project/2313/interface/api/385404) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/prizeRecords`
 */
const apiBlindBoxBoxPrizeRecordsRequestConfig: ApiBlindBoxBoxPrizeRecordsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_1,
    devUrl: devUrl_0_20_0_1,
    prodUrl: prodUrl_0_20_0_1,
    path: '/blindBox/api/box/prizeRecords',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxBoxPrizeRecords',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中奖记录列表', author: '333号开发' },
  }

/**
 * 接口 [中奖记录列表↗](https://yapi.gogpay.cn/project/2313/interface/api/385404) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13655)
 * @请求头 `POST /blindBox/api/box/prizeRecords`
 */
export const apiBlindBoxBoxPrizeRecords = /*#__PURE__*/ (
  requestData: ApiBlindBoxBoxPrizeRecordsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxBoxPrizeRecordsResponse>(
    prepare(apiBlindBoxBoxPrizeRecordsRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxBoxPrizeRecords.requestConfig =
  apiBlindBoxBoxPrizeRecordsRequestConfig

const mockUrl_0_20_0_2 = 'https://yapi.gogpay.cn/mock/2313' as any
const devUrl_0_20_0_2 = '' as any
const prodUrl_0_20_0_2 = '' as any
const dataKey_0_20_0_2 = 'data' as any

/**
 * 接口 [发货↗](https://yapi.gogpay.cn/project/2313/interface/api/62086) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/deliver`
 */
export interface ApiBlindBoxOrderDeliverRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
  }[]
}

/**
 * 接口 [发货↗](https://yapi.gogpay.cn/project/2313/interface/api/62086) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/deliver`
 */
export interface ApiBlindBoxOrderDeliverResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发货↗](https://yapi.gogpay.cn/project/2313/interface/api/62086) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/deliver`
 */
type ApiBlindBoxOrderDeliverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/deliver',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发货↗](https://yapi.gogpay.cn/project/2313/interface/api/62086) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/deliver`
 */
const apiBlindBoxOrderDeliverRequestConfig: ApiBlindBoxOrderDeliverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/deliver',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderDeliver',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发货', author: '成龙' },
  }

/**
 * 接口 [发货↗](https://yapi.gogpay.cn/project/2313/interface/api/62086) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/deliver`
 */
export const apiBlindBoxOrderDeliver = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderDeliverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderDeliverResponse>(
    prepare(apiBlindBoxOrderDeliverRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderDeliver.requestConfig = apiBlindBoxOrderDeliverRequestConfig

/**
 * 接口 [获取订单跳转路由↗](https://yapi.gogpay.cn/project/2313/interface/api/62092) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getOrderUrl`
 */
export interface ApiBlindBoxOrderGetOrderUrlRequest {
  /**
   * 订单Id
   */
  id: string
}

/**
 * 接口 [获取订单跳转路由↗](https://yapi.gogpay.cn/project/2313/interface/api/62092) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getOrderUrl`
 */
export type ApiBlindBoxOrderGetOrderUrlResponse = string

/**
 * 接口 [获取订单跳转路由↗](https://yapi.gogpay.cn/project/2313/interface/api/62092) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getOrderUrl`
 */
type ApiBlindBoxOrderGetOrderUrlRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/getOrderUrl',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单跳转路由↗](https://yapi.gogpay.cn/project/2313/interface/api/62092) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getOrderUrl`
 */
const apiBlindBoxOrderGetOrderUrlRequestConfig: ApiBlindBoxOrderGetOrderUrlRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/getOrderUrl',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderGetOrderUrl',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单跳转路由', author: '成龙' },
  }

/**
 * 接口 [获取订单跳转路由↗](https://yapi.gogpay.cn/project/2313/interface/api/62092) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getOrderUrl`
 */
export const apiBlindBoxOrderGetOrderUrl = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderGetOrderUrlRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderGetOrderUrlResponse>(
    prepare(apiBlindBoxOrderGetOrderUrlRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderGetOrderUrl.requestConfig =
  apiBlindBoxOrderGetOrderUrlRequestConfig

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/2313/interface/api/62098) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getRefundAmount`
 */
export interface ApiBlindBoxOrderGetRefundAmountRequest {
  /**
   * 订单Id
   */
  id: string
}

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/2313/interface/api/62098) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getRefundAmount`
 */
export interface ApiBlindBoxOrderGetRefundAmountResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 盲盒Id
   */
  boxId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 多彩宝订单编号
   */
  orderNo?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 退款状态 1退款中  2退款完成
   */
  refundStatus?: number
  /**
   * 退款文案
   */
  text?: string
}

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/2313/interface/api/62098) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getRefundAmount`
 */
type ApiBlindBoxOrderGetRefundAmountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/getRefundAmount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/2313/interface/api/62098) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getRefundAmount`
 */
const apiBlindBoxOrderGetRefundAmountRequestConfig: ApiBlindBoxOrderGetRefundAmountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/getRefundAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderGetRefundAmount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单退款金额', author: '成龙' },
  }

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/2313/interface/api/62098) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getRefundAmount`
 */
export const apiBlindBoxOrderGetRefundAmount = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderGetRefundAmountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderGetRefundAmountResponse>(
    prepare(apiBlindBoxOrderGetRefundAmountRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderGetRefundAmount.requestConfig =
  apiBlindBoxOrderGetRefundAmountRequestConfig

/**
 * 接口 [获取未开盒数量↗](https://yapi.gogpay.cn/project/2313/interface/api/62104) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getUnOpenCount`
 */
export interface ApiBlindBoxOrderGetUnOpenCountRequest {}

/**
 * 接口 [获取未开盒数量↗](https://yapi.gogpay.cn/project/2313/interface/api/62104) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getUnOpenCount`
 */
export type ApiBlindBoxOrderGetUnOpenCountResponse = number

/**
 * 接口 [获取未开盒数量↗](https://yapi.gogpay.cn/project/2313/interface/api/62104) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getUnOpenCount`
 */
type ApiBlindBoxOrderGetUnOpenCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/getUnOpenCount',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取未开盒数量↗](https://yapi.gogpay.cn/project/2313/interface/api/62104) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getUnOpenCount`
 */
const apiBlindBoxOrderGetUnOpenCountRequestConfig: ApiBlindBoxOrderGetUnOpenCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/getUnOpenCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderGetUnOpenCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取未开盒数量', author: '成龙' },
  }

/**
 * 接口 [获取未开盒数量↗](https://yapi.gogpay.cn/project/2313/interface/api/62104) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getUnOpenCount`
 */
export const apiBlindBoxOrderGetUnOpenCount = /*#__PURE__*/ (
  requestData?: ApiBlindBoxOrderGetUnOpenCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderGetUnOpenCountResponse>(
    prepare(apiBlindBoxOrderGetUnOpenCountRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderGetUnOpenCount.requestConfig =
  apiBlindBoxOrderGetUnOpenCountRequestConfig

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2313/interface/api/62110) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/list`
 */
export interface ApiBlindBoxOrderListRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 订单状态筛选 不传则是全部 1待开盒  2已开盒  3已出仓  4已回收
   */
  status?: '0' | '1' | '2' | '3' | '4' | '5' | '6'
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2313/interface/api/62110) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/list`
 */
export interface ApiBlindBoxOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 盲盒Id
     */
    boxId?: string
    /**
     * 盲盒名称
     */
    boxName?: string
    /**
     * 盲盒图片
     */
    boxPic?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品金额
     */
    commodityPrice?: number
    /**
     * 商品标题
     */
    commodityTitle?: string
    countDownConfig?: {
      /**
       * 发货剩余倒计时
       */
      deliverTime?: number
      /**
       * 开盒剩余倒计时
       */
      openBoxTime?: number
    }
    /**
     * 异常回收原因
     */
    errorReason?: string
    /**
     * 订单金额
     */
    orderAmount?: number
    /**
     * 订单Id
     */
    orderId?: string
    /**
     * 订单回收价格
     */
    recoverPrice?: number
    /**
     * 手续费比例
     */
    recoverScale?: number
    /**
     * 订单状态 订单状态 0待支付  1待开盒  2已开盒  3已出仓  4已回收 6异常回收单
     */
    status?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2313/interface/api/62110) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/list`
 */
type ApiBlindBoxOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2313/interface/api/62110) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/list`
 */
const apiBlindBoxOrderListRequestConfig: ApiBlindBoxOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表', author: '成龙' },
  }

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/2313/interface/api/62110) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/list`
 */
export const apiBlindBoxOrderList = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderListResponse>(
    prepare(apiBlindBoxOrderListRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderList.requestConfig = apiBlindBoxOrderListRequestConfig

/**
 * 接口 [开盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62116) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/open`
 */
export interface ApiBlindBoxOrderOpenRequest {
  /**
   * 订单Id
   */
  id: string
}

/**
 * 接口 [开盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62116) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/open`
 */
export interface ApiBlindBoxOrderOpenResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 盲盒Id
   */
  boxId?: string
  /**
   * 商品id
   */
  commodityId?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品类型 1标电 2标销
   */
  commodityType?: number
  /**
   * 是否跳转到失败详情页
   */
  jumpToDetail?: boolean
  /**
   * 匹配概率
   */
  matchProbability?: number
  /**
   * 是否开盒成功
   */
  openSuccess?: boolean
  /**
   * 商品价格
   */
  price?: number
  /**
   * 回收价格
   */
  recoverPrice?: number
  /**
   * 回收比例
   */
  recoverScale?: number
  /**
   * 规格信息
   */
  skuDesc?: string
  /**
   * sku Id
   */
  skuId?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
}

/**
 * 接口 [开盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62116) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/open`
 */
type ApiBlindBoxOrderOpenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/open',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62116) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/open`
 */
const apiBlindBoxOrderOpenRequestConfig: ApiBlindBoxOrderOpenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/open',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderOpen',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开盒', author: '成龙' },
  }

/**
 * 接口 [开盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62116) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/open`
 */
export const apiBlindBoxOrderOpen = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderOpenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderOpenResponse>(
    prepare(apiBlindBoxOrderOpenRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderOpen.requestConfig = apiBlindBoxOrderOpenRequestConfig

/**
 * 接口 [回收盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62122) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/recover`
 */
export interface ApiBlindBoxOrderRecoverRequest {
  /**
   * 订单Id
   */
  id: string
}

/**
 * 接口 [回收盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62122) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/recover`
 */
export interface ApiBlindBoxOrderRecoverResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [回收盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62122) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/recover`
 */
type ApiBlindBoxOrderRecoverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/recover',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [回收盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62122) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/recover`
 */
const apiBlindBoxOrderRecoverRequestConfig: ApiBlindBoxOrderRecoverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/recover',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderRecover',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '回收盲盒', author: '成龙' },
  }

/**
 * 接口 [回收盲盒↗](https://yapi.gogpay.cn/project/2313/interface/api/62122) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/recover`
 */
export const apiBlindBoxOrderRecover = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderRecoverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderRecoverResponse>(
    prepare(apiBlindBoxOrderRecoverRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderRecover.requestConfig = apiBlindBoxOrderRecoverRequestConfig

/**
 * 接口 [下单↗](https://yapi.gogpay.cn/project/2313/interface/api/66706) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/tradeOrder`
 */
export interface ApiBlindBoxOrderTradeOrderRequest {
  /**
   * 盲盒Id
   */
  id: string
  /**
   * 微信OPenId
   */
  openId?: string
}

/**
 * 接口 [下单↗](https://yapi.gogpay.cn/project/2313/interface/api/66706) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/tradeOrder`
 */
export interface ApiBlindBoxOrderTradeOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [下单↗](https://yapi.gogpay.cn/project/2313/interface/api/66706) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/tradeOrder`
 */
type ApiBlindBoxOrderTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [下单↗](https://yapi.gogpay.cn/project/2313/interface/api/66706) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/tradeOrder`
 */
const apiBlindBoxOrderTradeOrderRequestConfig: ApiBlindBoxOrderTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '下单', author: '成龙' },
  }

/**
 * 接口 [下单↗](https://yapi.gogpay.cn/project/2313/interface/api/66706) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/tradeOrder`
 */
export const apiBlindBoxOrderTradeOrder = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderTradeOrderResponse>(
    prepare(apiBlindBoxOrderTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderTradeOrder.requestConfig =
  apiBlindBoxOrderTradeOrderRequestConfig

/**
 * 接口 [预发货↗](https://yapi.gogpay.cn/project/2313/interface/api/66814) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/preDeliver`
 */
export interface ApiBlindBoxOrderPreDeliverRequest {
  /**
   * 订单Id
   */
  id: string
}

/**
 * 接口 [预发货↗](https://yapi.gogpay.cn/project/2313/interface/api/66814) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/preDeliver`
 */
export interface ApiBlindBoxOrderPreDeliverResponse {
  /**
   * 业务类型
   */
  businessType?: string
  /**
   * 是否计算过邮费
   */
  calcPostFeeFlag?: boolean
  /**
   * 积分抵扣项目列表
   */
  channelActivityItems?: {
    /**
     * 余额
     */
    balance?: string
    /**
     * 余额单位
     */
    balanceUnit?: string
    /**
     * 是否可抵扣
     */
    deduction?: boolean
    /**
     * 活动Id
     */
    id?: string
    /**
     * 是否需要密码
     */
    needPassword?: boolean
    /**
     * 不支持抵扣原因
     */
    noDeductionReason?: string
    passwordKeyboard?: {
      /**
       * 密码值列表
       */
      keys?: {
        /**
         * 密码数字
         */
        key?: number
        /**
         * 密码数字混淆值
         */
        keySlat?: number
        /**
         * 密码值
         */
        value?: string
      }[]
    }
    /**
     * 渠道名称
     */
    title?: string
  }[]
  closeOrderValue?: number
  /**
   * 折扣优惠消费ticket
   */
  discountActivityTicket?: string
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 是否需要收货地址
   */
  needAddress?: boolean
  /**
   * 是否需要使用日期
   */
  needUseDate?: boolean
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 活动名称
         */
        name?: string
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  orderType?: number
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
   */
  preOrderContentType?: '1' | '2' | '4' | '5' | '3'
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
  /**
   * 是否支持积分支付
   */
  supportPayType?: boolean
  /**
   * 是否为翼支付支付：true-是，false否
   */
  supportYiPay?: boolean
  /**
   * 提示信息
   */
  tips?: string
  /**
   * 订单包含的子机构编码
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [预发货↗](https://yapi.gogpay.cn/project/2313/interface/api/66814) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/preDeliver`
 */
type ApiBlindBoxOrderPreDeliverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/preDeliver',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预发货↗](https://yapi.gogpay.cn/project/2313/interface/api/66814) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/preDeliver`
 */
const apiBlindBoxOrderPreDeliverRequestConfig: ApiBlindBoxOrderPreDeliverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/preDeliver',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderPreDeliver',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预发货', author: '成龙' },
  }

/**
 * 接口 [预发货↗](https://yapi.gogpay.cn/project/2313/interface/api/66814) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/preDeliver`
 */
export const apiBlindBoxOrderPreDeliver = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderPreDeliverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderPreDeliverResponse>(
    prepare(apiBlindBoxOrderPreDeliverRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderPreDeliver.requestConfig =
  apiBlindBoxOrderPreDeliverRequestConfig

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2313/interface/api/67912) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/detail`
 */
export interface ApiBlindBoxOrderDetailRequest {
  /**
   * 订单Id
   */
  id: string
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2313/interface/api/67912) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/detail`
 */
export interface ApiBlindBoxOrderDetailResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 盲盒Id
   */
  boxId?: string
  /**
   * 盲盒名称
   */
  boxName?: string
  /**
   * 盲盒图片
   */
  boxPic?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品金额
   */
  commodityPrice?: number
  /**
   * 商品标题
   */
  commodityTitle?: string
  countDownConfig?: {
    /**
     * 发货剩余倒计时
     */
    deliverTime?: number
    /**
     * 开盒剩余倒计时
     */
    openBoxTime?: number
  }
  /**
   * 异常回收原因
   */
  errorReason?: string
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单回收价格
   */
  recoverPrice?: number
  /**
   * 手续费比例
   */
  recoverScale?: number
  /**
   * 订单状态 订单状态 0待支付  1待开盒  2已开盒  3已出仓  4已回收 6异常回收单
   */
  status?: number
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2313/interface/api/67912) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/detail`
 */
type ApiBlindBoxOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2313/interface/api/67912) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/detail`
 */
const apiBlindBoxOrderDetailRequestConfig: ApiBlindBoxOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单详情', author: '成龙' },
  }

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/2313/interface/api/67912) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/detail`
 */
export const apiBlindBoxOrderDetail = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderDetailResponse>(
    prepare(apiBlindBoxOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderDetail.requestConfig = apiBlindBoxOrderDetailRequestConfig

/**
 * 接口 [获取特定状态的盲盒订单↗](https://yapi.gogpay.cn/project/2313/interface/api/385407) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getBlindBoxOrder`
 */
export interface ApiBlindBoxOrderGetBlindBoxOrderRequest {
  /**
   * 盲盒订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [获取特定状态的盲盒订单↗](https://yapi.gogpay.cn/project/2313/interface/api/385407) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getBlindBoxOrder`
 */
export interface ApiBlindBoxOrderGetBlindBoxOrderResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 盲盒Id
     */
    boxId?: string
    /**
     * 盲盒名称
     */
    boxName?: string
    /**
     * 盲盒图片
     */
    boxPic?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品金额
     */
    commodityPrice?: number
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品类型
     */
    commodityType?: number
    /**
     * 商品类型名称
     */
    commodityTypeName?: string
    countDownConfig?: {
      /**
       * 发货剩余倒计时
       */
      deliverTime?: number
      /**
       * 开盒剩余倒计时
       */
      openBoxTime?: number
    }
    /**
     * 异常回收原因
     */
    errorReason?: string
    /**
     * 订单金额
     */
    orderAmount?: number
    /**
     * 订单Id
     */
    orderId?: string
    /**
     * 订单回收价格
     */
    recoverPrice?: number
    /**
     * 手续费比例
     */
    recoverScale?: number
    /**
     * 订单状态 订单状态 0待支付  1待开盒  2已开盒  3已出仓  4已回收 6异常回收单
     */
    status?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取特定状态的盲盒订单↗](https://yapi.gogpay.cn/project/2313/interface/api/385407) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getBlindBoxOrder`
 */
type ApiBlindBoxOrderGetBlindBoxOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/order/getBlindBoxOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取特定状态的盲盒订单↗](https://yapi.gogpay.cn/project/2313/interface/api/385407) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getBlindBoxOrder`
 */
const apiBlindBoxOrderGetBlindBoxOrderRequestConfig: ApiBlindBoxOrderGetBlindBoxOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_2,
    devUrl: devUrl_0_20_0_2,
    prodUrl: prodUrl_0_20_0_2,
    path: '/blindBox/api/order/getBlindBoxOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxOrderGetBlindBoxOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取特定状态的盲盒订单', author: '333号开发' },
  }

/**
 * 接口 [获取特定状态的盲盒订单↗](https://yapi.gogpay.cn/project/2313/interface/api/385407) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13664)
 * @请求头 `POST /blindBox/api/order/getBlindBoxOrder`
 */
export const apiBlindBoxOrderGetBlindBoxOrder = /*#__PURE__*/ (
  requestData: ApiBlindBoxOrderGetBlindBoxOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxOrderGetBlindBoxOrderResponse>(
    prepare(apiBlindBoxOrderGetBlindBoxOrderRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxOrderGetBlindBoxOrder.requestConfig =
  apiBlindBoxOrderGetBlindBoxOrderRequestConfig

const mockUrl_0_20_0_3 = 'https://yapi.gogpay.cn/mock/2313' as any
const devUrl_0_20_0_3 = '' as any
const prodUrl_0_20_0_3 = '' as any
const dataKey_0_20_0_3 = 'data' as any

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2313/interface/api/62074) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/activityIndex`
 */
export interface ApiBlindBoxHomeActivityIndexRequest {
  /**
   * 活动Id
   */
  id: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2313/interface/api/62074) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/activityIndex`
 */
export interface ApiBlindBoxHomeActivityIndexResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 活动图片
   */
  activityPic?: string
  /**
   * 盲盒列表
   */
  boxs?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 盲盒Id
     */
    boxId?: string
    /**
     * 盲盒名称
     */
    boxName?: string
    /**
     * 盲盒图片
     */
    boxPic?: string
    /**
     * 开启次数
     */
    openCount?: number
    /**
     * 盲盒价格
     */
    price?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  /**
   * 活动规则
   */
  rule?: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2313/interface/api/62074) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/activityIndex`
 */
type ApiBlindBoxHomeActivityIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/home/activityIndex',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2313/interface/api/62074) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/activityIndex`
 */
const apiBlindBoxHomeActivityIndexRequestConfig: ApiBlindBoxHomeActivityIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_3,
    devUrl: devUrl_0_20_0_3,
    prodUrl: prodUrl_0_20_0_3,
    path: '/blindBox/api/home/activityIndex',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxHomeActivityIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '活动首页', author: '成龙' },
  }

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2313/interface/api/62074) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/activityIndex`
 */
export const apiBlindBoxHomeActivityIndex = /*#__PURE__*/ (
  requestData: ApiBlindBoxHomeActivityIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxHomeActivityIndexResponse>(
    prepare(apiBlindBoxHomeActivityIndexRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxHomeActivityIndex.requestConfig =
  apiBlindBoxHomeActivityIndexRequestConfig

/**
 * 接口 [中奖弹幕↗](https://yapi.gogpay.cn/project/2313/interface/api/62080) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/prizeDanMu`
 */
export interface ApiBlindBoxHomePrizeDanMuRequest {
  /**
   * 活动Id
   */
  id: string
}

/**
 * 接口 [中奖弹幕↗](https://yapi.gogpay.cn/project/2313/interface/api/62080) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/prizeDanMu`
 */
export type ApiBlindBoxHomePrizeDanMuResponse = {
  /**
   * 索引序号
   */
  index?: number
  /**
   * 弹幕文本
   */
  text?: string
}[]

/**
 * 接口 [中奖弹幕↗](https://yapi.gogpay.cn/project/2313/interface/api/62080) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/prizeDanMu`
 */
type ApiBlindBoxHomePrizeDanMuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2313',
    '',
    '',
    '/blindBox/api/home/prizeDanMu',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中奖弹幕↗](https://yapi.gogpay.cn/project/2313/interface/api/62080) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/prizeDanMu`
 */
const apiBlindBoxHomePrizeDanMuRequestConfig: ApiBlindBoxHomePrizeDanMuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_20_0_3,
    devUrl: devUrl_0_20_0_3,
    prodUrl: prodUrl_0_20_0_3,
    path: '/blindBox/api/home/prizeDanMu',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_20_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiBlindBoxHomePrizeDanMu',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中奖弹幕', author: '成龙' },
  }

/**
 * 接口 [中奖弹幕↗](https://yapi.gogpay.cn/project/2313/interface/api/62080) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [首页↗](https://yapi.gogpay.cn/project/2313/interface/api/cat_13673)
 * @请求头 `POST /blindBox/api/home/prizeDanMu`
 */
export const apiBlindBoxHomePrizeDanMu = /*#__PURE__*/ (
  requestData: ApiBlindBoxHomePrizeDanMuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiBlindBoxHomePrizeDanMuResponse>(
    prepare(apiBlindBoxHomePrizeDanMuRequestConfig, requestData),
    ...args,
  )
}

apiBlindBoxHomePrizeDanMu.requestConfig = apiBlindBoxHomePrizeDanMuRequestConfig

const mockUrl_0_16_0_1 = 'https://yapi.gogpay.cn/mock/2210' as any
const devUrl_0_16_0_1 = '' as any
const prodUrl_0_16_0_1 = '' as any
const dataKey_0_16_0_1 = 'data' as any

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57491) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/loginBySms`
 */
export interface ApiUserLoginH5LoginBySmsRequest {
  /**
   * 手机号
   */
  phone: string
  /**
   * 验证码
   */
  verification: string
  /**
   * 微信小程序openId，或者第三方用户ID
   * 微信，分享出去后，url里面后端会注入一个opneId，有就传，没有就不传
   */
  openId?: string
  /**
   * 登录平台，联系开发获取
   * 4.0全国版H5：allCountryH5
   * H5版商城：h5Mall
   */
  platform: string
}

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57491) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/loginBySms`
 */
export interface ApiUserLoginH5LoginBySmsResponse {
  /**
   * 用户ID
   */
  id: string
  /**
   * p参数
   */
  p: string
}

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57491) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/loginBySms`
 */
type ApiUserLoginH5LoginBySmsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2210',
    '',
    '',
    '/user/login/h5/loginBySms',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57491) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/loginBySms`
 */
const apiUserLoginH5LoginBySmsRequestConfig: ApiUserLoginH5LoginBySmsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_16_0_1,
    devUrl: devUrl_0_16_0_1,
    prodUrl: prodUrl_0_16_0_1,
    path: '/user/login/h5/loginBySms',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_16_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiUserLoginH5LoginBySms',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'H5验证码登录', author: '杨大鑫' },
  }

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57491) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/loginBySms`
 */
export const apiUserLoginH5LoginBySms = /*#__PURE__*/ (
  requestData: ApiUserLoginH5LoginBySmsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiUserLoginH5LoginBySmsResponse>(
    prepare(apiUserLoginH5LoginBySmsRequestConfig, requestData),
    ...args,
  )
}

apiUserLoginH5LoginBySms.requestConfig = apiUserLoginH5LoginBySmsRequestConfig

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57500) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/sendSms4`
 */
export interface ApiUserLoginH5SendSms4Request {
  /**
   * 手机号
   */
  phone: string
}

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57500) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/sendSms4`
 */
export interface ApiUserLoginH5SendSms4Response {}

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57500) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/sendSms4`
 */
type ApiUserLoginH5SendSms4RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2210',
    '',
    '',
    '/user/login/h5/sendSms4',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57500) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/sendSms4`
 */
const apiUserLoginH5SendSms4RequestConfig: ApiUserLoginH5SendSms4RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_16_0_1,
    devUrl: devUrl_0_16_0_1,
    prodUrl: prodUrl_0_16_0_1,
    path: '/user/login/h5/sendSms4',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_16_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiUserLoginH5SendSms4',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'H5验证码登录', author: '杨大鑫' },
  }

/**
 * 接口 [H5验证码登录↗](https://yapi.gogpay.cn/project/2210/interface/api/57500) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/login/h5/sendSms4`
 */
export const apiUserLoginH5SendSms4 = /*#__PURE__*/ (
  requestData: ApiUserLoginH5SendSms4Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiUserLoginH5SendSms4Response>(
    prepare(apiUserLoginH5SendSms4RequestConfig, requestData),
    ...args,
  )
}

apiUserLoginH5SendSms4.requestConfig = apiUserLoginH5SendSms4RequestConfig

/**
 * 接口 [检测实名↗](https://yapi.gogpay.cn/project/2210/interface/api/59336) 的 **请求类型**
 *
 * @作者 254号开发
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/api/user/h5/checkRealName`
 */
export interface ApiUserUserH5CheckRealNameRequest {}

/**
 * 接口 [检测实名↗](https://yapi.gogpay.cn/project/2210/interface/api/59336) 的 **返回类型**
 *
 * @作者 254号开发
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/api/user/h5/checkRealName`
 */
export interface ApiUserUserH5CheckRealNameResponse {}

/**
 * 接口 [检测实名↗](https://yapi.gogpay.cn/project/2210/interface/api/59336) 的 **请求配置的类型**
 *
 * @作者 254号开发
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/api/user/h5/checkRealName`
 */
type ApiUserUserH5CheckRealNameRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2210',
    '',
    '',
    '/user/api/user/h5/checkRealName',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [检测实名↗](https://yapi.gogpay.cn/project/2210/interface/api/59336) 的 **请求配置**
 *
 * @作者 254号开发
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/api/user/h5/checkRealName`
 */
const apiUserUserH5CheckRealNameRequestConfig: ApiUserUserH5CheckRealNameRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_16_0_1,
    devUrl: devUrl_0_16_0_1,
    prodUrl: prodUrl_0_16_0_1,
    path: '/user/api/user/h5/checkRealName',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_16_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiUserUserH5CheckRealName',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '检测实名', author: '254号开发' },
  }

/**
 * 接口 [检测实名↗](https://yapi.gogpay.cn/project/2210/interface/api/59336) 的 **请求函数**
 *
 * @作者 254号开发
 * @分类 [H5用户登录↗](https://yapi.gogpay.cn/project/2210/interface/api/cat_11969)
 * @请求头 `POST /user/api/user/h5/checkRealName`
 */
export const apiUserUserH5CheckRealName = /*#__PURE__*/ (
  requestData?: ApiUserUserH5CheckRealNameRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiUserUserH5CheckRealNameResponse>(
    prepare(apiUserUserH5CheckRealNameRequestConfig, requestData),
    ...args,
  )
}

apiUserUserH5CheckRealName.requestConfig =
  apiUserUserH5CheckRealNameRequestConfig

const mockUrl_0_24_0_1 = 'https://yapi.gogpay.cn/mock/2496' as any
const devUrl_0_24_0_1 = '' as any
const prodUrl_0_24_0_1 = '' as any
const dataKey_0_24_0_1 = 'data' as any

/**
 * 接口 [批量获取排行榜信息↗](https://yapi.gogpay.cn/project/2496/interface/api/105196) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/batchTops`
 */
export interface ApiMallTopTopBatchTopsRequest {
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 排行榜ID列表
   */
  topIds: string[]
  /**
   * 排行榜等级，最大100最小1
   */
  topLevel: number
  /**
   * 省级编码
   */
  provinceCode?: string
  /**
   * 地市编码
   */
  cityCode?: string
  /**
   * 详细地址
   */
  address?: string
  /**
   * 地市名称
   */
  cityName?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 区县名称
   */
  districtName?: string
  /**
   * 省级名称
   */
  provinceName?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
}

/**
 * 接口 [批量获取排行榜信息↗](https://yapi.gogpay.cn/project/2496/interface/api/105196) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/batchTops`
 */
export type ApiMallTopTopBatchTopsResponse = {
  /**
   * 资源列表
   */
  resourceList?: {
    /**
     * 修改后排序值
     */
    changeSort?: number
    /**
     * 封面图
     */
    coverPic: string
    /**
     * 距离用户的距离-店铺类型才会有
     */
    distance: string
    /**
     * 指标值
     */
    indexValue: string
    /**
     * 资源ID
     */
    resourceId: string
    /**
     * 资源名称
     */
    resourceName: string
    /**
     * 价格
     */
    sellPrice: number
    /**
     * 排序值
     */
    sortNo?: number
    /**
     * 店铺地址-店铺类型才会有
     */
    storeAddress?: string
    /**
     * 店铺相册-店铺类型才会有
     */
    photoAlbums?: string[]
    /**
     * 评价星级-店铺类型才会有
     */
    evaluationStat?: number
    /**
     * 店铺路由-店铺类型才会有
     */
    storeUrl?: string
    /**
     * 营销标签-店铺类型才会有
     */
    marketingTag?: string
    /**
     * 活动标签-店铺类型才会有
     */
    activityTags?: string[]
    /**
     * 特点标签-店铺类型才会有
     */
    featureTags?: string[]
  }[]
  /**
   * 排行榜ID
   */
  topId?: string
  /**
   * 排行榜名称
   */
  topName?: string
}[]

/**
 * 接口 [批量获取排行榜信息↗](https://yapi.gogpay.cn/project/2496/interface/api/105196) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/batchTops`
 */
type ApiMallTopTopBatchTopsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2496',
    '',
    '',
    '/mallTop/api/top/batchTops',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量获取排行榜信息↗](https://yapi.gogpay.cn/project/2496/interface/api/105196) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/batchTops`
 */
const apiMallTopTopBatchTopsRequestConfig: ApiMallTopTopBatchTopsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_24_0_1,
    devUrl: devUrl_0_24_0_1,
    prodUrl: prodUrl_0_24_0_1,
    path: '/mallTop/api/top/batchTops',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_24_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallTopTopBatchTops',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量获取排行榜信息', author: '张彬' },
  }

/**
 * 接口 [批量获取排行榜信息↗](https://yapi.gogpay.cn/project/2496/interface/api/105196) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/batchTops`
 */
export const apiMallTopTopBatchTops = /*#__PURE__*/ (
  requestData: ApiMallTopTopBatchTopsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallTopTopBatchTopsResponse>(
    prepare(apiMallTopTopBatchTopsRequestConfig, requestData),
    ...args,
  )
}

apiMallTopTopBatchTops.requestConfig = apiMallTopTopBatchTopsRequestConfig

/**
 * 接口 [获取用户排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/230018) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/userTops`
 */
export interface ApiMallTopTopUserTopsRequest {
  /**
   * 排行榜ID
   */
  topId: string
  /**
   * 排行榜等级，最大100最小1
   */
  topLevel: number
}

/**
 * 接口 [获取用户排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/230018) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/userTops`
 */
export interface ApiMallTopTopUserTopsResponse {
  /**
   * 资源列表
   */
  resourceList?: {
    /**
     * 参与排行
     */
    join?: boolean
    /**
     * 订单总量
     */
    orderTotal?: number
    /**
     * 订单总额
     */
    orderTotalAmt?: number
    /**
     * 排序
     */
    sortNo?: number
    /**
     * 用户名称
     */
    userName?: string
    /**
     * 用户电话
     */
    userPhone?: string
    /**
     * 是否是用户自己
     */
    userSelf?: boolean
  }[]
  /**
   * 排行榜ID
   */
  topId?: string
  /**
   * 排行榜名称
   */
  topName?: string
}

/**
 * 接口 [获取用户排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/230018) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/userTops`
 */
type ApiMallTopTopUserTopsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2496',
    '',
    '',
    '/mallTop/api/top/userTops',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/230018) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/userTops`
 */
const apiMallTopTopUserTopsRequestConfig: ApiMallTopTopUserTopsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_24_0_1,
    devUrl: devUrl_0_24_0_1,
    prodUrl: prodUrl_0_24_0_1,
    path: '/mallTop/api/top/userTops',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_24_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallTopTopUserTops',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户排行榜', author: '张彬' },
  }

/**
 * 接口 [获取用户排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/230018) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-获取排行榜↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_22284)
 * @请求头 `POST /mallTop/api/top/userTops`
 */
export const apiMallTopTopUserTops = /*#__PURE__*/ (
  requestData: ApiMallTopTopUserTopsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallTopTopUserTopsResponse>(
    prepare(apiMallTopTopUserTopsRequestConfig, requestData),
    ...args,
  )
}

apiMallTopTopUserTops.requestConfig = apiMallTopTopUserTopsRequestConfig

const mockUrl_0_24_0_2 = 'https://yapi.gogpay.cn/mock/2496' as any
const devUrl_0_24_0_2 = '' as any
const prodUrl_0_24_0_2 = '' as any
const dataKey_0_24_0_2 = 'data' as any

/**
 * 接口 [获取店铺列表↗](https://yapi.gogpay.cn/project/2496/interface/api/189726) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStoreList`
 */
export interface ApiMallTopStoreGetStoreListRequest {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 城市编码
   */
  cityCode?: string
  /**
   * 返回商品数量:0-8个，默认三个
   */
  commodityCount?: number
  /**
   * 街道编码
   */
  communityCode?: string
  desc?: boolean
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 用户纬度
   */
  latitude: number
  /**
   * 用户经度
   */
  longitude: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省份编码
   */
  provinceCode?: string
  /**
   * 店铺分类信息
   */
  storeClassify?: {
    /**
     * 店铺分类ID
     */
    storeClassifyId?: string
    /**
     * 店铺分类名称
     */
    storeClassifyName?: string
  }[][]
  /**
   * 店铺Id
   */
  storeId?: string[]
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 乡镇编码
   */
  townCode?: string
  /**
   * 排序类型：1-综合排序 2-距离排序 3-销量排序 4-人均消费
   */
  sortType: 1 | 2 | 3 | 4
  /**
   * 店铺类型：1-标准电商,2-标准核销 3-配送店铺
   */
  storeType: 0 | 1 | 2 | 3
}

/**
 * 接口 [获取店铺列表↗](https://yapi.gogpay.cn/project/2496/interface/api/189726) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStoreList`
 */
export type ApiMallTopStoreGetStoreListResponse = {
  /**
   * 店铺ID
   */
  storeId?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺logo(店铺封面)
   */
  storeLogo?: string
  /**
   * 省级名称
   */
  provinceName?: string
  /**
   * 地市名称
   */
  cityName?: string
  /**
   * 区县名称
   */
  districtName?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 详细地址
   */
  address?: string
  /**
   * 距离
   */
  distance?: string
  /**
   * 销量
   */
  sales?: string
  /**
   * 特点标签
   */
  featureTags?: string[]
  /**
   * 店铺类型：1-标准电商,2-标准核销 3-配送店铺
   */
  storeType?: 0 | 1 | 2 | 3
  /**
   * 满减券信息
   */
  fullCoupons?: string[]
}[]

/**
 * 接口 [获取店铺列表↗](https://yapi.gogpay.cn/project/2496/interface/api/189726) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStoreList`
 */
type ApiMallTopStoreGetStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2496',
    '',
    '',
    '/mallTop/api/store/getStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺列表↗](https://yapi.gogpay.cn/project/2496/interface/api/189726) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStoreList`
 */
const apiMallTopStoreGetStoreListRequestConfig: ApiMallTopStoreGetStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_24_0_2,
    devUrl: devUrl_0_24_0_2,
    prodUrl: prodUrl_0_24_0_2,
    path: '/mallTop/api/store/getStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_24_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallTopStoreGetStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺列表', author: '张彬' },
  }

/**
 * 接口 [获取店铺列表↗](https://yapi.gogpay.cn/project/2496/interface/api/189726) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStoreList`
 */
export const apiMallTopStoreGetStoreList = /*#__PURE__*/ (
  requestData: ApiMallTopStoreGetStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallTopStoreGetStoreListResponse>(
    prepare(apiMallTopStoreGetStoreListRequestConfig, requestData),
    ...args,
  )
}

apiMallTopStoreGetStoreList.requestConfig =
  apiMallTopStoreGetStoreListRequestConfig

/**
 * 接口 [获取店铺分页列表↗](https://yapi.gogpay.cn/project/2496/interface/api/229414) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageList`
 */
export interface ApiMallTopStoreGetStorePageListRequest {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 城市编码
   */
  cityCode?: string
  /**
   * 返回商品数量:0-8个，默认三个
   */
  commodityCount?: number
  /**
   * 街道编码
   */
  communityCode?: string
  desc?: boolean
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 用户纬度
   */
  latitude: number
  /**
   * 用户经度
   */
  longitude: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省份编码
   */
  provinceCode?: string
  /**
   * 店铺分类信息
   */
  storeClassify?: {
    /**
     * 店铺分类ID
     */
    storeClassifyId?: string
    /**
     * 店铺分类名称
     */
    storeClassifyName?: string
  }[][]
  /**
   * 店铺Id
   */
  storeId?: string[]
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 乡镇编码
   */
  townCode?: string
  /**
   * 排序类型：1-综合排序 2-距离排序 3-销量排序 4-人均消费
   */
  sortType: 1 | 2 | 3 | 4
  /**
   * 店铺类型：1-标准电商,2-标准核销 3-配送店铺
   */
  storeType: 0 | 1 | 2 | 3
}

/**
 * 接口 [获取店铺分页列表↗](https://yapi.gogpay.cn/project/2496/interface/api/229414) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageList`
 */
export type ApiMallTopStoreGetStorePageListResponse = {
  /**
   * 运营渠道Id
   */
  businessChannelId?: string
  /**
   * 创建时间
   */
  createTime?: number
  /**
   * es返回的距离,字段名字随便取,距离单位以用户在序器中指定的为准,不指定es默认为:米
   */
  distance?: string
  /**
   * 地理位置经纬度坐标 例如: "40.13933715136454,116.63441990026217"
   */
  location?: string
  /**
   * es返回的得分字段,字段名字随便取,只要加了@Score注解即可
   */
  score?: number
  /**
   * 排序数据
   */
  sort?: string
  /**
   * 店铺分类
   */
  storeClassifyList?: {
    /**
     * 店铺分类ID
     */
    storeClassifyId?: string
    /**
     * 店铺分类名称
     */
    storeClassifyName?: string
  }[][]
  /**
   * 店铺ID
   */
  storeId?: string
  /**
   * 子机构编号(店铺编号)
   */
  unitOrgCode?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺logo(店铺封面)
   */
  storeLogo?: string
  /**
   * 店铺相册(url列表)
   */
  photoAlbums?: string[]
  /**
   * 人均消费
   */
  consumeAvgAmt?: number
  /**
   * 评价星级
   */
  evaluateStar?: number
  /**
   * 营业时间
   */
  openPeriod?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 省级编码
   */
  provinceCode?: string
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 销量
   */
  sales?: number
  /**
   * 地市编码
   */
  cityCode?: string
  /**
   * 销量
   */
  exposure?: number
  /**
   * 店铺路由
   */
  storeUrl?: string
  /**
   * 详细地址
   */
  address?: string
  /**
   * 地市名称
   */
  cityName?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 区县名称
   */
  districtName?: string
  /**
   * 省级名称
   */
  provinceName?: string
  /**
   * 店铺类型:1-标电 2-标销
   */
  storeType?: number
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
  /**
   * 营销标签
   */
  marketingTag?: string
  /**
   * 活动标签
   */
  activityTags?: string[]
  /**
   * 特点标签
   */
  featureTags?: string[]
  /**
   * 商品信息
   */
  commodityList?: {
    commodityId?: string
    commodityName?: string
    commoditySubTitle?: string
    coverPic?: string
    dashPrice?: number
    defaultPrice?: number
    lowestPrice?: number
  }[]
}[]

/**
 * 接口 [获取店铺分页列表↗](https://yapi.gogpay.cn/project/2496/interface/api/229414) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageList`
 */
type ApiMallTopStoreGetStorePageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2496',
    '',
    '',
    '/mallTop/api/store/getStorePageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺分页列表↗](https://yapi.gogpay.cn/project/2496/interface/api/229414) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageList`
 */
const apiMallTopStoreGetStorePageListRequestConfig: ApiMallTopStoreGetStorePageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_24_0_2,
    devUrl: devUrl_0_24_0_2,
    prodUrl: prodUrl_0_24_0_2,
    path: '/mallTop/api/store/getStorePageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_24_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallTopStoreGetStorePageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺分页列表', author: '张彬' },
  }

/**
 * 接口 [获取店铺分页列表↗](https://yapi.gogpay.cn/project/2496/interface/api/229414) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageList`
 */
export const apiMallTopStoreGetStorePageList = /*#__PURE__*/ (
  requestData: ApiMallTopStoreGetStorePageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallTopStoreGetStorePageListResponse>(
    prepare(apiMallTopStoreGetStorePageListRequestConfig, requestData),
    ...args,
  )
}

apiMallTopStoreGetStorePageList.requestConfig =
  apiMallTopStoreGetStorePageListRequestConfig

/**
 * 接口 [获取店铺分页列表带分页返回↗](https://yapi.gogpay.cn/project/2496/interface/api/229418) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageListV2`
 */
export interface ApiMallTopStoreGetStorePageListV2Request {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 城市编码
   */
  cityCode?: string
  /**
   * 返回商品数量:0-8个，默认三个
   */
  commodityCount?: number
  /**
   * 街道编码
   */
  communityCode?: string
  desc?: boolean
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 用户纬度
   */
  latitude: number
  /**
   * 用户经度
   */
  longitude: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省份编码
   */
  provinceCode?: string
  /**
   * 店铺分类信息
   */
  storeClassify?: {
    /**
     * 店铺分类ID
     */
    storeClassifyId?: string
    /**
     * 店铺分类名称
     */
    storeClassifyName?: string
  }[][]
  /**
   * 店铺Id
   */
  storeId?: string[]
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 乡镇编码
   */
  townCode?: string
  /**
   * 排序类型：1-综合排序 2-距离排序 3-销量排序 4-人均消费
   */
  sortType: 1 | 2 | 3 | 4
  /**
   * 店铺类型：1-标准电商,2-标准核销 3-配送店铺
   */
  storeType: 0 | 1 | 2 | 3
}

/**
 * 接口 [获取店铺分页列表带分页返回↗](https://yapi.gogpay.cn/project/2496/interface/api/229418) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageListV2`
 */
export interface ApiMallTopStoreGetStorePageListV2Response {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 创建时间
     */
    createTime?: number
    /**
     * es返回的距离,字段名字随便取,距离单位以用户在序器中指定的为准,不指定es默认为:米
     */
    distance?: string
    /**
     * 地理位置经纬度坐标 例如: "40.13933715136454,116.63441990026217"
     */
    location?: string
    /**
     * es返回的得分字段,字段名字随便取,只要加了@Score注解即可
     */
    score?: number
    /**
     * 排序数据
     */
    sort?: string
    /**
     * 店铺分类
     */
    storeClassifyList?: {
      /**
       * 店铺分类ID
       */
      storeClassifyId?: string
      /**
       * 店铺分类名称
       */
      storeClassifyName?: string
    }[][]
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 子机构编号(店铺编号)
     */
    unitOrgCode?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbums?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 省级编码
     */
    provinceCode?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * 地市编码
     */
    cityCode?: string
    /**
     * 销量
     */
    exposure?: number
    /**
     * 店铺路由
     */
    storeUrl?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 地市名称
     */
    cityName?: string
    /**
     * 村居社区名称
     */
    communityName?: string
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 省级名称
     */
    provinceName?: string
    /**
     * 店铺类型:1-标电 2-标销
     */
    storeType?: number
    /**
     * 乡镇街道名称
     */
    townName?: string
    /**
     * 乡镇街道编码
     */
    townCode?: string
    /**
     * 村居社区编码
     */
    communityCode?: string
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 商品信息
     */
    commodityList?: {
      commodityId?: string
      commodityName?: string
      commoditySubTitle?: string
      coverPic?: string
      dashPrice?: number
      defaultPrice?: number
      lowestPrice?: number
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取店铺分页列表带分页返回↗](https://yapi.gogpay.cn/project/2496/interface/api/229418) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageListV2`
 */
type ApiMallTopStoreGetStorePageListV2RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2496',
    '',
    '',
    '/mallTop/api/store/getStorePageListV2',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺分页列表带分页返回↗](https://yapi.gogpay.cn/project/2496/interface/api/229418) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageListV2`
 */
const apiMallTopStoreGetStorePageListV2RequestConfig: ApiMallTopStoreGetStorePageListV2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_24_0_2,
    devUrl: devUrl_0_24_0_2,
    prodUrl: prodUrl_0_24_0_2,
    path: '/mallTop/api/store/getStorePageListV2',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_24_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallTopStoreGetStorePageListV2',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺分页列表带分页返回', author: '张彬' },
  }

/**
 * 接口 [获取店铺分页列表带分页返回↗](https://yapi.gogpay.cn/project/2496/interface/api/229418) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-店铺信息↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_33870)
 * @请求头 `POST /mallTop/api/store/getStorePageListV2`
 */
export const apiMallTopStoreGetStorePageListV2 = /*#__PURE__*/ (
  requestData: ApiMallTopStoreGetStorePageListV2Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallTopStoreGetStorePageListV2Response>(
    prepare(apiMallTopStoreGetStorePageListV2RequestConfig, requestData),
    ...args,
  )
}

apiMallTopStoreGetStorePageListV2.requestConfig =
  apiMallTopStoreGetStorePageListV2RequestConfig

const mockUrl_0_24_0_3 = 'https://yapi.gogpay.cn/mock/2496' as any
const devUrl_0_24_0_3 = '' as any
const prodUrl_0_24_0_3 = '' as any
const dataKey_0_24_0_3 = 'data' as any

/**
 * 接口 [前台分类商品信息↗](https://yapi.gogpay.cn/project/2496/interface/api/329986) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品前端分类↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_57968)
 * @请求头 `POST /mallTop/api/frontCategory/list`
 */
export interface ApiMallTopFrontCategoryListRequest {
  /**
   * 排序方式：true-正序 false-倒序
   */
  asc?: boolean
  /**
   * 前台分类ID
   */
  categoryId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序类型：1-默认排序 2-销量排序 3-价格排序
   */
  sortType?: number
}

/**
 * 接口 [前台分类商品信息↗](https://yapi.gogpay.cn/project/2496/interface/api/329986) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品前端分类↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_57968)
 * @请求头 `POST /mallTop/api/frontCategory/list`
 */
export interface ApiMallTopFrontCategoryListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 分类id
     */
    categoryId?: string
    /**
     * 商品id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityTitle?: string
    /**
     * 商品类型
     */
    commodityTypeName?: string
    /**
     * 商品详情url
     */
    commodityUrl?: string
    /**
     * 商品封面图
     */
    coverPic?: string
    /**
     * 默认规格价格
     */
    defaultPrice?: number
    /**
     * 分类商品下的操作类型:1-添加分类 2-删除分类 3-添加商品 4-删除商品
     */
    frontCategoryOperate?: number
    /**
     * 商品销量
     */
    sales?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [前台分类商品信息↗](https://yapi.gogpay.cn/project/2496/interface/api/329986) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品前端分类↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_57968)
 * @请求头 `POST /mallTop/api/frontCategory/list`
 */
type ApiMallTopFrontCategoryListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2496',
    '',
    '',
    '/mallTop/api/frontCategory/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [前台分类商品信息↗](https://yapi.gogpay.cn/project/2496/interface/api/329986) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商品前端分类↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_57968)
 * @请求头 `POST /mallTop/api/frontCategory/list`
 */
const apiMallTopFrontCategoryListRequestConfig: ApiMallTopFrontCategoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_24_0_3,
    devUrl: devUrl_0_24_0_3,
    prodUrl: prodUrl_0_24_0_3,
    path: '/mallTop/api/frontCategory/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_24_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallTopFrontCategoryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '前台分类商品信息', author: '成龙' },
  }

/**
 * 接口 [前台分类商品信息↗](https://yapi.gogpay.cn/project/2496/interface/api/329986) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商品前端分类↗](https://yapi.gogpay.cn/project/2496/interface/api/cat_57968)
 * @请求头 `POST /mallTop/api/frontCategory/list`
 */
export const apiMallTopFrontCategoryList = /*#__PURE__*/ (
  requestData: ApiMallTopFrontCategoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallTopFrontCategoryListResponse>(
    prepare(apiMallTopFrontCategoryListRequestConfig, requestData),
    ...args,
  )
}

apiMallTopFrontCategoryList.requestConfig =
  apiMallTopFrontCategoryListRequestConfig

const mockUrl_0_13_0_1 = 'https://yapi.gogpay.cn/mock/1062' as any
const devUrl_0_13_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_13_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_13_0_1 = 'data' as any

/**
 * 接口 [添加商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31009) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/add`
 */
export interface ApiSubscribeCommodityArrivalReminderAddRequest {
  /**
   * sku唯一标识
   */
  skuId: string
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [添加商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31009) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/add`
 */
export type ApiSubscribeCommodityArrivalReminderAddResponse = string

/**
 * 接口 [添加商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31009) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/add`
 */
type ApiSubscribeCommodityArrivalReminderAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1062',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/subscribe/api/commodityArrivalReminder/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31009) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/add`
 */
const apiSubscribeCommodityArrivalReminderAddRequestConfig: ApiSubscribeCommodityArrivalReminderAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_13_0_1,
    devUrl: devUrl_0_13_0_1,
    prodUrl: prodUrl_0_13_0_1,
    path: '/subscribe/api/commodityArrivalReminder/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_13_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSubscribeCommodityArrivalReminderAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加商品到货提醒', author: '杨大鑫' },
  }

/**
 * 接口 [添加商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31009) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/add`
 */
export const apiSubscribeCommodityArrivalReminderAdd = /*#__PURE__*/ (
  requestData: ApiSubscribeCommodityArrivalReminderAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSubscribeCommodityArrivalReminderAddResponse>(
    prepare(apiSubscribeCommodityArrivalReminderAddRequestConfig, requestData),
    ...args,
  )
}

apiSubscribeCommodityArrivalReminderAdd.requestConfig =
  apiSubscribeCommodityArrivalReminderAddRequestConfig

/**
 * 接口 [取消商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31017) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/cancel`
 */
export interface ApiSubscribeCommodityArrivalReminderCancelRequest {
  /**
   * sku唯一标识
   */
  skuId: string
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [取消商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31017) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/cancel`
 */
export type ApiSubscribeCommodityArrivalReminderCancelResponse = string

/**
 * 接口 [取消商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31017) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/cancel`
 */
type ApiSubscribeCommodityArrivalReminderCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1062',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/subscribe/api/commodityArrivalReminder/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31017) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/cancel`
 */
const apiSubscribeCommodityArrivalReminderCancelRequestConfig: ApiSubscribeCommodityArrivalReminderCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_13_0_1,
    devUrl: devUrl_0_13_0_1,
    prodUrl: prodUrl_0_13_0_1,
    path: '/subscribe/api/commodityArrivalReminder/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_13_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSubscribeCommodityArrivalReminderCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消商品到货提醒', author: '杨大鑫' },
  }

/**
 * 接口 [取消商品到货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/31017) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/cancel`
 */
export const apiSubscribeCommodityArrivalReminderCancel = /*#__PURE__*/ (
  requestData: ApiSubscribeCommodityArrivalReminderCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSubscribeCommodityArrivalReminderCancelResponse>(
    prepare(
      apiSubscribeCommodityArrivalReminderCancelRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSubscribeCommodityArrivalReminderCancel.requestConfig =
  apiSubscribeCommodityArrivalReminderCancelRequestConfig

/**
 * 接口 [获取商品到货提醒状态↗](https://yapi.gogpay.cn/project/1062/interface/api/31025) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/status`
 */
export interface ApiSubscribeCommodityArrivalReminderStatusRequest {
  /**
   * sku唯一标识
   */
  skuId: string
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [获取商品到货提醒状态↗](https://yapi.gogpay.cn/project/1062/interface/api/31025) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/status`
 */
export interface ApiSubscribeCommodityArrivalReminderStatusResponse {
  /**
   * 状态：1=已添加，0=未添加
   */
  status: number
}

/**
 * 接口 [获取商品到货提醒状态↗](https://yapi.gogpay.cn/project/1062/interface/api/31025) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/status`
 */
type ApiSubscribeCommodityArrivalReminderStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1062',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/subscribe/api/commodityArrivalReminder/status',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品到货提醒状态↗](https://yapi.gogpay.cn/project/1062/interface/api/31025) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/status`
 */
const apiSubscribeCommodityArrivalReminderStatusRequestConfig: ApiSubscribeCommodityArrivalReminderStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_13_0_1,
    devUrl: devUrl_0_13_0_1,
    prodUrl: prodUrl_0_13_0_1,
    path: '/subscribe/api/commodityArrivalReminder/status',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_13_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSubscribeCommodityArrivalReminderStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品到货提醒状态', author: '杨大鑫' },
  }

/**
 * 接口 [获取商品到货提醒状态↗](https://yapi.gogpay.cn/project/1062/interface/api/31025) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [商品缺货提醒↗](https://yapi.gogpay.cn/project/1062/interface/api/cat_7315)
 * @请求头 `POST /subscribe/api/commodityArrivalReminder/status`
 */
export const apiSubscribeCommodityArrivalReminderStatus = /*#__PURE__*/ (
  requestData: ApiSubscribeCommodityArrivalReminderStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSubscribeCommodityArrivalReminderStatusResponse>(
    prepare(
      apiSubscribeCommodityArrivalReminderStatusRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSubscribeCommodityArrivalReminderStatus.requestConfig =
  apiSubscribeCommodityArrivalReminderStatusRequestConfig

const mockUrl_0_6_0_1 = 'https://yapi.gogpay.cn/mock/957' as any
const devUrl_0_6_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_6_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_6_0_1 = 'data' as any

/**
 * 接口 [添加购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30305) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/add`
 */
export interface ApiShoppingCartAddRequest {
  address?: {
    /**
     * 市级编码
     */
    cityCode?: string
    /**
     * 详细地址及门牌号
     */
    detail?: string
    /**
     * 区级编码
     */
    districtCode?: string
    /**
     * 省级编码
     */
    provinceCode?: string
  }
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 购买数量
   */
  quantity: number
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * sku唯一标识
   */
  skuId: string
}

/**
 * 接口 [添加购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30305) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/add`
 */
export interface ApiShoppingCartAddResponse {}

/**
 * 接口 [添加购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30305) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/add`
 */
type ApiShoppingCartAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/957',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/shoppingCart/api/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30305) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/add`
 */
const apiShoppingCartAddRequestConfig: ApiShoppingCartAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/shoppingCart/api/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShoppingCartAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加购物车', author: '杨大鑫' },
  }

/**
 * 接口 [添加购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30305) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/add`
 */
export const apiShoppingCartAdd = /*#__PURE__*/ (
  requestData: ApiShoppingCartAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShoppingCartAddResponse>(
    prepare(apiShoppingCartAddRequestConfig, requestData),
    ...args,
  )
}

apiShoppingCartAdd.requestConfig = apiShoppingCartAddRequestConfig

/**
 * 接口 [增减商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30309) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/addOrSub`
 */
export interface ApiShoppingCartAddOrSubRequest {
  /**
   * 购物车记录ID
   */
  id: string
  /**
   * 数量
   */
  quantity: number
}

/**
 * 接口 [增减商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30309) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/addOrSub`
 */
export interface ApiShoppingCartAddOrSubResponse {}

/**
 * 接口 [增减商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30309) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/addOrSub`
 */
type ApiShoppingCartAddOrSubRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/957',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/shoppingCart/api/addOrSub',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [增减商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30309) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/addOrSub`
 */
const apiShoppingCartAddOrSubRequestConfig: ApiShoppingCartAddOrSubRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/shoppingCart/api/addOrSub',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShoppingCartAddOrSub',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '增减商品数量', author: '杨大鑫' },
  }

/**
 * 接口 [增减商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30309) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/addOrSub`
 */
export const apiShoppingCartAddOrSub = /*#__PURE__*/ (
  requestData: ApiShoppingCartAddOrSubRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShoppingCartAddOrSubResponse>(
    prepare(apiShoppingCartAddOrSubRequestConfig, requestData),
    ...args,
  )
}

apiShoppingCartAddOrSub.requestConfig = apiShoppingCartAddOrSubRequestConfig

/**
 * 接口 [获取购物车商品列表↗](https://yapi.gogpay.cn/project/957/interface/api/30313) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/list`
 */
export interface ApiShoppingCartListRequest {}

/**
 * 接口 [获取购物车商品列表↗](https://yapi.gogpay.cn/project/957/interface/api/30313) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/list`
 */
export interface ApiShoppingCartListResponse {
  /**
   * 失效商品列表
   */
  inValidList?: {
    /**
     * 配送地址
     */
    address?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 详细地址及门牌号
       */
      detail?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 省级编码
       */
      provinceCode?: string
    }
    /**
     * 商品自动下架日期
     */
    autoDownDate?: string
    /**
     * 起售数量
     */
    beginSaleQuantity?: number
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品种类：0-套餐券 1-代金券
     */
    commodityClassifyType?: '0' | '1'
    /**
     * 商品合同标题
     */
    commodityContractTitle?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品标签
     */
    commodityLabel?: string[]
    /**
     * 商品参数json
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 商品规格
     */
    commoditySpecs?: {
      /**
       * sku属性名称
       */
      attributeName: string
      /**
       * 属性下拉参数
       */
      options: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 选中下拉参数
       */
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * sku属性ID
       */
      skuAttributeId: string
    }[]
    /**
     * sku库存，前端根据具体业务情况，通过本字段判断是否库存紧张
     */
    commodityStock: number
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
     */
    commodityTradeType?: number
    /**
     * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
     */
    commodityType?: number
    /**
     * 优惠券列表
     */
    couponList?: string[]
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 当前商品价格
     */
    currentPrice: number
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 使用渠道多选：0-TV 1-移动端
     */
    distributeChannel?: number[]
    /**
     * 购物车记录ID
     */
    id: string
    /**
     * 核销类组合商品信息
     */
    jointChildWriteOffCommodityList?: {
      /**
       * 子商品ID
       */
      childCommodityId?: string
      /**
       * 子商品规格ID
       */
      childSkuId?: string
      /**
       * 组合商品名称
       */
      commodityTitle?: string
      /**
       * 数量
       */
      num?: number
      /**
       * 单次核销价格
       */
      onePrice?: number
      /**
       * 商品原名称
       */
      originalCommodityTitle?: string
      /**
       * 组合商品ID
       */
      refCommodityId?: string
      /**
       * 销售价格
       */
      sellPrice?: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType?: 0 | 1
      /**
       * 结算值
       */
      settlementValue?: number
      /**
       * 剩余库存
       */
      surplusStock?: number
    }[]
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 所属商城ID
     */
    martId?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 包邮类型: 1-包邮 2-运费模板
     */
    postType?: number
    /**
     * 预览路由
     */
    previewUrl?: string
    /**
     * 最低价(2.0之后用lowestPrice代替)
     */
    price?: number
    /**
     * 是否提供发票
     */
    provideInvoiceFlag?: number
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 购买须知ID
     */
    purchaseNotesId?: string
    /**
     * 购买数量
     */
    quantity: number
    /**
     * 类目ID
     */
    refCategoryId?: string
    /**
     * 运费模板ID
     */
    refDeliverTemplateId?: string
    /**
     * 运营渠道Id
     */
    refUserGroupId?: string
    /**
     * 售后服务: 1-换货  2-仅退款 3-退货退款
     */
    saleAfterServiceType?: number[]
    saleAfterServiceTypeSwitch?: {
      /**
       * 是否关闭换货申请 0-否 1-是
       */
      exchangeCloseFlag?: number
      /**
       * 是否关闭退货退款申请 0-否 1-是
       */
      refundAndReturnCloseFlag?: number
      /**
       * 是否关闭仅退款申请 0-否 1-是
       */
      refundOnlyCloseFlag?: number
    }
    /**
     * 销量
     */
    sales?: number
    /**
     * 搜索词
     */
    searchWord?: string[]
    /**
     * 销售渠道ID
     */
    sellChannelId?: string
    /**
     * 价格区间
     */
    sellPrices?: number[]
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType?: number
    /**
     * 单日限购量，0表示无限购
     */
    singleDayLimitPurchases: number
    /**
     * 发货/服务（小时内）时间
     */
    sippingOrServiceTime?: number
    /**
     * sku唯一标识
     */
    skuId: string
    /**
     * 标电，虚拟商品规格详情
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 成本价
       */
      commoditySkuCost: number
      /**
       * SKU价格
       */
      commoditySkuPrice: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * SKU商品图
       */
      skuPic: string
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * SKU状态:0-无效 1-有效
       */
      skuStatus: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量(千克)
       */
      weight: number
    }[]
    /**
     * 标销商品规格详情
     */
    skuListWriteOff?: {
      /**
       * 库存
       */
      commodityStock: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: number
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId?: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: number
      /**
       * 规格名称
       */
      specName: string
      /**
       * 规格值
       */
      specValue: string
      /**
       * 库存日期
       */
      stockDate: string
      /**
       * 库存类型：0-标准库存 3-日期库存
       */
      stockType: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * 库存预警
     */
    stockAlertCount?: number
    /**
     * 库存类型： 0-标准库存 3-日期库存
     */
    stockType: number
    taxRateDetail?: {
      /**
       * 税率名称
       */
      taxName: string
      /**
       * 税率编号
       */
      taxNo: string
      /**
       * 税率
       */
      taxRate: string
    }
    /**
     * 是否涉税：0-否 1-是
     */
    texFlag?: number
    /**
     * TV轮播图
     */
    tvCarousePic?: string[]
    /**
     * TV封面图
     */
    tvCoverPic?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
    /**
     * 上下架状态 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 上架时间
     */
    upShelfTime?: string
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 失效原因
     */
    validReason?: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3'
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
     */
    zoneLimitType?: '0' | '1' | '2'
    /**
     * 重量(千克)
     */
    weight?: number
  }[]
  /**
   * 有效商品列表
   */
  validList?: {
    /**
     * 配送地址
     */
    address?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 详细地址及门牌号
       */
      detail?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 省级编码
       */
      provinceCode?: string
    }
    /**
     * 商品自动下架日期
     */
    autoDownDate?: string
    /**
     * 起售数量
     */
    beginSaleQuantity?: number
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品种类：0-套餐券 1-代金券
     */
    commodityClassifyType?: '0' | '1'
    /**
     * 商品合同标题
     */
    commodityContractTitle?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品标签
     */
    commodityLabel?: string[]
    /**
     * 商品参数json
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 商品规格
     */
    commoditySpecs?: {
      /**
       * sku属性名称
       */
      attributeName: string
      /**
       * 属性下拉参数
       */
      options: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 选中下拉参数
       */
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * sku属性ID
       */
      skuAttributeId: string
    }[]
    /**
     * sku库存，前端根据具体业务情况，通过本字段判断是否库存紧张
     */
    commodityStock: number
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
     */
    commodityTradeType?: number
    /**
     * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
     */
    commodityType?: number
    /**
     * 优惠券列表
     */
    couponList?: string[]
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 当前商品价格
     */
    currentPrice: number
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 使用渠道多选：0-TV 1-移动端
     */
    distributeChannel?: number[]
    /**
     * 购物车记录ID
     */
    id: string
    /**
     * 核销类组合商品信息
     */
    jointChildWriteOffCommodityList?: {
      /**
       * 子商品ID
       */
      childCommodityId?: string
      /**
       * 子商品规格ID
       */
      childSkuId?: string
      /**
       * 组合商品名称
       */
      commodityTitle?: string
      /**
       * 数量
       */
      num?: number
      /**
       * 单次核销价格
       */
      onePrice?: number
      /**
       * 商品原名称
       */
      originalCommodityTitle?: string
      /**
       * 组合商品ID
       */
      refCommodityId?: string
      /**
       * 销售价格
       */
      sellPrice?: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType?: 0 | 1
      /**
       * 结算值
       */
      settlementValue?: number
      /**
       * 剩余库存
       */
      surplusStock?: number
    }[]
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 所属商城ID
     */
    martId?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 包邮类型: 1-包邮 2-运费模板
     */
    postType?: number
    /**
     * 预览路由
     */
    previewUrl?: string
    /**
     * 最低价(2.0之后用lowestPrice代替)
     */
    price?: number
    /**
     * 是否提供发票
     */
    provideInvoiceFlag?: number
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 购买须知ID
     */
    purchaseNotesId?: string
    /**
     * 购买数量
     */
    quantity: number
    /**
     * 类目ID
     */
    refCategoryId?: string
    /**
     * 运费模板ID
     */
    refDeliverTemplateId?: string
    /**
     * 运营渠道Id
     */
    refUserGroupId?: string
    /**
     * 售后服务: 1-换货  2-仅退款 3-退货退款
     */
    saleAfterServiceType?: number[]
    saleAfterServiceTypeSwitch?: {
      /**
       * 是否关闭换货申请 0-否 1-是
       */
      exchangeCloseFlag?: number
      /**
       * 是否关闭退货退款申请 0-否 1-是
       */
      refundAndReturnCloseFlag?: number
      /**
       * 是否关闭仅退款申请 0-否 1-是
       */
      refundOnlyCloseFlag?: number
    }
    /**
     * 销量
     */
    sales?: number
    /**
     * 搜索词
     */
    searchWord?: string[]
    /**
     * 销售渠道ID
     */
    sellChannelId?: string
    /**
     * 价格区间
     */
    sellPrices?: number[]
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType?: number
    /**
     * 单日限购量，0表示无限购
     */
    singleDayLimitPurchases: number
    /**
     * 发货/服务（小时内）时间
     */
    sippingOrServiceTime?: number
    /**
     * sku唯一标识
     */
    skuId: string
    /**
     * 标电，虚拟商品规格详情
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 成本价
       */
      commoditySkuCost: number
      /**
       * SKU价格
       */
      commoditySkuPrice: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * SKU商品图
       */
      skuPic: string
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * SKU状态:0-无效 1-有效
       */
      skuStatus: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量(千克)
       */
      weight: number
    }[]
    /**
     * 标销商品规格详情
     */
    skuListWriteOff?: {
      /**
       * 库存
       */
      commodityStock: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: number
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId?: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: number
      /**
       * 规格名称
       */
      specName: string
      /**
       * 规格值
       */
      specValue: string
      /**
       * 库存日期
       */
      stockDate: string
      /**
       * 库存类型：0-标准库存 3-日期库存
       */
      stockType: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * 库存预警
     */
    stockAlertCount?: number
    /**
     * 库存类型： 0-标准库存 3-日期库存
     */
    stockType: number
    taxRateDetail?: {
      /**
       * 税率名称
       */
      taxName: string
      /**
       * 税率编号
       */
      taxNo: string
      /**
       * 税率
       */
      taxRate: string
    }
    /**
     * 是否涉税：0-否 1-是
     */
    texFlag?: number
    /**
     * TV轮播图
     */
    tvCarousePic?: string[]
    /**
     * TV封面图
     */
    tvCoverPic?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
    /**
     * 上下架状态 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 上架时间
     */
    upShelfTime?: string
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 失效原因
     */
    validReason?: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3'
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
     */
    zoneLimitType?: '0' | '1' | '2'
    /**
     * 重量(千克)
     */
    weight?: number
  }[]
}

/**
 * 接口 [获取购物车商品列表↗](https://yapi.gogpay.cn/project/957/interface/api/30313) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/list`
 */
type ApiShoppingCartListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/957',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/shoppingCart/api/list',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取购物车商品列表↗](https://yapi.gogpay.cn/project/957/interface/api/30313) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/list`
 */
const apiShoppingCartListRequestConfig: ApiShoppingCartListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/shoppingCart/api/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShoppingCartList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取购物车商品列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取购物车商品列表↗](https://yapi.gogpay.cn/project/957/interface/api/30313) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/list`
 */
export const apiShoppingCartList = /*#__PURE__*/ (
  requestData?: ApiShoppingCartListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShoppingCartListResponse>(
    prepare(apiShoppingCartListRequestConfig, requestData),
    ...args,
  )
}

apiShoppingCartList.requestConfig = apiShoppingCartListRequestConfig

/**
 * 接口 [获取购物车商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30317) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/quantity`
 */
export interface ApiShoppingCartQuantityRequest {}

/**
 * 接口 [获取购物车商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30317) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/quantity`
 */
export interface ApiShoppingCartQuantityResponse {
  /**
   * 数量
   */
  quantity: number
}

/**
 * 接口 [获取购物车商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30317) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/quantity`
 */
type ApiShoppingCartQuantityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/957',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/shoppingCart/api/quantity',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取购物车商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30317) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/quantity`
 */
const apiShoppingCartQuantityRequestConfig: ApiShoppingCartQuantityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/shoppingCart/api/quantity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShoppingCartQuantity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取购物车商品数量', author: '杨大鑫' },
  }

/**
 * 接口 [获取购物车商品数量↗](https://yapi.gogpay.cn/project/957/interface/api/30317) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/quantity`
 */
export const apiShoppingCartQuantity = /*#__PURE__*/ (
  requestData?: ApiShoppingCartQuantityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShoppingCartQuantityResponse>(
    prepare(apiShoppingCartQuantityRequestConfig, requestData),
    ...args,
  )
}

apiShoppingCartQuantity.requestConfig = apiShoppingCartQuantityRequestConfig

/**
 * 接口 [将商品移除购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30321) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/remove`
 */
export interface ApiShoppingCartRemoveRequest {
  /**
   * 购物车记录ID
   */
  idList: string[]
}

/**
 * 接口 [将商品移除购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30321) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/remove`
 */
export interface ApiShoppingCartRemoveResponse {}

/**
 * 接口 [将商品移除购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30321) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/remove`
 */
type ApiShoppingCartRemoveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/957',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/shoppingCart/api/remove',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [将商品移除购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30321) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/remove`
 */
const apiShoppingCartRemoveRequestConfig: ApiShoppingCartRemoveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/shoppingCart/api/remove',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShoppingCartRemove',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '将商品移除购物车', author: '杨大鑫' },
  }

/**
 * 接口 [将商品移除购物车↗](https://yapi.gogpay.cn/project/957/interface/api/30321) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/remove`
 */
export const apiShoppingCartRemove = /*#__PURE__*/ (
  requestData: ApiShoppingCartRemoveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShoppingCartRemoveResponse>(
    prepare(apiShoppingCartRemoveRequestConfig, requestData),
    ...args,
  )
}

apiShoppingCartRemove.requestConfig = apiShoppingCartRemoveRequestConfig

/**
 * 接口 [更新购物车SKU↗](https://yapi.gogpay.cn/project/957/interface/api/156015) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/updateSku`
 */
export interface ApiShoppingCartUpdateSkuRequest {
  /**
   * 购物车记录ID
   */
  id: string
  /**
   * sku唯一标识
   */
  skuId: string
  /**
   * 购买数量
   */
  quantity: number
}

/**
 * 接口 [更新购物车SKU↗](https://yapi.gogpay.cn/project/957/interface/api/156015) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/updateSku`
 */
export interface ApiShoppingCartUpdateSkuResponse {}

/**
 * 接口 [更新购物车SKU↗](https://yapi.gogpay.cn/project/957/interface/api/156015) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/updateSku`
 */
type ApiShoppingCartUpdateSkuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/957',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/shoppingCart/api/updateSku',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [更新购物车SKU↗](https://yapi.gogpay.cn/project/957/interface/api/156015) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/updateSku`
 */
const apiShoppingCartUpdateSkuRequestConfig: ApiShoppingCartUpdateSkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_6_0_1,
    devUrl: devUrl_0_6_0_1,
    prodUrl: prodUrl_0_6_0_1,
    path: '/shoppingCart/api/updateSku',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_6_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShoppingCartUpdateSku',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '更新购物车SKU', author: '杨大鑫' },
  }

/**
 * 接口 [更新购物车SKU↗](https://yapi.gogpay.cn/project/957/interface/api/156015) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [购物车↗](https://yapi.gogpay.cn/project/957/interface/api/cat_7226)
 * @请求头 `POST /shoppingCart/api/updateSku`
 */
export const apiShoppingCartUpdateSku = /*#__PURE__*/ (
  requestData: ApiShoppingCartUpdateSkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShoppingCartUpdateSkuResponse>(
    prepare(apiShoppingCartUpdateSkuRequestConfig, requestData),
    ...args,
  )
}

apiShoppingCartUpdateSku.requestConfig = apiShoppingCartUpdateSkuRequestConfig

const mockUrl_0_25_0_1 = 'https://yapi.gogpay.cn/mock/4082' as any
const devUrl_0_25_0_1 = '' as any
const prodUrl_0_25_0_1 = '' as any
const dataKey_0_25_0_1 = 'data' as any

/**
 * 接口 [获取initCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272094) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/getInitCode`
 */
export interface ApiEdgeYcYcVerifyGetInitCodeRequest {}

/**
 * 接口 [获取initCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272094) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/getInitCode`
 */
export interface ApiEdgeYcYcVerifyGetInitCodeResponse {
  /**
   * initCode的时效，默认为300秒
   */
  expiresIn?: number
  /**
   * 用于JS-SDK初始化的校验码，有效期内使用一次即失效
   */
  initCode?: string
}

/**
 * 接口 [获取initCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272094) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/getInitCode`
 */
type ApiEdgeYcYcVerifyGetInitCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4082',
    '',
    '',
    '/edgeYc/api/yc/verify/getInitCode',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取initCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272094) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/getInitCode`
 */
const apiEdgeYcYcVerifyGetInitCodeRequestConfig: ApiEdgeYcYcVerifyGetInitCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_25_0_1,
    devUrl: devUrl_0_25_0_1,
    prodUrl: prodUrl_0_25_0_1,
    path: '/edgeYc/api/yc/verify/getInitCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_25_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEdgeYcYcVerifyGetInitCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取initCode', author: '520号开发' },
  }

/**
 * 接口 [获取initCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272094) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/getInitCode`
 */
export const apiEdgeYcYcVerifyGetInitCode = /*#__PURE__*/ (
  requestData?: ApiEdgeYcYcVerifyGetInitCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEdgeYcYcVerifyGetInitCodeResponse>(
    prepare(apiEdgeYcYcVerifyGetInitCodeRequestConfig, requestData),
    ...args,
  )
}

apiEdgeYcYcVerifyGetInitCode.requestConfig =
  apiEdgeYcYcVerifyGetInitCodeRequestConfig

/**
 * 接口 [校验RequestCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272097) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/verifyRequestCode`
 */
export interface ApiEdgeYcYcVerifyVerifyRequestCodeRequest {
  /**
   * Native在开放平台申请的requestCode
   */
  requestCode: string
}

/**
 * 接口 [校验RequestCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272097) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/verifyRequestCode`
 */
export interface ApiEdgeYcYcVerifyVerifyRequestCodeResponse {
  /**
   * userAccessToken的有效时间，单位：秒
   */
  expiresIn?: number
  /**
   * 业务后端在开放平台申请的userAccessToken，有效期7200秒
   */
  userAccessToken?: string
  /**
   * requestCode检验结果：通过true 不通过false
   */
  verifyResult?: boolean
}

/**
 * 接口 [校验RequestCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272097) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/verifyRequestCode`
 */
type ApiEdgeYcYcVerifyVerifyRequestCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4082',
    '',
    '',
    '/edgeYc/api/yc/verify/verifyRequestCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [校验RequestCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272097) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/verifyRequestCode`
 */
const apiEdgeYcYcVerifyVerifyRequestCodeRequestConfig: ApiEdgeYcYcVerifyVerifyRequestCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_25_0_1,
    devUrl: devUrl_0_25_0_1,
    prodUrl: prodUrl_0_25_0_1,
    path: '/edgeYc/api/yc/verify/verifyRequestCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_25_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEdgeYcYcVerifyVerifyRequestCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '校验RequestCode', author: '520号开发' },
  }

/**
 * 接口 [校验RequestCode↗](https://yapi.gogpay.cn/project/4082/interface/api/272097) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [盐城App授权信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47808)
 * @请求头 `POST /edgeYc/api/yc/verify/verifyRequestCode`
 */
export const apiEdgeYcYcVerifyVerifyRequestCode = /*#__PURE__*/ (
  requestData: ApiEdgeYcYcVerifyVerifyRequestCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEdgeYcYcVerifyVerifyRequestCodeResponse>(
    prepare(apiEdgeYcYcVerifyVerifyRequestCodeRequestConfig, requestData),
    ...args,
  )
}

apiEdgeYcYcVerifyVerifyRequestCode.requestConfig =
  apiEdgeYcYcVerifyVerifyRequestCodeRequestConfig

const mockUrl_0_25_0_2 = 'https://yapi.gogpay.cn/mock/4082' as any
const devUrl_0_25_0_2 = '' as any
const prodUrl_0_25_0_2 = '' as any
const dataKey_0_25_0_2 = 'data' as any

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/272091) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [盐城App用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47812)
 * @请求头 `POST /edgeYc/api/yc/user/getUser`
 */
export interface ApiEdgeYcYcUserGetUserRequest {
  /**
   * 用户级别的访问令牌
   */
  userAccessToken?: string
}

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/272091) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [盐城App用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47812)
 * @请求头 `POST /edgeYc/api/yc/user/getUser`
 */
export interface ApiEdgeYcYcUserGetUserResponse {
  /**
   * 用户的token（p参数）
   */
  token?: string
}

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/272091) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [盐城App用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47812)
 * @请求头 `POST /edgeYc/api/yc/user/getUser`
 */
type ApiEdgeYcYcUserGetUserRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4082',
    '',
    '',
    '/edgeYc/api/yc/user/getUser',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/272091) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [盐城App用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47812)
 * @请求头 `POST /edgeYc/api/yc/user/getUser`
 */
const apiEdgeYcYcUserGetUserRequestConfig: ApiEdgeYcYcUserGetUserRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_25_0_2,
    devUrl: devUrl_0_25_0_2,
    prodUrl: prodUrl_0_25_0_2,
    path: '/edgeYc/api/yc/user/getUser',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_25_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEdgeYcYcUserGetUser',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户信息', author: '520号开发' },
  }

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/272091) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [盐城App用户信息↗](https://yapi.gogpay.cn/project/4082/interface/api/cat_47812)
 * @请求头 `POST /edgeYc/api/yc/user/getUser`
 */
export const apiEdgeYcYcUserGetUser = /*#__PURE__*/ (
  requestData: ApiEdgeYcYcUserGetUserRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEdgeYcYcUserGetUserResponse>(
    prepare(apiEdgeYcYcUserGetUserRequestConfig, requestData),
    ...args,
  )
}

apiEdgeYcYcUserGetUser.requestConfig = apiEdgeYcYcUserGetUserRequestConfig

const mockUrl_0_26_0_1 = 'https://yapi.gogpay.cn/mock/4926' as any
const devUrl_0_26_0_1 = '' as any
const prodUrl_0_26_0_1 = '' as any
const dataKey_0_26_0_1 = 'data' as any

/**
 * 接口 [获取H5访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/382149) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5/token`
 */
export interface ApiDuoauthOauthH5TokenRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 授权码
   */
  code?: string
  /**
   * 授权类型 authorization_code（授权码模式）、implicit（隐私模式）、client_credentials（客户端模式）
   */
  grantType?: string
  /**
   * 重定向地址
   */
  redirectUri?: string
  /**
   * 响应类型 code（授权码）、token（访问令牌）
   */
  responseType?: string
  /**
   * 授权作用域 sns_base（不弹出授权页面，直接跳转）、sns_userinfo（弹出授权页面）
   */
  scope?: string
  /**
   * 授权状态标识
   */
  state?: string
}

/**
 * 接口 [获取H5访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/382149) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5/token`
 */
export interface ApiDuoauthOauthH5TokenResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 会话密钥
   */
  sessionKey?: string
}

/**
 * 接口 [获取H5访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/382149) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5/token`
 */
type ApiDuoauthOauthH5TokenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/h5/token',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取H5访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/382149) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5/token`
 */
const apiDuoauthOauthH5TokenRequestConfig: ApiDuoauthOauthH5TokenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_1,
    devUrl: devUrl_0_26_0_1,
    prodUrl: prodUrl_0_26_0_1,
    path: '/duoauth/oauth/h5/token',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthH5Token',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取H5访问令牌', author: '熊小川' },
  }

/**
 * 接口 [获取H5访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/382149) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5/token`
 */
export const apiDuoauthOauthH5Token = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthH5TokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthH5TokenResponse>(
    prepare(apiDuoauthOauthH5TokenRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthH5Token.requestConfig = apiDuoauthOauthH5TokenRequestConfig

/**
 * 接口 [H5开发调试令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/384921) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5debug/token`
 */
export interface ApiDuoauthOauthH5debugTokenRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 手机号
   */
  phone?: string
  /**
   * 网关版本 1.0或2.0
   */
  version?: string
}

/**
 * 接口 [H5开发调试令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/384921) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5debug/token`
 */
export interface ApiDuoauthOauthH5debugTokenResponse {
  /**
   * 访问授权码
   */
  accessCode?: string
  /**
   * 访问密钥
   */
  accessKey?: string
  /**
   * 访问令牌
   */
  accessToken?: string
}

/**
 * 接口 [H5开发调试令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/384921) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5debug/token`
 */
type ApiDuoauthOauthH5debugTokenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/h5debug/token',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [H5开发调试令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/384921) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5debug/token`
 */
const apiDuoauthOauthH5debugTokenRequestConfig: ApiDuoauthOauthH5debugTokenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_1,
    devUrl: devUrl_0_26_0_1,
    prodUrl: prodUrl_0_26_0_1,
    path: '/duoauth/oauth/h5debug/token',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthH5debugToken',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'H5开发调试令牌', author: '熊小川' },
  }

/**
 * 接口 [H5开发调试令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/384921) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/h5debug/token`
 */
export const apiDuoauthOauthH5debugToken = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthH5debugTokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthH5debugTokenResponse>(
    prepare(apiDuoauthOauthH5debugTokenRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthH5debugToken.requestConfig =
  apiDuoauthOauthH5debugTokenRequestConfig

/**
 * 接口 [交换访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/404348) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/exchange/token`
 */
export interface ApiDuoauthOauthExchangeTokenRequest {
  /**
   * 前置访问令牌
   */
  accessToken?: string
  /**
   * 前置应用ID
   */
  appId?: string
  /**
   * 待交换应用ID
   */
  exAppId?: string
}

/**
 * 接口 [交换访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/404348) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/exchange/token`
 */
export interface ApiDuoauthOauthExchangeTokenResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 会话密钥
   */
  sessionKey?: string
}

/**
 * 接口 [交换访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/404348) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/exchange/token`
 */
type ApiDuoauthOauthExchangeTokenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/exchange/token',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交换访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/404348) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/exchange/token`
 */
const apiDuoauthOauthExchangeTokenRequestConfig: ApiDuoauthOauthExchangeTokenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_1,
    devUrl: devUrl_0_26_0_1,
    prodUrl: prodUrl_0_26_0_1,
    path: '/duoauth/oauth/exchange/token',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthExchangeToken',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交换访问令牌', author: '熊小川' },
  }

/**
 * 接口 [交换访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/404348) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/exchange/token`
 */
export const apiDuoauthOauthExchangeToken = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthExchangeTokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthExchangeTokenResponse>(
    prepare(apiDuoauthOauthExchangeTokenRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthExchangeToken.requestConfig =
  apiDuoauthOauthExchangeTokenRequestConfig

/**
 * 接口 [刷新访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/427963) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/refresh/token`
 */
export interface ApiDuoauthOauthRefreshTokenRequest {
  /**
   * 刷新令牌
   */
  refreshToken?: string
}

/**
 * 接口 [刷新访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/427963) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/refresh/token`
 */
export interface ApiDuoauthOauthRefreshTokenResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 刷新令牌
   */
  refreshToken?: string
  /**
   * 会话签名
   */
  sessionSign?: string
}

/**
 * 接口 [刷新访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/427963) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/refresh/token`
 */
type ApiDuoauthOauthRefreshTokenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/refresh/token',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [刷新访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/427963) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/refresh/token`
 */
const apiDuoauthOauthRefreshTokenRequestConfig: ApiDuoauthOauthRefreshTokenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_1,
    devUrl: devUrl_0_26_0_1,
    prodUrl: prodUrl_0_26_0_1,
    path: '/duoauth/oauth/refresh/token',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthRefreshToken',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '刷新访问令牌', author: '熊小川' },
  }

/**
 * 接口 [刷新访问令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/427963) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [令牌↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67103)
 * @请求头 `POST /duoauth/oauth/refresh/token`
 */
export const apiDuoauthOauthRefreshToken = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthRefreshTokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthRefreshTokenResponse>(
    prepare(apiDuoauthOauthRefreshTokenRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthRefreshToken.requestConfig =
  apiDuoauthOauthRefreshTokenRequestConfig

const mockUrl_0_26_0_2 = 'https://yapi.gogpay.cn/mock/4926' as any
const devUrl_0_26_0_2 = '' as any
const prodUrl_0_26_0_2 = '' as any
const dataKey_0_26_0_2 = 'data' as any

/**
 * 接口 [跳转链接授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382155) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/link/authorize`
 */
export interface ApiDuoauthOauthLinkAuthorizeRequest {
  /**
   * 第三方用户标识
   */
  openId?: string
  /**
   * 是否必须登录
   */
  required?: boolean
  /**
   * 授权状态标识 link_redirect（链接重定向）、h5_redirect（H5重定向）、un_login（用户未登录触发）、un_real（用户未实名触发）、un_live（用户未活体触发）
   */
  state?: string
  /**
   * 跳转链接
   */
  url?: string
}

/**
 * 接口 [跳转链接授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382155) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/link/authorize`
 */
export interface ApiDuoauthOauthLinkAuthorizeResponse {
  /**
   * 执行的动作
   */
  action?: number
  /**
   * 附加信息
   */
  addition?: string
  /**
   * 是否立即跳转
   */
  next?: boolean
  /**
   * 跳过路由参数校验
   */
  skip?: boolean
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [跳转链接授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382155) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/link/authorize`
 */
type ApiDuoauthOauthLinkAuthorizeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/link/authorize',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [跳转链接授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382155) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/link/authorize`
 */
const apiDuoauthOauthLinkAuthorizeRequestConfig: ApiDuoauthOauthLinkAuthorizeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/link/authorize',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLinkAuthorize',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '跳转链接授权', author: '熊小川' },
  }

/**
 * 接口 [跳转链接授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382155) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/link/authorize`
 */
export const apiDuoauthOauthLinkAuthorize = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLinkAuthorizeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLinkAuthorizeResponse>(
    prepare(apiDuoauthOauthLinkAuthorizeRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLinkAuthorize.requestConfig =
  apiDuoauthOauthLinkAuthorizeRequestConfig

/**
 * 接口 [H5应用授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382797) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/h5/authorize`
 */
export interface ApiDuoauthOauthH5AuthorizeRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 第三方用户标识
   */
  openId?: string
  /**
   * 重定向地址
   */
  redirectUri?: string
  /**
   * 响应类型 code（授权码）、token（访问令牌）
   */
  responseType?: string
  /**
   * 授权作用域 sns_base（不弹出授权页面，直接跳转）、sns_userinfo（弹出授权页面）
   */
  scope?: string
  /**
   * 授权状态标识 link_redirect（链接重定向）、h5_redirect（H5重定向）、un_login（用户未登录触发）、un_real（用户未实名触发）、un_live（用户未活体触发）
   */
  state?: string
}

/**
 * 接口 [H5应用授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382797) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/h5/authorize`
 */
export interface ApiDuoauthOauthH5AuthorizeResponse {
  /**
   * 执行的动作
   */
  action?: number
  /**
   * 附加信息
   */
  addition?: string
  /**
   * 是否立即跳转
   */
  next?: boolean
  /**
   * 跳过路由参数校验
   */
  skip?: boolean
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [H5应用授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382797) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/h5/authorize`
 */
type ApiDuoauthOauthH5AuthorizeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/h5/authorize',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [H5应用授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382797) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/h5/authorize`
 */
const apiDuoauthOauthH5AuthorizeRequestConfig: ApiDuoauthOauthH5AuthorizeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/h5/authorize',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthH5Authorize',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'H5应用授权', author: '熊小川' },
  }

/**
 * 接口 [H5应用授权↗](https://yapi.gogpay.cn/project/4926/interface/api/382797) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/h5/authorize`
 */
export const apiDuoauthOauthH5Authorize = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthH5AuthorizeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthH5AuthorizeResponse>(
    prepare(apiDuoauthOauthH5AuthorizeRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthH5Authorize.requestConfig =
  apiDuoauthOauthH5AuthorizeRequestConfig

/**
 * 接口 [跳转重新授权↗](https://yapi.gogpay.cn/project/4926/interface/api/404238) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/reauthorization`
 */
export interface ApiDuoauthOauthReauthorizationRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 重定向地址
   */
  redirectUri?: string
}

/**
 * 接口 [跳转重新授权↗](https://yapi.gogpay.cn/project/4926/interface/api/404238) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/reauthorization`
 */
export interface ApiDuoauthOauthReauthorizationResponse {
  /**
   * 执行的动作
   */
  action?: number
  /**
   * 附加信息
   */
  addition?: string
  /**
   * 是否立即跳转
   */
  next?: boolean
  /**
   * 跳过路由参数校验
   */
  skip?: boolean
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [跳转重新授权↗](https://yapi.gogpay.cn/project/4926/interface/api/404238) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/reauthorization`
 */
type ApiDuoauthOauthReauthorizationRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/reauthorization',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [跳转重新授权↗](https://yapi.gogpay.cn/project/4926/interface/api/404238) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/reauthorization`
 */
const apiDuoauthOauthReauthorizationRequestConfig: ApiDuoauthOauthReauthorizationRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/reauthorization',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthReauthorization',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '跳转重新授权', author: '熊小川' },
  }

/**
 * 接口 [跳转重新授权↗](https://yapi.gogpay.cn/project/4926/interface/api/404238) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/reauthorization`
 */
export const apiDuoauthOauthReauthorization = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthReauthorizationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthReauthorizationResponse>(
    prepare(apiDuoauthOauthReauthorizationRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthReauthorization.requestConfig =
  apiDuoauthOauthReauthorizationRequestConfig

/**
 * 接口 [应用授权凭证↗](https://yapi.gogpay.cn/project/4926/interface/api/469523) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/apply/certificate`
 */
export interface ApiDuoauthOauthApplyCertificateRequest {
  /**
   * 授权ID
   */
  authId?: string
  /**
   * 应用包名
   */
  bundleId?: string
  /**
   * 应用地址
   */
  redirectUri?: string
}

/**
 * 接口 [应用授权凭证↗](https://yapi.gogpay.cn/project/4926/interface/api/469523) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/apply/certificate`
 */
export interface ApiDuoauthOauthApplyCertificateResponse {
  /**
   * 临时授权状态
   */
  accessState?: string
  /**
   * 用户临时授权码
   */
  authCode?: string
}

/**
 * 接口 [应用授权凭证↗](https://yapi.gogpay.cn/project/4926/interface/api/469523) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/apply/certificate`
 */
type ApiDuoauthOauthApplyCertificateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/apply/certificate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [应用授权凭证↗](https://yapi.gogpay.cn/project/4926/interface/api/469523) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/apply/certificate`
 */
const apiDuoauthOauthApplyCertificateRequestConfig: ApiDuoauthOauthApplyCertificateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/apply/certificate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthApplyCertificate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '应用授权凭证', author: '275号开发' },
  }

/**
 * 接口 [应用授权凭证↗](https://yapi.gogpay.cn/project/4926/interface/api/469523) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/apply/certificate`
 */
export const apiDuoauthOauthApplyCertificate = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthApplyCertificateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthApplyCertificateResponse>(
    prepare(apiDuoauthOauthApplyCertificateRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthApplyCertificate.requestConfig =
  apiDuoauthOauthApplyCertificateRequestConfig

/**
 * 接口 [已授权凭证用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/469530) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/certificate/profile`
 */
export interface ApiDuoauthOauthCertificateProfileRequest {
  /**
   * 应用ID
   */
  ak?: string
  /**
   * 授权凭证
   */
  certificate?: string
  /**
   * 签名
   */
  sign?: string
  /**
   * 时间戳
   */
  timestamp?: string
}

/**
 * 接口 [已授权凭证用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/469530) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/certificate/profile`
 */
export interface ApiDuoauthOauthCertificateProfileResponse {
  /**
   * 用户是否实名
   */
  userAuthed?: boolean
  /**
   * 用户身份证号
   */
  userIdCard?: string
  /**
   * 用户手机号
   */
  userPhone?: string
  /**
   * 用户实名名称
   */
  userRealName?: string
}

/**
 * 接口 [已授权凭证用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/469530) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/certificate/profile`
 */
type ApiDuoauthOauthCertificateProfileRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/certificate/profile',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [已授权凭证用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/469530) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/certificate/profile`
 */
const apiDuoauthOauthCertificateProfileRequestConfig: ApiDuoauthOauthCertificateProfileRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/certificate/profile',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthCertificateProfile',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '已授权凭证用户信息', author: '275号开发' },
  }

/**
 * 接口 [已授权凭证用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/469530) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/certificate/profile`
 */
export const apiDuoauthOauthCertificateProfile = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthCertificateProfileRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthCertificateProfileResponse>(
    prepare(apiDuoauthOauthCertificateProfileRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthCertificateProfile.requestConfig =
  apiDuoauthOauthCertificateProfileRequestConfig

/**
 * 接口 [获取code编码（唤起微信小程序认证使用）↗](https://yapi.gogpay.cn/project/4926/interface/api/493589) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/wechat/code`
 */
export interface ApiDuoauthOauthWechatCodeRequest {
  /**
   * 身份证号码
   */
  idCard?: string
  /**
   * 跳转链接
   */
  url?: string
  /**
   * 用户真实姓名
   */
  userName?: string
}

/**
 * 接口 [获取code编码（唤起微信小程序认证使用）↗](https://yapi.gogpay.cn/project/4926/interface/api/493589) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/wechat/code`
 */
export interface ApiDuoauthOauthWechatCodeResponse {
  /**
   * AppId
   */
  appId?: string
  /**
   * code编码
   */
  code?: string
  /**
   * 原始ID
   */
  originalId?: string
  /**
   * 跳转地址
   */
  redirectUrl?: string
}

/**
 * 接口 [获取code编码（唤起微信小程序认证使用）↗](https://yapi.gogpay.cn/project/4926/interface/api/493589) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/wechat/code`
 */
type ApiDuoauthOauthWechatCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/wechat/code',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取code编码（唤起微信小程序认证使用）↗](https://yapi.gogpay.cn/project/4926/interface/api/493589) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/wechat/code`
 */
const apiDuoauthOauthWechatCodeRequestConfig: ApiDuoauthOauthWechatCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/wechat/code',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthWechatCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '获取code编码（唤起微信小程序认证使用）',
      author: '275号开发',
    },
  }

/**
 * 接口 [获取code编码（唤起微信小程序认证使用）↗](https://yapi.gogpay.cn/project/4926/interface/api/493589) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/wechat/code`
 */
export const apiDuoauthOauthWechatCode = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthWechatCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthWechatCodeResponse>(
    prepare(apiDuoauthOauthWechatCodeRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthWechatCode.requestConfig = apiDuoauthOauthWechatCodeRequestConfig

/**
 * 接口 [认证结果回调接口↗](https://yapi.gogpay.cn/project/4926/interface/api/493624) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/push/result`
 */
export interface ApiDuoauthOauthPushResultRequest {
  /**
   * 认证结果（true,false）
   */
  authResult?: boolean
  /**
   * 认证编码
   */
  code?: string
  /**
   * 应用方自定义参数，返回认证结果
   */
  customParam?: string
  /**
   * 认证时间
   */
  idCardNumberMd5?: string
  /**
   * 认证时间
   */
  identifyTime?: string
  /**
   * 认证时间
   */
  nameUtf8Md5?: string
}

/**
 * 接口 [认证结果回调接口↗](https://yapi.gogpay.cn/project/4926/interface/api/493624) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/push/result`
 */
export type ApiDuoauthOauthPushResultResponse = boolean & {
  /**
   * AppId
   */
  appId?: string
  /**
   * code编码
   */
  code?: string
  /**
   * 原始ID
   */
  originalId?: string
  /**
   * 跳转地址
   */
  redirectUrl?: string
  [k: string]: unknown
}

/**
 * 接口 [认证结果回调接口↗](https://yapi.gogpay.cn/project/4926/interface/api/493624) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/push/result`
 */
type ApiDuoauthOauthPushResultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/push/result',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [认证结果回调接口↗](https://yapi.gogpay.cn/project/4926/interface/api/493624) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/push/result`
 */
const apiDuoauthOauthPushResultRequestConfig: ApiDuoauthOauthPushResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/push/result',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthPushResult',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '认证结果回调接口', author: '275号开发' },
  }

/**
 * 接口 [认证结果回调接口↗](https://yapi.gogpay.cn/project/4926/interface/api/493624) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/push/result`
 */
export const apiDuoauthOauthPushResult = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthPushResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthPushResultResponse>(
    prepare(apiDuoauthOauthPushResultRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthPushResult.requestConfig = apiDuoauthOauthPushResultRequestConfig

/**
 * 接口 [认证结果查询↗](https://yapi.gogpay.cn/project/4926/interface/api/493631) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/result/query`
 */
export interface ApiDuoauthOauthResultQueryRequest {
  /**
   * 认证编码
   */
  code?: string
}

/**
 * 接口 [认证结果查询↗](https://yapi.gogpay.cn/project/4926/interface/api/493631) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/result/query`
 */
export interface ApiDuoauthOauthResultQueryResponse {
  /**
   * 认证结果（true,false）
   */
  authResult?: boolean
  /**
   * 认证授权码
   */
  authToken?: string
  /**
   * cardNoMd5
   */
  cardNoMd5?: string
  /**
   * 认证时间
   */
  identifyTime?: string
  /**
   * nameMd5
   */
  nameMd5?: string
}

/**
 * 接口 [认证结果查询↗](https://yapi.gogpay.cn/project/4926/interface/api/493631) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/result/query`
 */
type ApiDuoauthOauthResultQueryRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/result/query',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [认证结果查询↗](https://yapi.gogpay.cn/project/4926/interface/api/493631) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/result/query`
 */
const apiDuoauthOauthResultQueryRequestConfig: ApiDuoauthOauthResultQueryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/result/query',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthResultQuery',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '认证结果查询', author: '275号开发' },
  }

/**
 * 接口 [认证结果查询↗](https://yapi.gogpay.cn/project/4926/interface/api/493631) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/result/query`
 */
export const apiDuoauthOauthResultQuery = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthResultQueryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthResultQueryResponse>(
    prepare(apiDuoauthOauthResultQueryRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthResultQuery.requestConfig =
  apiDuoauthOauthResultQueryRequestConfig

/**
 * 接口 [查询应用实名认证方式↗](https://yapi.gogpay.cn/project/4926/interface/api/494401) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/query/realName/method`
 */
export interface ApiDuoauthOauthQueryRealNameMethodRequest {
  /**
   * 应用编号
   */
  appId?: string
  /**
   * 服务访问地址
   */
  url?: string
}

/**
 * 接口 [查询应用实名认证方式↗](https://yapi.gogpay.cn/project/4926/interface/api/494401) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/query/realName/method`
 */
export interface ApiDuoauthOauthQueryRealNameMethodResponse {
  /**
   * 活体类型 wechat:微信小程序 tianyancha:天眼查
   */
  liveType?: string
}

/**
 * 接口 [查询应用实名认证方式↗](https://yapi.gogpay.cn/project/4926/interface/api/494401) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/query/realName/method`
 */
type ApiDuoauthOauthQueryRealNameMethodRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/query/realName/method',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询应用实名认证方式↗](https://yapi.gogpay.cn/project/4926/interface/api/494401) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/query/realName/method`
 */
const apiDuoauthOauthQueryRealNameMethodRequestConfig: ApiDuoauthOauthQueryRealNameMethodRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_2,
    devUrl: devUrl_0_26_0_2,
    prodUrl: prodUrl_0_26_0_2,
    path: '/duoauth/oauth/query/realName/method',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthQueryRealNameMethod',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询应用实名认证方式', author: '275号开发' },
  }

/**
 * 接口 [查询应用实名认证方式↗](https://yapi.gogpay.cn/project/4926/interface/api/494401) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [授权↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67105)
 * @请求头 `POST /duoauth/oauth/query/realName/method`
 */
export const apiDuoauthOauthQueryRealNameMethod = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthQueryRealNameMethodRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthQueryRealNameMethodResponse>(
    prepare(apiDuoauthOauthQueryRealNameMethodRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthQueryRealNameMethod.requestConfig =
  apiDuoauthOauthQueryRealNameMethodRequestConfig

const mockUrl_0_26_0_3 = 'https://yapi.gogpay.cn/mock/4926' as any
const devUrl_0_26_0_3 = '' as any
const prodUrl_0_26_0_3 = '' as any
const dataKey_0_26_0_3 = 'data' as any

/**
 * 接口 [H5代理登录↗](https://yapi.gogpay.cn/project/4926/interface/api/382152) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/h5proxy/login`
 */
export interface ApiDuoauthOauthH5proxyLoginRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 验证码
   */
  captcha?: string
  /**
   * 授权类型 authorization_code（授权码模式）、implicit（隐私模式）、client_credentials（客户端模式）
   */
  grantType?: string
  /**
   * 登录方式 mobile-手机号登录 qrcode-多彩宝扫码登录 bridge-多彩宝网桥登录
   */
  kind?: string
  /**
   * 第三方用户标识
   */
  openId?: string
  /**
   * 密码
   */
  password?: string
  /**
   * 重定向地址
   */
  redirectUri?: string
  /**
   * 响应类型 code（授权码）、token（访问令牌）
   */
  responseType?: string
  /**
   * 授权作用域 sns_base（不弹出授权页面，直接跳转）、sns_userinfo（弹出授权页面）
   */
  scope?: string
  /**
   * 授权状态标识
   */
  state?: string
  /**
   * 注册来源(活动、催费短信等)
   */
  userSource?: string
  /**
   * 用户名
   */
  username?: string
}

/**
 * 接口 [H5代理登录↗](https://yapi.gogpay.cn/project/4926/interface/api/382152) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/h5proxy/login`
 */
export interface ApiDuoauthOauthH5proxyLoginResponse {
  /**
   * 执行的动作
   */
  action?: number
  /**
   * h5p网关应用参数
   */
  h5p?: string
  /**
   * 是否立即跳转
   */
  next?: boolean
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [H5代理登录↗](https://yapi.gogpay.cn/project/4926/interface/api/382152) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/h5proxy/login`
 */
type ApiDuoauthOauthH5proxyLoginRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/h5proxy/login',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [H5代理登录↗](https://yapi.gogpay.cn/project/4926/interface/api/382152) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/h5proxy/login`
 */
const apiDuoauthOauthH5proxyLoginRequestConfig: ApiDuoauthOauthH5proxyLoginRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/h5proxy/login',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthH5proxyLogin',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'H5代理登录', author: '熊小川' },
  }

/**
 * 接口 [H5代理登录↗](https://yapi.gogpay.cn/project/4926/interface/api/382152) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/h5proxy/login`
 */
export const apiDuoauthOauthH5proxyLogin = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthH5proxyLoginRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthH5proxyLoginResponse>(
    prepare(apiDuoauthOauthH5proxyLoginRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthH5proxyLogin.requestConfig =
  apiDuoauthOauthH5proxyLoginRequestConfig

/**
 * 接口 [发送登录验证码↗](https://yapi.gogpay.cn/project/4926/interface/api/382158) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captcha`
 */
export interface ApiDuoauthOauthLoginCaptchaRequest {
  /**
   * 手机号
   */
  phone: string
}

/**
 * 接口 [发送登录验证码↗](https://yapi.gogpay.cn/project/4926/interface/api/382158) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captcha`
 */
export interface ApiDuoauthOauthLoginCaptchaResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发送登录验证码↗](https://yapi.gogpay.cn/project/4926/interface/api/382158) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captcha`
 */
type ApiDuoauthOauthLoginCaptchaRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/login/captcha',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发送登录验证码↗](https://yapi.gogpay.cn/project/4926/interface/api/382158) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captcha`
 */
const apiDuoauthOauthLoginCaptchaRequestConfig: ApiDuoauthOauthLoginCaptchaRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/login/captcha',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLoginCaptcha',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发送登录验证码', author: '熊小川' },
  }

/**
 * 接口 [发送登录验证码↗](https://yapi.gogpay.cn/project/4926/interface/api/382158) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captcha`
 */
export const apiDuoauthOauthLoginCaptcha = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLoginCaptchaRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLoginCaptchaResponse>(
    prepare(apiDuoauthOauthLoginCaptchaRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLoginCaptcha.requestConfig =
  apiDuoauthOauthLoginCaptchaRequestConfig

/**
 * 接口 [密码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427953) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/password`
 */
export interface ApiDuoauthOauthLoginPasswordRequest {
  /**
   * 密码
   */
  password?: string
  /**
   * 手机号
   */
  phone: string
}

/**
 * 接口 [密码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427953) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/password`
 */
export interface ApiDuoauthOauthLoginPasswordResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 令牌有效期（秒）
   */
  duration?: number
  pid?: string
  profile?: {
    /**
     * 实名身份证号
     */
    authCardNo?: string
    /**
     * 实名姓名
     */
    authName?: string
    /**
     * 实名状态
     */
    authStatus?: string
    /**
     * 实名状态描述
     */
    authStatusDesc?: string
    /**
     * 用户头像
     */
    avatar?: string
    /**
     * 用户手机号
     */
    phone?: string
    /**
     * 用户名称
     */
    username?: string
  }
  /**
   * 刷新令牌
   */
  refreshToken?: string
  /**
   * 会话签名
   */
  sessionSign?: string
  /**
   * 是否绑定
   */
  unregistered?: boolean
}

/**
 * 接口 [密码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427953) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/password`
 */
type ApiDuoauthOauthLoginPasswordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/login/password',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [密码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427953) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/password`
 */
const apiDuoauthOauthLoginPasswordRequestConfig: ApiDuoauthOauthLoginPasswordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/login/password',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLoginPassword',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '密码登录', author: '熊小川' },
  }

/**
 * 接口 [密码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427953) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/password`
 */
export const apiDuoauthOauthLoginPassword = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLoginPasswordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLoginPasswordResponse>(
    prepare(apiDuoauthOauthLoginPasswordRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLoginPassword.requestConfig =
  apiDuoauthOauthLoginPasswordRequestConfig

/**
 * 接口 [验证码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427958) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/sms`
 */
export interface ApiDuoauthOauthLoginSmsRequest {
  /**
   * 验证码
   */
  captcha?: string
  /**
   * 手机号
   */
  phone: string
  /**
   * 网络身份证码（PID）
   */
  pid?: string
}

/**
 * 接口 [验证码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427958) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/sms`
 */
export interface ApiDuoauthOauthLoginSmsResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 令牌有效期（秒）
   */
  duration?: number
  pid?: string
  profile?: {
    /**
     * 实名身份证号
     */
    authCardNo?: string
    /**
     * 实名姓名
     */
    authName?: string
    /**
     * 实名状态
     */
    authStatus?: string
    /**
     * 实名状态描述
     */
    authStatusDesc?: string
    /**
     * 用户头像
     */
    avatar?: string
    /**
     * 用户手机号
     */
    phone?: string
    /**
     * 用户名称
     */
    username?: string
  }
  /**
   * 刷新令牌
   */
  refreshToken?: string
  /**
   * 会话签名
   */
  sessionSign?: string
  /**
   * 是否绑定
   */
  unregistered?: boolean
}

/**
 * 接口 [验证码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427958) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/sms`
 */
type ApiDuoauthOauthLoginSmsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/login/sms',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [验证码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427958) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/sms`
 */
const apiDuoauthOauthLoginSmsRequestConfig: ApiDuoauthOauthLoginSmsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/login/sms',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLoginSms',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '验证码登录', author: '熊小川' },
  }

/**
 * 接口 [验证码登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427958) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/sms`
 */
export const apiDuoauthOauthLoginSms = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLoginSmsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLoginSmsResponse>(
    prepare(apiDuoauthOauthLoginSmsRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLoginSms.requestConfig = apiDuoauthOauthLoginSmsRequestConfig

/**
 * 接口 [一键登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427998) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/oneclick`
 */
export interface ApiDuoauthOauthLoginOneclickRequest {
  /**
   * 一键登录SDK访问凭证
   */
  accessToken?: string
}

/**
 * 接口 [一键登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427998) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/oneclick`
 */
export interface ApiDuoauthOauthLoginOneclickResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 令牌有效期（秒）
   */
  duration?: number
  pid?: string
  profile?: {
    /**
     * 实名身份证号
     */
    authCardNo?: string
    /**
     * 实名姓名
     */
    authName?: string
    /**
     * 实名状态
     */
    authStatus?: string
    /**
     * 实名状态描述
     */
    authStatusDesc?: string
    /**
     * 用户头像
     */
    avatar?: string
    /**
     * 用户手机号
     */
    phone?: string
    /**
     * 用户名称
     */
    username?: string
  }
  /**
   * 刷新令牌
   */
  refreshToken?: string
  /**
   * 会话签名
   */
  sessionSign?: string
  /**
   * 是否绑定
   */
  unregistered?: boolean
}

/**
 * 接口 [一键登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427998) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/oneclick`
 */
type ApiDuoauthOauthLoginOneclickRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/login/oneclick',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [一键登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427998) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/oneclick`
 */
const apiDuoauthOauthLoginOneclickRequestConfig: ApiDuoauthOauthLoginOneclickRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/login/oneclick',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLoginOneclick',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '一键登录', author: '熊小川' },
  }

/**
 * 接口 [一键登录↗](https://yapi.gogpay.cn/project/4926/interface/api/427998) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/oneclick`
 */
export const apiDuoauthOauthLoginOneclick = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLoginOneclickRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLoginOneclickResponse>(
    prepare(apiDuoauthOauthLoginOneclickRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLoginOneclick.requestConfig =
  apiDuoauthOauthLoginOneclickRequestConfig

/**
 * 接口 [发送登录验证码(需要验证图形验证码)↗](https://yapi.gogpay.cn/project/4926/interface/api/472393) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captchaV2`
 */
export interface ApiDuoauthOauthLoginCaptchaV2Request {
  /**
   * 手机号
   */
  phone: string
}

/**
 * 接口 [发送登录验证码(需要验证图形验证码)↗](https://yapi.gogpay.cn/project/4926/interface/api/472393) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captchaV2`
 */
export interface ApiDuoauthOauthLoginCaptchaV2Response {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发送登录验证码(需要验证图形验证码)↗](https://yapi.gogpay.cn/project/4926/interface/api/472393) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captchaV2`
 */
type ApiDuoauthOauthLoginCaptchaV2RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/login/captchaV2',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发送登录验证码(需要验证图形验证码)↗](https://yapi.gogpay.cn/project/4926/interface/api/472393) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captchaV2`
 */
const apiDuoauthOauthLoginCaptchaV2RequestConfig: ApiDuoauthOauthLoginCaptchaV2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/login/captchaV2',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLoginCaptchaV2',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '发送登录验证码(需要验证图形验证码)',
      author: '275号开发',
    },
  }

/**
 * 接口 [发送登录验证码(需要验证图形验证码)↗](https://yapi.gogpay.cn/project/4926/interface/api/472393) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/captchaV2`
 */
export const apiDuoauthOauthLoginCaptchaV2 = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLoginCaptchaV2Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLoginCaptchaV2Response>(
    prepare(apiDuoauthOauthLoginCaptchaV2RequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLoginCaptchaV2.requestConfig =
  apiDuoauthOauthLoginCaptchaV2RequestConfig

/**
 * 接口 [网路身份证认证登录↗](https://yapi.gogpay.cn/project/4926/interface/api/493582) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/vieId`
 */
export interface ApiDuoauthOauthLoginVieIdRequest {
  /**
   * 业务序列号
   */
  bizSeq: string
  /**
   * 认证请求数据
   */
  idCardAuthData: string
}

/**
 * 接口 [网路身份证认证登录↗](https://yapi.gogpay.cn/project/4926/interface/api/493582) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/vieId`
 */
export interface ApiDuoauthOauthLoginVieIdResponse {
  /**
   * 访问令牌
   */
  accessToken?: string
  /**
   * 令牌有效期（秒）
   */
  duration?: number
  pid?: string
  profile?: {
    /**
     * 实名身份证号
     */
    authCardNo?: string
    /**
     * 实名姓名
     */
    authName?: string
    /**
     * 实名状态
     */
    authStatus?: string
    /**
     * 实名状态描述
     */
    authStatusDesc?: string
    /**
     * 用户头像
     */
    avatar?: string
    /**
     * 用户手机号
     */
    phone?: string
    /**
     * 用户名称
     */
    username?: string
  }
  /**
   * 刷新令牌
   */
  refreshToken?: string
  /**
   * 会话签名
   */
  sessionSign?: string
  /**
   * 是否绑定
   */
  unregistered?: boolean
}

/**
 * 接口 [网路身份证认证登录↗](https://yapi.gogpay.cn/project/4926/interface/api/493582) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/vieId`
 */
type ApiDuoauthOauthLoginVieIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/oauth/login/vieId',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [网路身份证认证登录↗](https://yapi.gogpay.cn/project/4926/interface/api/493582) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/vieId`
 */
const apiDuoauthOauthLoginVieIdRequestConfig: ApiDuoauthOauthLoginVieIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_3,
    devUrl: devUrl_0_26_0_3,
    prodUrl: prodUrl_0_26_0_3,
    path: '/duoauth/oauth/login/vieId',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOauthLoginVieId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '网路身份证认证登录', author: '275号开发' },
  }

/**
 * 接口 [网路身份证认证登录↗](https://yapi.gogpay.cn/project/4926/interface/api/493582) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [登录↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_67107)
 * @请求头 `POST /duoauth/oauth/login/vieId`
 */
export const apiDuoauthOauthLoginVieId = /*#__PURE__*/ (
  requestData: ApiDuoauthOauthLoginVieIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOauthLoginVieIdResponse>(
    prepare(apiDuoauthOauthLoginVieIdRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOauthLoginVieId.requestConfig = apiDuoauthOauthLoginVieIdRequestConfig

const mockUrl_0_26_0_4 = 'https://yapi.gogpay.cn/mock/4926' as any
const devUrl_0_26_0_4 = '' as any
const prodUrl_0_26_0_4 = '' as any
const dataKey_0_26_0_4 = 'data' as any

/**
 * 接口 [保存授权记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471238) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveAuthRecord`
 */
export interface ApiDuoauthOpenOauthSaveAuthRecordRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 用户手机号
   */
  phone?: string
  /**
   * 协议集合
   */
  policyIdList?: string[]
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [保存授权记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471238) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveAuthRecord`
 */
export type ApiDuoauthOpenOauthSaveAuthRecordResponse = boolean

/**
 * 接口 [保存授权记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471238) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveAuthRecord`
 */
type ApiDuoauthOpenOauthSaveAuthRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/open/oauth/saveAuthRecord',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [保存授权记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471238) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveAuthRecord`
 */
const apiDuoauthOpenOauthSaveAuthRecordRequestConfig: ApiDuoauthOpenOauthSaveAuthRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_4,
    devUrl: devUrl_0_26_0_4,
    prodUrl: prodUrl_0_26_0_4,
    path: '/duoauth/open/oauth/saveAuthRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOpenOauthSaveAuthRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '保存授权记录', author: '275号开发' },
  }

/**
 * 接口 [保存授权记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471238) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveAuthRecord`
 */
export const apiDuoauthOpenOauthSaveAuthRecord = /*#__PURE__*/ (
  requestData: ApiDuoauthOpenOauthSaveAuthRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOpenOauthSaveAuthRecordResponse>(
    prepare(apiDuoauthOpenOauthSaveAuthRecordRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOpenOauthSaveAuthRecord.requestConfig =
  apiDuoauthOpenOauthSaveAuthRecordRequestConfig

/**
 * 接口 [保存应用访问记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471245) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveThirdAppVisit`
 */
export interface ApiDuoauthOpenOauthSaveThirdAppVisitRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 用户手机号
   */
  phone?: string
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [保存应用访问记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471245) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveThirdAppVisit`
 */
export type ApiDuoauthOpenOauthSaveThirdAppVisitResponse = boolean

/**
 * 接口 [保存应用访问记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471245) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveThirdAppVisit`
 */
type ApiDuoauthOpenOauthSaveThirdAppVisitRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/open/oauth/saveThirdAppVisit',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [保存应用访问记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471245) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveThirdAppVisit`
 */
const apiDuoauthOpenOauthSaveThirdAppVisitRequestConfig: ApiDuoauthOpenOauthSaveThirdAppVisitRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_4,
    devUrl: devUrl_0_26_0_4,
    prodUrl: prodUrl_0_26_0_4,
    path: '/duoauth/open/oauth/saveThirdAppVisit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOpenOauthSaveThirdAppVisit',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '保存应用访问记录', author: '275号开发' },
  }

/**
 * 接口 [保存应用访问记录↗](https://yapi.gogpay.cn/project/4926/interface/api/471245) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/saveThirdAppVisit`
 */
export const apiDuoauthOpenOauthSaveThirdAppVisit = /*#__PURE__*/ (
  requestData: ApiDuoauthOpenOauthSaveThirdAppVisitRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOpenOauthSaveThirdAppVisitResponse>(
    prepare(apiDuoauthOpenOauthSaveThirdAppVisitRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOpenOauthSaveThirdAppVisit.requestConfig =
  apiDuoauthOpenOauthSaveThirdAppVisitRequestConfig

/**
 * 接口 [获取应用配置详情↗](https://yapi.gogpay.cn/project/4926/interface/api/471294) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/authConfigDetails`
 */
export interface ApiDuoauthOpenOauthAuthConfigDetailsRequest {
  /**
   * 应用Id
   */
  appId: string
}

/**
 * 接口 [获取应用配置详情↗](https://yapi.gogpay.cn/project/4926/interface/api/471294) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/authConfigDetails`
 */
export interface ApiDuoauthOpenOauthAuthConfigDetailsResponse {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 授权字段
   */
  authField?: string[]
  /**
   * 授权字段数据
   */
  authFieldData?: {}[]
  /**
   * 数据传输类型 0:URL加密传输 1:接口获取
   */
  dataTransferType?: number
  /**
   * 提示语
   */
  hintMessage?: string
  /**
   * 配置编号
   */
  id?: string
  /**
   * 隐私协议数据集合
   */
  policyData?: {
    /**
     * 政策地址
     */
    policyUrl?: string
    /**
     * 隐私政策记录ID
     */
    privacyPolicyId?: string
    /**
     * 协议标题
     */
    protocolTitle?: string
    /**
     * 资源标题
     */
    resourceTitle?: string
  }[]
  /**
   * 协议集合
   */
  policyIdList?: string[]
  /**
   * 资源id
   */
  resourceId?: string
  /**
   * 跳转地址
   */
  skipUrl?: string
}

/**
 * 接口 [获取应用配置详情↗](https://yapi.gogpay.cn/project/4926/interface/api/471294) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/authConfigDetails`
 */
type ApiDuoauthOpenOauthAuthConfigDetailsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/open/oauth/authConfigDetails',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取应用配置详情↗](https://yapi.gogpay.cn/project/4926/interface/api/471294) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/authConfigDetails`
 */
const apiDuoauthOpenOauthAuthConfigDetailsRequestConfig: ApiDuoauthOpenOauthAuthConfigDetailsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_4,
    devUrl: devUrl_0_26_0_4,
    prodUrl: prodUrl_0_26_0_4,
    path: '/duoauth/open/oauth/authConfigDetails',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOpenOauthAuthConfigDetails',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取应用配置详情', author: '275号开发' },
  }

/**
 * 接口 [获取应用配置详情↗](https://yapi.gogpay.cn/project/4926/interface/api/471294) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/authConfigDetails`
 */
export const apiDuoauthOpenOauthAuthConfigDetails = /*#__PURE__*/ (
  requestData: ApiDuoauthOpenOauthAuthConfigDetailsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOpenOauthAuthConfigDetailsResponse>(
    prepare(apiDuoauthOpenOauthAuthConfigDetailsRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOpenOauthAuthConfigDetails.requestConfig =
  apiDuoauthOpenOauthAuthConfigDetailsRequestConfig

/**
 * 接口 [获取用户是否授权↗](https://yapi.gogpay.cn/project/4926/interface/api/471308) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/checkUserAuth`
 */
export interface ApiDuoauthOpenOauthCheckUserAuthRequest {
  /**
   * 应用Id
   */
  appId: string
  /**
   * 用户手机号
   */
  phone?: string
}

/**
 * 接口 [获取用户是否授权↗](https://yapi.gogpay.cn/project/4926/interface/api/471308) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/checkUserAuth`
 */
export type ApiDuoauthOpenOauthCheckUserAuthResponse = boolean

/**
 * 接口 [获取用户是否授权↗](https://yapi.gogpay.cn/project/4926/interface/api/471308) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/checkUserAuth`
 */
type ApiDuoauthOpenOauthCheckUserAuthRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/open/oauth/checkUserAuth',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户是否授权↗](https://yapi.gogpay.cn/project/4926/interface/api/471308) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/checkUserAuth`
 */
const apiDuoauthOpenOauthCheckUserAuthRequestConfig: ApiDuoauthOpenOauthCheckUserAuthRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_4,
    devUrl: devUrl_0_26_0_4,
    prodUrl: prodUrl_0_26_0_4,
    path: '/duoauth/open/oauth/checkUserAuth',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOpenOauthCheckUserAuth',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户是否授权', author: '275号开发' },
  }

/**
 * 接口 [获取用户是否授权↗](https://yapi.gogpay.cn/project/4926/interface/api/471308) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/checkUserAuth`
 */
export const apiDuoauthOpenOauthCheckUserAuth = /*#__PURE__*/ (
  requestData: ApiDuoauthOpenOauthCheckUserAuthRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOpenOauthCheckUserAuthResponse>(
    prepare(apiDuoauthOpenOauthCheckUserAuthRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOpenOauthCheckUserAuth.requestConfig =
  apiDuoauthOpenOauthCheckUserAuthRequestConfig

/**
 * 接口 [获取授权凭证或者加密数据↗](https://yapi.gogpay.cn/project/4926/interface/api/482655) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/certificate`
 */
export interface ApiDuoauthOpenOauthCertificateRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 数据传输类型 0:URL加密传输 1:接口获取
   */
  dataTransferType?: number
}

/**
 * 接口 [获取授权凭证或者加密数据↗](https://yapi.gogpay.cn/project/4926/interface/api/482655) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/certificate`
 */
export interface ApiDuoauthOpenOauthCertificateResponse {
  /**
   * 授权凭证
   */
  certificate?: string
  /**
   * 密文数据
   */
  cipherData?: {}
}

/**
 * 接口 [获取授权凭证或者加密数据↗](https://yapi.gogpay.cn/project/4926/interface/api/482655) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/certificate`
 */
type ApiDuoauthOpenOauthCertificateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/open/oauth/certificate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取授权凭证或者加密数据↗](https://yapi.gogpay.cn/project/4926/interface/api/482655) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/certificate`
 */
const apiDuoauthOpenOauthCertificateRequestConfig: ApiDuoauthOpenOauthCertificateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_4,
    devUrl: devUrl_0_26_0_4,
    prodUrl: prodUrl_0_26_0_4,
    path: '/duoauth/open/oauth/certificate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOpenOauthCertificate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取授权凭证或者加密数据', author: '275号开发' },
  }

/**
 * 接口 [获取授权凭证或者加密数据↗](https://yapi.gogpay.cn/project/4926/interface/api/482655) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/certificate`
 */
export const apiDuoauthOpenOauthCertificate = /*#__PURE__*/ (
  requestData: ApiDuoauthOpenOauthCertificateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOpenOauthCertificateResponse>(
    prepare(apiDuoauthOpenOauthCertificateRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOpenOauthCertificate.requestConfig =
  apiDuoauthOpenOauthCertificateRequestConfig

/**
 * 接口 [根据授权凭证获取用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/482662) 的 **请求类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/profile`
 */
export interface ApiDuoauthOpenOauthProfileRequest {
  /**
   * 应用ID
   */
  appId?: string
  /**
   * 授权凭证
   */
  certificate?: string
}

/**
 * 接口 [根据授权凭证获取用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/482662) 的 **返回类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/profile`
 */
export interface ApiDuoauthOpenOauthProfileResponse {
  /**
   * 用户信息
   */
  userAuthInfo?: {}
}

/**
 * 接口 [根据授权凭证获取用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/482662) 的 **请求配置的类型**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/profile`
 */
type ApiDuoauthOpenOauthProfileRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/4926',
    '',
    '',
    '/duoauth/open/oauth/profile',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据授权凭证获取用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/482662) 的 **请求配置**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/profile`
 */
const apiDuoauthOpenOauthProfileRequestConfig: ApiDuoauthOpenOauthProfileRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_26_0_4,
    devUrl: devUrl_0_26_0_4,
    prodUrl: prodUrl_0_26_0_4,
    path: '/duoauth/open/oauth/profile',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_26_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiDuoauthOpenOauthProfile',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '根据授权凭证获取用户信息', author: '275号开发' },
  }

/**
 * 接口 [根据授权凭证获取用户信息↗](https://yapi.gogpay.cn/project/4926/interface/api/482662) 的 **请求函数**
 *
 * @作者 275号开发
 * @分类 [开放认证相关↗](https://yapi.gogpay.cn/project/4926/interface/api/cat_84960)
 * @请求头 `POST /duoauth/open/oauth/profile`
 */
export const apiDuoauthOpenOauthProfile = /*#__PURE__*/ (
  requestData: ApiDuoauthOpenOauthProfileRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiDuoauthOpenOauthProfileResponse>(
    prepare(apiDuoauthOpenOauthProfileRequestConfig, requestData),
    ...args,
  )
}

apiDuoauthOpenOauthProfile.requestConfig =
  apiDuoauthOpenOauthProfileRequestConfig

const mockUrl_0_3_0_3 = 'https://yapi.gogpay.cn/mock/969' as any
const devUrl_0_3_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_3_0_3 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_3_0_3 = 'data' as any

/**
 * 接口 [增加\/修改 场景↗](https://yapi.gogpay.cn/project/969/interface/api/25213) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/add`
 */
export interface ApiSceneAddRequest {
  /**
   * 条件的列表
   */
  conditions?: {
    /**
     * 筛选名称
     */
    filterCondition?: string
    /**
     * 筛选方式
     */
    filterName?: boolean
    /**
     * 筛选值
     */
    filterValue?: string
    id?: string
    /**
     * 1，与 2，或
     */
    logic?: string
    /**
     * 场景id
     */
    sceneId?: string
  }[]
  /**
   * 默认搜索关键字
   */
  defaultKeyWord?: string
  /**
   * 描述
   */
  description?: string
  id?: string
  /**
   * 场景名称
   */
  name?: string
  /**
   * 绑定的类目参数
   */
  refCategoryIds?: string[]
  /**
   * 场景类型
   */
  sceneType?: string
  /**
   * 搜索范围
   */
  searchRange?: boolean
  /**
   * 使用状态
   */
  status?: boolean
}

/**
 * 接口 [增加\/修改 场景↗](https://yapi.gogpay.cn/project/969/interface/api/25213) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/add`
 */
export interface ApiSceneAddResponse {}

/**
 * 接口 [增加\/修改 场景↗](https://yapi.gogpay.cn/project/969/interface/api/25213) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/add`
 */
type ApiSceneAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/scene/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [增加\/修改 场景↗](https://yapi.gogpay.cn/project/969/interface/api/25213) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/add`
 */
const apiSceneAddRequestConfig: ApiSceneAddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_3_0_3,
  devUrl: devUrl_0_3_0_3,
  prodUrl: prodUrl_0_3_0_3,
  path: '/scene/add',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_3_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiSceneAdd',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: { title: '增加/修改 场景', author: '310号开发' },
}

/**
 * 接口 [增加\/修改 场景↗](https://yapi.gogpay.cn/project/969/interface/api/25213) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/add`
 */
export const apiSceneAdd = /*#__PURE__*/ (
  requestData: ApiSceneAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSceneAddResponse>(
    prepare(apiSceneAddRequestConfig, requestData),
    ...args,
  )
}

apiSceneAdd.requestConfig = apiSceneAddRequestConfig

/**
 * 接口 [\/禁用\/场景启用)↗](https://yapi.gogpay.cn/project/969/interface/api/25217) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/enableScene`
 */
export interface ApiSceneEnableSceneRequest {
  /**
   * 场景id
   */
  sceneId: string
  /**
   * 状态
   */
  status: boolean
}

/**
 * 接口 [\/禁用\/场景启用)↗](https://yapi.gogpay.cn/project/969/interface/api/25217) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/enableScene`
 */
export interface ApiSceneEnableSceneResponse {}

/**
 * 接口 [\/禁用\/场景启用)↗](https://yapi.gogpay.cn/project/969/interface/api/25217) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/enableScene`
 */
type ApiSceneEnableSceneRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/scene/enableScene',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [\/禁用\/场景启用)↗](https://yapi.gogpay.cn/project/969/interface/api/25217) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/enableScene`
 */
const apiSceneEnableSceneRequestConfig: ApiSceneEnableSceneRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_3,
    devUrl: devUrl_0_3_0_3,
    prodUrl: prodUrl_0_3_0_3,
    path: '/scene/enableScene',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSceneEnableScene',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '/禁用/场景启用)', author: '310号开发' },
  }

/**
 * 接口 [\/禁用\/场景启用)↗](https://yapi.gogpay.cn/project/969/interface/api/25217) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/enableScene`
 */
export const apiSceneEnableScene = /*#__PURE__*/ (
  requestData: ApiSceneEnableSceneRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSceneEnableSceneResponse>(
    prepare(apiSceneEnableSceneRequestConfig, requestData),
    ...args,
  )
}

apiSceneEnableScene.requestConfig = apiSceneEnableSceneRequestConfig

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25221) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneById`
 */
export interface ApiSceneGetSceneByIdRequest {
  sceneId?: string
  /**
   * 1：客户端2:管理后台
   */
  sourceId?: string
}

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25221) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneById`
 */
export interface ApiSceneGetSceneByIdResponse {}

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25221) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneById`
 */
type ApiSceneGetSceneByIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/scene/getSceneById',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25221) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneById`
 */
const apiSceneGetSceneByIdRequestConfig: ApiSceneGetSceneByIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_3,
    devUrl: devUrl_0_3_0_3,
    prodUrl: prodUrl_0_3_0_3,
    path: '/scene/getSceneById',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSceneGetSceneById',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场景详情', author: '310号开发' },
  }

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25221) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneById`
 */
export const apiSceneGetSceneById = /*#__PURE__*/ (
  requestData: ApiSceneGetSceneByIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSceneGetSceneByIdResponse>(
    prepare(apiSceneGetSceneByIdRequestConfig, requestData),
    ...args,
  )
}

apiSceneGetSceneById.requestConfig = apiSceneGetSceneByIdRequestConfig

/**
 * 接口 [获取场景列表↗](https://yapi.gogpay.cn/project/969/interface/api/25225) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneList`
 */
export interface ApiSceneGetSceneListRequest {
  /**
   * 场景名称
   */
  name?: string
  /**
   * 商城id
   */
  refMartId?: string
  /**
   * 场景id
   */
  sceneId?: string
  /**
   * 场景类型
   */
  sceneType?: string
  /**
   * 状态
   */
  status?: boolean
}

/**
 * 接口 [获取场景列表↗](https://yapi.gogpay.cn/project/969/interface/api/25225) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneList`
 */
export interface ApiSceneGetSceneListResponse {}

/**
 * 接口 [获取场景列表↗](https://yapi.gogpay.cn/project/969/interface/api/25225) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneList`
 */
type ApiSceneGetSceneListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/scene/getSceneList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取场景列表↗](https://yapi.gogpay.cn/project/969/interface/api/25225) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneList`
 */
const apiSceneGetSceneListRequestConfig: ApiSceneGetSceneListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_3,
    devUrl: devUrl_0_3_0_3,
    prodUrl: prodUrl_0_3_0_3,
    path: '/scene/getSceneList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSceneGetSceneList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场景列表', author: '310号开发' },
  }

/**
 * 接口 [获取场景列表↗](https://yapi.gogpay.cn/project/969/interface/api/25225) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/getSceneList`
 */
export const apiSceneGetSceneList = /*#__PURE__*/ (
  requestData: ApiSceneGetSceneListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSceneGetSceneListResponse>(
    prepare(apiSceneGetSceneListRequestConfig, requestData),
    ...args,
  )
}

apiSceneGetSceneList.requestConfig = apiSceneGetSceneListRequestConfig

/**
 * 接口 [移除条件↗](https://yapi.gogpay.cn/project/969/interface/api/25229) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/remoteCondition`
 */
export interface ApiSceneRemoteConditionRequest {}

/**
 * 接口 [移除条件↗](https://yapi.gogpay.cn/project/969/interface/api/25229) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/remoteCondition`
 */
export interface ApiSceneRemoteConditionResponse {}

/**
 * 接口 [移除条件↗](https://yapi.gogpay.cn/project/969/interface/api/25229) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/remoteCondition`
 */
type ApiSceneRemoteConditionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/scene/remoteCondition',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [移除条件↗](https://yapi.gogpay.cn/project/969/interface/api/25229) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/remoteCondition`
 */
const apiSceneRemoteConditionRequestConfig: ApiSceneRemoteConditionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_3,
    devUrl: devUrl_0_3_0_3,
    prodUrl: prodUrl_0_3_0_3,
    path: '/scene/remoteCondition',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSceneRemoteCondition',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '移除条件', author: '310号开发' },
  }

/**
 * 接口 [移除条件↗](https://yapi.gogpay.cn/project/969/interface/api/25229) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [scene-controller↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7280)
 * @请求头 `POST /scene/remoteCondition`
 */
export const apiSceneRemoteCondition = /*#__PURE__*/ (
  requestData?: ApiSceneRemoteConditionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSceneRemoteConditionResponse>(
    prepare(apiSceneRemoteConditionRequestConfig, requestData),
    ...args,
  )
}

apiSceneRemoteCondition.requestConfig = apiSceneRemoteConditionRequestConfig

const mockUrl_0_3_0_4 = 'https://yapi.gogpay.cn/mock/969' as any
const devUrl_0_3_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_3_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_3_0_4 = 'data' as any

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/969/interface/api/25181) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchCommodity`
 */
export interface ApiSearchMartSearchSearchCommodityRequest {
  /**
   * 类目id
   */
  categoryIds?: string[]
  /**
   * 筛选条件:示例：{"author":["特德~姜","佚名"],"press":["浙江少儿出版社","商务印书馆"]}
   */
  categoryParams?: string
  /**
   * 仅看有货
   */
  inStockFlag?: boolean
  /**
   * 最大价格
   */
  maxPrice?: number
  /**
   * 最小价格
   */
  minPrice?: number
  /**
   * 当前页码
   */
  pageIndex?: number
  /**
   * 分页大小
   */
  pageSize?: number
  /**
   * 是否促销
   */
  promoteFlag?: boolean
  /**
   * 所属商城id
   */
  refMartId?: string
  /**
   * 为空串则全商城查询
   */
  refMerchantId?: string
  /**
   * 商品渠道id
   */
  refUserGroupId?: string
  /**
   * 场景id
   */
  sceneId?: string
  /**
   * 搜索词
   */
  searchWord?: string
  /**
   * 排序类型 00 销量正序，01 销量逆序 02 综合，03 价格正序,04价格逆序
   */
  sortType?: string
}

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/969/interface/api/25181) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchCommodity`
 */
export interface ApiSearchMartSearchSearchCommodityResponse {
  list?: {
    /**
     * 商户id
     */
    'refMerchantId'?: string
    /**
     * 渠道ID
     */
    'refUserGroupId'?: string
    'ProductArea'?: string
    'expiration date'?: string
    /**
     * esid
     */
    'esId'?: string
    'categoryParamsIdProductArea'?: string
    'categoryParamsIdexpiration date'?: string
    /**
     * 类目id
     */
    'refCategoryId'?: string
    'categoryParamspacking specification'?: string
    /**
     * 商品标题
     */
    'commodityTitle'?: string
    'categoryParamsexpiration date'?: string
    /**
     * 轮播图
     */
    'carouselPic'?: string[]
    /**
     * 上下架状态
     */
    'upDownShelfStatus'?: number
    'packing specification'?: string
    /**
     * 价格
     */
    'price'?: number
    'product grade'?: string
    'categoryParamsIdproduct grade'?: string
    /**
     * 划线价
     */
    'dashPrice'?: number
    /**
     * 封面图
     */
    'coverPic'?: string
    'categoryParamsDATE'?: string
    'categoryParamsIdDATE'?: string
    'commodityResourceId'?: string
    /**
     * 类目参数 json 字符串
     */
    'categoryParams'?: string
    /**
     * 包邮类型
     */
    'postType'?: number
    /**
     * 该商品的sku状态
     */
    'skuStatus'?: string
    'categoryParamsProductArea'?: string
    'saleNum'?: number
    'categoryParamsproduct grade'?: string
    'alertLeftStock'?: number
    'upTime'?: number
    'DATE'?: string
    'commodityTotalStock'?: number
    'martIdxName'?: string
    'commoditySubTitle'?: string
    'couponList'?: string[]
    'categoryParamsIdpacking specification'?: string
    'saleAfterServiceType'?: number[]
    'refMartId'?: string
    'searchWord'?: string[]
  }[]
  /**
   * 搜索id
   */
  searchId?: string
  /**
   * 总条数
   */
  total?: number
  /**
   * 总页数
   */
  totalPage?: number
}

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/969/interface/api/25181) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchCommodity`
 */
type ApiSearchMartSearchSearchCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/search/api/martSearch/searchCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/969/interface/api/25181) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchCommodity`
 */
const apiSearchMartSearchSearchCommodityRequestConfig: ApiSearchMartSearchSearchCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_4,
    devUrl: devUrl_0_3_0_4,
    prodUrl: prodUrl_0_3_0_4,
    path: '/search/api/martSearch/searchCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSearchMartSearchSearchCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '搜索商品', author: '310号开发' },
  }

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/969/interface/api/25181) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchCommodity`
 */
export const apiSearchMartSearchSearchCommodity = /*#__PURE__*/ (
  requestData: ApiSearchMartSearchSearchCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSearchMartSearchSearchCommodityResponse>(
    prepare(apiSearchMartSearchSearchCommodityRequestConfig, requestData),
    ...args,
  )
}

apiSearchMartSearchSearchCommodity.requestConfig =
  apiSearchMartSearchSearchCommodityRequestConfig

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25309) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSceneDetail`
 */
export interface ApiSearchMartSearchFindSceneDetailRequest {
  /**
   * 场景id
   */
  sceneId?: string
}

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25309) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSceneDetail`
 */
export interface ApiSearchMartSearchFindSceneDetailResponse {
  conditions?: string[]
  createTime?: null
  /**
   * 热搜词
   */
  defaultKeyWord?: string
  description?: string
  id?: string
  name?: string
  /**
   * 类目id
   */
  refCategoryIds?: string[]
  refMartId?: string
  sceneType?: string
  searchRange?: boolean
  status?: boolean
  updateTime?: null
}

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25309) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSceneDetail`
 */
type ApiSearchMartSearchFindSceneDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/search/api/martSearch/findSceneDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25309) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSceneDetail`
 */
const apiSearchMartSearchFindSceneDetailRequestConfig: ApiSearchMartSearchFindSceneDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_4,
    devUrl: devUrl_0_3_0_4,
    prodUrl: prodUrl_0_3_0_4,
    path: '/search/api/martSearch/findSceneDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSearchMartSearchFindSceneDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场景详情', author: '310号开发' },
  }

/**
 * 接口 [获取场景详情↗](https://yapi.gogpay.cn/project/969/interface/api/25309) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSceneDetail`
 */
export const apiSearchMartSearchFindSceneDetail = /*#__PURE__*/ (
  requestData: ApiSearchMartSearchFindSceneDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSearchMartSearchFindSceneDetailResponse>(
    prepare(apiSearchMartSearchFindSceneDetailRequestConfig, requestData),
    ...args,
  )
}

apiSearchMartSearchFindSceneDetail.requestConfig =
  apiSearchMartSearchFindSceneDetailRequestConfig

/**
 * 接口 [获取单个商品详情↗](https://yapi.gogpay.cn/project/969/interface/api/30841) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /api/martSearch/findCommodityById/{commodityResourceId}`
 */
export interface ApiMartSearchFindCommodityByIdCommodityResourceIdRequest {
  /**
   * commodityResourceId
   */
  commodityResourceId: string
}

/**
 * 接口 [获取单个商品详情↗](https://yapi.gogpay.cn/project/969/interface/api/30841) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /api/martSearch/findCommodityById/{commodityResourceId}`
 */
export interface ApiMartSearchFindCommodityByIdCommodityResourceIdResponse {}

/**
 * 接口 [获取单个商品详情↗](https://yapi.gogpay.cn/project/969/interface/api/30841) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /api/martSearch/findCommodityById/{commodityResourceId}`
 */
type ApiMartSearchFindCommodityByIdCommodityResourceIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/api/martSearch/findCommodityById/{commodityResourceId}',
    'data',
    'commodityResourceId',
    string,
    false
  >
>

/**
 * 接口 [获取单个商品详情↗](https://yapi.gogpay.cn/project/969/interface/api/30841) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /api/martSearch/findCommodityById/{commodityResourceId}`
 */
const apiMartSearchFindCommodityByIdCommodityResourceIdRequestConfig: ApiMartSearchFindCommodityByIdCommodityResourceIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_4,
    devUrl: devUrl_0_3_0_4,
    prodUrl: prodUrl_0_3_0_4,
    path: '/api/martSearch/findCommodityById/{commodityResourceId}',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_4,
    paramNames: ['commodityResourceId'],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMartSearchFindCommodityByIdCommodityResourceId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取单个商品详情', author: '310号开发' },
  }

/**
 * 接口 [获取单个商品详情↗](https://yapi.gogpay.cn/project/969/interface/api/30841) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /api/martSearch/findCommodityById/{commodityResourceId}`
 */
export const apiMartSearchFindCommodityByIdCommodityResourceId = /*#__PURE__*/ (
  requestData: ApiMartSearchFindCommodityByIdCommodityResourceIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMartSearchFindCommodityByIdCommodityResourceIdResponse>(
    prepare(
      apiMartSearchFindCommodityByIdCommodityResourceIdRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMartSearchFindCommodityByIdCommodityResourceId.requestConfig =
  apiMartSearchFindCommodityByIdCommodityResourceIdRequestConfig

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/969/interface/api/31865) 的 **请求类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSearchFilter`
 */
export interface ApiSearchMartSearchFindSearchFilterRequest {
  /**
   *  搜索结果返回的搜索Id
   */
  searchId?: string
}

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/969/interface/api/31865) 的 **返回类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSearchFilter`
 */
export type ApiSearchMartSearchFindSearchFilterResponse = {
  /**
   * key值
   */
  keyName: string
  /**
   * 显示的名字
   */
  showName: string
  /**
   * 对应的value字段
   */
  value: string[]
}[]

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/969/interface/api/31865) 的 **请求配置的类型**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSearchFilter`
 */
type ApiSearchMartSearchFindSearchFilterRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/search/api/martSearch/findSearchFilter',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/969/interface/api/31865) 的 **请求配置**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSearchFilter`
 */
const apiSearchMartSearchFindSearchFilterRequestConfig: ApiSearchMartSearchFindSearchFilterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_4,
    devUrl: devUrl_0_3_0_4,
    prodUrl: prodUrl_0_3_0_4,
    path: '/search/api/martSearch/findSearchFilter',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSearchMartSearchFindSearchFilter',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取搜索条件', author: '310号开发' },
  }

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/969/interface/api/31865) 的 **请求函数**
 *
 * @作者 310号开发
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/findSearchFilter`
 */
export const apiSearchMartSearchFindSearchFilter = /*#__PURE__*/ (
  requestData: ApiSearchMartSearchFindSearchFilterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSearchMartSearchFindSearchFilterResponse>(
    prepare(apiSearchMartSearchFindSearchFilterRequestConfig, requestData),
    ...args,
  )
}

apiSearchMartSearchFindSearchFilter.requestConfig =
  apiSearchMartSearchFindSearchFilterRequestConfig

/**
 * 接口 [关键字搜索↗](https://yapi.gogpay.cn/project/969/interface/api/81786) 的 **请求类型**
 *
 * @作者 白鸿木
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchKeyword`
 */
export interface ApiSearchMartSearchSearchKeywordRequest {
  /**
   * 关键字
   */
  keyword?: string
  /**
   * 使用渠道 0.TV端 1.移动端 不传默认移动端
   */
  distributeChannel?: number[]
  /**
   * 渠道id
   */
  refUserGroupId: string
}

/**
 * 接口 [关键字搜索↗](https://yapi.gogpay.cn/project/969/interface/api/81786) 的 **返回类型**
 *
 * @作者 白鸿木
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchKeyword`
 */
export type ApiSearchMartSearchSearchKeywordResponse = {
  /**
   * 标题
   */
  title?: string
  /**
   * 关键字
   */
  keywords?: string
}[]

/**
 * 接口 [关键字搜索↗](https://yapi.gogpay.cn/project/969/interface/api/81786) 的 **请求配置的类型**
 *
 * @作者 白鸿木
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchKeyword`
 */
type ApiSearchMartSearchSearchKeywordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/969',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/search/api/martSearch/searchKeyword',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [关键字搜索↗](https://yapi.gogpay.cn/project/969/interface/api/81786) 的 **请求配置**
 *
 * @作者 白鸿木
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchKeyword`
 */
const apiSearchMartSearchSearchKeywordRequestConfig: ApiSearchMartSearchSearchKeywordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_3_0_4,
    devUrl: devUrl_0_3_0_4,
    prodUrl: prodUrl_0_3_0_4,
    path: '/search/api/martSearch/searchKeyword',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_3_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSearchMartSearchSearchKeyword',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '关键字搜索', author: '白鸿木' },
  }

/**
 * 接口 [关键字搜索↗](https://yapi.gogpay.cn/project/969/interface/api/81786) 的 **请求函数**
 *
 * @作者 白鸿木
 * @分类 [商城搜索中心↗](https://yapi.gogpay.cn/project/969/interface/api/cat_7301)
 * @请求头 `POST /search/api/martSearch/searchKeyword`
 */
export const apiSearchMartSearchSearchKeyword = /*#__PURE__*/ (
  requestData: ApiSearchMartSearchSearchKeywordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSearchMartSearchSearchKeywordResponse>(
    prepare(apiSearchMartSearchSearchKeywordRequestConfig, requestData),
    ...args,
  )
}

apiSearchMartSearchSearchKeyword.requestConfig =
  apiSearchMartSearchSearchKeywordRequestConfig

const mockUrl_0_10_0_2 = 'https://yapi.gogpay.cn/mock/921' as any
const devUrl_0_10_0_2 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_10_0_2 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_10_0_2 = 'data' as any

/**
 * 接口 [客户端获取获取评价配置↗](https://yapi.gogpay.cn/project/921/interface/api/311074) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluateConfig/getDetail`
 */
export interface ApiEvaluationEvaluateConfigGetDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [客户端获取获取评价配置↗](https://yapi.gogpay.cn/project/921/interface/api/311074) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluateConfig/getDetail`
 */
export interface ApiEvaluationEvaluateConfigGetDetailResponse {
  /**
   * 默认评语
   */
  defaultComment?: string
  /**
   * 评价标签
   */
  labelJson?: string[]
  /**
   * 星级评价项
   */
  starEvaluateJson?: string[]
}

/**
 * 接口 [客户端获取获取评价配置↗](https://yapi.gogpay.cn/project/921/interface/api/311074) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluateConfig/getDetail`
 */
type ApiEvaluationEvaluateConfigGetDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluateConfig/getDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取获取评价配置↗](https://yapi.gogpay.cn/project/921/interface/api/311074) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluateConfig/getDetail`
 */
const apiEvaluationEvaluateConfigGetDetailRequestConfig: ApiEvaluationEvaluateConfigGetDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_2,
    devUrl: devUrl_0_10_0_2,
    prodUrl: prodUrl_0_10_0_2,
    path: '/evaluation/api/evaluateConfig/getDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateConfigGetDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端获取获取评价配置', author: '333号开发' },
  }

/**
 * 接口 [客户端获取获取评价配置↗](https://yapi.gogpay.cn/project/921/interface/api/311074) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluateConfig/getDetail`
 */
export const apiEvaluationEvaluateConfigGetDetail = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateConfigGetDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateConfigGetDetailResponse>(
    prepare(apiEvaluationEvaluateConfigGetDetailRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateConfigGetDetail.requestConfig =
  apiEvaluationEvaluateConfigGetDetailRequestConfig

/**
 * 接口 [客户端-评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/315058) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluate/detailV2`
 */
export interface ApiEvaluationEvaluateDetailV2Request {
  /**
   * 评价id
   */
  id: string
}

/**
 * 接口 [客户端-评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/315058) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluate/detailV2`
 */
export interface ApiEvaluationEvaluateDetailV2Response {
  /**
   * 商品/服务规格
   */
  commodityServiceSpecs?: string
  /**
   * 评论时间
   */
  createTime: string
  /**
   * 追评文字
   */
  evaluateAddContent?: string
  /**
   * 评论内容
   */
  evaluateContent: string
  /**
   * 评论图片
   */
  evaluatePic: string[]
  /**
   * 星级评价项
   */
  evaluateStarList?: {
    /**
     * 评星项名称
     */
    name: string
    /**
     * 评星项星级
     */
    value: number
  }[]
  /**
   * 评论id
   */
  id: string
  /**
   * 回复内容
   */
  replyContent?: string
  /**
   * 店铺ID
   */
  storeId?: string
  /**
   * 点赞数
   */
  thumbsUpCount: number
  /**
   * 该用户是否已点赞 0否1是
   */
  thumbsUpFlag: number
  /**
   * 评论人头像
   */
  userHeadshot: string
  /**
   * 评论人昵称
   */
  userNickName: string
}

/**
 * 接口 [客户端-评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/315058) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluate/detailV2`
 */
type ApiEvaluationEvaluateDetailV2RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/detailV2',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/315058) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluate/detailV2`
 */
const apiEvaluationEvaluateDetailV2RequestConfig: ApiEvaluationEvaluateDetailV2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_2,
    devUrl: devUrl_0_10_0_2,
    prodUrl: prodUrl_0_10_0_2,
    path: '/evaluation/api/evaluate/detailV2',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateDetailV2',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-评价详情', author: '333号开发' },
  }

/**
 * 接口 [客户端-评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/315058) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/921/interface/api/cat_54464)
 * @请求头 `POST /evaluation/api/evaluate/detailV2`
 */
export const apiEvaluationEvaluateDetailV2 = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateDetailV2Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateDetailV2Response>(
    prepare(apiEvaluationEvaluateDetailV2RequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateDetailV2.requestConfig =
  apiEvaluationEvaluateDetailV2RequestConfig

const mockUrl_0_10_0_5 = 'https://yapi.gogpay.cn/mock/921' as any
const devUrl_0_10_0_5 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_10_0_5 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_10_0_5 = 'data' as any

/**
 * 接口 [获取商品有图评价数量↗](https://yapi.gogpay.cn/project/921/interface/api/27477) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/countEvaluateHavingPic`
 */
export interface ApiEvaluationEvaluateCountEvaluateHavingPicRequest {
  /**
   * 商品id
   */
  commodityServiceId: string
}

/**
 * 接口 [获取商品有图评价数量↗](https://yapi.gogpay.cn/project/921/interface/api/27477) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/countEvaluateHavingPic`
 */
export type ApiEvaluationEvaluateCountEvaluateHavingPicResponse = number

/**
 * 接口 [获取商品有图评价数量↗](https://yapi.gogpay.cn/project/921/interface/api/27477) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/countEvaluateHavingPic`
 */
type ApiEvaluationEvaluateCountEvaluateHavingPicRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/countEvaluateHavingPic',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品有图评价数量↗](https://yapi.gogpay.cn/project/921/interface/api/27477) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/countEvaluateHavingPic`
 */
const apiEvaluationEvaluateCountEvaluateHavingPicRequestConfig: ApiEvaluationEvaluateCountEvaluateHavingPicRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/countEvaluateHavingPic',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateCountEvaluateHavingPic',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品有图评价数量', author: '史博文' },
  }

/**
 * 接口 [获取商品有图评价数量↗](https://yapi.gogpay.cn/project/921/interface/api/27477) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/countEvaluateHavingPic`
 */
export const apiEvaluationEvaluateCountEvaluateHavingPic = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateCountEvaluateHavingPicRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateCountEvaluateHavingPicResponse>(
    prepare(
      apiEvaluationEvaluateCountEvaluateHavingPicRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiEvaluationEvaluateCountEvaluateHavingPic.requestConfig =
  apiEvaluationEvaluateCountEvaluateHavingPicRequestConfig

/**
 * 接口 [点赞或取消点赞评价↗](https://yapi.gogpay.cn/project/921/interface/api/27493) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/thumbsUpOrDown`
 */
export interface ApiEvaluationEvaluateThumbsUpOrDownRequest {
  /**
   * 评价id
   */
  id: string
}

/**
 * 接口 [点赞或取消点赞评价↗](https://yapi.gogpay.cn/project/921/interface/api/27493) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/thumbsUpOrDown`
 */
export interface ApiEvaluationEvaluateThumbsUpOrDownResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [点赞或取消点赞评价↗](https://yapi.gogpay.cn/project/921/interface/api/27493) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/thumbsUpOrDown`
 */
type ApiEvaluationEvaluateThumbsUpOrDownRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/thumbsUpOrDown',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [点赞或取消点赞评价↗](https://yapi.gogpay.cn/project/921/interface/api/27493) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/thumbsUpOrDown`
 */
const apiEvaluationEvaluateThumbsUpOrDownRequestConfig: ApiEvaluationEvaluateThumbsUpOrDownRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/thumbsUpOrDown',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateThumbsUpOrDown',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '点赞或取消点赞评价', author: '史博文' },
  }

/**
 * 接口 [点赞或取消点赞评价↗](https://yapi.gogpay.cn/project/921/interface/api/27493) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/thumbsUpOrDown`
 */
export const apiEvaluationEvaluateThumbsUpOrDown = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateThumbsUpOrDownRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateThumbsUpOrDownResponse>(
    prepare(apiEvaluationEvaluateThumbsUpOrDownRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateThumbsUpOrDown.requestConfig =
  apiEvaluationEvaluateThumbsUpOrDownRequestConfig

/**
 * 接口 [客户端获取评价标签列表↗](https://yapi.gogpay.cn/project/921/interface/api/29401) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLabelList`
 */
export interface ApiEvaluationEvaluateGetLabelListRequest {
  /**
   * 商品id
   */
  commodityServiceId: string
}

/**
 * 接口 [客户端获取评价标签列表↗](https://yapi.gogpay.cn/project/921/interface/api/29401) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLabelList`
 */
export type ApiEvaluationEvaluateGetLabelListResponse = {
  /**
   * 标签文本
   */
  labelContent?: string
  /**
   * 标签id
   */
  labelId?: string
}[]

/**
 * 接口 [客户端获取评价标签列表↗](https://yapi.gogpay.cn/project/921/interface/api/29401) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLabelList`
 */
type ApiEvaluationEvaluateGetLabelListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/getLabelList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取评价标签列表↗](https://yapi.gogpay.cn/project/921/interface/api/29401) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLabelList`
 */
const apiEvaluationEvaluateGetLabelListRequestConfig: ApiEvaluationEvaluateGetLabelListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/getLabelList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateGetLabelList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端获取评价标签列表', author: '史博文' },
  }

/**
 * 接口 [客户端获取评价标签列表↗](https://yapi.gogpay.cn/project/921/interface/api/29401) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLabelList`
 */
export const apiEvaluationEvaluateGetLabelList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateGetLabelListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateGetLabelListResponse>(
    prepare(apiEvaluationEvaluateGetLabelListRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateGetLabelList.requestConfig =
  apiEvaluationEvaluateGetLabelListRequestConfig

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/30257) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submit`
 */
export interface ApiEvaluationEvaluateSubmitRequest {
  /**
   * 批量评价集合
   */
  list?: {
    /**
     * 商品id
     */
    commodityServiceId: string
    /**
     * 商品名称
     */
    commodityServiceName: string
    /**
     * 商品规格
     */
    commodityServiceSpecs: string
    /**
     * 评价文字
     */
    evaluateContent?: string
    /**
     * 评价图片
     */
    evaluatePic?: string[]
    /**
     * 评价星级
     */
    evaluateStar: number
    /**
     * 标签,逗号','隔开
     */
    label?: string
    /**
     * 商户名称
     */
    merchantName: string
    /**
     * 订单金额
     */
    orderAmount: number
    /**
     * 多彩宝订单中心支付流水号
     */
    paySerialNo: string
    /**
     * 订单编号
     */
    refOrderNo: string
  }[]
}

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/30257) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submit`
 */
export interface ApiEvaluationEvaluateSubmitResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/30257) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submit`
 */
type ApiEvaluationEvaluateSubmitRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/submit',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/30257) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submit`
 */
const apiEvaluationEvaluateSubmitRequestConfig: ApiEvaluationEvaluateSubmitRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateSubmit',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提交商品评价', author: '史博文' },
  }

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/30257) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submit`
 */
export const apiEvaluationEvaluateSubmit = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateSubmitRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateSubmitResponse>(
    prepare(apiEvaluationEvaluateSubmitRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateSubmit.requestConfig =
  apiEvaluationEvaluateSubmitRequestConfig

/**
 * 接口 [客户端获取商品最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/31669) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLatestEvaluateList`
 */
export interface ApiEvaluationEvaluateGetLatestEvaluateListRequest {
  /**
   * 商品id
   */
  commodityServiceId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [客户端获取商品最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/31669) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLatestEvaluateList`
 */
export interface ApiEvaluationEvaluateGetLatestEvaluateListResponse {
  /**
   * 评价星级
   */
  evaluateStat?: number
  /**
   * 评论内容
   */
  list?: {
    /**
     * 评论列表
     */
    childList?: unknown[]
    /**
     * 商品/服务规格
     */
    commodityServiceSpecs: string
    /**
     * 评论时间
     */
    createTime: string
    /**
     * 追评文字
     */
    evaluateAddContent: string
    /**
     * 追评图片
     */
    evaluateAddPic: string[]
    /**
     * 评论内容
     */
    evaluateContent: string
    /**
     * 评论图片
     */
    evaluatePic: string[]
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 评论id
     */
    id: string
    /**
     * 是否官方：0-否 1-是
     */
    officialFlag?: number
    /**
     * 回复内容
     */
    replyContent: string
    /**
     * 点赞数
     */
    thumbsUpCount: number
    /**
     * 该用户是否已点赞 0否1是
     */
    thumbsUpFlag: number
    /**
     * 总点赞数
     */
    totalThumbsUpCount: number
    /**
     * 评论人头像
     */
    userHeadshot: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 评论人昵称
     */
    userNickName: string
    /**
     * 用户电话
     */
    userTel?: number
    /**
     * 虚拟点赞数
     */
    virtualThumbsUpCount: number
  }[]
  /**
   * 好评率 如:'99%'
   */
  praiseRate?: string
  /**
   * 评价总数
   */
  totalNum?: number
}

/**
 * 接口 [客户端获取商品最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/31669) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLatestEvaluateList`
 */
type ApiEvaluationEvaluateGetLatestEvaluateListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/getLatestEvaluateList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取商品最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/31669) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLatestEvaluateList`
 */
const apiEvaluationEvaluateGetLatestEvaluateListRequestConfig: ApiEvaluationEvaluateGetLatestEvaluateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/getLatestEvaluateList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateGetLatestEvaluateList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '客户端获取商品最新（或精选）评价列表（好评率）',
      author: '史博文',
    },
  }

/**
 * 接口 [客户端获取商品最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/31669) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getLatestEvaluateList`
 */
export const apiEvaluationEvaluateGetLatestEvaluateList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateGetLatestEvaluateListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateGetLatestEvaluateListResponse>(
    prepare(
      apiEvaluationEvaluateGetLatestEvaluateListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiEvaluationEvaluateGetLatestEvaluateList.requestConfig =
  apiEvaluationEvaluateGetLatestEvaluateListRequestConfig

/**
 * 接口 [客户端获取商品全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/31673) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/list`
 */
export interface ApiEvaluationEvaluateListRequest {
  /**
   * 商品id
   */
  commodityServiceId: string
  /**
   * 评论ID
   */
  evaluateId?: string
  /**
   * 是否只查询带图评价 0否1是
   */
  havingPicFlag?: number
  /**
   * 标签内容
   */
  labelContent?: string
  /**
   * 标签id
   */
  labelId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [客户端获取商品全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/31673) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/list`
 */
export interface ApiEvaluationEvaluateListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 评论列表
     */
    childList?: unknown[]
    /**
     * 商品/服务规格
     */
    commodityServiceSpecs: string
    /**
     * 评论时间
     */
    createTime: string
    /**
     * 追评文字
     */
    evaluateAddContent: string
    /**
     * 追评图片
     */
    evaluateAddPic: string[]
    /**
     * 评论内容
     */
    evaluateContent: string
    /**
     * 评论图片
     */
    evaluatePic: string[]
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 评论id
     */
    id: string
    /**
     * 是否官方：0-否 1-是
     */
    officialFlag?: number
    /**
     * 回复内容
     */
    replyContent: string
    /**
     * 点赞数
     */
    thumbsUpCount: number
    /**
     * 该用户是否已点赞 0否1是
     */
    thumbsUpFlag: number
    /**
     * 总点赞数
     */
    totalThumbsUpCount: number
    /**
     * 评论人头像
     */
    userHeadshot: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 评论人昵称
     */
    userNickName: string
    /**
     * 用户电话
     */
    userTel?: number
    /**
     * 虚拟点赞数
     */
    virtualThumbsUpCount: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端获取商品全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/31673) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/list`
 */
type ApiEvaluationEvaluateListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取商品全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/31673) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/list`
 */
const apiEvaluationEvaluateListRequestConfig: ApiEvaluationEvaluateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端获取商品全部评价列表', author: '史博文' },
  }

/**
 * 接口 [客户端获取商品全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/31673) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/list`
 */
export const apiEvaluationEvaluateList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateListResponse>(
    prepare(apiEvaluationEvaluateListRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateList.requestConfig = apiEvaluationEvaluateListRequestConfig

/**
 * 接口 [客户端获取店铺最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/96892) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getStoreEvaluateList`
 */
export interface ApiEvaluationEvaluateGetStoreEvaluateListRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺
   */
  storeId: string
}

/**
 * 接口 [客户端获取店铺最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/96892) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getStoreEvaluateList`
 */
export interface ApiEvaluationEvaluateGetStoreEvaluateListResponse {
  /**
   * 评价星级
   */
  evaluateStat?: number
  /**
   * 评论内容
   */
  list?: {
    /**
     * 评论列表
     */
    childList?: unknown[]
    /**
     * 商品/服务规格
     */
    commodityServiceSpecs: string
    /**
     * 评论时间
     */
    createTime: string
    /**
     * 追评文字
     */
    evaluateAddContent: string
    /**
     * 追评图片
     */
    evaluateAddPic: string[]
    /**
     * 评论内容
     */
    evaluateContent: string
    /**
     * 评论图片
     */
    evaluatePic: string[]
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 评论id
     */
    id: string
    /**
     * 是否官方：0-否 1-是
     */
    officialFlag?: number
    /**
     * 回复内容
     */
    replyContent: string
    /**
     * 点赞数
     */
    thumbsUpCount: number
    /**
     * 该用户是否已点赞 0否1是
     */
    thumbsUpFlag: number
    /**
     * 总点赞数
     */
    totalThumbsUpCount: number
    /**
     * 评论人头像
     */
    userHeadshot: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 评论人昵称
     */
    userNickName: string
    /**
     * 用户电话
     */
    userTel?: number
    /**
     * 虚拟点赞数
     */
    virtualThumbsUpCount: number
  }[]
  /**
   * 好评率 如:'99%'
   */
  praiseRate?: string
  /**
   * 评价总数
   */
  totalNum?: number
}

/**
 * 接口 [客户端获取店铺最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/96892) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getStoreEvaluateList`
 */
type ApiEvaluationEvaluateGetStoreEvaluateListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/getStoreEvaluateList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取店铺最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/96892) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getStoreEvaluateList`
 */
const apiEvaluationEvaluateGetStoreEvaluateListRequestConfig: ApiEvaluationEvaluateGetStoreEvaluateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/getStoreEvaluateList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateGetStoreEvaluateList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '客户端获取店铺最新（或精选）评价列表（好评率）',
      author: '张彬',
    },
  }

/**
 * 接口 [客户端获取店铺最新（或精选）评价列表（好评率）↗](https://yapi.gogpay.cn/project/921/interface/api/96892) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getStoreEvaluateList`
 */
export const apiEvaluationEvaluateGetStoreEvaluateList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateGetStoreEvaluateListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateGetStoreEvaluateListResponse>(
    prepare(
      apiEvaluationEvaluateGetStoreEvaluateListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiEvaluationEvaluateGetStoreEvaluateList.requestConfig =
  apiEvaluationEvaluateGetStoreEvaluateListRequestConfig

/**
 * 接口 [客户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/96898) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/storeList`
 */
export interface ApiEvaluationEvaluateStoreListRequest {
  /**
   * 是否只显示有追评 0否1是
   */
  havingAddEvaluate?: number
  /**
   * 是否只查询带图评价 0否1是
   */
  havingPicFlag?: number
  /**
   * 标签内容
   */
  labelContent?: string
  /**
   * 标签id
   */
  labelId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺
   */
  storeId: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [客户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/96898) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/storeList`
 */
export interface ApiEvaluationEvaluateStoreListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 评论列表
     */
    childList?: unknown[]
    /**
     * 商品/服务规格
     */
    commodityServiceSpecs: string
    /**
     * 评论时间
     */
    createTime: string
    /**
     * 追评文字
     */
    evaluateAddContent: string
    /**
     * 追评图片
     */
    evaluateAddPic: string[]
    /**
     * 评论内容
     */
    evaluateContent: string
    /**
     * 评论图片
     */
    evaluatePic: string[]
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 评论id
     */
    id: string
    /**
     * 是否官方：0-否 1-是
     */
    officialFlag?: number
    /**
     * 回复内容
     */
    replyContent: string
    /**
     * 点赞数
     */
    thumbsUpCount: number
    /**
     * 该用户是否已点赞 0否1是
     */
    thumbsUpFlag: number
    /**
     * 总点赞数
     */
    totalThumbsUpCount: number
    /**
     * 评论人头像
     */
    userHeadshot: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 评论人昵称
     */
    userNickName: string
    /**
     * 用户电话
     */
    userTel?: number
    /**
     * 虚拟点赞数
     */
    virtualThumbsUpCount: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/96898) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/storeList`
 */
type ApiEvaluationEvaluateStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/storeList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/96898) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/storeList`
 */
const apiEvaluationEvaluateStoreListRequestConfig: ApiEvaluationEvaluateStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/storeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端获取店铺全部评价列表', author: '张彬' },
  }

/**
 * 接口 [客户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/96898) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/storeList`
 */
export const apiEvaluationEvaluateStoreList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateStoreListResponse>(
    prepare(apiEvaluationEvaluateStoreListRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateStoreList.requestConfig =
  apiEvaluationEvaluateStoreListRequestConfig

/**
 * 接口 [客户端批量获取店铺评分↗](https://yapi.gogpay.cn/project/921/interface/api/97054) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getBatchStareRate`
 */
export type ApiEvaluationEvaluateGetBatchStareRateRequest = string[]

/**
 * 接口 [客户端批量获取店铺评分↗](https://yapi.gogpay.cn/project/921/interface/api/97054) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getBatchStareRate`
 */
export type ApiEvaluationEvaluateGetBatchStareRateResponse = {
  /**
   * 评价星级
   */
  evaluateStat?: number
  /**
   * 好评率 如:'99%'
   */
  praiseRate?: string
  /**
   * 门店ID
   */
  storeId?: string
}[]

/**
 * 接口 [客户端批量获取店铺评分↗](https://yapi.gogpay.cn/project/921/interface/api/97054) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getBatchStareRate`
 */
type ApiEvaluationEvaluateGetBatchStareRateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/getBatchStareRate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端批量获取店铺评分↗](https://yapi.gogpay.cn/project/921/interface/api/97054) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getBatchStareRate`
 */
const apiEvaluationEvaluateGetBatchStareRateRequestConfig: ApiEvaluationEvaluateGetBatchStareRateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/getBatchStareRate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateGetBatchStareRate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端批量获取店铺评分', author: '张彬' },
  }

/**
 * 接口 [客户端批量获取店铺评分↗](https://yapi.gogpay.cn/project/921/interface/api/97054) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getBatchStareRate`
 */
export const apiEvaluationEvaluateGetBatchStareRate = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateGetBatchStareRateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateGetBatchStareRateResponse>(
    prepare(apiEvaluationEvaluateGetBatchStareRateRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateGetBatchStareRate.requestConfig =
  apiEvaluationEvaluateGetBatchStareRateRequestConfig

/**
 * 接口 [评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/101470) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/detail`
 */
export interface ApiEvaluationEvaluateDetailRequest {
  /**
   * 评价id
   */
  id: string
}

/**
 * 接口 [评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/101470) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/detail`
 */
export interface ApiEvaluationEvaluateDetailResponse {
  /**
   * 商品/服务规格
   */
  commodityServiceSpecs?: string
  /**
   * 评论时间
   */
  createTime: string
  /**
   * 追评文字
   */
  evaluateAddContent?: string
  /**
   * 评论内容
   */
  evaluateContent: string
  /**
   * 评论图片
   */
  evaluatePic: string[]
  /**
   * 评价星级
   */
  evaluateStar?: number
  /**
   * 评论id
   */
  id: string
  /**
   * 回复渠道 0 未回复 1 多彩宝 2 商家
   */
  replyChannel?: 0 | 1 | 2
  /**
   * 回复内容
   */
  replyContent?: string
  /**
   * 是否回复 0 否 1 是
   */
  replyFlag?: number
  /**
   * 回复时间
   */
  replyTime?: string
  /**
   * 回复人
   */
  responder?: string
  /**
   * 店铺ID
   */
  storeId?: string
  /**
   * 点赞数
   */
  thumbsUpCount: number
  /**
   * 该用户是否已点赞 0否1是
   */
  thumbsUpFlag: number
  /**
   * 评论人头像
   */
  userHeadshot: string
  /**
   * 评论人昵称
   */
  userNickName: string
}

/**
 * 接口 [评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/101470) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/detail`
 */
type ApiEvaluationEvaluateDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/101470) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/detail`
 */
const apiEvaluationEvaluateDetailRequestConfig: ApiEvaluationEvaluateDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '评价详情', author: '张彬' },
  }

/**
 * 接口 [评价详情↗](https://yapi.gogpay.cn/project/921/interface/api/101470) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/detail`
 */
export const apiEvaluationEvaluateDetail = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateDetailResponse>(
    prepare(apiEvaluationEvaluateDetailRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateDetail.requestConfig =
  apiEvaluationEvaluateDetailRequestConfig

/**
 * 接口 [提交攻略评价↗](https://yapi.gogpay.cn/project/921/interface/api/184308) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitStrategyEvaluate`
 */
export interface ApiEvaluationEvaluateSubmitStrategyEvaluateRequest {
  /**
   * 攻略ID
   */
  commodityServiceId: string
  /**
   * 商品名称
   */
  commodityServiceName: string
  /**
   * 评价文字
   */
  evaluateContent: string
  /**
   * 父级评论ID
   */
  parentEvaluateId: string
}

/**
 * 接口 [提交攻略评价↗](https://yapi.gogpay.cn/project/921/interface/api/184308) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitStrategyEvaluate`
 */
export interface ApiEvaluationEvaluateSubmitStrategyEvaluateResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [提交攻略评价↗](https://yapi.gogpay.cn/project/921/interface/api/184308) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitStrategyEvaluate`
 */
type ApiEvaluationEvaluateSubmitStrategyEvaluateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/submitStrategyEvaluate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提交攻略评价↗](https://yapi.gogpay.cn/project/921/interface/api/184308) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitStrategyEvaluate`
 */
const apiEvaluationEvaluateSubmitStrategyEvaluateRequestConfig: ApiEvaluationEvaluateSubmitStrategyEvaluateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/submitStrategyEvaluate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateSubmitStrategyEvaluate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提交攻略评价', author: '张彬' },
  }

/**
 * 接口 [提交攻略评价↗](https://yapi.gogpay.cn/project/921/interface/api/184308) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitStrategyEvaluate`
 */
export const apiEvaluationEvaluateSubmitStrategyEvaluate = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateSubmitStrategyEvaluateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateSubmitStrategyEvaluateResponse>(
    prepare(
      apiEvaluationEvaluateSubmitStrategyEvaluateRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiEvaluationEvaluateSubmitStrategyEvaluate.requestConfig =
  apiEvaluationEvaluateSubmitStrategyEvaluateRequestConfig

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/315066) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitOld`
 */
export interface ApiEvaluationEvaluateSubmitOldRequest {
  /**
   * 批量评价集合
   */
  list?: {
    /**
     * 商品id
     */
    commodityServiceId: string
    /**
     * 商品名称
     */
    commodityServiceName: string
    /**
     * 商品规格
     */
    commodityServiceSpecs: string
    /**
     * 评价文字
     */
    evaluateContent?: string
    /**
     * 评价图片
     */
    evaluatePic?: string[]
    /**
     * 评价星级
     */
    evaluateStar: number
    /**
     * 星级评价项
     */
    evaluateStarList?: {
      /**
       * 评星项名称
       */
      name: string
      /**
       * 评星项星级
       */
      value: number
    }[]
    /**
     * 标签,逗号','隔开
     */
    label?: string
    /**
     * 商户名称
     */
    merchantName: string
    /**
     * 订单金额
     */
    orderAmount: number
    /**
     * 多彩宝订单中心支付流水号
     */
    paySerialNo: string
    /**
     * 订单编号
     */
    refOrderNo: string
  }[]
}

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/315066) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitOld`
 */
export interface ApiEvaluationEvaluateSubmitOldResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/315066) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitOld`
 */
type ApiEvaluationEvaluateSubmitOldRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/submitOld',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/315066) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitOld`
 */
const apiEvaluationEvaluateSubmitOldRequestConfig: ApiEvaluationEvaluateSubmitOldRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/submitOld',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateSubmitOld',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提交商品评价', author: '333号开发' },
  }

/**
 * 接口 [提交商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/315066) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/submitOld`
 */
export const apiEvaluationEvaluateSubmitOld = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateSubmitOldRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateSubmitOldResponse>(
    prepare(apiEvaluationEvaluateSubmitOldRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateSubmitOld.requestConfig =
  apiEvaluationEvaluateSubmitOldRequestConfig

/**
 * 接口 [客户端获取85兑换券首页商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/405488) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/findVirtualExchangeEvaluateList`
 */
export interface ApiEvaluationEvaluateFindVirtualExchangeEvaluateListRequest {
  /**
   * 数据Id(商品id、skuId、专题id、分类Id)
   */
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [客户端获取85兑换券首页商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/405488) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/findVirtualExchangeEvaluateList`
 */
export type ApiEvaluationEvaluateFindVirtualExchangeEvaluateListResponse = {
  /**
   * 评论列表
   */
  childList?: unknown[]
  /**
   * 商品/服务规格
   */
  commodityServiceSpecs: string
  /**
   * 评论时间
   */
  createTime: string
  /**
   * 追评文字
   */
  evaluateAddContent: string
  /**
   * 追评图片
   */
  evaluateAddPic: string[]
  /**
   * 评论内容
   */
  evaluateContent: string
  /**
   * 评论图片
   */
  evaluatePic: string[]
  /**
   * 评价星级
   */
  evaluateStar?: number
  /**
   * 评论id
   */
  id: string
  /**
   * 是否官方：0-否 1-是
   */
  officialFlag?: number
  /**
   * 回复内容
   */
  replyContent: string
  /**
   * 点赞数
   */
  thumbsUpCount: number
  /**
   * 该用户是否已点赞 0否1是
   */
  thumbsUpFlag: number
  /**
   * 总点赞数
   */
  totalThumbsUpCount: number
  /**
   * 评论人头像
   */
  userHeadshot: string
  /**
   * 用户ID
   */
  userId?: string
  /**
   * 评论人昵称
   */
  userNickName: string
  /**
   * 用户电话
   */
  userTel?: number
  /**
   * 虚拟点赞数
   */
  virtualThumbsUpCount: number
}[]

/**
 * 接口 [客户端获取85兑换券首页商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/405488) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/findVirtualExchangeEvaluateList`
 */
type ApiEvaluationEvaluateFindVirtualExchangeEvaluateListRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/921',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/evaluation/api/evaluate/findVirtualExchangeEvaluateList',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [客户端获取85兑换券首页商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/405488) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/findVirtualExchangeEvaluateList`
 */
const apiEvaluationEvaluateFindVirtualExchangeEvaluateListRequestConfig: ApiEvaluationEvaluateFindVirtualExchangeEvaluateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/findVirtualExchangeEvaluateList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateFindVirtualExchangeEvaluateList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端获取85兑换券首页商品评价', author: '511号开发' },
  }

/**
 * 接口 [客户端获取85兑换券首页商品评价↗](https://yapi.gogpay.cn/project/921/interface/api/405488) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/findVirtualExchangeEvaluateList`
 */
export const apiEvaluationEvaluateFindVirtualExchangeEvaluateList =
  /*#__PURE__*/ (
    requestData: ApiEvaluationEvaluateFindVirtualExchangeEvaluateListRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiEvaluationEvaluateFindVirtualExchangeEvaluateListResponse>(
      prepare(
        apiEvaluationEvaluateFindVirtualExchangeEvaluateListRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiEvaluationEvaluateFindVirtualExchangeEvaluateList.requestConfig =
  apiEvaluationEvaluateFindVirtualExchangeEvaluateListRequestConfig

/**
 * 接口 [客户端获取用户全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/444213) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getUserEvaluateList`
 */
export interface ApiEvaluationEvaluateGetUserEvaluateListRequest {
  /**
   * 是否只显示有追评 0否1是
   */
  havingAddEvaluate?: number
  /**
   * 是否只查询带图评价 0否1是
   */
  havingPicFlag?: number
  /**
   * 标签内容
   */
  labelContent?: string
  /**
   * 标签id
   */
  labelId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺
   */
  storeId: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [客户端获取用户全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/444213) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getUserEvaluateList`
 */
export interface ApiEvaluationEvaluateGetUserEvaluateListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 评论列表
     */
    childList?: unknown[]
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName: string
    /**
     * 商品图片
     */
    commodityPic: string
    /**
     * 商品/服务价格
     */
    commodityPrice?: number
    /**
     * 商品/服务数量
     */
    commodityQuantity?: number
    /**
     * 商品/服务规格
     */
    commodityServiceSpecs: string
    /**
     * 商品/服务单价
     */
    commodityUnitPrice?: number
    /**
     * 评论时间
     */
    createTime: string
    /**
     * 追评文字
     */
    evaluateAddContent: string
    /**
     * 追评图片
     */
    evaluateAddPic: string[]
    /**
     * 评论内容
     */
    evaluateContent: string
    /**
     * 评论图片
     */
    evaluatePic: string[]
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 评论id
     */
    id: string
    /**
     * 是否官方：0-否 1-是
     */
    officialFlag?: number
    /**
     * 回复内容
     */
    replyContent: string
    /**
     * 门店名称
     */
    storeName: string
    /**
     * 门店图片
     */
    storePic: string
    /**
     * 点赞数
     */
    thumbsUpCount: number
    /**
     * 该用户是否已点赞 0否1是
     */
    thumbsUpFlag: number
    /**
     * 总点赞数
     */
    totalThumbsUpCount: number
    /**
     * 评论人头像
     */
    userHeadshot: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 评论人昵称
     */
    userNickName: string
    /**
     * 用户电话
     */
    userTel?: number
    /**
     * 虚拟点赞数
     */
    virtualThumbsUpCount: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端获取用户全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/444213) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getUserEvaluateList`
 */
type ApiEvaluationEvaluateGetUserEvaluateListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/getUserEvaluateList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端获取用户全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/444213) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getUserEvaluateList`
 */
const apiEvaluationEvaluateGetUserEvaluateListRequestConfig: ApiEvaluationEvaluateGetUserEvaluateListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/getUserEvaluateList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateGetUserEvaluateList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端获取用户全部评价列表', author: '511号开发' },
  }

/**
 * 接口 [客户端获取用户全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/444213) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/getUserEvaluateList`
 */
export const apiEvaluationEvaluateGetUserEvaluateList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateGetUserEvaluateListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateGetUserEvaluateListResponse>(
    prepare(apiEvaluationEvaluateGetUserEvaluateListRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateGetUserEvaluateList.requestConfig =
  apiEvaluationEvaluateGetUserEvaluateListRequestConfig

/**
 * 接口 [商户端回复评价↗](https://yapi.gogpay.cn/project/921/interface/api/458913) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/reply`
 */
export interface ApiEvaluationEvaluateMerchantReplyRequest {
  /**
   * 回复的评论ID
   */
  id: string
  /**
   * 回复内容
   */
  replyContent: string
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [商户端回复评价↗](https://yapi.gogpay.cn/project/921/interface/api/458913) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/reply`
 */
export interface ApiEvaluationEvaluateMerchantReplyResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商户端回复评价↗](https://yapi.gogpay.cn/project/921/interface/api/458913) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/reply`
 */
type ApiEvaluationEvaluateMerchantReplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/merchant/reply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户端回复评价↗](https://yapi.gogpay.cn/project/921/interface/api/458913) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/reply`
 */
const apiEvaluationEvaluateMerchantReplyRequestConfig: ApiEvaluationEvaluateMerchantReplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/merchant/reply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateMerchantReply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户端回复评价', author: '503号开发' },
  }

/**
 * 接口 [商户端回复评价↗](https://yapi.gogpay.cn/project/921/interface/api/458913) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/reply`
 */
export const apiEvaluationEvaluateMerchantReply = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateMerchantReplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateMerchantReplyResponse>(
    prepare(apiEvaluationEvaluateMerchantReplyRequestConfig, requestData),
    ...args,
  )
}

apiEvaluationEvaluateMerchantReply.requestConfig =
  apiEvaluationEvaluateMerchantReplyRequestConfig

/**
 * 接口 [商户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/458918) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/store/pageList`
 */
export interface ApiEvaluationEvaluateMerchantStorePageListRequest {
  /**
   * 评价星级
   */
  evaluateStar?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 是否回复 0 否 1 是
   */
  replyFlag?: number
  /**
   * 店铺
   */
  storeId: string
  /**
   * 1 今日 2 本周 3 本月
   */
  timeFlag?: number
}

/**
 * 接口 [商户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/458918) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/store/pageList`
 */
export interface ApiEvaluationEvaluateMerchantStorePageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName: string
    /**
     * 评论时间
     */
    createTime: string
    /**
     * 评论内容
     */
    evaluateContent: string
    /**
     * 评论图片
     */
    evaluatePic: string[]
    /**
     * 评价星级
     */
    evaluateStar?: number
    /**
     * 评论id
     */
    id: string
    /**
     * 订单号
     */
    refOrderNo?: string
    /**
     * 回复渠道 1多彩宝 2商家
     */
    replyChannel?: 0 | 1 | 2
    /**
     * 是否回复 0 否 1 是
     */
    replyFlag?: number
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 门店名称
     */
    storeName: string
    /**
     * 评论人头像
     */
    userHeadshot: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 评论人昵称
     */
    userNickName: string
    /**
     * 用户电话
     */
    userTel?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [商户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/458918) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/store/pageList`
 */
type ApiEvaluationEvaluateMerchantStorePageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluate/merchant/store/pageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/458918) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/store/pageList`
 */
const apiEvaluationEvaluateMerchantStorePageListRequestConfig: ApiEvaluationEvaluateMerchantStorePageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_5,
    devUrl: devUrl_0_10_0_5,
    prodUrl: prodUrl_0_10_0_5,
    path: '/evaluation/api/evaluate/merchant/store/pageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateMerchantStorePageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户端获取店铺全部评价列表', author: '503号开发' },
  }

/**
 * 接口 [商户端获取店铺全部评价列表↗](https://yapi.gogpay.cn/project/921/interface/api/458918) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端评价接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7065)
 * @请求头 `POST /evaluation/api/evaluate/merchant/store/pageList`
 */
export const apiEvaluationEvaluateMerchantStorePageList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateMerchantStorePageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateMerchantStorePageListResponse>(
    prepare(
      apiEvaluationEvaluateMerchantStorePageListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiEvaluationEvaluateMerchantStorePageList.requestConfig =
  apiEvaluationEvaluateMerchantStorePageListRequestConfig

const mockUrl_0_10_0_6 = 'https://yapi.gogpay.cn/mock/921' as any
const devUrl_0_10_0_6 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_10_0_6 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_10_0_6 = 'data' as any

/**
 * 接口 [获取商品评价标签↗](https://yapi.gogpay.cn/project/921/interface/api/29405) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端评价标签模板接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7188)
 * @请求头 `POST /evaluation/api/evaluateLabelTemplate/getLabelList`
 */
export interface ApiEvaluationEvaluateLabelTemplateGetLabelListRequest {
  /**
   * 商品类目id
   */
  commodityCategoryId: string
}

/**
 * 接口 [获取商品评价标签↗](https://yapi.gogpay.cn/project/921/interface/api/29405) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端评价标签模板接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7188)
 * @请求头 `POST /evaluation/api/evaluateLabelTemplate/getLabelList`
 */
export type ApiEvaluationEvaluateLabelTemplateGetLabelListResponse = {
  /**
   * 标签
   */
  labelContent: string[]
  /**
   * 等级
   */
  star: number
}[]

/**
 * 接口 [获取商品评价标签↗](https://yapi.gogpay.cn/project/921/interface/api/29405) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端评价标签模板接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7188)
 * @请求头 `POST /evaluation/api/evaluateLabelTemplate/getLabelList`
 */
type ApiEvaluationEvaluateLabelTemplateGetLabelListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/921',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/evaluation/api/evaluateLabelTemplate/getLabelList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品评价标签↗](https://yapi.gogpay.cn/project/921/interface/api/29405) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端评价标签模板接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7188)
 * @请求头 `POST /evaluation/api/evaluateLabelTemplate/getLabelList`
 */
const apiEvaluationEvaluateLabelTemplateGetLabelListRequestConfig: ApiEvaluationEvaluateLabelTemplateGetLabelListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_10_0_6,
    devUrl: devUrl_0_10_0_6,
    prodUrl: prodUrl_0_10_0_6,
    path: '/evaluation/api/evaluateLabelTemplate/getLabelList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_10_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiEvaluationEvaluateLabelTemplateGetLabelList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品评价标签', author: '史博文' },
  }

/**
 * 接口 [获取商品评价标签↗](https://yapi.gogpay.cn/project/921/interface/api/29405) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端评价标签模板接口↗](https://yapi.gogpay.cn/project/921/interface/api/cat_7188)
 * @请求头 `POST /evaluation/api/evaluateLabelTemplate/getLabelList`
 */
export const apiEvaluationEvaluateLabelTemplateGetLabelList = /*#__PURE__*/ (
  requestData: ApiEvaluationEvaluateLabelTemplateGetLabelListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiEvaluationEvaluateLabelTemplateGetLabelListResponse>(
    prepare(
      apiEvaluationEvaluateLabelTemplateGetLabelListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiEvaluationEvaluateLabelTemplateGetLabelList.requestConfig =
  apiEvaluationEvaluateLabelTemplateGetLabelListRequestConfig

const mockUrl_0_7_0_0 = 'https://yapi.gogpay.cn/mock/999' as any
const devUrl_0_7_0_0 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_7_0_0 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_7_0_0 = 'data' as any

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/104356) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/calcPostFee`
 */
export interface ApiTradeGeneralImsApiTradeCalcPostFeeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/104356) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/calcPostFee`
 */
export interface ApiTradeGeneralImsApiTradeCalcPostFeeResponse {
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: unknown[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
  }[]
}

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/104356) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/calcPostFee`
 */
type ApiTradeGeneralImsApiTradeCalcPostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/imsApi/trade/calcPostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/104356) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/calcPostFee`
 */
const apiTradeGeneralImsApiTradeCalcPostFeeRequestConfig: ApiTradeGeneralImsApiTradeCalcPostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_0,
    devUrl: devUrl_0_7_0_0,
    prodUrl: prodUrl_0_7_0_0,
    path: '/tradeGeneral/imsApi/trade/calcPostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralImsApiTradeCalcPostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '计算订单的邮费', author: '成龙' },
  }

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/104356) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/calcPostFee`
 */
export const apiTradeGeneralImsApiTradeCalcPostFee = /*#__PURE__*/ (
  requestData: ApiTradeGeneralImsApiTradeCalcPostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralImsApiTradeCalcPostFeeResponse>(
    prepare(apiTradeGeneralImsApiTradeCalcPostFeeRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralImsApiTradeCalcPostFee.requestConfig =
  apiTradeGeneralImsApiTradeCalcPostFeeRequestConfig

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/104362) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/preOrder`
 */
export interface ApiTradeGeneralImsApiTradePreOrderRequest {
  address?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 验证码凭证
   */
  captchaToken?: string
  /**
   * 设备Id
   */
  deviceId?: string
  /**
   * 预下单类型 1购物车下单 2直接下单 3秒杀下单
   */
  preOrderType: '1' | '2' | '3'
  /**
   * 自提地址Id
   */
  selfPickupAddressId?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 购买信息
   */
  skuInfo: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 购买数量
     */
    count: number
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 使用多彩豆购买商品数量
     */
    integralCount?: number
    /**
     * 销售渠道Id
     */
    sellChannelId?: string
    /**
     * SKU ID
     */
    skuId: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 购买日期 格式 yyyy-MM-dd
     */
    stockDate?: string
    /**
     * 购买结束日期 格式 yyyy-MM-dd
     */
    stockEndDate?: string
  }[]
  /**
   * 酒店订单酒店Id
   */
  tvHotelId?: string
  /**
   * 酒店订单酒店房间号
   */
  tvHotelRoomNo?: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/104362) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/preOrder`
 */
export interface ApiTradeGeneralImsApiTradePreOrderResponse {
  businessRuleInfo?: {
    /**
     * 是否勾选
     */
    selected?: boolean
    /**
     * 是否显示购物车
     */
    showCart?: boolean
    /**
     * 提示内容
     */
    tipContent?: string
    /**
     * 提示结尾
     */
    tipEnd?: string
    /**
     * 提示标题
     */
    tipHead?: string
    /**
     * 规则标题
     */
    title?: string
    /**
     * 规则类型：1-跨境电商平台运营规则
     */
    type?: number
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 业务类型
   */
  businessType?: string
  /**
   * 是否计算过邮费
   */
  calcPostFeeFlag?: boolean
  /**
   * 验证码凭证
   */
  captchaToken?: string
  /**
   * 积分抵扣项目列表
   */
  channelActivityItems?: {
    /**
     * 余额
     */
    balance?: string
    /**
     * 余额单位
     */
    balanceUnit?: string
    /**
     * 是否可抵扣
     */
    deduction?: boolean
    /**
     * 活动Id
     */
    id?: string
    /**
     * 是否需要密码
     */
    needPassword?: boolean
    /**
     * 不支持抵扣原因
     */
    noDeductionReason?: string
    passwordKeyboard?: {
      /**
       * 密码值列表
       */
      keys?: {
        /**
         * 密码数字
         */
        key?: number
        /**
         * 密码数字混淆值
         */
        keySlat?: number
        /**
         * 密码值
         */
        value?: string
      }[]
    }
    /**
     * 渠道名称
     */
    title?: string
  }[]
  closeOrderValue?: number
  /**
   * 折扣优惠消费ticket
   */
  discountActivityTicket?: string
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 满减活动消费ticket
   */
  fullReductionActivityTicket?: string
  /**
   * 是否可以选择核销店铺
   */
  hasChooseWriteOffStore?: boolean
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 是否需要收货地址
   */
  needAddress?: boolean
  /**
   * 是否需要经纬度
   */
  needLogLet?: boolean
  /**
   * 是否需要使用日期
   */
  needUseDate?: boolean
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券 2-兑换券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品来源：0多彩宝 1跨境电商
       */
      commodityResource?: number
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      fullReductioActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 满减优惠金额
       */
      fullReductionActivityAmount?: number
      integralActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 供应商绑定商品ID
       */
      provideCommodityId?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 供应商 0=多彩宝 1=京东
       */
      provideSource?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 是否实名制购买：0-否 1-是
       */
      realNamePurchase?: '0' | '1'
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
        | '13'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 兑换商品类父级商品订单编号
     */
    parentCommodityOrderNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 实名制类型 0-自动回填 1-手动填写
     */
    realNameInputType: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  orderType?: number
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
   */
  preOrderContentType?: '1' | '2' | '4' | '5' | '3'
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
  realNameStatusInfo?: {
    /**
     * 跳转链接名称
     */
    linkName?: string
    /**
     * 是否已经实名认证：0-否1-是
     */
    realNameAuth?: boolean
    /**
     * 注意文案
     */
    tip?: string
    /**
     * 标题文案
     */
    title?: string
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 自提地址Id
   */
  selfPickupAddressId?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 是否显示平台运营相关规则
   */
  showBusinessRuleInfo?: boolean
  /**
   * 是否需要显示实名认证
   */
  showNeedRealNameAuth?: boolean
  /**
   * 是否支持积分支付
   */
  supportPayType?: boolean
  /**
   * 是否为翼支付支付：true-是，false否
   */
  supportYiPay?: boolean
  /**
   * 提示信息
   */
  tips?: string
  /**
   * 酒店订单酒店Id
   */
  tvHotelId?: string
  /**
   * 酒店订单酒店房间号
   */
  tvHotelRoomNo?: string
  /**
   * 订单包含的子机构编码
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/104362) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/preOrder`
 */
type ApiTradeGeneralImsApiTradePreOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/imsApi/trade/preOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/104362) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/preOrder`
 */
const apiTradeGeneralImsApiTradePreOrderRequestConfig: ApiTradeGeneralImsApiTradePreOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_0,
    devUrl: devUrl_0_7_0_0,
    prodUrl: prodUrl_0_7_0_0,
    path: '/tradeGeneral/imsApi/trade/preOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralImsApiTradePreOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预下单', author: '成龙' },
  }

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/104362) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/preOrder`
 */
export const apiTradeGeneralImsApiTradePreOrder = /*#__PURE__*/ (
  requestData: ApiTradeGeneralImsApiTradePreOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralImsApiTradePreOrderResponse>(
    prepare(apiTradeGeneralImsApiTradePreOrderRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralImsApiTradePreOrder.requestConfig =
  apiTradeGeneralImsApiTradePreOrderRequestConfig

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/104368) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/tradeOrder`
 */
export interface ApiTradeGeneralImsApiTradeTradeOrderRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经纬度类型
   */
  locationType?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 使用积分购买数量
     */
    integralCount?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
    /**
     * 核销门店Id
     */
    writeOffStoreId?: string
  }[]
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/104368) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/tradeOrder`
 */
export interface ApiTradeGeneralImsApiTradeTradeOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/104368) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/tradeOrder`
 */
type ApiTradeGeneralImsApiTradeTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/imsApi/trade/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/104368) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/tradeOrder`
 */
const apiTradeGeneralImsApiTradeTradeOrderRequestConfig: ApiTradeGeneralImsApiTradeTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_0,
    devUrl: devUrl_0_7_0_0,
    prodUrl: prodUrl_0_7_0_0,
    path: '/tradeGeneral/imsApi/trade/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralImsApiTradeTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交易下单', author: '成龙' },
  }

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/104368) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单-开放↗](https://yapi.gogpay.cn/project/999/interface/api/cat_22164)
 * @请求头 `POST /tradeGeneral/imsApi/trade/tradeOrder`
 */
export const apiTradeGeneralImsApiTradeTradeOrder = /*#__PURE__*/ (
  requestData: ApiTradeGeneralImsApiTradeTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralImsApiTradeTradeOrderResponse>(
    prepare(apiTradeGeneralImsApiTradeTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralImsApiTradeTradeOrder.requestConfig =
  apiTradeGeneralImsApiTradeTradeOrderRequestConfig

const mockUrl_0_7_0_3 = 'https://yapi.gogpay.cn/mock/999' as any
const devUrl_0_7_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_7_0_3 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_7_0_3 = 'data' as any

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/28505) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/preOrder`
 */
export interface ApiTradeGeneralTradePreOrderRequest {
  address?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 验证码凭证
   */
  captchaToken?: string
  /**
   * 设备Id
   */
  deviceId?: string
  /**
   * 预下单类型 1购物车下单 2直接下单 3秒杀下单
   */
  preOrderType: '1' | '2' | '3'
  /**
   * 自提地址Id
   */
  selfPickupAddressId?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 购买信息
   */
  skuInfo: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 购买数量
     */
    count: number
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 使用多彩豆购买商品数量
     */
    integralCount?: number
    /**
     * 销售渠道Id
     */
    sellChannelId?: string
    /**
     * SKU ID
     */
    skuId: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 购买日期 格式 yyyy-MM-dd
     */
    stockDate?: string
    /**
     * 购买结束日期 格式 yyyy-MM-dd
     */
    stockEndDate?: string
  }[]
  /**
   * 酒店订单酒店Id
   */
  tvHotelId?: string
  /**
   * 酒店订单酒店房间号
   */
  tvHotelRoomNo?: string
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/28505) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/preOrder`
 */
export interface ApiTradeGeneralTradePreOrderResponse {
  businessRuleInfo?: {
    /**
     * 是否勾选
     */
    selected?: boolean
    /**
     * 是否显示购物车
     */
    showCart?: boolean
    /**
     * 提示内容
     */
    tipContent?: string
    /**
     * 提示结尾
     */
    tipEnd?: string
    /**
     * 提示标题
     */
    tipHead?: string
    /**
     * 规则标题
     */
    title?: string
    /**
     * 规则类型：1-跨境电商平台运营规则
     */
    type?: number
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 业务类型
   */
  businessType?: string
  /**
   * 是否计算过邮费
   */
  calcPostFeeFlag?: boolean
  /**
   * 验证码凭证
   */
  captchaToken?: string
  /**
   * 积分抵扣项目列表
   */
  channelActivityItems?: {
    /**
     * 余额
     */
    balance?: string
    /**
     * 余额单位
     */
    balanceUnit?: string
    /**
     * 是否可抵扣
     */
    deduction?: boolean
    /**
     * 活动Id
     */
    id?: string
    /**
     * 是否需要密码
     */
    needPassword?: boolean
    /**
     * 不支持抵扣原因
     */
    noDeductionReason?: string
    passwordKeyboard?: {
      /**
       * 密码值列表
       */
      keys?: {
        /**
         * 密码数字
         */
        key?: number
        /**
         * 密码数字混淆值
         */
        keySlat?: number
        /**
         * 密码值
         */
        value?: string
      }[]
    }
    /**
     * 渠道名称
     */
    title?: string
  }[]
  closeOrderValue?: number
  /**
   * 折扣优惠消费ticket
   */
  discountActivityTicket?: string
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 满减活动消费ticket
   */
  fullReductionActivityTicket?: string
  /**
   * 是否可以选择核销店铺
   */
  hasChooseWriteOffStore?: boolean
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 是否需要收货地址
   */
  needAddress?: boolean
  /**
   * 是否需要经纬度
   */
  needLogLet?: boolean
  /**
   * 是否需要使用日期
   */
  needUseDate?: boolean
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券 2-兑换券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品来源：0多彩宝 1跨境电商
       */
      commodityResource?: number
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      fullReductioActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 满减优惠金额
       */
      fullReductionActivityAmount?: number
      integralActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 供应商绑定商品ID
       */
      provideCommodityId?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 供应商 0=多彩宝 1=京东
       */
      provideSource?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 是否实名制购买：0-否 1-是
       */
      realNamePurchase?: '0' | '1'
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
        | '13'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 兑换商品类父级商品订单编号
     */
    parentCommodityOrderNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 实名制类型 0-自动回填 1-手动填写
     */
    realNameInputType: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  orderType?: number
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
   */
  preOrderContentType?: '1' | '2' | '4' | '5' | '3'
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
  realNameStatusInfo?: {
    /**
     * 跳转链接名称
     */
    linkName?: string
    /**
     * 是否已经实名认证：0-否1-是
     */
    realNameAuth?: boolean
    /**
     * 注意文案
     */
    tip?: string
    /**
     * 标题文案
     */
    title?: string
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 自提地址Id
   */
  selfPickupAddressId?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 是否显示平台运营相关规则
   */
  showBusinessRuleInfo?: boolean
  /**
   * 是否需要显示实名认证
   */
  showNeedRealNameAuth?: boolean
  /**
   * 是否支持积分支付
   */
  supportPayType?: boolean
  /**
   * 是否为翼支付支付：true-是，false否
   */
  supportYiPay?: boolean
  /**
   * 提示信息
   */
  tips?: string
  /**
   * 酒店订单酒店Id
   */
  tvHotelId?: string
  /**
   * 酒店订单酒店房间号
   */
  tvHotelRoomNo?: string
  /**
   * 订单包含的子机构编码
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/28505) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/preOrder`
 */
type ApiTradeGeneralTradePreOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/trade/preOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/28505) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/preOrder`
 */
const apiTradeGeneralTradePreOrderRequestConfig: ApiTradeGeneralTradePreOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_3,
    devUrl: devUrl_0_7_0_3,
    prodUrl: prodUrl_0_7_0_3,
    path: '/tradeGeneral/api/trade/preOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralTradePreOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预下单', author: '成龙' },
  }

/**
 * 接口 [预下单↗](https://yapi.gogpay.cn/project/999/interface/api/28505) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/preOrder`
 */
export const apiTradeGeneralTradePreOrder = /*#__PURE__*/ (
  requestData: ApiTradeGeneralTradePreOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralTradePreOrderResponse>(
    prepare(apiTradeGeneralTradePreOrderRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralTradePreOrder.requestConfig =
  apiTradeGeneralTradePreOrderRequestConfig

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/28509) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/tradeOrder`
 */
export interface ApiTradeGeneralTradeTradeOrderRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经纬度类型
   */
  locationType?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 使用积分购买数量
     */
    integralCount?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
    /**
     * 核销门店Id
     */
    writeOffStoreId?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/28509) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/tradeOrder`
 */
export interface ApiTradeGeneralTradeTradeOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/28509) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/tradeOrder`
 */
type ApiTradeGeneralTradeTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/trade/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/28509) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/tradeOrder`
 */
const apiTradeGeneralTradeTradeOrderRequestConfig: ApiTradeGeneralTradeTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_3,
    devUrl: devUrl_0_7_0_3,
    prodUrl: prodUrl_0_7_0_3,
    path: '/tradeGeneral/api/trade/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralTradeTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交易下单', author: '成龙' },
  }

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/28509) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/tradeOrder`
 */
export const apiTradeGeneralTradeTradeOrder = /*#__PURE__*/ (
  requestData: ApiTradeGeneralTradeTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralTradeTradeOrderResponse>(
    prepare(apiTradeGeneralTradeTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralTradeTradeOrder.requestConfig =
  apiTradeGeneralTradeTradeOrderRequestConfig

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/29261) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/calcPostFee`
 */
export interface ApiTradeGeneralTradeCalcPostFeeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/29261) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/calcPostFee`
 */
export interface ApiTradeGeneralTradeCalcPostFeeResponse {
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: unknown[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
  }[]
}

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/29261) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/calcPostFee`
 */
type ApiTradeGeneralTradeCalcPostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/trade/calcPostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/29261) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/calcPostFee`
 */
const apiTradeGeneralTradeCalcPostFeeRequestConfig: ApiTradeGeneralTradeCalcPostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_3,
    devUrl: devUrl_0_7_0_3,
    prodUrl: prodUrl_0_7_0_3,
    path: '/tradeGeneral/api/trade/calcPostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralTradeCalcPostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '计算订单的邮费', author: '成龙' },
  }

/**
 * 接口 [计算订单的邮费↗](https://yapi.gogpay.cn/project/999/interface/api/29261) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/calcPostFee`
 */
export const apiTradeGeneralTradeCalcPostFee = /*#__PURE__*/ (
  requestData: ApiTradeGeneralTradeCalcPostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralTradeCalcPostFeeResponse>(
    prepare(apiTradeGeneralTradeCalcPostFeeRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralTradeCalcPostFee.requestConfig =
  apiTradeGeneralTradeCalcPostFeeRequestConfig

/**
 * 接口 [获取渠道积分活动扣减信息↗](https://yapi.gogpay.cn/project/999/interface/api/259068) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/getChannelDiscountAmount`
 */
export interface ApiTradeGeneralTradeGetChannelDiscountAmountRequest {
  /**
   * 渠道活动Id
   */
  activityId: string
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [获取渠道积分活动扣减信息↗](https://yapi.gogpay.cn/project/999/interface/api/259068) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/getChannelDiscountAmount`
 */
export interface ApiTradeGeneralTradeGetChannelDiscountAmountResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 积分名称
   */
  name?: string
  /**
   * 支付金额
   */
  payAmount?: string
  /**
   * 优惠金额
   */
  subAmount?: string
  /**
   * 扣减积分
   */
  subPoint?: string
}

/**
 * 接口 [获取渠道积分活动扣减信息↗](https://yapi.gogpay.cn/project/999/interface/api/259068) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/getChannelDiscountAmount`
 */
type ApiTradeGeneralTradeGetChannelDiscountAmountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/trade/getChannelDiscountAmount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取渠道积分活动扣减信息↗](https://yapi.gogpay.cn/project/999/interface/api/259068) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/getChannelDiscountAmount`
 */
const apiTradeGeneralTradeGetChannelDiscountAmountRequestConfig: ApiTradeGeneralTradeGetChannelDiscountAmountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_3,
    devUrl: devUrl_0_7_0_3,
    prodUrl: prodUrl_0_7_0_3,
    path: '/tradeGeneral/api/trade/getChannelDiscountAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralTradeGetChannelDiscountAmount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取渠道积分活动扣减信息', author: '成龙' },
  }

/**
 * 接口 [获取渠道积分活动扣减信息↗](https://yapi.gogpay.cn/project/999/interface/api/259068) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/getChannelDiscountAmount`
 */
export const apiTradeGeneralTradeGetChannelDiscountAmount = /*#__PURE__*/ (
  requestData: ApiTradeGeneralTradeGetChannelDiscountAmountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralTradeGetChannelDiscountAmountResponse>(
    prepare(
      apiTradeGeneralTradeGetChannelDiscountAmountRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiTradeGeneralTradeGetChannelDiscountAmount.requestConfig =
  apiTradeGeneralTradeGetChannelDiscountAmountRequestConfig

/**
 * 接口 [发起验证码验证↗](https://yapi.gogpay.cn/project/999/interface/api/444183) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/verifyCaptcha`
 */
export interface ApiTradeGeneralTradeVerifyCaptchaRequest {
  /**
   * 验证码验证参数
   */
  captchaVerifyParam?: string
}

/**
 * 接口 [发起验证码验证↗](https://yapi.gogpay.cn/project/999/interface/api/444183) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/verifyCaptcha`
 */
export interface ApiTradeGeneralTradeVerifyCaptchaResponse {
  /**
   * 验证码凭证
   */
  captchaToken?: string
}

/**
 * 接口 [发起验证码验证↗](https://yapi.gogpay.cn/project/999/interface/api/444183) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/verifyCaptcha`
 */
type ApiTradeGeneralTradeVerifyCaptchaRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/trade/verifyCaptcha',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发起验证码验证↗](https://yapi.gogpay.cn/project/999/interface/api/444183) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/verifyCaptcha`
 */
const apiTradeGeneralTradeVerifyCaptchaRequestConfig: ApiTradeGeneralTradeVerifyCaptchaRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_3,
    devUrl: devUrl_0_7_0_3,
    prodUrl: prodUrl_0_7_0_3,
    path: '/tradeGeneral/api/trade/verifyCaptcha',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralTradeVerifyCaptcha',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发起验证码验证', author: '熊小川' },
  }

/**
 * 接口 [发起验证码验证↗](https://yapi.gogpay.cn/project/999/interface/api/444183) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/verifyCaptcha`
 */
export const apiTradeGeneralTradeVerifyCaptcha = /*#__PURE__*/ (
  requestData: ApiTradeGeneralTradeVerifyCaptchaRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralTradeVerifyCaptchaResponse>(
    prepare(apiTradeGeneralTradeVerifyCaptchaRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralTradeVerifyCaptcha.requestConfig =
  apiTradeGeneralTradeVerifyCaptchaRequestConfig

/**
 * 接口 [查询商品验证码校验↗](https://yapi.gogpay.cn/project/999/interface/api/444193) 的 **请求类型**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/queryVerifyCommodity`
 */
export interface ApiTradeGeneralTradeQueryVerifyCommodityRequest {
  /**
   * 商品ID
   */
  commodityId?: string
}

/**
 * 接口 [查询商品验证码校验↗](https://yapi.gogpay.cn/project/999/interface/api/444193) 的 **返回类型**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/queryVerifyCommodity`
 */
export interface ApiTradeGeneralTradeQueryVerifyCommodityResponse {
  /**
   * 是否开启商品验证码校验
   */
  enableVerifyCaptcha?: boolean
  /**
   * 校验身份标识
   */
  verifyIdentity?: string
  /**
   * 校验身份场景ID
   */
  verifySceneId?: string
}

/**
 * 接口 [查询商品验证码校验↗](https://yapi.gogpay.cn/project/999/interface/api/444193) 的 **请求配置的类型**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/queryVerifyCommodity`
 */
type ApiTradeGeneralTradeQueryVerifyCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/trade/queryVerifyCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品验证码校验↗](https://yapi.gogpay.cn/project/999/interface/api/444193) 的 **请求配置**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/queryVerifyCommodity`
 */
const apiTradeGeneralTradeQueryVerifyCommodityRequestConfig: ApiTradeGeneralTradeQueryVerifyCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_3,
    devUrl: devUrl_0_7_0_3,
    prodUrl: prodUrl_0_7_0_3,
    path: '/tradeGeneral/api/trade/queryVerifyCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralTradeQueryVerifyCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品验证码校验', author: '熊小川' },
  }

/**
 * 接口 [查询商品验证码校验↗](https://yapi.gogpay.cn/project/999/interface/api/444193) 的 **请求函数**
 *
 * @作者 熊小川
 * @分类 [交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_7114)
 * @请求头 `POST /tradeGeneral/api/trade/queryVerifyCommodity`
 */
export const apiTradeGeneralTradeQueryVerifyCommodity = /*#__PURE__*/ (
  requestData: ApiTradeGeneralTradeQueryVerifyCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralTradeQueryVerifyCommodityResponse>(
    prepare(apiTradeGeneralTradeQueryVerifyCommodityRequestConfig, requestData),
    ...args,
  )
}

apiTradeGeneralTradeQueryVerifyCommodity.requestConfig =
  apiTradeGeneralTradeQueryVerifyCommodityRequestConfig

const mockUrl_0_7_0_4 = 'https://yapi.gogpay.cn/mock/999' as any
const devUrl_0_7_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_7_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_7_0_4 = 'data' as any

/**
 * 接口 [获取商城预下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425668) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getPreOrderData`
 */
export interface ApiTradeGeneralActCouponTradeGetPreOrderDataRequest {
  /**
   * 预下单临时Id
   */
  preOrderId?: string
}

/**
 * 接口 [获取商城预下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425668) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getPreOrderData`
 */
export interface ApiTradeGeneralActCouponTradeGetPreOrderDataResponse {
  businessRuleInfo?: {
    /**
     * 是否勾选
     */
    selected?: boolean
    /**
     * 是否显示购物车
     */
    showCart?: boolean
    /**
     * 提示内容
     */
    tipContent?: string
    /**
     * 提示结尾
     */
    tipEnd?: string
    /**
     * 提示标题
     */
    tipHead?: string
    /**
     * 规则标题
     */
    title?: string
    /**
     * 规则类型：1-跨境电商平台运营规则
     */
    type?: number
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 业务类型
   */
  businessType?: string
  /**
   * 是否计算过邮费
   */
  calcPostFeeFlag?: boolean
  /**
   * 验证码凭证
   */
  captchaToken?: string
  /**
   * 积分抵扣项目列表
   */
  channelActivityItems?: {
    /**
     * 余额
     */
    balance?: string
    /**
     * 余额单位
     */
    balanceUnit?: string
    /**
     * 是否可抵扣
     */
    deduction?: boolean
    /**
     * 活动Id
     */
    id?: string
    /**
     * 是否需要密码
     */
    needPassword?: boolean
    /**
     * 不支持抵扣原因
     */
    noDeductionReason?: string
    passwordKeyboard?: {
      /**
       * 密码值列表
       */
      keys?: {
        /**
         * 密码数字
         */
        key?: number
        /**
         * 密码数字混淆值
         */
        keySlat?: number
        /**
         * 密码值
         */
        value?: string
      }[]
    }
    /**
     * 渠道名称
     */
    title?: string
  }[]
  closeOrderValue?: number
  /**
   * 折扣优惠消费ticket
   */
  discountActivityTicket?: string
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 满减活动消费ticket
   */
  fullReductionActivityTicket?: string
  /**
   * 是否可以选择核销店铺
   */
  hasChooseWriteOffStore?: boolean
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 是否需要收货地址
   */
  needAddress?: boolean
  /**
   * 是否需要经纬度
   */
  needLogLet?: boolean
  /**
   * 是否需要使用日期
   */
  needUseDate?: boolean
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券 2-兑换券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品来源：0多彩宝 1跨境电商
       */
      commodityResource?: number
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      fullReductioActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 满减优惠金额
       */
      fullReductionActivityAmount?: number
      integralActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 供应商绑定商品ID
       */
      provideCommodityId?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 供应商 0=多彩宝 1=京东
       */
      provideSource?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 是否实名制购买：0-否 1-是
       */
      realNamePurchase?: '0' | '1'
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
        | '13'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 兑换商品类父级商品订单编号
     */
    parentCommodityOrderNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 实名制类型 0-自动回填 1-手动填写
     */
    realNameInputType: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  orderType?: number
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
   */
  preOrderContentType?: '1' | '2' | '4' | '5' | '3'
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
  realNameStatusInfo?: {
    /**
     * 跳转链接名称
     */
    linkName?: string
    /**
     * 是否已经实名认证：0-否1-是
     */
    realNameAuth?: boolean
    /**
     * 注意文案
     */
    tip?: string
    /**
     * 标题文案
     */
    title?: string
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 自提地址Id
   */
  selfPickupAddressId?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 是否显示平台运营相关规则
   */
  showBusinessRuleInfo?: boolean
  /**
   * 是否需要显示实名认证
   */
  showNeedRealNameAuth?: boolean
  /**
   * 是否支持积分支付
   */
  supportPayType?: boolean
  /**
   * 是否为翼支付支付：true-是，false否
   */
  supportYiPay?: boolean
  /**
   * 提示信息
   */
  tips?: string
  /**
   * 酒店订单酒店Id
   */
  tvHotelId?: string
  /**
   * 酒店订单酒店房间号
   */
  tvHotelRoomNo?: string
  /**
   * 订单包含的子机构编码
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [获取商城预下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425668) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getPreOrderData`
 */
type ApiTradeGeneralActCouponTradeGetPreOrderDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/actCouponTrade/getPreOrderData',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商城预下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425668) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getPreOrderData`
 */
const apiTradeGeneralActCouponTradeGetPreOrderDataRequestConfig: ApiTradeGeneralActCouponTradeGetPreOrderDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_4,
    devUrl: devUrl_0_7_0_4,
    prodUrl: prodUrl_0_7_0_4,
    path: '/tradeGeneral/api/actCouponTrade/getPreOrderData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralActCouponTradeGetPreOrderData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商城预下单参数', author: '511号开发' },
  }

/**
 * 接口 [获取商城预下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425668) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getPreOrderData`
 */
export const apiTradeGeneralActCouponTradeGetPreOrderData = /*#__PURE__*/ (
  requestData: ApiTradeGeneralActCouponTradeGetPreOrderDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralActCouponTradeGetPreOrderDataResponse>(
    prepare(
      apiTradeGeneralActCouponTradeGetPreOrderDataRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiTradeGeneralActCouponTradeGetPreOrderData.requestConfig =
  apiTradeGeneralActCouponTradeGetPreOrderDataRequestConfig

/**
 * 接口 [积分支付下单↗](https://yapi.gogpay.cn/project/999/interface/api/425673) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/integralJoinTrade`
 */
export interface ApiTradeGeneralActCouponTradeIntegralJoinTradeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经纬度类型
   */
  locationType?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 使用积分购买数量
     */
    integralCount?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
    /**
     * 核销门店Id
     */
    writeOffStoreId?: string
  }[]
}

/**
 * 接口 [积分支付下单↗](https://yapi.gogpay.cn/project/999/interface/api/425673) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/integralJoinTrade`
 */
export interface ApiTradeGeneralActCouponTradeIntegralJoinTradeResponse {
  preOrderDTO?: {
    businessRuleInfo?: {
      /**
       * 是否勾选
       */
      selected?: boolean
      /**
       * 是否显示购物车
       */
      showCart?: boolean
      /**
       * 提示内容
       */
      tipContent?: string
      /**
       * 提示结尾
       */
      tipEnd?: string
      /**
       * 提示标题
       */
      tipHead?: string
      /**
       * 规则标题
       */
      title?: string
      /**
       * 规则类型：1-跨境电商平台运营规则
       */
      type?: number
      /**
       * 跳转地址
       */
      url?: string
    }
    /**
     * 业务类型
     */
    businessType?: string
    /**
     * 是否计算过邮费
     */
    calcPostFeeFlag?: boolean
    /**
     * 验证码凭证
     */
    captchaToken?: string
    /**
     * 积分抵扣项目列表
     */
    channelActivityItems?: {
      /**
       * 余额
       */
      balance?: string
      /**
       * 余额单位
       */
      balanceUnit?: string
      /**
       * 是否可抵扣
       */
      deduction?: boolean
      /**
       * 活动Id
       */
      id?: string
      /**
       * 是否需要密码
       */
      needPassword?: boolean
      /**
       * 不支持抵扣原因
       */
      noDeductionReason?: string
      passwordKeyboard?: {
        /**
         * 密码值列表
         */
        keys?: {
          /**
           * 密码数字
           */
          key?: number
          /**
           * 密码数字混淆值
           */
          keySlat?: number
          /**
           * 密码值
           */
          value?: string
        }[]
      }
      /**
       * 渠道名称
       */
      title?: string
    }[]
    closeOrderValue?: number
    /**
     * 折扣优惠消费ticket
     */
    discountActivityTicket?: string
    /**
     * 优惠项目列表
     */
    discountItems?: {
      /**
       * 优惠金额
       */
      amount?: number
      /**
       * 优惠名称,如:折扣优惠
       */
      name?: string
      /**
       * 优惠类型
       */
      type?: number
    }[]
    /**
     * 满减活动消费ticket
     */
    fullReductionActivityTicket?: string
    /**
     * 是否可以选择核销店铺
     */
    hasChooseWriteOffStore?: boolean
    /**
     * 是否支持开具发票 0不支持 1支持
     */
    invoiceFlag?: number
    /**
     * 是否需要收货地址
     */
    needAddress?: boolean
    /**
     * 是否需要经纬度
     */
    needLogLet?: boolean
    /**
     * 是否需要使用日期
     */
    needUseDate?: boolean
    /**
     * 订单总额
     */
    orderAmount?: number
    /**
     * 订单信息
     */
    orderInfo?: {
      /**
       * 运营渠道Id
       */
      businessChannelId?: string
      /**
       * 运营渠道名称
       */
      businessChannelName?: string
      /**
       * SKU信息
       */
      commodityInfo?: {
        /**
         * 13位69码
         */
        barCode?: string
        /**
         * 类目Id
         */
        categoryId?: string
        /**
         * 类目名称
         */
        categoryName?: string
        /**
         * 商品种类：0-套餐券 1-代金券 2-兑换券
         */
        commodityClassifyType?: number
        /**
         * 商品id
         */
        commodityId?: string
        /**
         * 商品名称
         */
        commodityName?: string
        /**
         * 商品图片
         */
        commodityPic?: string
        /**
         * 商品来源：0多彩宝 1跨境电商
         */
        commodityResource?: number
        /**
         * 商品类型 0-标准电商 1-派单核销
         */
        commodityType?: number
        /**
         * 商品合同名称
         */
        contractName?: string
        /**
         * 购买数量
         */
        count?: number
        /**
         * 划线价
         */
        dashPrice?: number
        /**
         * 仅支持配送地址
         */
        deliverAddress?: string[]
        /**
         * 地址配送限制类型
         */
        deliverAddressType?: number
        discountActivity?: {
          /**
           * 优惠金额
           */
          discountAmount?: number
          /**
           * 结束时间
           */
          endTime?: string
          /**
           * 活动Id
           */
          id?: string
          /**
           * 初始限制数量
           */
          initLimitCount?: number
          /**
           * 优惠后所需积分
           */
          integral?: number
          /**
           * 最大可选择数量
           */
          maxSelectCount?: number
          /**
           * 活动名称
           */
          name?: string
          /**
           * 原所需活动积分
           */
          needIntegral?: number
          /**
           * 原价
           */
          price?: number
          /**
           * 活动积分比例 一分钱：ratio
           */
          ratio?: number
          settlementConfig?: {
            /**
             * 出资方；1=平台出资，2=商家出资，3=共同出资
             */
            contributionType: number
            /**
             * 共同出资方式；1=商家出资占比，2=平台出资占比
             */
            jointContributionType: number
            /**
             * 共同出资占比
             */
            jointContributionVal: string
          }
          /**
           * 开始时间
           */
          startTime?: string
          /**
           * 单人限购
           */
          userPurchaseLimit?: number
        }
        /**
         * 折扣优惠金额
         */
        discountActivityAmount?: number
        /**
         * sku能效级别
         */
        efficiencyLevel?: number
        /**
         * 特征标签
         */
        featureLabel?: {
          /**
           * 标签CODE
           */
          code?: string
          /**
           * 标签名称
           */
          label?: string
        }[]
        fullReductioActivity?: {
          /**
           * 优惠金额
           */
          discountAmount?: number
          /**
           * 结束时间
           */
          endTime?: string
          /**
           * 活动Id
           */
          id?: string
          /**
           * 初始限制数量
           */
          initLimitCount?: number
          /**
           * 优惠后所需积分
           */
          integral?: number
          /**
           * 最大可选择数量
           */
          maxSelectCount?: number
          /**
           * 活动名称
           */
          name?: string
          /**
           * 原所需活动积分
           */
          needIntegral?: number
          /**
           * 原价
           */
          price?: number
          /**
           * 活动积分比例 一分钱：ratio
           */
          ratio?: number
          settlementConfig?: {
            /**
             * 出资方；1=平台出资，2=商家出资，3=共同出资
             */
            contributionType: number
            /**
             * 共同出资方式；1=商家出资占比，2=平台出资占比
             */
            jointContributionType: number
            /**
             * 共同出资占比
             */
            jointContributionVal: string
          }
          /**
           * 开始时间
           */
          startTime?: string
          /**
           * 单人限购
           */
          userPurchaseLimit?: number
        }
        /**
         * 满减优惠金额
         */
        fullReductionActivityAmount?: number
        integralActivity?: {
          /**
           * 优惠金额
           */
          discountAmount?: number
          /**
           * 结束时间
           */
          endTime?: string
          /**
           * 活动Id
           */
          id?: string
          /**
           * 初始限制数量
           */
          initLimitCount?: number
          /**
           * 优惠后所需积分
           */
          integral?: number
          /**
           * 最大可选择数量
           */
          maxSelectCount?: number
          /**
           * 活动名称
           */
          name?: string
          /**
           * 原所需活动积分
           */
          needIntegral?: number
          /**
           * 原价
           */
          price?: number
          /**
           * 活动积分比例 一分钱：ratio
           */
          ratio?: number
          settlementConfig?: {
            /**
             * 出资方；1=平台出资，2=商家出资，3=共同出资
             */
            contributionType: number
            /**
             * 共同出资方式；1=商家出资占比，2=平台出资占比
             */
            jointContributionType: number
            /**
             * 共同出资占比
             */
            jointContributionVal: string
          }
          /**
           * 开始时间
           */
          startTime?: string
          /**
           * 单人限购
           */
          userPurchaseLimit?: number
        }
        /**
         * 可选日期区间：0-否 1-是
         */
        isDateInterval: 0 | 1
        /**
         * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
         */
        isIncludeLastDay?: 0 | 1
        /**
         * 组合子商品列表
         */
        jointCommodityList?: {
          /**
           * 子商品ID
           */
          childCommodityId?: string
          /**
           * 子商品图片
           */
          childCommodityPic?: string
          /**
           * 子商品邮费价格
           */
          childPostPrice?: number
          /**
           * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
           */
          childPostType?: 0 | 1 | 2
          /**
           * 子商品规格ID
           */
          childSkuId?: string
          /**
           * 组合商品名称
           */
          commodityTitle?: string
          /**
           * 数量
           */
          num?: number
          /**
           * 单次核销价格
           */
          onePrice?: number
          /**
           * 商品原名称
           */
          originalCommodityTitle?: string
          /**
           * 组合商品ID
           */
          refCommodityId?: string
          /**
           * 运费模板
           */
          refDeliverTemplateId?: string
          /**
           * 销售价格
           */
          sellPrice?: number
          /**
           * 结算方式：0-固定金额 1-分层比例
           */
          settlementType?: 0 | 1
          /**
           * 结算值
           */
          settlementValue?: number
          /**
           * 剩余库存
           */
          surplusStock?: number
        }[]
        jointStandardCommodity?: {
          /**
           * 包邮类型  1-包邮 2-运费模板
           */
          postType: 0 | 1 | 2
          /**
           * 是佛提供发票：0-不提供 1-提供
           */
          provideInvoiceFlag: number
          /**
           * 商品售价
           */
          sellPrice: number
          /**
           * 发货类型 0-快递发货 1-同城配送 2-到店自提
           */
          shippingType: 0 | 1 | 2
          zoneLimit?: {
            /**
             * 邮费结算价
             */
            postFeeCost?: number
            /**
             * 配送区域
             */
            zones?: {
              /**
               * 市级编码
               */
              cityCode?: string
              /**
               * 省份名称
               */
              cityName?: string
              /**
               * 区级编码
               */
              districtCode?: string
              /**
               * 区县名称
               */
              districtName?: string
              /**
               * 省份编码
               */
              provinceCode?: string
              /**
               * 省份名称
               */
              provinceName?: string
            }[]
          }
          /**
           * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
           */
          zoneLimitType: 0 | 1 | 2
        }
        /**
         * 是否需要附加实名用户信息
         */
        needUserInfo?: boolean
        /**
         * 打包费
         */
        packagePrice?: number
        /**
         * 邮费
         */
        postFee?: number
        /**
         * 邮费结算价
         */
        postSettlementFee?: number
        /**
         * 邮费类型
         */
        postType?: number
        /**
         * 供应商绑定商品ID
         */
        provideCommodityId?: string
        /**
         * 是否提供发票
         */
        provideInvoiceFlag?: number
        /**
         * 供应商 0=多彩宝 1=京东
         */
        provideSource?: number
        /**
         * 实名制类型 0-自动回填 1-手动填写
         */
        realNameInputType: number
        /**
         * 是否实名制购买：0-否 1-是
         */
        realNamePurchase?: '0' | '1'
        /**
         * 是否支持换货 0不支持 1支持
         */
        replacementStatus?: number
        /**
         * 商品资源id
         */
        resourceId?: string
        /**
         * 售后装填 -1=不可申请  0可申请
         */
        saleStatus?: number
        /**
         * 销售渠道Id
         */
        sellChannelId?: string
        /**
         * 销售渠道名称
         */
        sellChannelName?: string
        /**
         * 是否支持7天无理由退款 0不支持 1支持
         */
        sevenDaysRefundStatus?: number
        /**
         * 商品单日限购量（0不限制）
         */
        singleDayLimitPurchases: number
        /**
         * sku描述
         */
        skuDesc?: string
        /**
         * skuid
         */
        skuId?: string
        /**
         * 库存购买日期
         */
        stockDate?: string
        /**
         * 使用日期字符串
         */
        stockDateStr?: string
        /**
         * 库存购买结束日期
         */
        stockEndDate?: string
        stockEndTime?: {
          hour?: number
          minute?: number
          nano?: number
          second?: number
        }
        /**
         * 库存Id
         */
        stockId?: string
        stockStartTime?: {
          hour?: number
          minute?: number
          nano?: number
          second?: number
        }
        /**
         * 禁售地址
         */
        stopDeliverAddress?: string[]
        /**
         * 剩余数量
         */
        surplusCount?: number
        /**
         * 总价
         */
        totalPrice?: number
        /**
         * 商品所属店铺机构
         */
        unitOrgCode?: string
        /**
         * 单价
         */
        unitPrice?: number
        /**
         * 用户单日限购量（0不限制）
         */
        userDayLimitPurchases: number
        /**
         * 重量（克）
         */
        weight?: number
        /**
         * 核销渠道
         */
        writeOffChannel?:
          | '0'
          | '1'
          | '2'
          | '3'
          | '4'
          | '5'
          | '6'
          | '7'
          | '8'
          | '9'
          | '10'
          | '11'
          | '12'
          | '13'
        /**
         * 第三方商品Id
         */
        writeOffChannelCommodityId?: string
        /**
         * 套餐详情
         */
        writeOffCombos?: {
          /**
           * 分组详情列表
           */
          groupDetails?: {
            /**
             * 数量
             */
            num?: number
            /**
             * 价格
             */
            price?: number
            /**
             * 服务名称
             */
            serviceName?: string
          }[]
          /**
           * 分组名称
           */
          groupName?: string
        }[]
        /**
         * 购买xxx天内有效
         */
        writeOffValidDay?: number
        /**
         * 核销有效期结束时间
         */
        writeOffValidEndTime?: string
        /**
         * 核销有效期开始时间
         */
        writeOffValidStartTime?: string
        /**
         * 核销有效期：0-相对时间 1-固定时间
         */
        writeOffValidType?: '0' | '1' | '2' | '3' | '4'
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 可配送区域类型
         */
        zoneLimitType?: '0' | '1' | '2'
      }[]
      /**
       * 商户Id
       */
      merchantId?: string
      /**
       * 商户名称
       */
      merchantName?: string
      /**
       * 商户图片
       */
      merchantPic?: string
      /**
       * 商户联系方式
       */
      merchantTel?: string
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 订单类型
       */
      orderClassifyType?: number
      /**
       * 订单Id，临时用，非真实
       */
      orderId?: string
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 兑换商品类父级商品订单编号
       */
      parentCommodityOrderNo?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 店铺营业时间
       */
      storeOpenPreiod?: string
      /**
       * 订单总金额
       */
      totalAmount?: number
      /**
       * 总商品数量
       */
      totalQuantity?: number
      /**
       * 子机构编码
       */
      unitOrgCode?: string
      writeOffRefund?: {
        /**
         * 过期后退款比例
         */
        expireRate?: number
        /**
         * 退款无需审批
         */
        notApproveFlag?: boolean
        /**
         * 未使用退款比例
         */
        unusedRate?: number
      }
    }[]
    orderType?: number
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
     */
    preOrderContentType?: '1' | '2' | '4' | '5' | '3'
    /**
     * 预下单任务Id
     */
    preOrderId?: string
    /**
     * 预下单类型
     */
    preOrderType?: number
    realNameStatusInfo?: {
      /**
       * 跳转链接名称
       */
      linkName?: string
      /**
       * 是否已经实名认证：0-否1-是
       */
      realNameAuth?: boolean
      /**
       * 注意文案
       */
      tip?: string
      /**
       * 标题文案
       */
      title?: string
      /**
       * 跳转地址
       */
      url?: string
    }
    /**
     * 自提地址Id
     */
    selfPickupAddressId?: string
    /**
     * 发货类型 0正常发货 1门店自提
     */
    shipType?: number
    /**
     * 是否显示平台运营相关规则
     */
    showBusinessRuleInfo?: boolean
    /**
     * 是否需要显示实名认证
     */
    showNeedRealNameAuth?: boolean
    /**
     * 是否支持积分支付
     */
    supportPayType?: boolean
    /**
     * 是否为翼支付支付：true-是，false否
     */
    supportYiPay?: boolean
    /**
     * 提示信息
     */
    tips?: string
    /**
     * 酒店订单酒店Id
     */
    tvHotelId?: string
    /**
     * 酒店订单酒店房间号
     */
    tvHotelRoomNo?: string
    /**
     * 订单包含的子机构编码
     */
    unitOrgCode?: string[]
  }
  /**
   * 跳转地址
   */
  targetUrl?: string
}

/**
 * 接口 [积分支付下单↗](https://yapi.gogpay.cn/project/999/interface/api/425673) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/integralJoinTrade`
 */
type ApiTradeGeneralActCouponTradeIntegralJoinTradeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/actCouponTrade/integralJoinTrade',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [积分支付下单↗](https://yapi.gogpay.cn/project/999/interface/api/425673) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/integralJoinTrade`
 */
const apiTradeGeneralActCouponTradeIntegralJoinTradeRequestConfig: ApiTradeGeneralActCouponTradeIntegralJoinTradeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_4,
    devUrl: devUrl_0_7_0_4,
    prodUrl: prodUrl_0_7_0_4,
    path: '/tradeGeneral/api/actCouponTrade/integralJoinTrade',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralActCouponTradeIntegralJoinTrade',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '积分支付下单', author: '511号开发' },
  }

/**
 * 接口 [积分支付下单↗](https://yapi.gogpay.cn/project/999/interface/api/425673) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/integralJoinTrade`
 */
export const apiTradeGeneralActCouponTradeIntegralJoinTrade = /*#__PURE__*/ (
  requestData: ApiTradeGeneralActCouponTradeIntegralJoinTradeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralActCouponTradeIntegralJoinTradeResponse>(
    prepare(
      apiTradeGeneralActCouponTradeIntegralJoinTradeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiTradeGeneralActCouponTradeIntegralJoinTrade.requestConfig =
  apiTradeGeneralActCouponTradeIntegralJoinTradeRequestConfig

/**
 * 接口 [积分扣减完成回调下单↗](https://yapi.gogpay.cn/project/999/interface/api/425678) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `GET /tradeGeneral/api/actCouponTrade/toMallPaySuccess`
 */
export interface ApiTradeGeneralActCouponTradeToMallPaySuccessRequest {}

/**
 * 接口 [积分扣减完成回调下单↗](https://yapi.gogpay.cn/project/999/interface/api/425678) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `GET /tradeGeneral/api/actCouponTrade/toMallPaySuccess`
 */
export type ApiTradeGeneralActCouponTradeToMallPaySuccessResponse = any

/**
 * 接口 [积分扣减完成回调下单↗](https://yapi.gogpay.cn/project/999/interface/api/425678) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `GET /tradeGeneral/api/actCouponTrade/toMallPaySuccess`
 */
type ApiTradeGeneralActCouponTradeToMallPaySuccessRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/actCouponTrade/toMallPaySuccess',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [积分扣减完成回调下单↗](https://yapi.gogpay.cn/project/999/interface/api/425678) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `GET /tradeGeneral/api/actCouponTrade/toMallPaySuccess`
 */
const apiTradeGeneralActCouponTradeToMallPaySuccessRequestConfig: ApiTradeGeneralActCouponTradeToMallPaySuccessRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_4,
    devUrl: devUrl_0_7_0_4,
    prodUrl: prodUrl_0_7_0_4,
    path: '/tradeGeneral/api/actCouponTrade/toMallPaySuccess',
    method: Method.GET,
    requestHeaders: {},
    requestBodyType: RequestBodyType.query,
    responseBodyType: ResponseBodyType.raw,
    dataKey: dataKey_0_7_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralActCouponTradeToMallPaySuccess',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '积分扣减完成回调下单', author: '511号开发' },
  }

/**
 * 接口 [积分扣减完成回调下单↗](https://yapi.gogpay.cn/project/999/interface/api/425678) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `GET /tradeGeneral/api/actCouponTrade/toMallPaySuccess`
 */
export const apiTradeGeneralActCouponTradeToMallPaySuccess = /*#__PURE__*/ (
  requestData?: ApiTradeGeneralActCouponTradeToMallPaySuccessRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralActCouponTradeToMallPaySuccessResponse>(
    prepare(
      apiTradeGeneralActCouponTradeToMallPaySuccessRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiTradeGeneralActCouponTradeToMallPaySuccess.requestConfig =
  apiTradeGeneralActCouponTradeToMallPaySuccessRequestConfig

/**
 * 接口 [获取商城下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425788) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getTradeOrderData`
 */
export interface ApiTradeGeneralActCouponTradeGetTradeOrderDataRequest {
  /**
   * 预下单临时Id
   */
  preOrderId?: string
}

/**
 * 接口 [获取商城下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425788) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getTradeOrderData`
 */
export interface ApiTradeGeneralActCouponTradeGetTradeOrderDataResponse {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经纬度类型
   */
  locationType?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 使用积分购买数量
     */
    integralCount?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
    /**
     * 核销门店Id
     */
    writeOffStoreId?: string
  }[]
}

/**
 * 接口 [获取商城下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425788) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getTradeOrderData`
 */
type ApiTradeGeneralActCouponTradeGetTradeOrderDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/999',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/tradeGeneral/api/actCouponTrade/getTradeOrderData',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商城下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425788) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getTradeOrderData`
 */
const apiTradeGeneralActCouponTradeGetTradeOrderDataRequestConfig: ApiTradeGeneralActCouponTradeGetTradeOrderDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_7_0_4,
    devUrl: devUrl_0_7_0_4,
    prodUrl: prodUrl_0_7_0_4,
    path: '/tradeGeneral/api/actCouponTrade/getTradeOrderData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_7_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiTradeGeneralActCouponTradeGetTradeOrderData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商城下单参数', author: '511号开发' },
  }

/**
 * 接口 [获取商城下单参数↗](https://yapi.gogpay.cn/project/999/interface/api/425788) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [契税交易下单↗](https://yapi.gogpay.cn/project/999/interface/api/cat_75245)
 * @请求头 `POST /tradeGeneral/api/actCouponTrade/getTradeOrderData`
 */
export const apiTradeGeneralActCouponTradeGetTradeOrderData = /*#__PURE__*/ (
  requestData: ApiTradeGeneralActCouponTradeGetTradeOrderDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiTradeGeneralActCouponTradeGetTradeOrderDataResponse>(
    prepare(
      apiTradeGeneralActCouponTradeGetTradeOrderDataRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiTradeGeneralActCouponTradeGetTradeOrderData.requestConfig =
  apiTradeGeneralActCouponTradeGetTradeOrderDataRequestConfig

const mockUrl_0_8_0_0 = 'https://yapi.gogpay.cn/mock/916' as any
const devUrl_0_8_0_0 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_8_0_0 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_8_0_0 = 'data' as any

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/96016) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/list`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 所属运营渠道
   */
  businessChannelIdList?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 申请时间-结束日期
   */
  createTimeEnd: string
  /**
   * 申请时间-开始日期
   */
  createTimeStart: string
  /**
   * 用户手机号
   */
  dcbUserPhone?: string
  /**
   * 售后编号
   */
  id?: string
  /**
   * 所属店铺
   */
  merchantIdList?: string[]
  /**
   * 中台订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 售后状态 1待商家同意售后申请   3商家同意仅退款申请   9售后关闭  10售后完成
   */
  saleAfterStatusList?: (
    | '99'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
  )[]
  /**
   * 售后订单类型  2标准核销   4组合订单
   */
  saleOrderType?: (
    | 'STANDARD'
    | 'WRITEE_OFF'
    | 'WRITE_OFF_PAY'
    | 'JOINT'
    | 'TRAVEL'
    | 'DELIVER'
    | 'DELIVER_PAY'
  )[]
  /**
   * 店铺机构编码
   */
  unitOrgCodeList?: string[]
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/96016) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/list`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 所属运营渠道
     */
    businessChannelName?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品售价
     */
    commodityPrice?: number
    /**
     * 售后申请时间
     */
    createTime?: string
    /**
     * 用户手机号
     */
    dcbUserPhone?: string
    /**
     * 售后编号
     */
    id?: string
    /**
     * 实收金额
     */
    orderAmount?: number
    /**
     * 支付流水号
     */
    paySerialNo?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 申请原因
     */
    reason?: string
    /**
     * 订单编号
     */
    refOrderNo?: string
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 退款比例
     */
    refundRate?: number
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeLabel?: string
    /**
     * 订单类型
     */
    saleOrderTypeName?: string
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 所属店铺
     */
    storeName?: string
    /**
     * 处理倒计时
     */
    timeoutTime?: string
    /**
     * 处理倒计时描述
     */
    timeoutTimeDesc?: string
    /**
     * 核销渠道
     */
    writeOffChannel?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/96016) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/list`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/imsApi/writeOffSaleAfter/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/96016) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/list`
 */
const apiSaleAfterImsApiWriteOffSaleAfterListRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterImsApiWriteOffSaleAfterList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '售后列表', author: '成龙' },
  }

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/96016) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/list`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterList = /*#__PURE__*/ (
  requestData: ApiSaleAfterImsApiWriteOffSaleAfterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterImsApiWriteOffSaleAfterListResponse>(
    prepare(apiSaleAfterImsApiWriteOffSaleAfterListRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterImsApiWriteOffSaleAfterList.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterListRequestConfig

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/96466) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/detail`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterDetailRequest {
  /**
   * 商品退款金额信息（配送售后）
   */
  commodityRefundInfo?: {
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
  dcbUserId?: string
  /**
   * 售后id
   */
  id: string
  /**
   * 申请原因
   */
  reason?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 是否退邮费
   */
  refundPostFee?: boolean
  registerPhone?: string
}

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/96466) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/detail`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterDetailResponse {
  /**
   * 售后轨迹
   */
  adminTimeFlow?: {
    /**
     * 激活状态 0否1是
     */
    activeFlag?: number
    /**
     * 行为主体
     */
    createBy?: string
    /**
     * 内容描述
     */
    description?: string
    /**
     * 排序值 升序
     */
    sort?: number
    /**
     * 发生时间
     */
    time?: string
    /**
     * 节点标题
     */
    title?: string
  }[]
  /**
   * 申请原因
   */
  applyReason?: string
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 商品图片
   */
  commodityCoverPic?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品价格
   */
  commodityPrice?: number
  /**
   * 商品名称
   */
  commodityTitle?: string
  /**
   * 售后Id
   */
  id?: string
  /**
   * 实收金额
   */
  orderAmount?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单支付金额
   */
  orderPayAmount?: number
  /**
   * 订单状态文案
   */
  orderStatusLabel?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 数量
   */
  quantity?: number
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 退款比例
   */
  refundRate?: number
  /**
   * 售后状态 1待商家同意售后申请   3商家同意仅退款申请   9售后关闭  10售后完成
   */
  saleAfterStatus?: number
  /**
   * 售后状态文案
   */
  saleAfterStatusLabel?: string
  /**
   * 售后类型（1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 售后类型文案
   */
  saleAfterTypeLabel?: string
  /**
   * 处理倒计时
   */
  timeoutTime?: string
  /**
   * 处理倒计时描述
   */
  timeoutTimeDesc?: string
  /**
   * 用户名
   */
  userName?: string
  /**
   * 用户手机号
   */
  userPhone?: string
  /**
   * 核销渠道
   */
  writeOffChannel?: string
}

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/96466) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/detail`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/imsApi/writeOffSaleAfter/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/96466) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/detail`
 */
const apiSaleAfterImsApiWriteOffSaleAfterDetailRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterImsApiWriteOffSaleAfterDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '售后详情', author: '成龙' },
  }

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/96466) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/detail`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterDetail = /*#__PURE__*/ (
  requestData: ApiSaleAfterImsApiWriteOffSaleAfterDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterImsApiWriteOffSaleAfterDetailResponse>(
    prepare(
      apiSaleAfterImsApiWriteOffSaleAfterDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterImsApiWriteOffSaleAfterDetail.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterDetailRequestConfig

/**
 * 接口 [申请售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/97078) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/apply`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterApplyRequest {
  /**
   * 申请原因
   */
  applyReason?: string
  /**
   * 核销码列表
   */
  codeList?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
}

/**
 * 接口 [申请售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/97078) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/apply`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterApplyResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [申请售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/97078) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/apply`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/imsApi/writeOffSaleAfter/apply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/97078) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/apply`
 */
const apiSaleAfterImsApiWriteOffSaleAfterApplyRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/apply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterImsApiWriteOffSaleAfterApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请售后-管理端', author: '成龙' },
  }

/**
 * 接口 [申请售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/97078) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/apply`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterApply = /*#__PURE__*/ (
  requestData: ApiSaleAfterImsApiWriteOffSaleAfterApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterImsApiWriteOffSaleAfterApplyResponse>(
    prepare(apiSaleAfterImsApiWriteOffSaleAfterApplyRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterImsApiWriteOffSaleAfterApply.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterApplyRequestConfig

/**
 * 接口 [申请售后-系统↗](https://yapi.gogpay.cn/project/916/interface/api/118018) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/systemApply`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequest {
  /**
   * 申请原因
   */
  applyReason?: string
  /**
   * 核销码列表
   */
  codeList?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
}

/**
 * 接口 [申请售后-系统↗](https://yapi.gogpay.cn/project/916/interface/api/118018) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/systemApply`
 */
export type ApiSaleAfterImsApiWriteOffSaleAfterSystemApplyResponse = string

/**
 * 接口 [申请售后-系统↗](https://yapi.gogpay.cn/project/916/interface/api/118018) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/systemApply`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/imsApi/writeOffSaleAfter/systemApply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请售后-系统↗](https://yapi.gogpay.cn/project/916/interface/api/118018) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/systemApply`
 */
const apiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/systemApply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterImsApiWriteOffSaleAfterSystemApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请售后-系统', author: '成龙' },
  }

/**
 * 接口 [申请售后-系统↗](https://yapi.gogpay.cn/project/916/interface/api/118018) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/systemApply`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterSystemApply = /*#__PURE__*/ (
  requestData: ApiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterImsApiWriteOffSaleAfterSystemApplyResponse>(
    prepare(
      apiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterImsApiWriteOffSaleAfterSystemApply.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterSystemApplyRequestConfig

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/916/interface/api/167324) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequest {
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/916/interface/api/167324) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount`
 */
export type ApiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountResponse =
  number

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/916/interface/api/167324) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/916/interface/api/167324) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount`
 */
const apiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单退款金额', author: '成龙' },
  }

/**
 * 接口 [获取订单退款金额↗](https://yapi.gogpay.cn/project/916/interface/api/167324) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/getOrderRefundAmount`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmount =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountResponse>(
      prepare(
        apiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmount.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterGetOrderRefundAmountRequestConfig

/**
 * 接口 [退票状态通知（open sdk）调用↗](https://yapi.gogpay.cn/project/916/interface/api/167332) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 退票状态 0未成功 1成功
   */
  status: number
}

/**
 * 接口 [退票状态通知（open sdk）调用↗](https://yapi.gogpay.cn/project/916/interface/api/167332) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [退票状态通知（open sdk）调用↗](https://yapi.gogpay.cn/project/916/interface/api/167332) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [退票状态通知（open sdk）调用↗](https://yapi.gogpay.cn/project/916/interface/api/167332) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus`
 */
const apiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '退票状态通知（open sdk）调用', author: '成龙' },
  }

/**
 * 接口 [退票状态通知（open sdk）调用↗](https://yapi.gogpay.cn/project/916/interface/api/167332) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/notifyTicketStatus`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatus =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusResponse>(
      prepare(
        apiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatus.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterNotifyTicketStatusRequestConfig

/**
 * 接口 [导出标销列表↗](https://yapi.gogpay.cn/project/916/interface/api/183196) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/export`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterExportRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 所属运营渠道
   */
  businessChannelIdList?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 申请时间-结束日期
   */
  createTimeEnd: string
  /**
   * 申请时间-开始日期
   */
  createTimeStart: string
  /**
   * 用户手机号
   */
  dcbUserPhone?: string
  /**
   * 售后编号
   */
  id?: string
  /**
   * 所属店铺
   */
  merchantIdList?: string[]
  /**
   * 中台订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 售后状态 1待商家同意售后申请   3商家同意仅退款申请   9售后关闭  10售后完成
   */
  saleAfterStatusList?: (
    | '99'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
  )[]
  /**
   * 售后订单类型  2标准核销   4组合订单
   */
  saleOrderType?: (
    | 'STANDARD'
    | 'WRITEE_OFF'
    | 'WRITE_OFF_PAY'
    | 'JOINT'
    | 'TRAVEL'
    | 'DELIVER'
    | 'DELIVER_PAY'
  )[]
  /**
   * 店铺机构编码
   */
  unitOrgCodeList?: string[]
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [导出标销列表↗](https://yapi.gogpay.cn/project/916/interface/api/183196) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/export`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterExportResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出标销列表↗](https://yapi.gogpay.cn/project/916/interface/api/183196) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/export`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterExportRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/imsApi/writeOffSaleAfter/export',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出标销列表↗](https://yapi.gogpay.cn/project/916/interface/api/183196) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/export`
 */
const apiSaleAfterImsApiWriteOffSaleAfterExportRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterImsApiWriteOffSaleAfterExport',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出标销列表', author: '成龙' },
  }

/**
 * 接口 [导出标销列表↗](https://yapi.gogpay.cn/project/916/interface/api/183196) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/export`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterExport = /*#__PURE__*/ (
  requestData: ApiSaleAfterImsApiWriteOffSaleAfterExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterImsApiWriteOffSaleAfterExportResponse>(
    prepare(
      apiSaleAfterImsApiWriteOffSaleAfterExportRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterImsApiWriteOffSaleAfterExport.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterExportRequestConfig

/**
 * 接口 [申请已核销售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/460368) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/applyEndCode`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequest {
  /**
   * 申请原因
   */
  applyReason?: string
  /**
   * 核销码Id列表
   */
  codeList: {
    /**
     * 核销码
     */
    code: string
    /**
     * 退款金额
     */
    refundAmount: number
    /**
     * 结算金额
     */
    settAmount: number
  }[]
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [申请已核销售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/460368) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/applyEndCode`
 */
export interface ApiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [申请已核销售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/460368) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/applyEndCode`
 */
type ApiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/imsApi/writeOffSaleAfter/applyEndCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请已核销售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/460368) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/applyEndCode`
 */
const apiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequestConfig: ApiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_0,
    devUrl: devUrl_0_8_0_0,
    prodUrl: prodUrl_0_8_0_0,
    path: '/saleAfter/imsApi/writeOffSaleAfter/applyEndCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterImsApiWriteOffSaleAfterApplyEndCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请已核销售后-管理端', author: '511号开发' },
  }

/**
 * 接口 [申请已核销售后-管理端↗](https://yapi.gogpay.cn/project/916/interface/api/460368) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [标销售后↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21246)
 * @请求头 `POST /saleAfter/imsApi/writeOffSaleAfter/applyEndCode`
 */
export const apiSaleAfterImsApiWriteOffSaleAfterApplyEndCode = /*#__PURE__*/ (
  requestData: ApiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeResponse>(
    prepare(
      apiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterImsApiWriteOffSaleAfterApplyEndCode.requestConfig =
  apiSaleAfterImsApiWriteOffSaleAfterApplyEndCodeRequestConfig

const mockUrl_0_8_0_1 = 'https://yapi.gogpay.cn/mock/916' as any
const devUrl_0_8_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_8_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_8_0_1 = 'data' as any

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/916/interface/api/100252) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/apply`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterApplyRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 申请数量
   */
  quantity?: number
  /**
   * 申请原因
   */
  reason?: string
}

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/916/interface/api/100252) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/apply`
 */
export type ApiSaleAfterWriteOffOrderSaleAfterApplyResponse = string

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/916/interface/api/100252) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/apply`
 */
type ApiSaleAfterWriteOffOrderSaleAfterApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/writeOffOrderSaleAfter/apply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/916/interface/api/100252) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/apply`
 */
const apiSaleAfterWriteOffOrderSaleAfterApplyRequestConfig: ApiSaleAfterWriteOffOrderSaleAfterApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_1,
    devUrl: devUrl_0_8_0_1,
    prodUrl: prodUrl_0_8_0_1,
    path: '/saleAfter/api/writeOffOrderSaleAfter/apply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterWriteOffOrderSaleAfterApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请售后', author: '成龙' },
  }

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/916/interface/api/100252) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/apply`
 */
export const apiSaleAfterWriteOffOrderSaleAfterApply = /*#__PURE__*/ (
  requestData: ApiSaleAfterWriteOffOrderSaleAfterApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterWriteOffOrderSaleAfterApplyResponse>(
    prepare(apiSaleAfterWriteOffOrderSaleAfterApplyRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterWriteOffOrderSaleAfterApply.requestConfig =
  apiSaleAfterWriteOffOrderSaleAfterApplyRequestConfig

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/100258) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/detail`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterDetailRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/100258) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/detail`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterDetailResponse {
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 申请数量
   */
  quantity?: number
  /**
   * 申请原因
   */
  reason?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 售后记录Id(售后编号)
   */
  saleId?: string
  /**
   * 状态 1退款中  2退款失败  3退款成功
   */
  status?: number
  /**
   * 状态文案
   */
  statusName?: string
  /**
   * 退款进度
   */
  timeFlow?: {
    /**
     * 激活状态 0否1是
     */
    activeFlag?: number
    /**
     * 排序值 升序
     */
    sort?: number
    /**
     * 子标题
     */
    subTitle?: string
    /**
     * 发生时间
     */
    time?: string
    /**
     * 流程名称
     */
    title?: string
  }[]
  /**
   * 申请类型 1用户申请  2管理后台申请
   */
  type?: number
}

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/100258) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/detail`
 */
type ApiSaleAfterWriteOffOrderSaleAfterDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/writeOffOrderSaleAfter/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/100258) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/detail`
 */
const apiSaleAfterWriteOffOrderSaleAfterDetailRequestConfig: ApiSaleAfterWriteOffOrderSaleAfterDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_1,
    devUrl: devUrl_0_8_0_1,
    prodUrl: prodUrl_0_8_0_1,
    path: '/saleAfter/api/writeOffOrderSaleAfter/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterWriteOffOrderSaleAfterDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '售后详情', author: '成龙' },
  }

/**
 * 接口 [售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/100258) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/detail`
 */
export const apiSaleAfterWriteOffOrderSaleAfterDetail = /*#__PURE__*/ (
  requestData: ApiSaleAfterWriteOffOrderSaleAfterDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterWriteOffOrderSaleAfterDetailResponse>(
    prepare(apiSaleAfterWriteOffOrderSaleAfterDetailRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterWriteOffOrderSaleAfterDetail.requestConfig =
  apiSaleAfterWriteOffOrderSaleAfterDetailRequestConfig

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/100264) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/list`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterListRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/100264) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/list`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 券码有效期
     */
    expireTime?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 售后记录Id
     */
    saleId?: string
    /**
     * 状态 1退款中  2退款失败  3退款成功
     */
    status?: number
    /**
     * 状态文案
     */
    statusName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/100264) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/list`
 */
type ApiSaleAfterWriteOffOrderSaleAfterListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/writeOffOrderSaleAfter/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/100264) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/list`
 */
const apiSaleAfterWriteOffOrderSaleAfterListRequestConfig: ApiSaleAfterWriteOffOrderSaleAfterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_1,
    devUrl: devUrl_0_8_0_1,
    prodUrl: prodUrl_0_8_0_1,
    path: '/saleAfter/api/writeOffOrderSaleAfter/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterWriteOffOrderSaleAfterList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '售后列表', author: '成龙' },
  }

/**
 * 接口 [售后列表↗](https://yapi.gogpay.cn/project/916/interface/api/100264) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/list`
 */
export const apiSaleAfterWriteOffOrderSaleAfterList = /*#__PURE__*/ (
  requestData: ApiSaleAfterWriteOffOrderSaleAfterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterWriteOffOrderSaleAfterListResponse>(
    prepare(apiSaleAfterWriteOffOrderSaleAfterListRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterWriteOffOrderSaleAfterList.requestConfig =
  apiSaleAfterWriteOffOrderSaleAfterListRequestConfig

/**
 * 接口 [获取预退款信息↗](https://yapi.gogpay.cn/project/916/interface/api/100270) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/preSaleInfo`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [获取预退款信息↗](https://yapi.gogpay.cn/project/916/interface/api/100270) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/preSaleInfo`
 */
export interface ApiSaleAfterWriteOffOrderSaleAfterPreSaleInfoResponse {
  /**
   * 券码类型   1多张券码   2单券码多次使用
   */
  codeType?: number
  /**
   * 退款原因列表
   */
  reasonList?: string[]
  /**
   * 剩余可退款数量
   */
  surplusCount?: number
  /**
   * 总价
   */
  totalAmount?: number
  /**
   * 单价
   */
  unitAmount?: number
}

/**
 * 接口 [获取预退款信息↗](https://yapi.gogpay.cn/project/916/interface/api/100270) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/preSaleInfo`
 */
type ApiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/writeOffOrderSaleAfter/preSaleInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取预退款信息↗](https://yapi.gogpay.cn/project/916/interface/api/100270) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/preSaleInfo`
 */
const apiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequestConfig: ApiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_1,
    devUrl: devUrl_0_8_0_1,
    prodUrl: prodUrl_0_8_0_1,
    path: '/saleAfter/api/writeOffOrderSaleAfter/preSaleInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterWriteOffOrderSaleAfterPreSaleInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取预退款信息', author: '成龙' },
  }

/**
 * 接口 [获取预退款信息↗](https://yapi.gogpay.cn/project/916/interface/api/100270) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销售后-客户端↗](https://yapi.gogpay.cn/project/916/interface/api/cat_21672)
 * @请求头 `POST /saleAfter/api/writeOffOrderSaleAfter/preSaleInfo`
 */
export const apiSaleAfterWriteOffOrderSaleAfterPreSaleInfo = /*#__PURE__*/ (
  requestData: ApiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterWriteOffOrderSaleAfterPreSaleInfoResponse>(
    prepare(
      apiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterWriteOffOrderSaleAfterPreSaleInfo.requestConfig =
  apiSaleAfterWriteOffOrderSaleAfterPreSaleInfoRequestConfig

const mockUrl_0_8_0_4 = 'https://yapi.gogpay.cn/mock/916' as any
const devUrl_0_8_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_8_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_8_0_4 = 'data' as any

/**
 * 接口 [4、退款、售后列表查询↗](https://yapi.gogpay.cn/project/916/interface/api/28805) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/list`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterListRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 售后单类型 1标准电商 6配送订单
   */
  saleOrderType?:
    | 'STANDARD'
    | 'WRITEE_OFF'
    | 'WRITE_OFF_PAY'
    | 'JOINT'
    | 'TRAVEL'
    | 'DELIVER'
    | 'DELIVER_PAY'
}

/**
 * 接口 [4、退款、售后列表查询↗](https://yapi.gogpay.cn/project/916/interface/api/28805) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/list`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品封面图
     */
    commodityCoverPic?: string
    /**
     * 商品规格
     */
    commoditySpecs?: string
    /**
     * 商品名称
     */
    commodityTitle?: string
    /**
     * 状态文案
     */
    description?: string
    /**
     * 服务单号
     */
    id?: string
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 商品退款总金额
     */
    refundAmount?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 商品售价
     */
    unitPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [4、退款、售后列表查询↗](https://yapi.gogpay.cn/project/916/interface/api/28805) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/list`
 */
type ApiSaleAfterStandardEcommerceSaleAfterListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [4、退款、售后列表查询↗](https://yapi.gogpay.cn/project/916/interface/api/28805) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/list`
 */
const apiSaleAfterStandardEcommerceSaleAfterListRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '4、退款、售后列表查询', author: '史博文' },
  }

/**
 * 接口 [4、退款、售后列表查询↗](https://yapi.gogpay.cn/project/916/interface/api/28805) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/list`
 */
export const apiSaleAfterStandardEcommerceSaleAfterList = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterListResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterList.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterListRequestConfig

/**
 * 接口 [3、商家同意退货后填写或修改快递单号↗](https://yapi.gogpay.cn/project/916/interface/api/28809) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequest {
  /**
   * 买家寄回物流快递单号
   */
  buyerLogisticsWaybillNo: string
  /**
   * 售后id
   */
  id: string
  /**
   * 买家寄回物流快递单号对应快递公司编码
   */
  shipperCode: string
  /**
   * 买家寄回物流快递单号对应快递公司名称
   */
  shipperName: string
}

/**
 * 接口 [3、商家同意退货后填写或修改快递单号↗](https://yapi.gogpay.cn/project/916/interface/api/28809) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [3、商家同意退货后填写或修改快递单号↗](https://yapi.gogpay.cn/project/916/interface/api/28809) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo`
 */
type ApiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [3、商家同意退货后填写或修改快递单号↗](https://yapi.gogpay.cn/project/916/interface/api/28809) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo`
 */
const apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '3、商家同意退货后填写或修改快递单号',
      author: '史博文',
    },
  }

/**
 * 接口 [3、商家同意退货后填写或修改快递单号↗](https://yapi.gogpay.cn/project/916/interface/api/28809) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/saveWaybillNo`
 */
export const apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNo =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNo.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNoRequestConfig

/**
 * 接口 [1、发起售后申请或重新申请（仅退款、退款退货、换货）↗](https://yapi.gogpay.cn/project/916/interface/api/29149) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/apply`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyRequest {
  /**
   * 买家申请原因
   */
  applyReason?: string
  /**
   * 买家申请补充描述
   */
  applyReasonAddDescription?: string
  /**
   * 买家申请补充凭证, 最多6张 如："applyReasonAddPic":["https://resource.gogpay.cn/file/5800ab3726b14f789a9aa49159ea3925","https://resource.gogpay.cn/file/6a3291c15a5a4bf6bacfc1f068e22ec1"]
   */
  applyReasonAddPic?: string
  /**
   * 售后id，商家拒绝时重新申请时需要
   */
  id?: string
  pickupAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 数量
   */
  quantity?: number
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * 退款金额 单位:元
   */
  refundAmount?: string
  /**
   * 退货方式 1:自行寄回 2:上门取件
   */
  returnCommodityType?: number
  /**
   * 货物状态 1：暂无物流信息 2：未签收 3：已签收
   */
  returnLogisticsWaybillStatus?: number
  /**
   * 发起售后类型 1:仅退款 2:退款退货;3:退换货
   */
  saleAfterType: number
  /**
   * skuId
   */
  skuId?: string
}

/**
 * 接口 [1、发起售后申请或重新申请（仅退款、退款退货、换货）↗](https://yapi.gogpay.cn/project/916/interface/api/29149) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/apply`
 */
export type ApiSaleAfterStandardEcommerceSaleAfterApplyResponse = string

/**
 * 接口 [1、发起售后申请或重新申请（仅退款、退款退货、换货）↗](https://yapi.gogpay.cn/project/916/interface/api/29149) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/apply`
 */
type ApiSaleAfterStandardEcommerceSaleAfterApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/apply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [1、发起售后申请或重新申请（仅退款、退款退货、换货）↗](https://yapi.gogpay.cn/project/916/interface/api/29149) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/apply`
 */
const apiSaleAfterStandardEcommerceSaleAfterApplyRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/apply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '1、发起售后申请或重新申请（仅退款、退款退货、换货）',
      author: '史博文',
    },
  }

/**
 * 接口 [1、发起售后申请或重新申请（仅退款、退款退货、换货）↗](https://yapi.gogpay.cn/project/916/interface/api/29149) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/apply`
 */
export const apiSaleAfterStandardEcommerceSaleAfterApply = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterApplyResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterApplyRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterApply.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterApplyRequestConfig

/**
 * 接口 [5、申请客服介入↗](https://yapi.gogpay.cn/project/916/interface/api/30165) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyCustomerService`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [5、申请客服介入↗](https://yapi.gogpay.cn/project/916/interface/api/30165) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyCustomerService`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [5、申请客服介入↗](https://yapi.gogpay.cn/project/916/interface/api/30165) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyCustomerService`
 */
type ApiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/applyCustomerService',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [5、申请客服介入↗](https://yapi.gogpay.cn/project/916/interface/api/30165) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyCustomerService`
 */
const apiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/applyCustomerService',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterApplyCustomerService',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '5、申请客服介入', author: '史博文' },
  }

/**
 * 接口 [5、申请客服介入↗](https://yapi.gogpay.cn/project/916/interface/api/30165) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyCustomerService`
 */
export const apiSaleAfterStandardEcommerceSaleAfterApplyCustomerService =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterApplyCustomerService.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterApplyCustomerServiceRequestConfig

/**
 * 接口 [6、申请延长收货↗](https://yapi.gogpay.cn/project/916/interface/api/30169) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [6、申请延长收货↗](https://yapi.gogpay.cn/project/916/interface/api/30169) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [6、申请延长收货↗](https://yapi.gogpay.cn/project/916/interface/api/30169) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive`
 */
type ApiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [6、申请延长收货↗](https://yapi.gogpay.cn/project/916/interface/api/30169) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive`
 */
const apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceive',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '6、申请延长收货', author: '史博文' },
  }

/**
 * 接口 [6、申请延长收货↗](https://yapi.gogpay.cn/project/916/interface/api/30169) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyDelayReceive`
 */
export const apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceive =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceive.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceiveRequestConfig

/**
 * 接口 [7、确认收货↗](https://yapi.gogpay.cn/project/916/interface/api/30221) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/confirmReceive`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [7、确认收货↗](https://yapi.gogpay.cn/project/916/interface/api/30221) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/confirmReceive`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterConfirmReceiveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [7、确认收货↗](https://yapi.gogpay.cn/project/916/interface/api/30221) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/confirmReceive`
 */
type ApiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/confirmReceive',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [7、确认收货↗](https://yapi.gogpay.cn/project/916/interface/api/30221) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/confirmReceive`
 */
const apiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/confirmReceive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterConfirmReceive',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '7、确认收货', author: '史博文' },
  }

/**
 * 接口 [7、确认收货↗](https://yapi.gogpay.cn/project/916/interface/api/30221) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/confirmReceive`
 */
export const apiSaleAfterStandardEcommerceSaleAfterConfirmReceive =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterConfirmReceiveResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterConfirmReceive.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterConfirmReceiveRequestConfig

/**
 * 接口 [8、撤销申请↗](https://yapi.gogpay.cn/project/916/interface/api/30229) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/revoke`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterRevokeRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [8、撤销申请↗](https://yapi.gogpay.cn/project/916/interface/api/30229) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/revoke`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterRevokeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [8、撤销申请↗](https://yapi.gogpay.cn/project/916/interface/api/30229) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/revoke`
 */
type ApiSaleAfterStandardEcommerceSaleAfterRevokeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/revoke',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [8、撤销申请↗](https://yapi.gogpay.cn/project/916/interface/api/30229) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/revoke`
 */
const apiSaleAfterStandardEcommerceSaleAfterRevokeRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterRevokeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/revoke',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterRevoke',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '8、撤销申请', author: '史博文' },
  }

/**
 * 接口 [8、撤销申请↗](https://yapi.gogpay.cn/project/916/interface/api/30229) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/revoke`
 */
export const apiSaleAfterStandardEcommerceSaleAfterRevoke = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterRevokeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterRevokeResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterRevokeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterRevoke.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterRevokeRequestConfig

/**
 * 接口 [10、标准电商状态机可选项↗](https://yapi.gogpay.cn/project/916/interface/api/30325) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getOptions`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetOptionsRequest {
  /**
   * 可选项类型：1：买家【未付款】取消订单原因；2：买家【已付款未发货】申请仅退款原因；3：买家【未收到货】申请仅退款原因；4：买家【已收到货】发起退货退款原因；5：买家【已收到货】发起仅退款原因；6：买家【已收到货】申请换货原因：
   */
  type?: number
}

/**
 * 接口 [10、标准电商状态机可选项↗](https://yapi.gogpay.cn/project/916/interface/api/30325) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getOptions`
 */
export type ApiSaleAfterStandardEcommerceSaleAfterGetOptionsResponse = string[]

/**
 * 接口 [10、标准电商状态机可选项↗](https://yapi.gogpay.cn/project/916/interface/api/30325) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getOptions`
 */
type ApiSaleAfterStandardEcommerceSaleAfterGetOptionsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/getOptions',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [10、标准电商状态机可选项↗](https://yapi.gogpay.cn/project/916/interface/api/30325) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getOptions`
 */
const apiSaleAfterStandardEcommerceSaleAfterGetOptionsRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterGetOptionsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/getOptions',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterGetOptions',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '10、标准电商状态机可选项', author: '史博文' },
  }

/**
 * 接口 [10、标准电商状态机可选项↗](https://yapi.gogpay.cn/project/916/interface/api/30325) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getOptions`
 */
export const apiSaleAfterStandardEcommerceSaleAfterGetOptions = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterGetOptionsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterGetOptionsResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterGetOptionsRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterGetOptions.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterGetOptionsRequestConfig

/**
 * 接口 [11、图片上传↗](https://yapi.gogpay.cn/project/916/interface/api/30329) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/uploadPic`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterUploadPicRequest {
  /**
   * file
   */
  file?: FileData
}

/**
 * 接口 [11、图片上传↗](https://yapi.gogpay.cn/project/916/interface/api/30329) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/uploadPic`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterUploadPicResponse {}

/**
 * 接口 [11、图片上传↗](https://yapi.gogpay.cn/project/916/interface/api/30329) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/uploadPic`
 */
type ApiSaleAfterStandardEcommerceSaleAfterUploadPicRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/uploadPic',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [11、图片上传↗](https://yapi.gogpay.cn/project/916/interface/api/30329) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/uploadPic`
 */
const apiSaleAfterStandardEcommerceSaleAfterUploadPicRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterUploadPicRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/uploadPic',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterUploadPic',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '11、图片上传', author: '史博文' },
  }

/**
 * 接口 [11、图片上传↗](https://yapi.gogpay.cn/project/916/interface/api/30329) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/uploadPic`
 */
export const apiSaleAfterStandardEcommerceSaleAfterUploadPic = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterUploadPicRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterUploadPicResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterUploadPicRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterUploadPic.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterUploadPicRequestConfig

/**
 * 接口 [12、查询物流↗](https://yapi.gogpay.cn/project/916/interface/api/31661) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [12、查询物流↗](https://yapi.gogpay.cn/project/916/interface/api/31661) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryResponse {
  eBusinessId?: string
  location?: string
  logisticCode?: string
  orderCode?: string
  orderNo?: string
  reason?: string
  shipperCode?: string
  shipperName?: string
  state?: string
  stateEx?: string
  success?: boolean
  traces?: {
    acceptStation?: string
    acceptTime?: string
    action?: string
    location?: string
    remark?: string
  }[]
}

/**
 * 接口 [12、查询物流↗](https://yapi.gogpay.cn/project/916/interface/api/31661) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery`
 */
type ApiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [12、查询物流↗](https://yapi.gogpay.cn/project/916/interface/api/31661) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery`
 */
const apiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterImmediatelyQuery',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '12、查询物流', author: '史博文' },
  }

/**
 * 接口 [12、查询物流↗](https://yapi.gogpay.cn/project/916/interface/api/31661) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/immediatelyQuery`
 */
export const apiSaleAfterStandardEcommerceSaleAfterImmediatelyQuery =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterImmediatelyQuery.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterImmediatelyQueryRequestConfig

/**
 * 接口 [13、获取可延长收货时间毫秒↗](https://yapi.gogpay.cn/project/916/interface/api/31701) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getDelayTime`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [13、获取可延长收货时间毫秒↗](https://yapi.gogpay.cn/project/916/interface/api/31701) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getDelayTime`
 */
export type ApiSaleAfterStandardEcommerceSaleAfterGetDelayTimeResponse = number

/**
 * 接口 [13、获取可延长收货时间毫秒↗](https://yapi.gogpay.cn/project/916/interface/api/31701) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getDelayTime`
 */
type ApiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/getDelayTime',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [13、获取可延长收货时间毫秒↗](https://yapi.gogpay.cn/project/916/interface/api/31701) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getDelayTime`
 */
const apiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/getDelayTime',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterGetDelayTime',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '13、获取可延长收货时间毫秒', author: '史博文' },
  }

/**
 * 接口 [13、获取可延长收货时间毫秒↗](https://yapi.gogpay.cn/project/916/interface/api/31701) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getDelayTime`
 */
export const apiSaleAfterStandardEcommerceSaleAfterGetDelayTime =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterGetDelayTimeResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterGetDelayTime.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterGetDelayTimeRequestConfig

/**
 * 接口 [9、获取可申请的退款金额上限，可申请的数量上限↗](https://yapi.gogpay.cn/project/916/interface/api/31937) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequest {
  /**
   * 申请数量
   */
  quantity: number
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [9、获取可申请的退款金额上限，可申请的数量上限↗](https://yapi.gogpay.cn/project/916/interface/api/31937) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitResponse {
  /**
   * 可申请退款数量
   */
  quantity?: number
  /**
   * 可申请退款总价（元）
   */
  refundAmount?: number
}

/**
 * 接口 [9、获取可申请的退款金额上限，可申请的数量上限↗](https://yapi.gogpay.cn/project/916/interface/api/31937) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit`
 */
type ApiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [9、获取可申请的退款金额上限，可申请的数量上限↗](https://yapi.gogpay.cn/project/916/interface/api/31937) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit`
 */
const apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimit',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '9、获取可申请的退款金额上限，可申请的数量上限',
      author: '史博文',
    },
  }

/**
 * 接口 [9、获取可申请的退款金额上限，可申请的数量上限↗](https://yapi.gogpay.cn/project/916/interface/api/31937) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getRefundAmountAndQuantityLimit`
 */
export const apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimit =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimit.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimitRequestConfig

/**
 * 接口 [2、查看售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/34341) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/findById`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterFindByIdRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [2、查看售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/34341) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/findById`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterFindByIdResponse {
  /**
   * 是否展示客服介入按钮：0否1是
   */
  applyCustomerServiceShowFlag?: number
  /**
   * 凭证图片
   */
  applyPic?: string[]
  /**
   * 退款原因
   */
  applyReason?: string
  /**
   * 补充说明
   */
  applyReasonAddDescription?: string
  /**
   * 商品封面
   */
  commodityCoverPic?: string
  /**
   * 商品id
   */
  commodityId?: string
  /**
   * 商品规格
   */
  commoditySpecs?: string
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品主标题
   */
  commodityTitle?: string
  /**
   * 是否展示确认收货按钮：0否1是
   */
  confirmShowFlag?: number
  /**
   * 是否隐藏联系客服按钮：0否1是
   */
  contactCustomerHiddenFlag?: number
  /**
   * 申请时间
   */
  createTime?: string
  /**
   * 客服介入状态 1：客服未介入 2：客服介入中 3：客服介入结束
   */
  customerServiceInterveneStatus?: number
  /**
   * 客服仲裁理由
   */
  customerServiceVerdictReason?: string
  /**
   * 是否展示延长收货按钮：0否1是
   */
  delayShowFlag?: number
  /**
   * 是否隐藏售后详情区域：0否1是
   */
  detailHiddenFlag?: number
  /**
   * 售后详情标题，如：换货信息
   */
  detailTitle?: string
  /**
   * 换货运单号 如：换货运单号：123
   */
  exchangeWaybillNo?: string
  /**
   * 是否显示换货运单号：0否1是
   */
  exchangeWaybillNoShowFlag?: number
  expressInfo?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }
  /**
   * 是否展示物流详情区域：0否1是
   */
  expressInfoShowFlag?: number
  /**
   * 服务单号
   */
  id?: string
  /**
   * 商户id
   */
  merchantId?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 是否隐藏商户联系方式 0否1是
   */
  merchantTelHiddenFlag?: number
  originalSku?: {
    channelDiscountInfo?: {
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 活动Id
       */
      id?: string
      /**
       * 积分
       */
      point?: number
    }
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 分润金额
     */
    distributionProfitAmount?: number
    /**
     * 分润比例 十位数，12%
     */
    distributionProfitRatio?: number
    /**
     * 是否关闭换货申请 0否1是
     */
    exchangeCloseFlag?: number
    /**
     * 发货时间
     */
    logisticsBeginTime?: string
    /**
     * 快递公司名称
     */
    logisticsCompanyName?: string
    /**
     * 快递公司编码
     */
    logisticsCompanyNo?: string
    /**
     * 物流订单号
     */
    logisticsOrderNo?: string
    /**
     * 物流运单号
     */
    logisticsWaybillNo?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 是否关闭退货退款申请 0否1是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0否1是
     */
    refundOnlyCloseFlag?: number
    /**
     * 是否支持换货 0不支持 1支持
     */
    replaceStatus?: number
    /**
     * 退款金额
     */
    returnAmount?: number
    sellerRefundAddress?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 是否支持7天无理由 0不支持 1支持
     */
    sevenDaysStatus?: number
    /**
     * 商品发货状态
     */
    shipingStatus?: number
    /**
     * 发货方式
     */
    shippingType?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * 规格描述
     */
    skuSpecs?: string
    /**
     * 总价
     */
    totalPrice?: number
    /**
     * 单价
     */
    unitPrice?: number
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }
  /**
   * 多彩宝订单中心支付流水号
   */
  paySerialNo?: string
  pickupAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 平台联系方式
   */
  platformTel?: string
  /**
   * 是否隐藏平台联系方式 0否1是
   */
  platformTelHiddenFlag?: number
  /**
   * 申请件数
   */
  quantity?: number
  /**
   * 是否展示重新申请按钮：0否1是
   */
  reapplyShowFlag?: number
  /**
   * 订单编号
   */
  refOrderNo?: string
  /**
   * 退货回寄地址
   */
  refundAddress?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 是否展示退货地址区域：0否1是
   */
  returnAddressShowFlag?: number
  /**
   * 退货方式：1自行寄回 2上门取件
   */
  returnCommodityType?: number
  /**
   * 货物状态
   */
  returnLogisticsWaybillStatus?: number
  /**
   * 是否展示撤销申请按钮：0否1是
   */
  revokeShowFlag?: number
  /**
   * 售后状态：1:待商家同意售后申请,3:商家同意仅退款申请,4:商家同意退货退款申请，待买家寄回货物,5:商家同意换货申请，待买家寄回货物,6:买家已退货，待商家确认收货,7:商家验收不通过拒绝收货，待买家处理,8:待商家发出换货,9:售后关闭,10:售后完成，11:商家发出换货，待买家收货，12:商家已确认收货，待商家退款
   */
  saleAfterStatus?: number
  /**
   * 售后类型
   */
  saleAfterType?: string
  /**
   * skuId
   */
  skuId?: string
  /**
   * 副标题 如:还剩9天7时4分,商家逾期未处理将自动统一
   */
  subTitle?: string
  /**
   * 是否隐藏副标题：0否1是
   */
  subtitleHiddenFlag?: number
  /**
   * 客服电话
   */
  tel?: string
  /**
   * 时间轴
   */
  timeFlow?: {
    /**
     * 激活状态 0否1是
     */
    activeFlag?: number
    /**
     * 排序值 升序
     */
    sort?: number
    /**
     * 子标题
     */
    subTitle?: string
    /**
     * 发生时间
     */
    time?: string
    /**
     * 流程名称
     */
    title?: string
  }[]
  /**
   * 是否展示时间轴json区域：0否1是
   */
  timeFlowShowFlag?: number
  /**
   * 超时时间 yyyy-MM-dd HH:mm:ss
   */
  timeoutTime?: number
  /**
   * 主标题 如:已提交退货申请,等待商家处理中
   */
  title?: string
  /**
   * 是否隐藏主标题：0否1是
   */
  titleHiddenFlag?: number
  /**
   * 是否显示修改运单号：0否1是
   */
  updateWaybillNoShowFlag?: number
  /**
   * 是否显示自提地址
   */
  pickupAddressShowFlag?: boolean
}

/**
 * 接口 [2、查看售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/34341) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/findById`
 */
type ApiSaleAfterStandardEcommerceSaleAfterFindByIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/findById',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [2、查看售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/34341) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/findById`
 */
const apiSaleAfterStandardEcommerceSaleAfterFindByIdRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterFindByIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/findById',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterFindById',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '2、查看售后详情', author: '史博文' },
  }

/**
 * 接口 [2、查看售后详情↗](https://yapi.gogpay.cn/project/916/interface/api/34341) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/findById`
 */
export const apiSaleAfterStandardEcommerceSaleAfterFindById = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterFindByIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterFindByIdResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterFindByIdRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterFindById.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterFindByIdRequestConfig

/**
 * 接口 [16、是否展示单SKU拆包提示↗](https://yapi.gogpay.cn/project/916/interface/api/34401) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getPrompt`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetPromptRequest {
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [16、是否展示单SKU拆包提示↗](https://yapi.gogpay.cn/project/916/interface/api/34401) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getPrompt`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetPromptResponse {
  /**
   * 警告文本
   */
  promptDetail?: string
  /**
   * 是否展示警告 0否1是
   */
  promptShowFlag?: number
}

/**
 * 接口 [16、是否展示单SKU拆包提示↗](https://yapi.gogpay.cn/project/916/interface/api/34401) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getPrompt`
 */
type ApiSaleAfterStandardEcommerceSaleAfterGetPromptRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/getPrompt',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [16、是否展示单SKU拆包提示↗](https://yapi.gogpay.cn/project/916/interface/api/34401) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getPrompt`
 */
const apiSaleAfterStandardEcommerceSaleAfterGetPromptRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterGetPromptRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/getPrompt',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterGetPrompt',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '16、是否展示单SKU拆包提示', author: '史博文' },
  }

/**
 * 接口 [16、是否展示单SKU拆包提示↗](https://yapi.gogpay.cn/project/916/interface/api/34401) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getPrompt`
 */
export const apiSaleAfterStandardEcommerceSaleAfterGetPrompt = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterGetPromptRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterGetPromptResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterGetPromptRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterGetPrompt.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterGetPromptRequestConfig

/**
 * 接口 [15、获取处理记录↗](https://yapi.gogpay.cn/project/916/interface/api/34409) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getSolveRecord`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequest {
  /**
   * 售后id
   */
  id: string
}

/**
 * 接口 [15、获取处理记录↗](https://yapi.gogpay.cn/project/916/interface/api/34409) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getSolveRecord`
 */
export type ApiSaleAfterStandardEcommerceSaleAfterGetSolveRecordResponse = {
  /**
   * 激活状态 0否1是
   */
  activeFlag?: number
  /**
   * 行为主体
   */
  createBy?: string
  /**
   * 内容描述
   */
  description?: string
  /**
   * 排序值 升序
   */
  sort?: number
  /**
   * 发生时间
   */
  time?: string
  /**
   * 节点标题
   */
  title?: string
}[]

/**
 * 接口 [15、获取处理记录↗](https://yapi.gogpay.cn/project/916/interface/api/34409) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getSolveRecord`
 */
type ApiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/getSolveRecord',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [15、获取处理记录↗](https://yapi.gogpay.cn/project/916/interface/api/34409) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getSolveRecord`
 */
const apiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/getSolveRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterGetSolveRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '15、获取处理记录', author: '史博文' },
  }

/**
 * 接口 [15、获取处理记录↗](https://yapi.gogpay.cn/project/916/interface/api/34409) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getSolveRecord`
 */
export const apiSaleAfterStandardEcommerceSaleAfterGetSolveRecord =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterGetSolveRecordResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterGetSolveRecord.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterGetSolveRecordRequestConfig

/**
 * 接口 [17、获取支持的售后类型↗](https://yapi.gogpay.cn/project/916/interface/api/34953) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequest {
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [17、获取支持的售后类型↗](https://yapi.gogpay.cn/project/916/interface/api/34953) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeResponse {
  /**
   * 是否关闭换货申请 0否1是
   */
  exchangeCloseFlag?: number
  /**
   * 寄回方式是否支持上门取件
   */
  pickup?: boolean
  /**
   * 是否关闭退货退款申请 0否1是
   */
  refundAndReturnCloseFlag?: number
  /**
   * 是否关闭仅退款申请 0否1是
   */
  refundOnlyCloseFlag?: number
  /**
   * 寄回方式是否支持自行寄件
   */
  selfDeliver?: boolean
}

/**
 * 接口 [17、获取支持的售后类型↗](https://yapi.gogpay.cn/project/916/interface/api/34953) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType`
 */
type ApiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [17、获取支持的售后类型↗](https://yapi.gogpay.cn/project/916/interface/api/34953) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType`
 */
const apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterType',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '17、获取支持的售后类型', author: '史博文' },
  }

/**
 * 接口 [17、获取支持的售后类型↗](https://yapi.gogpay.cn/project/916/interface/api/34953) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/getAvailableSaleAfterType`
 */
export const apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterType =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterType.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterTypeRequestConfig

/**
 * 接口 [19、大订单查询查询↗](https://yapi.gogpay.cn/project/916/interface/api/460353) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/bigOrderList`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterBigOrderListRequest {
  /**
   * 起始时间
   */
  beginTime?: string
  /**
   * 运营渠道
   */
  businessChannels?: string[]
  clientType?: '1' | '2' | '3' | '4'
  /**
   * 终止时间
   */
  endTime?: string
  headerChannel?: string[]
  /**
   * 订单号，商家名称，商品名
   */
  keyWord?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 售后ID
   */
  saleAfterId?: string
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口 [19、大订单查询查询↗](https://yapi.gogpay.cn/project/916/interface/api/460353) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/bigOrderList`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterBigOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 券码有效期
     */
    expireTime?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 状态 1退款中  2退款失败  3退款成功
     */
    saleAfterStatus?: number
    /**
     * 状态文案
     */
    saleAfterStatusName?: string
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型名称
     */
    saleAfterTypeName?: string
    /**
     * 商品售价
     */
    unitPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [19、大订单查询查询↗](https://yapi.gogpay.cn/project/916/interface/api/460353) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/bigOrderList`
 */
type ApiSaleAfterStandardEcommerceSaleAfterBigOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/bigOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [19、大订单查询查询↗](https://yapi.gogpay.cn/project/916/interface/api/460353) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/bigOrderList`
 */
const apiSaleAfterStandardEcommerceSaleAfterBigOrderListRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterBigOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/bigOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterBigOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '19、大订单查询查询', author: '511号开发' },
  }

/**
 * 接口 [19、大订单查询查询↗](https://yapi.gogpay.cn/project/916/interface/api/460353) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/bigOrderList`
 */
export const apiSaleAfterStandardEcommerceSaleAfterBigOrderList =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterBigOrderListRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterBigOrderListResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterBigOrderListRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterBigOrderList.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterBigOrderListRequestConfig

/**
 * 接口 [18、退款、售后订单下查询↗](https://yapi.gogpay.cn/project/916/interface/api/460358) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/listIn`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterListInRequest {
  /**
   * 订单编号集合
   */
  orderNoList: string[]
}

/**
 * 接口 [18、退款、售后订单下查询↗](https://yapi.gogpay.cn/project/916/interface/api/460358) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/listIn`
 */
export type ApiSaleAfterStandardEcommerceSaleAfterListInResponse = {
  /**
   * 订单号
   */
  orderId?: string
  /**
   * 售后sku数据（key-skuId value-数据）
   */
  skuSaleAfterInfoMap?: {}
}[]

/**
 * 接口 [18、退款、售后订单下查询↗](https://yapi.gogpay.cn/project/916/interface/api/460358) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/listIn`
 */
type ApiSaleAfterStandardEcommerceSaleAfterListInRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/listIn',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [18、退款、售后订单下查询↗](https://yapi.gogpay.cn/project/916/interface/api/460358) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/listIn`
 */
const apiSaleAfterStandardEcommerceSaleAfterListInRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterListInRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_4,
    devUrl: devUrl_0_8_0_4,
    prodUrl: prodUrl_0_8_0_4,
    path: '/saleAfter/api/standardEcommerceSaleAfter/listIn',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterListIn',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '18、退款、售后订单下查询', author: '511号开发' },
  }

/**
 * 接口 [18、退款、售后订单下查询↗](https://yapi.gogpay.cn/project/916/interface/api/460358) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端标准电商售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_7140)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/listIn`
 */
export const apiSaleAfterStandardEcommerceSaleAfterListIn = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterListInRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterListInResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterListInRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterListIn.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterListInRequestConfig

const mockUrl_0_8_0_6 = 'https://yapi.gogpay.cn/mock/916' as any
const devUrl_0_8_0_6 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_8_0_6 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_8_0_6 = 'data' as any

/**
 * 接口 [1、售后列表查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/460373) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/list`
 */
export interface ApiSaleAfterMerchantSaleAfterListRequest {
  /**
   * 店铺Id
   */
  merchantId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 售后类型1待处理 2处理中 3已处理 4平台介入
   */
  saleAfterStatus?: number
  /**
   * 售后Id
   */
  saleId?: string
}

/**
 * 接口 [1、售后列表查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/460373) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/list`
 */
export interface ApiSaleAfterMerchantSaleAfterListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 所属运营渠道
     */
    businessChannelName?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品售价
     */
    commodityPrice?: number
    /**
     * 售后申请时间
     */
    createTime?: string
    /**
     * 客服介入状态（1：未介入；2：介入中；3：客服介入结束）
     */
    customerServiceInterveneStatus?: number
    /**
     * 客服裁决理由
     */
    customerServiceVerdictReason?: string
    /**
     * 客服裁决状态（1：买家胜；2：卖家胜;3:买家胜并直接退款（仅换货））
     */
    customerServiceVerdictResultType?: number
    /**
     * 用户手机号
     */
    dcbUserPhone?: string
    /**
     * 处理期限
     */
    expireTime?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 实收金额
     */
    orderAmount?: number
    /**
     * 订单类型 1:标准电商订单 2:标准虚拟订单 3:标准核销  4组合订单  5旅游订单 6配送订单
     */
    orderType?: number
    /**
     * 支付流水号
     */
    paySerialNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 申请原因
     */
    reason?: string
    /**
     * 订单编号
     */
    refOrderNo?: string
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 退款比例
     */
    refundRate?: number
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeLabel?: string
    /**
     * 售后记录Id
     */
    saleId?: string
    /**
     * 订单类型
     */
    saleOrderTypeName?: string
    /**
     * 商品规格描述
     */
    skuSpec?: string
    /**
     * 状态 1退款中  2退款失败  3退款成功
     */
    status?: number
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 状态文案
     */
    statusName?: string
    /**
     * 所属店铺
     */
    storeName?: string
    /**
     * 处理倒计时
     */
    timeoutTime?: string
    /**
     * 处理倒计时描述
     */
    timeoutTimeDesc?: string
    /**
     * 核销渠道
     */
    writeOffChannel?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [1、售后列表查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/460373) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/list`
 */
type ApiSaleAfterMerchantSaleAfterListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/merchantSaleAfter/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [1、售后列表查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/460373) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/list`
 */
const apiSaleAfterMerchantSaleAfterListRequestConfig: ApiSaleAfterMerchantSaleAfterListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterMerchantSaleAfterList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '1、售后列表查询(标电、标销)', author: '511号开发' },
  }

/**
 * 接口 [1、售后列表查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/460373) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/list`
 */
export const apiSaleAfterMerchantSaleAfterList = /*#__PURE__*/ (
  requestData: ApiSaleAfterMerchantSaleAfterListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterMerchantSaleAfterListResponse>(
    prepare(apiSaleAfterMerchantSaleAfterListRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterMerchantSaleAfterList.requestConfig =
  apiSaleAfterMerchantSaleAfterListRequestConfig

/**
 * 接口 [同意退换货↗](https://yapi.gogpay.cn/project/916/interface/api/460418) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeExchange`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeExchangeRequest {
  /**
   * 商品退款金额信息（配送售后）
   */
  commodityRefundInfo?: {
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
  dcbUserId?: string
  /**
   * 售后id
   */
  id: string
  /**
   * 申请原因
   */
  reason?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 是否退邮费
   */
  refundPostFee?: boolean
  registerPhone?: string
}

/**
 * 接口 [同意退换货↗](https://yapi.gogpay.cn/project/916/interface/api/460418) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeExchange`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeExchangeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同意退换货↗](https://yapi.gogpay.cn/project/916/interface/api/460418) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeExchange`
 */
type ApiSaleAfterMerchantSaleAfterAgreeExchangeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/merchantSaleAfter/agreeExchange',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同意退换货↗](https://yapi.gogpay.cn/project/916/interface/api/460418) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeExchange`
 */
const apiSaleAfterMerchantSaleAfterAgreeExchangeRequestConfig: ApiSaleAfterMerchantSaleAfterAgreeExchangeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/agreeExchange',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterMerchantSaleAfterAgreeExchange',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同意退换货', author: '511号开发' },
  }

/**
 * 接口 [同意退换货↗](https://yapi.gogpay.cn/project/916/interface/api/460418) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeExchange`
 */
export const apiSaleAfterMerchantSaleAfterAgreeExchange = /*#__PURE__*/ (
  requestData: ApiSaleAfterMerchantSaleAfterAgreeExchangeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterMerchantSaleAfterAgreeExchangeResponse>(
    prepare(
      apiSaleAfterMerchantSaleAfterAgreeExchangeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterMerchantSaleAfterAgreeExchange.requestConfig =
  apiSaleAfterMerchantSaleAfterAgreeExchangeRequestConfig

/**
 * 接口 [同意收货或拒绝签收↗](https://yapi.gogpay.cn/project/916/interface/api/460423) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequest {
  dcbUserId?: string
  /**
   * 售后id
   */
  id?: string
  /**
   * 拒签理由
   */
  refuseReason?: string
  registerPhone?: string
  /**
   * 签收或拒签 1签收 2拒签
   */
  signForReceiveType?: number
}

/**
 * 接口 [同意收货或拒绝签收↗](https://yapi.gogpay.cn/project/916/interface/api/460423) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同意收货或拒绝签收↗](https://yapi.gogpay.cn/project/916/interface/api/460423) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive`
 */
type ApiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [同意收货或拒绝签收↗](https://yapi.gogpay.cn/project/916/interface/api/460423) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive`
 */
const apiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequestConfig: ApiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceive',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同意收货或拒绝签收', author: '511号开发' },
  }

/**
 * 接口 [同意收货或拒绝签收↗](https://yapi.gogpay.cn/project/916/interface/api/460423) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeOrRefuseSignForReceive`
 */
export const apiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceive =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveResponse>(
      prepare(
        apiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceive.requestConfig =
  apiSaleAfterMerchantSaleAfterAgreeOrRefuseSignForReceiveRequestConfig

/**
 * 接口 [同意退货且退款↗](https://yapi.gogpay.cn/project/916/interface/api/460428) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundAndReturn`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequest {
  /**
   * 商品退款金额信息（配送售后）
   */
  commodityRefundInfo?: {
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
  dcbUserId?: string
  /**
   * 售后id
   */
  id: string
  /**
   * 申请原因
   */
  reason?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 是否退邮费
   */
  refundPostFee?: boolean
  registerPhone?: string
}

/**
 * 接口 [同意退货且退款↗](https://yapi.gogpay.cn/project/916/interface/api/460428) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundAndReturn`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeRefundAndReturnResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同意退货且退款↗](https://yapi.gogpay.cn/project/916/interface/api/460428) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundAndReturn`
 */
type ApiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/merchantSaleAfter/agreeRefundAndReturn',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同意退货且退款↗](https://yapi.gogpay.cn/project/916/interface/api/460428) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundAndReturn`
 */
const apiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequestConfig: ApiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/agreeRefundAndReturn',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterMerchantSaleAfterAgreeRefundAndReturn',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同意退货且退款', author: '511号开发' },
  }

/**
 * 接口 [同意退货且退款↗](https://yapi.gogpay.cn/project/916/interface/api/460428) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundAndReturn`
 */
export const apiSaleAfterMerchantSaleAfterAgreeRefundAndReturn = /*#__PURE__*/ (
  requestData: ApiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterMerchantSaleAfterAgreeRefundAndReturnResponse>(
    prepare(
      apiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterMerchantSaleAfterAgreeRefundAndReturn.requestConfig =
  apiSaleAfterMerchantSaleAfterAgreeRefundAndReturnRequestConfig

/**
 * 接口 [同意仅退款↗](https://yapi.gogpay.cn/project/916/interface/api/460433) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundOnly`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequest {
  /**
   * 商品退款金额信息（配送售后）
   */
  commodityRefundInfo?: {
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
  dcbUserId?: string
  /**
   * 售后id
   */
  id: string
  /**
   * 申请原因
   */
  reason?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 是否退邮费
   */
  refundPostFee?: boolean
  registerPhone?: string
}

/**
 * 接口 [同意仅退款↗](https://yapi.gogpay.cn/project/916/interface/api/460433) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundOnly`
 */
export interface ApiSaleAfterMerchantSaleAfterAgreeRefundOnlyResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同意仅退款↗](https://yapi.gogpay.cn/project/916/interface/api/460433) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundOnly`
 */
type ApiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/merchantSaleAfter/agreeRefundOnly',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同意仅退款↗](https://yapi.gogpay.cn/project/916/interface/api/460433) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundOnly`
 */
const apiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequestConfig: ApiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/agreeRefundOnly',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterMerchantSaleAfterAgreeRefundOnly',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同意仅退款', author: '511号开发' },
  }

/**
 * 接口 [同意仅退款↗](https://yapi.gogpay.cn/project/916/interface/api/460433) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/agreeRefundOnly`
 */
export const apiSaleAfterMerchantSaleAfterAgreeRefundOnly = /*#__PURE__*/ (
  requestData: ApiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterMerchantSaleAfterAgreeRefundOnlyResponse>(
    prepare(
      apiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterMerchantSaleAfterAgreeRefundOnly.requestConfig =
  apiSaleAfterMerchantSaleAfterAgreeRefundOnlyRequestConfig

/**
 * 接口 [不同意售后↗](https://yapi.gogpay.cn/project/916/interface/api/460438) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/disAgree`
 */
export interface ApiSaleAfterMerchantSaleAfterDisAgreeRequest {
  dcbUserId?: string
  /**
   * 售后编号
   */
  id: string
  /**
   * 拒绝原因
   */
  refuseReason: string
  registerPhone?: string
}

/**
 * 接口 [不同意售后↗](https://yapi.gogpay.cn/project/916/interface/api/460438) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/disAgree`
 */
export interface ApiSaleAfterMerchantSaleAfterDisAgreeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [不同意售后↗](https://yapi.gogpay.cn/project/916/interface/api/460438) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/disAgree`
 */
type ApiSaleAfterMerchantSaleAfterDisAgreeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/merchantSaleAfter/disAgree',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [不同意售后↗](https://yapi.gogpay.cn/project/916/interface/api/460438) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/disAgree`
 */
const apiSaleAfterMerchantSaleAfterDisAgreeRequestConfig: ApiSaleAfterMerchantSaleAfterDisAgreeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/disAgree',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterMerchantSaleAfterDisAgree',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '不同意售后', author: '511号开发' },
  }

/**
 * 接口 [不同意售后↗](https://yapi.gogpay.cn/project/916/interface/api/460438) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/disAgree`
 */
export const apiSaleAfterMerchantSaleAfterDisAgree = /*#__PURE__*/ (
  requestData: ApiSaleAfterMerchantSaleAfterDisAgreeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterMerchantSaleAfterDisAgreeResponse>(
    prepare(apiSaleAfterMerchantSaleAfterDisAgreeRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterMerchantSaleAfterDisAgree.requestConfig =
  apiSaleAfterMerchantSaleAfterDisAgreeRequestConfig

/**
 * 接口 [填写换货运单号↗](https://yapi.gogpay.cn/project/916/interface/api/460443) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo`
 */
export interface ApiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequest {
  dcbUserId?: string
  /**
   * 售后编号
   */
  id: string
  registerPhone?: string
  /**
   * 回寄运单号
   */
  sellerLogisticsWaybillNo: string
}

/**
 * 接口 [填写换货运单号↗](https://yapi.gogpay.cn/project/916/interface/api/460443) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo`
 */
export interface ApiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoResponse {}

/**
 * 接口 [填写换货运单号↗](https://yapi.gogpay.cn/project/916/interface/api/460443) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo`
 */
type ApiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [填写换货运单号↗](https://yapi.gogpay.cn/project/916/interface/api/460443) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo`
 */
const apiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequestConfig: ApiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '填写换货运单号', author: '511号开发' },
  }

/**
 * 接口 [填写换货运单号↗](https://yapi.gogpay.cn/project/916/interface/api/460443) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/writeSellerLogisticsWaybillNo`
 */
export const apiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNo =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoResponse>(
      prepare(
        apiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNo.requestConfig =
  apiSaleAfterMerchantSaleAfterWriteSellerLogisticsWaybillNoRequestConfig

/**
 * 接口 [2、售后详情查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/461218) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/detail`
 */
export interface ApiSaleAfterMerchantSaleAfterDetailRequest {
  id?: string
}

/**
 * 接口 [2、售后详情查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/461218) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/detail`
 */
export interface ApiSaleAfterMerchantSaleAfterDetailResponse {
  /**
   * 时间轴
   */
  adminTimeFlow?: {
    /**
     * 激活状态 0否1是
     */
    activeFlag?: number
    /**
     * 行为主体
     */
    createBy?: string
    /**
     * 内容描述
     */
    description?: string
    /**
     * 排序值 升序
     */
    sort?: number
    /**
     * 发生时间
     */
    time?: string
    /**
     * 节点标题
     */
    title?: string
  }[]
  /**
   * 退款原因补充描述
   */
  applyReasonAddDescription?: string
  /**
   * 退款原因补充图片
   */
  applyReasonAddPic?: string[]
  /**
   * 商品图片
   */
  commodityCoverPic?: string
  /**
   * 商品退款信息
   */
  commodityRefundInfo?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品价格
     */
    commodityPrice?: number
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 售后金额
     */
    saleAfterAmount?: number
    /**
     * 规格信息
     */
    skuDesc?: string
    /**
     * 规格Id
     */
    skuId?: string
    /**
     * 剩余可退款金额
     */
    surplusPrice?: number
  }[]
  /**
   * 副标题
   */
  commoditySubTitle?: string
  /**
   * 主标题
   */
  commodityTitle?: string
  /**
   * 申请时间
   */
  createTime?: string
  /**
   * 多彩宝用户手机号
   */
  dcbUserPhone?: string
  /**
   * 退还积分
   */
  integralPoint?: number
  /**
   * 订单类型 1:标准电商订单 2:标准虚拟订单 3:标准核销  4组合订单  5旅游订单 6配送订单
   */
  orderType?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 退款原因
   */
  reason?: string
  /**
   * 售后订单编号
   */
  refOrderNo?: string
  /**
   * 退款金额
   */
  refundAmount?: number
  /**
   * 售后状态
   */
  saleAfterStatus?: number
  /**
   * 售后状态描述
   */
  saleAfterStatusLabel?: string
  /**
   * 售后类型（1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 售后类型描述
   */
  saleAfterTypeDesc?: string
  /**
   * 售后记录Id
   */
  saleId?: string
}

/**
 * 接口 [2、售后详情查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/461218) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/detail`
 */
type ApiSaleAfterMerchantSaleAfterDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/merchantSaleAfter/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [2、售后详情查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/461218) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/detail`
 */
const apiSaleAfterMerchantSaleAfterDetailRequestConfig: ApiSaleAfterMerchantSaleAfterDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_6,
    devUrl: devUrl_0_8_0_6,
    prodUrl: prodUrl_0_8_0_6,
    path: '/saleAfter/api/merchantSaleAfter/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterMerchantSaleAfterDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '2、售后详情查询(标电、标销)', author: '511号开发' },
  }

/**
 * 接口 [2、售后详情查询(标电、标销)↗](https://yapi.gogpay.cn/project/916/interface/api/461218) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端电商售后相关接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_80917)
 * @请求头 `POST /saleAfter/api/merchantSaleAfter/detail`
 */
export const apiSaleAfterMerchantSaleAfterDetail = /*#__PURE__*/ (
  requestData: ApiSaleAfterMerchantSaleAfterDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterMerchantSaleAfterDetailResponse>(
    prepare(apiSaleAfterMerchantSaleAfterDetailRequestConfig, requestData),
    ...args,
  )
}

apiSaleAfterMerchantSaleAfterDetail.requestConfig =
  apiSaleAfterMerchantSaleAfterDetailRequestConfig

const mockUrl_0_8_0_7 = 'https://yapi.gogpay.cn/mock/916' as any
const devUrl_0_8_0_7 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_8_0_7 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_8_0_7 = 'data' as any

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34437) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequest {
  /**
   * 数量
   */
  quantity?: number
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * 发起售后类型 1:仅退款 2:退款退货;3:退换货
   */
  saleAfterType: number
  /**
   * skuId
   */
  skuId?: string
  /**
   * 多彩宝用户id
   */
  userId?: string
  /**
   * 用户昵称
   */
  userName?: string
  /**
   * 运单号，换货必填
   */
  waybillNo?: string
}

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34437) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralResponse {}

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34437) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral`
 */
type ApiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34437) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral`
 */
const apiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_7,
    devUrl: devUrl_0_8_0_7,
    prodUrl: prodUrl_0_8_0_7,
    path: '/saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegral',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '2、边界发起售后', author: '史博文' },
  }

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34437) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/applyFromMaotaiIntegral`
 */
export const apiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegral =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegral.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterApplyFromMaotaiIntegralRequestConfig

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34441) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequest {
  /**
   * 售后id
   */
  id: string
  /**
   * 售后状态：1:待商家同意售后申请,3:商家同意仅退款申请,4:商家同意退货退款申请，待买家寄回货物,5:商家同意换货申请，待买家寄回货物,6:买家已退货，待商家确认收货,7:商家验收不通过拒绝收货，待买家处理,8:待商家发出换货,9:售后关闭,10:售后完成，11:商家发出换货，待买家收货，12:商家已确认收货，待商家退款
   */
  status: number
  /**
   * 第三方平台标识 苏宁:10
   */
  thirdPartyCode?: number
  /**
   * 运单号
   */
  wayBillNo?: string
}

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34441) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeResponse {}

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34441) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge`
 */
type ApiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34441) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge`
 */
const apiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_7,
    devUrl: devUrl_0_8_0_7,
    prodUrl: prodUrl_0_8_0_7,
    path: '/saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdge',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '1、边界同步售后状态', author: '史博文' },
  }

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34441) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/syncStatusFromEdge`
 */
export const apiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdge =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdge.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterSyncStatusFromEdgeRequestConfig

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34957) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/apply`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterOpenApplyRequest {
  /**
   * 申请原因
   */
  applyReasonAddDescription?: string
  /**
   * 数量
   */
  quantity?: number
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * 申请退款金额
   */
  refundAmt?: number
  /**
   * 仲裁备注
   */
  remark?: string
  /**
   * 发起售后类型 1:仅退款 2:退款退货;3:退换货
   */
  saleAfterType: number
  /**
   * skuId
   */
  skuId?: string
  /**
   * 多彩宝用户id
   */
  userId?: string
  /**
   * 用户昵称
   */
  userName?: string
  /**
   * 运单号，换货必填
   */
  waybillNo?: string
}

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34957) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/apply`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterOpenApplyResponse {}

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34957) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/apply`
 */
type ApiSaleAfterStandardEcommerceSaleAfterOpenApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/916',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/saleAfter/api/standardEcommerceSaleAfter/open/apply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34957) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/apply`
 */
const apiSaleAfterStandardEcommerceSaleAfterOpenApplyRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterOpenApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_7,
    devUrl: devUrl_0_8_0_7,
    prodUrl: prodUrl_0_8_0_7,
    path: '/saleAfter/api/standardEcommerceSaleAfter/open/apply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterOpenApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '2、边界发起售后', author: '史博文' },
  }

/**
 * 接口 [2、边界发起售后↗](https://yapi.gogpay.cn/project/916/interface/api/34957) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/apply`
 */
export const apiSaleAfterStandardEcommerceSaleAfterOpenApply = /*#__PURE__*/ (
  requestData: ApiSaleAfterStandardEcommerceSaleAfterOpenApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiSaleAfterStandardEcommerceSaleAfterOpenApplyResponse>(
    prepare(
      apiSaleAfterStandardEcommerceSaleAfterOpenApplyRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiSaleAfterStandardEcommerceSaleAfterOpenApply.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterOpenApplyRequestConfig

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34961) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/syncStatus`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequest {
  addressDTO?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 订单号
   */
  refOrderNo: string
  /**
   * 售后拒绝/拒签原因
   */
  refuseReason?: string
  /**
   * 售后状态：1:待商家同意售后申请,3:商家同意仅退款申请,4:商家同意退货退款申请，待买家寄回货物,5:商家同意换货申请，待买家寄回货物,6:买家已退货，待商家确认收货,7:商家验收不通过拒绝收货，待买家处理,8:待商家发出换货,9:售后关闭,10:售后完成，11:商家发出换货，待买家收货，12:商家已确认收货，待商家退款
   */
  saleAfterStatus: number
  /**
   * 商品skuId
   */
  skuId: string
  /**
   * 第三方平台标识 苏宁:10
   */
  thirdPartyCode: string
  /**
   * 状态变更时间
   */
  time: string
  /**
   * 商家寄出换货运单号,没有则不传
   */
  wayBillNo?: string
}

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34961) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/syncStatus`
 */
export interface ApiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusResponse {}

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34961) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/syncStatus`
 */
type ApiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/916',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/saleAfter/api/standardEcommerceSaleAfter/open/syncStatus',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34961) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/syncStatus`
 */
const apiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequestConfig: ApiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_8_0_7,
    devUrl: devUrl_0_8_0_7,
    prodUrl: prodUrl_0_8_0_7,
    path: '/saleAfter/api/standardEcommerceSaleAfter/open/syncStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_8_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiSaleAfterStandardEcommerceSaleAfterOpenSyncStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '1、边界同步售后状态', author: '史博文' },
  }

/**
 * 接口 [1、边界同步售后状态↗](https://yapi.gogpay.cn/project/916/interface/api/34961) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [标准电商边界售后接口↗](https://yapi.gogpay.cn/project/916/interface/api/cat_8850)
 * @请求头 `POST /saleAfter/api/standardEcommerceSaleAfter/open/syncStatus`
 */
export const apiSaleAfterStandardEcommerceSaleAfterOpenSyncStatus =
  /*#__PURE__*/ (
    requestData: ApiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusResponse>(
      prepare(
        apiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiSaleAfterStandardEcommerceSaleAfterOpenSyncStatus.requestConfig =
  apiSaleAfterStandardEcommerceSaleAfterOpenSyncStatusRequestConfig

const mockUrl_0_0_0_1 = 'https://yapi.gogpay.cn/mock/5563' as any
const devUrl_0_0_0_1 = '' as any
const prodUrl_0_0_0_1 = '' as any
const dataKey_0_0_0_1 = 'data' as any

/**
 * 接口 [延时回调通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497373) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/delayNotify`
 */
export interface ApiShopOpenV1OrderImsApiOrderDelayNotifyRequest {
  params?: string
}

/**
 * 接口 [延时回调通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497373) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/delayNotify`
 */
export interface ApiShopOpenV1OrderImsApiOrderDelayNotifyResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [延时回调通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497373) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/delayNotify`
 */
type ApiShopOpenV1OrderImsApiOrderDelayNotifyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/order/imsApi/order/delayNotify',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [延时回调通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497373) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/delayNotify`
 */
const apiShopOpenV1OrderImsApiOrderDelayNotifyRequestConfig: ApiShopOpenV1OrderImsApiOrderDelayNotifyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/shopOpen/v1/order/imsApi/order/delayNotify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OrderImsApiOrderDelayNotify',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '延时回调通知', author: '成龙' },
  }

/**
 * 接口 [延时回调通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497373) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/delayNotify`
 */
export const apiShopOpenV1OrderImsApiOrderDelayNotify = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OrderImsApiOrderDelayNotifyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OrderImsApiOrderDelayNotifyResponse>(
    prepare(apiShopOpenV1OrderImsApiOrderDelayNotifyRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OrderImsApiOrderDelayNotify.requestConfig =
  apiShopOpenV1OrderImsApiOrderDelayNotifyRequestConfig

/**
 * 接口 [查询订单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497374) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/detail`
 */
export interface ApiShopOpenV1OrderImsApiOrderDetailRequest {
  /**
   * 请求来源
   */
  adminSource?: number
  /**
   * 订单编号
   */
  orderNo?: string
}

/**
 * 接口 [查询订单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497374) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/detail`
 */
export interface ApiShopOpenV1OrderImsApiOrderDetailResponse {
  buyer?: {
    /**
     * 收货地址
     */
    address?: string
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  commodities?: {
    /**
     * 商品合同报价名称
     */
    commodityContractTitle?: string
    /**
     * 商品 Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 价格
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * sku Id
     */
    skuId?: string
    /**
     * 单价
     */
    unitPrice?: number
  }
  /**
   * 商户 Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  orderInfo?: {
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 成交时间，格式 yyyy-MM-dd HH:mm:ss
     */
    dealTime?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付渠道
     */
    payChannel?: string
    /**
     * 支付时间，格式 yyyy-MM-dd HH:mm:ss
     */
    payTime?: string
    /**
     * 状态变更原因
     */
    reason?: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 交易状态
     */
    tradeStatus?: number
    /**
     * 交易状态文案
     */
    tradeStatusName?: string
  }
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单轨迹
   */
  orderTimeLine?: {
    /**
     * 轨迹内容
     */
    content?: string
    /**
     * 轨迹时间
     */
    time?: string
  }[]
  payInfo?: {
    /**
     * 支付金额
     */
    amount?: number
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付渠道
     */
    payChannel?: string
    /**
     * 支付内容
     */
    payContent?: string
    /**
     * 支付场景
     */
    payScenario?: string
    /**
     * 支付流水号
     */
    paySerialNo?: string
    /**
     * 支付状态
     */
    payStatus?: string
    /**
     * 支付时间
     */
    payTime?: string
  }
  /**
   * 门店编号
   */
  unitOrgCode?: string
}

/**
 * 接口 [查询订单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497374) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/detail`
 */
type ApiShopOpenV1OrderImsApiOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/order/imsApi/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询订单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497374) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/detail`
 */
const apiShopOpenV1OrderImsApiOrderDetailRequestConfig: ApiShopOpenV1OrderImsApiOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/shopOpen/v1/order/imsApi/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OrderImsApiOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询订单详情', author: '成龙' },
  }

/**
 * 接口 [查询订单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497374) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/detail`
 */
export const apiShopOpenV1OrderImsApiOrderDetail = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OrderImsApiOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OrderImsApiOrderDetailResponse>(
    prepare(apiShopOpenV1OrderImsApiOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OrderImsApiOrderDetail.requestConfig =
  apiShopOpenV1OrderImsApiOrderDetailRequestConfig

/**
 * 接口 [查询所有订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497375) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/list`
 */
export interface ApiShopOpenV1OrderImsApiOrderListRequest {
  /**
   * 下单起始时间,格式 yyyy-MM-dd HH:mm:ss
   */
  beginTime?: string
  /**
   * 商品 Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 下单结束时间,格式 yyyy-MM-dd HH:mm:ss
   */
  endTime?: string
  /**
   * 商户 Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 分页页码
   */
  pageIndex?: number
  /**
   * 分页页容量
   */
  pageSize?: number
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 订单交易状态
   */
  tradeStatus?: number[]
}

/**
 * 接口 [查询所有订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497375) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/list`
 */
export interface ApiShopOpenV1OrderImsApiOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 实收款
     */
    actualReceivable?: number
    commodities?: {
      /**
       * 商品合同报价名称
       */
      commodityContractTitle?: string
      /**
       * 商品 Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * sku Id
       */
      skuId?: string
      /**
       * 单价
       */
      unitPrice?: number
    }
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 商户 Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 交易状态
     */
    tradeStatus?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 商户机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询所有订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497375) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/list`
 */
type ApiShopOpenV1OrderImsApiOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/order/imsApi/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询所有订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497375) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/list`
 */
const apiShopOpenV1OrderImsApiOrderListRequestConfig: ApiShopOpenV1OrderImsApiOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/shopOpen/v1/order/imsApi/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OrderImsApiOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询所有订单列表', author: '成龙' },
  }

/**
 * 接口 [查询所有订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497375) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/list`
 */
export const apiShopOpenV1OrderImsApiOrderList = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OrderImsApiOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OrderImsApiOrderListResponse>(
    prepare(apiShopOpenV1OrderImsApiOrderListRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OrderImsApiOrderList.requestConfig =
  apiShopOpenV1OrderImsApiOrderListRequestConfig

/**
 * 接口 [发起退款↗](https://yapi.gogpay.cn/project/5563/interface/api/497376) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/refund`
 */
export interface ApiShopOpenV1OrderImsApiOrderRefundRequest {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 退款原因
   */
  reason?: string
}

/**
 * 接口 [发起退款↗](https://yapi.gogpay.cn/project/5563/interface/api/497376) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/refund`
 */
export interface ApiShopOpenV1OrderImsApiOrderRefundResponse {
  /**
   * 退款金额
   */
  refundAmount?: number
}

/**
 * 接口 [发起退款↗](https://yapi.gogpay.cn/project/5563/interface/api/497376) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/refund`
 */
type ApiShopOpenV1OrderImsApiOrderRefundRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/order/imsApi/order/refund',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发起退款↗](https://yapi.gogpay.cn/project/5563/interface/api/497376) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/refund`
 */
const apiShopOpenV1OrderImsApiOrderRefundRequestConfig: ApiShopOpenV1OrderImsApiOrderRefundRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/shopOpen/v1/order/imsApi/order/refund',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OrderImsApiOrderRefund',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发起退款', author: '成龙' },
  }

/**
 * 接口 [发起退款↗](https://yapi.gogpay.cn/project/5563/interface/api/497376) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/refund`
 */
export const apiShopOpenV1OrderImsApiOrderRefund = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OrderImsApiOrderRefundRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OrderImsApiOrderRefundResponse>(
    prepare(apiShopOpenV1OrderImsApiOrderRefundRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OrderImsApiOrderRefund.requestConfig =
  apiShopOpenV1OrderImsApiOrderRefundRequestConfig

/**
 * 接口 [获取支付参数↗](https://yapi.gogpay.cn/project/5563/interface/api/497377) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/trade`
 */
export interface ApiShopOpenV1OrderImsApiOrderTradeRequest {
  /**
   * 下单用户IP
   */
  clientIP?: string
  /**
   * 用户手机
   */
  phoneNo?: string
  /**
   * 购买数量
   */
  quantity?: number
  /**
   * 备注
   */
  remark?: string
  /**
   * 购买规格 ID
   */
  skuId?: string
}

/**
 * 接口 [获取支付参数↗](https://yapi.gogpay.cn/project/5563/interface/api/497377) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/trade`
 */
export interface ApiShopOpenV1OrderImsApiOrderTradeResponse {
  /**
   * 订单未支付自动关闭时间,格式 yyyy-MM-dd HH:mm:ss
   */
  closeTime?: string
  /**
   * 订单总价
   */
  orderAmount?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 支付数据,用于提交到多彩宝 APP 拉起支付
   */
  payData?: string
}

/**
 * 接口 [获取支付参数↗](https://yapi.gogpay.cn/project/5563/interface/api/497377) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/trade`
 */
type ApiShopOpenV1OrderImsApiOrderTradeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/order/imsApi/order/trade',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取支付参数↗](https://yapi.gogpay.cn/project/5563/interface/api/497377) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/trade`
 */
const apiShopOpenV1OrderImsApiOrderTradeRequestConfig: ApiShopOpenV1OrderImsApiOrderTradeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/shopOpen/v1/order/imsApi/order/trade',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OrderImsApiOrderTrade',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取支付参数', author: '成龙' },
  }

/**
 * 接口 [获取支付参数↗](https://yapi.gogpay.cn/project/5563/interface/api/497377) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/trade`
 */
export const apiShopOpenV1OrderImsApiOrderTrade = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OrderImsApiOrderTradeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OrderImsApiOrderTradeResponse>(
    prepare(apiShopOpenV1OrderImsApiOrderTradeRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OrderImsApiOrderTrade.requestConfig =
  apiShopOpenV1OrderImsApiOrderTradeRequestConfig

/**
 * 接口 [获取用户订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497378) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/userList`
 */
export interface ApiShopOpenV1OrderImsApiOrderUserListRequest {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 筛选状态 筛选状态 0 全部 1 待付款 2 待发货 3 待收货 4 待评价 5 已完成 6 待使用 7 待接单 8 待配送 9 配送中 10 售后中
   */
  status?: number
  /**
   * 下单手机号
   */
  userPhone?: string
}

/**
 * 接口 [获取用户订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497378) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/userList`
 */
export interface ApiShopOpenV1OrderImsApiOrderUserListResponse {
  /**
   * 数据列表
   */
  list?: {
    commodities?: {
      /**
       * 商品合同报价名称
       */
      commodityContractTitle?: string
      /**
       * 商品 Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * sku Id
       */
      skuId?: string
      /**
       * 单价
       */
      unitPrice?: number
    }
    /**
     * 商户 Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 订单金额（实付）
     */
    orderAmount?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 下单时间,格式 yyyy-MM-dd HH:mm:ss
     */
    orderTime?: string
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 售后状态 0 无售后 1 待商家处理 2 已完成 3 售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    /**
     * 订单状态
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 订单金额（应付）
     */
    totalAmount?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取用户订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497378) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/userList`
 */
type ApiShopOpenV1OrderImsApiOrderUserListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/order/imsApi/order/userList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497378) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/userList`
 */
const apiShopOpenV1OrderImsApiOrderUserListRequestConfig: ApiShopOpenV1OrderImsApiOrderUserListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: '/shopOpen/v1/order/imsApi/order/userList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OrderImsApiOrderUserList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户订单列表', author: '成龙' },
  }

/**
 * 接口 [获取用户订单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497378) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-controller↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86809)
 * @请求头 `POST /shopOpen/v1/order/imsApi/order/userList`
 */
export const apiShopOpenV1OrderImsApiOrderUserList = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OrderImsApiOrderUserListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OrderImsApiOrderUserListResponse>(
    prepare(apiShopOpenV1OrderImsApiOrderUserListRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OrderImsApiOrderUserList.requestConfig =
  apiShopOpenV1OrderImsApiOrderUserListRequestConfig

const mockUrl_0_0_0_2 = 'https://yapi.gogpay.cn/mock/5563' as any
const devUrl_0_0_0_2 = '' as any
const prodUrl_0_0_0_2 = '' as any
const dataKey_0_0_0_2 = 'data' as any

/**
 * 接口 [新增商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497343) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/add`
 */
export interface ApiShopOpenV1CommodityImsApiCommodityAddRequest {
  /**
   * 商品自动下架日期，格式 yyyy-MM-dd HH:mm:ss
   */
  autoDownDate?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品描述
   */
  commodityDescription?: string
  /**
   * 商品详情,HTML代码
   */
  commodityDetail?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商封面图
   */
  coverPic?: string
  /**
   * 划线价
   */
  dashPrice?: number
  /**
   * 操作类型 0-入库 1-上架
   */
  operationType?: number
  /**
   * 所属店铺 ID
   */
  refMerchantId?: string
  /**
   * 所属店铺名称
   */
  refMerchantName?: string
  standardCommodity?: {
    /**
     * 成本价，结算金额
     */
    commoditySkuCost?: number
    /**
     * SKU 价格
     */
    commoditySkuPrice?: number
    /**
     * sku 库存数量
     */
    commodityStock?: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow?: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases?: number
    /**
     * SKU ID
     */
    skuId?: string
    /**
     * 规格名称
     */
    skuName?: string
    /**
     * SKU 商品图
     */
    skuPic?: string
    /**
     * SKU 状态:0-无效 1-有效
     */
    skuStatus?: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases?: number
    /**
     * 用户限购量
     */
    userLimitPurchases?: number
  }
  /**
   * 所属店铺机构号
   */
  unitOrgCode?: string
  /**
   * 虚拟销量
   */
  virtualSales?: number
}

/**
 * 接口 [新增商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497343) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/add`
 */
export type ApiShopOpenV1CommodityImsApiCommodityAddResponse = string

/**
 * 接口 [新增商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497343) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/add`
 */
type ApiShopOpenV1CommodityImsApiCommodityAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/commodity/imsApi/commodity/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497343) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/add`
 */
const apiShopOpenV1CommodityImsApiCommodityAddRequestConfig: ApiShopOpenV1CommodityImsApiCommodityAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/shopOpen/v1/commodity/imsApi/commodity/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1CommodityImsApiCommodityAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增商品', author: '成龙' },
  }

/**
 * 接口 [新增商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497343) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/add`
 */
export const apiShopOpenV1CommodityImsApiCommodityAdd = /*#__PURE__*/ (
  requestData: ApiShopOpenV1CommodityImsApiCommodityAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1CommodityImsApiCommodityAddResponse>(
    prepare(apiShopOpenV1CommodityImsApiCommodityAddRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1CommodityImsApiCommodityAdd.requestConfig =
  apiShopOpenV1CommodityImsApiCommodityAddRequestConfig

/**
 * 接口 [商品上下架↗](https://yapi.gogpay.cn/project/5563/interface/api/497344) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/changeStatus`
 */
export interface ApiShopOpenV1CommodityImsApiCommodityChangeStatusRequest {
  /**
   * 商品 ID
   */
  commodityId?: string
  /**
   * 操作状态：0-入库1-上架 2-下架
   */
  status?: number
}

/**
 * 接口 [商品上下架↗](https://yapi.gogpay.cn/project/5563/interface/api/497344) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/changeStatus`
 */
export interface ApiShopOpenV1CommodityImsApiCommodityChangeStatusResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商品上下架↗](https://yapi.gogpay.cn/project/5563/interface/api/497344) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/changeStatus`
 */
type ApiShopOpenV1CommodityImsApiCommodityChangeStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/commodity/imsApi/commodity/changeStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商品上下架↗](https://yapi.gogpay.cn/project/5563/interface/api/497344) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/changeStatus`
 */
const apiShopOpenV1CommodityImsApiCommodityChangeStatusRequestConfig: ApiShopOpenV1CommodityImsApiCommodityChangeStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/shopOpen/v1/commodity/imsApi/commodity/changeStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1CommodityImsApiCommodityChangeStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商品上下架', author: '成龙' },
  }

/**
 * 接口 [商品上下架↗](https://yapi.gogpay.cn/project/5563/interface/api/497344) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/changeStatus`
 */
export const apiShopOpenV1CommodityImsApiCommodityChangeStatus = /*#__PURE__*/ (
  requestData: ApiShopOpenV1CommodityImsApiCommodityChangeStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1CommodityImsApiCommodityChangeStatusResponse>(
    prepare(
      apiShopOpenV1CommodityImsApiCommodityChangeStatusRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1CommodityImsApiCommodityChangeStatus.requestConfig =
  apiShopOpenV1CommodityImsApiCommodityChangeStatusRequestConfig

/**
 * 接口 [商品列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497345) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/pageList`
 */
export interface ApiShopOpenV1CommodityImsApiCommodityPageListRequest {
  /**
   * 审批状态
   */
  applyStatusEnums?: number[]
  /**
   * 商品 ID
   */
  commodityId?: string
  /**
   * 商品 ID 集合
   */
  commodityIds?: string[]
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 创建时间,格式 yyyy-MM-dd HH:mm:ss
   */
  createTimes?: string[]
  /**
   * 所属店铺 ID 集合
   */
  merchantIds?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 上下架状态：-1-待入库 0-待上架 1-上架 2-下架
   */
  statusEnums?: number[]
  /**
   * 更新时间,格式 yyyy-MM-dd HH:mm:ss
   */
  updateTimes?: string[]
}

/**
 * 接口 [商品列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497345) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/pageList`
 */
export interface ApiShopOpenV1CommodityImsApiCommodityPageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 审批状态
     */
    applyStatus?: number
    /**
     * 类目 ID
     */
    categoryId?: string
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品 ID
     */
    commodityId?: string
    /**
     * 商品子标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品封面图
     */
    coverPic?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 商户 ID
     */
    merchantId?: string
    /**
     * 所属商户
     */
    merchantName?: string
    /**
     * 真实销量
     */
    sales?: number
    /**
     * 价格区间
     */
    sellPrices?: number[]
    /**
     * 标准电商虚拟规格列表
     */
    skuList?: {
      /**
       * 商品 ID
       */
      commodityId?: string
      /**
       * 成本价
       */
      commoditySkuCost?: number
      /**
       * SKU 价格
       */
      commoditySkuPrice?: number
      /**
       * sku 库存
       */
      commodityStock?: number
      /**
       * 默认展示:0-否 1-是
       */
      defaultShow?: number
      /**
       * SKU 主键
       */
      id?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 商品单日限购量（0 不限制）
       */
      singleDayLimitPurchases?: number
      /**
       * SKU 唯一参数标识
       */
      skuId?: string
      /**
       * 规格名称
       */
      skuName?: string
      /**
       * SKU 商品图
       */
      skuPic?: string
      /**
       * SKU 状态:0-无效 1-有效
       */
      skuStatus?: number
      /**
       * 用户单日限购量（0 不限制）
       */
      userDayLimitPurchases?: number
      /**
       * 用户限购量不能为空（0 不限制）
       */
      userLimitPurchases?: number
    }[]
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 上下架状态：-2-草稿 -1-待入库 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 更新人
     */
    updateBy?: string
    /**
     * 更新时间
     */
    updateTime?: string
  }[]
  /**
   * 总条数
   */
  total?: number
  /**
   * 总页数
   */
  totalPage?: number
}

/**
 * 接口 [商品列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497345) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/pageList`
 */
type ApiShopOpenV1CommodityImsApiCommodityPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/commodity/imsApi/commodity/pageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商品列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497345) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/pageList`
 */
const apiShopOpenV1CommodityImsApiCommodityPageListRequestConfig: ApiShopOpenV1CommodityImsApiCommodityPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/shopOpen/v1/commodity/imsApi/commodity/pageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1CommodityImsApiCommodityPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商品列表', author: '成龙' },
  }

/**
 * 接口 [商品列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497345) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/pageList`
 */
export const apiShopOpenV1CommodityImsApiCommodityPageList = /*#__PURE__*/ (
  requestData: ApiShopOpenV1CommodityImsApiCommodityPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1CommodityImsApiCommodityPageListResponse>(
    prepare(
      apiShopOpenV1CommodityImsApiCommodityPageListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1CommodityImsApiCommodityPageList.requestConfig =
  apiShopOpenV1CommodityImsApiCommodityPageListRequestConfig

/**
 * 接口 [修改商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497346) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/update`
 */
export interface ApiShopOpenV1CommodityImsApiCommodityUpdateRequest {
  /**
   * 商品自动下架日期，格式 yyyy-MM-dd HH:mm:ss
   */
  autoDownDate?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品描述
   */
  commodityDescription?: string
  /**
   * 商品详情,HTML代码
   */
  commodityDetail?: string
  /**
   * 商品 ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商封面图
   */
  coverPic?: string
  /**
   * 划线价
   */
  dashPrice?: number
  /**
   * 操作类型 0-入库 1-上架
   */
  operationType?: number
  /**
   * 所属店铺 ID
   */
  refMerchantId?: string
  /**
   * 所属店铺名称
   */
  refMerchantName?: string
  standardCommodity?: {
    /**
     * 成本价，结算金额
     */
    commoditySkuCost?: number
    /**
     * SKU 价格
     */
    commoditySkuPrice?: number
    /**
     * sku 库存数量
     */
    commodityStock?: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow?: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases?: number
    /**
     * SKU ID
     */
    skuId?: string
    /**
     * 规格名称
     */
    skuName?: string
    /**
     * SKU 商品图
     */
    skuPic?: string
    /**
     * SKU 状态:0-无效 1-有效
     */
    skuStatus?: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases?: number
    /**
     * 用户限购量
     */
    userLimitPurchases?: number
  }
  /**
   * 所属店铺机构号
   */
  unitOrgCode?: string
  /**
   * 虚拟销量
   */
  virtualSales?: number
}

/**
 * 接口 [修改商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497346) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/update`
 */
export type ApiShopOpenV1CommodityImsApiCommodityUpdateResponse = string

/**
 * 接口 [修改商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497346) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/update`
 */
type ApiShopOpenV1CommodityImsApiCommodityUpdateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/commodity/imsApi/commodity/update',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497346) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/update`
 */
const apiShopOpenV1CommodityImsApiCommodityUpdateRequestConfig: ApiShopOpenV1CommodityImsApiCommodityUpdateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/shopOpen/v1/commodity/imsApi/commodity/update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1CommodityImsApiCommodityUpdate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改商品', author: '成龙' },
  }

/**
 * 接口 [修改商品↗](https://yapi.gogpay.cn/project/5563/interface/api/497346) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/commodity/update`
 */
export const apiShopOpenV1CommodityImsApiCommodityUpdate = /*#__PURE__*/ (
  requestData: ApiShopOpenV1CommodityImsApiCommodityUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1CommodityImsApiCommodityUpdateResponse>(
    prepare(
      apiShopOpenV1CommodityImsApiCommodityUpdateRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1CommodityImsApiCommodityUpdate.requestConfig =
  apiShopOpenV1CommodityImsApiCommodityUpdateRequestConfig

/**
 * 接口 [添加或减少商品的库存↗](https://yapi.gogpay.cn/project/5563/interface/api/497347) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/skuStock/addOrSub`
 */
export interface ApiShopOpenV1CommodityImsApiSkuStockAddOrSubRequest {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * skuID
   */
  skuId?: string
  /**
   * 操作库存量
   */
  stock?: number
  /**
   * 操作类型 10-添加库存 20-减库存
   */
  type?: number
}

/**
 * 接口 [添加或减少商品的库存↗](https://yapi.gogpay.cn/project/5563/interface/api/497347) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/skuStock/addOrSub`
 */
export interface ApiShopOpenV1CommodityImsApiSkuStockAddOrSubResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [添加或减少商品的库存↗](https://yapi.gogpay.cn/project/5563/interface/api/497347) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/skuStock/addOrSub`
 */
type ApiShopOpenV1CommodityImsApiSkuStockAddOrSubRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/commodity/imsApi/skuStock/addOrSub',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加或减少商品的库存↗](https://yapi.gogpay.cn/project/5563/interface/api/497347) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/skuStock/addOrSub`
 */
const apiShopOpenV1CommodityImsApiSkuStockAddOrSubRequestConfig: ApiShopOpenV1CommodityImsApiSkuStockAddOrSubRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: '/shopOpen/v1/commodity/imsApi/skuStock/addOrSub',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1CommodityImsApiSkuStockAddOrSub',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加或减少商品的库存', author: '成龙' },
  }

/**
 * 接口 [添加或减少商品的库存↗](https://yapi.gogpay.cn/project/5563/interface/api/497347) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商品管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86810)
 * @请求头 `POST /shopOpen/v1/commodity/imsApi/skuStock/addOrSub`
 */
export const apiShopOpenV1CommodityImsApiSkuStockAddOrSub = /*#__PURE__*/ (
  requestData: ApiShopOpenV1CommodityImsApiSkuStockAddOrSubRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1CommodityImsApiSkuStockAddOrSubResponse>(
    prepare(
      apiShopOpenV1CommodityImsApiSkuStockAddOrSubRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1CommodityImsApiSkuStockAddOrSub.requestConfig =
  apiShopOpenV1CommodityImsApiSkuStockAddOrSubRequestConfig

const mockUrl_0_0_0_3 = 'https://yapi.gogpay.cn/mock/5563' as any
const devUrl_0_0_0_3 = '' as any
const prodUrl_0_0_0_3 = '' as any
const dataKey_0_0_0_3 = 'data' as any

/**
 * 接口 [获取商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497341) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/goods/detail`
 */
export interface ApiShopOpenV1OpenTradeGoodsDetailRequest {
  /**
   * ID
   */
  id?: string
}

/**
 * 接口 [获取商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497341) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/goods/detail`
 */
export interface ApiShopOpenV1OpenTradeGoodsDetailResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 商品自动下架日期
   */
  autoDownDate?: string
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 配送地址
   */
  deliveryAddress?: string
  /**
   * 使用渠道多选：0-TV 1-移动端
   */
  distributeChannel?: number[]
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 不配送地址
   */
  noDeliveryAddress?: string
  /**
   * 包邮类型: 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 预览路由
   */
  previewUrl?: string
  /**
   * 最低价(2.0之后用lowestPrice代替)
   */
  price?: number
  /**
   * 供应商绑定商品ID
   */
  provideCommodityId?: string
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 供应商 0=多彩宝 1=京东
   */
  provideSource?: number
  /**
   * 购买须知信息
   */
  purchaseNotesDetail: string
  /**
   * 购买须知ID
   */
  purchaseNotesId?: string
  /**
   * 实名制类型 0-自动回填 1-手动填写
   */
  realNameInputType: number
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 售后服务: 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 自提地址id列表
   */
  selfPickupAddressId?: string[]
  /**
   * 是否支持自提：0-否 1-是
   */
  selfPickupStatus?: number
  /**
   * 价格区间
   */
  sellPrices?: number[]
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 标电，虚拟商品规格详情
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
  /**
   * 库存预警
   */
  stockAlertCount?: number
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段库存
   */
  stockType: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  /**
   * TV轮播图
   */
  tvCarousePic?: string[]
  /**
   * TV封面图
   */
  tvCoverPic?: string
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 购买xxx天内有效
   */
  writeOffValidDay?: number
  /**
   * 核销有效期结束时间
   */
  writeOffValidEndTime?: string
  /**
   * 核销有效期开始时间
   */
  writeOffValidStartTime?: string
  /**
   * 优惠描述
   */
  discountDescList?: string[]
  /**
   * 优惠后价格
   */
  discountAfterAmt?: number
  /**
   * 优惠前价格
   */
  discountBeforeAmt?: number
}

/**
 * 接口 [获取商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497341) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/goods/detail`
 */
type ApiShopOpenV1OpenTradeGoodsDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/api/open/trade/goods/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497341) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/goods/detail`
 */
const apiShopOpenV1OpenTradeGoodsDetailRequestConfig: ApiShopOpenV1OpenTradeGoodsDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/shopOpen/v1/api/open/trade/goods/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OpenTradeGoodsDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品信息', author: '成龙' },
  }

/**
 * 接口 [获取商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497341) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/goods/detail`
 */
export const apiShopOpenV1OpenTradeGoodsDetail = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OpenTradeGoodsDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OpenTradeGoodsDetailResponse>(
    prepare(apiShopOpenV1OpenTradeGoodsDetailRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OpenTradeGoodsDetail.requestConfig =
  apiShopOpenV1OpenTradeGoodsDetailRequestConfig

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/5563/interface/api/497342) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/order/tradeOrder`
 */
export interface ApiShopOpenV1OpenTradeOrderTradeOrderRequest {
  /**
   * ID
   */
  id?: string
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/5563/interface/api/497342) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/order/tradeOrder`
 */
export interface ApiShopOpenV1OpenTradeOrderTradeOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  /**
   * 限制支付模式 01=小程序openID限制
   */
  limitPay?: string
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * 店铺logo
     */
    storeLogo?: string
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 店铺logo
   */
  storeLogo?: string
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/5563/interface/api/497342) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/order/tradeOrder`
 */
type ApiShopOpenV1OpenTradeOrderTradeOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/api/open/trade/order/tradeOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/5563/interface/api/497342) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/order/tradeOrder`
 */
const apiShopOpenV1OpenTradeOrderTradeOrderRequestConfig: ApiShopOpenV1OpenTradeOrderTradeOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: '/shopOpen/v1/api/open/trade/order/tradeOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1OpenTradeOrderTradeOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '交易下单', author: '成龙' },
  }

/**
 * 接口 [交易下单↗](https://yapi.gogpay.cn/project/5563/interface/api/497342) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商品信息↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86811)
 * @请求头 `POST /shopOpen/v1/api/open/trade/order/tradeOrder`
 */
export const apiShopOpenV1OpenTradeOrderTradeOrder = /*#__PURE__*/ (
  requestData: ApiShopOpenV1OpenTradeOrderTradeOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1OpenTradeOrderTradeOrderResponse>(
    prepare(apiShopOpenV1OpenTradeOrderTradeOrderRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1OpenTradeOrderTradeOrder.requestConfig =
  apiShopOpenV1OpenTradeOrderTradeOrderRequestConfig

const mockUrl_0_0_0_4 = 'https://yapi.gogpay.cn/mock/5563' as any
const devUrl_0_0_0_4 = '' as any
const prodUrl_0_0_0_4 = '' as any
const dataKey_0_0_0_4 = 'data' as any

/**
 * 接口 [提交店铺审核↗](https://yapi.gogpay.cn/project/5563/interface/api/497361) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/approve`
 */
export interface ApiShopOpenV1MerchantImsApiStoreApproveRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [提交店铺审核↗](https://yapi.gogpay.cn/project/5563/interface/api/497361) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/approve`
 */
export interface ApiShopOpenV1MerchantImsApiStoreApproveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [提交店铺审核↗](https://yapi.gogpay.cn/project/5563/interface/api/497361) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/approve`
 */
type ApiShopOpenV1MerchantImsApiStoreApproveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/store/approve',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提交店铺审核↗](https://yapi.gogpay.cn/project/5563/interface/api/497361) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/approve`
 */
const apiShopOpenV1MerchantImsApiStoreApproveRequestConfig: ApiShopOpenV1MerchantImsApiStoreApproveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/approve',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiStoreApprove',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提交店铺审核', author: '成龙' },
  }

/**
 * 接口 [提交店铺审核↗](https://yapi.gogpay.cn/project/5563/interface/api/497361) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/approve`
 */
export const apiShopOpenV1MerchantImsApiStoreApprove = /*#__PURE__*/ (
  requestData: ApiShopOpenV1MerchantImsApiStoreApproveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1MerchantImsApiStoreApproveResponse>(
    prepare(apiShopOpenV1MerchantImsApiStoreApproveRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1MerchantImsApiStoreApprove.requestConfig =
  apiShopOpenV1MerchantImsApiStoreApproveRequestConfig

/**
 * 接口 [店铺营业↗](https://yapi.gogpay.cn/project/5563/interface/api/497362) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStart`
 */
export interface ApiShopOpenV1MerchantImsApiStoreBusinessStartRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [店铺营业↗](https://yapi.gogpay.cn/project/5563/interface/api/497362) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStart`
 */
export interface ApiShopOpenV1MerchantImsApiStoreBusinessStartResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [店铺营业↗](https://yapi.gogpay.cn/project/5563/interface/api/497362) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStart`
 */
type ApiShopOpenV1MerchantImsApiStoreBusinessStartRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/store/businessStart',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺营业↗](https://yapi.gogpay.cn/project/5563/interface/api/497362) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStart`
 */
const apiShopOpenV1MerchantImsApiStoreBusinessStartRequestConfig: ApiShopOpenV1MerchantImsApiStoreBusinessStartRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/businessStart',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiStoreBusinessStart',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺营业', author: '成龙' },
  }

/**
 * 接口 [店铺营业↗](https://yapi.gogpay.cn/project/5563/interface/api/497362) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStart`
 */
export const apiShopOpenV1MerchantImsApiStoreBusinessStart = /*#__PURE__*/ (
  requestData: ApiShopOpenV1MerchantImsApiStoreBusinessStartRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1MerchantImsApiStoreBusinessStartResponse>(
    prepare(
      apiShopOpenV1MerchantImsApiStoreBusinessStartRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1MerchantImsApiStoreBusinessStart.requestConfig =
  apiShopOpenV1MerchantImsApiStoreBusinessStartRequestConfig

/**
 * 接口 [店铺休业↗](https://yapi.gogpay.cn/project/5563/interface/api/497363) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStop`
 */
export interface ApiShopOpenV1MerchantImsApiStoreBusinessStopRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [店铺休业↗](https://yapi.gogpay.cn/project/5563/interface/api/497363) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStop`
 */
export interface ApiShopOpenV1MerchantImsApiStoreBusinessStopResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [店铺休业↗](https://yapi.gogpay.cn/project/5563/interface/api/497363) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStop`
 */
type ApiShopOpenV1MerchantImsApiStoreBusinessStopRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/store/businessStop',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺休业↗](https://yapi.gogpay.cn/project/5563/interface/api/497363) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStop`
 */
const apiShopOpenV1MerchantImsApiStoreBusinessStopRequestConfig: ApiShopOpenV1MerchantImsApiStoreBusinessStopRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/businessStop',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiStoreBusinessStop',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺休业', author: '成龙' },
  }

/**
 * 接口 [店铺休业↗](https://yapi.gogpay.cn/project/5563/interface/api/497363) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/businessStop`
 */
export const apiShopOpenV1MerchantImsApiStoreBusinessStop = /*#__PURE__*/ (
  requestData: ApiShopOpenV1MerchantImsApiStoreBusinessStopRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1MerchantImsApiStoreBusinessStopResponse>(
    prepare(
      apiShopOpenV1MerchantImsApiStoreBusinessStopRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1MerchantImsApiStoreBusinessStop.requestConfig =
  apiShopOpenV1MerchantImsApiStoreBusinessStopRequestConfig

/**
 * 接口 [创建SKU规格↗](https://yapi.gogpay.cn/project/5563/interface/api/497364) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/createSkuAttribute`
 */
export interface ApiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [创建SKU规格↗](https://yapi.gogpay.cn/project/5563/interface/api/497364) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/createSkuAttribute`
 */
export interface ApiShopOpenV1MerchantImsApiStoreCreateSkuAttributeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [创建SKU规格↗](https://yapi.gogpay.cn/project/5563/interface/api/497364) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/createSkuAttribute`
 */
type ApiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/store/createSkuAttribute',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [创建SKU规格↗](https://yapi.gogpay.cn/project/5563/interface/api/497364) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/createSkuAttribute`
 */
const apiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequestConfig: ApiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/createSkuAttribute',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiStoreCreateSkuAttribute',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '创建SKU规格', author: '成龙' },
  }

/**
 * 接口 [创建SKU规格↗](https://yapi.gogpay.cn/project/5563/interface/api/497364) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/createSkuAttribute`
 */
export const apiShopOpenV1MerchantImsApiStoreCreateSkuAttribute =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreCreateSkuAttributeResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreCreateSkuAttribute.requestConfig =
  apiShopOpenV1MerchantImsApiStoreCreateSkuAttributeRequestConfig

/**
 * 接口 [查询店铺列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497365) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/queryPageList`
 */
export interface ApiShopOpenV1MerchantImsApiStoreQueryPageListRequest {
  /**
   * 创建时间筛选-结束,格式 yyyy-MM-dd HH:mm:ss
   */
  createTimeEnd?: string
  /**
   * 创建时间筛选-开始,格式 yyyy-MM-dd HH:mm:ss
   */
  createTimeStart?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺 ID
   */
  storeId?: string
  /**
   * 店铺 ID 集合
   */
  storeIdList?: string[]
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺状态
   */
  storeStatusList?: number[]
}

/**
 * 接口 [查询店铺列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497365) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/queryPageList`
 */
export interface ApiShopOpenV1MerchantImsApiStoreQueryPageListResponse {
  /**
   * 数据列表
   */
  content?: {
    /**
     * 审批状态
     */
    approveStatus?: number
    /**
     * 审批状态名称
     */
    approveStatusName?: string
    /**
     * 营业执照
     */
    businessLicense?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间,格式 yyyy-MM-dd HH:mm:ss
     */
    createTime?: string
    /**
     * 法人身份证号
     */
    legalPersonIdNo?: string
    /**
     * 法人姓名
     */
    legalPersonName?: string
    /**
     * 店铺封面/logo
     */
    logo?: string
    /**
     * 所属机构名称
     */
    orgName?: string
    /**
     * 是否可营业 为true表示可营业，false 需提交店铺审核
     */
    startFlag?: boolean
    /**
     * 店铺 ID
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺状态
     */
    storeStatus?: number
    /**
     * 店铺状态名称
     */
    storeStatusName?: string
    /**
     * 统一社会信用代码
     */
    uniSocialCreditCode?: string
    /**
     * 店铺编号
     */
    unitOrgCode?: string
    /**
     * 更新人
     */
    updateBy?: string
    /**
     * 最近更新时间,格式 yyyy-MM-dd HH:mm:ss
     */
    updateTime?: string
  }[]
  /**
   * 总条数
   */
  total?: number
}

/**
 * 接口 [查询店铺列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497365) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/queryPageList`
 */
type ApiShopOpenV1MerchantImsApiStoreQueryPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/store/queryPageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询店铺列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497365) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/queryPageList`
 */
const apiShopOpenV1MerchantImsApiStoreQueryPageListRequestConfig: ApiShopOpenV1MerchantImsApiStoreQueryPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/queryPageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiStoreQueryPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询店铺列表', author: '成龙' },
  }

/**
 * 接口 [查询店铺列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497365) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/queryPageList`
 */
export const apiShopOpenV1MerchantImsApiStoreQueryPageList = /*#__PURE__*/ (
  requestData: ApiShopOpenV1MerchantImsApiStoreQueryPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1MerchantImsApiStoreQueryPageListResponse>(
    prepare(
      apiShopOpenV1MerchantImsApiStoreQueryPageListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1MerchantImsApiStoreQueryPageList.requestConfig =
  apiShopOpenV1MerchantImsApiStoreQueryPageListRequestConfig

/**
 * 接口 [新增店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497366) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequest {
  /**
   * 详细地址
   */
  address?: string
  /**
   * 营业执照
   */
  businessLicense?: string
  /**
   * 法人身份证背面照片，BASE64
   */
  legalPersonIdCardB?: string
  /**
   * 法人身份证正面照片，BASE64
   */
  legalPersonIdCardF?: string
  /**
   * 法人身份证号
   */
  legalPersonIdNo?: string
  /**
   * 法人姓名
   */
  legalPersonName?: string
  /**
   * 机构公司名称
   */
  orgName?: string
  /**
   * 店铺联系人
   */
  storeContact?: string
  /**
   * 店铺 logo
   */
  storeLogo?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺联系电话
   */
  storePhone?: string
  /**
   * 统一社会信用代码
   */
  uniSocialCreditCode?: string
}

/**
 * 接口 [新增店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497366) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreResponse {
  /**
   * 店铺编码
   */
  storeCode?: string
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [新增店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497366) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore`
 */
type ApiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [新增店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497366) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore`
 */
const apiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequestConfig: ApiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增店铺', author: '成龙' },
  }

/**
 * 接口 [新增店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497366) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/saveElectronicCommerceStore`
 */
export const apiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStore =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStore.requestConfig =
  apiShopOpenV1MerchantImsApiStoreSaveElectronicCommerceStoreRequestConfig

/**
 * 接口 [店铺休息↗](https://yapi.gogpay.cn/project/5563/interface/api/497367) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/sleep`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSleepRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [店铺休息↗](https://yapi.gogpay.cn/project/5563/interface/api/497367) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/sleep`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSleepResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [店铺休息↗](https://yapi.gogpay.cn/project/5563/interface/api/497367) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/sleep`
 */
type ApiShopOpenV1MerchantImsApiStoreSleepRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/store/sleep',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺休息↗](https://yapi.gogpay.cn/project/5563/interface/api/497367) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/sleep`
 */
const apiShopOpenV1MerchantImsApiStoreSleepRequestConfig: ApiShopOpenV1MerchantImsApiStoreSleepRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/sleep',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiStoreSleep',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺休息', author: '成龙' },
  }

/**
 * 接口 [店铺休息↗](https://yapi.gogpay.cn/project/5563/interface/api/497367) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/sleep`
 */
export const apiShopOpenV1MerchantImsApiStoreSleep = /*#__PURE__*/ (
  requestData: ApiShopOpenV1MerchantImsApiStoreSleepRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1MerchantImsApiStoreSleepResponse>(
    prepare(apiShopOpenV1MerchantImsApiStoreSleepRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1MerchantImsApiStoreSleep.requestConfig =
  apiShopOpenV1MerchantImsApiStoreSleepRequestConfig

/**
 * 接口 [修改店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497368) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore`
 */
export interface ApiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequest {
  /**
   * 详细地址
   */
  address?: string
  /**
   * 营业执照
   */
  businessLicense?: string
  /**
   * 法人身份证背面照片，BASE64
   */
  legalPersonIdCardB?: string
  /**
   * 法人身份证正面照片，BASE64
   */
  legalPersonIdCardF?: string
  /**
   * 法人身份证号
   */
  legalPersonIdNo?: string
  /**
   * 法人姓名
   */
  legalPersonName?: string
  /**
   * 机构公司名称
   */
  orgName?: string
  /**
   * 店铺联系人
   */
  storeContact?: string
  /**
   * 店铺 Id
   */
  storeId?: string
  /**
   * 店铺 logo
   */
  storeLogo?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺联系电话
   */
  storePhone?: string
  /**
   * 统一社会信用代码
   */
  uniSocialCreditCode?: string
}

/**
 * 接口 [修改店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497368) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore`
 */
export interface ApiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreResponse {
  /**
   * 店铺编码
   */
  storeCode?: string
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [修改店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497368) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore`
 */
type ApiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [修改店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497368) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore`
 */
const apiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequestConfig: ApiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: '/shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改店铺', author: '成龙' },
  }

/**
 * 接口 [修改店铺↗](https://yapi.gogpay.cn/project/5563/interface/api/497368) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [店铺管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86812)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/store/updateElectronicCommerceStore`
 */
export const apiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStore =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStore.requestConfig =
  apiShopOpenV1MerchantImsApiStoreUpdateElectronicCommerceStoreRequestConfig

const mockUrl_0_0_0_5 = 'https://yapi.gogpay.cn/mock/5563' as any
const devUrl_0_0_0_5 = '' as any
const prodUrl_0_0_0_5 = '' as any
const dataKey_0_0_0_5 = 'data' as any

/**
 * 接口 [投诉通知回调↗](https://yapi.gogpay.cn/project/5563/interface/api/497348) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/callBack`
 */
export type ApiShopOpenV1ConsumerComplaintImsApiCallBackRequest = string

/**
 * 接口 [投诉通知回调↗](https://yapi.gogpay.cn/project/5563/interface/api/497348) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/callBack`
 */
export type ApiShopOpenV1ConsumerComplaintImsApiCallBackResponse = string

/**
 * 接口 [投诉通知回调↗](https://yapi.gogpay.cn/project/5563/interface/api/497348) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/callBack`
 */
type ApiShopOpenV1ConsumerComplaintImsApiCallBackRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/callBack',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [投诉通知回调↗](https://yapi.gogpay.cn/project/5563/interface/api/497348) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/callBack`
 */
const apiShopOpenV1ConsumerComplaintImsApiCallBackRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiCallBackRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/callBack',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiCallBack',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '投诉通知回调', author: '成龙' },
  }

/**
 * 接口 [投诉通知回调↗](https://yapi.gogpay.cn/project/5563/interface/api/497348) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/callBack`
 */
export const apiShopOpenV1ConsumerComplaintImsApiCallBack = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiCallBackRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiCallBackResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiCallBackRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiCallBack.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiCallBackRequestConfig

/**
 * 接口 [查询投诉单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497349) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complaintPage`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiComplaintPageRequest {
  /**
   * 开始日期
   */
  beginDate?: string
  /**
   * 结束日期
   */
  endDate?: string
  /**
   * 分页大小
   */
  limit?: number
  /**
   * 分页开始位置
   */
  offset?: number
}

/**
 * 接口 [查询投诉单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497349) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complaintPage`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiComplaintPageResponse {
  data?: {
    additionalInfo?: {
      sharePowerInfo?: {
        returnAddressInfo?: {
          latitude?: string
          longitude?: string
          returnAddress?: string
        }
        returnTime?: string
        returnedToSameMachine?: boolean
      }
      type?: 'SHARE_POWER_TYPE'
    }
    applyRefundAmount?: number
    complaintDetail?: string
    complaintFullRefunded?: boolean
    complaintId?: string
    complaintMediaList?: {
      mediaType?: 'USER_COMPLAINT_IMAGE' | 'OPERATION_IMAGE'
      mediaUrl?: string[]
    }[]
    complaintOrderInfo?: {
      amount?: number
      outTradeNo?: string
      transactionId?: string
    }[]
    complaintState?: string
    complaintTime?: string
    inPlatformService?: boolean
    incomingUserResponse?: boolean
    isAgentMode?: boolean
    needImmediateService?: boolean
    payerOpenid?: string
    payerPhone?: string
    problemDescription?: string
    problemType?: 'REFUND' | 'SERVICE_NOT_WORK' | 'OTHERS'
    serviceOrderInfo?: {
      orderId?: string
      outOrderNo?: string
      state?: 'DOING' | 'REVOKED' | 'WAITPAY' | 'DONE'
    }[]
    userComplaintTimes?: number
    userTagList?: ('TRUSTED' | 'HIGH_RISK')[]
  }[]
  limit?: number
  offset?: number
  totalCount?: number
}

/**
 * 接口 [查询投诉单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497349) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complaintPage`
 */
type ApiShopOpenV1ConsumerComplaintImsApiComplaintPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/complaintPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询投诉单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497349) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complaintPage`
 */
const apiShopOpenV1ConsumerComplaintImsApiComplaintPageRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiComplaintPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/complaintPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiComplaintPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询投诉单列表', author: '成龙' },
  }

/**
 * 接口 [查询投诉单列表↗](https://yapi.gogpay.cn/project/5563/interface/api/497349) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complaintPage`
 */
export const apiShopOpenV1ConsumerComplaintImsApiComplaintPage = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiComplaintPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiComplaintPageResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiComplaintPageRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiComplaintPage.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiComplaintPageRequestConfig

/**
 * 接口 [反馈处理完成↗](https://yapi.gogpay.cn/project/5563/interface/api/497350) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complete`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiCompleteRequest {
  complaintId?: string
  complainted_mchid?: string
}

/**
 * 接口 [反馈处理完成↗](https://yapi.gogpay.cn/project/5563/interface/api/497350) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complete`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiCompleteResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [反馈处理完成↗](https://yapi.gogpay.cn/project/5563/interface/api/497350) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complete`
 */
type ApiShopOpenV1ConsumerComplaintImsApiCompleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/complete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [反馈处理完成↗](https://yapi.gogpay.cn/project/5563/interface/api/497350) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complete`
 */
const apiShopOpenV1ConsumerComplaintImsApiCompleteRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiCompleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/complete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiComplete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '反馈处理完成', author: '成龙' },
  }

/**
 * 接口 [反馈处理完成↗](https://yapi.gogpay.cn/project/5563/interface/api/497350) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/complete`
 */
export const apiShopOpenV1ConsumerComplaintImsApiComplete = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiCompleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiCompleteResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiCompleteRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiComplete.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiCompleteRequestConfig

/**
 * 接口 [查询投诉单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497351) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/details`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiDetailsRequest {
  complaintId?: string
}

/**
 * 接口 [查询投诉单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497351) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/details`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiDetailsResponse {
  additionalInfo?: {
    sharePowerInfo?: {
      returnAddressInfo?: {
        latitude?: string
        longitude?: string
        returnAddress?: string
      }
      returnTime?: string
      returnedToSameMachine?: boolean
    }
    type?: 'SHARE_POWER_TYPE'
  }
  applyRefundAmount?: number
  complaintDetail?: string
  complaintFullRefunded?: boolean
  complaintId?: string
  complaintMediaList?: {
    mediaType?: 'USER_COMPLAINT_IMAGE' | 'OPERATION_IMAGE'
    mediaUrl?: string[]
  }[]
  complaintOrderInfo?: {
    amount?: number
    outTradeNo?: string
    transactionId?: string
  }[]
  complaintState?: string
  complaintTime?: string
  inPlatformService?: boolean
  incomingUserResponse?: boolean
  isAgentMode?: boolean
  needImmediateService?: boolean
  payerOpenid?: string
  payerPhone?: string
  problemDescription?: string
  problemType?: 'REFUND' | 'SERVICE_NOT_WORK' | 'OTHERS'
  serviceOrderInfo?: {
    orderId?: string
    outOrderNo?: string
    state?: 'DOING' | 'REVOKED' | 'WAITPAY' | 'DONE'
  }[]
  userComplaintTimes?: number
  userTagList?: ('TRUSTED' | 'HIGH_RISK')[]
}

/**
 * 接口 [查询投诉单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497351) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/details`
 */
type ApiShopOpenV1ConsumerComplaintImsApiDetailsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/details',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询投诉单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497351) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/details`
 */
const apiShopOpenV1ConsumerComplaintImsApiDetailsRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiDetailsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/details',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiDetails',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询投诉单详情', author: '成龙' },
  }

/**
 * 接口 [查询投诉单详情↗](https://yapi.gogpay.cn/project/5563/interface/api/497351) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/details`
 */
export const apiShopOpenV1ConsumerComplaintImsApiDetails = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiDetailsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiDetailsResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiDetailsRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiDetails.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiDetailsRequestConfig

/**
 * 接口 [获取多彩宝订单编号↗](https://yapi.gogpay.cn/project/5563/interface/api/497352) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/getOrderNo`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequest {
  complaintTime?: string
  outTradeNo?: string
}

/**
 * 接口 [获取多彩宝订单编号↗](https://yapi.gogpay.cn/project/5563/interface/api/497352) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/getOrderNo`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiGetOrderNoResponse {
  dcbOrderNo?: string
  /**
   * 订单中心支付单号
   */
  orderCenterPayNo?: string
  /**
   * 订单总价
   */
  totalPrice?: number
}

/**
 * 接口 [获取多彩宝订单编号↗](https://yapi.gogpay.cn/project/5563/interface/api/497352) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/getOrderNo`
 */
type ApiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/getOrderNo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取多彩宝订单编号↗](https://yapi.gogpay.cn/project/5563/interface/api/497352) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/getOrderNo`
 */
const apiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/getOrderNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiGetOrderNo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取多彩宝订单编号', author: '成龙' },
  }

/**
 * 接口 [获取多彩宝订单编号↗](https://yapi.gogpay.cn/project/5563/interface/api/497352) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/getOrderNo`
 */
export const apiShopOpenV1ConsumerComplaintImsApiGetOrderNo = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiGetOrderNoResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiGetOrderNo.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiGetOrderNoRequestConfig

/**
 * 接口 [图片请求接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497353) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/images`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiImagesRequest {
  mediaId?: string
}

/**
 * 接口 [图片请求接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497353) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/images`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiImagesResponse {
  redirect?: boolean
  successful?: boolean
}

/**
 * 接口 [图片请求接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497353) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/images`
 */
type ApiShopOpenV1ConsumerComplaintImsApiImagesRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/images',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [图片请求接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497353) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/images`
 */
const apiShopOpenV1ConsumerComplaintImsApiImagesRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiImagesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/images',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiImages',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '图片请求接口', author: '成龙' },
  }

/**
 * 接口 [图片请求接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497353) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/images`
 */
export const apiShopOpenV1ConsumerComplaintImsApiImages = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiImagesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiImagesResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiImagesRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiImages.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiImagesRequestConfig

/**
 * 接口 [查询投诉单协商历史↗](https://yapi.gogpay.cn/project/5563/interface/api/497354) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequest {
  complaintId?: string
  limit?: number
  offset?: number
}

/**
 * 接口 [查询投诉单协商历史↗](https://yapi.gogpay.cn/project/5563/interface/api/497354) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysResponse {
  data?: {
    complaintMediaList?: {
      mediaType?: 'USER_COMPLAINT_IMAGE' | 'OPERATION_IMAGE'
      mediaUrl?: string[]
    }
    imageList?: string[]
    logId?: string
    operateDetails?: string
    operateTime?: string
    operateType?:
      | 'USER_CREATE_COMPLAINT'
      | 'USER_CONTINUE_COMPLAINT'
      | 'USER_RESPONSE'
      | 'PLATFORM_RESPONSE'
      | 'MERCHANT_RESPONSE'
      | 'MERCHANT_CONFIRM_COMPLETE'
      | 'USER_CREATE_COMPLAINT_SYSTEM_MESSAGE'
      | 'COMPLAINT_FULL_REFUNDED_SYSTEM_MESSAGE'
      | 'USER_CONTINUE_COMPLAINT_SYSTEM_MESSAGE'
      | 'USER_REVOKE_COMPLAINT'
      | 'USER_COMFIRM_COMPLAINT'
      | 'PLATFORM_HELP_APPLICATION'
      | 'USER_APPLY_PLATFORM_HELP'
      | 'MERCHANT_APPROVE_REFUND'
      | 'MERCHANT_REFUSE_RERUND'
      | 'USER_SUBMIT_SATISFACTION'
      | 'SERVICE_ORDER_CANCEL'
      | 'SERVICE_ORDER_COMPLETE'
      | 'COMPLAINT_PARTIAL_REFUNDED_SYSTEM_MESSAGE'
      | 'COMPLAINT_REFUND_RECEIVED_SYSTEM_MESSAGE'
      | 'COMPLAINT_ENTRUSTED_REFUND_SYSTEM_MESSAGE'
      | 'USER_APPLY_PLATFORM_SERVICE'
      | 'USER_CANCEL_PLATFORM_SERVICE'
      | 'PLATFORM_SERVICE_FINISHED'
    operator?: string
    userAppyPlatformServiceReason?: string
    userAppyPlatformServiceReasonDescription?: string
  }[]
  limit?: number
  offset?: number
  totalCount?: number
}

/**
 * 接口 [查询投诉单协商历史↗](https://yapi.gogpay.cn/project/5563/interface/api/497354) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys`
 */
type ApiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [查询投诉单协商历史↗](https://yapi.gogpay.cn/project/5563/interface/api/497354) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys`
 */
const apiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1ConsumerComplaintImsApiNegotiationHistorys',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询投诉单协商历史', author: '成龙' },
  }

/**
 * 接口 [查询投诉单协商历史↗](https://yapi.gogpay.cn/project/5563/interface/api/497354) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/negotiationHistorys`
 */
export const apiShopOpenV1ConsumerComplaintImsApiNegotiationHistorys =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysResponse>(
      prepare(
        apiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1ConsumerComplaintImsApiNegotiationHistorys.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiNegotiationHistorysRequestConfig

/**
 * 接口 [创建投诉通知回调地址↗](https://yapi.gogpay.cn/project/5563/interface/api/497355) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/notifications`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiNotificationsRequest {
  method?: string
  url?: string
}

/**
 * 接口 [创建投诉通知回调地址↗](https://yapi.gogpay.cn/project/5563/interface/api/497355) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/notifications`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiNotificationsResponse {
  url?: string
}

/**
 * 接口 [创建投诉通知回调地址↗](https://yapi.gogpay.cn/project/5563/interface/api/497355) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/notifications`
 */
type ApiShopOpenV1ConsumerComplaintImsApiNotificationsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/notifications',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [创建投诉通知回调地址↗](https://yapi.gogpay.cn/project/5563/interface/api/497355) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/notifications`
 */
const apiShopOpenV1ConsumerComplaintImsApiNotificationsRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiNotificationsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/notifications',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiNotifications',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '创建投诉通知回调地址', author: '成龙' },
  }

/**
 * 接口 [创建投诉通知回调地址↗](https://yapi.gogpay.cn/project/5563/interface/api/497355) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/notifications`
 */
export const apiShopOpenV1ConsumerComplaintImsApiNotifications = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiNotificationsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiNotificationsResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiNotificationsRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiNotifications.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiNotificationsRequestConfig

/**
 * 接口 [更新退款审批结果↗](https://yapi.gogpay.cn/project/5563/interface/api/497356) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/progress`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiProgressRequest {
  action?: 'REJECT' | 'APPROVE'
  complaintId?: string
  launchRefundDay?: number
  rejectMediaList?: string[]
  rejectReason?: string
  remark?: string
}

/**
 * 接口 [更新退款审批结果↗](https://yapi.gogpay.cn/project/5563/interface/api/497356) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/progress`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiProgressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [更新退款审批结果↗](https://yapi.gogpay.cn/project/5563/interface/api/497356) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/progress`
 */
type ApiShopOpenV1ConsumerComplaintImsApiProgressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/progress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [更新退款审批结果↗](https://yapi.gogpay.cn/project/5563/interface/api/497356) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/progress`
 */
const apiShopOpenV1ConsumerComplaintImsApiProgressRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiProgressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/progress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiProgress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '更新退款审批结果', author: '成龙' },
  }

/**
 * 接口 [更新退款审批结果↗](https://yapi.gogpay.cn/project/5563/interface/api/497356) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/progress`
 */
export const apiShopOpenV1ConsumerComplaintImsApiProgress = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiProgressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiProgressResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiProgressRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiProgress.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiProgressRequestConfig

/**
 * 接口 [回复用户↗](https://yapi.gogpay.cn/project/5563/interface/api/497357) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/response`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiResponseRequest {
  complaintId?: string
  complainted_mchid?: string
  responseContent?: string
  responseImages?: string[]
}

/**
 * 接口 [回复用户↗](https://yapi.gogpay.cn/project/5563/interface/api/497357) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/response`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiResponseResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [回复用户↗](https://yapi.gogpay.cn/project/5563/interface/api/497357) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/response`
 */
type ApiShopOpenV1ConsumerComplaintImsApiResponseRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/response',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [回复用户↗](https://yapi.gogpay.cn/project/5563/interface/api/497357) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/response`
 */
const apiShopOpenV1ConsumerComplaintImsApiResponseRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiResponseRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/response',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiResponse',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '回复用户', author: '成龙' },
  }

/**
 * 接口 [回复用户↗](https://yapi.gogpay.cn/project/5563/interface/api/497357) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/response`
 */
export const apiShopOpenV1ConsumerComplaintImsApiResponse = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiResponseRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiResponseResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiResponseRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiResponse.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiResponseRequestConfig

/**
 * 接口 [图片上传接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497358) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/upload`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiUploadRequest {
  file?: string
  meta?: {
    filename?: string
  }
}

/**
 * 接口 [图片上传接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497358) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/upload`
 */
export interface ApiShopOpenV1ConsumerComplaintImsApiUploadResponse {
  mediaId?: string
}

/**
 * 接口 [图片上传接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497358) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/upload`
 */
type ApiShopOpenV1ConsumerComplaintImsApiUploadRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/consumer/complaint/imsApi/upload',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [图片上传接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497358) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/upload`
 */
const apiShopOpenV1ConsumerComplaintImsApiUploadRequestConfig: ApiShopOpenV1ConsumerComplaintImsApiUploadRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/consumer/complaint/imsApi/upload',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1ConsumerComplaintImsApiUpload',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '图片上传接口', author: '成龙' },
  }

/**
 * 接口 [图片上传接口↗](https://yapi.gogpay.cn/project/5563/interface/api/497358) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/consumer/complaint/imsApi/upload`
 */
export const apiShopOpenV1ConsumerComplaintImsApiUpload = /*#__PURE__*/ (
  requestData: ApiShopOpenV1ConsumerComplaintImsApiUploadRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1ConsumerComplaintImsApiUploadResponse>(
    prepare(
      apiShopOpenV1ConsumerComplaintImsApiUploadRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiShopOpenV1ConsumerComplaintImsApiUpload.requestConfig =
  apiShopOpenV1ConsumerComplaintImsApiUploadRequestConfig

/**
 * 接口 [支付通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497359) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/innerApi/order/notifyPay`
 */
export interface ApiShopOpenV1InnerApiOrderNotifyPayRequest {
  activityId?: string
  activitySessionId?: string
  businessChannelId?: string
  changeTime?: string
  count?: number
  couponId?: string
  createTime?: string
  dcbOrderNo?: string
  dcbUserId?: string
  discountInfoList?: {
    activityName?: string
    activityRange?: string
    amount?: number
    channelPoint?: number
    orderDiscountType?: number
    refActivityId?: string
    returnAmount?: number
    rule?: string
    validDate?: string
  }[]
  orderClassify?: number
  orderNo?: string
  orderStatus?: number
  orderType?: number
  parentOrderId?: string
  payAmount?: number
  quantity?: number
  reason?: string
  reasonStatus?: number
  sellChannelId?: string[]
  skuInfos?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 购买数量
     */
    count: number
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 使用多彩豆购买商品数量
     */
    integralCount?: number
    /**
     * 销售渠道Id
     */
    sellChannelId?: string
    /**
     * SKU ID
     */
    skuId: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 购买日期 格式 yyyy-MM-dd
     */
    stockDate?: string
    /**
     * 购买结束日期 格式 yyyy-MM-dd
     */
    stockEndDate?: string
  }[]
  totalPrice?: number
  unitOrgCode?: string
}

/**
 * 接口 [支付通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497359) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/innerApi/order/notifyPay`
 */
export interface ApiShopOpenV1InnerApiOrderNotifyPayResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [支付通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497359) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/innerApi/order/notifyPay`
 */
type ApiShopOpenV1InnerApiOrderNotifyPayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/innerApi/order/notifyPay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [支付通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497359) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/innerApi/order/notifyPay`
 */
const apiShopOpenV1InnerApiOrderNotifyPayRequestConfig: ApiShopOpenV1InnerApiOrderNotifyPayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: '/shopOpen/v1/innerApi/order/notifyPay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1InnerApiOrderNotifyPay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '支付通知', author: '成龙' },
  }

/**
 * 接口 [支付通知↗](https://yapi.gogpay.cn/project/5563/interface/api/497359) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [消费者投诉2.0↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86813)
 * @请求头 `POST /shopOpen/v1/innerApi/order/notifyPay`
 */
export const apiShopOpenV1InnerApiOrderNotifyPay = /*#__PURE__*/ (
  requestData: ApiShopOpenV1InnerApiOrderNotifyPayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1InnerApiOrderNotifyPayResponse>(
    prepare(apiShopOpenV1InnerApiOrderNotifyPayRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1InnerApiOrderNotifyPay.requestConfig =
  apiShopOpenV1InnerApiOrderNotifyPayRequestConfig

const mockUrl_0_0_0_6 = 'https://yapi.gogpay.cn/mock/5563' as any
const devUrl_0_0_0_6 = '' as any
const prodUrl_0_0_0_6 = '' as any
const dataKey_0_0_0_6 = 'data' as any

/**
 * 接口 [查询开户行信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497360) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/bank/page`
 */
export interface ApiShopOpenV1MerchantImsApiBankPageRequest {
  /**
   * 银行名称
   */
  keyword?: string
  /**
   * 分页页码
   */
  pageIndex?: number
  /**
   * 分页页容量
   */
  pageSize?: number
}

/**
 * 接口 [查询开户行信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497360) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/bank/page`
 */
export interface ApiShopOpenV1MerchantImsApiBankPageResponse {
  /**
   * 数据列表
   */
  content?: {
    /**
     * 银行编号
     */
    bankCode?: string
    /**
     * 银行名称
     */
    bankName?: string
  }[]
  /**
   * 总条数
   */
  total?: number
}

/**
 * 接口 [查询开户行信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497360) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/bank/page`
 */
type ApiShopOpenV1MerchantImsApiBankPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/5563',
    '',
    '',
    '/shopOpen/v1/merchant/imsApi/bank/page',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询开户行信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497360) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/bank/page`
 */
const apiShopOpenV1MerchantImsApiBankPageRequestConfig: ApiShopOpenV1MerchantImsApiBankPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: '/shopOpen/v1/merchant/imsApi/bank/page',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiShopOpenV1MerchantImsApiBankPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询开户行信息', author: '成龙' },
  }

/**
 * 接口 [查询开户行信息↗](https://yapi.gogpay.cn/project/5563/interface/api/497360) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/bank/page`
 */
export const apiShopOpenV1MerchantImsApiBankPage = /*#__PURE__*/ (
  requestData: ApiShopOpenV1MerchantImsApiBankPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiShopOpenV1MerchantImsApiBankPageResponse>(
    prepare(apiShopOpenV1MerchantImsApiBankPageRequestConfig, requestData),
    ...args,
  )
}

apiShopOpenV1MerchantImsApiBankPage.requestConfig =
  apiShopOpenV1MerchantImsApiBankPageRequestConfig

/**
 * 接口 [绑卡鉴权↗](https://yapi.gogpay.cn/project/5563/interface/api/497369) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequest {
  /**
   * 开户行编码
   */
  bankCode?: string
  /**
   * 开户行名称
   */
  bankName?: string
  /**
   * 银行账号
   */
  bankUserCardNo?: string
  /**
   * 银行账户名称
   */
  bankUserName?: string
  /**
   * 用户银行手机
   */
  mobilePhone?: string
  /**
   * 备注信息
   */
  remark?: string
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [绑卡鉴权↗](https://yapi.gogpay.cn/project/5563/interface/api/497369) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementBindBankCardResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [绑卡鉴权↗](https://yapi.gogpay.cn/project/5563/interface/api/497369) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard`
 */
type ApiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [绑卡鉴权↗](https://yapi.gogpay.cn/project/5563/interface/api/497369) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard`
 */
const apiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequestConfig: ApiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: '/shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1MerchantImsApiStoreSettlementBindBankCard',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '绑卡鉴权', author: '成龙' },
  }

/**
 * 接口 [绑卡鉴权↗](https://yapi.gogpay.cn/project/5563/interface/api/497369) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindBankCard`
 */
export const apiShopOpenV1MerchantImsApiStoreSettlementBindBankCard =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreSettlementBindBankCardResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreSettlementBindBankCard.requestConfig =
  apiShopOpenV1MerchantImsApiStoreSettlementBindBankCardRequestConfig

/**
 * 接口 [确认鉴权金额↗](https://yapi.gogpay.cn/project/5563/interface/api/497370) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
  /**
   * 收到的资金数（元）
   */
  tradeAmt?: string
}

/**
 * 接口 [确认鉴权金额↗](https://yapi.gogpay.cn/project/5563/interface/api/497370) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [确认鉴权金额↗](https://yapi.gogpay.cn/project/5563/interface/api/497370) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm`
 */
type ApiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [确认鉴权金额↗](https://yapi.gogpay.cn/project/5563/interface/api/497370) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm`
 */
const apiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequestConfig: ApiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: '/shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirm',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '确认鉴权金额', author: '成龙' },
  }

/**
 * 接口 [确认鉴权金额↗](https://yapi.gogpay.cn/project/5563/interface/api/497370) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/bindCardConfirm`
 */
export const apiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirm =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirm.requestConfig =
  apiShopOpenV1MerchantImsApiStoreSettlementBindCardConfirmRequestConfig

/**
 * 接口 [发送鉴权请求↗](https://yapi.gogpay.cn/project/5563/interface/api/497371) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [发送鉴权请求↗](https://yapi.gogpay.cn/project/5563/interface/api/497371) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发送鉴权请求↗](https://yapi.gogpay.cn/project/5563/interface/api/497371) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount`
 */
type ApiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [发送鉴权请求↗](https://yapi.gogpay.cn/project/5563/interface/api/497371) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount`
 */
const apiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequestConfig: ApiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: '/shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发送鉴权请求', author: '成龙' },
  }

/**
 * 接口 [发送鉴权请求↗](https://yapi.gogpay.cn/project/5563/interface/api/497371) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/checkBankAmount`
 */
export const apiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmount =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmount.requestConfig =
  apiShopOpenV1MerchantImsApiStoreSettlementCheckBankAmountRequestConfig

/**
 * 接口 [解绑银行卡↗](https://yapi.gogpay.cn/project/5563/interface/api/497372) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequest {
  /**
   * 店铺 ID
   */
  storeId?: string
}

/**
 * 接口 [解绑银行卡↗](https://yapi.gogpay.cn/project/5563/interface/api/497372) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard`
 */
export interface ApiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [解绑银行卡↗](https://yapi.gogpay.cn/project/5563/interface/api/497372) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard`
 */
type ApiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/5563',
      '',
      '',
      '/shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [解绑银行卡↗](https://yapi.gogpay.cn/project/5563/interface/api/497372) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard`
 */
const apiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequestConfig: ApiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: '/shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCard',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '解绑银行卡', author: '成龙' },
  }

/**
 * 接口 [解绑银行卡↗](https://yapi.gogpay.cn/project/5563/interface/api/497372) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [银行管理↗](https://yapi.gogpay.cn/project/5563/interface/api/cat_86814)
 * @请求头 `POST /shopOpen/v1/merchant/imsApi/storeSettlement/unBindBankCard`
 */
export const apiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCard =
  /*#__PURE__*/ (
    requestData: ApiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardResponse>(
      prepare(
        apiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCard.requestConfig =
  apiShopOpenV1MerchantImsApiStoreSettlementUnBindBankCardRequestConfig

const mockUrl_0_1_0_3 = 'https://yapi.gogpay.cn/mock/1011' as any
const devUrl_0_1_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_1_0_3 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_1_0_3 = 'data' as any

/**
 * 接口 [获取模块数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217030) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getData`
 */
export interface ApiPageConfigDecorateGetDataRequest {
  clientType?: '1' | '2'
  /**
   * 排序方向 asc=正序  desc=倒序
   */
  direction?: 'ASC' | 'DESC'
  headerChannel?: string[]
  /**
   * 组件模块Id
   */
  id: string
  /**
   * 内部数据Id，如分类返回的Id，用于查询分类下的数据
   */
  innerId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序方式  sales=销量  price=价格
   */
  sortType?: string
}

/**
 * 接口 [获取模块数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217030) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getData`
 */
export interface ApiPageConfigDecorateGetDataResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取模块数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217030) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getData`
 */
type ApiPageConfigDecorateGetDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/decorate/getData',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取模块数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217030) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getData`
 */
const apiPageConfigDecorateGetDataRequestConfig: ApiPageConfigDecorateGetDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/pageConfig/api/decorate/getData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigDecorateGetData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取模块数据', author: '成龙' },
  }

/**
 * 接口 [获取模块数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217030) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getData`
 */
export const apiPageConfigDecorateGetData = /*#__PURE__*/ (
  requestData: ApiPageConfigDecorateGetDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigDecorateGetDataResponse>(
    prepare(apiPageConfigDecorateGetDataRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigDecorateGetData.requestConfig =
  apiPageConfigDecorateGetDataRequestConfig

/**
 * 接口 [获取页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/217034) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getPage`
 */
export interface ApiPageConfigDecorateGetPageRequest {
  clientType?: '1' | '2'
  headerChannel?: string[]
  /**
   * 业务Id
   */
  id: string
  /**
   * 页面类型  STORE(1)=店铺   PAGE(2)=页面  PREVIEW(3)=预览
   */
  type: 'store' | 'page' | 'preview' | 'data'
}

/**
 * 接口 [获取页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/217034) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getPage`
 */
export interface ApiPageConfigDecorateGetPageResponse {
  /**
   * 组件列表
   */
  components?: {
    /**
     * 数据配置
     */
    data?: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
    /**
     * 组件Id，用于请求组件数据
     */
    id?: string
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 数据配置
   */
  data?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 是否具备装修配置信息
   */
  hasDecorate?: boolean
  /**
   * 页面Id
   */
  id?: string
  /**
   * 页面样式配置
   */
  style?: {}
}

/**
 * 接口 [获取页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/217034) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getPage`
 */
type ApiPageConfigDecorateGetPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/decorate/getPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/217034) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getPage`
 */
const apiPageConfigDecorateGetPageRequestConfig: ApiPageConfigDecorateGetPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/pageConfig/api/decorate/getPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigDecorateGetPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取页面配置', author: '成龙' },
  }

/**
 * 接口 [获取页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/217034) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getPage`
 */
export const apiPageConfigDecorateGetPage = /*#__PURE__*/ (
  requestData: ApiPageConfigDecorateGetPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigDecorateGetPageResponse>(
    prepare(apiPageConfigDecorateGetPageRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigDecorateGetPage.requestConfig =
  apiPageConfigDecorateGetPageRequestConfig

/**
 * 接口 [搜索页面数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217038) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/search`
 */
export interface ApiPageConfigDecorateSearchRequest {
  clientType?: '1' | '2'
  /**
   * 排序方向 asc=正序  desc=倒序
   */
  direction?: 'ASC' | 'DESC'
  headerChannel?: string[]
  /**
   * 页面模板Id
   */
  id: string
  /**
   * 搜索词
   */
  keyword?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序方式  sales=销量  price=价格
   */
  sortType?: string
}

/**
 * 接口 [搜索页面数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217038) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/search`
 */
export interface ApiPageConfigDecorateSearchResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [搜索页面数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217038) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/search`
 */
type ApiPageConfigDecorateSearchRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/decorate/search',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [搜索页面数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217038) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/search`
 */
const apiPageConfigDecorateSearchRequestConfig: ApiPageConfigDecorateSearchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/pageConfig/api/decorate/search',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigDecorateSearch',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '搜索页面数据', author: '成龙' },
  }

/**
 * 接口 [搜索页面数据↗](https://yapi.gogpay.cn/project/1011/interface/api/217038) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/search`
 */
export const apiPageConfigDecorateSearch = /*#__PURE__*/ (
  requestData: ApiPageConfigDecorateSearchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigDecorateSearchResponse>(
    prepare(apiPageConfigDecorateSearchRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigDecorateSearch.requestConfig =
  apiPageConfigDecorateSearchRequestConfig

/**
 * 接口 [是否拥有装修模板↗](https://yapi.gogpay.cn/project/1011/interface/api/219770) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/hasTemplate`
 */
export interface ApiPageConfigDecorateHasTemplateRequest {
  clientType?: '1' | '2'
  headerChannel?: string[]
  /**
   * 业务Id
   */
  id: string
  /**
   * 页面类型  STORE(1)=店铺   PAGE(2)=页面  PREVIEW(3)=预览
   */
  type: 'store' | 'page' | 'preview' | 'data'
}

/**
 * 接口 [是否拥有装修模板↗](https://yapi.gogpay.cn/project/1011/interface/api/219770) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/hasTemplate`
 */
export interface ApiPageConfigDecorateHasTemplateResponse {
  /**
   * 组件列表
   */
  components?: {
    /**
     * 数据配置
     */
    data?: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
    /**
     * 组件Id，用于请求组件数据
     */
    id?: string
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 数据配置
   */
  data?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 是否具备装修配置信息
   */
  hasDecorate?: boolean
  /**
   * 页面Id
   */
  id?: string
  /**
   * 页面样式配置
   */
  style?: {}
}

/**
 * 接口 [是否拥有装修模板↗](https://yapi.gogpay.cn/project/1011/interface/api/219770) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/hasTemplate`
 */
type ApiPageConfigDecorateHasTemplateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/decorate/hasTemplate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [是否拥有装修模板↗](https://yapi.gogpay.cn/project/1011/interface/api/219770) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/hasTemplate`
 */
const apiPageConfigDecorateHasTemplateRequestConfig: ApiPageConfigDecorateHasTemplateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/pageConfig/api/decorate/hasTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigDecorateHasTemplate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '是否拥有装修模板', author: '成龙' },
  }

/**
 * 接口 [是否拥有装修模板↗](https://yapi.gogpay.cn/project/1011/interface/api/219770) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/hasTemplate`
 */
export const apiPageConfigDecorateHasTemplate = /*#__PURE__*/ (
  requestData: ApiPageConfigDecorateHasTemplateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigDecorateHasTemplateResponse>(
    prepare(apiPageConfigDecorateHasTemplateRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigDecorateHasTemplate.requestConfig =
  apiPageConfigDecorateHasTemplateRequestConfig

/**
 * 接口 [获取模块样式↗](https://yapi.gogpay.cn/project/1011/interface/api/227194) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getStyle`
 */
export interface ApiPageConfigDecorateGetStyleRequest {
  clientType?: '1' | '2'
  /**
   * 排序方向 asc=正序  desc=倒序
   */
  direction?: 'ASC' | 'DESC'
  headerChannel?: string[]
  /**
   * 组件模块Id
   */
  id: string
  /**
   * 内部数据Id，如分类返回的Id，用于查询分类下的数据
   */
  innerId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序方式  sales=销量  price=价格
   */
  sortType?: string
}

/**
 * 接口 [获取模块样式↗](https://yapi.gogpay.cn/project/1011/interface/api/227194) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getStyle`
 */
export interface ApiPageConfigDecorateGetStyleResponse {
  /**
   * 数据配置
   */
  data?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 组件Id，用于请求组件数据
   */
  id?: string
  /**
   * 样式配置
   */
  style?: {}
  /**
   * 组件类型
   */
  type?:
    | 'STORE_HEAD'
    | 'BANNER'
    | 'CLASSIFY'
    | 'IMAGE_LAYER'
    | 'COMMODITY_ROTATION'
    | 'COMMODITY_LAYER'
    | 'COMMODITY_FEED'
    | 'STORE_LABEL'
    | 'STORE_NOTICE'
    | 'STORE_DISCOUNT'
    | 'CUSTOM'
    | 'PAGE_HEAD'
    | 'CLASSIFY_COMMODITY'
    | 'CLASSIFY_FEED'
    | 'ACTIVITY_FEED'
    | 'SKILL_ACTIVITY'
    | 'MARKETING_SCENE'
    | 'DESCRIPTION'
    | 'ARTICLE_ITEM'
    | 'COUPON'
    | 'COMMODITY_DATA'
    | 'ROUTE_DATA'
    | 'COUPON_DATA'
    | 'CLASSIFY_DATA'
    | 'INDEX_NAVIGATE'
    | 'INDEX_SEARCH_BAR'
    | 'INDEX_ICON'
    | 'INDEX_AD'
    | 'INDEX_ROATION'
    | 'INDEX_SIDE_AD'
    | 'INDEX_FORE_AD'
    | 'INDEX_TAB_AD'
    | 'INDEX_BANNER'
    | 'INDEX_TWO_COL'
    | 'INDEX_TWO_COL_FORE_ITEM'
    | 'INDEX_LEFT_AD'
    | 'INDEX_TOW_THREE_ROW'
    | 'INDEX_FEEDS'
    | 'INDEX_SCRREN_AD'
    | 'HOTEL_ONE_BIG'
    | 'HOTEL_SEARCH_BAR'
    | 'HOTEL_STAGGERED'
    | 'HOTEL_LEFT_AD'
    | 'HOTEL_FEEDS'
    | 'TICKET_SEARCH_BAR'
    | 'TICKET_ICON'
    | 'TICKET_ROTATION'
    | 'TICKET_ROTATION_STORE_LIST'
    | 'TICKET_PIN'
    | 'TICKET_THREE_COL'
    | 'TICKET_FEEDS'
    | 'TICKET_AD'
    | 'COMMON_BANNER'
    | 'COMMON_LEFT_PIN'
    | 'COMMON_ROTATION_BIG'
    | 'COMMON_ROTATION_COMMODITY'
    | 'COMMON_ROTATION_LITTLE'
    | 'COMMON_SEVEN_AD'
    | 'COMMON_TAB_AD'
    | 'COMMON_TAB_COMMODITY'
    | 'COMMON_TAB_STORE_LIST'
    | 'COMMON_TOP_PIC'
    | 'COMMON_TWO_COL'
    | 'TRAVEL_SEARCH_BAR'
    | 'TRAVEL_MAP'
    | 'TRAVEL_LEFT_PIN'
    | 'TRAVEL_AD'
    | 'TRAVEL_TAB_SIX'
    | 'TRAVEL_ROTATION'
    | 'TRAVEL_FEEDS'
    | 'CUSTOM_TRAVEL_SEARCH_BAR'
    | 'CUSTOM_TRAVEL_TAB_AD'
    | 'CUSTOM_TRAVEL_FEEDS'
    | 'ACTIVITY_1_TOP_ROTATION'
    | 'ACTIVITY_1_AD'
    | 'ACTIVITY_1_STORE_LIST'
    | 'ACTIVITY_2_TOP_AD'
    | 'ACTIVITY_2_TAB_AD'
    | 'ACTIVITY_2_VIDEO_AD'
    | 'ACTIVITY_2_FEEDS'
    | 'ACTIVITY_3_TOP_AD'
    | 'ACTIVITY_3_COUPON'
    | 'ACTIVITY_3_FEEDS'
    | 'STORE_MAP'
    | 'STORE_ICON'
}

/**
 * 接口 [获取模块样式↗](https://yapi.gogpay.cn/project/1011/interface/api/227194) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getStyle`
 */
type ApiPageConfigDecorateGetStyleRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/decorate/getStyle',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取模块样式↗](https://yapi.gogpay.cn/project/1011/interface/api/227194) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getStyle`
 */
const apiPageConfigDecorateGetStyleRequestConfig: ApiPageConfigDecorateGetStyleRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/pageConfig/api/decorate/getStyle',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigDecorateGetStyle',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取模块样式', author: '成龙' },
  }

/**
 * 接口 [获取模块样式↗](https://yapi.gogpay.cn/project/1011/interface/api/227194) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/getStyle`
 */
export const apiPageConfigDecorateGetStyle = /*#__PURE__*/ (
  requestData: ApiPageConfigDecorateGetStyleRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigDecorateGetStyleResponse>(
    prepare(apiPageConfigDecorateGetStyleRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigDecorateGetStyle.requestConfig =
  apiPageConfigDecorateGetStyleRequestConfig

/**
 * 接口 [搜索数据模块↗](https://yapi.gogpay.cn/project/1011/interface/api/227694) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/searchData`
 */
export interface ApiPageConfigDecorateSearchDataRequest {
  clientType?: '1' | '2'
  /**
   * 排序方向 asc=正序  desc=倒序
   */
  direction?: 'ASC' | 'DESC'
  headerChannel?: string[]
  /**
   * 页面模板Id
   */
  id: string
  /**
   * 搜索词
   */
  keyword?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序方式  sales=销量  price=价格
   */
  sortType?: string
}

/**
 * 接口 [搜索数据模块↗](https://yapi.gogpay.cn/project/1011/interface/api/227694) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/searchData`
 */
export interface ApiPageConfigDecorateSearchDataResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [搜索数据模块↗](https://yapi.gogpay.cn/project/1011/interface/api/227694) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/searchData`
 */
type ApiPageConfigDecorateSearchDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/decorate/searchData',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [搜索数据模块↗](https://yapi.gogpay.cn/project/1011/interface/api/227694) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/searchData`
 */
const apiPageConfigDecorateSearchDataRequestConfig: ApiPageConfigDecorateSearchDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: '/pageConfig/api/decorate/searchData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigDecorateSearchData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '搜索数据模块', author: '成龙' },
  }

/**
 * 接口 [搜索数据模块↗](https://yapi.gogpay.cn/project/1011/interface/api/227694) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-装修配置↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_37950)
 * @请求头 `POST /pageConfig/api/decorate/searchData`
 */
export const apiPageConfigDecorateSearchData = /*#__PURE__*/ (
  requestData: ApiPageConfigDecorateSearchDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigDecorateSearchDataResponse>(
    prepare(apiPageConfigDecorateSearchDataRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigDecorateSearchData.requestConfig =
  apiPageConfigDecorateSearchDataRequestConfig

const mockUrl_0_1_0_9 = 'https://yapi.gogpay.cn/mock/1011' as any
const devUrl_0_1_0_9 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_1_0_9 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_1_0_9 = 'data' as any

/**
 * 接口 [中国红-获取酒店页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310562) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/hotelPage`
 */
export interface ApiPageConfigImsApiDecorateHotelPageRequest {
  /**
   * 敏感词
   */
  words?: string[]
}

/**
 * 接口 [中国红-获取酒店页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310562) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/hotelPage`
 */
export interface ApiPageConfigImsApiDecorateHotelPageResponse {
  /**
   * 组件列表
   */
  components: {
    /**
     * 数据配置
     */
    config?: {}
    /**
     * 数据
     */
    data?: {}
    /**
     * 组件名称
     */
    name?: string
    /**
     * 是否显示组件
     */
    show?: boolean
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 模板Id
   */
  id: string
  pageStyle?: {
    /**
     * 背景数据 (纯色：颜色值  图片：图片路径)
     */
    background: string
    /**
     * 整体背景 0 纯色：color 1 图片：URL
     */
    backgroundType: 0 | 1
    /**
     * 购物车按钮切图
     */
    cartButtonImage?: string
    /**
     * 自定义css
     */
    css?: string
    /**
     * 是否有悬浮购物车
     */
    hasCartButton?: boolean
    /**
     * 是否有悬浮指定
     */
    hasTopButton?: boolean
    /**
     * 页面名称
     */
    title: string
    /**
     * 置顶按钮切图
     */
    topButtonImage?: string
  }
}

/**
 * 接口 [中国红-获取酒店页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310562) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/hotelPage`
 */
type ApiPageConfigImsApiDecorateHotelPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/hotelPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中国红-获取酒店页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310562) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/hotelPage`
 */
const apiPageConfigImsApiDecorateHotelPageRequestConfig: ApiPageConfigImsApiDecorateHotelPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/hotelPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateHotelPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中国红-获取酒店页面配置', author: '成龙' },
  }

/**
 * 接口 [中国红-获取酒店页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310562) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/hotelPage`
 */
export const apiPageConfigImsApiDecorateHotelPage = /*#__PURE__*/ (
  requestData: ApiPageConfigImsApiDecorateHotelPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateHotelPageResponse>(
    prepare(apiPageConfigImsApiDecorateHotelPageRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigImsApiDecorateHotelPage.requestConfig =
  apiPageConfigImsApiDecorateHotelPageRequestConfig

/**
 * 接口 [中国红-获取首页页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310570) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/indexPage`
 */
export interface ApiPageConfigImsApiDecorateIndexPageRequest {
  /**
   * 敏感词
   */
  words?: string[]
}

/**
 * 接口 [中国红-获取首页页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310570) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/indexPage`
 */
export interface ApiPageConfigImsApiDecorateIndexPageResponse {
  /**
   * 组件列表
   */
  components: {
    /**
     * 数据配置
     */
    config?: {}
    /**
     * 数据
     */
    data?: {}
    /**
     * 组件名称
     */
    name?: string
    /**
     * 是否显示组件
     */
    show?: boolean
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 模板Id
   */
  id: string
  pageStyle?: {
    /**
     * 背景数据 (纯色：颜色值  图片：图片路径)
     */
    background: string
    /**
     * 整体背景 0 纯色：color 1 图片：URL
     */
    backgroundType: 0 | 1
    /**
     * 购物车按钮切图
     */
    cartButtonImage?: string
    /**
     * 自定义css
     */
    css?: string
    /**
     * 是否有悬浮购物车
     */
    hasCartButton?: boolean
    /**
     * 是否有悬浮指定
     */
    hasTopButton?: boolean
    /**
     * 页面名称
     */
    title: string
    /**
     * 置顶按钮切图
     */
    topButtonImage?: string
  }
}

/**
 * 接口 [中国红-获取首页页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310570) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/indexPage`
 */
type ApiPageConfigImsApiDecorateIndexPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/indexPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中国红-获取首页页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310570) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/indexPage`
 */
const apiPageConfigImsApiDecorateIndexPageRequestConfig: ApiPageConfigImsApiDecorateIndexPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/indexPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateIndexPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中国红-获取首页页面配置', author: '成龙' },
  }

/**
 * 接口 [中国红-获取首页页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/310570) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/indexPage`
 */
export const apiPageConfigImsApiDecorateIndexPage = /*#__PURE__*/ (
  requestData: ApiPageConfigImsApiDecorateIndexPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateIndexPageResponse>(
    prepare(apiPageConfigImsApiDecorateIndexPageRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigImsApiDecorateIndexPage.requestConfig =
  apiPageConfigImsApiDecorateIndexPageRequestConfig

/**
 * 接口 [中国红-获取门票页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/312842) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/ticketPage`
 */
export interface ApiPageConfigImsApiDecorateTicketPageRequest {
  /**
   * 敏感词
   */
  words?: string[]
}

/**
 * 接口 [中国红-获取门票页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/312842) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/ticketPage`
 */
export interface ApiPageConfigImsApiDecorateTicketPageResponse {
  /**
   * 组件列表
   */
  components: {
    /**
     * 数据配置
     */
    config?: {}
    /**
     * 数据
     */
    data?: {}
    /**
     * 组件名称
     */
    name?: string
    /**
     * 是否显示组件
     */
    show?: boolean
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 模板Id
   */
  id: string
  pageStyle?: {
    /**
     * 背景数据 (纯色：颜色值  图片：图片路径)
     */
    background: string
    /**
     * 整体背景 0 纯色：color 1 图片：URL
     */
    backgroundType: 0 | 1
    /**
     * 购物车按钮切图
     */
    cartButtonImage?: string
    /**
     * 自定义css
     */
    css?: string
    /**
     * 是否有悬浮购物车
     */
    hasCartButton?: boolean
    /**
     * 是否有悬浮指定
     */
    hasTopButton?: boolean
    /**
     * 页面名称
     */
    title: string
    /**
     * 置顶按钮切图
     */
    topButtonImage?: string
  }
}

/**
 * 接口 [中国红-获取门票页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/312842) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/ticketPage`
 */
type ApiPageConfigImsApiDecorateTicketPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/ticketPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中国红-获取门票页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/312842) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/ticketPage`
 */
const apiPageConfigImsApiDecorateTicketPageRequestConfig: ApiPageConfigImsApiDecorateTicketPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/ticketPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateTicketPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中国红-获取门票页面配置', author: '成龙' },
  }

/**
 * 接口 [中国红-获取门票页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/312842) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/ticketPage`
 */
export const apiPageConfigImsApiDecorateTicketPage = /*#__PURE__*/ (
  requestData: ApiPageConfigImsApiDecorateTicketPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateTicketPageResponse>(
    prepare(apiPageConfigImsApiDecorateTicketPageRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigImsApiDecorateTicketPage.requestConfig =
  apiPageConfigImsApiDecorateTicketPageRequestConfig

/**
 * 接口 [保存或修改装修配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313074) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents`
 */
export interface ApiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequest {
  /**
   * 组件列表
   */
  components: {
    /**
     * 数据配置
     */
    config?: {}
    /**
     * 数据
     */
    data?: {}
    /**
     * 组件名称
     */
    name?: string
    /**
     * 是否显示组件
     */
    show?: boolean
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 模板Id
   */
  id: string
  pageStyle?: {
    /**
     * 背景数据 (纯色：颜色值  图片：图片路径)
     */
    background: string
    /**
     * 整体背景 0 纯色：color 1 图片：URL
     */
    backgroundType: 0 | 1
    /**
     * 购物车按钮切图
     */
    cartButtonImage?: string
    /**
     * 自定义css
     */
    css?: string
    /**
     * 是否有悬浮购物车
     */
    hasCartButton?: boolean
    /**
     * 是否有悬浮指定
     */
    hasTopButton?: boolean
    /**
     * 页面名称
     */
    title: string
    /**
     * 置顶按钮切图
     */
    topButtonImage?: string
  }
}

/**
 * 接口 [保存或修改装修配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313074) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents`
 */
export interface ApiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [保存或修改装修配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313074) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents`
 */
type ApiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/1011',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [保存或修改装修配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313074) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents`
 */
const apiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequestConfig: ApiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiPageConfigImsApiDecorateMallPageAddOrUpdateComponents',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '保存或修改装修配置-中国红', author: '333号开发' },
  }

/**
 * 接口 [保存或修改装修配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313074) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateComponents`
 */
export const apiPageConfigImsApiDecorateMallPageAddOrUpdateComponents =
  /*#__PURE__*/ (
    requestData: ApiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsResponse>(
      prepare(
        apiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiPageConfigImsApiDecorateMallPageAddOrUpdateComponents.requestConfig =
  apiPageConfigImsApiDecorateMallPageAddOrUpdateComponentsRequestConfig

/**
 * 接口 [更改新增自定义模板配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313082) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate`
 */
export interface ApiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequest {
  /**
   * 页面模板id
   */
  id?: string
  /**
   * 页面名称
   */
  templateName: string
  /**
   * 模板类型
   */
  templateStyleType:
    | 'COMMON'
    | 'ACTIVITY_1'
    | 'ACTIVITY_2'
    | 'ACTIVITY_3'
    | 'TRAVEL'
    | 'CUSTOM_TRAVEL'
}

/**
 * 接口 [更改新增自定义模板配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313082) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate`
 */
export type ApiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateResponse =
  string

/**
 * 接口 [更改新增自定义模板配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313082) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate`
 */
type ApiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/1011',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [更改新增自定义模板配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313082) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate`
 */
const apiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequestConfig: ApiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiPageConfigImsApiDecorateMallPageAddOrUpdateTemplate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '更改新增自定义模板配置-中国红', author: '333号开发' },
  }

/**
 * 接口 [更改新增自定义模板配置-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313082) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/addOrUpdateTemplate`
 */
export const apiPageConfigImsApiDecorateMallPageAddOrUpdateTemplate =
  /*#__PURE__*/ (
    requestData: ApiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateResponse>(
      prepare(
        apiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiPageConfigImsApiDecorateMallPageAddOrUpdateTemplate.requestConfig =
  apiPageConfigImsApiDecorateMallPageAddOrUpdateTemplateRequestConfig

/**
 * 接口 [商城样式配置页面配置删除-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313090) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/delete`
 */
export interface ApiPageConfigImsApiDecorateMallPageDeleteRequest {
  /**
   * 页面模板id
   */
  id: string
}

/**
 * 接口 [商城样式配置页面配置删除-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313090) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/delete`
 */
export interface ApiPageConfigImsApiDecorateMallPageDeleteResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商城样式配置页面配置删除-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313090) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/delete`
 */
type ApiPageConfigImsApiDecorateMallPageDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/mallPage/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商城样式配置页面配置删除-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313090) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/delete`
 */
const apiPageConfigImsApiDecorateMallPageDeleteRequestConfig: ApiPageConfigImsApiDecorateMallPageDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/mallPage/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateMallPageDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '商城样式配置页面配置删除-中国红',
      author: '333号开发',
    },
  }

/**
 * 接口 [商城样式配置页面配置删除-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313090) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/delete`
 */
export const apiPageConfigImsApiDecorateMallPageDelete = /*#__PURE__*/ (
  requestData: ApiPageConfigImsApiDecorateMallPageDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateMallPageDeleteResponse>(
    prepare(
      apiPageConfigImsApiDecorateMallPageDeleteRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiPageConfigImsApiDecorateMallPageDelete.requestConfig =
  apiPageConfigImsApiDecorateMallPageDeleteRequestConfig

/**
 * 接口 [获取国定地址列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313098) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listFixUrl`
 */
export interface ApiPageConfigImsApiDecorateMallPageListFixUrlRequest {}

/**
 * 接口 [获取国定地址列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313098) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listFixUrl`
 */
export type ApiPageConfigImsApiDecorateMallPageListFixUrlResponse = {
  /**
   * 页面链接
   */
  linkUrl?: string
  /**
   * 页面模板名称
   */
  templateName?: string
}[]

/**
 * 接口 [获取国定地址列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313098) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listFixUrl`
 */
type ApiPageConfigImsApiDecorateMallPageListFixUrlRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/mallPage/listFixUrl',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取国定地址列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313098) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listFixUrl`
 */
const apiPageConfigImsApiDecorateMallPageListFixUrlRequestConfig: ApiPageConfigImsApiDecorateMallPageListFixUrlRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/mallPage/listFixUrl',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateMallPageListFixUrl',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取国定地址列表-中国红', author: '333号开发' },
  }

/**
 * 接口 [获取国定地址列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313098) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listFixUrl`
 */
export const apiPageConfigImsApiDecorateMallPageListFixUrl = /*#__PURE__*/ (
  requestData?: ApiPageConfigImsApiDecorateMallPageListFixUrlRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateMallPageListFixUrlResponse>(
    prepare(
      apiPageConfigImsApiDecorateMallPageListFixUrlRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiPageConfigImsApiDecorateMallPageListFixUrl.requestConfig =
  apiPageConfigImsApiDecorateMallPageListFixUrlRequestConfig

/**
 * 接口 [自定义模板列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313106) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listPersonalTemplate`
 */
export interface ApiPageConfigImsApiDecorateMallPageListPersonalTemplateRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 页面名称
   */
  templateName?: string
  /**
   * 模板类型（1-通用样式）
   */
  templateStyleType?: number
}

/**
 * 接口 [自定义模板列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313106) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listPersonalTemplate`
 */
export interface ApiPageConfigImsApiDecorateMallPageListPersonalTemplateResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 模板id
     */
    id?: string
    /**
     * 页面链接
     */
    linkUrl?: string
    /**
     * 模板类型
     */
    styleType?: string
    /**
     * 页面模板名称
     */
    templateName?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间人
     */
    updateTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [自定义模板列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313106) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listPersonalTemplate`
 */
type ApiPageConfigImsApiDecorateMallPageListPersonalTemplateRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/1011',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/pageConfig/imsApi/decorate/mallPage/listPersonalTemplate',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [自定义模板列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313106) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listPersonalTemplate`
 */
const apiPageConfigImsApiDecorateMallPageListPersonalTemplateRequestConfig: ApiPageConfigImsApiDecorateMallPageListPersonalTemplateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/mallPage/listPersonalTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiPageConfigImsApiDecorateMallPageListPersonalTemplate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '自定义模板列表-中国红', author: '333号开发' },
  }

/**
 * 接口 [自定义模板列表-中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/313106) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/mallPage/listPersonalTemplate`
 */
export const apiPageConfigImsApiDecorateMallPageListPersonalTemplate =
  /*#__PURE__*/ (
    requestData: ApiPageConfigImsApiDecorateMallPageListPersonalTemplateRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiPageConfigImsApiDecorateMallPageListPersonalTemplateResponse>(
      prepare(
        apiPageConfigImsApiDecorateMallPageListPersonalTemplateRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiPageConfigImsApiDecorateMallPageListPersonalTemplate.requestConfig =
  apiPageConfigImsApiDecorateMallPageListPersonalTemplateRequestConfig

/**
 * 接口 [中国红-获取定制游页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315578) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/customTravelPage`
 */
export interface ApiPageConfigImsApiDecorateCustomTravelPageRequest {
  /**
   * 敏感词
   */
  words?: string[]
}

/**
 * 接口 [中国红-获取定制游页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315578) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/customTravelPage`
 */
export interface ApiPageConfigImsApiDecorateCustomTravelPageResponse {
  /**
   * 组件列表
   */
  components: {
    /**
     * 数据配置
     */
    config?: {}
    /**
     * 数据
     */
    data?: {}
    /**
     * 组件名称
     */
    name?: string
    /**
     * 是否显示组件
     */
    show?: boolean
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 模板Id
   */
  id: string
  pageStyle?: {
    /**
     * 背景数据 (纯色：颜色值  图片：图片路径)
     */
    background: string
    /**
     * 整体背景 0 纯色：color 1 图片：URL
     */
    backgroundType: 0 | 1
    /**
     * 购物车按钮切图
     */
    cartButtonImage?: string
    /**
     * 自定义css
     */
    css?: string
    /**
     * 是否有悬浮购物车
     */
    hasCartButton?: boolean
    /**
     * 是否有悬浮指定
     */
    hasTopButton?: boolean
    /**
     * 页面名称
     */
    title: string
    /**
     * 置顶按钮切图
     */
    topButtonImage?: string
  }
}

/**
 * 接口 [中国红-获取定制游页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315578) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/customTravelPage`
 */
type ApiPageConfigImsApiDecorateCustomTravelPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/customTravelPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中国红-获取定制游页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315578) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/customTravelPage`
 */
const apiPageConfigImsApiDecorateCustomTravelPageRequestConfig: ApiPageConfigImsApiDecorateCustomTravelPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/customTravelPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateCustomTravelPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中国红-获取定制游页面配置', author: '333号开发' },
  }

/**
 * 接口 [中国红-获取定制游页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315578) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/customTravelPage`
 */
export const apiPageConfigImsApiDecorateCustomTravelPage = /*#__PURE__*/ (
  requestData: ApiPageConfigImsApiDecorateCustomTravelPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateCustomTravelPageResponse>(
    prepare(
      apiPageConfigImsApiDecorateCustomTravelPageRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiPageConfigImsApiDecorateCustomTravelPage.requestConfig =
  apiPageConfigImsApiDecorateCustomTravelPageRequestConfig

/**
 * 接口 [中国红-获取旅游胜地页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315586) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/travelPage`
 */
export interface ApiPageConfigImsApiDecorateTravelPageRequest {
  /**
   * 敏感词
   */
  words?: string[]
}

/**
 * 接口 [中国红-获取旅游胜地页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315586) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/travelPage`
 */
export interface ApiPageConfigImsApiDecorateTravelPageResponse {
  /**
   * 组件列表
   */
  components: {
    /**
     * 数据配置
     */
    config?: {}
    /**
     * 数据
     */
    data?: {}
    /**
     * 组件名称
     */
    name?: string
    /**
     * 是否显示组件
     */
    show?: boolean
    /**
     * 样式配置
     */
    style?: {}
    /**
     * 组件类型
     */
    type?:
      | 'STORE_HEAD'
      | 'BANNER'
      | 'CLASSIFY'
      | 'IMAGE_LAYER'
      | 'COMMODITY_ROTATION'
      | 'COMMODITY_LAYER'
      | 'COMMODITY_FEED'
      | 'STORE_LABEL'
      | 'STORE_NOTICE'
      | 'STORE_DISCOUNT'
      | 'CUSTOM'
      | 'PAGE_HEAD'
      | 'CLASSIFY_COMMODITY'
      | 'CLASSIFY_FEED'
      | 'ACTIVITY_FEED'
      | 'SKILL_ACTIVITY'
      | 'MARKETING_SCENE'
      | 'DESCRIPTION'
      | 'ARTICLE_ITEM'
      | 'COUPON'
      | 'COMMODITY_DATA'
      | 'ROUTE_DATA'
      | 'COUPON_DATA'
      | 'CLASSIFY_DATA'
      | 'INDEX_NAVIGATE'
      | 'INDEX_SEARCH_BAR'
      | 'INDEX_ICON'
      | 'INDEX_AD'
      | 'INDEX_ROATION'
      | 'INDEX_SIDE_AD'
      | 'INDEX_FORE_AD'
      | 'INDEX_TAB_AD'
      | 'INDEX_BANNER'
      | 'INDEX_TWO_COL'
      | 'INDEX_TWO_COL_FORE_ITEM'
      | 'INDEX_LEFT_AD'
      | 'INDEX_TOW_THREE_ROW'
      | 'INDEX_FEEDS'
      | 'INDEX_SCRREN_AD'
      | 'HOTEL_ONE_BIG'
      | 'HOTEL_SEARCH_BAR'
      | 'HOTEL_STAGGERED'
      | 'HOTEL_LEFT_AD'
      | 'HOTEL_FEEDS'
      | 'TICKET_SEARCH_BAR'
      | 'TICKET_ICON'
      | 'TICKET_ROTATION'
      | 'TICKET_ROTATION_STORE_LIST'
      | 'TICKET_PIN'
      | 'TICKET_THREE_COL'
      | 'TICKET_FEEDS'
      | 'TICKET_AD'
      | 'COMMON_BANNER'
      | 'COMMON_LEFT_PIN'
      | 'COMMON_ROTATION_BIG'
      | 'COMMON_ROTATION_COMMODITY'
      | 'COMMON_ROTATION_LITTLE'
      | 'COMMON_SEVEN_AD'
      | 'COMMON_TAB_AD'
      | 'COMMON_TAB_COMMODITY'
      | 'COMMON_TAB_STORE_LIST'
      | 'COMMON_TOP_PIC'
      | 'COMMON_TWO_COL'
      | 'TRAVEL_SEARCH_BAR'
      | 'TRAVEL_MAP'
      | 'TRAVEL_LEFT_PIN'
      | 'TRAVEL_AD'
      | 'TRAVEL_TAB_SIX'
      | 'TRAVEL_ROTATION'
      | 'TRAVEL_FEEDS'
      | 'CUSTOM_TRAVEL_SEARCH_BAR'
      | 'CUSTOM_TRAVEL_TAB_AD'
      | 'CUSTOM_TRAVEL_FEEDS'
      | 'ACTIVITY_1_TOP_ROTATION'
      | 'ACTIVITY_1_AD'
      | 'ACTIVITY_1_STORE_LIST'
      | 'ACTIVITY_2_TOP_AD'
      | 'ACTIVITY_2_TAB_AD'
      | 'ACTIVITY_2_VIDEO_AD'
      | 'ACTIVITY_2_FEEDS'
      | 'ACTIVITY_3_TOP_AD'
      | 'ACTIVITY_3_COUPON'
      | 'ACTIVITY_3_FEEDS'
      | 'STORE_MAP'
      | 'STORE_ICON'
  }[]
  /**
   * 模板Id
   */
  id: string
  pageStyle?: {
    /**
     * 背景数据 (纯色：颜色值  图片：图片路径)
     */
    background: string
    /**
     * 整体背景 0 纯色：color 1 图片：URL
     */
    backgroundType: 0 | 1
    /**
     * 购物车按钮切图
     */
    cartButtonImage?: string
    /**
     * 自定义css
     */
    css?: string
    /**
     * 是否有悬浮购物车
     */
    hasCartButton?: boolean
    /**
     * 是否有悬浮指定
     */
    hasTopButton?: boolean
    /**
     * 页面名称
     */
    title: string
    /**
     * 置顶按钮切图
     */
    topButtonImage?: string
  }
}

/**
 * 接口 [中国红-获取旅游胜地页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315586) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/travelPage`
 */
type ApiPageConfigImsApiDecorateTravelPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/imsApi/decorate/travelPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [中国红-获取旅游胜地页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315586) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/travelPage`
 */
const apiPageConfigImsApiDecorateTravelPageRequestConfig: ApiPageConfigImsApiDecorateTravelPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: '/pageConfig/imsApi/decorate/travelPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigImsApiDecorateTravelPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '中国红-获取旅游胜地页面配置', author: '333号开发' },
  }

/**
 * 接口 [中国红-获取旅游胜地页面配置↗](https://yapi.gogpay.cn/project/1011/interface/api/315586) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_53712)
 * @请求头 `POST /pageConfig/imsApi/decorate/travelPage`
 */
export const apiPageConfigImsApiDecorateTravelPage = /*#__PURE__*/ (
  requestData: ApiPageConfigImsApiDecorateTravelPageRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigImsApiDecorateTravelPageResponse>(
    prepare(apiPageConfigImsApiDecorateTravelPageRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigImsApiDecorateTravelPage.requestConfig =
  apiPageConfigImsApiDecorateTravelPageRequestConfig

const mockUrl_0_1_0_10 = 'https://yapi.gogpay.cn/mock/1011' as any
const devUrl_0_1_0_10 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_1_0_10 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_1_0_10 = 'data' as any

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/29125) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContent`
 */
export interface ApiPageConfigGetStateContentRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 资源位id
   */
  stateId: string
}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/29125) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContent`
 */
export interface ApiPageConfigGetStateContentResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/29125) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContent`
 */
type ApiPageConfigGetStateContentRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getStateContent',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/29125) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContent`
 */
const apiPageConfigGetStateContentRequestConfig: ApiPageConfigGetStateContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getStateContent',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetStateContent',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '页面配置->根据资源位ID获取资源内容',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/29125) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContent`
 */
export const apiPageConfigGetStateContent = /*#__PURE__*/ (
  requestData: ApiPageConfigGetStateContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetStateContentResponse>(
    prepare(apiPageConfigGetStateContentRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetStateContent.requestConfig =
  apiPageConfigGetStateContentRequestConfig

/**
 * 接口 [获取用户基本信息↗](https://yapi.gogpay.cn/project/1011/interface/api/31677) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userBaseInfo`
 */
export interface ApiPageConfigUserBaseInfoRequest {}

/**
 * 接口 [获取用户基本信息↗](https://yapi.gogpay.cn/project/1011/interface/api/31677) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userBaseInfo`
 */
export interface ApiPageConfigUserBaseInfoResponse {
  /**
   * 用户头像
   */
  avatar: string
  /**
   * 手机号
   */
  phoneNum: string
  /**
   * 用户昵称
   */
  userName: string
}

/**
 * 接口 [获取用户基本信息↗](https://yapi.gogpay.cn/project/1011/interface/api/31677) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userBaseInfo`
 */
type ApiPageConfigUserBaseInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/userBaseInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取用户基本信息↗](https://yapi.gogpay.cn/project/1011/interface/api/31677) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userBaseInfo`
 */
const apiPageConfigUserBaseInfoRequestConfig: ApiPageConfigUserBaseInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/userBaseInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigUserBaseInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户基本信息', author: '杨大鑫' },
  }

/**
 * 接口 [获取用户基本信息↗](https://yapi.gogpay.cn/project/1011/interface/api/31677) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userBaseInfo`
 */
export const apiPageConfigUserBaseInfo = /*#__PURE__*/ (
  requestData?: ApiPageConfigUserBaseInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigUserBaseInfoResponse>(
    prepare(apiPageConfigUserBaseInfoRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigUserBaseInfo.requestConfig = apiPageConfigUserBaseInfoRequestConfig

/**
 * 接口 [页面配置->黔南农投茅台商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/32277) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getQianNanMaoTaiHomeData`
 */
export interface ApiPageConfigGetQianNanMaoTaiHomeDataRequest {}

/**
 * 接口 [页面配置->黔南农投茅台商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/32277) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getQianNanMaoTaiHomeData`
 */
export interface ApiPageConfigGetQianNanMaoTaiHomeDataResponse {
  /**
   * 商品类目
   */
  commodityCategory: {
    /**
     * 类目ID
     */
    categoryIds: string[]
    /**
     * 类目标题
     */
    title: string
  }[]
  /**
   * 中部热门商品，左侧轮播
   */
  hotCommodityLeft: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 中部热门商品，右侧商品
   */
  hotCommodityRight: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 茅台商品ID
   */
  mtCommodityId: string
  /**
   * 底部推荐商品
   */
  recommendCommodity: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
}

/**
 * 接口 [页面配置->黔南农投茅台商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/32277) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getQianNanMaoTaiHomeData`
 */
type ApiPageConfigGetQianNanMaoTaiHomeDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getQianNanMaoTaiHomeData',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [页面配置->黔南农投茅台商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/32277) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getQianNanMaoTaiHomeData`
 */
const apiPageConfigGetQianNanMaoTaiHomeDataRequestConfig: ApiPageConfigGetQianNanMaoTaiHomeDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getQianNanMaoTaiHomeData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetQianNanMaoTaiHomeData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '页面配置->黔南农投茅台商城首页数据',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [页面配置->黔南农投茅台商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/32277) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getQianNanMaoTaiHomeData`
 */
export const apiPageConfigGetQianNanMaoTaiHomeData = /*#__PURE__*/ (
  requestData?: ApiPageConfigGetQianNanMaoTaiHomeDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetQianNanMaoTaiHomeDataResponse>(
    prepare(apiPageConfigGetQianNanMaoTaiHomeDataRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetQianNanMaoTaiHomeData.requestConfig =
  apiPageConfigGetQianNanMaoTaiHomeDataRequestConfig

/**
 * 接口 [页面配置->数字贵州消费券商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/35489) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getDataGzCouponHomeData`
 */
export interface ApiPageConfigGetDataGzCouponHomeDataRequest {}

/**
 * 接口 [页面配置->数字贵州消费券商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/35489) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getDataGzCouponHomeData`
 */
export interface ApiPageConfigGetDataGzCouponHomeDataResponse {
  /**
   * 精选好物
   */
  boutiqueRecommend: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 商品推荐
   */
  commodityRecommend: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 5G专场服务
   */
  fivegService: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 金刚区固定服务
   */
  fixedService: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  hotRecommend: {
    /**
     * 主广告
     */
    mainAd: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
    /**
     * 副广告
     */
    subAd: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
  }
  /**
   * 旅游广告
   */
  travelAd: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
}

/**
 * 接口 [页面配置->数字贵州消费券商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/35489) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getDataGzCouponHomeData`
 */
type ApiPageConfigGetDataGzCouponHomeDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getDataGzCouponHomeData',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [页面配置->数字贵州消费券商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/35489) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getDataGzCouponHomeData`
 */
const apiPageConfigGetDataGzCouponHomeDataRequestConfig: ApiPageConfigGetDataGzCouponHomeDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getDataGzCouponHomeData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetDataGzCouponHomeData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '页面配置->数字贵州消费券商城首页数据',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [页面配置->数字贵州消费券商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/35489) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getDataGzCouponHomeData`
 */
export const apiPageConfigGetDataGzCouponHomeData = /*#__PURE__*/ (
  requestData?: ApiPageConfigGetDataGzCouponHomeDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetDataGzCouponHomeDataResponse>(
    prepare(apiPageConfigGetDataGzCouponHomeDataRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetDataGzCouponHomeData.requestConfig =
  apiPageConfigGetDataGzCouponHomeDataRequestConfig

/**
 * 接口 [页面配置->根据资源位ID获取资源内容（走3.0分发）↗](https://yapi.gogpay.cn/project/1011/interface/api/56330) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContentByApp`
 */
export interface ApiPageConfigGetStateContentByAppRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 资源位id
   */
  stateId: string
}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容（走3.0分发）↗](https://yapi.gogpay.cn/project/1011/interface/api/56330) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContentByApp`
 */
export interface ApiPageConfigGetStateContentByAppResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容（走3.0分发）↗](https://yapi.gogpay.cn/project/1011/interface/api/56330) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContentByApp`
 */
type ApiPageConfigGetStateContentByAppRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getStateContentByApp',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [页面配置->根据资源位ID获取资源内容（走3.0分发）↗](https://yapi.gogpay.cn/project/1011/interface/api/56330) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContentByApp`
 */
const apiPageConfigGetStateContentByAppRequestConfig: ApiPageConfigGetStateContentByAppRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getStateContentByApp',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetStateContentByApp',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '页面配置->根据资源位ID获取资源内容（走3.0分发）',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [页面配置->根据资源位ID获取资源内容（走3.0分发）↗](https://yapi.gogpay.cn/project/1011/interface/api/56330) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateContentByApp`
 */
export const apiPageConfigGetStateContentByApp = /*#__PURE__*/ (
  requestData: ApiPageConfigGetStateContentByAppRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetStateContentByAppResponse>(
    prepare(apiPageConfigGetStateContentByAppRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetStateContentByApp.requestConfig =
  apiPageConfigGetStateContentByAppRequestConfig

/**
 * 接口 [页面配置->省内版商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/62152) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeData`
 */
export interface ApiPageConfigGetGuiZhouMallHomeDataRequest {}

/**
 * 接口 [页面配置->省内版商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/62152) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeData`
 */
export interface ApiPageConfigGetGuiZhouMallHomeDataResponse {
  /**
   * 专题
   */
  feedTab: {
    /**
     * tab id，这里等同于商品专题ID
     */
    id: string
    /**
     * 商品列表
     */
    list: {
      /**
       * 仅当isValidDay=0有效，需要提前x天预约购买
       */
      advanceDay?: number
      /**
       * 商品自动下架日期
       */
      autoDownDate?: string
      /**
       * 起售数量
       */
      beginSaleQuantity?: number
      /**
       * 轮播图
       */
      carousePic?: string[]
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券
       */
      commodityClassifyType?: '0' | '1'
      /**
       * 商品合同标题
       */
      commodityContractTitle?: string
      /**
       * 商品ID
       */
      commodityId?: string
      /**
       * 商品标签
       */
      commodityLabel?: string[]
      /**
       * 商品参数json
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 商品规格
       */
      commoditySpecs?: {
        /**
         * sku属性名称
         */
        attributeName: string
        /**
         * 属性下拉参数
         */
        options: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 选中下拉参数
         */
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * sku属性ID
         */
        skuAttributeId: string
      }[]
      /**
       * 商品副标题
       */
      commoditySubTitle?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
       */
      commodityTradeType?: number
      /**
       * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
       */
      commodityType?: number
      /**
       * 优惠券列表
       */
      couponList?: string[]
      /**
       * 封面图
       */
      coverPic?: string
      /**
       * 划线价格
       */
      dashPrice?: number
      /**
       * 配送地址
       */
      deliveryAddress?: string
      /**
       * 配送地址类型：0-黑名单 1-白名单
       */
      deliveryAddressType?: 0 | 1
      deliveryCommodity: {
        /**
         * 封面标签
         */
        coverLabel?: string
        /**
         * 是否支持售后：0-否 1-是
         */
        isAfterSales?: 0 | 1
        multipleSku?: boolean
        /**
         * 规格列表
         */
        skuList?: {
          /**
           * 商品ID
           */
          commodityId: string
          /**
           * SKU唯一参数标识
           */
          skuId: string
        }[]
        /**
         * 包装费用
         */
        wrapPrice?: number
      }
      /**
       * 使用渠道多选：0-TV 1-移动端
       */
      distributeChannel?: number[]
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      hotelCommodity: {
        /**
         * 仅当isValidDay=0有效，需要提前x天预约购买
         */
        advanceDay?: number
        /**
         * 商品种类：0-套餐券
         */
        commodityClassifyType?: '0' | '1'
        /**
         * 是否实名：0-否 1-是
         */
        isAuth: 0 | 1
        /**
         * 是否当日有效：0-否 1-是
         */
        isValidDay?: 0 | 1
        /**
         * 购买须知信息
         */
        purchaseNotesDetail: string
        /**
         * 规格列表
         */
        skuList?: {
          /**
           * 默认展示：0-否 1-是
           */
          defaultShow: number
          endTime?: {
            hour?: number
            minute?: number
            nano?: number
            second?: number
          }
          /**
           * 初始库存
           */
          initStock: number
          /**
           * 单次核销价格
           */
          onePrice: number
          /**
           * 商品ID
           */
          refCommodityId: string
          /**
           * 店铺主键
           */
          refMerchantId: string
          /**
           * 销量
           */
          sales?: number
          /**
           * 商品售价
           */
          sellPrice: number
          /**
           * 结算方式：0-固定金额 1-分层比例
           */
          settlementType: 0 | 1
          /**
           * 结算值
           */
          settlementValue: number
          /**
           * 规格ID
           */
          skuId: string
          /**
           * SKU图
           */
          skuPic: string
          /**
           * 规格状态： 0-无效 1-有效
           */
          skuStatus: 0 | 1
          startTime?: {
            hour?: number
            minute?: number
            nano?: number
            second?: number
          }
          /**
           * 库存日期
           */
          stockDate?: string
          /**
           * 库存ID:第三方下单需要，非第三方和skuId一致
           */
          stockId: string
          /**
           * 剩余库存
           */
          surplusStock: number
          /**
           * 可核销次数
           */
          writeOffNum: number
        }[]
        /**
         * 库存类型： 0-标准库存 3-日期库存 5-时段库存
         */
        stockType: number
        /**
         * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
         */
        writeOffChannel:
          | '0'
          | '1'
          | '2'
          | '3'
          | '4'
          | '5'
          | '6'
          | '7'
          | '8'
          | '9'
        /**
         * 核销渠道商品ID
         */
        writeOffChannelCommodityId: string
        /**
         * 套餐详情
         */
        writeOffCombos?: {
          /**
           * 分组详情列表
           */
          groupDetails?: {
            /**
             * 数量
             */
            num?: number
            /**
             * 价格
             */
            price?: number
            /**
             * 服务名称
             */
            serviceName?: string
          }[]
          /**
           * 分组名称
           */
          groupName?: string
        }[]
        writeOffRefund?: {
          /**
           * 过期后退款比例
           */
          expireRate?: number
          /**
           * 退款无需审批
           */
          notApproveFlag?: boolean
          /**
           * 未使用退款比例
           */
          unusedRate?: number
        }
        /**
         * 购买xxx天内有效
         */
        writeOffValidDay?: number
        /**
         * 核销有效期结束时间
         */
        writeOffValidEndTime?: string
        /**
         * 核销有效期开始时间
         */
        writeOffValidStartTime?: string
        /**
         * 核销有效期类型：0-相对时间 1-固定时间
         */
        writeOffValidType?: '0' | '1' | '2' | '3'
      }
      /**
       * 是否支持售后：0-否 1-是
       */
      isAfterSales?: 0 | 1
      /**
       * 是否推荐商品： 0-否 1-是
       */
      isRecommend: 0 | 1
      /**
       * 是否当日有效：0-否 1-是
       */
      isValidDay?: 0 | 1
      /**
       * 核销类组合商品信息
       */
      jointChildWriteOffCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 最低价
       */
      lowestPrice?: number
      /**
       * 所属商城ID
       */
      martId?: string
      /**
       * 商户ID
       */
      merchantId?: string
      /**
       * 商户名称
       */
      merchantName?: string
      /**
       * 不配送地址
       */
      noDeliveryAddress?: string
      /**
       * 包邮类型: 1-包邮 2-运费模板
       */
      postType?: number
      /**
       * 预览路由
       */
      previewUrl?: string
      /**
       * 最低价(2.0之后用lowestPrice代替)
       */
      price?: number
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 购买须知信息
       */
      purchaseNotesDetail: string
      /**
       * 购买须知ID
       */
      purchaseNotesId?: string
      /**
       * 类目ID
       */
      refCategoryId?: string
      /**
       * 运费模板ID
       */
      refDeliverTemplateId?: string
      /**
       * 运营渠道Id
       */
      refUserGroupId?: string
      /**
       * 售后服务: 1-换货  2-仅退款 3-退货退款
       */
      saleAfterServiceType?: number[]
      saleAfterServiceTypeSwitch?: {
        /**
         * 是否关闭换货申请 0-否 1-是
         */
        exchangeCloseFlag?: number
        /**
         * 是否关闭退货退款申请 0-否 1-是
         */
        refundAndReturnCloseFlag?: number
        /**
         * 是否关闭仅退款申请 0-否 1-是
         */
        refundOnlyCloseFlag?: number
      }
      /**
       * 销量
       */
      sales?: number
      /**
       * 搜索词
       */
      searchWord?: string[]
      /**
       * 价格区间
       */
      sellPrices?: number[]
      /**
       * 发货类型 0-快递发货 1-同城配送 2-到店自提
       */
      shippingType?: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases?: number
      /**
       * 发货/服务（小时内）时间
       */
      sippingOrServiceTime?: number
      /**
       * 标电，虚拟商品规格详情
       */
      skuList?: {
        /**
         * 商品ID
         */
        commodityId: string
        /**
         * 成本价
         */
        commoditySkuCost: number
        /**
         * SKU价格
         */
        commoditySkuPrice: number
        /**
         * 默认展示：0-否 1-是
         */
        defaultShow: number
        /**
         * 商品单日限购量（0不限制）
         */
        singleDayLimitPurchases: number
        /**
         * SKU唯一参数标识
         */
        skuId: string
        /**
         * SKU商品图
         */
        skuPic: string
        /**
         * sku规格
         */
        skuSpecs: {
          /**
           * sku属性名称
           */
          attributeName?: string
          selected: {
            /**
             * 参数ID
             */
            id: string
            /**
             * 参数键(2.0废弃)
             */
            key?: string
            /**
             * 参数值
             */
            value: string
          }
          /**
           * sku属性ID
           */
          skuAttributeId?: string
        }[]
        /**
         * SKU状态:0-无效 1-有效
         */
        skuStatus: number
        /**
         * 用户单日限购量（0不限制）
         */
        userDayLimitPurchases: number
        /**
         * 重量(千克)
         */
        weight: number
      }[]
      /**
       * 标销商品规格详情
       */
      skuListWriteOff?: {
        /**
         * 库存
         */
        commodityStock: number
        /**
         * 默认展示：0-否 1-是
         */
        defaultShow: number
        /**
         * 单次核销价格
         */
        onePrice: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType: number
        /**
         * 结算值
         */
        settlementValue: number
        /**
         * 商品单日限购量
         */
        singleDayLimitPurchases: number
        /**
         * 规格ID
         */
        skuId?: string
        /**
         * SKU图
         */
        skuPic: string
        /**
         * 规格状态： 0-无效 1-有效
         */
        skuStatus: number
        /**
         * 规格名称
         */
        specName: string
        /**
         * 规格值
         */
        specValue: string
        /**
         * 库存日期
         */
        stockDate: string
        /**
         * 库存类型：0-标准库存 3-日期库存
         */
        stockType: number
        /**
         * 用户单日限购量
         */
        userDayLimitPurchases: number
        /**
         * 用户限购
         */
        userLimitPurchases: number
        /**
         * 可核销次数
         */
        writeOffNum: number
      }[]
      /**
       * 库存预警
       */
      stockAlertCount?: number
      /**
       * 库存类型： 0-标准库存 3-日期库存 5-时段库存
       */
      stockType: number
      /**
       * 是否支持积分支付
       */
      supportIntegral?: boolean
      taxRateDetail?: {
        /**
         * 税率名称
         */
        taxName: string
        /**
         * 税率编号
         */
        taxNo: string
        /**
         * 税率
         */
        taxRate: string
      }
      /**
       * 是否涉税：0-否 1-是
       */
      texFlag?: number
      travelCommodity: {
        /**
         * 仅当isValidDay=0有效，需要提前x天预约购买
         */
        advanceDay?: number
        /**
         * 商品种类：0-套餐券
         */
        commodityClassifyType?: '0' | '1'
        /**
         * 是否实名：0-否 1-是
         */
        isAuth: 0 | 1
        /**
         * 是否当日有效：0-否 1-是
         */
        isValidDay?: 0 | 1
        /**
         * 购买须知信息
         */
        purchaseNotesDetail: string
        /**
         * 规格列表
         */
        skuList?: {
          /**
           * 默认展示：0-否 1-是
           */
          defaultShow: number
          endTime?: {
            hour?: number
            minute?: number
            nano?: number
            second?: number
          }
          /**
           * 初始库存
           */
          initStock: number
          /**
           * 单次核销价格
           */
          onePrice: number
          /**
           * 商品ID
           */
          refCommodityId: string
          /**
           * 店铺主键
           */
          refMerchantId: string
          /**
           * 销量
           */
          sales?: number
          /**
           * 商品售价
           */
          sellPrice: number
          /**
           * 结算方式：0-固定金额 1-分层比例
           */
          settlementType: 0 | 1
          /**
           * 结算值
           */
          settlementValue: number
          /**
           * 规格ID
           */
          skuId: string
          /**
           * SKU图
           */
          skuPic: string
          /**
           * 规格状态： 0-无效 1-有效
           */
          skuStatus: 0 | 1
          startTime?: {
            hour?: number
            minute?: number
            nano?: number
            second?: number
          }
          /**
           * 库存日期
           */
          stockDate?: string
          /**
           * 库存ID:第三方下单需要，非第三方和skuId一致
           */
          stockId: string
          /**
           * 剩余库存
           */
          surplusStock: number
          /**
           * 可核销次数
           */
          writeOffNum: number
        }[]
        /**
         * 库存类型： 0-标准库存 3-日期库存 5-时段库存
         */
        stockType: number
        /**
         * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
         */
        writeOffChannel:
          | '0'
          | '1'
          | '2'
          | '3'
          | '4'
          | '5'
          | '6'
          | '7'
          | '8'
          | '9'
        /**
         * 核销渠道商品ID
         */
        writeOffChannelCommodityId: string
        /**
         * 套餐详情
         */
        writeOffCombos?: {
          /**
           * 分组详情列表
           */
          groupDetails?: {
            /**
             * 数量
             */
            num?: number
            /**
             * 价格
             */
            price?: number
            /**
             * 服务名称
             */
            serviceName?: string
          }[]
          /**
           * 分组名称
           */
          groupName?: string
        }[]
        writeOffRefund?: {
          /**
           * 过期后退款比例
           */
          expireRate?: number
          /**
           * 退款无需审批
           */
          notApproveFlag?: boolean
          /**
           * 未使用退款比例
           */
          unusedRate?: number
        }
        /**
         * 购买xxx天内有效
         */
        writeOffValidDay?: number
        /**
         * 核销有效期结束时间
         */
        writeOffValidEndTime?: string
        /**
         * 核销有效期开始时间
         */
        writeOffValidStartTime?: string
        /**
         * 核销有效期类型：0-相对时间 1-固定时间
         */
        writeOffValidType?: '0' | '1' | '2' | '3'
      }
      /**
       * TV轮播图
       */
      tvCarousePic?: string[]
      /**
       * TV封面图
       */
      tvCoverPic?: string
      /**
       * 店铺机构编码
       */
      unitOrgCode?: string
      /**
       * 上下架状态 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 上架时间
       */
      upShelfTime?: string
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases?: number
      /**
       * 用户限购
       */
      userLimitPurchases?: number
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      writeOffRefund?: {
        /**
         * 过期后退款比例
         */
        expireRate?: number
        /**
         * 退款无需审批
         */
        notApproveFlag?: boolean
        /**
         * 未使用退款比例
         */
        unusedRate?: number
      }
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期类型：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 子标题
     */
    subTitle: string
    /**
     * 标题
     */
    title: string
  }[]
  /**
   * 金刚区固定服务
   */
  fixedService: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  floatWindow: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }
  marketing: {
    /**
     * 活动
     */
    activity: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
    /**
     * 左侧banner
     */
    banner: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
    /**
     * 秒杀
     */
    seckill: {
      /**
       * 原价
       */
      amt?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 嵌套资源位资源信息
       */
      childList?: unknown[]
      /**
       * 优惠价格
       */
      discountAmt?: string
      /**
       * 区划id
       */
      divisionId?: string
      /**
       * 区划名称
       */
      divisionName?: string
      /**
       * 扩展数据
       */
      extendData?: {}
      /**
       * 服务图标
       */
      icon?: string
      /**
       * 服务图标(高度)
       */
      iconHeight?: number
      /**
       * 服务图标(宽度)
       */
      iconWidth?: number
      /**
       * 资源ID
       */
      id: string
      /**
       * 专区id（商品专用）
       */
      regionId?: string
      /**
       * 拓展字段
       */
      remark?: {
        /**
         * 自由字段键
         */
        name?: string
        /**
         * 自由字段值
         */
        value?: string
      }[]
      /**
       * 自由字段键值对
       */
      remarkMap?: {}
      /**
       * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
       */
      resType?: string
      /**
       * 根类目ID
       */
      rootCategoryId?: string
      /**
       * 根类目名称
       */
      rootCategoryIdMsg?: string
      /**
       * 销量
       */
      sales?: number
      /**
       * 资源位ID
       */
      stateId: string
      /**
       * 资源位名称
       */
      stateName?: string
      /**
       * 分发系统算法ID
       */
      strategyId?: string
      /**
       * 分发系统算法名称
       */
      strategyName?: string
      /**
       * 副标题
       */
      subTitle?: string
      /**
       * 标签数据
       */
      tags?: string[]
      /**
       * 路由
       */
      targetUrl?: string
      /**
       * 主标题
       */
      title?: string
      /**
       * 版本号
       */
      version?: number
    }[]
  }
}

/**
 * 接口 [页面配置->省内版商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/62152) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeData`
 */
type ApiPageConfigGetGuiZhouMallHomeDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getGuiZhouMallHomeData',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [页面配置->省内版商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/62152) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeData`
 */
const apiPageConfigGetGuiZhouMallHomeDataRequestConfig: ApiPageConfigGetGuiZhouMallHomeDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getGuiZhouMallHomeData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetGuiZhouMallHomeData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '页面配置->省内版商城首页数据', author: '杨大鑫' },
  }

/**
 * 接口 [页面配置->省内版商城首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/62152) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeData`
 */
export const apiPageConfigGetGuiZhouMallHomeData = /*#__PURE__*/ (
  requestData?: ApiPageConfigGetGuiZhouMallHomeDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetGuiZhouMallHomeDataResponse>(
    prepare(apiPageConfigGetGuiZhouMallHomeDataRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetGuiZhouMallHomeData.requestConfig =
  apiPageConfigGetGuiZhouMallHomeDataRequestConfig

/**
 * 接口 [【源位分组】获取资源位分组下的所有资源位列表↗](https://yapi.gogpay.cn/project/1011/interface/api/119632) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupList`
 */
export interface ApiPageConfigGetStateGroupListRequest {
  /**
   * 资源位分类的深度
   */
  level?: number
  /**
   * 资源位分组id
   */
  stateGroupId?: string
  /**
   * 分类 0 分组 ， 1 资源位
   */
  type?: number
}

/**
 * 接口 [【源位分组】获取资源位分组下的所有资源位列表↗](https://yapi.gogpay.cn/project/1011/interface/api/119632) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupList`
 */
export interface ApiPageConfigGetStateGroupListResponse {
  stateGroupDetail?: {
    /**
     * 背景图片
     */
    backGroundImg: string
    /**
     * 资源位分组id
     */
    stateGroupId: string
  }
  /**
   * 资源位分组id
   */
  stateGroupId?: string
  /**
   * 资源位分组中的节点详情
   */
  stateGroupInfo?: {
    /**
     * 节点名称
     */
    categoryName?: string
    /**
     * 当前节点是分类还是资源位 0 分类，1 资源位
     */
    categoryType?: number
    /**
     * 节点类型文案
     */
    categoryTypeText?: string
    /**
     * 资源位分组中的节点id
     */
    id?: string
    /**
     * 父级id
     */
    parentId?: string
    /**
     * 节点封面图
     */
    picUrl?: string
    /**
     * 自由字段
     */
    remarkField?: {}
    /**
     * 根类目id
     */
    rootParentId?: string
    /**
     * 资源位中的排序
     */
    serialNumber?: number
    /**
     * 资源位id
     */
    stateId?: string
  }[]
}

/**
 * 接口 [【源位分组】获取资源位分组下的所有资源位列表↗](https://yapi.gogpay.cn/project/1011/interface/api/119632) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupList`
 */
type ApiPageConfigGetStateGroupListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getStateGroupList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【源位分组】获取资源位分组下的所有资源位列表↗](https://yapi.gogpay.cn/project/1011/interface/api/119632) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupList`
 */
const apiPageConfigGetStateGroupListRequestConfig: ApiPageConfigGetStateGroupListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getStateGroupList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetStateGroupList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '【源位分组】获取资源位分组下的所有资源位列表',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [【源位分组】获取资源位分组下的所有资源位列表↗](https://yapi.gogpay.cn/project/1011/interface/api/119632) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupList`
 */
export const apiPageConfigGetStateGroupList = /*#__PURE__*/ (
  requestData: ApiPageConfigGetStateGroupListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetStateGroupListResponse>(
    prepare(apiPageConfigGetStateGroupListRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetStateGroupList.requestConfig =
  apiPageConfigGetStateGroupListRequestConfig

/**
 * 接口 [【源位分组】查询资源位分组中资源位的相关数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119638) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupResource`
 */
export interface ApiPageConfigGetStateGroupResourceRequest {
  /**
   * 资源中的节点id
   */
  categoryId?: string
  /**
   * 用户所在纬度
   */
  latitude?: string
  /**
   * 用户所在经度
   */
  longitude?: string
  /**
   * 当前页码
   */
  pageIndex?: number
  /**
   * 分页大小
   */
  pageSize?: number
  /**
   * 排序类型1：升序 2 降序
   */
  sequenceType?: number
  /**
   * 排序: 000001[推荐], 000002[距离],000003[价格],000004[评价],000005[销量]
   */
  sortType?: string
  /**
   * 资源位分组id
   */
  stateGroupId?: string
  /**
   * 资源位分组中的资源位id数组
   */
  stateIds?: string[]
}

/**
 * 接口 [【源位分组】查询资源位分组中资源位的相关数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119638) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupResource`
 */
export interface ApiPageConfigGetStateGroupResourceResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 类目
     */
    categoryId?: string
    /**
     * 策略id
     */
    decisionId?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 自定义的扩展字段
     */
    extendsField?: {}
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 划线价
     */
    markPrice?: number
    /**
     * 图片url
     */
    picUrl?: string
    /**
     * 价格
     */
    price?: number
    /**
     * 拓展字段
     */
    remark?: string
    /**
     * 自由字段映射
     */
    remarkMap?: {}
    /**
     * 资源类型 01商品 02功能 03专题 04专区 05广告 06商品规格 07资讯
     */
    resType?: string
    /**
     * 资源Id
     */
    resourceId?: string
    /**
     * 资源来源
     */
    resourceSource?: string
    /**
     * 根类目
     */
    rootCategoryId?: string
    /**
     * 类型
     */
    rootCategoryIdMsg?: string
    /**
     * 资源路由
     */
    routeUrl?: string
    /**
     * 销量
     */
    sales?: string
    /**
     * 资源位Id
     */
    stateId?: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法id
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [【源位分组】查询资源位分组中资源位的相关数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119638) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupResource`
 */
type ApiPageConfigGetStateGroupResourceRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getStateGroupResource',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【源位分组】查询资源位分组中资源位的相关数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119638) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupResource`
 */
const apiPageConfigGetStateGroupResourceRequestConfig: ApiPageConfigGetStateGroupResourceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getStateGroupResource',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetStateGroupResource',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '【源位分组】查询资源位分组中资源位的相关数据',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [【源位分组】查询资源位分组中资源位的相关数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119638) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getStateGroupResource`
 */
export const apiPageConfigGetStateGroupResource = /*#__PURE__*/ (
  requestData: ApiPageConfigGetStateGroupResourceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetStateGroupResourceResponse>(
    prepare(apiPageConfigGetStateGroupResourceRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetStateGroupResource.requestConfig =
  apiPageConfigGetStateGroupResourceRequestConfig

/**
 * 接口 [【TV】家庭购物首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119644) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getTvMallHomeData`
 */
export interface ApiPageConfigGetTvMallHomeDataRequest {}

/**
 * 接口 [【TV】家庭购物首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119644) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getTvMallHomeData`
 */
export interface ApiPageConfigGetTvMallHomeDataResponse {
  /**
   * banner
   */
  banner?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 分类
   */
  classify?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 热销榜
   */
  hotSale?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 推荐商品
   */
  recommendGoods?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
}

/**
 * 接口 [【TV】家庭购物首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119644) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getTvMallHomeData`
 */
type ApiPageConfigGetTvMallHomeDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getTvMallHomeData',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [【TV】家庭购物首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119644) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getTvMallHomeData`
 */
const apiPageConfigGetTvMallHomeDataRequestConfig: ApiPageConfigGetTvMallHomeDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getTvMallHomeData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetTvMallHomeData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【TV】家庭购物首页数据', author: '杨大鑫' },
  }

/**
 * 接口 [【TV】家庭购物首页数据↗](https://yapi.gogpay.cn/project/1011/interface/api/119644) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getTvMallHomeData`
 */
export const apiPageConfigGetTvMallHomeData = /*#__PURE__*/ (
  requestData?: ApiPageConfigGetTvMallHomeDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetTvMallHomeDataResponse>(
    prepare(apiPageConfigGetTvMallHomeDataRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetTvMallHomeData.requestConfig =
  apiPageConfigGetTvMallHomeDataRequestConfig

/**
 * 接口 [省内版商城首页数据V212↗](https://yapi.gogpay.cn/project/1011/interface/api/123452) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeDataV212`
 */
export interface ApiPageConfigGetGuiZhouMallHomeDataV212Request {}

/**
 * 接口 [省内版商城首页数据V212↗](https://yapi.gogpay.cn/project/1011/interface/api/123452) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeDataV212`
 */
export interface ApiPageConfigGetGuiZhouMallHomeDataV212Response {
  /**
   * 活动区域
   */
  activity: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 分类
   */
  classify: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 金刚区
   */
  fixed: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 商品类表
   */
  goodsList: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 热销榜
   */
  hotSale: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
}

/**
 * 接口 [省内版商城首页数据V212↗](https://yapi.gogpay.cn/project/1011/interface/api/123452) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeDataV212`
 */
type ApiPageConfigGetGuiZhouMallHomeDataV212RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/getGuiZhouMallHomeDataV212',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [省内版商城首页数据V212↗](https://yapi.gogpay.cn/project/1011/interface/api/123452) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeDataV212`
 */
const apiPageConfigGetGuiZhouMallHomeDataV212RequestConfig: ApiPageConfigGetGuiZhouMallHomeDataV212RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/getGuiZhouMallHomeDataV212',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigGetGuiZhouMallHomeDataV212',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '省内版商城首页数据V212', author: '杨大鑫' },
  }

/**
 * 接口 [省内版商城首页数据V212↗](https://yapi.gogpay.cn/project/1011/interface/api/123452) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/getGuiZhouMallHomeDataV212`
 */
export const apiPageConfigGetGuiZhouMallHomeDataV212 = /*#__PURE__*/ (
  requestData?: ApiPageConfigGetGuiZhouMallHomeDataV212Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigGetGuiZhouMallHomeDataV212Response>(
    prepare(apiPageConfigGetGuiZhouMallHomeDataV212RequestConfig, requestData),
    ...args,
  )
}

apiPageConfigGetGuiZhouMallHomeDataV212.requestConfig =
  apiPageConfigGetGuiZhouMallHomeDataV212RequestConfig

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/216110) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/test`
 */
export interface ApiPageConfigTestRequest {}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/216110) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/test`
 */
export interface ApiPageConfigTestResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 拓展字段
     */
    remark?: {
      /**
       * 自由字段键
       */
      name?: string
      /**
       * 自由字段值
       */
      value?: string
    }[]
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/216110) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/test`
 */
type ApiPageConfigTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/test',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/216110) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/test`
 */
const apiPageConfigTestRequestConfig: ApiPageConfigTestRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/test',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigTest',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '页面配置->根据资源位ID获取资源内容', author: '成龙' },
  }

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/1011/interface/api/216110) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/test`
 */
export const apiPageConfigTest = /*#__PURE__*/ (
  requestData?: ApiPageConfigTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigTestResponse>(
    prepare(apiPageConfigTestRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigTest.requestConfig = apiPageConfigTestRequestConfig

/**
 * 接口 [获取用户标签↗](https://yapi.gogpay.cn/project/1011/interface/api/232870) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userLabel`
 */
export interface ApiPageConfigUserLabelRequest {
  clientType?: '1' | '2'
  headerChannel?: string[]
}

/**
 * 接口 [获取用户标签↗](https://yapi.gogpay.cn/project/1011/interface/api/232870) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userLabel`
 */
export interface ApiPageConfigUserLabelResponse {
  /**
   * 是否是新用户
   */
  newUser?: boolean
}

/**
 * 接口 [获取用户标签↗](https://yapi.gogpay.cn/project/1011/interface/api/232870) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userLabel`
 */
type ApiPageConfigUserLabelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/userLabel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户标签↗](https://yapi.gogpay.cn/project/1011/interface/api/232870) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userLabel`
 */
const apiPageConfigUserLabelRequestConfig: ApiPageConfigUserLabelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/userLabel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigUserLabel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户标签', author: '成龙' },
  }

/**
 * 接口 [获取用户标签↗](https://yapi.gogpay.cn/project/1011/interface/api/232870) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/userLabel`
 */
export const apiPageConfigUserLabel = /*#__PURE__*/ (
  requestData: ApiPageConfigUserLabelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigUserLabelResponse>(
    prepare(apiPageConfigUserLabelRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigUserLabel.requestConfig = apiPageConfigUserLabelRequestConfig

/**
 * 接口 [领取门店券↗](https://yapi.gogpay.cn/project/1011/interface/api/277282) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/receiveStoreCoupon`
 */
export interface ApiPageConfigReceiveStoreCouponRequest {
  /**
   * 优惠券Id
   */
  id: string
}

/**
 * 接口 [领取门店券↗](https://yapi.gogpay.cn/project/1011/interface/api/277282) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/receiveStoreCoupon`
 */
export interface ApiPageConfigReceiveStoreCouponResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [领取门店券↗](https://yapi.gogpay.cn/project/1011/interface/api/277282) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/receiveStoreCoupon`
 */
type ApiPageConfigReceiveStoreCouponRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/1011',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/pageConfig/api/receiveStoreCoupon',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [领取门店券↗](https://yapi.gogpay.cn/project/1011/interface/api/277282) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/receiveStoreCoupon`
 */
const apiPageConfigReceiveStoreCouponRequestConfig: ApiPageConfigReceiveStoreCouponRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_10,
    devUrl: devUrl_0_1_0_10,
    prodUrl: prodUrl_0_1_0_10,
    path: '/pageConfig/api/receiveStoreCoupon',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_1_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiPageConfigReceiveStoreCoupon',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领取门店券', author: '成龙' },
  }

/**
 * 接口 [领取门店券↗](https://yapi.gogpay.cn/project/1011/interface/api/277282) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端接口↗](https://yapi.gogpay.cn/project/1011/interface/api/cat_7164)
 * @请求头 `POST /pageConfig/api/receiveStoreCoupon`
 */
export const apiPageConfigReceiveStoreCoupon = /*#__PURE__*/ (
  requestData: ApiPageConfigReceiveStoreCouponRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiPageConfigReceiveStoreCouponResponse>(
    prepare(apiPageConfigReceiveStoreCouponRequestConfig, requestData),
    ...args,
  )
}

apiPageConfigReceiveStoreCoupon.requestConfig =
  apiPageConfigReceiveStoreCouponRequestConfig

const mockUrl_0_9_0_1 = 'https://yapi.gogpay.cn/mock/951' as any
const devUrl_0_9_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_9_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_9_0_1 = 'data' as any

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312530) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/delete`
 */
export interface ApiExpressDeleteRequest {
  city?: string
  county?: string
  /**
   * 多彩宝用户id
   */
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  phoneNo?: string
  province?: string
  receiver?: string
  unitOrgCode?: string
}

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312530) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/delete`
 */
export interface ApiExpressDeleteResponse {}

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312530) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/delete`
 */
type ApiExpressDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312530) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/delete`
 */
const apiExpressDeleteRequestConfig: ApiExpressDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/express/api/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除收货地址', author: '成龙' },
  }

/**
 * 接口 [删除收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312530) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/delete`
 */
export const apiExpressDelete = /*#__PURE__*/ (
  requestData: ApiExpressDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressDeleteResponse>(
    prepare(apiExpressDeleteRequestConfig, requestData),
    ...args,
  )
}

apiExpressDelete.requestConfig = apiExpressDeleteRequestConfig

/**
 * 接口 [新增\/修改收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312538) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/edit`
 */
export interface ApiExpressEditRequest {
  city?: string
  county?: string
  /**
   * 多彩宝用户id
   */
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  phoneNo?: string
  province?: string
  receiver?: string
  unitOrgCode?: string
}

/**
 * 接口 [新增\/修改收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312538) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/edit`
 */
export interface ApiExpressEditResponse {}

/**
 * 接口 [新增\/修改收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312538) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/edit`
 */
type ApiExpressEditRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/edit',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增\/修改收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312538) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/edit`
 */
const apiExpressEditRequestConfig: ApiExpressEditRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_9_0_1,
  devUrl: devUrl_0_9_0_1,
  prodUrl: prodUrl_0_9_0_1,
  path: '/express/api/edit',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_9_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiExpressEdit',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: { title: '新增/修改收货地址', author: '成龙' },
}

/**
 * 接口 [新增\/修改收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312538) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/edit`
 */
export const apiExpressEdit = /*#__PURE__*/ (
  requestData: ApiExpressEditRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressEditResponse>(
    prepare(apiExpressEditRequestConfig, requestData),
    ...args,
  )
}

apiExpressEdit.requestConfig = apiExpressEditRequestConfig

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/951/interface/api/312546) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDefault`
 */
export interface ApiExpressGetDefaultRequest {
  city?: string
  county?: string
  /**
   * 多彩宝用户id
   */
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  phoneNo?: string
  province?: string
  receiver?: string
  unitOrgCode?: string
}

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/951/interface/api/312546) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDefault`
 */
export interface ApiExpressGetDefaultResponse {
  city?: string
  cityCode?: string
  county?: string
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  phoneNo?: string
  province?: string
  provinceCode?: string
  receiver?: string
  serviceFlag?: number
}

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/951/interface/api/312546) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDefault`
 */
type ApiExpressGetDefaultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/getDefault',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/951/interface/api/312546) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDefault`
 */
const apiExpressGetDefaultRequestConfig: ApiExpressGetDefaultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/express/api/getDefault',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressGetDefault',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取默认地址', author: '成龙' },
  }

/**
 * 接口 [获取默认地址↗](https://yapi.gogpay.cn/project/951/interface/api/312546) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDefault`
 */
export const apiExpressGetDefault = /*#__PURE__*/ (
  requestData: ApiExpressGetDefaultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressGetDefaultResponse>(
    prepare(apiExpressGetDefaultRequestConfig, requestData),
    ...args,
  )
}

apiExpressGetDefault.requestConfig = apiExpressGetDefaultRequestConfig

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312554) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictDetail`
 */
export interface ApiExpressGetDistrictDetailRequest {
  /**
   * 地址id
   */
  id?: string
}

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312554) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictDetail`
 */
export interface ApiExpressGetDistrictDetailResponse {
  city?: string
  cityCode?: string
  county?: string
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  phoneNo?: string
  province?: string
  provinceCode?: string
  receiver?: string
  serviceFlag?: number
}

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312554) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictDetail`
 */
type ApiExpressGetDistrictDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/getDistrictDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312554) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictDetail`
 */
const apiExpressGetDistrictDetailRequestConfig: ApiExpressGetDistrictDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/express/api/getDistrictDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressGetDistrictDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取区划信息', author: '成龙' },
  }

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312554) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictDetail`
 */
export const apiExpressGetDistrictDetail = /*#__PURE__*/ (
  requestData: ApiExpressGetDistrictDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressGetDistrictDetailResponse>(
    prepare(apiExpressGetDistrictDetailRequestConfig, requestData),
    ...args,
  )
}

apiExpressGetDistrictDetail.requestConfig =
  apiExpressGetDistrictDetailRequestConfig

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312562) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictList`
 */
export interface ApiExpressGetDistrictListRequest {
  /**
   * 区划代码
   */
  districtCode?: string
  /**
   * 区划等级
   */
  level?: number
}

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312562) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictList`
 */
export interface ApiExpressGetDistrictListResponse {
  /**
   * 热门区划地址,逗号','隔开
   */
  hotDistrict?: {
    /**
     * 祖级区划代码
     */
    ancestorCode?: string
    /**
     * 祖级区划名称
     */
    ancestorName?: string
    /**
     * 区划代码
     */
    districtCode?: string
    /**
     * 区划名称
     */
    districtSimpleName?: string
    /**
     * 区划等级
     */
    level?: number
    /**
     * 父级区划代码
     */
    parentCode?: string
    /**
     * 父级区划名称
     */
    parentName?: string
  }[]
  /**
   * 数据列表
   */
  list?: {
    /**
     * 区划代码
     */
    districtCode?: string
    /**
     * 区划名称
     */
    districtSimpleName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312562) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictList`
 */
type ApiExpressGetDistrictListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/getDistrictList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312562) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictList`
 */
const apiExpressGetDistrictListRequestConfig: ApiExpressGetDistrictListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_1,
    devUrl: devUrl_0_9_0_1,
    prodUrl: prodUrl_0_9_0_1,
    path: '/express/api/getDistrictList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressGetDistrictList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取区划信息', author: '成龙' },
  }

/**
 * 接口 [获取区划信息↗](https://yapi.gogpay.cn/project/951/interface/api/312562) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/getDistrictList`
 */
export const apiExpressGetDistrictList = /*#__PURE__*/ (
  requestData: ApiExpressGetDistrictListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressGetDistrictListResponse>(
    prepare(apiExpressGetDistrictListRequestConfig, requestData),
    ...args,
  )
}

apiExpressGetDistrictList.requestConfig = apiExpressGetDistrictListRequestConfig

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/951/interface/api/312570) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/list`
 */
export interface ApiExpressListRequest {
  city?: string
  county?: string
  /**
   * 多彩宝用户id
   */
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  phoneNo?: string
  province?: string
  receiver?: string
  unitOrgCode?: string
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/951/interface/api/312570) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/list`
 */
export interface ApiExpressListResponse {
  /**
   * 数据列表
   */
  list?: {
    city?: string
    cityCode?: string
    county?: string
    dcbUserId?: string
    defaultFlag?: number
    detail?: string
    districtCode?: string
    id?: string
    phoneNo?: string
    province?: string
    provinceCode?: string
    receiver?: string
    serviceFlag?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/951/interface/api/312570) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/list`
 */
type ApiExpressListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/951/interface/api/312570) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/list`
 */
const apiExpressListRequestConfig: ApiExpressListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_9_0_1,
  devUrl: devUrl_0_9_0_1,
  prodUrl: prodUrl_0_9_0_1,
  path: '/express/api/list',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_9_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiExpressList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: { title: '获取收货地址列表', author: '成龙' },
}

/**
 * 接口 [获取收货地址列表↗](https://yapi.gogpay.cn/project/951/interface/api/312570) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/list`
 */
export const apiExpressList = /*#__PURE__*/ (
  requestData: ApiExpressListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressListResponse>(
    prepare(apiExpressListRequestConfig, requestData),
    ...args,
  )
}

apiExpressList.requestConfig = apiExpressListRequestConfig

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312578) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/save`
 */
export interface ApiExpressSaveRequest {
  city?: string
  county?: string
  /**
   * 多彩宝用户id
   */
  dcbUserId?: string
  defaultFlag?: number
  detail?: string
  districtCode?: string
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  phoneNo?: string
  province?: string
  receiver?: string
  unitOrgCode?: string
}

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312578) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/save`
 */
export interface ApiExpressSaveResponse {}

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312578) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/save`
 */
type ApiExpressSaveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/save',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312578) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/save`
 */
const apiExpressSaveRequestConfig: ApiExpressSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_9_0_1,
  devUrl: devUrl_0_9_0_1,
  prodUrl: prodUrl_0_9_0_1,
  path: '/express/api/save',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_9_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiExpressSave',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: { title: '(新增/修改)收货地址', author: '成龙' },
}

/**
 * 接口 [(新增\/修改)收货地址↗](https://yapi.gogpay.cn/project/951/interface/api/312578) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [address-controller↗](https://yapi.gogpay.cn/project/951/interface/api/cat_54104)
 * @请求头 `POST /express/api/save`
 */
export const apiExpressSave = /*#__PURE__*/ (
  requestData: ApiExpressSaveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressSaveResponse>(
    prepare(apiExpressSaveRequestConfig, requestData),
    ...args,
  )
}

apiExpressSave.requestConfig = apiExpressSaveRequestConfig

const mockUrl_0_9_0_3 = 'https://yapi.gogpay.cn/mock/951' as any
const devUrl_0_9_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_9_0_3 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_9_0_3 = 'data' as any

/**
 * 接口 [接收来自快递鸟的物流轨迹推送↗](https://yapi.gogpay.cn/project/951/interface/api/28613) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端-快递鸟-物流轨迹接收层↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7127)
 * @请求头 `POST /express/api/logisticsSubscription/acceptSubscription`
 */
export interface ApiExpressLogisticsSubscriptionAcceptSubscriptionRequest {}

/**
 * 接口 [接收来自快递鸟的物流轨迹推送↗](https://yapi.gogpay.cn/project/951/interface/api/28613) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端-快递鸟-物流轨迹接收层↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7127)
 * @请求头 `POST /express/api/logisticsSubscription/acceptSubscription`
 */
export interface ApiExpressLogisticsSubscriptionAcceptSubscriptionResponse {
  /**
   * 用户编号
   */
  eBusinessID: string
  /**
   * 失败原因
   */
  reason?: string
  /**
   * 是否成功
   */
  success: boolean
  /**
   * 更新时间
   */
  updateTime?: string
}

/**
 * 接口 [接收来自快递鸟的物流轨迹推送↗](https://yapi.gogpay.cn/project/951/interface/api/28613) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端-快递鸟-物流轨迹接收层↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7127)
 * @请求头 `POST /express/api/logisticsSubscription/acceptSubscription`
 */
type ApiExpressLogisticsSubscriptionAcceptSubscriptionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/logisticsSubscription/acceptSubscription',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [接收来自快递鸟的物流轨迹推送↗](https://yapi.gogpay.cn/project/951/interface/api/28613) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端-快递鸟-物流轨迹接收层↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7127)
 * @请求头 `POST /express/api/logisticsSubscription/acceptSubscription`
 */
const apiExpressLogisticsSubscriptionAcceptSubscriptionRequestConfig: ApiExpressLogisticsSubscriptionAcceptSubscriptionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_3,
    devUrl: devUrl_0_9_0_3,
    prodUrl: prodUrl_0_9_0_3,
    path: '/express/api/logisticsSubscription/acceptSubscription',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressLogisticsSubscriptionAcceptSubscription',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '接收来自快递鸟的物流轨迹推送', author: '324号开发' },
  }

/**
 * 接口 [接收来自快递鸟的物流轨迹推送↗](https://yapi.gogpay.cn/project/951/interface/api/28613) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端-快递鸟-物流轨迹接收层↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7127)
 * @请求头 `POST /express/api/logisticsSubscription/acceptSubscription`
 */
export const apiExpressLogisticsSubscriptionAcceptSubscription = /*#__PURE__*/ (
  requestData?: ApiExpressLogisticsSubscriptionAcceptSubscriptionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressLogisticsSubscriptionAcceptSubscriptionResponse>(
    prepare(
      apiExpressLogisticsSubscriptionAcceptSubscriptionRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiExpressLogisticsSubscriptionAcceptSubscription.requestConfig =
  apiExpressLogisticsSubscriptionAcceptSubscriptionRequestConfig

const mockUrl_0_9_0_4 = 'https://yapi.gogpay.cn/mock/951' as any
const devUrl_0_9_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_9_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_9_0_4 = 'data' as any

/**
 * 接口 [即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/28609) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQuery`
 */
export interface ApiExpressLogisticsQueryImmediatelyQueryRequest {
  /**
   * 用户编码
   */
  customerName?: string
  /**
   * 物流单号
   */
  logisticCode: string
  /**
   * 订单id
   */
  orderId: string
  /**
   * 快递公司编码
   */
  shipperCode: string
}

/**
 * 接口 [即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/28609) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQuery`
 */
export interface ApiExpressLogisticsQueryImmediatelyQueryResponse {
  /**
   * 用户id
   */
  eBusinessId: string
  /**
   * 包裹当前所在位置
   */
  location?: string
  /**
   * 物流运单号
   */
  logisticCode: string
  /**
   * 对应订单id
   */
  orderCode: string
  /**
   * 失败原因
   */
  reason?: string
  /**
   * 快递公司编码
   */
  shipperCode: string
  /**
   * 快递公司名称
   */
  shipperName: string
  /**
   * 物流状态
   */
  state?: string
  /**
   * 详细物流状态
   */
  stateEx?: string
  /**
   * 成功与否
   */
  success: boolean
  /**
   * 物流节点信息集合
   */
  traces?: {
    /**
     * 物流节点信息描述
     */
    acceptStation?: string
    /**
     * 物流节点对应时间
     */
    acceptTime?: string
    /**
     * 物流节点信息当前状态
     */
    action?: string
    /**
     * 当前所在城市
     */
    location?: string
    /**
     * 备注信息
     */
    remark?: string
  }[]
}

/**
 * 接口 [即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/28609) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQuery`
 */
type ApiExpressLogisticsQueryImmediatelyQueryRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/logistics/query/immediatelyQuery',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/28609) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQuery`
 */
const apiExpressLogisticsQueryImmediatelyQueryRequestConfig: ApiExpressLogisticsQueryImmediatelyQueryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_4,
    devUrl: devUrl_0_9_0_4,
    prodUrl: prodUrl_0_9_0_4,
    path: '/express/api/logistics/query/immediatelyQuery',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressLogisticsQueryImmediatelyQuery',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '即时查询物流信息', author: '324号开发' },
  }

/**
 * 接口 [即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/28609) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQuery`
 */
export const apiExpressLogisticsQueryImmediatelyQuery = /*#__PURE__*/ (
  requestData: ApiExpressLogisticsQueryImmediatelyQueryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressLogisticsQueryImmediatelyQueryResponse>(
    prepare(apiExpressLogisticsQueryImmediatelyQueryRequestConfig, requestData),
    ...args,
  )
}

apiExpressLogisticsQueryImmediatelyQuery.requestConfig =
  apiExpressLogisticsQueryImmediatelyQueryRequestConfig

/**
 * 接口 [通过单号即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/60494) 的 **请求类型**
 *
 * @作者 史博文
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQueryByLogisticCode`
 */
export interface ApiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequest {
  /**
   * 用户编码
   */
  customerName?: string
  /**
   * 物流单号
   */
  logisticCode: string
  /**
   * 订单id
   */
  orderId: string
  /**
   * 快递公司编码
   */
  shipperCode: string
}

/**
 * 接口 [通过单号即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/60494) 的 **返回类型**
 *
 * @作者 史博文
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQueryByLogisticCode`
 */
export interface ApiExpressLogisticsQueryImmediatelyQueryByLogisticCodeResponse {
  /**
   * 用户id
   */
  eBusinessId: string
  /**
   * 包裹当前所在位置
   */
  location?: string
  /**
   * 物流运单号
   */
  logisticCode: string
  /**
   * 对应订单id
   */
  orderCode: string
  /**
   * 失败原因
   */
  reason?: string
  /**
   * 快递公司编码
   */
  shipperCode: string
  /**
   * 快递公司名称
   */
  shipperName: string
  /**
   * 物流状态
   */
  state?: string
  /**
   * 详细物流状态
   */
  stateEx?: string
  /**
   * 成功与否
   */
  success: boolean
  /**
   * 物流节点信息集合
   */
  traces?: {
    /**
     * 物流节点信息描述
     */
    acceptStation?: string
    /**
     * 物流节点对应时间
     */
    acceptTime?: string
    /**
     * 物流节点信息当前状态
     */
    action?: string
    /**
     * 当前所在城市
     */
    location?: string
    /**
     * 备注信息
     */
    remark?: string
  }[]
}

/**
 * 接口 [通过单号即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/60494) 的 **请求配置的类型**
 *
 * @作者 史博文
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQueryByLogisticCode`
 */
type ApiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/951',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/express/api/logistics/query/immediatelyQueryByLogisticCode',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [通过单号即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/60494) 的 **请求配置**
 *
 * @作者 史博文
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQueryByLogisticCode`
 */
const apiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequestConfig: ApiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_4,
    devUrl: devUrl_0_9_0_4,
    prodUrl: prodUrl_0_9_0_4,
    path: '/express/api/logistics/query/immediatelyQueryByLogisticCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiExpressLogisticsQueryImmediatelyQueryByLogisticCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '通过单号即时查询物流信息', author: '史博文' },
  }

/**
 * 接口 [通过单号即时查询物流信息↗](https://yapi.gogpay.cn/project/951/interface/api/60494) 的 **请求函数**
 *
 * @作者 史博文
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/immediatelyQueryByLogisticCode`
 */
export const apiExpressLogisticsQueryImmediatelyQueryByLogisticCode =
  /*#__PURE__*/ (
    requestData: ApiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiExpressLogisticsQueryImmediatelyQueryByLogisticCodeResponse>(
      prepare(
        apiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiExpressLogisticsQueryImmediatelyQueryByLogisticCode.requestConfig =
  apiExpressLogisticsQueryImmediatelyQueryByLogisticCodeRequestConfig

/**
 * 接口 [查询所有物流公司↗](https://yapi.gogpay.cn/project/951/interface/api/446513) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/queryAll`
 */
export interface ApiExpressLogisticsQueryQueryAllRequest {}

/**
 * 接口 [查询所有物流公司↗](https://yapi.gogpay.cn/project/951/interface/api/446513) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/queryAll`
 */
export type ApiExpressLogisticsQueryQueryAllResponse = {
  /**
   * 主键id
   */
  id?: string
  /**
   * 快递公司编码
   */
  logisticsCode?: string
  /**
   * 快递公司名称
   */
  logisticsInfo?: string
  /**
   * 快递公司logo链接地址
   */
  logoUrl?: string
}[]

/**
 * 接口 [查询所有物流公司↗](https://yapi.gogpay.cn/project/951/interface/api/446513) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/queryAll`
 */
type ApiExpressLogisticsQueryQueryAllRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/logistics/query/queryAll',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询所有物流公司↗](https://yapi.gogpay.cn/project/951/interface/api/446513) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/queryAll`
 */
const apiExpressLogisticsQueryQueryAllRequestConfig: ApiExpressLogisticsQueryQueryAllRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_4,
    devUrl: devUrl_0_9_0_4,
    prodUrl: prodUrl_0_9_0_4,
    path: '/express/api/logistics/query/queryAll',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressLogisticsQueryQueryAll',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询所有物流公司', author: '511号开发' },
  }

/**
 * 接口 [查询所有物流公司↗](https://yapi.gogpay.cn/project/951/interface/api/446513) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-物流信息查询接口↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7128)
 * @请求头 `POST /express/api/logistics/query/queryAll`
 */
export const apiExpressLogisticsQueryQueryAll = /*#__PURE__*/ (
  requestData?: ApiExpressLogisticsQueryQueryAllRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressLogisticsQueryQueryAllResponse>(
    prepare(apiExpressLogisticsQueryQueryAllRequestConfig, requestData),
    ...args,
  )
}

apiExpressLogisticsQueryQueryAll.requestConfig =
  apiExpressLogisticsQueryQueryAllRequestConfig

const mockUrl_0_9_0_12 = 'https://yapi.gogpay.cn/mock/951' as any
const devUrl_0_9_0_12 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_9_0_12 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_9_0_12 = 'data' as any

/**
 * 接口 [根据模板id计算费用↗](https://yapi.gogpay.cn/project/951/interface/api/28921) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端-商家物流模板信息↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7144)
 * @请求头 `POST /express/api/freightTemplate/calculateFreight`
 */
export interface ApiExpressFreightTemplateCalculateFreightRequest {
  /**
   * 收货地区编码（传入最后一级---区）
   */
  areaCode: string
  /**
   * 数量
   */
  count: number
  /**
   * 运费模板id
   */
  id: string
  /**
   * 重量不能为空
   */
  weight: number
}

/**
 * 接口 [根据模板id计算费用↗](https://yapi.gogpay.cn/project/951/interface/api/28921) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端-商家物流模板信息↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7144)
 * @请求头 `POST /express/api/freightTemplate/calculateFreight`
 */
export interface ApiExpressFreightTemplateCalculateFreightResponse {
  /**
   * 邮费金额
   */
  amount: number
  /**
   * 模板名称
   */
  templateName: string
}

/**
 * 接口 [根据模板id计算费用↗](https://yapi.gogpay.cn/project/951/interface/api/28921) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端-商家物流模板信息↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7144)
 * @请求头 `POST /express/api/freightTemplate/calculateFreight`
 */
type ApiExpressFreightTemplateCalculateFreightRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/freightTemplate/calculateFreight',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据模板id计算费用↗](https://yapi.gogpay.cn/project/951/interface/api/28921) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端-商家物流模板信息↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7144)
 * @请求头 `POST /express/api/freightTemplate/calculateFreight`
 */
const apiExpressFreightTemplateCalculateFreightRequestConfig: ApiExpressFreightTemplateCalculateFreightRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_12,
    devUrl: devUrl_0_9_0_12,
    prodUrl: prodUrl_0_9_0_12,
    path: '/express/api/freightTemplate/calculateFreight',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressFreightTemplateCalculateFreight',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '根据模板id计算费用', author: '324号开发' },
  }

/**
 * 接口 [根据模板id计算费用↗](https://yapi.gogpay.cn/project/951/interface/api/28921) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端-商家物流模板信息↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7144)
 * @请求头 `POST /express/api/freightTemplate/calculateFreight`
 */
export const apiExpressFreightTemplateCalculateFreight = /*#__PURE__*/ (
  requestData: ApiExpressFreightTemplateCalculateFreightRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressFreightTemplateCalculateFreightResponse>(
    prepare(
      apiExpressFreightTemplateCalculateFreightRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiExpressFreightTemplateCalculateFreight.requestConfig =
  apiExpressFreightTemplateCalculateFreightRequestConfig

const mockUrl_0_9_0_13 = 'https://yapi.gogpay.cn/mock/951' as any
const devUrl_0_9_0_13 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_9_0_13 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_9_0_13 = 'data' as any

/**
 * 接口 [验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/30241) 的 **请求类型**
 *
 * @作者 324号开发
 * @分类 [客户端-验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7222)
 * @请求头 `POST /express/api/recognition/validateLogisticsCode`
 */
export interface ApiExpressRecognitionValidateLogisticsCodeRequest {
  /**
   * 运单号
   */
  logisticsCode: string
}

/**
 * 接口 [验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/30241) 的 **返回类型**
 *
 * @作者 324号开发
 * @分类 [客户端-验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7222)
 * @请求头 `POST /express/api/recognition/validateLogisticsCode`
 */
export interface ApiExpressRecognitionValidateLogisticsCodeResponse {
  /**
   * 快递单号
   */
  logisticsCode?: string
  /**
   * 识别的快递公司集合
   */
  shippers?: {
    /**
     * 快递公司编码
     */
    shipperCode?: string
    /**
     * 快递公司名称
     */
    shipperName?: string
  }[]
}

/**
 * 接口 [验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/30241) 的 **请求配置的类型**
 *
 * @作者 324号开发
 * @分类 [客户端-验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7222)
 * @请求头 `POST /express/api/recognition/validateLogisticsCode`
 */
type ApiExpressRecognitionValidateLogisticsCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/951',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/express/api/recognition/validateLogisticsCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/30241) 的 **请求配置**
 *
 * @作者 324号开发
 * @分类 [客户端-验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7222)
 * @请求头 `POST /express/api/recognition/validateLogisticsCode`
 */
const apiExpressRecognitionValidateLogisticsCodeRequestConfig: ApiExpressRecognitionValidateLogisticsCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_9_0_13,
    devUrl: devUrl_0_9_0_13,
    prodUrl: prodUrl_0_9_0_13,
    path: '/express/api/recognition/validateLogisticsCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_9_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiExpressRecognitionValidateLogisticsCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '验证物流单号', author: '324号开发' },
  }

/**
 * 接口 [验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/30241) 的 **请求函数**
 *
 * @作者 324号开发
 * @分类 [客户端-验证物流单号↗](https://yapi.gogpay.cn/project/951/interface/api/cat_7222)
 * @请求头 `POST /express/api/recognition/validateLogisticsCode`
 */
export const apiExpressRecognitionValidateLogisticsCode = /*#__PURE__*/ (
  requestData: ApiExpressRecognitionValidateLogisticsCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiExpressRecognitionValidateLogisticsCodeResponse>(
    prepare(
      apiExpressRecognitionValidateLogisticsCodeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiExpressRecognitionValidateLogisticsCode.requestConfig =
  apiExpressRecognitionValidateLogisticsCodeRequestConfig

const mockUrl_0_23_0_2 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_2 = '' as any
const prodUrl_0_23_0_2 = '' as any
const dataKey_0_23_0_2 = 'data' as any

/**
 * 接口 [选择礼品↗](https://yapi.gogpay.cn/project/2968/interface/api/145989) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/choosePrize`
 */
export interface ApiMallDocInfoQuestionnaireChoosePrizeRequest {
  /**
   * 收货地址
   */
  address: string
  /**
   * 业务内容Id
   */
  id: string
  /**
   * 奖品名称
   */
  prizeName: string
  /**
   * 收件人姓名
   */
  userName: string
  /**
   * 联系电话
   */
  userPhone: string
}

/**
 * 接口 [选择礼品↗](https://yapi.gogpay.cn/project/2968/interface/api/145989) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/choosePrize`
 */
export interface ApiMallDocInfoQuestionnaireChoosePrizeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [选择礼品↗](https://yapi.gogpay.cn/project/2968/interface/api/145989) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/choosePrize`
 */
type ApiMallDocInfoQuestionnaireChoosePrizeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/questionnaire/choosePrize',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [选择礼品↗](https://yapi.gogpay.cn/project/2968/interface/api/145989) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/choosePrize`
 */
const apiMallDocInfoQuestionnaireChoosePrizeRequestConfig: ApiMallDocInfoQuestionnaireChoosePrizeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_2,
    devUrl: devUrl_0_23_0_2,
    prodUrl: prodUrl_0_23_0_2,
    path: '/mallDocInfo/api/questionnaire/choosePrize',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoQuestionnaireChoosePrize',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '选择礼品', author: '成龙' },
  }

/**
 * 接口 [选择礼品↗](https://yapi.gogpay.cn/project/2968/interface/api/145989) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/choosePrize`
 */
export const apiMallDocInfoQuestionnaireChoosePrize = /*#__PURE__*/ (
  requestData: ApiMallDocInfoQuestionnaireChoosePrizeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoQuestionnaireChoosePrizeResponse>(
    prepare(apiMallDocInfoQuestionnaireChoosePrizeRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoQuestionnaireChoosePrize.requestConfig =
  apiMallDocInfoQuestionnaireChoosePrizeRequestConfig

/**
 * 接口 [提交问卷↗](https://yapi.gogpay.cn/project/2968/interface/api/146007) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/submit`
 */
export interface ApiMallDocInfoQuestionnaireSubmitRequest {
  /**
   * 答案列表
   */
  answers: {
    /**
     * 答案列表
     */
    answers: string[]
    /**
     * 问题
     */
    title: string
  }[]
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [提交问卷↗](https://yapi.gogpay.cn/project/2968/interface/api/146007) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/submit`
 */
export type ApiMallDocInfoQuestionnaireSubmitResponse = boolean

/**
 * 接口 [提交问卷↗](https://yapi.gogpay.cn/project/2968/interface/api/146007) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/submit`
 */
type ApiMallDocInfoQuestionnaireSubmitRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/questionnaire/submit',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提交问卷↗](https://yapi.gogpay.cn/project/2968/interface/api/146007) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/submit`
 */
const apiMallDocInfoQuestionnaireSubmitRequestConfig: ApiMallDocInfoQuestionnaireSubmitRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_2,
    devUrl: devUrl_0_23_0_2,
    prodUrl: prodUrl_0_23_0_2,
    path: '/mallDocInfo/api/questionnaire/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoQuestionnaireSubmit',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提交问卷', author: '成龙' },
  }

/**
 * 接口 [提交问卷↗](https://yapi.gogpay.cn/project/2968/interface/api/146007) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/submit`
 */
export const apiMallDocInfoQuestionnaireSubmit = /*#__PURE__*/ (
  requestData: ApiMallDocInfoQuestionnaireSubmitRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoQuestionnaireSubmitResponse>(
    prepare(apiMallDocInfoQuestionnaireSubmitRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoQuestionnaireSubmit.requestConfig =
  apiMallDocInfoQuestionnaireSubmitRequestConfig

/**
 * 接口 [获取问卷数据↗](https://yapi.gogpay.cn/project/2968/interface/api/146421) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/get`
 */
export interface ApiMallDocInfoQuestionnaireGetRequest {
  /**
   * 答案列表
   */
  answers: {
    /**
     * 答案列表
     */
    answers: string[]
    /**
     * 问题
     */
    title: string
  }[]
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [获取问卷数据↗](https://yapi.gogpay.cn/project/2968/interface/api/146421) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/get`
 */
export type ApiMallDocInfoQuestionnaireGetResponse = boolean & {
  /**
   * 收货地址
   */
  address?: string
  /**
   * 用户问卷状态  un_own：未提交 un_choose：未选择奖品  confirmed：已选择奖品
   */
  prizeStatus?: 'UN_OWN' | 'UN_CHOOSE' | 'CONFIRMED' | 'THANKS'
  /**
   * 奖品列表
   */
  prizes?: {
    /**
     * 奖品名称
     */
    name?: string
    /**
     * 奖品图片
     */
    pic?: string
  }[]
  /**
   * 问题列表
   */
  questions?: {
    /**
     * 答案选项列表
     */
    options?: string[]
    /**
     * placeholder内容
     */
    placeholder?: string
    /**
     * 是否必填
     */
    required?: boolean
    /**
     * 问题
     */
    title?: string
    /**
     * 问题类型 radio:单选 checkbox:多选 textarea:文本输入
     */
    type?: string
  }[]
  /**
   * 收件人姓名
   */
  userName?: string
  /**
   * 联系电话
   */
  userPhone?: string
  userPrize?: {
    /**
     * 奖品名称
     */
    name?: string
    /**
     * 奖品图片
     */
    pic?: string
  }
  [k: string]: unknown
}

/**
 * 接口 [获取问卷数据↗](https://yapi.gogpay.cn/project/2968/interface/api/146421) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/get`
 */
type ApiMallDocInfoQuestionnaireGetRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/questionnaire/get',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取问卷数据↗](https://yapi.gogpay.cn/project/2968/interface/api/146421) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/get`
 */
const apiMallDocInfoQuestionnaireGetRequestConfig: ApiMallDocInfoQuestionnaireGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_2,
    devUrl: devUrl_0_23_0_2,
    prodUrl: prodUrl_0_23_0_2,
    path: '/mallDocInfo/api/questionnaire/get',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoQuestionnaireGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取问卷数据', author: '成龙' },
  }

/**
 * 接口 [获取问卷数据↗](https://yapi.gogpay.cn/project/2968/interface/api/146421) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-问卷调查↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26524)
 * @请求头 `POST /mallDocInfo/api/questionnaire/get`
 */
export const apiMallDocInfoQuestionnaireGet = /*#__PURE__*/ (
  requestData: ApiMallDocInfoQuestionnaireGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoQuestionnaireGetResponse>(
    prepare(apiMallDocInfoQuestionnaireGetRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoQuestionnaireGet.requestConfig =
  apiMallDocInfoQuestionnaireGetRequestConfig

const mockUrl_0_23_0_3 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_3 = '' as any
const prodUrl_0_23_0_3 = '' as any
const dataKey_0_23_0_3 = 'data' as any

/**
 * 接口 [获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/146223) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/details`
 */
export interface ApiMallDocInfoStrategyDetailsRequest {
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/146223) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/details`
 */
export interface ApiMallDocInfoStrategyDetailsResponse {
  /**
   * 地址
   */
  address: string
  /**
   * 作者
   */
  author?: string
  /**
   * 作者头像
   */
  authorCover?: string
  /**
   * 作者标签
   */
  authorLabel?: string
  /**
   * 轮播图推荐资源
   */
  bannerResources?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 评论数
   */
  commentCount?: number
  /**
   * 内容
   */
  content: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 封面视频
   */
  coverVideo?: string
  /**
   * 头图
   */
  headPic: string[]
  /**
   * 主键
   */
  id?: string
  /**
   * 点赞数量
   */
  likeCount?: number
  liked?: boolean
  /**
   * 发布时间
   */
  publishTime?: string
  recommendResource?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }
  /**
   * 攻略描述
   */
  strategyDesc?: string
  /**
   * 跳转链接
   */
  targetUrl?: string
  /**
   * 标题
   */
  title: string
}

/**
 * 接口 [获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/146223) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/details`
 */
type ApiMallDocInfoStrategyDetailsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/strategy/details',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/146223) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/details`
 */
const apiMallDocInfoStrategyDetailsRequestConfig: ApiMallDocInfoStrategyDetailsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_3,
    devUrl: devUrl_0_23_0_3,
    prodUrl: prodUrl_0_23_0_3,
    path: '/mallDocInfo/api/strategy/details',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoStrategyDetails',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取策略管理详情', author: '成龙' },
  }

/**
 * 接口 [获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/146223) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/details`
 */
export const apiMallDocInfoStrategyDetails = /*#__PURE__*/ (
  requestData: ApiMallDocInfoStrategyDetailsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoStrategyDetailsResponse>(
    prepare(apiMallDocInfoStrategyDetailsRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoStrategyDetails.requestConfig =
  apiMallDocInfoStrategyDetailsRequestConfig

/**
 * 接口 [点赞\/取消点赞↗](https://yapi.gogpay.cn/project/2968/interface/api/183934) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/likeOrUnLike`
 */
export interface ApiMallDocInfoStrategyLikeOrUnLikeRequest {
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [点赞\/取消点赞↗](https://yapi.gogpay.cn/project/2968/interface/api/183934) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/likeOrUnLike`
 */
export interface ApiMallDocInfoStrategyLikeOrUnLikeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [点赞\/取消点赞↗](https://yapi.gogpay.cn/project/2968/interface/api/183934) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/likeOrUnLike`
 */
type ApiMallDocInfoStrategyLikeOrUnLikeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/strategy/likeOrUnLike',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [点赞\/取消点赞↗](https://yapi.gogpay.cn/project/2968/interface/api/183934) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/likeOrUnLike`
 */
const apiMallDocInfoStrategyLikeOrUnLikeRequestConfig: ApiMallDocInfoStrategyLikeOrUnLikeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_3,
    devUrl: devUrl_0_23_0_3,
    prodUrl: prodUrl_0_23_0_3,
    path: '/mallDocInfo/api/strategy/likeOrUnLike',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoStrategyLikeOrUnLike',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '点赞/取消点赞', author: '成龙' },
  }

/**
 * 接口 [点赞\/取消点赞↗](https://yapi.gogpay.cn/project/2968/interface/api/183934) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/likeOrUnLike`
 */
export const apiMallDocInfoStrategyLikeOrUnLike = /*#__PURE__*/ (
  requestData: ApiMallDocInfoStrategyLikeOrUnLikeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoStrategyLikeOrUnLikeResponse>(
    prepare(apiMallDocInfoStrategyLikeOrUnLikeRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoStrategyLikeOrUnLike.requestConfig =
  apiMallDocInfoStrategyLikeOrUnLikeRequestConfig

/**
 * 接口 [tv获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/437788) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/tvDetails`
 */
export interface ApiMallDocInfoStrategyTvDetailsRequest {
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [tv获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/437788) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/tvDetails`
 */
export interface ApiMallDocInfoStrategyTvDetailsResponse {
  /**
   * 地址
   */
  address: string
  /**
   * 作者
   */
  author?: string
  /**
   * 作者头像
   */
  authorCover?: string
  /**
   * 作者标签
   */
  authorLabel?: string
  /**
   * 轮播图推荐资源
   */
  bannerResources?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 评论数
   */
  commentCount?: number
  /**
   * 内容
   */
  content: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 封面视频
   */
  coverVideo?: string
  /**
   * 头图
   */
  headPic: string[]
  /**
   * 主键
   */
  id?: string
  /**
   * 点赞数量
   */
  likeCount?: number
  liked?: boolean
  /**
   * 发布时间
   */
  publishTime?: string
  recommendResource?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }
  /**
   * 攻略描述
   */
  strategyDesc?: string
  /**
   * 跳转链接
   */
  targetUrl?: string
  /**
   * 标题
   */
  title: string
}

/**
 * 接口 [tv获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/437788) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/tvDetails`
 */
type ApiMallDocInfoStrategyTvDetailsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/strategy/tvDetails',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [tv获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/437788) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/tvDetails`
 */
const apiMallDocInfoStrategyTvDetailsRequestConfig: ApiMallDocInfoStrategyTvDetailsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_3,
    devUrl: devUrl_0_23_0_3,
    prodUrl: prodUrl_0_23_0_3,
    path: '/mallDocInfo/api/strategy/tvDetails',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoStrategyTvDetails',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'tv获取策略管理详情', author: '511号开发' },
  }

/**
 * 接口 [tv获取策略管理详情↗](https://yapi.gogpay.cn/project/2968/interface/api/437788) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-攻略管理↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26545)
 * @请求头 `POST /mallDocInfo/api/strategy/tvDetails`
 */
export const apiMallDocInfoStrategyTvDetails = /*#__PURE__*/ (
  requestData: ApiMallDocInfoStrategyTvDetailsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoStrategyTvDetailsResponse>(
    prepare(apiMallDocInfoStrategyTvDetailsRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoStrategyTvDetails.requestConfig =
  apiMallDocInfoStrategyTvDetailsRequestConfig

const mockUrl_0_23_0_4 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_4 = '' as any
const prodUrl_0_23_0_4 = '' as any
const dataKey_0_23_0_4 = 'data' as any

/**
 * 接口 [获取资源↗](https://yapi.gogpay.cn/project/2968/interface/api/146214) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-资源接口↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26552)
 * @请求头 `POST /mallDocInfo/api/resource/get`
 */
export interface ApiMallDocInfoResourceGetRequest {
  /**
   * Id列表
   */
  id: string[]
}

/**
 * 接口 [获取资源↗](https://yapi.gogpay.cn/project/2968/interface/api/146214) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-资源接口↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26552)
 * @请求头 `POST /mallDocInfo/api/resource/get`
 */
export type ApiMallDocInfoResourceGetResponse = {
  /**
   * 原价
   */
  amt?: string
  /**
   * 类目ID
   */
  categoryId?: string
  /**
   * 优惠价格
   */
  discountAmt?: string
  /**
   * 区划id
   */
  divisionId?: string
  /**
   * 区划名称
   */
  divisionName?: string
  /**
   * 服务图标
   */
  icon?: string
  /**
   * 服务图标(高度)
   */
  iconHeight?: number
  /**
   * 服务图标(宽度)
   */
  iconWidth?: number
  /**
   * 资源ID
   */
  id: string
  /**
   * 专区id（商品专用）
   */
  regionId?: string
  /**
   * 自由字段键值对
   */
  remarkMap?: {}
  /**
   * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告
   */
  resType?: string
  /**
   * 根类目ID
   */
  rootCategoryId?: string
  /**
   * 根类目名称
   */
  rootCategoryIdMsg?: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 资源位ID
   */
  stateId: string
  /**
   * 资源位名称
   */
  stateName?: string
  /**
   * 分发系统算法ID
   */
  strategyId?: string
  /**
   * 分发系统算法名称
   */
  strategyName?: string
  /**
   * 副标题
   */
  subTitle?: string
  /**
   * 路由
   */
  targetUrl?: string
  /**
   * 主标题
   */
  title?: string
  /**
   * 版本号
   */
  version?: number
}[]

/**
 * 接口 [获取资源↗](https://yapi.gogpay.cn/project/2968/interface/api/146214) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-资源接口↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26552)
 * @请求头 `POST /mallDocInfo/api/resource/get`
 */
type ApiMallDocInfoResourceGetRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/resource/get',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取资源↗](https://yapi.gogpay.cn/project/2968/interface/api/146214) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-资源接口↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26552)
 * @请求头 `POST /mallDocInfo/api/resource/get`
 */
const apiMallDocInfoResourceGetRequestConfig: ApiMallDocInfoResourceGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_4,
    devUrl: devUrl_0_23_0_4,
    prodUrl: prodUrl_0_23_0_4,
    path: '/mallDocInfo/api/resource/get',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoResourceGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取资源', author: '成龙' },
  }

/**
 * 接口 [获取资源↗](https://yapi.gogpay.cn/project/2968/interface/api/146214) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-资源接口↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_26552)
 * @请求头 `POST /mallDocInfo/api/resource/get`
 */
export const apiMallDocInfoResourceGet = /*#__PURE__*/ (
  requestData: ApiMallDocInfoResourceGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoResourceGetResponse>(
    prepare(apiMallDocInfoResourceGetRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoResourceGet.requestConfig = apiMallDocInfoResourceGetRequestConfig

const mockUrl_0_23_0_9 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_9 = '' as any
const prodUrl_0_23_0_9 = '' as any
const dataKey_0_23_0_9 = 'data' as any

/**
 * 接口 [投票项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/180534) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/detail`
 */
export interface ApiMallDocInfoVoteDetailRequest {
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [投票项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/180534) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/detail`
 */
export interface ApiMallDocInfoVoteDetailResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 分类Id
   */
  classifyId?: string
  /**
   * 项目介绍
   */
  desc?: string
  /**
   * 项目Id
   */
  itemId?: string
  /**
   * 项目名称
   */
  itemName?: string
  /**
   * 排序编号
   */
  orderNumber?: string
  /**
   * 图片
   */
  pic?: string
  /**
   * 票数文案
   */
  voteLabel?: string
  /**
   * 投票状态 0不可投票  1可投票  2已投票
   */
  voteStatus?: number
  /**
   * 投票按钮文案
   */
  voteStatusLabel?: string
  /**
   * 票数值
   */
  voteValue?: number
}

/**
 * 接口 [投票项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/180534) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/detail`
 */
type ApiMallDocInfoVoteDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/vote/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [投票项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/180534) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/detail`
 */
const apiMallDocInfoVoteDetailRequestConfig: ApiMallDocInfoVoteDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_9,
    devUrl: devUrl_0_23_0_9,
    prodUrl: prodUrl_0_23_0_9,
    path: '/mallDocInfo/api/vote/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoVoteDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '投票项目详情', author: '成龙' },
  }

/**
 * 接口 [投票项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/180534) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/detail`
 */
export const apiMallDocInfoVoteDetail = /*#__PURE__*/ (
  requestData: ApiMallDocInfoVoteDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoVoteDetailResponse>(
    prepare(apiMallDocInfoVoteDetailRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoVoteDetail.requestConfig = apiMallDocInfoVoteDetailRequestConfig

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2968/interface/api/180536) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/index`
 */
export interface ApiMallDocInfoVoteIndexRequest {
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2968/interface/api/180536) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/index`
 */
export interface ApiMallDocInfoVoteIndexResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 活动状态 0未开始 1进行中 2已结束
   */
  activityStatus?: number
  /**
   * 头图
   */
  banner?: string
  /**
   * 分类列表
   */
  classifies?: {
    /**
     * 分类Id
     */
    id?: string
    /**
     * 分类名称
     */
    name?: string
  }[]
  /**
   * 活动描述
   */
  desc?: string
  /**
   * 结束日期
   */
  endDate?: string
  /**
   * 活动规则
   */
  rules?: string
  /**
   * 是否显示分类筛选条
   */
  showClassify?: boolean
  /**
   * 开始日期
   */
  startDate?: string
  /**
   * 活动标题
   */
  title?: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2968/interface/api/180536) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/index`
 */
type ApiMallDocInfoVoteIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/vote/index',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2968/interface/api/180536) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/index`
 */
const apiMallDocInfoVoteIndexRequestConfig: ApiMallDocInfoVoteIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_9,
    devUrl: devUrl_0_23_0_9,
    prodUrl: prodUrl_0_23_0_9,
    path: '/mallDocInfo/api/vote/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoVoteIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '活动首页', author: '成龙' },
  }

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/2968/interface/api/180536) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/index`
 */
export const apiMallDocInfoVoteIndex = /*#__PURE__*/ (
  requestData: ApiMallDocInfoVoteIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoVoteIndexResponse>(
    prepare(apiMallDocInfoVoteIndexRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoVoteIndex.requestConfig = apiMallDocInfoVoteIndexRequestConfig

/**
 * 接口 [投票项列表↗](https://yapi.gogpay.cn/project/2968/interface/api/180538) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/items`
 */
export interface ApiMallDocInfoVoteItemsRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 分类Id
   */
  classifyId?: string
  /**
   * 搜索关键字（序号、名称)
   */
  keyword?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序方向 ASC：正序  DESC：倒序
   */
  sortDirection?: string
  /**
   * 排序类型 NO=序号  VOTE=票数
   */
  sortType?: string
}

/**
 * 接口 [投票项列表↗](https://yapi.gogpay.cn/project/2968/interface/api/180538) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/items`
 */
export interface ApiMallDocInfoVoteItemsResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 分类Id
     */
    classifyId?: string
    /**
     * 项目Id
     */
    itemId?: string
    /**
     * 项目名称
     */
    itemName?: string
    /**
     * 排序编号
     */
    orderNumber?: string
    /**
     * 图片
     */
    pic?: string
    /**
     * 票数文案
     */
    voteLabel?: string
    /**
     * 投票状态 0不可投票  1可投票  2已投票  3未开始  4已结束
     */
    voteStatus?: number
    /**
     * 投票按钮文案
     */
    voteStatusLabel?: string
    /**
     * 投票成功文案
     */
    voteSuccessText?: string
    /**
     * 票数值
     */
    voteValue?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [投票项列表↗](https://yapi.gogpay.cn/project/2968/interface/api/180538) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/items`
 */
type ApiMallDocInfoVoteItemsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/vote/items',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [投票项列表↗](https://yapi.gogpay.cn/project/2968/interface/api/180538) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/items`
 */
const apiMallDocInfoVoteItemsRequestConfig: ApiMallDocInfoVoteItemsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_9,
    devUrl: devUrl_0_23_0_9,
    prodUrl: prodUrl_0_23_0_9,
    path: '/mallDocInfo/api/vote/items',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoVoteItems',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '投票项列表', author: '成龙' },
  }

/**
 * 接口 [投票项列表↗](https://yapi.gogpay.cn/project/2968/interface/api/180538) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/items`
 */
export const apiMallDocInfoVoteItems = /*#__PURE__*/ (
  requestData: ApiMallDocInfoVoteItemsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoVoteItemsResponse>(
    prepare(apiMallDocInfoVoteItemsRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoVoteItems.requestConfig = apiMallDocInfoVoteItemsRequestConfig

/**
 * 接口 [投票↗](https://yapi.gogpay.cn/project/2968/interface/api/180540) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/vote`
 */
export interface ApiMallDocInfoVoteVoteRequest {
  /**
   * 投票渠道 DCB=多彩宝  WX=微信
   */
  channel: 'DCB' | 'WX'
  /**
   * 业务内容Id
   */
  id: string
  /**
   * 微信openId
   */
  openId?: string
  /**
   * 投票来源 LIST：列表  DETAIL：详情
   */
  source?: 'LIST' | 'DETAIL'
}

/**
 * 接口 [投票↗](https://yapi.gogpay.cn/project/2968/interface/api/180540) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/vote`
 */
export interface ApiMallDocInfoVoteVoteResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 分类Id
   */
  classifyId?: string
  /**
   * 项目Id
   */
  itemId?: string
  /**
   * 项目名称
   */
  itemName?: string
  /**
   * 排序编号
   */
  orderNumber?: string
  /**
   * 图片
   */
  pic?: string
  /**
   * 票数文案
   */
  voteLabel?: string
  /**
   * 投票状态 0不可投票  1可投票  2已投票  3未开始  4已结束
   */
  voteStatus?: number
  /**
   * 投票按钮文案
   */
  voteStatusLabel?: string
  /**
   * 投票成功文案
   */
  voteSuccessText?: string
  /**
   * 票数值
   */
  voteValue?: number
}

/**
 * 接口 [投票↗](https://yapi.gogpay.cn/project/2968/interface/api/180540) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/vote`
 */
type ApiMallDocInfoVoteVoteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/vote/vote',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [投票↗](https://yapi.gogpay.cn/project/2968/interface/api/180540) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/vote`
 */
const apiMallDocInfoVoteVoteRequestConfig: ApiMallDocInfoVoteVoteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_9,
    devUrl: devUrl_0_23_0_9,
    prodUrl: prodUrl_0_23_0_9,
    path: '/mallDocInfo/api/vote/vote',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoVoteVote',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '投票', author: '成龙' },
  }

/**
 * 接口 [投票↗](https://yapi.gogpay.cn/project/2968/interface/api/180540) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-投票活动↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_32827)
 * @请求头 `POST /mallDocInfo/api/vote/vote`
 */
export const apiMallDocInfoVoteVote = /*#__PURE__*/ (
  requestData: ApiMallDocInfoVoteVoteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoVoteVoteResponse>(
    prepare(apiMallDocInfoVoteVoteRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoVoteVote.requestConfig = apiMallDocInfoVoteVoteRequestConfig

const mockUrl_0_23_0_11 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_11 = '' as any
const prodUrl_0_23_0_11 = '' as any
const dataKey_0_23_0_11 = 'data' as any

/**
 * 接口 [招商引资项目分类↗](https://yapi.gogpay.cn/project/2968/interface/api/210266) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/classifyList`
 */
export interface ApiMallDocInfoAttractinvestmentClassifyListRequest {}

/**
 * 接口 [招商引资项目分类↗](https://yapi.gogpay.cn/project/2968/interface/api/210266) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/classifyList`
 */
export type ApiMallDocInfoAttractinvestmentClassifyListResponse = {
  /**
   * 项目分类名称
   */
  classifyName?: string
  /**
   * 项目分类id
   */
  id?: string
}[]

/**
 * 接口 [招商引资项目分类↗](https://yapi.gogpay.cn/project/2968/interface/api/210266) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/classifyList`
 */
type ApiMallDocInfoAttractinvestmentClassifyListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/attractinvestment/classifyList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [招商引资项目分类↗](https://yapi.gogpay.cn/project/2968/interface/api/210266) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/classifyList`
 */
const apiMallDocInfoAttractinvestmentClassifyListRequestConfig: ApiMallDocInfoAttractinvestmentClassifyListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_11,
    devUrl: devUrl_0_23_0_11,
    prodUrl: prodUrl_0_23_0_11,
    path: '/mallDocInfo/api/attractinvestment/classifyList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoAttractinvestmentClassifyList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '招商引资项目分类', author: '张彬' },
  }

/**
 * 接口 [招商引资项目分类↗](https://yapi.gogpay.cn/project/2968/interface/api/210266) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/classifyList`
 */
export const apiMallDocInfoAttractinvestmentClassifyList = /*#__PURE__*/ (
  requestData?: ApiMallDocInfoAttractinvestmentClassifyListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoAttractinvestmentClassifyListResponse>(
    prepare(
      apiMallDocInfoAttractinvestmentClassifyListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMallDocInfoAttractinvestmentClassifyList.requestConfig =
  apiMallDocInfoAttractinvestmentClassifyListRequestConfig

/**
 * 接口 [招商引资项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/210270) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/detail`
 */
export interface ApiMallDocInfoAttractinvestmentDetailRequest {
  /**
   * 项目ID
   */
  id: string
}

/**
 * 接口 [招商引资项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/210270) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/detail`
 */
export interface ApiMallDocInfoAttractinvestmentDetailResponse {
  /**
   * 项目总投资（亿元）
   */
  allInvestment?: string
  /**
   * 所属市州
   */
  cityName?: string
  /**
   * 所属县市
   */
  districtName?: string
  /**
   * 项目ID
   */
  id?: string
  /**
   * 计划招商引资金额（亿元）
   */
  planInvestment?: string
  /**
   * 项目所属板块ID
   */
  plateId?: string
  /**
   * 项目地址
   */
  projectAddress?: string
  /**
   * 招商项目前期工作开展情况
   */
  projectAdvancePlan?: string
  /**
   * 项目简介
   */
  projectDescribe?: string
  /**
   * 项目名称
   */
  projectName?: string
  /**
   * 项目业主单位
   */
  projectOwnership?: string
  /**
   * 联系人及联系方式
   */
  projectPerson?: string
  /**
   * 项目类型
   */
  projectType?: string
}

/**
 * 接口 [招商引资项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/210270) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/detail`
 */
type ApiMallDocInfoAttractinvestmentDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/attractinvestment/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [招商引资项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/210270) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/detail`
 */
const apiMallDocInfoAttractinvestmentDetailRequestConfig: ApiMallDocInfoAttractinvestmentDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_11,
    devUrl: devUrl_0_23_0_11,
    prodUrl: prodUrl_0_23_0_11,
    path: '/mallDocInfo/api/attractinvestment/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoAttractinvestmentDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '招商引资项目详情', author: '张彬' },
  }

/**
 * 接口 [招商引资项目详情↗](https://yapi.gogpay.cn/project/2968/interface/api/210270) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/detail`
 */
export const apiMallDocInfoAttractinvestmentDetail = /*#__PURE__*/ (
  requestData: ApiMallDocInfoAttractinvestmentDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoAttractinvestmentDetailResponse>(
    prepare(apiMallDocInfoAttractinvestmentDetailRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoAttractinvestmentDetail.requestConfig =
  apiMallDocInfoAttractinvestmentDetailRequestConfig

/**
 * 接口 [引资项目列表↗](https://yapi.gogpay.cn/project/2968/interface/api/210274) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/list`
 */
export interface ApiMallDocInfoAttractinvestmentListRequest {
  /**
   * 项目分类ID
   */
  classifyId?: string
  /**
   * 项目名称
   */
  projectName?: string
}

/**
 * 接口 [引资项目列表↗](https://yapi.gogpay.cn/project/2968/interface/api/210274) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/list`
 */
export type ApiMallDocInfoAttractinvestmentListResponse = {
  /**
   * 招商引资项目
   */
  attractInvestmentData?: {
    /**
     * 项目总投资（亿元）
     */
    allInvestment?: string
    /**
     * 所属市州
     */
    cityName?: string
    /**
     * 所属县市
     */
    districtName?: string
    /**
     * 项目ID
     */
    id?: string
    /**
     * 计划招商引资金额（亿元）
     */
    planInvestment?: string
    /**
     * 项目所属板块ID
     */
    plateId?: string
    /**
     * 项目地址
     */
    projectAddress?: string
    /**
     * 招商项目前期工作开展情况
     */
    projectAdvancePlan?: string
    /**
     * 项目简介
     */
    projectDescribe?: string
    /**
     * 项目名称
     */
    projectName?: string
    /**
     * 项目业主单位
     */
    projectOwnership?: string
    /**
     * 联系人及联系方式
     */
    projectPerson?: string
    /**
     * 项目类型
     */
    projectType?: string
  }[]
  plateData?: {
    /**
     * 关联项目分类Id
     */
    classifyId?: string
    /**
     * 项目板块Id
     */
    id?: string
    /**
     * 项目所属板块名称
     */
    plateName?: string
  }
}[]

/**
 * 接口 [引资项目列表↗](https://yapi.gogpay.cn/project/2968/interface/api/210274) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/list`
 */
type ApiMallDocInfoAttractinvestmentListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/attractinvestment/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [引资项目列表↗](https://yapi.gogpay.cn/project/2968/interface/api/210274) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/list`
 */
const apiMallDocInfoAttractinvestmentListRequestConfig: ApiMallDocInfoAttractinvestmentListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_11,
    devUrl: devUrl_0_23_0_11,
    prodUrl: prodUrl_0_23_0_11,
    path: '/mallDocInfo/api/attractinvestment/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoAttractinvestmentList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '引资项目列表', author: '张彬' },
  }

/**
 * 接口 [引资项目列表↗](https://yapi.gogpay.cn/project/2968/interface/api/210274) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/list`
 */
export const apiMallDocInfoAttractinvestmentList = /*#__PURE__*/ (
  requestData: ApiMallDocInfoAttractinvestmentListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoAttractinvestmentListResponse>(
    prepare(apiMallDocInfoAttractinvestmentListRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoAttractinvestmentList.requestConfig =
  apiMallDocInfoAttractinvestmentListRequestConfig

/**
 * 接口 [招商引资项目搜索↗](https://yapi.gogpay.cn/project/2968/interface/api/210282) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/search`
 */
export interface ApiMallDocInfoAttractinvestmentSearchRequest {
  /**
   * 招商引资项目名称
   */
  name?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 招商引资板块id
   */
  plateId?: string
}

/**
 * 接口 [招商引资项目搜索↗](https://yapi.gogpay.cn/project/2968/interface/api/210282) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/search`
 */
export interface ApiMallDocInfoAttractinvestmentSearchResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 项目总投资（亿元）
     */
    allInvestment?: string
    /**
     * 所属市州
     */
    cityName?: string
    /**
     * 所属县市
     */
    districtName?: string
    /**
     * 项目ID
     */
    id?: string
    /**
     * 计划招商引资金额（亿元）
     */
    planInvestment?: string
    /**
     * 项目所属板块ID
     */
    plateId?: string
    /**
     * 项目地址
     */
    projectAddress?: string
    /**
     * 招商项目前期工作开展情况
     */
    projectAdvancePlan?: string
    /**
     * 项目简介
     */
    projectDescribe?: string
    /**
     * 项目名称
     */
    projectName?: string
    /**
     * 项目业主单位
     */
    projectOwnership?: string
    /**
     * 联系人及联系方式
     */
    projectPerson?: string
    /**
     * 项目类型
     */
    projectType?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [招商引资项目搜索↗](https://yapi.gogpay.cn/project/2968/interface/api/210282) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/search`
 */
type ApiMallDocInfoAttractinvestmentSearchRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/attractinvestment/search',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [招商引资项目搜索↗](https://yapi.gogpay.cn/project/2968/interface/api/210282) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/search`
 */
const apiMallDocInfoAttractinvestmentSearchRequestConfig: ApiMallDocInfoAttractinvestmentSearchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_11,
    devUrl: devUrl_0_23_0_11,
    prodUrl: prodUrl_0_23_0_11,
    path: '/mallDocInfo/api/attractinvestment/search',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoAttractinvestmentSearch',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '招商引资项目搜索', author: '张彬' },
  }

/**
 * 接口 [招商引资项目搜索↗](https://yapi.gogpay.cn/project/2968/interface/api/210282) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-招商引资↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_36789)
 * @请求头 `POST /mallDocInfo/api/attractinvestment/search`
 */
export const apiMallDocInfoAttractinvestmentSearch = /*#__PURE__*/ (
  requestData: ApiMallDocInfoAttractinvestmentSearchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoAttractinvestmentSearchResponse>(
    prepare(apiMallDocInfoAttractinvestmentSearchRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoAttractinvestmentSearch.requestConfig =
  apiMallDocInfoAttractinvestmentSearchRequestConfig

const mockUrl_0_23_0_13 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_13 = '' as any
const prodUrl_0_23_0_13 = '' as any
const dataKey_0_23_0_13 = 'data' as any

/**
 * 接口 [添加审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229646) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/add`
 */
export interface ApiMallDocInfoActivityAuditAddRequest {
  /**
   * 申请资料
   */
  auditInformation: string[]
  /**
   * 活动审核类型 1-消费券 2-返现
   */
  auditType: number
  /**
   * 备注
   */
  remark?: string
}

/**
 * 接口 [添加审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229646) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/add`
 */
export type ApiMallDocInfoActivityAuditAddResponse = string

/**
 * 接口 [添加审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229646) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/add`
 */
type ApiMallDocInfoActivityAuditAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/activityAudit/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [添加审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229646) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/add`
 */
const apiMallDocInfoActivityAuditAddRequestConfig: ApiMallDocInfoActivityAuditAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_13,
    devUrl: devUrl_0_23_0_13,
    prodUrl: prodUrl_0_23_0_13,
    path: '/mallDocInfo/api/activityAudit/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoActivityAuditAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '添加审核', author: '李诗凡' },
  }

/**
 * 接口 [添加审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229646) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/add`
 */
export const apiMallDocInfoActivityAuditAdd = /*#__PURE__*/ (
  requestData: ApiMallDocInfoActivityAuditAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoActivityAuditAddResponse>(
    prepare(apiMallDocInfoActivityAuditAddRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoActivityAuditAdd.requestConfig =
  apiMallDocInfoActivityAuditAddRequestConfig

/**
 * 接口 [审核详情↗](https://yapi.gogpay.cn/project/2968/interface/api/229650) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/detail`
 */
export interface ApiMallDocInfoActivityAuditDetailRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [审核详情↗](https://yapi.gogpay.cn/project/2968/interface/api/229650) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/detail`
 */
export interface ApiMallDocInfoActivityAuditDetailResponse {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 申请资料
   */
  auditInformation?: string[]
  /**
   * 审核状态 0-待审核，1-审核通过 2-审核拒绝
   */
  auditStatus?: number
  /**
   * 审核状态
   */
  auditStatusName?: string
  /**
   * 审核时间
   */
  auditTime?: string
  /**
   * 审核类型：1-消费券 2-返现
   */
  auditType?: number
  /**
   * 审核类型
   */
  auditTypeName?: string
  couponData?: {
    /**
     * 优惠金额
     */
    amount?: string
    /**
     * 是否已领取
     */
    received?: boolean
    /**
     * 适用范围
     */
    region?: string
    /**
     * 优惠规则
     */
    rule?: string
  }
  /**
   * 审核ID
   */
  id?: string
  /**
   * 是否上传审核
   */
  isUpload?: boolean
  /**
   * 备注
   */
  remark?: string
  /**
   * 申请人姓名
   */
  userName?: string
  /**
   * 申请人手机号
   */
  userPhone?: string
}

/**
 * 接口 [审核详情↗](https://yapi.gogpay.cn/project/2968/interface/api/229650) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/detail`
 */
type ApiMallDocInfoActivityAuditDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/activityAudit/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [审核详情↗](https://yapi.gogpay.cn/project/2968/interface/api/229650) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/detail`
 */
const apiMallDocInfoActivityAuditDetailRequestConfig: ApiMallDocInfoActivityAuditDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_13,
    devUrl: devUrl_0_23_0_13,
    prodUrl: prodUrl_0_23_0_13,
    path: '/mallDocInfo/api/activityAudit/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoActivityAuditDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '审核详情', author: '李诗凡' },
  }

/**
 * 接口 [审核详情↗](https://yapi.gogpay.cn/project/2968/interface/api/229650) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/detail`
 */
export const apiMallDocInfoActivityAuditDetail = /*#__PURE__*/ (
  requestData: ApiMallDocInfoActivityAuditDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoActivityAuditDetailResponse>(
    prepare(apiMallDocInfoActivityAuditDetailRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoActivityAuditDetail.requestConfig =
  apiMallDocInfoActivityAuditDetailRequestConfig

/**
 * 接口 [领券↗](https://yapi.gogpay.cn/project/2968/interface/api/230126) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/receiveCoupon`
 */
export interface ApiMallDocInfoActivityAuditReceiveCouponRequest {}

/**
 * 接口 [领券↗](https://yapi.gogpay.cn/project/2968/interface/api/230126) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/receiveCoupon`
 */
export interface ApiMallDocInfoActivityAuditReceiveCouponResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [领券↗](https://yapi.gogpay.cn/project/2968/interface/api/230126) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/receiveCoupon`
 */
type ApiMallDocInfoActivityAuditReceiveCouponRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/activityAudit/receiveCoupon',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [领券↗](https://yapi.gogpay.cn/project/2968/interface/api/230126) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/receiveCoupon`
 */
const apiMallDocInfoActivityAuditReceiveCouponRequestConfig: ApiMallDocInfoActivityAuditReceiveCouponRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_13,
    devUrl: devUrl_0_23_0_13,
    prodUrl: prodUrl_0_23_0_13,
    path: '/mallDocInfo/api/activityAudit/receiveCoupon',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoActivityAuditReceiveCoupon',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领券', author: '成龙' },
  }

/**
 * 接口 [领券↗](https://yapi.gogpay.cn/project/2968/interface/api/230126) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-活动审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39495)
 * @请求头 `POST /mallDocInfo/api/activityAudit/receiveCoupon`
 */
export const apiMallDocInfoActivityAuditReceiveCoupon = /*#__PURE__*/ (
  requestData?: ApiMallDocInfoActivityAuditReceiveCouponRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoActivityAuditReceiveCouponResponse>(
    prepare(apiMallDocInfoActivityAuditReceiveCouponRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoActivityAuditReceiveCoupon.requestConfig =
  apiMallDocInfoActivityAuditReceiveCouponRequestConfig

const mockUrl_0_23_0_16 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_16 = '' as any
const prodUrl_0_23_0_16 = '' as any
const dataKey_0_23_0_16 = 'data' as any

/**
 * 接口 [上传审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229654) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/upload`
 */
export interface ApiMallDocInfoCashbackUploadRequest {
  /**
   * 申请资料
   */
  auditInformation?: string[]
}

/**
 * 接口 [上传审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229654) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/upload`
 */
export interface ApiMallDocInfoCashbackUploadResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [上传审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229654) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/upload`
 */
type ApiMallDocInfoCashbackUploadRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/cashback/upload',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [上传审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229654) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/upload`
 */
const apiMallDocInfoCashbackUploadRequestConfig: ApiMallDocInfoCashbackUploadRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_16,
    devUrl: devUrl_0_23_0_16,
    prodUrl: prodUrl_0_23_0_16,
    path: '/mallDocInfo/api/cashback/upload',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoCashbackUpload',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '上传审核', author: '李诗凡' },
  }

/**
 * 接口 [上传审核↗](https://yapi.gogpay.cn/project/2968/interface/api/229654) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/upload`
 */
export const apiMallDocInfoCashbackUpload = /*#__PURE__*/ (
  requestData: ApiMallDocInfoCashbackUploadRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoCashbackUploadResponse>(
    prepare(apiMallDocInfoCashbackUploadRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoCashbackUpload.requestConfig =
  apiMallDocInfoCashbackUploadRequestConfig

/**
 * 接口 [审核列表↗](https://yapi.gogpay.cn/project/2968/interface/api/229846) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/list`
 */
export interface ApiMallDocInfoCashbackListRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [审核列表↗](https://yapi.gogpay.cn/project/2968/interface/api/229846) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/list`
 */
export interface ApiMallDocInfoCashbackListResponse {
  /**
   * 审核材料
   */
  auditInformation?: string[]
  /**
   * 审核状态：0-待审核，1-审核通过 2-审核拒绝
   */
  auditStatus?: number
  /**
   * 审核状态：0-待审核，1-审核通过 2-审核拒绝
   */
  auditStatusName?: string
  /**
   * 审核备注
   */
  remark?: string
}

/**
 * 接口 [审核列表↗](https://yapi.gogpay.cn/project/2968/interface/api/229846) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/list`
 */
type ApiMallDocInfoCashbackListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/cashback/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [审核列表↗](https://yapi.gogpay.cn/project/2968/interface/api/229846) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/list`
 */
const apiMallDocInfoCashbackListRequestConfig: ApiMallDocInfoCashbackListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_16,
    devUrl: devUrl_0_23_0_16,
    prodUrl: prodUrl_0_23_0_16,
    path: '/mallDocInfo/api/cashback/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoCashbackList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '审核列表', author: '李诗凡' },
  }

/**
 * 接口 [审核列表↗](https://yapi.gogpay.cn/project/2968/interface/api/229846) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-返现审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_39522)
 * @请求头 `POST /mallDocInfo/api/cashback/list`
 */
export const apiMallDocInfoCashbackList = /*#__PURE__*/ (
  requestData: ApiMallDocInfoCashbackListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoCashbackListResponse>(
    prepare(apiMallDocInfoCashbackListRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoCashbackList.requestConfig =
  apiMallDocInfoCashbackListRequestConfig

const mockUrl_0_23_0_17 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_17 = '' as any
const prodUrl_0_23_0_17 = '' as any
const dataKey_0_23_0_17 = 'data' as any

/**
 * 接口 [领取补贴↗](https://yapi.gogpay.cn/project/2968/interface/api/261753) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/details`
 */
export interface ApiMallDocInfoGtkDetailsRequest {}

/**
 * 接口 [领取补贴↗](https://yapi.gogpay.cn/project/2968/interface/api/261753) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/details`
 */
export interface ApiMallDocInfoGtkDetailsResponse {
  /**
   * 申请人昵称
   */
  contractName?: string
  /**
   * 申请人手机号
   */
  contractTel?: string
  district?: {
    /**
     * 区县编码
     */
    areaCode?: string
    /**
     * 区县名称
     */
    areaName?: string
    /**
     * 城市编码
     */
    cityCode?: string
    /**
     * 城市名称
     */
    cityName?: string
    /**
     * 省份编码
     */
    provinceCode?: string
    /**
     * 省份名称
     */
    provinceName?: string
  }
  /**
   * 酒店规模：1.1-10间 2.11-50间 3.51-100间 4.100间以上
   */
  shopScale?: number
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户名称
   */
  userName?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [领取补贴↗](https://yapi.gogpay.cn/project/2968/interface/api/261753) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/details`
 */
type ApiMallDocInfoGtkDetailsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/gtk/details',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [领取补贴↗](https://yapi.gogpay.cn/project/2968/interface/api/261753) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/details`
 */
const apiMallDocInfoGtkDetailsRequestConfig: ApiMallDocInfoGtkDetailsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_17,
    devUrl: devUrl_0_23_0_17,
    prodUrl: prodUrl_0_23_0_17,
    path: '/mallDocInfo/api/gtk/details',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoGtkDetails',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领取补贴', author: '520号开发' },
  }

/**
 * 接口 [领取补贴↗](https://yapi.gogpay.cn/project/2968/interface/api/261753) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/details`
 */
export const apiMallDocInfoGtkDetails = /*#__PURE__*/ (
  requestData?: ApiMallDocInfoGtkDetailsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoGtkDetailsResponse>(
    prepare(apiMallDocInfoGtkDetailsRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoGtkDetails.requestConfig = apiMallDocInfoGtkDetailsRequestConfig

/**
 * 接口 [商家入驻↗](https://yapi.gogpay.cn/project/2968/interface/api/274650) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/recruitment`
 */
export interface ApiMallDocInfoGtkRecruitmentRequest {
  /**
   * 申请人昵称
   */
  contractName?: string
  /**
   * 申请人手机号
   */
  contractTel?: string
  district?: {
    /**
     * 区县编码
     */
    areaCode?: string
    /**
     * 区县名称
     */
    areaName?: string
    /**
     * 城市编码
     */
    cityCode?: string
    /**
     * 城市名称
     */
    cityName?: string
    /**
     * 省份编码
     */
    provinceCode?: string
    /**
     * 省份名称
     */
    provinceName?: string
  }
  /**
   * 酒店规模：1:1-10间 2:11-50间 3:51-100间 4:100间以上
   */
  shopScale?: number
}

/**
 * 接口 [商家入驻↗](https://yapi.gogpay.cn/project/2968/interface/api/274650) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/recruitment`
 */
export interface ApiMallDocInfoGtkRecruitmentResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商家入驻↗](https://yapi.gogpay.cn/project/2968/interface/api/274650) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/recruitment`
 */
type ApiMallDocInfoGtkRecruitmentRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/gtk/recruitment',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商家入驻↗](https://yapi.gogpay.cn/project/2968/interface/api/274650) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/recruitment`
 */
const apiMallDocInfoGtkRecruitmentRequestConfig: ApiMallDocInfoGtkRecruitmentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_17,
    devUrl: devUrl_0_23_0_17,
    prodUrl: prodUrl_0_23_0_17,
    path: '/mallDocInfo/api/gtk/recruitment',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoGtkRecruitment',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商家入驻', author: '520号开发' },
  }

/**
 * 接口 [商家入驻↗](https://yapi.gogpay.cn/project/2968/interface/api/274650) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/recruitment`
 */
export const apiMallDocInfoGtkRecruitment = /*#__PURE__*/ (
  requestData: ApiMallDocInfoGtkRecruitmentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoGtkRecruitmentResponse>(
    prepare(apiMallDocInfoGtkRecruitmentRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoGtkRecruitment.requestConfig =
  apiMallDocInfoGtkRecruitmentRequestConfig

/**
 * 接口 [查询用户信息↗](https://yapi.gogpay.cn/project/2968/interface/api/274658) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userInfo`
 */
export interface ApiMallDocInfoGtkUserInfoRequest {
  /**
   * 手机号
   */
  phone?: string
}

/**
 * 接口 [查询用户信息↗](https://yapi.gogpay.cn/project/2968/interface/api/274658) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userInfo`
 */
export interface ApiMallDocInfoGtkUserInfoResponse {
  /**
   * 是否是龟途客用户 0-不是 1-是
   */
  isOwnGtk?: string
  /**
   * 龟途客会员ID
   */
  membershipId?: string
}

/**
 * 接口 [查询用户信息↗](https://yapi.gogpay.cn/project/2968/interface/api/274658) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userInfo`
 */
type ApiMallDocInfoGtkUserInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/gtk/userInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户信息↗](https://yapi.gogpay.cn/project/2968/interface/api/274658) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userInfo`
 */
const apiMallDocInfoGtkUserInfoRequestConfig: ApiMallDocInfoGtkUserInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_17,
    devUrl: devUrl_0_23_0_17,
    prodUrl: prodUrl_0_23_0_17,
    path: '/mallDocInfo/api/gtk/userInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoGtkUserInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户信息', author: '520号开发' },
  }

/**
 * 接口 [查询用户信息↗](https://yapi.gogpay.cn/project/2968/interface/api/274658) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userInfo`
 */
export const apiMallDocInfoGtkUserInfo = /*#__PURE__*/ (
  requestData: ApiMallDocInfoGtkUserInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoGtkUserInfoResponse>(
    prepare(apiMallDocInfoGtkUserInfoRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoGtkUserInfo.requestConfig = apiMallDocInfoGtkUserInfoRequestConfig

/**
 * 接口 [用户注册↗](https://yapi.gogpay.cn/project/2968/interface/api/274666) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userRegister`
 */
export interface ApiMallDocInfoGtkUserRegisterRequest {}

/**
 * 接口 [用户注册↗](https://yapi.gogpay.cn/project/2968/interface/api/274666) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userRegister`
 */
export interface ApiMallDocInfoGtkUserRegisterResponse {
  /**
   * 申请人昵称
   */
  contractName?: string
  /**
   * 申请人手机号
   */
  contractTel?: string
  district?: {
    /**
     * 区县编码
     */
    areaCode?: string
    /**
     * 区县名称
     */
    areaName?: string
    /**
     * 城市编码
     */
    cityCode?: string
    /**
     * 城市名称
     */
    cityName?: string
    /**
     * 省份编码
     */
    provinceCode?: string
    /**
     * 省份名称
     */
    provinceName?: string
  }
  /**
   * 酒店规模：1.1-10间 2.11-50间 3.51-100间 4.100间以上
   */
  shopScale?: number
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户名称
   */
  userName?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [用户注册↗](https://yapi.gogpay.cn/project/2968/interface/api/274666) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userRegister`
 */
type ApiMallDocInfoGtkUserRegisterRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/gtk/userRegister',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [用户注册↗](https://yapi.gogpay.cn/project/2968/interface/api/274666) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userRegister`
 */
const apiMallDocInfoGtkUserRegisterRequestConfig: ApiMallDocInfoGtkUserRegisterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_17,
    devUrl: devUrl_0_23_0_17,
    prodUrl: prodUrl_0_23_0_17,
    path: '/mallDocInfo/api/gtk/userRegister',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoGtkUserRegister',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '用户注册', author: '520号开发' },
  }

/**
 * 接口 [用户注册↗](https://yapi.gogpay.cn/project/2968/interface/api/274666) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-商家审核↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_44980)
 * @请求头 `POST /mallDocInfo/api/gtk/userRegister`
 */
export const apiMallDocInfoGtkUserRegister = /*#__PURE__*/ (
  requestData?: ApiMallDocInfoGtkUserRegisterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoGtkUserRegisterResponse>(
    prepare(apiMallDocInfoGtkUserRegisterRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoGtkUserRegister.requestConfig =
  apiMallDocInfoGtkUserRegisterRequestConfig

const mockUrl_0_23_0_19 = 'https://yapi.gogpay.cn/mock/2968' as any
const devUrl_0_23_0_19 = '' as any
const prodUrl_0_23_0_19 = '' as any
const dataKey_0_23_0_19 = 'data' as any

/**
 * 接口 [获取公告资讯详情↗](https://yapi.gogpay.cn/project/2968/interface/api/380415) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [中国红客户端-公告资讯↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_66883)
 * @请求头 `POST /mallDocInfo/api/information/detail`
 */
export interface ApiMallDocInfoInformationDetailRequest {
  /**
   * 业务内容Id
   */
  id: string
}

/**
 * 接口 [获取公告资讯详情↗](https://yapi.gogpay.cn/project/2968/interface/api/380415) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [中国红客户端-公告资讯↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_66883)
 * @请求头 `POST /mallDocInfo/api/information/detail`
 */
export interface ApiMallDocInfoInformationDetailResponse {
  /**
   * 地址
   */
  address: string
  /**
   * 作者
   */
  author?: string
  /**
   * 作者头像
   */
  authorCover?: string
  /**
   * 作者标签
   */
  authorLabel?: string
  /**
   * 轮播图推荐资源
   */
  bannerResources?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 06:店铺
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 评论数
   */
  commentCount?: number
  /**
   * 内容
   */
  content: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 头图
   */
  headPic: string[]
  /**
   * 主键
   */
  id?: string
  /**
   * 点赞数量
   */
  likeCount?: number
  liked?: boolean
  /**
   * 发布时间
   */
  publishTime?: string
  recommendResource?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 06:店铺
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }
  /**
   * 跳转链接
   */
  targetUrl?: string
  /**
   * 标题
   */
  title: string
}

/**
 * 接口 [获取公告资讯详情↗](https://yapi.gogpay.cn/project/2968/interface/api/380415) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [中国红客户端-公告资讯↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_66883)
 * @请求头 `POST /mallDocInfo/api/information/detail`
 */
type ApiMallDocInfoInformationDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2968',
    '',
    '',
    '/mallDocInfo/api/information/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取公告资讯详情↗](https://yapi.gogpay.cn/project/2968/interface/api/380415) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [中国红客户端-公告资讯↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_66883)
 * @请求头 `POST /mallDocInfo/api/information/detail`
 */
const apiMallDocInfoInformationDetailRequestConfig: ApiMallDocInfoInformationDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_23_0_19,
    devUrl: devUrl_0_23_0_19,
    prodUrl: prodUrl_0_23_0_19,
    path: '/mallDocInfo/api/information/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_23_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMallDocInfoInformationDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取公告资讯详情', author: '333号开发' },
  }

/**
 * 接口 [获取公告资讯详情↗](https://yapi.gogpay.cn/project/2968/interface/api/380415) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [中国红客户端-公告资讯↗](https://yapi.gogpay.cn/project/2968/interface/api/cat_66883)
 * @请求头 `POST /mallDocInfo/api/information/detail`
 */
export const apiMallDocInfoInformationDetail = /*#__PURE__*/ (
  requestData: ApiMallDocInfoInformationDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMallDocInfoInformationDetailResponse>(
    prepare(apiMallDocInfoInformationDetailRequestConfig, requestData),
    ...args,
  )
}

apiMallDocInfoInformationDetail.requestConfig =
  apiMallDocInfoInformationDetailRequestConfig

const mockUrl_0_11_0_4 = 'https://yapi.gogpay.cn/mock/757' as any
const devUrl_0_11_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_11_0_4 = '' as any
const dataKey_0_11_0_4 = 'data' as any

/**
 * 接口 [v4.0我的优惠券数量↗](https://yapi.gogpay.cn/project/757/interface/api/49769) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCount`
 */
export interface ApiMarketingCouponMyCouponCouponCountRequest {
  /**
   * 手机号
   */
  phone: string
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口 [v4.0我的优惠券数量↗](https://yapi.gogpay.cn/project/757/interface/api/49769) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCount`
 */
export interface ApiMarketingCouponMyCouponCouponCountResponse {
  /**
   * 平台券数据
   */
  couponCount: number
  /**
   * 礼品卡数量
   */
  presentCardCount: number
  /**
   * 优惠券总数量
   */
  totalCount: number
  /**
   * 门店券数量
   */
  voucherCount: number
  /**
   * 微信券数量
   */
  weChatCount: number
}

/**
 * 接口 [v4.0我的优惠券数量↗](https://yapi.gogpay.cn/project/757/interface/api/49769) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCount`
 */
type ApiMarketingCouponMyCouponCouponCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/couponCount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [v4.0我的优惠券数量↗](https://yapi.gogpay.cn/project/757/interface/api/49769) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCount`
 */
const apiMarketingCouponMyCouponCouponCountRequestConfig: ApiMarketingCouponMyCouponCouponCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/myCoupon/couponCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponCouponCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'v4.0我的优惠券数量', author: '杨大鑫' },
  }

/**
 * 接口 [v4.0我的优惠券数量↗](https://yapi.gogpay.cn/project/757/interface/api/49769) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCount`
 */
export const apiMarketingCouponMyCouponCouponCount = /*#__PURE__*/ (
  requestData: ApiMarketingCouponMyCouponCouponCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponCouponCountResponse>(
    prepare(apiMarketingCouponMyCouponCouponCountRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponCouponCount.requestConfig =
  apiMarketingCouponMyCouponCouponCountRequestConfig

/**
 * 接口 [微信优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/49778) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/weChatList`
 */
export interface ApiMarketingCouponMyCouponWeChatListRequest {
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 状态：1-有效，0-无效
   */
  status: number
}

/**
 * 接口 [微信优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/49778) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/weChatList`
 */
export type ApiMarketingCouponMyCouponWeChatListResponse = {
  /**
   * 优惠活动ID
   */
  couponActId: string
  /**
   * 优惠券ID
   */
  couponId: string
  /**
   * 优惠名称
   */
  couponName: string
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType: number
  /**
   * 抵扣金额/折扣数/兑换
   */
  denomination?: string
  /**
   * 优惠级别；1=商品优惠，2=商家优惠，3=业务优惠
   */
  discountLevel: number
  /**
   * 优惠金额
   */
  discountedAmt?: number
  /**
   * 有效结束日期
   */
  endTime: string
  /**
   * 扩展字段，存json
   */
  extend?: {}
  /**
   * 门槛金额
   */
  minPointAmt?: string
  /**
   * 即将过期，0=未过期，1=24小时内即将过期，2=5天内即将过期
   */
  nearExpire: number
  /**
   * 支付金额
   */
  payAmt?: number
  /**
   * 支付方式，00表示所有支付方式
   */
  payType: string
  /**
   * 备注说明
   */
  remarks: string
  /**
   * 券包跳转路由地址
   */
  routeUrl?: string
  /**
   * 适用范围
   */
  scope: string
  /**
   * 适用门店
   */
  shops: {
    /**
     * 距离
     */
    distanceText: string
    /**
     * 纬度
     */
    latitude: string
    /**
     * 导航位置
     */
    locationName: string
    /**
     * 经度
     */
    longitude: string
    /**
     * 店铺名称
     */
    shopName: string
    /**
     * 门店数量
     */
    storeCount: number
    /**
     * 门店名称
     */
    storeName: string
    /**
     * 门店联系电话
     */
    storePhoneNum: string
  }
  /**
   * 状态：1=可用券，2=已过期，3=已作废，4=退回可用，5=已使用，6=订单冻结中
   */
  status: number
  /**
   * 三级标题
   */
  ticketThirdName?: string
  /**
   * 优惠券可用时间
   */
  useTimeType: number
  /**
   * 优惠券可用时间值
   */
  useTimeVal?: string
  /**
   * 券有效结束时间，时间戳
   */
  validEndTime?: number
  /**
   * 优惠券券码
   */
  couponPoolCode?: string
}[]

/**
 * 接口 [微信优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/49778) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/weChatList`
 */
type ApiMarketingCouponMyCouponWeChatListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/weChatList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [微信优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/49778) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/weChatList`
 */
const apiMarketingCouponMyCouponWeChatListRequestConfig: ApiMarketingCouponMyCouponWeChatListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/myCoupon/weChatList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponWeChatList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '微信优惠券列表', author: '杨大鑫' },
  }

/**
 * 接口 [微信优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/49778) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/weChatList`
 */
export const apiMarketingCouponMyCouponWeChatList = /*#__PURE__*/ (
  requestData: ApiMarketingCouponMyCouponWeChatListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponWeChatListResponse>(
    prepare(apiMarketingCouponMyCouponWeChatListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponWeChatList.requestConfig =
  apiMarketingCouponMyCouponWeChatListRequestConfig

/**
 * 接口 [v4.0领券【会员专属优惠券活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/49787) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/receive/vipCouponList`
 */
export interface ApiMarketingCouponReceiveVipCouponListRequest {}

/**
 * 接口 [v4.0领券【会员专属优惠券活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/49787) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/receive/vipCouponList`
 */
export interface ApiMarketingCouponReceiveVipCouponListResponse {
  isMaxVipLevel?: number
  list?: {
    /**
     * 是否可以继续领券
     */
    canReceive?: boolean
    /**
     * 优惠内容
     */
    couponContent?: string
    /**
     * 优惠名称
     */
    couponName?: string
    /**
     * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
     */
    couponType?: number
    /**
     * 优惠券折扣比例
     */
    discountRatio?: number
    /**
     * 优惠券单笔订单最大优惠金额
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 有效结束日期
     */
    endTime: string
    /**
     * 优惠券面额
     */
    fullAmount?: number
    /**
     * 适用商品；0=全部商品，1=指定商品可用，2=指定商品不可用
     */
    goodsType?: number
    /**
     * 优惠活动ID
     */
    id?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 支付方式，00表示所有支付方式
     */
    payType: string
    /**
     * 领取状态：0=未领取，1=已领取
     */
    receiveStatus: number
    /**
     * 领取人限制；1=不限制，所有注册用户可领，2=指定用户身、、、份可领，3=指定用户可领，4=指定会员等级可领
     */
    receiveUserType?: number
    /**
     * 领取人限制值
     */
    receiveUserVal?: string
    /**
     * 备注说明
     */
    remarks?: string
    /**
     * 可叠加优惠类型
     */
    superimposeDiscountType: number[]
    /**
     * 优惠使用结束时间
     */
    useEndTime: string
    /**
     * 优惠使用开始时间
     */
    useStartTime: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
    /**
     * 用户已领取数量
     */
    userReceiveCount?: number
  }[]
}

/**
 * 接口 [v4.0领券【会员专属优惠券活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/49787) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/receive/vipCouponList`
 */
type ApiMarketingCouponReceiveVipCouponListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/vipCouponList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [v4.0领券【会员专属优惠券活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/49787) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/receive/vipCouponList`
 */
const apiMarketingCouponReceiveVipCouponListRequestConfig: ApiMarketingCouponReceiveVipCouponListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/receive/vipCouponList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveVipCouponList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: 'v4.0领券【会员专属优惠券活动列表】',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [v4.0领券【会员专属优惠券活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/49787) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/receive/vipCouponList`
 */
export const apiMarketingCouponReceiveVipCouponList = /*#__PURE__*/ (
  requestData?: ApiMarketingCouponReceiveVipCouponListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveVipCouponListResponse>(
    prepare(apiMarketingCouponReceiveVipCouponListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveVipCouponList.requestConfig =
  apiMarketingCouponReceiveVipCouponListRequestConfig

/**
 * 接口 [v4.0我的优惠券数量web端↗](https://yapi.gogpay.cn/project/757/interface/api/54152) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCountH5`
 */
export interface ApiMarketingCouponMyCouponCouponCountH5Request {}

/**
 * 接口 [v4.0我的优惠券数量web端↗](https://yapi.gogpay.cn/project/757/interface/api/54152) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCountH5`
 */
export interface ApiMarketingCouponMyCouponCouponCountH5Response {
  /**
   * 平台券数据
   */
  couponCount: number
  /**
   * 礼品卡数量
   */
  presentCardCount: number
  /**
   * 优惠券总数量
   */
  totalCount: number
  /**
   * 门店券数量
   */
  voucherCount: number
  /**
   * 微信券数量
   */
  weChatCount: number
}

/**
 * 接口 [v4.0我的优惠券数量web端↗](https://yapi.gogpay.cn/project/757/interface/api/54152) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCountH5`
 */
type ApiMarketingCouponMyCouponCouponCountH5RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/couponCountH5',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [v4.0我的优惠券数量web端↗](https://yapi.gogpay.cn/project/757/interface/api/54152) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCountH5`
 */
const apiMarketingCouponMyCouponCouponCountH5RequestConfig: ApiMarketingCouponMyCouponCouponCountH5RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/myCoupon/couponCountH5',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponCouponCountH5',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'v4.0我的优惠券数量web端', author: '杨大鑫' },
  }

/**
 * 接口 [v4.0我的优惠券数量web端↗](https://yapi.gogpay.cn/project/757/interface/api/54152) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/couponCountH5`
 */
export const apiMarketingCouponMyCouponCouponCountH5 = /*#__PURE__*/ (
  requestData?: ApiMarketingCouponMyCouponCouponCountH5Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponCouponCountH5Response>(
    prepare(apiMarketingCouponMyCouponCouponCountH5RequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponCouponCountH5.requestConfig =
  apiMarketingCouponMyCouponCouponCountH5RequestConfig

/**
 * 接口 [领券至微信↗](https://yapi.gogpay.cn/project/757/interface/api/69124) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/receiveTicketToWeChat`
 */
export interface ApiMarketingCouponMyCouponReceiveTicketToWeChatRequest {
  /**
   * 微信券ID
   */
  couponActivityId: string
  /**
   * 微信昵称
   */
  weChatNickName: string
  /**
   * 微信open id
   */
  weChatOpenId: string
}

/**
 * 接口 [领券至微信↗](https://yapi.gogpay.cn/project/757/interface/api/69124) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/receiveTicketToWeChat`
 */
export interface ApiMarketingCouponMyCouponReceiveTicketToWeChatResponse {}

/**
 * 接口 [领券至微信↗](https://yapi.gogpay.cn/project/757/interface/api/69124) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/receiveTicketToWeChat`
 */
type ApiMarketingCouponMyCouponReceiveTicketToWeChatRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/receiveTicketToWeChat',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [领券至微信↗](https://yapi.gogpay.cn/project/757/interface/api/69124) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/receiveTicketToWeChat`
 */
const apiMarketingCouponMyCouponReceiveTicketToWeChatRequestConfig: ApiMarketingCouponMyCouponReceiveTicketToWeChatRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/myCoupon/receiveTicketToWeChat',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponReceiveTicketToWeChat',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领券至微信', author: '杨大鑫' },
  }

/**
 * 接口 [领券至微信↗](https://yapi.gogpay.cn/project/757/interface/api/69124) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/receiveTicketToWeChat`
 */
export const apiMarketingCouponMyCouponReceiveTicketToWeChat = /*#__PURE__*/ (
  requestData: ApiMarketingCouponMyCouponReceiveTicketToWeChatRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponReceiveTicketToWeChatResponse>(
    prepare(
      apiMarketingCouponMyCouponReceiveTicketToWeChatRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMarketingCouponMyCouponReceiveTicketToWeChat.requestConfig =
  apiMarketingCouponMyCouponReceiveTicketToWeChatRequestConfig

/**
 * 接口 [获取使用门店列表↗](https://yapi.gogpay.cn/project/757/interface/api/90292) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/getShopList`
 */
export interface ApiMarketingCouponMyCouponGetShopListRequest {
  /**
   * 券ID
   */
  couponId: string
  /**
   * 券类型，1=平台券，2=微信券，3=门店券，4=礼品卡
   */
  couponType: number
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
}

/**
 * 接口 [获取使用门店列表↗](https://yapi.gogpay.cn/project/757/interface/api/90292) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/getShopList`
 */
export type ApiMarketingCouponMyCouponGetShopListResponse = {
  /**
   * 距离
   */
  distanceText: string
  /**
   * 纬度
   */
  latitude: string
  /**
   * 导航位置
   */
  locationName: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 店铺名称
   */
  shopName: string
  /**
   * 门店数量
   */
  storeCount: number
  /**
   * 门店名称
   */
  storeName: string
  /**
   * 门店联系电话
   */
  storePhoneNum: string
}[]

/**
 * 接口 [获取使用门店列表↗](https://yapi.gogpay.cn/project/757/interface/api/90292) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/getShopList`
 */
type ApiMarketingCouponMyCouponGetShopListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/getShopList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取使用门店列表↗](https://yapi.gogpay.cn/project/757/interface/api/90292) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/getShopList`
 */
const apiMarketingCouponMyCouponGetShopListRequestConfig: ApiMarketingCouponMyCouponGetShopListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/myCoupon/getShopList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponGetShopList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取使用门店列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取使用门店列表↗](https://yapi.gogpay.cn/project/757/interface/api/90292) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/myCoupon/getShopList`
 */
export const apiMarketingCouponMyCouponGetShopList = /*#__PURE__*/ (
  requestData: ApiMarketingCouponMyCouponGetShopListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponGetShopListResponse>(
    prepare(apiMarketingCouponMyCouponGetShopListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponGetShopList.requestConfig =
  apiMarketingCouponMyCouponGetShopListRequestConfig

/**
 * 接口 [v4.0领券【获取优惠券活动用户领取情况】↗](https://yapi.gogpay.cn/project/757/interface/api/103996) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/getCouponReceiveInfo`
 */
export interface ApiMarketingCouponGetCouponReceiveInfoRequest {
  /**
   * 优惠券活动ID
   */
  couponActId?: string
}

/**
 * 接口 [v4.0领券【获取优惠券活动用户领取情况】↗](https://yapi.gogpay.cn/project/757/interface/api/103996) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/getCouponReceiveInfo`
 */
export interface ApiMarketingCouponGetCouponReceiveInfoResponse {
  /**
   * 领取状态：0=未领取，1=已领取，2=已领完
   */
  receiveStatus: number
}

/**
 * 接口 [v4.0领券【获取优惠券活动用户领取情况】↗](https://yapi.gogpay.cn/project/757/interface/api/103996) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/getCouponReceiveInfo`
 */
type ApiMarketingCouponGetCouponReceiveInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/getCouponReceiveInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [v4.0领券【获取优惠券活动用户领取情况】↗](https://yapi.gogpay.cn/project/757/interface/api/103996) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/getCouponReceiveInfo`
 */
const apiMarketingCouponGetCouponReceiveInfoRequestConfig: ApiMarketingCouponGetCouponReceiveInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_4,
    devUrl: devUrl_0_11_0_4,
    prodUrl: prodUrl_0_11_0_4,
    path: '/marketingCoupon/api/getCouponReceiveInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponGetCouponReceiveInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: 'v4.0领券【获取优惠券活动用户领取情况】',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [v4.0领券【获取优惠券活动用户领取情况】↗](https://yapi.gogpay.cn/project/757/interface/api/103996) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [4.0新增接口↗](https://yapi.gogpay.cn/project/757/interface/api/cat_11169)
 * @请求头 `POST /marketingCoupon/api/getCouponReceiveInfo`
 */
export const apiMarketingCouponGetCouponReceiveInfo = /*#__PURE__*/ (
  requestData: ApiMarketingCouponGetCouponReceiveInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponGetCouponReceiveInfoResponse>(
    prepare(apiMarketingCouponGetCouponReceiveInfoRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponGetCouponReceiveInfo.requestConfig =
  apiMarketingCouponGetCouponReceiveInfoRequestConfig

const mockUrl_0_11_0_16 = 'https://yapi.gogpay.cn/mock/757' as any
const devUrl_0_11_0_16 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_11_0_16 = '' as any
const dataKey_0_11_0_16 = 'data' as any

/**
 * 接口 [获取我的惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19778) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/list`
 */
export interface ApiMarketingCouponMyCouponListRequest {
  /**
   * 优惠活动ID
   */
  couponActIds?: string[]
  /**
   * 支付方式，00表示所有支付方式
   */
  payType?: string
  /**
   * 是否查询所有状态 false 只查询可用的
   */
  queryStatusAllFlag?: boolean
  /**
   * 关联活动ID
   */
  refMarketingActivityId?: string
  /**
   * 专区ID
   */
  specialId?: string
}

/**
 * 接口 [获取我的惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19778) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/list`
 */
export type ApiMarketingCouponMyCouponListResponse = {
  /**
   * 优惠活动ID
   */
  couponActId: string
  /**
   * 优惠券ID
   */
  couponId: string
  /**
   * 优惠名称
   */
  couponName: string
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType: number
  /**
   * 抵扣金额/折扣数/兑换
   */
  denomination?: string
  /**
   * 优惠级别；1=商品优惠，2=商家优惠，3=业务优惠
   */
  discountLevel: number
  /**
   * 优惠金额
   */
  discountedAmt?: number
  /**
   * 有效结束日期
   */
  endTime: string
  /**
   * 扩展字段，存json
   */
  extend?: {}
  /**
   * 门槛金额
   */
  minPointAmt?: string
  /**
   * 即将过期，0=未过期，1=24小时内即将过期，2=5天内即将过期
   */
  nearExpire: number
  /**
   * 支付金额
   */
  payAmt?: number
  /**
   * 支付方式，00表示所有支付方式
   */
  payType: string
  /**
   * 备注说明
   */
  remarks: string
  /**
   * 券包跳转路由地址
   */
  routeUrl?: string
  /**
   * 适用范围
   */
  scope: string
  shops: {
    /**
     * 距离
     */
    distanceText: string
    /**
     * 纬度
     */
    latitude: string
    /**
     * 导航位置
     */
    locationName: string
    /**
     * 经度
     */
    longitude: string
    /**
     * 店铺名称
     */
    shopName: string
    /**
     * 门店数量
     */
    storeCount: number
    /**
     * 门店名称
     */
    storeName: string
    /**
     * 门店联系电话
     */
    storePhoneNum: string
  }
  /**
   * 状态：1=可用券，2=已过期，3=已作废，4=退回可用，5=已使用，6=订单冻结中
   */
  status: number
  /**
   * 三级标题
   */
  ticketThirdName?: string
  /**
   * 优惠券可用时间
   */
  useTimeType: number
  /**
   * 优惠券可用时间值
   */
  useTimeVal?: string
  /**
   * 券有效结束时间，时间戳
   */
  validEndTime?: number
  /**
   * 优惠券券码
   */
  couponPoolCode?: string
}[]

/**
 * 接口 [获取我的惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19778) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/list`
 */
type ApiMarketingCouponMyCouponListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取我的惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19778) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/list`
 */
const apiMarketingCouponMyCouponListRequestConfig: ApiMarketingCouponMyCouponListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_16,
    devUrl: devUrl_0_11_0_16,
    prodUrl: prodUrl_0_11_0_16,
    path: '/marketingCoupon/api/myCoupon/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取我的惠券列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取我的惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19778) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/list`
 */
export const apiMarketingCouponMyCouponList = /*#__PURE__*/ (
  requestData: ApiMarketingCouponMyCouponListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponListResponse>(
    prepare(apiMarketingCouponMyCouponListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponList.requestConfig =
  apiMarketingCouponMyCouponListRequestConfig

/**
 * 接口 [获取失效券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19779) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/noUsableList`
 */
export interface ApiMarketingCouponMyCouponNoUsableListRequest {}

/**
 * 接口 [获取失效券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19779) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/noUsableList`
 */
export type ApiMarketingCouponMyCouponNoUsableListResponse = {
  /**
   * 优惠活动ID
   */
  couponActId: string
  /**
   * 优惠券ID
   */
  couponId: string
  /**
   * 优惠名称
   */
  couponName: string
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType: number
  /**
   * 抵扣金额/折扣数/兑换
   */
  denomination?: string
  /**
   * 优惠级别；1=商品优惠，2=商家优惠，3=业务优惠
   */
  discountLevel: number
  /**
   * 优惠金额
   */
  discountedAmt?: number
  /**
   * 有效结束日期
   */
  endTime: string
  /**
   * 扩展字段，存json
   */
  extend?: {}
  /**
   * 门槛金额
   */
  minPointAmt?: string
  /**
   * 即将过期，0=未过期，1=24小时内即将过期，2=5天内即将过期
   */
  nearExpire: number
  /**
   * 支付金额
   */
  payAmt?: number
  /**
   * 支付方式，00表示所有支付方式
   */
  payType: string
  /**
   * 备注说明
   */
  remarks: string
  /**
   * 券包跳转路由地址
   */
  routeUrl?: string
  /**
   * 适用范围
   */
  scope: string
  shops: {
    /**
     * 距离
     */
    distanceText: string
    /**
     * 纬度
     */
    latitude: string
    /**
     * 导航位置
     */
    locationName: string
    /**
     * 经度
     */
    longitude: string
    /**
     * 店铺名称
     */
    shopName: string
    /**
     * 门店数量
     */
    storeCount: number
    /**
     * 门店名称
     */
    storeName: string
    /**
     * 门店联系电话
     */
    storePhoneNum: string
  }
  /**
   * 状态：1=可用券，2=已过期，3=已作废，4=退回可用，5=已使用，6=订单冻结中
   */
  status: number
  /**
   * 三级标题
   */
  ticketThirdName?: string
  /**
   * 优惠券可用时间
   */
  useTimeType: number
  /**
   * 优惠券可用时间值
   */
  useTimeVal?: string
  /**
   * 券有效结束时间，时间戳
   */
  validEndTime?: number
  /**
   * 优惠券券码
   */
  couponPoolCode?: string
}[]

/**
 * 接口 [获取失效券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19779) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/noUsableList`
 */
type ApiMarketingCouponMyCouponNoUsableListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/noUsableList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取失效券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19779) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/noUsableList`
 */
const apiMarketingCouponMyCouponNoUsableListRequestConfig: ApiMarketingCouponMyCouponNoUsableListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_16,
    devUrl: devUrl_0_11_0_16,
    prodUrl: prodUrl_0_11_0_16,
    path: '/marketingCoupon/api/myCoupon/noUsableList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponNoUsableList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取失效券列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取失效券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19779) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/noUsableList`
 */
export const apiMarketingCouponMyCouponNoUsableList = /*#__PURE__*/ (
  requestData?: ApiMarketingCouponMyCouponNoUsableListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponNoUsableListResponse>(
    prepare(apiMarketingCouponMyCouponNoUsableListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponNoUsableList.requestConfig =
  apiMarketingCouponMyCouponNoUsableListRequestConfig

/**
 * 接口 [获取可用优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19780) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/usableList`
 */
export interface ApiMarketingCouponMyCouponUsableListRequest {
  /**
   * 订单金额
   */
  amt: number
  /**
   * 业务类型，4.0新增
   */
  businessType: string
  /**
   * 订单优惠金额
   */
  discountedAmt?: number
  /**
   * 商品ID列表
   */
  goodsIdList: string[]
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 子机构编码，4.0新增
   */
  unitOrgCode: string[]
}

/**
 * 接口 [获取可用优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19780) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/usableList`
 */
export type ApiMarketingCouponMyCouponUsableListResponse = {
  /**
   * 优惠活动ID
   */
  couponActId: string
  /**
   * 优惠券ID
   */
  couponId: string
  /**
   * 优惠名称
   */
  couponName: string
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType: number
  /**
   * 抵扣金额/折扣数/兑换
   */
  denomination?: string
  /**
   * 优惠级别；1=商品优惠，2=商家优惠，3=业务优惠
   */
  discountLevel: number
  /**
   * 优惠金额
   */
  discountedAmt?: number
  /**
   * 有效结束日期
   */
  endTime: string
  /**
   * 扩展字段，存json
   */
  extend?: {}
  /**
   * 门槛金额
   */
  minPointAmt?: string
  /**
   * 即将过期，0=未过期，1=24小时内即将过期，2=5天内即将过期
   */
  nearExpire: number
  /**
   * 支付金额
   */
  payAmt?: number
  /**
   * 支付方式，00表示所有支付方式
   */
  payType: string
  /**
   * 备注说明
   */
  remarks: string
  /**
   * 券包跳转路由地址
   */
  routeUrl?: string
  /**
   * 适用范围
   */
  scope: string
  shops: {
    /**
     * 距离
     */
    distanceText: string
    /**
     * 纬度
     */
    latitude: string
    /**
     * 导航位置
     */
    locationName: string
    /**
     * 经度
     */
    longitude: string
    /**
     * 店铺名称
     */
    shopName: string
    /**
     * 门店数量
     */
    storeCount: number
    /**
     * 门店名称
     */
    storeName: string
    /**
     * 门店联系电话
     */
    storePhoneNum: string
  }
  /**
   * 状态：1=可用券，2=已过期，3=已作废，4=退回可用，5=已使用，6=订单冻结中
   */
  status: number
  /**
   * 三级标题
   */
  ticketThirdName?: string
  /**
   * 优惠券可用时间
   */
  useTimeType: number
  /**
   * 优惠券可用时间值
   */
  useTimeVal?: string
  /**
   * 券有效结束时间，时间戳
   */
  validEndTime?: number
  /**
   * 优惠券券码
   */
  couponPoolCode?: string
}[]

/**
 * 接口 [获取可用优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19780) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/usableList`
 */
type ApiMarketingCouponMyCouponUsableListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/myCoupon/usableList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取可用优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19780) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/usableList`
 */
const apiMarketingCouponMyCouponUsableListRequestConfig: ApiMarketingCouponMyCouponUsableListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_16,
    devUrl: devUrl_0_11_0_16,
    prodUrl: prodUrl_0_11_0_16,
    path: '/marketingCoupon/api/myCoupon/usableList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponMyCouponUsableList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取可用优惠券列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取可用优惠券列表↗](https://yapi.gogpay.cn/project/757/interface/api/19780) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/api/myCoupon/usableList`
 */
export const apiMarketingCouponMyCouponUsableList = /*#__PURE__*/ (
  requestData: ApiMarketingCouponMyCouponUsableListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponMyCouponUsableListResponse>(
    prepare(apiMarketingCouponMyCouponUsableListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponMyCouponUsableList.requestConfig =
  apiMarketingCouponMyCouponUsableListRequestConfig

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/757/interface/api/36229) 的 **请求类型**
 *
 * @作者 14号开发
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/basicPageConfig/api/getStateContent`
 */
export interface ApiMarketingCouponBasicPageConfigGetStateContentRequest {}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/757/interface/api/36229) 的 **返回类型**
 *
 * @作者 14号开发
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/basicPageConfig/api/getStateContent`
 */
export interface ApiMarketingCouponBasicPageConfigGetStateContentResponse {}

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/757/interface/api/36229) 的 **请求配置的类型**
 *
 * @作者 14号开发
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/basicPageConfig/api/getStateContent`
 */
type ApiMarketingCouponBasicPageConfigGetStateContentRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/basicPageConfig/api/getStateContent',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/757/interface/api/36229) 的 **请求配置**
 *
 * @作者 14号开发
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/basicPageConfig/api/getStateContent`
 */
const apiMarketingCouponBasicPageConfigGetStateContentRequestConfig: ApiMarketingCouponBasicPageConfigGetStateContentRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_16,
    devUrl: devUrl_0_11_0_16,
    prodUrl: prodUrl_0_11_0_16,
    path: '/marketingCoupon/basicPageConfig/api/getStateContent',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.none,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponBasicPageConfigGetStateContent',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '页面配置->根据资源位ID获取资源内容',
      author: '14号开发',
    },
  }

/**
 * 接口 [页面配置->根据资源位ID获取资源内容↗](https://yapi.gogpay.cn/project/757/interface/api/36229) 的 **请求函数**
 *
 * @作者 14号开发
 * @分类 [券包↗](https://yapi.gogpay.cn/project/757/interface/api/cat_4601)
 * @请求头 `POST /marketingCoupon/basicPageConfig/api/getStateContent`
 */
export const apiMarketingCouponBasicPageConfigGetStateContent = /*#__PURE__*/ (
  requestData?: ApiMarketingCouponBasicPageConfigGetStateContentRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponBasicPageConfigGetStateContentResponse>(
    prepare(
      apiMarketingCouponBasicPageConfigGetStateContentRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMarketingCouponBasicPageConfigGetStateContent.requestConfig =
  apiMarketingCouponBasicPageConfigGetStateContentRequestConfig

const mockUrl_0_11_0_29 = 'https://yapi.gogpay.cn/mock/757' as any
const devUrl_0_11_0_29 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_11_0_29 = '' as any
const dataKey_0_11_0_29 = 'data' as any

/**
 * 接口 [兑换码触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22394) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/code`
 */
export interface ApiMarketingCouponReceiveCodeRequest {
  /**
   * 兑换码
   */
  couponCode: string
}

/**
 * 接口 [兑换码触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22394) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/code`
 */
export interface ApiMarketingCouponReceiveCodeResponse {}

/**
 * 接口 [兑换码触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22394) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/code`
 */
type ApiMarketingCouponReceiveCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/code',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [兑换码触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22394) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/code`
 */
const apiMarketingCouponReceiveCodeRequestConfig: ApiMarketingCouponReceiveCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/receive/code',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '兑换码触发领券（主要给web端使用）', author: '杨大鑫' },
  }

/**
 * 接口 [兑换码触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22394) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/code`
 */
export const apiMarketingCouponReceiveCode = /*#__PURE__*/ (
  requestData: ApiMarketingCouponReceiveCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveCodeResponse>(
    prepare(apiMarketingCouponReceiveCodeRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveCode.requestConfig =
  apiMarketingCouponReceiveCodeRequestConfig

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22397) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/open`
 */
export interface ApiMarketingCouponReceiveOpenRequest {
  /**
   * 优惠ID
   */
  couponActId: string
}

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22397) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/open`
 */
export interface ApiMarketingCouponReceiveOpenResponse {}

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22397) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/open`
 */
type ApiMarketingCouponReceiveOpenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/open',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22397) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/open`
 */
const apiMarketingCouponReceiveOpenRequestConfig: ApiMarketingCouponReceiveOpenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/receive/open',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveOpen',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '公开触发领券（主要给web端使用）', author: '杨大鑫' },
  }

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22397) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/open`
 */
export const apiMarketingCouponReceiveOpen = /*#__PURE__*/ (
  requestData: ApiMarketingCouponReceiveOpenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveOpenResponse>(
    prepare(apiMarketingCouponReceiveOpenRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveOpen.requestConfig =
  apiMarketingCouponReceiveOpenRequestConfig

/**
 * 接口 [业务系统触发领券（主要给业务系统通过接口的方式调用）↗](https://yapi.gogpay.cn/project/757/interface/api/22643) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/bizTest`
 */
export interface ApiMarketingCouponReceiveBizTestRequest {
  /**
   * 优惠ID
   */
  couponActId: string
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口 [业务系统触发领券（主要给业务系统通过接口的方式调用）↗](https://yapi.gogpay.cn/project/757/interface/api/22643) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/bizTest`
 */
export interface ApiMarketingCouponReceiveBizTestResponse {}

/**
 * 接口 [业务系统触发领券（主要给业务系统通过接口的方式调用）↗](https://yapi.gogpay.cn/project/757/interface/api/22643) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/bizTest`
 */
type ApiMarketingCouponReceiveBizTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/bizTest',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [业务系统触发领券（主要给业务系统通过接口的方式调用）↗](https://yapi.gogpay.cn/project/757/interface/api/22643) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/bizTest`
 */
const apiMarketingCouponReceiveBizTestRequestConfig: ApiMarketingCouponReceiveBizTestRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/receive/bizTest',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveBizTest',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '业务系统触发领券（主要给业务系统通过接口的方式调用）',
      author: '杨大鑫',
    },
  }

/**
 * 接口 [业务系统触发领券（主要给业务系统通过接口的方式调用）↗](https://yapi.gogpay.cn/project/757/interface/api/22643) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/bizTest`
 */
export const apiMarketingCouponReceiveBizTest = /*#__PURE__*/ (
  requestData: ApiMarketingCouponReceiveBizTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveBizTestResponse>(
    prepare(apiMarketingCouponReceiveBizTestRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveBizTest.requestConfig =
  apiMarketingCouponReceiveBizTestRequestConfig

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22649) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/openTest`
 */
export interface ApiMarketingCouponReceiveOpenTestRequest {
  /**
   * 优惠ID
   */
  couponActId: string
}

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22649) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/openTest`
 */
export interface ApiMarketingCouponReceiveOpenTestResponse {}

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22649) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/openTest`
 */
type ApiMarketingCouponReceiveOpenTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/openTest',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22649) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/openTest`
 */
const apiMarketingCouponReceiveOpenTestRequestConfig: ApiMarketingCouponReceiveOpenTestRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/receive/openTest',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveOpenTest',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '公开触发领券（主要给web端使用）', author: '杨大鑫' },
  }

/**
 * 接口 [公开触发领券（主要给web端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/22649) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/openTest`
 */
export const apiMarketingCouponReceiveOpenTest = /*#__PURE__*/ (
  requestData: ApiMarketingCouponReceiveOpenTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveOpenTestResponse>(
    prepare(apiMarketingCouponReceiveOpenTestRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveOpenTest.requestConfig =
  apiMarketingCouponReceiveOpenTestRequestConfig

/**
 * 接口 [领券【优惠活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/30625) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/couponList`
 */
export interface ApiMarketingCouponReceiveCouponListRequest {}

/**
 * 接口 [领券【优惠活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/30625) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/couponList`
 */
export type ApiMarketingCouponReceiveCouponListResponse = {
  /**
   * 是否可以继续领券
   */
  canReceive?: boolean
  /**
   * 优惠内容
   */
  couponContent?: string
  /**
   * 优惠名称
   */
  couponName?: string
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType?: number
  /**
   * 优惠券折扣比例
   */
  discountRatio?: number
  /**
   * 优惠券单笔订单最大优惠金额
   */
  discountSingleOrderMaxLimit?: number
  /**
   * 有效结束日期
   */
  endTime: string
  /**
   * 优惠券面额
   */
  fullAmount?: number
  /**
   * 适用商品；0=全部商品，1=指定商品可用，2=指定商品不可用
   */
  goodsType?: number
  /**
   * 优惠活动ID
   */
  id?: string
  /**
   * 使用门槛；0表示无门槛
   */
  minPoint?: number
  /**
   * 支付方式，00表示所有支付方式
   */
  payType: string
  /**
   * 领取状态：0=未领取，1=已领取
   */
  receiveStatus: number
  /**
   * 领取人限制；1=不限制，所有注册用户可领，2=指定用户身、、、份可领，3=指定用户可领，4=指定会员等级可领
   */
  receiveUserType?: number
  /**
   * 领取人限制值
   */
  receiveUserVal?: string
  /**
   * 备注说明
   */
  remarks?: string
  /**
   * 可叠加优惠类型
   */
  superimposeDiscountType: number[]
  /**
   * 优惠使用结束时间
   */
  useEndTime: string
  /**
   * 优惠使用开始时间
   */
  useStartTime: string
  /**
   * 优惠券可用时间
   */
  useTimeType?: number
  /**
   * 优惠券可用时间值
   */
  useTimeVal?: string
  /**
   * 用户已领取数量
   */
  userReceiveCount?: number
}[]

/**
 * 接口 [领券【优惠活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/30625) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/couponList`
 */
type ApiMarketingCouponReceiveCouponListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/couponList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [领券【优惠活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/30625) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/couponList`
 */
const apiMarketingCouponReceiveCouponListRequestConfig: ApiMarketingCouponReceiveCouponListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/receive/couponList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveCouponList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领券【优惠活动列表】', author: '杨大鑫' },
  }

/**
 * 接口 [领券【优惠活动列表】↗](https://yapi.gogpay.cn/project/757/interface/api/30625) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/couponList`
 */
export const apiMarketingCouponReceiveCouponList = /*#__PURE__*/ (
  requestData?: ApiMarketingCouponReceiveCouponListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveCouponListResponse>(
    prepare(apiMarketingCouponReceiveCouponListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveCouponList.requestConfig =
  apiMarketingCouponReceiveCouponListRequestConfig

/**
 * 接口 [获取指定商品优惠活动列表↗](https://yapi.gogpay.cn/project/757/interface/api/30633) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponListByGoodsId`
 */
export interface ApiMarketingCouponCouponListByGoodsIdRequest {
  /**
   * 商品ID
   */
  goodsId: string
}

/**
 * 接口 [获取指定商品优惠活动列表↗](https://yapi.gogpay.cn/project/757/interface/api/30633) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponListByGoodsId`
 */
export type ApiMarketingCouponCouponListByGoodsIdResponse = {
  /**
   * 优惠券ID
   */
  couponId: string
  /**
   * 优惠名称
   */
  couponName: string
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType: number
  /**
   * 抵扣金额/折扣数/兑换
   */
  denomination?: string
  /**
   * 有效结束日期
   */
  endTime: string
  /**
   * 门槛金额
   */
  minPointAmt?: string
  /**
   * 即将过期，0=未过期，1=24小时内即将过期，2=5天内即将过期
   */
  nearExpire: number
  /**
   * 领取状态：0=未领取，1=已领取，2=未领取已领完
   */
  receiveStatus: number
  /**
   * 备注说明
   */
  remarks: string
  /**
   * 适用范围
   */
  scope: string
  /**
   * 优惠券可用时间
   */
  useTimeType: number
  /**
   * 优惠券可用时间值
   */
  useTimeVal?: string
  /**
   * 券有效结束时间，时间戳
   */
  validEndTime?: number
}[]

/**
 * 接口 [获取指定商品优惠活动列表↗](https://yapi.gogpay.cn/project/757/interface/api/30633) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponListByGoodsId`
 */
type ApiMarketingCouponCouponListByGoodsIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/couponListByGoodsId',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定商品优惠活动列表↗](https://yapi.gogpay.cn/project/757/interface/api/30633) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponListByGoodsId`
 */
const apiMarketingCouponCouponListByGoodsIdRequestConfig: ApiMarketingCouponCouponListByGoodsIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/couponListByGoodsId',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponCouponListByGoodsId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定商品优惠活动列表', author: '杨大鑫' },
  }

/**
 * 接口 [获取指定商品优惠活动列表↗](https://yapi.gogpay.cn/project/757/interface/api/30633) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponListByGoodsId`
 */
export const apiMarketingCouponCouponListByGoodsId = /*#__PURE__*/ (
  requestData: ApiMarketingCouponCouponListByGoodsIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponCouponListByGoodsIdResponse>(
    prepare(apiMarketingCouponCouponListByGoodsIdRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponCouponListByGoodsId.requestConfig =
  apiMarketingCouponCouponListByGoodsIdRequestConfig

/**
 * 接口 [公开触发领券（服务端端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/105166) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/serviceOpen`
 */
export interface ApiMarketingCouponReceiveServiceOpenRequest {
  /**
   * 优惠ID
   */
  couponActId: string
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口 [公开触发领券（服务端端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/105166) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/serviceOpen`
 */
export interface ApiMarketingCouponReceiveServiceOpenResponse {}

/**
 * 接口 [公开触发领券（服务端端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/105166) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/serviceOpen`
 */
type ApiMarketingCouponReceiveServiceOpenRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/receive/serviceOpen',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [公开触发领券（服务端端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/105166) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/serviceOpen`
 */
const apiMarketingCouponReceiveServiceOpenRequestConfig: ApiMarketingCouponReceiveServiceOpenRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/receive/serviceOpen',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponReceiveServiceOpen',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '公开触发领券（服务端端使用）', author: '张彬' },
  }

/**
 * 接口 [公开触发领券（服务端端使用）↗](https://yapi.gogpay.cn/project/757/interface/api/105166) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/receive/serviceOpen`
 */
export const apiMarketingCouponReceiveServiceOpen = /*#__PURE__*/ (
  requestData: ApiMarketingCouponReceiveServiceOpenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponReceiveServiceOpenResponse>(
    prepare(apiMarketingCouponReceiveServiceOpenRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponReceiveServiceOpen.requestConfig =
  apiMarketingCouponReceiveServiceOpenRequestConfig

/**
 * 接口 [根据订单号查询对应优惠券信息↗](https://yapi.gogpay.cn/project/757/interface/api/226310) 的 **请求类型**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponsByOrderId`
 */
export interface ApiMarketingCouponCouponOrderQueryCouponsByOrderIdRequest {
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单号列表
   */
  orderNoList?: string[]
}

/**
 * 接口 [根据订单号查询对应优惠券信息↗](https://yapi.gogpay.cn/project/757/interface/api/226310) 的 **返回类型**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponsByOrderId`
 */
export interface ApiMarketingCouponCouponOrderQueryCouponsByOrderIdResponse {
  /**
   * 优惠详情列表
   */
  couponOrderDetailList: {
    /**
     * 优惠券ID
     */
    couponId: string
    /**
     * 优惠名称
     */
    couponName: string
    /**
     * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
     */
    couponType: number
    couponTypeName?: string
    /**
     * 优惠金额
     */
    discountedAmt: number
  }[]
  /**
   * 优惠总金额
   */
  totalDiscountedAmt: number
}

/**
 * 接口 [根据订单号查询对应优惠券信息↗](https://yapi.gogpay.cn/project/757/interface/api/226310) 的 **请求配置的类型**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponsByOrderId`
 */
type ApiMarketingCouponCouponOrderQueryCouponsByOrderIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/couponOrder/queryCouponsByOrderId',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据订单号查询对应优惠券信息↗](https://yapi.gogpay.cn/project/757/interface/api/226310) 的 **请求配置**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponsByOrderId`
 */
const apiMarketingCouponCouponOrderQueryCouponsByOrderIdRequestConfig: ApiMarketingCouponCouponOrderQueryCouponsByOrderIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/couponOrder/queryCouponsByOrderId',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponCouponOrderQueryCouponsByOrderId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '根据订单号查询对应优惠券信息',
      author: '202205号开发',
    },
  }

/**
 * 接口 [根据订单号查询对应优惠券信息↗](https://yapi.gogpay.cn/project/757/interface/api/226310) 的 **请求函数**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponsByOrderId`
 */
export const apiMarketingCouponCouponOrderQueryCouponsByOrderId =
  /*#__PURE__*/ (
    requestData: ApiMarketingCouponCouponOrderQueryCouponsByOrderIdRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiMarketingCouponCouponOrderQueryCouponsByOrderIdResponse>(
      prepare(
        apiMarketingCouponCouponOrderQueryCouponsByOrderIdRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiMarketingCouponCouponOrderQueryCouponsByOrderId.requestConfig =
  apiMarketingCouponCouponOrderQueryCouponsByOrderIdRequestConfig

/**
 * 接口 [根据订单号列表查询券、支付方式渠道信息↗](https://yapi.gogpay.cn/project/757/interface/api/232966) 的 **请求类型**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList`
 */
export interface ApiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequest {
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单号列表
   */
  orderNoList?: string[]
}

/**
 * 接口 [根据订单号列表查询券、支付方式渠道信息↗](https://yapi.gogpay.cn/project/757/interface/api/232966) 的 **返回类型**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList`
 */
export type ApiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListResponse =
  {
    couponOrderInfo: {
      /**
       * 优惠金额，单位元
       */
      discountedAmt: number
      /**
       * 优惠券ID
       */
      refCouponId: string
    }
    /**
     * 订单号
     */
    orderNo: string
    payChannelOrderInfo: {
      /**
       * 优惠金额，单位元
       */
      discountedAmt: number
      /**
       * 优惠支付渠道ID
       */
      refActivityId: string
    }
  }[]

/**
 * 接口 [根据订单号列表查询券、支付方式渠道信息↗](https://yapi.gogpay.cn/project/757/interface/api/232966) 的 **请求配置的类型**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList`
 */
type ApiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/757',
      'https://mall-gw.duotest.cn',
      '',
      '/marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [根据订单号列表查询券、支付方式渠道信息↗](https://yapi.gogpay.cn/project/757/interface/api/232966) 的 **请求配置**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList`
 */
const apiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequestConfig: ApiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '根据订单号列表查询券、支付方式渠道信息',
      author: '202205号开发',
    },
  }

/**
 * 接口 [根据订单号列表查询券、支付方式渠道信息↗](https://yapi.gogpay.cn/project/757/interface/api/232966) 的 **请求函数**
 *
 * @作者 202205号开发
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/couponOrder/queryCouponPayChannelByOrderNoList`
 */
export const apiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoList =
  /*#__PURE__*/ (
    requestData: ApiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListResponse>(
      prepare(
        apiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoList.requestConfig =
  apiMarketingCouponCouponOrderQueryCouponPayChannelByOrderNoListRequestConfig

/**
 * 接口 [获取卡包列表↗](https://yapi.gogpay.cn/project/757/interface/api/325202) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/list`
 */
export interface ApiMarketingCouponCardBagListRequest {
  /**
   * 状态：0=新到，1=快过期，2=待生效, 3=已失效 4=有效的 5=已使用
   */
  status?: number
  /**
   * 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券
   */
  ticketType?: number
}

/**
 * 接口 [获取卡包列表↗](https://yapi.gogpay.cn/project/757/interface/api/325202) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/list`
 */
export type ApiMarketingCouponCardBagListResponse = {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 适用范围说明
   */
  applyScope?: string
  /**
   * 优惠级别；0=无优惠级别 1=商品优惠，2=商家优惠，3=业务优惠
   */
  discountLevel?: number
  /**
   * 卡券有效期
   */
  expirationTime?: string
  extend?: {}
  /**
   * 适用商品；0=全部商品，1=指定商品可用，2=指定商品不可用
   */
  goodsType?: number
  /**
   * 备注类型 1 文字 2 链接
   */
  noteType?: number
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 领取状态；0=未领取或领取失败，1=领取成功,2领取中
   */
  receiveState?: number
  /**
   * 备注说明
   */
  remarks?: string
  /**
   * 适用范围
   */
  scope?: string
  /**
   * 状态：0=待生效，1=已生效,2=已过期,3=已使用
   */
  status?: number
  /**
   * 跳转按钮文案
   */
  targetTitle?: string
  /**
   * 跳转类型 -1：商品列表，0：指定路由，1：唤起微信
   */
  targetType?: number
  /**
   * 跳转路由
   */
  targetUrl?: string
  /**
   * 卡券ID
   */
  ticketId?: string
  /**
   * 卡券logo
   */
  ticketLogo?: string
  /**
   * 卡券名字
   */
  ticketName?: string
  /**
   * 卡券副标题
   */
  ticketSubName?: string
  /**
   * 卡券下面的子分类
   */
  ticketSubType?: number
  /**
   * 三级标题
   */
  ticketThirdName?: string
  /**
   * 卡券类型；1=平台券，2=微信券，3=门店券，4=礼品卡 5=第三方券 6=翼支付
   */
  ticketType?: number
  /**
   * TV跳转路由
   */
  tvTargetUrl?: string
  /**
   * 使用结束时间
   */
  useEndTime?: string
  /**
   * 开始使用时间
   */
  useStartTime?: string
  /**
   * 使用时限
   */
  useTimeLimit?: string
  /**
   * 可用时间
   */
  validTime?: string
}[]

/**
 * 接口 [获取卡包列表↗](https://yapi.gogpay.cn/project/757/interface/api/325202) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/list`
 */
type ApiMarketingCouponCardBagListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/cardBag/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取卡包列表↗](https://yapi.gogpay.cn/project/757/interface/api/325202) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/list`
 */
const apiMarketingCouponCardBagListRequestConfig: ApiMarketingCouponCardBagListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/cardBag/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponCardBagList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取卡包列表', author: '成龙' },
  }

/**
 * 接口 [获取卡包列表↗](https://yapi.gogpay.cn/project/757/interface/api/325202) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/list`
 */
export const apiMarketingCouponCardBagList = /*#__PURE__*/ (
  requestData: ApiMarketingCouponCardBagListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponCardBagListResponse>(
    prepare(apiMarketingCouponCardBagListRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponCardBagList.requestConfig =
  apiMarketingCouponCardBagListRequestConfig

/**
 * 接口 [获取券包预览↗](https://yapi.gogpay.cn/project/757/interface/api/325210) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/reviewCount`
 */
export interface ApiMarketingCouponCardBagReviewCountRequest {
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口 [获取券包预览↗](https://yapi.gogpay.cn/project/757/interface/api/325210) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/reviewCount`
 */
export interface ApiMarketingCouponCardBagReviewCountResponse {
  allCount?: {
    /**
     * 总量
     */
    count?: number
    /**
     * 卡券类型 0全部 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券 6 翼支付
     */
    tickType?: number
    /**
     * 卡券类型文案
     */
    tickTypeText?: string
  }
  bestPayCoupon?: {
    /**
     * 总量
     */
    count?: number
    /**
     * 卡券类型 0全部 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券 6 翼支付
     */
    tickType?: number
    /**
     * 卡券类型文案
     */
    tickTypeText?: string
  }
  coupon?: {
    /**
     * 总量
     */
    count?: number
    /**
     * 卡券类型 0全部 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券 6 翼支付
     */
    tickType?: number
    /**
     * 卡券类型文案
     */
    tickTypeText?: string
  }
  third?: {
    /**
     * 总量
     */
    count?: number
    /**
     * 卡券类型 0全部 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券 6 翼支付
     */
    tickType?: number
    /**
     * 卡券类型文案
     */
    tickTypeText?: string
  }
  voucher?: {
    /**
     * 总量
     */
    count?: number
    /**
     * 卡券类型 0全部 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券 6 翼支付
     */
    tickType?: number
    /**
     * 卡券类型文案
     */
    tickTypeText?: string
  }
  wxCoupon?: {
    /**
     * 总量
     */
    count?: number
    /**
     * 卡券类型 0全部 1 平台券 2 微信券 3 门店券 4 礼品卡 5 第三方券 6 翼支付
     */
    tickType?: number
    /**
     * 卡券类型文案
     */
    tickTypeText?: string
  }
}

/**
 * 接口 [获取券包预览↗](https://yapi.gogpay.cn/project/757/interface/api/325210) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/reviewCount`
 */
type ApiMarketingCouponCardBagReviewCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/757',
    'https://mall-gw.duotest.cn',
    '',
    '/marketingCoupon/api/cardBag/reviewCount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取券包预览↗](https://yapi.gogpay.cn/project/757/interface/api/325210) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/reviewCount`
 */
const apiMarketingCouponCardBagReviewCountRequestConfig: ApiMarketingCouponCardBagReviewCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_11_0_29,
    devUrl: devUrl_0_11_0_29,
    prodUrl: prodUrl_0_11_0_29,
    path: '/marketingCoupon/api/cardBag/reviewCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_11_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMarketingCouponCardBagReviewCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取券包预览', author: '成龙' },
  }

/**
 * 接口 [获取券包预览↗](https://yapi.gogpay.cn/project/757/interface/api/325210) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [公开领取API↗](https://yapi.gogpay.cn/project/757/interface/api/cat_6271)
 * @请求头 `POST /marketingCoupon/api/cardBag/reviewCount`
 */
export const apiMarketingCouponCardBagReviewCount = /*#__PURE__*/ (
  requestData: ApiMarketingCouponCardBagReviewCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMarketingCouponCardBagReviewCountResponse>(
    prepare(apiMarketingCouponCardBagReviewCountRequestConfig, requestData),
    ...args,
  )
}

apiMarketingCouponCardBagReviewCount.requestConfig =
  apiMarketingCouponCardBagReviewCountRequestConfig

const mockUrl_0_18_0_0 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_0 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_0 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_0 = 'data' as any

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/60606) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodityByDate`
 */
export interface ApiActivityActivityGetActivityCommodityByDateRequest {
  /**
   * 活动日期，不传默认为今日
   */
  date?: string
}

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/60606) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodityByDate`
 */
export interface ApiActivityActivityGetActivityCommodityByDateResponse {
  /**
   * 数据列表
   */
  list?: {
    activityData?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 是否可以进行购买
       */
      canPay?: boolean
      commodityInfo?: {
        /**
         * 商品图片
         */
        commodityCoverImg?: string
        /**
         * 商品Id
         */
        commodityId?: string
        /**
         * 商品标题
         */
        commodityTitle?: string
        /**
         * 商品类型 0标电 1标销
         */
        commodityType?: number
        /**
         * 划线价
         */
        dashPrice?: number
        /**
         * 单日限购数量
         */
        dayLimitCount?: number
        /**
         * 等级要求 0表示不限制
         */
        levelLimit?: number
        /**
         * 会员等级名称
         */
        levelLimitName?: string
        /**
         * 限购数量
         */
        limitCount?: number
        /**
         * 原价
         */
        originalPrice?: number
        /**
         * 秒杀进度
         */
        progress?: number
        /**
         * 秒杀价格
         */
        seckillPrice?: number
        /**
         * sku信息
         */
        skuInfo?: {
          /**
           * 原价
           */
          originalPrice?: number
          /**
           * sku图片
           */
          pic?: string
          /**
           * sku价格
           */
          price?: number
          /**
           * sku描述
           */
          skuDesc?: string
          /**
           * SKU Id
           */
          skuId?: string
          /**
           * 剩余库存
           */
          stock?: number
        }[]
        /**
         * 排序值
         */
        sortNo?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
        /**
         * 总库存
         */
        totalStock?: number
      }
      /**
       * 结束时间
       */
      endTime?: string
      /**
       * 不可购买的原因
       */
      notPayReason?: string
      /**
       * 场次Id
       */
      sessionId?: string
      /**
       * 开始日期
       */
      startDate?: string
      /**
       * 开始时间
       */
      startTime?: string
      /**
       * 用户当前的等级
       */
      userLevel?: number
    }
    /**
     * 是否有活动正在运行
     */
    hasActivity?: boolean
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/60606) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodityByDate`
 */
type ApiActivityActivityGetActivityCommodityByDateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getActivityCommodityByDate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/60606) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodityByDate`
 */
const apiActivityActivityGetActivityCommodityByDateRequestConfig: ApiActivityActivityGetActivityCommodityByDateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getActivityCommodityByDate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetActivityCommodityByDate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '根据日期获取活动商品', author: '成龙' },
  }

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/60606) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodityByDate`
 */
export const apiActivityActivityGetActivityCommodityByDate = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetActivityCommodityByDateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetActivityCommodityByDateResponse>(
    prepare(
      apiActivityActivityGetActivityCommodityByDateRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityActivityGetActivityCommodityByDate.requestConfig =
  apiActivityActivityGetActivityCommodityByDateRequestConfig

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/60608) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommoditySku`
 */
export interface ApiActivityActivityGetCommoditySkuRequest {
  /**
   * 活动Id
   */
  activityId: string
  commodityId?: string
  /**
   * 场次Id
   */
  sessionId: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/60608) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommoditySku`
 */
export type ApiActivityActivityGetCommoditySkuResponse = {
  /**
   * sku属性名称
   */
  attributeName: string
  /**
   * 属性下拉参数
   */
  options: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * 选中下拉参数
   */
  selected: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * sku属性ID
   */
  skuAttributeId: string
}[]

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/60608) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommoditySku`
 */
type ApiActivityActivityGetCommoditySkuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getCommoditySku',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/60608) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommoditySku`
 */
const apiActivityActivityGetCommoditySkuRequestConfig: ApiActivityActivityGetCommoditySkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getCommoditySku',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetCommoditySku',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定活动的商品SKU列表', author: '成龙' },
  }

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/60608) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommoditySku`
 */
export const apiActivityActivityGetCommoditySku = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetCommoditySkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetCommoditySkuResponse>(
    prepare(apiActivityActivityGetCommoditySkuRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityGetCommoditySku.requestConfig =
  apiActivityActivityGetCommoditySkuRequestConfig

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/60610) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getSkuInfo`
 */
export interface ApiActivityActivityGetSkuInfoRequest {
  commodityId?: string
  skuId?: string
}

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/60610) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getSkuInfo`
 */
export interface ApiActivityActivityGetSkuInfoResponse {
  activityId?: string
  limitCount?: number
  price?: number
  skuId?: string
  stock?: number
}

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/60610) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getSkuInfo`
 */
type ApiActivityActivityGetSkuInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getSkuInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/60610) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getSkuInfo`
 */
const apiActivityActivityGetSkuInfoRequestConfig: ApiActivityActivityGetSkuInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getSkuInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetSkuInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品SKU信息', author: '成龙' },
  }

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/60610) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getSkuInfo`
 */
export const apiActivityActivityGetSkuInfo = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetSkuInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetSkuInfoResponse>(
    prepare(apiActivityActivityGetSkuInfoRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityGetSkuInfo.requestConfig =
  apiActivityActivityGetSkuInfoRequestConfig

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/60614) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/commodityList`
 */
export interface ApiActivityActivityCommodityListRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 场次Id
   */
  sessionId: string
  /**
   * 1全部 2我能买
   */
  type: number
}

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/60614) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/commodityList`
 */
export interface ApiActivityActivityCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品图片
     */
    commodityCoverImg?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品类型 0标电 1标销
     */
    commodityType?: number
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 单日限购数量
     */
    dayLimitCount?: number
    /**
     * 等级要求 0表示不限制
     */
    levelLimit?: number
    /**
     * 会员等级名称
     */
    levelLimitName?: string
    /**
     * 限购数量
     */
    limitCount?: number
    /**
     * 原价
     */
    originalPrice?: number
    /**
     * 秒杀进度
     */
    progress?: number
    /**
     * 秒杀价格
     */
    seckillPrice?: number
    /**
     * sku信息
     */
    skuInfo?: {
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * sku图片
       */
      pic?: string
      /**
       * sku价格
       */
      price?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * SKU Id
       */
      skuId?: string
      /**
       * 剩余库存
       */
      stock?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 总库存
     */
    totalStock?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/60614) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/commodityList`
 */
type ApiActivityActivityCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/60614) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/commodityList`
 */
const apiActivityActivityCommodityListRequestConfig: ApiActivityActivityCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场次商品列表', author: '成龙' },
  }

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/60614) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/commodityList`
 */
export const apiActivityActivityCommodityList = /*#__PURE__*/ (
  requestData: ApiActivityActivityCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityCommodityListResponse>(
    prepare(apiActivityActivityCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityCommodityList.requestConfig =
  apiActivityActivityCommodityListRequestConfig

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60616) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodity`
 */
export interface ApiActivityActivityGetActivityCommodityRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60616) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodity`
 */
export interface ApiActivityActivityGetActivityCommodityResponse {
  activityData?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 是否可以进行购买
     */
    canPay?: boolean
    commodityInfo?: {
      /**
       * 商品图片
       */
      commodityCoverImg?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 商品类型 0标电 1标销
       */
      commodityType?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 单日限购数量
       */
      dayLimitCount?: number
      /**
       * 等级要求 0表示不限制
       */
      levelLimit?: number
      /**
       * 会员等级名称
       */
      levelLimitName?: string
      /**
       * 限购数量
       */
      limitCount?: number
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * 秒杀进度
       */
      progress?: number
      /**
       * 秒杀价格
       */
      seckillPrice?: number
      /**
       * sku信息
       */
      skuInfo?: {
        /**
         * 原价
         */
        originalPrice?: number
        /**
         * sku图片
         */
        pic?: string
        /**
         * sku价格
         */
        price?: number
        /**
         * sku描述
         */
        skuDesc?: string
        /**
         * SKU Id
         */
        skuId?: string
        /**
         * 剩余库存
         */
        stock?: number
      }[]
      /**
       * 排序值
       */
      sortNo?: number
      /**
       * 剩余库存
       */
      surplusStock?: number
      /**
       * 总库存
       */
      totalStock?: number
    }
    /**
     * 结束时间
     */
    endTime?: string
    /**
     * 不可购买的原因
     */
    notPayReason?: string
    /**
     * 场次Id
     */
    sessionId?: string
    /**
     * 开始日期
     */
    startDate?: string
    /**
     * 开始时间
     */
    startTime?: string
    /**
     * 用户当前的等级
     */
    userLevel?: number
  }
  /**
   * 是否有活动正在运行
   */
  hasActivity?: boolean
}

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60616) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodity`
 */
type ApiActivityActivityGetActivityCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getActivityCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60616) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodity`
 */
const apiActivityActivityGetActivityCommodityRequestConfig: ApiActivityActivityGetActivityCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getActivityCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetActivityCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品对应的秒杀活动信息', author: '成龙' },
  }

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60616) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getActivityCommodity`
 */
export const apiActivityActivityGetActivityCommodity = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetActivityCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetActivityCommodityResponse>(
    prepare(apiActivityActivityGetActivityCommodityRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityGetActivityCommodity.requestConfig =
  apiActivityActivityGetActivityCommodityRequestConfig

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/60618) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/index`
 */
export interface ApiActivityActivityIndexRequest {
  /**
   * 运营渠道Id
   */
  businessChannelId: string
}

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/60618) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/index`
 */
export interface ApiActivityActivityIndexResponse {
  /**
   * 活动日期列表,格式yyyy-MM-dd
   */
  activityDates?: unknown[]
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 浮动按钮图片地址
   */
  buttonImage?: string
  /**
   * 浮动按钮跳转链接
   */
  buttonJumpLink?: string
  /**
   * 是否有活动运行
   */
  hasActivity?: boolean
  /**
   * 匹配最近可用日期，默认选中日期,
   */
  matchDate?: string
  /**
   * 场次时间列表，默认返回匹配日期对应的场次
   */
  sessions?: {
    /**
     * 结束时间，格式HH:mm
     */
    endTime?: string
    /**
     * 场次Id
     */
    sessionId?: string
    /**
     * 场次开始日期，格式yyyy-MM-dd
     */
    startDate?: string
    /**
     * 开始时间,格式 HH:mm
     */
    startTime?: string
    /**
     * 时间段类型 0普通时段  1全天时段
     */
    timeType?: number
  }[]
}

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/60618) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/index`
 */
type ApiActivityActivityIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/index',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/60618) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/index`
 */
const apiActivityActivityIndexRequestConfig: ApiActivityActivityIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取活动首页', author: '成龙' },
  }

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/60618) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/index`
 */
export const apiActivityActivityIndex = /*#__PURE__*/ (
  requestData: ApiActivityActivityIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityIndexResponse>(
    prepare(apiActivityActivityIndexRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityIndex.requestConfig = apiActivityActivityIndexRequestConfig

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/81678) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/activitySession`
 */
export interface ApiActivityActivityActivitySessionRequest {
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  /**
   * 活动日期，不传默认为今日
   */
  date?: string
}

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/81678) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/activitySession`
 */
export type ApiActivityActivityActivitySessionResponse = {
  /**
   * 结束时间，格式HH:mm
   */
  endTime?: string
  /**
   * 场次Id
   */
  sessionId?: string
  /**
   * 场次开始日期，格式yyyy-MM-dd
   */
  startDate?: string
  /**
   * 开始时间,格式 HH:mm
   */
  startTime?: string
  /**
   * 时间段类型 0普通时段  1全天时段
   */
  timeType?: number
}[]

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/81678) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/activitySession`
 */
type ApiActivityActivityActivitySessionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/activitySession',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/81678) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/activitySession`
 */
const apiActivityActivityActivitySessionRequestConfig: ApiActivityActivityActivitySessionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/activitySession',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityActivitySession',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定日期对应的活动场次', author: '成龙' },
  }

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/81678) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/activitySession`
 */
export const apiActivityActivityActivitySession = /*#__PURE__*/ (
  requestData: ApiActivityActivityActivitySessionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityActivitySessionResponse>(
    prepare(apiActivityActivityActivitySessionRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityActivitySession.requestConfig =
  apiActivityActivityActivitySessionRequestConfig

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/214226) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityActivity`
 */
export interface ApiActivityActivityGetCommodityActivityRequest {
  categoryId?: string
  commodityId?: string
  unitOrgCode?: string
}

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/214226) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityActivity`
 */
export interface ApiActivityActivityGetCommodityActivityResponse {
  /**
   * 活动列表
   */
  activityList?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动类型 1秒杀 2折扣优惠
     */
    activityType?:
      | 'SECKILL'
      | 'DISCOUNT'
      | 'FULL_REDUCTION'
      | 'INTEGRAL'
      | 'VIRTUAL'
      | 'PRODUCT_LIBRARY'
    /**
     * 活动描述
     */
    desc?: string
    /**
     * 活动结束日期
     */
    endDate?: string
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 活动sku列表
     */
    skuList?: {
      /**
       * 活动售卖价格
       */
      activityPrice?: number
      /**
       * sku图片
       */
      image?: string
      /**
       * 活动配置原价
       */
      originalPrice?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuId
       */
      skuId?: string
      /**
       * 剩余活动库存
       */
      surplusActivityStock?: number
    }[]
    /**
     * 活动开始日期
     */
    startDate?: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
  }[]
  /**
   * 是否包含活动
   */
  hasActivity?: boolean
}

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/214226) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityActivity`
 */
type ApiActivityActivityGetCommodityActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getCommodityActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/214226) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityActivity`
 */
const apiActivityActivityGetCommodityActivityRequestConfig: ApiActivityActivityGetCommodityActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getCommodityActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetCommodityActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品活动列表信息', author: '520号开发' },
  }

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/214226) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityActivity`
 */
export const apiActivityActivityGetCommodityActivity = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetCommodityActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetCommodityActivityResponse>(
    prepare(apiActivityActivityGetCommodityActivityRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivityGetCommodityActivity.requestConfig =
  apiActivityActivityGetCommodityActivityRequestConfig

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/214230) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityGroupBuying`
 */
export interface ApiActivityActivityGetCommodityGroupBuyingRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/214230) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityGroupBuying`
 */
export interface ApiActivityActivityGetCommodityGroupBuyingResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 商品Id
   */
  commodityId?: string
  groupData?: {
    /**
     * 团单信息
     */
    groupItems?: {
      /**
       * 团单购买商品Id
       */
      commodityId?: string
      /**
       * 拼团倒计时（秒),groupStatus=（0,1时返回）
       */
      finishCountDown?: number
      /**
       * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
       */
      groupStatus?: number
      /**
       * 头像
       */
      headImg?: string
      /**
       * 下一阶段成团人数差距，groupStatus=(0,1)时返回
       */
      nextLevelCount?: number
      /**
       * 下一阶段退还金额,groupStatus=1时返回
       */
      nextLevelReturnAmount?: number
      /**
       * 团单订单Id
       */
      orderId?: string
      /**
       * 手机号码
       */
      userPhone?: string
    }[]
    /**
     * 正在拼单人数
     */
    userCount?: number
  }
  /**
   * 是否具备活动
   */
  hasActivity?: boolean
  /**
   * 规格列表
   */
  skuInfos?: {
    /**
     * 阶梯配置
     */
    ladderConfig?: {
      /**
       * 阶梯：1-一阶 2-...
       */
      ladder?: number
      /**
       * 阶梯价格
       */
      ladderPrice?: number
      /**
       * 阶梯人数
       */
      userNum?: number
    }[]
    /**
     * 最高价格
     */
    maxPrice?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
}

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/214230) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityGroupBuying`
 */
type ApiActivityActivityGetCommodityGroupBuyingRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getCommodityGroupBuying',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/214230) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityGroupBuying`
 */
const apiActivityActivityGetCommodityGroupBuyingRequestConfig: ApiActivityActivityGetCommodityGroupBuyingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getCommodityGroupBuying',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetCommodityGroupBuying',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品的拼团优惠信息', author: '520号开发' },
  }

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/214230) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getCommodityGroupBuying`
 */
export const apiActivityActivityGetCommodityGroupBuying = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetCommodityGroupBuyingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetCommodityGroupBuyingResponse>(
    prepare(
      apiActivityActivityGetCommodityGroupBuyingRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityActivityGetCommodityGroupBuying.requestConfig =
  apiActivityActivityGetCommodityGroupBuyingRequestConfig

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214234) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getGroupBuyingActivity`
 */
export interface ApiActivityActivityGetGroupBuyingActivityRequest {
  /**
   * 活动Id
   */
  activityId?: string
}

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214234) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getGroupBuyingActivity`
 */
export interface ApiActivityActivityGetGroupBuyingActivityResponse {
  /**
   * 活动规则
   */
  activityRules?: string
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: number
  /**
   * 运营渠道
   */
  businessChannel?: string
  /**
   * 活动规则地址
   */
  cmsUrl?: string
  /**
   * 结束时间
   */
  endTime?: string
  /**
   * 团购活动ID
   */
  groupBuyingActId?: string
  /**
   * 团购活动名称
   */
  groupBuyingActName?: string
  /**
   * 分组列表
   */
  groupList?: {
    /**
     * 分组Id
     */
    groupId?: string
    /**
     * 分组名称
     */
    groupName?: string
    /**
     * 分组图片
     */
    groupPic?: string
    /**
     * SKU列表
     */
    skuList?: {
      activityId?: string
      /**
       * SKU阶梯信息
       */
      groupBuyingLadder?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 会员等级：-1不限制 参照会员中心
       */
      membersLv?: number
      /**
       * SKU原价
       */
      originalPrice?: number
      /**
       * 专区ID
       */
      regionId?: string
      /**
       * 专区名称
       */
      regionName?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      settlementConfig?: {
        /**
         * 出资方；1=平台出资，2=商家出资，3=共同出资
         */
        contributionType: number
        /**
         * 共同出资方式；1=商家出资占比，2=平台出资占比
         */
        jointContributionType: number
        /**
         * 共同出资占比
         */
        jointContributionVal: string
      }
      /**
       * SKUID
       */
      skuId?: string
      /**
       * sku名称
       */
      skuName?: string
      /**
       * sku状态：0-待开售 1-售卖中 2-已停售
       */
      skuStatus?: 'WAIT_SELL' | 'SELLING' | 'STOP_SELL'
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * 上下架状态 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 虚拟团员数量
       */
      virtualUserNum?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
  }[]
  /**
   * 成团有效时间(小时)
   */
  groupValidTime?: number
  /**
   * 头图
   */
  headPic?: string
  /**
   * 开始时间
   */
  startTime?: string
}

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214234) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getGroupBuyingActivity`
 */
type ApiActivityActivityGetGroupBuyingActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/getGroupBuyingActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214234) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getGroupBuyingActivity`
 */
const apiActivityActivityGetGroupBuyingActivityRequestConfig: ApiActivityActivityGetGroupBuyingActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/getGroupBuyingActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityGetGroupBuyingActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取拼团活动信息', author: '520号开发' },
  }

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214234) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/getGroupBuyingActivity`
 */
export const apiActivityActivityGetGroupBuyingActivity = /*#__PURE__*/ (
  requestData: ApiActivityActivityGetGroupBuyingActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivityGetGroupBuyingActivityResponse>(
    prepare(
      apiActivityActivityGetGroupBuyingActivityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityActivityGetGroupBuyingActivity.requestConfig =
  apiActivityActivityGetGroupBuyingActivityRequestConfig

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214238) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/sync`
 */
export interface ApiActivityActivitySyncRequest {
  /**
   * 活动规则
   */
  activityRules?: string
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: number
  /**
   * 运营渠道
   */
  businessChannel?: string
  /**
   * 活动规则地址
   */
  cmsUrl?: string
  /**
   * 结束时间
   */
  endTime?: string
  /**
   * 团购活动ID
   */
  groupBuyingActId?: string
  /**
   * 团购活动名称
   */
  groupBuyingActName?: string
  /**
   * 分组列表
   */
  groupList?: {
    /**
     * 分组Id
     */
    groupId?: string
    /**
     * 分组名称
     */
    groupName?: string
    /**
     * 分组图片
     */
    groupPic?: string
    /**
     * SKU列表
     */
    skuList?: {
      activityId?: string
      /**
       * SKU阶梯信息
       */
      groupBuyingLadder?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 会员等级：-1不限制 参照会员中心
       */
      membersLv?: number
      /**
       * SKU原价
       */
      originalPrice?: number
      /**
       * 专区ID
       */
      regionId?: string
      /**
       * 专区名称
       */
      regionName?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      settlementConfig?: {
        /**
         * 出资方；1=平台出资，2=商家出资，3=共同出资
         */
        contributionType: number
        /**
         * 共同出资方式；1=商家出资占比，2=平台出资占比
         */
        jointContributionType: number
        /**
         * 共同出资占比
         */
        jointContributionVal: string
      }
      /**
       * SKUID
       */
      skuId?: string
      /**
       * sku名称
       */
      skuName?: string
      /**
       * sku状态：0-待开售 1-售卖中 2-已停售
       */
      skuStatus?: 'WAIT_SELL' | 'SELLING' | 'STOP_SELL'
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * 上下架状态 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 虚拟团员数量
       */
      virtualUserNum?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
  }[]
  /**
   * 成团有效时间(小时)
   */
  groupValidTime?: number
  /**
   * 头图
   */
  headPic?: string
  /**
   * 开始时间
   */
  startTime?: string
}

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214238) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/sync`
 */
export interface ApiActivityActivitySyncResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214238) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/sync`
 */
type ApiActivityActivitySyncRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/activity/sync',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214238) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/sync`
 */
const apiActivityActivitySyncRequestConfig: ApiActivityActivitySyncRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_0,
    devUrl: devUrl_0_18_0_0,
    prodUrl: prodUrl_0_18_0_0,
    path: '/activity/api/activity/sync',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivitySync',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同步拼团活动信息', author: '520号开发' },
  }

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/214238) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12905)
 * @请求头 `POST /activity/api/activity/sync`
 */
export const apiActivityActivitySync = /*#__PURE__*/ (
  requestData: ApiActivityActivitySyncRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityActivitySyncResponse>(
    prepare(apiActivityActivitySyncRequestConfig, requestData),
    ...args,
  )
}

apiActivityActivitySync.requestConfig = apiActivityActivitySyncRequestConfig

const mockUrl_0_18_0_1 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_1 = 'data' as any

/**
 * 接口 [获取活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60562) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/activityInfo`
 */
export interface ApiActivityImsApiActivitySeckillActivityInfoRequest {
  /**
   * 活动Id
   */
  activityId?: string
}

/**
 * 接口 [获取活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60562) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/activityInfo`
 */
export interface ApiActivityImsApiActivitySeckillActivityInfoResponse {
  activationFlag?: number
  activityStatus?: '0' | '1' | '2' | '3'
  backgroundImage?: string
  buttonImage?: string
  buttonJumpLink?: string
  regionId?: string
  sessionList?: {
    commodityList?: {
      commodityType?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '1001' | '1002'
      dashPrice?: number
      dayPurchaseLimit?: number
      membersLv?: number
      /**
       * 会员名称
       */
      membersName?: string
      originalPrice?: number
      regionId?: string
      resourceId?: string
      resourceName?: string
      resourcePic?: string
      resourceStatus?: '0' | '1' | '2' | '3'
      skillPrice?: number
      skuList?: {
        originalPrice?: number
        skillPrice?: number
        skillStock?: number
        skuId?: string
        skuImage?: string
        skuName?: string
        stockKey?: string
      }[]
      sortNo?: number
      surplusStock?: number
      totalStock?: number
      userPurchaseLimit?: number
    }[]
    /**
     * 日期类型：0-短期 1-长期
     */
    dateType?: number
    endDate?: string
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    sessionId?: string
    /**
     * 场次状态：0-未开始 1-进行中 2-已结束 3-已终止
     */
    sessionStatus?: '0' | '1' | '2' | '3'
    startDate?: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 时段类型：0-时段 1-全天
     */
    timeType?: number
  }[]
  settlementConfig?: {
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
  }
  skillActivityId?: string
  skillActivityName?: string
}

/**
 * 接口 [获取活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60562) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/activityInfo`
 */
type ApiActivityImsApiActivitySeckillActivityInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/imsApi/activity/seckill/activityInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60562) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/activityInfo`
 */
const apiActivityImsApiActivitySeckillActivityInfoRequestConfig: ApiActivityImsApiActivitySeckillActivityInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_1,
    devUrl: devUrl_0_18_0_1,
    prodUrl: prodUrl_0_18_0_1,
    path: '/activity/imsApi/activity/seckill/activityInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityImsApiActivitySeckillActivityInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取活动信息', author: '成龙' },
  }

/**
 * 接口 [获取活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60562) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/activityInfo`
 */
export const apiActivityImsApiActivitySeckillActivityInfo = /*#__PURE__*/ (
  requestData: ApiActivityImsApiActivitySeckillActivityInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityImsApiActivitySeckillActivityInfoResponse>(
    prepare(
      apiActivityImsApiActivitySeckillActivityInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityImsApiActivitySeckillActivityInfo.requestConfig =
  apiActivityImsApiActivitySeckillActivityInfoRequestConfig

/**
 * 接口 [获取所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60564) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/allActivity`
 */
export interface ApiActivityImsApiActivitySeckillAllActivityRequest {}

/**
 * 接口 [获取所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60564) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/allActivity`
 */
export type ApiActivityImsApiActivitySeckillAllActivityResponse = string[]

/**
 * 接口 [获取所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60564) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/allActivity`
 */
type ApiActivityImsApiActivitySeckillAllActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/imsApi/activity/seckill/allActivity',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60564) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/allActivity`
 */
const apiActivityImsApiActivitySeckillAllActivityRequestConfig: ApiActivityImsApiActivitySeckillAllActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_1,
    devUrl: devUrl_0_18_0_1,
    prodUrl: prodUrl_0_18_0_1,
    path: '/activity/imsApi/activity/seckill/allActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityImsApiActivitySeckillAllActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取所有活动信息', author: '成龙' },
  }

/**
 * 接口 [获取所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60564) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/allActivity`
 */
export const apiActivityImsApiActivitySeckillAllActivity = /*#__PURE__*/ (
  requestData?: ApiActivityImsApiActivitySeckillAllActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityImsApiActivitySeckillAllActivityResponse>(
    prepare(
      apiActivityImsApiActivitySeckillAllActivityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityImsApiActivitySeckillAllActivity.requestConfig =
  apiActivityImsApiActivitySeckillAllActivityRequestConfig

/**
 * 接口 [同步活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60566) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/sync`
 */
export interface ApiActivityImsApiActivitySeckillSyncRequest {
  /**
   * 活动Id
   */
  activityId?: string
}

/**
 * 接口 [同步活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60566) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/sync`
 */
export interface ApiActivityImsApiActivitySeckillSyncResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同步活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60566) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/sync`
 */
type ApiActivityImsApiActivitySeckillSyncRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/imsApi/activity/seckill/sync',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同步活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60566) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/sync`
 */
const apiActivityImsApiActivitySeckillSyncRequestConfig: ApiActivityImsApiActivitySeckillSyncRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_1,
    devUrl: devUrl_0_18_0_1,
    prodUrl: prodUrl_0_18_0_1,
    path: '/activity/imsApi/activity/seckill/sync',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityImsApiActivitySeckillSync',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同步活动信息', author: '成龙' },
  }

/**
 * 接口 [同步活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/60566) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [秒杀活动管理↗](https://yapi.gogpay.cn/project/927/interface/api/cat_12912)
 * @请求头 `POST /activity/imsApi/activity/seckill/sync`
 */
export const apiActivityImsApiActivitySeckillSync = /*#__PURE__*/ (
  requestData: ApiActivityImsApiActivitySeckillSyncRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityImsApiActivitySeckillSyncResponse>(
    prepare(apiActivityImsApiActivitySeckillSyncRequestConfig, requestData),
    ...args,
  )
}

apiActivityImsApiActivitySeckillSync.requestConfig =
  apiActivityImsApiActivitySeckillSyncRequestConfig

const mockUrl_0_18_0_2 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_2 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_2 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_2 = 'data' as any

/**
 * 接口 [获取优惠活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/326386) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [discount-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_37449)
 * @请求头 `POST /activity/api/discount/detail`
 */
export interface ApiActivityDiscountDetailRequest {
  /**
   * 业务类型，4.0新增
   */
  businessType: string
  /**
   * 类目ID
   */
  categoryId: string
  /**
   * 规格ID
   */
  skuId: string
  /**
   * 子机构编码，4.0新增
   */
  unitOrgCode: string[]
}

/**
 * 接口 [获取优惠活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/326386) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [discount-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_37449)
 * @请求头 `POST /activity/api/discount/detail`
 */
export interface ApiActivityDiscountDetailResponse {
  /**
   * 活动ID
   */
  activityActId: string
  /**
   * 折扣活动名称
   */
  activityName: string
  /**
   * 活动状态：0=未开始，1=进行中,2=已终止
   */
  activityStatus?: number
  /**
   * 审批状态：0=待审批，10=审批中，11=审批拒绝，12=审批已撤销,13=审批通过，20=终止审批中，21=终止审批拒绝，22=终止审批已撤销 23=终止审批通过
   */
  approvalStatus?: number
  businessLeader?: {
    /**
     * 部门ID
     */
    departId?: string
    /**
     * 部门名称
     */
    departName?: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 用户名称
     */
    userName?: string
  }
  /**
   * 优惠内容
   */
  couponContent?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 是否跨店：0-否 1-是'
   */
  crossStoreFlag?: number
  /**
   * 优惠条件
   */
  discountConditions?: {
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityTitle?: string
    /**
     * 条件ID
     */
    conditionId?: string
    /**
     * 条件名称
     */
    conditionName?: string
    /**
     * 折后价
     */
    discountAfterPrice?: number
    /**
     * 优惠级别；1=商品优惠，2=商家优惠，3=业务优惠 4-类目优惠
     */
    discountLevel?: number
    /**
     * 优惠订单数量
     */
    discountOrder?: number
    /**
     * 优惠总额
     */
    discountTotal?: number
    /**
     * 售价
     */
    sellPrice?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 总限购
     */
    totalPurchaseLimit?: number
    /**
     * 单人限购
     */
    userPurchaseLimit?: number
  }[]
  /**
   * 优惠级别: 1=商品优惠，2=商家优惠，3=业务优惠 4-类目优惠'
   */
  discountLevel?: number
  /**
   * 折扣率
   */
  discountRate?: number
  /**
   * 优惠结束时间
   */
  endTime?: string
  /**
   * 营销活动名称
   */
  marketingActivityName?: string
  /**
   * 营销活动ID
   */
  refMarketingActivityId?: string
  /**
   * 备注说明'
   */
  remarks?: string
  settlementConfig: {
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
  }
  /**
   * 展示模板ID
   */
  showTemplateId?: string
  /**
   * 专项营销活动标识
   */
  specialMarketingExplain?: string
  /**
   * 优惠开始时间
   */
  startTime?: string
  /**
   * 是否可叠加优惠:0-否 1-是
   */
  superimposeDiscountFlag?: number
  /**
   * 触发类型：0-无限制 1-订单金额满 2-商品件满'
   */
  triggerType?: number
  /**
   * 数量：triggerType=1、2时有值'
   */
  triggerVal?: number
  /**
   * 活动商品待支付时间配置
   */
  waitPayTimeConfig?: number
}

/**
 * 接口 [获取优惠活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/326386) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [discount-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_37449)
 * @请求头 `POST /activity/api/discount/detail`
 */
type ApiActivityDiscountDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/discount/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取优惠活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/326386) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [discount-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_37449)
 * @请求头 `POST /activity/api/discount/detail`
 */
const apiActivityDiscountDetailRequestConfig: ApiActivityDiscountDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_2,
    devUrl: devUrl_0_18_0_2,
    prodUrl: prodUrl_0_18_0_2,
    path: '/activity/api/discount/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityDiscountDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取优惠活动详情', author: '333号开发' },
  }

/**
 * 接口 [获取优惠活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/326386) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [discount-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_37449)
 * @请求头 `POST /activity/api/discount/detail`
 */
export const apiActivityDiscountDetail = /*#__PURE__*/ (
  requestData: ApiActivityDiscountDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityDiscountDetailResponse>(
    prepare(apiActivityDiscountDetailRequestConfig, requestData),
    ...args,
  )
}

apiActivityDiscountDetail.requestConfig = apiActivityDiscountDetailRequestConfig

const mockUrl_0_18_0_10 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_10 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_10 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_10 = 'data' as any

/**
 * 接口 [品牌升级详情↗](https://yapi.gogpay.cn/project/927/interface/api/229862) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-品牌升级↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39468)
 * @请求头 `POST /activity/api/brand/detail`
 */
export interface ApiActivityBrandDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [品牌升级详情↗](https://yapi.gogpay.cn/project/927/interface/api/229862) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-品牌升级↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39468)
 * @请求头 `POST /activity/api/brand/detail`
 */
export interface ApiActivityBrandDetailResponse {
  /**
   * 背景色
   */
  backgroundColor: string
  /**
   * 按钮文案
   */
  buttonText: string
  /**
   * 产品介绍
   */
  commodityDetails: string[]
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 主图
   */
  mainImage: string
  /**
   * 商品是否品牌升级：0-否 1-是
   */
  status: number
  /**
   * 产品故事
   */
  story: string[]
  /**
   * 故事类型：0-图片 1-视频
   */
  storyType?: number
  /**
   * 跳转路由
   */
  targetUrl: string
  /**
   * 主题色
   */
  topicColor: string
}

/**
 * 接口 [品牌升级详情↗](https://yapi.gogpay.cn/project/927/interface/api/229862) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-品牌升级↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39468)
 * @请求头 `POST /activity/api/brand/detail`
 */
type ApiActivityBrandDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/brand/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [品牌升级详情↗](https://yapi.gogpay.cn/project/927/interface/api/229862) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-品牌升级↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39468)
 * @请求头 `POST /activity/api/brand/detail`
 */
const apiActivityBrandDetailRequestConfig: ApiActivityBrandDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_10,
    devUrl: devUrl_0_18_0_10,
    prodUrl: prodUrl_0_18_0_10,
    path: '/activity/api/brand/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityBrandDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '品牌升级详情', author: '成龙' },
  }

/**
 * 接口 [品牌升级详情↗](https://yapi.gogpay.cn/project/927/interface/api/229862) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-品牌升级↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39468)
 * @请求头 `POST /activity/api/brand/detail`
 */
export const apiActivityBrandDetail = /*#__PURE__*/ (
  requestData: ApiActivityBrandDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityBrandDetailResponse>(
    prepare(apiActivityBrandDetailRequestConfig, requestData),
    ...args,
  )
}

apiActivityBrandDetail.requestConfig = apiActivityBrandDetailRequestConfig

const mockUrl_0_18_0_12 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_12 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_12 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_12 = 'data' as any

/**
 * 接口 [获取团购信息↗](https://yapi.gogpay.cn/project/927/interface/api/229866) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-团购活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39525)
 * @请求头 `POST /activity/api/groupBuying/getGroupBuying`
 */
export interface ApiActivityGroupBuyingGetGroupBuyingRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 活动状态：活动状态：0-未开始 1-进行中 2-已结束 2-已终止
   */
  activityStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 分组ID
   */
  groupId?: string
}

/**
 * 接口 [获取团购信息↗](https://yapi.gogpay.cn/project/927/interface/api/229866) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-团购活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39525)
 * @请求头 `POST /activity/api/groupBuying/getGroupBuying`
 */
export type ApiActivityGroupBuyingGetGroupBuyingResponse = {
  /**
   * 活动规则
   */
  activityRules?: string
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: number
  /**
   * 运营渠道
   */
  businessChannel?: string
  /**
   * 活动规则地址
   */
  cmsUrl?: string
  /**
   * 结束时间
   */
  endTime?: string
  /**
   * 团购活动ID
   */
  groupBuyingActId?: string
  /**
   * 团购活动名称
   */
  groupBuyingActName?: string
  /**
   * 分组列表
   */
  groupList?: {
    /**
     * 分组Id
     */
    groupId?: string
    /**
     * 分组名称
     */
    groupName?: string
    /**
     * 分组图片
     */
    groupPic?: string
    /**
     * SKU列表
     */
    skuList?: {
      activityId?: string
      /**
       * SKU阶梯信息
       */
      groupBuyingLadder?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 会员等级：-1不限制 参照会员中心
       */
      membersLv?: number
      /**
       * SKU原价
       */
      originalPrice?: number
      /**
       * 专区ID
       */
      regionId?: string
      /**
       * 专区名称
       */
      regionName?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      settlementConfig?: {
        /**
         * 出资方；1=平台出资，2=商家出资，3=共同出资
         */
        contributionType: number
        /**
         * 共同出资方式；1=商家出资占比，2=平台出资占比
         */
        jointContributionType: number
        /**
         * 共同出资占比
         */
        jointContributionVal: string
      }
      /**
       * SKUID
       */
      skuId?: string
      /**
       * sku名称
       */
      skuName?: string
      /**
       * sku状态：0-待开售 1-售卖中 2-已停售
       */
      skuStatus?: 'WAIT_SELL' | 'SELLING' | 'STOP_SELL'
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * 上下架状态 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 虚拟团员数量
       */
      virtualUserNum?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
  }[]
  /**
   * 成团有效时间(小时)
   */
  groupValidTime?: number
  /**
   * 头图
   */
  headPic?: string
  /**
   * 开始时间
   */
  startTime?: string
}[]

/**
 * 接口 [获取团购信息↗](https://yapi.gogpay.cn/project/927/interface/api/229866) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-团购活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39525)
 * @请求头 `POST /activity/api/groupBuying/getGroupBuying`
 */
type ApiActivityGroupBuyingGetGroupBuyingRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/groupBuying/getGroupBuying',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取团购信息↗](https://yapi.gogpay.cn/project/927/interface/api/229866) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-团购活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39525)
 * @请求头 `POST /activity/api/groupBuying/getGroupBuying`
 */
const apiActivityGroupBuyingGetGroupBuyingRequestConfig: ApiActivityGroupBuyingGetGroupBuyingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_12,
    devUrl: devUrl_0_18_0_12,
    prodUrl: prodUrl_0_18_0_12,
    path: '/activity/api/groupBuying/getGroupBuying',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityGroupBuyingGetGroupBuying',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取团购信息', author: '成龙' },
  }

/**
 * 接口 [获取团购信息↗](https://yapi.gogpay.cn/project/927/interface/api/229866) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-团购活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39525)
 * @请求头 `POST /activity/api/groupBuying/getGroupBuying`
 */
export const apiActivityGroupBuyingGetGroupBuying = /*#__PURE__*/ (
  requestData: ApiActivityGroupBuyingGetGroupBuyingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityGroupBuyingGetGroupBuyingResponse>(
    prepare(apiActivityGroupBuyingGetGroupBuyingRequestConfig, requestData),
    ...args,
  )
}

apiActivityGroupBuyingGetGroupBuying.requestConfig =
  apiActivityGroupBuyingGetGroupBuyingRequestConfig

const mockUrl_0_18_0_13 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_13 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_13 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_13 = 'data' as any

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/229870) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/index`
 */
export interface ApiActivityLotteryOpenIndexRequest {
  /**
   * 活动Id
   */
  activityId?: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/229870) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/index`
 */
export interface ApiActivityLotteryOpenIndexResponse {
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 背景色
   */
  backgroundColor?: string
  /**
   * 活动简介
   */
  description?: string
  /**
   * 活动头图
   */
  headImage?: string
  /**
   * 活动Id
   */
  id?: string
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 场次列表
   */
  sessionList?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 报名结束时间
     */
    endTime?: string
    /**
     * 报名结束时间时间戳
     */
    endTimeTS?: number
    /**
     * 场次Id
     */
    id?: string
    /**
     * 限制类型 1无限制 2优惠券限制
     */
    limitType?: number
    /**
     * 场次名称
     */
    name?: string
    /**
     * 开奖时间
     */
    openPrizeTime?: string
    /**
     * 开奖时间时间戳
     */
    openPrizeTimeTS?: number
    /**
     * 中奖名额数量
     */
    prizeCount?: number
    /**
     * 奖品图片
     */
    prizeImage?: string
    /**
     * 场次状态 1未开始 2报名中 3待开奖 4已结束
     */
    sessionStatus?: number
    /**
     * 报名开始时间
     */
    startTime?: string
    /**
     * 报名开始时间时间戳
     */
    startTimeTS?: number
    /**
     * 用户状态 1未报名 2已报名 3已中奖 4未中奖
     */
    userStatus?: number
  }[]
  /**
   * 分享描述
   */
  shareDesc: string
  /**
   * 分享图片
   */
  shareImage: string
  /**
   * 分享标题
   */
  shareTitle: string
}

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/229870) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/index`
 */
type ApiActivityLotteryOpenIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/open/index',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/229870) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/index`
 */
const apiActivityLotteryOpenIndexRequestConfig: ApiActivityLotteryOpenIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_13,
    devUrl: devUrl_0_18_0_13,
    prodUrl: prodUrl_0_18_0_13,
    path: '/activity/api/lottery/open/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryOpenIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '活动首页', author: '成龙' },
  }

/**
 * 接口 [活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/229870) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/index`
 */
export const apiActivityLotteryOpenIndex = /*#__PURE__*/ (
  requestData: ApiActivityLotteryOpenIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryOpenIndexResponse>(
    prepare(apiActivityLotteryOpenIndexRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryOpenIndex.requestConfig =
  apiActivityLotteryOpenIndexRequestConfig

/**
 * 接口 [场次详情↗](https://yapi.gogpay.cn/project/927/interface/api/229874) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/sessionDetail`
 */
export interface ApiActivityLotteryOpenSessionDetailRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * IP地址
   */
  ip?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 场次ID
   */
  sessionId: string
}

/**
 * 接口 [场次详情↗](https://yapi.gogpay.cn/project/927/interface/api/229874) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/sessionDetail`
 */
export interface ApiActivityLotteryOpenSessionDetailResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 报名结束时间
   */
  endTime?: string
  /**
   * 报名结束时间时间戳
   */
  endTimeTS?: number
  /**
   * 场次Id
   */
  id?: string
  /**
   * 限制类型 1无限制 2优惠券限制
   */
  limitType?: number
  /**
   * 场次名称
   */
  name?: string
  /**
   * 开奖时间
   */
  openPrizeTime?: string
  /**
   * 开奖时间时间戳
   */
  openPrizeTimeTS?: number
  /**
   * 中奖名额数量
   */
  prizeCount?: number
  /**
   * 奖品图片
   */
  prizeImage?: string
  /**
   * 开奖结果 如果
   */
  prizeItems?: {
    /**
     * 用户手机号
     */
    userPhone?: string
  }[]
  /**
   * 中奖提示语
   */
  prizeTips?: string
  /**
   * 场次规则
   */
  rule?: string
  /**
   * 场次数量
   */
  sessionCount?: number
  /**
   * 场次状态 1未开始 2报名中 3待开奖 4已结束
   */
  sessionStatus?: number
  /**
   * 分享描述
   */
  shareDesc: string
  /**
   * 分享图片
   */
  shareImage: string
  /**
   * 分享标题
   */
  shareTitle: string
  /**
   * 报名开始时间
   */
  startTime?: string
  /**
   * 报名开始时间时间戳
   */
  startTimeTS?: number
  /**
   * 用户状态 1未报名 2已报名 3已中奖 4未中奖
   */
  userStatus?: number
}

/**
 * 接口 [场次详情↗](https://yapi.gogpay.cn/project/927/interface/api/229874) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/sessionDetail`
 */
type ApiActivityLotteryOpenSessionDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/open/sessionDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [场次详情↗](https://yapi.gogpay.cn/project/927/interface/api/229874) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/sessionDetail`
 */
const apiActivityLotteryOpenSessionDetailRequestConfig: ApiActivityLotteryOpenSessionDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_13,
    devUrl: devUrl_0_18_0_13,
    prodUrl: prodUrl_0_18_0_13,
    path: '/activity/api/lottery/open/sessionDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryOpenSessionDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '场次详情', author: '成龙' },
  }

/**
 * 接口 [场次详情↗](https://yapi.gogpay.cn/project/927/interface/api/229874) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/sessionDetail`
 */
export const apiActivityLotteryOpenSessionDetail = /*#__PURE__*/ (
  requestData: ApiActivityLotteryOpenSessionDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryOpenSessionDetailResponse>(
    prepare(apiActivityLotteryOpenSessionDetailRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryOpenSessionDetail.requestConfig =
  apiActivityLotteryOpenSessionDetailRequestConfig

/**
 * 接口 [报名↗](https://yapi.gogpay.cn/project/927/interface/api/229878) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signUp`
 */
export interface ApiActivityLotteryOpenSignUpRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * IP地址
   */
  ip?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 场次ID
   */
  sessionId: string
}

/**
 * 接口 [报名↗](https://yapi.gogpay.cn/project/927/interface/api/229878) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signUp`
 */
export interface ApiActivityLotteryOpenSignUpResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [报名↗](https://yapi.gogpay.cn/project/927/interface/api/229878) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signUp`
 */
type ApiActivityLotteryOpenSignUpRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/open/signUp',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [报名↗](https://yapi.gogpay.cn/project/927/interface/api/229878) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signUp`
 */
const apiActivityLotteryOpenSignUpRequestConfig: ApiActivityLotteryOpenSignUpRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_13,
    devUrl: devUrl_0_18_0_13,
    prodUrl: prodUrl_0_18_0_13,
    path: '/activity/api/lottery/open/signUp',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryOpenSignUp',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '报名', author: '成龙' },
  }

/**
 * 接口 [报名↗](https://yapi.gogpay.cn/project/927/interface/api/229878) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signUp`
 */
export const apiActivityLotteryOpenSignUp = /*#__PURE__*/ (
  requestData: ApiActivityLotteryOpenSignUpRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryOpenSignUpResponse>(
    prepare(apiActivityLotteryOpenSignUpRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryOpenSignUp.requestConfig =
  apiActivityLotteryOpenSignUpRequestConfig

/**
 * 接口 [开奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/230054) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signRecord`
 */
export interface ApiActivityLotteryOpenSignRecordRequest {}

/**
 * 接口 [开奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/230054) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signRecord`
 */
export type ApiActivityLotteryOpenSignRecordResponse = {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 记录id
   */
  id?: string
  /**
   * 场次名称
   */
  name?: string
  /**
   * 开奖时间
   */
  openPrizeTime?: string
  /**
   * 开奖时间时间戳
   */
  openPrizeTimeTS?: number
  /**
   * 中奖名额数量
   */
  prizeCount?: number
  /**
   * 奖品图片
   */
  prizeImage?: string
  /**
   * 场次Id
   */
  sessionId?: string
  /**
   * 提示语
   */
  tips?: string
  /**
   * 用户状态  2待开奖 3已中奖 4未中奖
   */
  userStatus?: number
}[]

/**
 * 接口 [开奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/230054) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signRecord`
 */
type ApiActivityLotteryOpenSignRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/open/signRecord',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [开奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/230054) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signRecord`
 */
const apiActivityLotteryOpenSignRecordRequestConfig: ApiActivityLotteryOpenSignRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_13,
    devUrl: devUrl_0_18_0_13,
    prodUrl: prodUrl_0_18_0_13,
    path: '/activity/api/lottery/open/signRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryOpenSignRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开奖记录', author: '成龙' },
  }

/**
 * 接口 [开奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/230054) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/signRecord`
 */
export const apiActivityLotteryOpenSignRecord = /*#__PURE__*/ (
  requestData?: ApiActivityLotteryOpenSignRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryOpenSignRecordResponse>(
    prepare(apiActivityLotteryOpenSignRecordRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryOpenSignRecord.requestConfig =
  apiActivityLotteryOpenSignRecordRequestConfig

/**
 * 接口 [触发用户分享↗](https://yapi.gogpay.cn/project/927/interface/api/230262) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/triggerShare`
 */
export interface ApiActivityLotteryOpenTriggerShareRequest {
  /**
   * 活动Id
   */
  activityId?: string
}

/**
 * 接口 [触发用户分享↗](https://yapi.gogpay.cn/project/927/interface/api/230262) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/triggerShare`
 */
export interface ApiActivityLotteryOpenTriggerShareResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [触发用户分享↗](https://yapi.gogpay.cn/project/927/interface/api/230262) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/triggerShare`
 */
type ApiActivityLotteryOpenTriggerShareRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/open/triggerShare',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [触发用户分享↗](https://yapi.gogpay.cn/project/927/interface/api/230262) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/triggerShare`
 */
const apiActivityLotteryOpenTriggerShareRequestConfig: ApiActivityLotteryOpenTriggerShareRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_13,
    devUrl: devUrl_0_18_0_13,
    prodUrl: prodUrl_0_18_0_13,
    path: '/activity/api/lottery/open/triggerShare',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryOpenTriggerShare',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '触发用户分享', author: '成龙' },
  }

/**
 * 接口 [触发用户分享↗](https://yapi.gogpay.cn/project/927/interface/api/230262) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-开奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39528)
 * @请求头 `POST /activity/api/lottery/open/triggerShare`
 */
export const apiActivityLotteryOpenTriggerShare = /*#__PURE__*/ (
  requestData: ApiActivityLotteryOpenTriggerShareRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryOpenTriggerShareResponse>(
    prepare(apiActivityLotteryOpenTriggerShareRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryOpenTriggerShare.requestConfig =
  apiActivityLotteryOpenTriggerShareRequestConfig

const mockUrl_0_18_0_14 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_14 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_14 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_14 = 'data' as any

/**
 * 接口 [获取盲盒活动↗](https://yapi.gogpay.cn/project/927/interface/api/229858) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-盲盒↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39531)
 * @请求头 `POST /activity/api/blind/box/getActivity`
 */
export interface ApiActivityBlindBoxGetActivityRequest {
  /**
   * 秒杀活动ID
   */
  blindBoxActivityId?: string
  /**
   * 分页起始参数
   */
  pageIndex?: number
  /**
   * 每页大小
   */
  pageSize?: number
}

/**
 * 接口 [获取盲盒活动↗](https://yapi.gogpay.cn/project/927/interface/api/229858) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-盲盒↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39531)
 * @请求头 `POST /activity/api/blind/box/getActivity`
 */
export type ApiActivityBlindBoxGetActivityResponse = {
  /**
   * 激活状态：0-否 1-是
   */
  activationFlag?: number
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: '0' | '1' | '2' | '3'
  /**
   * 背景图
   */
  backgroundImage: string
  /**
   * 浮动按钮图片地址
   */
  buttonImage?: string
  /**
   * 浮动按钮跳转链接
   */
  buttonJumpLink?: string
  /**
   * 专区ID
   */
  regionId?: string
  /**
   * 秒杀活动场次
   */
  sessionList?: {
    /**
     * 商品列表
     */
    commodityList?: {
      /**
       * 商品图片
       */
      commodityCoverImg?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 商品类型
       */
      commodityType?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '1001' | '1002'
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 单日限购数量
       */
      dayLimitCount?: number
      /**
       * 单日销售限量
       */
      dayPurchaseLimit?: number
      /**
       * 等级要求 0表示不限制
       */
      levelLimit?: number
      /**
       * 会员等级名称
       */
      levelLimitName?: string
      /**
       * 限购数量
       */
      limitCount?: number
      /**
       * 会员等级限制，0表示不限制
       */
      membersLv?: number
      /**
       * 会员名称
       */
      membersName?: string
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * 秒杀进度
       */
      progress?: number
      /**
       * 所属专区Id（商城）
       */
      regionId?: string
      /**
       * 资源Id（商品ID）
       */
      resourceId?: string
      /**
       * 资源名称（商品名称）
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      /**
       * 资源状态：0-未开始 1-进行中 2-已结束 3-已终止
       */
      resourceStatus?: number
      /**
       * 秒杀价格
       */
      seckillPrice?: number
      /**
       * 秒杀价格
       */
      skillPrice?: number
      /**
       * 规格列表
       */
      skuList?: {
        /**
         * 原价
         */
        originalPrice?: number
        /**
         * 秒杀价格
         */
        skillPrice?: number
        /**
         * 秒杀库存
         */
        skillStock?: number
        /**
         * skuId
         */
        skuId?: string
        /**
         * sku图片
         */
        skuImage?: string
        /**
         * sku名称
         */
        skuName?: string
        /**
         * 缓存key
         */
        stockKey?: string
      }[]
      /**
       * 排序值正序
       */
      sortNo?: number
      /**
       * 剩余库存
       */
      surplusStock?: number
      /**
       * 总库存
       */
      totalStock?: number
      /**
       * 用户限购数量
       */
      userPurchaseLimit?: number
    }[]
    /**
     * 日期类型：0-短期 1-长期
     */
    dateType?: number
    /**
     * 结束日期
     */
    endDate?: string
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 场次ID
     */
    sessionId?: string
    /**
     * 场次状态：0-未开始 1-进行中 2-已结束 3-已终止
     */
    sessionStatus?: number
    /**
     * 开始日期
     */
    startDate?: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 时段类型：0-时段 1-全天
     */
    timeType?: number
  }[]
  settlementConfig: {
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
  }
  /**
   * 秒杀活动ID
   */
  skillActivityId?: string
  /**
   * 秒杀活动名称
   */
  skillActivityName?: string
}[]

/**
 * 接口 [获取盲盒活动↗](https://yapi.gogpay.cn/project/927/interface/api/229858) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-盲盒↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39531)
 * @请求头 `POST /activity/api/blind/box/getActivity`
 */
type ApiActivityBlindBoxGetActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/blind/box/getActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取盲盒活动↗](https://yapi.gogpay.cn/project/927/interface/api/229858) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-盲盒↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39531)
 * @请求头 `POST /activity/api/blind/box/getActivity`
 */
const apiActivityBlindBoxGetActivityRequestConfig: ApiActivityBlindBoxGetActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_14,
    devUrl: devUrl_0_18_0_14,
    prodUrl: prodUrl_0_18_0_14,
    path: '/activity/api/blind/box/getActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityBlindBoxGetActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取盲盒活动', author: '成龙' },
  }

/**
 * 接口 [获取盲盒活动↗](https://yapi.gogpay.cn/project/927/interface/api/229858) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-盲盒↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39531)
 * @请求头 `POST /activity/api/blind/box/getActivity`
 */
export const apiActivityBlindBoxGetActivity = /*#__PURE__*/ (
  requestData: ApiActivityBlindBoxGetActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityBlindBoxGetActivityResponse>(
    prepare(apiActivityBlindBoxGetActivityRequestConfig, requestData),
    ...args,
  )
}

apiActivityBlindBoxGetActivity.requestConfig =
  apiActivityBlindBoxGetActivityRequestConfig

const mockUrl_0_18_0_15 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_15 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_15 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_15 = 'data' as any

/**
 * 接口 [获取秒杀活动↗](https://yapi.gogpay.cn/project/927/interface/api/229882) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-秒杀↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39534)
 * @请求头 `POST /activity/api/skill/getSkillActivity`
 */
export interface ApiActivitySkillGetSkillActivityRequest {
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 2-已终止
   */
  activityStatus?: number
  /**
   * 分页起始参数
   */
  pageIndex?: number
  /**
   * 每页大小
   */
  pageSize?: number
  /**
   * 秒杀专区ID
   */
  regionId?: string
  /**
   * 秒杀活动ID
   */
  skillActivityId?: string
}

/**
 * 接口 [获取秒杀活动↗](https://yapi.gogpay.cn/project/927/interface/api/229882) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-秒杀↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39534)
 * @请求头 `POST /activity/api/skill/getSkillActivity`
 */
export type ApiActivitySkillGetSkillActivityResponse = {
  /**
   * 激活状态：0-否 1-是
   */
  activationFlag?: number
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: '0' | '1' | '2' | '3'
  /**
   * 背景图
   */
  backgroundImage: string
  /**
   * 浮动按钮图片地址
   */
  buttonImage?: string
  /**
   * 浮动按钮跳转链接
   */
  buttonJumpLink?: string
  /**
   * 专区ID
   */
  regionId?: string
  /**
   * 秒杀活动场次
   */
  sessionList?: {
    /**
     * 商品列表
     */
    commodityList?: {
      /**
       * 商品图片
       */
      commodityCoverImg?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 商品类型
       */
      commodityType?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '1001' | '1002'
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 单日限购数量
       */
      dayLimitCount?: number
      /**
       * 单日销售限量
       */
      dayPurchaseLimit?: number
      /**
       * 等级要求 0表示不限制
       */
      levelLimit?: number
      /**
       * 会员等级名称
       */
      levelLimitName?: string
      /**
       * 限购数量
       */
      limitCount?: number
      /**
       * 会员等级限制，0表示不限制
       */
      membersLv?: number
      /**
       * 会员名称
       */
      membersName?: string
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * 秒杀进度
       */
      progress?: number
      /**
       * 所属专区Id（商城）
       */
      regionId?: string
      /**
       * 资源Id（商品ID）
       */
      resourceId?: string
      /**
       * 资源名称（商品名称）
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      /**
       * 资源状态：0-未开始 1-进行中 2-已结束 3-已终止
       */
      resourceStatus?: number
      /**
       * 秒杀价格
       */
      seckillPrice?: number
      /**
       * 秒杀价格
       */
      skillPrice?: number
      /**
       * 规格列表
       */
      skuList?: {
        /**
         * 原价
         */
        originalPrice?: number
        /**
         * 秒杀价格
         */
        skillPrice?: number
        /**
         * 秒杀库存
         */
        skillStock?: number
        /**
         * skuId
         */
        skuId?: string
        /**
         * sku图片
         */
        skuImage?: string
        /**
         * sku名称
         */
        skuName?: string
        /**
         * 缓存key
         */
        stockKey?: string
      }[]
      /**
       * 排序值正序
       */
      sortNo?: number
      /**
       * 剩余库存
       */
      surplusStock?: number
      /**
       * 总库存
       */
      totalStock?: number
      /**
       * 用户限购数量
       */
      userPurchaseLimit?: number
    }[]
    /**
     * 日期类型：0-短期 1-长期
     */
    dateType?: number
    /**
     * 结束日期
     */
    endDate?: string
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 场次ID
     */
    sessionId?: string
    /**
     * 场次状态：0-未开始 1-进行中 2-已结束 3-已终止
     */
    sessionStatus?: number
    /**
     * 开始日期
     */
    startDate?: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 时段类型：0-时段 1-全天
     */
    timeType?: number
  }[]
  settlementConfig: {
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
  }
  /**
   * 秒杀活动ID
   */
  skillActivityId?: string
  /**
   * 秒杀活动名称
   */
  skillActivityName?: string
}[]

/**
 * 接口 [获取秒杀活动↗](https://yapi.gogpay.cn/project/927/interface/api/229882) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-秒杀↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39534)
 * @请求头 `POST /activity/api/skill/getSkillActivity`
 */
type ApiActivitySkillGetSkillActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/skill/getSkillActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取秒杀活动↗](https://yapi.gogpay.cn/project/927/interface/api/229882) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-秒杀↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39534)
 * @请求头 `POST /activity/api/skill/getSkillActivity`
 */
const apiActivitySkillGetSkillActivityRequestConfig: ApiActivitySkillGetSkillActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_15,
    devUrl: devUrl_0_18_0_15,
    prodUrl: prodUrl_0_18_0_15,
    path: '/activity/api/skill/getSkillActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivitySkillGetSkillActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取秒杀活动', author: '成龙' },
  }

/**
 * 接口 [获取秒杀活动↗](https://yapi.gogpay.cn/project/927/interface/api/229882) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-秒杀↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39534)
 * @请求头 `POST /activity/api/skill/getSkillActivity`
 */
export const apiActivitySkillGetSkillActivity = /*#__PURE__*/ (
  requestData: ApiActivitySkillGetSkillActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivitySkillGetSkillActivityResponse>(
    prepare(apiActivitySkillGetSkillActivityRequestConfig, requestData),
    ...args,
  )
}

apiActivitySkillGetSkillActivity.requestConfig =
  apiActivitySkillGetSkillActivityRequestConfig

const mockUrl_0_18_0_16 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_16 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_16 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_16 = 'data' as any

/**
 * 接口 [获取商品展示模板↗](https://yapi.gogpay.cn/project/927/interface/api/229854) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-获取活动模板↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39537)
 * @请求头 `POST /activity/api/activityShowTemplate/getCommodityTemplate`
 */
export interface ApiActivityActivityShowTemplateGetCommodityTemplateRequest {
  /**
   * 关联业务ID
   */
  refId: string
  /**
   * skuId
   */
  resourceId: string
}

/**
 * 接口 [获取商品展示模板↗](https://yapi.gogpay.cn/project/927/interface/api/229854) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-获取活动模板↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39537)
 * @请求头 `POST /activity/api/activityShowTemplate/getCommodityTemplate`
 */
export interface ApiActivityActivityShowTemplateGetCommodityTemplateResponse {
  /**
   * 活动展示模板名称
   */
  activityShowTemplateName?: string
  /**
   * 背景图
   */
  backgroundImgUrl?: string
  /**
   * 划线价背景色
   */
  dashPriceBackgroundColor?: string
  /**
   * 划线价标签
   */
  dashPriceTag?: string
  /**
   * 划线价文字色
   */
  dashPriceTextColor?: string
  /**
   * 是否存在模板：0-否 1-是
   */
  hasTemplate?: number
  /**
   * 是否进行活动预告 0否1是
   */
  noticeFlag?: string
  /**
   * 活动预告时间
   */
  noticeTime?: string
  /**
   * 业务ID
   */
  refId?: string
  /**
   * 售价背景色
   */
  sellingPriceBackgroundColor?: string
  /**
   * 售价标签
   */
  sellingPriceTag?: string
  /**
   * 售价文字色
   */
  sellingPriceTextColor?: string
  /**
   * 是否存在模板：0-图片 1-图文并茂
   */
  templateType?: number
}

/**
 * 接口 [获取商品展示模板↗](https://yapi.gogpay.cn/project/927/interface/api/229854) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-获取活动模板↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39537)
 * @请求头 `POST /activity/api/activityShowTemplate/getCommodityTemplate`
 */
type ApiActivityActivityShowTemplateGetCommodityTemplateRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/927',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/activity/api/activityShowTemplate/getCommodityTemplate',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取商品展示模板↗](https://yapi.gogpay.cn/project/927/interface/api/229854) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-获取活动模板↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39537)
 * @请求头 `POST /activity/api/activityShowTemplate/getCommodityTemplate`
 */
const apiActivityActivityShowTemplateGetCommodityTemplateRequestConfig: ApiActivityActivityShowTemplateGetCommodityTemplateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_16,
    devUrl: devUrl_0_18_0_16,
    prodUrl: prodUrl_0_18_0_16,
    path: '/activity/api/activityShowTemplate/getCommodityTemplate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityActivityShowTemplateGetCommodityTemplate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品展示模板', author: '成龙' },
  }

/**
 * 接口 [获取商品展示模板↗](https://yapi.gogpay.cn/project/927/interface/api/229854) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-获取活动模板↗](https://yapi.gogpay.cn/project/927/interface/api/cat_39537)
 * @请求头 `POST /activity/api/activityShowTemplate/getCommodityTemplate`
 */
export const apiActivityActivityShowTemplateGetCommodityTemplate =
  /*#__PURE__*/ (
    requestData: ApiActivityActivityShowTemplateGetCommodityTemplateRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiActivityActivityShowTemplateGetCommodityTemplateResponse>(
      prepare(
        apiActivityActivityShowTemplateGetCommodityTemplateRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiActivityActivityShowTemplateGetCommodityTemplate.requestConfig =
  apiActivityActivityShowTemplateGetCommodityTemplateRequestConfig

const mockUrl_0_18_0_22 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_22 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_22 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_22 = 'data' as any

/**
 * 接口 [活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/234646) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryActivityInfo`
 */
export interface ApiActivityLotteryQueryActivityInfoRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/234646) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryActivityInfo`
 */
export interface ApiActivityLotteryQueryActivityInfoResponse {
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 活动结束时间
   */
  endTime?: string
  exchangeRule?: number
  /**
   * 活动头图
   */
  headPic?: string
  /**
   * 活动ID
   */
  id?: string
  /**
   * 活动简介
   */
  introduction?: string
  /**
   * 是否可分享获取次数；1=是，0=否
   */
  isShare?: number
  /**
   * 是否可分享获取次数；1=是，0=否
   */
  isSignIn?: number
  /**
   * 活动模板类型 0默认模板 1对联模板 2自定义模板
   */
  lottyActivityType: number
  /**
   * 奖品类表
   */
  prizeList?: {
    id?: string
    pic?: string
    title?: string
  }[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 分享描述
   */
  shareDesc?: string
  /**
   * 分享缩略图
   */
  shareImage?: string
  /**
   * 分享标题
   */
  shareTitle?: string
  /**
   * 分享地址
   */
  shareUrl: string
  /**
   * 活动开始时间
   */
  startTime?: string
  /**
   * 状态：0=未开始，1=进行中，2=已结束
   */
  state?: number
  templateInfo: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动简介图片
     */
    activityIntroImage: string
    /**
     * 活动时间按钮线条颜色
     */
    activityTimeButtonBorderColor: string
    /**
     * 活动时间字体颜色
     */
    activityTimeButtonFontColor: string
    /**
     * 背景颜色
     */
    backgroundColor: string
    /**
     * 背景图
     */
    backgroundImage: string
    /**
     * 活动简介/抽奖规则内容背景颜色
     */
    introBackgroundColor: string
    /**
     * 抽奖按钮图片
     */
    lotteryButtonImage: string
    /**
     * 抽奖规则图片
     */
    lotteryRulesImage: string
    /**
     * 中奖记录图片
     */
    lotteryWinRecordImage: string
    /**
     * 剩余机会背景颜色
     */
    remainingChancesBgColor: string
    /**
     * 剩余机会字体颜色
     */
    remainingChancesFontColor: string
    /**
     * 转盘背景图(亮灯)
     */
    wheelBrightImage: string
    /**
     * 转盘颜色1
     */
    wheelColor1: string
    /**
     * 转盘颜色2
     */
    wheelColor2: string
    /**
     * 转盘颜色3
     */
    wheelColor3: string
    /**
     * 转盘背景图(暗灯)
     */
    wheelDarkImage: string
  }
}

/**
 * 接口 [活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/234646) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryActivityInfo`
 */
type ApiActivityLotteryQueryActivityInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/queryActivityInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/234646) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryActivityInfo`
 */
const apiActivityLotteryQueryActivityInfoRequestConfig: ApiActivityLotteryQueryActivityInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/queryActivityInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryQueryActivityInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '活动信息', author: '张彬' },
  }

/**
 * 接口 [活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/234646) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryActivityInfo`
 */
export const apiActivityLotteryQueryActivityInfo = /*#__PURE__*/ (
  requestData: ApiActivityLotteryQueryActivityInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryQueryActivityInfoResponse>(
    prepare(apiActivityLotteryQueryActivityInfoRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryQueryActivityInfo.requestConfig =
  apiActivityLotteryQueryActivityInfoRequestConfig

/**
 * 接口 [获取抽奖资格↗](https://yapi.gogpay.cn/project/927/interface/api/234654) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryQualification`
 */
export interface ApiActivityLotteryQueryQualificationRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [获取抽奖资格↗](https://yapi.gogpay.cn/project/927/interface/api/234654) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryQualification`
 */
export interface ApiActivityLotteryQueryQualificationResponse {
  /**
   * 剩余抽奖次数
   */
  count?: number
}

/**
 * 接口 [获取抽奖资格↗](https://yapi.gogpay.cn/project/927/interface/api/234654) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryQualification`
 */
type ApiActivityLotteryQueryQualificationRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/queryQualification',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取抽奖资格↗](https://yapi.gogpay.cn/project/927/interface/api/234654) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryQualification`
 */
const apiActivityLotteryQueryQualificationRequestConfig: ApiActivityLotteryQueryQualificationRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/queryQualification',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryQueryQualification',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取抽奖资格', author: '张彬' },
  }

/**
 * 接口 [获取抽奖资格↗](https://yapi.gogpay.cn/project/927/interface/api/234654) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryQualification`
 */
export const apiActivityLotteryQueryQualification = /*#__PURE__*/ (
  requestData: ApiActivityLotteryQueryQualificationRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryQueryQualificationResponse>(
    prepare(apiActivityLotteryQueryQualificationRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryQueryQualification.requestConfig =
  apiActivityLotteryQueryQualificationRequestConfig

/**
 * 接口 [查询抽奖结果↗](https://yapi.gogpay.cn/project/927/interface/api/234662) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryResult`
 */
export interface ApiActivityLotteryQueryResultRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 抽奖批次ID
   */
  batchNo?: string
}

/**
 * 接口 [查询抽奖结果↗](https://yapi.gogpay.cn/project/927/interface/api/234662) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryResult`
 */
export interface ApiActivityLotteryQueryResultResponse {
  /**
   * 奖品ID
   */
  id: string
  /**
   * 奖品图片
   */
  pic: string
  /**
   * 抽奖状态；0=抽奖中，1=中奖，2=未中奖
   */
  state: number
  /**
   * 未中奖提示文案
   */
  tips: string
  /**
   * 奖品名称
   */
  title: string
}

/**
 * 接口 [查询抽奖结果↗](https://yapi.gogpay.cn/project/927/interface/api/234662) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryResult`
 */
type ApiActivityLotteryQueryResultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/queryResult',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询抽奖结果↗](https://yapi.gogpay.cn/project/927/interface/api/234662) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryResult`
 */
const apiActivityLotteryQueryResultRequestConfig: ApiActivityLotteryQueryResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/queryResult',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryQueryResult',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询抽奖结果', author: '张彬' },
  }

/**
 * 接口 [查询抽奖结果↗](https://yapi.gogpay.cn/project/927/interface/api/234662) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryResult`
 */
export const apiActivityLotteryQueryResult = /*#__PURE__*/ (
  requestData: ApiActivityLotteryQueryResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryQueryResultResponse>(
    prepare(apiActivityLotteryQueryResultRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryQueryResult.requestConfig =
  apiActivityLotteryQueryResultRequestConfig

/**
 * 接口 [查询签到记录↗](https://yapi.gogpay.cn/project/927/interface/api/234670) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/querySignInRecord`
 */
export interface ApiActivityLotteryQuerySignInRecordRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [查询签到记录↗](https://yapi.gogpay.cn/project/927/interface/api/234670) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/querySignInRecord`
 */
export interface ApiActivityLotteryQuerySignInRecordResponse {
  /**
   * 已签到日期列表
   */
  dayList?: {
    /**
     * 日期，格式：2022-11-07
     */
    date: string
    /**
     * 是否签到获得抽奖次数；true=是，false=否
     */
    isGetTimes?: boolean
    /**
     * 签到状态；0=未签到，1=已签到，2=已过期
     */
    state: number
  }[]
  isContinuousSignIn?: boolean
  /**
   * 今日是否已签到；true=是，false=否
   */
  isSignedInToday?: boolean
  /**
   * 签到获取次数周期x天
   */
  signInDays?: number
  /**
   * 已签到天数
   */
  signedInDays?: number
}

/**
 * 接口 [查询签到记录↗](https://yapi.gogpay.cn/project/927/interface/api/234670) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/querySignInRecord`
 */
type ApiActivityLotteryQuerySignInRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/querySignInRecord',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询签到记录↗](https://yapi.gogpay.cn/project/927/interface/api/234670) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/querySignInRecord`
 */
const apiActivityLotteryQuerySignInRecordRequestConfig: ApiActivityLotteryQuerySignInRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/querySignInRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryQuerySignInRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询签到记录', author: '张彬' },
  }

/**
 * 接口 [查询签到记录↗](https://yapi.gogpay.cn/project/927/interface/api/234670) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/querySignInRecord`
 */
export const apiActivityLotteryQuerySignInRecord = /*#__PURE__*/ (
  requestData: ApiActivityLotteryQuerySignInRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryQuerySignInRecordResponse>(
    prepare(apiActivityLotteryQuerySignInRecordRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryQuerySignInRecord.requestConfig =
  apiActivityLotteryQuerySignInRecordRequestConfig

/**
 * 接口 [查询中奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/234678) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryWinRecord`
 */
export interface ApiActivityLotteryQueryWinRecordRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [查询中奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/234678) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryWinRecord`
 */
export type ApiActivityLotteryQueryWinRecordResponse = {
  /**
   * 是否已兑奖；兑换状态；1=是，0=否
   */
  exchangeStatus?: number
  /**
   * 是否填写了收货地址；1=填写了，0=未填写
   */
  hasReceiveAddress?: number
  /**
   * 中奖记录ID
   */
  id?: string
  /**
   * 奖品名称
   */
  prizeName?: string
  /**
   * 奖品类型:1-商品 2-优惠券
   */
  prizeType?: 'NONE' | 'COMMODITY' | 'COUPON'
  receiveAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 中奖时间
   */
  winTime?: string
}[]

/**
 * 接口 [查询中奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/234678) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryWinRecord`
 */
type ApiActivityLotteryQueryWinRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/queryWinRecord',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询中奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/234678) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryWinRecord`
 */
const apiActivityLotteryQueryWinRecordRequestConfig: ApiActivityLotteryQueryWinRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/queryWinRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryQueryWinRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询中奖记录', author: '张彬' },
  }

/**
 * 接口 [查询中奖记录↗](https://yapi.gogpay.cn/project/927/interface/api/234678) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/queryWinRecord`
 */
export const apiActivityLotteryQueryWinRecord = /*#__PURE__*/ (
  requestData: ApiActivityLotteryQueryWinRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryQueryWinRecordResponse>(
    prepare(apiActivityLotteryQueryWinRecordRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryQueryWinRecord.requestConfig =
  apiActivityLotteryQueryWinRecordRequestConfig

/**
 * 接口 [保存收货地址↗](https://yapi.gogpay.cn/project/927/interface/api/234686) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/saveAddress`
 */
export interface ApiActivityLotterySaveAddressRequest {
  receiveAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 中奖记录ID
   */
  winRecordId?: string
}

/**
 * 接口 [保存收货地址↗](https://yapi.gogpay.cn/project/927/interface/api/234686) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/saveAddress`
 */
export type ApiActivityLotterySaveAddressResponse = string

/**
 * 接口 [保存收货地址↗](https://yapi.gogpay.cn/project/927/interface/api/234686) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/saveAddress`
 */
type ApiActivityLotterySaveAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/saveAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [保存收货地址↗](https://yapi.gogpay.cn/project/927/interface/api/234686) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/saveAddress`
 */
const apiActivityLotterySaveAddressRequestConfig: ApiActivityLotterySaveAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/saveAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotterySaveAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '保存收货地址', author: '张彬' },
  }

/**
 * 接口 [保存收货地址↗](https://yapi.gogpay.cn/project/927/interface/api/234686) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/saveAddress`
 */
export const apiActivityLotterySaveAddress = /*#__PURE__*/ (
  requestData: ApiActivityLotterySaveAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotterySaveAddressResponse>(
    prepare(apiActivityLotterySaveAddressRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotterySaveAddress.requestConfig =
  apiActivityLotterySaveAddressRequestConfig

/**
 * 接口 [分享回调↗](https://yapi.gogpay.cn/project/927/interface/api/234694) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/share`
 */
export interface ApiActivityLotteryShareRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [分享回调↗](https://yapi.gogpay.cn/project/927/interface/api/234694) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/share`
 */
export interface ApiActivityLotteryShareResponse {
  /**
   * 分享次数
   */
  count?: number
  /**
   * 分享状态：0=未获得抽奖次数，1=获得抽奖次数，2=分享达到上线
   */
  state?: number
}

/**
 * 接口 [分享回调↗](https://yapi.gogpay.cn/project/927/interface/api/234694) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/share`
 */
type ApiActivityLotteryShareRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/share',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分享回调↗](https://yapi.gogpay.cn/project/927/interface/api/234694) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/share`
 */
const apiActivityLotteryShareRequestConfig: ApiActivityLotteryShareRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/share',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryShare',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分享回调', author: '张彬' },
  }

/**
 * 接口 [分享回调↗](https://yapi.gogpay.cn/project/927/interface/api/234694) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/share`
 */
export const apiActivityLotteryShare = /*#__PURE__*/ (
  requestData: ApiActivityLotteryShareRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryShareResponse>(
    prepare(apiActivityLotteryShareRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryShare.requestConfig = apiActivityLotteryShareRequestConfig

/**
 * 接口 [签到↗](https://yapi.gogpay.cn/project/927/interface/api/234702) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/signIn`
 */
export interface ApiActivityLotterySignInRequest {
  /**
   * 活动ID
   */
  activityId?: string
}

/**
 * 接口 [签到↗](https://yapi.gogpay.cn/project/927/interface/api/234702) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/signIn`
 */
export type ApiActivityLotterySignInResponse = string

/**
 * 接口 [签到↗](https://yapi.gogpay.cn/project/927/interface/api/234702) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/signIn`
 */
type ApiActivityLotterySignInRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/signIn',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [签到↗](https://yapi.gogpay.cn/project/927/interface/api/234702) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/signIn`
 */
const apiActivityLotterySignInRequestConfig: ApiActivityLotterySignInRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/signIn',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotterySignIn',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '签到', author: '张彬' },
  }

/**
 * 接口 [签到↗](https://yapi.gogpay.cn/project/927/interface/api/234702) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/signIn`
 */
export const apiActivityLotterySignIn = /*#__PURE__*/ (
  requestData: ApiActivityLotterySignInRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotterySignInResponse>(
    prepare(apiActivityLotterySignInRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotterySignIn.requestConfig = apiActivityLotterySignInRequestConfig

/**
 * 接口 [开始抽奖↗](https://yapi.gogpay.cn/project/927/interface/api/234710) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/start`
 */
export interface ApiActivityLotteryStartRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 微信open id
   */
  wxOpenId?: string
}

/**
 * 接口 [开始抽奖↗](https://yapi.gogpay.cn/project/927/interface/api/234710) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/start`
 */
export interface ApiActivityLotteryStartResponse {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 抽奖批次ID
   */
  batchNo?: string
  /**
   * 业务自定义错误码；0=业务处理成功，10001=抽奖次数不足
   */
  errorCode?: number
}

/**
 * 接口 [开始抽奖↗](https://yapi.gogpay.cn/project/927/interface/api/234710) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/start`
 */
type ApiActivityLotteryStartRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/start',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开始抽奖↗](https://yapi.gogpay.cn/project/927/interface/api/234710) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/start`
 */
const apiActivityLotteryStartRequestConfig: ApiActivityLotteryStartRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/start',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryStart',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开始抽奖', author: '张彬' },
  }

/**
 * 接口 [开始抽奖↗](https://yapi.gogpay.cn/project/927/interface/api/234710) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/start`
 */
export const apiActivityLotteryStart = /*#__PURE__*/ (
  requestData: ApiActivityLotteryStartRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryStartResponse>(
    prepare(apiActivityLotteryStartRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryStart.requestConfig = apiActivityLotteryStartRequestConfig

/**
 * 接口 [兑换奖品↗](https://yapi.gogpay.cn/project/927/interface/api/427548) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/exchangePrize`
 */
export interface ApiActivityLotteryExchangePrizeRequest {
  /**
   * 兑奖码
   */
  exchangeCode?: string
  /**
   * 中奖记录ID
   */
  winRecordId?: string
}

/**
 * 接口 [兑换奖品↗](https://yapi.gogpay.cn/project/927/interface/api/427548) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/exchangePrize`
 */
export type ApiActivityLotteryExchangePrizeResponse = string

/**
 * 接口 [兑换奖品↗](https://yapi.gogpay.cn/project/927/interface/api/427548) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/exchangePrize`
 */
type ApiActivityLotteryExchangePrizeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/exchangePrize',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [兑换奖品↗](https://yapi.gogpay.cn/project/927/interface/api/427548) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/exchangePrize`
 */
const apiActivityLotteryExchangePrizeRequestConfig: ApiActivityLotteryExchangePrizeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/exchangePrize',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryExchangePrize',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '兑换奖品', author: '511号开发' },
  }

/**
 * 接口 [兑换奖品↗](https://yapi.gogpay.cn/project/927/interface/api/427548) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/exchangePrize`
 */
export const apiActivityLotteryExchangePrize = /*#__PURE__*/ (
  requestData: ApiActivityLotteryExchangePrizeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryExchangePrizeResponse>(
    prepare(apiActivityLotteryExchangePrizeRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryExchangePrize.requestConfig =
  apiActivityLotteryExchangePrizeRequestConfig

/**
 * 接口 [答题获取抽奖次数-获取一个题目↗](https://yapi.gogpay.cn/project/927/interface/api/446168) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getLotteryQuestion`
 */
export interface ApiActivityLotteryGetLotteryQuestionRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 答题答案
   */
  answer?: string
  /**
   * 题目ID
   */
  questionId?: string
}

/**
 * 接口 [答题获取抽奖次数-获取一个题目↗](https://yapi.gogpay.cn/project/927/interface/api/446168) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getLotteryQuestion`
 */
export interface ApiActivityLotteryGetLotteryQuestionResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 可选择答案
   */
  answer?: string[]
  /**
   * 回答记录
   */
  answerList?: {
    /**
     * 答题结果 0错误 1正确
     */
    answerStatus?: number
    /**
     * 答题用户Id
     */
    answerUserId?: string
    /**
     * 获得抽奖次数
     */
    lotteryGetCount?: number
    /**
     * 用户答案
     */
    userAnswer?: string
  }[]
  /**
   * 题目内容
   */
  question?: string
  /**
   * 题目Id
   */
  questionId?: string
}

/**
 * 接口 [答题获取抽奖次数-获取一个题目↗](https://yapi.gogpay.cn/project/927/interface/api/446168) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getLotteryQuestion`
 */
type ApiActivityLotteryGetLotteryQuestionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/getLotteryQuestion',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [答题获取抽奖次数-获取一个题目↗](https://yapi.gogpay.cn/project/927/interface/api/446168) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getLotteryQuestion`
 */
const apiActivityLotteryGetLotteryQuestionRequestConfig: ApiActivityLotteryGetLotteryQuestionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/getLotteryQuestion',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryGetLotteryQuestion',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '答题获取抽奖次数-获取一个题目', author: '511号开发' },
  }

/**
 * 接口 [答题获取抽奖次数-获取一个题目↗](https://yapi.gogpay.cn/project/927/interface/api/446168) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getLotteryQuestion`
 */
export const apiActivityLotteryGetLotteryQuestion = /*#__PURE__*/ (
  requestData: ApiActivityLotteryGetLotteryQuestionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryGetLotteryQuestionResponse>(
    prepare(apiActivityLotteryGetLotteryQuestionRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryGetLotteryQuestion.requestConfig =
  apiActivityLotteryGetLotteryQuestionRequestConfig

/**
 * 接口 [答题获取抽奖次数-用户答题↗](https://yapi.gogpay.cn/project/927/interface/api/446173) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerQuestion`
 */
export interface ApiActivityLotteryLotteryUserAnswerQuestionRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 答题答案
   */
  answer?: string
  /**
   * 题目ID
   */
  questionId?: string
}

/**
 * 接口 [答题获取抽奖次数-用户答题↗](https://yapi.gogpay.cn/project/927/interface/api/446173) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerQuestion`
 */
export type ApiActivityLotteryLotteryUserAnswerQuestionResponse = number

/**
 * 接口 [答题获取抽奖次数-用户答题↗](https://yapi.gogpay.cn/project/927/interface/api/446173) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerQuestion`
 */
type ApiActivityLotteryLotteryUserAnswerQuestionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/lotteryUserAnswerQuestion',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [答题获取抽奖次数-用户答题↗](https://yapi.gogpay.cn/project/927/interface/api/446173) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerQuestion`
 */
const apiActivityLotteryLotteryUserAnswerQuestionRequestConfig: ApiActivityLotteryLotteryUserAnswerQuestionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/lotteryUserAnswerQuestion',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryLotteryUserAnswerQuestion',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '答题获取抽奖次数-用户答题', author: '511号开发' },
  }

/**
 * 接口 [答题获取抽奖次数-用户答题↗](https://yapi.gogpay.cn/project/927/interface/api/446173) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerQuestion`
 */
export const apiActivityLotteryLotteryUserAnswerQuestion = /*#__PURE__*/ (
  requestData: ApiActivityLotteryLotteryUserAnswerQuestionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryLotteryUserAnswerQuestionResponse>(
    prepare(
      apiActivityLotteryLotteryUserAnswerQuestionRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityLotteryLotteryUserAnswerQuestion.requestConfig =
  apiActivityLotteryLotteryUserAnswerQuestionRequestConfig

/**
 * 接口 [答题获取抽奖次数-获取用户回答记录↗](https://yapi.gogpay.cn/project/927/interface/api/446178) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerRecord`
 */
export interface ApiActivityLotteryLotteryUserAnswerRecordRequest {
  id?: string
}

/**
 * 接口 [答题获取抽奖次数-获取用户回答记录↗](https://yapi.gogpay.cn/project/927/interface/api/446178) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerRecord`
 */
export type ApiActivityLotteryLotteryUserAnswerRecordResponse = {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 可选择答案
   */
  answer?: string[]
  /**
   * 回答记录
   */
  answerList?: {
    /**
     * 答题结果 0错误 1正确
     */
    answerStatus?: number
    /**
     * 答题用户Id
     */
    answerUserId?: string
    /**
     * 获得抽奖次数
     */
    lotteryGetCount?: number
    /**
     * 用户答案
     */
    userAnswer?: string
  }[]
  /**
   * 题目内容
   */
  question?: string
  /**
   * 题目Id
   */
  questionId?: string
}[]

/**
 * 接口 [答题获取抽奖次数-获取用户回答记录↗](https://yapi.gogpay.cn/project/927/interface/api/446178) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerRecord`
 */
type ApiActivityLotteryLotteryUserAnswerRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/lotteryUserAnswerRecord',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [答题获取抽奖次数-获取用户回答记录↗](https://yapi.gogpay.cn/project/927/interface/api/446178) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerRecord`
 */
const apiActivityLotteryLotteryUserAnswerRecordRequestConfig: ApiActivityLotteryLotteryUserAnswerRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/lotteryUserAnswerRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryLotteryUserAnswerRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '答题获取抽奖次数-获取用户回答记录',
      author: '511号开发',
    },
  }

/**
 * 接口 [答题获取抽奖次数-获取用户回答记录↗](https://yapi.gogpay.cn/project/927/interface/api/446178) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/lotteryUserAnswerRecord`
 */
export const apiActivityLotteryLotteryUserAnswerRecord = /*#__PURE__*/ (
  requestData: ApiActivityLotteryLotteryUserAnswerRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryLotteryUserAnswerRecordResponse>(
    prepare(
      apiActivityLotteryLotteryUserAnswerRecordRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityLotteryLotteryUserAnswerRecord.requestConfig =
  apiActivityLotteryLotteryUserAnswerRecordRequestConfig

/**
 * 接口 [答题获取抽奖次数-判断是否可以答题↗](https://yapi.gogpay.cn/project/927/interface/api/446368) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getQuestionStatus`
 */
export interface ApiActivityLotteryGetQuestionStatusRequest {
  id?: string
}

/**
 * 接口 [答题获取抽奖次数-判断是否可以答题↗](https://yapi.gogpay.cn/project/927/interface/api/446368) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getQuestionStatus`
 */
export type ApiActivityLotteryGetQuestionStatusResponse = boolean

/**
 * 接口 [答题获取抽奖次数-判断是否可以答题↗](https://yapi.gogpay.cn/project/927/interface/api/446368) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getQuestionStatus`
 */
type ApiActivityLotteryGetQuestionStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/lottery/getQuestionStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [答题获取抽奖次数-判断是否可以答题↗](https://yapi.gogpay.cn/project/927/interface/api/446368) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getQuestionStatus`
 */
const apiActivityLotteryGetQuestionStatusRequestConfig: ApiActivityLotteryGetQuestionStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_22,
    devUrl: devUrl_0_18_0_22,
    prodUrl: prodUrl_0_18_0_22,
    path: '/activity/api/lottery/getQuestionStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityLotteryGetQuestionStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '答题获取抽奖次数-判断是否可以答题',
      author: '511号开发',
    },
  }

/**
 * 接口 [答题获取抽奖次数-判断是否可以答题↗](https://yapi.gogpay.cn/project/927/interface/api/446368) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-抽奖活动↗](https://yapi.gogpay.cn/project/927/interface/api/cat_40015)
 * @请求头 `POST /activity/api/lottery/getQuestionStatus`
 */
export const apiActivityLotteryGetQuestionStatus = /*#__PURE__*/ (
  requestData: ApiActivityLotteryGetQuestionStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityLotteryGetQuestionStatusResponse>(
    prepare(apiActivityLotteryGetQuestionStatusRequestConfig, requestData),
    ...args,
  )
}

apiActivityLotteryGetQuestionStatus.requestConfig =
  apiActivityLotteryGetQuestionStatusRequestConfig

const mockUrl_0_18_0_25 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_25 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_25 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_25 = 'data' as any

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/256293) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/activitySession`
 */
export interface ApiActivityChannelIntegralActivitySessionRequest {
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  clientType?: '1' | '2'
  /**
   * 活动日期，不传默认为今日
   */
  date?: string
  headerChannel?: string[]
}

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/256293) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/activitySession`
 */
export type ApiActivityChannelIntegralActivitySessionResponse = {
  /**
   * 结束时间，格式HH:mm
   */
  endTime?: string
  /**
   * 场次Id
   */
  sessionId?: string
  /**
   * 场次开始日期，格式yyyy-MM-dd
   */
  startDate?: string
  /**
   * 开始时间,格式 HH:mm
   */
  startTime?: string
  /**
   * 时间段类型 0普通时段  1全天时段
   */
  timeType?: number
}[]

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/256293) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/activitySession`
 */
type ApiActivityChannelIntegralActivitySessionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/activitySession',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/256293) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/activitySession`
 */
const apiActivityChannelIntegralActivitySessionRequestConfig: ApiActivityChannelIntegralActivitySessionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/activitySession',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralActivitySession',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定日期对应的活动场次', author: '李诗凡' },
  }

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/256293) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/activitySession`
 */
export const apiActivityChannelIntegralActivitySession = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralActivitySessionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralActivitySessionResponse>(
    prepare(
      apiActivityChannelIntegralActivitySessionRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralActivitySession.requestConfig =
  apiActivityChannelIntegralActivitySessionRequestConfig

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/256296) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/commodityList`
 */
export interface ApiActivityChannelIntegralCommodityListRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  clientType?: '1' | '2'
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 场次Id
   */
  sessionId: string
  /**
   * 1全部 2我能买
   */
  type: number
}

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/256296) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/commodityList`
 */
export interface ApiActivityChannelIntegralCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品图片
     */
    commodityCoverImg?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品类型 0标电 1标销
     */
    commodityType?: number
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 单日限购数量
     */
    dayLimitCount?: number
    /**
     * 等级要求 0表示不限制
     */
    levelLimit?: number
    /**
     * 会员等级名称
     */
    levelLimitName?: string
    /**
     * 限购数量
     */
    limitCount?: number
    /**
     * 原价
     */
    originalPrice?: number
    /**
     * 秒杀进度
     */
    progress?: number
    /**
     * 秒杀价格
     */
    seckillPrice?: number
    /**
     * sku信息
     */
    skuInfo?: {
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * sku图片
       */
      pic?: string
      /**
       * sku价格
       */
      price?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * SKU Id
       */
      skuId?: string
      /**
       * 剩余库存
       */
      stock?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 总库存
     */
    totalStock?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/256296) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/commodityList`
 */
type ApiActivityChannelIntegralCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/256296) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/commodityList`
 */
const apiActivityChannelIntegralCommodityListRequestConfig: ApiActivityChannelIntegralCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场次商品列表', author: '李诗凡' },
  }

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/256296) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/commodityList`
 */
export const apiActivityChannelIntegralCommodityList = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralCommodityListResponse>(
    prepare(apiActivityChannelIntegralCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiActivityChannelIntegralCommodityList.requestConfig =
  apiActivityChannelIntegralCommodityListRequestConfig

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256299) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodity`
 */
export interface ApiActivityChannelIntegralGetActivityCommodityRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256299) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodity`
 */
export interface ApiActivityChannelIntegralGetActivityCommodityResponse {
  activityData?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 是否可以进行购买
     */
    canPay?: boolean
    commodityInfo?: {
      /**
       * 商品图片
       */
      commodityCoverImg?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 商品类型 0标电 1标销
       */
      commodityType?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 单日限购数量
       */
      dayLimitCount?: number
      /**
       * 等级要求 0表示不限制
       */
      levelLimit?: number
      /**
       * 会员等级名称
       */
      levelLimitName?: string
      /**
       * 限购数量
       */
      limitCount?: number
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * 秒杀进度
       */
      progress?: number
      /**
       * 秒杀价格
       */
      seckillPrice?: number
      /**
       * sku信息
       */
      skuInfo?: {
        /**
         * 原价
         */
        originalPrice?: number
        /**
         * sku图片
         */
        pic?: string
        /**
         * sku价格
         */
        price?: number
        /**
         * sku描述
         */
        skuDesc?: string
        /**
         * SKU Id
         */
        skuId?: string
        /**
         * 剩余库存
         */
        stock?: number
      }[]
      /**
       * 排序值
       */
      sortNo?: number
      /**
       * 剩余库存
       */
      surplusStock?: number
      /**
       * 总库存
       */
      totalStock?: number
    }
    /**
     * 结束时间
     */
    endTime?: string
    /**
     * 不可购买的原因
     */
    notPayReason?: string
    /**
     * 场次Id
     */
    sessionId?: string
    /**
     * 开始日期
     */
    startDate?: string
    /**
     * 开始时间
     */
    startTime?: string
    /**
     * 用户当前的等级
     */
    userLevel?: number
  }
  /**
   * 是否有活动正在运行
   */
  hasActivity?: boolean
}

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256299) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodity`
 */
type ApiActivityChannelIntegralGetActivityCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getActivityCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256299) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodity`
 */
const apiActivityChannelIntegralGetActivityCommodityRequestConfig: ApiActivityChannelIntegralGetActivityCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getActivityCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetActivityCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品对应的秒杀活动信息', author: '李诗凡' },
  }

/**
 * 接口 [获取商品对应的秒杀活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256299) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodity`
 */
export const apiActivityChannelIntegralGetActivityCommodity = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetActivityCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetActivityCommodityResponse>(
    prepare(
      apiActivityChannelIntegralGetActivityCommodityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralGetActivityCommodity.requestConfig =
  apiActivityChannelIntegralGetActivityCommodityRequestConfig

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/256302) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodityByDate`
 */
export interface ApiActivityChannelIntegralGetActivityCommodityByDateRequest {
  /**
   * 活动日期，不传默认为今日
   */
  date?: string
}

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/256302) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodityByDate`
 */
export interface ApiActivityChannelIntegralGetActivityCommodityByDateResponse {
  /**
   * 数据列表
   */
  list?: {
    activityData?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 是否可以进行购买
       */
      canPay?: boolean
      commodityInfo?: {
        /**
         * 商品图片
         */
        commodityCoverImg?: string
        /**
         * 商品Id
         */
        commodityId?: string
        /**
         * 商品标题
         */
        commodityTitle?: string
        /**
         * 商品类型 0标电 1标销
         */
        commodityType?: number
        /**
         * 划线价
         */
        dashPrice?: number
        /**
         * 单日限购数量
         */
        dayLimitCount?: number
        /**
         * 等级要求 0表示不限制
         */
        levelLimit?: number
        /**
         * 会员等级名称
         */
        levelLimitName?: string
        /**
         * 限购数量
         */
        limitCount?: number
        /**
         * 原价
         */
        originalPrice?: number
        /**
         * 秒杀进度
         */
        progress?: number
        /**
         * 秒杀价格
         */
        seckillPrice?: number
        /**
         * sku信息
         */
        skuInfo?: {
          /**
           * 原价
           */
          originalPrice?: number
          /**
           * sku图片
           */
          pic?: string
          /**
           * sku价格
           */
          price?: number
          /**
           * sku描述
           */
          skuDesc?: string
          /**
           * SKU Id
           */
          skuId?: string
          /**
           * 剩余库存
           */
          stock?: number
        }[]
        /**
         * 排序值
         */
        sortNo?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
        /**
         * 总库存
         */
        totalStock?: number
      }
      /**
       * 结束时间
       */
      endTime?: string
      /**
       * 不可购买的原因
       */
      notPayReason?: string
      /**
       * 场次Id
       */
      sessionId?: string
      /**
       * 开始日期
       */
      startDate?: string
      /**
       * 开始时间
       */
      startTime?: string
      /**
       * 用户当前的等级
       */
      userLevel?: number
    }
    /**
     * 是否有活动正在运行
     */
    hasActivity?: boolean
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/256302) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodityByDate`
 */
type ApiActivityChannelIntegralGetActivityCommodityByDateRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/927',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/activity/api/channelIntegral/getActivityCommodityByDate',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/256302) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodityByDate`
 */
const apiActivityChannelIntegralGetActivityCommodityByDateRequestConfig: ApiActivityChannelIntegralGetActivityCommodityByDateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getActivityCommodityByDate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetActivityCommodityByDate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '根据日期获取活动商品', author: '李诗凡' },
  }

/**
 * 接口 [根据日期获取活动商品↗](https://yapi.gogpay.cn/project/927/interface/api/256302) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getActivityCommodityByDate`
 */
export const apiActivityChannelIntegralGetActivityCommodityByDate =
  /*#__PURE__*/ (
    requestData: ApiActivityChannelIntegralGetActivityCommodityByDateRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiActivityChannelIntegralGetActivityCommodityByDateResponse>(
      prepare(
        apiActivityChannelIntegralGetActivityCommodityByDateRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiActivityChannelIntegralGetActivityCommodityByDate.requestConfig =
  apiActivityChannelIntegralGetActivityCommodityByDateRequestConfig

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/256305) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityActivity`
 */
export interface ApiActivityChannelIntegralGetCommodityActivityRequest {
  categoryId?: string
  commodityId?: string
  unitOrgCode?: string
}

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/256305) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityActivity`
 */
export interface ApiActivityChannelIntegralGetCommodityActivityResponse {
  /**
   * 活动列表
   */
  activityList?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动类型 1秒杀 2折扣优惠
     */
    activityType?: 'SECKILL' | 'DISCOUNT'
    /**
     * 活动描述
     */
    desc?: string
    /**
     * 活动结束日期
     */
    endDate?: string
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 活动sku列表
     */
    skuList?: {
      /**
       * 活动售卖价格
       */
      activityPrice?: number
      /**
       * sku图片
       */
      image?: string
      /**
       * 活动配置原价
       */
      originalPrice?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuId
       */
      skuId?: string
      /**
       * 剩余活动库存
       */
      surplusActivityStock?: number
    }[]
    /**
     * 活动开始日期
     */
    startDate?: string
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
  }[]
  /**
   * 是否包含活动
   */
  hasActivity?: boolean
}

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/256305) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityActivity`
 */
type ApiActivityChannelIntegralGetCommodityActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getCommodityActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/256305) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityActivity`
 */
const apiActivityChannelIntegralGetCommodityActivityRequestConfig: ApiActivityChannelIntegralGetCommodityActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getCommodityActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetCommodityActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品活动列表信息', author: '李诗凡' },
  }

/**
 * 接口 [获取商品活动列表信息↗](https://yapi.gogpay.cn/project/927/interface/api/256305) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityActivity`
 */
export const apiActivityChannelIntegralGetCommodityActivity = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetCommodityActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetCommodityActivityResponse>(
    prepare(
      apiActivityChannelIntegralGetCommodityActivityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralGetCommodityActivity.requestConfig =
  apiActivityChannelIntegralGetCommodityActivityRequestConfig

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/256308) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityGroupBuying`
 */
export interface ApiActivityChannelIntegralGetCommodityGroupBuyingRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/256308) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityGroupBuying`
 */
export interface ApiActivityChannelIntegralGetCommodityGroupBuyingResponse {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 商品Id
   */
  commodityId?: string
  groupData?: {
    /**
     * 团单信息
     */
    groupItems?: {
      /**
       * 团单购买商品Id
       */
      commodityId?: string
      /**
       * 拼团倒计时（秒),groupStatus=（0,1时返回）
       */
      finishCountDown?: number
      /**
       * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
       */
      groupStatus?: number
      /**
       * 头像
       */
      headImg?: string
      /**
       * 下一阶段成团人数差距，groupStatus=(0,1)时返回
       */
      nextLevelCount?: number
      /**
       * 下一阶段退还金额,groupStatus=1时返回
       */
      nextLevelReturnAmount?: number
      /**
       * 团单订单Id
       */
      orderId?: string
      /**
       * 手机号码
       */
      userPhone?: string
    }[]
    /**
     * 正在拼单人数
     */
    userCount?: number
  }
  /**
   * 是否具备活动
   */
  hasActivity?: boolean
  /**
   * 规格列表
   */
  skuInfos?: {
    /**
     * 阶梯配置
     */
    ladderConfig?: {
      /**
       * 阶梯：1-一阶 2-...
       */
      ladder?: number
      /**
       * 阶梯价格
       */
      ladderPrice?: number
      /**
       * 阶梯人数
       */
      userNum?: number
    }[]
    /**
     * 最高价格
     */
    maxPrice?: number
    /**
     * 规格Id
     */
    skuId?: string
  }[]
}

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/256308) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityGroupBuying`
 */
type ApiActivityChannelIntegralGetCommodityGroupBuyingRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getCommodityGroupBuying',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/256308) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityGroupBuying`
 */
const apiActivityChannelIntegralGetCommodityGroupBuyingRequestConfig: ApiActivityChannelIntegralGetCommodityGroupBuyingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getCommodityGroupBuying',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetCommodityGroupBuying',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品的拼团优惠信息', author: '李诗凡' },
  }

/**
 * 接口 [获取商品的拼团优惠信息↗](https://yapi.gogpay.cn/project/927/interface/api/256308) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommodityGroupBuying`
 */
export const apiActivityChannelIntegralGetCommodityGroupBuying = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetCommodityGroupBuyingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetCommodityGroupBuyingResponse>(
    prepare(
      apiActivityChannelIntegralGetCommodityGroupBuyingRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralGetCommodityGroupBuying.requestConfig =
  apiActivityChannelIntegralGetCommodityGroupBuyingRequestConfig

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/256311) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySku`
 */
export interface ApiActivityChannelIntegralGetCommoditySkuRequest {
  /**
   * 活动Id
   */
  activityId: string
  commodityId?: string
  /**
   * 场次Id
   */
  sessionId: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/256311) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySku`
 */
export type ApiActivityChannelIntegralGetCommoditySkuResponse = {
  /**
   * sku属性名称
   */
  attributeName: string
  /**
   * 属性下拉参数
   */
  options: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * 选中下拉参数
   */
  selected: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * sku属性ID
   */
  skuAttributeId: string
}[]

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/256311) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySku`
 */
type ApiActivityChannelIntegralGetCommoditySkuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getCommoditySku',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/256311) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySku`
 */
const apiActivityChannelIntegralGetCommoditySkuRequestConfig: ApiActivityChannelIntegralGetCommoditySkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getCommoditySku',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetCommoditySku',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定活动的商品SKU列表', author: '李诗凡' },
  }

/**
 * 接口 [获取指定活动的商品SKU列表↗](https://yapi.gogpay.cn/project/927/interface/api/256311) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySku`
 */
export const apiActivityChannelIntegralGetCommoditySku = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetCommoditySkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetCommoditySkuResponse>(
    prepare(
      apiActivityChannelIntegralGetCommoditySkuRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralGetCommoditySku.requestConfig =
  apiActivityChannelIntegralGetCommoditySkuRequestConfig

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256314) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getGroupBuyingActivity`
 */
export interface ApiActivityChannelIntegralGetGroupBuyingActivityRequest {
  /**
   * 活动Id
   */
  activityId?: string
}

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256314) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getGroupBuyingActivity`
 */
export interface ApiActivityChannelIntegralGetGroupBuyingActivityResponse {
  /**
   * 活动规则
   */
  activityRules?: string
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: number
  /**
   * 活动规则地址
   */
  cmsUrl?: string
  /**
   * 结束时间
   */
  endTime?: string
  /**
   * 团购活动ID
   */
  groupBuyingActId?: string
  /**
   * 团购活动名称
   */
  groupBuyingActName?: string
  /**
   * 分组列表
   */
  groupList?: {
    /**
     * 分组Id
     */
    groupId?: string
    /**
     * 分组名称
     */
    groupName?: string
    /**
     * 分组图片
     */
    groupPic?: string
    /**
     * SKU列表
     */
    skuList?: {
      activityId?: string
      /**
       * SKU阶梯信息
       */
      groupBuyingLadder?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 会员等级：-1不限制 参照会员中心
       */
      membersLv?: number
      /**
       * SKU原价
       */
      originalPrice?: number
      /**
       * 专区ID
       */
      regionId?: string
      /**
       * 专区名称
       */
      regionName?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      settlementConfig?: {
        /**
         * 出资方；1=平台出资，2=商家出资，3=共同出资
         */
        contributionType: number
        /**
         * 共同出资方式；1=商家出资占比，2=平台出资占比
         */
        jointContributionType: number
        /**
         * 共同出资占比
         */
        jointContributionVal: string
      }
      /**
       * SKUID
       */
      skuId?: string
      /**
       * sku名称
       */
      skuName?: string
      /**
       * sku状态：0-待开售 1-售卖中 2-已停售
       */
      skuStatus?: 'WAIT_SELL' | 'SELLING' | 'STOP_SELL'
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * 上下架状态 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 虚拟团员数量
       */
      virtualUserNum?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
  }[]
  /**
   * 成团有效时间(小时)
   */
  groupValidTime?: number
  /**
   * 头图
   */
  headPic?: string
  /**
   * 开始时间
   */
  startTime?: string
}

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256314) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getGroupBuyingActivity`
 */
type ApiActivityChannelIntegralGetGroupBuyingActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getGroupBuyingActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256314) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getGroupBuyingActivity`
 */
const apiActivityChannelIntegralGetGroupBuyingActivityRequestConfig: ApiActivityChannelIntegralGetGroupBuyingActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getGroupBuyingActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetGroupBuyingActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取拼团活动信息', author: '李诗凡' },
  }

/**
 * 接口 [获取拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256314) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getGroupBuyingActivity`
 */
export const apiActivityChannelIntegralGetGroupBuyingActivity = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetGroupBuyingActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetGroupBuyingActivityResponse>(
    prepare(
      apiActivityChannelIntegralGetGroupBuyingActivityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralGetGroupBuyingActivity.requestConfig =
  apiActivityChannelIntegralGetGroupBuyingActivityRequestConfig

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/256317) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSkuInfo`
 */
export interface ApiActivityChannelIntegralGetSkuInfoRequest {
  commodityId?: string
  skuId?: string
}

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/256317) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSkuInfo`
 */
export interface ApiActivityChannelIntegralGetSkuInfoResponse {
  activityId?: string
  limitCount?: number
  price?: number
  skuId?: string
  stock?: number
}

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/256317) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSkuInfo`
 */
type ApiActivityChannelIntegralGetSkuInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getSkuInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/256317) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSkuInfo`
 */
const apiActivityChannelIntegralGetSkuInfoRequestConfig: ApiActivityChannelIntegralGetSkuInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getSkuInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetSkuInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品SKU信息', author: '李诗凡' },
  }

/**
 * 接口 [获取商品SKU信息↗](https://yapi.gogpay.cn/project/927/interface/api/256317) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSkuInfo`
 */
export const apiActivityChannelIntegralGetSkuInfo = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetSkuInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetSkuInfoResponse>(
    prepare(apiActivityChannelIntegralGetSkuInfoRequestConfig, requestData),
    ...args,
  )
}

apiActivityChannelIntegralGetSkuInfo.requestConfig =
  apiActivityChannelIntegralGetSkuInfoRequestConfig

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/256320) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/index`
 */
export interface ApiActivityChannelIntegralIndexRequest {
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  clientType?: '1' | '2'
  headerChannel?: string[]
}

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/256320) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/index`
 */
export interface ApiActivityChannelIntegralIndexResponse {
  /**
   * 活动日期列表,格式yyyy-MM-dd
   */
  activityDates?: unknown[]
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 是否有活动运行
   */
  hasActivity?: boolean
  /**
   * 匹配最近可用日期，默认选中日期,
   */
  matchDate?: string
  /**
   * 场次时间列表，默认返回匹配日期对应的场次
   */
  sessions?: {
    /**
     * 结束时间，格式HH:mm
     */
    endTime?: string
    /**
     * 场次Id
     */
    sessionId?: string
    /**
     * 场次开始日期，格式yyyy-MM-dd
     */
    startDate?: string
    /**
     * 开始时间,格式 HH:mm
     */
    startTime?: string
    /**
     * 时间段类型 0普通时段  1全天时段
     */
    timeType?: number
  }[]
}

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/256320) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/index`
 */
type ApiActivityChannelIntegralIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/index',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/256320) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/index`
 */
const apiActivityChannelIntegralIndexRequestConfig: ApiActivityChannelIntegralIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取活动首页', author: '李诗凡' },
  }

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/256320) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/index`
 */
export const apiActivityChannelIntegralIndex = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralIndexResponse>(
    prepare(apiActivityChannelIntegralIndexRequestConfig, requestData),
    ...args,
  )
}

apiActivityChannelIntegralIndex.requestConfig =
  apiActivityChannelIntegralIndexRequestConfig

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256323) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/sync`
 */
export interface ApiActivityChannelIntegralSyncRequest {
  /**
   * 活动规则
   */
  activityRules?: string
  /**
   * 活动状态：0-未开始 1-进行中 2-已结束 3-已终止
   */
  activityStatus?: number
  /**
   * 活动规则地址
   */
  cmsUrl?: string
  /**
   * 结束时间
   */
  endTime?: string
  /**
   * 团购活动ID
   */
  groupBuyingActId?: string
  /**
   * 团购活动名称
   */
  groupBuyingActName?: string
  /**
   * 分组列表
   */
  groupList?: {
    /**
     * 分组Id
     */
    groupId?: string
    /**
     * 分组名称
     */
    groupName?: string
    /**
     * 分组图片
     */
    groupPic?: string
    /**
     * SKU列表
     */
    skuList?: {
      activityId?: string
      /**
       * SKU阶梯信息
       */
      groupBuyingLadder?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 会员等级：-1不限制 参照会员中心
       */
      membersLv?: number
      /**
       * SKU原价
       */
      originalPrice?: number
      /**
       * 专区ID
       */
      regionId?: string
      /**
       * 专区名称
       */
      regionName?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 资源图片
       */
      resourcePic?: string
      settlementConfig?: {
        /**
         * 出资方；1=平台出资，2=商家出资，3=共同出资
         */
        contributionType: number
        /**
         * 共同出资方式；1=商家出资占比，2=平台出资占比
         */
        jointContributionType: number
        /**
         * 共同出资占比
         */
        jointContributionVal: string
      }
      /**
       * SKUID
       */
      skuId?: string
      /**
       * sku名称
       */
      skuName?: string
      /**
       * sku状态：0-待开售 1-售卖中 2-已停售
       */
      skuStatus?: 'WAIT_SELL' | 'SELLING' | 'STOP_SELL'
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * 上下架状态 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 虚拟团员数量
       */
      virtualUserNum?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
  }[]
  /**
   * 成团有效时间(小时)
   */
  groupValidTime?: number
  /**
   * 头图
   */
  headPic?: string
  /**
   * 开始时间
   */
  startTime?: string
}

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256323) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/sync`
 */
export interface ApiActivityChannelIntegralSyncResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256323) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/sync`
 */
type ApiActivityChannelIntegralSyncRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/sync',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256323) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/sync`
 */
const apiActivityChannelIntegralSyncRequestConfig: ApiActivityChannelIntegralSyncRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/sync',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralSync',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同步拼团活动信息', author: '李诗凡' },
  }

/**
 * 接口 [同步拼团活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/256323) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/sync`
 */
export const apiActivityChannelIntegralSync = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralSyncRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralSyncResponse>(
    prepare(apiActivityChannelIntegralSyncRequestConfig, requestData),
    ...args,
  )
}

apiActivityChannelIntegralSync.requestConfig =
  apiActivityChannelIntegralSyncRequestConfig

/**
 * 接口 [获取订单积分抵扣详情↗](https://yapi.gogpay.cn/project/927/interface/api/256794) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getIntegralDeductionDetail`
 */
export interface ApiActivityChannelIntegralGetIntegralDeductionDetailRequest {
  /**
   * 渠道积分活动ID
   */
  channelIntegralActId?: string
  /**
   * 子订单信息
   */
  childList?: {
    /**
     * 运营渠道ID
     */
    businessChannelId?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 订单金额
     */
    orderAmt?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 店铺ID
     */
    storeId?: string
  }[]
  orderNo?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [获取订单积分抵扣详情↗](https://yapi.gogpay.cn/project/927/interface/api/256794) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getIntegralDeductionDetail`
 */
export interface ApiActivityChannelIntegralGetIntegralDeductionDetailResponse {
  /**
   * 子订单信息
   */
  childList?: {
    /**
     * 运营渠道ID
     */
    businessChannelId?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 抵扣的金额
     */
    deductionAmt?: number
    /**
     * 抵扣的积分
     */
    deductionIntegral?: number
    /**
     * 订单金额
     */
    orderAmt?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 店铺ID
     */
    storeId?: string
  }[]
  /**
   * 父订单编号
   */
  orderNo?: string
}

/**
 * 接口 [获取订单积分抵扣详情↗](https://yapi.gogpay.cn/project/927/interface/api/256794) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getIntegralDeductionDetail`
 */
type ApiActivityChannelIntegralGetIntegralDeductionDetailRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/927',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/activity/api/channelIntegral/getIntegralDeductionDetail',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取订单积分抵扣详情↗](https://yapi.gogpay.cn/project/927/interface/api/256794) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getIntegralDeductionDetail`
 */
const apiActivityChannelIntegralGetIntegralDeductionDetailRequestConfig: ApiActivityChannelIntegralGetIntegralDeductionDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getIntegralDeductionDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetIntegralDeductionDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单积分抵扣详情', author: '李诗凡' },
  }

/**
 * 接口 [获取订单积分抵扣详情↗](https://yapi.gogpay.cn/project/927/interface/api/256794) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getIntegralDeductionDetail`
 */
export const apiActivityChannelIntegralGetIntegralDeductionDetail =
  /*#__PURE__*/ (
    requestData: ApiActivityChannelIntegralGetIntegralDeductionDetailRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiActivityChannelIntegralGetIntegralDeductionDetailResponse>(
      prepare(
        apiActivityChannelIntegralGetIntegralDeductionDetailRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiActivityChannelIntegralGetIntegralDeductionDetail.requestConfig =
  apiActivityChannelIntegralGetIntegralDeductionDetailRequestConfig

/**
 * 接口 [获取订单支持渠道↗](https://yapi.gogpay.cn/project/927/interface/api/256797) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSupportChannel`
 */
export interface ApiActivityChannelIntegralGetSupportChannelRequest {
  /**
   * 子订单信息
   */
  childList?: {
    /**
     * 运营渠道ID
     */
    businessChannelId?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 订单金额
     */
    orderAmt?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 店铺ID
     */
    storeId?: string
  }[]
  orderNo?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [获取订单支持渠道↗](https://yapi.gogpay.cn/project/927/interface/api/256797) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSupportChannel`
 */
export type ApiActivityChannelIntegralGetSupportChannelResponse = {
  /**
   * 渠道积分活动ID
   */
  channelIntegralActId?: string
  /**
   * 积分单位
   */
  channelIntegralUnit?: string
  /**
   * 渠道名称
   */
  channelName?: string
  /**
   * 是否足够抵扣
   */
  deduction?: boolean
  /**
   * 是否需要密码
   */
  needPassword?: boolean
  /**
   * 不足抵扣原因
   */
  noDeductionReason?: string
  /**
   * 剩余积分
   */
  surplusIntegral?: number
}[]

/**
 * 接口 [获取订单支持渠道↗](https://yapi.gogpay.cn/project/927/interface/api/256797) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSupportChannel`
 */
type ApiActivityChannelIntegralGetSupportChannelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/channelIntegral/getSupportChannel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单支持渠道↗](https://yapi.gogpay.cn/project/927/interface/api/256797) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSupportChannel`
 */
const apiActivityChannelIntegralGetSupportChannelRequestConfig: ApiActivityChannelIntegralGetSupportChannelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getSupportChannel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityChannelIntegralGetSupportChannel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单支持渠道', author: '李诗凡' },
  }

/**
 * 接口 [获取订单支持渠道↗](https://yapi.gogpay.cn/project/927/interface/api/256797) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getSupportChannel`
 */
export const apiActivityChannelIntegralGetSupportChannel = /*#__PURE__*/ (
  requestData: ApiActivityChannelIntegralGetSupportChannelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityChannelIntegralGetSupportChannelResponse>(
    prepare(
      apiActivityChannelIntegralGetSupportChannelRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityChannelIntegralGetSupportChannel.requestConfig =
  apiActivityChannelIntegralGetSupportChannelRequestConfig

/**
 * 接口 [获取商品支持活动↗](https://yapi.gogpay.cn/project/927/interface/api/258720) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySupportActivity`
 */
export interface ApiActivityChannelIntegralGetCommoditySupportActivityRequest {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 店铺ID
   */
  storeId?: string
}

/**
 * 接口 [获取商品支持活动↗](https://yapi.gogpay.cn/project/927/interface/api/258720) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySupportActivity`
 */
export type ApiActivityChannelIntegralGetCommoditySupportActivityResponse = {
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 活动ID
   */
  id?: string
}[]

/**
 * 接口 [获取商品支持活动↗](https://yapi.gogpay.cn/project/927/interface/api/258720) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySupportActivity`
 */
type ApiActivityChannelIntegralGetCommoditySupportActivityRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/927',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/activity/api/channelIntegral/getCommoditySupportActivity',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取商品支持活动↗](https://yapi.gogpay.cn/project/927/interface/api/258720) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySupportActivity`
 */
const apiActivityChannelIntegralGetCommoditySupportActivityRequestConfig: ApiActivityChannelIntegralGetCommoditySupportActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_25,
    devUrl: devUrl_0_18_0_25,
    prodUrl: prodUrl_0_18_0_25,
    path: '/activity/api/channelIntegral/getCommoditySupportActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiActivityChannelIntegralGetCommoditySupportActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品支持活动', author: '李诗凡' },
  }

/**
 * 接口 [获取商品支持活动↗](https://yapi.gogpay.cn/project/927/interface/api/258720) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-渠道积分↗](https://yapi.gogpay.cn/project/927/interface/api/cat_43134)
 * @请求头 `POST /activity/api/channelIntegral/getCommoditySupportActivity`
 */
export const apiActivityChannelIntegralGetCommoditySupportActivity =
  /*#__PURE__*/ (
    requestData: ApiActivityChannelIntegralGetCommoditySupportActivityRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiActivityChannelIntegralGetCommoditySupportActivityResponse>(
      prepare(
        apiActivityChannelIntegralGetCommoditySupportActivityRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiActivityChannelIntegralGetCommoditySupportActivity.requestConfig =
  apiActivityChannelIntegralGetCommoditySupportActivityRequestConfig

const mockUrl_0_18_0_26 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_26 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_26 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_26 = 'data' as any

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/326450) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/activitySession`
 */
export interface ApiActivityOpenApiSkillActivitySessionRequest {
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  /**
   * 活动日期，不传默认为今日
   */
  date?: string
}

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/326450) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/activitySession`
 */
export type ApiActivityOpenApiSkillActivitySessionResponse = {
  /**
   * 结束时间，格式HH:mm
   */
  endTime?: string
  /**
   * 场次Id
   */
  sessionId?: string
  /**
   * 场次开始日期，格式yyyy-MM-dd
   */
  startDate?: string
  /**
   * 开始时间,格式 HH:mm
   */
  startTime?: string
  /**
   * 时间段类型 0普通时段  1全天时段
   */
  timeType?: number
}[]

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/326450) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/activitySession`
 */
type ApiActivityOpenApiSkillActivitySessionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/openApi/skill/activitySession',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/326450) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/activitySession`
 */
const apiActivityOpenApiSkillActivitySessionRequestConfig: ApiActivityOpenApiSkillActivitySessionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_26,
    devUrl: devUrl_0_18_0_26,
    prodUrl: prodUrl_0_18_0_26,
    path: '/activity/openApi/skill/activitySession',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityOpenApiSkillActivitySession',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定日期对应的活动场次', author: '333号开发' },
  }

/**
 * 接口 [获取指定日期对应的活动场次↗](https://yapi.gogpay.cn/project/927/interface/api/326450) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/activitySession`
 */
export const apiActivityOpenApiSkillActivitySession = /*#__PURE__*/ (
  requestData: ApiActivityOpenApiSkillActivitySessionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityOpenApiSkillActivitySessionResponse>(
    prepare(apiActivityOpenApiSkillActivitySessionRequestConfig, requestData),
    ...args,
  )
}

apiActivityOpenApiSkillActivitySession.requestConfig =
  apiActivityOpenApiSkillActivitySessionRequestConfig

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/326458) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/commodityList`
 */
export interface ApiActivityOpenApiSkillCommodityListRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 运营渠道Id
   */
  businessChannelId: string
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 场次Id
   */
  sessionId: string
  /**
   * 1全部 2我能买
   */
  type: number
}

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/326458) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/commodityList`
 */
export interface ApiActivityOpenApiSkillCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品图片
     */
    commodityCoverImg?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品类型 0标电 1标销
     */
    commodityType?: number
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 单日限购数量
     */
    dayLimitCount?: number
    /**
     * 等级要求 0表示不限制
     */
    levelLimit?: number
    /**
     * 会员等级名称
     */
    levelLimitName?: string
    /**
     * 限购数量
     */
    limitCount?: number
    /**
     * 原价
     */
    originalPrice?: number
    /**
     * 秒杀进度
     */
    progress?: number
    /**
     * 秒杀价格
     */
    seckillPrice?: number
    /**
     * sku信息
     */
    skuInfo?: {
      /**
       * 原价
       */
      originalPrice?: number
      /**
       * sku图片
       */
      pic?: string
      /**
       * sku价格
       */
      price?: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * SKU Id
       */
      skuId?: string
      /**
       * 剩余库存
       */
      stock?: number
    }[]
    /**
     * 排序值
     */
    sortNo?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 总库存
     */
    totalStock?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/326458) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/commodityList`
 */
type ApiActivityOpenApiSkillCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/openApi/skill/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/326458) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/commodityList`
 */
const apiActivityOpenApiSkillCommodityListRequestConfig: ApiActivityOpenApiSkillCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_26,
    devUrl: devUrl_0_18_0_26,
    prodUrl: prodUrl_0_18_0_26,
    path: '/activity/openApi/skill/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityOpenApiSkillCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场次商品列表', author: '333号开发' },
  }

/**
 * 接口 [获取场次商品列表↗](https://yapi.gogpay.cn/project/927/interface/api/326458) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/commodityList`
 */
export const apiActivityOpenApiSkillCommodityList = /*#__PURE__*/ (
  requestData: ApiActivityOpenApiSkillCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityOpenApiSkillCommodityListResponse>(
    prepare(apiActivityOpenApiSkillCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiActivityOpenApiSkillCommodityList.requestConfig =
  apiActivityOpenApiSkillCommodityListRequestConfig

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/326466) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/index`
 */
export interface ApiActivityOpenApiSkillIndexRequest {
  /**
   * 运营渠道Id
   */
  businessChannelId: string
}

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/326466) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/index`
 */
export interface ApiActivityOpenApiSkillIndexResponse {
  /**
   * 活动日期列表,格式yyyy-MM-dd
   */
  activityDates?: unknown[]
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 浮动按钮图片地址
   */
  buttonImage?: string
  /**
   * 浮动按钮跳转链接
   */
  buttonJumpLink?: string
  /**
   * 是否有活动运行
   */
  hasActivity?: boolean
  /**
   * 匹配最近可用日期，默认选中日期,
   */
  matchDate?: string
  /**
   * 场次时间列表，默认返回匹配日期对应的场次
   */
  sessions?: {
    /**
     * 结束时间，格式HH:mm
     */
    endTime?: string
    /**
     * 场次Id
     */
    sessionId?: string
    /**
     * 场次开始日期，格式yyyy-MM-dd
     */
    startDate?: string
    /**
     * 开始时间,格式 HH:mm
     */
    startTime?: string
    /**
     * 时间段类型 0普通时段  1全天时段
     */
    timeType?: number
  }[]
}

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/326466) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/index`
 */
type ApiActivityOpenApiSkillIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/openApi/skill/index',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/326466) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/index`
 */
const apiActivityOpenApiSkillIndexRequestConfig: ApiActivityOpenApiSkillIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_26,
    devUrl: devUrl_0_18_0_26,
    prodUrl: prodUrl_0_18_0_26,
    path: '/activity/openApi/skill/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityOpenApiSkillIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取活动首页', author: '333号开发' },
  }

/**
 * 接口 [获取活动首页↗](https://yapi.gogpay.cn/project/927/interface/api/326466) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [open-skill-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57072)
 * @请求头 `POST /activity/openApi/skill/index`
 */
export const apiActivityOpenApiSkillIndex = /*#__PURE__*/ (
  requestData: ApiActivityOpenApiSkillIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityOpenApiSkillIndexResponse>(
    prepare(apiActivityOpenApiSkillIndexRequestConfig, requestData),
    ...args,
  )
}

apiActivityOpenApiSkillIndex.requestConfig =
  apiActivityOpenApiSkillIndexRequestConfig

const mockUrl_0_18_0_27 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_27 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_27 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_27 = 'data' as any

/**
 * 接口 [【折扣活动】取消折扣商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/326474) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelDiscount`
 */
export interface ApiActivityTradeCancelDiscountRequest {
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 规格Id列表
   */
  skuIdList?: string[]
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [【折扣活动】取消折扣商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/326474) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelDiscount`
 */
export interface ApiActivityTradeCancelDiscountResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【折扣活动】取消折扣商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/326474) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelDiscount`
 */
type ApiActivityTradeCancelDiscountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/cancelDiscount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【折扣活动】取消折扣商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/326474) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelDiscount`
 */
const apiActivityTradeCancelDiscountRequestConfig: ApiActivityTradeCancelDiscountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/cancelDiscount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeCancelDiscount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【折扣活动】取消折扣商品记录', author: '333号开发' },
  }

/**
 * 接口 [【折扣活动】取消折扣商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/326474) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelDiscount`
 */
export const apiActivityTradeCancelDiscount = /*#__PURE__*/ (
  requestData: ApiActivityTradeCancelDiscountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeCancelDiscountResponse>(
    prepare(apiActivityTradeCancelDiscountRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeCancelDiscount.requestConfig =
  apiActivityTradeCancelDiscountRequestConfig

/**
 * 接口 [【折扣活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/326482) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/disCountUseCheck`
 */
export interface ApiActivityTradeDisCountUseCheckRequest {
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      matchActivityInfo?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始数量
         */
        initLimitCount?: number
        /**
         * 实际所需活动积分
         */
        integral?: number
        /**
         * 匹配活动规则ID
         */
        matchRuleId?: string
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 匹配条件Id
       */
      matchConditionId?: string
      /**
       * 规格描述
       */
      skuDesc?: string
      /**
       * sku id
       */
      skuId?: string
      /**
       * 商品总额
       */
      totalAmount?: number
      /**
       * 商品总数量
       */
      totalQuantity?: number
      /**
       * 商品单价
       */
      unitPrice?: number
    }[]
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 业务订单Id，检测仅供临时使用。下单做为存储唯一标识
     */
    orderId?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [【折扣活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/326482) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/disCountUseCheck`
 */
export interface ApiActivityTradeDisCountUseCheckResponse {
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 是否匹配活动信息
   */
  matchActivity?: boolean
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      matchActivityInfo?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始数量
         */
        initLimitCount?: number
        /**
         * 实际所需活动积分
         */
        integral?: number
        /**
         * 匹配活动规则ID
         */
        matchRuleId?: string
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 匹配条件Id
       */
      matchConditionId?: string
      /**
       * 规格描述
       */
      skuDesc?: string
      /**
       * sku id
       */
      skuId?: string
      /**
       * 商品总额
       */
      totalAmount?: number
      /**
       * 商品总数量
       */
      totalQuantity?: number
      /**
       * 商品单价
       */
      unitPrice?: number
    }[]
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 业务订单Id，检测仅供临时使用。下单做为存储唯一标识
     */
    orderId?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 消费凭据
   */
  ticket?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [【折扣活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/326482) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/disCountUseCheck`
 */
type ApiActivityTradeDisCountUseCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/disCountUseCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【折扣活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/326482) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/disCountUseCheck`
 */
const apiActivityTradeDisCountUseCheckRequestConfig: ApiActivityTradeDisCountUseCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/disCountUseCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeDisCountUseCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【折扣活动】道优惠可用性检测', author: '333号开发' },
  }

/**
 * 接口 [【折扣活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/326482) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/disCountUseCheck`
 */
export const apiActivityTradeDisCountUseCheck = /*#__PURE__*/ (
  requestData: ApiActivityTradeDisCountUseCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeDisCountUseCheckResponse>(
    prepare(apiActivityTradeDisCountUseCheckRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeDisCountUseCheck.requestConfig =
  apiActivityTradeDisCountUseCheckRequestConfig

/**
 * 接口 [【折扣活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/326490) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/discountConsume`
 */
export interface ApiActivityTradeDiscountConsumeRequest {
  /**
   * 业务订单Id
   */
  orderId?: string
  /**
   * 消费凭据
   */
  ticket?: string
}

/**
 * 接口 [【折扣活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/326490) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/discountConsume`
 */
export interface ApiActivityTradeDiscountConsumeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【折扣活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/326490) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/discountConsume`
 */
type ApiActivityTradeDiscountConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/discountConsume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【折扣活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/326490) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/discountConsume`
 */
const apiActivityTradeDiscountConsumeRequestConfig: ApiActivityTradeDiscountConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/discountConsume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeDiscountConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【折扣活动】支付渠道优惠消费', author: '333号开发' },
  }

/**
 * 接口 [【折扣活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/326490) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/discountConsume`
 */
export const apiActivityTradeDiscountConsume = /*#__PURE__*/ (
  requestData: ApiActivityTradeDiscountConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeDiscountConsumeResponse>(
    prepare(apiActivityTradeDiscountConsumeRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeDiscountConsume.requestConfig =
  apiActivityTradeDiscountConsumeRequestConfig

/**
 * 接口 [【满减活动】取消满减商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/378789) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelFullReduction`
 */
export interface ApiActivityTradeCancelFullReductionRequest {
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 规格Id列表
   */
  skuIdList?: string[]
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [【满减活动】取消满减商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/378789) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelFullReduction`
 */
export interface ApiActivityTradeCancelFullReductionResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【满减活动】取消满减商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/378789) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelFullReduction`
 */
type ApiActivityTradeCancelFullReductionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/cancelFullReduction',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【满减活动】取消满减商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/378789) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelFullReduction`
 */
const apiActivityTradeCancelFullReductionRequestConfig: ApiActivityTradeCancelFullReductionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/cancelFullReduction',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeCancelFullReduction',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【满减活动】取消满减商品记录', author: '333号开发' },
  }

/**
 * 接口 [【满减活动】取消满减商品记录↗](https://yapi.gogpay.cn/project/927/interface/api/378789) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelFullReduction`
 */
export const apiActivityTradeCancelFullReduction = /*#__PURE__*/ (
  requestData: ApiActivityTradeCancelFullReductionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeCancelFullReductionResponse>(
    prepare(apiActivityTradeCancelFullReductionRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeCancelFullReduction.requestConfig =
  apiActivityTradeCancelFullReductionRequestConfig

/**
 * 接口 [【满减活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/378792) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionConsume`
 */
export interface ApiActivityTradeFullReductionConsumeRequest {
  /**
   * 业务订单Id
   */
  orderId?: string
  /**
   * 消费凭据
   */
  ticket?: string
}

/**
 * 接口 [【满减活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/378792) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionConsume`
 */
export interface ApiActivityTradeFullReductionConsumeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【满减活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/378792) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionConsume`
 */
type ApiActivityTradeFullReductionConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/fullReductionConsume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【满减活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/378792) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionConsume`
 */
const apiActivityTradeFullReductionConsumeRequestConfig: ApiActivityTradeFullReductionConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/fullReductionConsume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeFullReductionConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【满减活动】支付渠道优惠消费', author: '333号开发' },
  }

/**
 * 接口 [【满减活动】支付渠道优惠消费↗](https://yapi.gogpay.cn/project/927/interface/api/378792) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionConsume`
 */
export const apiActivityTradeFullReductionConsume = /*#__PURE__*/ (
  requestData: ApiActivityTradeFullReductionConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeFullReductionConsumeResponse>(
    prepare(apiActivityTradeFullReductionConsumeRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeFullReductionConsume.requestConfig =
  apiActivityTradeFullReductionConsumeRequestConfig

/**
 * 接口 [【满减活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/379176) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionUseCheck`
 */
export interface ApiActivityTradeFullReductionUseCheckRequest {
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      matchActivityInfo?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始数量
         */
        initLimitCount?: number
        /**
         * 实际所需活动积分
         */
        integral?: number
        /**
         * 匹配活动规则ID
         */
        matchRuleId?: string
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 匹配条件Id
       */
      matchConditionId?: string
      /**
       * 规格描述
       */
      skuDesc?: string
      /**
       * sku id
       */
      skuId?: string
      /**
       * 商品总额
       */
      totalAmount?: number
      /**
       * 商品总数量
       */
      totalQuantity?: number
      /**
       * 商品单价
       */
      unitPrice?: number
    }[]
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 业务订单Id，检测仅供临时使用。下单做为存储唯一标识
     */
    orderId?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [【满减活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/379176) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionUseCheck`
 */
export interface ApiActivityTradeFullReductionUseCheckResponse {
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 是否匹配活动信息
   */
  matchActivity?: boolean
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      matchActivityInfo?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始数量
         */
        initLimitCount?: number
        /**
         * 实际所需活动积分
         */
        integral?: number
        /**
         * 匹配活动规则ID
         */
        matchRuleId?: string
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 匹配条件Id
       */
      matchConditionId?: string
      /**
       * 规格描述
       */
      skuDesc?: string
      /**
       * sku id
       */
      skuId?: string
      /**
       * 商品总额
       */
      totalAmount?: number
      /**
       * 商品总数量
       */
      totalQuantity?: number
      /**
       * 商品单价
       */
      unitPrice?: number
    }[]
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 业务订单Id，检测仅供临时使用。下单做为存储唯一标识
     */
    orderId?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 消费凭据
   */
  ticket?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [【满减活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/379176) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionUseCheck`
 */
type ApiActivityTradeFullReductionUseCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/fullReductionUseCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【满减活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/379176) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionUseCheck`
 */
const apiActivityTradeFullReductionUseCheckRequestConfig: ApiActivityTradeFullReductionUseCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/fullReductionUseCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeFullReductionUseCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【满减活动】道优惠可用性检测', author: '333号开发' },
  }

/**
 * 接口 [【满减活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/379176) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/fullReductionUseCheck`
 */
export const apiActivityTradeFullReductionUseCheck = /*#__PURE__*/ (
  requestData: ApiActivityTradeFullReductionUseCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeFullReductionUseCheckResponse>(
    prepare(apiActivityTradeFullReductionUseCheckRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeFullReductionUseCheck.requestConfig =
  apiActivityTradeFullReductionUseCheckRequestConfig

/**
 * 接口 [【积分活动】取消消费↗](https://yapi.gogpay.cn/project/927/interface/api/385605) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelIntegral`
 */
export interface ApiActivityTradeCancelIntegralRequest {
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 规格Id列表
   */
  skuIdList?: string[]
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [【积分活动】取消消费↗](https://yapi.gogpay.cn/project/927/interface/api/385605) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelIntegral`
 */
export interface ApiActivityTradeCancelIntegralResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【积分活动】取消消费↗](https://yapi.gogpay.cn/project/927/interface/api/385605) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelIntegral`
 */
type ApiActivityTradeCancelIntegralRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/cancelIntegral',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【积分活动】取消消费↗](https://yapi.gogpay.cn/project/927/interface/api/385605) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelIntegral`
 */
const apiActivityTradeCancelIntegralRequestConfig: ApiActivityTradeCancelIntegralRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/cancelIntegral',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeCancelIntegral',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【积分活动】取消消费', author: '333号开发' },
  }

/**
 * 接口 [【积分活动】取消消费↗](https://yapi.gogpay.cn/project/927/interface/api/385605) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/cancelIntegral`
 */
export const apiActivityTradeCancelIntegral = /*#__PURE__*/ (
  requestData: ApiActivityTradeCancelIntegralRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeCancelIntegralResponse>(
    prepare(apiActivityTradeCancelIntegralRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeCancelIntegral.requestConfig =
  apiActivityTradeCancelIntegralRequestConfig

/**
 * 接口 [【积分活动】消费↗](https://yapi.gogpay.cn/project/927/interface/api/385608) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralConsume`
 */
export interface ApiActivityTradeIntegralConsumeRequest {
  /**
   * 活动Id
   */
  activityId: string
  /**
   * 活动名称
   */
  activityName: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 多彩豆
   */
  dcbCoin: number
  /**
   * 是否锁定多彩豆；0：未锁定；1：锁定
   */
  dcbCoinLockFlag: number
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 使用积分商品数量
   */
  integralQuantity: number
  /**
   * 所需积分
   */
  needIntegral: number
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 下单时间
   */
  orderTime: string
  /**
   * 订单类型
   */
  orderType: number
  /**
   * 原价
   */
  originalAmount?: number
  /**
   * 原始单价
   */
  originalUnitPrice?: number
  /**
   * 父订单id
   */
  parentId?: string
  /**
   * 订单编号
   */
  phone: string
  /**
   * 积分比例
   */
  pointsRatio: string
  /**
   * 数量
   */
  quantity?: number
  /**
   * 备注
   */
  remarks: string
  /**
   * 商品ID
   */
  shopId: string
  /**
   * 商品名称
   */
  shopName: string
  /**
   * sku规格
   */
  skuDesc?: string
  /**
   * skuId
   */
  skuId: string
  /**
   * 更新时间
   */
  updateTime: string
  /**
   * 用户ID
   */
  userId: string
}

/**
 * 接口 [【积分活动】消费↗](https://yapi.gogpay.cn/project/927/interface/api/385608) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralConsume`
 */
export interface ApiActivityTradeIntegralConsumeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【积分活动】消费↗](https://yapi.gogpay.cn/project/927/interface/api/385608) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralConsume`
 */
type ApiActivityTradeIntegralConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/integralConsume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【积分活动】消费↗](https://yapi.gogpay.cn/project/927/interface/api/385608) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralConsume`
 */
const apiActivityTradeIntegralConsumeRequestConfig: ApiActivityTradeIntegralConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/integralConsume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeIntegralConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【积分活动】消费', author: '333号开发' },
  }

/**
 * 接口 [【积分活动】消费↗](https://yapi.gogpay.cn/project/927/interface/api/385608) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralConsume`
 */
export const apiActivityTradeIntegralConsume = /*#__PURE__*/ (
  requestData: ApiActivityTradeIntegralConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeIntegralConsumeResponse>(
    prepare(apiActivityTradeIntegralConsumeRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeIntegralConsume.requestConfig =
  apiActivityTradeIntegralConsumeRequestConfig

/**
 * 接口 [【积分活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/385611) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralUseCheck`
 */
export interface ApiActivityTradeIntegralUseCheckRequest {
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      matchActivityInfo?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始数量
         */
        initLimitCount?: number
        /**
         * 实际所需活动积分
         */
        integral?: number
        /**
         * 匹配活动规则ID
         */
        matchRuleId?: string
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 匹配条件Id
       */
      matchConditionId?: string
      /**
       * 规格描述
       */
      skuDesc?: string
      /**
       * sku id
       */
      skuId?: string
      /**
       * 商品总额
       */
      totalAmount?: number
      /**
       * 商品总数量
       */
      totalQuantity?: number
      /**
       * 商品单价
       */
      unitPrice?: number
    }[]
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 业务订单Id，检测仅供临时使用。下单做为存储唯一标识
     */
    orderId?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [【积分活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/385611) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralUseCheck`
 */
export interface ApiActivityTradeIntegralUseCheckResponse {
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 是否匹配活动信息
   */
  matchActivity?: boolean
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 优惠金额
       */
      discountAmount?: number
      matchActivityInfo?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 优惠级别
         */
        discountLevel?: 'GOODS' | 'ORG' | 'BUSINESS_TYPE' | 'CATEGORY'
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始数量
         */
        initLimitCount?: number
        /**
         * 实际所需活动积分
         */
        integral?: number
        /**
         * 匹配活动规则ID
         */
        matchRuleId?: string
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 折扣比例
         */
        rate?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        /**
         * 活动规则
         */
        rules?: string
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 匹配条件Id
       */
      matchConditionId?: string
      /**
       * 规格描述
       */
      skuDesc?: string
      /**
       * sku id
       */
      skuId?: string
      /**
       * 商品总额
       */
      totalAmount?: number
      /**
       * 商品总数量
       */
      totalQuantity?: number
      /**
       * 商品单价
       */
      unitPrice?: number
    }[]
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 业务订单Id，检测仅供临时使用。下单做为存储唯一标识
     */
    orderId?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 消费凭据
   */
  ticket?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [【积分活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/385611) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralUseCheck`
 */
type ApiActivityTradeIntegralUseCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/integralUseCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【积分活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/385611) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralUseCheck`
 */
const apiActivityTradeIntegralUseCheckRequestConfig: ApiActivityTradeIntegralUseCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/integralUseCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeIntegralUseCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【积分活动】道优惠可用性检测', author: '333号开发' },
  }

/**
 * 接口 [【积分活动】道优惠可用性检测↗](https://yapi.gogpay.cn/project/927/interface/api/385611) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/integralUseCheck`
 */
export const apiActivityTradeIntegralUseCheck = /*#__PURE__*/ (
  requestData: ApiActivityTradeIntegralUseCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeIntegralUseCheckResponse>(
    prepare(apiActivityTradeIntegralUseCheckRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeIntegralUseCheck.requestConfig =
  apiActivityTradeIntegralUseCheckRequestConfig

/**
 * 接口 [【积分活动】归还积分消费↗](https://yapi.gogpay.cn/project/927/interface/api/385851) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/returnIntegral`
 */
export interface ApiActivityTradeReturnIntegralRequest {
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [【积分活动】归还积分消费↗](https://yapi.gogpay.cn/project/927/interface/api/385851) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/returnIntegral`
 */
export interface ApiActivityTradeReturnIntegralResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [【积分活动】归还积分消费↗](https://yapi.gogpay.cn/project/927/interface/api/385851) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/returnIntegral`
 */
type ApiActivityTradeReturnIntegralRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/trade/returnIntegral',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【积分活动】归还积分消费↗](https://yapi.gogpay.cn/project/927/interface/api/385851) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/returnIntegral`
 */
const apiActivityTradeReturnIntegralRequestConfig: ApiActivityTradeReturnIntegralRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_27,
    devUrl: devUrl_0_18_0_27,
    prodUrl: prodUrl_0_18_0_27,
    path: '/activity/trade/returnIntegral',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityTradeReturnIntegral',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【积分活动】归还积分消费', author: '333号开发' },
  }

/**
 * 接口 [【积分活动】归还积分消费↗](https://yapi.gogpay.cn/project/927/interface/api/385851) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [交易系统API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_57080)
 * @请求头 `POST /activity/trade/returnIntegral`
 */
export const apiActivityTradeReturnIntegral = /*#__PURE__*/ (
  requestData: ApiActivityTradeReturnIntegralRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityTradeReturnIntegralResponse>(
    prepare(apiActivityTradeReturnIntegralRequestConfig, requestData),
    ...args,
  )
}

apiActivityTradeReturnIntegral.requestConfig =
  apiActivityTradeReturnIntegralRequestConfig

const mockUrl_0_18_0_30 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_30 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_30 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_30 = 'data' as any

/**
 * 接口 [获取满减活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/379173) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [full-reduction-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_66919)
 * @请求头 `POST /activity/api/fullReduction/detail`
 */
export interface ApiActivityFullReductionDetailRequest {
  /**
   * SKU信息
   */
  skuId?: string
}

/**
 * 接口 [获取满减活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/379173) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [full-reduction-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_66919)
 * @请求头 `POST /activity/api/fullReduction/detail`
 */
export interface ApiActivityFullReductionDetailResponse {
  /**
   * 满减活动名称
   */
  activityName: string
  /**
   * 活动状态：0=未开始，1=进行中,2=已终止
   */
  activityStatus?: number
  /**
   * 审批状态：0=待审批，10=审批中，11=审批拒绝，12=审批已撤销,13=审批通过，20=终止审批中，21=终止审批拒绝，22=终止审批已撤销 23=终止审批通过
   */
  approvalStatus?: number
  businessLeader: {
    /**
     * 部门ID
     */
    departId?: string
    /**
     * 部门名称
     */
    departName?: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 用户名称
     */
    userName?: string
  }
  /**
   * 触发物限购设置
   */
  conditions: {
    /**
     * 类目名称
     */
    categoryName: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName: string
    /**
     * shuId
     */
    conditionId: string
    /**
     * 商品规格
     */
    conditionName: string
    /**
     * 店铺ID
     */
    merchantId: string
    /**
     * 店铺名称
     */
    merchantName: string
    /**
     * 渠道名称
     */
    refUserGroupName: string
  }[]
  /**
   * 活动内容描述
   */
  content?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 优惠结束时间
   */
  endTime?: string
  /**
   * 满减使用设置
   */
  fullReductioSetParam: {
    /**
     * 总库存量
     */
    count: number
    /**
     * 满减临界价格
     */
    fullAmt: number
    /**
     * 规则编码
     */
    id?: string
    /**
     * 优惠价格
     */
    reductionAmt: number
    /**
     * 当前用户是否使用
     */
    use?: boolean
    /**
     * 已使用量
     */
    usedCount?: number
    /**
     * 用户使用限制
     */
    userLimitPurchases: number
  }[]
  /**
   * 满减活动名称
   */
  id: string
  /**
   * 营销活动名称
   */
  marketingActivityName: string
  /**
   * 营销活动ID
   */
  refMarketingActivityId: string
  /**
   * 活动规则统计
   */
  ruleStatistics?: {
    /**
     * 总优惠金额
     */
    discountAmount?: number
    /**
     * 已优惠订单数
     */
    discountOrderCount?: number
    /**
     * 规则编码
     */
    id?: string
    /**
     * 规则
     */
    rule?: string
    /**
     * 可使用名额总量
     */
    total?: number
    /**
     * 已使用名额量
     */
    usedCount?: number
    /**
     * 用户使用限制
     */
    userLimitPurchases?: number
  }[]
  settlementConfig: {
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
  }
  /**
   * 出资方名称
   */
  settlementName: string
  /**
   * 专项营销活动标识
   */
  specialMarketingExplain?: string
  /**
   * 优惠开始时间
   */
  startTime?: string
  /**
   * 活动商品待支付时间配置
   */
  waitPayTimeConfig?: number
}

/**
 * 接口 [获取满减活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/379173) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [full-reduction-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_66919)
 * @请求头 `POST /activity/api/fullReduction/detail`
 */
type ApiActivityFullReductionDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/fullReduction/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取满减活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/379173) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [full-reduction-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_66919)
 * @请求头 `POST /activity/api/fullReduction/detail`
 */
const apiActivityFullReductionDetailRequestConfig: ApiActivityFullReductionDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_30,
    devUrl: devUrl_0_18_0_30,
    prodUrl: prodUrl_0_18_0_30,
    path: '/activity/api/fullReduction/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityFullReductionDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取满减活动详情', author: '333号开发' },
  }

/**
 * 接口 [获取满减活动详情↗](https://yapi.gogpay.cn/project/927/interface/api/379173) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [full-reduction-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_66919)
 * @请求头 `POST /activity/api/fullReduction/detail`
 */
export const apiActivityFullReductionDetail = /*#__PURE__*/ (
  requestData: ApiActivityFullReductionDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityFullReductionDetailResponse>(
    prepare(apiActivityFullReductionDetailRequestConfig, requestData),
    ...args,
  )
}

apiActivityFullReductionDetail.requestConfig =
  apiActivityFullReductionDetailRequestConfig

const mockUrl_0_18_0_36 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_36 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_36 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_36 = 'data' as any

/**
 * 接口 [获取积分活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/385320) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/commodityByActivity`
 */
export interface ApiActivityIntegralCommodityByActivityRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 运营渠道ID
   */
  bussinessChannelId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取积分活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/385320) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/commodityByActivity`
 */
export interface ApiActivityIntegralCommodityByActivityResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName: string
    /**
     * 商品图片
     */
    commodityPic: string
    /**
     * 商品类型：0-标电 1-核销
     */
    commodityType?: number
    /**
     * 商品详情地址
     */
    commodityUrl?: string
    /**
     * 商品优惠内容
     */
    content?: string
    /**
     * 积分使用量
     */
    integralUsedCount?: number
    /**
     * 商品最低需要积分
     */
    minIntegral?: number
    /**
     * 商品价格区间
     */
    priceRange?: string
    /**
     * 商品sku信息
     */
    skuList?: {
      /**
       * 积分活动ID
       */
      activityId: string
      /**
       * 活动价格
       */
      activityPrice?: number
      /**
       * 积分活动商品
       */
      commodityId: string
      /**
       * 原始结算价格
       */
      costPrice?: number
      /**
       * 活动刚开始划拨出来的总库存
       */
      cutStock?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 积分优惠
       */
      discountIntegral?: number
      /**
       * 所需积分
       */
      integral?: number
      /**
       * sku当前价格
       */
      price?: number
      /**
       * sku描述信息
       */
      skuDesc?: string
      /**
       * 积分活动商品skuID
       */
      skuId: string
      /**
       * 库存
       */
      stock?: number
      /**
       * 单人限购
       */
      userPurchaseLimit?: number
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取积分活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/385320) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/commodityByActivity`
 */
type ApiActivityIntegralCommodityByActivityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/integral/commodityByActivity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取积分活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/385320) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/commodityByActivity`
 */
const apiActivityIntegralCommodityByActivityRequestConfig: ApiActivityIntegralCommodityByActivityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_36,
    devUrl: devUrl_0_18_0_36,
    prodUrl: prodUrl_0_18_0_36,
    path: '/activity/api/integral/commodityByActivity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityIntegralCommodityByActivity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取积分活动信息', author: '333号开发' },
  }

/**
 * 接口 [获取积分活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/385320) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/commodityByActivity`
 */
export const apiActivityIntegralCommodityByActivity = /*#__PURE__*/ (
  requestData: ApiActivityIntegralCommodityByActivityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityIntegralCommodityByActivityResponse>(
    prepare(apiActivityIntegralCommodityByActivityRequestConfig, requestData),
    ...args,
  )
}

apiActivityIntegralCommodityByActivity.requestConfig =
  apiActivityIntegralCommodityByActivityRequestConfig

/**
 * 接口 [检测多彩豆是否足够↗](https://yapi.gogpay.cn/project/927/interface/api/385494) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/userCheck`
 */
export interface ApiActivityIntegralUserCheckRequest {
  /**
   * sku信息
   */
  skuInfoList?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 购买数量
     */
    quantity: number
    /**
     * skuId
     */
    skuId: string
  }[]
}

/**
 * 接口 [检测多彩豆是否足够↗](https://yapi.gogpay.cn/project/927/interface/api/385494) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/userCheck`
 */
export interface ApiActivityIntegralUserCheckResponse {
  /**
   * 多彩分是否足够
   */
  integralFull?: boolean
  /**
   * 提示文案
   */
  tipsContent?: string
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [检测多彩豆是否足够↗](https://yapi.gogpay.cn/project/927/interface/api/385494) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/userCheck`
 */
type ApiActivityIntegralUserCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/integral/userCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [检测多彩豆是否足够↗](https://yapi.gogpay.cn/project/927/interface/api/385494) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/userCheck`
 */
const apiActivityIntegralUserCheckRequestConfig: ApiActivityIntegralUserCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_36,
    devUrl: devUrl_0_18_0_36,
    prodUrl: prodUrl_0_18_0_36,
    path: '/activity/api/integral/userCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityIntegralUserCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '检测多彩豆是否足够', author: '333号开发' },
  }

/**
 * 接口 [检测多彩豆是否足够↗](https://yapi.gogpay.cn/project/927/interface/api/385494) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/userCheck`
 */
export const apiActivityIntegralUserCheck = /*#__PURE__*/ (
  requestData: ApiActivityIntegralUserCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityIntegralUserCheckResponse>(
    prepare(apiActivityIntegralUserCheckRequestConfig, requestData),
    ...args,
  )
}

apiActivityIntegralUserCheck.requestConfig =
  apiActivityIntegralUserCheckRequestConfig

/**
 * 接口 [获取积分活动详情信息↗](https://yapi.gogpay.cn/project/927/interface/api/385602) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/detail`
 */
export interface ApiActivityIntegralDetailRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取积分活动详情信息↗](https://yapi.gogpay.cn/project/927/interface/api/385602) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/detail`
 */
export interface ApiActivityIntegralDetailResponse {
  /**
   * 积分活动Id
   */
  activityId: string
  /**
   * 积分活动名称
   */
  activityName: string
  /**
   * 活动状态：0=未开始，1=进行中,2=已终止
   */
  activityStatus?: number
  /**
   * 活动内容描述
   */
  content?: string
  /**
   * 优惠结束时间
   */
  endTime?: string
  /**
   * sku信息
   */
  skuInfoList?: {
    /**
     * 原价
     */
    originalPrice?: number
    /**
     * sku图片
     */
    pic?: string
    /**
     * sku价格
     */
    price?: number
    /**
     * sku描述
     */
    skuDesc?: string
    /**
     * SKU Id
     */
    skuId?: string
    /**
     * 剩余库存
     */
    stock?: number
  }[]
  /**
   * 优惠开始时间
   */
  startTime?: string
}

/**
 * 接口 [获取积分活动详情信息↗](https://yapi.gogpay.cn/project/927/interface/api/385602) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/detail`
 */
type ApiActivityIntegralDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/integral/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取积分活动详情信息↗](https://yapi.gogpay.cn/project/927/interface/api/385602) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/detail`
 */
const apiActivityIntegralDetailRequestConfig: ApiActivityIntegralDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_36,
    devUrl: devUrl_0_18_0_36,
    prodUrl: prodUrl_0_18_0_36,
    path: '/activity/api/integral/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityIntegralDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取积分活动详情信息', author: '333号开发' },
  }

/**
 * 接口 [获取积分活动详情信息↗](https://yapi.gogpay.cn/project/927/interface/api/385602) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/detail`
 */
export const apiActivityIntegralDetail = /*#__PURE__*/ (
  requestData: ApiActivityIntegralDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityIntegralDetailResponse>(
    prepare(apiActivityIntegralDetailRequestConfig, requestData),
    ...args,
  )
}

apiActivityIntegralDetail.requestConfig = apiActivityIntegralDetailRequestConfig

/**
 * 接口 [获取积分活动活动库存↗](https://yapi.gogpay.cn/project/927/interface/api/388581) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/getIntegralActivityStock`
 */
export interface ApiActivityIntegralGetIntegralActivityStockRequest {
  /**
   * SKU信息
   */
  skuId?: string
}

/**
 * 接口 [获取积分活动活动库存↗](https://yapi.gogpay.cn/project/927/interface/api/388581) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/getIntegralActivityStock`
 */
export type ApiActivityIntegralGetIntegralActivityStockResponse = number

/**
 * 接口 [获取积分活动活动库存↗](https://yapi.gogpay.cn/project/927/interface/api/388581) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/getIntegralActivityStock`
 */
type ApiActivityIntegralGetIntegralActivityStockRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/integral/getIntegralActivityStock',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取积分活动活动库存↗](https://yapi.gogpay.cn/project/927/interface/api/388581) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/getIntegralActivityStock`
 */
const apiActivityIntegralGetIntegralActivityStockRequestConfig: ApiActivityIntegralGetIntegralActivityStockRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_36,
    devUrl: devUrl_0_18_0_36,
    prodUrl: prodUrl_0_18_0_36,
    path: '/activity/api/integral/getIntegralActivityStock',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityIntegralGetIntegralActivityStock',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取积分活动活动库存', author: '333号开发' },
  }

/**
 * 接口 [获取积分活动活动库存↗](https://yapi.gogpay.cn/project/927/interface/api/388581) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [积分活动API↗](https://yapi.gogpay.cn/project/927/interface/api/cat_67465)
 * @请求头 `POST /activity/api/integral/getIntegralActivityStock`
 */
export const apiActivityIntegralGetIntegralActivityStock = /*#__PURE__*/ (
  requestData: ApiActivityIntegralGetIntegralActivityStockRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityIntegralGetIntegralActivityStockResponse>(
    prepare(
      apiActivityIntegralGetIntegralActivityStockRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityIntegralGetIntegralActivityStock.requestConfig =
  apiActivityIntegralGetIntegralActivityStockRequestConfig

const mockUrl_0_18_0_41 = 'https://yapi.gogpay.cn/mock/927' as any
const devUrl_0_18_0_41 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_18_0_41 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_18_0_41 = 'data' as any

/**
 * 接口 [获取商品虚拟活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/449283) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findVirtualActivityDetailVo`
 */
export interface ApiActivityVirtualActivityFindVirtualActivityDetailVoRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取商品虚拟活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/449283) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findVirtualActivityDetailVo`
 */
export interface ApiActivityVirtualActivityFindVirtualActivityDetailVoResponse {
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 活动状态：0=未开始，1=进行中,2=已终止
   */
  activityStatus?: number
  /**
   * 审批状态：0=待审批，10=审批中，11=审批拒绝，12=审批已撤销,13=审批通过，20=终止审批中，21=终止审批拒绝，22=终止审批已撤销 23=终止审批通过
   */
  approvalStatus?: number
  businessLeader?: {
    /**
     * 部门ID
     */
    departId?: string
    /**
     * 部门名称
     */
    departName?: string
    /**
     * 用户ID
     */
    userId?: string
    /**
     * 用户名称
     */
    userName?: string
  }
  /**
   * 商品详情优惠内容
   */
  commodityDiscountContent?: string
  /**
   * 商品详情跳转内容
   */
  commodityRouteContent?: string
  /**
   * 商品详情跳转链接
   */
  commodityRouteUrl?: string
  /**
   * 触发物限购设置
   */
  conditions: {
    /**
     * 类目名称
     */
    categoryName: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName: string
    /**
     * shuId
     */
    conditionId: string
    /**
     * 商品规格
     */
    conditionName: string
    /**
     * 店铺ID
     */
    merchantId: string
    /**
     * 店铺名称
     */
    merchantName: string
    /**
     * 渠道名称
     */
    refUserGroupName: string
  }[]
  /**
   * 优惠内容
   */
  couponContent?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 商品发货是否校验：0=否，1=是
   */
  deliveryCheckStatus?: '0' | '1'
  /**
   * 优惠结束时间
   */
  endTime?: string
  /**
   * 营销活动名称
   */
  marketingActivityName?: string
  /**
   * 支付渠道描述
   */
  payChannelDesc?: string
  /**
   * 支付渠道
   */
  payChannelIds?: string
  /**
   * 营销活动ID
   */
  refMarketingActivityId?: string
  /**
   * 备注说明
   */
  remarks?: string
  /**
   * 是否允许添加购物车：0=否，1=是
   */
  shopCarStatus?: '0' | '1'
  /**
   * 专项营销活动标识
   */
  specialMarketingExplain?: string
  /**
   * 是否可启动标识 0否 1是
   */
  startFlag?: number
  /**
   * 优惠开始时间
   */
  startTime?: string
  /**
   * 商品下单是否需要成年：0=否，1=是
   */
  tradeOrderCheckAdult?: number
  /**
   * 是否可编辑标识 0否 1是
   */
  updateFlag?: number
  /**
   * 活动Id
   */
  virtualActivityId?: string
}

/**
 * 接口 [获取商品虚拟活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/449283) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findVirtualActivityDetailVo`
 */
type ApiActivityVirtualActivityFindVirtualActivityDetailVoRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/927',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/activity/api/virtualActivity/findVirtualActivityDetailVo',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取商品虚拟活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/449283) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findVirtualActivityDetailVo`
 */
const apiActivityVirtualActivityFindVirtualActivityDetailVoRequestConfig: ApiActivityVirtualActivityFindVirtualActivityDetailVoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_41,
    devUrl: devUrl_0_18_0_41,
    prodUrl: prodUrl_0_18_0_41,
    path: '/activity/api/virtualActivity/findVirtualActivityDetailVo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiActivityVirtualActivityFindVirtualActivityDetailVo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品虚拟活动信息', author: '511号开发' },
  }

/**
 * 接口 [获取商品虚拟活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/449283) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findVirtualActivityDetailVo`
 */
export const apiActivityVirtualActivityFindVirtualActivityDetailVo =
  /*#__PURE__*/ (
    requestData: ApiActivityVirtualActivityFindVirtualActivityDetailVoRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiActivityVirtualActivityFindVirtualActivityDetailVoResponse>(
      prepare(
        apiActivityVirtualActivityFindVirtualActivityDetailVoRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiActivityVirtualActivityFindVirtualActivityDetailVo.requestConfig =
  apiActivityVirtualActivityFindVirtualActivityDetailVoRequestConfig

/**
 * 接口 [通过触发物查询参加的所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/453723) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findCommodityActivityInfo`
 */
export interface ApiActivityVirtualActivityFindCommodityActivityInfoRequest {
  commodityId?: string
  /**
   * 用户Id
   */
  skuList?: {
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
}

/**
 * 接口 [通过触发物查询参加的所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/453723) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findCommodityActivityInfo`
 */
export interface ApiActivityVirtualActivityFindCommodityActivityInfoResponse {
  /**
   * 活动信息描述列表
   */
  activityDescList?: string[]
  /**
   * 优惠后最低金额
   */
  discountAfterMinAmt?: number
  /**
   * 优惠前最低金额
   */
  discountBeforeMinAmt?: number
  /**
   * 优惠类目描述
   */
  discountTypeDesc?: string
  /**
   * 是否有优惠
   */
  hasDiscount?: number
}

/**
 * 接口 [通过触发物查询参加的所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/453723) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findCommodityActivityInfo`
 */
type ApiActivityVirtualActivityFindCommodityActivityInfoRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/927',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/activity/api/virtualActivity/findCommodityActivityInfo',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [通过触发物查询参加的所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/453723) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findCommodityActivityInfo`
 */
const apiActivityVirtualActivityFindCommodityActivityInfoRequestConfig: ApiActivityVirtualActivityFindCommodityActivityInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_41,
    devUrl: devUrl_0_18_0_41,
    prodUrl: prodUrl_0_18_0_41,
    path: '/activity/api/virtualActivity/findCommodityActivityInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityVirtualActivityFindCommodityActivityInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '通过触发物查询参加的所有活动信息',
      author: '511号开发',
    },
  }

/**
 * 接口 [通过触发物查询参加的所有活动信息↗](https://yapi.gogpay.cn/project/927/interface/api/453723) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findCommodityActivityInfo`
 */
export const apiActivityVirtualActivityFindCommodityActivityInfo =
  /*#__PURE__*/ (
    requestData: ApiActivityVirtualActivityFindCommodityActivityInfoRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiActivityVirtualActivityFindCommodityActivityInfoResponse>(
      prepare(
        apiActivityVirtualActivityFindCommodityActivityInfoRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiActivityVirtualActivityFindCommodityActivityInfo.requestConfig =
  apiActivityVirtualActivityFindCommodityActivityInfoRequestConfig

/**
 * 接口 [预下单页查询用户消费金列表↗](https://yapi.gogpay.cn/project/927/interface/api/453728) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findUserIntegralCoupon`
 */
export interface ApiActivityVirtualActivityFindUserIntegralCouponRequest {
  /**
   * 积分消费券活动结束时间
   */
  endTime?: string
  /**
   * 积分消费券余额
   */
  integralBalance?: number
  /**
   * 积分消费券Id
   */
  integralCouponId?: string
  /**
   * 积分消费券名称
   */
  integralCouponName?: string
  /**
   * 当前订单使用此消费券可补贴金额
   */
  integralDiscountAmt?: number
  /**
   * 门店Id
   */
  merchantId?: string
  /**
   * 当前订单商城优惠后金额
   */
  orderDiscountAmt?: number
  /**
   * 1：多彩宝APP环境 2：微信环境
   */
  paymentMethod: number
  /**
   * 积分消费券活动开始时间
   */
  startTime?: string
  userIntegralCouponList?: unknown[]
}

/**
 * 接口 [预下单页查询用户消费金列表↗](https://yapi.gogpay.cn/project/927/interface/api/453728) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findUserIntegralCoupon`
 */
export interface ApiActivityVirtualActivityFindUserIntegralCouponResponse {
  /**
   * 积分消费券活动结束时间
   */
  endTime?: string
  /**
   * 积分消费券余额
   */
  integralBalance?: number
  /**
   * 积分消费券Id
   */
  integralCouponId?: string
  /**
   * 积分消费券名称
   */
  integralCouponName?: string
  /**
   * 当前订单使用此消费券可补贴金额
   */
  integralDiscountAmt?: number
  /**
   * 门店Id
   */
  merchantId?: string
  /**
   * 当前订单商城优惠后金额
   */
  orderDiscountAmt?: number
  /**
   * 1：多彩宝APP环境 2：微信环境
   */
  paymentMethod: number
  /**
   * 积分消费券活动开始时间
   */
  startTime?: string
  userIntegralCouponList?: unknown[]
}

/**
 * 接口 [预下单页查询用户消费金列表↗](https://yapi.gogpay.cn/project/927/interface/api/453728) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findUserIntegralCoupon`
 */
type ApiActivityVirtualActivityFindUserIntegralCouponRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/927',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/activity/api/virtualActivity/findUserIntegralCoupon',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预下单页查询用户消费金列表↗](https://yapi.gogpay.cn/project/927/interface/api/453728) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findUserIntegralCoupon`
 */
const apiActivityVirtualActivityFindUserIntegralCouponRequestConfig: ApiActivityVirtualActivityFindUserIntegralCouponRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_18_0_41,
    devUrl: devUrl_0_18_0_41,
    prodUrl: prodUrl_0_18_0_41,
    path: '/activity/api/virtualActivity/findUserIntegralCoupon',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_18_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiActivityVirtualActivityFindUserIntegralCoupon',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预下单页查询用户消费金列表', author: '511号开发' },
  }

/**
 * 接口 [预下单页查询用户消费金列表↗](https://yapi.gogpay.cn/project/927/interface/api/453728) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [web-virtual-activity-controller↗](https://yapi.gogpay.cn/project/927/interface/api/cat_80035)
 * @请求头 `POST /activity/api/virtualActivity/findUserIntegralCoupon`
 */
export const apiActivityVirtualActivityFindUserIntegralCoupon = /*#__PURE__*/ (
  requestData: ApiActivityVirtualActivityFindUserIntegralCouponRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiActivityVirtualActivityFindUserIntegralCouponResponse>(
    prepare(
      apiActivityVirtualActivityFindUserIntegralCouponRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiActivityVirtualActivityFindUserIntegralCoupon.requestConfig =
  apiActivityVirtualActivityFindUserIntegralCouponRequestConfig

const mockUrl_0_22_0_0 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_0 = '' as any
const prodUrl_0_22_0_0 = '' as any
const dataKey_0_22_0_0 = 'data' as any

/**
 * 接口 [主商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187718) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-主商户相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33528)
 * @请求头 `POST /merchant/api/masterMerchant/detail`
 */
export interface ApiMerchantMasterMerchantDetailRequest {
  /**
   * 主商户id
   */
  masterMerchantId: string
}

/**
 * 接口 [主商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187718) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-主商户相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33528)
 * @请求头 `POST /merchant/api/masterMerchant/detail`
 */
export interface ApiMerchantMasterMerchantDetailResponse {
  address?: string
  administratorId?: string
  administratorName?: string
  checkType?: number
  cityCode?: string
  cityName?: string
  contactTel?: string
  countyCode?: string
  countyName?: string
  createBy?: string
  createTime?: string
  delFlag?: number
  detailedAddress?: string
  email?: string
  frontendShowName?: string
  id?: string
  lastUpdateTime?: string
  masterMerchantName?: string
  merchantStatus?: number
  pic?: string
  provinceCode?: string
  provinceName?: string
  refMartId?: string
  refMerchantId?: string
  refRoleId?: string
  refRoleName?: string
  refUserGroupId?: string
  remark?: string
  reviewStatus?: number
  saleType?: number
  securityDepositBalance?: number
  securityDepositBaseline?: number
  securityDepositFlag?: boolean
  securityDepositFrozenAmount?: number
  settlementPeriod?: number
  unitOrgCode?: string
  updateBy?: string
  updateTime?: string
}

/**
 * 接口 [主商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187718) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-主商户相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33528)
 * @请求头 `POST /merchant/api/masterMerchant/detail`
 */
type ApiMerchantMasterMerchantDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/masterMerchant/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [主商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187718) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-主商户相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33528)
 * @请求头 `POST /merchant/api/masterMerchant/detail`
 */
const apiMerchantMasterMerchantDetailRequestConfig: ApiMerchantMasterMerchantDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_0,
    devUrl: devUrl_0_22_0_0,
    prodUrl: prodUrl_0_22_0_0,
    path: '/merchant/api/masterMerchant/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMasterMerchantDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '主商户详情查询', author: '张彬' },
  }

/**
 * 接口 [主商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187718) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-主商户相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33528)
 * @请求头 `POST /merchant/api/masterMerchant/detail`
 */
export const apiMerchantMasterMerchantDetail = /*#__PURE__*/ (
  requestData: ApiMerchantMasterMerchantDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMasterMerchantDetailResponse>(
    prepare(apiMerchantMasterMerchantDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMasterMerchantDetail.requestConfig =
  apiMerchantMasterMerchantDetailRequestConfig

const mockUrl_0_22_0_1 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_1 = '' as any
const prodUrl_0_22_0_1 = '' as any
const dataKey_0_22_0_1 = 'data' as any

/**
 * 接口 [商户基本信息查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187722) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/baseInfo`
 */
export interface ApiMerchantMerchantBaseInfoRequest {
  /**
   * 商户id
   */
  id?: string
}

/**
 * 接口 [商户基本信息查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187722) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/baseInfo`
 */
export interface ApiMerchantMerchantBaseInfoResponse {
  /**
   * 商户管理员姓名
   */
  administratorName?: string
  /**
   * 附件地址
   */
  attachment?: string
  /**
   * 联系电话
   */
  contactTel?: string
  /**
   * 前台商户名称
   */
  frontendShowName?: string
  /**
   * 商户id
   */
  id?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户状态，0:待上线(默认)，1:营业中; 2.已停业；3.休息中
   */
  merchantStatus: number
  /**
   * 公司图片
   */
  pic?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 审核状态
   */
  reviewStatus?: number
}

/**
 * 接口 [商户基本信息查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187722) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/baseInfo`
 */
type ApiMerchantMerchantBaseInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/baseInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户基本信息查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187722) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/baseInfo`
 */
const apiMerchantMerchantBaseInfoRequestConfig: ApiMerchantMerchantBaseInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_1,
    devUrl: devUrl_0_22_0_1,
    prodUrl: prodUrl_0_22_0_1,
    path: '/merchant/api/merchant/baseInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantBaseInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户基本信息查询', author: '张彬' },
  }

/**
 * 接口 [商户基本信息查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187722) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/baseInfo`
 */
export const apiMerchantMerchantBaseInfo = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantBaseInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantBaseInfoResponse>(
    prepare(apiMerchantMerchantBaseInfoRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantBaseInfo.requestConfig =
  apiMerchantMerchantBaseInfoRequestConfig

/**
 * 接口 [商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187726) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/detail`
 */
export interface ApiMerchantMerchantDetailRequest {
  /**
   * 商户id
   */
  merchantId: string
}

/**
 * 接口 [商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187726) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/detail`
 */
export interface ApiMerchantMerchantDetailResponse {
  address?: string
  administratorId?: string
  administratorName?: string
  attachment?: string
  bankOpenedAccountName?: string
  checkType?: number
  cityCode?: string
  cityName?: string
  configId?: string
  contactTel?: string
  countyCode?: string
  countyName?: string
  createBy?: string
  createTime?: string
  customerTel?: string
  delFlag?: number
  deliveryMode?: string
  detailedAddress?: string
  email?: string
  frontendShowName?: string
  id?: string
  lastUpdateTime?: string
  masterId?: string
  masterMerchantName?: string
  merchantName?: string
  merchantStatus?: number
  openedAccountBranchCode?: string
  openedAccountBranchName?: string
  openingHoursPeriod?: string
  openingHoursType?: number
  pic?: string
  provinceCode?: string
  provinceName?: string
  receivableBankAccount?: string
  refMartId?: string
  refMerchantId?: string
  refRoleId?: string
  refRoleName?: string
  refUserGroupId?: string
  remark?: string
  reviewStatus?: number
  saleType?: number
  securityDepositBalance?: number
  securityDepositBaseline?: number
  securityDepositFlag?: boolean
  securityDepositFrozenAmount?: number
  settlementPeriod?: number
  unifySocialCreditCode?: string
  unitOrgCode?: string
  updateBy?: string
  updateTime?: string
}

/**
 * 接口 [商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187726) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/detail`
 */
type ApiMerchantMerchantDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187726) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/detail`
 */
const apiMerchantMerchantDetailRequestConfig: ApiMerchantMerchantDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_1,
    devUrl: devUrl_0_22_0_1,
    prodUrl: prodUrl_0_22_0_1,
    path: '/merchant/api/merchant/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户详情查询', author: '张彬' },
  }

/**
 * 接口 [商户详情查询↗](https://yapi.gogpay.cn/project/2492/interface/api/187726) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-商户请求接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33531)
 * @请求头 `POST /merchant/api/merchant/detail`
 */
export const apiMerchantMerchantDetail = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantDetailResponse>(
    prepare(apiMerchantMerchantDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantDetail.requestConfig = apiMerchantMerchantDetailRequestConfig

const mockUrl_0_22_0_2 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_2 = '' as any
const prodUrl_0_22_0_2 = '' as any
const dataKey_0_22_0_2 = 'data' as any

/**
 * 接口 [通过ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187730) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/get`
 */
export interface ApiMerchantMerchantConfigGetRequest {}

/**
 * 接口 [通过ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187730) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/get`
 */
export interface ApiMerchantMerchantConfigGetResponse {
  activityStoreFlag?: boolean
  applyCustomerServiceHiddenFlag?: number
  autoConfirmSurplusDays?: number
  autoReceiveSurplusDays?: number
  autoReceiveTimeoutDays?: number
  autoReceiverOrderFlag?: number
  cacelUnpaidOrderTimeoutMins?: number
  cancelReceiverOrderTimeout?: number
  confirmReceiptSurplusDay?: number
  createBy?: string
  createTime?: string
  delFlag?: number
  delayReceiveDuration?: number
  delayReceiveDurationUnit?: string
  distributeGuaranteeDays?: number
  exchangeSaleAfterCloseSurplusDays?: number
  extendReceiptFlag?: number
  flagshipStoreFlag?: number
  id?: string
  merchantId?: string
  onlyShowWriteOffStoreAddress?: number
  reapplyHiddenFlag?: number
  refMartId?: string
  refMerchantId?: string
  refUserGroupId?: string
  returnExchangeDisposalTimeoutDays?: number
  saleAfterContactMerchantHiddenFlag?: number
  saleAfterDisposalTimeoutDays?: number
  sellLimitCount?: number
  sendGoodsGuaranteeDays?: number
  storeOnlineInvoiceFlag?: boolean
  supportIntegral?: boolean
  supportPaymentChannels?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  supportYiPay?: boolean
  unitOrgCode?: string
  updateBy?: string
  updateTime?: string
  urgeShipHiddenFlag?: number
}

/**
 * 接口 [通过ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187730) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/get`
 */
type ApiMerchantMerchantConfigGetRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchantConfig/get',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [通过ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187730) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/get`
 */
const apiMerchantMerchantConfigGetRequestConfig: ApiMerchantMerchantConfigGetRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_2,
    devUrl: devUrl_0_22_0_2,
    prodUrl: prodUrl_0_22_0_2,
    path: '/merchant/api/merchantConfig/get',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantConfigGet',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '通过ID获取商户通用配置', author: '张彬' },
  }

/**
 * 接口 [通过ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187730) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/get`
 */
export const apiMerchantMerchantConfigGet = /*#__PURE__*/ (
  requestData?: ApiMerchantMerchantConfigGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantConfigGetResponse>(
    prepare(apiMerchantMerchantConfigGetRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantConfigGet.requestConfig =
  apiMerchantMerchantConfigGetRequestConfig

/**
 * 接口 [通过商户ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187734) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/getByMerchantId`
 */
export interface ApiMerchantMerchantConfigGetByMerchantIdRequest {}

/**
 * 接口 [通过商户ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187734) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/getByMerchantId`
 */
export interface ApiMerchantMerchantConfigGetByMerchantIdResponse {
  activityStoreFlag?: boolean
  applyCustomerServiceHiddenFlag?: number
  autoConfirmSurplusDays?: number
  autoReceiveSurplusDays?: number
  autoReceiveTimeoutDays?: number
  autoReceiverOrderFlag?: number
  cacelUnpaidOrderTimeoutMins?: number
  cancelReceiverOrderTimeout?: number
  confirmReceiptSurplusDay?: number
  createBy?: string
  createTime?: string
  delFlag?: number
  delayReceiveDuration?: number
  delayReceiveDurationUnit?: string
  distributeGuaranteeDays?: number
  exchangeSaleAfterCloseSurplusDays?: number
  extendReceiptFlag?: number
  flagshipStoreFlag?: number
  id?: string
  merchantId?: string
  onlyShowWriteOffStoreAddress?: number
  reapplyHiddenFlag?: number
  refMartId?: string
  refMerchantId?: string
  refUserGroupId?: string
  returnExchangeDisposalTimeoutDays?: number
  saleAfterContactMerchantHiddenFlag?: number
  saleAfterDisposalTimeoutDays?: number
  sellLimitCount?: number
  sendGoodsGuaranteeDays?: number
  storeOnlineInvoiceFlag?: boolean
  supportIntegral?: boolean
  supportPaymentChannels?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  supportYiPay?: boolean
  unitOrgCode?: string
  updateBy?: string
  updateTime?: string
  urgeShipHiddenFlag?: number
}

/**
 * 接口 [通过商户ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187734) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/getByMerchantId`
 */
type ApiMerchantMerchantConfigGetByMerchantIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchantConfig/getByMerchantId',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [通过商户ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187734) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/getByMerchantId`
 */
const apiMerchantMerchantConfigGetByMerchantIdRequestConfig: ApiMerchantMerchantConfigGetByMerchantIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_2,
    devUrl: devUrl_0_22_0_2,
    prodUrl: prodUrl_0_22_0_2,
    path: '/merchant/api/merchantConfig/getByMerchantId',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantConfigGetByMerchantId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '通过商户ID获取商户通用配置', author: '张彬' },
  }

/**
 * 接口 [通过商户ID获取商户通用配置↗](https://yapi.gogpay.cn/project/2492/interface/api/187734) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-商户通用配置相关接口（带缓存）↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33534)
 * @请求头 `POST /merchant/api/merchantConfig/getByMerchantId`
 */
export const apiMerchantMerchantConfigGetByMerchantId = /*#__PURE__*/ (
  requestData?: ApiMerchantMerchantConfigGetByMerchantIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantConfigGetByMerchantIdResponse>(
    prepare(apiMerchantMerchantConfigGetByMerchantIdRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantConfigGetByMerchantId.requestConfig =
  apiMerchantMerchantConfigGetByMerchantIdRequestConfig

const mockUrl_0_22_0_3 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_3 = '' as any
const prodUrl_0_22_0_3 = '' as any
const dataKey_0_22_0_3 = 'data' as any

/**
 * 接口 [获取店铺简介(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/120268) 的 **请求类型**
 *
 * @作者 李连信
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreIntroduction`
 */
export interface ApiMerchantStoreGetStoreIntroductionRequest {
  /**
   * 店铺ID(和子机构编号二选一必填)
   */
  storeId?: string
  /**
   * 子机构编号(和店铺ID二选一必填)
   */
  unitOrgCode?: string
  /**
   * 店铺状态(1-待营业,2-营业中,3-已停业,4-休息中)
   */
  storeStatus?: number
}

/**
 * 接口 [获取店铺简介(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/120268) 的 **返回类型**
 *
 * @作者 李连信
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreIntroduction`
 */
export interface ApiMerchantStoreGetStoreIntroductionResponse {
  /**
   * 机构营业执照
   */
  businessLicensePicture?: string
  /**
   * 资质地址
   */
  certifications?: string[]
  /**
   * 是否仅显示核销店铺地址
   */
  onlyShowWriteOffStoreAddress?: boolean
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 0-不限制 1-支付宝 2-农行 4-微信 7-云闪付
   */
  supportPaymentChannels?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 是否支持翼支付
   */
  supportYiPay?: boolean
  /**
   * 核销店铺列表
   */
  writeOffStoreItems?: {
    /**
     * 店铺地址
     */
    address?: string
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 经度
     */
    lat?: string
    /**
     * 纬度
     */
    lng?: string
    /**
     * 店铺名称
     */
    name?: string
    /**
     * 核销人姓名
     */
    userName?: string
    /**
     * 核销人手机
     */
    userPhone?: string
  }[]
  /**
   * 店铺ID
   */
  storeId?: string
  /**
   * 子机构编号(店铺编号)
   */
  unitOrgCode?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺logo(店铺封面)
   */
  storeLogo?: string
  /**
   * 店铺相册(url列表)
   */
  photoAlbums?: string[]
  /**
   * 最低配送价格
   */
  minDeliveryPrice?: number
  /**
   * 店铺公告
   */
  storeNotice?: string
  /**
   * 店铺活动列表
   */
  storeActivityList?: {
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 活动ID
     */
    id?: string
    /**
     * 活动图片地址
     */
    imgUrl?: string
    /**
     * 资源跳转地址
     */
    resourceUrl?: string
    /**
     * 资源ID
     */
    resourceId?: string
    /**
     * 资源名称
     */
    resourceName?: string
    /**
     * 资源类型
     */
    resourceType?: string
    /**
     * 资源类型名称
     */
    resourceTypeName?: string
    /**
     * 排序值
     */
    sortIndex?: number
  }[]
  /**
   * 人均消费
   */
  consumeAvgAmt?: number
  /**
   * 营业时间
   */
  openPeriod?: string
  /**
   * 营业起始时间(HH:mm)
   */
  openStartTime?: string
  /**
   * 营业结束时间(HH:mm)
   */
  openEndTime?: string
  /**
   * 商家联系电话
   */
  storePhone?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 省级编码
   */
  provinceCode?: string
  /**
   * 省级名称
   */
  provinceName?: string
  /**
   * 地市编码
   */
  cityCode?: string
  /**
   * 地市名称
   */
  cityName?: string
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 区县名称
   */
  districtName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
  /**
   * 配送范围
   */
  deliverZone?: {
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 初始配送价格
     */
    initPrice?: number
    /**
     * 初始阶梯
     */
    initStep?: number
    /**
     * 满xx件|满xxKG
     */
    step?: number
    /**
     * 满加配送价格
     */
    stepPrice?: number
  }[]
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 详细地址
   */
  address?: string
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 店铺状态名称
   */
  storeStatusName?: string
  /**
   * 营销标签
   */
  marketingTag?: string
  /**
   * 活动标签
   */
  activityTags?: string[]
  /**
   * 特点标签
   */
  featureTags?: string[]
  /**
   * 推荐语
   */
  recommendWord?: string
  /**
   * 评价星级
   */
  evaluateStar?: number
  /**
   * 好评率
   */
  praiseRate?: string
  /**
   * 店铺类型：1-标准电商,2-标准核销
   */
  storeType?: number
  /**
   * 店铺类型名称
   */
  storeTypeName?: string
  /**
   * 店铺链接(客户端)
   */
  storeUrl?: string
  /**
   * 店铺链接(TV端)
   */
  storeTvUrl?: string
  /**
   * 所属运营渠道ID
   */
  businessChannelId?: string
  /**
   * 所属运营渠道名称
   */
  businessChannelName?: string
  /**
   * 店铺分类(JSONArray)
   */
  classifyList?: {
    /**
     * 店铺分类ID
     */
    storeClassifyId?: string
    /**
     * 店铺分类名称
     */
    storeClassifyName?: string
  }[][]
  storeSettlementInfo?: {
    /**
     * 结算方式：1-代收代付 2-自营
     */
    settlementMethod: number
    /**
     * 清分机构：1-见证宝 2-NC
     */
    distributionOrg: number
    /**
     * 结算逻辑：1-订单支付成功后结算 2-订单完结后进行结算
     */
    settlementLogic: number
  }
  leader?: {
    /**
     * 钉钉id
     */
    dingTalkId: string
    /**
     * 用户id
     */
    staffId: string
    /**
     * 用户名
     */
    staffName: string
    /**
     * 钉钉手机号
     */
    staffPhone: string
  }
  /**
   * 店铺有效日期
   */
  storeEffectiveEndDate?: string
}

/**
 * 接口 [获取店铺简介(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/120268) 的 **请求配置的类型**
 *
 * @作者 李连信
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreIntroduction`
 */
type ApiMerchantStoreGetStoreIntroductionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getStoreIntroduction',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺简介(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/120268) 的 **请求配置**
 *
 * @作者 李连信
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreIntroduction`
 */
const apiMerchantStoreGetStoreIntroductionRequestConfig: ApiMerchantStoreGetStoreIntroductionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getStoreIntroduction',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetStoreIntroduction',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺简介(带缓存)', author: '李连信' },
  }

/**
 * 接口 [获取店铺简介(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/120268) 的 **请求函数**
 *
 * @作者 李连信
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreIntroduction`
 */
export const apiMerchantStoreGetStoreIntroduction = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetStoreIntroductionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetStoreIntroductionResponse>(
    prepare(apiMerchantStoreGetStoreIntroductionRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetStoreIntroduction.requestConfig =
  apiMerchantStoreGetStoreIntroductionRequestConfig

/**
 * 接口 [获取商品配送费用↗](https://yapi.gogpay.cn/project/2492/interface/api/189862) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getCommodityDeliveryFee`
 */
export interface ApiMerchantStoreGetCommodityDeliveryFeeRequest {
  /**
   * 配送地区CODE
   */
  districtCode: string
  /**
   * 店铺ID
   */
  storeId: string
  /**
   * 商品总数
   */
  totalNumber: number
  /**
   * 商品总总量
   */
  totalWeight: number
}

/**
 * 接口 [获取商品配送费用↗](https://yapi.gogpay.cn/project/2492/interface/api/189862) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getCommodityDeliveryFee`
 */
export interface ApiMerchantStoreGetCommodityDeliveryFeeResponse {
  delivery?: boolean
  /**
   * 起送价格
   */
  minDeliveryPrice: number
  /**
   * 配送价格
   */
  price: number
  /**
   * 店铺ID
   */
  storeId?: string
}

/**
 * 接口 [获取商品配送费用↗](https://yapi.gogpay.cn/project/2492/interface/api/189862) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getCommodityDeliveryFee`
 */
type ApiMerchantStoreGetCommodityDeliveryFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getCommodityDeliveryFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品配送费用↗](https://yapi.gogpay.cn/project/2492/interface/api/189862) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getCommodityDeliveryFee`
 */
const apiMerchantStoreGetCommodityDeliveryFeeRequestConfig: ApiMerchantStoreGetCommodityDeliveryFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getCommodityDeliveryFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetCommodityDeliveryFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品配送费用', author: '张彬' },
  }

/**
 * 接口 [获取商品配送费用↗](https://yapi.gogpay.cn/project/2492/interface/api/189862) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getCommodityDeliveryFee`
 */
export const apiMerchantStoreGetCommodityDeliveryFee = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetCommodityDeliveryFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetCommodityDeliveryFeeResponse>(
    prepare(apiMerchantStoreGetCommodityDeliveryFeeRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetCommodityDeliveryFee.requestConfig =
  apiMerchantStoreGetCommodityDeliveryFeeRequestConfig

/**
 * 接口 [【中国红】获取基地店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265791) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/baseDetail`
 */
export interface ApiMerchantStoreBaseDetailRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [【中国红】获取基地店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265791) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/baseDetail`
 */
export interface ApiMerchantStoreBaseDetailResponse {
  /**
   * 地址
   */
  address?: string
  /**
   * 推荐分类
   */
  classifyList?: {
    /**
     * 分类图标
     */
    icon?: string
    /**
     * 分类Id
     */
    id?: string
    /**
     * 分类名称
     */
    name?: string
  }[]
  /**
   * 商品区域名称
   */
  commodityAreaName?: string
  /**
   * 商品列表
   */
  commodityList?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    /**
     * 封面图
     */
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    sellPrice?: number
  }[]
  iconStyle?: {
    /**
     * 背景颜色
     */
    background?: string
    /**
     * icon图边角 circle=圆角 square=方形
     */
    iconBorder?: string
    /**
     * icon单页排数
     */
    lineCount?: number
    /**
     * icon单排个数
     */
    rowCount?: number
  }
  /**
   * 金刚区
   */
  icons?: {
    /**
     * 图标
     */
    icon?: string
    /**
     * 名称
     */
    name?: string
    /**
     * 跳转地址
     */
    url?: string
  }[]
  /**
   * 店铺Id
   */
  id?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lng?: string
  /**
   * logo
   */
  logo?: string
  /**
   * 地图图片
   */
  mapImage?: string
  /**
   * 地图跳转地址
   */
  mapUrl?: string
  /**
   * 店铺名称
   */
  name?: string
  /**
   * 营业时间
   */
  openPeriod?: string
  /**
   * 店铺相册列表
   */
  pics?: string[]
  /**
   * 评分
   */
  score?: number
  /**
   * 评价数量
   */
  scoreCount?: number
  /**
   * 店铺标签 比如 4A 5A之类的玩意儿
   */
  tags?: string[]
}

/**
 * 接口 [【中国红】获取基地店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265791) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/baseDetail`
 */
type ApiMerchantStoreBaseDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/baseDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取基地店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265791) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/baseDetail`
 */
const apiMerchantStoreBaseDetailRequestConfig: ApiMerchantStoreBaseDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/baseDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreBaseDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取基地店铺详情 ', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取基地店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265791) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/baseDetail`
 */
export const apiMerchantStoreBaseDetail = /*#__PURE__*/ (
  requestData: ApiMerchantStoreBaseDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreBaseDetailResponse>(
    prepare(apiMerchantStoreBaseDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreBaseDetail.requestConfig =
  apiMerchantStoreBaseDetailRequestConfig

/**
 * 接口 [【中国红】获取店铺介绍↗](https://yapi.gogpay.cn/project/2492/interface/api/265794) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getDesc`
 */
export interface ApiMerchantStoreGetDescRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [【中国红】获取店铺介绍↗](https://yapi.gogpay.cn/project/2492/interface/api/265794) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getDesc`
 */
export type ApiMerchantStoreGetDescResponse = string

/**
 * 接口 [【中国红】获取店铺介绍↗](https://yapi.gogpay.cn/project/2492/interface/api/265794) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getDesc`
 */
type ApiMerchantStoreGetDescRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getDesc',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取店铺介绍↗](https://yapi.gogpay.cn/project/2492/interface/api/265794) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getDesc`
 */
const apiMerchantStoreGetDescRequestConfig: ApiMerchantStoreGetDescRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getDesc',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetDesc',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取店铺介绍', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取店铺介绍↗](https://yapi.gogpay.cn/project/2492/interface/api/265794) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getDesc`
 */
export const apiMerchantStoreGetDesc = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetDescRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetDescResponse>(
    prepare(apiMerchantStoreGetDescRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetDesc.requestConfig = apiMerchantStoreGetDescRequestConfig

/**
 * 接口 [【中国红】获取店铺样式类型↗](https://yapi.gogpay.cn/project/2492/interface/api/265797) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreStyleType`
 */
export interface ApiMerchantStoreGetStoreStyleTypeRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [【中国红】获取店铺样式类型↗](https://yapi.gogpay.cn/project/2492/interface/api/265797) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreStyleType`
 */
export interface ApiMerchantStoreGetStoreStyleTypeResponse {
  /**
   * 样式类型 1机构  2基地 3酒店 4门票
   */
  styleType?: number
}

/**
 * 接口 [【中国红】获取店铺样式类型↗](https://yapi.gogpay.cn/project/2492/interface/api/265797) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreStyleType`
 */
type ApiMerchantStoreGetStoreStyleTypeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getStoreStyleType',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取店铺样式类型↗](https://yapi.gogpay.cn/project/2492/interface/api/265797) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreStyleType`
 */
const apiMerchantStoreGetStoreStyleTypeRequestConfig: ApiMerchantStoreGetStoreStyleTypeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getStoreStyleType',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetStoreStyleType',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取店铺样式类型', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取店铺样式类型↗](https://yapi.gogpay.cn/project/2492/interface/api/265797) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getStoreStyleType`
 */
export const apiMerchantStoreGetStoreStyleType = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetStoreStyleTypeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetStoreStyleTypeResponse>(
    prepare(apiMerchantStoreGetStoreStyleTypeRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetStoreStyleType.requestConfig =
  apiMerchantStoreGetStoreStyleTypeRequestConfig

/**
 * 接口 [【中国红】获取机构店铺详情↗](https://yapi.gogpay.cn/project/2492/interface/api/265800) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/orgDetail`
 */
export interface ApiMerchantStoreOrgDetailRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [【中国红】获取机构店铺详情↗](https://yapi.gogpay.cn/project/2492/interface/api/265800) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/orgDetail`
 */
export interface ApiMerchantStoreOrgDetailResponse {
  /**
   * 全部产品
   */
  all?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    /**
     * 封面图
     */
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    sellPrice?: number
  }[]
  /**
   * 产品分类
   */
  classifyList?: {
    /**
     * 分类图标
     */
    icon?: string
    /**
     * 分类Id
     */
    id?: string
    /**
     * 分类名称
     */
    name?: string
  }[]
  /**
   * 简介
   */
  desc?: string
  /**
   * 热门推荐
   */
  hot?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    /**
     * 封面图
     */
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    sellPrice?: number
  }[]
  iconStyle?: {
    /**
     * 背景颜色
     */
    background?: string
    /**
     * icon图边角 circle=圆角 square=方形
     */
    iconBorder?: string
    /**
     * icon单页排数
     */
    lineCount?: number
    /**
     * icon单排个数
     */
    rowCount?: number
  }
  /**
   * 金刚区
   */
  icons?: {
    /**
     * 图标
     */
    icon?: string
    /**
     * 名称
     */
    name?: string
    /**
     * 跳转地址
     */
    url?: string
  }[]
  /**
   * 店铺Id
   */
  id?: string
  /**
   * logo
   */
  logo?: string
  /**
   * 地图图片
   */
  mapImage?: string
  /**
   * 地图跳转地址
   */
  mapUrl?: string
  /**
   * 名称
   */
  name?: string
  /**
   * 店铺相册列表
   */
  pics?: string[]
  /**
   * 推荐店铺
   */
  recommendStores?: {
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 店铺logo
     */
    logo?: string
    /**
     * 店铺名称
     */
    name?: string
    /**
     * 样式类型 1机构 2基地
     */
    styleType?: number
  }[]
  /**
   * 评分
   */
  score?: number
}

/**
 * 接口 [【中国红】获取机构店铺详情↗](https://yapi.gogpay.cn/project/2492/interface/api/265800) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/orgDetail`
 */
type ApiMerchantStoreOrgDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/orgDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取机构店铺详情↗](https://yapi.gogpay.cn/project/2492/interface/api/265800) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/orgDetail`
 */
const apiMerchantStoreOrgDetailRequestConfig: ApiMerchantStoreOrgDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/orgDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreOrgDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取机构店铺详情', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取机构店铺详情↗](https://yapi.gogpay.cn/project/2492/interface/api/265800) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/orgDetail`
 */
export const apiMerchantStoreOrgDetail = /*#__PURE__*/ (
  requestData: ApiMerchantStoreOrgDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreOrgDetailResponse>(
    prepare(apiMerchantStoreOrgDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreOrgDetail.requestConfig = apiMerchantStoreOrgDetailRequestConfig

/**
 * 接口 [【中国红】获取店铺产品分类↗](https://yapi.gogpay.cn/project/2492/interface/api/265803) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify`
 */
export interface ApiMerchantStoreProductClassifyRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [【中国红】获取店铺产品分类↗](https://yapi.gogpay.cn/project/2492/interface/api/265803) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify`
 */
export type ApiMerchantStoreProductClassifyResponse = {
  /**
   * 分类图标
   */
  icon?: string
  /**
   * 分类Id
   */
  id?: string
  /**
   * 分类名称
   */
  name?: string
}[]

/**
 * 接口 [【中国红】获取店铺产品分类↗](https://yapi.gogpay.cn/project/2492/interface/api/265803) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify`
 */
type ApiMerchantStoreProductClassifyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/product/classify',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取店铺产品分类↗](https://yapi.gogpay.cn/project/2492/interface/api/265803) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify`
 */
const apiMerchantStoreProductClassifyRequestConfig: ApiMerchantStoreProductClassifyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/product/classify',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreProductClassify',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取店铺产品分类', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取店铺产品分类↗](https://yapi.gogpay.cn/project/2492/interface/api/265803) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify`
 */
export const apiMerchantStoreProductClassify = /*#__PURE__*/ (
  requestData: ApiMerchantStoreProductClassifyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreProductClassifyResponse>(
    prepare(apiMerchantStoreProductClassifyRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreProductClassify.requestConfig =
  apiMerchantStoreProductClassifyRequestConfig

/**
 * 接口 [【中国红】获取人气榜列表 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265809) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/rankList`
 */
export interface ApiMerchantStoreRankListRequest {}

/**
 * 接口 [【中国红】获取人气榜列表 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265809) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/rankList`
 */
export type ApiMerchantStoreRankListResponse = {
  /**
   * 店铺Id
   */
  id?: string
  /**
   * logo
   */
  logo?: string
  /**
   * 店铺名称
   */
  name?: string
  /**
   * 上榜理由
   */
  reason?: string
  /**
   * 评分
   */
  score?: number
  /**
   * 样式类型 1机构 2基地
   */
  styleType?: number
}[]

/**
 * 接口 [【中国红】获取人气榜列表 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265809) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/rankList`
 */
type ApiMerchantStoreRankListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/rankList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [【中国红】获取人气榜列表 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265809) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/rankList`
 */
const apiMerchantStoreRankListRequestConfig: ApiMerchantStoreRankListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/rankList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreRankList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取人气榜列表 ', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取人气榜列表 ↗](https://yapi.gogpay.cn/project/2492/interface/api/265809) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/rankList`
 */
export const apiMerchantStoreRankList = /*#__PURE__*/ (
  requestData?: ApiMerchantStoreRankListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreRankListResponse>(
    prepare(apiMerchantStoreRankListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreRankList.requestConfig = apiMerchantStoreRankListRequestConfig

/**
 * 接口 [【中国红】获取店铺相册↗](https://yapi.gogpay.cn/project/2492/interface/api/266967) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getAlbums`
 */
export interface ApiMerchantStoreGetAlbumsRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [【中国红】获取店铺相册↗](https://yapi.gogpay.cn/project/2492/interface/api/266967) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getAlbums`
 */
export type ApiMerchantStoreGetAlbumsResponse = string[]

/**
 * 接口 [【中国红】获取店铺相册↗](https://yapi.gogpay.cn/project/2492/interface/api/266967) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getAlbums`
 */
type ApiMerchantStoreGetAlbumsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getAlbums',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取店铺相册↗](https://yapi.gogpay.cn/project/2492/interface/api/266967) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getAlbums`
 */
const apiMerchantStoreGetAlbumsRequestConfig: ApiMerchantStoreGetAlbumsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getAlbums',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetAlbums',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取店铺相册', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取店铺相册↗](https://yapi.gogpay.cn/project/2492/interface/api/266967) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getAlbums`
 */
export const apiMerchantStoreGetAlbums = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetAlbumsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetAlbumsResponse>(
    prepare(apiMerchantStoreGetAlbumsRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetAlbums.requestConfig = apiMerchantStoreGetAlbumsRequestConfig

/**
 * 接口 [商户登录↗](https://yapi.gogpay.cn/project/2492/interface/api/267600) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/login`
 */
export interface ApiMerchantStoreLoginRequest {
  /**
   * token信息
   */
  token: string
}

/**
 * 接口 [商户登录↗](https://yapi.gogpay.cn/project/2492/interface/api/267600) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/login`
 */
export interface ApiMerchantStoreLoginResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商户登录↗](https://yapi.gogpay.cn/project/2492/interface/api/267600) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/login`
 */
type ApiMerchantStoreLoginRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/login',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户登录↗](https://yapi.gogpay.cn/project/2492/interface/api/267600) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/login`
 */
const apiMerchantStoreLoginRequestConfig: ApiMerchantStoreLoginRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/login',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreLogin',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户登录', author: '成龙' },
  }

/**
 * 接口 [商户登录↗](https://yapi.gogpay.cn/project/2492/interface/api/267600) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/login`
 */
export const apiMerchantStoreLogin = /*#__PURE__*/ (
  requestData: ApiMerchantStoreLoginRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreLoginResponse>(
    prepare(apiMerchantStoreLoginRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreLogin.requestConfig = apiMerchantStoreLoginRequestConfig

/**
 * 接口 [【中国红】根据分类获取推荐店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/267804) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify/storeList`
 */
export interface ApiMerchantStoreProductClassifyStoreListRequest {
  /**
   * 分类Id
   */
  classifyId: string
  clientType?: '1' | '2'
  headerChannel?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺Id
   */
  storeId: string
}

/**
 * 接口 [【中国红】根据分类获取推荐店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/267804) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify/storeList`
 */
export interface ApiMerchantStoreProductClassifyStoreListResponse {
  /**
   * 数据列表
   */
  list?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    /**
     * 封面图
     */
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    sellPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [【中国红】根据分类获取推荐店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/267804) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify/storeList`
 */
type ApiMerchantStoreProductClassifyStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/product/classify/storeList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】根据分类获取推荐店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/267804) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify/storeList`
 */
const apiMerchantStoreProductClassifyStoreListRequestConfig: ApiMerchantStoreProductClassifyStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/product/classify/storeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreProductClassifyStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】根据分类获取推荐店铺列表', author: '成龙' },
  }

/**
 * 接口 [【中国红】根据分类获取推荐店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/267804) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/product/classify/storeList`
 */
export const apiMerchantStoreProductClassifyStoreList = /*#__PURE__*/ (
  requestData: ApiMerchantStoreProductClassifyStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreProductClassifyStoreListResponse>(
    prepare(apiMerchantStoreProductClassifyStoreListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreProductClassifyStoreList.requestConfig =
  apiMerchantStoreProductClassifyStoreListRequestConfig

/**
 * 接口 [获取用户的店铺信息↗](https://yapi.gogpay.cn/project/2492/interface/api/268182) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getUserStoreInfo`
 */
export interface ApiMerchantStoreGetUserStoreInfoRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [获取用户的店铺信息↗](https://yapi.gogpay.cn/project/2492/interface/api/268182) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getUserStoreInfo`
 */
export interface ApiMerchantStoreGetUserStoreInfoResponse {
  /**
   * 图片
   */
  logo?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 店铺Id
   */
  storeId?: string
  /**
   * 店铺名称
   */
  storeName?: string
}

/**
 * 接口 [获取用户的店铺信息↗](https://yapi.gogpay.cn/project/2492/interface/api/268182) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getUserStoreInfo`
 */
type ApiMerchantStoreGetUserStoreInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getUserStoreInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户的店铺信息↗](https://yapi.gogpay.cn/project/2492/interface/api/268182) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getUserStoreInfo`
 */
const apiMerchantStoreGetUserStoreInfoRequestConfig: ApiMerchantStoreGetUserStoreInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getUserStoreInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetUserStoreInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户的店铺信息', author: '成龙' },
  }

/**
 * 接口 [获取用户的店铺信息↗](https://yapi.gogpay.cn/project/2492/interface/api/268182) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getUserStoreInfo`
 */
export const apiMerchantStoreGetUserStoreInfo = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetUserStoreInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetUserStoreInfoResponse>(
    prepare(apiMerchantStoreGetUserStoreInfoRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetUserStoreInfo.requestConfig =
  apiMerchantStoreGetUserStoreInfoRequestConfig

/**
 * 接口 [获取核销店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/271242) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getWroteOffStoreList`
 */
export interface ApiMerchantStoreGetWroteOffStoreListRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [获取核销店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/271242) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getWroteOffStoreList`
 */
export type ApiMerchantStoreGetWroteOffStoreListResponse = {
  /**
   * 店铺联系电话
   */
  contactPhone: string
  /**
   * 店铺纬度
   */
  latitude: number
  /**
   * 店铺经度
   */
  longitude: number
  /**
   * 是否是主店
   */
  masterStore?: boolean
  /**
   * 店铺地址
   */
  storeAddress: string
  /**
   * 店铺Id
   */
  storeId?: string
  /**
   * 店铺名称
   */
  storeName?: string
}[]

/**
 * 接口 [获取核销店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/271242) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getWroteOffStoreList`
 */
type ApiMerchantStoreGetWroteOffStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/getWroteOffStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取核销店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/271242) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getWroteOffStoreList`
 */
const apiMerchantStoreGetWroteOffStoreListRequestConfig: ApiMerchantStoreGetWroteOffStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/getWroteOffStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreGetWroteOffStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取核销店铺列表', author: '成龙' },
  }

/**
 * 接口 [获取核销店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/271242) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/getWroteOffStoreList`
 */
export const apiMerchantStoreGetWroteOffStoreList = /*#__PURE__*/ (
  requestData: ApiMerchantStoreGetWroteOffStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreGetWroteOffStoreListResponse>(
    prepare(apiMerchantStoreGetWroteOffStoreListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreGetWroteOffStoreList.requestConfig =
  apiMerchantStoreGetWroteOffStoreListRequestConfig

/**
 * 接口 [【中国红】获取酒店店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312098) 的 **请求类型**
 *
 * @作者 514号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/hotelDetail`
 */
export interface ApiMerchantStoreHotelDetailRequest {
  id?: string
  /**
   * 店铺ID
   */
  storeId: string
  /**
   * 库存开始日期
   */
  stockDateStart?: string
  /**
   * 库存结束日期
   */
  stockDateEnd?: string
}

/**
 * 接口 [【中国红】获取酒店店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312098) 的 **返回类型**
 *
 * @作者 514号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/hotelDetail`
 */
export interface ApiMerchantStoreHotelDetailResponse {
  /**
   * 地址
   */
  address?: string
  /**
   * 推荐分类
   */
  classifyList?: {
    /**
     * 分类图标
     */
    icon?: string
    /**
     * 分类Id
     */
    id?: string
    /**
     * 分类名称
     */
    name?: string
  }[]
  /**
   * 商品区域名称
   */
  commodityAreaName?: string
  /**
   * 商品列表
   */
  commodityList?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    /**
     * 封面图
     */
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    sellPrice?: number
  }[]
  iconStyle?: {
    /**
     * 背景颜色
     */
    background?: string
    /**
     * icon图边角 circle=圆角 square=方形
     */
    iconBorder?: string
    /**
     * icon单页排数
     */
    lineCount?: number
    /**
     * icon单排个数
     */
    rowCount?: number
  }
  /**
   * 金刚区
   */
  icons?: {
    /**
     * 图标
     */
    icon?: string
    /**
     * 名称
     */
    name?: string
    /**
     * 跳转地址
     */
    url?: string
  }[]
  /**
   * 店铺Id
   */
  id?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lng?: string
  /**
   * logo
   */
  logo?: string
  /**
   * 地图图片
   */
  mapImage?: string
  /**
   * 地图跳转地址
   */
  mapUrl?: string
  /**
   * 店铺名称
   */
  name?: string
  /**
   * 营业时间
   */
  openPeriod?: string
  /**
   * 店铺相册列表
   */
  pics?: string[]
  /**
   * 评分
   */
  score?: number
  /**
   * 评价数量
   */
  scoreCount?: number
  /**
   * 店铺标签 比如 4A 5A之类的玩意儿
   */
  tags?: string[]
}

/**
 * 接口 [【中国红】获取酒店店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312098) 的 **请求配置的类型**
 *
 * @作者 514号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/hotelDetail`
 */
type ApiMerchantStoreHotelDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/hotelDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取酒店店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312098) 的 **请求配置**
 *
 * @作者 514号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/hotelDetail`
 */
const apiMerchantStoreHotelDetailRequestConfig: ApiMerchantStoreHotelDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/hotelDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreHotelDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取酒店店铺详情 ', author: '514号开发' },
  }

/**
 * 接口 [【中国红】获取酒店店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312098) 的 **请求函数**
 *
 * @作者 514号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/hotelDetail`
 */
export const apiMerchantStoreHotelDetail = /*#__PURE__*/ (
  requestData: ApiMerchantStoreHotelDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreHotelDetailResponse>(
    prepare(apiMerchantStoreHotelDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreHotelDetail.requestConfig =
  apiMerchantStoreHotelDetailRequestConfig

/**
 * 接口 [【中国红】获取门票店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312482) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/ticketDetail`
 */
export interface ApiMerchantStoreTicketDetailRequest {
  id?: string
  /**
   * 店铺ID
   */
  storeId: string
  /**
   * 库存开始日期
   */
  stockDateStart?: string
  /**
   * 库存结束日期
   */
  stockDateEnd?: string
}

/**
 * 接口 [【中国红】获取门票店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312482) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/ticketDetail`
 */
export interface ApiMerchantStoreTicketDetailResponse {
  /**
   * 地址
   */
  address?: string
  /**
   * 推荐分类
   */
  classifyList?: {
    /**
     * 分类图标
     */
    icon?: string
    /**
     * 分类Id
     */
    id?: string
    /**
     * 分类名称
     */
    name?: string
  }[]
  /**
   * 商品区域名称
   */
  commodityAreaName?: string
  /**
   * 商品列表
   */
  commodityList?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    /**
     * 封面图
     */
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    sellPrice?: number
  }[]
  iconStyle?: {
    /**
     * 背景颜色
     */
    background?: string
    /**
     * icon图边角 circle=圆角 square=方形
     */
    iconBorder?: string
    /**
     * icon单页排数
     */
    lineCount?: number
    /**
     * icon单排个数
     */
    rowCount?: number
  }
  /**
   * 金刚区
   */
  icons?: {
    /**
     * 图标
     */
    icon?: string
    /**
     * 名称
     */
    name?: string
    /**
     * 跳转地址
     */
    url?: string
  }[]
  /**
   * 店铺Id
   */
  id?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lng?: string
  /**
   * logo
   */
  logo?: string
  /**
   * 地图图片
   */
  mapImage?: string
  /**
   * 地图跳转地址
   */
  mapUrl?: string
  /**
   * 店铺名称
   */
  name?: string
  /**
   * 营业时间
   */
  openPeriod?: string
  /**
   * 店铺相册列表
   */
  pics?: string[]
  /**
   * 评分
   */
  score?: number
  /**
   * 评价数量
   */
  scoreCount?: number
  /**
   * 店铺标签 比如 4A 5A之类的玩意儿
   */
  tags?: string[]
}

/**
 * 接口 [【中国红】获取门票店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312482) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/ticketDetail`
 */
type ApiMerchantStoreTicketDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/ticketDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】获取门票店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312482) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/ticketDetail`
 */
const apiMerchantStoreTicketDetailRequestConfig: ApiMerchantStoreTicketDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/ticketDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreTicketDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】获取门票店铺详情 ', author: '成龙' },
  }

/**
 * 接口 [【中国红】获取门票店铺详情 ↗](https://yapi.gogpay.cn/project/2492/interface/api/312482) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/ticketDetail`
 */
export const apiMerchantStoreTicketDetail = /*#__PURE__*/ (
  requestData: ApiMerchantStoreTicketDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreTicketDetailResponse>(
    prepare(apiMerchantStoreTicketDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreTicketDetail.requestConfig =
  apiMerchantStoreTicketDetailRequestConfig

/**
 * 接口 [搜索查询核销门店列表↗](https://yapi.gogpay.cn/project/2492/interface/api/348394) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/queryWriteOffStoreList`
 */
export interface ApiMerchantStoreQueryWriteOffStoreListRequest {
  /**
   * 城市编码
   */
  cityCode?: string
  /**
   * 区县编码
   */
  countyCode?: string
  /**
   * 关键词(门店地址或门店名称)
   */
  keyWord?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省份编码
   */
  provinceCode?: string
  /**
   * 标销店铺ID
   */
  refMerchantId: string
}

/**
 * 接口 [搜索查询核销门店列表↗](https://yapi.gogpay.cn/project/2492/interface/api/348394) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/queryWriteOffStoreList`
 */
export interface ApiMerchantStoreQueryWriteOffStoreListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 是否是主店
     */
    masterStore?: boolean
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [搜索查询核销门店列表↗](https://yapi.gogpay.cn/project/2492/interface/api/348394) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/queryWriteOffStoreList`
 */
type ApiMerchantStoreQueryWriteOffStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/queryWriteOffStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [搜索查询核销门店列表↗](https://yapi.gogpay.cn/project/2492/interface/api/348394) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/queryWriteOffStoreList`
 */
const apiMerchantStoreQueryWriteOffStoreListRequestConfig: ApiMerchantStoreQueryWriteOffStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_3,
    devUrl: devUrl_0_22_0_3,
    prodUrl: prodUrl_0_22_0_3,
    path: '/merchant/api/store/queryWriteOffStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreQueryWriteOffStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '搜索查询核销门店列表', author: '333号开发' },
  }

/**
 * 接口 [搜索查询核销门店列表↗](https://yapi.gogpay.cn/project/2492/interface/api/348394) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [客户端-店铺请求相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33537)
 * @请求头 `POST /merchant/api/store/queryWriteOffStoreList`
 */
export const apiMerchantStoreQueryWriteOffStoreList = /*#__PURE__*/ (
  requestData: ApiMerchantStoreQueryWriteOffStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreQueryWriteOffStoreListResponse>(
    prepare(apiMerchantStoreQueryWriteOffStoreListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreQueryWriteOffStoreList.requestConfig =
  apiMerchantStoreQueryWriteOffStoreListRequestConfig

const mockUrl_0_22_0_18 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_18 = '' as any
const prodUrl_0_22_0_18 = '' as any
const dataKey_0_22_0_18 = 'data' as any

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189850) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/addOrUpdate`
 */
export interface ApiMerchantDeliveryUserAddOrUpdateRequest {
  /**
   * ID
   */
  id?: string
  /**
   * 配送人员名称
   */
  userName?: string
  /**
   * 配送人员电话
   */
  userPhone?: string
  /**
   * 店铺ID
   */
  storeId?: string
}

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189850) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/addOrUpdate`
 */
export type ApiMerchantDeliveryUserAddOrUpdateResponse = string

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189850) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/addOrUpdate`
 */
type ApiMerchantDeliveryUserAddOrUpdateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/deliveryUser/addOrUpdate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189850) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/addOrUpdate`
 */
const apiMerchantDeliveryUserAddOrUpdateRequestConfig: ApiMerchantDeliveryUserAddOrUpdateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_18,
    devUrl: devUrl_0_22_0_18,
    prodUrl: prodUrl_0_22_0_18,
    path: '/merchant/api/deliveryUser/addOrUpdate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantDeliveryUserAddOrUpdate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增或更新配送人员', author: '张彬' },
  }

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189850) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/addOrUpdate`
 */
export const apiMerchantDeliveryUserAddOrUpdate = /*#__PURE__*/ (
  requestData: ApiMerchantDeliveryUserAddOrUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantDeliveryUserAddOrUpdateResponse>(
    prepare(apiMerchantDeliveryUserAddOrUpdateRequestConfig, requestData),
    ...args,
  )
}

apiMerchantDeliveryUserAddOrUpdate.requestConfig =
  apiMerchantDeliveryUserAddOrUpdateRequestConfig

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189854) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/delete`
 */
export interface ApiMerchantDeliveryUserDeleteRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189854) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/delete`
 */
export type ApiMerchantDeliveryUserDeleteResponse = string

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189854) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/delete`
 */
type ApiMerchantDeliveryUserDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/deliveryUser/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189854) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/delete`
 */
const apiMerchantDeliveryUserDeleteRequestConfig: ApiMerchantDeliveryUserDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_18,
    devUrl: devUrl_0_22_0_18,
    prodUrl: prodUrl_0_22_0_18,
    path: '/merchant/api/deliveryUser/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantDeliveryUserDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除店铺配送人员', author: '张彬' },
  }

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189854) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/delete`
 */
export const apiMerchantDeliveryUserDelete = /*#__PURE__*/ (
  requestData: ApiMerchantDeliveryUserDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantDeliveryUserDeleteResponse>(
    prepare(apiMerchantDeliveryUserDeleteRequestConfig, requestData),
    ...args,
  )
}

apiMerchantDeliveryUserDelete.requestConfig =
  apiMerchantDeliveryUserDeleteRequestConfig

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189858) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/list`
 */
export interface ApiMerchantDeliveryUserListRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189858) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/list`
 */
export type ApiMerchantDeliveryUserListResponse = {
  /**
   * ID
   */
  id?: string
  /**
   * 配送人员名称
   */
  userName?: string
  /**
   * 配送人员电话
   */
  userPhone?: string
  /**
   * 店铺ID
   */
  storeId?: string
}[]

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189858) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/list`
 */
type ApiMerchantDeliveryUserListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/deliveryUser/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189858) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/list`
 */
const apiMerchantDeliveryUserListRequestConfig: ApiMerchantDeliveryUserListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_18,
    devUrl: devUrl_0_22_0_18,
    prodUrl: prodUrl_0_22_0_18,
    path: '/merchant/api/deliveryUser/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantDeliveryUserList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺配送人员', author: '张彬' },
  }

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/2492/interface/api/189858) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-配送人员的相关接口(带缓存)↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_33888)
 * @请求头 `POST /merchant/api/deliveryUser/list`
 */
export const apiMerchantDeliveryUserList = /*#__PURE__*/ (
  requestData: ApiMerchantDeliveryUserListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantDeliveryUserListResponse>(
    prepare(apiMerchantDeliveryUserListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantDeliveryUserList.requestConfig =
  apiMerchantDeliveryUserListRequestConfig

const mockUrl_0_22_0_20 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_20 = '' as any
const prodUrl_0_22_0_20 = '' as any
const dataKey_0_22_0_20 = 'data' as any

/**
 * 接口 [获取分组商品列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189866) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/commodityList`
 */
export interface ApiMerchantStoreCommodityGroupCommodityListRequest {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 分组ID
   */
  groupId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取分组商品列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189866) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/commodityList`
 */
export type ApiMerchantStoreCommodityGroupCommodityListResponse = {
  /**
   * 起售数量
   */
  beginSaleQuantity: number
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 封面标签
   */
  coverLabel?: string
  /**
   * 商品封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  multipleSku?: boolean
  /**
   * 销量
   */
  sales?: string
  /**
   * 商品售价
   */
  sellPrice?: number
  /**
   * 规格信息
   */
  skuList?: {
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 划线价格
     */
    dashPrice: number
    /**
     * 默认展示规格
     */
    defaultShow: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * 规格图片
     */
    skuPic: string
    /**
     * 规格价格
     */
    skuPrice: number
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * 规格状态:0-停售 1-正常
     */
    skuStatus: number
    /**
     * 剩余库存
     */
    surplusStock: number
    /**
     * 重量
     */
    weight: number
  }[]
  /**
   * 店铺ID
   */
  storeId: string
  /**
   * 剩余库存
   */
  surplusStock: number
}[]

/**
 * 接口 [获取分组商品列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189866) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/commodityList`
 */
type ApiMerchantStoreCommodityGroupCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/storeCommodityGroup/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取分组商品列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189866) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/commodityList`
 */
const apiMerchantStoreCommodityGroupCommodityListRequestConfig: ApiMerchantStoreCommodityGroupCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_20,
    devUrl: devUrl_0_22_0_20,
    prodUrl: prodUrl_0_22_0_20,
    path: '/merchant/api/storeCommodityGroup/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreCommodityGroupCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取分组商品列表', author: '张彬' },
  }

/**
 * 接口 [获取分组商品列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189866) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/commodityList`
 */
export const apiMerchantStoreCommodityGroupCommodityList = /*#__PURE__*/ (
  requestData: ApiMerchantStoreCommodityGroupCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreCommodityGroupCommodityListResponse>(
    prepare(
      apiMerchantStoreCommodityGroupCommodityListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantStoreCommodityGroupCommodityList.requestConfig =
  apiMerchantStoreCommodityGroupCommodityListRequestConfig

/**
 * 接口 [获取分组列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189870) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/list`
 */
export interface ApiMerchantStoreCommodityGroupListRequest {
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [获取分组列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189870) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/list`
 */
export type ApiMerchantStoreCommodityGroupListResponse = {
  /**
   * 商品分组标题
   */
  commodityGroupTitle: string
  /**
   * 商品列表
   */
  commodityList: {
    /**
     * 起售数量
     */
    beginSaleQuantity: number
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品标签
     */
    commodityLabel?: string[]
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 封面标签
     */
    coverLabel?: string
    /**
     * 商品封面图
     */
    coverPic?: string
    /**
     * 划线价格
     */
    dashPrice?: number
    multipleSku?: boolean
    /**
     * 销量
     */
    sales?: string
    /**
     * 商品售价
     */
    sellPrice?: number
    /**
     * 规格信息
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 划线价格
       */
      dashPrice: number
      /**
       * 默认展示规格
       */
      defaultShow: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * 规格图片
       */
      skuPic: string
      /**
       * 规格价格
       */
      skuPrice: number
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * 规格状态:0-停售 1-正常
       */
      skuStatus: number
      /**
       * 剩余库存
       */
      surplusStock: number
      /**
       * 重量
       */
      weight: number
    }[]
    /**
     * 店铺ID
     */
    storeId: string
    /**
     * 剩余库存
     */
    surplusStock: number
  }[]
  /**
   * 商品分组ID
   */
  id: string
  /**
   * 排序
   */
  sortNo: number
  /**
   * 店铺ID
   */
  storeId: string
}[]

/**
 * 接口 [获取分组列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189870) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/list`
 */
type ApiMerchantStoreCommodityGroupListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/storeCommodityGroup/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取分组列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189870) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/list`
 */
const apiMerchantStoreCommodityGroupListRequestConfig: ApiMerchantStoreCommodityGroupListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_20,
    devUrl: devUrl_0_22_0_20,
    prodUrl: prodUrl_0_22_0_20,
    path: '/merchant/api/storeCommodityGroup/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreCommodityGroupList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取分组列表', author: '张彬' },
  }

/**
 * 接口 [获取分组列表↗](https://yapi.gogpay.cn/project/2492/interface/api/189870) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/list`
 */
export const apiMerchantStoreCommodityGroupList = /*#__PURE__*/ (
  requestData: ApiMerchantStoreCommodityGroupListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreCommodityGroupListResponse>(
    prepare(apiMerchantStoreCommodityGroupListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreCommodityGroupList.requestConfig =
  apiMerchantStoreCommodityGroupListRequestConfig

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/318154) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/search/keyword`
 */
export interface ApiMerchantStoreCommodityGroupSearchKeywordRequest {}

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/318154) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/search/keyword`
 */
export interface ApiMerchantStoreCommodityGroupSearchKeywordResponse {
  /**
   * 数据列表
   */
  list?: {
    distance?: number
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    merchantName?: string
    pic?: string
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    sales?: number
    sellPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/318154) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/search/keyword`
 */
type ApiMerchantStoreCommodityGroupSearchKeywordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/storeCommodityGroup/search/keyword',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/318154) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/search/keyword`
 */
const apiMerchantStoreCommodityGroupSearchKeywordRequestConfig: ApiMerchantStoreCommodityGroupSearchKeywordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_20,
    devUrl: devUrl_0_22_0_20,
    prodUrl: prodUrl_0_22_0_20,
    path: '/merchant/api/storeCommodityGroup/search/keyword',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreCommodityGroupSearchKeyword',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺关键词搜索', author: '成龙' },
  }

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/318154) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺商品分组↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34002)
 * @请求头 `POST /merchant/api/storeCommodityGroup/search/keyword`
 */
export const apiMerchantStoreCommodityGroupSearchKeyword = /*#__PURE__*/ (
  requestData?: ApiMerchantStoreCommodityGroupSearchKeywordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreCommodityGroupSearchKeywordResponse>(
    prepare(
      apiMerchantStoreCommodityGroupSearchKeywordRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantStoreCommodityGroupSearchKeyword.requestConfig =
  apiMerchantStoreCommodityGroupSearchKeywordRequestConfig

const mockUrl_0_22_0_25 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_25 = '' as any
const prodUrl_0_22_0_25 = '' as any
const dataKey_0_22_0_25 = 'data' as any

/**
 * 接口 [营业执照OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197374) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/businessLicense`
 */
export interface ApiMerchantOpenapiBaiduocrBusinessLicenseRequest {}

/**
 * 接口 [营业执照OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197374) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/businessLicense`
 */
export interface ApiMerchantOpenapiBaiduocrBusinessLicenseResponse {}

/**
 * 接口 [营业执照OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197374) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/businessLicense`
 */
type ApiMerchantOpenapiBaiduocrBusinessLicenseRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/openapi/baiduocr/businessLicense',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [营业执照OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197374) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/businessLicense`
 */
const apiMerchantOpenapiBaiduocrBusinessLicenseRequestConfig: ApiMerchantOpenapiBaiduocrBusinessLicenseRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_25,
    devUrl: devUrl_0_22_0_25,
    prodUrl: prodUrl_0_22_0_25,
    path: '/merchant/openapi/baiduocr/businessLicense',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantOpenapiBaiduocrBusinessLicense',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '营业执照OCR读取', author: '张彬' },
  }

/**
 * 接口 [营业执照OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197374) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/businessLicense`
 */
export const apiMerchantOpenapiBaiduocrBusinessLicense = /*#__PURE__*/ (
  requestData?: ApiMerchantOpenapiBaiduocrBusinessLicenseRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantOpenapiBaiduocrBusinessLicenseResponse>(
    prepare(
      apiMerchantOpenapiBaiduocrBusinessLicenseRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantOpenapiBaiduocrBusinessLicense.requestConfig =
  apiMerchantOpenapiBaiduocrBusinessLicenseRequestConfig

/**
 * 接口 [身份证OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197378) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/idCard`
 */
export interface ApiMerchantOpenapiBaiduocrIdCardRequest {}

/**
 * 接口 [身份证OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197378) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/idCard`
 */
export interface ApiMerchantOpenapiBaiduocrIdCardResponse {}

/**
 * 接口 [身份证OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197378) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/idCard`
 */
type ApiMerchantOpenapiBaiduocrIdCardRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/openapi/baiduocr/idCard',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [身份证OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197378) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/idCard`
 */
const apiMerchantOpenapiBaiduocrIdCardRequestConfig: ApiMerchantOpenapiBaiduocrIdCardRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_25,
    devUrl: devUrl_0_22_0_25,
    prodUrl: prodUrl_0_22_0_25,
    path: '/merchant/openapi/baiduocr/idCard',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantOpenapiBaiduocrIdCard',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '身份证OCR读取', author: '张彬' },
  }

/**
 * 接口 [身份证OCR读取↗](https://yapi.gogpay.cn/project/2492/interface/api/197378) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [ocr-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_34866)
 * @请求头 `POST /merchant/openapi/baiduocr/idCard`
 */
export const apiMerchantOpenapiBaiduocrIdCard = /*#__PURE__*/ (
  requestData?: ApiMerchantOpenapiBaiduocrIdCardRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantOpenapiBaiduocrIdCardResponse>(
    prepare(apiMerchantOpenapiBaiduocrIdCardRequestConfig, requestData),
    ...args,
  )
}

apiMerchantOpenapiBaiduocrIdCard.requestConfig =
  apiMerchantOpenapiBaiduocrIdCardRequestConfig

const mockUrl_0_22_0_27 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_27 = '' as any
const prodUrl_0_22_0_27 = '' as any
const dataKey_0_22_0_27 = 'data' as any

/**
 * 接口 [获取店铺分类数据↗](https://yapi.gogpay.cn/project/2492/interface/api/222694) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺分类↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_38748)
 * @请求头 `POST /merchant/api/storeClassify/getList`
 */
export interface ApiMerchantStoreClassifyGetListRequest {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 分类ID
   */
  classifyId?: string
  /**
   * 分类名称
   */
  classifyName?: string
}

/**
 * 接口 [获取店铺分类数据↗](https://yapi.gogpay.cn/project/2492/interface/api/222694) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺分类↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_38748)
 * @请求头 `POST /merchant/api/storeClassify/getList`
 */
export type ApiMerchantStoreClassifyGetListResponse = {
  /**
   * 分类ID
   */
  id?: string
  /**
   * 分类名称
   */
  classifyName?: string
  /**
   * 分类层级
   */
  classifyLevel?: number
  /**
   * 父级分类ID
   */
  parentId?: string
  /**
   * 店铺数量
   */
  storeCount?: number
  /**
   * 所属运营渠道Id
   */
  businessChannelId?: string
  /**
   * 所属运营渠道名称
   */
  businessChannelName?: string
  /**
   * 更新人
   */
  updateBy?: string
  /**
   * 最近更新时间
   */
  updateTime?: string
  /**
   * 是否有子级
   */
  hasChildren?: boolean
  /**
   * 子节点数据
   */
  childList?: unknown[]
}[]

/**
 * 接口 [获取店铺分类数据↗](https://yapi.gogpay.cn/project/2492/interface/api/222694) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-店铺分类↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_38748)
 * @请求头 `POST /merchant/api/storeClassify/getList`
 */
type ApiMerchantStoreClassifyGetListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/storeClassify/getList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺分类数据↗](https://yapi.gogpay.cn/project/2492/interface/api/222694) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-店铺分类↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_38748)
 * @请求头 `POST /merchant/api/storeClassify/getList`
 */
const apiMerchantStoreClassifyGetListRequestConfig: ApiMerchantStoreClassifyGetListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_27,
    devUrl: devUrl_0_22_0_27,
    prodUrl: prodUrl_0_22_0_27,
    path: '/merchant/api/storeClassify/getList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreClassifyGetList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺分类数据', author: '成龙' },
  }

/**
 * 接口 [获取店铺分类数据↗](https://yapi.gogpay.cn/project/2492/interface/api/222694) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-店铺分类↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_38748)
 * @请求头 `POST /merchant/api/storeClassify/getList`
 */
export const apiMerchantStoreClassifyGetList = /*#__PURE__*/ (
  requestData: ApiMerchantStoreClassifyGetListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreClassifyGetListResponse>(
    prepare(apiMerchantStoreClassifyGetListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreClassifyGetList.requestConfig =
  apiMerchantStoreClassifyGetListRequestConfig

const mockUrl_0_22_0_28 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_28 = '' as any
const prodUrl_0_22_0_28 = '' as any
const dataKey_0_22_0_28 = 'data' as any

/**
 * 接口 [获取运营渠道配置↗](https://yapi.gogpay.cn/project/2492/interface/api/235694) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-运营渠道↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_40165)
 * @请求头 `POST /merchant/api/businessChannel/detail`
 */
export interface ApiMerchantBusinessChannelDetailRequest {
  /**
   * 渠道ID
   */
  channelId: number
}

/**
 * 接口 [获取运营渠道配置↗](https://yapi.gogpay.cn/project/2492/interface/api/235694) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-运营渠道↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_40165)
 * @请求头 `POST /merchant/api/businessChannel/detail`
 */
export interface ApiMerchantBusinessChannelDetailResponse {
  /**
   * 是否显示多彩宝资源数据 0不显示 1显示
   */
  isShowDcbResource?: number
  /**
   * 是否显示底部tab
   */
  isShowTab?: number
  /**
   * 运营渠道跳转路由
   */
  jumpRoute?: string
  /**
   * 显示的订单分类  格式为 mall=多多商城订单 writeOff=周边游订单  deliver=同城配送订单  group=拼团订单
   */
  showOrderClassify?: {}[]
}

/**
 * 接口 [获取运营渠道配置↗](https://yapi.gogpay.cn/project/2492/interface/api/235694) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [客户端-运营渠道↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_40165)
 * @请求头 `POST /merchant/api/businessChannel/detail`
 */
type ApiMerchantBusinessChannelDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/businessChannel/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取运营渠道配置↗](https://yapi.gogpay.cn/project/2492/interface/api/235694) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [客户端-运营渠道↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_40165)
 * @请求头 `POST /merchant/api/businessChannel/detail`
 */
const apiMerchantBusinessChannelDetailRequestConfig: ApiMerchantBusinessChannelDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_28,
    devUrl: devUrl_0_22_0_28,
    prodUrl: prodUrl_0_22_0_28,
    path: '/merchant/api/businessChannel/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantBusinessChannelDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取运营渠道配置', author: '李诗凡' },
  }

/**
 * 接口 [获取运营渠道配置↗](https://yapi.gogpay.cn/project/2492/interface/api/235694) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [客户端-运营渠道↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_40165)
 * @请求头 `POST /merchant/api/businessChannel/detail`
 */
export const apiMerchantBusinessChannelDetail = /*#__PURE__*/ (
  requestData: ApiMerchantBusinessChannelDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantBusinessChannelDetailResponse>(
    prepare(apiMerchantBusinessChannelDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantBusinessChannelDetail.requestConfig =
  apiMerchantBusinessChannelDetailRequestConfig

const mockUrl_0_22_0_30 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_30 = '' as any
const prodUrl_0_22_0_30 = '' as any
const dataKey_0_22_0_30 = 'data' as any

/**
 * 接口 [预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/267597) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】店铺预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_46604)
 * @请求头 `POST /merchant/api/store/booking/upload`
 */
export interface ApiMerchantStoreBookingUploadRequest {
  /**
   * 预约日期
   */
  bookingDate?: string
  /**
   * 预约人身份证
   */
  idCard?: string
  /**
   * 预约人
   */
  name?: string
  /**
   * 预约人联系电话
   */
  phone?: string
  /**
   * 预约景区名称
   */
  scenicSpotName?: string
  /**
   * 店铺ID(和子机构编号二选一必填)
   */
  storeId?: string
  /**
   * 子机构编号(和店铺ID二选一必填)
   */
  unitOrgCode?: string
}

/**
 * 接口 [预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/267597) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】店铺预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_46604)
 * @请求头 `POST /merchant/api/store/booking/upload`
 */
export interface ApiMerchantStoreBookingUploadResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/267597) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】店铺预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_46604)
 * @请求头 `POST /merchant/api/store/booking/upload`
 */
type ApiMerchantStoreBookingUploadRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/store/booking/upload',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/267597) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】店铺预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_46604)
 * @请求头 `POST /merchant/api/store/booking/upload`
 */
const apiMerchantStoreBookingUploadRequestConfig: ApiMerchantStoreBookingUploadRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_30,
    devUrl: devUrl_0_22_0_30,
    prodUrl: prodUrl_0_22_0_30,
    path: '/merchant/api/store/booking/upload',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreBookingUpload',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '预约上传信息', author: '成龙' },
  }

/**
 * 接口 [预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/267597) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】店铺预约上传信息↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_46604)
 * @请求头 `POST /merchant/api/store/booking/upload`
 */
export const apiMerchantStoreBookingUpload = /*#__PURE__*/ (
  requestData: ApiMerchantStoreBookingUploadRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreBookingUploadResponse>(
    prepare(apiMerchantStoreBookingUploadRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreBookingUpload.requestConfig =
  apiMerchantStoreBookingUploadRequestConfig

const mockUrl_0_22_0_35 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_35 = '' as any
const prodUrl_0_22_0_35 = '' as any
const dataKey_0_22_0_35 = 'data' as any

/**
 * 接口 [获取店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312466) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/getStoreStyleConfig`
 */
export interface ApiMerchantImsApiStoreGetStoreStyleConfigRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [获取店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312466) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/getStoreStyleConfig`
 */
export interface ApiMerchantImsApiStoreGetStoreStyleConfigResponse {
  iconConfig?: {
    /**
     * 数据配置
     */
    data?: {
      /**
       * 图片
       */
      image?: string
      /**
       * 路由Id
       */
      routerId?: string
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * icon名称
       */
      title?: string
    }[]
    style?: {
      /**
       * 背景颜色
       */
      background?: string
      /**
       * icon图边角 circle=圆角 square=方形
       */
      iconBorder?: string
      /**
       * icon单页排数
       */
      lineCount?: number
      /**
       * icon单排个数
       */
      rowCount?: number
    }
  }
  /**
   * 店铺Id
   */
  id: string
  mapConfig?: {
    /**
     * 图片
     */
    image?: string
    /**
     * 路由Id
     */
    routerId?: string
  }
}

/**
 * 接口 [获取店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312466) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/getStoreStyleConfig`
 */
type ApiMerchantImsApiStoreGetStoreStyleConfigRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/store/getStoreStyleConfig',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312466) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/getStoreStyleConfig`
 */
const apiMerchantImsApiStoreGetStoreStyleConfigRequestConfig: ApiMerchantImsApiStoreGetStoreStyleConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_35,
    devUrl: devUrl_0_22_0_35,
    prodUrl: prodUrl_0_22_0_35,
    path: '/merchant/imsApi/store/getStoreStyleConfig',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStoreGetStoreStyleConfig',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺样式配置', author: '成龙' },
  }

/**
 * 接口 [获取店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312466) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/getStoreStyleConfig`
 */
export const apiMerchantImsApiStoreGetStoreStyleConfig = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStoreGetStoreStyleConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStoreGetStoreStyleConfigResponse>(
    prepare(
      apiMerchantImsApiStoreGetStoreStyleConfigRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantImsApiStoreGetStoreStyleConfig.requestConfig =
  apiMerchantImsApiStoreGetStoreStyleConfigRequestConfig

/**
 * 接口 [保存店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312474) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/saveStoreStyleConfig`
 */
export interface ApiMerchantImsApiStoreSaveStoreStyleConfigRequest {
  iconConfig?: {
    /**
     * 数据配置
     */
    data?: {
      /**
       * 图片
       */
      image?: string
      /**
       * 路由Id
       */
      routerId?: string
      /**
       * 排序号
       */
      sortNo?: number
      /**
       * icon名称
       */
      title?: string
    }[]
    style?: {
      /**
       * 背景颜色
       */
      background?: string
      /**
       * icon图边角 circle=圆角 square=方形
       */
      iconBorder?: string
      /**
       * icon单页排数
       */
      lineCount?: number
      /**
       * icon单排个数
       */
      rowCount?: number
    }
  }
  /**
   * 店铺Id
   */
  id: string
  mapConfig?: {
    /**
     * 图片
     */
    image?: string
    /**
     * 路由Id
     */
    routerId?: string
  }
}

/**
 * 接口 [保存店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312474) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/saveStoreStyleConfig`
 */
export interface ApiMerchantImsApiStoreSaveStoreStyleConfigResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [保存店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312474) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/saveStoreStyleConfig`
 */
type ApiMerchantImsApiStoreSaveStoreStyleConfigRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/store/saveStoreStyleConfig',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [保存店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312474) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/saveStoreStyleConfig`
 */
const apiMerchantImsApiStoreSaveStoreStyleConfigRequestConfig: ApiMerchantImsApiStoreSaveStoreStyleConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_35,
    devUrl: devUrl_0_22_0_35,
    prodUrl: prodUrl_0_22_0_35,
    path: '/merchant/imsApi/store/saveStoreStyleConfig',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStoreSaveStoreStyleConfig',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '保存店铺样式配置', author: '成龙' },
  }

/**
 * 接口 [保存店铺样式配置↗](https://yapi.gogpay.cn/project/2492/interface/api/312474) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/saveStoreStyleConfig`
 */
export const apiMerchantImsApiStoreSaveStoreStyleConfig = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStoreSaveStoreStyleConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStoreSaveStoreStyleConfigResponse>(
    prepare(
      apiMerchantImsApiStoreSaveStoreStyleConfigRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantImsApiStoreSaveStoreStyleConfig.requestConfig =
  apiMerchantImsApiStoreSaveStoreStyleConfigRequestConfig

/**
 * 接口 [搜索店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318226) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/searchStore`
 */
export interface ApiMerchantImsApiStoreSearchStoreRequest {
  clientType?: '1' | '2'
  headerChannel?: string[]
  id?: string[]
  keyword?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序类型 1综合 2好评 3销量 4低价优先 5高价优先
   */
  sortType?: number
}

/**
 * 接口 [搜索店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318226) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/searchStore`
 */
export type ApiMerchantImsApiStoreSearchStoreResponse = {
  /**
   * 店铺地址
   */
  address?: string
  /**
   * 店铺评价
   */
  evaluate?: number
  /**
   * 店铺Id
   */
  id?: string
  /**
   * 店铺logo
   */
  logo?: string
  /**
   * 店铺名称
   */
  name?: string
  /**
   * 店铺销量
   */
  sales?: number
  /**
   * 店铺类型
   */
  storeType?: number
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 店铺url
   */
  url?: string
}[]

/**
 * 接口 [搜索店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318226) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/searchStore`
 */
type ApiMerchantImsApiStoreSearchStoreRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/store/searchStore',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [搜索店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318226) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/searchStore`
 */
const apiMerchantImsApiStoreSearchStoreRequestConfig: ApiMerchantImsApiStoreSearchStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_35,
    devUrl: devUrl_0_22_0_35,
    prodUrl: prodUrl_0_22_0_35,
    path: '/merchant/imsApi/store/searchStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStoreSearchStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '搜索店铺', author: '成龙' },
  }

/**
 * 接口 [搜索店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318226) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_54056)
 * @请求头 `POST /merchant/imsApi/store/searchStore`
 */
export const apiMerchantImsApiStoreSearchStore = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStoreSearchStoreRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStoreSearchStoreResponse>(
    prepare(apiMerchantImsApiStoreSearchStoreRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStoreSearchStore.requestConfig =
  apiMerchantImsApiStoreSearchStoreRequestConfig

const mockUrl_0_22_0_37 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_37 = '' as any
const prodUrl_0_22_0_37 = '' as any
const dataKey_0_22_0_37 = 'data' as any

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/312458) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [merchant-search-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55256)
 * @请求头 `POST /merchant/api/storeSearch/search/keyword`
 */
export interface ApiMerchantStoreSearchSearchKeywordRequest {
  /**
   * 市级地区编码
   */
  cityCode?: string
  /**
   * 商品类型 7酒店 4门票
   */
  commodityType?: number
  /**
   * 区县编码
   */
  countyCode?: string
  /**
   * 距离
   */
  distance?: number
  /**
   * 星级 1-5星
   */
  evaluateStat?: number[]
  /**
   * 关键字
   */
  keyword?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lng?: string
  /**
   * 最高价
   */
  maxPrice?: number
  /**
   * 最低价
   */
  minPrice?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省级地区编码
   */
  provinceCode?: string
  /**
   * 排序 0-好评率 1-评分星级  2-位置距离 3-低价格 4-高价格 5-销量
   */
  sort?: string
  /**
   * 库存结束时间
   */
  stockDateEnd?: string
  /**
   * 库存开始时间
   */
  stockDateStart?: string
}

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/312458) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [merchant-search-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55256)
 * @请求头 `POST /merchant/api/storeSearch/search/keyword`
 */
export interface ApiMerchantStoreSearchSearchKeywordResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 距离(单位：米)
     */
    distance?: number
    /**
     * 星级
     */
    evaluateStat?: number
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺主键
     */
    id: string
    /**
     * 商户名称      default value: ''
     */
    merchantName?: string
    /**
     * 图片      default value: ''
     */
    pic?: string
    /**
     * 好评率
     */
    praiseRate?: string
    /**
     * 评级数量
     */
    quantity?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * 销售价
     */
    sellPrice?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/312458) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [merchant-search-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55256)
 * @请求头 `POST /merchant/api/storeSearch/search/keyword`
 */
type ApiMerchantStoreSearchSearchKeywordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/storeSearch/search/keyword',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/312458) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [merchant-search-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55256)
 * @请求头 `POST /merchant/api/storeSearch/search/keyword`
 */
const apiMerchantStoreSearchSearchKeywordRequestConfig: ApiMerchantStoreSearchSearchKeywordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_37,
    devUrl: devUrl_0_22_0_37,
    prodUrl: prodUrl_0_22_0_37,
    path: '/merchant/api/storeSearch/search/keyword',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_37,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantStoreSearchSearchKeyword',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺关键词搜索', author: '成龙' },
  }

/**
 * 接口 [店铺关键词搜索↗](https://yapi.gogpay.cn/project/2492/interface/api/312458) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [merchant-search-controller↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55256)
 * @请求头 `POST /merchant/api/storeSearch/search/keyword`
 */
export const apiMerchantStoreSearchSearchKeyword = /*#__PURE__*/ (
  requestData: ApiMerchantStoreSearchSearchKeywordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantStoreSearchSearchKeywordResponse>(
    prepare(apiMerchantStoreSearchSearchKeywordRequestConfig, requestData),
    ...args,
  )
}

apiMerchantStoreSearchSearchKeyword.requestConfig =
  apiMerchantStoreSearchSearchKeywordRequestConfig

const mockUrl_0_22_0_38 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_38 = '' as any
const prodUrl_0_22_0_38 = '' as any
const dataKey_0_22_0_38 = 'data' as any

/**
 * 接口 [新增站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318162) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/add`
 */
export interface ApiMerchantImsApiStationAddRequest {
  district?: {
    /**
     * 城市编码
     */
    cityCode?: string
    /**
     * 城市名称
     */
    cityName?: string
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 省份编码
     */
    provinceCode?: string
    /**
     * 省份名称
     */
    provinceName?: string
  }
  /**
   * 站点名称
   */
  name: string
  /**
   * 管理员手机号
   */
  phone: string
}

/**
 * 接口 [新增站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318162) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/add`
 */
export interface ApiMerchantImsApiStationAddResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [新增站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318162) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/add`
 */
type ApiMerchantImsApiStationAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/add',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318162) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/add`
 */
const apiMerchantImsApiStationAddRequestConfig: ApiMerchantImsApiStationAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/add',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增站点', author: '成龙' },
  }

/**
 * 接口 [新增站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318162) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/add`
 */
export const apiMerchantImsApiStationAdd = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationAddResponse>(
    prepare(apiMerchantImsApiStationAddRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationAdd.requestConfig =
  apiMerchantImsApiStationAddRequestConfig

/**
 * 接口 [绑定店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318170) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/bindStore`
 */
export interface ApiMerchantImsApiStationBindStoreRequest {
  /**
   * 站点Id
   */
  id: string
  /**
   * 店铺Id列表
   */
  storeIdList?: string[]
}

/**
 * 接口 [绑定店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318170) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/bindStore`
 */
export interface ApiMerchantImsApiStationBindStoreResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [绑定店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318170) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/bindStore`
 */
type ApiMerchantImsApiStationBindStoreRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/bindStore',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [绑定店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318170) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/bindStore`
 */
const apiMerchantImsApiStationBindStoreRequestConfig: ApiMerchantImsApiStationBindStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/bindStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationBindStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '绑定店铺', author: '成龙' },
  }

/**
 * 接口 [绑定店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318170) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/bindStore`
 */
export const apiMerchantImsApiStationBindStore = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationBindStoreRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationBindStoreResponse>(
    prepare(apiMerchantImsApiStationBindStoreRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationBindStore.requestConfig =
  apiMerchantImsApiStationBindStoreRequestConfig

/**
 * 接口 [站点详情↗](https://yapi.gogpay.cn/project/2492/interface/api/318178) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/detail`
 */
export interface ApiMerchantImsApiStationDetailRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [站点详情↗](https://yapi.gogpay.cn/project/2492/interface/api/318178) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/detail`
 */
export interface ApiMerchantImsApiStationDetailResponse {
  /**
   * 城市编码
   */
  cityCode?: string
  /**
   * 城市名称
   */
  cityName?: string
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 区县名称
   */
  districtName?: string
  /**
   * 站点Id
   */
  id?: string
  /**
   * 站点名称
   */
  name: string
  /**
   * 管理员手机号
   */
  phone: string
  /**
   * 省份编码
   */
  provinceCode?: string
  /**
   * 省份名称
   */
  provinceName?: string
}

/**
 * 接口 [站点详情↗](https://yapi.gogpay.cn/project/2492/interface/api/318178) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/detail`
 */
type ApiMerchantImsApiStationDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [站点详情↗](https://yapi.gogpay.cn/project/2492/interface/api/318178) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/detail`
 */
const apiMerchantImsApiStationDetailRequestConfig: ApiMerchantImsApiStationDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '站点详情', author: '成龙' },
  }

/**
 * 接口 [站点详情↗](https://yapi.gogpay.cn/project/2492/interface/api/318178) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/detail`
 */
export const apiMerchantImsApiStationDetail = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationDetailResponse>(
    prepare(apiMerchantImsApiStationDetailRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationDetail.requestConfig =
  apiMerchantImsApiStationDetailRequestConfig

/**
 * 接口 [禁用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318186) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/disable`
 */
export interface ApiMerchantImsApiStationDisableRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [禁用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318186) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/disable`
 */
export interface ApiMerchantImsApiStationDisableResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [禁用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318186) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/disable`
 */
type ApiMerchantImsApiStationDisableRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/disable',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [禁用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318186) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/disable`
 */
const apiMerchantImsApiStationDisableRequestConfig: ApiMerchantImsApiStationDisableRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/disable',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationDisable',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '禁用站点', author: '成龙' },
  }

/**
 * 接口 [禁用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318186) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/disable`
 */
export const apiMerchantImsApiStationDisable = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationDisableRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationDisableResponse>(
    prepare(apiMerchantImsApiStationDisableRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationDisable.requestConfig =
  apiMerchantImsApiStationDisableRequestConfig

/**
 * 接口 [启用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318194) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/enable`
 */
export interface ApiMerchantImsApiStationEnableRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [启用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318194) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/enable`
 */
export interface ApiMerchantImsApiStationEnableResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [启用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318194) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/enable`
 */
type ApiMerchantImsApiStationEnableRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/enable',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [启用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318194) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/enable`
 */
const apiMerchantImsApiStationEnableRequestConfig: ApiMerchantImsApiStationEnableRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/enable',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationEnable',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '启用站点', author: '成龙' },
  }

/**
 * 接口 [启用站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318194) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/enable`
 */
export const apiMerchantImsApiStationEnable = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationEnableRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationEnableResponse>(
    prepare(apiMerchantImsApiStationEnableRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationEnable.requestConfig =
  apiMerchantImsApiStationEnableRequestConfig

/**
 * 接口 [获取站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/318202) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/list`
 */
export interface ApiMerchantImsApiStationListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 站点Id
   */
  id?: string
  /**
   * 站点名称
   */
  name?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 站点状态 0禁用 1启用
   */
  status?: number
}

/**
 * 接口 [获取站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/318202) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/list`
 */
export interface ApiMerchantImsApiStationListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 站点Id
     */
    id?: string
    /**
     * 站点名称
     */
    name?: string
    /**
     * 站点状态 0禁用 1启用
     */
    status?: number
    /**
     * 状态文案
     */
    statusLabel?: string
    /**
     * 站点店铺数量
     */
    storeCount?: number
    /**
     * 店铺编码
     */
    unitOrgCode?: string[]
    /**
     * 首页地址
     */
    url?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/318202) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/list`
 */
type ApiMerchantImsApiStationListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/318202) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/list`
 */
const apiMerchantImsApiStationListRequestConfig: ApiMerchantImsApiStationListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取站点列表', author: '成龙' },
  }

/**
 * 接口 [获取站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/318202) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/list`
 */
export const apiMerchantImsApiStationList = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationListResponse>(
    prepare(apiMerchantImsApiStationListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationList.requestConfig =
  apiMerchantImsApiStationListRequestConfig

/**
 * 接口 [解绑店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318210) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/unbindStore`
 */
export interface ApiMerchantImsApiStationUnbindStoreRequest {
  /**
   * 站点Id
   */
  id: string
  /**
   * 店铺Id列表
   */
  storeIdList?: string[]
}

/**
 * 接口 [解绑店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318210) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/unbindStore`
 */
export interface ApiMerchantImsApiStationUnbindStoreResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [解绑店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318210) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/unbindStore`
 */
type ApiMerchantImsApiStationUnbindStoreRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/unbindStore',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [解绑店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318210) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/unbindStore`
 */
const apiMerchantImsApiStationUnbindStoreRequestConfig: ApiMerchantImsApiStationUnbindStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/unbindStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationUnbindStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '解绑店铺', author: '成龙' },
  }

/**
 * 接口 [解绑店铺↗](https://yapi.gogpay.cn/project/2492/interface/api/318210) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/unbindStore`
 */
export const apiMerchantImsApiStationUnbindStore = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationUnbindStoreRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationUnbindStoreResponse>(
    prepare(apiMerchantImsApiStationUnbindStoreRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationUnbindStore.requestConfig =
  apiMerchantImsApiStationUnbindStoreRequestConfig

/**
 * 接口 [修改站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318218) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/update`
 */
export interface ApiMerchantImsApiStationUpdateRequest {
  district?: {
    /**
     * 城市编码
     */
    cityCode?: string
    /**
     * 城市名称
     */
    cityName?: string
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 省份编码
     */
    provinceCode?: string
    /**
     * 省份名称
     */
    provinceName?: string
  }
  /**
   * Id
   */
  id: string
  /**
   * 站点名称
   */
  name: string
  /**
   * 管理员手机号
   */
  phone: string
}

/**
 * 接口 [修改站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318218) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/update`
 */
export interface ApiMerchantImsApiStationUpdateResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318218) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/update`
 */
type ApiMerchantImsApiStationUpdateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/update',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318218) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/update`
 */
const apiMerchantImsApiStationUpdateRequestConfig: ApiMerchantImsApiStationUpdateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/update',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationUpdate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改站点', author: '成龙' },
  }

/**
 * 接口 [修改站点↗](https://yapi.gogpay.cn/project/2492/interface/api/318218) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/update`
 */
export const apiMerchantImsApiStationUpdate = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationUpdateResponse>(
    prepare(apiMerchantImsApiStationUpdateRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationUpdate.requestConfig =
  apiMerchantImsApiStationUpdateRequestConfig

/**
 * 接口 [获取用户站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319082) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/userList`
 */
export interface ApiMerchantImsApiStationUserListRequest {
  merchantId?: string
}

/**
 * 接口 [获取用户站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319082) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/userList`
 */
export type ApiMerchantImsApiStationUserListResponse = {
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 站点Id
   */
  id?: string
  /**
   * 站点名称
   */
  name?: string
  /**
   * 站点状态 0禁用 1启用
   */
  status?: number
  /**
   * 状态文案
   */
  statusLabel?: string
  /**
   * 站点店铺数量
   */
  storeCount?: number
  /**
   * 店铺编码
   */
  unitOrgCode?: string[]
  /**
   * 首页地址
   */
  url?: string
}[]

/**
 * 接口 [获取用户站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319082) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/userList`
 */
type ApiMerchantImsApiStationUserListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/userList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319082) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/userList`
 */
const apiMerchantImsApiStationUserListRequestConfig: ApiMerchantImsApiStationUserListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/userList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationUserList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户站点列表', author: '成龙' },
  }

/**
 * 接口 [获取用户站点列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319082) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/userList`
 */
export const apiMerchantImsApiStationUserList = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationUserListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationUserListResponse>(
    prepare(apiMerchantImsApiStationUserListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationUserList.requestConfig =
  apiMerchantImsApiStationUserListRequestConfig

/**
 * 接口 [获取站点店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319674) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/stationStoreList`
 */
export interface ApiMerchantImsApiStationStationStoreListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 站点id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取站点店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319674) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/stationStoreList`
 */
export interface ApiMerchantImsApiStationStationStoreListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 店铺名称
     */
    name?: string
    /**
     * 站点Id
     */
    stationId?: string
    /**
     * 店铺类型
     */
    storeType?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取站点店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319674) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/stationStoreList`
 */
type ApiMerchantImsApiStationStationStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/imsApi/station/stationStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取站点店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319674) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/stationStoreList`
 */
const apiMerchantImsApiStationStationStoreListRequestConfig: ApiMerchantImsApiStationStationStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_38,
    devUrl: devUrl_0_22_0_38,
    prodUrl: prodUrl_0_22_0_38,
    path: '/merchant/imsApi/station/stationStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantImsApiStationStationStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取站点店铺列表', author: '成龙' },
  }

/**
 * 接口 [获取站点店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/319674) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-站点管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_55264)
 * @请求头 `POST /merchant/imsApi/station/stationStoreList`
 */
export const apiMerchantImsApiStationStationStoreList = /*#__PURE__*/ (
  requestData: ApiMerchantImsApiStationStationStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantImsApiStationStationStoreListResponse>(
    prepare(apiMerchantImsApiStationStationStoreListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantImsApiStationStationStoreList.requestConfig =
  apiMerchantImsApiStationStationStoreListRequestConfig

const mockUrl_0_22_0_41 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_41 = '' as any
const prodUrl_0_22_0_41 = '' as any
const dataKey_0_22_0_41 = 'data' as any

/**
 * 接口 [删除商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458658) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/deleteMerchantAddress`
 */
export interface ApiMerchantMerchantDeleteMerchantAddressRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [删除商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458658) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/deleteMerchantAddress`
 */
export interface ApiMerchantMerchantDeleteMerchantAddressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [删除商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458658) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/deleteMerchantAddress`
 */
type ApiMerchantMerchantDeleteMerchantAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/deleteMerchantAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458658) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/deleteMerchantAddress`
 */
const apiMerchantMerchantDeleteMerchantAddressRequestConfig: ApiMerchantMerchantDeleteMerchantAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/deleteMerchantAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantDeleteMerchantAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除商户地址', author: '511号开发' },
  }

/**
 * 接口 [删除商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458658) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/deleteMerchantAddress`
 */
export const apiMerchantMerchantDeleteMerchantAddress = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantDeleteMerchantAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantDeleteMerchantAddressResponse>(
    prepare(apiMerchantMerchantDeleteMerchantAddressRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantDeleteMerchantAddress.requestConfig =
  apiMerchantMerchantDeleteMerchantAddressRequestConfig

/**
 * 接口 [分页获取商户地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458663) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/findMerchantAddressList`
 */
export interface ApiMerchantMerchantFindMerchantAddressListRequest {
  /**
   * 查询类型 1发货地址 2退货地址 3自提地址
   */
  addressType: number
  /**
   * 门店Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [分页获取商户地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458663) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/findMerchantAddressList`
 */
export interface ApiMerchantMerchantFindMerchantAddressListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 营业结束时间
     */
    businessEndTime?: string
    /**
     * 营业开始时间
     */
    businessStartTime?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 地址Id
     */
    id?: string
    /**
     * 商户id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 省级地区编码
     */
    provinceCode?: string
    /**
     * 省名
     */
    provinceName?: string
    /**
     * 市级地区编码
     */
    cityCode?: string
    /**
     * 市名
     */
    cityName?: string
    /**
     * 区县编码
     */
    countyCode?: string
    /**
     * 区县名称
     */
    countyName?: string
    /**
     * 乡镇街道编码
     */
    townCode?: string
    /**
     * 乡镇街道名称
     */
    townName?: string
    /**
     * 村居社区编码
     */
    communityCode?: string
    /**
     * 村居社区名称
     */
    communityName?: string
    /**
     * 地址
     */
    address?: string
    /**
     * 商户详细地址
     */
    detailedAddress?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
    /**
     * 邮政编码
     */
    postalCode?: string
    /**
     * 地址类型，门店地址:000001,退货地址：00010：发货地址；000100, 门店:000100 ,提货地址:200100 退货&发货&门店 :000111
     */
    addressType?: string
    /**
     * 门店地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
     */
    defaultShopAddressFlag?: boolean
    /**
     * 退货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
     */
    defaultReturnAddressFlag?: boolean
    /**
     * 收货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
     */
    defaultReceiveAddressFlag?: boolean
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [分页获取商户地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458663) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/findMerchantAddressList`
 */
type ApiMerchantMerchantFindMerchantAddressListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/findMerchantAddressList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分页获取商户地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458663) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/findMerchantAddressList`
 */
const apiMerchantMerchantFindMerchantAddressListRequestConfig: ApiMerchantMerchantFindMerchantAddressListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/findMerchantAddressList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantFindMerchantAddressList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分页获取商户地址列表', author: '511号开发' },
  }

/**
 * 接口 [分页获取商户地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458663) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/findMerchantAddressList`
 */
export const apiMerchantMerchantFindMerchantAddressList = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantFindMerchantAddressListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantFindMerchantAddressListResponse>(
    prepare(
      apiMerchantMerchantFindMerchantAddressListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantMerchantFindMerchantAddressList.requestConfig =
  apiMerchantMerchantFindMerchantAddressListRequestConfig

/**
 * 接口 [修改商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458668) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/updateMerchantAddress`
 */
export interface ApiMerchantMerchantUpdateMerchantAddressRequest {
  /**
   * 营业结束时间
   */
  businessEndTime?: string
  /**
   * 营业开始时间
   */
  businessStartTime?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 地址Id
   */
  id?: string
  /**
   * 商户id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 自提点名称
   */
  selfPickupName?: string
  /**
   * 省级地区编码
   */
  provinceCode?: string
  /**
   * 省名
   */
  provinceName?: string
  /**
   * 市级地区编码
   */
  cityCode?: string
  /**
   * 市名
   */
  cityName?: string
  /**
   * 区县编码
   */
  countyCode?: string
  /**
   * 区县名称
   */
  countyName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 地址
   */
  address?: string
  /**
   * 商户详细地址
   */
  detailedAddress?: string
  /**
   * 联系人
   */
  contact?: string
  /**
   * 联系电话
   */
  contactTel?: string
  /**
   * 邮政编码
   */
  postalCode?: string
  /**
   * 地址类型，门店地址:000001,退货地址：00010：发货地址；000100, 门店:000100 ,提货地址:200100 退货&发货&门店 :000111
   */
  addressType?: string
  /**
   * 门店地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultShopAddressFlag?: boolean
  /**
   * 退货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultReturnAddressFlag?: boolean
  /**
   * 收货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultReceiveAddressFlag?: boolean
}

/**
 * 接口 [修改商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458668) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/updateMerchantAddress`
 */
export interface ApiMerchantMerchantUpdateMerchantAddressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458668) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/updateMerchantAddress`
 */
type ApiMerchantMerchantUpdateMerchantAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/updateMerchantAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458668) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/updateMerchantAddress`
 */
const apiMerchantMerchantUpdateMerchantAddressRequestConfig: ApiMerchantMerchantUpdateMerchantAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/updateMerchantAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantUpdateMerchantAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改商户地址', author: '511号开发' },
  }

/**
 * 接口 [修改商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458668) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/updateMerchantAddress`
 */
export const apiMerchantMerchantUpdateMerchantAddress = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantUpdateMerchantAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantUpdateMerchantAddressResponse>(
    prepare(apiMerchantMerchantUpdateMerchantAddressRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantUpdateMerchantAddress.requestConfig =
  apiMerchantMerchantUpdateMerchantAddressRequestConfig

/**
 * 接口 [查询用户管理的商户列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458683) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/queryUserMerchantList`
 */
export interface ApiMerchantMerchantQueryUserMerchantListRequest {
  merchantName?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [查询用户管理的商户列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458683) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/queryUserMerchantList`
 */
export interface ApiMerchantMerchantQueryUserMerchantListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 地址详情
     */
    address?: string
    businessChannel?: {
      /**
       * 所属运营渠道id
       */
      businessChannelId: string
      /**
       * 所属运营渠道名称
       */
      businessChannelName: string
    }
    /**
     * 地市编码
     */
    cityCode?: string
    /**
     * 地市名称
     */
    cityName?: string
    /**
     * 多彩宝客服电话
     */
    dcbPhone?: string
    /**
     * 是否默认收货地址
     */
    defaultRefundAddressFlag?: number
    /**
     * 是否默认发货地址
     */
    defaultShipAddressFlag?: number
    /**
     * 是否默认店铺地址
     */
    defaultStoreAddressFlag?: number
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 前台显示名称
     */
    frontName?: string
    /**
     * 前台展示名称
     */
    frontendName?: string
    /**
     * 纬度
     */
    latitude?: string
    leader?: {
      /**
       * 钉钉id
       */
      dingTalkId: string
      /**
       * 用户id
       */
      staffId: string
      /**
       * 用户名
       */
      staffName: string
      /**
       * 钉钉手机号
       */
      staffPhone: string
    }
    /**
     * 经度
     */
    longitude?: string
    org?: {
      /**
       * 地址详情
       */
      address?: string
      /**
       * 审批状态
       */
      approveStatus?: number
      /**
       * 营业执照
       */
      businessLicensePicture?: string
      /**
       * 业务类型
       */
      businessType?: string
      /**
       * 业务类型名称
       */
      businessTypeName?: string
      /**
       * 地市编码
       */
      cityCode?: string
      /**
       * 地市名称
       */
      cityName?: string
      /**
       * 企业简介
       */
      companyProfile?: string
      /**
       * 联系人姓名
       */
      contactName?: string
      /**
       * 联系人电话
       */
      contactPhone?: string
      /**
       * 区县编码
       */
      districtCode?: string
      /**
       * 区县名称
       */
      districtName?: string
      /**
       * 法人姓名
       */
      legalPersonName?: string
      /**
       * 机构logo
       */
      logo?: string
      /**
       * 机构编码
       */
      orgCode?: string
      /**
       * 机构ID
       */
      orgId?: string
      /**
       * 机构名称
       */
      orgName?: string
      /**
       * 机构状态: 1审核中 2正常 3停业
       */
      orgStatus?: number
      /**
       * 省级编码
       */
      provinceCode?: string
      /**
       * 省级名称
       */
      provinceName?: string
      /**
       * 机构简称
       */
      shortName?: string
      /**
       * 统一社会信用代码
       */
      uniSocialCreditCode?: string
    }
    /**
     * 机构id
     */
    orgId?: string
    /**
     * 省级编码
     */
    provinceCode?: string
    /**
     * 省级名称
     */
    provinceName?: string
    settlement?: {
      /**
       * 开户行编码
       */
      backCode?: string
      /**
       * 开户行名称
       */
      backName?: string
      /**
       * 开户行地址详情
       */
      bankAddress?: string
      /**
       * 开户行地市编码
       */
      bankCityCode?: string
      /**
       * 开户行地市名称
       */
      bankCityName?: string
      /**
       * 开户行区县编码
       */
      bankDistrictCode?: string
      /**
       * 开户行区县名称
       */
      bankDistrictName?: string
      /**
       * 开户行省级编码
       */
      bankProvinceCode?: string
      /**
       * 开户行省级名称
       */
      bankProvinceName?: string
      /**
       * 银行卡号
       */
      bankUserCardNo?: string
      /**
       * 银行开户名
       */
      bankUserName?: string
      /**
       * 业务类型
       */
      businessType?: string
      /**
       * 业务类型名称
       */
      businessTypeName?: string
      /**
       * 清分机构：1-见证宝 2-NC
       */
      distributionOrg?: number
      /**
       * 分润类型：00-固定值 01-百分比
       */
      feeType?: string
      /**
       * 分润值（元）
       */
      feeValue?: number
      /**
       * ID
       */
      id?: string
      /**
       * 机构ID
       */
      orgId?: string
      /**
       * 结算逻辑：1-订单支付成功后结算 2-订单完结后进行结算
       */
      settlementLogic?: number
      /**
       * 结算方式：1-代收代付 2-代销转采销
       */
      settlementMethod?: number
      /**
       * 结算开户绑卡状态：1-未开户未绑卡 2-已开户未绑卡 3-已开户已绑卡 4-已绑卡未鉴权
       */
      settlementOpenBindStatus?: number
      /**
       * 结算周期：00-日结 01-周结 02-月结
       */
      settlementPeriod?: string
      /**
       * 结算周期类型：1-自然日结算 2-交易日结算
       */
      settlementPeriodType?: number
      /**
       * 店铺ID
       */
      storeId?: string
      /**
       * 子机构号
       */
      unitOrgCode?: string
      /**
       * 子机构名称
       */
      unitOrgName?: string
    }
    /**
     * 商户管理员姓名
     */
    storeContact?: string
    /**
     * 店铺id
     */
    storeId?: string
    /**
     * 店铺logo
     */
    storeLogo?: string
    /**
     * 商户名称
     */
    storeName?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 门店类型 0线上 1线下
     */
    storeType?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 所属机构
     */
    unitOrgName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询用户管理的商户列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458683) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/queryUserMerchantList`
 */
type ApiMerchantMerchantQueryUserMerchantListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/queryUserMerchantList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户管理的商户列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458683) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/queryUserMerchantList`
 */
const apiMerchantMerchantQueryUserMerchantListRequestConfig: ApiMerchantMerchantQueryUserMerchantListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/queryUserMerchantList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantQueryUserMerchantList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户管理的商户列表', author: '511号开发' },
  }

/**
 * 接口 [查询用户管理的商户列表↗](https://yapi.gogpay.cn/project/2492/interface/api/458683) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/queryUserMerchantList`
 */
export const apiMerchantMerchantQueryUserMerchantList = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantQueryUserMerchantListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantQueryUserMerchantListResponse>(
    prepare(apiMerchantMerchantQueryUserMerchantListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantQueryUserMerchantList.requestConfig =
  apiMerchantMerchantQueryUserMerchantListRequestConfig

/**
 * 接口 [新增商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458933) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/addMerchantAddress`
 */
export interface ApiMerchantMerchantAddMerchantAddressRequest {
  /**
   * 营业结束时间
   */
  businessEndTime?: string
  /**
   * 营业开始时间
   */
  businessStartTime?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 地址Id
   */
  id?: string
  /**
   * 商户id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 自提点名称
   */
  selfPickupName?: string
  /**
   * 省级地区编码
   */
  provinceCode?: string
  /**
   * 省名
   */
  provinceName?: string
  /**
   * 市级地区编码
   */
  cityCode?: string
  /**
   * 市名
   */
  cityName?: string
  /**
   * 区县编码
   */
  countyCode?: string
  /**
   * 区县名称
   */
  countyName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 地址
   */
  address?: string
  /**
   * 商户详细地址
   */
  detailedAddress?: string
  /**
   * 联系人
   */
  contact?: string
  /**
   * 联系电话
   */
  contactTel?: string
  /**
   * 邮政编码
   */
  postalCode?: string
  /**
   * 地址类型，门店地址:000001,退货地址：00010：发货地址；000100, 门店:000100 ,提货地址:200100 退货&发货&门店 :000111
   */
  addressType?: string
  /**
   * 门店地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultShopAddressFlag?: boolean
  /**
   * 退货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultReturnAddressFlag?: boolean
  /**
   * 收货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultReceiveAddressFlag?: boolean
}

/**
 * 接口 [新增商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458933) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/addMerchantAddress`
 */
export interface ApiMerchantMerchantAddMerchantAddressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [新增商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458933) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/addMerchantAddress`
 */
type ApiMerchantMerchantAddMerchantAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/addMerchantAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458933) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/addMerchantAddress`
 */
const apiMerchantMerchantAddMerchantAddressRequestConfig: ApiMerchantMerchantAddMerchantAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/addMerchantAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantAddMerchantAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增商户地址', author: '511号开发' },
  }

/**
 * 接口 [新增商户地址↗](https://yapi.gogpay.cn/project/2492/interface/api/458933) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/addMerchantAddress`
 */
export const apiMerchantMerchantAddMerchantAddress = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantAddMerchantAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantAddMerchantAddressResponse>(
    prepare(apiMerchantMerchantAddMerchantAddressRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantAddMerchantAddress.requestConfig =
  apiMerchantMerchantAddMerchantAddressRequestConfig

/**
 * 接口 [查询地址详情↗](https://yapi.gogpay.cn/project/2492/interface/api/458948) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/getMerchantAddressDetail`
 */
export interface ApiMerchantMerchantGetMerchantAddressDetailRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [查询地址详情↗](https://yapi.gogpay.cn/project/2492/interface/api/458948) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/getMerchantAddressDetail`
 */
export interface ApiMerchantMerchantGetMerchantAddressDetailResponse {
  /**
   * 营业结束时间
   */
  businessEndTime?: string
  /**
   * 营业开始时间
   */
  businessStartTime?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 地址Id
   */
  id?: string
  /**
   * 商户id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 自提点名称
   */
  selfPickupName?: string
  /**
   * 省级地区编码
   */
  provinceCode?: string
  /**
   * 省名
   */
  provinceName?: string
  /**
   * 市级地区编码
   */
  cityCode?: string
  /**
   * 市名
   */
  cityName?: string
  /**
   * 区县编码
   */
  countyCode?: string
  /**
   * 区县名称
   */
  countyName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 地址
   */
  address?: string
  /**
   * 商户详细地址
   */
  detailedAddress?: string
  /**
   * 联系人
   */
  contact?: string
  /**
   * 联系电话
   */
  contactTel?: string
  /**
   * 邮政编码
   */
  postalCode?: string
  /**
   * 地址类型，门店地址:000001,退货地址：00010：发货地址；000100, 门店:000100 ,提货地址:200100 退货&发货&门店 :000111
   */
  addressType?: string
  /**
   * 门店地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultShopAddressFlag?: boolean
  /**
   * 退货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultReturnAddressFlag?: boolean
  /**
   * 收货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
   */
  defaultReceiveAddressFlag?: boolean
}

/**
 * 接口 [查询地址详情↗](https://yapi.gogpay.cn/project/2492/interface/api/458948) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/getMerchantAddressDetail`
 */
type ApiMerchantMerchantGetMerchantAddressDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/getMerchantAddressDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询地址详情↗](https://yapi.gogpay.cn/project/2492/interface/api/458948) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/getMerchantAddressDetail`
 */
const apiMerchantMerchantGetMerchantAddressDetailRequestConfig: ApiMerchantMerchantGetMerchantAddressDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/getMerchantAddressDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantGetMerchantAddressDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询地址详情', author: '511号开发' },
  }

/**
 * 接口 [查询地址详情↗](https://yapi.gogpay.cn/project/2492/interface/api/458948) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/getMerchantAddressDetail`
 */
export const apiMerchantMerchantGetMerchantAddressDetail = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantGetMerchantAddressDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantGetMerchantAddressDetailResponse>(
    prepare(
      apiMerchantMerchantGetMerchantAddressDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantMerchantGetMerchantAddressDetail.requestConfig =
  apiMerchantMerchantGetMerchantAddressDetailRequestConfig

/**
 * 接口 [客户端分页获取商户自提地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464002) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/listByIds`
 */
export interface ApiMerchantMerchantListByIdsRequest {
  cityName?: string
  ids?: string[]
  merchantId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  selfPickupName?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 纬度
   */
  latitude?: string
}

/**
 * 接口 [客户端分页获取商户自提地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464002) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/listByIds`
 */
export interface ApiMerchantMerchantListByIdsResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * id
     */
    id?: string
    /**
     * 商户id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 省级地区编码
     */
    provinceCode?: string
    /**
     * 省名
     */
    provinceName?: string
    /**
     * 市级地区编码
     */
    cityCode?: string
    /**
     * 市名
     */
    cityName?: string
    /**
     * 区县编码
     */
    countyCode?: string
    /**
     * 区县名称
     */
    countyName?: string
    /**
     * 乡镇街道编码
     */
    townCode?: string
    /**
     * 乡镇街道名称
     */
    townName?: string
    /**
     * 村居社区编码
     */
    communityCode?: string
    /**
     * 村居社区名称
     */
    communityName?: string
    /**
     * 地址
     */
    address?: string
    /**
     * 商户详细地址
     */
    detailedAddress?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
    /**
     * 邮政编码
     */
    postalCode?: string
    /**
     * 地址类型，门店地址:000001,退货地址：000010：发货地址；000100,提货地址:200100, 门店:000100 退货&发货&门店 :000111
     */
    addressType?: string
    /**
     * 门店地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
     */
    defaultShopAddressFlag?: boolean
    /**
     * 退货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
     */
    defaultReturnAddressFlag?: boolean
    /**
     * 收货地址标识，1：默；0：非默认。和type结合，一个商户（子商户）只能有一个默认退货|发货|门店 地址，但一个地址可以同时是发、退货地址
     */
    defaultReceiveAddressFlag?: boolean
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 营业开始时间
     */
    businessStartTime?: string
    /**
     * 营业结束时间
     */
    businessEndTime?: string
    /**
     * 距离当前距离
     */
    distanceDesc?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端分页获取商户自提地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464002) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/listByIds`
 */
type ApiMerchantMerchantListByIdsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/listByIds',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端分页获取商户自提地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464002) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/listByIds`
 */
const apiMerchantMerchantListByIdsRequestConfig: ApiMerchantMerchantListByIdsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_41,
    devUrl: devUrl_0_22_0_41,
    prodUrl: prodUrl_0_22_0_41,
    path: '/merchant/api/merchant/listByIds',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantListByIds',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端分页获取商户自提地址列表', author: '511号开发' },
  }

/**
 * 接口 [客户端分页获取商户自提地址列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464002) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家端管理↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80680)
 * @请求头 `POST /merchant/api/merchant/listByIds`
 */
export const apiMerchantMerchantListByIds = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantListByIdsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantListByIdsResponse>(
    prepare(apiMerchantMerchantListByIdsRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantListByIds.requestConfig =
  apiMerchantMerchantListByIdsRequestConfig

const mockUrl_0_22_0_42 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_42 = '' as any
const prodUrl_0_22_0_42 = '' as any
const dataKey_0_22_0_42 = 'data' as any

/**
 * 接口 [客户端-批量删除配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459153) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/batchDel`
 */
export interface ApiMerchantMerchantCourierBatchDelRequest {
  /**
   * id数组
   */
  ids: string[]
  /**
   * 商户ID
   */
  merchantId: string
}

/**
 * 接口 [客户端-批量删除配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459153) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/batchDel`
 */
export interface ApiMerchantMerchantCourierBatchDelResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-批量删除配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459153) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/batchDel`
 */
type ApiMerchantMerchantCourierBatchDelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/courier/batchDel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-批量删除配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459153) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/batchDel`
 */
const apiMerchantMerchantCourierBatchDelRequestConfig: ApiMerchantMerchantCourierBatchDelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_42,
    devUrl: devUrl_0_22_0_42,
    prodUrl: prodUrl_0_22_0_42,
    path: '/merchant/api/merchant/courier/batchDel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantCourierBatchDel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-批量删除配送员信息', author: '503号开发' },
  }

/**
 * 接口 [客户端-批量删除配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459153) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/batchDel`
 */
export const apiMerchantMerchantCourierBatchDel = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantCourierBatchDelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantCourierBatchDelResponse>(
    prepare(apiMerchantMerchantCourierBatchDelRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantCourierBatchDel.requestConfig =
  apiMerchantMerchantCourierBatchDelRequestConfig

/**
 * 接口 [客户端-查询配送员分页列表↗](https://yapi.gogpay.cn/project/2492/interface/api/459158) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryPageList`
 */
export interface ApiMerchantMerchantCourierQueryPageListRequest {
  /**
   * 商户ID
   */
  merchantId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [客户端-查询配送员分页列表↗](https://yapi.gogpay.cn/project/2492/interface/api/459158) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryPageList`
 */
export interface ApiMerchantMerchantCourierQueryPageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端-查询配送员分页列表↗](https://yapi.gogpay.cn/project/2492/interface/api/459158) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryPageList`
 */
type ApiMerchantMerchantCourierQueryPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/courier/queryPageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-查询配送员分页列表↗](https://yapi.gogpay.cn/project/2492/interface/api/459158) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryPageList`
 */
const apiMerchantMerchantCourierQueryPageListRequestConfig: ApiMerchantMerchantCourierQueryPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_42,
    devUrl: devUrl_0_22_0_42,
    prodUrl: prodUrl_0_22_0_42,
    path: '/merchant/api/merchant/courier/queryPageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantCourierQueryPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-查询配送员分页列表', author: '503号开发' },
  }

/**
 * 接口 [客户端-查询配送员分页列表↗](https://yapi.gogpay.cn/project/2492/interface/api/459158) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryPageList`
 */
export const apiMerchantMerchantCourierQueryPageList = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantCourierQueryPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantCourierQueryPageListResponse>(
    prepare(apiMerchantMerchantCourierQueryPageListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantCourierQueryPageList.requestConfig =
  apiMerchantMerchantCourierQueryPageListRequestConfig

/**
 * 接口 [客户端-保存更新配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459163) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/save`
 */
export interface ApiMerchantMerchantCourierSaveRequest {
  /**
   * 配送员名称
   */
  courierName: string
  /**
   * 配送员手机号
   */
  courierPhone: string
  /**
   * 是否默认配送员
   */
  defaultFlag?: boolean
  /**
   * 主键ID 存在则更新
   */
  id?: string
  /**
   * 商户ID
   */
  merchantId: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 门店类型 0线上 1线下
   */
  storeType?: number
}

/**
 * 接口 [客户端-保存更新配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459163) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/save`
 */
export interface ApiMerchantMerchantCourierSaveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-保存更新配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459163) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/save`
 */
type ApiMerchantMerchantCourierSaveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/courier/save',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-保存更新配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459163) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/save`
 */
const apiMerchantMerchantCourierSaveRequestConfig: ApiMerchantMerchantCourierSaveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_42,
    devUrl: devUrl_0_22_0_42,
    prodUrl: prodUrl_0_22_0_42,
    path: '/merchant/api/merchant/courier/save',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantCourierSave',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-保存更新配送员信息', author: '503号开发' },
  }

/**
 * 接口 [客户端-保存更新配送员信息↗](https://yapi.gogpay.cn/project/2492/interface/api/459163) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/save`
 */
export const apiMerchantMerchantCourierSave = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantCourierSaveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantCourierSaveResponse>(
    prepare(apiMerchantMerchantCourierSaveRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantCourierSave.requestConfig =
  apiMerchantMerchantCourierSaveRequestConfig

/**
 * 接口 [客户端-查询配送员详情↗](https://yapi.gogpay.cn/project/2492/interface/api/463553) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/findById`
 */
export interface ApiMerchantMerchantCourierFindByIdRequest {
  /**
   * 对象ID
   */
  id?: string
}

/**
 * 接口 [客户端-查询配送员详情↗](https://yapi.gogpay.cn/project/2492/interface/api/463553) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/findById`
 */
export interface ApiMerchantMerchantCourierFindByIdResponse {
  /**
   * 配送员名称
   */
  courierName?: string
  /**
   * 配送员手机号
   */
  courierPhone?: string
  /**
   * 创建人
   */
  createBy?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 是否默认配送员
   */
  defaultFlag?: boolean
  /**
   * 主键ID
   */
  id?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 子机构号
   */
  unitOrgCode?: string
  /**
   * 修改人
   */
  updateBy?: string
  /**
   * 修改时间
   */
  updateTime?: string
}

/**
 * 接口 [客户端-查询配送员详情↗](https://yapi.gogpay.cn/project/2492/interface/api/463553) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/findById`
 */
type ApiMerchantMerchantCourierFindByIdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/courier/findById',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-查询配送员详情↗](https://yapi.gogpay.cn/project/2492/interface/api/463553) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/findById`
 */
const apiMerchantMerchantCourierFindByIdRequestConfig: ApiMerchantMerchantCourierFindByIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_42,
    devUrl: devUrl_0_22_0_42,
    prodUrl: prodUrl_0_22_0_42,
    path: '/merchant/api/merchant/courier/findById',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantCourierFindById',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-查询配送员详情', author: '511号开发' },
  }

/**
 * 接口 [客户端-查询配送员详情↗](https://yapi.gogpay.cn/project/2492/interface/api/463553) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/findById`
 */
export const apiMerchantMerchantCourierFindById = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantCourierFindByIdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantCourierFindByIdResponse>(
    prepare(apiMerchantMerchantCourierFindByIdRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantCourierFindById.requestConfig =
  apiMerchantMerchantCourierFindByIdRequestConfig

/**
 * 接口 [客户端-查询商户配送员列表↗](https://yapi.gogpay.cn/project/2492/interface/api/463554) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryList`
 */
export interface ApiMerchantMerchantCourierQueryListRequest {
  merchantId?: string
  unitOrgCode?: string
}

/**
 * 接口 [客户端-查询商户配送员列表↗](https://yapi.gogpay.cn/project/2492/interface/api/463554) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryList`
 */
export type ApiMerchantMerchantCourierQueryListResponse = {
  /**
   * 配送员名称
   */
  courierName?: string
  /**
   * 配送员手机号
   */
  courierPhone?: string
  /**
   * 创建人
   */
  createBy?: string
  /**
   * 创建时间
   */
  createTime?: string
  /**
   * 是否默认配送员
   */
  defaultFlag?: boolean
  /**
   * 主键ID
   */
  id?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 子机构号
   */
  unitOrgCode?: string
  /**
   * 修改人
   */
  updateBy?: string
  /**
   * 修改时间
   */
  updateTime?: string
}[]

/**
 * 接口 [客户端-查询商户配送员列表↗](https://yapi.gogpay.cn/project/2492/interface/api/463554) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryList`
 */
type ApiMerchantMerchantCourierQueryListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/merchant/courier/queryList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-查询商户配送员列表↗](https://yapi.gogpay.cn/project/2492/interface/api/463554) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryList`
 */
const apiMerchantMerchantCourierQueryListRequestConfig: ApiMerchantMerchantCourierQueryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_42,
    devUrl: devUrl_0_22_0_42,
    prodUrl: prodUrl_0_22_0_42,
    path: '/merchant/api/merchant/courier/queryList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantMerchantCourierQueryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-查询商户配送员列表', author: '511号开发' },
  }

/**
 * 接口 [客户端-查询商户配送员列表↗](https://yapi.gogpay.cn/project/2492/interface/api/463554) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [商家配送员接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_80749)
 * @请求头 `POST /merchant/api/merchant/courier/queryList`
 */
export const apiMerchantMerchantCourierQueryList = /*#__PURE__*/ (
  requestData: ApiMerchantMerchantCourierQueryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantMerchantCourierQueryListResponse>(
    prepare(apiMerchantMerchantCourierQueryListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantMerchantCourierQueryList.requestConfig =
  apiMerchantMerchantCourierQueryListRequestConfig

const mockUrl_0_22_0_45 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_45 = '' as any
const prodUrl_0_22_0_45 = '' as any
const dataKey_0_22_0_45 = 'data' as any

/**
 * 接口 [分层级查询区划列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464569) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-区划查询↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83749)
 * @请求头 `POST /merchant/api/district/districtLevelList`
 */
export interface ApiMerchantDistrictDistrictLevelListRequest {
  /**
   * 父级区划ID
   */
  parentId?: string
}

/**
 * 接口 [分层级查询区划列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464569) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-区划查询↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83749)
 * @请求头 `POST /merchant/api/district/districtLevelList`
 */
export type ApiMerchantDistrictDistrictLevelListResponse = {
  /**
   * 当前区划层级
   */
  currentLevel?: number
  /**
   * 区划ID
   */
  districtId?: string
  /**
   * 区划名称
   */
  districtName?: string
  /**
   * 是否存在子级区划
   */
  hasChildren?: boolean
  /**
   * 父级区划ID
   */
  parentId?: string
  /**
   * 区划简称
   */
  simpleName?: string
}[]

/**
 * 接口 [分层级查询区划列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464569) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-区划查询↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83749)
 * @请求头 `POST /merchant/api/district/districtLevelList`
 */
type ApiMerchantDistrictDistrictLevelListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/district/districtLevelList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分层级查询区划列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464569) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-区划查询↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83749)
 * @请求头 `POST /merchant/api/district/districtLevelList`
 */
const apiMerchantDistrictDistrictLevelListRequestConfig: ApiMerchantDistrictDistrictLevelListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_45,
    devUrl: devUrl_0_22_0_45,
    prodUrl: prodUrl_0_22_0_45,
    path: '/merchant/api/district/districtLevelList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantDistrictDistrictLevelList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分层级查询区划列表', author: '511号开发' },
  }

/**
 * 接口 [分层级查询区划列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464569) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-区划查询↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83749)
 * @请求头 `POST /merchant/api/district/districtLevelList`
 */
export const apiMerchantDistrictDistrictLevelList = /*#__PURE__*/ (
  requestData: ApiMerchantDistrictDistrictLevelListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantDistrictDistrictLevelListResponse>(
    prepare(apiMerchantDistrictDistrictLevelListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantDistrictDistrictLevelList.requestConfig =
  apiMerchantDistrictDistrictLevelListRequestConfig

const mockUrl_0_22_0_46 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_46 = '' as any
const prodUrl_0_22_0_46 = '' as any
const dataKey_0_22_0_46 = 'data' as any

/**
 * 接口 [分页查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464608) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webPageList`
 */
export interface ApiMerchantOfflineStoreWebPageListRequest {
  /**
   * 市编码
   */
  cityCode?: string
  /**
   * 排序方式 asc=正序 desc=倒序
   */
  direction?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 定位类型 baidu、gcj、gps
   */
  locationType?: string
  /**
   * 经度
   */
  lon?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省编码
   */
  provinceCode?: string
  /**
   * 店铺名称
   */
  storeName?: string
}

/**
 * 接口 [分页查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464608) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webPageList`
 */
export interface ApiMerchantOfflineStoreWebPageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 详细地址
     */
    address: string
    /**
     * 全拼地址
     */
    addressDetail?: string
    /**
     * 所属运营渠道ID
     */
    businessChannelId?: string
    /**
     * 地市编码
     */
    cityCode?: string
    /**
     * 地市名称
     */
    cityName?: string
    /**
     * 村居社区编码
     */
    communityCode?: string
    /**
     * 村居社区名称
     */
    communityName?: string
    /**
     * 客服电话
     */
    dcbPhone?: string
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 所属机构ID
     */
    orgId?: string
    /**
     * 省级编码
     */
    provinceCode?: string
    /**
     * 省级名称
     */
    provinceName?: string
    /**
     * 签约主体ID，不传默认为多彩宝
     */
    signSubjectId?: string
    /**
     * 签约主体名称
     */
    signSubjectName?: string
    /**
     * 商家联系人
     */
    storeContact?: string
    /**
     * 店铺有效日期
     */
    storeEffectiveEndDate: string
    /**
     * 主键ID
     */
    storeId?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 商家联系电话
     */
    storePhone: string
    /**
     * 店铺状态 1 待营业 2 营业中 3 已停业 4 休息中
     */
    storeStatus?: number
    /**
     * 店铺状态名称
     */
    storeStatusName?: string
    /**
     * 乡镇街道编码
     */
    townCode?: string
    /**
     * 乡镇街道名称
     */
    townName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [分页查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464608) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webPageList`
 */
type ApiMerchantOfflineStoreWebPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/offline/store/webPageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分页查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464608) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webPageList`
 */
const apiMerchantOfflineStoreWebPageListRequestConfig: ApiMerchantOfflineStoreWebPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_46,
    devUrl: devUrl_0_22_0_46,
    prodUrl: prodUrl_0_22_0_46,
    path: '/merchant/api/offline/store/webPageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_46,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantOfflineStoreWebPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分页查询线下店铺列表', author: '503号开发' },
  }

/**
 * 接口 [分页查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464608) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webPageList`
 */
export const apiMerchantOfflineStoreWebPageList = /*#__PURE__*/ (
  requestData: ApiMerchantOfflineStoreWebPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantOfflineStoreWebPageListResponse>(
    prepare(apiMerchantOfflineStoreWebPageListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantOfflineStoreWebPageList.requestConfig =
  apiMerchantOfflineStoreWebPageListRequestConfig

/**
 * 接口 [查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464609) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webQueryStoreList`
 */
export interface ApiMerchantOfflineStoreWebQueryStoreListRequest {
  cityCode?: string
  storeIdList?: string[]
}

/**
 * 接口 [查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464609) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webQueryStoreList`
 */
export type ApiMerchantOfflineStoreWebQueryStoreListResponse = {
  /**
   * 详细地址
   */
  address: string
  /**
   * 全拼地址
   */
  addressDetail?: string
  /**
   * 所属运营渠道ID
   */
  businessChannelId?: string
  /**
   * 地市编码
   */
  cityCode?: string
  /**
   * 地市名称
   */
  cityName?: string
  /**
   * 村居社区编码
   */
  communityCode?: string
  /**
   * 村居社区名称
   */
  communityName?: string
  /**
   * 客服电话
   */
  dcbPhone?: string
  /**
   * 区县编码
   */
  districtCode?: string
  /**
   * 区县名称
   */
  districtName?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 所属机构ID
   */
  orgId?: string
  /**
   * 省级编码
   */
  provinceCode?: string
  /**
   * 省级名称
   */
  provinceName?: string
  /**
   * 签约主体ID，不传默认为多彩宝
   */
  signSubjectId?: string
  /**
   * 签约主体名称
   */
  signSubjectName?: string
  /**
   * 商家联系人
   */
  storeContact?: string
  /**
   * 店铺有效日期
   */
  storeEffectiveEndDate: string
  /**
   * 主键ID
   */
  storeId?: string
  /**
   * 店铺logo(店铺封面)
   */
  storeLogo?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 商家联系电话
   */
  storePhone: string
  /**
   * 店铺状态 1 待营业 2 营业中 3 已停业 4 休息中
   */
  storeStatus?: number
  /**
   * 店铺状态名称
   */
  storeStatusName?: string
  /**
   * 乡镇街道编码
   */
  townCode?: string
  /**
   * 乡镇街道名称
   */
  townName?: string
}[]

/**
 * 接口 [查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464609) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webQueryStoreList`
 */
type ApiMerchantOfflineStoreWebQueryStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/offline/store/webQueryStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464609) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webQueryStoreList`
 */
const apiMerchantOfflineStoreWebQueryStoreListRequestConfig: ApiMerchantOfflineStoreWebQueryStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_46,
    devUrl: devUrl_0_22_0_46,
    prodUrl: prodUrl_0_22_0_46,
    path: '/merchant/api/offline/store/webQueryStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_46,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantOfflineStoreWebQueryStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询线下店铺列表', author: '503号开发' },
  }

/**
 * 接口 [查询线下店铺列表↗](https://yapi.gogpay.cn/project/2492/interface/api/464609) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/webQueryStoreList`
 */
export const apiMerchantOfflineStoreWebQueryStoreList = /*#__PURE__*/ (
  requestData: ApiMerchantOfflineStoreWebQueryStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantOfflineStoreWebQueryStoreListResponse>(
    prepare(apiMerchantOfflineStoreWebQueryStoreListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantOfflineStoreWebQueryStoreList.requestConfig =
  apiMerchantOfflineStoreWebQueryStoreListRequestConfig

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/2492/interface/api/478539) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/locationList`
 */
export interface ApiMerchantOfflineStoreLocationListRequest {
  /**
   * 市编码
   */
  cityCode?: string
  /**
   * 排序方式 asc=正序 desc=倒序
   */
  direction?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 定位类型 baidu、gcj、gps
   */
  locationType?: string
  /**
   * 经度
   */
  lon?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省编码
   */
  provinceCode?: string
  /**
   * 店铺名称
   */
  storeName?: string
}

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/2492/interface/api/478539) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/locationList`
 */
export type ApiMerchantOfflineStoreLocationListResponse = {
  /**
   * 店铺地址
   */
  address?: string
  /**
   * 距离
   */
  distance?: string
  /**
   * 店铺Id
   */
  id?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lon?: string
  /**
   * 店铺名称
   */
  name?: string
}[]

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/2492/interface/api/478539) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/locationList`
 */
type ApiMerchantOfflineStoreLocationListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/api/offline/store/locationList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/2492/interface/api/478539) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/locationList`
 */
const apiMerchantOfflineStoreLocationListRequestConfig: ApiMerchantOfflineStoreLocationListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_46,
    devUrl: devUrl_0_22_0_46,
    prodUrl: prodUrl_0_22_0_46,
    path: '/merchant/api/offline/store/locationList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_46,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantOfflineStoreLocationList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分页查询线下店铺列表（带定位）', author: '511号开发' },
  }

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/2492/interface/api/478539) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-线下店铺相关接口↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_83813)
 * @请求头 `POST /merchant/api/offline/store/locationList`
 */
export const apiMerchantOfflineStoreLocationList = /*#__PURE__*/ (
  requestData: ApiMerchantOfflineStoreLocationListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantOfflineStoreLocationListResponse>(
    prepare(apiMerchantOfflineStoreLocationListRequestConfig, requestData),
    ...args,
  )
}

apiMerchantOfflineStoreLocationList.requestConfig =
  apiMerchantOfflineStoreLocationListRequestConfig

const mockUrl_0_22_0_47 = 'https://yapi.gogpay.cn/mock/2492' as any
const devUrl_0_22_0_47 = '' as any
const prodUrl_0_22_0_47 = '' as any
const dataKey_0_22_0_47 = 'data' as any

/**
 * 接口 [钉钉消息推送↗](https://yapi.gogpay.cn/project/2492/interface/api/485042) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [开放接口-适老化调用↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_85888)
 * @请求头 `POST /merchant/openAgingApi/common/dingTalkPush`
 */
export interface ApiMerchantOpenAgingApiCommonDingTalkPushRequest {
  /**
   * 消息发送内容
   */
  messageContent?: string
}

/**
 * 接口 [钉钉消息推送↗](https://yapi.gogpay.cn/project/2492/interface/api/485042) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [开放接口-适老化调用↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_85888)
 * @请求头 `POST /merchant/openAgingApi/common/dingTalkPush`
 */
export interface ApiMerchantOpenAgingApiCommonDingTalkPushResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [钉钉消息推送↗](https://yapi.gogpay.cn/project/2492/interface/api/485042) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [开放接口-适老化调用↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_85888)
 * @请求头 `POST /merchant/openAgingApi/common/dingTalkPush`
 */
type ApiMerchantOpenAgingApiCommonDingTalkPushRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/2492',
    '',
    '',
    '/merchant/openAgingApi/common/dingTalkPush',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [钉钉消息推送↗](https://yapi.gogpay.cn/project/2492/interface/api/485042) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [开放接口-适老化调用↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_85888)
 * @请求头 `POST /merchant/openAgingApi/common/dingTalkPush`
 */
const apiMerchantOpenAgingApiCommonDingTalkPushRequestConfig: ApiMerchantOpenAgingApiCommonDingTalkPushRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_22_0_47,
    devUrl: devUrl_0_22_0_47,
    prodUrl: prodUrl_0_22_0_47,
    path: '/merchant/openAgingApi/common/dingTalkPush',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_22_0_47,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiMerchantOpenAgingApiCommonDingTalkPush',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '钉钉消息推送', author: '511号开发' },
  }

/**
 * 接口 [钉钉消息推送↗](https://yapi.gogpay.cn/project/2492/interface/api/485042) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [开放接口-适老化调用↗](https://yapi.gogpay.cn/project/2492/interface/api/cat_85888)
 * @请求头 `POST /merchant/openAgingApi/common/dingTalkPush`
 */
export const apiMerchantOpenAgingApiCommonDingTalkPush = /*#__PURE__*/ (
  requestData: ApiMerchantOpenAgingApiCommonDingTalkPushRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiMerchantOpenAgingApiCommonDingTalkPushResponse>(
    prepare(
      apiMerchantOpenAgingApiCommonDingTalkPushRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiMerchantOpenAgingApiCommonDingTalkPush.requestConfig =
  apiMerchantOpenAgingApiCommonDingTalkPushRequestConfig

const mockUrl_0_5_0_0 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_0 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_0 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_0 = 'data' as any

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/95938) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/detail`
 */
export interface ApiOrderImsApiWriteOffOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/95938) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/detail`
 */
export interface ApiOrderImsApiWriteOffOrderDetailResponse {
  /**
   * 实收款
   */
  actualReceivable?: number
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  buyer?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: number
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品售价
   */
  commodityPrice?: number
  /**
   * 优惠金额
   */
  discount?: number
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单商品Sn码
   */
  orderSnNum?: string
  /**
   * 订单来源
   */
  orderSource?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单轨迹
   */
  orderTimeLine?: {
    /**
     * 轨迹内容
     */
    content?: string
    /**
     * 轨迹时间
     */
    time?: string
  }[]
  /**
   * 支付渠道
   */
  payChannel?: string
  /**
   * 支付流水号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 数量
   */
  quantity?: number
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 销售渠道名称
   */
  sellChannelName?: string
  /**
   * 规格信息
   */
  skuDesc?: string
  /**
   * 订单应付金额
   */
  totalPrice?: number
  /**
   * 交易状态
   */
  tradeStatus?: number
  /**
   * 交易状态文案
   */
  tradeStatusName?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户信息
   */
  userInfoList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
  }[]
  /**
   * 核销渠道
   */
  writeOffChannel?: string
  /**
   * 核销店铺
   */
  writeOffStore?: string
}

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/95938) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/detail`
 */
type ApiOrderImsApiWriteOffOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/95938) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/detail`
 */
const apiOrderImsApiWriteOffOrderDetailRequestConfig: ApiOrderImsApiWriteOffOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销订单详情', author: '成龙' },
  }

/**
 * 接口 [标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/95938) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/detail`
 */
export const apiOrderImsApiWriteOffOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderDetailResponse>(
    prepare(apiOrderImsApiWriteOffOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderDetail.requestConfig =
  apiOrderImsApiWriteOffOrderDetailRequestConfig

/**
 * 接口 [标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/95944) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/list`
 */
export interface ApiOrderImsApiWriteOffOrderListRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类
   */
  orderClassification?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 可结算类型 0不可结算 1未结算 3已结算  4部分结算 5可结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   *  300待使用   904已退款202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭
   *  902交易完结
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/95944) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/list`
 */
export interface ApiOrderImsApiWriteOffOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 售后状态文案
     */
    afterSale?: string
    /**
     * 售后状态
     */
    afterSaleStatus?: number
    /**
     * 申报剩余时间
     */
    applySupDate?: string
    appointmentInfo?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * 可结算金额
     */
    canSettlementingAmount?: number
    /**
     * 商品种类：0-套餐券 1-代金券
     */
    commodityClassifyType?: number
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品售价
     */
    commodityPrice?: number
    /**
     * 多彩宝订单编号
     */
    dcbOrderNo?: string
    /**
     * 多彩宝订单编号列表
     */
    dcbOrderNos?: string[]
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * imei1编码
     */
    imei1Code?: string
    /**
     * imei2编码
     */
    imei2Code?: string
    /**
     * 实付积分
     */
    integral?: number
    /**
     * 积分活动优惠
     */
    integralDiscountAmount?: number
    /**
     * 用户是否申请开票0否 1是
     */
    invoiceApplyInfoStatus?: number
    /**
     * 发票图片
     */
    invoiceImg?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 所需积分
     */
    needIntegral?: number
    /**
     * 申报状态失败原因
     */
    orderApplyFailReason?: string
    /**
     * 申报状态 99待申报，00已申报，待审核，01审核通过，02审核不通过，03补贴已支付
     */
    orderApplyYardGoStatus?: string
    /**
     * 申报状态描述
     */
    orderApplyYardGoStatusDesc?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单同步状态0否 1是
     */
    orderPushStatus?: number
    /**
     * 重新申报复核失败原因
     */
    orderReApplyFailReason?: string
    /**
     * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
     */
    orderReApplyYardGoStatus?: string
    /**
     * 重新申报复核状态描述
     */
    orderReApplyYardGoStatusDesc?: string
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 多彩宝批订单编号(支付流水号)
     */
    paySerialNo?: string
    /**
     * 下单时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 买家手机号码
     */
    phoneNo?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 退款状态0未申请退款 1退款中 2退款成功
     */
    refundStatus?: number
    /**
     * 退款状态文案
     */
    refundStatusText?: string
    /**
     * 订单售后状态 0未售后 1已售后
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeText?: string
    /**
     * 结算状态
     */
    settlementStatus?: string
    /**
     * 已结算金额
     */
    settlementedAmount?: number
    /**
     * 结算中金额
     */
    settlementingAmount?: number
    /**
     * 规格信息
     */
    skuDesc?: string
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 订单交易状态 "0待支付
     * 100待发货
     * 101已发货
     *
     * 200待派单
     * 201已派单
     *  300待使用   904已退款202待服务
     * 203服务中
     *
     * 900交易完成
     * 901交易关闭"
     */
    tradeStatus?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 未结算金额
     */
    unSettlementAmount?: number
    /**
     * 订单所属用户Id
     */
    userId?: string
    /**
     * 核销渠道
     */
    writeOffChannel?: string
    /**
     * 核销图片
     */
    writeOffImage?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/95944) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/list`
 */
type ApiOrderImsApiWriteOffOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/95944) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/list`
 */
const apiOrderImsApiWriteOffOrderListRequestConfig: ApiOrderImsApiWriteOffOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销订单列表', author: '成龙' },
  }

/**
 * 接口 [标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/95944) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/list`
 */
export const apiOrderImsApiWriteOffOrderList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderListResponse>(
    prepare(apiOrderImsApiWriteOffOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderList.requestConfig =
  apiOrderImsApiWriteOffOrderListRequestConfig

/**
 * 接口 [订单核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/95950) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeList`
 */
export interface ApiOrderImsApiWriteOffOrderWriteOffCodeListRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/95950) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeList`
 */
export interface ApiOrderImsApiWriteOffOrderWriteOffCodeListResponse {
  /**
   * 核销码列表
   */
  codeList?: {
    /**
     * 券码金额
     */
    amount?: number
    /**
     * 券码号码
     */
    code?: string
    /**
     * 多彩宝订单编号
     */
    dcbOrderNo?: string
    /**
     * 核销有效期
     */
    delayTime?: string
    /**
     * 券码Id，不做显示，用于标识唯一key
     */
    id?: string
    /**
     * 操作人
     */
    operationName?: string
    /**
     * 操作时间
     */
    operationTime?: string
    /**
     * 操作类型
     */
    operationType?: string
    /**
     * 状态 0未激活  1待使用  2已使用  3已冻结  4已退款  5已过期
     */
    status?: number
    /**
     * 状态名称
     */
    statusName?: string
    /**
     * 核銷店鋪
     */
    writeOffStore?: string
  }[]
  /**
   * 触发退款时是否选中全部
   */
  selectedAll?: boolean
  /**
   * 剩余可用次数
   */
  surplusCount?: number
}

/**
 * 接口 [订单核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/95950) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeList`
 */
type ApiOrderImsApiWriteOffOrderWriteOffCodeListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/writeOffCodeList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/95950) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeList`
 */
const apiOrderImsApiWriteOffOrderWriteOffCodeListRequestConfig: ApiOrderImsApiWriteOffOrderWriteOffCodeListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/writeOffCodeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderWriteOffCodeList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单核销码列表', author: '成龙' },
  }

/**
 * 接口 [订单核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/95950) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeList`
 */
export const apiOrderImsApiWriteOffOrderWriteOffCodeList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderWriteOffCodeListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderWriteOffCodeListResponse>(
    prepare(
      apiOrderImsApiWriteOffOrderWriteOffCodeListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderWriteOffCodeList.requestConfig =
  apiOrderImsApiWriteOffOrderWriteOffCodeListRequestConfig

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/906/interface/api/96886) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyRefund`
 */
export interface ApiOrderImsApiWriteOffOrderApplyRefundRequest {
  /**
   * 申请原因
   */
  applyReason?: string
  /**
   * 核销码Id列表
   */
  codeList?: string[]
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/906/interface/api/96886) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyRefund`
 */
export interface ApiOrderImsApiWriteOffOrderApplyRefundResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/906/interface/api/96886) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyRefund`
 */
type ApiOrderImsApiWriteOffOrderApplyRefundRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/applyRefund',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/906/interface/api/96886) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyRefund`
 */
const apiOrderImsApiWriteOffOrderApplyRefundRequestConfig: ApiOrderImsApiWriteOffOrderApplyRefundRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/applyRefund',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderApplyRefund',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请售后', author: '成龙' },
  }

/**
 * 接口 [申请售后↗](https://yapi.gogpay.cn/project/906/interface/api/96886) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyRefund`
 */
export const apiOrderImsApiWriteOffOrderApplyRefund = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderApplyRefundRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderApplyRefundResponse>(
    prepare(apiOrderImsApiWriteOffOrderApplyRefundRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderApplyRefund.requestConfig =
  apiOrderImsApiWriteOffOrderApplyRefundRequestConfig

/**
 * 接口 [标销订单数量统计-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104674) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/statistics`
 */
export interface ApiOrderImsApiWriteOffOrderStatisticsRequest {
  /**
   * 运营渠道列表
   */
  businessChannelId?: string[]
  /**
   * 1标电 3标虚 2标销
   */
  findType?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'
  /**
   * 用户id
   */
  userId: string
}

/**
 * 接口 [标销订单数量统计-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104674) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/statistics`
 */
export interface ApiOrderImsApiWriteOffOrderStatisticsResponse {
  /**
   * 待使用数量
   */
  unUseCount?: number
  /**
   * 待评价数量
   */
  waitEvaluateCount?: number
  /**
   * 待付款数量
   */
  waitPayCount?: number
}

/**
 * 接口 [标销订单数量统计-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104674) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/statistics`
 */
type ApiOrderImsApiWriteOffOrderStatisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/statistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销订单数量统计-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104674) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/statistics`
 */
const apiOrderImsApiWriteOffOrderStatisticsRequestConfig: ApiOrderImsApiWriteOffOrderStatisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/statistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderStatistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销订单数量统计-客户端', author: '成龙' },
  }

/**
 * 接口 [标销订单数量统计-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104674) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/statistics`
 */
export const apiOrderImsApiWriteOffOrderStatistics = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderStatisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderStatisticsResponse>(
    prepare(apiOrderImsApiWriteOffOrderStatisticsRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderStatistics.requestConfig =
  apiOrderImsApiWriteOffOrderStatisticsRequestConfig

/**
 * 接口 [导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/152217) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/export`
 */
export interface ApiOrderImsApiWriteOffOrderExportRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类
   */
  orderClassification?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 可结算类型 0不可结算 1未结算 3已结算  4部分结算 5可结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   *  300待使用   904已退款202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭
   *  902交易完结
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/152217) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/export`
 */
export interface ApiOrderImsApiWriteOffOrderExportResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/152217) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/export`
 */
type ApiOrderImsApiWriteOffOrderExportRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/export',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/152217) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/export`
 */
const apiOrderImsApiWriteOffOrderExportRequestConfig: ApiOrderImsApiWriteOffOrderExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderExport',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出标销订单', author: '成龙' },
  }

/**
 * 接口 [导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/152217) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/export`
 */
export const apiOrderImsApiWriteOffOrderExport = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderExportResponse>(
    prepare(apiOrderImsApiWriteOffOrderExportRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderExport.requestConfig =
  apiOrderImsApiWriteOffOrderExportRequestConfig

/**
 * 接口 [申请已核销售后↗](https://yapi.gogpay.cn/project/906/interface/api/271236) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyEndRefund`
 */
export interface ApiOrderImsApiWriteOffOrderApplyEndRefundRequest {
  /**
   * 申请原因
   */
  applyReason?: string
  /**
   * 核销码Id列表
   */
  codeList: {
    /**
     * 核销码
     */
    code: string
    /**
     * 退款金额
     */
    refundAmount: number
    /**
     * 结算金额
     */
    settAmount: number
  }[]
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [申请已核销售后↗](https://yapi.gogpay.cn/project/906/interface/api/271236) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyEndRefund`
 */
export interface ApiOrderImsApiWriteOffOrderApplyEndRefundResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [申请已核销售后↗](https://yapi.gogpay.cn/project/906/interface/api/271236) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyEndRefund`
 */
type ApiOrderImsApiWriteOffOrderApplyEndRefundRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/applyEndRefund',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请已核销售后↗](https://yapi.gogpay.cn/project/906/interface/api/271236) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyEndRefund`
 */
const apiOrderImsApiWriteOffOrderApplyEndRefundRequestConfig: ApiOrderImsApiWriteOffOrderApplyEndRefundRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/applyEndRefund',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderApplyEndRefund',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请已核销售后', author: '成龙' },
  }

/**
 * 接口 [申请已核销售后↗](https://yapi.gogpay.cn/project/906/interface/api/271236) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/applyEndRefund`
 */
export const apiOrderImsApiWriteOffOrderApplyEndRefund = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderApplyEndRefundRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderApplyEndRefundResponse>(
    prepare(
      apiOrderImsApiWriteOffOrderApplyEndRefundRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderApplyEndRefund.requestConfig =
  apiOrderImsApiWriteOffOrderApplyEndRefundRequestConfig

/**
 * 接口 [已核销列表↗](https://yapi.gogpay.cn/project/906/interface/api/271239) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/endCodeList`
 */
export interface ApiOrderImsApiWriteOffOrderEndCodeListRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [已核销列表↗](https://yapi.gogpay.cn/project/906/interface/api/271239) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/endCodeList`
 */
export type ApiOrderImsApiWriteOffOrderEndCodeListResponse = {
  /**
   * 可退款金额
   */
  amount?: number
  /**
   * 是否可退款
   */
  canRefund?: boolean
  /**
   * 券码号码
   */
  code?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 核销人
   */
  operationName?: string
  /**
   * 核销时间
   */
  operationTime?: string
  /**
   * 结算价
   */
  settlementAmount?: number
  /**
   * 状态 0未激活  1待使用  2已使用  3已冻结  4已退款  5已过期
   */
  status?: number
  /**
   * 状态名称
   */
  statusName?: string
}[]

/**
 * 接口 [已核销列表↗](https://yapi.gogpay.cn/project/906/interface/api/271239) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/endCodeList`
 */
type ApiOrderImsApiWriteOffOrderEndCodeListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/endCodeList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [已核销列表↗](https://yapi.gogpay.cn/project/906/interface/api/271239) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/endCodeList`
 */
const apiOrderImsApiWriteOffOrderEndCodeListRequestConfig: ApiOrderImsApiWriteOffOrderEndCodeListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/endCodeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderEndCodeList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '已核销列表', author: '成龙' },
  }

/**
 * 接口 [已核销列表↗](https://yapi.gogpay.cn/project/906/interface/api/271239) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/endCodeList`
 */
export const apiOrderImsApiWriteOffOrderEndCodeList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderEndCodeListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderEndCodeListResponse>(
    prepare(apiOrderImsApiWriteOffOrderEndCodeListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderEndCodeList.requestConfig =
  apiOrderImsApiWriteOffOrderEndCodeListRequestConfig

/**
 * 接口 [订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/426608) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/orderTabStatistics`
 */
export interface ApiOrderImsApiWriteOffOrderOrderTabStatisticsRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类
   */
  orderClassification?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 可结算类型 0不可结算 1未结算 3已结算  4部分结算 5可结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   *  300待使用   904已退款202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭
   *  902交易完结
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/426608) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/orderTabStatistics`
 */
export interface ApiOrderImsApiWriteOffOrderOrderTabStatisticsResponse {
  /**
   * 实际收款
   */
  actualReceivable?: number
  /**
   * 购买数量
   */
  buyCount?: number
  /**
   * 总优惠金额
   */
  discountAmount?: number
  /**
   * 订单笔数
   */
  orderCount?: number
}

/**
 * 接口 [订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/426608) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/orderTabStatistics`
 */
type ApiOrderImsApiWriteOffOrderOrderTabStatisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/orderTabStatistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/426608) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/orderTabStatistics`
 */
const apiOrderImsApiWriteOffOrderOrderTabStatisticsRequestConfig: ApiOrderImsApiWriteOffOrderOrderTabStatisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/orderTabStatistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderOrderTabStatistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表数量统计-标销', author: '511号开发' },
  }

/**
 * 接口 [订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/426608) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/orderTabStatistics`
 */
export const apiOrderImsApiWriteOffOrderOrderTabStatistics = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderOrderTabStatisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderOrderTabStatisticsResponse>(
    prepare(
      apiOrderImsApiWriteOffOrderOrderTabStatisticsRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderOrderTabStatistics.requestConfig =
  apiOrderImsApiWriteOffOrderOrderTabStatisticsRequestConfig

/**
 * 接口 [订单核销时间延期↗](https://yapi.gogpay.cn/project/906/interface/api/453618) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeDelay`
 */
export interface ApiOrderImsApiWriteOffOrderWriteOffCodeDelayRequest {
  /**
   * 延期截至时间
   */
  delayTime?: string
  /**
   * 中台订单编号
   */
  orderNo?: string
}

/**
 * 接口 [订单核销时间延期↗](https://yapi.gogpay.cn/project/906/interface/api/453618) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeDelay`
 */
export interface ApiOrderImsApiWriteOffOrderWriteOffCodeDelayResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [订单核销时间延期↗](https://yapi.gogpay.cn/project/906/interface/api/453618) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeDelay`
 */
type ApiOrderImsApiWriteOffOrderWriteOffCodeDelayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/writeOffCodeDelay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单核销时间延期↗](https://yapi.gogpay.cn/project/906/interface/api/453618) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeDelay`
 */
const apiOrderImsApiWriteOffOrderWriteOffCodeDelayRequestConfig: ApiOrderImsApiWriteOffOrderWriteOffCodeDelayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/writeOffCodeDelay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderWriteOffCodeDelay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单核销时间延期', author: '511号开发' },
  }

/**
 * 接口 [订单核销时间延期↗](https://yapi.gogpay.cn/project/906/interface/api/453618) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/writeOffCodeDelay`
 */
export const apiOrderImsApiWriteOffOrderWriteOffCodeDelay = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderWriteOffCodeDelayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderWriteOffCodeDelayResponse>(
    prepare(
      apiOrderImsApiWriteOffOrderWriteOffCodeDelayRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderWriteOffCodeDelay.requestConfig =
  apiOrderImsApiWriteOffOrderWriteOffCodeDelayRequestConfig

/**
 * 接口 [以旧换新标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465533) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeList`
 */
export interface ApiOrderImsApiWriteOffOrderOldChangeListRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类
   */
  orderClassification?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 可结算类型 0不可结算 1未结算 3已结算  4部分结算 5可结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   *  300待使用   904已退款202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭
   *  902交易完结
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [以旧换新标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465533) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeList`
 */
export interface ApiOrderImsApiWriteOffOrderOldChangeListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 售后状态文案
     */
    afterSale?: string
    /**
     * 售后状态
     */
    afterSaleStatus?: number
    /**
     * 申报剩余时间
     */
    applySupDate?: string
    appointmentInfo?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * 可结算金额
     */
    canSettlementingAmount?: number
    /**
     * 商品种类：0-套餐券 1-代金券
     */
    commodityClassifyType?: number
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品售价
     */
    commodityPrice?: number
    /**
     * 多彩宝订单编号
     */
    dcbOrderNo?: string
    /**
     * 多彩宝订单编号列表
     */
    dcbOrderNos?: string[]
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * imei1编码
     */
    imei1Code?: string
    /**
     * imei2编码
     */
    imei2Code?: string
    /**
     * 实付积分
     */
    integral?: number
    /**
     * 积分活动优惠
     */
    integralDiscountAmount?: number
    /**
     * 用户是否申请开票0否 1是
     */
    invoiceApplyInfoStatus?: number
    /**
     * 发票图片
     */
    invoiceImg?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 所需积分
     */
    needIntegral?: number
    /**
     * 申报状态失败原因
     */
    orderApplyFailReason?: string
    /**
     * 申报状态 99待申报，00已申报，待审核，01审核通过，02审核不通过，03补贴已支付
     */
    orderApplyYardGoStatus?: string
    /**
     * 申报状态描述
     */
    orderApplyYardGoStatusDesc?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单同步状态0否 1是
     */
    orderPushStatus?: number
    /**
     * 重新申报复核失败原因
     */
    orderReApplyFailReason?: string
    /**
     * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
     */
    orderReApplyYardGoStatus?: string
    /**
     * 重新申报复核状态描述
     */
    orderReApplyYardGoStatusDesc?: string
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 多彩宝批订单编号(支付流水号)
     */
    paySerialNo?: string
    /**
     * 下单时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 买家手机号码
     */
    phoneNo?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款金额
     */
    refundAmount?: number
    /**
     * 退款状态0未申请退款 1退款中 2退款成功
     */
    refundStatus?: number
    /**
     * 退款状态文案
     */
    refundStatusText?: string
    /**
     * 订单售后状态 0未售后 1已售后
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeText?: string
    /**
     * 结算状态
     */
    settlementStatus?: string
    /**
     * 已结算金额
     */
    settlementedAmount?: number
    /**
     * 结算中金额
     */
    settlementingAmount?: number
    /**
     * 规格信息
     */
    skuDesc?: string
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 订单交易状态 "0待支付
     * 100待发货
     * 101已发货
     *
     * 200待派单
     * 201已派单
     *  300待使用   904已退款202待服务
     * 203服务中
     *
     * 900交易完成
     * 901交易关闭"
     */
    tradeStatus?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 未结算金额
     */
    unSettlementAmount?: number
    /**
     * 订单所属用户Id
     */
    userId?: string
    /**
     * 核销渠道
     */
    writeOffChannel?: string
    /**
     * 核销图片
     */
    writeOffImage?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [以旧换新标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465533) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeList`
 */
type ApiOrderImsApiWriteOffOrderOldChangeListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/oldChangeList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [以旧换新标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465533) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeList`
 */
const apiOrderImsApiWriteOffOrderOldChangeListRequestConfig: ApiOrderImsApiWriteOffOrderOldChangeListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/oldChangeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderOldChangeList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '以旧换新标销订单列表', author: '511号开发' },
  }

/**
 * 接口 [以旧换新标销订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465533) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeList`
 */
export const apiOrderImsApiWriteOffOrderOldChangeList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderOldChangeListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderOldChangeListResponse>(
    prepare(apiOrderImsApiWriteOffOrderOldChangeListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderOldChangeList.requestConfig =
  apiOrderImsApiWriteOffOrderOldChangeListRequestConfig

/**
 * 接口 [以旧换新订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/465540) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeOrderTabStatistics`
 */
export interface ApiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类
   */
  orderClassification?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 可结算类型 0不可结算 1未结算 3已结算  4部分结算 5可结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   *  300待使用   904已退款202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭
   *  902交易完结
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [以旧换新订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/465540) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeOrderTabStatistics`
 */
export interface ApiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsResponse {
  /**
   * 实际收款
   */
  actualReceivable?: number
  /**
   * 购买数量
   */
  buyCount?: number
  /**
   * 总优惠金额
   */
  discountAmount?: number
  /**
   * 订单笔数
   */
  orderCount?: number
}

/**
 * 接口 [以旧换新订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/465540) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeOrderTabStatistics`
 */
type ApiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/writeOff/order/oldChangeOrderTabStatistics',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [以旧换新订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/465540) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeOrderTabStatistics`
 */
const apiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequestConfig: ApiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/oldChangeOrderTabStatistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiWriteOffOrderOldChangeOrderTabStatistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '以旧换新订单列表数量统计-标销', author: '511号开发' },
  }

/**
 * 接口 [以旧换新订单列表数量统计-标销↗](https://yapi.gogpay.cn/project/906/interface/api/465540) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeOrderTabStatistics`
 */
export const apiOrderImsApiWriteOffOrderOldChangeOrderTabStatistics =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsResponse>(
      prepare(
        apiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiWriteOffOrderOldChangeOrderTabStatistics.requestConfig =
  apiOrderImsApiWriteOffOrderOldChangeOrderTabStatisticsRequestConfig

/**
 * 接口 [以旧换新导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/465645) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeExport`
 */
export interface ApiOrderImsApiWriteOffOrderOldChangeExportRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类
   */
  orderClassification?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: ('0' | '1' | '2' | '3')[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 可结算类型 0不可结算 1未结算 3已结算  4部分结算 5可结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   *  300待使用   904已退款202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭
   *  902交易完结
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
}

/**
 * 接口 [以旧换新导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/465645) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeExport`
 */
export interface ApiOrderImsApiWriteOffOrderOldChangeExportResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [以旧换新导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/465645) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeExport`
 */
type ApiOrderImsApiWriteOffOrderOldChangeExportRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOff/order/oldChangeExport',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [以旧换新导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/465645) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeExport`
 */
const apiOrderImsApiWriteOffOrderOldChangeExportRequestConfig: ApiOrderImsApiWriteOffOrderOldChangeExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_0,
    devUrl: devUrl_0_5_0_0,
    prodUrl: prodUrl_0_5_0_0,
    path: '/order/imsApi/writeOff/order/oldChangeExport',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffOrderOldChangeExport',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '以旧换新导出标销订单', author: '511号开发' },
  }

/**
 * 接口 [以旧换新导出标销订单↗](https://yapi.gogpay.cn/project/906/interface/api/465645) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [标销订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21240)
 * @请求头 `POST /order/imsApi/writeOff/order/oldChangeExport`
 */
export const apiOrderImsApiWriteOffOrderOldChangeExport = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffOrderOldChangeExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffOrderOldChangeExportResponse>(
    prepare(
      apiOrderImsApiWriteOffOrderOldChangeExportRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiWriteOffOrderOldChangeExport.requestConfig =
  apiOrderImsApiWriteOffOrderOldChangeExportRequestConfig

const mockUrl_0_5_0_1 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_1 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_1 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_1 = 'data' as any

/**
 * 接口 [核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/96004) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/list`
 */
export interface ApiOrderImsApiWriteOffCodeListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 券码Id
   */
  code?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 买家手机号
   */
  phoneNo?: string
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
  /**
   * 核销时间-结束时间
   */
  writeOffEndTime?: string
  /**
   * 核销人
   */
  writeOffName?: string
  /**
   * 核销时间-开始时间
   */
  writeOffStartTime?: string
}

/**
 * 接口 [核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/96004) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/list`
 */
export interface ApiOrderImsApiWriteOffCodeListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * 券码Id
     */
    code?: string
    /**
     * 套餐内容
     */
    comboData?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品售价
     */
    commodityPrice?: number
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付编号
     */
    paySerialNo?: string
    /**
     * 买家手机号码
     */
    phoneNo?: string
    /**
     * 核销渠道
     */
    writeOffChannel?: string
    /**
     * 核销人
     */
    writeOffName?: string
    /**
     * 核销来源
     */
    writeOffSource?: string
    /**
     * 核销店铺名称
     */
    writeOffStoreName?: string
    /**
     * 核销时间
     */
    writeOffTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/96004) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/list`
 */
type ApiOrderImsApiWriteOffCodeListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/96004) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/list`
 */
const apiOrderImsApiWriteOffCodeListRequestConfig: ApiOrderImsApiWriteOffCodeListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '核销记录列表', author: '成龙' },
  }

/**
 * 接口 [核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/96004) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/list`
 */
export const apiOrderImsApiWriteOffCodeList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeListResponse>(
    prepare(apiOrderImsApiWriteOffCodeListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeList.requestConfig =
  apiOrderImsApiWriteOffCodeListRequestConfig

/**
 * 接口 [核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/97060) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/writeOff`
 */
export interface ApiOrderImsApiWriteOffCodeWriteOffRequest {
  /**
   * 核销码
   */
  code?: string
  /**
   * 核销店铺Id
   */
  storeId?: string
}

/**
 * 接口 [核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/97060) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/writeOff`
 */
export interface ApiOrderImsApiWriteOffCodeWriteOffResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/97060) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/writeOff`
 */
type ApiOrderImsApiWriteOffCodeWriteOffRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/writeOff',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/97060) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/writeOff`
 */
const apiOrderImsApiWriteOffCodeWriteOffRequestConfig: ApiOrderImsApiWriteOffCodeWriteOffRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/writeOff',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeWriteOff',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '核销核销码', author: '成龙' },
  }

/**
 * 接口 [核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/97060) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/writeOff`
 */
export const apiOrderImsApiWriteOffCodeWriteOff = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeWriteOffRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeWriteOffResponse>(
    prepare(apiOrderImsApiWriteOffCodeWriteOffRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeWriteOff.requestConfig =
  apiOrderImsApiWriteOffCodeWriteOffRequestConfig

/**
 * 接口 [核销码详情↗](https://yapi.gogpay.cn/project/906/interface/api/97084) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/detail`
 */
export interface ApiOrderImsApiWriteOffCodeDetailRequest {
  /**
   * 核销码
   */
  code?: string
  /**
   * 核销店铺Id
   */
  storeId?: string
}

/**
 * 接口 [核销码详情↗](https://yapi.gogpay.cn/project/906/interface/api/97084) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/detail`
 */
export interface ApiOrderImsApiWriteOffCodeDetailResponse {
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 运营渠道名称
   */
  businessChannelName?: string
  /**
   * 核销码
   */
  code?: string
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  commodityInfo?: {
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品Id
     */
    id?: string
    /**
     * 商品价格
     */
    price?: number
    /**
     * 规格信息
     */
    skuDesc?: string
  }
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 核销店铺列表
   */
  writeOffStoreList?: {
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 店铺名称
     */
    name?: string
  }[]
}

/**
 * 接口 [核销码详情↗](https://yapi.gogpay.cn/project/906/interface/api/97084) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/detail`
 */
type ApiOrderImsApiWriteOffCodeDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [核销码详情↗](https://yapi.gogpay.cn/project/906/interface/api/97084) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/detail`
 */
const apiOrderImsApiWriteOffCodeDetailRequestConfig: ApiOrderImsApiWriteOffCodeDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '核销码详情', author: '成龙' },
  }

/**
 * 接口 [核销码详情↗](https://yapi.gogpay.cn/project/906/interface/api/97084) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/detail`
 */
export const apiOrderImsApiWriteOffCodeDetail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeDetailResponse>(
    prepare(apiOrderImsApiWriteOffCodeDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeDetail.requestConfig =
  apiOrderImsApiWriteOffCodeDetailRequestConfig

/**
 * 接口 [冻结核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99274) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/freeze`
 */
export interface ApiOrderImsApiWriteOffCodeFreezeRequest {
  /**
   * 核销码
   */
  code?: string
  entity?: {}
  /**
   * 操作人
   */
  operationName?: string
  /**
   * 操作时间
   */
  operationTime?: string
  /**
   * 操作类型
   */
  operationType?:
    | 'WRITE_OFF'
    | 'PAYED'
    | 'APPLY_REFUND'
    | 'AGREE_REFUND'
    | 'REFUSE_REFUND'
    | 'EXPIRE'
  /**
   * 售后Id
   */
  saleId?: string
}

/**
 * 接口 [冻结核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99274) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/freeze`
 */
export interface ApiOrderImsApiWriteOffCodeFreezeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [冻结核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99274) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/freeze`
 */
type ApiOrderImsApiWriteOffCodeFreezeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/freeze',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [冻结核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99274) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/freeze`
 */
const apiOrderImsApiWriteOffCodeFreezeRequestConfig: ApiOrderImsApiWriteOffCodeFreezeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/freeze',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeFreeze',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '冻结核销码', author: '成龙' },
  }

/**
 * 接口 [冻结核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99274) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/freeze`
 */
export const apiOrderImsApiWriteOffCodeFreeze = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeFreezeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeFreezeResponse>(
    prepare(apiOrderImsApiWriteOffCodeFreezeRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeFreeze.requestConfig =
  apiOrderImsApiWriteOffCodeFreezeRequestConfig

/**
 * 接口 [退款核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99280) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/refundCode`
 */
export interface ApiOrderImsApiWriteOffCodeRefundCodeRequest {
  /**
   * 核销码
   */
  code?: string
  entity?: {}
  /**
   * 操作人
   */
  operationName?: string
  /**
   * 操作时间
   */
  operationTime?: string
  /**
   * 操作类型
   */
  operationType?:
    | 'WRITE_OFF'
    | 'PAYED'
    | 'APPLY_REFUND'
    | 'AGREE_REFUND'
    | 'REFUSE_REFUND'
    | 'EXPIRE'
  /**
   * 售后Id
   */
  saleId?: string
}

/**
 * 接口 [退款核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99280) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/refundCode`
 */
export interface ApiOrderImsApiWriteOffCodeRefundCodeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [退款核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99280) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/refundCode`
 */
type ApiOrderImsApiWriteOffCodeRefundCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/refundCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [退款核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99280) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/refundCode`
 */
const apiOrderImsApiWriteOffCodeRefundCodeRequestConfig: ApiOrderImsApiWriteOffCodeRefundCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/refundCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeRefundCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '退款核销码', author: '成龙' },
  }

/**
 * 接口 [退款核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99280) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/refundCode`
 */
export const apiOrderImsApiWriteOffCodeRefundCode = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeRefundCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeRefundCodeResponse>(
    prepare(apiOrderImsApiWriteOffCodeRefundCodeRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeRefundCode.requestConfig =
  apiOrderImsApiWriteOffCodeRefundCodeRequestConfig

/**
 * 接口 [解冻核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99286) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/unfreeze`
 */
export interface ApiOrderImsApiWriteOffCodeUnfreezeRequest {
  /**
   * 核销码
   */
  code?: string
  entity?: {}
  /**
   * 操作人
   */
  operationName?: string
  /**
   * 操作时间
   */
  operationTime?: string
  /**
   * 操作类型
   */
  operationType?:
    | 'WRITE_OFF'
    | 'PAYED'
    | 'APPLY_REFUND'
    | 'AGREE_REFUND'
    | 'REFUSE_REFUND'
    | 'EXPIRE'
  /**
   * 售后Id
   */
  saleId?: string
}

/**
 * 接口 [解冻核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99286) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/unfreeze`
 */
export interface ApiOrderImsApiWriteOffCodeUnfreezeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [解冻核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99286) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/unfreeze`
 */
type ApiOrderImsApiWriteOffCodeUnfreezeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/unfreeze',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [解冻核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99286) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/unfreeze`
 */
const apiOrderImsApiWriteOffCodeUnfreezeRequestConfig: ApiOrderImsApiWriteOffCodeUnfreezeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/unfreeze',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeUnfreeze',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '解冻核销码', author: '成龙' },
  }

/**
 * 接口 [解冻核销码↗](https://yapi.gogpay.cn/project/906/interface/api/99286) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/unfreeze`
 */
export const apiOrderImsApiWriteOffCodeUnfreeze = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeUnfreezeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeUnfreezeResponse>(
    prepare(apiOrderImsApiWriteOffCodeUnfreezeRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeUnfreeze.requestConfig =
  apiOrderImsApiWriteOffCodeUnfreezeRequestConfig

/**
 * 接口 [导出核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/154197) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/export`
 */
export interface ApiOrderImsApiWriteOffCodeExportRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 券码Id
   */
  code?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 买家手机号
   */
  phoneNo?: string
  /**
   * 核销渠道 0多彩宝 1智游宝 2天时同城  3镇远九州
   */
  writeOffChannel?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '13'
  /**
   * 核销时间-结束时间
   */
  writeOffEndTime?: string
  /**
   * 核销人
   */
  writeOffName?: string
  /**
   * 核销时间-开始时间
   */
  writeOffStartTime?: string
}

/**
 * 接口 [导出核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/154197) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/export`
 */
export type ApiOrderImsApiWriteOffCodeExportResponse = {
  /**
   * 实收款
   */
  actualReceivable?: number
  /**
   * 运营渠道名称
   */
  businessChannelName?: string
  /**
   * 券码Id
   */
  code?: string
  /**
   * 套餐内容
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品售价
   */
  commodityPrice?: number
  /**
   * 优惠金额
   */
  discount?: number
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 买家手机号码
   */
  phoneNo?: string
  /**
   * 核销渠道
   */
  writeOffChannel?: string
  /**
   * 核销人
   */
  writeOffName?: string
  /**
   * 核销来源
   */
  writeOffSource?: string
  /**
   * 核销店铺名称
   */
  writeOffStoreName?: string
  /**
   * 核销时间
   */
  writeOffTime?: string
}[]

/**
 * 接口 [导出核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/154197) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/export`
 */
type ApiOrderImsApiWriteOffCodeExportRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/writeOffCode/export',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/154197) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/export`
 */
const apiOrderImsApiWriteOffCodeExportRequestConfig: ApiOrderImsApiWriteOffCodeExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_1,
    devUrl: devUrl_0_5_0_1,
    prodUrl: prodUrl_0_5_0_1,
    path: '/order/imsApi/writeOffCode/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiWriteOffCodeExport',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出核销记录列表', author: '成龙' },
  }

/**
 * 接口 [导出核销记录列表↗](https://yapi.gogpay.cn/project/906/interface/api/154197) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21243)
 * @请求头 `POST /order/imsApi/writeOffCode/export`
 */
export const apiOrderImsApiWriteOffCodeExport = /*#__PURE__*/ (
  requestData: ApiOrderImsApiWriteOffCodeExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiWriteOffCodeExportResponse>(
    prepare(apiOrderImsApiWriteOffCodeExportRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiWriteOffCodeExport.requestConfig =
  apiOrderImsApiWriteOffCodeExportRequestConfig

const mockUrl_0_5_0_2 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_2 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_2 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_2 = 'data' as any

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99262) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/detail`
 */
export interface ApiOrderWriteOffOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99262) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/detail`
 */
export interface ApiOrderWriteOffOrderDetailResponse {
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 券码列表
   */
  codeList?: {
    /**
     * 券码
     */
    code?: string
    /**
     * 售后Id，券码状态=13或者14时有值
     */
    saleId?: string
    /**
     * 券码状态 11待使用  12已使用  13退款中  14已退款 15已过期
     */
    status?: number
    /**
     * 券码状态文案
     */
    statusName?: string
  }[]
  /**
   * 券码使用类型 1多张券码   2单券码多次使用  3外部核销
   */
  codeType?: number
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: number
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 当前可用券码
   */
  currentCode?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluationStatus?: number
  expireDate?: string
  /**
   * 有效期
   */
  expireTime?: string
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 多彩豆
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  /**
   * 门店详细地址
   */
  merchantAddress?: string
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 营业时间
   */
  merchantOpenPeriod?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额(优惠前)
   */
  orderAmount?: number
  /**
   * 订单分类  2标准核销 5组合订单
   */
  orderClassify?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 支付/待支付金额（优惠后)
   */
  payAmount?: number
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 温馨提示
   */
  purchaseNotesDetail?: string
  /**
   * 核销二维码数据（兼容)
   */
  qrCodeData?: string
  /**
   * 核销二维码生成数据
   */
  qrCodeDataList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
    /**
     * 二维码数据
     */
    qrCodeData?: string
  }[]
  /**
   * 数量
   */
  quantity?: number
  /**
   * 备注
   */
  remark?: string
  /**
   * 退款状态 0未申请 1已申请 2已使用
   */
  saleStatus?: number
  /**
   * 规格信息
   */
  skuDesc?: string
  /**
   * sku id
   */
  skuId?: string
  /**
   * 订单状态 0待支付
   * 300待使用900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 使用日期/库存日期
   */
  stockDate?: string
  /**
   * 剩余券码可用数量
   */
  surplusCodeCount?: number
  /**
   * 商品单价
   */
  unitPrice?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
  /**
   * 游玩用户信息
   */
  userInfoList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
  }[]
  writeOffStores?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic?: string
    /**
     * 主店店铺url
     */
    storeUrl: string
  }[]
  /**
   * 消费时间
   */
  writeOffTime?: string
  /**
   * 经度
   */
  merchantLongitude?: string
  /**
   * 纬度
   */
  merchantLatitude?: string
  /**
   * 店铺链接(客户端)
   */
  storeUrl?: string
}

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99262) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/detail`
 */
type ApiOrderWriteOffOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOffOrder/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99262) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/detail`
 */
const apiOrderWriteOffOrderDetailRequestConfig: ApiOrderWriteOffOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_2,
    devUrl: devUrl_0_5_0_2,
    prodUrl: prodUrl_0_5_0_2,
    path: '/order/api/writeOffOrder/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单详情-客户端', author: '成龙' },
  }

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99262) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/detail`
 */
export const apiOrderWriteOffOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffOrderDetailResponse>(
    prepare(apiOrderWriteOffOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffOrderDetail.requestConfig =
  apiOrderWriteOffOrderDetailRequestConfig

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99268) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/list`
 */
export interface ApiOrderWriteOffOrderListRequest {
  clientType?: '1' | '2' | '3' | '4'
  /**
   * 商品Id
   */
  commodityIdList?: string[]
  headerChannel?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 订单状态 0全部 1待付款 2待使用  3待评价 4有效订单（TV）
   */
  status?: number
  /**
   * 店铺机构编码列表
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99268) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/list`
 */
export interface ApiOrderWriteOffOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    countDownTime?: {
      /**
       * 自动取消订单时效（毫秒)
       */
      cancelOrderCountDown?: number
      /**
       * 关闭订单时效（毫秒）
       */
      closeCountDown?: number
      /**
       * 自动确认收货时效（毫秒）
       */
      confirmCountDown?: number
      /**
       * 发货（派单）倒计时（毫秒）
       */
      shippingCountDown?: number
    }
    /**
     * 评价状态 0未评价 1已评价
     */
    evaluationStatus?: number
    /**
     * 券码有效期
     */
    expireTime?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 订单金额(优惠前)
     */
    orderAmount?: number
    /**
     * 订单种类 2标准核销  5组合订单
     */
    orderClassify?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 支付/待支付金额（优惠后)
     */
    payAmount?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款状态 0未申请 1已申请 2已使用
     */
    saleStatus?: number
    /**
     * 规格描述
     */
    skuDesc?: string
    /**
     * sku id
     */
    skuId?: string
    /**
     * 订单状态 0待支付
     * 300待使用900交易完成
     * 901交易关闭"902交易完结
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99268) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/list`
 */
type ApiOrderWriteOffOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOffOrder/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99268) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/list`
 */
const apiOrderWriteOffOrderListRequestConfig: ApiOrderWriteOffOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_2,
    devUrl: devUrl_0_5_0_2,
    prodUrl: prodUrl_0_5_0_2,
    path: '/order/api/writeOffOrder/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表-客户端', author: '成龙' },
  }

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/99268) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单服务-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21525)
 * @请求头 `POST /order/api/writeOffOrder/list`
 */
export const apiOrderWriteOffOrderList = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffOrderListResponse>(
    prepare(apiOrderWriteOffOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffOrderList.requestConfig = apiOrderWriteOffOrderListRequestConfig

const mockUrl_0_5_0_3 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_3 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_3 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_3 = 'data' as any

/**
 * 接口 [获取扫码结果↗](https://yapi.gogpay.cn/project/906/interface/api/100486) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/preWriteOffInfo`
 */
export interface ApiOrderWriteOffPreWriteOffInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取扫码结果↗](https://yapi.gogpay.cn/project/906/interface/api/100486) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/preWriteOffInfo`
 */
export interface ApiOrderWriteOffPreWriteOffInfoResponse {
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 核销码列表
   */
  codeList?: string[]
  /**
   * 券码使用类型 1多张券码   2单券码多次使用
   */
  codeType?: number
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品售价
   */
  commodityPrice?: number
  /**
   * 错误消息
   */
  errorMsg?: string
  /**
   * 有效期
   */
  expireTime?: string
  /**
   * 是否具有核销权限
   */
  hasPeri?: boolean
  /**
   * 营业时间
   */
  merchantOpenPeriod?: string
  /**
   * 是否需要填写sn码 0否 1是
   */
  needPutSnCode?: number
  /**
   * 剩余数量/次数
   */
  surplusCount?: number
  /**
   * 核销店铺列表
   */
  writeOffStoreList?: {
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 店铺名称
     */
    name?: string
  }[]
}

/**
 * 接口 [获取扫码结果↗](https://yapi.gogpay.cn/project/906/interface/api/100486) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/preWriteOffInfo`
 */
type ApiOrderWriteOffPreWriteOffInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/preWriteOffInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取扫码结果↗](https://yapi.gogpay.cn/project/906/interface/api/100486) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/preWriteOffInfo`
 */
const apiOrderWriteOffPreWriteOffInfoRequestConfig: ApiOrderWriteOffPreWriteOffInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/preWriteOffInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffPreWriteOffInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取扫码结果', author: '成龙' },
  }

/**
 * 接口 [获取扫码结果↗](https://yapi.gogpay.cn/project/906/interface/api/100486) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/preWriteOffInfo`
 */
export const apiOrderWriteOffPreWriteOffInfo = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffPreWriteOffInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffPreWriteOffInfoResponse>(
    prepare(apiOrderWriteOffPreWriteOffInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffPreWriteOffInfo.requestConfig =
  apiOrderWriteOffPreWriteOffInfoRequestConfig

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/100492) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/userStoreList`
 */
export interface ApiOrderWriteOffUserStoreListRequest {}

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/100492) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/userStoreList`
 */
export type ApiOrderWriteOffUserStoreListResponse = {
  /**
   * 是否默认选中
   */
  defaultChoose?: boolean
  /**
   * logo图片
   */
  logo?: string
  /**
   * 店铺Id，核销店铺Id
   */
  merchantId?: string
  /**
   * 店铺名称
   */
  merchantName?: string
  /**
   * 公告
   */
  notice?: string
}[]

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/100492) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/userStoreList`
 */
type ApiOrderWriteOffUserStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/userStoreList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/100492) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/userStoreList`
 */
const apiOrderWriteOffUserStoreListRequestConfig: ApiOrderWriteOffUserStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/userStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffUserStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺列表', author: '成龙' },
  }

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/100492) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/userStoreList`
 */
export const apiOrderWriteOffUserStoreList = /*#__PURE__*/ (
  requestData?: ApiOrderWriteOffUserStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffUserStoreListResponse>(
    prepare(apiOrderWriteOffUserStoreListRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffUserStoreList.requestConfig =
  apiOrderWriteOffUserStoreListRequestConfig

/**
 * 接口 [核销↗](https://yapi.gogpay.cn/project/906/interface/api/100498) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOff`
 */
export interface ApiOrderWriteOffWriteOffRequest {
  /**
   * 券码列表
   */
  code?: string[]
  /**
   * 核销商品Sn码
   */
  orderSnNum?: string
  /**
   * 核销店铺Id
   */
  storeId?: string
  /**
   * 核销图片
   */
  writeOffImage?: string
}

/**
 * 接口 [核销↗](https://yapi.gogpay.cn/project/906/interface/api/100498) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOff`
 */
export type ApiOrderWriteOffWriteOffResponse = {
  /**
   * 券码
   */
  code?: string
  /**
   * 核销结果
   */
  msg?: string
  /**
   * 是否成功
   */
  success?: boolean
}[]

/**
 * 接口 [核销↗](https://yapi.gogpay.cn/project/906/interface/api/100498) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOff`
 */
type ApiOrderWriteOffWriteOffRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/writeOff',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [核销↗](https://yapi.gogpay.cn/project/906/interface/api/100498) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOff`
 */
const apiOrderWriteOffWriteOffRequestConfig: ApiOrderWriteOffWriteOffRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/writeOff',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffWriteOff',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '核销', author: '成龙' },
  }

/**
 * 接口 [核销↗](https://yapi.gogpay.cn/project/906/interface/api/100498) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOff`
 */
export const apiOrderWriteOffWriteOff = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffWriteOffRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffWriteOffResponse>(
    prepare(apiOrderWriteOffWriteOffRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffWriteOff.requestConfig = apiOrderWriteOffWriteOffRequestConfig

/**
 * 接口 [获取核销详情↗](https://yapi.gogpay.cn/project/906/interface/api/100504) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffDetail`
 */
export interface ApiOrderWriteOffWriteOffDetailRequest {
  /**
   * 核销码
   */
  code?: string
  /**
   * 核销店铺Id
   */
  storeId?: string
}

/**
 * 接口 [获取核销详情↗](https://yapi.gogpay.cn/project/906/interface/api/100504) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffDetail`
 */
export interface ApiOrderWriteOffWriteOffDetailResponse {
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 核销码
   */
  code?: string
  /**
   * 券码使用类型 1多张券码   2单券码多次使用
   */
  codeType?: number
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品售价
   */
  commodityPrice?: number
  /**
   * 有效期
   */
  expireTime?: string
  /**
   * 营业时间
   */
  merchantOpenPeriod?: string
  /**
   * 核销人
   */
  writeOffName?: string
  /**
   * 核销来源
   */
  writeOffSource?: string
  /**
   * 核销店铺列表
   */
  writeOffStoreList?: {
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 店铺名称
     */
    name?: string
  }[]
  /**
   * 核销时间
   */
  writeOffTime?: string
}

/**
 * 接口 [获取核销详情↗](https://yapi.gogpay.cn/project/906/interface/api/100504) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffDetail`
 */
type ApiOrderWriteOffWriteOffDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/writeOffDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取核销详情↗](https://yapi.gogpay.cn/project/906/interface/api/100504) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffDetail`
 */
const apiOrderWriteOffWriteOffDetailRequestConfig: ApiOrderWriteOffWriteOffDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/writeOffDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffWriteOffDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取核销详情', author: '成龙' },
  }

/**
 * 接口 [获取核销详情↗](https://yapi.gogpay.cn/project/906/interface/api/100504) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffDetail`
 */
export const apiOrderWriteOffWriteOffDetail = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffWriteOffDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffWriteOffDetailResponse>(
    prepare(apiOrderWriteOffWriteOffDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffWriteOffDetail.requestConfig =
  apiOrderWriteOffWriteOffDetailRequestConfig

/**
 * 接口 [获取核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/100510) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffList`
 */
export interface ApiOrderWriteOffWriteOffListRequest {
  /**
   * 核销码(模糊匹配)
   */
  code?: string
  /**
   * 商户店铺Id
   */
  merchantId: string
  /**
   * 核销日期
   */
  writeOffDate: string
}

/**
 * 接口 [获取核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/100510) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffList`
 */
export type ApiOrderWriteOffWriteOffListResponse = {
  /**
   * 券码
   */
  code?: string
  /**
   * 标题
   */
  title?: string
}[]

/**
 * 接口 [获取核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/100510) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffList`
 */
type ApiOrderWriteOffWriteOffListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/writeOffList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/100510) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffList`
 */
const apiOrderWriteOffWriteOffListRequestConfig: ApiOrderWriteOffWriteOffListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/writeOffList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffWriteOffList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取核销记录', author: '成龙' },
  }

/**
 * 接口 [获取核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/100510) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/writeOffList`
 */
export const apiOrderWriteOffWriteOffList = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffWriteOffListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffWriteOffListResponse>(
    prepare(apiOrderWriteOffWriteOffListRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffWriteOffList.requestConfig =
  apiOrderWriteOffWriteOffListRequestConfig

/**
 * 接口 [切换选中店铺↗](https://yapi.gogpay.cn/project/906/interface/api/101428) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/chooseStore`
 */
export interface ApiOrderWriteOffChooseStoreRequest {
  /**
   * 商户店铺Id
   */
  merchantId: string
}

/**
 * 接口 [切换选中店铺↗](https://yapi.gogpay.cn/project/906/interface/api/101428) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/chooseStore`
 */
export interface ApiOrderWriteOffChooseStoreResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [切换选中店铺↗](https://yapi.gogpay.cn/project/906/interface/api/101428) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/chooseStore`
 */
type ApiOrderWriteOffChooseStoreRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/chooseStore',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [切换选中店铺↗](https://yapi.gogpay.cn/project/906/interface/api/101428) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/chooseStore`
 */
const apiOrderWriteOffChooseStoreRequestConfig: ApiOrderWriteOffChooseStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/chooseStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffChooseStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '切换选中店铺', author: '成龙' },
  }

/**
 * 接口 [切换选中店铺↗](https://yapi.gogpay.cn/project/906/interface/api/101428) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/chooseStore`
 */
export const apiOrderWriteOffChooseStore = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffChooseStoreRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffChooseStoreResponse>(
    prepare(apiOrderWriteOffChooseStoreRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffChooseStore.requestConfig =
  apiOrderWriteOffChooseStoreRequestConfig

/**
 * 接口 [获取用户上传图片识别信息↗](https://yapi.gogpay.cn/project/906/interface/api/459183) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/getImgSnCode`
 */
export interface ApiOrderWriteOffGetImgSnCodeRequest {
  /**
   * file
   */
  file: FileData
}

/**
 * 接口 [获取用户上传图片识别信息↗](https://yapi.gogpay.cn/project/906/interface/api/459183) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/getImgSnCode`
 */
export interface ApiOrderWriteOffGetImgSnCodeResponse {
  codesResult?: {
    text?: string
    type?: string
  }[]
  codesResultNum?: number
  logId?: string
}

/**
 * 接口 [获取用户上传图片识别信息↗](https://yapi.gogpay.cn/project/906/interface/api/459183) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/getImgSnCode`
 */
type ApiOrderWriteOffGetImgSnCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/writeOff/getImgSnCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户上传图片识别信息↗](https://yapi.gogpay.cn/project/906/interface/api/459183) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/getImgSnCode`
 */
const apiOrderWriteOffGetImgSnCodeRequestConfig: ApiOrderWriteOffGetImgSnCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_3,
    devUrl: devUrl_0_5_0_3,
    prodUrl: prodUrl_0_5_0_3,
    path: '/order/api/writeOff/getImgSnCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderWriteOffGetImgSnCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户上传图片识别信息', author: '511号开发' },
  }

/**
 * 接口 [获取用户上传图片识别信息↗](https://yapi.gogpay.cn/project/906/interface/api/459183) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [商家核销↗](https://yapi.gogpay.cn/project/906/interface/api/cat_21726)
 * @请求头 `POST /order/api/writeOff/getImgSnCode`
 */
export const apiOrderWriteOffGetImgSnCode = /*#__PURE__*/ (
  requestData: ApiOrderWriteOffGetImgSnCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderWriteOffGetImgSnCodeResponse>(
    prepare(apiOrderWriteOffGetImgSnCodeRequestConfig, requestData),
    ...args,
  )
}

apiOrderWriteOffGetImgSnCode.requestConfig =
  apiOrderWriteOffGetImgSnCodeRequestConfig

const mockUrl_0_5_0_4 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_4 = 'data' as any

/**
 * 接口 [通过审批↗](https://yapi.gogpay.cn/project/906/interface/api/104212) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/agree`
 */
export interface ApiOrderImsApiOrderSettlementAgreeRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [通过审批↗](https://yapi.gogpay.cn/project/906/interface/api/104212) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/agree`
 */
export interface ApiOrderImsApiOrderSettlementAgreeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [通过审批↗](https://yapi.gogpay.cn/project/906/interface/api/104212) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/agree`
 */
type ApiOrderImsApiOrderSettlementAgreeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/agree',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [通过审批↗](https://yapi.gogpay.cn/project/906/interface/api/104212) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/agree`
 */
const apiOrderImsApiOrderSettlementAgreeRequestConfig: ApiOrderImsApiOrderSettlementAgreeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/agree',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementAgree',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '通过审批', author: '成龙' },
  }

/**
 * 接口 [通过审批↗](https://yapi.gogpay.cn/project/906/interface/api/104212) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/agree`
 */
export const apiOrderImsApiOrderSettlementAgree = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementAgreeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementAgreeResponse>(
    prepare(apiOrderImsApiOrderSettlementAgreeRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderSettlementAgree.requestConfig =
  apiOrderImsApiOrderSettlementAgreeRequestConfig

/**
 * 接口 [按订单创建提单申请↗](https://yapi.gogpay.cn/project/906/interface/api/104218) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime`
 */
export interface ApiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 提单订单列表（多彩宝订单号）
   */
  orderNoList?: string[]
  /**
   * 机构号列表
   */
  orgCodeList?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 支付开始日期 yyyy-MM-dd
   */
  payStartDate?: string
}

/**
 * 接口 [按订单创建提单申请↗](https://yapi.gogpay.cn/project/906/interface/api/104218) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime`
 */
export interface ApiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeResponse {
  /**
   * 失败订单数
   */
  failedOrderTotal?: number
  /**
   * 打款申请失败信息
   */
  payApplyFailedMessage?: string
  /**
   * 结算申请失败订单列表
   */
  payApplyFailedOrderList?: {
    /**
     * 实付金额
     */
    actualAmt?: string
    /**
     * 订单金额
     */
    amt?: string
    /**
     * 优惠金额
     */
    discountAmt?: string
    /**
     * 失败原因
     */
    failureReason?: string
    /**
     * 分润金额
     */
    feeAmt?: string
    /**
     * 商品结算价
     */
    goodsAmt?: string
    /**
     * 数量
     */
    goodsCount?: number
    /**
     * 商品名称
     */
    goodsName?: string
    /**
     * 规格
     */
    goodsSku?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 手续费金额
     */
    payChannelAmt?: string
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 结算金额
     */
    settlementAmt?: string
  }[]
  /**
   * 结算申请机构列表
   */
  payApplyOrgResultList?: {
    /**
     * 机构编号
     */
    orgCode?: string
    /**
     * 机构名称
     */
    orgName?: string
    /**
     * 打款流水号
     */
    payOrgSerialNumber?: string
    /**
     * 提单结果
     */
    result?: boolean
    /**
     * 提单结果备注
     */
    resultRemark?: string
  }[]
  /**
   * 打款申请是否成功
   */
  payApplySuccess?: boolean
  /**
   * 打款流水号
   */
  payOrgSerialNumber?: string
  /**
   * 成功订单数
   */
  successOrderTotal?: number
}

/**
 * 接口 [按订单创建提单申请↗](https://yapi.gogpay.cn/project/906/interface/api/104218) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime`
 */
type ApiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [按订单创建提单申请↗](https://yapi.gogpay.cn/project/906/interface/api/104218) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime`
 */
const apiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequestConfig: ApiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTime',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '按订单创建提单申请', author: '成龙' },
  }

/**
 * 接口 [按订单创建提单申请↗](https://yapi.gogpay.cn/project/906/interface/api/104218) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/createOrderPayRecordByOrgAndPayTime`
 */
export const apiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTime =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeResponse>(
      prepare(
        apiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTime.requestConfig =
  apiOrderImsApiOrderSettlementCreateOrderPayRecordByOrgAndPayTimeRequestConfig

/**
 * 接口 [拒绝审批↗](https://yapi.gogpay.cn/project/906/interface/api/104224) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/disAgree`
 */
export interface ApiOrderImsApiOrderSettlementDisAgreeRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [拒绝审批↗](https://yapi.gogpay.cn/project/906/interface/api/104224) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/disAgree`
 */
export interface ApiOrderImsApiOrderSettlementDisAgreeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [拒绝审批↗](https://yapi.gogpay.cn/project/906/interface/api/104224) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/disAgree`
 */
type ApiOrderImsApiOrderSettlementDisAgreeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/disAgree',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [拒绝审批↗](https://yapi.gogpay.cn/project/906/interface/api/104224) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/disAgree`
 */
const apiOrderImsApiOrderSettlementDisAgreeRequestConfig: ApiOrderImsApiOrderSettlementDisAgreeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/disAgree',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementDisAgree',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '拒绝审批', author: '成龙' },
  }

/**
 * 接口 [拒绝审批↗](https://yapi.gogpay.cn/project/906/interface/api/104224) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/disAgree`
 */
export const apiOrderImsApiOrderSettlementDisAgree = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementDisAgreeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementDisAgreeResponse>(
    prepare(apiOrderImsApiOrderSettlementDisAgreeRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderSettlementDisAgree.requestConfig =
  apiOrderImsApiOrderSettlementDisAgreeRequestConfig

/**
 * 接口 [获取提单详情数据↗](https://yapi.gogpay.cn/project/906/interface/api/104230) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getOrderPayRecordDetail`
 */
export interface ApiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [获取提单详情数据↗](https://yapi.gogpay.cn/project/906/interface/api/104230) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getOrderPayRecordDetail`
 */
export interface ApiOrderImsApiOrderSettlementGetOrderPayRecordDetailResponse {
  commoditySettleDTO?: {
    /**
     * 商品数量
     */
    goodsAmount?: number
    /**
     * 商品类型数量
     */
    goodsCategoryAmount?: number
    /**
     * 订单数量
     */
    orderAmount?: number
    /**
     * 支付结束时间
     */
    payEndTime?: string
    /**
     * 支付开始时间
     */
    payStartTime?: string
    /**
     * 本次结算金额
     */
    settleAmt?: number
  }
  orgAccountInfoDTO?: {
    /**
     * 收款银行账户
     */
    bankUserCode?: string
    /**
     * 收款账户名称
     */
    bankUserName?: string
    /**
     * 结算周期
     */
    dcbSettlePeriod?: string
    /**
     * 机构编码
     */
    orgCode?: string
    /**
     * 机构名称
     */
    orgName?: string
    /**
     * 业务类型
     */
    serviceType?: string
    /**
     * 结算时间类型
     */
    settlePeriodType?: string
    /**
     * 结算时间
     */
    settlePeriodValue?: string
    /**
     * 结算方式
     */
    settleType?: string
    /**
     * 社会统一信用代码
     */
    socialUnifiedCreditCode?: string
  }
  payOrgRecordFlowStepDTO?: {
    /**
     * 当前处理的步骤序号
     */
    currentIndex?: number
    /**
     * 结算单处理流程数据
     */
    flowStepUnitDTOList?: {
      /**
       * 当前步骤序号
       */
      flowStepIndex?: number
      /**
       * 当前步骤名称
       */
      flowStepName?: string
      /**
       * 当前步骤备注
       */
      flowStepRemark?: string
      /**
       * 当前步骤时间
       */
      flowStepTime?: string
    }[]
  }
  payOrgRecordSettleDataTotalDTO?: {
    /**
     * 订单金额总计
     */
    totalAmt?: number
    /**
     * 已结算金额
     */
    totalSettledAmt?: number
    /**
     * 结算中
     */
    totalSettlingAmt?: number
    /**
     * 未结算金额
     */
    totalUnsettledAmt?: number
  }
  settlementTotalDTO?: {
    /**
     * 汇总数据列表
     */
    settlementTotalUnitDTOList?: {
      /**
       * 汇总数据key
       */
      totalKey?: string
      /**
       * 汇总数据描述
       */
      totalLabel?: string
      /**
       * 汇总数据值
       */
      totalValue?: {}
    }[]
  }
  /**
   * 可结算金额
   */
  totalBillableAmt?: number
  /**
   * 已结算金额
   */
  totalSettledAmt?: number
  /**
   * 结算中金额
   */
  totalSettlingAmt?: number
  /**
   * 未结算金额
   */
  totalWaitingSettleAmt?: number
}

/**
 * 接口 [获取提单详情数据↗](https://yapi.gogpay.cn/project/906/interface/api/104230) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getOrderPayRecordDetail`
 */
type ApiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/getOrderPayRecordDetail',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取提单详情数据↗](https://yapi.gogpay.cn/project/906/interface/api/104230) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getOrderPayRecordDetail`
 */
const apiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequestConfig: ApiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/getOrderPayRecordDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementGetOrderPayRecordDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取提单详情数据', author: '成龙' },
  }

/**
 * 接口 [获取提单详情数据↗](https://yapi.gogpay.cn/project/906/interface/api/104230) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getOrderPayRecordDetail`
 */
export const apiOrderImsApiOrderSettlementGetOrderPayRecordDetail =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementGetOrderPayRecordDetailResponse>(
      prepare(
        apiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementGetOrderPayRecordDetail.requestConfig =
  apiOrderImsApiOrderSettlementGetOrderPayRecordDetailRequestConfig

/**
 * 接口 [获取结算单详情中的商品结算信息↗](https://yapi.gogpay.cn/project/906/interface/api/104236) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordGoodsData`
 */
export interface ApiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [获取结算单详情中的商品结算信息↗](https://yapi.gogpay.cn/project/906/interface/api/104236) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordGoodsData`
 */
export interface ApiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品数量
     */
    goodsAmount?: number
    /**
     * 税收类目
     */
    taxCategory?: string
    /**
     * 结算总价
     */
    totalAmt?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取结算单详情中的商品结算信息↗](https://yapi.gogpay.cn/project/906/interface/api/104236) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordGoodsData`
 */
type ApiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/getPayOrgRecordGoodsData',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取结算单详情中的商品结算信息↗](https://yapi.gogpay.cn/project/906/interface/api/104236) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordGoodsData`
 */
const apiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequestConfig: ApiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/getPayOrgRecordGoodsData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementGetPayOrgRecordGoodsData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取结算单详情中的商品结算信息', author: '成龙' },
  }

/**
 * 接口 [获取结算单详情中的商品结算信息↗](https://yapi.gogpay.cn/project/906/interface/api/104236) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordGoodsData`
 */
export const apiOrderImsApiOrderSettlementGetPayOrgRecordGoodsData =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataResponse>(
      prepare(
        apiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementGetPayOrgRecordGoodsData.requestConfig =
  apiOrderImsApiOrderSettlementGetPayOrgRecordGoodsDataRequestConfig

/**
 * 接口 [获取结算单详情中的订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104242) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getSettlementOrderDetailPage`
 */
export interface ApiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [获取结算单详情中的订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104242) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getSettlementOrderDetailPage`
 */
export interface ApiOrderImsApiOrderSettlementGetSettlementOrderDetailPageResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单属性
     */
    settlementOrderDetailUnitDTOList?: {
      /**
       * 订单属性排序
       */
      attributionSortIndex?: number
      /**
       * 订单属性key
       */
      orderAttributionKey?: string
      /**
       * 订单属性描述
       */
      orderAttributionLabel?: string
      /**
       * 订单属性值
       */
      orderAttributionValue?: {}[]
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取结算单详情中的订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104242) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getSettlementOrderDetailPage`
 */
type ApiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/getSettlementOrderDetailPage',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取结算单详情中的订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104242) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getSettlementOrderDetailPage`
 */
const apiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequestConfig: ApiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/getSettlementOrderDetailPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementGetSettlementOrderDetailPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取结算单详情中的订单明细', author: '成龙' },
  }

/**
 * 接口 [获取结算单详情中的订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104242) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getSettlementOrderDetailPage`
 */
export const apiOrderImsApiOrderSettlementGetSettlementOrderDetailPage =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementGetSettlementOrderDetailPageResponse>(
      prepare(
        apiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementGetSettlementOrderDetailPage.requestConfig =
  apiOrderImsApiOrderSettlementGetSettlementOrderDetailPageRequestConfig

/**
 * 接口 [获取各个机构可结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/104248) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/orgSettlementDataPage`
 */
export interface ApiOrderImsApiOrderSettlementOrgSettlementDataPageRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 提单订单列表（多彩宝订单号）
   */
  orderNoList?: string[]
  /**
   * 机构号列表
   */
  orgCodeList?: string[]
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 支付开始日期 yyyy-MM-dd
   */
  payStartDate?: string
}

/**
 * 接口 [获取各个机构可结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/104248) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/orgSettlementDataPage`
 */
export interface ApiOrderImsApiOrderSettlementOrgSettlementDataPageResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 操作人（最近提单人）
     */
    lastApplyUserName?: string
    /**
     * 最近结算日期
     */
    lastSettleDate?: string
    /**
     * 业务类型
     */
    serviceTypeName?: string
    /**
     * 总交易额
     */
    totalAmt?: number
    /**
     * 可结算金额
     */
    totalBillableAmt?: number
    /**
     * 已结算金额
     */
    totalSettledAmt?: number
    /**
     * 结算中金额
     */
    totalSettlingAmt?: number
    /**
     * 未结算金额
     */
    totalWaitingSettleAmt?: number
    /**
     * 机构编号
     */
    unitOrgCode?: string
    /**
     * 机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取各个机构可结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/104248) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/orgSettlementDataPage`
 */
type ApiOrderImsApiOrderSettlementOrgSettlementDataPageRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/orgSettlementDataPage',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取各个机构可结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/104248) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/orgSettlementDataPage`
 */
const apiOrderImsApiOrderSettlementOrgSettlementDataPageRequestConfig: ApiOrderImsApiOrderSettlementOrgSettlementDataPageRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/orgSettlementDataPage',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementOrgSettlementDataPage',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取各个机构可结算列表', author: '成龙' },
  }

/**
 * 接口 [获取各个机构可结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/104248) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/orgSettlementDataPage`
 */
export const apiOrderImsApiOrderSettlementOrgSettlementDataPage =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementOrgSettlementDataPageRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementOrgSettlementDataPageResponse>(
      prepare(
        apiOrderImsApiOrderSettlementOrgSettlementDataPageRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementOrgSettlementDataPage.requestConfig =
  apiOrderImsApiOrderSettlementOrgSettlementDataPageRequestConfig

/**
 * 接口 [查询打款申请列表↗](https://yapi.gogpay.cn/project/906/interface/api/104254) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/payOrgRecordList`
 */
export interface ApiOrderImsApiOrderSettlementPayOrgRecordListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 提交时间-结束时间
   */
  endTime?: string
  /**
   * 机构名称/编码
   */
  orgCode?: string
  /**
   * 结算方式 00-见证宝   01-NC
   */
  orgTradeType?: 'ONLINE' | 'NC'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 提交时间-开始时间
   */
  startTime?: string
  /**
   * 记录状态
   */
  status?: number
}

/**
 * 接口 [查询打款申请列表↗](https://yapi.gogpay.cn/project/906/interface/api/104254) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/payOrgRecordList`
 */
export interface ApiOrderImsApiOrderSettlementPayOrgRecordListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 提交时间
     */
    createTime?: string
    /**
     * 结算区间结束日期
     */
    endDate?: string
    /**
     * 结算单Id
     */
    id?: string
    /**
     * 操作人
     */
    operator?: string
    /**
     * 机构编号
     */
    orgCode?: string
    /**
     * 机构名称
     */
    orgName?: string
    /**
     * 结算方式
     */
    orgTradeType?: string
    /**
     * 业务类型
     */
    serverType?: string
    /**
     * 结算区间开始日期
     */
    startDate?: string
    /**
     * 结算单状态 1待业务审核  2财务初审中  3待上传发票  4财务复审中 5打款中  6业务初审未通过 7财务初审未通过  8财务初审未通过  9结算完成  10已撤回
     */
    status?: number
    /**
     * 结算单状态名称
     */
    statusName?: string
    /**
     * 结算金额
     */
    totalAmt?: number
    /**
     * 订单数量
     */
    totalOrderAmount?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询打款申请列表↗](https://yapi.gogpay.cn/project/906/interface/api/104254) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/payOrgRecordList`
 */
type ApiOrderImsApiOrderSettlementPayOrgRecordListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/payOrgRecordList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询打款申请列表↗](https://yapi.gogpay.cn/project/906/interface/api/104254) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/payOrgRecordList`
 */
const apiOrderImsApiOrderSettlementPayOrgRecordListRequestConfig: ApiOrderImsApiOrderSettlementPayOrgRecordListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/payOrgRecordList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementPayOrgRecordList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询打款申请列表', author: '成龙' },
  }

/**
 * 接口 [查询打款申请列表↗](https://yapi.gogpay.cn/project/906/interface/api/104254) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/payOrgRecordList`
 */
export const apiOrderImsApiOrderSettlementPayOrgRecordList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementPayOrgRecordListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementPayOrgRecordListResponse>(
    prepare(
      apiOrderImsApiOrderSettlementPayOrgRecordListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderSettlementPayOrgRecordList.requestConfig =
  apiOrderImsApiOrderSettlementPayOrgRecordListRequestConfig

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)↗](https://yapi.gogpay.cn/project/906/interface/api/104260) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime`
 */
export interface ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 订单列表
   */
  orderNoList?: string[]
  /**
   * 机构号
   */
  orgCode?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 支付开始日期
   */
  payStartDate?: string
  /**
   * 业务类型
   */
  serviceType?: string
}

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)↗](https://yapi.gogpay.cn/project/906/interface/api/104260) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime`
 */
export interface ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeResponse {
  commoditySettleDTO?: {
    /**
     * 商品数量
     */
    goodsAmount?: number
    /**
     * 商品类型数量
     */
    goodsCategoryAmount?: number
    /**
     * 订单数量
     */
    orderAmount?: number
    /**
     * 支付结束时间
     */
    payEndTime?: string
    /**
     * 支付开始时间
     */
    payStartTime?: string
    /**
     * 本次结算金额
     */
    settleAmt?: number
  }
  orgAccountInfoDTO?: {
    /**
     * 收款银行账户
     */
    bankUserCode?: string
    /**
     * 收款账户名称
     */
    bankUserName?: string
    /**
     * 结算周期
     */
    dcbSettlePeriod?: string
    /**
     * 机构编码
     */
    orgCode?: string
    /**
     * 机构名称
     */
    orgName?: string
    /**
     * 业务类型
     */
    serviceType?: string
    /**
     * 结算时间类型
     */
    settlePeriodType?: string
    /**
     * 结算时间
     */
    settlePeriodValue?: string
    /**
     * 结算方式
     */
    settleType?: string
    /**
     * 社会统一信用代码
     */
    socialUnifiedCreditCode?: string
  }
  payOrgRecordFlowStepDTO?: {
    /**
     * 当前处理的步骤序号
     */
    currentIndex?: number
    /**
     * 结算单处理流程数据
     */
    flowStepUnitDTOList?: {
      /**
       * 当前步骤序号
       */
      flowStepIndex?: number
      /**
       * 当前步骤名称
       */
      flowStepName?: string
      /**
       * 当前步骤备注
       */
      flowStepRemark?: string
      /**
       * 当前步骤时间
       */
      flowStepTime?: string
    }[]
  }
  payOrgRecordSettleDataTotalDTO?: {
    /**
     * 订单金额总计
     */
    totalAmt?: number
    /**
     * 已结算金额
     */
    totalSettledAmt?: number
    /**
     * 结算中
     */
    totalSettlingAmt?: number
    /**
     * 未结算金额
     */
    totalUnsettledAmt?: number
  }
  settlementTotalDTO?: {
    /**
     * 汇总数据列表
     */
    settlementTotalUnitDTOList?: {
      /**
       * 汇总数据key
       */
      totalKey?: string
      /**
       * 汇总数据描述
       */
      totalLabel?: string
      /**
       * 汇总数据值
       */
      totalValue?: {}
    }[]
  }
  /**
   * 可结算金额
   */
  totalBillableAmt?: number
  /**
   * 已结算金额
   */
  totalSettledAmt?: number
  /**
   * 结算中金额
   */
  totalSettlingAmt?: number
  /**
   * 未结算金额
   */
  totalWaitingSettleAmt?: number
}

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)↗](https://yapi.gogpay.cn/project/906/interface/api/104260) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime`
 */
type ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)↗](https://yapi.gogpay.cn/project/906/interface/api/104260) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime`
 */
const apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequestConfig: ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTime',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '【预】按订单创建提单申请(按机构及时间范围)',
      author: '成龙',
    },
  }

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)↗](https://yapi.gogpay.cn/project/906/interface/api/104260) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTime`
 */
export const apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTime =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeResponse>(
      prepare(
        apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTime.requestConfig =
  apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeRequestConfig

/**
 * 接口 [上传发票↗](https://yapi.gogpay.cn/project/906/interface/api/104278) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadInvoices`
 */
export interface ApiOrderImsApiOrderSettlementUploadInvoicesRequest {
  /**
   * 发票列表
   */
  invoiceUrlList: string[]
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [上传发票↗](https://yapi.gogpay.cn/project/906/interface/api/104278) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadInvoices`
 */
export interface ApiOrderImsApiOrderSettlementUploadInvoicesResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [上传发票↗](https://yapi.gogpay.cn/project/906/interface/api/104278) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadInvoices`
 */
type ApiOrderImsApiOrderSettlementUploadInvoicesRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/uploadInvoices',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [上传发票↗](https://yapi.gogpay.cn/project/906/interface/api/104278) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadInvoices`
 */
const apiOrderImsApiOrderSettlementUploadInvoicesRequestConfig: ApiOrderImsApiOrderSettlementUploadInvoicesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/uploadInvoices',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementUploadInvoices',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '上传发票', author: '成龙' },
  }

/**
 * 接口 [上传发票↗](https://yapi.gogpay.cn/project/906/interface/api/104278) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadInvoices`
 */
export const apiOrderImsApiOrderSettlementUploadInvoices = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementUploadInvoicesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementUploadInvoicesResponse>(
    prepare(
      apiOrderImsApiOrderSettlementUploadInvoicesRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderSettlementUploadInvoices.requestConfig =
  apiOrderImsApiOrderSettlementUploadInvoicesRequestConfig

/**
 * 接口 [上传NC请款流水号↗](https://yapi.gogpay.cn/project/906/interface/api/104284) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadNcSerialNo`
 */
export interface ApiOrderImsApiOrderSettlementUploadNcSerialNoRequest {
  /**
   * NC请款流水号
   */
  ncSerialNo: string
  /**
   * 结算单id
   */
  recordId: string
}

/**
 * 接口 [上传NC请款流水号↗](https://yapi.gogpay.cn/project/906/interface/api/104284) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadNcSerialNo`
 */
export interface ApiOrderImsApiOrderSettlementUploadNcSerialNoResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [上传NC请款流水号↗](https://yapi.gogpay.cn/project/906/interface/api/104284) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadNcSerialNo`
 */
type ApiOrderImsApiOrderSettlementUploadNcSerialNoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/uploadNcSerialNo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [上传NC请款流水号↗](https://yapi.gogpay.cn/project/906/interface/api/104284) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadNcSerialNo`
 */
const apiOrderImsApiOrderSettlementUploadNcSerialNoRequestConfig: ApiOrderImsApiOrderSettlementUploadNcSerialNoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/uploadNcSerialNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementUploadNcSerialNo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '上传NC请款流水号', author: '成龙' },
  }

/**
 * 接口 [上传NC请款流水号↗](https://yapi.gogpay.cn/project/906/interface/api/104284) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/uploadNcSerialNo`
 */
export const apiOrderImsApiOrderSettlementUploadNcSerialNo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementUploadNcSerialNoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementUploadNcSerialNoResponse>(
    prepare(
      apiOrderImsApiOrderSettlementUploadNcSerialNoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderSettlementUploadNcSerialNo.requestConfig =
  apiOrderImsApiOrderSettlementUploadNcSerialNoRequestConfig

/**
 * 接口 [撤回打款申请↗](https://yapi.gogpay.cn/project/906/interface/api/104290) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/withdrawPayApply`
 */
export interface ApiOrderImsApiOrderSettlementWithdrawPayApplyRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [撤回打款申请↗](https://yapi.gogpay.cn/project/906/interface/api/104290) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/withdrawPayApply`
 */
export interface ApiOrderImsApiOrderSettlementWithdrawPayApplyResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [撤回打款申请↗](https://yapi.gogpay.cn/project/906/interface/api/104290) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/withdrawPayApply`
 */
type ApiOrderImsApiOrderSettlementWithdrawPayApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/withdrawPayApply',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [撤回打款申请↗](https://yapi.gogpay.cn/project/906/interface/api/104290) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/withdrawPayApply`
 */
const apiOrderImsApiOrderSettlementWithdrawPayApplyRequestConfig: ApiOrderImsApiOrderSettlementWithdrawPayApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/withdrawPayApply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementWithdrawPayApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '撤回打款申请', author: '成龙' },
  }

/**
 * 接口 [撤回打款申请↗](https://yapi.gogpay.cn/project/906/interface/api/104290) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/withdrawPayApply`
 */
export const apiOrderImsApiOrderSettlementWithdrawPayApply = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementWithdrawPayApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementWithdrawPayApplyResponse>(
    prepare(
      apiOrderImsApiOrderSettlementWithdrawPayApplyRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderSettlementWithdrawPayApply.requestConfig =
  apiOrderImsApiOrderSettlementWithdrawPayApplyRequestConfig

/**
 * 接口 [获取结算单操作详情↗](https://yapi.gogpay.cn/project/906/interface/api/104650) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData`
 */
export interface ApiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [获取结算单操作详情↗](https://yapi.gogpay.cn/project/906/interface/api/104650) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData`
 */
export type ApiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataResponse =
  {
    /**
     * 操作人
     */
    operator?: string
    /**
     * 操作时间
     */
    operatorTime?: string
    /**
     * 结算单id
     */
    payOrgRecordId?: string
    /**
     * 结算单状态
     */
    payOrgRecordStatus?: string
  }[]

/**
 * 接口 [获取结算单操作详情↗](https://yapi.gogpay.cn/project/906/interface/api/104650) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData`
 */
type ApiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取结算单操作详情↗](https://yapi.gogpay.cn/project/906/interface/api/104650) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData`
 */
const apiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequestConfig: ApiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取结算单操作详情', author: '成龙' },
  }

/**
 * 接口 [获取结算单操作详情↗](https://yapi.gogpay.cn/project/906/interface/api/104650) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/getPayOrgRecordStatusUpdateData`
 */
export const apiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateData =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataResponse>(
      prepare(
        apiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateData.requestConfig =
  apiOrderImsApiOrderSettlementGetPayOrgRecordStatusUpdateDataRequestConfig

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单商品信息↗](https://yapi.gogpay.cn/project/906/interface/api/104656) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail`
 */
export interface ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 订单列表
   */
  orderNoList?: string[]
  /**
   * 机构号
   */
  orgCode?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 支付开始日期
   */
  payStartDate?: string
  /**
   * 业务类型
   */
  serviceType?: string
}

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单商品信息↗](https://yapi.gogpay.cn/project/906/interface/api/104656) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail`
 */
export interface ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品数量
     */
    goodsAmount?: number
    /**
     * 税收类目
     */
    taxCategory?: string
    /**
     * 结算总价
     */
    totalAmt?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单商品信息↗](https://yapi.gogpay.cn/project/906/interface/api/104656) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail`
 */
type ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单商品信息↗](https://yapi.gogpay.cn/project/906/interface/api/104656) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail`
 */
const apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequestConfig: ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '【预】按订单创建提单申请(按机构及时间范围)-获取结算单商品信息',
      author: '成龙',
    },
  }

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单商品信息↗](https://yapi.gogpay.cn/project/906/interface/api/104656) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetGoodsDetail`
 */
export const apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetail =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailResponse>(
      prepare(
        apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetail.requestConfig =
  apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetGoodsDetailRequestConfig

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104662) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail`
 */
export interface ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 订单列表
   */
  orderNoList?: string[]
  /**
   * 机构号
   */
  orgCode?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 支付开始日期
   */
  payStartDate?: string
  /**
   * 业务类型
   */
  serviceType?: string
}

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104662) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail`
 */
export interface ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单属性
     */
    settlementOrderDetailUnitDTOList?: {
      /**
       * 订单属性排序
       */
      attributionSortIndex?: number
      /**
       * 订单属性key
       */
      orderAttributionKey?: string
      /**
       * 订单属性描述
       */
      orderAttributionLabel?: string
      /**
       * 订单属性值
       */
      orderAttributionValue?: {}[]
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104662) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail`
 */
type ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104662) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail`
 */
const apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequestConfig: ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '【预】按订单创建提单申请(按机构及时间范围)-获取结算单订单明细',
      author: '成龙',
    },
  }

/**
 * 接口 [【预】按订单创建提单申请(按机构及时间范围)-获取结算单订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/104662) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/preCreateOrderPayRecordByOrgAndTimeGetOrderDetail`
 */
export const apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetail =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailResponse>(
      prepare(
        apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetail.requestConfig =
  apiOrderImsApiOrderSettlementPreCreateOrderPayRecordByOrgAndTimeGetOrderDetailRequestConfig

/**
 * 接口 [撤回打款申请（批量）↗](https://yapi.gogpay.cn/project/906/interface/api/104668) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch`
 */
export interface ApiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequest {
  /**
   * 记录id
   */
  idList?: string[]
}

/**
 * 接口 [撤回打款申请（批量）↗](https://yapi.gogpay.cn/project/906/interface/api/104668) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch`
 */
export interface ApiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [撤回打款申请（批量）↗](https://yapi.gogpay.cn/project/906/interface/api/104668) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch`
 */
type ApiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [撤回打款申请（批量）↗](https://yapi.gogpay.cn/project/906/interface/api/104668) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch`
 */
const apiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequestConfig: ApiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatch',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '撤回打款申请（批量）', author: '成龙' },
  }

/**
 * 接口 [撤回打款申请（批量）↗](https://yapi.gogpay.cn/project/906/interface/api/104668) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/settlement/withdrawPayApplyBatch`
 */
export const apiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatch =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchResponse>(
      prepare(
        apiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatch.requestConfig =
  apiOrderImsApiOrderSettlementSettlementWithdrawPayApplyBatchRequestConfig

/**
 * 接口 [导出订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/156825) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/exportOrders`
 */
export interface ApiOrderImsApiOrderSettlementExportOrdersRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [导出订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/156825) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/exportOrders`
 */
export type ApiOrderImsApiOrderSettlementExportOrdersResponse = {
  /**
   * 促销结算金额
   */
  activitySettlementAmount?: number
  /**
   * 促销类型
   */
  activityType?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品结算价
   */
  costPrice?: number
  /**
   * 优惠结算金额
   */
  discountSettleAmount?: number
  /**
   * 订单金额
   */
  orderAmt?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 支付金额
   */
  payAmount?: number
  /**
   * 多彩宝订单编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 邮费结算价
   */
  postFeeSettlementAmount?: number
  /**
   * 数量
   */
  quantity?: number
  /**
   * 业务类型
   */
  serviceType?: string
  /**
   * 结算金额合计
   */
  settlementAmount?: number
  /**
   * 签约主体
   */
  signBody?: string
  /**
   * 规格
   */
  skuDesc?: string
  /**
   * 税收类目
   */
  taxCategory?: string
  /**
   * 税率编码
   */
  taxNo?: string
  /**
   * 税率
   */
  taxRate?: number
  /**
   * 机构编号
   */
  uniOrgCode?: string
  /**
   * 机构名称
   */
  uniOrgCodeName?: string
}[]

/**
 * 接口 [导出订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/156825) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/exportOrders`
 */
type ApiOrderImsApiOrderSettlementExportOrdersRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/exportOrders',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/156825) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/exportOrders`
 */
const apiOrderImsApiOrderSettlementExportOrdersRequestConfig: ApiOrderImsApiOrderSettlementExportOrdersRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/exportOrders',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementExportOrders',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出订单明细', author: '成龙' },
  }

/**
 * 接口 [导出订单明细↗](https://yapi.gogpay.cn/project/906/interface/api/156825) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/exportOrders`
 */
export const apiOrderImsApiOrderSettlementExportOrders = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementExportOrdersRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementExportOrdersResponse>(
    prepare(
      apiOrderImsApiOrderSettlementExportOrdersRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderSettlementExportOrders.requestConfig =
  apiOrderImsApiOrderSettlementExportOrdersRequestConfig

/**
 * 接口 [查询可结算订单号↗](https://yapi.gogpay.cn/project/906/interface/api/273000) 的 **请求类型**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findBillOrder`
 */
export interface ApiOrderImsApiOrderSettlementFindBillOrderRequest {
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 订单号
   */
  paySerialNo?: string
  /**
   * 支付开始日期 yyyy-MM-dd
   */
  payStartDate?: string
  /**
   * 机构号
   */
  uniOrgCode?: string
}

/**
 * 接口 [查询可结算订单号↗](https://yapi.gogpay.cn/project/906/interface/api/273000) 的 **返回类型**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findBillOrder`
 */
export interface ApiOrderImsApiOrderSettlementFindBillOrderResponse {
  /**
   * 可结算订单结果集
   */
  settleOrderExportVoList?: {
    /**
     * 促销结算金额
     */
    activitySettlementAmount?: number
    /**
     * 促销类型
     */
    activityType?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品结算价
     */
    costPrice?: number
    /**
     * 优惠结算金额
     */
    discountSettleAmount?: number
    /**
     * 订单金额
     */
    orderAmt?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付金额
     */
    payAmount?: number
    /**
     * 多彩宝订单编号
     */
    paySerialNo?: string
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 邮费结算价
     */
    postFeeSettlementAmount?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 业务类型
     */
    serviceType?: string
    /**
     * 结算金额合计
     */
    settlementAmount?: number
    /**
     * 签约主体
     */
    signBody?: string
    /**
     * 规格
     */
    skuDesc?: string
    /**
     * 税收类目
     */
    taxCategory?: string
    /**
     * 税率编码
     */
    taxNo?: string
    /**
     * 税率
     */
    taxRate?: number
    /**
     * 机构编号
     */
    uniOrgCode?: string
    /**
     * 机构名称
     */
    uniOrgCodeName?: string
  }[]
  /**
   * 总记录条数
   */
  total?: number
  /**
   * 总条数
   */
  totalNum?: number
  /**
   * 总页数
   */
  totalPage?: number
  /**
   * 总支付金额
   */
  totalPayAmt?: number
  /**
   * 总结算金额
   */
  totalSettlementAmt?: number
}

/**
 * 接口 [查询可结算订单号↗](https://yapi.gogpay.cn/project/906/interface/api/273000) 的 **请求配置的类型**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findBillOrder`
 */
type ApiOrderImsApiOrderSettlementFindBillOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/findBillOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询可结算订单号↗](https://yapi.gogpay.cn/project/906/interface/api/273000) 的 **请求配置**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findBillOrder`
 */
const apiOrderImsApiOrderSettlementFindBillOrderRequestConfig: ApiOrderImsApiOrderSettlementFindBillOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/findBillOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementFindBillOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询可结算订单号', author: '202306号开发' },
  }

/**
 * 接口 [查询可结算订单号↗](https://yapi.gogpay.cn/project/906/interface/api/273000) 的 **请求函数**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findBillOrder`
 */
export const apiOrderImsApiOrderSettlementFindBillOrder = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementFindBillOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementFindBillOrderResponse>(
    prepare(
      apiOrderImsApiOrderSettlementFindBillOrderRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderSettlementFindBillOrder.requestConfig =
  apiOrderImsApiOrderSettlementFindBillOrderRequestConfig

/**
 * 接口 [查询订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/277314) 的 **请求类型**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findOrderDiscountInfo`
 */
export interface ApiOrderImsApiOrderSettlementFindOrderDiscountInfoRequest {
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付结束日期
   */
  payEndDate?: string
  /**
   * 订单号
   */
  paySerialNo?: string
  /**
   * 支付开始日期 yyyy-MM-dd
   */
  payStartDate?: string
  /**
   * 机构号
   */
  uniOrgCode?: string
}

/**
 * 接口 [查询订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/277314) 的 **返回类型**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findOrderDiscountInfo`
 */
export interface ApiOrderImsApiOrderSettlementFindOrderDiscountInfoResponse {
  /**
   * 订单信息列表
   */
  orderDiscountInfo?: {
    /**
     * 订单优惠类型金额
     */
    orderDiscountAmt?: number
    /**
     * 订单优惠类型名称
     */
    orderDiscountName?: string
  }[]
}

/**
 * 接口 [查询订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/277314) 的 **请求配置的类型**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findOrderDiscountInfo`
 */
type ApiOrderImsApiOrderSettlementFindOrderDiscountInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/findOrderDiscountInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/277314) 的 **请求配置**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findOrderDiscountInfo`
 */
const apiOrderImsApiOrderSettlementFindOrderDiscountInfoRequestConfig: ApiOrderImsApiOrderSettlementFindOrderDiscountInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/findOrderDiscountInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementFindOrderDiscountInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询订单优惠信息', author: '202306号开发' },
  }

/**
 * 接口 [查询订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/277314) 的 **请求函数**
 *
 * @作者 202306号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/findOrderDiscountInfo`
 */
export const apiOrderImsApiOrderSettlementFindOrderDiscountInfo =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementFindOrderDiscountInfoRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementFindOrderDiscountInfoResponse>(
      prepare(
        apiOrderImsApiOrderSettlementFindOrderDiscountInfoRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementFindOrderDiscountInfo.requestConfig =
  apiOrderImsApiOrderSettlementFindOrderDiscountInfoRequestConfig

/**
 * 接口 [导出下载结算汇总单↗](https://yapi.gogpay.cn/project/906/interface/api/331258) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/downSettOrderStatFile`
 */
export interface ApiOrderImsApiOrderSettlementDownSettOrderStatFileRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 结算单Id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算单Id
   */
  payOrgRecordId: string
  /**
   * 结算单Id
   */
  recordId: string
}

/**
 * 接口 [导出下载结算汇总单↗](https://yapi.gogpay.cn/project/906/interface/api/331258) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/downSettOrderStatFile`
 */
export interface ApiOrderImsApiOrderSettlementDownSettOrderStatFileResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 文件密码
   */
  password?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出下载结算汇总单↗](https://yapi.gogpay.cn/project/906/interface/api/331258) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/downSettOrderStatFile`
 */
type ApiOrderImsApiOrderSettlementDownSettOrderStatFileRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/downSettOrderStatFile',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出下载结算汇总单↗](https://yapi.gogpay.cn/project/906/interface/api/331258) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/downSettOrderStatFile`
 */
const apiOrderImsApiOrderSettlementDownSettOrderStatFileRequestConfig: ApiOrderImsApiOrderSettlementDownSettOrderStatFileRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_4,
    devUrl: devUrl_0_5_0_4,
    prodUrl: prodUrl_0_5_0_4,
    path: '/order/imsApi/orderSettlement/downSettOrderStatFile',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementDownSettOrderStatFile',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出下载结算汇总单', author: '333号开发' },
  }

/**
 * 接口 [导出下载结算汇总单↗](https://yapi.gogpay.cn/project/906/interface/api/331258) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [结算中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22146)
 * @请求头 `POST /order/imsApi/orderSettlement/downSettOrderStatFile`
 */
export const apiOrderImsApiOrderSettlementDownSettOrderStatFile =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementDownSettOrderStatFileRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementDownSettOrderStatFileResponse>(
      prepare(
        apiOrderImsApiOrderSettlementDownSettOrderStatFileRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementDownSettOrderStatFile.requestConfig =
  apiOrderImsApiOrderSettlementDownSettOrderStatFileRequestConfig

const mockUrl_0_5_0_5 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_5 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_5 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_5 = 'data' as any

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104374) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderList`
 */
export interface ApiOrderImsApiOpenApiOrderListRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中
   */
  status?: number
  /**
   * 用户Id
   */
  userId: string
  /**
   * 下单手机号
   */
  userPhone?: string
}

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104374) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderList`
 */
export interface ApiOrderImsApiOpenApiOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单活动名称
     */
    activityName?: string
    /**
     * 订单商品列表
     */
    commodities?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态文案
       */
      saleAfterName?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    countDownTime?: {
      /**
       * 自动取消订单时效（毫秒)
       */
      cancelOrderCountDown?: number
      /**
       * 关闭订单时效（毫秒）
       */
      closeCountDown?: number
      /**
       * 自动确认收货时效（毫秒）
       */
      confirmCountDown?: number
      /**
       * 发货（派单）倒计时（毫秒）
       */
      shippingCountDown?: number
    }
    /**
     * 延长收货天数
     */
    delayDays?: number
    /**
     * 延长收货状态 -1不支持 0未延长 1已延长
     */
    delayStatus?: number
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 评价状态 0未评价 1已评价
     */
    evaluationStatus?: number
    /**
     * 配送方式值 1普通快递 2同城自提
     */
    logisticsMethodValue?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 订单金额（实付）
     */
    orderAmount?: string
    /**
     * 订单分类  1标准电商  2标准核销  3标准虚拟
     */
    orderClassify?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 是否为父订单
     */
    parentOrderFlag?: boolean
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    selfAddress?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 订单状态 0待支付
     * 100待发货
     * 101已发货
     *
     * 400待接单
     * 401待配送
     * 402配送中
     *
     * 900交易完成
     * 901交易关闭"902交易完结
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 订单金额（应付)
     */
    totalAmount?: string
    /**
     * 催单状态 -1不支持催单 0未催单 1已催单
     */
    urgedStatus?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104374) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderList`
 */
type ApiOrderImsApiOpenApiOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/orderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104374) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderList`
 */
const apiOrderImsApiOpenApiOrderListRequestConfig: ApiOrderImsApiOpenApiOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/orderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表-客户端', author: '成龙' },
  }

/**
 * 接口 [订单列表-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104374) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderList`
 */
export const apiOrderImsApiOpenApiOrderList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiOrderListResponse>(
    prepare(apiOrderImsApiOpenApiOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiOrderList.requestConfig =
  apiOrderImsApiOpenApiOrderListRequestConfig

/**
 * 接口 [订单列表-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/104398) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/adminOrderList`
 */
export interface ApiOrderImsApiOpenApiAdminOrderListRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [订单列表-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/104398) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/adminOrderList`
 */
export interface ApiOrderImsApiOpenApiAdminOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 促销金额
     */
    activityAmount?: number
    /**
     * 促销类型
     */
    activityType?: string
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 申报剩余时间
     */
    applySupDate?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    buyer?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    buyerAddress?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 渠道优惠
     */
    channelDiscount?: string
    /**
     * 渠道优惠金额
     */
    channelDiscountAmount?: number
    /**
     * 商品信息
     */
    commodities?: {
      /**
       * 售后状态文案
       */
      afterSale?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品合同报价名称
       */
      commodityContractTitle?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品来源
       */
      commodityResource?: string
      /**
       * 商品图片
       */
      comoodityPic?: string
      /**
       * SKU成本价
       */
      costPrice?: number
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 优惠活动名称
       */
      discountName?: string
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * 满减优惠规则
       */
      fullReductionDiscount?: string
      /**
       * 满减优惠金额
       */
      fullReductionDiscountAmount?: number
      /**
       * 订单商品Id
       */
      id?: string
      /**
       * 实付积分
       */
      integral?: number
      /**
       * 所需积分
       */
      needIntegral?: number
      /**
       * 未发货数量
       */
      noShipQuantity?: number
      /**
       * 订单商品Sn码
       */
      orderSnNum?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 退款状态文案
       */
      refundStatusText?: string
      /**
       * 返现金额
       */
      returnAmount?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeText?: string
      /**
       * 销售渠道
       */
      sellChannelName?: string
      /**
       * 发货状态  0未发货  1已发货  2不可发货
       */
      shipStatus?: number
      /**
       * 订单商品69码
       */
      skuBarCode?: string
      /**
       * sku Id
       */
      skuId?: string
      /**
       * 规格信息
       */
      specs?: string
      /**
       * 税率编码
       */
      taxNo?: string
      /**
       * 税率
       */
      taxRate?: number
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    /**
     * 多彩宝订单编号
     */
    dcbOrderNo?: string
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 是否已评价 0未评价 1已评价
     */
    evaluateFlag?: number
    /**
     * 兑换商品名称
     */
    exchangeCommodityName?: string
    /**
     * 兑换商品订单编号
     */
    exchangeCommodityOrderNo?: string
    /**
     * 兑换商品类型
     */
    exchangeCommodityType?: number
    /**
     * 满减优惠规则
     */
    fullReductionDiscount?: string
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * imei1编码
     */
    imei1Code?: string
    /**
     * imei2编码
     */
    imei2Code?: string
    /**
     * 积分优惠金额
     */
    integralDiscountAmount?: number
    /**
     * 用户是否申请开票 0未申请 1已申请
     */
    invoiceApplyInfoStatus?: number
    /**
     * 是否开发票 0不开 1开
     */
    invoiceFlag?: number
    /**
     * 发票图片
     */
    invoiceImg?: string
    /**
     * 京东单号
     */
    jdOrderNo?: string
    /**
     * 订单营销类型
     */
    marketingType?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 申报状态失败原因
     */
    orderApplyFailReason?: string
    /**
     * 申报状态 99待申报，00已申报，待审核，01审核通过，02审核不通过，03补贴已支付
     */
    orderApplyYardGoStatus?: string
    /**
     * 申报状态描述
     */
    orderApplyYardGoStatusDesc?: string
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单类型
     */
    orderClassification?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'
    /**
     * 订单日期
     */
    orderDate?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单同步状态0否 1是
     */
    orderPushStatus?: number
    /**
     * 重新申报复核失败原因
     */
    orderReApplyFailReason?: string
    /**
     * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
     */
    orderReApplyYardGoStatus?: string
    /**
     * 重新申报复核状态描述
     */
    orderReApplyYardGoStatusDesc?: string
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    orderTabStatisticsVO?: {
      /**
       * 实际收款
       */
      actualReceivable?: number
      /**
       * 购买数量
       */
      buyCount?: number
      /**
       * 总优惠金额
       */
      discountAmount?: number
      /**
       * 订单笔数
       */
      orderCount?: number
    }
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 订单类型
     */
    orderType?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 邮费免除状态 0不可免除 1可免除
     */
    postFeeFreeStatus?: number
    /**
     * 状态变更原因
     */
    reason?:
      | 'CREATE'
      | 'PAYED'
      | 'AUTO_CLOSE'
      | 'ADMIN_CLOSE'
      | 'USER_CLOSE'
      | 'SALE_AFTER_CLOSE'
      | 'PART_SHIP'
      | 'SHIP'
      | 'BATCH_SHIP'
      | 'BUSINESS_SHIP'
      | 'SALE_DONE_SHIP'
      | 'USER_CONFIRM'
      | 'AUTO_CONFIRM'
      | 'FINISH'
      | 'SALE_AFTER_FINISH'
      | 'INCENTIVE_FINISH'
      | 'WRITE_OFF'
      | 'REFUND'
      | 'TAKE'
      | 'CANCEL'
      | 'SYSTEM_TAKE'
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 订单售后状态 0未售后 1已售后
     */
    saleAfterStatus?: number
    /**
     * 结算状态
     */
    settlementStatus?: string
    /**
     * 是否可结算
     */
    settlementType?: string
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 交易状态 "0待支付
     * 100待发货
     * 101已发货
     *
     * 200待派单
     * 201已派单
     * 202待服务
     * 203服务中
     *
     * 900交易完成
     * 901交易关闭"
     */
    tradeStatus?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 商户机构编码
     */
    unitOrgCode?: string
    /**
     * 是否已催单  0未催单  1已催单
     */
    urgedFlag?: number
    /**
     * 订单所属用户Id
     */
    userId?: string
    /**
     * 订单核销状态 （派单核销）
     */
    verificationStatus?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/104398) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/adminOrderList`
 */
type ApiOrderImsApiOpenApiAdminOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/adminOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/104398) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/adminOrderList`
 */
const apiOrderImsApiOpenApiAdminOrderListRequestConfig: ApiOrderImsApiOpenApiAdminOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/adminOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiAdminOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表-管理端', author: '成龙' },
  }

/**
 * 接口 [订单列表-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/104398) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/adminOrderList`
 */
export const apiOrderImsApiOpenApiAdminOrderList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiAdminOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiAdminOrderListResponse>(
    prepare(apiOrderImsApiOpenApiAdminOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiAdminOrderList.requestConfig =
  apiOrderImsApiOpenApiAdminOrderListRequestConfig

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104404) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetail`
 */
export interface ApiOrderImsApiOpenApiOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104404) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetail`
 */
export interface ApiOrderImsApiOpenApiOrderDetailResponse {
  /**
   * 抵扣积分数量
   */
  channelDiscountAmount?: string
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单商品列表
   */
  commodities?: {
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品类目参数
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    name?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 总价
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterName?: string
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeName?: string
    /**
     * 发货状态 0未发货 1已发货
     */
    shipStatus?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * SKU规格信息
     */
    skuSpecs?: string
    /**
     * 标签
     */
    tags?: string[]
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 成交时间
   */
  dealTime?: string
  /**
   * 延长收货天数
   */
  delayDays?: number
  /**
   * 延长收货状态 -1不支持延迟收货 0未延长 1已延长
   */
  delayStatus?: number
  /**
   * 配送日期
   */
  deliverDate?: string
  deliverUser?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 评价状态 0未评价 1已评价 2已追评 3审核中
   */
  evaluationStatus?: number
  /**
   * 兑换时间
   */
  exchangeTime?: string
  /**
   * 订单扩展数据
   */
  extendData?: {
    /**
     * 扩展字段的key，业务系统可自由定制
     */
    key?: string
    /**
     * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
     */
    name?: string
    /**
     * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
     */
    sort?: number
    /**
     * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
     */
    type?: string
    /**
     * 扩展字段的值，内容可自由定制。如100、302等
     */
    value?: string
  }[]
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 积分活动积分
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  lastExpressTrace?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }
  /**
   * 是否需要人脸认证
   */
  liveCheckFlag?: boolean
  /**
   * 物流达到时间
   */
  logisticsEndTime?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 配送方式
   */
  logisticsMethod?: string
  /**
   * 配送方式值 1普通快递/现场自提 2同城自提 3商户自配送
   */
  logisticsMethodValue?: number
  merchantCourier?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 发货是否需要填写sn码 0否 1是
   */
  needSnNum?: number
  /**
   * 是否需要上传签收单0否 1是
   */
  needUploadSignature?: number
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单中心支付单号
   */
  orderCenterPayNo?: string
  /**
   * 订单分类；1=标准电商，2=标准核销，3=标准虚拟，4=核销支付，5=组合标销售，6=旅游订单，7=组合电商
   */
  orderClassify?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 原始订单号，该字段为空代表为父单，不为空则为子单
   */
  originalOrderNo?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 需支付金额
   */
  payAmount?: string
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 支付方式
   */
  payTypeStatus?: number
  /**
   * 运费
   */
  postFee?: number
  /**
   * 订单操作是否只读
   */
  readonly?: boolean
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
   */
  saleAfterStatus?: number
  /**
   * 售后状态文案
   */
  saleAfterStatusLabel?: string
  selfAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 发货时间
   */
  shipTime?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  shippingType?: number
  /**
   * 订单状态 0待支付
   * 100待发货
   * 101已发货
   *
   * 400待接单
   * 401待配送
   * 402配送中
   *
   * 900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 订单状态变更
   */
  statusReason?: string
  /**
   * 接单时间
   */
  takeTime?: string
  /**
   * 订单提示信息
   */
  tips?: string
  /**
   * 催单状态 -1不支持催单 0未催单 1已催单
   */
  urgedStatus?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
}

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104404) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetail`
 */
type ApiOrderImsApiOpenApiOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/orderDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104404) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetail`
 */
const apiOrderImsApiOpenApiOrderDetailRequestConfig: ApiOrderImsApiOpenApiOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/orderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单详情-客户端', author: '成龙' },
  }

/**
 * 接口 [订单详情-客户端↗](https://yapi.gogpay.cn/project/906/interface/api/104404) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetail`
 */
export const apiOrderImsApiOpenApiOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiOrderDetailResponse>(
    prepare(apiOrderImsApiOpenApiOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiOrderDetail.requestConfig =
  apiOrderImsApiOpenApiOrderDetailRequestConfig

/**
 * 接口 [订单支付-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/105394) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/payOrder`
 */
export interface ApiOrderImsApiOpenApiPayOrderRequest {
  /**
   * 微信用户Id
   */
  openId?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [订单支付-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/105394) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/payOrder`
 */
export interface ApiOrderImsApiOpenApiPayOrderResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  needRealNameAuth?: boolean
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [订单支付-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/105394) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/payOrder`
 */
type ApiOrderImsApiOpenApiPayOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/payOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单支付-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/105394) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/payOrder`
 */
const apiOrderImsApiOpenApiPayOrderRequestConfig: ApiOrderImsApiOpenApiPayOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/payOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiPayOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单支付-管理端', author: '成龙' },
  }

/**
 * 接口 [订单支付-管理端↗](https://yapi.gogpay.cn/project/906/interface/api/105394) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/payOrder`
 */
export const apiOrderImsApiOpenApiPayOrder = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiPayOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiPayOrderResponse>(
    prepare(apiOrderImsApiOpenApiPayOrderRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiPayOrder.requestConfig =
  apiOrderImsApiOpenApiPayOrderRequestConfig

/**
 * 接口 [标销-核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/121120) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/use`
 */
export interface ApiOrderImsApiOpenApiWriteOffUseRequest {
  /**
   * 核销码列表，和订单编号二选一传递
   */
  code: string[]
  /**
   * 订单编号，和核销码二选一传递
   */
  orderNo?: string
  /**
   * 核销店铺机构号
   */
  writeOffUnitOrgCode?: string
  /**
   * 核销人
   */
  writeOffUser: string
}

/**
 * 接口 [标销-核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/121120) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/use`
 */
export interface ApiOrderImsApiOpenApiWriteOffUseResponse {
  /**
   * 失败数量
   */
  failCount?: number
  /**
   * 核销结果
   */
  results?: {
    /**
     * 券码
     */
    code?: string
    /**
     * 核销结果
     */
    msg?: string
    /**
     * 是否成功
     */
    success?: boolean
  }[]
  /**
   * 成功数量
   */
  successCount?: number
}

/**
 * 接口 [标销-核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/121120) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/use`
 */
type ApiOrderImsApiOpenApiWriteOffUseRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/writeOff/use',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销-核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/121120) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/use`
 */
const apiOrderImsApiOpenApiWriteOffUseRequestConfig: ApiOrderImsApiOpenApiWriteOffUseRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/writeOff/use',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiWriteOffUse',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销-核销核销码', author: '成龙' },
  }

/**
 * 接口 [标销-核销核销码↗](https://yapi.gogpay.cn/project/906/interface/api/121120) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/use`
 */
export const apiOrderImsApiOpenApiWriteOffUse = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiWriteOffUseRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiWriteOffUseResponse>(
    prepare(apiOrderImsApiOpenApiWriteOffUseRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiWriteOffUse.requestConfig =
  apiOrderImsApiOpenApiWriteOffUseRequestConfig

/**
 * 接口 [标销-获取用户可用核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/121126) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/userAvailableCode`
 */
export interface ApiOrderImsApiOpenApiWriteOffUserAvailableCodeRequest {
  /**
   * 用户手机
   */
  phoneNo?: string
  /**
   * 机构编码
   */
  unitOrgCode: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [标销-获取用户可用核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/121126) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/userAvailableCode`
 */
export type ApiOrderImsApiOpenApiWriteOffUserAvailableCodeResponse = {
  /**
   * 预约时间
   */
  appointmentDate?: string
  /**
   * 核销码
   */
  code?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 划线价
   */
  dashPrice?: number
  /**
   * 过期时间
   */
  expireTime?: string
  /**
   * 核销记录Id
   */
  id?: string
  /**
   * 订单时间
   */
  orderTime?: string
  /**
   * 售价
   */
  price?: number
  /**
   * 店铺Id
   */
  storeId?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 所属用户日期
   */
  userId?: string
}[]

/**
 * 接口 [标销-获取用户可用核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/121126) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/userAvailableCode`
 */
type ApiOrderImsApiOpenApiWriteOffUserAvailableCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/writeOff/userAvailableCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销-获取用户可用核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/121126) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/userAvailableCode`
 */
const apiOrderImsApiOpenApiWriteOffUserAvailableCodeRequestConfig: ApiOrderImsApiOpenApiWriteOffUserAvailableCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/writeOff/userAvailableCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiWriteOffUserAvailableCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销-获取用户可用核销码列表', author: '成龙' },
  }

/**
 * 接口 [标销-获取用户可用核销码列表↗](https://yapi.gogpay.cn/project/906/interface/api/121126) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/userAvailableCode`
 */
export const apiOrderImsApiOpenApiWriteOffUserAvailableCode = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiWriteOffUserAvailableCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiWriteOffUserAvailableCodeResponse>(
    prepare(
      apiOrderImsApiOpenApiWriteOffUserAvailableCodeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOpenApiWriteOffUserAvailableCode.requestConfig =
  apiOrderImsApiOpenApiWriteOffUserAvailableCodeRequestConfig

/**
 * 接口 [标销-获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/121594) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/record`
 */
export interface ApiOrderImsApiOpenApiWriteOffRecordRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 机构编码
   */
  unitOrgCode: string
}

/**
 * 接口 [标销-获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/121594) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/record`
 */
export interface ApiOrderImsApiOpenApiWriteOffRecordResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 核销码
     */
    code?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品价格
     */
    commodityPrice?: number
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 核销记录Id
     */
    id?: string
    /**
     * 核销来源
     */
    writeOffSourceLabel?: string
    /**
     * 核销来源值  1平台端 2商家端  3移动端
     */
    writeOffSourceValue?: number
    /**
     * 核销时间
     */
    writeOffTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [标销-获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/121594) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/record`
 */
type ApiOrderImsApiOpenApiWriteOffRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/writeOff/record',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销-获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/121594) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/record`
 */
const apiOrderImsApiOpenApiWriteOffRecordRequestConfig: ApiOrderImsApiOpenApiWriteOffRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/writeOff/record',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiWriteOffRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销-获取商家核销记录', author: '成龙' },
  }

/**
 * 接口 [标销-获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/121594) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/record`
 */
export const apiOrderImsApiOpenApiWriteOffRecord = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiWriteOffRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiWriteOffRecordResponse>(
    prepare(apiOrderImsApiOpenApiWriteOffRecordRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiWriteOffRecord.requestConfig =
  apiOrderImsApiOpenApiWriteOffRecordRequestConfig

/**
 * 接口 [标销-获取核销记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/121864) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/detail`
 */
export interface ApiOrderImsApiOpenApiWriteOffDetailRequest {
  /**
   * 请求Id
   */
  id: string
}

/**
 * 接口 [标销-获取核销记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/121864) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/detail`
 */
export interface ApiOrderImsApiOpenApiWriteOffDetailResponse {
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 核销码
   */
  code?: string
  /**
   * 券码使用类型 1多张券码   2单券码多次使用
   */
  codeType?: number
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品售价
   */
  commodityPrice?: number
  /**
   * 有效期
   */
  expireTime?: string
  /**
   * 营业时间
   */
  merchantOpenPeriod?: string
  /**
   * 核销人
   */
  writeOffName?: string
  /**
   * 核销来源
   */
  writeOffSource?: string
  /**
   * 核销店铺列表
   */
  writeOffStoreList?: {
    /**
     * 店铺Id
     */
    id?: string
    /**
     * 店铺名称
     */
    name?: string
  }[]
  /**
   * 核销时间
   */
  writeOffTime?: string
}

/**
 * 接口 [标销-获取核销记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/121864) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/detail`
 */
type ApiOrderImsApiOpenApiWriteOffDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/writeOff/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销-获取核销记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/121864) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/detail`
 */
const apiOrderImsApiOpenApiWriteOffDetailRequestConfig: ApiOrderImsApiOpenApiWriteOffDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/writeOff/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiWriteOffDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销-获取核销记录详情', author: '成龙' },
  }

/**
 * 接口 [标销-获取核销记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/121864) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/detail`
 */
export const apiOrderImsApiOpenApiWriteOffDetail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiWriteOffDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiWriteOffDetailResponse>(
    prepare(apiOrderImsApiOpenApiWriteOffDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiWriteOffDetail.requestConfig =
  apiOrderImsApiOpenApiWriteOffDetailRequestConfig

/**
 * 接口 [查询订单结算比例↗](https://yapi.gogpay.cn/project/906/interface/api/187466) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettleInfo`
 */
export interface ApiOrderImsApiOpenApiGetOrderSettleInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [查询订单结算比例↗](https://yapi.gogpay.cn/project/906/interface/api/187466) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettleInfo`
 */
export interface ApiOrderImsApiOpenApiGetOrderSettleInfoResponse {
  /**
   * 分润比例
   */
  feeRadio?: number
}

/**
 * 接口 [查询订单结算比例↗](https://yapi.gogpay.cn/project/906/interface/api/187466) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettleInfo`
 */
type ApiOrderImsApiOpenApiGetOrderSettleInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/getOrderSettleInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询订单结算比例↗](https://yapi.gogpay.cn/project/906/interface/api/187466) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettleInfo`
 */
const apiOrderImsApiOpenApiGetOrderSettleInfoRequestConfig: ApiOrderImsApiOpenApiGetOrderSettleInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/getOrderSettleInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiGetOrderSettleInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询订单结算比例', author: '成龙' },
  }

/**
 * 接口 [查询订单结算比例↗](https://yapi.gogpay.cn/project/906/interface/api/187466) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettleInfo`
 */
export const apiOrderImsApiOpenApiGetOrderSettleInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiGetOrderSettleInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiGetOrderSettleInfoResponse>(
    prepare(apiOrderImsApiOpenApiGetOrderSettleInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiGetOrderSettleInfo.requestConfig =
  apiOrderImsApiOpenApiGetOrderSettleInfoRequestConfig

/**
 * 接口 [获取多彩宝订单状态↗](https://yapi.gogpay.cn/project/906/interface/api/214642) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getDcbOrderStatus`
 */
export interface ApiOrderImsApiOpenApiGetDcbOrderStatusRequest {
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [获取多彩宝订单状态↗](https://yapi.gogpay.cn/project/906/interface/api/214642) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getDcbOrderStatus`
 */
export interface ApiOrderImsApiOpenApiGetDcbOrderStatusResponse {
  /**
   * 批量单号，statusType=01时才会返回
   */
  batchNo?: string
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 流转状态 01待发货 02已发货 03已签收 04待使用 05已使用
   */
  shopStutas?: string
  /**
   * 商品状态类型  00其他订单 01核销订单 02物流订单
   */
  shopType?: string
  /**
   * 订单状态类型 00:子单状态 01:父单状态（batchNo有值)
   */
  statusType?: string
}

/**
 * 接口 [获取多彩宝订单状态↗](https://yapi.gogpay.cn/project/906/interface/api/214642) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getDcbOrderStatus`
 */
type ApiOrderImsApiOpenApiGetDcbOrderStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/getDcbOrderStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取多彩宝订单状态↗](https://yapi.gogpay.cn/project/906/interface/api/214642) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getDcbOrderStatus`
 */
const apiOrderImsApiOpenApiGetDcbOrderStatusRequestConfig: ApiOrderImsApiOpenApiGetDcbOrderStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/getDcbOrderStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiGetDcbOrderStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取多彩宝订单状态', author: '成龙' },
  }

/**
 * 接口 [获取多彩宝订单状态↗](https://yapi.gogpay.cn/project/906/interface/api/214642) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getDcbOrderStatus`
 */
export const apiOrderImsApiOpenApiGetDcbOrderStatus = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiGetDcbOrderStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiGetDcbOrderStatusResponse>(
    prepare(apiOrderImsApiOpenApiGetDcbOrderStatusRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiGetDcbOrderStatus.requestConfig =
  apiOrderImsApiOpenApiGetDcbOrderStatusRequestConfig

/**
 * 接口 [创建开放订单↗](https://yapi.gogpay.cn/project/906/interface/api/268407) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/createOrder`
 */
export interface ApiOrderImsApiOpenApiCreateOrderRequest {
  /**
   * 订单金额
   */
  amount?: number
  /**
   * 订单未支付自动关闭时间（秒数)
   */
  closeSeconds?: number
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品副名称
   */
  commoditySubName?: string
  /**
   * 购买数量
   */
  quantity?: number
  /**
   * 店铺Logo图片
   */
  storeLogo?: string
  /**
   * 店铺名称 比如：VIP购买、课程购买
   */
  storeName?: string
  /**
   * 订单详情回调地址
   */
  targetUrl?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [创建开放订单↗](https://yapi.gogpay.cn/project/906/interface/api/268407) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/createOrder`
 */
export interface ApiOrderImsApiOpenApiCreateOrderResponse {
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 支付参数
   */
  payParams?: {}
}

/**
 * 接口 [创建开放订单↗](https://yapi.gogpay.cn/project/906/interface/api/268407) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/createOrder`
 */
type ApiOrderImsApiOpenApiCreateOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/createOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [创建开放订单↗](https://yapi.gogpay.cn/project/906/interface/api/268407) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/createOrder`
 */
const apiOrderImsApiOpenApiCreateOrderRequestConfig: ApiOrderImsApiOpenApiCreateOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/createOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiCreateOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '创建开放订单', author: '成龙' },
  }

/**
 * 接口 [创建开放订单↗](https://yapi.gogpay.cn/project/906/interface/api/268407) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/createOrder`
 */
export const apiOrderImsApiOpenApiCreateOrder = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiCreateOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiCreateOrderResponse>(
    prepare(apiOrderImsApiOpenApiCreateOrderRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiCreateOrder.requestConfig =
  apiOrderImsApiOpenApiCreateOrderRequestConfig

/**
 * 接口 [获取用户最后一笔支付单↗](https://yapi.gogpay.cn/project/906/interface/api/326746) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getUserLastPayOrder`
 */
export interface ApiOrderImsApiOpenApiGetUserLastPayOrderRequest {
  /**
   * 请求Id
   */
  id: string
}

/**
 * 接口 [获取用户最后一笔支付单↗](https://yapi.gogpay.cn/project/906/interface/api/326746) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getUserLastPayOrder`
 */
export interface ApiOrderImsApiOpenApiGetUserLastPayOrderResponse {
  /**
   * 订单创建时间
   */
  createTime?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单状态 0:待支付 1:支付成功 2:订单关闭 3:退款中 4:退款成功
   */
  orderStatus?: number
}

/**
 * 接口 [获取用户最后一笔支付单↗](https://yapi.gogpay.cn/project/906/interface/api/326746) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getUserLastPayOrder`
 */
type ApiOrderImsApiOpenApiGetUserLastPayOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/getUserLastPayOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户最后一笔支付单↗](https://yapi.gogpay.cn/project/906/interface/api/326746) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getUserLastPayOrder`
 */
const apiOrderImsApiOpenApiGetUserLastPayOrderRequestConfig: ApiOrderImsApiOpenApiGetUserLastPayOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/getUserLastPayOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiGetUserLastPayOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户最后一笔支付单', author: '成龙' },
  }

/**
 * 接口 [获取用户最后一笔支付单↗](https://yapi.gogpay.cn/project/906/interface/api/326746) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getUserLastPayOrder`
 */
export const apiOrderImsApiOpenApiGetUserLastPayOrder = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiGetUserLastPayOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiGetUserLastPayOrderResponse>(
    prepare(apiOrderImsApiOpenApiGetUserLastPayOrderRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiGetUserLastPayOrder.requestConfig =
  apiOrderImsApiOpenApiGetUserLastPayOrderRequestConfig

/**
 * 接口 [获取用户订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/326754) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/queryUserOrderCount`
 */
export interface ApiOrderImsApiOpenApiQueryUserOrderCountRequest {
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [获取用户订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/326754) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/queryUserOrderCount`
 */
export interface ApiOrderImsApiOpenApiQueryUserOrderCountResponse {
  /**
   * 订单数量
   */
  count?: number
}

/**
 * 接口 [获取用户订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/326754) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/queryUserOrderCount`
 */
type ApiOrderImsApiOpenApiQueryUserOrderCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/queryUserOrderCount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/326754) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/queryUserOrderCount`
 */
const apiOrderImsApiOpenApiQueryUserOrderCountRequestConfig: ApiOrderImsApiOpenApiQueryUserOrderCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/queryUserOrderCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiQueryUserOrderCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户订单数量', author: '成龙' },
  }

/**
 * 接口 [获取用户订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/326754) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/queryUserOrderCount`
 */
export const apiOrderImsApiOpenApiQueryUserOrderCount = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiQueryUserOrderCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiQueryUserOrderCountResponse>(
    prepare(apiOrderImsApiOpenApiQueryUserOrderCountRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiQueryUserOrderCount.requestConfig =
  apiOrderImsApiOpenApiQueryUserOrderCountRequestConfig

/**
 * 接口 [获取订单结算金额↗](https://yapi.gogpay.cn/project/906/interface/api/331242) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettAmount`
 */
export interface ApiOrderImsApiOpenApiGetOrderSettAmountRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取订单结算金额↗](https://yapi.gogpay.cn/project/906/interface/api/331242) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettAmount`
 */
export type ApiOrderImsApiOpenApiGetOrderSettAmountResponse = number

/**
 * 接口 [获取订单结算金额↗](https://yapi.gogpay.cn/project/906/interface/api/331242) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettAmount`
 */
type ApiOrderImsApiOpenApiGetOrderSettAmountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/getOrderSettAmount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单结算金额↗](https://yapi.gogpay.cn/project/906/interface/api/331242) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettAmount`
 */
const apiOrderImsApiOpenApiGetOrderSettAmountRequestConfig: ApiOrderImsApiOpenApiGetOrderSettAmountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/getOrderSettAmount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiGetOrderSettAmount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单结算金额', author: '333号开发' },
  }

/**
 * 接口 [获取订单结算金额↗](https://yapi.gogpay.cn/project/906/interface/api/331242) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/getOrderSettAmount`
 */
export const apiOrderImsApiOpenApiGetOrderSettAmount = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiGetOrderSettAmountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiGetOrderSettAmountResponse>(
    prepare(apiOrderImsApiOpenApiGetOrderSettAmountRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiGetOrderSettAmount.requestConfig =
  apiOrderImsApiOpenApiGetOrderSettAmountRequestConfig

/**
 * 接口 [标销-模糊获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/380673) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/recordByUser`
 */
export interface ApiOrderImsApiOpenApiWriteOffRecordByUserRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 机构编码
   */
  unitOrgCode: string
}

/**
 * 接口 [标销-模糊获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/380673) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/recordByUser`
 */
export interface ApiOrderImsApiOpenApiWriteOffRecordByUserResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 核销码
     */
    code?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 商品价格
     */
    commodityPrice?: number
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 核销记录Id
     */
    id?: string
    /**
     * 核销来源
     */
    writeOffSourceLabel?: string
    /**
     * 核销来源值  1平台端 2商家端  3移动端
     */
    writeOffSourceValue?: number
    /**
     * 核销时间
     */
    writeOffTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [标销-模糊获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/380673) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/recordByUser`
 */
type ApiOrderImsApiOpenApiWriteOffRecordByUserRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/writeOff/recordByUser',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [标销-模糊获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/380673) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/recordByUser`
 */
const apiOrderImsApiOpenApiWriteOffRecordByUserRequestConfig: ApiOrderImsApiOpenApiWriteOffRecordByUserRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/writeOff/recordByUser',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiWriteOffRecordByUser',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '标销-模糊获取商家核销记录', author: '333号开发' },
  }

/**
 * 接口 [标销-模糊获取商家核销记录↗](https://yapi.gogpay.cn/project/906/interface/api/380673) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/writeOff/recordByUser`
 */
export const apiOrderImsApiOpenApiWriteOffRecordByUser = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiWriteOffRecordByUserRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiWriteOffRecordByUserResponse>(
    prepare(
      apiOrderImsApiOpenApiWriteOffRecordByUserRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOpenApiWriteOffRecordByUser.requestConfig =
  apiOrderImsApiOpenApiWriteOffRecordByUserRequestConfig

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/405518) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/ship`
 */
export interface ApiOrderImsApiOpenApiShipRequest {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 发货方式 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配 4同城配送 5商家自配
   */
  orderShipType?: '1' | '2' | '3' | '4' | '5'
  /**
   * 包裹列表
   */
  packageItems?: {
    /**
     * 订单商品Id，和sku Id二选一传递
     */
    commodityId?: {
      commodityCount?: number
      commodityId?: string
    }[]
    /**
     * 快递公司编码，当发货方式为【线下自寄】时必传
     */
    companyCode?: string
    /**
     * 快递公司名称，当发货方式为【线下自寄】时必传
     */
    companyName?: string
    /**
     * 运单号，当发货方式为【线下自寄】时必传
     */
    logisticCode?: string
    /**
     * 快递公司信息Id，当发货方式为【线上发货】时必传
     */
    merchantShipperId?: string
    /**
     * 备注信息
     */
    remark?: string
    /**
     * 订单商品SKU Id,和订单商品Id二选一传递
     */
    skuId?: {
      commodityCount?: number
      commoditySkuId?: string
    }[]
  }[]
  /**
   * 备注信息，线下自提时的备注传入此处
   */
  remark?: string
  /**
   * 门店自提地址Id，当发货方式为【门店自提】时必传
   */
  selfAddress?: string
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/405518) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/ship`
 */
export interface ApiOrderImsApiOpenApiShipResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/405518) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/ship`
 */
type ApiOrderImsApiOpenApiShipRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/ship',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/405518) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/ship`
 */
const apiOrderImsApiOpenApiShipRequestConfig: ApiOrderImsApiOpenApiShipRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/ship',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiShip',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单发货', author: '511号开发' },
  }

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/405518) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/ship`
 */
export const apiOrderImsApiOpenApiShip = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiShipRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiShipResponse>(
    prepare(apiOrderImsApiOpenApiShipRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiShip.requestConfig = apiOrderImsApiOpenApiShipRequestConfig

/**
 * 接口 [积分商城-订单支付详情↗](https://yapi.gogpay.cn/project/906/interface/api/426603) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetailByIntegral`
 */
export interface ApiOrderImsApiOpenApiOrderDetailByIntegralRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [积分商城-订单支付详情↗](https://yapi.gogpay.cn/project/906/interface/api/426603) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetailByIntegral`
 */
export interface ApiOrderImsApiOpenApiOrderDetailByIntegralResponse {
  /**
   * 订单编号
   */
  orderNo?: string
  payInfoVO?: {
    /**
     * 支付金额
     */
    amount?: number
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付渠道
     */
    payChannel?: string
    /**
     * 支付内容
     */
    payContent?: string
    /**
     * 支付场景
     */
    payScenario?: string
    /**
     * 支付流水号
     */
    paySerialNo?: string
    /**
     * 支付状态
     */
    payStatus?: string
    /**
     * 支付时间
     */
    payTime?: string
  }
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [积分商城-订单支付详情↗](https://yapi.gogpay.cn/project/906/interface/api/426603) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetailByIntegral`
 */
type ApiOrderImsApiOpenApiOrderDetailByIntegralRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/orderDetailByIntegral',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [积分商城-订单支付详情↗](https://yapi.gogpay.cn/project/906/interface/api/426603) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetailByIntegral`
 */
const apiOrderImsApiOpenApiOrderDetailByIntegralRequestConfig: ApiOrderImsApiOpenApiOrderDetailByIntegralRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/orderDetailByIntegral',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiOrderDetailByIntegral',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '积分商城-订单支付详情', author: '511号开发' },
  }

/**
 * 接口 [积分商城-订单支付详情↗](https://yapi.gogpay.cn/project/906/interface/api/426603) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/orderDetailByIntegral`
 */
export const apiOrderImsApiOpenApiOrderDetailByIntegral = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiOrderDetailByIntegralRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiOrderDetailByIntegralResponse>(
    prepare(
      apiOrderImsApiOpenApiOrderDetailByIntegralRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOpenApiOrderDetailByIntegral.requestConfig =
  apiOrderImsApiOpenApiOrderDetailByIntegralRequestConfig

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/459338) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/userStoreList`
 */
export interface ApiOrderImsApiOpenApiUserStoreListRequest {
  auth?: boolean
  authCardNo?: string
  authId?: string
  authName?: string
  authStatus?: string
  avatar?: string
  headerParams?: {
    carrier?: string
    cityCode?: string
    clientId?: string
    deviceId?: string
    deviceName?: string
    districtCode?: string
    latitude?: string
    locateCityCode?: string
    locateDistrictCode?: string
    locateProvinceCode?: string
    longitude?: string
    netType?: string
    osVersion?: string
    phoneNum?: string
    provinceCode?: string
    releaseCode?: string
    serviceCityCode?: string
    serviceCityName?: string
    serviceCountryCode?: string
    serviceCountryName?: string
    serviceDistrictCode?: string
    serviceDistrictName?: string
    serviceProvinceCode?: string
    serviceProvinceName?: string
    userId?: string
    versionCode?: string
  }
  registerPhone?: string
  userId?: string
  userName?: string
}

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/459338) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/userStoreList`
 */
export type ApiOrderImsApiOpenApiUserStoreListResponse = {
  /**
   * 是否默认选中
   */
  defaultChoose?: boolean
  /**
   * logo图片
   */
  logo?: string
  /**
   * 店铺Id，核销店铺Id
   */
  merchantId?: string
  /**
   * 店铺名称
   */
  merchantName?: string
  /**
   * 公告
   */
  notice?: string
}[]

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/459338) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/userStoreList`
 */
type ApiOrderImsApiOpenApiUserStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/openApi/userStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/459338) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/userStoreList`
 */
const apiOrderImsApiOpenApiUserStoreListRequestConfig: ApiOrderImsApiOpenApiUserStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_5,
    devUrl: devUrl_0_5_0_5,
    prodUrl: prodUrl_0_5_0_5,
    path: '/order/imsApi/openApi/userStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOpenApiUserStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺列表', author: '503号开发' },
  }

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/459338) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [开放接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_22167)
 * @请求头 `POST /order/imsApi/openApi/userStoreList`
 */
export const apiOrderImsApiOpenApiUserStoreList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOpenApiUserStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOpenApiUserStoreListResponse>(
    prepare(apiOrderImsApiOpenApiUserStoreListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOpenApiUserStoreList.requestConfig =
  apiOrderImsApiOpenApiUserStoreListRequestConfig

const mockUrl_0_5_0_6 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_6 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_6 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_6 = 'data' as any

/**
 * 接口 [统计商品销量↗](https://yapi.gogpay.cn/project/906/interface/api/118186) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/commoditySellQuantity`
 */
export interface ApiOrderImsApiStatisticsCommoditySellQuantityRequest {
  /**
   * 商品Id
   */
  commodityId: string
}

/**
 * 接口 [统计商品销量↗](https://yapi.gogpay.cn/project/906/interface/api/118186) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/commoditySellQuantity`
 */
export type ApiOrderImsApiStatisticsCommoditySellQuantityResponse = number

/**
 * 接口 [统计商品销量↗](https://yapi.gogpay.cn/project/906/interface/api/118186) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/commoditySellQuantity`
 */
type ApiOrderImsApiStatisticsCommoditySellQuantityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/statistics/commoditySellQuantity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [统计商品销量↗](https://yapi.gogpay.cn/project/906/interface/api/118186) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/commoditySellQuantity`
 */
const apiOrderImsApiStatisticsCommoditySellQuantityRequestConfig: ApiOrderImsApiStatisticsCommoditySellQuantityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_6,
    devUrl: devUrl_0_5_0_6,
    prodUrl: prodUrl_0_5_0_6,
    path: '/order/imsApi/statistics/commoditySellQuantity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiStatisticsCommoditySellQuantity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '统计商品销量', author: '成龙' },
  }

/**
 * 接口 [统计商品销量↗](https://yapi.gogpay.cn/project/906/interface/api/118186) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/commoditySellQuantity`
 */
export const apiOrderImsApiStatisticsCommoditySellQuantity = /*#__PURE__*/ (
  requestData: ApiOrderImsApiStatisticsCommoditySellQuantityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiStatisticsCommoditySellQuantityResponse>(
    prepare(
      apiOrderImsApiStatisticsCommoditySellQuantityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiStatisticsCommoditySellQuantity.requestConfig =
  apiOrderImsApiStatisticsCommoditySellQuantityRequestConfig

/**
 * 接口 [统计规格销量↗](https://yapi.gogpay.cn/project/906/interface/api/118192) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/skuSellQuantity`
 */
export interface ApiOrderImsApiStatisticsSkuSellQuantityRequest {
  /**
   * 规格Id
   */
  skuId: string
}

/**
 * 接口 [统计规格销量↗](https://yapi.gogpay.cn/project/906/interface/api/118192) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/skuSellQuantity`
 */
export type ApiOrderImsApiStatisticsSkuSellQuantityResponse = number

/**
 * 接口 [统计规格销量↗](https://yapi.gogpay.cn/project/906/interface/api/118192) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/skuSellQuantity`
 */
type ApiOrderImsApiStatisticsSkuSellQuantityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/statistics/skuSellQuantity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [统计规格销量↗](https://yapi.gogpay.cn/project/906/interface/api/118192) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/skuSellQuantity`
 */
const apiOrderImsApiStatisticsSkuSellQuantityRequestConfig: ApiOrderImsApiStatisticsSkuSellQuantityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_6,
    devUrl: devUrl_0_5_0_6,
    prodUrl: prodUrl_0_5_0_6,
    path: '/order/imsApi/statistics/skuSellQuantity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiStatisticsSkuSellQuantity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '统计规格销量', author: '成龙' },
  }

/**
 * 接口 [统计规格销量↗](https://yapi.gogpay.cn/project/906/interface/api/118192) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/skuSellQuantity`
 */
export const apiOrderImsApiStatisticsSkuSellQuantity = /*#__PURE__*/ (
  requestData: ApiOrderImsApiStatisticsSkuSellQuantityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiStatisticsSkuSellQuantityResponse>(
    prepare(apiOrderImsApiStatisticsSkuSellQuantityRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiStatisticsSkuSellQuantity.requestConfig =
  apiOrderImsApiStatisticsSkuSellQuantityRequestConfig

/**
 * 接口 [获取指定日期订单统计信息↗](https://yapi.gogpay.cn/project/906/interface/api/261156) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/dayOrderStat`
 */
export interface ApiOrderImsApiStatisticsDayOrderStatRequest {
  /**
   * 统计日期,不传则为今日
   */
  statDate?: string
}

/**
 * 接口 [获取指定日期订单统计信息↗](https://yapi.gogpay.cn/project/906/interface/api/261156) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/dayOrderStat`
 */
export interface ApiOrderImsApiStatisticsDayOrderStatResponse {
  /**
   * 查询日期订单销售额
   */
  amount?: string
  /**
   * 查询日期订单数量
   */
  quantity?: number
}

/**
 * 接口 [获取指定日期订单统计信息↗](https://yapi.gogpay.cn/project/906/interface/api/261156) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/dayOrderStat`
 */
type ApiOrderImsApiStatisticsDayOrderStatRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/statistics/dayOrderStat',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取指定日期订单统计信息↗](https://yapi.gogpay.cn/project/906/interface/api/261156) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/dayOrderStat`
 */
const apiOrderImsApiStatisticsDayOrderStatRequestConfig: ApiOrderImsApiStatisticsDayOrderStatRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_6,
    devUrl: devUrl_0_5_0_6,
    prodUrl: prodUrl_0_5_0_6,
    path: '/order/imsApi/statistics/dayOrderStat',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiStatisticsDayOrderStat',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取指定日期订单统计信息', author: '成龙' },
  }

/**
 * 接口 [获取指定日期订单统计信息↗](https://yapi.gogpay.cn/project/906/interface/api/261156) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [统计↗](https://yapi.gogpay.cn/project/906/interface/api/cat_23763)
 * @请求头 `POST /order/imsApi/statistics/dayOrderStat`
 */
export const apiOrderImsApiStatisticsDayOrderStat = /*#__PURE__*/ (
  requestData: ApiOrderImsApiStatisticsDayOrderStatRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiStatisticsDayOrderStatResponse>(
    prepare(apiOrderImsApiStatisticsDayOrderStatRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiStatisticsDayOrderStat.requestConfig =
  apiOrderImsApiStatisticsDayOrderStatRequestConfig

const mockUrl_0_5_0_9 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_9 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_9 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_9 = 'data' as any

/**
 * 接口 [商户中心首页↗](https://yapi.gogpay.cn/project/906/interface/api/188786) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/index`
 */
export interface ApiOrderMerchantIndexRequest {}

/**
 * 接口 [商户中心首页↗](https://yapi.gogpay.cn/project/906/interface/api/188786) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/index`
 */
export interface ApiOrderMerchantIndexResponse {
  /**
   * 配送中数量
   */
  deliverCount?: number
  /**
   * 已完成数量
   */
  doneCount?: number
  /**
   * 店铺公告
   */
  notice?: string
  /**
   * 售后进行中数量
   */
  refundingCount?: number
  /**
   * 售后/退款数量数量
   */
  saleRefundCount?: number
  /**
   * 待配送数量
   */
  waitDeliverCount?: number
  /**
   * 待接单数量
   */
  waitTakeCount?: number
}

/**
 * 接口 [商户中心首页↗](https://yapi.gogpay.cn/project/906/interface/api/188786) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/index`
 */
type ApiOrderMerchantIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/index',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [商户中心首页↗](https://yapi.gogpay.cn/project/906/interface/api/188786) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/index`
 */
const apiOrderMerchantIndexRequestConfig: ApiOrderMerchantIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/index',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户中心首页', author: '成龙' },
  }

/**
 * 接口 [商户中心首页↗](https://yapi.gogpay.cn/project/906/interface/api/188786) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/index`
 */
export const apiOrderMerchantIndex = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantIndexResponse>(
    prepare(apiOrderMerchantIndexRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantIndex.requestConfig = apiOrderMerchantIndexRequestConfig

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188790) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/list`
 */
export interface ApiOrderMerchantOrderListRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中
   */
  status?: number
  /**
   * 下单手机号
   */
  userPhone?: string
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188790) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/list`
 */
export interface ApiOrderMerchantOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品数据
     */
    commodityNames?: string[]
    consigneeInfo?: {
      /**
       * 收件地址-详细地址
       */
      address?: string
      /**
       * 收件地址-地区
       */
      area?: string
      /**
       * 收件地址-城市
       */
      city?: string
      /**
       * 收件人
       */
      name?: string
      /**
       * 包裹数量，如果为0则是未发货
       */
      packageQuantity?: number
      /**
       * 包裹发送类型 0未发货 1整包发货 2拆包发货
       */
      packageType?: number
      /**
       * 收件地址-省份
       */
      province?: string
      /**
       * 收件人手机号
       */
      tel?: string
    }
    deliverUserInfo?: {
      /**
       * 服务人员Id
       */
      serviceUserId?: string
      /**
       * 服务人员姓名
       */
      serviceUserName?: string
      /**
       * 服务人员手机号
       */
      serviceUserTel?: string
      /**
       * 自定义配送文案
       */
      tips?: string
    }
    /**
     * 订单金额
     */
    orderAmount?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单状态
     */
    orderStatus?: number
    /**
     * 订单状态标签
     */
    orderStatusLabel?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 商品封面图
     */
    pic?: string
    /**
     * 售后状态 0无售后 1待商家处理  2已完成 3售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态标签
     */
    saleAfterStatusLabel?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188790) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/list`
 */
type ApiOrderMerchantOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188790) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/list`
 */
const apiOrderMerchantOrderListRequestConfig: ApiOrderMerchantOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表', author: '成龙' },
  }

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188790) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/list`
 */
export const apiOrderMerchantOrderList = /*#__PURE__*/ (
  requestData: ApiOrderMerchantOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOrderListResponse>(
    prepare(apiOrderMerchantOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOrderList.requestConfig = apiOrderMerchantOrderListRequestConfig

/**
 * 接口 [拒绝接单↗](https://yapi.gogpay.cn/project/906/interface/api/188794) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/reject`
 */
export interface ApiOrderMerchantOrderRejectRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 拒绝原因
   */
  reason: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [拒绝接单↗](https://yapi.gogpay.cn/project/906/interface/api/188794) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/reject`
 */
export interface ApiOrderMerchantOrderRejectResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [拒绝接单↗](https://yapi.gogpay.cn/project/906/interface/api/188794) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/reject`
 */
type ApiOrderMerchantOrderRejectRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/order/reject',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [拒绝接单↗](https://yapi.gogpay.cn/project/906/interface/api/188794) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/reject`
 */
const apiOrderMerchantOrderRejectRequestConfig: ApiOrderMerchantOrderRejectRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/order/reject',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOrderReject',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '拒绝接单', author: '成龙' },
  }

/**
 * 接口 [拒绝接单↗](https://yapi.gogpay.cn/project/906/interface/api/188794) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/reject`
 */
export const apiOrderMerchantOrderReject = /*#__PURE__*/ (
  requestData: ApiOrderMerchantOrderRejectRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOrderRejectResponse>(
    prepare(apiOrderMerchantOrderRejectRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOrderReject.requestConfig =
  apiOrderMerchantOrderRejectRequestConfig

/**
 * 接口 [同意接单↗](https://yapi.gogpay.cn/project/906/interface/api/188798) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/take`
 */
export interface ApiOrderMerchantOrderTakeRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [同意接单↗](https://yapi.gogpay.cn/project/906/interface/api/188798) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/take`
 */
export interface ApiOrderMerchantOrderTakeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [同意接单↗](https://yapi.gogpay.cn/project/906/interface/api/188798) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/take`
 */
type ApiOrderMerchantOrderTakeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/order/take',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同意接单↗](https://yapi.gogpay.cn/project/906/interface/api/188798) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/take`
 */
const apiOrderMerchantOrderTakeRequestConfig: ApiOrderMerchantOrderTakeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/order/take',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOrderTake',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同意接单', author: '成龙' },
  }

/**
 * 接口 [同意接单↗](https://yapi.gogpay.cn/project/906/interface/api/188798) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/take`
 */
export const apiOrderMerchantOrderTake = /*#__PURE__*/ (
  requestData: ApiOrderMerchantOrderTakeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOrderTakeResponse>(
    prepare(apiOrderMerchantOrderTakeRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOrderTake.requestConfig = apiOrderMerchantOrderTakeRequestConfig

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/188810) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/storeList`
 */
export interface ApiOrderMerchantStoreListRequest {}

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/188810) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/storeList`
 */
export type ApiOrderMerchantStoreListResponse = {
  /**
   * 是否默认选中
   */
  defaultChoose?: boolean
  /**
   * logo图片
   */
  logo?: string
  /**
   * 店铺Id，核销店铺Id
   */
  merchantId?: string
  /**
   * 店铺名称
   */
  merchantName?: string
  /**
   * 公告
   */
  notice?: string
}[]

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/188810) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/storeList`
 */
type ApiOrderMerchantStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/storeList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/188810) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/storeList`
 */
const apiOrderMerchantStoreListRequestConfig: ApiOrderMerchantStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/storeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺列表', author: '成龙' },
  }

/**
 * 接口 [获取用户店铺列表↗](https://yapi.gogpay.cn/project/906/interface/api/188810) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/storeList`
 */
export const apiOrderMerchantStoreList = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantStoreListResponse>(
    prepare(apiOrderMerchantStoreListRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantStoreList.requestConfig = apiOrderMerchantStoreListRequestConfig

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188830) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/addOrUpdate`
 */
export interface ApiOrderMerchantDeliveryUserAddOrUpdateRequest {
  /**
   * ID
   */
  id?: string
  /**
   * 配送人员名称
   */
  userName?: string
  /**
   * 配送人员电话
   */
  userPhone?: string
}

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188830) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/addOrUpdate`
 */
export type ApiOrderMerchantDeliveryUserAddOrUpdateResponse = string

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188830) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/addOrUpdate`
 */
type ApiOrderMerchantDeliveryUserAddOrUpdateRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/deliveryUser/addOrUpdate',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188830) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/addOrUpdate`
 */
const apiOrderMerchantDeliveryUserAddOrUpdateRequestConfig: ApiOrderMerchantDeliveryUserAddOrUpdateRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/deliveryUser/addOrUpdate',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantDeliveryUserAddOrUpdate',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增或更新配送人员', author: '成龙' },
  }

/**
 * 接口 [新增或更新配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188830) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/addOrUpdate`
 */
export const apiOrderMerchantDeliveryUserAddOrUpdate = /*#__PURE__*/ (
  requestData: ApiOrderMerchantDeliveryUserAddOrUpdateRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantDeliveryUserAddOrUpdateResponse>(
    prepare(apiOrderMerchantDeliveryUserAddOrUpdateRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantDeliveryUserAddOrUpdate.requestConfig =
  apiOrderMerchantDeliveryUserAddOrUpdateRequestConfig

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188834) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/delete`
 */
export interface ApiOrderMerchantDeliveryUserDeleteRequest {
  /**
   * 请求Id
   */
  id: string
}

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188834) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/delete`
 */
export type ApiOrderMerchantDeliveryUserDeleteResponse = string

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188834) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/delete`
 */
type ApiOrderMerchantDeliveryUserDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/deliveryUser/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188834) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/delete`
 */
const apiOrderMerchantDeliveryUserDeleteRequestConfig: ApiOrderMerchantDeliveryUserDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/deliveryUser/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantDeliveryUserDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除店铺配送人员', author: '成龙' },
  }

/**
 * 接口 [删除店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188834) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/delete`
 */
export const apiOrderMerchantDeliveryUserDelete = /*#__PURE__*/ (
  requestData: ApiOrderMerchantDeliveryUserDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantDeliveryUserDeleteResponse>(
    prepare(apiOrderMerchantDeliveryUserDeleteRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantDeliveryUserDelete.requestConfig =
  apiOrderMerchantDeliveryUserDeleteRequestConfig

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188838) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/list`
 */
export interface ApiOrderMerchantDeliveryUserListRequest {}

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188838) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/list`
 */
export type ApiOrderMerchantDeliveryUserListResponse = {
  /**
   * ID
   */
  id?: string
  /**
   * 配送人员名称
   */
  userName?: string
  /**
   * 配送人员电话
   */
  userPhone?: string
  /**
   * 店铺ID
   */
  storeId?: string
}[]

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188838) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/list`
 */
type ApiOrderMerchantDeliveryUserListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/deliveryUser/list',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188838) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/list`
 */
const apiOrderMerchantDeliveryUserListRequestConfig: ApiOrderMerchantDeliveryUserListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/deliveryUser/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantDeliveryUserList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺配送人员', author: '成龙' },
  }

/**
 * 接口 [获取店铺配送人员↗](https://yapi.gogpay.cn/project/906/interface/api/188838) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/deliveryUser/list`
 */
export const apiOrderMerchantDeliveryUserList = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantDeliveryUserListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantDeliveryUserListResponse>(
    prepare(apiOrderMerchantDeliveryUserListRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantDeliveryUserList.requestConfig =
  apiOrderMerchantDeliveryUserListRequestConfig

/**
 * 接口 [配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/189614) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/deliver`
 */
export interface ApiOrderMerchantOrderDeliverRequest {
  /**
   * 配送人员Id
   */
  deliverUserId: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
  /**
   * 自定义文案
   */
  tips?: string
}

/**
 * 接口 [配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/189614) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/deliver`
 */
export interface ApiOrderMerchantOrderDeliverResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/189614) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/deliver`
 */
type ApiOrderMerchantOrderDeliverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/order/deliver',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/189614) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/deliver`
 */
const apiOrderMerchantOrderDeliverRequestConfig: ApiOrderMerchantOrderDeliverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/order/deliver',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOrderDeliver',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '配送订单', author: '成龙' },
  }

/**
 * 接口 [配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/189614) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/deliver`
 */
export const apiOrderMerchantOrderDeliver = /*#__PURE__*/ (
  requestData: ApiOrderMerchantOrderDeliverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOrderDeliverResponse>(
    prepare(apiOrderMerchantOrderDeliverRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOrderDeliver.requestConfig =
  apiOrderMerchantOrderDeliverRequestConfig

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/189618) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/detail`
 */
export interface ApiOrderMerchantOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/189618) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/detail`
 */
export interface ApiOrderMerchantOrderDetailResponse {
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单商品列表
   */
  commodities?: {
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 规格
     */
    skuDesc?: string
    /**
     * 规格Id
     */
    skuId?: string
    /**
     * 总价
     */
    totalPrice?: number
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 完成时间
   */
  dealTime?: string
  deliverUser?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 支付金额
   */
  payAmount?: number
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 运费/配送费
   */
  postFee?: number
  /**
   * 退款时间
   */
  refundTime?: string
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 售后状态 0无售后 1待商家处理  2已完成
   */
  saleAfterStatus?: number
  /**
   * 售后状态标签
   */
  saleAfterStatusLabel?: string
  /**
   * 配送时间
   */
  shipTime?: string
  /**
   * 订单状态 0待支付
   * 100待发货
   * 101已发货
   *
   * 400待接单
   * 401待配送
   * 402配送中
   *
   * 900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 订单状态变更原因
   */
  statusReason?: string
  /**
   * 接单时间
   */
  takeTime?: string
  /**
   * 订单提示信息
   */
  tips?: string
  /**
   * 买家姓名
   */
  userName?: string
  /**
   * 买家手机
   */
  userPhone?: string
}

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/189618) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/detail`
 */
type ApiOrderMerchantOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/189618) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/detail`
 */
const apiOrderMerchantOrderDetailRequestConfig: ApiOrderMerchantOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '配送订单详情', author: '成龙' },
  }

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/189618) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/order/detail`
 */
export const apiOrderMerchantOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderMerchantOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOrderDetailResponse>(
    prepare(apiOrderMerchantOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOrderDetail.requestConfig =
  apiOrderMerchantOrderDetailRequestConfig

/**
 * 接口 [获取店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189626) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getConfig`
 */
export interface ApiOrderMerchantGetConfigRequest {}

/**
 * 接口 [获取店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189626) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getConfig`
 */
export interface ApiOrderMerchantGetConfigResponse {
  /**
   * 是否自动接单
   */
  autoReceive?: boolean
  /**
   * 公告
   */
  notice?: string
}

/**
 * 接口 [获取店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189626) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getConfig`
 */
type ApiOrderMerchantGetConfigRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/getConfig',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189626) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getConfig`
 */
const apiOrderMerchantGetConfigRequestConfig: ApiOrderMerchantGetConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/getConfig',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantGetConfig',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺配置', author: '成龙' },
  }

/**
 * 接口 [获取店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189626) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getConfig`
 */
export const apiOrderMerchantGetConfig = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantGetConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantGetConfigResponse>(
    prepare(apiOrderMerchantGetConfigRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantGetConfig.requestConfig = apiOrderMerchantGetConfigRequestConfig

/**
 * 接口 [更新店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189630) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/updateConfig`
 */
export interface ApiOrderMerchantUpdateConfigRequest {
  /**
   * 是否自动接单
   */
  autoReceive?: boolean
  /**
   * 公告
   */
  notice?: string
}

/**
 * 接口 [更新店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189630) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/updateConfig`
 */
export interface ApiOrderMerchantUpdateConfigResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [更新店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189630) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/updateConfig`
 */
type ApiOrderMerchantUpdateConfigRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/updateConfig',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [更新店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189630) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/updateConfig`
 */
const apiOrderMerchantUpdateConfigRequestConfig: ApiOrderMerchantUpdateConfigRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/updateConfig',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantUpdateConfig',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '更新店铺配置', author: '成龙' },
  }

/**
 * 接口 [更新店铺配置↗](https://yapi.gogpay.cn/project/906/interface/api/189630) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/updateConfig`
 */
export const apiOrderMerchantUpdateConfig = /*#__PURE__*/ (
  requestData: ApiOrderMerchantUpdateConfigRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantUpdateConfigResponse>(
    prepare(apiOrderMerchantUpdateConfigRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantUpdateConfig.requestConfig =
  apiOrderMerchantUpdateConfigRequestConfig

/**
 * 接口 [获取用户店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/458653) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantBusinessInfo`
 */
export interface ApiOrderMerchantFindMerchantBusinessInfoRequest {
  /**
   * 请求Id
   */
  id: string
}

/**
 * 接口 [获取用户店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/458653) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantBusinessInfo`
 */
export interface ApiOrderMerchantFindMerchantBusinessInfoResponse {
  /**
   * 预计营业额
   */
  expectedRevenue?: number
  /**
   * 店铺状态 1 待营业 2 营业中 3 已停业 4 休息中
   */
  storeStatus?: number
  /**
   * 有效订单
   */
  validOrderCount?: number
}

/**
 * 接口 [获取用户店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/458653) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantBusinessInfo`
 */
type ApiOrderMerchantFindMerchantBusinessInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findMerchantBusinessInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/458653) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantBusinessInfo`
 */
const apiOrderMerchantFindMerchantBusinessInfoRequestConfig: ApiOrderMerchantFindMerchantBusinessInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findMerchantBusinessInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindMerchantBusinessInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺首页营业额信息', author: '511号开发' },
  }

/**
 * 接口 [获取用户店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/458653) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantBusinessInfo`
 */
export const apiOrderMerchantFindMerchantBusinessInfo = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindMerchantBusinessInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindMerchantBusinessInfoResponse>(
    prepare(apiOrderMerchantFindMerchantBusinessInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantFindMerchantBusinessInfo.requestConfig =
  apiOrderMerchantFindMerchantBusinessInfoRequestConfig

/**
 * 接口 [获取用户店铺订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/459318) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderList`
 */
export interface ApiOrderMerchantFindMerchantOrderListRequest {
  /**
   * 下单起始时间
   */
  beginTime?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 订单编号/收件人手机号
   */
  keyword?: string
  /**
   * 商户店铺Id
   */
  merchantId: string
  /**
   * 订单分类 1标准电商 2标准核销
   */
  orderClassification?: number
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 订单编号列表
   */
  orderNoList?: string[]
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中 11盲盒 12拼团
   */
  orderStatus?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取用户店铺订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/459318) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderList`
 */
export interface ApiOrderMerchantFindMerchantOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单实付款
     */
    actualReceivable?: number
    appointmentDate?: string
    /**
     * 预约人
     */
    appointmentName?: string
    /**
     * 预约手机
     */
    appointmentPhone?: string
    buyerVO?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 商品数据
     */
    commodityInfo?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态文案
       */
      saleAfterName?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    consigneeInfo?: {
      /**
       * 收件地址-详细地址
       */
      address?: string
      /**
       * 收件地址-地区
       */
      area?: string
      /**
       * 收件地址-城市
       */
      city?: string
      /**
       * 收件人
       */
      name?: string
      /**
       * 包裹数量，如果为0则是未发货
       */
      packageQuantity?: number
      /**
       * 包裹发送类型 0未发货 1整包发货 2拆包发货
       */
      packageType?: number
      /**
       * 收件地址-省份
       */
      province?: string
      /**
       * 收件人手机号
       */
      tel?: string
    }
    deliverUserInfo?: {
      /**
       * 服务人员Id
       */
      serviceUserId?: string
      /**
       * 服务人员姓名
       */
      serviceUserName?: string
      /**
       * 服务人员手机号
       */
      serviceUserTel?: string
      /**
       * 自定义配送文案
       */
      tips?: string
    }
    /**
     * 配送方式值 1现场提货 3配送发货
     */
    logisticsMethodValue?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 是否需要上传签收单0否 1是
     */
    needUploadSignature?: number
    /**
     * 订单总金额
     */
    orderAmount?: number
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单分类 1标准电商 2派送核销
     */
    orderClassification?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单状态
     */
    orderStatus?: number
    /**
     * 订单状态标签
     */
    orderStatusLabel?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 售后状态 0无售后 1待商家处理  2已完成 3售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态标签
     */
    saleAfterStatusLabel?: string
    /**
     * 0普通订单 1 门店自提
     */
    shipType?: number
    /**
     * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
     */
    shippingType?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取用户店铺订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/459318) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderList`
 */
type ApiOrderMerchantFindMerchantOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findMerchantOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/459318) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderList`
 */
const apiOrderMerchantFindMerchantOrderListRequestConfig: ApiOrderMerchantFindMerchantOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findMerchantOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindMerchantOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺订单列表', author: '503号开发' },
  }

/**
 * 接口 [获取用户店铺订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/459318) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderList`
 */
export const apiOrderMerchantFindMerchantOrderList = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindMerchantOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindMerchantOrderListResponse>(
    prepare(apiOrderMerchantFindMerchantOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantFindMerchantOrderList.requestConfig =
  apiOrderMerchantFindMerchantOrderListRequestConfig

/**
 * 接口 [客户端-商户修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/459323) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyAddress`
 */
export interface ApiOrderMerchantModifyAddressRequest {
  /**
   * 收货人姓名
   */
  consigneeName: string
  /**
   * 收货人手机号
   */
  consigneeTel: number
  /**
   * 订单编号
   */
  orderNo: string
  receiveAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
}

/**
 * 接口 [客户端-商户修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/459323) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyAddress`
 */
export interface ApiOrderMerchantModifyAddressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-商户修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/459323) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyAddress`
 */
type ApiOrderMerchantModifyAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/modifyAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-商户修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/459323) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyAddress`
 */
const apiOrderMerchantModifyAddressRequestConfig: ApiOrderMerchantModifyAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/modifyAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantModifyAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-商户修改订单收货地址', author: '503号开发' },
  }

/**
 * 接口 [客户端-商户修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/459323) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyAddress`
 */
export const apiOrderMerchantModifyAddress = /*#__PURE__*/ (
  requestData: ApiOrderMerchantModifyAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantModifyAddressResponse>(
    prepare(apiOrderMerchantModifyAddressRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantModifyAddress.requestConfig =
  apiOrderMerchantModifyAddressRequestConfig

/**
 * 接口 [客户端-商户修改订单物流↗](https://yapi.gogpay.cn/project/906/interface/api/459328) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyLogistics`
 */
export interface ApiOrderMerchantModifyLogisticsRequest {
  /**
   * 快递公司编码
   */
  companyCode: string
  /**
   * 快递公司名称
   */
  companyName: string
  /**
   * 运单号
   */
  logisticCode: string
  /**
   * 订单号
   */
  orderNo: string
  /**
   * 包裹Id
   */
  packageId: string
}

/**
 * 接口 [客户端-商户修改订单物流↗](https://yapi.gogpay.cn/project/906/interface/api/459328) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyLogistics`
 */
export interface ApiOrderMerchantModifyLogisticsResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-商户修改订单物流↗](https://yapi.gogpay.cn/project/906/interface/api/459328) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyLogistics`
 */
type ApiOrderMerchantModifyLogisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/modifyLogistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-商户修改订单物流↗](https://yapi.gogpay.cn/project/906/interface/api/459328) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyLogistics`
 */
const apiOrderMerchantModifyLogisticsRequestConfig: ApiOrderMerchantModifyLogisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/modifyLogistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantModifyLogistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-商户修改订单物流', author: '503号开发' },
  }

/**
 * 接口 [客户端-商户修改订单物流↗](https://yapi.gogpay.cn/project/906/interface/api/459328) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/modifyLogistics`
 */
export const apiOrderMerchantModifyLogistics = /*#__PURE__*/ (
  requestData: ApiOrderMerchantModifyLogisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantModifyLogisticsResponse>(
    prepare(apiOrderMerchantModifyLogisticsRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantModifyLogistics.requestConfig =
  apiOrderMerchantModifyLogisticsRequestConfig

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459333) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/orderShip`
 */
export interface ApiOrderMerchantOrderShipRequest {
  /**
   * 货物图片
   */
  commodityPicList?: string[]
  /**
   * 自配送人员ID， 当发货方式为自配送时必传
   */
  courierId?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 发货方式 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  orderShipType?: '1' | '2' | '3' | '4' | '5'
  /**
   * 核销商品Sn码
   */
  orderSnNum?: string
  /**
   * 出库单
   */
  outboundOrders?: string[]
  /**
   * 包裹列表
   */
  packageItems?: {
    /**
     * 订单商品Id，和sku Id二选一传递
     */
    commodityId?: {
      commodityCount?: number
      commodityId?: string
    }[]
    /**
     * 快递公司编码，当发货方式为【线下自寄】时必传
     */
    companyCode?: string
    /**
     * 快递公司名称，当发货方式为【线下自寄】时必传
     */
    companyName?: string
    /**
     * 运单号，当发货方式为【线下自寄】时必传
     */
    logisticCode?: string
    /**
     * 快递公司信息Id，当发货方式为【线上发货】时必传
     */
    merchantShipperId?: string
    /**
     * 备注信息
     */
    remark?: string
    /**
     * 订单商品SKU Id,和订单商品Id二选一传递
     */
    skuId?: {
      commodityCount?: number
      commoditySkuId?: string
    }[]
  }[]
  /**
   * 发货地址Id
   */
  sendAddress?: string
  /**
   * 自配送人员姓名
   */
  serviceUserName?: string
  /**
   * 自配送人员手机号
   */
  serviceUserTel?: string
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459333) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/orderShip`
 */
export interface ApiOrderMerchantOrderShipResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459333) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/orderShip`
 */
type ApiOrderMerchantOrderShipRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/orderShip',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459333) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/orderShip`
 */
const apiOrderMerchantOrderShipRequestConfig: ApiOrderMerchantOrderShipRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/orderShip',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOrderShip',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单发货', author: '503号开发' },
  }

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459333) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/orderShip`
 */
export const apiOrderMerchantOrderShip = /*#__PURE__*/ (
  requestData: ApiOrderMerchantOrderShipRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOrderShipResponse>(
    prepare(apiOrderMerchantOrderShipRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOrderShip.requestConfig = apiOrderMerchantOrderShipRequestConfig

/**
 * 接口 [客户端-商户导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/459793) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/exportOrder`
 */
export interface ApiOrderMerchantExportOrderRequest {
  /**
   * 下单起始时间
   */
  beginTime?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 订单编号/收件人手机号
   */
  keyword?: string
  /**
   * 商户店铺Id
   */
  merchantId: string
  /**
   * 订单分类 1标准电商 2标准核销
   */
  orderClassification?: number
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 订单编号列表
   */
  orderNoList?: string[]
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中 11盲盒 12拼团
   */
  orderStatus?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [客户端-商户导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/459793) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/exportOrder`
 */
export interface ApiOrderMerchantExportOrderResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-商户导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/459793) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/exportOrder`
 */
type ApiOrderMerchantExportOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/exportOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-商户导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/459793) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/exportOrder`
 */
const apiOrderMerchantExportOrderRequestConfig: ApiOrderMerchantExportOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/exportOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantExportOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-商户导出订单', author: '503号开发' },
  }

/**
 * 接口 [客户端-商户导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/459793) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/exportOrder`
 */
export const apiOrderMerchantExportOrder = /*#__PURE__*/ (
  requestData: ApiOrderMerchantExportOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantExportOrderResponse>(
    prepare(apiOrderMerchantExportOrderRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantExportOrder.requestConfig =
  apiOrderMerchantExportOrderRequestConfig

/**
 * 接口 [商户端-导出信息管理↗](https://yapi.gogpay.cn/project/906/interface/api/459798) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/merchantTask/pageList`
 */
export interface ApiOrderMerchantMerchantTaskPageListRequest {
  /**
   * 商户ID
   */
  merchantId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 任务类型 0-订单信息导出
   */
  taskType: number
}

/**
 * 接口 [商户端-导出信息管理↗](https://yapi.gogpay.cn/project/906/interface/api/459798) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/merchantTask/pageList`
 */
export interface ApiOrderMerchantMerchantTaskPageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 任务明细标题
     */
    detailTitle?: string
    /**
     * 地址
     */
    executorResult?: string
    /**
     * 完成时间
     */
    finishTime?: string
    /**
     * 主键ID
     */
    id?: string
    /**
     * 操作人电话
     */
    operationPhone?: string
    /**
     * 操作人id
     */
    operationUserId?: string
    /**
     * 任务简介
     */
    taskIntroduction?: string
    /**
     * -1 处理失败 0-处理中 1-处理完成
     */
    taskStatus?: number
    /**
     * 任务类型：0-订单信息导出
     */
    taskType?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [商户端-导出信息管理↗](https://yapi.gogpay.cn/project/906/interface/api/459798) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/merchantTask/pageList`
 */
type ApiOrderMerchantMerchantTaskPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/merchantTask/pageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户端-导出信息管理↗](https://yapi.gogpay.cn/project/906/interface/api/459798) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/merchantTask/pageList`
 */
const apiOrderMerchantMerchantTaskPageListRequestConfig: ApiOrderMerchantMerchantTaskPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/merchantTask/pageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantMerchantTaskPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户端-导出信息管理', author: '503号开发' },
  }

/**
 * 接口 [商户端-导出信息管理↗](https://yapi.gogpay.cn/project/906/interface/api/459798) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/merchantTask/pageList`
 */
export const apiOrderMerchantMerchantTaskPageList = /*#__PURE__*/ (
  requestData: ApiOrderMerchantMerchantTaskPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantMerchantTaskPageListResponse>(
    prepare(apiOrderMerchantMerchantTaskPageListRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantMerchantTaskPageList.requestConfig =
  apiOrderMerchantMerchantTaskPageListRequestConfig

/**
 * 接口 [获取用户店铺订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459813) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderDetail`
 */
export interface ApiOrderMerchantFindMerchantOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取用户店铺订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459813) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderDetail`
 */
export interface ApiOrderMerchantFindMerchantOrderDetailResponse {
  /**
   * 抵扣积分数量
   */
  channelDiscountAmount?: string
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单商品列表
   */
  commodities?: {
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品类目参数
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    name?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 总价
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterName?: string
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeName?: string
    /**
     * 发货状态 0未发货 1已发货
     */
    shipStatus?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * SKU规格信息
     */
    skuSpecs?: string
    /**
     * 标签
     */
    tags?: string[]
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 成交时间
   */
  dealTime?: string
  /**
   * 延长收货天数
   */
  delayDays?: number
  /**
   * 延长收货状态 -1不支持延迟收货 0未延长 1已延长
   */
  delayStatus?: number
  /**
   * 配送日期
   */
  deliverDate?: string
  deliverUser?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 评价状态 0未评价 1已评价 2已追评 3审核中
   */
  evaluationStatus?: number
  /**
   * 兑换时间
   */
  exchangeTime?: string
  /**
   * 订单扩展数据
   */
  extendData?: {
    /**
     * 扩展字段的key，业务系统可自由定制
     */
    key?: string
    /**
     * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
     */
    name?: string
    /**
     * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
     */
    sort?: number
    /**
     * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
     */
    type?: string
    /**
     * 扩展字段的值，内容可自由定制。如100、302等
     */
    value?: string
  }[]
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 积分活动积分
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  lastExpressTrace?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }
  /**
   * 是否需要人脸认证
   */
  liveCheckFlag?: boolean
  /**
   * 物流达到时间
   */
  logisticsEndTime?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 配送方式
   */
  logisticsMethod?: string
  /**
   * 配送方式值 1普通快递/现场自提 2同城自提 3商户自配送
   */
  logisticsMethodValue?: number
  merchantCourier?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 发货是否需要填写sn码 0否 1是
   */
  needSnNum?: number
  /**
   * 是否需要上传签收单0否 1是
   */
  needUploadSignature?: number
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单中心支付单号
   */
  orderCenterPayNo?: string
  /**
   * 订单分类；1=标准电商，2=标准核销，3=标准虚拟，4=核销支付，5=组合标销售，6=旅游订单，7=组合电商
   */
  orderClassify?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 原始订单号，该字段为空代表为父单，不为空则为子单
   */
  originalOrderNo?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 需支付金额
   */
  payAmount?: string
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 支付方式
   */
  payTypeStatus?: number
  /**
   * 运费
   */
  postFee?: number
  /**
   * 订单操作是否只读
   */
  readonly?: boolean
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
   */
  saleAfterStatus?: number
  /**
   * 售后状态文案
   */
  saleAfterStatusLabel?: string
  selfAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 发货时间
   */
  shipTime?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  shippingType?: number
  /**
   * 订单状态 0待支付
   * 100待发货
   * 101已发货
   *
   * 400待接单
   * 401待配送
   * 402配送中
   *
   * 900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 订单状态变更
   */
  statusReason?: string
  /**
   * 接单时间
   */
  takeTime?: string
  /**
   * 订单提示信息
   */
  tips?: string
  /**
   * 催单状态 -1不支持催单 0未催单 1已催单
   */
  urgedStatus?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
}

/**
 * 接口 [获取用户店铺订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459813) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderDetail`
 */
type ApiOrderMerchantFindMerchantOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findMerchantOrderDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459813) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderDetail`
 */
const apiOrderMerchantFindMerchantOrderDetailRequestConfig: ApiOrderMerchantFindMerchantOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findMerchantOrderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindMerchantOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺订单详情', author: '511号开发' },
  }

/**
 * 接口 [获取用户店铺订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459813) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOrderDetail`
 */
export const apiOrderMerchantFindMerchantOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindMerchantOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindMerchantOrderDetailResponse>(
    prepare(apiOrderMerchantFindMerchantOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantFindMerchantOrderDetail.requestConfig =
  apiOrderMerchantFindMerchantOrderDetailRequestConfig

/**
 * 接口 [获取用户店铺标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459818) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantWriteOffOrderDetail`
 */
export interface ApiOrderMerchantFindMerchantWriteOffOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取用户店铺标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459818) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantWriteOffOrderDetail`
 */
export interface ApiOrderMerchantFindMerchantWriteOffOrderDetailResponse {
  appointmentInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 券码列表
   */
  codeList?: {
    /**
     * 券码
     */
    code?: string
    /**
     * 售后Id，券码状态=13或者14时有值
     */
    saleId?: string
    /**
     * 券码状态 11待使用  12已使用  13退款中  14已退款 15已过期
     */
    status?: number
    /**
     * 券码状态文案
     */
    statusName?: string
  }[]
  /**
   * 券码使用类型 1多张券码   2单券码多次使用  3外部核销
   */
  codeType?: number
  /**
   * 套餐信息
   */
  comboData?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: number
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 当前可用券码
   */
  currentCode?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluationStatus?: number
  expireDate?: string
  /**
   * 有效期
   */
  expireTime?: string
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 多彩豆
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  /**
   * 门店详细地址
   */
  merchantAddress?: string
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 营业时间
   */
  merchantOpenPeriod?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额(优惠前)
   */
  orderAmount?: number
  /**
   * 订单分类  2标准核销 5组合订单
   */
  orderClassify?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 支付/待支付金额（优惠后)
   */
  payAmount?: number
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 温馨提示
   */
  purchaseNotesDetail?: string
  /**
   * 核销二维码数据（兼容)
   */
  qrCodeData?: string
  /**
   * 核销二维码生成数据
   */
  qrCodeDataList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
    /**
     * 二维码数据
     */
    qrCodeData?: string
  }[]
  /**
   * 数量
   */
  quantity?: number
  /**
   * 备注
   */
  remark?: string
  /**
   * 退款状态 0未申请 1已申请 2已使用
   */
  saleStatus?: number
  /**
   * 规格信息
   */
  skuDesc?: string
  /**
   * sku id
   */
  skuId?: string
  /**
   * 订单状态 0待支付
   * 300待使用900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 使用日期/库存日期
   */
  stockDate?: string
  /**
   * 剩余券码可用数量
   */
  surplusCodeCount?: number
  /**
   * 商品单价
   */
  unitPrice?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
  /**
   * 游玩用户信息
   */
  userInfoList?: {
    /**
     * 身份证号码
     */
    idCard?: string
    /**
     * 用户姓名
     */
    name?: string
    /**
     * 手机号码
     */
    phone?: string
  }[]
  writeOffStores?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic?: string
    /**
     * 主店店铺url
     */
    storeUrl: string
  }[]
  /**
   * 消费时间
   */
  writeOffTime?: string
  /**
   * 经度
   */
  merchantLongitude?: string
  /**
   * 纬度
   */
  merchantLatitude?: string
  /**
   * 店铺链接(客户端)
   */
  storeUrl?: string
}

/**
 * 接口 [获取用户店铺标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459818) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantWriteOffOrderDetail`
 */
type ApiOrderMerchantFindMerchantWriteOffOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findMerchantWriteOffOrderDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459818) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantWriteOffOrderDetail`
 */
const apiOrderMerchantFindMerchantWriteOffOrderDetailRequestConfig: ApiOrderMerchantFindMerchantWriteOffOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findMerchantWriteOffOrderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindMerchantWriteOffOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺标销订单详情', author: '511号开发' },
  }

/**
 * 接口 [获取用户店铺标销订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/459818) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantWriteOffOrderDetail`
 */
export const apiOrderMerchantFindMerchantWriteOffOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindMerchantWriteOffOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindMerchantWriteOffOrderDetailResponse>(
    prepare(
      apiOrderMerchantFindMerchantWriteOffOrderDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderMerchantFindMerchantWriteOffOrderDetail.requestConfig =
  apiOrderMerchantFindMerchantWriteOffOrderDetailRequestConfig

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/459823) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getLogistics`
 */
export interface ApiOrderMerchantGetLogisticsRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 发货方式 1在线 2线下
   */
  shipType: '1' | '2' | '3' | '4' | '5'
}

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/459823) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getLogistics`
 */
export type ApiOrderMerchantGetLogisticsResponse = {
  /**
   * 快递公司编码
   */
  code?: string
  /**
   * 快递公司Id
   */
  id?: string
  /**
   * 快递公司名称
   */
  name?: string
}[]

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/459823) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getLogistics`
 */
type ApiOrderMerchantGetLogisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/getLogistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/459823) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getLogistics`
 */
const apiOrderMerchantGetLogisticsRequestConfig: ApiOrderMerchantGetLogisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/getLogistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantGetLogistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取快递公司信息', author: '511号开发' },
  }

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/459823) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/getLogistics`
 */
export const apiOrderMerchantGetLogistics = /*#__PURE__*/ (
  requestData: ApiOrderMerchantGetLogisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantGetLogisticsResponse>(
    prepare(apiOrderMerchantGetLogisticsRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantGetLogistics.requestConfig =
  apiOrderMerchantGetLogisticsRequestConfig

/**
 * 接口 [商户端-商户确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/459983) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/confirmDeliver`
 */
export interface ApiOrderMerchantConfirmDeliverRequest {
  /**
   * 货物69码图片
   */
  barCodePicList: string[]
  /**
   * 货物照片
   */
  commodityPicList: string[]
  /**
   * 客户与货物合照
   */
  customerAndCommodityPicList: string[]
  /**
   * 货物拆封图片
   */
  goodsUnsealingPicList: string[]
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 提货订单照片
   */
  orderPickPicList: string[]
  /**
   * 签收单据
   */
  signaturePicList: string[]
}

/**
 * 接口 [商户端-商户确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/459983) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/confirmDeliver`
 */
export interface ApiOrderMerchantConfirmDeliverResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商户端-商户确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/459983) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/confirmDeliver`
 */
type ApiOrderMerchantConfirmDeliverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/confirmDeliver',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户端-商户确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/459983) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/confirmDeliver`
 */
const apiOrderMerchantConfirmDeliverRequestConfig: ApiOrderMerchantConfirmDeliverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/confirmDeliver',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantConfirmDeliver',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户端-商户确认送达', author: '503号开发' },
  }

/**
 * 接口 [商户端-商户确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/459983) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/confirmDeliver`
 */
export const apiOrderMerchantConfirmDeliver = /*#__PURE__*/ (
  requestData: ApiOrderMerchantConfirmDeliverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantConfirmDeliverResponse>(
    prepare(apiOrderMerchantConfirmDeliverRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantConfirmDeliver.requestConfig =
  apiOrderMerchantConfirmDeliverRequestConfig

/**
 * 接口 [商户端-商家上传签收单↗](https://yapi.gogpay.cn/project/906/interface/api/466744) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/uploadSignature`
 */
export interface ApiOrderMerchantUploadSignatureRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 签收单照片
   */
  signaturePicList: string[]
}

/**
 * 接口 [商户端-商家上传签收单↗](https://yapi.gogpay.cn/project/906/interface/api/466744) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/uploadSignature`
 */
export interface ApiOrderMerchantUploadSignatureResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商户端-商家上传签收单↗](https://yapi.gogpay.cn/project/906/interface/api/466744) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/uploadSignature`
 */
type ApiOrderMerchantUploadSignatureRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/uploadSignature',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户端-商家上传签收单↗](https://yapi.gogpay.cn/project/906/interface/api/466744) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/uploadSignature`
 */
const apiOrderMerchantUploadSignatureRequestConfig: ApiOrderMerchantUploadSignatureRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/uploadSignature',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantUploadSignature',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户端-商家上传签收单', author: '511号开发' },
  }

/**
 * 接口 [商户端-商家上传签收单↗](https://yapi.gogpay.cn/project/906/interface/api/466744) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/uploadSignature`
 */
export const apiOrderMerchantUploadSignature = /*#__PURE__*/ (
  requestData: ApiOrderMerchantUploadSignatureRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantUploadSignatureResponse>(
    prepare(apiOrderMerchantUploadSignatureRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantUploadSignature.requestConfig =
  apiOrderMerchantUploadSignatureRequestConfig

/**
 * 接口 [获取用户店铺线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/477216) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderDetail`
 */
export interface ApiOrderMerchantFindMerchantOfflineOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取用户店铺线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/477216) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderDetail`
 */
export interface ApiOrderMerchantFindMerchantOfflineOrderDetailResponse {
  /**
   * 抵扣积分数量
   */
  channelDiscountAmount?: string
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单商品列表
   */
  commodities?: {
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品类目参数
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    name?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 总价
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterName?: string
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeName?: string
    /**
     * 发货状态 0未发货 1已发货
     */
    shipStatus?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * SKU规格信息
     */
    skuSpecs?: string
    /**
     * 标签
     */
    tags?: string[]
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 成交时间
   */
  dealTime?: string
  /**
   * 延长收货天数
   */
  delayDays?: number
  /**
   * 延长收货状态 -1不支持延迟收货 0未延长 1已延长
   */
  delayStatus?: number
  /**
   * 配送日期
   */
  deliverDate?: string
  deliverUser?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 评价状态 0未评价 1已评价 2已追评 3审核中
   */
  evaluationStatus?: number
  /**
   * 兑换时间
   */
  exchangeTime?: string
  /**
   * 订单扩展数据
   */
  extendData?: {
    /**
     * 扩展字段的key，业务系统可自由定制
     */
    key?: string
    /**
     * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
     */
    name?: string
    /**
     * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
     */
    sort?: number
    /**
     * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
     */
    type?: string
    /**
     * 扩展字段的值，内容可自由定制。如100、302等
     */
    value?: string
  }[]
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 积分活动积分
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  lastExpressTrace?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }
  /**
   * 是否需要人脸认证
   */
  liveCheckFlag?: boolean
  /**
   * 物流达到时间
   */
  logisticsEndTime?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 配送方式
   */
  logisticsMethod?: string
  /**
   * 配送方式值 1普通快递/现场自提 2同城自提 3商户自配送
   */
  logisticsMethodValue?: number
  merchantCourier?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 发货是否需要填写sn码 0否 1是
   */
  needSnNum?: number
  /**
   * 是否需要上传签收单0否 1是
   */
  needUploadSignature?: number
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单中心支付单号
   */
  orderCenterPayNo?: string
  /**
   * 订单分类；1=标准电商，2=标准核销，3=标准虚拟，4=核销支付，5=组合标销售，6=旅游订单，7=组合电商
   */
  orderClassify?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 原始订单号，该字段为空代表为父单，不为空则为子单
   */
  originalOrderNo?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 需支付金额
   */
  payAmount?: string
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 支付方式
   */
  payTypeStatus?: number
  /**
   * 运费
   */
  postFee?: number
  /**
   * 订单操作是否只读
   */
  readonly?: boolean
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
   */
  saleAfterStatus?: number
  /**
   * 售后状态文案
   */
  saleAfterStatusLabel?: string
  selfAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 发货时间
   */
  shipTime?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  shippingType?: number
  /**
   * 订单状态 0待支付
   * 100待发货
   * 101已发货
   *
   * 400待接单
   * 401待配送
   * 402配送中
   *
   * 900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 订单状态变更
   */
  statusReason?: string
  /**
   * 接单时间
   */
  takeTime?: string
  /**
   * 订单提示信息
   */
  tips?: string
  /**
   * 催单状态 -1不支持催单 0未催单 1已催单
   */
  urgedStatus?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
}

/**
 * 接口 [获取用户店铺线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/477216) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderDetail`
 */
type ApiOrderMerchantFindMerchantOfflineOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findMerchantOfflineOrderDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/477216) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderDetail`
 */
const apiOrderMerchantFindMerchantOfflineOrderDetailRequestConfig: ApiOrderMerchantFindMerchantOfflineOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findMerchantOfflineOrderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindMerchantOfflineOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺线下订单详情', author: '511号开发' },
  }

/**
 * 接口 [获取用户店铺线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/477216) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderDetail`
 */
export const apiOrderMerchantFindMerchantOfflineOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindMerchantOfflineOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindMerchantOfflineOrderDetailResponse>(
    prepare(
      apiOrderMerchantFindMerchantOfflineOrderDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderMerchantFindMerchantOfflineOrderDetail.requestConfig =
  apiOrderMerchantFindMerchantOfflineOrderDetailRequestConfig

/**
 * 接口 [获取用户店铺线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/477223) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderList`
 */
export interface ApiOrderMerchantFindMerchantOfflineOrderListRequest {
  /**
   * 下单起始时间
   */
  beginTime?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 订单编号/收件人手机号
   */
  keyword?: string
  /**
   * 商户店铺Id
   */
  merchantId: string
  /**
   * 订单分类 1标准电商 2标准核销
   */
  orderClassification?: number
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 订单编号列表
   */
  orderNoList?: string[]
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中 11盲盒 12拼团
   */
  orderStatus?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取用户店铺线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/477223) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderList`
 */
export interface ApiOrderMerchantFindMerchantOfflineOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单实付款
     */
    actualReceivable?: number
    appointmentDate?: string
    /**
     * 预约人
     */
    appointmentName?: string
    /**
     * 预约手机
     */
    appointmentPhone?: string
    buyerVO?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 商品数据
     */
    commodityInfo?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态文案
       */
      saleAfterName?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    consigneeInfo?: {
      /**
       * 收件地址-详细地址
       */
      address?: string
      /**
       * 收件地址-地区
       */
      area?: string
      /**
       * 收件地址-城市
       */
      city?: string
      /**
       * 收件人
       */
      name?: string
      /**
       * 包裹数量，如果为0则是未发货
       */
      packageQuantity?: number
      /**
       * 包裹发送类型 0未发货 1整包发货 2拆包发货
       */
      packageType?: number
      /**
       * 收件地址-省份
       */
      province?: string
      /**
       * 收件人手机号
       */
      tel?: string
    }
    deliverUserInfo?: {
      /**
       * 服务人员Id
       */
      serviceUserId?: string
      /**
       * 服务人员姓名
       */
      serviceUserName?: string
      /**
       * 服务人员手机号
       */
      serviceUserTel?: string
      /**
       * 自定义配送文案
       */
      tips?: string
    }
    /**
     * 配送方式值 1现场提货 3配送发货
     */
    logisticsMethodValue?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 是否需要上传签收单0否 1是
     */
    needUploadSignature?: number
    /**
     * 订单总金额
     */
    orderAmount?: number
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单分类 1标准电商 2派送核销
     */
    orderClassification?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单状态
     */
    orderStatus?: number
    /**
     * 订单状态标签
     */
    orderStatusLabel?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 售后状态 0无售后 1待商家处理  2已完成 3售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态标签
     */
    saleAfterStatusLabel?: string
    /**
     * 0普通订单 1 门店自提
     */
    shipType?: number
    /**
     * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
     */
    shippingType?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取用户店铺线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/477223) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderList`
 */
type ApiOrderMerchantFindMerchantOfflineOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findMerchantOfflineOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户店铺线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/477223) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderList`
 */
const apiOrderMerchantFindMerchantOfflineOrderListRequestConfig: ApiOrderMerchantFindMerchantOfflineOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findMerchantOfflineOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindMerchantOfflineOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺线下订单列表', author: '511号开发' },
  }

/**
 * 接口 [获取用户店铺线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/477223) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findMerchantOfflineOrderList`
 */
export const apiOrderMerchantFindMerchantOfflineOrderList = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindMerchantOfflineOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindMerchantOfflineOrderListResponse>(
    prepare(
      apiOrderMerchantFindMerchantOfflineOrderListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderMerchantFindMerchantOfflineOrderList.requestConfig =
  apiOrderMerchantFindMerchantOfflineOrderListRequestConfig

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/477230) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderArrive`
 */
export interface ApiOrderMerchantOfflineOrderArriveRequest {}

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/477230) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderArrive`
 */
export interface ApiOrderMerchantOfflineOrderArriveResponse {}

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/477230) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderArrive`
 */
type ApiOrderMerchantOfflineOrderArriveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/offlineOrderArrive',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/477230) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderArrive`
 */
const apiOrderMerchantOfflineOrderArriveRequestConfig: ApiOrderMerchantOfflineOrderArriveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/offlineOrderArrive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOfflineOrderArrive',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '线下订单确认送达', author: '511号开发' },
  }

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/477230) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderArrive`
 */
export const apiOrderMerchantOfflineOrderArrive = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantOfflineOrderArriveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOfflineOrderArriveResponse>(
    prepare(apiOrderMerchantOfflineOrderArriveRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOfflineOrderArrive.requestConfig =
  apiOrderMerchantOfflineOrderArriveRequestConfig

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/477237) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderDeliver`
 */
export interface ApiOrderMerchantOfflineOrderDeliverRequest {}

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/477237) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderDeliver`
 */
export interface ApiOrderMerchantOfflineOrderDeliverResponse {}

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/477237) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderDeliver`
 */
type ApiOrderMerchantOfflineOrderDeliverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/offlineOrderDeliver',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/477237) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderDeliver`
 */
const apiOrderMerchantOfflineOrderDeliverRequestConfig: ApiOrderMerchantOfflineOrderDeliverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/offlineOrderDeliver',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOfflineOrderDeliver',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '线下订单发货', author: '511号开发' },
  }

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/477237) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/offlineOrderDeliver`
 */
export const apiOrderMerchantOfflineOrderDeliver = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantOfflineOrderDeliverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOfflineOrderDeliverResponse>(
    prepare(apiOrderMerchantOfflineOrderDeliverRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOfflineOrderDeliver.requestConfig =
  apiOrderMerchantOfflineOrderDeliverRequestConfig

/**
 * 接口 [获取用户线下店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/478588) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findOfflineMerchantBusinessInfo`
 */
export interface ApiOrderMerchantFindOfflineMerchantBusinessInfoRequest {
  /**
   * 请求Id
   */
  id: string
}

/**
 * 接口 [获取用户线下店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/478588) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findOfflineMerchantBusinessInfo`
 */
export interface ApiOrderMerchantFindOfflineMerchantBusinessInfoResponse {
  /**
   * 预计营业额
   */
  expectedRevenue?: number
  /**
   * 店铺状态 1 待营业 2 营业中 3 已停业 4 休息中
   */
  storeStatus?: number
  /**
   * 有效订单
   */
  validOrderCount?: number
}

/**
 * 接口 [获取用户线下店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/478588) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findOfflineMerchantBusinessInfo`
 */
type ApiOrderMerchantFindOfflineMerchantBusinessInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/findOfflineMerchantBusinessInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取用户线下店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/478588) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findOfflineMerchantBusinessInfo`
 */
const apiOrderMerchantFindOfflineMerchantBusinessInfoRequestConfig: ApiOrderMerchantFindOfflineMerchantBusinessInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_9,
    devUrl: devUrl_0_5_0_9,
    prodUrl: prodUrl_0_5_0_9,
    path: '/order/api/merchant/findOfflineMerchantBusinessInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantFindOfflineMerchantBusinessInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户线下店铺首页营业额信息', author: '511号开发' },
  }

/**
 * 接口 [获取用户线下店铺首页营业额信息↗](https://yapi.gogpay.cn/project/906/interface/api/478588) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户中心↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33708)
 * @请求头 `POST /order/api/merchant/findOfflineMerchantBusinessInfo`
 */
export const apiOrderMerchantFindOfflineMerchantBusinessInfo = /*#__PURE__*/ (
  requestData: ApiOrderMerchantFindOfflineMerchantBusinessInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantFindOfflineMerchantBusinessInfoResponse>(
    prepare(
      apiOrderMerchantFindOfflineMerchantBusinessInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderMerchantFindOfflineMerchantBusinessInfo.requestConfig =
  apiOrderMerchantFindOfflineMerchantBusinessInfoRequestConfig

const mockUrl_0_5_0_10 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_10 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_10 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_10 = 'data' as any

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/188802) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/detail`
 */
export interface ApiOrderOrderDeliverDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/188802) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/detail`
 */
export interface ApiOrderOrderDeliverDetailResponse {
  /**
   * 抵扣积分数量
   */
  channelDiscountAmount?: string
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单商品列表
   */
  commodities?: {
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品类目参数
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    name?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 总价
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterName?: string
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeName?: string
    /**
     * 发货状态 0未发货 1已发货
     */
    shipStatus?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * SKU规格信息
     */
    skuSpecs?: string
    /**
     * 标签
     */
    tags?: string[]
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 成交时间
   */
  dealTime?: string
  /**
   * 延长收货天数
   */
  delayDays?: number
  /**
   * 延长收货状态 -1不支持延迟收货 0未延长 1已延长
   */
  delayStatus?: number
  /**
   * 配送日期
   */
  deliverDate?: string
  deliverUser?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 评价状态 0未评价 1已评价 2已追评 3审核中
   */
  evaluationStatus?: number
  /**
   * 兑换时间
   */
  exchangeTime?: string
  /**
   * 订单扩展数据
   */
  extendData?: {
    /**
     * 扩展字段的key，业务系统可自由定制
     */
    key?: string
    /**
     * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
     */
    name?: string
    /**
     * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
     */
    sort?: number
    /**
     * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
     */
    type?: string
    /**
     * 扩展字段的值，内容可自由定制。如100、302等
     */
    value?: string
  }[]
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 积分活动积分
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  lastExpressTrace?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }
  /**
   * 是否需要人脸认证
   */
  liveCheckFlag?: boolean
  /**
   * 物流达到时间
   */
  logisticsEndTime?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 配送方式
   */
  logisticsMethod?: string
  /**
   * 配送方式值 1普通快递/现场自提 2同城自提 3商户自配送
   */
  logisticsMethodValue?: number
  merchantCourier?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 发货是否需要填写sn码 0否 1是
   */
  needSnNum?: number
  /**
   * 是否需要上传签收单0否 1是
   */
  needUploadSignature?: number
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单中心支付单号
   */
  orderCenterPayNo?: string
  /**
   * 订单分类；1=标准电商，2=标准核销，3=标准虚拟，4=核销支付，5=组合标销售，6=旅游订单，7=组合电商
   */
  orderClassify?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 原始订单号，该字段为空代表为父单，不为空则为子单
   */
  originalOrderNo?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 需支付金额
   */
  payAmount?: string
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 支付方式
   */
  payTypeStatus?: number
  /**
   * 运费
   */
  postFee?: number
  /**
   * 订单操作是否只读
   */
  readonly?: boolean
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
   */
  saleAfterStatus?: number
  /**
   * 售后状态文案
   */
  saleAfterStatusLabel?: string
  selfAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 发货时间
   */
  shipTime?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  shippingType?: number
  /**
   * 订单状态 0待支付
   * 100待发货
   * 101已发货
   *
   * 400待接单
   * 401待配送
   * 402配送中
   *
   * 900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 订单状态变更
   */
  statusReason?: string
  /**
   * 接单时间
   */
  takeTime?: string
  /**
   * 订单提示信息
   */
  tips?: string
  /**
   * 催单状态 -1不支持催单 0未催单 1已催单
   */
  urgedStatus?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
}

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/188802) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/detail`
 */
type ApiOrderOrderDeliverDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/deliver/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/188802) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/detail`
 */
const apiOrderOrderDeliverDetailRequestConfig: ApiOrderOrderDeliverDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_10,
    devUrl: devUrl_0_5_0_10,
    prodUrl: prodUrl_0_5_0_10,
    path: '/order/api/order/deliver/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderDeliverDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '配送订单详情', author: '成龙' },
  }

/**
 * 接口 [配送订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/188802) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/detail`
 */
export const apiOrderOrderDeliverDetail = /*#__PURE__*/ (
  requestData: ApiOrderOrderDeliverDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderDeliverDetailResponse>(
    prepare(apiOrderOrderDeliverDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderDeliverDetail.requestConfig =
  apiOrderOrderDeliverDetailRequestConfig

/**
 * 接口 [配送订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188806) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/list`
 */
export interface ApiOrderOrderDeliverListRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中
   */
  status?: number
  /**
   * 下单手机号
   */
  userPhone?: string
}

/**
 * 接口 [配送订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188806) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/list`
 */
export interface ApiOrderOrderDeliverListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单活动名称
     */
    activityName?: string
    /**
     * 订单商品列表
     */
    commodities?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态文案
       */
      saleAfterName?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    countDownTime?: {
      /**
       * 自动取消订单时效（毫秒)
       */
      cancelOrderCountDown?: number
      /**
       * 关闭订单时效（毫秒）
       */
      closeCountDown?: number
      /**
       * 自动确认收货时效（毫秒）
       */
      confirmCountDown?: number
      /**
       * 发货（派单）倒计时（毫秒）
       */
      shippingCountDown?: number
    }
    /**
     * 延长收货天数
     */
    delayDays?: number
    /**
     * 延长收货状态 -1不支持 0未延长 1已延长
     */
    delayStatus?: number
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 评价状态 0未评价 1已评价
     */
    evaluationStatus?: number
    /**
     * 配送方式值 1普通快递 2同城自提
     */
    logisticsMethodValue?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 订单金额（实付）
     */
    orderAmount?: string
    /**
     * 订单分类  1标准电商  2标准核销  3标准虚拟
     */
    orderClassify?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 是否为父订单
     */
    parentOrderFlag?: boolean
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    selfAddress?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 订单状态 0待支付
     * 100待发货
     * 101已发货
     *
     * 400待接单
     * 401待配送
     * 402配送中
     *
     * 900交易完成
     * 901交易关闭"902交易完结
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 订单金额（应付)
     */
    totalAmount?: string
    /**
     * 催单状态 -1不支持催单 0未催单 1已催单
     */
    urgedStatus?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [配送订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188806) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/list`
 */
type ApiOrderOrderDeliverListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/deliver/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [配送订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188806) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/list`
 */
const apiOrderOrderDeliverListRequestConfig: ApiOrderOrderDeliverListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_10,
    devUrl: devUrl_0_5_0_10,
    prodUrl: prodUrl_0_5_0_10,
    path: '/order/api/order/deliver/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_10,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderDeliverList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '配送订单列表', author: '成龙' },
  }

/**
 * 接口 [配送订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/188806) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-配送订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_33711)
 * @请求头 `POST /order/api/order/deliver/list`
 */
export const apiOrderOrderDeliverList = /*#__PURE__*/ (
  requestData: ApiOrderOrderDeliverListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderDeliverListResponse>(
    prepare(apiOrderOrderDeliverListRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderDeliverList.requestConfig = apiOrderOrderDeliverListRequestConfig

const mockUrl_0_5_0_15 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_15 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_15 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_15 = 'data' as any

/**
 * 接口 [客户端大订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/331282) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [客户端大订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_58424)
 * @请求头 `POST /order/api/bigOrder/list`
 */
export interface ApiOrderBigOrderListRequest {
  /**
   * 起始时间
   */
  beginTime?: string
  clientType?: '1' | '2' | '3' | '4'
  /**
   * 终止时间
   */
  endTime?: string
  headerChannel?: string[]
  /**
   * 订单号，商家名称，商品名
   */
  keyWord?: string
  /**
   * 订单编码
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 售后ID
   */
  saleAfterId?: string
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中 11盲盒 12拼团
   */
  status?: number
}

/**
 * 接口 [客户端大订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/331282) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [客户端大订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_58424)
 * @请求头 `POST /order/api/bigOrder/list`
 */
export interface ApiOrderBigOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 盲盒-活动Id
     */
    activityId?: string
    /**
     * 订单活动名称
     */
    activityName?: string
    /**
     * 盲盒-Id
     */
    boxId?: string
    /**
     * 盲盒-名称
     */
    boxName?: string
    /**
     * 盲盒-图片
     */
    boxPic?: string
    /**
     * 按钮列表
     */
    buttonList?: {
      /**
       * 是否是主按钮
       */
      isPrimary?: boolean
      /**
       * 按钮显示内容
       */
      text?: string
      /**
       * 按钮类型(         1 去支付)
       *      2 取消订单
       *      3  提醒发货
       *      4  延长收货
       *      5  查看物流
       *      6  确认收货
       *      7  删除订单
       *      8  评价
       *      9 查看劵码
       *      10 再来一单
       *      11  邀请好友
       *      12 支付并参团
       *      13 退款详情
       *      14 查看详情
       *      15 我要回收
       *      16  立即发货
       *      17  开盲盒
       *      18  提醒接单
       *      19 申请售后
       *      20 删除团单 )
       */
      type?: number
      /**
       * 跳转地址
       */
      url?: string
    }[]
    /**
     * 订单商品列表
     */
    commodities?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 券码有效期
       */
      expireTime?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 商品退款金额
       */
      refundAmount?: string
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后状态文案
       */
      saleAfterStatusLabel?: string
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 商品类型
       */
      type?: number
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    countDownTime?: {
      /**
       * 自动取消订单时效（毫秒)
       */
      cancelOrderCountDown?: number
      /**
       * 关闭订单时效（毫秒）
       */
      closeCountDown?: number
      /**
       * 自动确认收货时效（毫秒）
       */
      confirmCountDown?: number
      /**
       * 发货（派单）倒计时（毫秒）
       */
      shippingCountDown?: number
    }
    /**
     * 延长收货天数
     */
    delayDays?: number
    /**
     * 延长收货状态 -1不支持 0未延长 1已延长
     */
    delayStatus?: number
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 拼团-距成团人数差距
     */
    differCount?: number
    /**
     * 盲盒-异常回收原因
     */
    errorReason?: string
    /**
     * 评价状态 0未评价 1已评价
     */
    evaluationStatus?: number
    /**
     * 券码有效期
     */
    expireTime?: string
    /**
     * 倒计时，如果是待支付订单则是关闭订单时间，如果是待成团则是结束时间
     */
    groupCountDownTime?: number
    /**
     * 拼团-团单Id
     */
    groupOrderId?: string
    /**
     * 拼团-团单类型 NORMAL：普通   LADDER：阶梯团
     */
    groupType?: string
    /**
     * 拼团-是否已成团
     */
    grouped?: boolean
    /**
     * 是否需要人脸认证
     */
    liveCheckFlag?: boolean
    /**
     * 配送方式值 1普通快递 2同城自提
     */
    logisticsMethodValue?: number
    /**
     * 拼团-商城中台订单编号，仅拼团成功才返回
     */
    mallOrderNo?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 店铺链接
     */
    merchantUrl?: string
    /**
     * 订单金额（实付）
     */
    orderAmount?: string
    /**
     * 盲盒-订单Id
     */
    orderId?: string
    /**
     * 订单编号（盲盒Id,拼团Id）
     */
    orderNo?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 是否为父订单
     */
    parentOrderFlag?: boolean
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 支付/待支付金额（优惠后)
     */
    payAmount?: number
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 盲盒-订单回收价格
     */
    recoverPrice?: number
    /**
     * 盲盒-手续费比例
     */
    recoverScale?: number
    /**
     * 拼团-可返金额，可返金额为0时表示没有返回金额
     */
    returnAmount?: number
    /**
     * 售后ID
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    /**
     * 退款状态 0未申请 1已申请 2已使用
     */
    saleStatus?: number
    selfAddress?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 发货类型 0正常发货 1门店自提
     */
    shipType?: number
    /**
     * 订单状态 0待支付
     * 100待发货
     * 101已发货
     *
     * 400待接单
     * 401待配送
     * 402配送中
     *
     * 900交易完成
     * 901交易关闭
     * 902交易完结
     *
     * 1001 盲盒待开盒
     * 1002 盲盒已开盒
     * 2002 拼团中
     *
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 订单金额（应付)
     */
    totalAmount?: string
    /**
     * 订单类型 1-标电 2-标销 9-盲盒 10-拼团
     */
    type?: number
    /**
     * 拼团-商品单价
     */
    unitPrice?: number
    /**
     * 催单状态 -1不支持催单 0未催单 1已催单
     */
    urgedStatus?: number
    /**
     * 订单详情地址
     */
    url?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端大订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/331282) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [客户端大订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_58424)
 * @请求头 `POST /order/api/bigOrder/list`
 */
type ApiOrderBigOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/bigOrder/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端大订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/331282) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [客户端大订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_58424)
 * @请求头 `POST /order/api/bigOrder/list`
 */
const apiOrderBigOrderListRequestConfig: ApiOrderBigOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_15,
    devUrl: devUrl_0_5_0_15,
    prodUrl: prodUrl_0_5_0_15,
    path: '/order/api/bigOrder/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderBigOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端大订单列表', author: '333号开发' },
  }

/**
 * 接口 [客户端大订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/331282) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [客户端大订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_58424)
 * @请求头 `POST /order/api/bigOrder/list`
 */
export const apiOrderBigOrderList = /*#__PURE__*/ (
  requestData: ApiOrderBigOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderBigOrderListResponse>(
    prepare(apiOrderBigOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderBigOrderList.requestConfig = apiOrderBigOrderListRequestConfig

const mockUrl_0_5_0_16 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_16 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_16 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_16 = 'data' as any

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/364551) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/cancel`
 */
export interface ApiOrderImsApiOrderApiCancelRequest {
  /**
   * 批量单号
   */
  batchNo?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 多彩宝订单编号
   */
  orderNo?: string
  /**
   * 触发时间
   */
  triggerTime?: string
  /**
   * 业务类型
   */
  type?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/364551) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/cancel`
 */
export interface ApiOrderImsApiOrderApiCancelResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/364551) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/cancel`
 */
type ApiOrderImsApiOrderApiCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/364551) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/cancel`
 */
const apiOrderImsApiOrderApiCancelRequestConfig: ApiOrderImsApiOrderApiCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消订单', author: '333号开发' },
  }

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/364551) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/cancel`
 */
export const apiOrderImsApiOrderApiCancel = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiCancelResponse>(
    prepare(apiOrderImsApiOrderApiCancelRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiCancel.requestConfig =
  apiOrderImsApiOrderApiCancelRequestConfig

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/364560) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/confirm`
 */
export interface ApiOrderImsApiOrderApiConfirmRequest {
  /**
   * 批量单号
   */
  batchNo?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 多彩宝订单编号
   */
  orderNo?: string
  /**
   * 触发时间
   */
  triggerTime?: string
  /**
   * 业务类型
   */
  type?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/364560) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/confirm`
 */
export interface ApiOrderImsApiOrderApiConfirmResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/364560) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/confirm`
 */
type ApiOrderImsApiOrderApiConfirmRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/confirm',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/364560) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/confirm`
 */
const apiOrderImsApiOrderApiConfirmRequestConfig: ApiOrderImsApiOrderApiConfirmRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/confirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiConfirm',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '确认收货', author: '333号开发' },
  }

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/364560) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/confirm`
 */
export const apiOrderImsApiOrderApiConfirm = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiConfirmRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiConfirmResponse>(
    prepare(apiOrderImsApiOrderApiConfirmRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiConfirm.requestConfig =
  apiOrderImsApiOrderApiConfirmRequestConfig

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/364569) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/delayConfirm`
 */
export interface ApiOrderImsApiOrderApiDelayConfirmRequest {
  /**
   * 批量单号
   */
  batchNo?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 多彩宝订单编号
   */
  orderNo?: string
  /**
   * 触发时间
   */
  triggerTime?: string
  /**
   * 业务类型
   */
  type?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/364569) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/delayConfirm`
 */
export interface ApiOrderImsApiOrderApiDelayConfirmResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/364569) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/delayConfirm`
 */
type ApiOrderImsApiOrderApiDelayConfirmRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/delayConfirm',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/364569) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/delayConfirm`
 */
const apiOrderImsApiOrderApiDelayConfirmRequestConfig: ApiOrderImsApiOrderApiDelayConfirmRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/delayConfirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiDelayConfirm',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '延长收货', author: '333号开发' },
  }

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/364569) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/delayConfirm`
 */
export const apiOrderImsApiOrderApiDelayConfirm = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiDelayConfirmRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiDelayConfirmResponse>(
    prepare(apiOrderImsApiOrderApiDelayConfirmRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiDelayConfirm.requestConfig =
  apiOrderImsApiOrderApiDelayConfirmRequestConfig

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/364578) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/remove`
 */
export interface ApiOrderImsApiOrderApiRemoveRequest {
  /**
   * 批量单号
   */
  batchNo?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 多彩宝订单编号
   */
  orderNo?: string
  /**
   * 触发时间
   */
  triggerTime?: string
  /**
   * 业务类型
   */
  type?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/364578) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/remove`
 */
export interface ApiOrderImsApiOrderApiRemoveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/364578) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/remove`
 */
type ApiOrderImsApiOrderApiRemoveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/remove',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/364578) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/remove`
 */
const apiOrderImsApiOrderApiRemoveRequestConfig: ApiOrderImsApiOrderApiRemoveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/remove',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiRemove',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除订单', author: '333号开发' },
  }

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/364578) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/remove`
 */
export const apiOrderImsApiOrderApiRemove = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiRemoveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiRemoveResponse>(
    prepare(apiOrderImsApiOrderApiRemoveRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiRemove.requestConfig =
  apiOrderImsApiOrderApiRemoveRequestConfig

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/364587) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/urged`
 */
export interface ApiOrderImsApiOrderApiUrgedRequest {
  /**
   * 批量单号
   */
  batchNo?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 多彩宝订单编号
   */
  orderNo?: string
  /**
   * 触发时间
   */
  triggerTime?: string
  /**
   * 业务类型
   */
  type?: string
  /**
   * 机构编码
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/364587) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/urged`
 */
export interface ApiOrderImsApiOrderApiUrgedResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/364587) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/urged`
 */
type ApiOrderImsApiOrderApiUrgedRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/urged',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/364587) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/urged`
 */
const apiOrderImsApiOrderApiUrgedRequestConfig: ApiOrderImsApiOrderApiUrgedRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/urged',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiUrged',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '催单', author: '333号开发' },
  }

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/364587) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/urged`
 */
export const apiOrderImsApiOrderApiUrged = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiUrgedRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiUrgedResponse>(
    prepare(apiOrderImsApiOrderApiUrgedRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiUrged.requestConfig =
  apiOrderImsApiOrderApiUrgedRequestConfig

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/380679) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysCancel`
 */
export interface ApiOrderImsApiOrderApiInnerSysCancelRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/380679) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysCancel`
 */
export interface ApiOrderImsApiOrderApiInnerSysCancelResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/380679) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysCancel`
 */
type ApiOrderImsApiOrderApiInnerSysCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/innerSysCancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/380679) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysCancel`
 */
const apiOrderImsApiOrderApiInnerSysCancelRequestConfig: ApiOrderImsApiOrderApiInnerSysCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/innerSysCancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiInnerSysCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消订单', author: '333号开发' },
  }

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/380679) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysCancel`
 */
export const apiOrderImsApiOrderApiInnerSysCancel = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiInnerSysCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiInnerSysCancelResponse>(
    prepare(apiOrderImsApiOrderApiInnerSysCancelRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiInnerSysCancel.requestConfig =
  apiOrderImsApiOrderApiInnerSysCancelRequestConfig

/**
 * 接口 [订单支付成功回调↗](https://yapi.gogpay.cn/project/906/interface/api/380682) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysPayed`
 */
export interface ApiOrderImsApiOrderApiInnerSysPayedRequest {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  needRealNameAuth?: boolean
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 用户Id
   */
  userId: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [订单支付成功回调↗](https://yapi.gogpay.cn/project/906/interface/api/380682) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysPayed`
 */
export interface ApiOrderImsApiOrderApiInnerSysPayedResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [订单支付成功回调↗](https://yapi.gogpay.cn/project/906/interface/api/380682) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysPayed`
 */
type ApiOrderImsApiOrderApiInnerSysPayedRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/innerSysPayed',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单支付成功回调↗](https://yapi.gogpay.cn/project/906/interface/api/380682) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysPayed`
 */
const apiOrderImsApiOrderApiInnerSysPayedRequestConfig: ApiOrderImsApiOrderApiInnerSysPayedRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/innerSysPayed',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiInnerSysPayed',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单支付成功回调', author: '333号开发' },
  }

/**
 * 接口 [订单支付成功回调↗](https://yapi.gogpay.cn/project/906/interface/api/380682) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysPayed`
 */
export const apiOrderImsApiOrderApiInnerSysPayed = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiInnerSysPayedRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiInnerSysPayedResponse>(
    prepare(apiOrderImsApiOrderApiInnerSysPayedRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiInnerSysPayed.requestConfig =
  apiOrderImsApiOrderApiInnerSysPayedRequestConfig

/**
 * 接口 [内部系统退款↗](https://yapi.gogpay.cn/project/906/interface/api/380685) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysRefund`
 */
export interface ApiOrderImsApiOrderApiInnerSysRefundRequest {
  /**
   * 支付订单号
   */
  orderNo?: string
  /**
   * 机构号
   */
  orgCode?: string
  /**
   * 退款金额
   */
  refundAmt?: number
  /**
   * 退款的手续费(分润)金额
   */
  refundFeeAmt?: number
  /**
   * 请求流水号
   */
  serialNumber?: string
}

/**
 * 接口 [内部系统退款↗](https://yapi.gogpay.cn/project/906/interface/api/380685) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysRefund`
 */
export interface ApiOrderImsApiOrderApiInnerSysRefundResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [内部系统退款↗](https://yapi.gogpay.cn/project/906/interface/api/380685) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysRefund`
 */
type ApiOrderImsApiOrderApiInnerSysRefundRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/innerSysRefund',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [内部系统退款↗](https://yapi.gogpay.cn/project/906/interface/api/380685) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysRefund`
 */
const apiOrderImsApiOrderApiInnerSysRefundRequestConfig: ApiOrderImsApiOrderApiInnerSysRefundRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/innerSysRefund',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiInnerSysRefund',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '内部系统退款', author: '333号开发' },
  }

/**
 * 接口 [内部系统退款↗](https://yapi.gogpay.cn/project/906/interface/api/380685) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/innerSysRefund`
 */
export const apiOrderImsApiOrderApiInnerSysRefund = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiInnerSysRefundRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiInnerSysRefundResponse>(
    prepare(apiOrderImsApiOrderApiInnerSysRefundRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiInnerSysRefund.requestConfig =
  apiOrderImsApiOrderApiInnerSysRefundRequestConfig

/**
 * 接口 [内部系统到账↗](https://yapi.gogpay.cn/project/906/interface/api/380688) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/orderArrival`
 */
export interface ApiOrderImsApiOrderApiOrderArrivalRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [内部系统到账↗](https://yapi.gogpay.cn/project/906/interface/api/380688) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/orderArrival`
 */
export interface ApiOrderImsApiOrderApiOrderArrivalResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [内部系统到账↗](https://yapi.gogpay.cn/project/906/interface/api/380688) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/orderArrival`
 */
type ApiOrderImsApiOrderApiOrderArrivalRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderApi/orderArrival',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [内部系统到账↗](https://yapi.gogpay.cn/project/906/interface/api/380688) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/orderArrival`
 */
const apiOrderImsApiOrderApiOrderArrivalRequestConfig: ApiOrderImsApiOrderApiOrderArrivalRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_16,
    devUrl: devUrl_0_5_0_16,
    prodUrl: prodUrl_0_5_0_16,
    path: '/order/imsApi/orderApi/orderArrival',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_16,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApiOrderArrival',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '内部系统到账', author: '333号开发' },
  }

/**
 * 接口 [内部系统到账↗](https://yapi.gogpay.cn/project/906/interface/api/380688) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单状态触发接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_64821)
 * @请求头 `POST /order/imsApi/orderApi/orderArrival`
 */
export const apiOrderImsApiOrderApiOrderArrival = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApiOrderArrivalRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApiOrderArrivalResponse>(
    prepare(apiOrderImsApiOrderApiOrderArrivalRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApiOrderArrival.requestConfig =
  apiOrderImsApiOrderApiOrderArrivalRequestConfig

const mockUrl_0_5_0_18 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_18 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_18 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_18 = 'data' as any

/**
 * 接口 [修改收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/24441) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/changeAddress`
 */
export interface ApiOrderImsApiOrderChangeAddressRequest {
  /**
   * 区划，如观山湖区
   */
  area?: string
  /**
   * 区划编码
   */
  areaCode?: string
  /**
   * 营业时间-分割
   */
  businessTimeStr?: string
  /**
   * 城市
   */
  city?: string
  /**
   * 城市代码
   */
  cityCode?: string
  /**
   * 详细地址，不需要省市区
   */
  detail?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 手机号
   */
  phoneNo?: string
  /**
   * 省份
   */
  province?: string
  /**
   * 省份代码
   */
  provinceCode?: string
  /**
   * 自提点名称
   */
  selfPickupName?: string
  /**
   * 联系人
   */
  contact?: string
  /**
   * 联系电话
   */
  contactTel?: string
}

/**
 * 接口 [修改收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/24441) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/changeAddress`
 */
export interface ApiOrderImsApiOrderChangeAddressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/24441) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/changeAddress`
 */
type ApiOrderImsApiOrderChangeAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/changeAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/24441) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/changeAddress`
 */
const apiOrderImsApiOrderChangeAddressRequestConfig: ApiOrderImsApiOrderChangeAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/changeAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderChangeAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改收货地址', author: '成龙' },
  }

/**
 * 接口 [修改收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/24441) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/changeAddress`
 */
export const apiOrderImsApiOrderChangeAddress = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderChangeAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderChangeAddressResponse>(
    prepare(apiOrderImsApiOrderChangeAddressRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderChangeAddress.requestConfig =
  apiOrderImsApiOrderChangeAddressRequestConfig

/**
 * 接口 [关闭订单↗](https://yapi.gogpay.cn/project/906/interface/api/24445) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/close`
 */
export interface ApiOrderImsApiOrderCloseRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 关闭原因
   */
  reason: string
}

/**
 * 接口 [关闭订单↗](https://yapi.gogpay.cn/project/906/interface/api/24445) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/close`
 */
export interface ApiOrderImsApiOrderCloseResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [关闭订单↗](https://yapi.gogpay.cn/project/906/interface/api/24445) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/close`
 */
type ApiOrderImsApiOrderCloseRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/close',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [关闭订单↗](https://yapi.gogpay.cn/project/906/interface/api/24445) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/close`
 */
const apiOrderImsApiOrderCloseRequestConfig: ApiOrderImsApiOrderCloseRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/close',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderClose',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '关闭订单', author: '成龙' },
  }

/**
 * 接口 [关闭订单↗](https://yapi.gogpay.cn/project/906/interface/api/24445) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/close`
 */
export const apiOrderImsApiOrderClose = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderCloseRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderCloseResponse>(
    prepare(apiOrderImsApiOrderCloseRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderClose.requestConfig = apiOrderImsApiOrderCloseRequestConfig

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/24449) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/detail`
 */
export interface ApiOrderImsApiOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/24449) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/detail`
 */
export interface ApiOrderImsApiOrderDetailResponse {
  buyer?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 商品信息
   */
  commodities?: {
    /**
     * 售后状态文案
     */
    afterSale?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品合同报价名称
     */
    commodityContractTitle?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品来源
     */
    commodityResource?: string
    /**
     * 商品图片
     */
    comoodityPic?: string
    /**
     * SKU成本价
     */
    costPrice?: number
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 优惠活动名称
     */
    discountName?: string
    /**
     * 能效级别
     */
    efficiencyLevel?: number
    /**
     * 满减优惠规则
     */
    fullReductionDiscount?: string
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * 订单商品Id
     */
    id?: string
    /**
     * 实付积分
     */
    integral?: number
    /**
     * 所需积分
     */
    needIntegral?: number
    /**
     * 未发货数量
     */
    noShipQuantity?: number
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 价格
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款状态文案
     */
    refundStatusText?: string
    /**
     * 返现金额
     */
    returnAmount?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeText?: string
    /**
     * 销售渠道
     */
    sellChannelName?: string
    /**
     * 发货状态  0未发货  1已发货  2不可发货
     */
    shipStatus?: number
    /**
     * 订单商品69码
     */
    skuBarCode?: string
    /**
     * sku Id
     */
    skuId?: string
    /**
     * 规格信息
     */
    specs?: string
    /**
     * 税率编码
     */
    taxNo?: string
    /**
     * 税率
     */
    taxRate?: number
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  countDownConfig?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  dispatchInfo?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 发票图片
   */
  invoiceImgUrl?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户封面图
   */
  merchantPic?: string
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 校验资格接口地址
       */
      businessCheckUrl?: string
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 是否实名制购买：0-否 1-是
       */
      checkBuyFlag?: 0 | 1
      /**
       * 商品种类：0-套餐券 1-代金券 2-兑换券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品来源：0多彩宝 1跨境电商
       */
      commodityResource?: number
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      fullReductioActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 满减优惠金额
       */
      fullReductionActivityAmount?: number
      integralActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 供应商绑定商品ID
       */
      provideCommodityId?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 供应商 0=多彩宝 1=京东
       */
      provideSource?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 是否实名制购买：0-否 1-是
       */
      realNamePurchase?: '0' | '1'
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 第三方商品Id
       */
      thirdCommodityId?: string
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
        | '13'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 兑换商品类父级商品订单编号
     */
    parentCommodityOrderNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 实名制类型 0-自动回填 1-手动填写
     */
    realNameInputType: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单轨迹
   */
  orderTimeLine?: {
    /**
     * 轨迹内容
     */
    content?: string
    /**
     * 轨迹时间
     */
    time?: string
  }[]
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 支付信息
   */
  payInfo?: {
    /**
     * 支付金额
     */
    amount?: number
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付渠道
     */
    payChannel?: string
    /**
     * 支付内容
     */
    payContent?: string
    /**
     * 支付场景
     */
    payScenario?: string
    /**
     * 支付流水号
     */
    paySerialNo?: string
    /**
     * 支付状态
     */
    payStatus?: string
    /**
     * 支付时间
     */
    payTime?: string
  }[]
  pickupInfo?: {
    actualAddressDTO?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    addressDTO?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 人脸核验记录
     */
    authRealPicUrl?: string
    /**
     * 人脸核验时间
     */
    authTime?: string
    /**
     * 人脸token
     */
    authToken?: string
    /**
     * 自提码图片
     */
    commodityPicList?: string[]
    /**
     * 客户和商品图片
     */
    customerAndCommodityPicList?: string[]
    /**
     * 提货距离
     */
    distance?: string
    getSelfCodeForm?: {
      /**
       * 详细地址
       */
      addressDetails?: string
      /**
       * 市级区划
       */
      cityCode: string
      /**
       * 市级区划名
       */
      cityName: string
      distance?: string
      /**
       * 区县区划
       */
      districtCode: string
      /**
       * 区县区划名
       */
      districtName: string
      ip?: string
      /**
       * 纬度
       */
      latitude: string
      /**
       * 经度
       */
      longitude: string
      /**
       * 订单详情地址
       */
      orderDetailUrl?: string
      /**
       * 订单编号
       */
      orderNo: string
      /**
       * 省级区划
       */
      provinceCode: string
      /**
       * 省级区划名
       */
      provinceName: string
      /**
       * 券码
       */
      selfPickupCode?: string
    }
    /**
     * 订单取货图片
     */
    orderPickPicList?: string[]
    /**
     * 提货时间
     */
    pickupTime?: string
  }
  /**
   * 服务内容
   */
  serverContent?: {
    /**
     * 金额
     */
    amount?: number
    /**
     * 服务内容
     */
    content?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 添加人
     */
    creator?: string
    /**
     * 服务描述
     */
    desc?: string
    /**
     * 支付状态
     */
    payStatus?: string
  }[]
  /**
   * 门店编号
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/24449) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/detail`
 */
type ApiOrderImsApiOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/24449) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/detail`
 */
const apiOrderImsApiOrderDetailRequestConfig: ApiOrderImsApiOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单详情', author: '成龙' },
  }

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/24449) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/detail`
 */
export const apiOrderImsApiOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderDetailResponse>(
    prepare(apiOrderImsApiOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderDetail.requestConfig = apiOrderImsApiOrderDetailRequestConfig

/**
 * 接口 [订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/24453) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/discountInfo`
 */
export interface ApiOrderImsApiOrderDiscountInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/24453) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/discountInfo`
 */
export type ApiOrderImsApiOrderDiscountInfoResponse = {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 订单优惠金额
   */
  discountAmount?: number
  /**
   * 营销类型
   */
  marketingType?: string
  /**
   * 出资方
   */
  moneyGiver?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 渠道优惠
   */
  payType?: string
  /**
   * 活动范围
   */
  range?: string
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 来源
   */
  source?: string
  /**
   * 使用时间
   */
  useTime?: string
  /**
   * 活动有效期
   */
  validDate?: string
}[]

/**
 * 接口 [订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/24453) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/discountInfo`
 */
type ApiOrderImsApiOrderDiscountInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/discountInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/24453) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/discountInfo`
 */
const apiOrderImsApiOrderDiscountInfoRequestConfig: ApiOrderImsApiOrderDiscountInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/discountInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderDiscountInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单优惠信息', author: '成龙' },
  }

/**
 * 接口 [订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/24453) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/discountInfo`
 */
export const apiOrderImsApiOrderDiscountInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderDiscountInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderDiscountInfoResponse>(
    prepare(apiOrderImsApiOrderDiscountInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderDiscountInfo.requestConfig =
  apiOrderImsApiOrderDiscountInfoRequestConfig

/**
 * 接口 [免除邮费↗](https://yapi.gogpay.cn/project/906/interface/api/24457) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/freePostFee`
 */
export interface ApiOrderImsApiOrderFreePostFeeRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [免除邮费↗](https://yapi.gogpay.cn/project/906/interface/api/24457) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/freePostFee`
 */
export interface ApiOrderImsApiOrderFreePostFeeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [免除邮费↗](https://yapi.gogpay.cn/project/906/interface/api/24457) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/freePostFee`
 */
type ApiOrderImsApiOrderFreePostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/freePostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [免除邮费↗](https://yapi.gogpay.cn/project/906/interface/api/24457) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/freePostFee`
 */
const apiOrderImsApiOrderFreePostFeeRequestConfig: ApiOrderImsApiOrderFreePostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/freePostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderFreePostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '免除邮费', author: '成龙' },
  }

/**
 * 接口 [免除邮费↗](https://yapi.gogpay.cn/project/906/interface/api/24457) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/freePostFee`
 */
export const apiOrderImsApiOrderFreePostFee = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderFreePostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderFreePostFeeResponse>(
    prepare(apiOrderImsApiOrderFreePostFeeRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderFreePostFee.requestConfig =
  apiOrderImsApiOrderFreePostFeeRequestConfig

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/24461) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/list`
 */
export interface ApiOrderImsApiOrderListRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/24461) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/list`
 */
export interface ApiOrderImsApiOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 促销金额
     */
    activityAmount?: number
    /**
     * 促销类型
     */
    activityType?: string
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 申报剩余时间
     */
    applySupDate?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    buyer?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    buyerAddress?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 渠道优惠
     */
    channelDiscount?: string
    /**
     * 渠道优惠金额
     */
    channelDiscountAmount?: number
    /**
     * 商品信息
     */
    commodities?: {
      /**
       * 售后状态文案
       */
      afterSale?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品合同报价名称
       */
      commodityContractTitle?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品来源
       */
      commodityResource?: string
      /**
       * 商品图片
       */
      comoodityPic?: string
      /**
       * SKU成本价
       */
      costPrice?: number
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 优惠活动名称
       */
      discountName?: string
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * 满减优惠规则
       */
      fullReductionDiscount?: string
      /**
       * 满减优惠金额
       */
      fullReductionDiscountAmount?: number
      /**
       * 订单商品Id
       */
      id?: string
      /**
       * 实付积分
       */
      integral?: number
      /**
       * 所需积分
       */
      needIntegral?: number
      /**
       * 未发货数量
       */
      noShipQuantity?: number
      /**
       * 订单商品Sn码
       */
      orderSnNum?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 退款状态文案
       */
      refundStatusText?: string
      /**
       * 返现金额
       */
      returnAmount?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeText?: string
      /**
       * 销售渠道
       */
      sellChannelName?: string
      /**
       * 发货状态  0未发货  1已发货  2不可发货
       */
      shipStatus?: number
      /**
       * 订单商品69码
       */
      skuBarCode?: string
      /**
       * sku Id
       */
      skuId?: string
      /**
       * 规格信息
       */
      specs?: string
      /**
       * 税率编码
       */
      taxNo?: string
      /**
       * 税率
       */
      taxRate?: number
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    /**
     * 多彩宝订单编号
     */
    dcbOrderNo?: string
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 是否已评价 0未评价 1已评价
     */
    evaluateFlag?: number
    /**
     * 兑换商品名称
     */
    exchangeCommodityName?: string
    /**
     * 兑换商品订单编号
     */
    exchangeCommodityOrderNo?: string
    /**
     * 兑换商品类型
     */
    exchangeCommodityType?: number
    /**
     * 满减优惠规则
     */
    fullReductionDiscount?: string
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * imei1编码
     */
    imei1Code?: string
    /**
     * imei2编码
     */
    imei2Code?: string
    /**
     * 积分优惠金额
     */
    integralDiscountAmount?: number
    /**
     * 用户是否申请开票 0未申请 1已申请
     */
    invoiceApplyInfoStatus?: number
    /**
     * 是否开发票 0不开 1开
     */
    invoiceFlag?: number
    /**
     * 发票图片
     */
    invoiceImg?: string
    /**
     * 京东单号
     */
    jdOrderNo?: string
    /**
     * 订单营销类型
     */
    marketingType?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 申报状态失败原因
     */
    orderApplyFailReason?: string
    /**
     * 申报状态 99待申报，00已申报，待审核，01审核通过，02审核不通过，03补贴已支付
     */
    orderApplyYardGoStatus?: string
    /**
     * 申报状态描述
     */
    orderApplyYardGoStatusDesc?: string
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单类型
     */
    orderClassification?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'
    /**
     * 订单日期
     */
    orderDate?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单同步状态0否 1是
     */
    orderPushStatus?: number
    /**
     * 重新申报复核失败原因
     */
    orderReApplyFailReason?: string
    /**
     * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
     */
    orderReApplyYardGoStatus?: string
    /**
     * 重新申报复核状态描述
     */
    orderReApplyYardGoStatusDesc?: string
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    orderTabStatisticsVO?: {
      /**
       * 实际收款
       */
      actualReceivable?: number
      /**
       * 购买数量
       */
      buyCount?: number
      /**
       * 总优惠金额
       */
      discountAmount?: number
      /**
       * 订单笔数
       */
      orderCount?: number
    }
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 订单类型
     */
    orderType?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 邮费免除状态 0不可免除 1可免除
     */
    postFeeFreeStatus?: number
    /**
     * 状态变更原因
     */
    reason?:
      | 'CREATE'
      | 'PAYED'
      | 'AUTO_CLOSE'
      | 'ADMIN_CLOSE'
      | 'USER_CLOSE'
      | 'SALE_AFTER_CLOSE'
      | 'PART_SHIP'
      | 'SHIP'
      | 'BATCH_SHIP'
      | 'BUSINESS_SHIP'
      | 'SALE_DONE_SHIP'
      | 'USER_CONFIRM'
      | 'AUTO_CONFIRM'
      | 'FINISH'
      | 'SALE_AFTER_FINISH'
      | 'INCENTIVE_FINISH'
      | 'WRITE_OFF'
      | 'REFUND'
      | 'TAKE'
      | 'CANCEL'
      | 'SYSTEM_TAKE'
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 订单售后状态 0未售后 1已售后
     */
    saleAfterStatus?: number
    /**
     * 结算状态
     */
    settlementStatus?: string
    /**
     * 是否可结算
     */
    settlementType?: string
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 交易状态 "0待支付
     * 100待发货
     * 101已发货
     *
     * 200待派单
     * 201已派单
     * 202待服务
     * 203服务中
     *
     * 900交易完成
     * 901交易关闭"
     */
    tradeStatus?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 商户机构编码
     */
    unitOrgCode?: string
    /**
     * 是否已催单  0未催单  1已催单
     */
    urgedFlag?: number
    /**
     * 订单所属用户Id
     */
    userId?: string
    /**
     * 订单核销状态 （派单核销）
     */
    verificationStatus?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/24461) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/list`
 */
type ApiOrderImsApiOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/24461) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/list`
 */
const apiOrderImsApiOrderListRequestConfig: ApiOrderImsApiOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表', author: '成龙' },
  }

/**
 * 接口 [订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/24461) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/list`
 */
export const apiOrderImsApiOrderList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderListResponse>(
    prepare(apiOrderImsApiOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderList.requestConfig = apiOrderImsApiOrderListRequestConfig

/**
 * 接口 [订单邮费信息↗](https://yapi.gogpay.cn/project/906/interface/api/24465) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/postFeeInfo`
 */
export interface ApiOrderImsApiOrderPostFeeInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单邮费信息↗](https://yapi.gogpay.cn/project/906/interface/api/24465) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/postFeeInfo`
 */
export type ApiOrderImsApiOrderPostFeeInfoResponse = {
  /**
   * 邮费金额
   */
  amount?: number
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 邮费详情
   */
  detail?: string
  /**
   * 模板名称
   */
  name?: string
  /**
   * 操作人
   */
  operation?: string
  /**
   * 操作时间
   */
  operationTime?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 邮费模板Id
   */
  templateId?: string
  /**
   * 邮费类型
   */
  type?: string
}[]

/**
 * 接口 [订单邮费信息↗](https://yapi.gogpay.cn/project/906/interface/api/24465) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/postFeeInfo`
 */
type ApiOrderImsApiOrderPostFeeInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/postFeeInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单邮费信息↗](https://yapi.gogpay.cn/project/906/interface/api/24465) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/postFeeInfo`
 */
const apiOrderImsApiOrderPostFeeInfoRequestConfig: ApiOrderImsApiOrderPostFeeInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/postFeeInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderPostFeeInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单邮费信息', author: '成龙' },
  }

/**
 * 接口 [订单邮费信息↗](https://yapi.gogpay.cn/project/906/interface/api/24465) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/postFeeInfo`
 */
export const apiOrderImsApiOrderPostFeeInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderPostFeeInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderPostFeeInfoResponse>(
    prepare(apiOrderImsApiOrderPostFeeInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderPostFeeInfo.requestConfig =
  apiOrderImsApiOrderPostFeeInfoRequestConfig

/**
 * 接口 [提醒买家收货\/核销↗](https://yapi.gogpay.cn/project/906/interface/api/24469) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindConfirm`
 */
export interface ApiOrderImsApiOrderRemindConfirmRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [提醒买家收货\/核销↗](https://yapi.gogpay.cn/project/906/interface/api/24469) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindConfirm`
 */
export interface ApiOrderImsApiOrderRemindConfirmResponse {
  /**
   * 发送失败原因
   */
  msg?: string
  /**
   * 处理状态 0发送失败 1发送成功
   */
  status?: number
}

/**
 * 接口 [提醒买家收货\/核销↗](https://yapi.gogpay.cn/project/906/interface/api/24469) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindConfirm`
 */
type ApiOrderImsApiOrderRemindConfirmRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/remindConfirm',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提醒买家收货\/核销↗](https://yapi.gogpay.cn/project/906/interface/api/24469) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindConfirm`
 */
const apiOrderImsApiOrderRemindConfirmRequestConfig: ApiOrderImsApiOrderRemindConfirmRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/remindConfirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderRemindConfirm',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提醒买家收货/核销', author: '成龙' },
  }

/**
 * 接口 [提醒买家收货\/核销↗](https://yapi.gogpay.cn/project/906/interface/api/24469) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindConfirm`
 */
export const apiOrderImsApiOrderRemindConfirm = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderRemindConfirmRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderRemindConfirmResponse>(
    prepare(apiOrderImsApiOrderRemindConfirmRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderRemindConfirm.requestConfig =
  apiOrderImsApiOrderRemindConfirmRequestConfig

/**
 * 接口 [提醒买家付款↗](https://yapi.gogpay.cn/project/906/interface/api/24473) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindPay`
 */
export interface ApiOrderImsApiOrderRemindPayRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [提醒买家付款↗](https://yapi.gogpay.cn/project/906/interface/api/24473) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindPay`
 */
export interface ApiOrderImsApiOrderRemindPayResponse {
  /**
   * 发送失败原因
   */
  msg?: string
  /**
   * 处理状态 0发送失败 1发送成功
   */
  status?: number
}

/**
 * 接口 [提醒买家付款↗](https://yapi.gogpay.cn/project/906/interface/api/24473) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindPay`
 */
type ApiOrderImsApiOrderRemindPayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/remindPay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提醒买家付款↗](https://yapi.gogpay.cn/project/906/interface/api/24473) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindPay`
 */
const apiOrderImsApiOrderRemindPayRequestConfig: ApiOrderImsApiOrderRemindPayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/remindPay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderRemindPay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提醒买家付款', author: '成龙' },
  }

/**
 * 接口 [提醒买家付款↗](https://yapi.gogpay.cn/project/906/interface/api/24473) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/remindPay`
 */
export const apiOrderImsApiOrderRemindPay = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderRemindPayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderRemindPayResponse>(
    prepare(apiOrderImsApiOrderRemindPayRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderRemindPay.requestConfig =
  apiOrderImsApiOrderRemindPayRequestConfig

/**
 * 接口 [催单记录↗](https://yapi.gogpay.cn/project/906/interface/api/24477) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/urgedInfo`
 */
export interface ApiOrderImsApiOrderUrgedInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [催单记录↗](https://yapi.gogpay.cn/project/906/interface/api/24477) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/urgedInfo`
 */
export type ApiOrderImsApiOrderUrgedInfoResponse = {
  /**
   * 序号
   */
  no?: number
  /**
   * 催单时间
   */
  urgedTime?: string
}[]

/**
 * 接口 [催单记录↗](https://yapi.gogpay.cn/project/906/interface/api/24477) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/urgedInfo`
 */
type ApiOrderImsApiOrderUrgedInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/urgedInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [催单记录↗](https://yapi.gogpay.cn/project/906/interface/api/24477) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/urgedInfo`
 */
const apiOrderImsApiOrderUrgedInfoRequestConfig: ApiOrderImsApiOrderUrgedInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/urgedInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderUrgedInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '催单记录', author: '成龙' },
  }

/**
 * 接口 [催单记录↗](https://yapi.gogpay.cn/project/906/interface/api/24477) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/urgedInfo`
 */
export const apiOrderImsApiOrderUrgedInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderUrgedInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderUrgedInfoResponse>(
    prepare(apiOrderImsApiOrderUrgedInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderUrgedInfo.requestConfig =
  apiOrderImsApiOrderUrgedInfoRequestConfig

/**
 * 接口 [发票记录↗](https://yapi.gogpay.cn/project/906/interface/api/25441) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/invoiceInfo`
 */
export interface ApiOrderImsApiOrderInvoiceInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [发票记录↗](https://yapi.gogpay.cn/project/906/interface/api/25441) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/invoiceInfo`
 */
export interface ApiOrderImsApiOrderInvoiceInfoResponse {
  /**
   * 可开票金额
   */
  amount?: number
  /**
   * 发票品类
   */
  category?: string
  /**
   * 发票内容
   */
  content?: string
  /**
   * 收票邮箱地址
   */
  email?: string
  /**
   * 发票号码
   */
  invoiceNo?: string
  /**
   * 发票地址
   */
  invoiceUrl?: string
  /**
   * 开票日期
   */
  issueDate?: string
  /**
   * 订单状态
   */
  orderStatus?: number
  /**
   * 订单状态文案
   */
  orderStatusName?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 商品销售类型 1自营 2联营
   */
  saleType?: number
  /**
   * 商品销售类型文案
   */
  saleTypeName?: string
  /**
   * 开票状态 0未开票 1自动开票 2手动上传
   */
  status?: number
  /**
   * 可开票金额
   */
  statusName?: string
  /**
   * 发票抬头
   */
  title?: string
  /**
   * 抬头类型
   */
  titleType?: string
  /**
   * 发票类型
   */
  type?: string
}

/**
 * 接口 [发票记录↗](https://yapi.gogpay.cn/project/906/interface/api/25441) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/invoiceInfo`
 */
type ApiOrderImsApiOrderInvoiceInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/invoiceInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发票记录↗](https://yapi.gogpay.cn/project/906/interface/api/25441) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/invoiceInfo`
 */
const apiOrderImsApiOrderInvoiceInfoRequestConfig: ApiOrderImsApiOrderInvoiceInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/invoiceInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderInvoiceInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发票记录', author: '成龙' },
  }

/**
 * 接口 [发票记录↗](https://yapi.gogpay.cn/project/906/interface/api/25441) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/invoiceInfo`
 */
export const apiOrderImsApiOrderInvoiceInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderInvoiceInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderInvoiceInfoResponse>(
    prepare(apiOrderImsApiOrderInvoiceInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderInvoiceInfo.requestConfig =
  apiOrderImsApiOrderInvoiceInfoRequestConfig

/**
 * 接口 [上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/25449) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/uploadInvoiceUrl`
 */
export interface ApiOrderImsApiOrderUploadInvoiceUrlRequest {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 发票文件地址
   */
  url?: string
}

/**
 * 接口 [上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/25449) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/uploadInvoiceUrl`
 */
export interface ApiOrderImsApiOrderUploadInvoiceUrlResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/25449) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/uploadInvoiceUrl`
 */
type ApiOrderImsApiOrderUploadInvoiceUrlRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/uploadInvoiceUrl',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/25449) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/uploadInvoiceUrl`
 */
const apiOrderImsApiOrderUploadInvoiceUrlRequestConfig: ApiOrderImsApiOrderUploadInvoiceUrlRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/uploadInvoiceUrl',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderUploadInvoiceUrl',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '上传发票文件', author: '成龙' },
  }

/**
 * 接口 [上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/25449) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/uploadInvoiceUrl`
 */
export const apiOrderImsApiOrderUploadInvoiceUrl = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderUploadInvoiceUrlRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderUploadInvoiceUrlResponse>(
    prepare(apiOrderImsApiOrderUploadInvoiceUrlRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderUploadInvoiceUrl.requestConfig =
  apiOrderImsApiOrderUploadInvoiceUrlRequestConfig

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/25589) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getLogistics`
 */
export interface ApiOrderImsApiOrderGetLogisticsRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 发货方式 1在线 2线下
   */
  shipType: '1' | '2' | '3' | '4' | '5'
}

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/25589) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getLogistics`
 */
export type ApiOrderImsApiOrderGetLogisticsResponse = {
  /**
   * 快递公司编码
   */
  code?: string
  /**
   * 快递公司Id
   */
  id?: string
  /**
   * 快递公司名称
   */
  name?: string
}[]

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/25589) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getLogistics`
 */
type ApiOrderImsApiOrderGetLogisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/getLogistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/25589) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getLogistics`
 */
const apiOrderImsApiOrderGetLogisticsRequestConfig: ApiOrderImsApiOrderGetLogisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/getLogistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderGetLogistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取快递公司信息', author: '成龙' },
  }

/**
 * 接口 [获取快递公司信息↗](https://yapi.gogpay.cn/project/906/interface/api/25589) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getLogistics`
 */
export const apiOrderImsApiOrderGetLogistics = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderGetLogisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderGetLogisticsResponse>(
    prepare(apiOrderImsApiOrderGetLogisticsRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderGetLogistics.requestConfig =
  apiOrderImsApiOrderGetLogisticsRequestConfig

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/25593) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryLogisticsInfo`
 */
export interface ApiOrderImsApiOrderQueryLogisticsInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 包裹Id
   */
  packageId?: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/25593) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryLogisticsInfo`
 */
export interface ApiOrderImsApiOrderQueryLogisticsInfoResponse {
  /**
   * 发货时间
   */
  beginTime?: string
  /**
   * 物流公司名称
   */
  companyName?: string
  /**
   * 运送方式
   */
  logisticsMethod?: string
  /**
   * 物流订单号
   */
  logisticsOrderNo?: string
  /**
   * 物流状态
   */
  state?: string
  /**
   * 物流轨迹信息
   */
  traces?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }[]
  /**
   * 运单号
   */
  waybillNo?: string
}

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/25593) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryLogisticsInfo`
 */
type ApiOrderImsApiOrderQueryLogisticsInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/queryLogisticsInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/25593) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryLogisticsInfo`
 */
const apiOrderImsApiOrderQueryLogisticsInfoRequestConfig: ApiOrderImsApiOrderQueryLogisticsInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/queryLogisticsInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderQueryLogisticsInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询物流信息', author: '成龙' },
  }

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/25593) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryLogisticsInfo`
 */
export const apiOrderImsApiOrderQueryLogisticsInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderQueryLogisticsInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderQueryLogisticsInfoResponse>(
    prepare(apiOrderImsApiOrderQueryLogisticsInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderQueryLogisticsInfo.requestConfig =
  apiOrderImsApiOrderQueryLogisticsInfoRequestConfig

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/25597) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/ship`
 */
export interface ApiOrderImsApiOrderShipRequest {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 发货方式 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配 4同城配送 5商家自配
   */
  orderShipType?: '1' | '2' | '3' | '4' | '5'
  /**
   * 包裹列表
   */
  packageItems?: {
    /**
     * 订单商品Id，和sku Id二选一传递
     */
    commodityId?: {
      commodityCount?: number
      commodityId?: string
    }[]
    /**
     * 快递公司编码，当发货方式为【线下自寄】时必传
     */
    companyCode?: string
    /**
     * 快递公司名称，当发货方式为【线下自寄】时必传
     */
    companyName?: string
    /**
     * 运单号，当发货方式为【线下自寄】时必传
     */
    logisticCode?: string
    /**
     * 快递公司信息Id，当发货方式为【线上发货】时必传
     */
    merchantShipperId?: string
    /**
     * 备注信息
     */
    remark?: string
    /**
     * 订单商品SKU Id,和订单商品Id二选一传递
     */
    skuId?: {
      commodityCount?: number
      commoditySkuId?: string
    }[]
  }[]
  /**
   * 备注信息，线下自提时的备注传入此处
   */
  remark?: string
  /**
   * 门店自提地址Id，当发货方式为【门店自提】时必传
   */
  selfAddress?: string
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/25597) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/ship`
 */
export interface ApiOrderImsApiOrderShipResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/25597) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/ship`
 */
type ApiOrderImsApiOrderShipRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/ship',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/25597) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/ship`
 */
const apiOrderImsApiOrderShipRequestConfig: ApiOrderImsApiOrderShipRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/ship',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderShip',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单发货', author: '成龙' },
  }

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/25597) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/ship`
 */
export const apiOrderImsApiOrderShip = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderShipRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderShipResponse>(
    prepare(apiOrderImsApiOrderShipRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderShip.requestConfig = apiOrderImsApiOrderShipRequestConfig

/**
 * 接口 [商户地址列表↗](https://yapi.gogpay.cn/project/906/interface/api/25601) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantAddress`
 */
export interface ApiOrderImsApiOrderMerchantAddressRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 门店地址类型筛选 1门店地址  2退货地址  4发货地址
   */
  type?: number
}

/**
 * 接口 [商户地址列表↗](https://yapi.gogpay.cn/project/906/interface/api/25601) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantAddress`
 */
export type ApiOrderImsApiOrderMerchantAddressResponse = {
  /**
   * 地址
   */
  address?: string
  /**
   * 地址Id
   */
  id?: string
  /**
   * 排序
   */
  sort?: number
}[]

/**
 * 接口 [商户地址列表↗](https://yapi.gogpay.cn/project/906/interface/api/25601) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantAddress`
 */
type ApiOrderImsApiOrderMerchantAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/merchantAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户地址列表↗](https://yapi.gogpay.cn/project/906/interface/api/25601) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantAddress`
 */
const apiOrderImsApiOrderMerchantAddressRequestConfig: ApiOrderImsApiOrderMerchantAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/merchantAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderMerchantAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户地址列表', author: '成龙' },
  }

/**
 * 接口 [商户地址列表↗](https://yapi.gogpay.cn/project/906/interface/api/25601) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantAddress`
 */
export const apiOrderImsApiOrderMerchantAddress = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderMerchantAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderMerchantAddressResponse>(
    prepare(apiOrderImsApiOrderMerchantAddressRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderMerchantAddress.requestConfig =
  apiOrderImsApiOrderMerchantAddressRequestConfig

/**
 * 接口 [商户列表↗](https://yapi.gogpay.cn/project/906/interface/api/25605) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantList`
 */
export interface ApiOrderImsApiOrderMerchantListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 提交时间-结束时间
   */
  endTime?: string
  /**
   * 机构名称/编码
   */
  orgCode?: string
  /**
   * 结算方式 00-见证宝   01-NC
   */
  orgTradeType?: 'ONLINE' | 'NC'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 提交时间-开始时间
   */
  startTime?: string
  /**
   * 记录状态
   */
  status?: number
}

/**
 * 接口 [商户列表↗](https://yapi.gogpay.cn/project/906/interface/api/25605) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantList`
 */
export type ApiOrderImsApiOrderMerchantListResponse = {
  /**
   * 商户Id
   */
  id?: string
  /**
   * 商户名称
   */
  name?: string
}[]

/**
 * 接口 [商户列表↗](https://yapi.gogpay.cn/project/906/interface/api/25605) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantList`
 */
type ApiOrderImsApiOrderMerchantListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/merchantList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户列表↗](https://yapi.gogpay.cn/project/906/interface/api/25605) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantList`
 */
const apiOrderImsApiOrderMerchantListRequestConfig: ApiOrderImsApiOrderMerchantListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/merchantList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderMerchantList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户列表', author: '成龙' },
  }

/**
 * 接口 [商户列表↗](https://yapi.gogpay.cn/project/906/interface/api/25605) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/merchantList`
 */
export const apiOrderImsApiOrderMerchantList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderMerchantListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderMerchantListResponse>(
    prepare(apiOrderImsApiOrderMerchantListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderMerchantList.requestConfig =
  apiOrderImsApiOrderMerchantListRequestConfig

/**
 * 接口 [导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/29045) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/export`
 */
export interface ApiOrderImsApiOrderExportRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/29045) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/export`
 */
export interface ApiOrderImsApiOrderExportResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/29045) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/export`
 */
type ApiOrderImsApiOrderExportRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/export',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/29045) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/export`
 */
const apiOrderImsApiOrderExportRequestConfig: ApiOrderImsApiOrderExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderExport',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出订单', author: '成龙' },
  }

/**
 * 接口 [导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/29045) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/export`
 */
export const apiOrderImsApiOrderExport = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderExportResponse>(
    prepare(apiOrderImsApiOrderExportRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderExport.requestConfig = apiOrderImsApiOrderExportRequestConfig

/**
 * 接口 [发送发票到邮箱↗](https://yapi.gogpay.cn/project/906/interface/api/30209) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/sendInvoiceEmail`
 */
export interface ApiOrderImsApiOrderSendInvoiceEmailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [发送发票到邮箱↗](https://yapi.gogpay.cn/project/906/interface/api/30209) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/sendInvoiceEmail`
 */
export interface ApiOrderImsApiOrderSendInvoiceEmailResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发送发票到邮箱↗](https://yapi.gogpay.cn/project/906/interface/api/30209) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/sendInvoiceEmail`
 */
type ApiOrderImsApiOrderSendInvoiceEmailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/sendInvoiceEmail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发送发票到邮箱↗](https://yapi.gogpay.cn/project/906/interface/api/30209) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/sendInvoiceEmail`
 */
const apiOrderImsApiOrderSendInvoiceEmailRequestConfig: ApiOrderImsApiOrderSendInvoiceEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/sendInvoiceEmail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSendInvoiceEmail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发送发票到邮箱', author: '成龙' },
  }

/**
 * 接口 [发送发票到邮箱↗](https://yapi.gogpay.cn/project/906/interface/api/30209) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/sendInvoiceEmail`
 */
export const apiOrderImsApiOrderSendInvoiceEmail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSendInvoiceEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSendInvoiceEmailResponse>(
    prepare(apiOrderImsApiOrderSendInvoiceEmailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderSendInvoiceEmail.requestConfig =
  apiOrderImsApiOrderSendInvoiceEmailRequestConfig

/**
 * 接口 [获取订单发票参数↗](https://yapi.gogpay.cn/project/906/interface/api/37558) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getInvoiceParam`
 */
export interface ApiOrderImsApiOrderGetInvoiceParamRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取订单发票参数↗](https://yapi.gogpay.cn/project/906/interface/api/37558) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getInvoiceParam`
 */
export interface ApiOrderImsApiOrderGetInvoiceParamResponse {
  address?: string
  bankAccount?: string
  bankName?: string
  dcbUserId?: string
  email?: string
  invoiceCategory?: number
  invoiceContent?: string
  invoiceImageUrl?: string
  invoicePdfUrl?: string
  invoiceStatus?: number
  invoiceTitle?: string
  invoiceTitleType?: number
  invoiceType?: number
  orderNo?: string
  saleType?: number
  taxPayerNumber?: string
}

/**
 * 接口 [获取订单发票参数↗](https://yapi.gogpay.cn/project/906/interface/api/37558) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getInvoiceParam`
 */
type ApiOrderImsApiOrderGetInvoiceParamRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/getInvoiceParam',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单发票参数↗](https://yapi.gogpay.cn/project/906/interface/api/37558) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getInvoiceParam`
 */
const apiOrderImsApiOrderGetInvoiceParamRequestConfig: ApiOrderImsApiOrderGetInvoiceParamRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/getInvoiceParam',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderGetInvoiceParam',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单发票参数', author: '成龙' },
  }

/**
 * 接口 [获取订单发票参数↗](https://yapi.gogpay.cn/project/906/interface/api/37558) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getInvoiceParam`
 */
export const apiOrderImsApiOrderGetInvoiceParam = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderGetInvoiceParamRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderGetInvoiceParamResponse>(
    prepare(apiOrderImsApiOrderGetInvoiceParamRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderGetInvoiceParam.requestConfig =
  apiOrderImsApiOrderGetInvoiceParamRequestConfig

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/37568) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyInvoice`
 */
export interface ApiOrderImsApiOrderModifyInvoiceRequest {
  /**
   * 企业地址
   */
  address?: string
  /**
   * 银行账号
   */
  bankAccount?: string
  /**
   * 开户银行
   */
  bankName?: string
  /**
   * 发票邮箱地址
   */
  email?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 纳税人识别号
   */
  taxPayerNumber?: string
  /**
   * 发票抬头
   */
  title: string
  /**
   * 抬头类型 1个人 2企业
   */
  titleType: number
}

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/37568) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyInvoice`
 */
export interface ApiOrderImsApiOrderModifyInvoiceResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/37568) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyInvoice`
 */
type ApiOrderImsApiOrderModifyInvoiceRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/modifyInvoice',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/37568) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyInvoice`
 */
const apiOrderImsApiOrderModifyInvoiceRequestConfig: ApiOrderImsApiOrderModifyInvoiceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/modifyInvoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderModifyInvoice',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改订单发票信息', author: '成龙' },
  }

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/37568) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyInvoice`
 */
export const apiOrderImsApiOrderModifyInvoice = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderModifyInvoiceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderModifyInvoiceResponse>(
    prepare(apiOrderImsApiOrderModifyInvoiceRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderModifyInvoice.requestConfig =
  apiOrderImsApiOrderModifyInvoiceRequestConfig

/**
 * 接口 [修改订单运单号↗](https://yapi.gogpay.cn/project/906/interface/api/57473) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyLogisticsNo`
 */
export interface ApiOrderImsApiOrderModifyLogisticsNoRequest {
  /**
   * 快递公司编码
   */
  companyCode: string
  /**
   * 快递公司名称
   */
  companyName: string
  /**
   * 运单号
   */
  logisticCode: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 包裹Id
   */
  packageId: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [修改订单运单号↗](https://yapi.gogpay.cn/project/906/interface/api/57473) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyLogisticsNo`
 */
export interface ApiOrderImsApiOrderModifyLogisticsNoResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改订单运单号↗](https://yapi.gogpay.cn/project/906/interface/api/57473) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyLogisticsNo`
 */
type ApiOrderImsApiOrderModifyLogisticsNoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/modifyLogisticsNo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改订单运单号↗](https://yapi.gogpay.cn/project/906/interface/api/57473) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyLogisticsNo`
 */
const apiOrderImsApiOrderModifyLogisticsNoRequestConfig: ApiOrderImsApiOrderModifyLogisticsNoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/modifyLogisticsNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderModifyLogisticsNo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改订单运单号', author: '成龙' },
  }

/**
 * 接口 [修改订单运单号↗](https://yapi.gogpay.cn/project/906/interface/api/57473) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifyLogisticsNo`
 */
export const apiOrderImsApiOrderModifyLogisticsNo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderModifyLogisticsNoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderModifyLogisticsNoResponse>(
    prepare(apiOrderImsApiOrderModifyLogisticsNoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderModifyLogisticsNo.requestConfig =
  apiOrderImsApiOrderModifyLogisticsNoRequestConfig

/**
 * 接口 [新增订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/59354) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/addDiscountInfo`
 */
export interface ApiOrderImsApiOrderAddDiscountInfoRequest {
  activityId?: string
  activityName?: string
  activityRange?: string
  discountAmount?: number
  /**
   * 优惠标识，特殊标识，用于与优惠资金池匹配
   */
  flag?: string
  /**
   * 来自父订单的调用
   */
  fromParent?: boolean
  needPoint?: number
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  point?: number
  returnAmount?: number
  rule?: string
  settlementConfig?: {
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
  }
  validDate?: string
}

/**
 * 接口 [新增订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/59354) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/addDiscountInfo`
 */
export interface ApiOrderImsApiOrderAddDiscountInfoResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [新增订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/59354) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/addDiscountInfo`
 */
type ApiOrderImsApiOrderAddDiscountInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/addDiscountInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [新增订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/59354) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/addDiscountInfo`
 */
const apiOrderImsApiOrderAddDiscountInfoRequestConfig: ApiOrderImsApiOrderAddDiscountInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/addDiscountInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderAddDiscountInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '新增订单优惠信息', author: '成龙' },
  }

/**
 * 接口 [新增订单优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/59354) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/addDiscountInfo`
 */
export const apiOrderImsApiOrderAddDiscountInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderAddDiscountInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderAddDiscountInfoResponse>(
    prepare(apiOrderImsApiOrderAddDiscountInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderAddDiscountInfo.requestConfig =
  apiOrderImsApiOrderAddDiscountInfoRequestConfig

/**
 * 接口 [订单渠道优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/74590) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/channelDiscountInfo`
 */
export interface ApiOrderImsApiOrderChannelDiscountInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单渠道优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/74590) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/channelDiscountInfo`
 */
export type ApiOrderImsApiOrderChannelDiscountInfoResponse = {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 订单优惠金额
   */
  discountAmount?: number
  /**
   * 营销类型
   */
  marketingType?: string
  /**
   * 出资方
   */
  moneyGiver?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 渠道优惠
   */
  payType?: string
  /**
   * 活动范围
   */
  range?: string
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 来源
   */
  source?: string
  /**
   * 使用时间
   */
  useTime?: string
  /**
   * 活动有效期
   */
  validDate?: string
}[]

/**
 * 接口 [订单渠道优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/74590) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/channelDiscountInfo`
 */
type ApiOrderImsApiOrderChannelDiscountInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/channelDiscountInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单渠道优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/74590) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/channelDiscountInfo`
 */
const apiOrderImsApiOrderChannelDiscountInfoRequestConfig: ApiOrderImsApiOrderChannelDiscountInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/channelDiscountInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderChannelDiscountInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单渠道优惠信息', author: '成龙' },
  }

/**
 * 接口 [订单渠道优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/74590) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/channelDiscountInfo`
 */
export const apiOrderImsApiOrderChannelDiscountInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderChannelDiscountInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderChannelDiscountInfoResponse>(
    prepare(apiOrderImsApiOrderChannelDiscountInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderChannelDiscountInfo.requestConfig =
  apiOrderImsApiOrderChannelDiscountInfoRequestConfig

/**
 * 接口 [修改售后入口↗](https://yapi.gogpay.cn/project/906/interface/api/74596) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifySaleAfterSwitch`
 */
export interface ApiOrderImsApiOrderModifySaleAfterSwitchRequest {
  /**
   * 订单商品Id
   */
  id: string
  /**
   * 是否开启
   */
  open?: boolean
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType: '1' | '2' | '3'
}

/**
 * 接口 [修改售后入口↗](https://yapi.gogpay.cn/project/906/interface/api/74596) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifySaleAfterSwitch`
 */
export interface ApiOrderImsApiOrderModifySaleAfterSwitchResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改售后入口↗](https://yapi.gogpay.cn/project/906/interface/api/74596) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifySaleAfterSwitch`
 */
type ApiOrderImsApiOrderModifySaleAfterSwitchRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/modifySaleAfterSwitch',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改售后入口↗](https://yapi.gogpay.cn/project/906/interface/api/74596) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifySaleAfterSwitch`
 */
const apiOrderImsApiOrderModifySaleAfterSwitchRequestConfig: ApiOrderImsApiOrderModifySaleAfterSwitchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/modifySaleAfterSwitch',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderModifySaleAfterSwitch',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改售后入口', author: '成龙' },
  }

/**
 * 接口 [修改售后入口↗](https://yapi.gogpay.cn/project/906/interface/api/74596) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/modifySaleAfterSwitch`
 */
export const apiOrderImsApiOrderModifySaleAfterSwitch = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderModifySaleAfterSwitchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderModifySaleAfterSwitchResponse>(
    prepare(apiOrderImsApiOrderModifySaleAfterSwitchRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderModifySaleAfterSwitch.requestConfig =
  apiOrderImsApiOrderModifySaleAfterSwitchRequestConfig

/**
 * 接口 [售后入口列表↗](https://yapi.gogpay.cn/project/906/interface/api/74602) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/saleAfterSwitch`
 */
export interface ApiOrderImsApiOrderSaleAfterSwitchRequest {
  /**
   * 订单商品Id
   */
  id: string
}

/**
 * 接口 [售后入口列表↗](https://yapi.gogpay.cn/project/906/interface/api/74602) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/saleAfterSwitch`
 */
export type ApiOrderImsApiOrderSaleAfterSwitchResponse = {
  /**
   * 是否已开启
   */
  open?: boolean
  /**
   * 开启文案
   */
  openText?: string
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: number
  /**
   * 售后类型文案
   */
  saleAfterTypeText?: string
  /**
   * 更新人
   */
  updateBy?: string
  /**
   * 更新时间
   */
  updateTime?: string
}[]

/**
 * 接口 [售后入口列表↗](https://yapi.gogpay.cn/project/906/interface/api/74602) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/saleAfterSwitch`
 */
type ApiOrderImsApiOrderSaleAfterSwitchRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/saleAfterSwitch',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [售后入口列表↗](https://yapi.gogpay.cn/project/906/interface/api/74602) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/saleAfterSwitch`
 */
const apiOrderImsApiOrderSaleAfterSwitchRequestConfig: ApiOrderImsApiOrderSaleAfterSwitchRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/saleAfterSwitch',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSaleAfterSwitch',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '售后入口列表', author: '成龙' },
  }

/**
 * 接口 [售后入口列表↗](https://yapi.gogpay.cn/project/906/interface/api/74602) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/saleAfterSwitch`
 */
export const apiOrderImsApiOrderSaleAfterSwitch = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSaleAfterSwitchRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSaleAfterSwitchResponse>(
    prepare(apiOrderImsApiOrderSaleAfterSwitchRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderSaleAfterSwitch.requestConfig =
  apiOrderImsApiOrderSaleAfterSwitchRequestConfig

/**
 * 接口 [订单促销优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/76282) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityDiscountInfo`
 */
export interface ApiOrderImsApiOrderActivityDiscountInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单促销优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/76282) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityDiscountInfo`
 */
export type ApiOrderImsApiOrderActivityDiscountInfoResponse = {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 活动名称
   */
  activityName?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 订单优惠金额
   */
  discountAmount?: number
  /**
   * 营销类型
   */
  marketingType?: string
  /**
   * 出资方
   */
  moneyGiver?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 渠道优惠
   */
  payType?: string
  /**
   * 活动范围
   */
  range?: string
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 来源
   */
  source?: string
  /**
   * 使用时间
   */
  useTime?: string
  /**
   * 活动有效期
   */
  validDate?: string
}[]

/**
 * 接口 [订单促销优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/76282) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityDiscountInfo`
 */
type ApiOrderImsApiOrderActivityDiscountInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/activityDiscountInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单促销优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/76282) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityDiscountInfo`
 */
const apiOrderImsApiOrderActivityDiscountInfoRequestConfig: ApiOrderImsApiOrderActivityDiscountInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/activityDiscountInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderActivityDiscountInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单促销优惠信息', author: '成龙' },
  }

/**
 * 接口 [订单促销优惠信息↗](https://yapi.gogpay.cn/project/906/interface/api/76282) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityDiscountInfo`
 */
export const apiOrderImsApiOrderActivityDiscountInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderActivityDiscountInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderActivityDiscountInfoResponse>(
    prepare(apiOrderImsApiOrderActivityDiscountInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderActivityDiscountInfo.requestConfig =
  apiOrderImsApiOrderActivityDiscountInfoRequestConfig

/**
 * 接口 [发起售后↗](https://yapi.gogpay.cn/project/906/interface/api/76522) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/applySaleAfter`
 */
export interface ApiOrderImsApiOrderApplySaleAfterRequest {
  /**
   * 申请原因
   */
  applyReasonAddDescription?: string
  /**
   * 凭证图片
   */
  applyReasonAddPic?: string[]
  /**
   * 仲裁备注
   */
  judgmentalSaleAfterRemark?: string
  /**
   * 数量
   */
  quantity?: number
  /**
   * 是否收到货 0否1是
   */
  receiveFlag?: number
  /**
   * 订单编号
   */
  refOrderNo: string
  /**
   * 申请退款金额
   */
  refundAmt?: number
  /**
   * 发起售后类型 1:仅退款 2:退款退货;3:退换货
   */
  saleAfterType: number
  /**
   * skuId
   */
  skuId?: string
  /**
   * 运单号，换货必填
   */
  waybillNo?: string
}

/**
 * 接口 [发起售后↗](https://yapi.gogpay.cn/project/906/interface/api/76522) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/applySaleAfter`
 */
export interface ApiOrderImsApiOrderApplySaleAfterResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发起售后↗](https://yapi.gogpay.cn/project/906/interface/api/76522) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/applySaleAfter`
 */
type ApiOrderImsApiOrderApplySaleAfterRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/applySaleAfter',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发起售后↗](https://yapi.gogpay.cn/project/906/interface/api/76522) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/applySaleAfter`
 */
const apiOrderImsApiOrderApplySaleAfterRequestConfig: ApiOrderImsApiOrderApplySaleAfterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/applySaleAfter',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderApplySaleAfter',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发起售后', author: '成龙' },
  }

/**
 * 接口 [发起售后↗](https://yapi.gogpay.cn/project/906/interface/api/76522) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/applySaleAfter`
 */
export const apiOrderImsApiOrderApplySaleAfter = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderApplySaleAfterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderApplySaleAfterResponse>(
    prepare(apiOrderImsApiOrderApplySaleAfterRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderApplySaleAfter.requestConfig =
  apiOrderImsApiOrderApplySaleAfterRequestConfig

/**
 * 接口 [获取子单列表↗](https://yapi.gogpay.cn/project/906/interface/api/261147) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getChildOrders`
 */
export interface ApiOrderImsApiOrderGetChildOrdersRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [获取子单列表↗](https://yapi.gogpay.cn/project/906/interface/api/261147) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getChildOrders`
 */
export type ApiOrderImsApiOrderGetChildOrdersResponse = {
  actualReceivable?: number
  businessChannelId?: string
  businessChannelName?: string
  commodityClassifyType?: number
  commodityQuantity?: number
  consigneeInfo?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  contactName?: string
  contactPhoneNum?: string
  createTime?: string
  dcbUserId?: string
  discountAmount?: number
  merchantId?: string
  merchantName?: string
  orderActivityType?: number
  orderClassification?: number
  orderNo?: string
  orderStatus?: number
  orderTime?: string
  orderType?: number
  originalOrderNo?: string
  parentOrderId?: string
  payAmount?: number
  payOrderNo?: string
  payTime?: string
  payType?: number
  postFee?: number
  refMartId?: string
  remark?: string
  skuList?: {
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 边界商品编号
     */
    edgeCommodityNo?: string
    /**
     * 商品项税费(总税费，单个商品税费*数量)
     */
    goodsTotalTax?: number
    /**
     * 单价(精确到2位小数;单位:元)
     */
    price?: number
    /**
     * 购买数量
     */
    quantity: number
    /**
     * 结算价(精确到2位小数;单位:元)
     */
    settlementPrice?: number
    /**
     * sku Id
     */
    skuId: string
    /**
     * 第三方商品Id
     */
    thirdCommodityId?: string
    /**
     * 时段ID
     */
    timeIntervalId?: string
    /**
     * 游玩日期，格式yyyy-MM-dd
     */
    travelDate?: string
  }[]
  taxFeeAmount?: number
  totalPrice?: number
  unitOrgCode?: string
  userList?: {
    idCardNo?: string
    name?: string
    phoneNum?: string
  }[]
  userName?: string
  userTel?: number
}[]

/**
 * 接口 [获取子单列表↗](https://yapi.gogpay.cn/project/906/interface/api/261147) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getChildOrders`
 */
type ApiOrderImsApiOrderGetChildOrdersRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/getChildOrders',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取子单列表↗](https://yapi.gogpay.cn/project/906/interface/api/261147) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getChildOrders`
 */
const apiOrderImsApiOrderGetChildOrdersRequestConfig: ApiOrderImsApiOrderGetChildOrdersRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/getChildOrders',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderGetChildOrders',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取子单列表', author: '成龙' },
  }

/**
 * 接口 [获取子单列表↗](https://yapi.gogpay.cn/project/906/interface/api/261147) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getChildOrders`
 */
export const apiOrderImsApiOrderGetChildOrders = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderGetChildOrdersRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderGetChildOrdersResponse>(
    prepare(apiOrderImsApiOrderGetChildOrdersRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderGetChildOrders.requestConfig =
  apiOrderImsApiOrderGetChildOrdersRequestConfig

/**
 * 接口 [获取订单指定日期统计数据↗](https://yapi.gogpay.cn/project/906/interface/api/261150) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getOrderStat`
 */
export interface ApiOrderImsApiOrderGetOrderStatRequest {
  /**
   * 统计日期,不传则为今日
   */
  statDate?: string
}

/**
 * 接口 [获取订单指定日期统计数据↗](https://yapi.gogpay.cn/project/906/interface/api/261150) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getOrderStat`
 */
export type ApiOrderImsApiOrderGetOrderStatResponse = {
  /**
   * 订单总额
   */
  amount?: number
  /**
   * 运营渠道Id
   */
  businessChannelId?: string
  /**
   * 关闭订单总额
   */
  closeAmount?: number
  /**
   * 关闭订单数量
   */
  closeQuantity?: number
  /**
   * 订单数量
   */
  quantity?: number
  /**
   * 销售渠道Id
   */
  sellChannelId?: string
  /**
   * 统计日期
   */
  statDate?: string
  /**
   * 用户数量
   */
  userCount?: number
}[]

/**
 * 接口 [获取订单指定日期统计数据↗](https://yapi.gogpay.cn/project/906/interface/api/261150) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getOrderStat`
 */
type ApiOrderImsApiOrderGetOrderStatRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/getOrderStat',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单指定日期统计数据↗](https://yapi.gogpay.cn/project/906/interface/api/261150) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getOrderStat`
 */
const apiOrderImsApiOrderGetOrderStatRequestConfig: ApiOrderImsApiOrderGetOrderStatRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/getOrderStat',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderGetOrderStat',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单指定日期统计数据', author: '成龙' },
  }

/**
 * 接口 [获取订单指定日期统计数据↗](https://yapi.gogpay.cn/project/906/interface/api/261150) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/getOrderStat`
 */
export const apiOrderImsApiOrderGetOrderStat = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderGetOrderStatRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderGetOrderStatResponse>(
    prepare(apiOrderImsApiOrderGetOrderStatRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderGetOrderStat.requestConfig =
  apiOrderImsApiOrderGetOrderStatRequestConfig

/**
 * 接口 [转换正常单↗](https://yapi.gogpay.cn/project/906/interface/api/261153) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/transToNormal`
 */
export interface ApiOrderImsApiOrderTransToNormalRequest {
  /**
   * 批量单号
   */
  batchNo?: string
  /**
   * 子单支付信息
   */
  childOrderMap?: {}
  /**
   * 操作人
   */
  operationUser?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 支付流水号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 异常原因
   */
  reason?:
    | '"NONE"'
    | '"EX_TIME_PAY"'
    | '"BUSINESS_NOTIFY_FAIL"'
    | '"CHANNEL_PAY_AMOUNT_FAILED"'
    | '"CHANNEL_PAY_ACTIVITY_FAILED"'
    | '"QUERY_CHANNEL_FAIL"'
    | '"QUERY_CHANNEL_NOT_EXISTS"'
    | '"UN_KNOW_ACTIVITY"'
    | '"ADD_DISCOUNT_FAIL"'
    | '"QUERY_ORDER_FAIL"'
    | '"EDGE_PAY_FAIL"'
}

/**
 * 接口 [转换正常单↗](https://yapi.gogpay.cn/project/906/interface/api/261153) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/transToNormal`
 */
export interface ApiOrderImsApiOrderTransToNormalResponse {
  /**
   * 消息结果
   */
  msg?: string
  /**
   * 是否已转换为正常单
   */
  result?: boolean
}

/**
 * 接口 [转换正常单↗](https://yapi.gogpay.cn/project/906/interface/api/261153) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/transToNormal`
 */
type ApiOrderImsApiOrderTransToNormalRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/transToNormal',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [转换正常单↗](https://yapi.gogpay.cn/project/906/interface/api/261153) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/transToNormal`
 */
const apiOrderImsApiOrderTransToNormalRequestConfig: ApiOrderImsApiOrderTransToNormalRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/transToNormal',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderTransToNormal',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '转换正常单', author: '成龙' },
  }

/**
 * 接口 [转换正常单↗](https://yapi.gogpay.cn/project/906/interface/api/261153) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/transToNormal`
 */
export const apiOrderImsApiOrderTransToNormal = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderTransToNormalRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderTransToNormalResponse>(
    prepare(apiOrderImsApiOrderTransToNormalRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderTransToNormal.requestConfig =
  apiOrderImsApiOrderTransToNormalRequestConfig

/**
 * 接口 [导出标电订单↗](https://yapi.gogpay.cn/project/906/interface/api/331250) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportStandard`
 */
export interface ApiOrderImsApiOrderExportStandardRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [导出标电订单↗](https://yapi.gogpay.cn/project/906/interface/api/331250) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportStandard`
 */
export interface ApiOrderImsApiOrderExportStandardResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出标电订单↗](https://yapi.gogpay.cn/project/906/interface/api/331250) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportStandard`
 */
type ApiOrderImsApiOrderExportStandardRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/exportStandard',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出标电订单↗](https://yapi.gogpay.cn/project/906/interface/api/331250) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportStandard`
 */
const apiOrderImsApiOrderExportStandardRequestConfig: ApiOrderImsApiOrderExportStandardRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/exportStandard',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderExportStandard',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出标电订单', author: '333号开发' },
  }

/**
 * 接口 [导出标电订单↗](https://yapi.gogpay.cn/project/906/interface/api/331250) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportStandard`
 */
export const apiOrderImsApiOrderExportStandard = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderExportStandardRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderExportStandardResponse>(
    prepare(apiOrderImsApiOrderExportStandardRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderExportStandard.requestConfig =
  apiOrderImsApiOrderExportStandardRequestConfig

/**
 * 接口 [查询订单↗](https://yapi.gogpay.cn/project/906/interface/api/364542) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryOrder`
 */
export interface ApiOrderImsApiOrderQueryOrderRequest {
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [查询订单↗](https://yapi.gogpay.cn/project/906/interface/api/364542) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryOrder`
 */
export type ApiOrderImsApiOrderQueryOrderResponse = {
  /**
   * 商品列表
   */
  commodityItems?: {
    /**
     * 封面图片
     */
    coverPic?: string
    /**
     * 商品Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 支付金额
     */
    payAmount?: number
    /**
     * 购买数量
     */
    quantity?: number
    /**
     * 规格名称
     */
    skuName?: string
    /**
     * 总价
     */
    totalPrice?: number
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 支付金额
   */
  payAmount?: number
  /**
   * 用户Id
   */
  userId?: string
}[]

/**
 * 接口 [查询订单↗](https://yapi.gogpay.cn/project/906/interface/api/364542) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryOrder`
 */
type ApiOrderImsApiOrderQueryOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/queryOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询订单↗](https://yapi.gogpay.cn/project/906/interface/api/364542) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryOrder`
 */
const apiOrderImsApiOrderQueryOrderRequestConfig: ApiOrderImsApiOrderQueryOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/queryOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderQueryOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询订单', author: '333号开发' },
  }

/**
 * 接口 [查询订单↗](https://yapi.gogpay.cn/project/906/interface/api/364542) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/queryOrder`
 */
export const apiOrderImsApiOrderQueryOrder = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderQueryOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderQueryOrderResponse>(
    prepare(apiOrderImsApiOrderQueryOrderRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderQueryOrder.requestConfig =
  apiOrderImsApiOrderQueryOrderRequestConfig

/**
 * 接口 [订单活动统计↗](https://yapi.gogpay.cn/project/906/interface/api/380676) 的 **请求类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityStatistic`
 */
export interface ApiOrderImsApiOrderActivityStatisticRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 订单数量
   */
  orderCount?: number
  /**
   * 订单总优惠金额
   */
  orderDiscountAmt?: number
  /**
   * 活动规则
   */
  rule?: string
}

/**
 * 接口 [订单活动统计↗](https://yapi.gogpay.cn/project/906/interface/api/380676) 的 **返回类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityStatistic`
 */
export interface ApiOrderImsApiOrderActivityStatisticResponse {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 订单数量
   */
  orderCount?: number
  /**
   * 订单总优惠金额
   */
  orderDiscountAmt?: number
  /**
   * 活动规则
   */
  rule?: string
}

/**
 * 接口 [订单活动统计↗](https://yapi.gogpay.cn/project/906/interface/api/380676) 的 **请求配置的类型**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityStatistic`
 */
type ApiOrderImsApiOrderActivityStatisticRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/activityStatistic',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单活动统计↗](https://yapi.gogpay.cn/project/906/interface/api/380676) 的 **请求配置**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityStatistic`
 */
const apiOrderImsApiOrderActivityStatisticRequestConfig: ApiOrderImsApiOrderActivityStatisticRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/activityStatistic',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderActivityStatistic',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单活动统计', author: '333号开发' },
  }

/**
 * 接口 [订单活动统计↗](https://yapi.gogpay.cn/project/906/interface/api/380676) 的 **请求函数**
 *
 * @作者 333号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/activityStatistic`
 */
export const apiOrderImsApiOrderActivityStatistic = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderActivityStatisticRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderActivityStatisticResponse>(
    prepare(apiOrderImsApiOrderActivityStatisticRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderActivityStatistic.requestConfig =
  apiOrderImsApiOrderActivityStatisticRequestConfig

/**
 * 接口 [订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/427893) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderTabStatistics`
 */
export interface ApiOrderImsApiOrderOrderTabStatisticsRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/427893) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderTabStatistics`
 */
export interface ApiOrderImsApiOrderOrderTabStatisticsResponse {
  /**
   * 实际收款
   */
  actualReceivable?: number
  /**
   * 购买数量
   */
  buyCount?: number
  /**
   * 总优惠金额
   */
  discountAmount?: number
  /**
   * 订单笔数
   */
  orderCount?: number
}

/**
 * 接口 [订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/427893) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderTabStatistics`
 */
type ApiOrderImsApiOrderOrderTabStatisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/orderTabStatistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/427893) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderTabStatistics`
 */
const apiOrderImsApiOrderOrderTabStatisticsRequestConfig: ApiOrderImsApiOrderOrderTabStatisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/orderTabStatistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOrderTabStatistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单列表数量统计-标电', author: '511号开发' },
  }

/**
 * 接口 [订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/427893) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderTabStatistics`
 */
export const apiOrderImsApiOrderOrderTabStatistics = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOrderTabStatisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOrderTabStatisticsResponse>(
    prepare(apiOrderImsApiOrderOrderTabStatisticsRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOrderTabStatistics.requestConfig =
  apiOrderImsApiOrderOrderTabStatisticsRequestConfig

/**
 * 接口 [通过多彩宝订单号查询订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/447348) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderDetailByDcbOrderNo`
 */
export interface ApiOrderImsApiOrderOrderDetailByDcbOrderNoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 用户Id
   */
  userId: string
}

/**
 * 接口 [通过多彩宝订单号查询订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/447348) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderDetailByDcbOrderNo`
 */
export interface ApiOrderImsApiOrderOrderDetailByDcbOrderNoResponse {
  buyer?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 商品信息
   */
  commodities?: {
    /**
     * 售后状态文案
     */
    afterSale?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品合同报价名称
     */
    commodityContractTitle?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品来源
     */
    commodityResource?: string
    /**
     * 商品图片
     */
    comoodityPic?: string
    /**
     * SKU成本价
     */
    costPrice?: number
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 优惠活动名称
     */
    discountName?: string
    /**
     * 能效级别
     */
    efficiencyLevel?: number
    /**
     * 满减优惠规则
     */
    fullReductionDiscount?: string
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * 订单商品Id
     */
    id?: string
    /**
     * 实付积分
     */
    integral?: number
    /**
     * 所需积分
     */
    needIntegral?: number
    /**
     * 未发货数量
     */
    noShipQuantity?: number
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 价格
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款状态文案
     */
    refundStatusText?: string
    /**
     * 返现金额
     */
    returnAmount?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeText?: string
    /**
     * 销售渠道
     */
    sellChannelName?: string
    /**
     * 发货状态  0未发货  1已发货  2不可发货
     */
    shipStatus?: number
    /**
     * 订单商品69码
     */
    skuBarCode?: string
    /**
     * sku Id
     */
    skuId?: string
    /**
     * 规格信息
     */
    specs?: string
    /**
     * 税率编码
     */
    taxNo?: string
    /**
     * 税率
     */
    taxRate?: number
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  countDownConfig?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  dispatchInfo?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 发票图片
   */
  invoiceImgUrl?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户封面图
   */
  merchantPic?: string
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 校验资格接口地址
       */
      businessCheckUrl?: string
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 是否实名制购买：0-否 1-是
       */
      checkBuyFlag?: 0 | 1
      /**
       * 商品种类：0-套餐券 1-代金券 2-兑换券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品来源：0多彩宝 1跨境电商
       */
      commodityResource?: number
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      fullReductioActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 满减优惠金额
       */
      fullReductionActivityAmount?: number
      integralActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 供应商绑定商品ID
       */
      provideCommodityId?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 供应商 0=多彩宝 1=京东
       */
      provideSource?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 是否实名制购买：0-否 1-是
       */
      realNamePurchase?: '0' | '1'
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 第三方商品Id
       */
      thirdCommodityId?: string
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
        | '13'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 兑换商品类父级商品订单编号
     */
    parentCommodityOrderNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 实名制类型 0-自动回填 1-手动填写
     */
    realNameInputType: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 订单轨迹
   */
  orderTimeLine?: {
    /**
     * 轨迹内容
     */
    content?: string
    /**
     * 轨迹时间
     */
    time?: string
  }[]
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 支付信息
   */
  payInfo?: {
    /**
     * 支付金额
     */
    amount?: number
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 支付渠道
     */
    payChannel?: string
    /**
     * 支付内容
     */
    payContent?: string
    /**
     * 支付场景
     */
    payScenario?: string
    /**
     * 支付流水号
     */
    paySerialNo?: string
    /**
     * 支付状态
     */
    payStatus?: string
    /**
     * 支付时间
     */
    payTime?: string
  }[]
  pickupInfo?: {
    actualAddressDTO?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    addressDTO?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 人脸核验记录
     */
    authRealPicUrl?: string
    /**
     * 人脸核验时间
     */
    authTime?: string
    /**
     * 人脸token
     */
    authToken?: string
    /**
     * 自提码图片
     */
    commodityPicList?: string[]
    /**
     * 客户和商品图片
     */
    customerAndCommodityPicList?: string[]
    /**
     * 提货距离
     */
    distance?: string
    getSelfCodeForm?: {
      /**
       * 详细地址
       */
      addressDetails?: string
      /**
       * 市级区划
       */
      cityCode: string
      /**
       * 市级区划名
       */
      cityName: string
      distance?: string
      /**
       * 区县区划
       */
      districtCode: string
      /**
       * 区县区划名
       */
      districtName: string
      ip?: string
      /**
       * 纬度
       */
      latitude: string
      /**
       * 经度
       */
      longitude: string
      /**
       * 订单详情地址
       */
      orderDetailUrl?: string
      /**
       * 订单编号
       */
      orderNo: string
      /**
       * 省级区划
       */
      provinceCode: string
      /**
       * 省级区划名
       */
      provinceName: string
      /**
       * 券码
       */
      selfPickupCode?: string
    }
    /**
     * 订单取货图片
     */
    orderPickPicList?: string[]
    /**
     * 提货时间
     */
    pickupTime?: string
  }
  /**
   * 服务内容
   */
  serverContent?: {
    /**
     * 金额
     */
    amount?: number
    /**
     * 服务内容
     */
    content?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 添加人
     */
    creator?: string
    /**
     * 服务描述
     */
    desc?: string
    /**
     * 支付状态
     */
    payStatus?: string
  }[]
  /**
   * 门店编号
   */
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [通过多彩宝订单号查询订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/447348) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderDetailByDcbOrderNo`
 */
type ApiOrderImsApiOrderOrderDetailByDcbOrderNoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/orderDetailByDcbOrderNo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [通过多彩宝订单号查询订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/447348) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderDetailByDcbOrderNo`
 */
const apiOrderImsApiOrderOrderDetailByDcbOrderNoRequestConfig: ApiOrderImsApiOrderOrderDetailByDcbOrderNoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/orderDetailByDcbOrderNo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOrderDetailByDcbOrderNo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '通过多彩宝订单号查询订单详情', author: '511号开发' },
  }

/**
 * 接口 [通过多彩宝订单号查询订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/447348) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderDetailByDcbOrderNo`
 */
export const apiOrderImsApiOrderOrderDetailByDcbOrderNo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOrderDetailByDcbOrderNoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOrderDetailByDcbOrderNoResponse>(
    prepare(
      apiOrderImsApiOrderOrderDetailByDcbOrderNoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderOrderDetailByDcbOrderNo.requestConfig =
  apiOrderImsApiOrderOrderDetailByDcbOrderNoRequestConfig

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/447353) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/pay`
 */
export interface ApiOrderImsApiOrderPayRequest {
  /**
   * 微信用户Id
   */
  openId?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
}

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/447353) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/pay`
 */
export interface ApiOrderImsApiOrderPayResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  needRealNameAuth?: boolean
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/447353) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/pay`
 */
type ApiOrderImsApiOrderPayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/pay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/447353) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/pay`
 */
const apiOrderImsApiOrderPayRequestConfig: ApiOrderImsApiOrderPayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderPay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单支付', author: '511号开发' },
  }

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/447353) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/pay`
 */
export const apiOrderImsApiOrderPay = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderPayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderPayResponse>(
    prepare(apiOrderImsApiOrderPayRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderPay.requestConfig = apiOrderImsApiOrderPayRequestConfig

/**
 * 接口 [录入订单sn码↗](https://yapi.gogpay.cn/project/906/interface/api/449558) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderSnNumEnter`
 */
export interface ApiOrderImsApiOrderOrderSnNumEnterRequest {
  /**
   * imei1编码
   */
  imei1Code?: string
  /**
   * imei2编码
   */
  imei2Code?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单商品Sn码
   */
  orderSnNum?: string
}

/**
 * 接口 [录入订单sn码↗](https://yapi.gogpay.cn/project/906/interface/api/449558) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderSnNumEnter`
 */
export interface ApiOrderImsApiOrderOrderSnNumEnterResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [录入订单sn码↗](https://yapi.gogpay.cn/project/906/interface/api/449558) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderSnNumEnter`
 */
type ApiOrderImsApiOrderOrderSnNumEnterRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/orderSnNumEnter',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [录入订单sn码↗](https://yapi.gogpay.cn/project/906/interface/api/449558) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderSnNumEnter`
 */
const apiOrderImsApiOrderOrderSnNumEnterRequestConfig: ApiOrderImsApiOrderOrderSnNumEnterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/orderSnNumEnter',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOrderSnNumEnter',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '录入订单sn码', author: '511号开发' },
  }

/**
 * 接口 [录入订单sn码↗](https://yapi.gogpay.cn/project/906/interface/api/449558) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderSnNumEnter`
 */
export const apiOrderImsApiOrderOrderSnNumEnter = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOrderSnNumEnterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOrderSnNumEnterResponse>(
    prepare(apiOrderImsApiOrderOrderSnNumEnterRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOrderSnNumEnter.requestConfig =
  apiOrderImsApiOrderOrderSnNumEnterRequestConfig

/**
 * 接口 [确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/461213) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/confirmDelivery`
 */
export interface ApiOrderImsApiOrderConfirmDeliveryRequest {
  /**
   * 送达时间
   */
  logisticsEndTime: string
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/461213) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/confirmDelivery`
 */
export interface ApiOrderImsApiOrderConfirmDeliveryResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/461213) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/confirmDelivery`
 */
type ApiOrderImsApiOrderConfirmDeliveryRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/confirmDelivery',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/461213) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/confirmDelivery`
 */
const apiOrderImsApiOrderConfirmDeliveryRequestConfig: ApiOrderImsApiOrderConfirmDeliveryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/confirmDelivery',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderConfirmDelivery',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '确认送达', author: '503号开发' },
  }

/**
 * 接口 [确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/461213) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/confirmDelivery`
 */
export const apiOrderImsApiOrderConfirmDelivery = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderConfirmDeliveryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderConfirmDeliveryResponse>(
    prepare(apiOrderImsApiOrderConfirmDeliveryRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderConfirmDelivery.requestConfig =
  apiOrderImsApiOrderConfirmDeliveryRequestConfig

/**
 * 接口 [以旧换新订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465435) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeList`
 */
export interface ApiOrderImsApiOrderOldChangeListRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [以旧换新订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465435) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeList`
 */
export interface ApiOrderImsApiOrderOldChangeListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 促销金额
     */
    activityAmount?: number
    /**
     * 促销类型
     */
    activityType?: string
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 申报剩余时间
     */
    applySupDate?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    buyer?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    buyerAddress?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 渠道优惠
     */
    channelDiscount?: string
    /**
     * 渠道优惠金额
     */
    channelDiscountAmount?: number
    /**
     * 商品信息
     */
    commodities?: {
      /**
       * 售后状态文案
       */
      afterSale?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品合同报价名称
       */
      commodityContractTitle?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品来源
       */
      commodityResource?: string
      /**
       * 商品图片
       */
      comoodityPic?: string
      /**
       * SKU成本价
       */
      costPrice?: number
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 优惠活动名称
       */
      discountName?: string
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * 满减优惠规则
       */
      fullReductionDiscount?: string
      /**
       * 满减优惠金额
       */
      fullReductionDiscountAmount?: number
      /**
       * 订单商品Id
       */
      id?: string
      /**
       * 实付积分
       */
      integral?: number
      /**
       * 所需积分
       */
      needIntegral?: number
      /**
       * 未发货数量
       */
      noShipQuantity?: number
      /**
       * 订单商品Sn码
       */
      orderSnNum?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 退款状态文案
       */
      refundStatusText?: string
      /**
       * 返现金额
       */
      returnAmount?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeText?: string
      /**
       * 销售渠道
       */
      sellChannelName?: string
      /**
       * 发货状态  0未发货  1已发货  2不可发货
       */
      shipStatus?: number
      /**
       * 订单商品69码
       */
      skuBarCode?: string
      /**
       * sku Id
       */
      skuId?: string
      /**
       * 规格信息
       */
      specs?: string
      /**
       * 税率编码
       */
      taxNo?: string
      /**
       * 税率
       */
      taxRate?: number
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    /**
     * 多彩宝订单编号
     */
    dcbOrderNo?: string
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 优惠金额
     */
    discount?: number
    /**
     * 是否已评价 0未评价 1已评价
     */
    evaluateFlag?: number
    /**
     * 兑换商品名称
     */
    exchangeCommodityName?: string
    /**
     * 兑换商品订单编号
     */
    exchangeCommodityOrderNo?: string
    /**
     * 兑换商品类型
     */
    exchangeCommodityType?: number
    /**
     * 满减优惠规则
     */
    fullReductionDiscount?: string
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * imei1编码
     */
    imei1Code?: string
    /**
     * imei2编码
     */
    imei2Code?: string
    /**
     * 积分优惠金额
     */
    integralDiscountAmount?: number
    /**
     * 用户是否申请开票 0未申请 1已申请
     */
    invoiceApplyInfoStatus?: number
    /**
     * 是否开发票 0不开 1开
     */
    invoiceFlag?: number
    /**
     * 发票图片
     */
    invoiceImg?: string
    /**
     * 京东单号
     */
    jdOrderNo?: string
    /**
     * 订单营销类型
     */
    marketingType?: string
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 申报状态失败原因
     */
    orderApplyFailReason?: string
    /**
     * 申报状态 99待申报，00已申报，待审核，01审核通过，02审核不通过，03补贴已支付
     */
    orderApplyYardGoStatus?: string
    /**
     * 申报状态描述
     */
    orderApplyYardGoStatusDesc?: string
    /**
     * 订单中心支付单号
     */
    orderCenterPayNo?: string
    /**
     * 订单类型
     */
    orderClassification?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'
    /**
     * 订单日期
     */
    orderDate?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单同步状态0否 1是
     */
    orderPushStatus?: number
    /**
     * 重新申报复核失败原因
     */
    orderReApplyFailReason?: string
    /**
     * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
     */
    orderReApplyYardGoStatus?: string
    /**
     * 重新申报复核状态描述
     */
    orderReApplyYardGoStatusDesc?: string
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    orderTabStatisticsVO?: {
      /**
       * 实际收款
       */
      actualReceivable?: number
      /**
       * 购买数量
       */
      buyCount?: number
      /**
       * 总优惠金额
       */
      discountAmount?: number
      /**
       * 订单笔数
       */
      orderCount?: number
    }
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 订单类型
     */
    orderType?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 邮费免除状态 0不可免除 1可免除
     */
    postFeeFreeStatus?: number
    /**
     * 状态变更原因
     */
    reason?:
      | 'CREATE'
      | 'PAYED'
      | 'AUTO_CLOSE'
      | 'ADMIN_CLOSE'
      | 'USER_CLOSE'
      | 'SALE_AFTER_CLOSE'
      | 'PART_SHIP'
      | 'SHIP'
      | 'BATCH_SHIP'
      | 'BUSINESS_SHIP'
      | 'SALE_DONE_SHIP'
      | 'USER_CONFIRM'
      | 'AUTO_CONFIRM'
      | 'FINISH'
      | 'SALE_AFTER_FINISH'
      | 'INCENTIVE_FINISH'
      | 'WRITE_OFF'
      | 'REFUND'
      | 'TAKE'
      | 'CANCEL'
      | 'SYSTEM_TAKE'
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 订单售后状态 0未售后 1已售后
     */
    saleAfterStatus?: number
    /**
     * 结算状态
     */
    settlementStatus?: string
    /**
     * 是否可结算
     */
    settlementType?: string
    /**
     * 状态变更时间
     */
    statusChangeTime?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 交易状态 "0待支付
     * 100待发货
     * 101已发货
     *
     * 200待派单
     * 201已派单
     * 202待服务
     * 203服务中
     *
     * 900交易完成
     * 901交易关闭"
     */
    tradeStatus?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 商户机构编码
     */
    unitOrgCode?: string
    /**
     * 是否已催单  0未催单  1已催单
     */
    urgedFlag?: number
    /**
     * 订单所属用户Id
     */
    userId?: string
    /**
     * 订单核销状态 （派单核销）
     */
    verificationStatus?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [以旧换新订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465435) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeList`
 */
type ApiOrderImsApiOrderOldChangeListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/oldChangeList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [以旧换新订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465435) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeList`
 */
const apiOrderImsApiOrderOldChangeListRequestConfig: ApiOrderImsApiOrderOldChangeListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/oldChangeList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOldChangeList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '以旧换新订单列表', author: '511号开发' },
  }

/**
 * 接口 [以旧换新订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/465435) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeList`
 */
export const apiOrderImsApiOrderOldChangeList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOldChangeListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOldChangeListResponse>(
    prepare(apiOrderImsApiOrderOldChangeListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOldChangeList.requestConfig =
  apiOrderImsApiOrderOldChangeListRequestConfig

/**
 * 接口 [以旧换新订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/465498) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeOrderTabStatistics`
 */
export interface ApiOrderImsApiOrderOldChangeOrderTabStatisticsRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [以旧换新订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/465498) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeOrderTabStatistics`
 */
export interface ApiOrderImsApiOrderOldChangeOrderTabStatisticsResponse {
  /**
   * 实际收款
   */
  actualReceivable?: number
  /**
   * 购买数量
   */
  buyCount?: number
  /**
   * 总优惠金额
   */
  discountAmount?: number
  /**
   * 订单笔数
   */
  orderCount?: number
}

/**
 * 接口 [以旧换新订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/465498) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeOrderTabStatistics`
 */
type ApiOrderImsApiOrderOldChangeOrderTabStatisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/oldChangeOrderTabStatistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [以旧换新订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/465498) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeOrderTabStatistics`
 */
const apiOrderImsApiOrderOldChangeOrderTabStatisticsRequestConfig: ApiOrderImsApiOrderOldChangeOrderTabStatisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/oldChangeOrderTabStatistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOldChangeOrderTabStatistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '以旧换新订单列表数量统计-标电', author: '511号开发' },
  }

/**
 * 接口 [以旧换新订单列表数量统计-标电↗](https://yapi.gogpay.cn/project/906/interface/api/465498) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeOrderTabStatistics`
 */
export const apiOrderImsApiOrderOldChangeOrderTabStatistics = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOldChangeOrderTabStatisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOldChangeOrderTabStatisticsResponse>(
    prepare(
      apiOrderImsApiOrderOldChangeOrderTabStatisticsRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderOldChangeOrderTabStatistics.requestConfig =
  apiOrderImsApiOrderOldChangeOrderTabStatisticsRequestConfig

/**
 * 接口 [以旧换新导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/465554) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeExportOrder`
 */
export interface ApiOrderImsApiOrderOldChangeExportOrderRequest {
  /**
   * 活动ID
   */
  activityId?: string
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 下单起始时间
   */
  beginTIme?: string
  /**
   * 运营渠道Id
   */
  businessChannelId?: string[]
  /**
   * 商品类目Id
   */
  categoryId?: string
  /**
   * 商品类目Id列表
   */
  categoryIds?: string[]
  /**
   * 渠道优惠 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  channelDiscount?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 商品合同报价名称
   */
  commodityContractTitle?: string
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品订单编号（2.0新增）
   */
  commodityOrderNo?: string
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 收货人手机号
   */
  consigneePhone?: string
  /**
   * 多彩宝订单编号
   */
  dcbOrderNo?: string
  /**
   * 订单促销类型 1秒杀 2盲盒 3黔贝 4折扣
   */
  discountSaleType?: (
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  )[]
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 评价状态 0未评价 1已评价
   */
  evaluateStatus?: number[]
  /**
   * 用户是否申请开票0否 1是
   */
  invoiceApplyInfoStatus?: number
  /**
   * 订单营销类型 1满减订单
   */
  marketingType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 商户Id(所属店铺)
   */
  merchantId?: string[]
  /**
   * 订单分类 1标准电商  2派送核销  3标准虚拟订单
   */
  orderCategory: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /**
   * 活动优惠类型：10-满减优惠 11-积分优惠
   */
  orderDiscountType?:
    | 'UN_KNOW'
    | 'COUPON'
    | 'CHANNEL'
    | 'MARKETING'
    | 'SENCOND_KILL'
    | 'BLIND_BOX'
    | 'DISCOUNT'
    | 'GROUP'
    | 'JOINT'
    | 'CHANNEL_INTEGRAL'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单编号列表匹配模式 0:in匹配 1:not in匹配
   */
  orderNoMatchMode?: number
  /**
   * 重新申报复核状态 复核状态 00-未重新提交 01-复核通过 02-复核不通过 03-补贴已支付 04-待复核
   */
  orderReApplyYardGoStatus?: string
  /**
   * 订单类型 1普通订单  2促销订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单编号
   */
  parentOrderNo?: string
  /**
   * 支付类型 1支付宝  2农行 3农行银联  4微信支付  5银联 6银联H5 7云闪付
   */
  payType?: (
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  )[]
  /**
   * 手机号码
   */
  phoneNo?: string
  /**
   * 退款状态 1退款中 2退款成功
   */
  refundStatus?: number[]
  /**
   * 活动规则
   */
  rule?: string
  /**
   * 售后状态 1：待商家同意售后申请；2：商家不同意售后申请；3：商家同意仅退款申请，待买家寄回货物；4：商家同意退货退款申请，待买家寄回货物；
   *      * 5：商家同意换货申请，待买家寄回货物
   *      * 6：买家已退货，待商家确认收货；7：商家验收不通过拒绝收货，待买家处理；8：待商家发出换货；9：售后关闭；10：售后完成
   */
  saleAfterStatus?: 99 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  /**
   * 售后类型 1：仅退款；2：退货退款；3：退换货
   */
  saleAfterType?: 1 | 2 | 3
  /**
   * 销售渠道ID
   */
  sellChannelId?: string
  /**
   * 可结算类型 0不可结算 1可结算 3已结算
   */
  settlementType?: 0 | 1 | 2 | 3 | 4 | 5
  /**
   * 规格Id
   */
  skuId?: string
  /**
   * 状态变更开始时间
   */
  statusBeginTime?: string
  /**
   * 状态变更结束时间
   */
  statusEndTime?: string
  /**
   * 订单交易状态 "0待支付
   * 100待发货
   * 101已发货
   *
   * 200待派单
   * 201已派单
   * 202待服务
   * 203服务中
   *
   * 900交易完成
   * 901交易关闭"
   */
  tradeStatus?:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
  /**
   * 机构编码列表
   */
  unitOrgCode?: string[]
  /**
   * 催单状态 0未催单 1已催单
   */
  urgedStatus?: number[]
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 核销状态 2后台核销 3用户自主核销
   */
  verificationStatus?: 0 | 1 | 2
}

/**
 * 接口 [以旧换新导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/465554) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeExportOrder`
 */
export interface ApiOrderImsApiOrderOldChangeExportOrderResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [以旧换新导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/465554) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeExportOrder`
 */
type ApiOrderImsApiOrderOldChangeExportOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/oldChangeExportOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [以旧换新导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/465554) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeExportOrder`
 */
const apiOrderImsApiOrderOldChangeExportOrderRequestConfig: ApiOrderImsApiOrderOldChangeExportOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/oldChangeExportOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOldChangeExportOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '以旧换新导出订单', author: '511号开发' },
  }

/**
 * 接口 [以旧换新导出订单↗](https://yapi.gogpay.cn/project/906/interface/api/465554) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/oldChangeExportOrder`
 */
export const apiOrderImsApiOrderOldChangeExportOrder = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOldChangeExportOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOldChangeExportOrderResponse>(
    prepare(apiOrderImsApiOrderOldChangeExportOrderRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOldChangeExportOrder.requestConfig =
  apiOrderImsApiOrderOldChangeExportOrderRequestConfig

/**
 * 接口 [开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/466331) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutInvoiceV2`
 */
export interface ApiOrderImsApiOrderMakeOutInvoiceV2Request {
  /**
   * 重复开票后缀
   */
  bisSuffix?: string
  /**
   * 分类Id匹配项
   */
  categoryId: string
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/466331) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutInvoiceV2`
 */
export interface ApiOrderImsApiOrderMakeOutInvoiceV2Response {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/466331) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutInvoiceV2`
 */
type ApiOrderImsApiOrderMakeOutInvoiceV2RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/makeOutInvoiceV2',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/466331) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutInvoiceV2`
 */
const apiOrderImsApiOrderMakeOutInvoiceV2RequestConfig: ApiOrderImsApiOrderMakeOutInvoiceV2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/makeOutInvoiceV2',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderMakeOutInvoiceV2',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开具发票-后管', author: '511号开发' },
  }

/**
 * 接口 [开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/466331) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutInvoiceV2`
 */
export const apiOrderImsApiOrderMakeOutInvoiceV2 = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderMakeOutInvoiceV2Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderMakeOutInvoiceV2Response>(
    prepare(apiOrderImsApiOrderMakeOutInvoiceV2RequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderMakeOutInvoiceV2.requestConfig =
  apiOrderImsApiOrderMakeOutInvoiceV2RequestConfig

/**
 * 接口 [线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/476299) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineDetail`
 */
export interface ApiOrderImsApiOrderOffLineDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/476299) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineDetail`
 */
export interface ApiOrderImsApiOrderOffLineDetailResponse {
  /**
   * 促销金额
   */
  activityAmount?: number
  /**
   * 优惠出资方
   */
  activitySaleMoneyGiver?: string
  /**
   * 促销类型
   */
  activityType?: string
  /**
   * 实收款
   */
  actualReceivable?: number
  /**
   * 送达操作人纬度
   */
  arriveLatitude?: string
  /**
   * 送达操作人经度
   */
  arriveLongitude?: string
  /**
   * 送达人
   */
  arriveName?: string
  /**
   * 送达时间
   */
  arriveTime?: string
  /**
   * 送达操作用户Id
   */
  arriveUserId?: string
  /**
   * 货物69码图片
   */
  barCodePicList?: string[]
  buyer?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 商品信息
   */
  commodities?: {
    /**
     * 售后状态文案
     */
    afterSale?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品合同报价名称
     */
    commodityContractTitle?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品来源
     */
    commodityResource?: string
    /**
     * 商品图片
     */
    comoodityPic?: string
    /**
     * SKU成本价
     */
    costPrice?: number
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 优惠活动名称
     */
    discountName?: string
    /**
     * 能效级别
     */
    efficiencyLevel?: number
    /**
     * 满减优惠规则
     */
    fullReductionDiscount?: string
    /**
     * 满减优惠金额
     */
    fullReductionDiscountAmount?: number
    /**
     * 订单商品Id
     */
    id?: string
    /**
     * 实付积分
     */
    integral?: number
    /**
     * 所需积分
     */
    needIntegral?: number
    /**
     * 未发货数量
     */
    noShipQuantity?: number
    /**
     * 订单商品Sn码
     */
    orderSnNum?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 价格
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 退款状态文案
     */
    refundStatusText?: string
    /**
     * 返现金额
     */
    returnAmount?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeText?: string
    /**
     * 销售渠道
     */
    sellChannelName?: string
    /**
     * 发货状态  0未发货  1已发货  2不可发货
     */
    shipStatus?: number
    /**
     * 订单商品69码
     */
    skuBarCode?: string
    /**
     * sku Id
     */
    skuId?: string
    /**
     * 规格信息
     */
    specs?: string
    /**
     * 税率编码
     */
    taxNo?: string
    /**
     * 税率
     */
    taxRate?: number
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  /**
   * 货物图片
   */
  commodityPicList?: string[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  /**
   * 发货人姓名
   */
  deliverName?: string
  /**
   * 发货时间
   */
  deliverTime?: string
  /**
   * 发货人Id
   */
  deliverUserId?: string
  /**
   * 优惠金额
   */
  discount?: number
  dispatchInfo?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 货物拆封图片
   */
  goodsUnsealingPicList?: string[]
  /**
   * 配送方式值 1现场提货 3配送发货
   */
  logisticsMethodValue?: number
  /**
   * 订单状态
   */
  mallOrderStatus?: number
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 订单日期
   */
  orderDate?: string
  /**
   * 订单编号
   */
  orderNo?: string
  orderStatus?: number
  /**
   * 订单状态描述
   */
  orderStatusLabel?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 出库单
   */
  outboundOrders?: string[]
  /**
   * 支付状态 1未支付 2已支付
   */
  payStatus?: number
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 订单总价
   */
  totalPrice?: number
  /**
   * 交易状态文案描述
   */
  tradeStatusName?: string
  /**
   * 订单所属用户Id
   */
  userId?: string
}

/**
 * 接口 [线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/476299) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineDetail`
 */
type ApiOrderImsApiOrderOffLineDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/offLineDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/476299) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineDetail`
 */
const apiOrderImsApiOrderOffLineDetailRequestConfig: ApiOrderImsApiOrderOffLineDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/offLineDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOffLineDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '线下订单详情', author: '511号开发' },
  }

/**
 * 接口 [线下订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/476299) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineDetail`
 */
export const apiOrderImsApiOrderOffLineDetail = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOffLineDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOffLineDetailResponse>(
    prepare(apiOrderImsApiOrderOffLineDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOffLineDetail.requestConfig =
  apiOrderImsApiOrderOffLineDetailRequestConfig

/**
 * 接口 [线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/476306) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineList`
 */
export interface ApiOrderImsApiOrderOffLineListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 提交时间-结束时间
   */
  endTime?: string
  /**
   * 机构名称/编码
   */
  orgCode?: string
  /**
   * 结算方式 00-见证宝   01-NC
   */
  orgTradeType?: 'ONLINE' | 'NC'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 提交时间-开始时间
   */
  startTime?: string
  /**
   * 记录状态
   */
  status?: number
}

/**
 * 接口 [线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/476306) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineList`
 */
export interface ApiOrderImsApiOrderOffLineListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 促销金额
     */
    activityAmount?: number
    /**
     * 优惠出资方
     */
    activitySaleMoneyGiver?: string
    /**
     * 促销类型
     */
    activityType?: string
    /**
     * 实收款
     */
    actualReceivable?: number
    /**
     * 送达操作人纬度
     */
    arriveLatitude?: string
    /**
     * 送达操作人经度
     */
    arriveLongitude?: string
    /**
     * 送达人
     */
    arriveName?: string
    /**
     * 送达时间
     */
    arriveTime?: string
    /**
     * 送达操作用户Id
     */
    arriveUserId?: string
    /**
     * 货物69码图片
     */
    barCodePicList?: string[]
    buyer?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 商品信息
     */
    commodities?: {
      /**
       * 售后状态文案
       */
      afterSale?: string
      /**
       * 类目ID
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品合同报价名称
       */
      commodityContractTitle?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品来源
       */
      commodityResource?: string
      /**
       * 商品图片
       */
      comoodityPic?: string
      /**
       * SKU成本价
       */
      costPrice?: number
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 优惠活动名称
       */
      discountName?: string
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * 满减优惠规则
       */
      fullReductionDiscount?: string
      /**
       * 满减优惠金额
       */
      fullReductionDiscountAmount?: number
      /**
       * 订单商品Id
       */
      id?: string
      /**
       * 实付积分
       */
      integral?: number
      /**
       * 所需积分
       */
      needIntegral?: number
      /**
       * 未发货数量
       */
      noShipQuantity?: number
      /**
       * 订单商品Sn码
       */
      orderSnNum?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 退款状态文案
       */
      refundStatusText?: string
      /**
       * 返现金额
       */
      returnAmount?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeText?: string
      /**
       * 销售渠道
       */
      sellChannelName?: string
      /**
       * 发货状态  0未发货  1已发货  2不可发货
       */
      shipStatus?: number
      /**
       * 订单商品69码
       */
      skuBarCode?: string
      /**
       * sku Id
       */
      skuId?: string
      /**
       * 规格信息
       */
      specs?: string
      /**
       * 税率编码
       */
      taxNo?: string
      /**
       * 税率
       */
      taxRate?: number
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    /**
     * 货物图片
     */
    commodityPicList?: string[]
    consigneeInfo?: {
      /**
       * 收件地址-详细地址
       */
      address?: string
      /**
       * 收件地址-地区
       */
      area?: string
      /**
       * 收件地址-城市
       */
      city?: string
      /**
       * 收件人
       */
      name?: string
      /**
       * 包裹数量，如果为0则是未发货
       */
      packageQuantity?: number
      /**
       * 包裹发送类型 0未发货 1整包发货 2拆包发货
       */
      packageType?: number
      /**
       * 收件地址-省份
       */
      province?: string
      /**
       * 收件人手机号
       */
      tel?: string
    }
    /**
     * 发货人姓名
     */
    deliverName?: string
    /**
     * 发货时间
     */
    deliverTime?: string
    /**
     * 发货人Id
     */
    deliverUserId?: string
    /**
     * 优惠金额
     */
    discount?: number
    dispatchInfo?: {
      /**
       * 服务人员Id
       */
      serviceUserId?: string
      /**
       * 服务人员姓名
       */
      serviceUserName?: string
      /**
       * 服务人员手机号
       */
      serviceUserTel?: string
      /**
       * 自定义配送文案
       */
      tips?: string
    }
    /**
     * 货物拆封图片
     */
    goodsUnsealingPicList?: string[]
    /**
     * 配送方式值 1现场提货 3配送发货
     */
    logisticsMethodValue?: number
    /**
     * 订单状态
     */
    mallOrderStatus?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 订单日期
     */
    orderDate?: string
    /**
     * 订单编号
     */
    orderNo?: string
    orderStatus?: number
    /**
     * 订单状态描述
     */
    orderStatusLabel?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 出库单
     */
    outboundOrders?: string[]
    /**
     * 支付状态 1未支付 2已支付
     */
    payStatus?: number
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 订单总价
     */
    totalPrice?: number
    /**
     * 交易状态文案描述
     */
    tradeStatusName?: string
    /**
     * 订单所属用户Id
     */
    userId?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/476306) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineList`
 */
type ApiOrderImsApiOrderOffLineListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/offLineList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/476306) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineList`
 */
const apiOrderImsApiOrderOffLineListRequestConfig: ApiOrderImsApiOrderOffLineListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/offLineList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOffLineList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '线下订单列表', author: '511号开发' },
  }

/**
 * 接口 [线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/476306) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/offLineList`
 */
export const apiOrderImsApiOrderOffLineList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOffLineListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOffLineListResponse>(
    prepare(apiOrderImsApiOrderOffLineListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOffLineList.requestConfig =
  apiOrderImsApiOrderOffLineListRequestConfig

/**
 * 接口 [查询用户该优惠下是否有未支付订单↗](https://yapi.gogpay.cn/project/906/interface/api/483929) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkOrderPayStatus`
 */
export interface ApiOrderImsApiOrderCheckOrderPayStatusRequest {
  couponActivityId?: string
  userId?: string
}

/**
 * 接口 [查询用户该优惠下是否有未支付订单↗](https://yapi.gogpay.cn/project/906/interface/api/483929) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkOrderPayStatus`
 */
export type ApiOrderImsApiOrderCheckOrderPayStatusResponse = boolean

/**
 * 接口 [查询用户该优惠下是否有未支付订单↗](https://yapi.gogpay.cn/project/906/interface/api/483929) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkOrderPayStatus`
 */
type ApiOrderImsApiOrderCheckOrderPayStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/checkOrderPayStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户该优惠下是否有未支付订单↗](https://yapi.gogpay.cn/project/906/interface/api/483929) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkOrderPayStatus`
 */
const apiOrderImsApiOrderCheckOrderPayStatusRequestConfig: ApiOrderImsApiOrderCheckOrderPayStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/checkOrderPayStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderCheckOrderPayStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户该优惠下是否有未支付订单', author: '成龙' },
  }

/**
 * 接口 [查询用户该优惠下是否有未支付订单↗](https://yapi.gogpay.cn/project/906/interface/api/483929) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkOrderPayStatus`
 */
export const apiOrderImsApiOrderCheckOrderPayStatus = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderCheckOrderPayStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderCheckOrderPayStatusResponse>(
    prepare(apiOrderImsApiOrderCheckOrderPayStatusRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderCheckOrderPayStatus.requestConfig =
  apiOrderImsApiOrderCheckOrderPayStatusRequestConfig

/**
 * 接口 [查询优惠订单是否存在已支付记录↗](https://yapi.gogpay.cn/project/906/interface/api/483936) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkParentOrderPayStatus`
 */
export interface ApiOrderImsApiOrderCheckParentOrderPayStatusRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [查询优惠订单是否存在已支付记录↗](https://yapi.gogpay.cn/project/906/interface/api/483936) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkParentOrderPayStatus`
 */
export type ApiOrderImsApiOrderCheckParentOrderPayStatusResponse = boolean

/**
 * 接口 [查询优惠订单是否存在已支付记录↗](https://yapi.gogpay.cn/project/906/interface/api/483936) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkParentOrderPayStatus`
 */
type ApiOrderImsApiOrderCheckParentOrderPayStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/checkParentOrderPayStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询优惠订单是否存在已支付记录↗](https://yapi.gogpay.cn/project/906/interface/api/483936) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkParentOrderPayStatus`
 */
const apiOrderImsApiOrderCheckParentOrderPayStatusRequestConfig: ApiOrderImsApiOrderCheckParentOrderPayStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/checkParentOrderPayStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderCheckParentOrderPayStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询优惠订单是否存在已支付记录', author: '成龙' },
  }

/**
 * 接口 [查询优惠订单是否存在已支付记录↗](https://yapi.gogpay.cn/project/906/interface/api/483936) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/checkParentOrderPayStatus`
 */
export const apiOrderImsApiOrderCheckParentOrderPayStatus = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderCheckParentOrderPayStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderCheckParentOrderPayStatusResponse>(
    prepare(
      apiOrderImsApiOrderCheckParentOrderPayStatusRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderCheckParentOrderPayStatus.requestConfig =
  apiOrderImsApiOrderCheckParentOrderPayStatusRequestConfig

/**
 * 接口 [导出线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/483943) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportOffLineList`
 */
export interface ApiOrderImsApiOrderExportOffLineListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 提交时间-结束时间
   */
  endTime?: string
  /**
   * 机构名称/编码
   */
  orgCode?: string
  /**
   * 结算方式 00-见证宝   01-NC
   */
  orgTradeType?: 'ONLINE' | 'NC'
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 提交时间-开始时间
   */
  startTime?: string
  /**
   * 记录状态
   */
  status?: number
}

/**
 * 接口 [导出线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/483943) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportOffLineList`
 */
export interface ApiOrderImsApiOrderExportOffLineListResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 文件密码
   */
  password?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/483943) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportOffLineList`
 */
type ApiOrderImsApiOrderExportOffLineListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/exportOffLineList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/483943) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportOffLineList`
 */
const apiOrderImsApiOrderExportOffLineListRequestConfig: ApiOrderImsApiOrderExportOffLineListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/exportOffLineList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderExportOffLineList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出线下订单列表', author: '成龙' },
  }

/**
 * 接口 [导出线下订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/483943) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/exportOffLineList`
 */
export const apiOrderImsApiOrderExportOffLineList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderExportOffLineListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderExportOffLineListResponse>(
    prepare(apiOrderImsApiOrderExportOffLineListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderExportOffLineList.requestConfig =
  apiOrderImsApiOrderExportOffLineListRequestConfig

/**
 * 接口 [已冲红重复开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/489130) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutV2ByBis`
 */
export interface ApiOrderImsApiOrderMakeOutV2ByBisRequest {
  /**
   * 重复开票后缀
   */
  bisSuffix?: string
  /**
   * 分类Id匹配项
   */
  categoryId: string
  /**
   * 订单编号
   */
  orderNos: string[]
}

/**
 * 接口 [已冲红重复开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/489130) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutV2ByBis`
 */
export type ApiOrderImsApiOrderMakeOutV2ByBisResponse = {}[]

/**
 * 接口 [已冲红重复开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/489130) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutV2ByBis`
 */
type ApiOrderImsApiOrderMakeOutV2ByBisRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/makeOutV2ByBis',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [已冲红重复开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/489130) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutV2ByBis`
 */
const apiOrderImsApiOrderMakeOutV2ByBisRequestConfig: ApiOrderImsApiOrderMakeOutV2ByBisRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/makeOutV2ByBis',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderMakeOutV2ByBis',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '已冲红重复开具发票-后管', author: '511号开发' },
  }

/**
 * 接口 [已冲红重复开具发票-后管↗](https://yapi.gogpay.cn/project/906/interface/api/489130) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/makeOutV2ByBis`
 */
export const apiOrderImsApiOrderMakeOutV2ByBis = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderMakeOutV2ByBisRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderMakeOutV2ByBisResponse>(
    prepare(apiOrderImsApiOrderMakeOutV2ByBisRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderMakeOutV2ByBis.requestConfig =
  apiOrderImsApiOrderMakeOutV2ByBisRequestConfig

/**
 * 接口 [修改发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/491195) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/updateInvoiceInfo`
 */
export interface ApiOrderImsApiOrderUpdateInvoiceInfoRequest {
  /**
   * 发票号码
   */
  invoiceNo: string
  /**
   * 开票日期
   */
  issueDate: string
  /**
   * 订单号
   */
  orderNo: string
}

/**
 * 接口 [修改发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/491195) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/updateInvoiceInfo`
 */
export interface ApiOrderImsApiOrderUpdateInvoiceInfoResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/491195) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/updateInvoiceInfo`
 */
type ApiOrderImsApiOrderUpdateInvoiceInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/updateInvoiceInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/491195) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/updateInvoiceInfo`
 */
const apiOrderImsApiOrderUpdateInvoiceInfoRequestConfig: ApiOrderImsApiOrderUpdateInvoiceInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/updateInvoiceInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderUpdateInvoiceInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改发票信息', author: '511号开发' },
  }

/**
 * 接口 [修改发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/491195) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/updateInvoiceInfo`
 */
export const apiOrderImsApiOrderUpdateInvoiceInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderUpdateInvoiceInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderUpdateInvoiceInfoResponse>(
    prepare(apiOrderImsApiOrderUpdateInvoiceInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderUpdateInvoiceInfo.requestConfig =
  apiOrderImsApiOrderUpdateInvoiceInfoRequestConfig

/**
 * 接口 [录入订单Imei码↗](https://yapi.gogpay.cn/project/906/interface/api/493288) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderImeiCodeEnter`
 */
export interface ApiOrderImsApiOrderOrderImeiCodeEnterRequest {
  /**
   * imei1编码
   */
  imei1Code?: string
  /**
   * imei2编码
   */
  imei2Code?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单商品Sn码
   */
  orderSnNum?: string
}

/**
 * 接口 [录入订单Imei码↗](https://yapi.gogpay.cn/project/906/interface/api/493288) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderImeiCodeEnter`
 */
export interface ApiOrderImsApiOrderOrderImeiCodeEnterResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [录入订单Imei码↗](https://yapi.gogpay.cn/project/906/interface/api/493288) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderImeiCodeEnter`
 */
type ApiOrderImsApiOrderOrderImeiCodeEnterRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/order/orderImeiCodeEnter',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [录入订单Imei码↗](https://yapi.gogpay.cn/project/906/interface/api/493288) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderImeiCodeEnter`
 */
const apiOrderImsApiOrderOrderImeiCodeEnterRequestConfig: ApiOrderImsApiOrderOrderImeiCodeEnterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_18,
    devUrl: devUrl_0_5_0_18,
    prodUrl: prodUrl_0_5_0_18,
    path: '/order/imsApi/order/orderImeiCodeEnter',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderOrderImeiCodeEnter',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '录入订单Imei码', author: '511号开发' },
  }

/**
 * 接口 [录入订单Imei码↗](https://yapi.gogpay.cn/project/906/interface/api/493288) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_6907)
 * @请求头 `POST /order/imsApi/order/orderImeiCodeEnter`
 */
export const apiOrderImsApiOrderOrderImeiCodeEnter = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderOrderImeiCodeEnterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderOrderImeiCodeEnterResponse>(
    prepare(apiOrderImsApiOrderOrderImeiCodeEnterRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderOrderImeiCodeEnter.requestConfig =
  apiOrderImsApiOrderOrderImeiCodeEnterRequestConfig

const mockUrl_0_5_0_19 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_19 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_19 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_19 = 'data' as any

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/28485) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/detail`
 */
export interface ApiOrderOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/28485) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/detail`
 */
export interface ApiOrderOrderDetailResponse {
  /**
   * 抵扣积分数量
   */
  channelDiscountAmount?: string
  /**
   * 子订单列表
   */
  childOrderList?: unknown[]
  /**
   * 关闭时间
   */
  closeTime?: string
  /**
   * 订单商品列表
   */
  commodities?: {
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品类目参数
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    name?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 总价
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterName?: string
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeName?: string
    /**
     * 发货状态 0未发货 1已发货
     */
    shipStatus?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * SKU规格信息
     */
    skuSpecs?: string
    /**
     * 标签
     */
    tags?: string[]
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  countDownTime?: {
    /**
     * 自动取消订单时效（毫秒)
     */
    cancelOrderCountDown?: number
    /**
     * 关闭订单时效（毫秒）
     */
    closeCountDown?: number
    /**
     * 自动确认收货时效（毫秒）
     */
    confirmCountDown?: number
    /**
     * 发货（派单）倒计时（毫秒）
     */
    shippingCountDown?: number
  }
  /**
   * 成交时间
   */
  dealTime?: string
  /**
   * 延长收货天数
   */
  delayDays?: number
  /**
   * 延长收货状态 -1不支持延迟收货 0未延长 1已延长
   */
  delayStatus?: number
  /**
   * 配送日期
   */
  deliverDate?: string
  deliverUser?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 评价状态 0未评价 1已评价 2已追评 3审核中
   */
  evaluationStatus?: number
  /**
   * 兑换时间
   */
  exchangeTime?: string
  /**
   * 订单扩展数据
   */
  extendData?: {
    /**
     * 扩展字段的key，业务系统可自由定制
     */
    key?: string
    /**
     * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
     */
    name?: string
    /**
     * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
     */
    sort?: number
    /**
     * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
     */
    type?: string
    /**
     * 扩展字段的值，内容可自由定制。如100、302等
     */
    value?: string
  }[]
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 积分活动积分
   */
  integral?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 发票申请是否禁止填写
   */
  invoiceIsNoWrite?: boolean
  /**
   * 用户发票状态 0未选择开具发票  1未开票 2已开票
   */
  invoiceStatus?: number
  lastExpressTrace?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }
  /**
   * 是否需要人脸认证
   */
  liveCheckFlag?: boolean
  /**
   * 物流达到时间
   */
  logisticsEndTime?: string
  logisticsInfo?: {
    /**
     * 物流信息
     */
    packageInfos?: {
      /**
       * 送达操作人纬度
       */
      arriveLatitude?: string
      /**
       * 送达操作人经度
       */
      arriveLongitude?: string
      /**
       * 货物69码图片
       */
      barCodePicList?: string[]
      /**
       * 发货时间
       */
      beginTime?: string
      /**
       * 货物图片
       */
      commodityPicList?: string[]
      /**
       * 物流公司
       */
      companyName?: string
      /**
       * 客户和商品图片
       */
      customerAndCommodityPicList?: string[]
      /**
       * 到达时间
       */
      endTime?: string
      /**
       * 货物拆封图片
       */
      goodsUnsealingPicList?: string[]
      /**
       * 物流公司编号
       */
      logisticsCompanyNo?: string
      merchantCourier?: {
        /**
         * 配送员名称
         */
        courierName?: string
        /**
         * 配送员手机号
         */
        courierPhone?: string
        /**
         * 创建人
         */
        createBy?: string
        /**
         * 创建时间
         */
        createTime?: string
        /**
         * 是否默认配送员
         */
        defaultFlag?: boolean
        /**
         * 主键ID
         */
        id?: string
        /**
         * 商户ID
         */
        merchantId?: string
        /**
         * 备注
         */
        remark?: string
        /**
         * 子机构号
         */
        unitOrgCode?: string
        /**
         * 修改人
         */
        updateBy?: string
        /**
         * 修改时间
         */
        updateTime?: string
      }
      /**
       * 配送员ID
       */
      merchantCourierId?: string
      /**
       * 物流订单编号
       */
      orderNo?: string
      /**
       * 提货订单图片
       */
      orderPickPicList?: string[]
      /**
       * 出库单
       */
      outboundOrders?: string[]
      /**
       * 包裹Id
       */
      packageId?: string
      /**
       * 发货地址
       */
      receiveAddress?: string
      /**
       * 备注
       */
      remark?: string
      /**
       * 发货方式
       */
      sendType?: string
      /**
       * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
       */
      sendTypeValue?: number
      /**
       * 签收单
       */
      signaturePicList?: string[]
      /**
       * 运单号
       */
      waybillNo?: string
    }[]
    receiver?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
  }
  /**
   * 配送方式
   */
  logisticsMethod?: string
  /**
   * 配送方式值 1普通快递/现场自提 2同城自提 3商户自配送
   */
  logisticsMethodValue?: number
  merchantCourier?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 发货是否需要填写sn码 0否 1是
   */
  needSnNum?: number
  /**
   * 是否需要上传签收单0否 1是
   */
  needUploadSignature?: number
  /**
   * 订单活动促销类型
   */
  orderActivityType?:
    | 'NONE'
    | 'SECKILL'
    | 'BLIND_BOX'
    | 'POINT'
    | 'DISCOUNT'
    | 'GROUP'
    | 'FULL_REDUCTION'
    | 'INTEGRAL'
    | 'EXCHANGE_COUPON'
    | 'INTEGRAL_JOIN'
    | 'LOVE_DRAW'
    | 'MARKETING_BOX'
  /**
   * 订单金额
   */
  orderAmount?: number
  /**
   * 订单中心支付单号
   */
  orderCenterPayNo?: string
  /**
   * 订单分类；1=标准电商，2=标准核销，3=标准虚拟，4=核销支付，5=组合标销售，6=旅游订单，7=组合电商
   */
  orderClassify?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  orderNo?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 原始订单号，该字段为空代表为父单，不为空则为子单
   */
  originalOrderNo?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 是否为父订单
   */
  parentOrderFlag?: boolean
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 需支付金额
   */
  payAmount?: string
  /**
   * 支付编号
   */
  paySerialNo?: string
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 支付方式
   */
  payType?: string
  /**
   * 支付方式
   */
  payTypeStatus?: number
  /**
   * 运费
   */
  postFee?: number
  /**
   * 订单操作是否只读
   */
  readonly?: boolean
  /**
   * 订单备注
   */
  remark?: string
  /**
   * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
   */
  saleAfterStatus?: number
  /**
   * 售后状态文案
   */
  saleAfterStatusLabel?: string
  selfAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 发货时间
   */
  shipTime?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 发货类型 0待发货 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  shippingType?: number
  /**
   * 订单状态 0待支付
   * 100待发货
   * 101已发货
   *
   * 400待接单
   * 401待配送
   * 402配送中
   *
   * 900交易完成
   * 901交易关闭"902交易完结
   */
  status?: number
  /**
   * 订单状态文案
   */
  statusName?: string
  /**
   * 订单状态变更
   */
  statusReason?: string
  /**
   * 接单时间
   */
  takeTime?: string
  /**
   * 订单提示信息
   */
  tips?: string
  /**
   * 催单状态 -1不支持催单 0未催单 1已催单
   */
  urgedStatus?: number
  /**
   * 用户实名信息
   */
  userAuthName?: string
}

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/28485) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/detail`
 */
type ApiOrderOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/28485) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/detail`
 */
const apiOrderOrderDetailRequestConfig: ApiOrderOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单详情', author: '成龙' },
  }

/**
 * 接口 [订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/28485) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/detail`
 */
export const apiOrderOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderDetailResponse>(
    prepare(apiOrderOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderDetail.requestConfig = apiOrderOrderDetailRequestConfig

/**
 * 接口 [客户端订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/28489) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/list`
 */
export interface ApiOrderOrderListRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中
   */
  status?: number
  /**
   * 下单手机号
   */
  userPhone?: string
}

/**
 * 接口 [客户端订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/28489) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/list`
 */
export interface ApiOrderOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单活动名称
     */
    activityName?: string
    /**
     * 订单商品列表
     */
    commodities?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态文案
       */
      saleAfterName?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    countDownTime?: {
      /**
       * 自动取消订单时效（毫秒)
       */
      cancelOrderCountDown?: number
      /**
       * 关闭订单时效（毫秒）
       */
      closeCountDown?: number
      /**
       * 自动确认收货时效（毫秒）
       */
      confirmCountDown?: number
      /**
       * 发货（派单）倒计时（毫秒）
       */
      shippingCountDown?: number
    }
    /**
     * 延长收货天数
     */
    delayDays?: number
    /**
     * 延长收货状态 -1不支持 0未延长 1已延长
     */
    delayStatus?: number
    /**
     * 配送日期
     */
    deliverDate?: string
    /**
     * 评价状态 0未评价 1已评价
     */
    evaluationStatus?: number
    /**
     * 配送方式值 1普通快递 2同城自提
     */
    logisticsMethodValue?: number
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 订单金额（实付）
     */
    orderAmount?: string
    /**
     * 订单分类  1标准电商  2标准核销  3标准虚拟
     */
    orderClassify?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 包裹数量，如果为0则是未发货
     */
    packageQuantity?: number
    /**
     * 包裹发送类型 0未发货 1整包发货 2拆包发货
     */
    packageType?: number
    /**
     * 是否为父订单
     */
    parentOrderFlag?: boolean
    /**
     * 父订单Id
     */
    parentOrderId?: string
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 售后状态 0无售后 1待商家处理  2已完成  3售后关闭
     */
    saleAfterStatus?: number
    /**
     * 售后状态文案
     */
    saleAfterStatusLabel?: string
    selfAddress?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 订单状态 0待支付
     * 100待发货
     * 101已发货
     *
     * 400待接单
     * 401待配送
     * 402配送中
     *
     * 900交易完成
     * 901交易关闭"902交易完结
     */
    status?: number
    /**
     * 订单状态文案
     */
    statusName?: string
    /**
     * 订单金额（应付)
     */
    totalAmount?: string
    /**
     * 催单状态 -1不支持催单 0未催单 1已催单
     */
    urgedStatus?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/28489) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/list`
 */
type ApiOrderOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/28489) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/list`
 */
const apiOrderOrderListRequestConfig: ApiOrderOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端订单列表', author: '成龙' },
  }

/**
 * 接口 [客户端订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/28489) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/list`
 */
export const apiOrderOrderList = /*#__PURE__*/ (
  requestData: ApiOrderOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderListResponse>(
    prepare(apiOrderOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderList.requestConfig = apiOrderOrderListRequestConfig

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/28513) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/cancel`
 */
export interface ApiOrderOrderCancelRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/28513) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/cancel`
 */
export interface ApiOrderOrderCancelResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/28513) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/cancel`
 */
type ApiOrderOrderCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/cancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/28513) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/cancel`
 */
const apiOrderOrderCancelRequestConfig: ApiOrderOrderCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/cancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '取消订单', author: '成龙' },
  }

/**
 * 接口 [取消订单↗](https://yapi.gogpay.cn/project/906/interface/api/28513) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/cancel`
 */
export const apiOrderOrderCancel = /*#__PURE__*/ (
  requestData: ApiOrderOrderCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderCancelResponse>(
    prepare(apiOrderOrderCancelRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderCancel.requestConfig = apiOrderOrderCancelRequestConfig

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/28517) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delayConfirm`
 */
export interface ApiOrderOrderDelayConfirmRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/28517) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delayConfirm`
 */
export interface ApiOrderOrderDelayConfirmResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/28517) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delayConfirm`
 */
type ApiOrderOrderDelayConfirmRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/delayConfirm',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/28517) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delayConfirm`
 */
const apiOrderOrderDelayConfirmRequestConfig: ApiOrderOrderDelayConfirmRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/delayConfirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderDelayConfirm',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '延长收货', author: '成龙' },
  }

/**
 * 接口 [延长收货↗](https://yapi.gogpay.cn/project/906/interface/api/28517) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delayConfirm`
 */
export const apiOrderOrderDelayConfirm = /*#__PURE__*/ (
  requestData: ApiOrderOrderDelayConfirmRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderDelayConfirmResponse>(
    prepare(apiOrderOrderDelayConfirmRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderDelayConfirm.requestConfig = apiOrderOrderDelayConfirmRequestConfig

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/28521) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delete`
 */
export interface ApiOrderOrderDeleteRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/28521) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delete`
 */
export interface ApiOrderOrderDeleteResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/28521) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delete`
 */
type ApiOrderOrderDeleteRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/delete',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/28521) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delete`
 */
const apiOrderOrderDeleteRequestConfig: ApiOrderOrderDeleteRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/delete',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderDelete',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '删除订单', author: '成龙' },
  }

/**
 * 接口 [删除订单↗](https://yapi.gogpay.cn/project/906/interface/api/28521) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/delete`
 */
export const apiOrderOrderDelete = /*#__PURE__*/ (
  requestData: ApiOrderOrderDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderDeleteResponse>(
    prepare(apiOrderOrderDeleteRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderDelete.requestConfig = apiOrderOrderDeleteRequestConfig

/**
 * 接口 [订单数量统计↗](https://yapi.gogpay.cn/project/906/interface/api/28525) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/statisticsCount`
 */
export interface ApiOrderOrderStatisticsCountRequest {
  orderClassify?: ('1' | '2' | '3' | '4' | '5' | '6' | '7' | '8')[]
}

/**
 * 接口 [订单数量统计↗](https://yapi.gogpay.cn/project/906/interface/api/28525) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/statisticsCount`
 */
export interface ApiOrderOrderStatisticsCountResponse {
  /**
   * im跳转地址
   */
  imMessage?: string
  /**
   * 待使用数量
   */
  unUseCount?: number
  /**
   * 待收货数量
   */
  waitConfirmCount?: number
  /**
   * 待评价数量
   */
  waitEvaluateCount?: number
  /**
   * 待付款数量
   */
  waitPayCount?: number
  /**
   * 待发货数量
   */
  waitShipCount?: number
}

/**
 * 接口 [订单数量统计↗](https://yapi.gogpay.cn/project/906/interface/api/28525) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/statisticsCount`
 */
type ApiOrderOrderStatisticsCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/statisticsCount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单数量统计↗](https://yapi.gogpay.cn/project/906/interface/api/28525) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/statisticsCount`
 */
const apiOrderOrderStatisticsCountRequestConfig: ApiOrderOrderStatisticsCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/statisticsCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderStatisticsCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单数量统计', author: '成龙' },
  }

/**
 * 接口 [订单数量统计↗](https://yapi.gogpay.cn/project/906/interface/api/28525) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/statisticsCount`
 */
export const apiOrderOrderStatisticsCount = /*#__PURE__*/ (
  requestData: ApiOrderOrderStatisticsCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderStatisticsCountResponse>(
    prepare(apiOrderOrderStatisticsCountRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderStatisticsCount.requestConfig =
  apiOrderOrderStatisticsCountRequestConfig

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/29253) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/confirm`
 */
export interface ApiOrderOrderConfirmRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/29253) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/confirm`
 */
export interface ApiOrderOrderConfirmResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/29253) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/confirm`
 */
type ApiOrderOrderConfirmRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/confirm',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/29253) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/confirm`
 */
const apiOrderOrderConfirmRequestConfig: ApiOrderOrderConfirmRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/confirm',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderConfirm',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '确认收货', author: '成龙' },
  }

/**
 * 接口 [确认收货↗](https://yapi.gogpay.cn/project/906/interface/api/29253) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/confirm`
 */
export const apiOrderOrderConfirm = /*#__PURE__*/ (
  requestData: ApiOrderOrderConfirmRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderConfirmResponse>(
    prepare(apiOrderOrderConfirmRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderConfirm.requestConfig = apiOrderOrderConfirmRequestConfig

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/29257) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/queryLogistics`
 */
export interface ApiOrderOrderQueryLogisticsRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 包裹Id
   */
  packageId?: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/29257) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/queryLogistics`
 */
export interface ApiOrderOrderQueryLogisticsResponse {
  /**
   * 发货时间
   */
  beginTime?: string
  /**
   * 物流公司名称
   */
  companyName?: string
  /**
   * 运送方式
   */
  logisticsMethod?: string
  /**
   * 物流订单号
   */
  logisticsOrderNo?: string
  /**
   * 物流状态
   */
  state?: string
  /**
   * 物流轨迹信息
   */
  traces?: {
    /**
     * 轨迹动作，如【派送中】【已签收】等
     */
    action?: string
    /**
     * 轨迹信息内容 如【快件达到小河中转站】
     */
    actionInfo?: string
    /**
     * 轨迹发生时间
     */
    actionTime?: string
  }[]
  /**
   * 运单号
   */
  waybillNo?: string
}

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/29257) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/queryLogistics`
 */
type ApiOrderOrderQueryLogisticsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/queryLogistics',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/29257) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/queryLogistics`
 */
const apiOrderOrderQueryLogisticsRequestConfig: ApiOrderOrderQueryLogisticsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/queryLogistics',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderQueryLogistics',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询物流信息', author: '成龙' },
  }

/**
 * 接口 [查询物流信息↗](https://yapi.gogpay.cn/project/906/interface/api/29257) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/queryLogistics`
 */
export const apiOrderOrderQueryLogistics = /*#__PURE__*/ (
  requestData: ApiOrderOrderQueryLogisticsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderQueryLogisticsResponse>(
    prepare(apiOrderOrderQueryLogisticsRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderQueryLogistics.requestConfig =
  apiOrderOrderQueryLogisticsRequestConfig

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/29501) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/urged`
 */
export interface ApiOrderOrderUrgedRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/29501) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/urged`
 */
export interface ApiOrderOrderUrgedResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/29501) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/urged`
 */
type ApiOrderOrderUrgedRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/urged',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/29501) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/urged`
 */
const apiOrderOrderUrgedRequestConfig: ApiOrderOrderUrgedRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/urged',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderUrged',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '催单', author: '成龙' },
  }

/**
 * 接口 [催单↗](https://yapi.gogpay.cn/project/906/interface/api/29501) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/urged`
 */
export const apiOrderOrderUrged = /*#__PURE__*/ (
  requestData: ApiOrderOrderUrgedRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderUrgedResponse>(
    prepare(apiOrderOrderUrgedRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderUrged.requestConfig = apiOrderOrderUrgedRequestConfig

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/30393) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/pay`
 */
export interface ApiOrderOrderPayRequest {
  /**
   * 微信用户Id
   */
  openId?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
}

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/30393) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/pay`
 */
export interface ApiOrderOrderPayResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  needRealNameAuth?: boolean
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/30393) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/pay`
 */
type ApiOrderOrderPayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/pay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/30393) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/pay`
 */
const apiOrderOrderPayRequestConfig: ApiOrderOrderPayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderPay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单支付', author: '成龙' },
  }

/**
 * 接口 [订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/30393) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/pay`
 */
export const apiOrderOrderPay = /*#__PURE__*/ (
  requestData: ApiOrderOrderPayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderPayResponse>(
    prepare(apiOrderOrderPayRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderPay.requestConfig = apiOrderOrderPayRequestConfig

/**
 * 接口 [查看发票↗](https://yapi.gogpay.cn/project/906/interface/api/31765) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/invoiceInfo`
 */
export interface ApiOrderOrderInvoiceInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [查看发票↗](https://yapi.gogpay.cn/project/906/interface/api/31765) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/invoiceInfo`
 */
export interface ApiOrderOrderInvoiceInfoResponse {
  /**
   * 发票图片地址
   */
  invoiceUrl?: string
}

/**
 * 接口 [查看发票↗](https://yapi.gogpay.cn/project/906/interface/api/31765) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/invoiceInfo`
 */
type ApiOrderOrderInvoiceInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/invoiceInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查看发票↗](https://yapi.gogpay.cn/project/906/interface/api/31765) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/invoiceInfo`
 */
const apiOrderOrderInvoiceInfoRequestConfig: ApiOrderOrderInvoiceInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/invoiceInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderInvoiceInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查看发票', author: '成龙' },
  }

/**
 * 接口 [查看发票↗](https://yapi.gogpay.cn/project/906/interface/api/31765) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/invoiceInfo`
 */
export const apiOrderOrderInvoiceInfo = /*#__PURE__*/ (
  requestData: ApiOrderOrderInvoiceInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderInvoiceInfoResponse>(
    prepare(apiOrderOrderInvoiceInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderInvoiceInfo.requestConfig = apiOrderOrderInvoiceInfoRequestConfig

/**
 * 接口 [发送发票邮件↗](https://yapi.gogpay.cn/project/906/interface/api/31769) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/sendInvoiceEmail`
 */
export interface ApiOrderOrderSendInvoiceEmailRequest {
  /**
   * 邮箱地址
   */
  email: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [发送发票邮件↗](https://yapi.gogpay.cn/project/906/interface/api/31769) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/sendInvoiceEmail`
 */
export interface ApiOrderOrderSendInvoiceEmailResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发送发票邮件↗](https://yapi.gogpay.cn/project/906/interface/api/31769) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/sendInvoiceEmail`
 */
type ApiOrderOrderSendInvoiceEmailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/sendInvoiceEmail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发送发票邮件↗](https://yapi.gogpay.cn/project/906/interface/api/31769) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/sendInvoiceEmail`
 */
const apiOrderOrderSendInvoiceEmailRequestConfig: ApiOrderOrderSendInvoiceEmailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/sendInvoiceEmail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderSendInvoiceEmail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发送发票邮件', author: '成龙' },
  }

/**
 * 接口 [发送发票邮件↗](https://yapi.gogpay.cn/project/906/interface/api/31769) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/sendInvoiceEmail`
 */
export const apiOrderOrderSendInvoiceEmail = /*#__PURE__*/ (
  requestData: ApiOrderOrderSendInvoiceEmailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderSendInvoiceEmailResponse>(
    prepare(apiOrderOrderSendInvoiceEmailRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderSendInvoiceEmail.requestConfig =
  apiOrderOrderSendInvoiceEmailRequestConfig

/**
 * 接口 [获取订单的包裹列表↗](https://yapi.gogpay.cn/project/906/interface/api/32153) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/packageInfo`
 */
export interface ApiOrderOrderPackageInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取订单的包裹列表↗](https://yapi.gogpay.cn/project/906/interface/api/32153) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/packageInfo`
 */
export interface ApiOrderOrderPackageInfoResponse {
  /**
   * 包裹列表
   */
  items: {
    /**
     * 商品列表
     */
    commodities?: {
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 购买SKU ID
       */
      skuId?: string
    }[]
    /**
     * 物流公司名称
     */
    companyName?: string
    /**
     * 包裹Id
     */
    packageId?: string
    /**
     * 物流节点名称
     */
    pointName?: string
    /**
     * 商品数量
     */
    quantity?: number
    /**
     * 运单编号
     */
    waybillNo?: string
  }[]
  /**
   * 包裹发货方式  0未发货 1整包发货  2拆包发货
   */
  packageType: number
  /**
   * 包裹数量
   */
  quantity: number
}

/**
 * 接口 [获取订单的包裹列表↗](https://yapi.gogpay.cn/project/906/interface/api/32153) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/packageInfo`
 */
type ApiOrderOrderPackageInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/packageInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单的包裹列表↗](https://yapi.gogpay.cn/project/906/interface/api/32153) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/packageInfo`
 */
const apiOrderOrderPackageInfoRequestConfig: ApiOrderOrderPackageInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/packageInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderPackageInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单的包裹列表', author: '成龙' },
  }

/**
 * 接口 [获取订单的包裹列表↗](https://yapi.gogpay.cn/project/906/interface/api/32153) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/packageInfo`
 */
export const apiOrderOrderPackageInfo = /*#__PURE__*/ (
  requestData: ApiOrderOrderPackageInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderPackageInfoResponse>(
    prepare(apiOrderOrderPackageInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderPackageInfo.requestConfig = apiOrderOrderPackageInfoRequestConfig

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/32161) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyInvoice`
 */
export interface ApiOrderOrderModifyInvoiceRequest {
  /**
   * 企业地址
   */
  address?: string
  /**
   * 银行账号
   */
  bankAccount?: string
  /**
   * 开户银行
   */
  bankName?: string
  /**
   * 发票邮箱地址
   */
  email?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 纳税人识别号
   */
  taxPayerNumber?: string
  /**
   * 发票抬头
   */
  title: string
  /**
   * 抬头类型 1个人 2企业
   */
  titleType: number
}

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/32161) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyInvoice`
 */
export interface ApiOrderOrderModifyInvoiceResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/32161) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyInvoice`
 */
type ApiOrderOrderModifyInvoiceRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/modifyInvoice',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/32161) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyInvoice`
 */
const apiOrderOrderModifyInvoiceRequestConfig: ApiOrderOrderModifyInvoiceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/modifyInvoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderModifyInvoice',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改订单发票信息', author: '成龙' },
  }

/**
 * 接口 [修改订单发票信息↗](https://yapi.gogpay.cn/project/906/interface/api/32161) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyInvoice`
 */
export const apiOrderOrderModifyInvoice = /*#__PURE__*/ (
  requestData: ApiOrderOrderModifyInvoiceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderModifyInvoiceResponse>(
    prepare(apiOrderOrderModifyInvoiceRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderModifyInvoice.requestConfig =
  apiOrderOrderModifyInvoiceRequestConfig

/**
 * 接口 [test↗](https://yapi.gogpay.cn/project/906/interface/api/59345) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/test`
 */
export interface ApiOrderOrderTestRequest {
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [test↗](https://yapi.gogpay.cn/project/906/interface/api/59345) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/test`
 */
export interface ApiOrderOrderTestResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [test↗](https://yapi.gogpay.cn/project/906/interface/api/59345) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/test`
 */
type ApiOrderOrderTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/test',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [test↗](https://yapi.gogpay.cn/project/906/interface/api/59345) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/test`
 */
const apiOrderOrderTestRequestConfig: ApiOrderOrderTestRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/test',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderTest',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'test', author: '成龙' },
  }

/**
 * 接口 [test↗](https://yapi.gogpay.cn/project/906/interface/api/59345) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/test`
 */
export const apiOrderOrderTest = /*#__PURE__*/ (
  requestData: ApiOrderOrderTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderTestResponse>(
    prepare(apiOrderOrderTestRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderTest.requestConfig = apiOrderOrderTestRequestConfig

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/906/interface/api/119650) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getUserInfo`
 */
export interface ApiOrderOrderGetUserInfoRequest {}

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/906/interface/api/119650) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getUserInfo`
 */
export interface ApiOrderOrderGetUserInfoResponse {
  /**
   * 用户实名，如果未实名则为空
   */
  authName?: string
  /**
   * 头像
   */
  avatar?: string
  /**
   * 用户昵称
   */
  nickName?: string
  /**
   * 用户手机
   */
  phoneNo?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/906/interface/api/119650) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getUserInfo`
 */
type ApiOrderOrderGetUserInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/getUserInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/906/interface/api/119650) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getUserInfo`
 */
const apiOrderOrderGetUserInfoRequestConfig: ApiOrderOrderGetUserInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/getUserInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderGetUserInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户信息', author: '成龙' },
  }

/**
 * 接口 [获取用户信息↗](https://yapi.gogpay.cn/project/906/interface/api/119650) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getUserInfo`
 */
export const apiOrderOrderGetUserInfo = /*#__PURE__*/ (
  requestData?: ApiOrderOrderGetUserInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderGetUserInfoResponse>(
    prepare(apiOrderOrderGetUserInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderGetUserInfo.requestConfig = apiOrderOrderGetUserInfoRequestConfig

/**
 * 接口 [修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/178356) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyAddress`
 */
export interface ApiOrderOrderModifyAddressRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/178356) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyAddress`
 */
export interface ApiOrderOrderModifyAddressResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/178356) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyAddress`
 */
type ApiOrderOrderModifyAddressRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/modifyAddress',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/178356) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyAddress`
 */
const apiOrderOrderModifyAddressRequestConfig: ApiOrderOrderModifyAddressRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/modifyAddress',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderModifyAddress',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '修改订单收货地址', author: '杨大鑫' },
  }

/**
 * 接口 [修改订单收货地址↗](https://yapi.gogpay.cn/project/906/interface/api/178356) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/modifyAddress`
 */
export const apiOrderOrderModifyAddress = /*#__PURE__*/ (
  requestData: ApiOrderOrderModifyAddressRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderModifyAddressResponse>(
    prepare(apiOrderOrderModifyAddressRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderModifyAddress.requestConfig =
  apiOrderOrderModifyAddressRequestConfig

/**
 * 接口 [获取平台运营规则信息↗](https://yapi.gogpay.cn/project/906/interface/api/405513) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getBusinessRuleInfo`
 */
export interface ApiOrderOrderGetBusinessRuleInfoRequest {
  /**
   * 商品来源类型
   */
  commodityResource?: '0' | '1'
  /**
   * 用户ID
   */
  dcbUserId?: string
}

/**
 * 接口 [获取平台运营规则信息↗](https://yapi.gogpay.cn/project/906/interface/api/405513) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getBusinessRuleInfo`
 */
export interface ApiOrderOrderGetBusinessRuleInfoResponse {
  /**
   * 是否勾选
   */
  selected?: boolean
  /**
   * 是否显示购物车
   */
  showCart?: boolean
  /**
   * 提示内容
   */
  tipContent?: string
  /**
   * 提示结尾
   */
  tipEnd?: string
  /**
   * 提示标题
   */
  tipHead?: string
  /**
   * 规则标题
   */
  title?: string
  /**
   * 规则类型：1-跨境电商平台运营规则
   */
  type?: number
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [获取平台运营规则信息↗](https://yapi.gogpay.cn/project/906/interface/api/405513) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getBusinessRuleInfo`
 */
type ApiOrderOrderGetBusinessRuleInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/getBusinessRuleInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取平台运营规则信息↗](https://yapi.gogpay.cn/project/906/interface/api/405513) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getBusinessRuleInfo`
 */
const apiOrderOrderGetBusinessRuleInfoRequestConfig: ApiOrderOrderGetBusinessRuleInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/getBusinessRuleInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderGetBusinessRuleInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取平台运营规则信息', author: '511号开发' },
  }

/**
 * 接口 [获取平台运营规则信息↗](https://yapi.gogpay.cn/project/906/interface/api/405513) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/getBusinessRuleInfo`
 */
export const apiOrderOrderGetBusinessRuleInfo = /*#__PURE__*/ (
  requestData: ApiOrderOrderGetBusinessRuleInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderGetBusinessRuleInfoResponse>(
    prepare(apiOrderOrderGetBusinessRuleInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderGetBusinessRuleInfo.requestConfig =
  apiOrderOrderGetBusinessRuleInfoRequestConfig

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459288) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/orderShip`
 */
export interface ApiOrderOrderOrderShipRequest {
  /**
   * 自配送人员ID， 当发货方式为自配送时必传
   */
  courierId?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 发货方式 1电子面单 2线下自寄 3门店自提 4同城配送 5商家自配
   */
  orderShipType?: '1' | '2' | '3' | '4' | '5'
  /**
   * 包裹列表
   */
  packageItems?: {
    /**
     * 订单商品Id，和sku Id二选一传递
     */
    commodityId?: {
      commodityCount?: number
      commodityId?: string
    }[]
    /**
     * 快递公司编码，当发货方式为【线下自寄】时必传
     */
    companyCode?: string
    /**
     * 快递公司名称，当发货方式为【线下自寄】时必传
     */
    companyName?: string
    /**
     * 运单号，当发货方式为【线下自寄】时必传
     */
    logisticCode?: string
    /**
     * 快递公司信息Id，当发货方式为【线上发货】时必传
     */
    merchantShipperId?: string
    /**
     * 备注信息
     */
    remark?: string
    /**
     * 订单商品SKU Id,和订单商品Id二选一传递
     */
    skuId?: {
      commodityCount?: number
      commoditySkuId?: string
    }[]
  }[]
  /**
   * 发货地址Id
   */
  sendAddress?: string
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459288) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/orderShip`
 */
export interface ApiOrderOrderOrderShipResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459288) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/orderShip`
 */
type ApiOrderOrderOrderShipRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/orderShip',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459288) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/orderShip`
 */
const apiOrderOrderOrderShipRequestConfig: ApiOrderOrderOrderShipRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/orderShip',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderOrderShip',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单发货', author: '503号开发' },
  }

/**
 * 接口 [订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/459288) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/orderShip`
 */
export const apiOrderOrderOrderShip = /*#__PURE__*/ (
  requestData: ApiOrderOrderOrderShipRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderOrderShipResponse>(
    prepare(apiOrderOrderOrderShipRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderOrderShip.requestConfig = apiOrderOrderOrderShipRequestConfig

/**
 * 接口 [订单支付成功后获取抽奖次数↗](https://yapi.gogpay.cn/project/906/interface/api/497712) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/marketingBoxTimesAdd`
 */
export interface ApiOrderOrderMarketingBoxTimesAddRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [订单支付成功后获取抽奖次数↗](https://yapi.gogpay.cn/project/906/interface/api/497712) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/marketingBoxTimesAdd`
 */
export interface ApiOrderOrderMarketingBoxTimesAddResponse {
  /**
   * 是否展示弹窗
   */
  isShowAlert?: boolean
  /**
   * 返回描述
   */
  msgDesc?: string
  /**
   * 跳转地址
   */
  url?: string
}

/**
 * 接口 [订单支付成功后获取抽奖次数↗](https://yapi.gogpay.cn/project/906/interface/api/497712) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/marketingBoxTimesAdd`
 */
type ApiOrderOrderMarketingBoxTimesAddRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/marketingBoxTimesAdd',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [订单支付成功后获取抽奖次数↗](https://yapi.gogpay.cn/project/906/interface/api/497712) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/marketingBoxTimesAdd`
 */
const apiOrderOrderMarketingBoxTimesAddRequestConfig: ApiOrderOrderMarketingBoxTimesAddRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_19,
    devUrl: devUrl_0_5_0_19,
    prodUrl: prodUrl_0_5_0_19,
    path: '/order/api/order/marketingBoxTimesAdd',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderMarketingBoxTimesAdd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单支付成功后获取抽奖次数', author: '511号开发' },
  }

/**
 * 接口 [订单支付成功后获取抽奖次数↗](https://yapi.gogpay.cn/project/906/interface/api/497712) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端订单↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7111)
 * @请求头 `POST /order/api/order/marketingBoxTimesAdd`
 */
export const apiOrderOrderMarketingBoxTimesAdd = /*#__PURE__*/ (
  requestData: ApiOrderOrderMarketingBoxTimesAddRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderMarketingBoxTimesAddResponse>(
    prepare(apiOrderOrderMarketingBoxTimesAddRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderMarketingBoxTimesAdd.requestConfig =
  apiOrderOrderMarketingBoxTimesAddRequestConfig

const mockUrl_0_5_0_20 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_20 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_20 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_20 = 'data' as any

/**
 * 接口 [获取订单结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/29505) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/list`
 */
export interface ApiOrderImsApiOrderSettlementListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS'
  /**
   * 订单日期起始日期
   */
  beginDate?: string
  /**
   * 订单日期结束日期
   */
  endDate?: string
  /**
   * 子商户Id列表
   */
  merchantId?: string[]
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单类型 1普通订单 2秒杀订单
   */
  orderType?: 1 | 2
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 结算状态 1待结算 2结算中 3已结算
   */
  settlementStatus: 0 | 1 | 2 | 3
}

/**
 * 接口 [获取订单结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/29505) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/list`
 */
export interface ApiOrderImsApiOrderSettlementListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 账目类型 1正常账 2退款账
     */
    accountType?: number
    /**
     * 账目类型文案
     */
    accountTypeName?: string
    /**
     * 商品总额
     */
    commodityAmount?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 材料费
     */
    materialFee?: number
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 订单编号（业务系统）
     */
    orderNo?: string
    /**
     * 订单类型
     */
    orderType?: string
    /**
     * 支付金额
     */
    payAmount?: number
    /**
     * 支付渠道
     */
    payChannel?: string
    /**
     * 支付流水号（多彩报交易中心订单编号）
     */
    paySerialNo?: string
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 平台利润
     */
    profitAmount?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 结算金额
     */
    settlementAmount?: number
    /**
     * 结算状态 1待结算 2结算中 3已结算
     */
    settlementStatus?: number
    /**
     * 商户名称 结算状态文案
     */
    settlementStatusName?: string
    /**
     * 结算时间
     */
    settlementTime?: string
    /**
     * sku规格信息
     */
    skuSpecs?: string
    /**
     * 原始订单号
     */
    sourceOrderNo?: string
    /**
     * 二次补充费
     */
    supplyFee?: number
    /**
     * 二次补充费说明
     */
    supplyRemark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 用户手机号
     */
    userTel?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取订单结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/29505) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/list`
 */
type ApiOrderImsApiOrderSettlementListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSettlement/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/29505) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/list`
 */
const apiOrderImsApiOrderSettlementListRequestConfig: ApiOrderImsApiOrderSettlementListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_20,
    devUrl: devUrl_0_5_0_20,
    prodUrl: prodUrl_0_5_0_20,
    path: '/order/imsApi/orderSettlement/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单结算列表', author: '成龙' },
  }

/**
 * 接口 [获取订单结算列表↗](https://yapi.gogpay.cn/project/906/interface/api/29505) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/list`
 */
export const apiOrderImsApiOrderSettlementList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSettlementListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSettlementListResponse>(
    prepare(apiOrderImsApiOrderSettlementListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderSettlementList.requestConfig =
  apiOrderImsApiOrderSettlementListRequestConfig

/**
 * 接口 [更新订单结算状态↗](https://yapi.gogpay.cn/project/906/interface/api/29509) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/updateSettlementStatus`
 */
export interface ApiOrderImsApiOrderSettlementUpdateSettlementStatusRequest {
  /**
   * 数据开始日期
   */
  beginDate: string
  /**
   * 数据结束日期
   */
  endDate: string
  /**
   * 结算状态 2结算中  3结算完成
   */
  settlementStatus: '0' | '1' | '2' | '3'
  /**
   * 结算时间，结算完成时必穿
   */
  settlementTime?: string
}

/**
 * 接口 [更新订单结算状态↗](https://yapi.gogpay.cn/project/906/interface/api/29509) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/updateSettlementStatus`
 */
export interface ApiOrderImsApiOrderSettlementUpdateSettlementStatusResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [更新订单结算状态↗](https://yapi.gogpay.cn/project/906/interface/api/29509) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/updateSettlementStatus`
 */
type ApiOrderImsApiOrderSettlementUpdateSettlementStatusRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderSettlement/updateSettlementStatus',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [更新订单结算状态↗](https://yapi.gogpay.cn/project/906/interface/api/29509) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/updateSettlementStatus`
 */
const apiOrderImsApiOrderSettlementUpdateSettlementStatusRequestConfig: ApiOrderImsApiOrderSettlementUpdateSettlementStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_20,
    devUrl: devUrl_0_5_0_20,
    prodUrl: prodUrl_0_5_0_20,
    path: '/order/imsApi/orderSettlement/updateSettlementStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSettlementUpdateSettlementStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '更新订单结算状态', author: '成龙' },
  }

/**
 * 接口 [更新订单结算状态↗](https://yapi.gogpay.cn/project/906/interface/api/29509) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单结算↗](https://yapi.gogpay.cn/project/906/interface/api/cat_7190)
 * @请求头 `POST /order/imsApi/orderSettlement/updateSettlementStatus`
 */
export const apiOrderImsApiOrderSettlementUpdateSettlementStatus =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderSettlementUpdateSettlementStatusRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderSettlementUpdateSettlementStatusResponse>(
      prepare(
        apiOrderImsApiOrderSettlementUpdateSettlementStatusRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderSettlementUpdateSettlementStatus.requestConfig =
  apiOrderImsApiOrderSettlementUpdateSettlementStatusRequestConfig

const mockUrl_0_5_0_21 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_21 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_21 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_21 = 'data' as any

/**
 * 接口 [兑换商品预下单↗](https://yapi.gogpay.cn/project/906/interface/api/407748) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsPreOrder`
 */
export interface ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest {
  /**
   * 最下级商品Id
   */
  commodityId: string
  /**
   * 配置兑换商品Id
   */
  exchangeCommodityId: string
  /**
   * 父订单Id
   */
  parentOrderNo: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [兑换商品预下单↗](https://yapi.gogpay.cn/project/906/interface/api/407748) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsPreOrder`
 */
export interface ApiOrderExchangeGoodsExchangeGoodsPreOrderResponse {
  businessRuleInfo?: {
    /**
     * 是否勾选
     */
    selected?: boolean
    /**
     * 是否显示购物车
     */
    showCart?: boolean
    /**
     * 提示内容
     */
    tipContent?: string
    /**
     * 提示结尾
     */
    tipEnd?: string
    /**
     * 提示标题
     */
    tipHead?: string
    /**
     * 规则标题
     */
    title?: string
    /**
     * 规则类型：1-跨境电商平台运营规则
     */
    type?: number
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 业务类型
   */
  businessType?: string
  /**
   * 是否计算过邮费
   */
  calcPostFeeFlag?: boolean
  /**
   * 验证码凭证
   */
  captchaToken?: string
  /**
   * 积分抵扣项目列表
   */
  channelActivityItems?: {
    /**
     * 余额
     */
    balance?: string
    /**
     * 余额单位
     */
    balanceUnit?: string
    /**
     * 是否可抵扣
     */
    deduction?: boolean
    /**
     * 活动Id
     */
    id?: string
    /**
     * 是否需要密码
     */
    needPassword?: boolean
    /**
     * 不支持抵扣原因
     */
    noDeductionReason?: string
    passwordKeyboard?: {
      /**
       * 密码值列表
       */
      keys?: {
        /**
         * 密码数字
         */
        key?: number
        /**
         * 密码数字混淆值
         */
        keySlat?: number
        /**
         * 密码值
         */
        value?: string
      }[]
    }
    /**
     * 渠道名称
     */
    title?: string
  }[]
  closeOrderValue?: number
  /**
   * 折扣优惠消费ticket
   */
  discountActivityTicket?: string
  /**
   * 优惠项目列表
   */
  discountItems?: {
    /**
     * 优惠金额
     */
    amount?: number
    /**
     * 优惠名称,如:折扣优惠
     */
    name?: string
    /**
     * 优惠类型
     */
    type?: number
  }[]
  /**
   * 满减活动消费ticket
   */
  fullReductionActivityTicket?: string
  /**
   * 是否可以选择核销店铺
   */
  hasChooseWriteOffStore?: boolean
  /**
   * 是否支持开具发票 0不支持 1支持
   */
  invoiceFlag?: number
  /**
   * 是否需要收货地址
   */
  needAddress?: boolean
  /**
   * 是否需要经纬度
   */
  needLogLet?: boolean
  /**
   * 是否需要使用日期
   */
  needUseDate?: boolean
  /**
   * 订单总额
   */
  orderAmount?: number
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * 运营渠道Id
     */
    businessChannelId?: string
    /**
     * 运营渠道名称
     */
    businessChannelName?: string
    /**
     * SKU信息
     */
    commodityInfo?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 校验资格接口地址
       */
      businessCheckUrl?: string
      /**
       * 类目Id
       */
      categoryId?: string
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 是否实名制购买：0-否 1-是
       */
      checkBuyFlag?: 0 | 1
      /**
       * 商品种类：0-套餐券 1-代金券 2-兑换券
       */
      commodityClassifyType?: number
      /**
       * 商品id
       */
      commodityId?: string
      /**
       * 商品名称
       */
      commodityName?: string
      /**
       * 商品图片
       */
      commodityPic?: string
      /**
       * 商品来源：0多彩宝 1跨境电商
       */
      commodityResource?: number
      /**
       * 商品类型 0-标准电商 1-派单核销
       */
      commodityType?: number
      /**
       * 商品合同名称
       */
      contractName?: string
      /**
       * 购买数量
       */
      count?: number
      /**
       * 划线价
       */
      dashPrice?: number
      /**
       * 仅支持配送地址
       */
      deliverAddress?: string[]
      /**
       * 地址配送限制类型
       */
      deliverAddressType?: number
      discountActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 折扣优惠金额
       */
      discountActivityAmount?: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 特征标签
       */
      featureLabel?: {
        /**
         * 标签CODE
         */
        code?: string
        /**
         * 标签名称
         */
        label?: string
      }[]
      fullReductioActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 满减优惠金额
       */
      fullReductionActivityAmount?: number
      integralActivity?: {
        /**
         * 优惠金额
         */
        discountAmount?: number
        /**
         * 结束时间
         */
        endTime?: string
        /**
         * 活动Id
         */
        id?: string
        /**
         * 初始限制数量
         */
        initLimitCount?: number
        /**
         * 优惠后所需积分
         */
        integral?: number
        /**
         * 最大可选择数量
         */
        maxSelectCount?: number
        /**
         * 活动名称
         */
        name?: string
        /**
         * 原所需活动积分
         */
        needIntegral?: number
        /**
         * 原价
         */
        price?: number
        /**
         * 活动积分比例 一分钱：ratio
         */
        ratio?: number
        settlementConfig?: {
          /**
           * 出资方；1=平台出资，2=商家出资，3=共同出资
           */
          contributionType: number
          /**
           * 共同出资方式；1=商家出资占比，2=平台出资占比
           */
          jointContributionType: number
          /**
           * 共同出资占比
           */
          jointContributionVal: string
        }
        /**
         * 开始时间
         */
        startTime?: string
        /**
         * 单人限购
         */
        userPurchaseLimit?: number
      }
      /**
       * 可选日期区间：0-否 1-是
       */
      isDateInterval: 0 | 1
      /**
       * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
       */
      isIncludeLastDay?: 0 | 1
      /**
       * 组合子商品列表
       */
      jointCommodityList?: {
        /**
         * 子商品ID
         */
        childCommodityId?: string
        /**
         * 子商品图片
         */
        childCommodityPic?: string
        /**
         * 子商品邮费价格
         */
        childPostPrice?: number
        /**
         * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
         */
        childPostType?: 0 | 1 | 2
        /**
         * 子商品规格ID
         */
        childSkuId?: string
        /**
         * 组合商品名称
         */
        commodityTitle?: string
        /**
         * 数量
         */
        num?: number
        /**
         * 单次核销价格
         */
        onePrice?: number
        /**
         * 商品原名称
         */
        originalCommodityTitle?: string
        /**
         * 组合商品ID
         */
        refCommodityId?: string
        /**
         * 运费模板
         */
        refDeliverTemplateId?: string
        /**
         * 销售价格
         */
        sellPrice?: number
        /**
         * 结算方式：0-固定金额 1-分层比例
         */
        settlementType?: 0 | 1
        /**
         * 结算值
         */
        settlementValue?: number
        /**
         * 剩余库存
         */
        surplusStock?: number
      }[]
      jointStandardCommodity?: {
        /**
         * 包邮类型  1-包邮 2-运费模板
         */
        postType: 0 | 1 | 2
        /**
         * 是佛提供发票：0-不提供 1-提供
         */
        provideInvoiceFlag: number
        /**
         * 商品售价
         */
        sellPrice: number
        /**
         * 发货类型 0-快递发货 1-同城配送 2-到店自提
         */
        shippingType: 0 | 1 | 2
        zoneLimit?: {
          /**
           * 邮费结算价
           */
          postFeeCost?: number
          /**
           * 配送区域
           */
          zones?: {
            /**
             * 市级编码
             */
            cityCode?: string
            /**
             * 省份名称
             */
            cityName?: string
            /**
             * 区级编码
             */
            districtCode?: string
            /**
             * 区县名称
             */
            districtName?: string
            /**
             * 省份编码
             */
            provinceCode?: string
            /**
             * 省份名称
             */
            provinceName?: string
          }[]
        }
        /**
         * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
         */
        zoneLimitType: 0 | 1 | 2
      }
      /**
       * 是否需要附加实名用户信息
       */
      needUserInfo?: boolean
      /**
       * 打包费
       */
      packagePrice?: number
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 邮费结算价
       */
      postSettlementFee?: number
      /**
       * 邮费类型
       */
      postType?: number
      /**
       * 供应商绑定商品ID
       */
      provideCommodityId?: string
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 供应商 0=多彩宝 1=京东
       */
      provideSource?: number
      /**
       * 实名制类型 0-自动回填 1-手动填写
       */
      realNameInputType: number
      /**
       * 是否实名制购买：0-否 1-是
       */
      realNamePurchase?: '0' | '1'
      /**
       * 是否支持换货 0不支持 1支持
       */
      replacementStatus?: number
      /**
       * 商品资源id
       */
      resourceId?: string
      /**
       * 售后装填 -1=不可申请  0可申请
       */
      saleStatus?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * 销售渠道名称
       */
      sellChannelName?: string
      /**
       * 是否支持7天无理由退款 0不支持 1支持
       */
      sevenDaysRefundStatus?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * sku描述
       */
      skuDesc?: string
      /**
       * skuid
       */
      skuId?: string
      /**
       * 库存购买日期
       */
      stockDate?: string
      /**
       * 使用日期字符串
       */
      stockDateStr?: string
      /**
       * 库存购买结束日期
       */
      stockEndDate?: string
      stockEndTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存Id
       */
      stockId?: string
      stockStartTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 禁售地址
       */
      stopDeliverAddress?: string[]
      /**
       * 剩余数量
       */
      surplusCount?: number
      /**
       * 第三方商品Id
       */
      thirdCommodityId?: string
      /**
       * 总价
       */
      totalPrice?: number
      /**
       * 商品所属店铺机构
       */
      unitOrgCode?: string
      /**
       * 单价
       */
      unitPrice?: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 重量（克）
       */
      weight?: number
      /**
       * 核销渠道
       */
      writeOffChannel?:
        | '0'
        | '1'
        | '2'
        | '3'
        | '4'
        | '5'
        | '6'
        | '7'
        | '8'
        | '9'
        | '10'
        | '11'
        | '12'
        | '13'
      /**
       * 第三方商品Id
       */
      writeOffChannelCommodityId?: string
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }
      /**
       * 可配送区域类型
       */
      zoneLimitType?: '0' | '1' | '2'
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 商户图片
     */
    merchantPic?: string
    /**
     * 商户联系方式
     */
    merchantTel?: string
    /**
     * 是否需要附加实名用户信息
     */
    needUserInfo?: boolean
    /**
     * 订单类型
     */
    orderClassifyType?: number
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 兑换商品类父级商品订单编号
     */
    parentCommodityOrderNo?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 实名制类型 0-自动回填 1-手动填写
     */
    realNameInputType: number
    /**
     * 店铺营业时间
     */
    storeOpenPreiod?: string
    /**
     * 订单总金额
     */
    totalAmount?: number
    /**
     * 总商品数量
     */
    totalQuantity?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  orderType?: number
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 预下单内容类型 1 标准电商 2标准虚拟  3混合下单  4标准核销
   */
  preOrderContentType?: '1' | '2' | '4' | '5' | '3'
  /**
   * 预下单任务Id
   */
  preOrderId?: string
  /**
   * 预下单类型
   */
  preOrderType?: number
  realNameStatusInfo?: {
    /**
     * 跳转链接名称
     */
    linkName?: string
    /**
     * 是否已经实名认证：0-否1-是
     */
    realNameAuth?: boolean
    /**
     * 注意文案
     */
    tip?: string
    /**
     * 标题文案
     */
    title?: string
    /**
     * 跳转地址
     */
    url?: string
  }
  /**
   * 自提地址Id
   */
  selfPickupAddressId?: string
  /**
   * 发货类型 0正常发货 1门店自提
   */
  shipType?: number
  /**
   * 是否显示平台运营相关规则
   */
  showBusinessRuleInfo?: boolean
  /**
   * 是否需要显示实名认证
   */
  showNeedRealNameAuth?: boolean
  /**
   * 是否支持积分支付
   */
  supportPayType?: boolean
  /**
   * 是否为翼支付支付：true-是，false否
   */
  supportYiPay?: boolean
  /**
   * 提示信息
   */
  tips?: string
  /**
   * 酒店订单酒店Id
   */
  tvHotelId?: string
  /**
   * 酒店订单酒店房间号
   */
  tvHotelRoomNo?: string
  /**
   * 订单包含的子机构编码
   */
  unitOrgCode?: string[]
}

/**
 * 接口 [兑换商品预下单↗](https://yapi.gogpay.cn/project/906/interface/api/407748) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsPreOrder`
 */
type ApiOrderExchangeGoodsExchangeGoodsPreOrderRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/exchangeGoods/exchangeGoodsPreOrder',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [兑换商品预下单↗](https://yapi.gogpay.cn/project/906/interface/api/407748) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsPreOrder`
 */
const apiOrderExchangeGoodsExchangeGoodsPreOrderRequestConfig: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_21,
    devUrl: devUrl_0_5_0_21,
    prodUrl: prodUrl_0_5_0_21,
    path: '/order/api/exchangeGoods/exchangeGoodsPreOrder',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderExchangeGoodsExchangeGoodsPreOrder',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '兑换商品预下单', author: '511号开发' },
  }

/**
 * 接口 [兑换商品预下单↗](https://yapi.gogpay.cn/project/906/interface/api/407748) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsPreOrder`
 */
export const apiOrderExchangeGoodsExchangeGoodsPreOrder = /*#__PURE__*/ (
  requestData: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderExchangeGoodsExchangeGoodsPreOrderResponse>(
    prepare(
      apiOrderExchangeGoodsExchangeGoodsPreOrderRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderExchangeGoodsExchangeGoodsPreOrder.requestConfig =
  apiOrderExchangeGoodsExchangeGoodsPreOrderRequestConfig

/**
 * 接口 [兑换商品下单↗](https://yapi.gogpay.cn/project/906/interface/api/407753) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsTrade`
 */
export interface ApiOrderExchangeGoodsExchangeGoodsTradeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 收获人姓名
   */
  consigneeName?: string
  /**
   * 收货人手机号
   */
  consigneeTel?: string
  /**
   * 优惠券Id
   */
  couponId?: string
  /**
   * 配送时间 不传就是立即配送
   */
  deliverDate?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  invoiceInfo?: {
    /**
     * 企业地址
     */
    address?: string
    /**
     * 银行账号
     */
    bankAccount?: string
    /**
     * 开户银行
     */
    bankName?: string
    /**
     * 发票邮箱地址
     */
    email?: string
    /**
     * 纳税人识别号
     */
    taxPayerNumber?: string
    /**
     * 发票抬头
     */
    title: string
    /**
     * 抬头类型 1个人 2企业
     */
    titleType: number
  }
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经纬度类型
   */
  locationType?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 用户密码
   */
  password?: string[]
  /**
   * 支付方式 4微信 可不传
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 预下单任务Id
   */
  preOrderId: string
  /**
   * 订单信息
   */
  tradeOrderInfo?: {
    /**
     * 购买数量
     */
    count?: number
    /**
     * 使用积分购买数量
     */
    integralCount?: number
    /**
     * 订单扩展字段
     */
    orderExtendData?: {
      /**
       * 扩展字段的key，业务系统可自由定制
       */
      key?: string
      /**
       * 扩展字段的中文名称，会展示在订单详情页面，如:积分、金币、黔贝等
       */
      name?: string
      /**
       * 扩展字段的排序序号，如果有多个字段的情况下可指定，否则按照入参顺序排序
       */
      sort?: number
      /**
       * 扩展字段的类型，可用于业务系统自行判断使用，中台内置类型  POINT：积分
       */
      type?: string
      /**
       * 扩展字段的值，内容可自由定制。如100、302等
       */
      value?: string
    }[]
    /**
     * 临时订单Id，由预下单接口返回
     */
    orderId: string
    /**
     * 订单备注
     */
    remark?: string
    /**
     * 使用日期/库存日期
     */
    stockDate?: string
    /**
     * 用户信息
     */
    userInfoList?: {
      /**
       * 身份证号码
       */
      idCard?: string
      /**
       * 用户姓名
       */
      name?: string
      /**
       * 手机号码
       */
      phone?: string
    }[]
    /**
     * 核销门店Id
     */
    writeOffStoreId?: string
  }[]
}

/**
 * 接口 [兑换商品下单↗](https://yapi.gogpay.cn/project/906/interface/api/407753) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsTrade`
 */
export interface ApiOrderExchangeGoodsExchangeGoodsTradeResponse {
  /**
   * 购买数量
   */
  amount?: number
  /**
   * 商品数量
   */
  amt?: string
  /**
   * 地区编码
   */
  areaCode?: string
  /**
   * 业务机构编码
   */
  businessOrgCode?: string
  /**
   * 客户端Ip
   */
  clientIp?: string
  /**
   * 客户名称
   */
  consName?: string
  /**
   * 户号
   */
  consNo?: string
  /**
   * 订单分润金额
   */
  dcbFee?: string
  /**
   * 优惠项目
   */
  discountItems?: {
    /**
     * 活动Id
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 优惠金额
     */
    amt?: string
    /**
     * 出资方；1=平台出资，2=商家出资，3=共同出资
     */
    contributionType: number
    /**
     * 优惠标识，特殊标识，用于与优惠资金池匹配
     */
    flag?: string
    /**
     * 共同出资方式；1=商家出资占比，2=平台出资占比
     */
    jointContributionType: number
    /**
     * 共同出资占比
     */
    jointContributionVal: string
    /**
     * 优惠类型
     */
    type?: string
  }[]
  /**
   * 优惠金额
   */
  discountedAmt?: string
  /**
   * 订单包含所有商品列表，渠道支付使用
   */
  goodsList?: {
    /**
     * 数量
     */
    amount?: number
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 数量
     */
    count?: number
    goodsDiscountAmt?: string
    goodsDiscountId?: string
    /**
     * 商品图片
     */
    icon?: string
    /**
     * 商品资源Id
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * 单价
     */
    price?: string
    /**
     * 商品结算价
     */
    settlePrice?: string
    /**
     * 规格
     */
    standard?: string
    superimposeDiscountType?: number
    /**
     * 总额
     */
    totalAmt?: string
    /**
     * 单价
     */
    unitPrice?: string
  }[]
  /**
   * 是否属于幂等请求
   */
  idempotent?: boolean
  /**
   * 是否使用渠道优惠 1=不使用
   */
  isUseActPay?: number
  /**
   * 是否使用新版支付
   */
  isUseNewPay?: number
  needRealNameAuth?: boolean
  /**
   * 微信用户openId
   */
  openId?: string
  /**
   * 订单Id
   */
  orderId?: string
  /**
   * 订单编号 多彩宝交易中心填入
   */
  orderNo?: string
  orderPayRemark?: string
  orderPayTitle?: string
  /**
   * 子单是否合并显示  0不合并  1合并
   */
  orderStick?: number
  /**
   * 订单列表
   */
  orders?: {
    /**
     * 金额
     */
    amt?: string
    /**
     * 订单分润金额
     */
    dcbFee?: string
    delaySettlement?: boolean
    /**
     * 优惠项目
     */
    discountItems?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 活动名称
       */
      activityName?: string
      /**
       * 优惠金额
       */
      amt?: string
      /**
       * 出资方；1=平台出资，2=商家出资，3=共同出资
       */
      contributionType: number
      /**
       * 优惠标识，特殊标识，用于与优惠资金池匹配
       */
      flag?: string
      /**
       * 共同出资方式；1=商家出资占比，2=平台出资占比
       */
      jointContributionType: number
      /**
       * 共同出资占比
       */
      jointContributionVal: string
      /**
       * 优惠类型
       */
      type?: string
    }[]
    /**
     * 优惠金额
     */
    discountedAmt?: string
    /**
     * 商品列表
     */
    goodsList?: {
      /**
       * 数量
       */
      amount?: number
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 数量
       */
      count?: number
      goodsDiscountAmt?: string
      goodsDiscountId?: string
      /**
       * 商品图片
       */
      icon?: string
      /**
       * 商品资源Id
       */
      id?: string
      /**
       * 商品名称
       */
      name?: string
      /**
       * 单价
       */
      price?: string
      /**
       * 商品结算价
       */
      settlePrice?: string
      /**
       * 规格
       */
      standard?: string
      superimposeDiscountType?: number
      /**
       * 总额
       */
      totalAmt?: string
      /**
       * 单价
       */
      unitPrice?: string
    }[]
    /**
     * 商户Id
     */
    merchantId?: string
    /**
     * 订单Id， 业务系统自己的Id
     */
    orderId?: string
    /**
     * 订单编号 多彩宝交易中心填入
     */
    orderNo?: string
    /**
     * 订单类型 1普通订单 2秒杀订单
     */
    orderType?: number
    /**
     * 支付金额
     */
    payAmt?: string
    /**
     * 预下单临时订单Id
     */
    preOrderId?: string
    /**
     * 订单类型 00其他   01 核销订单 02 物流订单
     */
    shopType?: string
    /**
     * SKU列表
     */
    skuInfos?: {
      /**
       * 活动Id
       */
      activityId?: string
      /**
       * 商品Id
       */
      commodityId: string
      /**
       * 购买数量
       */
      count: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 使用多彩豆购买商品数量
       */
      integralCount?: number
      /**
       * 销售渠道Id
       */
      sellChannelId?: string
      /**
       * SKU ID
       */
      skuId: string
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 购买日期 格式 yyyy-MM-dd
       */
      stockDate?: string
      /**
       * 购买结束日期 格式 yyyy-MM-dd
       */
      stockEndDate?: string
    }[]
    /**
     * 订单关闭秒数
     */
    surplusTime?: number
    /**
     * 子机构编码
     */
    unitOrgCode?: string
    /**
     * 子机构名称
     */
    unitOrgName?: string
  }[]
  /**
   * 机构编码
   */
  orgCode?: string
  /**
   * 支付金额
   */
  payAmt?: string
  /**
   * 支付类型
   */
  payType?: string
  productAttr1?: string
  /**
   * 支付成功回调地址
   */
  returnUrl?: string
  /**
   * 订单来源
   */
  source?: string
  specifyPayMethods?: string[]
  /**
   * 扩展支付参数，用于进行微信支付或其他第三方支付
   */
  thirdParams?: {}
  /**
   * 业务类型
   */
  type?: string
  /**
   * 子机构编码
   */
  unitOrgCode?: string
  /**
   * 子机构名称
   */
  unitOrgName?: string
  /**
   * 虚拟货币使用情况
   */
  virtualCurrencyPayList?: {
    /**
     * 虚拟货币抵扣金额
     */
    discountedAmt?: number
    /**
     * 外部虚拟支付订单号
     */
    outPayOrderId?: string
    /**
     * 虚拟货币使用数量
     */
    useAmount?: number
    /**
     * 虚拟货币类型
     */
    virtualCurrencyType?: string
  }[]
}

/**
 * 接口 [兑换商品下单↗](https://yapi.gogpay.cn/project/906/interface/api/407753) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsTrade`
 */
type ApiOrderExchangeGoodsExchangeGoodsTradeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/exchangeGoods/exchangeGoodsTrade',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [兑换商品下单↗](https://yapi.gogpay.cn/project/906/interface/api/407753) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsTrade`
 */
const apiOrderExchangeGoodsExchangeGoodsTradeRequestConfig: ApiOrderExchangeGoodsExchangeGoodsTradeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_21,
    devUrl: devUrl_0_5_0_21,
    prodUrl: prodUrl_0_5_0_21,
    path: '/order/api/exchangeGoods/exchangeGoodsTrade',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderExchangeGoodsExchangeGoodsTrade',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '兑换商品下单', author: '511号开发' },
  }

/**
 * 接口 [兑换商品下单↗](https://yapi.gogpay.cn/project/906/interface/api/407753) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/exchangeGoodsTrade`
 */
export const apiOrderExchangeGoodsExchangeGoodsTrade = /*#__PURE__*/ (
  requestData: ApiOrderExchangeGoodsExchangeGoodsTradeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderExchangeGoodsExchangeGoodsTradeResponse>(
    prepare(apiOrderExchangeGoodsExchangeGoodsTradeRequestConfig, requestData),
    ...args,
  )
}

apiOrderExchangeGoodsExchangeGoodsTrade.requestConfig =
  apiOrderExchangeGoodsExchangeGoodsTradeRequestConfig

/**
 * 接口 [兑换标电商品计算邮费↗](https://yapi.gogpay.cn/project/906/interface/api/407838) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/calcPostFee`
 */
export interface ApiOrderExchangeGoodsCalcPostFeeRequest {
  consigneeAddress: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * 预下单任务Id
   */
  preOrderId: string
}

/**
 * 接口 [兑换标电商品计算邮费↗](https://yapi.gogpay.cn/project/906/interface/api/407838) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/calcPostFee`
 */
export interface ApiOrderExchangeGoodsCalcPostFeeResponse {
  /**
   * 订单信息
   */
  orderInfo?: {
    /**
     * SKU信息
     */
    commodityInfo?: unknown[]
    /**
     * 所属商户Id
     */
    merchantId?: string
    /**
     * 订单Id，临时用，非真实
     */
    orderId?: string
    /**
     * 总邮费
     */
    postFee?: number
  }[]
}

/**
 * 接口 [兑换标电商品计算邮费↗](https://yapi.gogpay.cn/project/906/interface/api/407838) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/calcPostFee`
 */
type ApiOrderExchangeGoodsCalcPostFeeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/exchangeGoods/calcPostFee',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [兑换标电商品计算邮费↗](https://yapi.gogpay.cn/project/906/interface/api/407838) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/calcPostFee`
 */
const apiOrderExchangeGoodsCalcPostFeeRequestConfig: ApiOrderExchangeGoodsCalcPostFeeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_21,
    devUrl: devUrl_0_5_0_21,
    prodUrl: prodUrl_0_5_0_21,
    path: '/order/api/exchangeGoods/calcPostFee',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderExchangeGoodsCalcPostFee',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '兑换标电商品计算邮费', author: '511号开发' },
  }

/**
 * 接口 [兑换标电商品计算邮费↗](https://yapi.gogpay.cn/project/906/interface/api/407838) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-85券兑换商品↗](https://yapi.gogpay.cn/project/906/interface/api/cat_72305)
 * @请求头 `POST /order/api/exchangeGoods/calcPostFee`
 */
export const apiOrderExchangeGoodsCalcPostFee = /*#__PURE__*/ (
  requestData: ApiOrderExchangeGoodsCalcPostFeeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderExchangeGoodsCalcPostFeeResponse>(
    prepare(apiOrderExchangeGoodsCalcPostFeeRequestConfig, requestData),
    ...args,
  )
}

apiOrderExchangeGoodsCalcPostFee.requestConfig =
  apiOrderExchangeGoodsCalcPostFeeRequestConfig

const mockUrl_0_5_0_22 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_22 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_22 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_22 = 'data' as any

/**
 * 接口 [获取用户店铺发票列表↗](https://yapi.gogpay.cn/project/906/interface/api/459988) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderList`
 */
export interface ApiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequest {
  /**
   * 下单起始时间
   */
  beginTime?: string
  /**
   * 下单结束时间
   */
  endTime?: string
  /**
   * 筛选状态 0未开票 1已开票
   */
  invoiceStatus?: number
  /**
   * 商户店铺Id
   */
  merchantId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取用户店铺发票列表↗](https://yapi.gogpay.cn/project/906/interface/api/459988) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderList`
 */
export interface ApiOrderMerchantInvoiceFindMerchantInvoiceOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单实付款
     */
    actualReceivable?: number
    /**
     * 商品数据
     */
    commodityInfo?: {
      /**
       * 商品类目Id
       */
      categoryId?: string
      /**
       * 商品Id
       */
      commodityId?: string
      /**
       * 商品类目参数
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 已发货数量
       */
      deliverQuantity?: number
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 商品名称
       */
      name?: string
      /**
       * 包装费
       */
      packagePrice?: number
      /**
       * 商品图片
       */
      pic?: string
      /**
       * 邮费
       */
      postFee?: number
      /**
       * 总价
       */
      price?: number
      /**
       * 数量
       */
      quantity?: number
      /**
       * 售后记录Id
       */
      saleAfterId?: string
      /**
       * 售后状态文案
       */
      saleAfterName?: string
      /**
       * 售后状态
       */
      saleAfterStatus?: number
      /**
       * 售后类型
       */
      saleAfterType?: number
      /**
       * 售后类型文案
       */
      saleAfterTypeName?: string
      /**
       * 发货状态 0未发货 1已发货
       */
      shipStatus?: number
      /**
       * sku id
       */
      skuId?: string
      /**
       * SKU规格信息
       */
      skuSpecs?: string
      /**
       * 标签
       */
      tags?: string[]
      /**
       * 单价
       */
      unitPrice?: number
    }[]
    /**
     * 发票图片地址
     */
    invoiceImageUrl?: string
    /**
     * 发票文件地址
     */
    invoicePdfUrl?: string
    /**
     * 开票状态
     */
    invoiceStatus?: number
    /**
     * 开票状态标签
     */
    invoiceStatusLabel?: string
    /**
     * 发票申请时间
     */
    invoiceTime?: string
    /**
     * 发票抬头
     */
    invoiceTitle?: string
    /**
     * 发票抬头类型 1个人 2企业
     */
    invoiceTitleType?: number
    /**
     * 发票类型 1普通发票
     */
    invoiceType?: number
    /**
     * 开通开票功能跳转地址
     */
    openOnlineInvoiceUrl?: string
    /**
     * 订单总金额
     */
    orderAmount?: number
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单状态
     */
    orderStatus?: number
    /**
     * 订单状态标签
     */
    orderStatusLabel?: string
    /**
     * 是否支持在线开票 0否 1是
     */
    storeOnlineInvoiceFlag?: boolean
    /**
     * 买方纳税人识别号，抬头时企业时有值
     */
    taxPayerNumber?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取用户店铺发票列表↗](https://yapi.gogpay.cn/project/906/interface/api/459988) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderList`
 */
type ApiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/api/merchantInvoice/findMerchantInvoiceOrderList',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取用户店铺发票列表↗](https://yapi.gogpay.cn/project/906/interface/api/459988) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderList`
 */
const apiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequestConfig: ApiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_22,
    devUrl: devUrl_0_5_0_22,
    prodUrl: prodUrl_0_5_0_22,
    path: '/order/api/merchantInvoice/findMerchantInvoiceOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantInvoiceFindMerchantInvoiceOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺发票列表', author: '503号开发' },
  }

/**
 * 接口 [获取用户店铺发票列表↗](https://yapi.gogpay.cn/project/906/interface/api/459988) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderList`
 */
export const apiOrderMerchantInvoiceFindMerchantInvoiceOrderList =
  /*#__PURE__*/ (
    requestData: ApiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderMerchantInvoiceFindMerchantInvoiceOrderListResponse>(
      prepare(
        apiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderMerchantInvoiceFindMerchantInvoiceOrderList.requestConfig =
  apiOrderMerchantInvoiceFindMerchantInvoiceOrderListRequestConfig

/**
 * 接口 [获取用户店铺发票详情↗](https://yapi.gogpay.cn/project/906/interface/api/460068) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderDetail`
 */
export interface ApiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [获取用户店铺发票详情↗](https://yapi.gogpay.cn/project/906/interface/api/460068) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderDetail`
 */
export interface ApiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailResponse {
  /**
   * 订单实付款
   */
  actualReceivable?: number
  /**
   * 商品数据
   */
  commodityInfo?: {
    /**
     * 商品类目Id
     */
    categoryId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品类目参数
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 已发货数量
     */
    deliverQuantity?: number
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    name?: string
    /**
     * 包装费
     */
    packagePrice?: number
    /**
     * 商品图片
     */
    pic?: string
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 总价
     */
    price?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 售后记录Id
     */
    saleAfterId?: string
    /**
     * 售后状态文案
     */
    saleAfterName?: string
    /**
     * 售后状态
     */
    saleAfterStatus?: number
    /**
     * 售后类型
     */
    saleAfterType?: number
    /**
     * 售后类型文案
     */
    saleAfterTypeName?: string
    /**
     * 发货状态 0未发货 1已发货
     */
    shipStatus?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * SKU规格信息
     */
    skuSpecs?: string
    /**
     * 标签
     */
    tags?: string[]
    /**
     * 单价
     */
    unitPrice?: number
  }[]
  /**
   * 发票图片地址
   */
  invoiceImageUrl?: string
  /**
   * 发票文件地址
   */
  invoicePdfUrl?: string
  /**
   * 开票状态
   */
  invoiceStatus?: number
  /**
   * 开票状态标签
   */
  invoiceStatusLabel?: string
  /**
   * 发票申请时间
   */
  invoiceTime?: string
  /**
   * 发票抬头
   */
  invoiceTitle?: string
  /**
   * 发票抬头类型 1个人 2企业
   */
  invoiceTitleType?: number
  /**
   * 发票类型 1普通发票
   */
  invoiceType?: number
  /**
   * 开通开票功能跳转地址
   */
  openOnlineInvoiceUrl?: string
  /**
   * 订单总金额
   */
  orderAmount?: number
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单状态
   */
  orderStatus?: number
  /**
   * 订单状态标签
   */
  orderStatusLabel?: string
  /**
   * 是否支持在线开票 0否 1是
   */
  storeOnlineInvoiceFlag?: boolean
  /**
   * 买方纳税人识别号，抬头时企业时有值
   */
  taxPayerNumber?: string
}

/**
 * 接口 [获取用户店铺发票详情↗](https://yapi.gogpay.cn/project/906/interface/api/460068) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderDetail`
 */
type ApiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/api/merchantInvoice/findMerchantInvoiceOrderDetail',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [获取用户店铺发票详情↗](https://yapi.gogpay.cn/project/906/interface/api/460068) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderDetail`
 */
const apiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequestConfig: ApiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_22,
    devUrl: devUrl_0_5_0_22,
    prodUrl: prodUrl_0_5_0_22,
    path: '/order/api/merchantInvoice/findMerchantInvoiceOrderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderMerchantInvoiceFindMerchantInvoiceOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户店铺发票详情', author: '511号开发' },
  }

/**
 * 接口 [获取用户店铺发票详情↗](https://yapi.gogpay.cn/project/906/interface/api/460068) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/findMerchantInvoiceOrderDetail`
 */
export const apiOrderMerchantInvoiceFindMerchantInvoiceOrderDetail =
  /*#__PURE__*/ (
    requestData: ApiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailResponse>(
      prepare(
        apiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderMerchantInvoiceFindMerchantInvoiceOrderDetail.requestConfig =
  apiOrderMerchantInvoiceFindMerchantInvoiceOrderDetailRequestConfig

/**
 * 接口 [商户端上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/460123) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/uploadInvoice`
 */
export interface ApiOrderMerchantInvoiceUploadInvoiceRequest {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 发票文件地址
   */
  url?: string
}

/**
 * 接口 [商户端上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/460123) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/uploadInvoice`
 */
export interface ApiOrderMerchantInvoiceUploadInvoiceResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商户端上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/460123) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/uploadInvoice`
 */
type ApiOrderMerchantInvoiceUploadInvoiceRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchantInvoice/uploadInvoice',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商户端上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/460123) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/uploadInvoice`
 */
const apiOrderMerchantInvoiceUploadInvoiceRequestConfig: ApiOrderMerchantInvoiceUploadInvoiceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_22,
    devUrl: devUrl_0_5_0_22,
    prodUrl: prodUrl_0_5_0_22,
    path: '/order/api/merchantInvoice/uploadInvoice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantInvoiceUploadInvoice',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商户端上传发票文件', author: '511号开发' },
  }

/**
 * 接口 [商户端上传发票文件↗](https://yapi.gogpay.cn/project/906/interface/api/460123) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/uploadInvoice`
 */
export const apiOrderMerchantInvoiceUploadInvoice = /*#__PURE__*/ (
  requestData: ApiOrderMerchantInvoiceUploadInvoiceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantInvoiceUploadInvoiceResponse>(
    prepare(apiOrderMerchantInvoiceUploadInvoiceRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantInvoiceUploadInvoice.requestConfig =
  apiOrderMerchantInvoiceUploadInvoiceRequestConfig

/**
 * 接口 [商家端在线开具发票↗](https://yapi.gogpay.cn/project/906/interface/api/461838) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/makeOutInvoiceV2`
 */
export interface ApiOrderMerchantInvoiceMakeOutInvoiceV2Request {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [商家端在线开具发票↗](https://yapi.gogpay.cn/project/906/interface/api/461838) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/makeOutInvoiceV2`
 */
export interface ApiOrderMerchantInvoiceMakeOutInvoiceV2Response {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商家端在线开具发票↗](https://yapi.gogpay.cn/project/906/interface/api/461838) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/makeOutInvoiceV2`
 */
type ApiOrderMerchantInvoiceMakeOutInvoiceV2RequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchantInvoice/makeOutInvoiceV2',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商家端在线开具发票↗](https://yapi.gogpay.cn/project/906/interface/api/461838) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/makeOutInvoiceV2`
 */
const apiOrderMerchantInvoiceMakeOutInvoiceV2RequestConfig: ApiOrderMerchantInvoiceMakeOutInvoiceV2RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_22,
    devUrl: devUrl_0_5_0_22,
    prodUrl: prodUrl_0_5_0_22,
    path: '/order/api/merchantInvoice/makeOutInvoiceV2',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantInvoiceMakeOutInvoiceV2',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商家端在线开具发票', author: '511号开发' },
  }

/**
 * 接口 [商家端在线开具发票↗](https://yapi.gogpay.cn/project/906/interface/api/461838) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商户开票相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_80878)
 * @请求头 `POST /order/api/merchantInvoice/makeOutInvoiceV2`
 */
export const apiOrderMerchantInvoiceMakeOutInvoiceV2 = /*#__PURE__*/ (
  requestData: ApiOrderMerchantInvoiceMakeOutInvoiceV2Request,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantInvoiceMakeOutInvoiceV2Response>(
    prepare(apiOrderMerchantInvoiceMakeOutInvoiceV2RequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantInvoiceMakeOutInvoiceV2.requestConfig =
  apiOrderMerchantInvoiceMakeOutInvoiceV2RequestConfig

const mockUrl_0_5_0_23 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_23 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_23 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_23 = 'data' as any

/**
 * 接口 [获取自提码↗](https://yapi.gogpay.cn/project/906/interface/api/463940) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/getSelfPickupCode`
 */
export interface ApiOrderOrderSelfPickupGetSelfPickupCodeRequest {
  /**
   * 详细地址
   */
  addressDetails?: string
  /**
   * 市级区划
   */
  cityCode: string
  /**
   * 市级区划名
   */
  cityName: string
  distance?: string
  /**
   * 区县区划
   */
  districtCode: string
  /**
   * 区县区划名
   */
  districtName: string
  ip?: string
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 订单详情地址
   */
  orderDetailUrl?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 省级区划
   */
  provinceCode: string
  /**
   * 省级区划名
   */
  provinceName: string
  /**
   * 券码
   */
  selfPickupCode?: string
}

/**
 * 接口 [获取自提码↗](https://yapi.gogpay.cn/project/906/interface/api/463940) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/getSelfPickupCode`
 */
export interface ApiOrderOrderSelfPickupGetSelfPickupCodeResponse {
  /**
   * 详细地址
   */
  addressDetails?: string
  /**
   * 市级区划
   */
  cityCode: string
  /**
   * 市级区划名
   */
  cityName: string
  distance?: string
  /**
   * 区县区划
   */
  districtCode: string
  /**
   * 区县区划名
   */
  districtName: string
  ip?: string
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 订单详情地址
   */
  orderDetailUrl?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 省级区划
   */
  provinceCode: string
  /**
   * 省级区划名
   */
  provinceName: string
  /**
   * 券码
   */
  selfPickupCode?: string
}

/**
 * 接口 [获取自提码↗](https://yapi.gogpay.cn/project/906/interface/api/463940) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/getSelfPickupCode`
 */
type ApiOrderOrderSelfPickupGetSelfPickupCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/self/pickup/getSelfPickupCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取自提码↗](https://yapi.gogpay.cn/project/906/interface/api/463940) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/getSelfPickupCode`
 */
const apiOrderOrderSelfPickupGetSelfPickupCodeRequestConfig: ApiOrderOrderSelfPickupGetSelfPickupCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_23,
    devUrl: devUrl_0_5_0_23,
    prodUrl: prodUrl_0_5_0_23,
    path: '/order/api/order/self/pickup/getSelfPickupCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderSelfPickupGetSelfPickupCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取自提码', author: '503号开发' },
  }

/**
 * 接口 [获取自提码↗](https://yapi.gogpay.cn/project/906/interface/api/463940) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/getSelfPickupCode`
 */
export const apiOrderOrderSelfPickupGetSelfPickupCode = /*#__PURE__*/ (
  requestData: ApiOrderOrderSelfPickupGetSelfPickupCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderSelfPickupGetSelfPickupCodeResponse>(
    prepare(apiOrderOrderSelfPickupGetSelfPickupCodeRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderSelfPickupGetSelfPickupCode.requestConfig =
  apiOrderOrderSelfPickupGetSelfPickupCodeRequestConfig

/**
 * 接口 [获取自提码人脸认证↗](https://yapi.gogpay.cn/project/906/interface/api/463941) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/liveCheck`
 */
export interface ApiOrderOrderSelfPickupLiveCheckRequest {
  /**
   * 认证token
   */
  authToken: string
  /**
   * 订单号
   */
  orderNo: string
}

/**
 * 接口 [获取自提码人脸认证↗](https://yapi.gogpay.cn/project/906/interface/api/463941) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/liveCheck`
 */
export interface ApiOrderOrderSelfPickupLiveCheckResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [获取自提码人脸认证↗](https://yapi.gogpay.cn/project/906/interface/api/463941) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/liveCheck`
 */
type ApiOrderOrderSelfPickupLiveCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/self/pickup/liveCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取自提码人脸认证↗](https://yapi.gogpay.cn/project/906/interface/api/463941) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/liveCheck`
 */
const apiOrderOrderSelfPickupLiveCheckRequestConfig: ApiOrderOrderSelfPickupLiveCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_23,
    devUrl: devUrl_0_5_0_23,
    prodUrl: prodUrl_0_5_0_23,
    path: '/order/api/order/self/pickup/liveCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderSelfPickupLiveCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取自提码人脸认证', author: '503号开发' },
  }

/**
 * 接口 [获取自提码人脸认证↗](https://yapi.gogpay.cn/project/906/interface/api/463941) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/liveCheck`
 */
export const apiOrderOrderSelfPickupLiveCheck = /*#__PURE__*/ (
  requestData: ApiOrderOrderSelfPickupLiveCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderSelfPickupLiveCheckResponse>(
    prepare(apiOrderOrderSelfPickupLiveCheckRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderSelfPickupLiveCheck.requestConfig =
  apiOrderOrderSelfPickupLiveCheckRequestConfig

/**
 * 接口 [自提码取货↗](https://yapi.gogpay.cn/project/906/interface/api/463942) 的 **请求类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/pickUpGoods`
 */
export interface ApiOrderOrderSelfPickupPickUpGoodsRequest {
  /**
   * 详细地址
   */
  addressDetails?: string
  /**
   * 市级区划
   */
  cityCode: string
  /**
   * 市级区划名
   */
  cityName: string
  /**
   * 货物照片
   */
  commodityPicList: string[]
  /**
   * 客户与货物合照
   */
  customerAndCommodityPicList: string[]
  /**
   * 区县区划
   */
  districtCode: string
  /**
   * 区县区划名
   */
  districtName: string
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 提货订单照片
   */
  orderPickPicList: string[]
  /**
   * 省级区划
   */
  provinceCode: string
  /**
   * 省级区划名
   */
  provinceName: string
}

/**
 * 接口 [自提码取货↗](https://yapi.gogpay.cn/project/906/interface/api/463942) 的 **返回类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/pickUpGoods`
 */
export interface ApiOrderOrderSelfPickupPickUpGoodsResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [自提码取货↗](https://yapi.gogpay.cn/project/906/interface/api/463942) 的 **请求配置的类型**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/pickUpGoods`
 */
type ApiOrderOrderSelfPickupPickUpGoodsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/order/self/pickup/pickUpGoods',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [自提码取货↗](https://yapi.gogpay.cn/project/906/interface/api/463942) 的 **请求配置**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/pickUpGoods`
 */
const apiOrderOrderSelfPickupPickUpGoodsRequestConfig: ApiOrderOrderSelfPickupPickUpGoodsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_23,
    devUrl: devUrl_0_5_0_23,
    prodUrl: prodUrl_0_5_0_23,
    path: '/order/api/order/self/pickup/pickUpGoods',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOrderSelfPickupPickUpGoods',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '自提码取货', author: '503号开发' },
  }

/**
 * 接口 [自提码取货↗](https://yapi.gogpay.cn/project/906/interface/api/463942) 的 **请求函数**
 *
 * @作者 503号开发
 * @分类 [客户端-自提功能↗](https://yapi.gogpay.cn/project/906/interface/api/cat_82685)
 * @请求头 `POST /order/api/order/self/pickup/pickUpGoods`
 */
export const apiOrderOrderSelfPickupPickUpGoods = /*#__PURE__*/ (
  requestData: ApiOrderOrderSelfPickupPickUpGoodsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOrderSelfPickupPickUpGoodsResponse>(
    prepare(apiOrderOrderSelfPickupPickUpGoodsRequestConfig, requestData),
    ...args,
  )
}

apiOrderOrderSelfPickupPickUpGoods.requestConfig =
  apiOrderOrderSelfPickupPickUpGoodsRequestConfig

const mockUrl_0_5_0_24 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_24 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_24 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_24 = 'data' as any

/**
 * 接口 [一码贵州以旧换新订单推送结果查询同步↗](https://yapi.gogpay.cn/project/906/interface/api/465505) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus`
 */
export interface ApiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequest {
  /**
   * 订单编号列表
   */
  dcbOrderNo?: string[]
}

/**
 * 接口 [一码贵州以旧换新订单推送结果查询同步↗](https://yapi.gogpay.cn/project/906/interface/api/465505) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus`
 */
export interface ApiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [一码贵州以旧换新订单推送结果查询同步↗](https://yapi.gogpay.cn/project/906/interface/api/465505) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus`
 */
type ApiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [一码贵州以旧换新订单推送结果查询同步↗](https://yapi.gogpay.cn/project/906/interface/api/465505) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus`
 */
const apiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequestConfig: ApiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_24,
    devUrl: devUrl_0_5_0_24,
    prodUrl: prodUrl_0_5_0_24,
    path: '/order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '一码贵州以旧换新订单推送结果查询同步',
      author: '511号开发',
    },
  }

/**
 * 接口 [一码贵州以旧换新订单推送结果查询同步↗](https://yapi.gogpay.cn/project/906/interface/api/465505) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/checkOldChangeOrderPushStatus`
 */
export const apiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatus =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusResponse>(
      prepare(
        apiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatus.requestConfig =
  apiOrderImsApiYardGoOrderPushCheckOldChangeOrderPushStatusRequestConfig

/**
 * 接口 [一码贵州以旧换新订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/465512) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/oldChangeOrderPush`
 */
export interface ApiOrderImsApiYardGoOrderPushOldChangeOrderPushRequest {
  /**
   * 订单编号列表
   */
  dcbOrderNo?: string[]
}

/**
 * 接口 [一码贵州以旧换新订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/465512) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/oldChangeOrderPush`
 */
export interface ApiOrderImsApiYardGoOrderPushOldChangeOrderPushResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [一码贵州以旧换新订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/465512) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/oldChangeOrderPush`
 */
type ApiOrderImsApiYardGoOrderPushOldChangeOrderPushRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/yardGoOrderPush/oldChangeOrderPush',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [一码贵州以旧换新订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/465512) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/oldChangeOrderPush`
 */
const apiOrderImsApiYardGoOrderPushOldChangeOrderPushRequestConfig: ApiOrderImsApiYardGoOrderPushOldChangeOrderPushRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_24,
    devUrl: devUrl_0_5_0_24,
    prodUrl: prodUrl_0_5_0_24,
    path: '/order/imsApi/yardGoOrderPush/oldChangeOrderPush',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiYardGoOrderPushOldChangeOrderPush',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '一码贵州以旧换新订单推送', author: '511号开发' },
  }

/**
 * 接口 [一码贵州以旧换新订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/465512) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/cat_84211)
 * @请求头 `POST /order/imsApi/yardGoOrderPush/oldChangeOrderPush`
 */
export const apiOrderImsApiYardGoOrderPushOldChangeOrderPush = /*#__PURE__*/ (
  requestData: ApiOrderImsApiYardGoOrderPushOldChangeOrderPushRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiYardGoOrderPushOldChangeOrderPushResponse>(
    prepare(
      apiOrderImsApiYardGoOrderPushOldChangeOrderPushRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiYardGoOrderPushOldChangeOrderPush.requestConfig =
  apiOrderImsApiYardGoOrderPushOldChangeOrderPushRequestConfig

const mockUrl_0_5_0_26 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_26 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_26 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_26 = 'data' as any

/**
 * 接口 [订单台账查询街道地址订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/476313) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderCount`
 */
export interface ApiOrderImsApiOrderStandingGetAddressStreetOrderCountRequest {
  endTime?: string
  startTime?: string
  /**
   * 街道地址不能为空
   */
  streetAddress: string
}

/**
 * 接口 [订单台账查询街道地址订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/476313) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderCount`
 */
export type ApiOrderImsApiOrderStandingGetAddressStreetOrderCountResponse =
  number

/**
 * 接口 [订单台账查询街道地址订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/476313) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderCount`
 */
type ApiOrderImsApiOrderStandingGetAddressStreetOrderCountRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderStanding/getAddressStreetOrderCount',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [订单台账查询街道地址订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/476313) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderCount`
 */
const apiOrderImsApiOrderStandingGetAddressStreetOrderCountRequestConfig: ApiOrderImsApiOrderStandingGetAddressStreetOrderCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_26,
    devUrl: devUrl_0_5_0_26,
    prodUrl: prodUrl_0_5_0_26,
    path: '/order/imsApi/orderStanding/getAddressStreetOrderCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiOrderImsApiOrderStandingGetAddressStreetOrderCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单台账查询街道地址订单数量', author: '511号开发' },
  }

/**
 * 接口 [订单台账查询街道地址订单数量↗](https://yapi.gogpay.cn/project/906/interface/api/476313) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderCount`
 */
export const apiOrderImsApiOrderStandingGetAddressStreetOrderCount =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderStandingGetAddressStreetOrderCountRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderStandingGetAddressStreetOrderCountResponse>(
      prepare(
        apiOrderImsApiOrderStandingGetAddressStreetOrderCountRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderStandingGetAddressStreetOrderCount.requestConfig =
  apiOrderImsApiOrderStandingGetAddressStreetOrderCountRequestConfig

/**
 * 接口 [订单台账查询街道地址订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/483950) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderList`
 */
export interface ApiOrderImsApiOrderStandingGetAddressStreetOrderListRequest {
  endTime?: string
  startTime?: string
  /**
   * 街道地址不能为空
   */
  streetAddress: string
}

/**
 * 接口 [订单台账查询街道地址订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/483950) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderList`
 */
export type ApiOrderImsApiOrderStandingGetAddressStreetOrderListResponse = {
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单街道地址
   */
  orderStreetAddress?: string
  /**
   * 关联活动Id
   */
  refActivityId?: string
  /**
   * 关联活动场次Id
   */
  refSessionId?: string
  /**
   * 下单类型 1购物车 2直接下单 3秒杀下单
   */
  tradeOrderType?: number
  /**
   * 核销门店Id
   */
  writeOffStoreId?: string
}[]

/**
 * 接口 [订单台账查询街道地址订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/483950) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderList`
 */
type ApiOrderImsApiOrderStandingGetAddressStreetOrderListRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/906',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/order/imsApi/orderStanding/getAddressStreetOrderList',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [订单台账查询街道地址订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/483950) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderList`
 */
const apiOrderImsApiOrderStandingGetAddressStreetOrderListRequestConfig: ApiOrderImsApiOrderStandingGetAddressStreetOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_26,
    devUrl: devUrl_0_5_0_26,
    prodUrl: prodUrl_0_5_0_26,
    path: '/order/imsApi/orderStanding/getAddressStreetOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderStandingGetAddressStreetOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '订单台账查询街道地址订单信息', author: '成龙' },
  }

/**
 * 接口 [订单台账查询街道地址订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/483950) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [订单数据面板↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85392)
 * @请求头 `POST /order/imsApi/orderStanding/getAddressStreetOrderList`
 */
export const apiOrderImsApiOrderStandingGetAddressStreetOrderList =
  /*#__PURE__*/ (
    requestData: ApiOrderImsApiOrderStandingGetAddressStreetOrderListRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiOrderImsApiOrderStandingGetAddressStreetOrderListResponse>(
      prepare(
        apiOrderImsApiOrderStandingGetAddressStreetOrderListRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiOrderImsApiOrderStandingGetAddressStreetOrderList.requestConfig =
  apiOrderImsApiOrderStandingGetAddressStreetOrderListRequestConfig

const mockUrl_0_5_0_27 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_27 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_27 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_27 = 'data' as any

/**
 * 接口 [客户端-查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/484965) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderList`
 */
export interface ApiOrderUmsOrderWebOrderListRequest {
  /**
   * 审核状态 1-未同步 2-待审核 3-审核通过 4-审核驳回 5-待完善
   */
  auditStatus?: 'UN_SYNC' | 'AUDITING' | 'SUCCESS' | 'FAIL' | 'WAIT_IMPROVE'
  /**
   * 订单渠道 1线上 2线下
   */
  channel?: 'ONLINE' | 'OFFLINE'
  /**
   * 搜索关键字
   */
  keyword?: string
  /**
   * 订单结束时间，格式：yyyy-MM-dd
   */
  orderEndTime?: string
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单开始时间，格式：yyyy-MM-dd
   */
  orderStartTime?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 门店Id
   */
  storeId?: string
  /**
   * 门店名称
   */
  storeName?: string
  /**
   * 上传结束时间，格式：yyyy-MM-dd
   */
  uploadEndTime?: string
  /**
   * 上传开始时间，格式：yyyy-MM-dd
   */
  uploadStartTime?: string
}

/**
 * 接口 [客户端-查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/484965) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderList`
 */
export interface ApiOrderUmsOrderWebOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 实付金额
     */
    actualReceivable?: number
    /**
     * 审核结果
     */
    auditResult?: string
    /**
     * 审核状态
     */
    auditStatus?: number
    /**
     * 审核状态标签
     */
    auditStatusLabel?: string
    buyerInfo?: {
      /**
       * 收货地址
       */
      address?: string
      addressData?: {
        /**
         * 区划，如观山湖区
         */
        area?: string
        /**
         * 区划编码
         */
        areaCode?: string
        /**
         * 营业时间-分割
         */
        businessTimeStr?: string
        /**
         * 城市
         */
        city?: string
        /**
         * 城市代码
         */
        cityCode?: string
        /**
         * 详细地址，不需要省市区
         */
        detail?: string
        /**
         * 纬度
         */
        latitude?: string
        /**
         * 经度
         */
        longitude?: string
        /**
         * 姓名
         */
        name?: string
        /**
         * 手机号
         */
        phoneNo?: string
        /**
         * 省份
         */
        province?: string
        /**
         * 省份代码
         */
        provinceCode?: string
        /**
         * 自提点名称
         */
        selfPickupName?: string
        /**
         * 联系人
         */
        contact?: string
        /**
         * 联系电话
         */
        contactTel?: string
      }
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 收货地址区划编码
       */
      areaCode?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 数据是否完整
     */
    dataFullFlag?: string
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    goodsName?: string
    /**
     * 商品图片
     */
    goodsPic?: string
    /**
     * 商品拆封图片
     */
    goodsUnsealingPic?: string[]
    /**
     * 数据id
     */
    id?: string
    /**
     * 发票金额
     */
    invoiceAmount?: number
    /**
     * 开票时间
     */
    invoiceDate?: string
    /**
     * 发票抬头，购买方名称
     */
    invoiceHead?: string
    /**
     * 发票图片
     */
    invoiceImage?: string
    /**
     * 发票号码
     */
    invoiceNo?: string
    /**
     * 项目名称
     */
    invoiceProjectName?: string
    /**
     * 规格型号
     */
    invoiceSpecification?: string
    /**
     * 发货时间
     */
    logisticsBeginTime?: string
    /**
     * 订单编号
     */
    mallOrderNo?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单备注
     */
    orderRemark?: string
    /**
     * 订单状态
     */
    orderStatus?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 出库单
     */
    outboundOrders?: string[]
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 配送费
     */
    postFee?: number
    /**
     * 是否已推送
     */
    pushFlag?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 销售企业名称
     */
    sellerName?: string
    /**
     * 序列ID
     */
    seqId?: string
    /**
     * 配送方式
     */
    shipTypeName?: string
    /**
     * 签收单
     */
    signaturePic?: string[]
    /**
     * 商品规格
     */
    skuName?: string
    /**
     * 门店Id
     */
    storeId?: string
    /**
     * 门店名称
     */
    storeName?: string
    /**
     * 总价
     */
    totalPrice?: number
    /**
     * 单价
     */
    unitPrice?: number
    /**
     * 上传时间
     */
    uploadTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [客户端-查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/484965) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderList`
 */
type ApiOrderUmsOrderWebOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/ums/order/webOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/484965) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderList`
 */
const apiOrderUmsOrderWebOrderListRequestConfig: ApiOrderUmsOrderWebOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_27,
    devUrl: devUrl_0_5_0_27,
    prodUrl: prodUrl_0_5_0_27,
    path: '/order/api/ums/order/webOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderUmsOrderWebOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-查询审计订单列表', author: '511号开发' },
  }

/**
 * 接口 [客户端-查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/484965) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderList`
 */
export const apiOrderUmsOrderWebOrderList = /*#__PURE__*/ (
  requestData: ApiOrderUmsOrderWebOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderUmsOrderWebOrderListResponse>(
    prepare(apiOrderUmsOrderWebOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderUmsOrderWebOrderList.requestConfig =
  apiOrderUmsOrderWebOrderListRequestConfig

/**
 * 接口 [客户端-审计订单信息完善↗](https://yapi.gogpay.cn/project/906/interface/api/484972) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderImprove`
 */
export interface ApiOrderUmsOrderWebUmsOrderImproveRequest {
  /**
   * 商品拆封图片
   */
  goodsUnsealingPic?: string[]
  /**
   * 数据id
   */
  id?: string
  /**
   * 发票金额
   */
  invoiceAmount?: number
  /**
   * 开票时间
   */
  invoiceDate?: string
  /**
   * 发票抬头，购买方名称
   */
  invoiceHead?: string
  /**
   * 发票图片
   */
  invoiceImage?: string
  /**
   * 发票号码
   */
  invoiceNo?: string
  /**
   * 项目名称
   */
  invoiceProjectName?: string
  /**
   * 规格型号
   */
  invoiceSpecification?: string
  /**
   * 商城订单号
   */
  mallOrderNo?: string
  /**
   * 出库单
   */
  outboundOrders?: string[]
  /**
   * 销售企业名称
   */
  sellerName?: string
  /**
   * 序列ID
   */
  seqId?: string
  /**
   * 签收单
   */
  signaturePic?: string[]
}

/**
 * 接口 [客户端-审计订单信息完善↗](https://yapi.gogpay.cn/project/906/interface/api/484972) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderImprove`
 */
export interface ApiOrderUmsOrderWebUmsOrderImproveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-审计订单信息完善↗](https://yapi.gogpay.cn/project/906/interface/api/484972) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderImprove`
 */
type ApiOrderUmsOrderWebUmsOrderImproveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/ums/order/webUmsOrderImprove',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-审计订单信息完善↗](https://yapi.gogpay.cn/project/906/interface/api/484972) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderImprove`
 */
const apiOrderUmsOrderWebUmsOrderImproveRequestConfig: ApiOrderUmsOrderWebUmsOrderImproveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_27,
    devUrl: devUrl_0_5_0_27,
    prodUrl: prodUrl_0_5_0_27,
    path: '/order/api/ums/order/webUmsOrderImprove',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderUmsOrderWebUmsOrderImprove',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-审计订单信息完善', author: '511号开发' },
  }

/**
 * 接口 [客户端-审计订单信息完善↗](https://yapi.gogpay.cn/project/906/interface/api/484972) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderImprove`
 */
export const apiOrderUmsOrderWebUmsOrderImprove = /*#__PURE__*/ (
  requestData: ApiOrderUmsOrderWebUmsOrderImproveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderUmsOrderWebUmsOrderImproveResponse>(
    prepare(apiOrderUmsOrderWebUmsOrderImproveRequestConfig, requestData),
    ...args,
  )
}

apiOrderUmsOrderWebUmsOrderImprove.requestConfig =
  apiOrderUmsOrderWebUmsOrderImproveRequestConfig

/**
 * 接口 [客户端-查询审计订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/485007) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderDetail`
 */
export interface ApiOrderUmsOrderWebOrderDetailRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [客户端-查询审计订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/485007) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderDetail`
 */
export interface ApiOrderUmsOrderWebOrderDetailResponse {
  /**
   * 实付金额
   */
  actualReceivable?: number
  /**
   * 审核结果
   */
  auditResult?: string
  /**
   * 审核状态
   */
  auditStatus?: number
  /**
   * 审核状态标签
   */
  auditStatusLabel?: string
  buyerInfo?: {
    /**
     * 收货地址
     */
    address?: string
    addressData?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 城市代码
       */
      cityCode?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 省份代码
       */
      provinceCode?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 预约时间
     */
    appointmentDate?: string
    /**
     * 收货地址区划编码
     */
    areaCode?: string
    /**
     * 身份证号
     */
    idCardNo?: string
    /**
     * 买家姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
  }
  /**
   * 数据是否完整
   */
  dataFullFlag?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 商品名称
   */
  goodsName?: string
  /**
   * 商品图片
   */
  goodsPic?: string
  /**
   * 商品拆封图片
   */
  goodsUnsealingPic?: string[]
  /**
   * 数据id
   */
  id?: string
  /**
   * 发票金额
   */
  invoiceAmount?: number
  /**
   * 开票时间
   */
  invoiceDate?: string
  /**
   * 发票抬头，购买方名称
   */
  invoiceHead?: string
  /**
   * 发票图片
   */
  invoiceImage?: string
  /**
   * 发票号码
   */
  invoiceNo?: string
  /**
   * 项目名称
   */
  invoiceProjectName?: string
  /**
   * 规格型号
   */
  invoiceSpecification?: string
  /**
   * 发货时间
   */
  logisticsBeginTime?: string
  /**
   * 订单编号
   */
  mallOrderNo?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单备注
   */
  orderRemark?: string
  /**
   * 订单状态
   */
  orderStatus?: string
  /**
   * 下单时间
   */
  orderTime?: string
  /**
   * 出库单
   */
  outboundOrders?: string[]
  /**
   * 支付时间
   */
  payTime?: string
  /**
   * 配送费
   */
  postFee?: number
  /**
   * 是否已推送
   */
  pushFlag?: string
  /**
   * 数量
   */
  quantity?: number
  /**
   * 销售企业名称
   */
  sellerName?: string
  /**
   * 序列ID
   */
  seqId?: string
  /**
   * 配送方式
   */
  shipTypeName?: string
  /**
   * 签收单
   */
  signaturePic?: string[]
  /**
   * 商品规格
   */
  skuName?: string
  /**
   * 门店Id
   */
  storeId?: string
  /**
   * 门店名称
   */
  storeName?: string
  /**
   * 总价
   */
  totalPrice?: number
  /**
   * 单价
   */
  unitPrice?: number
  /**
   * 上传时间
   */
  uploadTime?: string
}

/**
 * 接口 [客户端-查询审计订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/485007) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderDetail`
 */
type ApiOrderUmsOrderWebOrderDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/ums/order/webOrderDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-查询审计订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/485007) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderDetail`
 */
const apiOrderUmsOrderWebOrderDetailRequestConfig: ApiOrderUmsOrderWebOrderDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_27,
    devUrl: devUrl_0_5_0_27,
    prodUrl: prodUrl_0_5_0_27,
    path: '/order/api/ums/order/webOrderDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderUmsOrderWebOrderDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-查询审计订单详情', author: '511号开发' },
  }

/**
 * 接口 [客户端-查询审计订单详情↗](https://yapi.gogpay.cn/project/906/interface/api/485007) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderDetail`
 */
export const apiOrderUmsOrderWebOrderDetail = /*#__PURE__*/ (
  requestData: ApiOrderUmsOrderWebOrderDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderUmsOrderWebOrderDetailResponse>(
    prepare(apiOrderUmsOrderWebOrderDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderUmsOrderWebOrderDetail.requestConfig =
  apiOrderUmsOrderWebOrderDetailRequestConfig

/**
 * 接口 [客户端-审计订单提交申报↗](https://yapi.gogpay.cn/project/906/interface/api/485014) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderSync`
 */
export interface ApiOrderUmsOrderWebUmsOrderSyncRequest {
  /**
   * 是否全部推送
   */
  allSyncFlag: boolean
  /**
   * 请求Id
   */
  ids: string[]
  /**
   * 门店Id
   */
  merchantId: string
}

/**
 * 接口 [客户端-审计订单提交申报↗](https://yapi.gogpay.cn/project/906/interface/api/485014) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderSync`
 */
export interface ApiOrderUmsOrderWebUmsOrderSyncResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [客户端-审计订单提交申报↗](https://yapi.gogpay.cn/project/906/interface/api/485014) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderSync`
 */
type ApiOrderUmsOrderWebUmsOrderSyncRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/ums/order/webUmsOrderSync',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-审计订单提交申报↗](https://yapi.gogpay.cn/project/906/interface/api/485014) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderSync`
 */
const apiOrderUmsOrderWebUmsOrderSyncRequestConfig: ApiOrderUmsOrderWebUmsOrderSyncRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_27,
    devUrl: devUrl_0_5_0_27,
    prodUrl: prodUrl_0_5_0_27,
    path: '/order/api/ums/order/webUmsOrderSync',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderUmsOrderWebUmsOrderSync',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-审计订单提交申报', author: '511号开发' },
  }

/**
 * 接口 [客户端-审计订单提交申报↗](https://yapi.gogpay.cn/project/906/interface/api/485014) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webUmsOrderSync`
 */
export const apiOrderUmsOrderWebUmsOrderSync = /*#__PURE__*/ (
  requestData: ApiOrderUmsOrderWebUmsOrderSyncRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderUmsOrderWebUmsOrderSyncResponse>(
    prepare(apiOrderUmsOrderWebUmsOrderSyncRequestConfig, requestData),
    ...args,
  )
}

apiOrderUmsOrderWebUmsOrderSync.requestConfig =
  apiOrderUmsOrderWebUmsOrderSyncRequestConfig

/**
 * 接口 [客户端-查询审计订单统计列表↗](https://yapi.gogpay.cn/project/906/interface/api/489123) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderListCount`
 */
export interface ApiOrderUmsOrderWebOrderListCountRequest {
  /**
   * 审核状态 1-未同步 2-待审核 3-审核通过 4-审核驳回 5-待完善
   */
  auditStatus?: 'UN_SYNC' | 'AUDITING' | 'SUCCESS' | 'FAIL' | 'WAIT_IMPROVE'
  /**
   * 订单渠道 1线上 2线下
   */
  channel?: 'ONLINE' | 'OFFLINE'
  /**
   * 搜索关键字
   */
  keyword?: string
  /**
   * 订单结束时间，格式：yyyy-MM-dd
   */
  orderEndTime?: string
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单开始时间，格式：yyyy-MM-dd
   */
  orderStartTime?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 门店Id
   */
  storeId?: string
  /**
   * 门店名称
   */
  storeName?: string
  /**
   * 上传结束时间，格式：yyyy-MM-dd
   */
  uploadEndTime?: string
  /**
   * 上传开始时间，格式：yyyy-MM-dd
   */
  uploadStartTime?: string
}

/**
 * 接口 [客户端-查询审计订单统计列表↗](https://yapi.gogpay.cn/project/906/interface/api/489123) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderListCount`
 */
export interface ApiOrderUmsOrderWebOrderListCountResponse {}

/**
 * 接口 [客户端-查询审计订单统计列表↗](https://yapi.gogpay.cn/project/906/interface/api/489123) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderListCount`
 */
type ApiOrderUmsOrderWebOrderListCountRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/ums/order/webOrderListCount',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [客户端-查询审计订单统计列表↗](https://yapi.gogpay.cn/project/906/interface/api/489123) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderListCount`
 */
const apiOrderUmsOrderWebOrderListCountRequestConfig: ApiOrderUmsOrderWebOrderListCountRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_27,
    devUrl: devUrl_0_5_0_27,
    prodUrl: prodUrl_0_5_0_27,
    path: '/order/api/ums/order/webOrderListCount',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderUmsOrderWebOrderListCount',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '客户端-查询审计订单统计列表', author: '511号开发' },
  }

/**
 * 接口 [客户端-查询审计订单统计列表↗](https://yapi.gogpay.cn/project/906/interface/api/489123) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85880)
 * @请求头 `POST /order/api/ums/order/webOrderListCount`
 */
export const apiOrderUmsOrderWebOrderListCount = /*#__PURE__*/ (
  requestData: ApiOrderUmsOrderWebOrderListCountRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderUmsOrderWebOrderListCountResponse>(
    prepare(apiOrderUmsOrderWebOrderListCountRequestConfig, requestData),
    ...args,
  )
}

apiOrderUmsOrderWebOrderListCount.requestConfig =
  apiOrderUmsOrderWebOrderListCountRequestConfig

const mockUrl_0_5_0_28 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_28 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_28 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_28 = 'data' as any

/**
 * 接口 [管理后台-查询商户配送员列表↗](https://yapi.gogpay.cn/project/906/interface/api/485049) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryCourierPageList`
 */
export interface ApiOrderImsApiOrderPackageQueryCourierPageListRequest {
  /**
   * 商户ID
   */
  merchantId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [管理后台-查询商户配送员列表↗](https://yapi.gogpay.cn/project/906/interface/api/485049) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryCourierPageList`
 */
export interface ApiOrderImsApiOrderPackageQueryCourierPageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [管理后台-查询商户配送员列表↗](https://yapi.gogpay.cn/project/906/interface/api/485049) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryCourierPageList`
 */
type ApiOrderImsApiOrderPackageQueryCourierPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderPackage/queryCourierPageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [管理后台-查询商户配送员列表↗](https://yapi.gogpay.cn/project/906/interface/api/485049) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryCourierPageList`
 */
const apiOrderImsApiOrderPackageQueryCourierPageListRequestConfig: ApiOrderImsApiOrderPackageQueryCourierPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_28,
    devUrl: devUrl_0_5_0_28,
    prodUrl: prodUrl_0_5_0_28,
    path: '/order/imsApi/orderPackage/queryCourierPageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderPackageQueryCourierPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '管理后台-查询商户配送员列表', author: '511号开发' },
  }

/**
 * 接口 [管理后台-查询商户配送员列表↗](https://yapi.gogpay.cn/project/906/interface/api/485049) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryCourierPageList`
 */
export const apiOrderImsApiOrderPackageQueryCourierPageList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderPackageQueryCourierPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderPackageQueryCourierPageListResponse>(
    prepare(
      apiOrderImsApiOrderPackageQueryCourierPageListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderPackageQueryCourierPageList.requestConfig =
  apiOrderImsApiOrderPackageQueryCourierPageListRequestConfig

/**
 * 接口 [管理后台-修改商户配送员↗](https://yapi.gogpay.cn/project/906/interface/api/485056) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/updateOrderCourier`
 */
export interface ApiOrderImsApiOrderPackageUpdateOrderCourierRequest {
  /**
   * 自配送人员ID， 当发货方式为自配送时必传
   */
  courierId: string
  /**
   * 订单号
   */
  orderNo: string
  /**
   * 自配送人员姓名
   */
  serviceUserName?: string
  /**
   * 自配送人员手机号
   */
  serviceUserTel?: string
}

/**
 * 接口 [管理后台-修改商户配送员↗](https://yapi.gogpay.cn/project/906/interface/api/485056) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/updateOrderCourier`
 */
export interface ApiOrderImsApiOrderPackageUpdateOrderCourierResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [管理后台-修改商户配送员↗](https://yapi.gogpay.cn/project/906/interface/api/485056) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/updateOrderCourier`
 */
type ApiOrderImsApiOrderPackageUpdateOrderCourierRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderPackage/updateOrderCourier',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [管理后台-修改商户配送员↗](https://yapi.gogpay.cn/project/906/interface/api/485056) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/updateOrderCourier`
 */
const apiOrderImsApiOrderPackageUpdateOrderCourierRequestConfig: ApiOrderImsApiOrderPackageUpdateOrderCourierRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_28,
    devUrl: devUrl_0_5_0_28,
    prodUrl: prodUrl_0_5_0_28,
    path: '/order/imsApi/orderPackage/updateOrderCourier',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderPackageUpdateOrderCourier',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '管理后台-修改商户配送员', author: '511号开发' },
  }

/**
 * 接口 [管理后台-修改商户配送员↗](https://yapi.gogpay.cn/project/906/interface/api/485056) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/updateOrderCourier`
 */
export const apiOrderImsApiOrderPackageUpdateOrderCourier = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderPackageUpdateOrderCourierRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderPackageUpdateOrderCourierResponse>(
    prepare(
      apiOrderImsApiOrderPackageUpdateOrderCourierRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderPackageUpdateOrderCourier.requestConfig =
  apiOrderImsApiOrderPackageUpdateOrderCourierRequestConfig

/**
 * 接口 [管理后台-查询订单包裹信息↗](https://yapi.gogpay.cn/project/906/interface/api/497726) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryOrderPackageInfo`
 */
export interface ApiOrderImsApiOrderPackageQueryOrderPackageInfoRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 来源
   */
  source?: string
}

/**
 * 接口 [管理后台-查询订单包裹信息↗](https://yapi.gogpay.cn/project/906/interface/api/497726) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryOrderPackageInfo`
 */
export type ApiOrderImsApiOrderPackageQueryOrderPackageInfoResponse = {
  /**
   * 送达操作人纬度
   */
  arriveLatitude?: string
  /**
   * 送达操作人经度
   */
  arriveLongitude?: string
  /**
   * 货物69码图片
   */
  barCodePicList?: string[]
  /**
   * 发货时间
   */
  beginTime?: string
  /**
   * 货物图片
   */
  commodityPicList?: string[]
  /**
   * 物流公司
   */
  companyName?: string
  /**
   * 客户和商品图片
   */
  customerAndCommodityPicList?: string[]
  /**
   * 到达时间
   */
  endTime?: string
  /**
   * 货物拆封图片
   */
  goodsUnsealingPicList?: string[]
  /**
   * 物流公司编号
   */
  logisticsCompanyNo?: string
  merchantCourier?: {
    /**
     * 配送员名称
     */
    courierName?: string
    /**
     * 配送员手机号
     */
    courierPhone?: string
    /**
     * 创建人
     */
    createBy?: string
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 是否默认配送员
     */
    defaultFlag?: boolean
    /**
     * 主键ID
     */
    id?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 备注
     */
    remark?: string
    /**
     * 子机构号
     */
    unitOrgCode?: string
    /**
     * 修改人
     */
    updateBy?: string
    /**
     * 修改时间
     */
    updateTime?: string
  }
  /**
   * 配送员ID
   */
  merchantCourierId?: string
  /**
   * 物流订单编号
   */
  orderNo?: string
  /**
   * 提货订单图片
   */
  orderPickPicList?: string[]
  /**
   * 出库单
   */
  outboundOrders?: string[]
  /**
   * 包裹Id
   */
  packageId?: string
  /**
   * 发货地址
   */
  receiveAddress?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 发货方式
   */
  sendType?: string
  /**
   * 发货方式值 1：线上寄送   2：线下自寄  3：门店自提
   */
  sendTypeValue?: number
  /**
   * 签收单
   */
  signaturePicList?: string[]
  /**
   * 运单号
   */
  waybillNo?: string
}[]

/**
 * 接口 [管理后台-查询订单包裹信息↗](https://yapi.gogpay.cn/project/906/interface/api/497726) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryOrderPackageInfo`
 */
type ApiOrderImsApiOrderPackageQueryOrderPackageInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderPackage/queryOrderPackageInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [管理后台-查询订单包裹信息↗](https://yapi.gogpay.cn/project/906/interface/api/497726) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryOrderPackageInfo`
 */
const apiOrderImsApiOrderPackageQueryOrderPackageInfoRequestConfig: ApiOrderImsApiOrderPackageQueryOrderPackageInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_28,
    devUrl: devUrl_0_5_0_28,
    prodUrl: prodUrl_0_5_0_28,
    path: '/order/imsApi/orderPackage/queryOrderPackageInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderPackageQueryOrderPackageInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '管理后台-查询订单包裹信息', author: '511号开发' },
  }

/**
 * 接口 [管理后台-查询订单包裹信息↗](https://yapi.gogpay.cn/project/906/interface/api/497726) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [管理后台-订单包裹管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_85890)
 * @请求头 `POST /order/imsApi/orderPackage/queryOrderPackageInfo`
 */
export const apiOrderImsApiOrderPackageQueryOrderPackageInfo = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderPackageQueryOrderPackageInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderPackageQueryOrderPackageInfoResponse>(
    prepare(
      apiOrderImsApiOrderPackageQueryOrderPackageInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderImsApiOrderPackageQueryOrderPackageInfo.requestConfig =
  apiOrderImsApiOrderPackageQueryOrderPackageInfoRequestConfig

const mockUrl_0_5_0_29 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_29 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_29 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_29 = 'data' as any

/**
 * 接口 [管理端测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/492245) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [admin-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86332)
 * @请求头 `POST /order/imsApi/test`
 */
export interface ApiOrderImsApiTestRequest {
  /**
   * ID
   */
  id: string
}

/**
 * 接口 [管理端测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/492245) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [admin-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86332)
 * @请求头 `POST /order/imsApi/test`
 */
export interface ApiOrderImsApiTestResponse {
  /**
   * ID
   */
  id: string
  /**
   * 名称
   */
  name: string
}

/**
 * 接口 [管理端测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/492245) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [admin-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86332)
 * @请求头 `POST /order/imsApi/test`
 */
type ApiOrderImsApiTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/test',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [管理端测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/492245) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [admin-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86332)
 * @请求头 `POST /order/imsApi/test`
 */
const apiOrderImsApiTestRequestConfig: ApiOrderImsApiTestRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_29,
    devUrl: devUrl_0_5_0_29,
    prodUrl: prodUrl_0_5_0_29,
    path: '/order/imsApi/test',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiTest',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '管理端测试接口', author: '511号开发' },
  }

/**
 * 接口 [管理端测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/492245) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [admin-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86332)
 * @请求头 `POST /order/imsApi/test`
 */
export const apiOrderImsApiTest = /*#__PURE__*/ (
  requestData: ApiOrderImsApiTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiTestResponse>(
    prepare(apiOrderImsApiTestRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiTest.requestConfig = apiOrderImsApiTestRequestConfig

const mockUrl_0_5_0_30 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_30 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_30 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_30 = 'data' as any

/**
 * 接口 [获取商城线下门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491846) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [api-duo-mall-merchant-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86336)
 * @请求头 `POST /order/api/merchant/offline/store/webPageList`
 */
export interface ApiOrderMerchantOfflineStoreWebPageListRequest {}

/**
 * 接口 [获取商城线下门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491846) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [api-duo-mall-merchant-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86336)
 * @请求头 `POST /order/api/merchant/offline/store/webPageList`
 */
export interface ApiOrderMerchantOfflineStoreWebPageListResponse {}

/**
 * 接口 [获取商城线下门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491846) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [api-duo-mall-merchant-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86336)
 * @请求头 `POST /order/api/merchant/offline/store/webPageList`
 */
type ApiOrderMerchantOfflineStoreWebPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/merchant/offline/store/webPageList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取商城线下门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491846) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [api-duo-mall-merchant-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86336)
 * @请求头 `POST /order/api/merchant/offline/store/webPageList`
 */
const apiOrderMerchantOfflineStoreWebPageListRequestConfig: ApiOrderMerchantOfflineStoreWebPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_30,
    devUrl: devUrl_0_5_0_30,
    prodUrl: prodUrl_0_5_0_30,
    path: '/order/api/merchant/offline/store/webPageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderMerchantOfflineStoreWebPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商城线下门店列表', author: '511号开发' },
  }

/**
 * 接口 [获取商城线下门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491846) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [api-duo-mall-merchant-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86336)
 * @请求头 `POST /order/api/merchant/offline/store/webPageList`
 */
export const apiOrderMerchantOfflineStoreWebPageList = /*#__PURE__*/ (
  requestData?: ApiOrderMerchantOfflineStoreWebPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderMerchantOfflineStoreWebPageListResponse>(
    prepare(apiOrderMerchantOfflineStoreWebPageListRequestConfig, requestData),
    ...args,
  )
}

apiOrderMerchantOfflineStoreWebPageList.requestConfig =
  apiOrderMerchantOfflineStoreWebPageListRequestConfig

const mockUrl_0_5_0_31 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_31 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_31 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_31 = 'data' as any

/**
 * 接口 [API测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/491909) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [api-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86338)
 * @请求头 `POST /order/api/test`
 */
export interface ApiOrderTestRequest {
  /**
   * ID
   */
  id: string
}

/**
 * 接口 [API测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/491909) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [api-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86338)
 * @请求头 `POST /order/api/test`
 */
export interface ApiOrderTestResponse {
  /**
   * ID
   */
  id: string
  /**
   * 名称
   */
  name: string
}

/**
 * 接口 [API测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/491909) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [api-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86338)
 * @请求头 `POST /order/api/test`
 */
type ApiOrderTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/test',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [API测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/491909) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [api-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86338)
 * @请求头 `POST /order/api/test`
 */
const apiOrderTestRequestConfig: ApiOrderTestRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_5_0_31,
  devUrl: devUrl_0_5_0_31,
  prodUrl: prodUrl_0_5_0_31,
  path: '/order/api/test',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_5_0_31,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiOrderTest',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: { title: 'API测试接口', author: '511号开发' },
}

/**
 * 接口 [API测试接口↗](https://yapi.gogpay.cn/project/906/interface/api/491909) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [api-test-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86338)
 * @请求头 `POST /order/api/test`
 */
export const apiOrderTest = /*#__PURE__*/ (
  requestData: ApiOrderTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderTestResponse>(
    prepare(apiOrderTestRequestConfig, requestData),
    ...args,
  )
}

apiOrderTest.requestConfig = apiOrderTestRequestConfig

const mockUrl_0_5_0_32 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_32 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_32 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_32 = 'data' as any

/**
 * 接口 [商家补贴申请审核结果通知↗](https://yapi.gogpay.cn/project/906/interface/api/492371) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [api-yard-go-open-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86340)
 * @请求头 `POST /order/openApi/test`
 */
export interface ApiOrderOpenApiTestRequest {
  /**
   * 应用编码
   */
  appKey: string
  /**
   * 提示信息
   */
  msg: string
  /**
   * 第三方平台门店id
   */
  shopId: string
  /**
   * 签名
   */
  sign: string
  /**
   * 00-已申报，待审核 01-审核通过 02-审核不通过 03-补贴已支付
   */
  state: string
  /**
   * 时间戳(毫秒)
   */
  timestamp: string
  /**
   * 第三方平台订单号
   */
  tranId: string
}

/**
 * 接口 [商家补贴申请审核结果通知↗](https://yapi.gogpay.cn/project/906/interface/api/492371) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [api-yard-go-open-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86340)
 * @请求头 `POST /order/openApi/test`
 */
export interface ApiOrderOpenApiTestResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [商家补贴申请审核结果通知↗](https://yapi.gogpay.cn/project/906/interface/api/492371) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [api-yard-go-open-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86340)
 * @请求头 `POST /order/openApi/test`
 */
type ApiOrderOpenApiTestRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/openApi/test',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商家补贴申请审核结果通知↗](https://yapi.gogpay.cn/project/906/interface/api/492371) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [api-yard-go-open-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86340)
 * @请求头 `POST /order/openApi/test`
 */
const apiOrderOpenApiTestRequestConfig: ApiOrderOpenApiTestRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_32,
    devUrl: devUrl_0_5_0_32,
    prodUrl: prodUrl_0_5_0_32,
    path: '/order/openApi/test',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_32,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenApiTest',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商家补贴申请审核结果通知', author: '511号开发' },
  }

/**
 * 接口 [商家补贴申请审核结果通知↗](https://yapi.gogpay.cn/project/906/interface/api/492371) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [api-yard-go-open-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86340)
 * @请求头 `POST /order/openApi/test`
 */
export const apiOrderOpenApiTest = /*#__PURE__*/ (
  requestData: ApiOrderOpenApiTestRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenApiTestResponse>(
    prepare(apiOrderOpenApiTestRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenApiTest.requestConfig = apiOrderOpenApiTestRequestConfig

const mockUrl_0_5_0_33 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_33 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_33 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_33 = 'data' as any

/**
 * 接口 [开放接口-机构店铺入驻↗](https://yapi.gogpay.cn/project/906/interface/api/492280) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/addOrgStore`
 */
export interface ApiOrderOpenAddOrgStoreRequest {
  /**
   * 机构经营范围，营业执照上的经营范围
   */
  businessRegion?: string
  /**
   * 机构联系人姓名
   */
  contractName?: string
  /**
   * 机构联系人电话
   */
  contractPhone?: string
  /**
   * 店铺所在纬度
   */
  lat?: string
  /**
   * 法人身份证背面图片，BASE64
   */
  legalIdBackPic?: string
  /**
   * 法人身份证正面图片，BASE64
   */
  legalIdFrontPic?: string
  /**
   * 法人身份证号码
   */
  legalIdNo?: string
  /**
   * 法人姓名
   */
  legalName?: string
  /**
   * 机构营业执照图片，BASE64
   */
  licensePic?: string
  /**
   * 店铺所在经度
   */
  log?: string
  /**
   * 机构所在地
   */
  orgAddress?: string
  /**
   * 机构ID，外部系统的机构ID
   */
  orgId?: string
  /**
   * 机构名称，店铺所属公司的名称
   */
  orgName?: string
  /**
   * 机构类型，营业执照上的类型
   */
  orgType?: string
  /**
   * 机构其他相关资质图片信息，BASE64
   */
  otherPics?: string[]
  /**
   * 店铺详细地址
   */
  storeAddress?: string
  /**
   * 店铺所在城市，如：贵阳市
   */
  storeCity?: string
  /**
   * 店铺所在区县，如：观山湖区
   */
  storeCounty?: string
  /**
   * 店铺ID，外部系统的店铺ID
   */
  storeId?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺联系方式
   */
  storePhone?: string
  /**
   * 店铺所在省份，如：贵州省
   */
  storeProvince?: string
  /**
   * 机构社会信用代码
   */
  usci?: string
}

/**
 * 接口 [开放接口-机构店铺入驻↗](https://yapi.gogpay.cn/project/906/interface/api/492280) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/addOrgStore`
 */
export interface ApiOrderOpenAddOrgStoreResponse {
  new?: boolean
  /**
   * 驳回原因
   */
  reason?: string
  /**
   * 审核结果 0待审核 1审核通过 2审核拒绝
   */
  status?: number
}

/**
 * 接口 [开放接口-机构店铺入驻↗](https://yapi.gogpay.cn/project/906/interface/api/492280) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/addOrgStore`
 */
type ApiOrderOpenAddOrgStoreRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/addOrgStore',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-机构店铺入驻↗](https://yapi.gogpay.cn/project/906/interface/api/492280) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/addOrgStore`
 */
const apiOrderOpenAddOrgStoreRequestConfig: ApiOrderOpenAddOrgStoreRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/addOrgStore',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenAddOrgStore',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-机构店铺入驻', author: '511号开发' },
  }

/**
 * 接口 [开放接口-机构店铺入驻↗](https://yapi.gogpay.cn/project/906/interface/api/492280) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/addOrgStore`
 */
export const apiOrderOpenAddOrgStore = /*#__PURE__*/ (
  requestData: ApiOrderOpenAddOrgStoreRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenAddOrgStoreResponse>(
    prepare(apiOrderOpenAddOrgStoreRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenAddOrgStore.requestConfig = apiOrderOpenAddOrgStoreRequestConfig

/**
 * 接口 [开放接口-取消核销↗](https://yapi.gogpay.cn/project/906/interface/api/492287) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelConsume`
 */
export interface ApiOrderOpenCancelConsumeRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 取消原因
   */
  reason?: string
}

/**
 * 接口 [开放接口-取消核销↗](https://yapi.gogpay.cn/project/906/interface/api/492287) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelConsume`
 */
export interface ApiOrderOpenCancelConsumeResponse {
  /**
   * 取消时间
   */
  cancelTime?: string
}

/**
 * 接口 [开放接口-取消核销↗](https://yapi.gogpay.cn/project/906/interface/api/492287) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelConsume`
 */
type ApiOrderOpenCancelConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/cancelConsume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-取消核销↗](https://yapi.gogpay.cn/project/906/interface/api/492287) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelConsume`
 */
const apiOrderOpenCancelConsumeRequestConfig: ApiOrderOpenCancelConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/cancelConsume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenCancelConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-取消核销', author: '511号开发' },
  }

/**
 * 接口 [开放接口-取消核销↗](https://yapi.gogpay.cn/project/906/interface/api/492287) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelConsume`
 */
export const apiOrderOpenCancelConsume = /*#__PURE__*/ (
  requestData: ApiOrderOpenCancelConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenCancelConsumeResponse>(
    prepare(apiOrderOpenCancelConsumeRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenCancelConsume.requestConfig = apiOrderOpenCancelConsumeRequestConfig

/**
 * 接口 [开放接口-取消预占↗](https://yapi.gogpay.cn/project/906/interface/api/492294) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelPreConsume`
 */
export interface ApiOrderOpenCancelPreConsumeRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 取消原因
   */
  reason?: string
}

/**
 * 接口 [开放接口-取消预占↗](https://yapi.gogpay.cn/project/906/interface/api/492294) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelPreConsume`
 */
export interface ApiOrderOpenCancelPreConsumeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [开放接口-取消预占↗](https://yapi.gogpay.cn/project/906/interface/api/492294) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelPreConsume`
 */
type ApiOrderOpenCancelPreConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/cancelPreConsume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-取消预占↗](https://yapi.gogpay.cn/project/906/interface/api/492294) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelPreConsume`
 */
const apiOrderOpenCancelPreConsumeRequestConfig: ApiOrderOpenCancelPreConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/cancelPreConsume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenCancelPreConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-取消预占', author: '511号开发' },
  }

/**
 * 接口 [开放接口-取消预占↗](https://yapi.gogpay.cn/project/906/interface/api/492294) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/cancelPreConsume`
 */
export const apiOrderOpenCancelPreConsume = /*#__PURE__*/ (
  requestData: ApiOrderOpenCancelPreConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenCancelPreConsumeResponse>(
    prepare(apiOrderOpenCancelPreConsumeRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenCancelPreConsume.requestConfig =
  apiOrderOpenCancelPreConsumeRequestConfig

/**
 * 接口 [开放接口-查询用户资格↗](https://yapi.gogpay.cn/project/906/interface/api/492301) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/checkUserAgingInfo`
 */
export interface ApiOrderOpenCheckUserAgingInfoRequest {
  userCardNo?: string
  userId?: string
  userPhone?: string
}

/**
 * 接口 [开放接口-查询用户资格↗](https://yapi.gogpay.cn/project/906/interface/api/492301) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/checkUserAgingInfo`
 */
export interface ApiOrderOpenCheckUserAgingInfoResponse {
  /**
   * 撤销人Id
   */
  cancelId?: string
  /**
   * 撤销人姓名
   */
  cancelName?: string
  /**
   * 撤销原因
   */
  cancelReason?: string
  /**
   * 资格冻结时间
   */
  cancelTime?: string
  /**
   * 代领人活体截图图片地址
   */
  clientRealPicUrl: string
  /**
   * 已使用优惠券张数
   */
  couponUseCount?: number
  /**
   * 资格冻结人姓名
   */
  freezeName?: string
  /**
   * 资格冻结原因
   */
  freezeReason?: string
  /**
   * 资格冻结时间
   */
  freezeTime?: string
  /**
   * 外省用户通过备注
   */
  outsideRemark?: string
  /**
   * 老年人活体截图图片地址
   */
  realPicUrl: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 总优惠金额
   */
  totalDiscountAmt?: number
  /**
   * 一码贵州资格状态0未持有 1持有 2资格已注销/回退 3正常过期 4排队等待中
   */
  yardGoStatus?: number
  /**
   * 申请记录id
   */
  id?: string
  /**
   * 申请记录id
   */
  applyInfoId?: string
  /**
   * 用户/委托人姓名
   */
  userName?: string
  /**
   * 用户/委托人姓名
   */
  userId?: string
  /**
   * 用户/委托人手机号
   */
  userPhone?: string
  /**
   * 用户/委托人身份证号
   */
  userIdCardNo?: string
  /**
   * 提交类型 1本人提交 2委托提交
   */
  applyType?: number
  /**
   * 申请人/被委托人身份证来源用户姓名
   */
  cardName?: string
  /**
   * 申请人/被委托人身份证来源身份证号
   */
  cardIdNo?: string
  /**
   * 申请人/被委托人ocr身份证来源用户姓名
   */
  ocrCardName?: string
  /**
   * 申请人/被委托人ocr身份证来源身份证号
   */
  ocrCardIdNo?: string
  /**
   * 申请人/被委托人身份证正面图片
   */
  idCardImgFront?: string
  /**
   * 申请人/被委托人身份证反面图片
   */
  idCardImgBack?: string
  /**
   * 委托人身份证来源用户姓名
   */
  clientCardName?: string
  /**
   * 委托人身份证来源身份证号
   */
  clientCardIdNo?: string
  /**
   * 委托人ocr身份证来源用户姓名
   */
  clientOcrCardName?: string
  /**
   * 委托人ocr身份证来源身份证号
   */
  clientOcrCardIdNo?: string
  /**
   * 委托人身份证正面图片
   */
  clientIdCardImgFront?: string
  /**
   * 委托人身份证反面图片
   */
  clientIdCardImgBack?: string
  /**
   * 委托代申领承诺书
   */
  clientApplyCertificate?: string
  /**
   * 补贴名称
   */
  fundsName?: string
  /**
   * 审核状态0草稿 1待审核 2审核通过 3审核驳回 4名额不足 5驳回并重新提交 6消费券已发放
   */
  checkStatus?: number
  /**
   * 审核驳回原因
   */
  checkFailReason?: string
  /**
   * 审核人
   */
  checkName?: string
  /**
   * 消费券状态0待领取 1领取成功 2冻结 3过期 4待发放
   */
  applyInfoStatus?: number
  /**
   * 消费券领取时间
   */
  foundsReceiveTime?: string
  /**
   * 消费券过期时间
   */
  foundsExpireTime?: string
  /**
   * 消费券发放时间
   */
  pushTime?: string
  /**
   * 补贴金额
   */
  fundsAmount?: number
  /**
   * 实际补贴金额
   */
  lowFundsAmount?: number
  /**
   * 补贴金额余额
   */
  fundsAmountBalance?: number
  /**
   * 审核时间
   */
  checkTime?: string
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 消费券使用记录
   */
  couponUseRecord?: string
}

/**
 * 接口 [开放接口-查询用户资格↗](https://yapi.gogpay.cn/project/906/interface/api/492301) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/checkUserAgingInfo`
 */
type ApiOrderOpenCheckUserAgingInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/checkUserAgingInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-查询用户资格↗](https://yapi.gogpay.cn/project/906/interface/api/492301) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/checkUserAgingInfo`
 */
const apiOrderOpenCheckUserAgingInfoRequestConfig: ApiOrderOpenCheckUserAgingInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/checkUserAgingInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenCheckUserAgingInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-查询用户资格', author: '511号开发' },
  }

/**
 * 接口 [开放接口-查询用户资格↗](https://yapi.gogpay.cn/project/906/interface/api/492301) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/checkUserAgingInfo`
 */
export const apiOrderOpenCheckUserAgingInfo = /*#__PURE__*/ (
  requestData: ApiOrderOpenCheckUserAgingInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenCheckUserAgingInfoResponse>(
    prepare(apiOrderOpenCheckUserAgingInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenCheckUserAgingInfo.requestConfig =
  apiOrderOpenCheckUserAgingInfoRequestConfig

/**
 * 接口 [开放接口-核销↗](https://yapi.gogpay.cn/project/906/interface/api/492308) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/consume`
 */
export interface ApiOrderOpenConsumeRequest {
  /**
   * 商品编码，商品在产品库中的唯一编码（69码）
   */
  goodsId?: string
  /**
   * 银商商户名称
   */
  merchantName?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 购买数量
   */
  quantity?: number
  /**
   * 门店编码
   */
  storeCode?: string
  /**
   * 门店名称
   */
  storeName?: string
  /**
   * 券码ID
   */
  ticketCode?: string
  /**
   * 订单金额
   */
  totalAmount?: number
  /**
   * 下单时间，yyyy-MM-dd HH:mm:ss
   */
  tradeTime?: string
}

/**
 * 接口 [开放接口-核销↗](https://yapi.gogpay.cn/project/906/interface/api/492308) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/consume`
 */
export interface ApiOrderOpenConsumeResponse {
  /**
   * 核销成功时间，格式 yyyy-MM-dd HH:mm:ss.SSS
   */
  consumeTime?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 核销成功对应的订单号，如果status=2，则会返回和入参的orderNo不一致的单号
   */
  orderNo?: string
  /**
   * 核销结果说明
   */
  resultMsg?: string
  /**
   * 核销状态  0未核销  1核销成功 2核销成功(被其他订单核销) 3已退款
   */
  status?: number
}

/**
 * 接口 [开放接口-核销↗](https://yapi.gogpay.cn/project/906/interface/api/492308) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/consume`
 */
type ApiOrderOpenConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/consume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-核销↗](https://yapi.gogpay.cn/project/906/interface/api/492308) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/consume`
 */
const apiOrderOpenConsumeRequestConfig: ApiOrderOpenConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/consume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-核销', author: '511号开发' },
  }

/**
 * 接口 [开放接口-核销↗](https://yapi.gogpay.cn/project/906/interface/api/492308) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/consume`
 */
export const apiOrderOpenConsume = /*#__PURE__*/ (
  requestData: ApiOrderOpenConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenConsumeResponse>(
    prepare(apiOrderOpenConsumeRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenConsume.requestConfig = apiOrderOpenConsumeRequestConfig

/**
 * 接口 [开放接口-订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/492315) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/pay`
 */
export interface ApiOrderOpenPayRequest {
  /**
   * 商户编号
   */
  merchantNo?: string
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 支付金额
   */
  payAmount?: number
  payResult?: {
    alipayDiscountCode?: string
    authCode?: string
    cashierName?: string
    cashierNo?: string
    channelDiscountAmount?: string
    city?: string
    credFrozenNo?: string
    credFrozenTime?: string
    customRefNo?: string
    district?: string
    errCode?: string
    errInfo?: string
    goodsArray?: {
      bcd?: string
      brand?: string
      category?: string
      discountAmount?: string
      eei?: string
      gbCategoryCode?: string
      goodsName?: string
      imei1?: string
      imei2?: string
      price?: string
      qty?: string
      realAmount?: string
      saleAmount?: string
      spec?: string
      ucode?: string
      unit?: string
    }[]
    latitude?: string
    leagueDiscountCode?: string
    longitude?: string
    merchantIdentify?: string
    merchantName?: string
    orderDiscountAmount?: string
    originalOrderId?: string
    payArray?: {
      category?: string
      channelDisAmt?: string
      channelPayAmt?: string
      merNo?: string
      middleOrderId?: string
      oriPaySsn?: string
      payAmt?: string
      payChannel?: string
      paySsn?: string
      payTime?: string
      promotionList?: {
        channelName?: string
        discountId?: string
        discountScope?: string
        discountType?: string
        eventDiscountAmount?: number
        eventName?: string
        eventNo?: string
        goodsList?: {
          discountAmount?: number
          goodsId?: string
          goodsNumber?: number
          goodsPrice?: number
          goodsRemark?: string
        }[]
        merchantDiscountAmount?: number
        platformDiscountAmount?: number
        thirdPartyDiscountAmount?: number
      }[]
      refNo?: string
      remark?: string
      settleDate?: string
      targetOrderId?: string
      targetSys?: string
      thirdPartyDiscountInstruction?: string
      tid?: string
      traceNo?: string
      transType?: string
      transTypeName?: string
      type?: string
    }[]
    posNo?: string
    province?: string
    receiverInfo?: {
      receiverAddress?: string
      receiverCityName?: string
      receiverDistrictCode?: string
      receiverDistrictName?: string
      receiverProvinceName?: string
    }
    refNo?: string
    remark?: string
    renewOrderCode?: string
    shopIdentify?: string
    shopName?: string
    srcAttach?: string
    thirdPartyOrderNo?: string
    tranId?: string
    tranStatus?: string
    tranTime?: string
    tranType?: string
    unionpayDiscountCode?: string
    version?: string
    wechatDiscountCode?: string
    yxlmCouponNo?: string
  }
  /**
   * 支付时间，yyyy-MM-dd HH:mm:ss
   */
  payTime?: string
  /**
   * 支付类型
   */
  payType: string
  /**
   * 参考号
   */
  refNo: string
}

/**
 * 接口 [开放接口-订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/492315) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/pay`
 */
export interface ApiOrderOpenPayResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [开放接口-订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/492315) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/pay`
 */
type ApiOrderOpenPayRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/pay',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/492315) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/pay`
 */
const apiOrderOpenPayRequestConfig: ApiOrderOpenPayRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/pay',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenPay',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-订单支付', author: '511号开发' },
  }

/**
 * 接口 [开放接口-订单支付↗](https://yapi.gogpay.cn/project/906/interface/api/492315) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/pay`
 */
export const apiOrderOpenPay = /*#__PURE__*/ (
  requestData: ApiOrderOpenPayRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenPayResponse>(
    prepare(apiOrderOpenPayRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenPay.requestConfig = apiOrderOpenPayRequestConfig

/**
 * 接口 [开放接口-预占消费券↗](https://yapi.gogpay.cn/project/906/interface/api/492322) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/preConsume`
 */
export interface ApiOrderOpenPreConsumeRequest {
  /**
   * 业务ID
   */
  bizId: string
  /**
   * 商品编码，商品在产品库中的唯一编码
   */
  goodsId?: string
  /**
   * 预占多久后释放（秒），默认600，最大3600秒。超出3600会按照3600使用
   */
  lockTimeout?: number
  /**
   * 购买数量
   */
  quantity?: number
  /**
   * 券码ID
   */
  ticketCode?: string
  /**
   * 交易金额（原价）
   */
  totalAmount?: number
  /**
   * 商品单价
   */
  unitPrice?: number
}

/**
 * 接口 [开放接口-预占消费券↗](https://yapi.gogpay.cn/project/906/interface/api/492322) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/preConsume`
 */
export interface ApiOrderOpenPreConsumeResponse {
  /**
   * 可优惠金额
   */
  discountAmount?: number
  /**
   * 预占释放时间 yyyy-MM-dd HH:mm:ss
   */
  expireTime?: string
  /**
   * 预占结果说明
   */
  resultMsg?: string
  /**
   * 预占状态  0未占用成功  1成功预占 2券码已被其他线下订单预占 3券码已被使用 4用户已被锁定核销
   */
  status?: number
  /**
   * 券码被预占的业务ID，当status=2或者3并且usePlatform=ums时会返回。或者当status=4时也会返回
   */
  useBizId?: string
  /**
   * 使用平台 dcb：多彩宝  ums：银联商务
   */
  usePlatform?: string
}

/**
 * 接口 [开放接口-预占消费券↗](https://yapi.gogpay.cn/project/906/interface/api/492322) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/preConsume`
 */
type ApiOrderOpenPreConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/preConsume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-预占消费券↗](https://yapi.gogpay.cn/project/906/interface/api/492322) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/preConsume`
 */
const apiOrderOpenPreConsumeRequestConfig: ApiOrderOpenPreConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/preConsume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenPreConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-预占消费券', author: '511号开发' },
  }

/**
 * 接口 [开放接口-预占消费券↗](https://yapi.gogpay.cn/project/906/interface/api/492322) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/preConsume`
 */
export const apiOrderOpenPreConsume = /*#__PURE__*/ (
  requestData: ApiOrderOpenPreConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenPreConsumeResponse>(
    prepare(apiOrderOpenPreConsumeRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenPreConsume.requestConfig = apiOrderOpenPreConsumeRequestConfig

/**
 * 接口 [开放接口-查询核销结果↗](https://yapi.gogpay.cn/project/906/interface/api/492329) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryConsumeResult`
 */
export interface ApiOrderOpenQueryConsumeResultRequest {
  /**
   * 订单编号
   */
  orderNo: string
}

/**
 * 接口 [开放接口-查询核销结果↗](https://yapi.gogpay.cn/project/906/interface/api/492329) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryConsumeResult`
 */
export interface ApiOrderOpenQueryConsumeResultResponse {
  /**
   * 核销成功时间，格式 yyyy-MM-dd HH:mm:ss.SSS
   */
  consumeTime?: string
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 核销成功对应的订单号，如果status=2，则会返回和入参的orderNo不一致的单号
   */
  orderNo?: string
  /**
   * 核销结果说明
   */
  resultMsg?: string
  /**
   * 核销状态  0未核销  1核销成功 2核销成功(被其他订单核销) 3已退款
   */
  status?: number
}

/**
 * 接口 [开放接口-查询核销结果↗](https://yapi.gogpay.cn/project/906/interface/api/492329) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryConsumeResult`
 */
type ApiOrderOpenQueryConsumeResultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/queryConsumeResult',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-查询核销结果↗](https://yapi.gogpay.cn/project/906/interface/api/492329) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryConsumeResult`
 */
const apiOrderOpenQueryConsumeResultRequestConfig: ApiOrderOpenQueryConsumeResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/queryConsumeResult',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenQueryConsumeResult',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-查询核销结果', author: '511号开发' },
  }

/**
 * 接口 [开放接口-查询核销结果↗](https://yapi.gogpay.cn/project/906/interface/api/492329) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryConsumeResult`
 */
export const apiOrderOpenQueryConsumeResult = /*#__PURE__*/ (
  requestData: ApiOrderOpenQueryConsumeResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenQueryConsumeResultResponse>(
    prepare(apiOrderOpenQueryConsumeResultRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenQueryConsumeResult.requestConfig =
  apiOrderOpenQueryConsumeResultRequestConfig

/**
 * 接口 [开放接口-查询预占结果↗](https://yapi.gogpay.cn/project/906/interface/api/492336) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryPreConsumeResult`
 */
export interface ApiOrderOpenQueryPreConsumeResultRequest {
  /**
   * 业务ID
   */
  bizId: string
}

/**
 * 接口 [开放接口-查询预占结果↗](https://yapi.gogpay.cn/project/906/interface/api/492336) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryPreConsumeResult`
 */
export interface ApiOrderOpenQueryPreConsumeResultResponse {
  /**
   * 可优惠金额
   */
  discountAmount?: number
  /**
   * 预占释放时间 yyyy-MM-dd HH:mm:ss
   */
  expireTime?: string
  /**
   * 预占结果说明
   */
  resultMsg?: string
  /**
   * 预占状态  0未占用成功  1成功预占 2券码已被其他线下订单预占 3券码已被使用 4用户已被锁定核销
   */
  status?: number
  /**
   * 券码被预占的业务ID，当status=2或者3并且usePlatform=ums时会返回。或者当status=4时也会返回
   */
  useBizId?: string
  /**
   * 使用平台 dcb：多彩宝  ums：银联商务
   */
  usePlatform?: string
}

/**
 * 接口 [开放接口-查询预占结果↗](https://yapi.gogpay.cn/project/906/interface/api/492336) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryPreConsumeResult`
 */
type ApiOrderOpenQueryPreConsumeResultRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/queryPreConsumeResult',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-查询预占结果↗](https://yapi.gogpay.cn/project/906/interface/api/492336) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryPreConsumeResult`
 */
const apiOrderOpenQueryPreConsumeResultRequestConfig: ApiOrderOpenQueryPreConsumeResultRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/queryPreConsumeResult',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenQueryPreConsumeResult',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-查询预占结果', author: '511号开发' },
  }

/**
 * 接口 [开放接口-查询预占结果↗](https://yapi.gogpay.cn/project/906/interface/api/492336) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryPreConsumeResult`
 */
export const apiOrderOpenQueryPreConsumeResult = /*#__PURE__*/ (
  requestData: ApiOrderOpenQueryPreConsumeResultRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenQueryPreConsumeResultResponse>(
    prepare(apiOrderOpenQueryPreConsumeResultRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenQueryPreConsumeResult.requestConfig =
  apiOrderOpenQueryPreConsumeResultRequestConfig

/**
 * 接口 [开放接口-查询机构店铺状态↗](https://yapi.gogpay.cn/project/906/interface/api/492343) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryStoreStatus`
 */
export interface ApiOrderOpenQueryStoreStatusRequest {
  /**
   * 外部系统店铺ID
   */
  storeId?: string
}

/**
 * 接口 [开放接口-查询机构店铺状态↗](https://yapi.gogpay.cn/project/906/interface/api/492343) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryStoreStatus`
 */
export interface ApiOrderOpenQueryStoreStatusResponse {
  /**
   * 驳回原因
   */
  reason?: string
  /**
   * 审核结果 0待审核 1审核通过 2审核拒绝
   */
  status?: number
}

/**
 * 接口 [开放接口-查询机构店铺状态↗](https://yapi.gogpay.cn/project/906/interface/api/492343) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryStoreStatus`
 */
type ApiOrderOpenQueryStoreStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/open/api/queryStoreStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [开放接口-查询机构店铺状态↗](https://yapi.gogpay.cn/project/906/interface/api/492343) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryStoreStatus`
 */
const apiOrderOpenQueryStoreStatusRequestConfig: ApiOrderOpenQueryStoreStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_33,
    devUrl: devUrl_0_5_0_33,
    prodUrl: prodUrl_0_5_0_33,
    path: '/order/open/api/queryStoreStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenQueryStoreStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '开放接口-查询机构店铺状态', author: '511号开发' },
  }

/**
 * 接口 [开放接口-查询机构店铺状态↗](https://yapi.gogpay.cn/project/906/interface/api/492343) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-api-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86342)
 * @请求头 `POST /order/open/api/queryStoreStatus`
 */
export const apiOrderOpenQueryStoreStatus = /*#__PURE__*/ (
  requestData: ApiOrderOpenQueryStoreStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenQueryStoreStatusResponse>(
    prepare(apiOrderOpenQueryStoreStatusRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenQueryStoreStatus.requestConfig =
  apiOrderOpenQueryStoreStatusRequestConfig

const mockUrl_0_5_0_34 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_34 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_34 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_34 = 'data' as any

/**
 * 接口 [查询线下订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/492350) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-mall-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86344)
 * @请求头 `POST /order/openApi/dcbMall/getOfflineOrderList`
 */
export interface ApiOrderOpenApiDcbMallGetOfflineOrderListRequest {
  /**
   * 筛选订单状态
   */
  adminMallOrderStatus?: number
  /**
   * 下单开始时间，yyyy-MM-dd HH:mm:ss
   */
  beginTime?: string
  /**
   * 下单结束时间，yyyy-MM-dd HH:mm:ss
   */
  endTime?: string
  /**
   * 订单编号/收件人手机号
   */
  keyword?: string
  /**
   * 筛选状态 0全部 1待付款 2待发货 3待收货 4待评价 5已完成 6待使用  7待接单  8待配送 9配送中 10售后中 11盲盒 12拼团
   */
  mallOrderStatus?: number
  /**
   * 下单结束时间，yyyy-MM-dd HH:mm:ss
   */
  orderEndTime?: string
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 下单开始时间，yyyy-MM-dd HH:mm:ss
   */
  orderStartTime?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 支付类型
   */
  payType?: string
  /**
   * 店铺编码
   */
  storeId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
}

/**
 * 接口 [查询线下订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/492350) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-mall-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86344)
 * @请求头 `POST /order/openApi/dcbMall/getOfflineOrderList`
 */
export interface ApiOrderOpenApiDcbMallGetOfflineOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 送达操作人纬度
     */
    arriveLatitude?: string
    /**
     * 送达操作人经度
     */
    arriveLongitude?: string
    /**
     * 送达人
     */
    arriveName?: string
    /**
     * 送达时间
     */
    arriveTime?: string
    /**
     * 送达操作用户Id
     */
    arriveUserId?: string
    /**
     * 货物69码图片
     */
    barCodePicList?: string[]
    /**
     * 业务单号
     */
    bizId?: string
    /**
     * 取消时间
     */
    cancelTime?: string
    /**
     * 商品类目ID
     */
    categoryId?: string
    /**
     * 货物图片
     */
    commodityPicList?: string[]
    consigneeInfo?: {
      /**
       * 收件地址-详细地址
       */
      address?: string
      /**
       * 收件地址-地区
       */
      area?: string
      /**
       * 收件地址-城市
       */
      city?: string
      /**
       * 收件人
       */
      name?: string
      /**
       * 收件地址-省份
       */
      province?: string
      /**
       * 收件人手机号
       */
      tel?: string
    }
    /**
     * 券码活动ID
     */
    couponActivityId?: string
    /**
     * 券码
     */
    couponCode?: string
    /**
     * 券码ID
     */
    couponPoolId?: string
    /**
     * 优惠券核销凭据
     */
    couponPreUseTicket?: string
    /**
     * 发货人姓名
     */
    deliverName?: string
    /**
     * 发货时间
     */
    deliverTime?: string
    /**
     * 发货人Id
     */
    deliverUserId?: string
    /**
     * 优惠金额
     */
    discountAmount?: number
    dispatchInfo?: {
      /**
       * 服务人员Id
       */
      serviceUserId?: string
      /**
       * 服务人员姓名
       */
      serviceUserName?: string
      /**
       * 服务人员手机号
       */
      serviceUserTel?: string
      /**
       * 自定义配送文案
       */
      tips?: string
    }
    /**
     * 商品编码
     */
    goodsId?: string
    /**
     * 货物拆封图片
     */
    goodsUnsealingPicList?: string[]
    /**
     * 配送方式值 1现场提货 3配送发货
     */
    logisticsMethodValue?: number
    /**
     * 订单状态 0未支付 100待发货
     */
    mallOrderStatus?:
      | '1'
      | '0'
      | '100'
      | '101'
      | '102'
      | '200'
      | '201'
      | '202'
      | '203'
      | '204'
      | '300'
      | '400'
      | '401'
      | '402'
      | '900'
      | '901'
      | '902'
      | '903'
    /**
     * 订单状态 0预占成功 1核销成功 2取消核销 3取消预占
     */
    orderStatus?: number
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 出库单
     */
    outboundOrders?: string[]
    /**
     * 支付金额
     */
    payAmount?: number
    /**
     * 支付单号
     */
    payOrderNo?: string
    /**
     * 支付状态 1未支付 2已支付
     */
    payStatus?: number
    /**
     * 支付时间
     */
    payTime?: string
    /**
     * 支付类型
     */
    payType?: string
    /**
     * 预占到期时间
     */
    preExpireTime?: string
    /**
     * 变更原因
     */
    reason?: string
    /**
     * 商品规格
     */
    skuId?: string
    /**
     * 店铺编码
     */
    storeId?: string
    /**
     * 订单金额
     */
    totalAmount?: number
    /**
     * 用户Id
     */
    userId?: string
    /**
     * 用户手机号
     */
    userPhone?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询线下订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/492350) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-mall-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86344)
 * @请求头 `POST /order/openApi/dcbMall/getOfflineOrderList`
 */
type ApiOrderOpenApiDcbMallGetOfflineOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/openApi/dcbMall/getOfflineOrderList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询线下订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/492350) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-mall-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86344)
 * @请求头 `POST /order/openApi/dcbMall/getOfflineOrderList`
 */
const apiOrderOpenApiDcbMallGetOfflineOrderListRequestConfig: ApiOrderOpenApiDcbMallGetOfflineOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_34,
    devUrl: devUrl_0_5_0_34,
    prodUrl: prodUrl_0_5_0_34,
    path: '/order/openApi/dcbMall/getOfflineOrderList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenApiDcbMallGetOfflineOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询线下订单信息', author: '511号开发' },
  }

/**
 * 接口 [查询线下订单信息↗](https://yapi.gogpay.cn/project/906/interface/api/492350) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-mall-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86344)
 * @请求头 `POST /order/openApi/dcbMall/getOfflineOrderList`
 */
export const apiOrderOpenApiDcbMallGetOfflineOrderList = /*#__PURE__*/ (
  requestData: ApiOrderOpenApiDcbMallGetOfflineOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenApiDcbMallGetOfflineOrderListResponse>(
    prepare(
      apiOrderOpenApiDcbMallGetOfflineOrderListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderOpenApiDcbMallGetOfflineOrderList.requestConfig =
  apiOrderOpenApiDcbMallGetOfflineOrderListRequestConfig

const mockUrl_0_5_0_35 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_35 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_35 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_35 = 'data' as any

/**
 * 接口 [用券↗](https://yapi.gogpay.cn/project/906/interface/api/492357) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/consume`
 */
export interface ApiOrderOpenApiMarketingCouponConsumeRequest {
  address?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 城市代码
     */
    cityCode?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 省份代码
     */
    provinceCode?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
  }
  /**
   * 消费金额
   */
  amount?: number
  /**
   * 业务ID
   */
  bizId?: string
  /**
   * 用户IP
   */
  clientIP?: string
  /**
   * 商品封面图
   */
  commodityCoverImg?: string
  /**
   * 商品名称
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 消费时间
   */
  consumeTime?: string
  /**
   * 优惠券领取id
   */
  couponPoolId?: string
  /**
   *  优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType?: number
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 中台订单编号
   */
  orderNo?: string
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [用券↗](https://yapi.gogpay.cn/project/906/interface/api/492357) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/consume`
 */
export interface ApiOrderOpenApiMarketingCouponConsumeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [用券↗](https://yapi.gogpay.cn/project/906/interface/api/492357) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/consume`
 */
type ApiOrderOpenApiMarketingCouponConsumeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/openApi/marketingCoupon/consume',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [用券↗](https://yapi.gogpay.cn/project/906/interface/api/492357) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/consume`
 */
const apiOrderOpenApiMarketingCouponConsumeRequestConfig: ApiOrderOpenApiMarketingCouponConsumeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_35,
    devUrl: devUrl_0_5_0_35,
    prodUrl: prodUrl_0_5_0_35,
    path: '/order/openApi/marketingCoupon/consume',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenApiMarketingCouponConsume',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '用券', author: '511号开发' },
  }

/**
 * 接口 [用券↗](https://yapi.gogpay.cn/project/906/interface/api/492357) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/consume`
 */
export const apiOrderOpenApiMarketingCouponConsume = /*#__PURE__*/ (
  requestData: ApiOrderOpenApiMarketingCouponConsumeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenApiMarketingCouponConsumeResponse>(
    prepare(apiOrderOpenApiMarketingCouponConsumeRequestConfig, requestData),
    ...args,
  )
}

apiOrderOpenApiMarketingCouponConsume.requestConfig =
  apiOrderOpenApiMarketingCouponConsumeRequestConfig

/**
 * 接口 [领券校验↗](https://yapi.gogpay.cn/project/906/interface/api/492364) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/receiveCheck`
 */
export interface ApiOrderOpenApiMarketingCouponReceiveCheckRequest {
  /**
   * 优惠Id
   */
  couponId?: string
  /**
   *  优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType?: number
  /**
   * 折扣比例0-1
   */
  discountRatio?: number
  /**
   * 折扣最高优惠金额
   */
  discountSingleOrderMaxLimit?: number
  /**
   * 优惠金额
   */
  fullAmount?: number
  /**
   * 使用门槛；0表示无门槛
   */
  minPoint?: number
  /**
   * 用户手机
   */
  phone?: string
  /**
   * 用户Id
   */
  userId?: string
}

/**
 * 接口 [领券校验↗](https://yapi.gogpay.cn/project/906/interface/api/492364) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/receiveCheck`
 */
export interface ApiOrderOpenApiMarketingCouponReceiveCheckResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [领券校验↗](https://yapi.gogpay.cn/project/906/interface/api/492364) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/receiveCheck`
 */
type ApiOrderOpenApiMarketingCouponReceiveCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/openApi/marketingCoupon/receiveCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [领券校验↗](https://yapi.gogpay.cn/project/906/interface/api/492364) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/receiveCheck`
 */
const apiOrderOpenApiMarketingCouponReceiveCheckRequestConfig: ApiOrderOpenApiMarketingCouponReceiveCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_35,
    devUrl: devUrl_0_5_0_35,
    prodUrl: prodUrl_0_5_0_35,
    path: '/order/openApi/marketingCoupon/receiveCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOpenApiMarketingCouponReceiveCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领券校验', author: '511号开发' },
  }

/**
 * 接口 [领券校验↗](https://yapi.gogpay.cn/project/906/interface/api/492364) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [open-marketing-coupon-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86346)
 * @请求头 `POST /order/openApi/marketingCoupon/receiveCheck`
 */
export const apiOrderOpenApiMarketingCouponReceiveCheck = /*#__PURE__*/ (
  requestData: ApiOrderOpenApiMarketingCouponReceiveCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOpenApiMarketingCouponReceiveCheckResponse>(
    prepare(
      apiOrderOpenApiMarketingCouponReceiveCheckRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderOpenApiMarketingCouponReceiveCheck.requestConfig =
  apiOrderOpenApiMarketingCouponReceiveCheckRequestConfig

const mockUrl_0_5_0_36 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_36 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_36 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_36 = 'data' as any

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/491853) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/arrive`
 */
export interface ApiOrderOfflineOrderArriveRequest {
  /**
   * 货物69码图片
   */
  barCodePicList?: string[]
  /**
   * 货物拆封图片
   */
  goodsUnsealingPicList?: string[]
  /**
   * 纬度
   */
  latitude: string
  /**
   * 经度
   */
  longitude: string
  /**
   * 订单号
   */
  orderNo: string
}

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/491853) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/arrive`
 */
export interface ApiOrderOfflineOrderArriveResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/491853) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/arrive`
 */
type ApiOrderOfflineOrderArriveRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/offline/order/arrive',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/491853) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/arrive`
 */
const apiOrderOfflineOrderArriveRequestConfig: ApiOrderOfflineOrderArriveRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_36,
    devUrl: devUrl_0_5_0_36,
    prodUrl: prodUrl_0_5_0_36,
    path: '/order/api/offline/order/arrive',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOfflineOrderArrive',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '线下订单确认送达', author: '511号开发' },
  }

/**
 * 接口 [线下订单确认送达↗](https://yapi.gogpay.cn/project/906/interface/api/491853) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/arrive`
 */
export const apiOrderOfflineOrderArrive = /*#__PURE__*/ (
  requestData: ApiOrderOfflineOrderArriveRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOfflineOrderArriveResponse>(
    prepare(apiOrderOfflineOrderArriveRequestConfig, requestData),
    ...args,
  )
}

apiOrderOfflineOrderArrive.requestConfig =
  apiOrderOfflineOrderArriveRequestConfig

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/491860) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/deliver`
 */
export interface ApiOrderOfflineOrderDeliverRequest {
  /**
   * 货物图片
   */
  commodityPicList?: string[]
  consigneeInfo?: {
    /**
     * 收件地址-详细地址
     */
    address?: string
    /**
     * 收件地址-地区
     */
    area?: string
    /**
     * 收件地址-城市
     */
    city?: string
    /**
     * 收件人
     */
    name?: string
    /**
     * 收件地址-省份
     */
    province?: string
    /**
     * 收件人手机号
     */
    tel?: string
  }
  dispatchInfo?: {
    /**
     * 服务人员Id
     */
    serviceUserId?: string
    /**
     * 服务人员姓名
     */
    serviceUserName?: string
    /**
     * 服务人员手机号
     */
    serviceUserTel?: string
    /**
     * 自定义配送文案
     */
    tips?: string
  }
  /**
   * 配送方式值 1现场提货 3配送发货
   */
  logisticsMethodValue?: number
  /**
   * 订单号
   */
  orderNo: string
  /**
   * 出库单
   */
  outboundOrders?: string[]
}

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/491860) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/deliver`
 */
export interface ApiOrderOfflineOrderDeliverResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/491860) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/deliver`
 */
type ApiOrderOfflineOrderDeliverRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/offline/order/deliver',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/491860) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/deliver`
 */
const apiOrderOfflineOrderDeliverRequestConfig: ApiOrderOfflineOrderDeliverRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_36,
    devUrl: devUrl_0_5_0_36,
    prodUrl: prodUrl_0_5_0_36,
    path: '/order/api/offline/order/deliver',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOfflineOrderDeliver',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '线下订单发货', author: '511号开发' },
  }

/**
 * 接口 [线下订单发货↗](https://yapi.gogpay.cn/project/906/interface/api/491860) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [web-offline-order-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86348)
 * @请求头 `POST /order/api/offline/order/deliver`
 */
export const apiOrderOfflineOrderDeliver = /*#__PURE__*/ (
  requestData: ApiOrderOfflineOrderDeliverRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOfflineOrderDeliverResponse>(
    prepare(apiOrderOfflineOrderDeliverRequestConfig, requestData),
    ...args,
  )
}

apiOrderOfflineOrderDeliver.requestConfig =
  apiOrderOfflineOrderDeliverRequestConfig

const mockUrl_0_5_0_37 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_37 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_37 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_37 = 'data' as any

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/906/interface/api/491867) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-store-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86350)
 * @请求头 `POST /order/api/offline/store/locationList`
 */
export interface ApiOrderOfflineStoreLocationListRequest {
  /**
   * 排序方式 asc=正序 desc=倒序
   */
  direction?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 定位类型 baidu、gcj、gps
   */
  locationType?: string
  /**
   * 经度
   */
  lon?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺名称
   */
  storeName?: string
}

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/906/interface/api/491867) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-store-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86350)
 * @请求头 `POST /order/api/offline/store/locationList`
 */
export type ApiOrderOfflineStoreLocationListResponse = {
  /**
   * 店铺地址
   */
  address?: string
  /**
   * 距离
   */
  distance?: string
  /**
   * 店铺Id
   */
  id?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lon?: string
  /**
   * 店铺名称
   */
  name?: string
}[]

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/906/interface/api/491867) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [web-offline-store-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86350)
 * @请求头 `POST /order/api/offline/store/locationList`
 */
type ApiOrderOfflineStoreLocationListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/offline/store/locationList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/906/interface/api/491867) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [web-offline-store-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86350)
 * @请求头 `POST /order/api/offline/store/locationList`
 */
const apiOrderOfflineStoreLocationListRequestConfig: ApiOrderOfflineStoreLocationListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_37,
    devUrl: devUrl_0_5_0_37,
    prodUrl: prodUrl_0_5_0_37,
    path: '/order/api/offline/store/locationList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_37,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderOfflineStoreLocationList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分页查询线下店铺列表（带定位）', author: '511号开发' },
  }

/**
 * 接口 [分页查询线下店铺列表（带定位）↗](https://yapi.gogpay.cn/project/906/interface/api/491867) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [web-offline-store-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86350)
 * @请求头 `POST /order/api/offline/store/locationList`
 */
export const apiOrderOfflineStoreLocationList = /*#__PURE__*/ (
  requestData: ApiOrderOfflineStoreLocationListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderOfflineStoreLocationListResponse>(
    prepare(apiOrderOfflineStoreLocationListRequestConfig, requestData),
    ...args,
  )
}

apiOrderOfflineStoreLocationList.requestConfig =
  apiOrderOfflineStoreLocationListRequestConfig

const mockUrl_0_5_0_38 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_38 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_38 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_38 = 'data' as any

/**
 * 接口 [导出审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492252) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/export`
 */
export interface ApiOrderImsApiUmsOrderExportRequest {
  /**
   * 审核状态 1-未同步 2-待审核 3-审核通过 4-审核驳回
   */
  auditStatus?: 'UN_SYNC' | 'AUDITING' | 'SUCCESS' | 'FAIL' | 'WAIT_IMPROVE'
  /**
   * 订单渠道 1线上 2线下
   */
  channel?: 'ONLINE' | 'OFFLINE'
  /**
   * 搜索关键字
   */
  keyword?: string
  /**
   * 订单结束时间，格式：yyyy-MM-dd
   */
  orderEndTime?: string
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单开始时间，格式：yyyy-MM-dd
   */
  orderStartTime?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 门店Id
   */
  storeId?: string
  /**
   * 门店名称
   */
  storeName?: string
  /**
   * 上传结束时间，格式：yyyy-MM-dd
   */
  uploadEndTime?: string
  /**
   * 上传开始时间，格式：yyyy-MM-dd
   */
  uploadStartTime?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [导出审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492252) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/export`
 */
export interface ApiOrderImsApiUmsOrderExportResponse {
  /**
   * 文件地址
   */
  fileUrl?: string
  /**
   * 是否属于任务中心任务
   */
  useTask?: boolean
}

/**
 * 接口 [导出审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492252) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/export`
 */
type ApiOrderImsApiUmsOrderExportRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/ums/order/export',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [导出审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492252) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/export`
 */
const apiOrderImsApiUmsOrderExportRequestConfig: ApiOrderImsApiUmsOrderExportRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_38,
    devUrl: devUrl_0_5_0_38,
    prodUrl: prodUrl_0_5_0_38,
    path: '/order/imsApi/ums/order/export',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiUmsOrderExport',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '导出审计订单列表', author: '511号开发' },
  }

/**
 * 接口 [导出审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492252) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/export`
 */
export const apiOrderImsApiUmsOrderExport = /*#__PURE__*/ (
  requestData: ApiOrderImsApiUmsOrderExportRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiUmsOrderExportResponse>(
    prepare(apiOrderImsApiUmsOrderExportRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiUmsOrderExport.requestConfig =
  apiOrderImsApiUmsOrderExportRequestConfig

/**
 * 接口 [查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492259) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/list`
 */
export interface ApiOrderImsApiUmsOrderListRequest {
  /**
   * 审核状态 1-未同步 2-待审核 3-审核通过 4-审核驳回
   */
  auditStatus?: 'UN_SYNC' | 'AUDITING' | 'SUCCESS' | 'FAIL' | 'WAIT_IMPROVE'
  /**
   * 订单渠道 1线上 2线下
   */
  channel?: 'ONLINE' | 'OFFLINE'
  /**
   * 搜索关键字
   */
  keyword?: string
  /**
   * 订单结束时间，格式：yyyy-MM-dd
   */
  orderEndTime?: string
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单开始时间，格式：yyyy-MM-dd
   */
  orderStartTime?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 门店Id
   */
  storeId?: string
  /**
   * 门店名称
   */
  storeName?: string
  /**
   * 上传结束时间，格式：yyyy-MM-dd
   */
  uploadEndTime?: string
  /**
   * 上传开始时间，格式：yyyy-MM-dd
   */
  uploadStartTime?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492259) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/list`
 */
export interface ApiOrderImsApiUmsOrderListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 审核结果
     */
    auditResult?: string
    /**
     * 审核状态
     */
    auditStatus?: number
    /**
     * 审核状态标签
     */
    auditStatusLabel?: string
    buyerInfo?: {
      /**
       * 收货地址
       */
      address?: string
      /**
       * 预约时间
       */
      appointmentDate?: string
      /**
       * 身份证号
       */
      idCardNo?: string
      /**
       * 买家姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
    }
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 数据是否完整
     */
    dataFullFlag?: string
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 商品名称
     */
    goodsName?: string
    /**
     * 商品图片
     */
    goodsPic?: string
    /**
     * 商品拆封图片
     */
    goodsUnsealingPic?: string[]
    /**
     * 数据id
     */
    id?: string
    /**
     * 发票金额
     */
    invoiceAmount?: number
    /**
     * 开票时间
     */
    invoiceDate?: string
    /**
     * 发票抬头，购买方名称
     */
    invoiceHead?: string
    /**
     * 发票图片
     */
    invoiceImage?: string
    /**
     * 发票号码
     */
    invoiceNo?: string
    /**
     * 项目名称
     */
    invoiceProjectName?: string
    /**
     * 规格型号
     */
    invoiceSpecification?: string
    /**
     * 商城订单编号
     */
    mallOrderNo?: string
    /**
     * 订单编号
     */
    orderNo?: string
    /**
     * 订单状态
     */
    orderStatus?: string
    /**
     * 下单时间
     */
    orderTime?: string
    /**
     * 出库单
     */
    outboundOrders?: string[]
    /**
     * 是否已推送
     */
    pushFlag?: string
    /**
     * 数量
     */
    quantity?: number
    /**
     * 销售企业名称
     */
    sellerName?: string
    /**
     * 序列ID
     */
    seqId?: string
    /**
     * 签收单
     */
    signaturePic?: string[]
    /**
     * 门店Id
     */
    storeId?: string
    /**
     * 门店名称
     */
    storeName?: string
    /**
     * 总价
     */
    totalPrice?: number
    /**
     * 单价
     */
    unitPrice?: number
    /**
     * 上传时间
     */
    uploadTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492259) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/list`
 */
type ApiOrderImsApiUmsOrderListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/ums/order/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492259) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/list`
 */
const apiOrderImsApiUmsOrderListRequestConfig: ApiOrderImsApiUmsOrderListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_38,
    devUrl: devUrl_0_5_0_38,
    prodUrl: prodUrl_0_5_0_38,
    path: '/order/imsApi/ums/order/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiUmsOrderList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询审计订单列表', author: '511号开发' },
  }

/**
 * 接口 [查询审计订单列表↗](https://yapi.gogpay.cn/project/906/interface/api/492259) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [审计订单管理↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86352)
 * @请求头 `POST /order/imsApi/ums/order/list`
 */
export const apiOrderImsApiUmsOrderList = /*#__PURE__*/ (
  requestData: ApiOrderImsApiUmsOrderListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiUmsOrderListResponse>(
    prepare(apiOrderImsApiUmsOrderListRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiUmsOrderList.requestConfig =
  apiOrderImsApiUmsOrderListRequestConfig

const mockUrl_0_5_0_39 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_39 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_39 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_39 = 'data' as any

/**
 * 接口 [查询用户是否有消费金资格↗](https://yapi.gogpay.cn/project/906/interface/api/491748) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/findUserAging`
 */
export interface ApiOrderBusinessFindUserAgingRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询用户是否有消费金资格↗](https://yapi.gogpay.cn/project/906/interface/api/491748) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/findUserAging`
 */
export interface ApiOrderBusinessFindUserAgingResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [查询用户是否有消费金资格↗](https://yapi.gogpay.cn/project/906/interface/api/491748) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/findUserAging`
 */
type ApiOrderBusinessFindUserAgingRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/business/findUserAging',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户是否有消费金资格↗](https://yapi.gogpay.cn/project/906/interface/api/491748) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/findUserAging`
 */
const apiOrderBusinessFindUserAgingRequestConfig: ApiOrderBusinessFindUserAgingRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_39,
    devUrl: devUrl_0_5_0_39,
    prodUrl: prodUrl_0_5_0_39,
    path: '/order/api/business/findUserAging',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderBusinessFindUserAging',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户是否有消费金资格', author: '511号开发' },
  }

/**
 * 接口 [查询用户是否有消费金资格↗](https://yapi.gogpay.cn/project/906/interface/api/491748) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/findUserAging`
 */
export const apiOrderBusinessFindUserAging = /*#__PURE__*/ (
  requestData: ApiOrderBusinessFindUserAgingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderBusinessFindUserAgingResponse>(
    prepare(apiOrderBusinessFindUserAgingRequestConfig, requestData),
    ...args,
  )
}

apiOrderBusinessFindUserAging.requestConfig =
  apiOrderBusinessFindUserAgingRequestConfig

/**
 * 接口 [分页查询商店信息↗](https://yapi.gogpay.cn/project/906/interface/api/491755) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/pageList`
 */
export interface ApiOrderBusinessPageListRequest {
  /**
   * 业务类型
   */
  businessType?: number
  /**
   * 商户类型
   */
  commercialType?: number
  /**
   * 区划编码
   */
  districtCode?: string
  /**
   * 消费券Id
   */
  fundsInfoId?: string
  /**
   * 搜索关键词
   */
  keyWord?: string
  /**
   * 联系电话
   */
  managePhoneNo?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 商户名称
   */
  storeName?: string
  /**
   * 商户编码
   */
  unitOrgCode?: string
}

/**
 * 接口 [分页查询商店信息↗](https://yapi.gogpay.cn/project/906/interface/api/491755) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/pageList`
 */
export interface ApiOrderBusinessPageListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 店铺地址
     */
    address?: string
    /**
     * 业务类型(1-多多商城 0-多多收银台
     */
    businessType?: number
    /**
     * 店铺类型
     */
    commercialType?: number
    /**
     * 店铺类型名称
     */
    commercialTypeName?: string
    /**
     * 店铺区划
     */
    districtName?: string
    /**
     * 商家id
     */
    id?: string
    /**
     * 联系电话
     */
    managePhoneNo?: string
    /**
     * 联系人
     */
    manageUserName?: string
    /**
     * 店铺地址
     */
    storeAdd?: string
    /**
     * 商家id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [分页查询商店信息↗](https://yapi.gogpay.cn/project/906/interface/api/491755) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/pageList`
 */
type ApiOrderBusinessPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/business/pageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [分页查询商店信息↗](https://yapi.gogpay.cn/project/906/interface/api/491755) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/pageList`
 */
const apiOrderBusinessPageListRequestConfig: ApiOrderBusinessPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_39,
    devUrl: devUrl_0_5_0_39,
    prodUrl: prodUrl_0_5_0_39,
    path: '/order/api/business/pageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderBusinessPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '分页查询商店信息', author: '511号开发' },
  }

/**
 * 接口 [分页查询商店信息↗](https://yapi.gogpay.cn/project/906/interface/api/491755) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/pageList`
 */
export const apiOrderBusinessPageList = /*#__PURE__*/ (
  requestData: ApiOrderBusinessPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderBusinessPageListResponse>(
    prepare(apiOrderBusinessPageListRequestConfig, requestData),
    ...args,
  )
}

apiOrderBusinessPageList.requestConfig = apiOrderBusinessPageListRequestConfig

/**
 * 接口 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/491762) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderInfoPush`
 */
export interface ApiOrderBusinessYardGoOrderInfoPushRequest {
  /**
   * 订单编号列表
   */
  dcbOrderNo?: string[]
}

/**
 * 接口 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/491762) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderInfoPush`
 */
export interface ApiOrderBusinessYardGoOrderInfoPushResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/491762) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderInfoPush`
 */
type ApiOrderBusinessYardGoOrderInfoPushRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/business/yardGoOrderInfoPush',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/491762) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderInfoPush`
 */
const apiOrderBusinessYardGoOrderInfoPushRequestConfig: ApiOrderBusinessYardGoOrderInfoPushRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_39,
    devUrl: devUrl_0_5_0_39,
    prodUrl: prodUrl_0_5_0_39,
    path: '/order/api/business/yardGoOrderInfoPush',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderBusinessYardGoOrderInfoPush',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '一码贵州订单推送', author: '511号开发' },
  }

/**
 * 接口 [一码贵州订单推送↗](https://yapi.gogpay.cn/project/906/interface/api/491762) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderInfoPush`
 */
export const apiOrderBusinessYardGoOrderInfoPush = /*#__PURE__*/ (
  requestData: ApiOrderBusinessYardGoOrderInfoPushRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderBusinessYardGoOrderInfoPushResponse>(
    prepare(apiOrderBusinessYardGoOrderInfoPushRequestConfig, requestData),
    ...args,
  )
}

apiOrderBusinessYardGoOrderInfoPush.requestConfig =
  apiOrderBusinessYardGoOrderInfoPushRequestConfig

/**
 * 接口 [一码贵州订单退款推送↗](https://yapi.gogpay.cn/project/906/interface/api/491769) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderRefundPush`
 */
export interface ApiOrderBusinessYardGoOrderRefundPushRequest {
  /**
   * 订单编号列表
   */
  dcbOrderNo?: string[]
}

/**
 * 接口 [一码贵州订单退款推送↗](https://yapi.gogpay.cn/project/906/interface/api/491769) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderRefundPush`
 */
export interface ApiOrderBusinessYardGoOrderRefundPushResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [一码贵州订单退款推送↗](https://yapi.gogpay.cn/project/906/interface/api/491769) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderRefundPush`
 */
type ApiOrderBusinessYardGoOrderRefundPushRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/business/yardGoOrderRefundPush',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [一码贵州订单退款推送↗](https://yapi.gogpay.cn/project/906/interface/api/491769) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderRefundPush`
 */
const apiOrderBusinessYardGoOrderRefundPushRequestConfig: ApiOrderBusinessYardGoOrderRefundPushRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_39,
    devUrl: devUrl_0_5_0_39,
    prodUrl: prodUrl_0_5_0_39,
    path: '/order/api/business/yardGoOrderRefundPush',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderBusinessYardGoOrderRefundPush',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '一码贵州订单退款推送', author: '511号开发' },
  }

/**
 * 接口 [一码贵州订单退款推送↗](https://yapi.gogpay.cn/project/906/interface/api/491769) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-商家管理接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86354)
 * @请求头 `POST /order/api/business/yardGoOrderRefundPush`
 */
export const apiOrderBusinessYardGoOrderRefundPush = /*#__PURE__*/ (
  requestData: ApiOrderBusinessYardGoOrderRefundPushRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderBusinessYardGoOrderRefundPushResponse>(
    prepare(apiOrderBusinessYardGoOrderRefundPushRequestConfig, requestData),
    ...args,
  )
}

apiOrderBusinessYardGoOrderRefundPush.requestConfig =
  apiOrderBusinessYardGoOrderRefundPushRequestConfig

const mockUrl_0_5_0_40 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_40 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_40 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_40 = 'data' as any

/**
 * 接口 [申请补贴金提交↗](https://yapi.gogpay.cn/project/906/interface/api/491615) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/applyFunds`
 */
export interface ApiOrderApplyFoundsApplyFundsRequest {
  /**
   * 老年人认证凭据
   */
  authToken?: string
  /**
   * 代理人认证凭据
   */
  clientAuthToken?: string
  /**
   * 申请记录id
   */
  id?: string
  /**
   * 申请记录id
   */
  applyInfoId?: string
  /**
   * 用户姓名
   */
  userName?: string
  /**
   * 用户姓名
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
  /**
   * 用户身份证号
   */
  userIdCardNo?: string
  /**
   * 提交类型 1本人提交 2委托提交
   */
  applyType?: number
  /**
   * 老年人身份证来源用户姓名
   */
  cardName?: string
  /**
   * 老年人身份证来源身份证号
   */
  cardIdNo?: string
  /**
   * 老年人ocr身份证来源用户姓名
   */
  ocrCardName?: string
  /**
   * 老年人ocr身份证来源身份证号
   */
  ocrCardIdNo?: string
  /**
   * 老年人身份证正面图片
   */
  idCardImgFront?: string
  /**
   * 老年人身份证反面图片
   */
  idCardImgBack?: string
  /**
   * 代理人身份证来源用户姓名
   */
  clientCardName?: string
  /**
   * 代理人身份证来源身份证号
   */
  clientCardIdNo?: string
  /**
   * 代理人ocr身份证来源用户姓名
   */
  clientOcrCardName?: string
  /**
   * 代理人ocr身份证来源身份证号
   */
  clientOcrCardIdNo?: string
  /**
   * 代理人身份证正面图片
   */
  clientIdCardImgFront?: string
  /**
   * 代理人身份证反面图片
   */
  clientIdCardImgBack?: string
  /**
   * 委托代申领承诺书
   */
  clientApplyCertificate?: string
}

/**
 * 接口 [申请补贴金提交↗](https://yapi.gogpay.cn/project/906/interface/api/491615) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/applyFunds`
 */
export interface ApiOrderApplyFoundsApplyFundsResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [申请补贴金提交↗](https://yapi.gogpay.cn/project/906/interface/api/491615) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/applyFunds`
 */
type ApiOrderApplyFoundsApplyFundsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyFounds/applyFunds',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请补贴金提交↗](https://yapi.gogpay.cn/project/906/interface/api/491615) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/applyFunds`
 */
const apiOrderApplyFoundsApplyFundsRequestConfig: ApiOrderApplyFoundsApplyFundsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_40,
    devUrl: devUrl_0_5_0_40,
    prodUrl: prodUrl_0_5_0_40,
    path: '/order/api/applyFounds/applyFunds',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyFoundsApplyFunds',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请补贴金提交', author: '511号开发' },
  }

/**
 * 接口 [申请补贴金提交↗](https://yapi.gogpay.cn/project/906/interface/api/491615) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/applyFunds`
 */
export const apiOrderApplyFoundsApplyFunds = /*#__PURE__*/ (
  requestData: ApiOrderApplyFoundsApplyFundsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyFoundsApplyFundsResponse>(
    prepare(apiOrderApplyFoundsApplyFundsRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyFoundsApplyFunds.requestConfig =
  apiOrderApplyFoundsApplyFundsRequestConfig

/**
 * 接口 [补贴金继续申请↗](https://yapi.gogpay.cn/project/906/interface/api/491622) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/continueApplyInfo`
 */
export interface ApiOrderApplyFoundsContinueApplyInfoRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [补贴金继续申请↗](https://yapi.gogpay.cn/project/906/interface/api/491622) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/continueApplyInfo`
 */
export interface ApiOrderApplyFoundsContinueApplyInfoResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [补贴金继续申请↗](https://yapi.gogpay.cn/project/906/interface/api/491622) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/continueApplyInfo`
 */
type ApiOrderApplyFoundsContinueApplyInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyFounds/continueApplyInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [补贴金继续申请↗](https://yapi.gogpay.cn/project/906/interface/api/491622) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/continueApplyInfo`
 */
const apiOrderApplyFoundsContinueApplyInfoRequestConfig: ApiOrderApplyFoundsContinueApplyInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_40,
    devUrl: devUrl_0_5_0_40,
    prodUrl: prodUrl_0_5_0_40,
    path: '/order/api/applyFounds/continueApplyInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyFoundsContinueApplyInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '补贴金继续申请', author: '511号开发' },
  }

/**
 * 接口 [补贴金继续申请↗](https://yapi.gogpay.cn/project/906/interface/api/491622) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/continueApplyInfo`
 */
export const apiOrderApplyFoundsContinueApplyInfo = /*#__PURE__*/ (
  requestData: ApiOrderApplyFoundsContinueApplyInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyFoundsContinueApplyInfoResponse>(
    prepare(apiOrderApplyFoundsContinueApplyInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyFoundsContinueApplyInfo.requestConfig =
  apiOrderApplyFoundsContinueApplyInfoRequestConfig

/**
 * 接口 [查询首页活动↗](https://yapi.gogpay.cn/project/906/interface/api/491629) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findActivityInfo`
 */
export interface ApiOrderApplyFoundsFindActivityInfoRequest {}

/**
 * 接口 [查询首页活动↗](https://yapi.gogpay.cn/project/906/interface/api/491629) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findActivityInfo`
 */
export type ApiOrderApplyFoundsFindActivityInfoResponse = {
  createBy?: string
  createTime?: string
  delFlag?: number
  description?: string
  fundsAmount?: number
  id?: string
  inventory?: number
  sumInventory?: number
  unitOrgCode?: string
  updateBy?: string
  updateTime?: string
}[]

/**
 * 接口 [查询首页活动↗](https://yapi.gogpay.cn/project/906/interface/api/491629) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findActivityInfo`
 */
type ApiOrderApplyFoundsFindActivityInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyFounds/findActivityInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询首页活动↗](https://yapi.gogpay.cn/project/906/interface/api/491629) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findActivityInfo`
 */
const apiOrderApplyFoundsFindActivityInfoRequestConfig: ApiOrderApplyFoundsFindActivityInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_40,
    devUrl: devUrl_0_5_0_40,
    prodUrl: prodUrl_0_5_0_40,
    path: '/order/api/applyFounds/findActivityInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyFoundsFindActivityInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询首页活动', author: '511号开发' },
  }

/**
 * 接口 [查询首页活动↗](https://yapi.gogpay.cn/project/906/interface/api/491629) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findActivityInfo`
 */
export const apiOrderApplyFoundsFindActivityInfo = /*#__PURE__*/ (
  requestData?: ApiOrderApplyFoundsFindActivityInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyFoundsFindActivityInfoResponse>(
    prepare(apiOrderApplyFoundsFindActivityInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyFoundsFindActivityInfo.requestConfig =
  apiOrderApplyFoundsFindActivityInfoRequestConfig

/**
 * 接口 [查询申请页相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491636) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findApplyPageInfo`
 */
export interface ApiOrderApplyFoundsFindApplyPageInfoRequest {}

/**
 * 接口 [查询申请页相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491636) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findApplyPageInfo`
 */
export interface ApiOrderApplyFoundsFindApplyPageInfoResponse {
  dcbUserDTO?: {
    auth?: boolean
    authCardNo?: string
    authId?: string
    authName?: string
    authStatus?: string
    avatar?: string
    headerParams?: {
      carrier?: string
      cityCode?: string
      clientId?: string
      deviceId?: string
      deviceName?: string
      districtCode?: string
      latitude?: string
      locateCityCode?: string
      locateDistrictCode?: string
      locateProvinceCode?: string
      longitude?: string
      netType?: string
      osVersion?: string
      phoneNum?: string
      provinceCode?: string
      releaseCode?: string
      serviceCityCode?: string
      serviceCityName?: string
      serviceCountryCode?: string
      serviceCountryName?: string
      serviceDistrictCode?: string
      serviceDistrictName?: string
      serviceProvinceCode?: string
      serviceProvinceName?: string
      userId?: string
      versionCode?: string
    }
    registerPhone?: string
    userId?: string
    userName?: string
  }
}

/**
 * 接口 [查询申请页相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491636) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findApplyPageInfo`
 */
type ApiOrderApplyFoundsFindApplyPageInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyFounds/findApplyPageInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询申请页相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491636) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findApplyPageInfo`
 */
const apiOrderApplyFoundsFindApplyPageInfoRequestConfig: ApiOrderApplyFoundsFindApplyPageInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_40,
    devUrl: devUrl_0_5_0_40,
    prodUrl: prodUrl_0_5_0_40,
    path: '/order/api/applyFounds/findApplyPageInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyFoundsFindApplyPageInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询申请页相关信息', author: '511号开发' },
  }

/**
 * 接口 [查询申请页相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491636) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findApplyPageInfo`
 */
export const apiOrderApplyFoundsFindApplyPageInfo = /*#__PURE__*/ (
  requestData?: ApiOrderApplyFoundsFindApplyPageInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyFoundsFindApplyPageInfoResponse>(
    prepare(apiOrderApplyFoundsFindApplyPageInfoRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyFoundsFindApplyPageInfo.requestConfig =
  apiOrderApplyFoundsFindApplyPageInfoRequestConfig

/**
 * 接口 [查询用户是否可申请↗](https://yapi.gogpay.cn/project/906/interface/api/491643) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserCanBeApply`
 */
export interface ApiOrderApplyFoundsFindUserCanBeApplyRequest {}

/**
 * 接口 [查询用户是否可申请↗](https://yapi.gogpay.cn/project/906/interface/api/491643) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserCanBeApply`
 */
export type ApiOrderApplyFoundsFindUserCanBeApplyResponse = boolean

/**
 * 接口 [查询用户是否可申请↗](https://yapi.gogpay.cn/project/906/interface/api/491643) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserCanBeApply`
 */
type ApiOrderApplyFoundsFindUserCanBeApplyRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyFounds/findUserCanBeApply',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户是否可申请↗](https://yapi.gogpay.cn/project/906/interface/api/491643) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserCanBeApply`
 */
const apiOrderApplyFoundsFindUserCanBeApplyRequestConfig: ApiOrderApplyFoundsFindUserCanBeApplyRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_40,
    devUrl: devUrl_0_5_0_40,
    prodUrl: prodUrl_0_5_0_40,
    path: '/order/api/applyFounds/findUserCanBeApply',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyFoundsFindUserCanBeApply',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户是否可申请', author: '511号开发' },
  }

/**
 * 接口 [查询用户是否可申请↗](https://yapi.gogpay.cn/project/906/interface/api/491643) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserCanBeApply`
 */
export const apiOrderApplyFoundsFindUserCanBeApply = /*#__PURE__*/ (
  requestData?: ApiOrderApplyFoundsFindUserCanBeApplyRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyFoundsFindUserCanBeApplyResponse>(
    prepare(apiOrderApplyFoundsFindUserCanBeApplyRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyFoundsFindUserCanBeApply.requestConfig =
  apiOrderApplyFoundsFindUserCanBeApplyRequestConfig

/**
 * 接口 [查询用户待提交申请↗](https://yapi.gogpay.cn/project/906/interface/api/491650) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserDraftApplyInfo`
 */
export interface ApiOrderApplyFoundsFindUserDraftApplyInfoRequest {}

/**
 * 接口 [查询用户待提交申请↗](https://yapi.gogpay.cn/project/906/interface/api/491650) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserDraftApplyInfo`
 */
export interface ApiOrderApplyFoundsFindUserDraftApplyInfoResponse {
  /**
   * 撤销人Id
   */
  cancelId?: string
  /**
   * 撤销人姓名
   */
  cancelName?: string
  /**
   * 撤销原因
   */
  cancelReason?: string
  /**
   * 资格冻结时间
   */
  cancelTime?: string
  /**
   * 代领人活体截图图片地址
   */
  clientRealPicUrl: string
  /**
   * 已使用优惠券张数
   */
  couponUseCount?: number
  /**
   * 资格冻结人姓名
   */
  freezeName?: string
  /**
   * 资格冻结原因
   */
  freezeReason?: string
  /**
   * 资格冻结时间
   */
  freezeTime?: string
  /**
   * 外省用户通过备注
   */
  outsideRemark?: string
  /**
   * 老年人活体截图图片地址
   */
  realPicUrl: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 总优惠金额
   */
  totalDiscountAmt?: number
  /**
   * 一码贵州资格状态0未持有 1持有 2资格已注销/回退 3正常过期 4排队等待中
   */
  yardGoStatus?: number
  /**
   * 申请记录id
   */
  id?: string
  /**
   * 申请记录id
   */
  applyInfoId?: string
  /**
   * 用户/委托人姓名
   */
  userName?: string
  /**
   * 用户/委托人姓名
   */
  userId?: string
  /**
   * 用户/委托人手机号
   */
  userPhone?: string
  /**
   * 用户/委托人身份证号
   */
  userIdCardNo?: string
  /**
   * 提交类型 1本人提交 2委托提交
   */
  applyType?: number
  /**
   * 申请人/被委托人身份证来源用户姓名
   */
  cardName?: string
  /**
   * 申请人/被委托人身份证来源身份证号
   */
  cardIdNo?: string
  /**
   * 申请人/被委托人ocr身份证来源用户姓名
   */
  ocrCardName?: string
  /**
   * 申请人/被委托人ocr身份证来源身份证号
   */
  ocrCardIdNo?: string
  /**
   * 申请人/被委托人身份证正面图片
   */
  idCardImgFront?: string
  /**
   * 申请人/被委托人身份证反面图片
   */
  idCardImgBack?: string
  /**
   * 委托人身份证来源用户姓名
   */
  clientCardName?: string
  /**
   * 委托人身份证来源身份证号
   */
  clientCardIdNo?: string
  /**
   * 委托人ocr身份证来源用户姓名
   */
  clientOcrCardName?: string
  /**
   * 委托人ocr身份证来源身份证号
   */
  clientOcrCardIdNo?: string
  /**
   * 委托人身份证正面图片
   */
  clientIdCardImgFront?: string
  /**
   * 委托人身份证反面图片
   */
  clientIdCardImgBack?: string
  /**
   * 委托代申领承诺书
   */
  clientApplyCertificate?: string
  /**
   * 补贴名称
   */
  fundsName?: string
  /**
   * 审核状态0草稿 1待审核 2审核通过 3审核驳回 4名额不足 5驳回并重新提交 6消费券已发放
   */
  checkStatus?: number
  /**
   * 审核驳回原因
   */
  checkFailReason?: string
  /**
   * 审核人
   */
  checkName?: string
  /**
   * 消费券状态0待领取 1领取成功 2冻结 3过期 4待发放
   */
  applyInfoStatus?: number
  /**
   * 消费券领取时间
   */
  foundsReceiveTime?: string
  /**
   * 消费券过期时间
   */
  foundsExpireTime?: string
  /**
   * 消费券发放时间
   */
  pushTime?: string
  /**
   * 补贴金额
   */
  fundsAmount?: number
  /**
   * 实际补贴金额
   */
  lowFundsAmount?: number
  /**
   * 补贴金额余额
   */
  fundsAmountBalance?: number
  /**
   * 审核时间
   */
  checkTime?: string
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 消费券使用记录
   */
  couponUseRecord?: string
}

/**
 * 接口 [查询用户待提交申请↗](https://yapi.gogpay.cn/project/906/interface/api/491650) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserDraftApplyInfo`
 */
type ApiOrderApplyFoundsFindUserDraftApplyInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyFounds/findUserDraftApplyInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户待提交申请↗](https://yapi.gogpay.cn/project/906/interface/api/491650) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserDraftApplyInfo`
 */
const apiOrderApplyFoundsFindUserDraftApplyInfoRequestConfig: ApiOrderApplyFoundsFindUserDraftApplyInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_40,
    devUrl: devUrl_0_5_0_40,
    prodUrl: prodUrl_0_5_0_40,
    path: '/order/api/applyFounds/findUserDraftApplyInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyFoundsFindUserDraftApplyInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户待提交申请', author: '511号开发' },
  }

/**
 * 接口 [查询用户待提交申请↗](https://yapi.gogpay.cn/project/906/interface/api/491650) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-提交申领补贴↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86356)
 * @请求头 `POST /order/api/applyFounds/findUserDraftApplyInfo`
 */
export const apiOrderApplyFoundsFindUserDraftApplyInfo = /*#__PURE__*/ (
  requestData?: ApiOrderApplyFoundsFindUserDraftApplyInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyFoundsFindUserDraftApplyInfoResponse>(
    prepare(
      apiOrderApplyFoundsFindUserDraftApplyInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderApplyFoundsFindUserDraftApplyInfo.requestConfig =
  apiOrderApplyFoundsFindUserDraftApplyInfoRequestConfig

const mockUrl_0_5_0_41 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_41 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_41 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_41 = 'data' as any

/**
 * 接口 [批量更新车牌号↗](https://yapi.gogpay.cn/project/906/interface/api/491657) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/batchUpdateCarNumber`
 */
export interface ApiOrderApplyInfoBatchUpdateCarNumberRequest {}

/**
 * 接口 [批量更新车牌号↗](https://yapi.gogpay.cn/project/906/interface/api/491657) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/batchUpdateCarNumber`
 */
export interface ApiOrderApplyInfoBatchUpdateCarNumberResponse {}

/**
 * 接口 [批量更新车牌号↗](https://yapi.gogpay.cn/project/906/interface/api/491657) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/batchUpdateCarNumber`
 */
type ApiOrderApplyInfoBatchUpdateCarNumberRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/batchUpdateCarNumber',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [批量更新车牌号↗](https://yapi.gogpay.cn/project/906/interface/api/491657) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/batchUpdateCarNumber`
 */
const apiOrderApplyInfoBatchUpdateCarNumberRequestConfig: ApiOrderApplyInfoBatchUpdateCarNumberRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/batchUpdateCarNumber',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoBatchUpdateCarNumber',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量更新车牌号', author: '511号开发' },
  }

/**
 * 接口 [批量更新车牌号↗](https://yapi.gogpay.cn/project/906/interface/api/491657) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/batchUpdateCarNumber`
 */
export const apiOrderApplyInfoBatchUpdateCarNumber = /*#__PURE__*/ (
  requestData?: ApiOrderApplyInfoBatchUpdateCarNumberRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoBatchUpdateCarNumberResponse>(
    prepare(apiOrderApplyInfoBatchUpdateCarNumberRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoBatchUpdateCarNumber.requestConfig =
  apiOrderApplyInfoBatchUpdateCarNumberRequestConfig

/**
 * 接口 [验证人脸识别情况↗](https://yapi.gogpay.cn/project/906/interface/api/491664) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/checkFaceStatus`
 */
export interface ApiOrderApplyInfoCheckFaceStatusRequest {
  /**
   * 人脸识别记录id
   */
  encryptedData: string
  /**
   * 用户密码（加密）-用户未设置过密码该字段必传
   */
  password?: string
}

/**
 * 接口 [验证人脸识别情况↗](https://yapi.gogpay.cn/project/906/interface/api/491664) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/checkFaceStatus`
 */
export interface ApiOrderApplyInfoCheckFaceStatusResponse {}

/**
 * 接口 [验证人脸识别情况↗](https://yapi.gogpay.cn/project/906/interface/api/491664) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/checkFaceStatus`
 */
type ApiOrderApplyInfoCheckFaceStatusRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/checkFaceStatus',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [验证人脸识别情况↗](https://yapi.gogpay.cn/project/906/interface/api/491664) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/checkFaceStatus`
 */
const apiOrderApplyInfoCheckFaceStatusRequestConfig: ApiOrderApplyInfoCheckFaceStatusRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/checkFaceStatus',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoCheckFaceStatus',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '验证人脸识别情况', author: '511号开发' },
  }

/**
 * 接口 [验证人脸识别情况↗](https://yapi.gogpay.cn/project/906/interface/api/491664) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/checkFaceStatus`
 */
export const apiOrderApplyInfoCheckFaceStatus = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoCheckFaceStatusRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoCheckFaceStatusResponse>(
    prepare(apiOrderApplyInfoCheckFaceStatusRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoCheckFaceStatus.requestConfig =
  apiOrderApplyInfoCheckFaceStatusRequestConfig

/**
 * 接口 [查询活动是否过期↗](https://yapi.gogpay.cn/project/906/interface/api/491671) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findActivityIsExpire`
 */
export interface ApiOrderApplyInfoFindActivityIsExpireRequest {}

/**
 * 接口 [查询活动是否过期↗](https://yapi.gogpay.cn/project/906/interface/api/491671) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findActivityIsExpire`
 */
export interface ApiOrderApplyInfoFindActivityIsExpireResponse {
  /**
   * ID
   */
  id: string
  /**
   * 名称
   */
  name: string
}

/**
 * 接口 [查询活动是否过期↗](https://yapi.gogpay.cn/project/906/interface/api/491671) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findActivityIsExpire`
 */
type ApiOrderApplyInfoFindActivityIsExpireRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/findActivityIsExpire',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询活动是否过期↗](https://yapi.gogpay.cn/project/906/interface/api/491671) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findActivityIsExpire`
 */
const apiOrderApplyInfoFindActivityIsExpireRequestConfig: ApiOrderApplyInfoFindActivityIsExpireRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/findActivityIsExpire',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoFindActivityIsExpire',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询活动是否过期', author: '511号开发' },
  }

/**
 * 接口 [查询活动是否过期↗](https://yapi.gogpay.cn/project/906/interface/api/491671) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findActivityIsExpire`
 */
export const apiOrderApplyInfoFindActivityIsExpire = /*#__PURE__*/ (
  requestData?: ApiOrderApplyInfoFindActivityIsExpireRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoFindActivityIsExpireResponse>(
    prepare(apiOrderApplyInfoFindActivityIsExpireRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoFindActivityIsExpire.requestConfig =
  apiOrderApplyInfoFindActivityIsExpireRequestConfig

/**
 * 接口 [查询申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491678) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoDetail`
 */
export interface ApiOrderApplyInfoFindApplyInfoDetailRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491678) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoDetail`
 */
export interface ApiOrderApplyInfoFindApplyInfoDetailResponse {
  /**
   * 撤销人Id
   */
  cancelId?: string
  /**
   * 撤销人姓名
   */
  cancelName?: string
  /**
   * 撤销原因
   */
  cancelReason?: string
  /**
   * 资格冻结时间
   */
  cancelTime?: string
  /**
   * 代领人活体截图图片地址
   */
  clientRealPicUrl: string
  /**
   * 已使用优惠券张数
   */
  couponUseCount?: number
  /**
   * 资格冻结人姓名
   */
  freezeName?: string
  /**
   * 资格冻结原因
   */
  freezeReason?: string
  /**
   * 资格冻结时间
   */
  freezeTime?: string
  /**
   * 外省用户通过备注
   */
  outsideRemark?: string
  /**
   * 老年人活体截图图片地址
   */
  realPicUrl: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 总优惠金额
   */
  totalDiscountAmt?: number
  /**
   * 一码贵州资格状态0未持有 1持有 2资格已注销/回退 3正常过期 4排队等待中
   */
  yardGoStatus?: number
  /**
   * 申请记录id
   */
  id?: string
  /**
   * 申请记录id
   */
  applyInfoId?: string
  /**
   * 用户/委托人姓名
   */
  userName?: string
  /**
   * 用户/委托人姓名
   */
  userId?: string
  /**
   * 用户/委托人手机号
   */
  userPhone?: string
  /**
   * 用户/委托人身份证号
   */
  userIdCardNo?: string
  /**
   * 提交类型 1本人提交 2委托提交
   */
  applyType?: number
  /**
   * 申请人/被委托人身份证来源用户姓名
   */
  cardName?: string
  /**
   * 申请人/被委托人身份证来源身份证号
   */
  cardIdNo?: string
  /**
   * 申请人/被委托人ocr身份证来源用户姓名
   */
  ocrCardName?: string
  /**
   * 申请人/被委托人ocr身份证来源身份证号
   */
  ocrCardIdNo?: string
  /**
   * 申请人/被委托人身份证正面图片
   */
  idCardImgFront?: string
  /**
   * 申请人/被委托人身份证反面图片
   */
  idCardImgBack?: string
  /**
   * 委托人身份证来源用户姓名
   */
  clientCardName?: string
  /**
   * 委托人身份证来源身份证号
   */
  clientCardIdNo?: string
  /**
   * 委托人ocr身份证来源用户姓名
   */
  clientOcrCardName?: string
  /**
   * 委托人ocr身份证来源身份证号
   */
  clientOcrCardIdNo?: string
  /**
   * 委托人身份证正面图片
   */
  clientIdCardImgFront?: string
  /**
   * 委托人身份证反面图片
   */
  clientIdCardImgBack?: string
  /**
   * 委托代申领承诺书
   */
  clientApplyCertificate?: string
  /**
   * 补贴名称
   */
  fundsName?: string
  /**
   * 审核状态0草稿 1待审核 2审核通过 3审核驳回 4名额不足 5驳回并重新提交 6消费券已发放
   */
  checkStatus?: number
  /**
   * 审核驳回原因
   */
  checkFailReason?: string
  /**
   * 审核人
   */
  checkName?: string
  /**
   * 消费券状态0待领取 1领取成功 2冻结 3过期 4待发放
   */
  applyInfoStatus?: number
  /**
   * 消费券领取时间
   */
  foundsReceiveTime?: string
  /**
   * 消费券过期时间
   */
  foundsExpireTime?: string
  /**
   * 消费券发放时间
   */
  pushTime?: string
  /**
   * 补贴金额
   */
  fundsAmount?: number
  /**
   * 实际补贴金额
   */
  lowFundsAmount?: number
  /**
   * 补贴金额余额
   */
  fundsAmountBalance?: number
  /**
   * 审核时间
   */
  checkTime?: string
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 消费券使用记录
   */
  couponUseRecord?: string
}

/**
 * 接口 [查询申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491678) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoDetail`
 */
type ApiOrderApplyInfoFindApplyInfoDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/findApplyInfoDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491678) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoDetail`
 */
const apiOrderApplyInfoFindApplyInfoDetailRequestConfig: ApiOrderApplyInfoFindApplyInfoDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/findApplyInfoDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoFindApplyInfoDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询申请记录详情', author: '511号开发' },
  }

/**
 * 接口 [查询申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491678) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoDetail`
 */
export const apiOrderApplyInfoFindApplyInfoDetail = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoFindApplyInfoDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoFindApplyInfoDetailResponse>(
    prepare(apiOrderApplyInfoFindApplyInfoDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoFindApplyInfoDetail.requestConfig =
  apiOrderApplyInfoFindApplyInfoDetailRequestConfig

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491685) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoRecordList`
 */
export interface ApiOrderApplyInfoFindApplyInfoRecordListRequest {}

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491685) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoRecordList`
 */
export interface ApiOrderApplyInfoFindApplyInfoRecordListResponse {
  /**
   * 消费券总库存
   */
  sumInventory?: number
}

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491685) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoRecordList`
 */
type ApiOrderApplyInfoFindApplyInfoRecordListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/findApplyInfoRecordList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491685) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoRecordList`
 */
const apiOrderApplyInfoFindApplyInfoRecordListRequestConfig: ApiOrderApplyInfoFindApplyInfoRecordListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/findApplyInfoRecordList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoFindApplyInfoRecordList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户消费券申请记录', author: '511号开发' },
  }

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491685) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findApplyInfoRecordList`
 */
export const apiOrderApplyInfoFindApplyInfoRecordList = /*#__PURE__*/ (
  requestData?: ApiOrderApplyInfoFindApplyInfoRecordListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoFindApplyInfoRecordListResponse>(
    prepare(apiOrderApplyInfoFindApplyInfoRecordListRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoFindApplyInfoRecordList.requestConfig =
  apiOrderApplyInfoFindApplyInfoRecordListRequestConfig

/**
 * 接口 [查询用户去使用消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491692) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findCouponList`
 */
export interface ApiOrderApplyInfoFindCouponListRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询用户去使用消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491692) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findCouponList`
 */
export interface ApiOrderApplyInfoFindCouponListResponse {
  /**
   * 券描述
   */
  couponDesc?: string
  /**
   * 券活动Id
   */
  fundsInfoId?: string
}

/**
 * 接口 [查询用户去使用消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491692) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findCouponList`
 */
type ApiOrderApplyInfoFindCouponListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/findCouponList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户去使用消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491692) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findCouponList`
 */
const apiOrderApplyInfoFindCouponListRequestConfig: ApiOrderApplyInfoFindCouponListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/findCouponList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoFindCouponList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户去使用消费券列表', author: '511号开发' },
  }

/**
 * 接口 [查询用户去使用消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491692) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findCouponList`
 */
export const apiOrderApplyInfoFindCouponList = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoFindCouponListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoFindCouponListResponse>(
    prepare(apiOrderApplyInfoFindCouponListRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoFindCouponList.requestConfig =
  apiOrderApplyInfoFindCouponListRequestConfig

/**
 * 接口 [查询用户申请的消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491699) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findUserFoundsList`
 */
export interface ApiOrderApplyInfoFindUserFoundsListRequest {}

/**
 * 接口 [查询用户申请的消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491699) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findUserFoundsList`
 */
export type ApiOrderApplyInfoFindUserFoundsListResponse = {
  /**
   * 门店名称
   */
  fundsName?: string
  /**
   * 申请记录Id
   */
  id?: string
  /**
   * 门店名称
   */
  fundAmount?: number
  /**
   * 车架号
   */
  carVin?: string
  /**
   * 申请的忧患券活动Id
   */
  fundsId?: string
  /**
   * 消费券过期时间
   */
  foundsExpireTime?: string
  /**
   * 补贴金额余额
   */
  fundsAmountBalance?: number
  /**
   * 消费券状态0待领取 1领取成功 2冻结 3过期
   */
  applyInfoStatus?: number
  /**
   * 是否可以继续申请0否 1是
   */
  continueStatus?: number
}[]

/**
 * 接口 [查询用户申请的消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491699) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findUserFoundsList`
 */
type ApiOrderApplyInfoFindUserFoundsListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/findUserFoundsList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户申请的消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491699) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findUserFoundsList`
 */
const apiOrderApplyInfoFindUserFoundsListRequestConfig: ApiOrderApplyInfoFindUserFoundsListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/findUserFoundsList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoFindUserFoundsList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户申请的消费券列表', author: '511号开发' },
  }

/**
 * 接口 [查询用户申请的消费券列表↗](https://yapi.gogpay.cn/project/906/interface/api/491699) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/findUserFoundsList`
 */
export const apiOrderApplyInfoFindUserFoundsList = /*#__PURE__*/ (
  requestData?: ApiOrderApplyInfoFindUserFoundsListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoFindUserFoundsListResponse>(
    prepare(apiOrderApplyInfoFindUserFoundsListRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoFindUserFoundsList.requestConfig =
  apiOrderApplyInfoFindUserFoundsListRequestConfig

/**
 * 接口 [查询补贴使用记录↗](https://yapi.gogpay.cn/project/906/interface/api/491706) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/integralRecord`
 */
export interface ApiOrderApplyInfoIntegralRecordRequest {
  /**
   * 申请记录id
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺编码
   */
  unitOrgCode?: string
}

/**
 * 接口 [查询补贴使用记录↗](https://yapi.gogpay.cn/project/906/interface/api/491706) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/integralRecord`
 */
export interface ApiOrderApplyInfoIntegralRecordResponse {
  /**
   * 数据列表
   */
  list?: {
    commodityDesc?: string
    commodityName?: string
    /**
     * 此单支付过后剩余金额
     */
    couponBalanceAmt?: number
    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 订单流水号
     */
    orderNo?: string
    /**
     * 原有券金额
     */
    originalAmt?: number
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺编码
     */
    unitOrgCode?: string
    /**
     * 使用券金额
     */
    useCouponAmt?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询补贴使用记录↗](https://yapi.gogpay.cn/project/906/interface/api/491706) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/integralRecord`
 */
type ApiOrderApplyInfoIntegralRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/integralRecord',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询补贴使用记录↗](https://yapi.gogpay.cn/project/906/interface/api/491706) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/integralRecord`
 */
const apiOrderApplyInfoIntegralRecordRequestConfig: ApiOrderApplyInfoIntegralRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/integralRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoIntegralRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询补贴使用记录', author: '511号开发' },
  }

/**
 * 接口 [查询补贴使用记录↗](https://yapi.gogpay.cn/project/906/interface/api/491706) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/integralRecord`
 */
export const apiOrderApplyInfoIntegralRecord = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoIntegralRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoIntegralRecordResponse>(
    prepare(apiOrderApplyInfoIntegralRecordRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoIntegralRecord.requestConfig =
  apiOrderApplyInfoIntegralRecordRequestConfig

/**
 * 接口 [活体结果检测↗](https://yapi.gogpay.cn/project/906/interface/api/491713) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/liveCheck`
 */
export interface ApiOrderApplyInfoLiveCheckRequest {
  /**
   * 认证身份证号
   */
  authCheckUserIdCard: string
  /**
   * 认证姓名
   */
  authCheckUserName: string
  /**
   * 认证凭据
   */
  authToken: string
}

/**
 * 接口 [活体结果检测↗](https://yapi.gogpay.cn/project/906/interface/api/491713) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/liveCheck`
 */
export interface ApiOrderApplyInfoLiveCheckResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [活体结果检测↗](https://yapi.gogpay.cn/project/906/interface/api/491713) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/liveCheck`
 */
type ApiOrderApplyInfoLiveCheckRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/liveCheck',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [活体结果检测↗](https://yapi.gogpay.cn/project/906/interface/api/491713) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/liveCheck`
 */
const apiOrderApplyInfoLiveCheckRequestConfig: ApiOrderApplyInfoLiveCheckRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/liveCheck',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoLiveCheck',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '活体结果检测', author: '511号开发' },
  }

/**
 * 接口 [活体结果检测↗](https://yapi.gogpay.cn/project/906/interface/api/491713) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/liveCheck`
 */
export const apiOrderApplyInfoLiveCheck = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoLiveCheckRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoLiveCheckResponse>(
    prepare(apiOrderApplyInfoLiveCheckRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoLiveCheck.requestConfig =
  apiOrderApplyInfoLiveCheckRequestConfig

/**
 * 接口 [查询用户是否设置过密码↗](https://yapi.gogpay.cn/project/906/interface/api/491720) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/queryUserPsdSetFlag`
 */
export interface ApiOrderApplyInfoQueryUserPsdSetFlagRequest {}

/**
 * 接口 [查询用户是否设置过密码↗](https://yapi.gogpay.cn/project/906/interface/api/491720) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/queryUserPsdSetFlag`
 */
export interface ApiOrderApplyInfoQueryUserPsdSetFlagResponse {}

/**
 * 接口 [查询用户是否设置过密码↗](https://yapi.gogpay.cn/project/906/interface/api/491720) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/queryUserPsdSetFlag`
 */
type ApiOrderApplyInfoQueryUserPsdSetFlagRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/queryUserPsdSetFlag',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户是否设置过密码↗](https://yapi.gogpay.cn/project/906/interface/api/491720) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/queryUserPsdSetFlag`
 */
const apiOrderApplyInfoQueryUserPsdSetFlagRequestConfig: ApiOrderApplyInfoQueryUserPsdSetFlagRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/queryUserPsdSetFlag',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoQueryUserPsdSetFlag',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户是否设置过密码', author: '511号开发' },
  }

/**
 * 接口 [查询用户是否设置过密码↗](https://yapi.gogpay.cn/project/906/interface/api/491720) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/queryUserPsdSetFlag`
 */
export const apiOrderApplyInfoQueryUserPsdSetFlag = /*#__PURE__*/ (
  requestData?: ApiOrderApplyInfoQueryUserPsdSetFlagRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoQueryUserPsdSetFlagResponse>(
    prepare(apiOrderApplyInfoQueryUserPsdSetFlagRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoQueryUserPsdSetFlag.requestConfig =
  apiOrderApplyInfoQueryUserPsdSetFlagRequestConfig

/**
 * 接口 [补贴注销↗](https://yapi.gogpay.cn/project/906/interface/api/491727) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/subsidyCancel`
 */
export interface ApiOrderApplyInfoSubsidyCancelRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [补贴注销↗](https://yapi.gogpay.cn/project/906/interface/api/491727) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/subsidyCancel`
 */
export interface ApiOrderApplyInfoSubsidyCancelResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [补贴注销↗](https://yapi.gogpay.cn/project/906/interface/api/491727) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/subsidyCancel`
 */
type ApiOrderApplyInfoSubsidyCancelRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/subsidyCancel',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [补贴注销↗](https://yapi.gogpay.cn/project/906/interface/api/491727) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/subsidyCancel`
 */
const apiOrderApplyInfoSubsidyCancelRequestConfig: ApiOrderApplyInfoSubsidyCancelRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/subsidyCancel',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoSubsidyCancel',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '补贴注销', author: '511号开发' },
  }

/**
 * 接口 [补贴注销↗](https://yapi.gogpay.cn/project/906/interface/api/491727) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/subsidyCancel`
 */
export const apiOrderApplyInfoSubsidyCancel = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoSubsidyCancelRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoSubsidyCancelResponse>(
    prepare(apiOrderApplyInfoSubsidyCancelRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoSubsidyCancel.requestConfig =
  apiOrderApplyInfoSubsidyCancelRequestConfig

/**
 * 接口 [用户激活消费券↗](https://yapi.gogpay.cn/project/906/interface/api/491734) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userReceiveCoupon`
 */
export interface ApiOrderApplyInfoUserReceiveCouponRequest {
  /**
   * 申请记录id
   */
  applyId: string
  /**
   * 是否自动领取 0否 1是
   */
  autoReceiveType: number
  /**
   * 人脸识别记录id
   */
  encryptedData: string
  /**
   * 用户密码（加密）-用户未设置过密码该字段必传
   */
  password: string
}

/**
 * 接口 [用户激活消费券↗](https://yapi.gogpay.cn/project/906/interface/api/491734) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userReceiveCoupon`
 */
export interface ApiOrderApplyInfoUserReceiveCouponResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [用户激活消费券↗](https://yapi.gogpay.cn/project/906/interface/api/491734) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userReceiveCoupon`
 */
type ApiOrderApplyInfoUserReceiveCouponRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/userReceiveCoupon',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [用户激活消费券↗](https://yapi.gogpay.cn/project/906/interface/api/491734) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userReceiveCoupon`
 */
const apiOrderApplyInfoUserReceiveCouponRequestConfig: ApiOrderApplyInfoUserReceiveCouponRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/userReceiveCoupon',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoUserReceiveCoupon',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '用户激活消费券', author: '511号开发' },
  }

/**
 * 接口 [用户激活消费券↗](https://yapi.gogpay.cn/project/906/interface/api/491734) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userReceiveCoupon`
 */
export const apiOrderApplyInfoUserReceiveCoupon = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoUserReceiveCouponRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoUserReceiveCouponResponse>(
    prepare(apiOrderApplyInfoUserReceiveCouponRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoUserReceiveCoupon.requestConfig =
  apiOrderApplyInfoUserReceiveCouponRequestConfig

/**
 * 接口 [用户初始化或修改密码↗](https://yapi.gogpay.cn/project/906/interface/api/491741) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userUpdatePsd`
 */
export interface ApiOrderApplyInfoUserUpdatePsdRequest {
  /**
   * 人脸识别记录id
   */
  encryptedData: string
  /**
   * 用户密码（加密）-用户未设置过密码该字段必传
   */
  password?: string
}

/**
 * 接口 [用户初始化或修改密码↗](https://yapi.gogpay.cn/project/906/interface/api/491741) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userUpdatePsd`
 */
export interface ApiOrderApplyInfoUserUpdatePsdResponse {}

/**
 * 接口 [用户初始化或修改密码↗](https://yapi.gogpay.cn/project/906/interface/api/491741) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userUpdatePsd`
 */
type ApiOrderApplyInfoUserUpdatePsdRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/applyInfo/userUpdatePsd',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [用户初始化或修改密码↗](https://yapi.gogpay.cn/project/906/interface/api/491741) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userUpdatePsd`
 */
const apiOrderApplyInfoUserUpdatePsdRequestConfig: ApiOrderApplyInfoUserUpdatePsdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_41,
    devUrl: devUrl_0_5_0_41,
    prodUrl: prodUrl_0_5_0_41,
    path: '/order/api/applyInfo/userUpdatePsd',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderApplyInfoUserUpdatePsd',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '用户初始化或修改密码', author: '511号开发' },
  }

/**
 * 接口 [用户初始化或修改密码↗](https://yapi.gogpay.cn/project/906/interface/api/491741) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户消费券相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86358)
 * @请求头 `POST /order/api/applyInfo/userUpdatePsd`
 */
export const apiOrderApplyInfoUserUpdatePsd = /*#__PURE__*/ (
  requestData: ApiOrderApplyInfoUserUpdatePsdRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderApplyInfoUserUpdatePsdResponse>(
    prepare(apiOrderApplyInfoUserUpdatePsdRequestConfig, requestData),
    ...args,
  )
}

apiOrderApplyInfoUserUpdatePsd.requestConfig =
  apiOrderApplyInfoUserUpdatePsdRequestConfig

const mockUrl_0_5_0_42 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_42 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_42 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_42 = 'data' as any

/**
 * 接口 [申请优惠券领取资格↗](https://yapi.gogpay.cn/project/906/interface/api/491552) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/applyFunds`
 */
export interface ApiOrderAgingApplyInfoApplyFundsRequest {
  /**
   * 老年人认证凭据
   */
  authToken?: string
  /**
   * 代理人认证凭据
   */
  clientAuthToken?: string
  /**
   * 申请记录id
   */
  id?: string
  /**
   * 申请记录id
   */
  applyInfoId?: string
  /**
   * 用户姓名
   */
  userName?: string
  /**
   * 用户姓名
   */
  userId?: string
  /**
   * 用户手机号
   */
  userPhone?: string
  /**
   * 用户身份证号
   */
  userIdCardNo?: string
  /**
   * 提交类型 1本人提交 2委托提交
   */
  applyType?: number
  /**
   * 老年人身份证来源用户姓名
   */
  cardName?: string
  /**
   * 老年人身份证来源身份证号
   */
  cardIdNo?: string
  /**
   * 老年人ocr身份证来源用户姓名
   */
  ocrCardName?: string
  /**
   * 老年人ocr身份证来源身份证号
   */
  ocrCardIdNo?: string
  /**
   * 老年人身份证正面图片
   */
  idCardImgFront?: string
  /**
   * 老年人身份证反面图片
   */
  idCardImgBack?: string
  /**
   * 代理人身份证来源用户姓名
   */
  clientCardName?: string
  /**
   * 代理人身份证来源身份证号
   */
  clientCardIdNo?: string
  /**
   * 代理人ocr身份证来源用户姓名
   */
  clientOcrCardName?: string
  /**
   * 代理人ocr身份证来源身份证号
   */
  clientOcrCardIdNo?: string
  /**
   * 代理人身份证正面图片
   */
  clientIdCardImgFront?: string
  /**
   * 代理人身份证反面图片
   */
  clientIdCardImgBack?: string
  /**
   * 委托代申领承诺书
   */
  clientApplyCertificate?: string
}

/**
 * 接口 [申请优惠券领取资格↗](https://yapi.gogpay.cn/project/906/interface/api/491552) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/applyFunds`
 */
export interface ApiOrderAgingApplyInfoApplyFundsResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [申请优惠券领取资格↗](https://yapi.gogpay.cn/project/906/interface/api/491552) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/applyFunds`
 */
type ApiOrderAgingApplyInfoApplyFundsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/applyFunds',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [申请优惠券领取资格↗](https://yapi.gogpay.cn/project/906/interface/api/491552) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/applyFunds`
 */
const apiOrderAgingApplyInfoApplyFundsRequestConfig: ApiOrderAgingApplyInfoApplyFundsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/applyFunds',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoApplyFunds',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '申请优惠券领取资格', author: '511号开发' },
  }

/**
 * 接口 [申请优惠券领取资格↗](https://yapi.gogpay.cn/project/906/interface/api/491552) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/applyFunds`
 */
export const apiOrderAgingApplyInfoApplyFunds = /*#__PURE__*/ (
  requestData: ApiOrderAgingApplyInfoApplyFundsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoApplyFundsResponse>(
    prepare(apiOrderAgingApplyInfoApplyFundsRequestConfig, requestData),
    ...args,
  )
}

apiOrderAgingApplyInfoApplyFunds.requestConfig =
  apiOrderAgingApplyInfoApplyFundsRequestConfig

/**
 * 接口 [优惠券消费记录↗](https://yapi.gogpay.cn/project/906/interface/api/491559) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/consumePoolRecord`
 */
export interface ApiOrderAgingApplyInfoConsumePoolRecordRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [优惠券消费记录↗](https://yapi.gogpay.cn/project/906/interface/api/491559) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/consumePoolRecord`
 */
export type ApiOrderAgingApplyInfoConsumePoolRecordResponse = {
  /**
   * 消费金额
   */
  amount?: number
  /**
   * 商品封面图
   */
  commodityCoverImg?: string
  /**
   * 商品名称
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 消费时间
   */
  consumeTime?: string
  /**
   * 消费记录Id
   */
  id?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 中台订单编号
   */
  orderNo?: string
  /**
   * 是否已退券 0否 1是
   */
  refundState?: boolean
  /**
   * 用户ID
   */
  userId?: string
}[]

/**
 * 接口 [优惠券消费记录↗](https://yapi.gogpay.cn/project/906/interface/api/491559) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/consumePoolRecord`
 */
type ApiOrderAgingApplyInfoConsumePoolRecordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/consumePoolRecord',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [优惠券消费记录↗](https://yapi.gogpay.cn/project/906/interface/api/491559) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/consumePoolRecord`
 */
const apiOrderAgingApplyInfoConsumePoolRecordRequestConfig: ApiOrderAgingApplyInfoConsumePoolRecordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/consumePoolRecord',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoConsumePoolRecord',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '优惠券消费记录', author: '511号开发' },
  }

/**
 * 接口 [优惠券消费记录↗](https://yapi.gogpay.cn/project/906/interface/api/491559) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/consumePoolRecord`
 */
export const apiOrderAgingApplyInfoConsumePoolRecord = /*#__PURE__*/ (
  requestData: ApiOrderAgingApplyInfoConsumePoolRecordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoConsumePoolRecordResponse>(
    prepare(apiOrderAgingApplyInfoConsumePoolRecordRequestConfig, requestData),
    ...args,
  )
}

apiOrderAgingApplyInfoConsumePoolRecord.requestConfig =
  apiOrderAgingApplyInfoConsumePoolRecordRequestConfig

/**
 * 接口 [查询首页活动相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491566) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findAgingIndexActivityInfo`
 */
export interface ApiOrderAgingApplyInfoFindAgingIndexActivityInfoRequest {}

/**
 * 接口 [查询首页活动相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491566) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findAgingIndexActivityInfo`
 */
export interface ApiOrderAgingApplyInfoFindAgingIndexActivityInfoResponse {
  activityEndTime?: string
  /**
   * 活动是否过期 0未过期 1已过期
   */
  activityIsExpire: number
  /**
   * 活动是否开始 0已开始 1未开始
   */
  activityIsStart: number
  /**
   * 活动领券状态 0暂停 1正常
   */
  activityReceiveStatus: number
  /**
   * 活动领券状态提示文案
   */
  activityReceiveStatusDesc: string
  activityStartTime?: string
  /**
   * 活动状态 0暂停 1正常
   */
  activityStopStatus: number
  /**
   * 活动状态提示文案
   */
  activityStopStatusDesc: string
  /**
   * 资格是否冻结 0未冻结 1已冻结
   */
  applyInfoFreezeStatus: number
  /**
   * 进度条数值
   */
  progressBar: number
  /**
   * 申请记录Id
   */
  id?: string
  /**
   * 申请记录状态
   */
  applyInfoStatus?: number
  /**
   * 是否可申请 0否 1是
   */
  canApplyInfoStatus?: number
  /**
   * 是否可继续领取优惠券 0否 1是
   */
  receiveCouponStatus?: number
  /**
   * 申请记录驳回原因
   */
  rejectReason?: string
  /**
   * 当前已使用券数量
   */
  useCouponCount?: number
  /**
   * 待领取消费券数量
   */
  waitReceiveCouponCount?: number
}

/**
 * 接口 [查询首页活动相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491566) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findAgingIndexActivityInfo`
 */
type ApiOrderAgingApplyInfoFindAgingIndexActivityInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/findAgingIndexActivityInfo',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询首页活动相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491566) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findAgingIndexActivityInfo`
 */
const apiOrderAgingApplyInfoFindAgingIndexActivityInfoRequestConfig: ApiOrderAgingApplyInfoFindAgingIndexActivityInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/findAgingIndexActivityInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoFindAgingIndexActivityInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询首页活动相关信息', author: '511号开发' },
  }

/**
 * 接口 [查询首页活动相关信息↗](https://yapi.gogpay.cn/project/906/interface/api/491566) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findAgingIndexActivityInfo`
 */
export const apiOrderAgingApplyInfoFindAgingIndexActivityInfo = /*#__PURE__*/ (
  requestData?: ApiOrderAgingApplyInfoFindAgingIndexActivityInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoFindAgingIndexActivityInfoResponse>(
    prepare(
      apiOrderAgingApplyInfoFindAgingIndexActivityInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderAgingApplyInfoFindAgingIndexActivityInfo.requestConfig =
  apiOrderAgingApplyInfoFindAgingIndexActivityInfoRequestConfig

/**
 * 接口 [查询用户消费券申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491573) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoDetail`
 */
export interface ApiOrderAgingApplyInfoFindApplyInfoDetailRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询用户消费券申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491573) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoDetail`
 */
export interface ApiOrderAgingApplyInfoFindApplyInfoDetailResponse {
  /**
   * 撤销人Id
   */
  cancelId?: string
  /**
   * 撤销人姓名
   */
  cancelName?: string
  /**
   * 撤销原因
   */
  cancelReason?: string
  /**
   * 资格冻结时间
   */
  cancelTime?: string
  /**
   * 代领人活体截图图片地址
   */
  clientRealPicUrl: string
  /**
   * 已使用优惠券张数
   */
  couponUseCount?: number
  /**
   * 资格冻结人姓名
   */
  freezeName?: string
  /**
   * 资格冻结原因
   */
  freezeReason?: string
  /**
   * 资格冻结时间
   */
  freezeTime?: string
  /**
   * 外省用户通过备注
   */
  outsideRemark?: string
  /**
   * 老年人活体截图图片地址
   */
  realPicUrl: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 总优惠金额
   */
  totalDiscountAmt?: number
  /**
   * 一码贵州资格状态0未持有 1持有 2资格已注销/回退 3正常过期 4排队等待中
   */
  yardGoStatus?: number
  /**
   * 申请记录id
   */
  id?: string
  /**
   * 申请记录id
   */
  applyInfoId?: string
  /**
   * 用户/委托人姓名
   */
  userName?: string
  /**
   * 用户/委托人姓名
   */
  userId?: string
  /**
   * 用户/委托人手机号
   */
  userPhone?: string
  /**
   * 用户/委托人身份证号
   */
  userIdCardNo?: string
  /**
   * 提交类型 1本人提交 2委托提交
   */
  applyType?: number
  /**
   * 申请人/被委托人身份证来源用户姓名
   */
  cardName?: string
  /**
   * 申请人/被委托人身份证来源身份证号
   */
  cardIdNo?: string
  /**
   * 申请人/被委托人ocr身份证来源用户姓名
   */
  ocrCardName?: string
  /**
   * 申请人/被委托人ocr身份证来源身份证号
   */
  ocrCardIdNo?: string
  /**
   * 申请人/被委托人身份证正面图片
   */
  idCardImgFront?: string
  /**
   * 申请人/被委托人身份证反面图片
   */
  idCardImgBack?: string
  /**
   * 委托人身份证来源用户姓名
   */
  clientCardName?: string
  /**
   * 委托人身份证来源身份证号
   */
  clientCardIdNo?: string
  /**
   * 委托人ocr身份证来源用户姓名
   */
  clientOcrCardName?: string
  /**
   * 委托人ocr身份证来源身份证号
   */
  clientOcrCardIdNo?: string
  /**
   * 委托人身份证正面图片
   */
  clientIdCardImgFront?: string
  /**
   * 委托人身份证反面图片
   */
  clientIdCardImgBack?: string
  /**
   * 委托代申领承诺书
   */
  clientApplyCertificate?: string
  /**
   * 补贴名称
   */
  fundsName?: string
  /**
   * 审核状态0草稿 1待审核 2审核通过 3审核驳回 4名额不足 5驳回并重新提交 6消费券已发放
   */
  checkStatus?: number
  /**
   * 审核驳回原因
   */
  checkFailReason?: string
  /**
   * 审核人
   */
  checkName?: string
  /**
   * 消费券状态0待领取 1领取成功 2冻结 3过期 4待发放
   */
  applyInfoStatus?: number
  /**
   * 消费券领取时间
   */
  foundsReceiveTime?: string
  /**
   * 消费券过期时间
   */
  foundsExpireTime?: string
  /**
   * 消费券发放时间
   */
  pushTime?: string
  /**
   * 补贴金额
   */
  fundsAmount?: number
  /**
   * 实际补贴金额
   */
  lowFundsAmount?: number
  /**
   * 补贴金额余额
   */
  fundsAmountBalance?: number
  /**
   * 审核时间
   */
  checkTime?: string
  /**
   * 申请时间
   */
  applyTime?: string
  /**
   * 消费券使用记录
   */
  couponUseRecord?: string
}

/**
 * 接口 [查询用户消费券申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491573) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoDetail`
 */
type ApiOrderAgingApplyInfoFindApplyInfoDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/findApplyInfoDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户消费券申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491573) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoDetail`
 */
const apiOrderAgingApplyInfoFindApplyInfoDetailRequestConfig: ApiOrderAgingApplyInfoFindApplyInfoDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/findApplyInfoDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoFindApplyInfoDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户消费券申请记录详情', author: '511号开发' },
  }

/**
 * 接口 [查询用户消费券申请记录详情↗](https://yapi.gogpay.cn/project/906/interface/api/491573) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoDetail`
 */
export const apiOrderAgingApplyInfoFindApplyInfoDetail = /*#__PURE__*/ (
  requestData: ApiOrderAgingApplyInfoFindApplyInfoDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoFindApplyInfoDetailResponse>(
    prepare(
      apiOrderAgingApplyInfoFindApplyInfoDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderAgingApplyInfoFindApplyInfoDetail.requestConfig =
  apiOrderAgingApplyInfoFindApplyInfoDetailRequestConfig

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491580) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoRecordList`
 */
export interface ApiOrderAgingApplyInfoFindApplyInfoRecordListRequest {}

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491580) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoRecordList`
 */
export interface ApiOrderAgingApplyInfoFindApplyInfoRecordListResponse {
  /**
   * 消费券总库存
   */
  sumInventory?: number
}

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491580) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoRecordList`
 */
type ApiOrderAgingApplyInfoFindApplyInfoRecordListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/findApplyInfoRecordList',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491580) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoRecordList`
 */
const apiOrderAgingApplyInfoFindApplyInfoRecordListRequestConfig: ApiOrderAgingApplyInfoFindApplyInfoRecordListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/findApplyInfoRecordList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoFindApplyInfoRecordList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户消费券申请记录', author: '511号开发' },
  }

/**
 * 接口 [查询用户消费券申请记录↗](https://yapi.gogpay.cn/project/906/interface/api/491580) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findApplyInfoRecordList`
 */
export const apiOrderAgingApplyInfoFindApplyInfoRecordList = /*#__PURE__*/ (
  requestData?: ApiOrderAgingApplyInfoFindApplyInfoRecordListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoFindApplyInfoRecordListResponse>(
    prepare(
      apiOrderAgingApplyInfoFindApplyInfoRecordListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderAgingApplyInfoFindApplyInfoRecordList.requestConfig =
  apiOrderAgingApplyInfoFindApplyInfoRecordListRequestConfig

/**
 * 接口 [查询用户优惠券领取记录↗](https://yapi.gogpay.cn/project/906/interface/api/491587) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findCouponReceiveRecordList`
 */
export interface ApiOrderAgingApplyInfoFindCouponReceiveRecordListRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询用户优惠券领取记录↗](https://yapi.gogpay.cn/project/906/interface/api/491587) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findCouponReceiveRecordList`
 */
export type ApiOrderAgingApplyInfoFindCouponReceiveRecordListResponse = {
  /**
   * 优惠类型：1=满减券，2=折扣券，3=兑换券，4=随机金额券
   */
  couponType: number
  /**
   * 抵扣金额/折扣数/兑换
   */
  denomination?: string
  /**
   * 优惠金额
   */
  discountedAmt?: number
  /**
   * 记录ID
   */
  id?: string
  /**
   * 门槛金额
   */
  minPointAmt?: string
  /**
   * 支付金额
   */
  payAmt?: number
  /**
   * 券包跳转路由地址
   */
  routeUrl?: string
  /**
   * 三级标题
   */
  ticketThirdName?: string
  /**
   * 申请Id
   */
  applyInfoId?: string
  /**
   * 优惠券活动Id
   */
  couponId?: string
  /**
   * 优惠券名称
   */
  couponName?: string
  /**
   * 优惠券Id
   */
  couponPoolId?: string
  /**
   * 优惠券券码
   */
  couponPoolCode?: string
  /**
   * 优惠券状态
   */
  couponStatus?: number
  /**
   * 有效时间
   */
  expireTime?: string
}[]

/**
 * 接口 [查询用户优惠券领取记录↗](https://yapi.gogpay.cn/project/906/interface/api/491587) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findCouponReceiveRecordList`
 */
type ApiOrderAgingApplyInfoFindCouponReceiveRecordListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/findCouponReceiveRecordList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询用户优惠券领取记录↗](https://yapi.gogpay.cn/project/906/interface/api/491587) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findCouponReceiveRecordList`
 */
const apiOrderAgingApplyInfoFindCouponReceiveRecordListRequestConfig: ApiOrderAgingApplyInfoFindCouponReceiveRecordListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/findCouponReceiveRecordList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoFindCouponReceiveRecordList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户优惠券领取记录', author: '511号开发' },
  }

/**
 * 接口 [查询用户优惠券领取记录↗](https://yapi.gogpay.cn/project/906/interface/api/491587) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/findCouponReceiveRecordList`
 */
export const apiOrderAgingApplyInfoFindCouponReceiveRecordList = /*#__PURE__*/ (
  requestData: ApiOrderAgingApplyInfoFindCouponReceiveRecordListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoFindCouponReceiveRecordListResponse>(
    prepare(
      apiOrderAgingApplyInfoFindCouponReceiveRecordListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiOrderAgingApplyInfoFindCouponReceiveRecordList.requestConfig =
  apiOrderAgingApplyInfoFindCouponReceiveRecordListRequestConfig

/**
 * 接口 [获取优惠券二维码↗](https://yapi.gogpay.cn/project/906/interface/api/491594) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getCouponCode`
 */
export interface ApiOrderAgingApplyInfoGetCouponCodeRequest {
  /**
   * 人脸识别token，重复获取可重复使用相同token。单个token的免验证时间是6小时
   */
  faceToken?: string
  id?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 定位类型 baidu、gcj、gps
   */
  locationType?: string
  /**
   * 经度
   */
  lon?: string
  /**
   * 选择的门店Id
   */
  storeId?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [获取优惠券二维码↗](https://yapi.gogpay.cn/project/906/interface/api/491594) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getCouponCode`
 */
export interface ApiOrderAgingApplyInfoGetCouponCodeResponse {
  /**
   * 二维码到期时间 yyyy-MM-dd HH:mm:ss
   */
  expireTime?: string
  /**
   * 二维码到期时间（毫秒）
   */
  expireTimeValue?: number
  /**
   * 二维码数据
   */
  qrCode?: string
}

/**
 * 接口 [获取优惠券二维码↗](https://yapi.gogpay.cn/project/906/interface/api/491594) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getCouponCode`
 */
type ApiOrderAgingApplyInfoGetCouponCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/getCouponCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取优惠券二维码↗](https://yapi.gogpay.cn/project/906/interface/api/491594) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getCouponCode`
 */
const apiOrderAgingApplyInfoGetCouponCodeRequestConfig: ApiOrderAgingApplyInfoGetCouponCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/getCouponCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoGetCouponCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取优惠券二维码', author: '511号开发' },
  }

/**
 * 接口 [获取优惠券二维码↗](https://yapi.gogpay.cn/project/906/interface/api/491594) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getCouponCode`
 */
export const apiOrderAgingApplyInfoGetCouponCode = /*#__PURE__*/ (
  requestData: ApiOrderAgingApplyInfoGetCouponCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoGetCouponCodeResponse>(
    prepare(apiOrderAgingApplyInfoGetCouponCodeRequestConfig, requestData),
    ...args,
  )
}

apiOrderAgingApplyInfoGetCouponCode.requestConfig =
  apiOrderAgingApplyInfoGetCouponCodeRequestConfig

/**
 * 接口 [查询用户须知↗](https://yapi.gogpay.cn/project/906/interface/api/491601) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getUserNotice`
 */
export interface ApiOrderAgingApplyInfoGetUserNoticeRequest {}

/**
 * 接口 [查询用户须知↗](https://yapi.gogpay.cn/project/906/interface/api/491601) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getUserNotice`
 */
export interface ApiOrderAgingApplyInfoGetUserNoticeResponse {
  /**
   * ID
   */
  id: string
  /**
   * 用户须知
   */
  noticeContent: string
  /**
   * 标题
   */
  noticeTitle: string
}

/**
 * 接口 [查询用户须知↗](https://yapi.gogpay.cn/project/906/interface/api/491601) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getUserNotice`
 */
type ApiOrderAgingApplyInfoGetUserNoticeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/getUserNotice',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [查询用户须知↗](https://yapi.gogpay.cn/project/906/interface/api/491601) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getUserNotice`
 */
const apiOrderAgingApplyInfoGetUserNoticeRequestConfig: ApiOrderAgingApplyInfoGetUserNoticeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/getUserNotice',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoGetUserNotice',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询用户须知', author: '511号开发' },
  }

/**
 * 接口 [查询用户须知↗](https://yapi.gogpay.cn/project/906/interface/api/491601) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/getUserNotice`
 */
export const apiOrderAgingApplyInfoGetUserNotice = /*#__PURE__*/ (
  requestData?: ApiOrderAgingApplyInfoGetUserNoticeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoGetUserNoticeResponse>(
    prepare(apiOrderAgingApplyInfoGetUserNoticeRequestConfig, requestData),
    ...args,
  )
}

apiOrderAgingApplyInfoGetUserNotice.requestConfig =
  apiOrderAgingApplyInfoGetUserNoticeRequestConfig

/**
 * 接口 [领取优惠券↗](https://yapi.gogpay.cn/project/906/interface/api/491608) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/receiveCoupon`
 */
export interface ApiOrderAgingApplyInfoReceiveCouponRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [领取优惠券↗](https://yapi.gogpay.cn/project/906/interface/api/491608) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/receiveCoupon`
 */
export interface ApiOrderAgingApplyInfoReceiveCouponResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [领取优惠券↗](https://yapi.gogpay.cn/project/906/interface/api/491608) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/receiveCoupon`
 */
type ApiOrderAgingApplyInfoReceiveCouponRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/agingApplyInfo/receiveCoupon',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [领取优惠券↗](https://yapi.gogpay.cn/project/906/interface/api/491608) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/receiveCoupon`
 */
const apiOrderAgingApplyInfoReceiveCouponRequestConfig: ApiOrderAgingApplyInfoReceiveCouponRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_42,
    devUrl: devUrl_0_5_0_42,
    prodUrl: prodUrl_0_5_0_42,
    path: '/order/api/agingApplyInfo/receiveCoupon',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_42,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderAgingApplyInfoReceiveCoupon',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '领取优惠券', author: '511号开发' },
  }

/**
 * 接口 [领取优惠券↗](https://yapi.gogpay.cn/project/906/interface/api/491608) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-用户申请优惠券领取资格相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86360)
 * @请求头 `POST /order/api/agingApplyInfo/receiveCoupon`
 */
export const apiOrderAgingApplyInfoReceiveCoupon = /*#__PURE__*/ (
  requestData: ApiOrderAgingApplyInfoReceiveCouponRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderAgingApplyInfoReceiveCouponResponse>(
    prepare(apiOrderAgingApplyInfoReceiveCouponRequestConfig, requestData),
    ...args,
  )
}

apiOrderAgingApplyInfoReceiveCoupon.requestConfig =
  apiOrderAgingApplyInfoReceiveCouponRequestConfig

const mockUrl_0_5_0_43 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_43 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_43 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_43 = 'data' as any

/**
 * 接口 [查询购车门店详情↗](https://yapi.gogpay.cn/project/906/interface/api/491776) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/findCarShopDetail`
 */
export interface ApiOrderCarShopFindCarShopDetailRequest {
  id?: string
  userInfo?: {
    avatar?: string
    delFlag?: string
    deptId?: number
    email?: string
    loginDate?: string
    loginIp?: string
    nickName?: string
    password?: string
    phonenumber?: string
    sex?: string
    status?: string
    userId?: number
    userName?: string
  }
}

/**
 * 接口 [查询购车门店详情↗](https://yapi.gogpay.cn/project/906/interface/api/491776) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/findCarShopDetail`
 */
export interface ApiOrderCarShopFindCarShopDetailResponse {
  businessEndTime?: string
  businessLicensePicture?: string
  businessStartTime?: string
  creditCode?: string
  frontPhotoOfLegalPerson?: string
  id?: string
  informationPicture?: string
  introduction?: string
  latitude?: string
  legalRepresentative?: string
  legalRepresentativeMobileNumber?: string
  legalRepresentativeName?: string
  longitude?: string
  newCarType?: number
  photoOfTheReverseSideOfTheCorporate?: string
  shopAddress?: string
  shopName?: string
  shopZoningId?: string
  supportHotLine?: string
}

/**
 * 接口 [查询购车门店详情↗](https://yapi.gogpay.cn/project/906/interface/api/491776) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/findCarShopDetail`
 */
type ApiOrderCarShopFindCarShopDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/carShop/findCarShopDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询购车门店详情↗](https://yapi.gogpay.cn/project/906/interface/api/491776) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/findCarShopDetail`
 */
const apiOrderCarShopFindCarShopDetailRequestConfig: ApiOrderCarShopFindCarShopDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_43,
    devUrl: devUrl_0_5_0_43,
    prodUrl: prodUrl_0_5_0_43,
    path: '/order/api/carShop/findCarShopDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_43,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderCarShopFindCarShopDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询购车门店详情', author: '511号开发' },
  }

/**
 * 接口 [查询购车门店详情↗](https://yapi.gogpay.cn/project/906/interface/api/491776) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/findCarShopDetail`
 */
export const apiOrderCarShopFindCarShopDetail = /*#__PURE__*/ (
  requestData: ApiOrderCarShopFindCarShopDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderCarShopFindCarShopDetailResponse>(
    prepare(apiOrderCarShopFindCarShopDetailRequestConfig, requestData),
    ...args,
  )
}

apiOrderCarShopFindCarShopDetail.requestConfig =
  apiOrderCarShopFindCarShopDetailRequestConfig

/**
 * 接口 [查询购车门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491783) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/getCarShopList`
 */
export interface ApiOrderCarShopGetCarShopListRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [查询购车门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491783) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/getCarShopList`
 */
export interface ApiOrderCarShopGetCarShopListResponse {
  /**
   * 数据列表
   */
  list?: {
    businessEndTime?: string
    businessLicensePicture?: string
    businessStartTime?: string
    creditCode?: string
    frontPhotoOfLegalPerson?: string
    id?: string
    informationPicture?: string
    introduction?: string
    latitude?: string
    legalRepresentative?: string
    legalRepresentativeMobileNumber?: string
    legalRepresentativeName?: string
    longitude?: string
    newCarType?: number
    photoOfTheReverseSideOfTheCorporate?: string
    shopAddress?: string
    shopName?: string
    shopZoningId?: string
    supportHotLine?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询购车门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491783) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/getCarShopList`
 */
type ApiOrderCarShopGetCarShopListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/carShop/getCarShopList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询购车门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491783) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/getCarShopList`
 */
const apiOrderCarShopGetCarShopListRequestConfig: ApiOrderCarShopGetCarShopListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_43,
    devUrl: devUrl_0_5_0_43,
    prodUrl: prodUrl_0_5_0_43,
    path: '/order/api/carShop/getCarShopList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_43,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderCarShopGetCarShopList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询购车门店列表', author: '511号开发' },
  }

/**
 * 接口 [查询购车门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/491783) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-门店列表↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86362)
 * @请求头 `POST /order/api/carShop/getCarShopList`
 */
export const apiOrderCarShopGetCarShopList = /*#__PURE__*/ (
  requestData: ApiOrderCarShopGetCarShopListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderCarShopGetCarShopListResponse>(
    prepare(apiOrderCarShopGetCarShopListRequestConfig, requestData),
    ...args,
  )
}

apiOrderCarShopGetCarShopList.requestConfig =
  apiOrderCarShopGetCarShopListRequestConfig

const mockUrl_0_5_0_44 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_44 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_44 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_44 = 'data' as any

/**
 * 接口 [获取面板商品排行↗](https://yapi.gogpay.cn/project/906/interface/api/491790) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getCommodityRank`
 */
export interface ApiOrderDataPanelGetCommodityRankRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 0日榜 1月榜 2总榜
   */
  rankType: number
}

/**
 * 接口 [获取面板商品排行↗](https://yapi.gogpay.cn/project/906/interface/api/491790) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getCommodityRank`
 */
export interface ApiOrderDataPanelGetCommodityRankResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 订单总价
     */
    allOrderAmount: number
    /**
     * 商品Id
     */
    commodityId: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic: string
    /**
     * 商品类型 0-商城商品 1-线下商品
     */
    commodityType: number
    /**
     * 单价
     */
    price: number
    /**
     * 销量
     */
    saleCount: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取面板商品排行↗](https://yapi.gogpay.cn/project/906/interface/api/491790) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getCommodityRank`
 */
type ApiOrderDataPanelGetCommodityRankRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/dataPanel/getCommodityRank',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取面板商品排行↗](https://yapi.gogpay.cn/project/906/interface/api/491790) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getCommodityRank`
 */
const apiOrderDataPanelGetCommodityRankRequestConfig: ApiOrderDataPanelGetCommodityRankRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_44,
    devUrl: devUrl_0_5_0_44,
    prodUrl: prodUrl_0_5_0_44,
    path: '/order/api/dataPanel/getCommodityRank',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_44,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderDataPanelGetCommodityRank',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取面板商品排行', author: '511号开发' },
  }

/**
 * 接口 [获取面板商品排行↗](https://yapi.gogpay.cn/project/906/interface/api/491790) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getCommodityRank`
 */
export const apiOrderDataPanelGetCommodityRank = /*#__PURE__*/ (
  requestData: ApiOrderDataPanelGetCommodityRankRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderDataPanelGetCommodityRankResponse>(
    prepare(apiOrderDataPanelGetCommodityRankRequestConfig, requestData),
    ...args,
  )
}

apiOrderDataPanelGetCommodityRank.requestConfig =
  apiOrderDataPanelGetCommodityRankRequestConfig

/**
 * 接口 [获取面板主页数据↗](https://yapi.gogpay.cn/project/906/interface/api/491797) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelData`
 */
export interface ApiOrderDataPanelGetPanelDataRequest {}

/**
 * 接口 [获取面板主页数据↗](https://yapi.gogpay.cn/project/906/interface/api/491797) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelData`
 */
export interface ApiOrderDataPanelGetPanelDataResponse {
  /**
   * 总申领人数
   */
  allApplyCount: number
  /**
   * 总订单金额
   */
  allOrderAmt: number
  /**
   * 总领券数
   */
  allReceiveCount: number
  /**
   * 总补贴使用金额
   */
  allUseAmount: number
  /**
   * 总使用数量
   */
  allUseCouponCount: number
  /**
   * 代申领人数
   */
  clintApplyCount: number
  /**
   * 产品数量
   */
  commodityCount: number
  /**
   * 上次更新时间
   */
  lastSyncTime?: string
  /**
   * 本人申领人数
   */
  oneselfApplyCount: number
  /**
   * 商户数量
   */
  storeCount: number
  /**
   * 总补贴金额
   */
  sumCouponAmount: number
  /**
   * 今日订单金额
   */
  toDayOrderAmount: number
  /**
   * 今日领取数量
   */
  toDayReceiveCount: number
  /**
   * 今日补贴使用金额
   */
  toDayUseAmount: number
  /**
   * 今日使用数量
   */
  toDayUseCouponCount: number
  /**
   * 今日申领人数
   */
  todayApplyCount: number
  /**
   * 今日代申领人数
   */
  todayClintApplyCount: number
  /**
   * 今日新增产品数量
   */
  todayCommodityCount: number
  /**
   * 今日本人申领人数
   */
  todayOneselfApplyCount: number
  /**
   * 今日新增商户数量
   */
  todayStoreCount: number
  /**
   * 近7日领取趋势数据
   */
  weekReceiveData: {
    /**
     * 统计数量
     */
    statisticsCount?: number
    /**
     * 统计日期
     */
    statisticsDate?: string
  }[]
  /**
   * 近7日核销趋势数据
   */
  weekWriteOffData: {
    /**
     * 统计数量
     */
    statisticsCount?: number
    /**
     * 统计日期
     */
    statisticsDate?: string
  }[]
}

/**
 * 接口 [获取面板主页数据↗](https://yapi.gogpay.cn/project/906/interface/api/491797) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelData`
 */
type ApiOrderDataPanelGetPanelDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/dataPanel/getPanelData',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取面板主页数据↗](https://yapi.gogpay.cn/project/906/interface/api/491797) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelData`
 */
const apiOrderDataPanelGetPanelDataRequestConfig: ApiOrderDataPanelGetPanelDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_44,
    devUrl: devUrl_0_5_0_44,
    prodUrl: prodUrl_0_5_0_44,
    path: '/order/api/dataPanel/getPanelData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_44,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderDataPanelGetPanelData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取面板主页数据', author: '511号开发' },
  }

/**
 * 接口 [获取面板主页数据↗](https://yapi.gogpay.cn/project/906/interface/api/491797) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelData`
 */
export const apiOrderDataPanelGetPanelData = /*#__PURE__*/ (
  requestData?: ApiOrderDataPanelGetPanelDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderDataPanelGetPanelDataResponse>(
    prepare(apiOrderDataPanelGetPanelDataRequestConfig, requestData),
    ...args,
  )
}

apiOrderDataPanelGetPanelData.requestConfig =
  apiOrderDataPanelGetPanelDataRequestConfig

/**
 * 接口 [获取面板预警数据↗](https://yapi.gogpay.cn/project/906/interface/api/491804) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelWaringData`
 */
export interface ApiOrderDataPanelGetPanelWaringDataRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [获取面板预警数据↗](https://yapi.gogpay.cn/project/906/interface/api/491804) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelWaringData`
 */
export interface ApiOrderDataPanelGetPanelWaringDataResponse {
  /**
   * 今日预警数
   */
  toDayWarningCount: number
  /**
   * 总预警数
   */
  warningCount?: number
  warningInfoList: {
    /**
     * 数据列表
     */
    list?: {
      /**
       * 预警时间
       */
      waringTime?: string
      /**
       * 预警描述
       */
      warningDesc?: string
    }[]
    /**
     * 记录总数
     */
    total: number
    /**
     * 总页数
     */
    totalPage: number
  }
}

/**
 * 接口 [获取面板预警数据↗](https://yapi.gogpay.cn/project/906/interface/api/491804) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelWaringData`
 */
type ApiOrderDataPanelGetPanelWaringDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/dataPanel/getPanelWaringData',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取面板预警数据↗](https://yapi.gogpay.cn/project/906/interface/api/491804) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelWaringData`
 */
const apiOrderDataPanelGetPanelWaringDataRequestConfig: ApiOrderDataPanelGetPanelWaringDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_44,
    devUrl: devUrl_0_5_0_44,
    prodUrl: prodUrl_0_5_0_44,
    path: '/order/api/dataPanel/getPanelWaringData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_44,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderDataPanelGetPanelWaringData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取面板预警数据', author: '511号开发' },
  }

/**
 * 接口 [获取面板预警数据↗](https://yapi.gogpay.cn/project/906/interface/api/491804) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getPanelWaringData`
 */
export const apiOrderDataPanelGetPanelWaringData = /*#__PURE__*/ (
  requestData: ApiOrderDataPanelGetPanelWaringDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderDataPanelGetPanelWaringDataResponse>(
    prepare(apiOrderDataPanelGetPanelWaringDataRequestConfig, requestData),
    ...args,
  )
}

apiOrderDataPanelGetPanelWaringData.requestConfig =
  apiOrderDataPanelGetPanelWaringDataRequestConfig

/**
 * 接口 [获取面板店铺排行↗](https://yapi.gogpay.cn/project/906/interface/api/491811) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getStoreRank`
 */
export interface ApiOrderDataPanelGetStoreRankRequest {
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 0日榜 1月榜 2总榜
   */
  rankType: number
}

/**
 * 接口 [获取面板店铺排行↗](https://yapi.gogpay.cn/project/906/interface/api/491811) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getStoreRank`
 */
export interface ApiOrderDataPanelGetStoreRankResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 销售额
     */
    allOrderAmount: number
    /**
     * 订单数量
     */
    orderCount: number
    /**
     * 商品名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [获取面板店铺排行↗](https://yapi.gogpay.cn/project/906/interface/api/491811) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getStoreRank`
 */
type ApiOrderDataPanelGetStoreRankRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/dataPanel/getStoreRank',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取面板店铺排行↗](https://yapi.gogpay.cn/project/906/interface/api/491811) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getStoreRank`
 */
const apiOrderDataPanelGetStoreRankRequestConfig: ApiOrderDataPanelGetStoreRankRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_44,
    devUrl: devUrl_0_5_0_44,
    prodUrl: prodUrl_0_5_0_44,
    path: '/order/api/dataPanel/getStoreRank',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_44,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderDataPanelGetStoreRank',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取面板店铺排行', author: '511号开发' },
  }

/**
 * 接口 [获取面板店铺排行↗](https://yapi.gogpay.cn/project/906/interface/api/491811) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [数据面板数据获取相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86364)
 * @请求头 `POST /order/api/dataPanel/getStoreRank`
 */
export const apiOrderDataPanelGetStoreRank = /*#__PURE__*/ (
  requestData: ApiOrderDataPanelGetStoreRankRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderDataPanelGetStoreRankResponse>(
    prepare(apiOrderDataPanelGetStoreRankRequestConfig, requestData),
    ...args,
  )
}

apiOrderDataPanelGetStoreRank.requestConfig =
  apiOrderDataPanelGetStoreRankRequestConfig

const mockUrl_0_5_0_45 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_45 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_45 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_45 = 'data' as any

/**
 * 接口 [数据面板获取登录验证码↗](https://yapi.gogpay.cn/project/906/interface/api/491818) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/getSmsCode`
 */
export interface ApiOrderDataPanelLoginGetSmsCodeRequest {
  /**
   * 登录手机号
   */
  loginPhone?: string
  /**
   * 短信验证码
   */
  smsCode?: string
}

/**
 * 接口 [数据面板获取登录验证码↗](https://yapi.gogpay.cn/project/906/interface/api/491818) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/getSmsCode`
 */
export interface ApiOrderDataPanelLoginGetSmsCodeResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [数据面板获取登录验证码↗](https://yapi.gogpay.cn/project/906/interface/api/491818) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/getSmsCode`
 */
type ApiOrderDataPanelLoginGetSmsCodeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/dataPanelLogin/getSmsCode',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [数据面板获取登录验证码↗](https://yapi.gogpay.cn/project/906/interface/api/491818) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/getSmsCode`
 */
const apiOrderDataPanelLoginGetSmsCodeRequestConfig: ApiOrderDataPanelLoginGetSmsCodeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_45,
    devUrl: devUrl_0_5_0_45,
    prodUrl: prodUrl_0_5_0_45,
    path: '/order/api/dataPanelLogin/getSmsCode',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderDataPanelLoginGetSmsCode',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '数据面板获取登录验证码', author: '511号开发' },
  }

/**
 * 接口 [数据面板获取登录验证码↗](https://yapi.gogpay.cn/project/906/interface/api/491818) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/getSmsCode`
 */
export const apiOrderDataPanelLoginGetSmsCode = /*#__PURE__*/ (
  requestData: ApiOrderDataPanelLoginGetSmsCodeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderDataPanelLoginGetSmsCodeResponse>(
    prepare(apiOrderDataPanelLoginGetSmsCodeRequestConfig, requestData),
    ...args,
  )
}

apiOrderDataPanelLoginGetSmsCode.requestConfig =
  apiOrderDataPanelLoginGetSmsCodeRequestConfig

/**
 * 接口 [数据面板登录↗](https://yapi.gogpay.cn/project/906/interface/api/491825) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/smsLogin`
 */
export interface ApiOrderDataPanelLoginSmsLoginRequest {
  /**
   * 登录手机号
   */
  loginPhone?: string
  /**
   * 短信验证码
   */
  smsCode?: string
}

/**
 * 接口 [数据面板登录↗](https://yapi.gogpay.cn/project/906/interface/api/491825) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/smsLogin`
 */
export type ApiOrderDataPanelLoginSmsLoginResponse = string

/**
 * 接口 [数据面板登录↗](https://yapi.gogpay.cn/project/906/interface/api/491825) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/smsLogin`
 */
type ApiOrderDataPanelLoginSmsLoginRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/dataPanelLogin/smsLogin',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [数据面板登录↗](https://yapi.gogpay.cn/project/906/interface/api/491825) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/smsLogin`
 */
const apiOrderDataPanelLoginSmsLoginRequestConfig: ApiOrderDataPanelLoginSmsLoginRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_45,
    devUrl: devUrl_0_5_0_45,
    prodUrl: prodUrl_0_5_0_45,
    path: '/order/api/dataPanelLogin/smsLogin',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderDataPanelLoginSmsLogin',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '数据面板登录', author: '511号开发' },
  }

/**
 * 接口 [数据面板登录↗](https://yapi.gogpay.cn/project/906/interface/api/491825) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [数据面板登录相关↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86366)
 * @请求头 `POST /order/api/dataPanelLogin/smsLogin`
 */
export const apiOrderDataPanelLoginSmsLogin = /*#__PURE__*/ (
  requestData: ApiOrderDataPanelLoginSmsLoginRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderDataPanelLoginSmsLoginResponse>(
    prepare(apiOrderDataPanelLoginSmsLoginRequestConfig, requestData),
    ...args,
  )
}

apiOrderDataPanelLoginSmsLogin.requestConfig =
  apiOrderDataPanelLoginSmsLoginRequestConfig

const mockUrl_0_5_0_57 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_57 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_57 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_57 = 'data' as any

/**
 * 接口 [查询资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491881) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getResources`
 */
export interface ApiOrderStateGetResourcesRequest {
  /**
   * 【区划code】
   */
  areaCode?: string
  /**
   * 客户端标识
   */
  clientId?: string
  /**
   * 【客户端版本】
   */
  clientVersion?: string
  /**
   * 暂定资源id
   */
  keyword?: string
  /**
   * 当前页码(从1开始)
   */
  pageNum?: number
  /**
   * 每页数量
   */
  pageSize?: number
  /**
   * 资源位id
   */
  stateId: string
  /**
   * 【用户id】
   */
  userId?: string
}

/**
 * 接口 [查询资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491881) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getResources`
 */
export interface ApiOrderStateGetResourcesResponse {}

/**
 * 接口 [查询资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491881) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getResources`
 */
type ApiOrderStateGetResourcesRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/state/getResources',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491881) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getResources`
 */
const apiOrderStateGetResourcesRequestConfig: ApiOrderStateGetResourcesRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_57,
    devUrl: devUrl_0_5_0_57,
    prodUrl: prodUrl_0_5_0_57,
    path: '/order/api/state/getResources',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_57,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderStateGetResources',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询资源位的相关资源数据', author: '511号开发' },
  }

/**
 * 接口 [查询资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491881) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getResources`
 */
export const apiOrderStateGetResources = /*#__PURE__*/ (
  requestData: ApiOrderStateGetResourcesRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderStateGetResourcesResponse>(
    prepare(apiOrderStateGetResourcesRequestConfig, requestData),
    ...args,
  )
}

apiOrderStateGetResources.requestConfig = apiOrderStateGetResourcesRequestConfig

/**
 * 接口 [查询资源位分组下的所有分类↗](https://yapi.gogpay.cn/project/906/interface/api/491888) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupList`
 */
export interface ApiOrderStateGetStateGroupListRequest {
  /**
   * 资源位分类的深度
   */
  level?: number
  /**
   * 资源位分组id
   */
  stateGroupId?: string
  /**
   * 分类 0 分组 ， 1 资源位
   */
  type?: number
}

/**
 * 接口 [查询资源位分组下的所有分类↗](https://yapi.gogpay.cn/project/906/interface/api/491888) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupList`
 */
export interface ApiOrderStateGetStateGroupListResponse {}

/**
 * 接口 [查询资源位分组下的所有分类↗](https://yapi.gogpay.cn/project/906/interface/api/491888) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupList`
 */
type ApiOrderStateGetStateGroupListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/state/getStateGroupList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询资源位分组下的所有分类↗](https://yapi.gogpay.cn/project/906/interface/api/491888) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupList`
 */
const apiOrderStateGetStateGroupListRequestConfig: ApiOrderStateGetStateGroupListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_57,
    devUrl: devUrl_0_5_0_57,
    prodUrl: prodUrl_0_5_0_57,
    path: '/order/api/state/getStateGroupList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_57,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderStateGetStateGroupList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询资源位分组下的所有分类', author: '511号开发' },
  }

/**
 * 接口 [查询资源位分组下的所有分类↗](https://yapi.gogpay.cn/project/906/interface/api/491888) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupList`
 */
export const apiOrderStateGetStateGroupList = /*#__PURE__*/ (
  requestData: ApiOrderStateGetStateGroupListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderStateGetStateGroupListResponse>(
    prepare(apiOrderStateGetStateGroupListRequestConfig, requestData),
    ...args,
  )
}

apiOrderStateGetStateGroupList.requestConfig =
  apiOrderStateGetStateGroupListRequestConfig

/**
 * 接口 [查询资源位分组中资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491895) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupResource`
 */
export interface ApiOrderStateGetStateGroupResourceRequest {
  /**
   * 店铺区划ID
   */
  belongZoneIds?: string[]
  /**
   * 资源中的节点id
   */
  categoryId?: string
  /**
   * 用户所在纬度
   */
  latitude?: number
  /**
   * 用户所在经度
   */
  longitude?: number
  /**
   * 当前页码
   */
  pageIndex: number
  /**
   * 分页大小
   */
  pageSize: number
  /**
   * 排序类型1：升序 2 降序
   */
  sequenceType?: number
  /**
   * 排序: 000001[推荐], 000002[距离],000003[人均],000004[评价]，000005[销量],000006[商品价格]
   */
  sortType?: string
  /**
   * 资源位分组id
   */
  stateGroupId: string
  /**
   * 资源位分组中的资源位id数组
   */
  stateIds: string[]
}

/**
 * 接口 [查询资源位分组中资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491895) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupResource`
 */
export interface ApiOrderStateGetStateGroupResourceResponse {}

/**
 * 接口 [查询资源位分组中资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491895) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupResource`
 */
type ApiOrderStateGetStateGroupResourceRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/state/getStateGroupResource',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询资源位分组中资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491895) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupResource`
 */
const apiOrderStateGetStateGroupResourceRequestConfig: ApiOrderStateGetStateGroupResourceRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_57,
    devUrl: devUrl_0_5_0_57,
    prodUrl: prodUrl_0_5_0_57,
    path: '/order/api/state/getStateGroupResource',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_57,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderStateGetStateGroupResource',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '查询资源位分组中资源位的相关资源数据',
      author: '511号开发',
    },
  }

/**
 * 接口 [查询资源位分组中资源位的相关资源数据↗](https://yapi.gogpay.cn/project/906/interface/api/491895) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/getStateGroupResource`
 */
export const apiOrderStateGetStateGroupResource = /*#__PURE__*/ (
  requestData: ApiOrderStateGetStateGroupResourceRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderStateGetStateGroupResourceResponse>(
    prepare(apiOrderStateGetStateGroupResourceRequestConfig, requestData),
    ...args,
  )
}

apiOrderStateGetStateGroupResource.requestConfig =
  apiOrderStateGetStateGroupResourceRequestConfig

/**
 * 接口 [手动同步数据↗](https://yapi.gogpay.cn/project/906/interface/api/491902) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/updateSourceData`
 */
export type ApiOrderStateUpdateSourceDataRequest = string

/**
 * 接口 [手动同步数据↗](https://yapi.gogpay.cn/project/906/interface/api/491902) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/updateSourceData`
 */
export interface ApiOrderStateUpdateSourceDataResponse {}

/**
 * 接口 [手动同步数据↗](https://yapi.gogpay.cn/project/906/interface/api/491902) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/updateSourceData`
 */
type ApiOrderStateUpdateSourceDataRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/api/state/updateSourceData',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [手动同步数据↗](https://yapi.gogpay.cn/project/906/interface/api/491902) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/updateSourceData`
 */
const apiOrderStateUpdateSourceDataRequestConfig: ApiOrderStateUpdateSourceDataRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_57,
    devUrl: devUrl_0_5_0_57,
    prodUrl: prodUrl_0_5_0_57,
    path: '/order/api/state/updateSourceData',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_57,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderStateUpdateSourceData',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '手动同步数据', author: '511号开发' },
  }

/**
 * 接口 [手动同步数据↗](https://yapi.gogpay.cn/project/906/interface/api/491902) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [资源位接口↗](https://yapi.gogpay.cn/project/906/interface/api/cat_86390)
 * @请求头 `POST /order/api/state/updateSourceData`
 */
export const apiOrderStateUpdateSourceData = /*#__PURE__*/ (
  requestData: ApiOrderStateUpdateSourceDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderStateUpdateSourceDataResponse>(
    prepare(apiOrderStateUpdateSourceDataRequestConfig, requestData),
    ...args,
  )
}

apiOrderStateUpdateSourceData.requestConfig =
  apiOrderStateUpdateSourceDataRequestConfig

const mockUrl_0_5_0_58 = 'https://yapi.gogpay.cn/mock/906' as any
const devUrl_0_5_0_58 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_5_0_58 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_5_0_58 = 'data' as any

/**
 * 接口 [获取订单快照↗](https://yapi.gogpay.cn/project/906/interface/api/37573) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [order-snap-shot-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_9812)
 * @请求头 `POST /order/imsApi/orderSnapshot/getSnapShot`
 */
export interface ApiOrderImsApiOrderSnapshotGetSnapShotRequest {
  /**
   * 订单编号
   */
  orderNo: string
  /**
   * 订单状态
   */
  orderStatus:
    | 1
    | 0
    | 100
    | 101
    | 102
    | 200
    | 201
    | 202
    | 203
    | 204
    | 300
    | 400
    | 401
    | 402
    | 900
    | 901
    | 902
    | 903
}

/**
 * 接口 [获取订单快照↗](https://yapi.gogpay.cn/project/906/interface/api/37573) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [order-snap-shot-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_9812)
 * @请求头 `POST /order/imsApi/orderSnapshot/getSnapShot`
 */
export interface ApiOrderImsApiOrderSnapshotGetSnapShotResponse {
  /**
   * 优惠金额
   */
  discountAmount?: number
  /**
   * 手续费比例
   */
  feeRate?: number
  /**
   * 商户Id
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户图片
   */
  merchantPic?: string
  /**
   * 商户联系方式
   */
  merchantTel?: string
  /**
   * 当前订单状态
   */
  nowOrderStatus?: number
  /**
   * 订单活动类型 0无 1秒杀 2盲盒 3积分 4折扣 5拼团
   */
  orderActivityType?: number
  /**
   * 订单活动类型名称
   */
  orderActivityTypeName?: string
  orderClassification?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'
  orderConfig?: {
    applyCustomerServiceHiddenFlag?: number
    autoCloseOrderCountdown?: number
    autoConfirmOrderCountdown?: number
    autoEvaluateCountdown?: number
    autoNoReasonSaleAfterCountdown?: number
    autoReceiveSurplusDays?: number
    delayReceiveCountdown?: number
    delayStatus?: number
    dispatchCountdown?: number
    exchangeConfirmCountdown?: number
    merchantConfirmCountdown?: number
    merchantNotShippingCountdown?: number
    merchantShippingCountdown?: number
    orderNo?: string
    reapplyHiddenFlag?: number
    refActivityId?: string
    saleAfterContactMerchantHiddenFlag?: number
    saleAfterDisposalTimeoutDays?: number
    shippingCountdown?: number
    urgedCountdown?: number
    userNotShippingCountdown?: number
  }
  /**
   * 订单编号
   */
  orderNo?: string
  /**
   * 订单状态
   */
  orderStatus?: number
  orderTime?: string
  /**
   * 原始订单号
   */
  originalOrderNo?: string
  /**
   * 打包费
   */
  packagePrice?: number
  /**
   * 父订单Id
   */
  parentOrderId?: string
  /**
   * 支付金额
   */
  payAmount?: number
  /**
   * 订单中心支付流水号
   */
  paySerialNo?: string
  /**
   * 支付方式
   */
  payType?:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '12'
    | '13'
    | '15'
    | '16'
    | '17'
    | '18'
    | '21'
    | '22'
    | '14'
  /**
   * 邮费
   */
  postFee?: number
  /**
   * 数量
   */
  quantity?: number
  /**
   * 退款是否需要退多彩宝分润金额
   */
  refundDcbFee?: boolean
  saleType?: number
  sellerAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  sellerRefundAddress?: {
    /**
     * 区划，如观山湖区
     */
    area?: string
    /**
     * 区划编码
     */
    areaCode?: string
    /**
     * 营业时间-分割
     */
    businessTimeStr?: string
    /**
     * 城市
     */
    city?: string
    /**
     * 详细地址，不需要省市区
     */
    detail?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 姓名
     */
    name?: string
    /**
     * 手机号
     */
    phoneNo?: string
    /**
     * 省份
     */
    province?: string
    /**
     * 自提点名称
     */
    selfPickupName?: string
    /**
     * 联系人
     */
    contact?: string
    /**
     * 联系电话
     */
    contactTel?: string
  }
  /**
   * SKU列表
   */
  skus?: {
    channelDiscountInfo?: {
      /**
       * 优惠金额
       */
      discountAmount?: number
      /**
       * 活动Id
       */
      id?: string
      /**
       * 积分
       */
      point?: number
    }
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品名称
     */
    commodityName?: string
    /**
     * 商品图片
     */
    commodityPic?: string
    /**
     * 优惠金额
     */
    discountAmount?: number
    /**
     * 分润金额
     */
    distributionProfitAmount?: number
    /**
     * 分润比例 十位数，12%
     */
    distributionProfitRatio?: number
    /**
     * 是否关闭换货申请 0否1是
     */
    exchangeCloseFlag?: number
    /**
     * 发货时间
     */
    logisticsBeginTime?: string
    /**
     * 快递公司名称
     */
    logisticsCompanyName?: string
    /**
     * 快递公司编码
     */
    logisticsCompanyNo?: string
    /**
     * 物流订单号
     */
    logisticsOrderNo?: string
    /**
     * 物流运单号
     */
    logisticsWaybillNo?: string
    /**
     * 打包费
     */
    packagePrice?: number
    /**
     * 邮费
     */
    postFee?: number
    /**
     * 数量
     */
    quantity?: number
    /**
     * 是否关闭退货退款申请 0否1是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0否1是
     */
    refundOnlyCloseFlag?: number
    /**
     * 是否支持换货 0不支持 1支持
     */
    replaceStatus?: number
    /**
     * 退款金额
     */
    returnAmount?: number
    sellerRefundAddress?: {
      /**
       * 区划，如观山湖区
       */
      area?: string
      /**
       * 区划编码
       */
      areaCode?: string
      /**
       * 营业时间-分割
       */
      businessTimeStr?: string
      /**
       * 城市
       */
      city?: string
      /**
       * 详细地址，不需要省市区
       */
      detail?: string
      /**
       * 纬度
       */
      latitude?: string
      /**
       * 经度
       */
      longitude?: string
      /**
       * 姓名
       */
      name?: string
      /**
       * 手机号
       */
      phoneNo?: string
      /**
       * 省份
       */
      province?: string
      /**
       * 自提点名称
       */
      selfPickupName?: string
      /**
       * 联系人
       */
      contact?: string
      /**
       * 联系电话
       */
      contactTel?: string
    }
    /**
     * 是否支持7天无理由 0不支持 1支持
     */
    sevenDaysStatus?: number
    /**
     * 商品发货状态
     */
    shipingStatus?: number
    /**
     * 发货方式
     */
    shippingType?: number
    /**
     * sku id
     */
    skuId?: string
    /**
     * 规格描述
     */
    skuSpecs?: string
    /**
     * 总价
     */
    totalPrice?: number
    /**
     * 单价
     */
    unitPrice?: number
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
  }[]
  /**
   * 订单总价
   */
  totalPrice?: number
  unitOrgCode?: string
  /**
   * 用户Id
   */
  userId?: string
  /**
   * 用户名
   */
  userName?: string
  /**
   * 用户手机号
   */
  userTel?: string
}

/**
 * 接口 [获取订单快照↗](https://yapi.gogpay.cn/project/906/interface/api/37573) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [order-snap-shot-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_9812)
 * @请求头 `POST /order/imsApi/orderSnapshot/getSnapShot`
 */
type ApiOrderImsApiOrderSnapshotGetSnapShotRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/906',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/order/imsApi/orderSnapshot/getSnapShot',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取订单快照↗](https://yapi.gogpay.cn/project/906/interface/api/37573) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [order-snap-shot-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_9812)
 * @请求头 `POST /order/imsApi/orderSnapshot/getSnapShot`
 */
const apiOrderImsApiOrderSnapshotGetSnapShotRequestConfig: ApiOrderImsApiOrderSnapshotGetSnapShotRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_5_0_58,
    devUrl: devUrl_0_5_0_58,
    prodUrl: prodUrl_0_5_0_58,
    path: '/order/imsApi/orderSnapshot/getSnapShot',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_5_0_58,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiOrderImsApiOrderSnapshotGetSnapShot',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取订单快照', author: '成龙' },
  }

/**
 * 接口 [获取订单快照↗](https://yapi.gogpay.cn/project/906/interface/api/37573) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [order-snap-shot-controller↗](https://yapi.gogpay.cn/project/906/interface/api/cat_9812)
 * @请求头 `POST /order/imsApi/orderSnapshot/getSnapShot`
 */
export const apiOrderImsApiOrderSnapshotGetSnapShot = /*#__PURE__*/ (
  requestData: ApiOrderImsApiOrderSnapshotGetSnapShotRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiOrderImsApiOrderSnapshotGetSnapShotResponse>(
    prepare(apiOrderImsApiOrderSnapshotGetSnapShotRequestConfig, requestData),
    ...args,
  )
}

apiOrderImsApiOrderSnapshotGetSnapShot.requestConfig =
  apiOrderImsApiOrderSnapshotGetSnapShotRequestConfig

const mockUrl_0_4_0_2 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_2 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_2 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_2 = 'data' as any

/**
 * 接口 [查询商品分组基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118294) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/baseInfo`
 */
export interface ApiCommodityCommodityGroupBaseInfoRequest {
  /**
   * 商品分组ID
   */
  id: string
}

/**
 * 接口 [查询商品分组基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118294) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/baseInfo`
 */
export interface ApiCommodityCommodityGroupBaseInfoResponse {
  /**
   * 背景图片
   */
  commodityGroupBackgroundPic: string
  /**
   * 商品分组图片
   */
  commodityGroupPic: string
  /**
   * 商品分组子标题
   */
  commodityGroupSubTitle: string
  /**
   * 商品分组标题
   */
  commodityGroupTitle: string
  /**
   * 商品分组ID
   */
  id: string
  /**
   * 分组下商品数量
   */
  quantity: number
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus: number
}

/**
 * 接口 [查询商品分组基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118294) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/baseInfo`
 */
type ApiCommodityCommodityGroupBaseInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodityGroup/baseInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品分组基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118294) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/baseInfo`
 */
const apiCommodityCommodityGroupBaseInfoRequestConfig: ApiCommodityCommodityGroupBaseInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/commodity/api/commodityGroup/baseInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGroupBaseInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品分组基本信息', author: '张彬' },
  }

/**
 * 接口 [查询商品分组基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118294) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/baseInfo`
 */
export const apiCommodityCommodityGroupBaseInfo = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGroupBaseInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGroupBaseInfoResponse>(
    prepare(apiCommodityCommodityGroupBaseInfoRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityGroupBaseInfo.requestConfig =
  apiCommodityCommodityGroupBaseInfoRequestConfig

/**
 * 接口 [批量查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118300) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/batchCommodityList`
 */
export interface ApiCommodityCommodityGroupBatchCommodityListRequest {
  /**
   * 商品分组ID列表
   */
  commodityGroupIdList: {
    /**
     * 分类ID
     */
    classifyId: string
    /**
     * 商品分组ID
     */
    id: string
    /**
     * 当前页数，从1开始
     */
    pageIndex?: number
    /**
     * 显示条数
     */
    pageSize?: number
    /**
     * 价格排序方式；0=默认，1=升序，2=降序
     */
    priceSortType: number
    /**
     * 销量排序方式；0=默认，1=升序，2=降序
     */
    salesSortType: number
  }[]
}

/**
 * 接口 [批量查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118300) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/batchCommodityList`
 */
export type ApiCommodityCommodityGroupBatchCommodityListResponse = {
  commodityGroupResourceId?: string
  pageResult?: {
    /**
     * 数据列表
     */
    list?: {
      /**
       * 商品自动下架日期
       */
      autoDownDate?: string
      /**
       * 起售数量
       */
      beginSaleQuantity?: number
      /**
       * 轮播图
       */
      carousePic?: string[]
      /**
       * 类目名称
       */
      categoryName?: string
      /**
       * 商品种类：0-套餐券 1-代金券
       */
      commodityClassifyType?: '0' | '1' | '2'
      /**
       * 商品合同标题
       */
      commodityContractTitle?: string
      /**
       * 商品ID
       */
      commodityId?: string
      /**
       * 商品标签
       */
      commodityLabel?: string[]
      /**
       * 商品参数json
       */
      commodityParams?: {
        /**
         * 类目参数ID
         */
        categoryParamsId?: string
        /**
         * 类目参数名称
         */
        categoryParamsName?: string
        /**
         * 类目参数值
         */
        categoryParamsValue?: string
        /**
         * 组件类型 0-文本框 1-下拉框
         */
        componentType?: number
        /**
         * 类目参数键值数组
         */
        options?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 是否新搜索页展示 0：不展示  1：展示
         */
        pageShowFlag?: number
        /**
         * 是否必输 0-否 1-是
         */
        requiredFlag?: number
        /**
         * 选中类目参数键值数组
         */
        selected?: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
      }[]
      /**
       * 商品规格
       */
      commoditySpecs?: {
        /**
         * sku属性名称
         */
        attributeName: string
        /**
         * 属性下拉参数
         */
        options: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * 选中下拉参数
         */
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }[]
        /**
         * sku属性ID
         */
        skuAttributeId: string
      }[]
      /**
       * 商品副标题
       */
      commoditySubTitle?: string
      /**
       * 商品标题
       */
      commodityTitle?: string
      /**
       * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
       */
      commodityTradeType?: number
      /**
       * 商品类型 0-标准电商 1-标准核销 2-标准虚拟 3-组合核销
       */
      commodityType?: number
      /**
       * 优惠券列表
       */
      couponList?: string[]
      /**
       * 封面图
       */
      coverPic?: string
      /**
       * 划线价格
       */
      dashPrice?: number
      /**
       * 最低价
       */
      lowestPrice?: number
      /**
       * 所属商城ID
       */
      martId?: string
      /**
       * 商户ID
       */
      merchantId?: string
      /**
       * 商户名称
       */
      merchantName?: string
      /**
       * 包邮类型: 1-包邮 2-运费模板
       */
      postType?: number
      /**
       * 预览路由
       */
      previewUrl?: string
      /**
       * 最低价(2.0之后用lowestPrice代替)
       */
      price?: number
      /**
       * 是否提供发票
       */
      provideInvoiceFlag?: number
      /**
       * 购买须知信息
       */
      purchaseNotesDetail: string
      /**
       * 购买须知ID
       */
      purchaseNotesId?: string
      /**
       * 类目ID
       */
      refCategoryId?: string
      /**
       * 运费模板ID
       */
      refDeliverTemplateId?: string
      /**
       * 运营渠道Id
       */
      refUserGroupId?: string
      /**
       * 售后服务: 1-换货  2-仅退款 3-退货退款
       */
      saleAfterServiceType?: number[]
      saleAfterServiceTypeSwitch?: {
        /**
         * 是否关闭换货申请 0-否 1-是
         */
        exchangeCloseFlag?: number
        /**
         * 是否关闭退货退款申请 0-否 1-是
         */
        refundAndReturnCloseFlag?: number
        /**
         * 是否关闭仅退款申请 0-否 1-是
         */
        refundOnlyCloseFlag?: number
      }
      /**
       * 销量
       */
      sales?: number
      /**
       * 搜索词
       */
      searchWord?: string[]
      /**
       * 价格区间
       */
      sellPrices?: number[]
      /**
       * 发货类型 0-快递发货 1-同城配送 2-到店自提
       */
      shippingType?: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases?: number
      /**
       * 发货/服务（小时内）时间
       */
      sippingOrServiceTime?: number
      /**
       * 商品规格详情
       */
      skuList?: {
        /**
         * 13位69码
         */
        barCode?: string
        /**
         * 商品ID
         */
        commodityId: string
        /**
         * 商品来源sku编号
         */
        commodityResourceSkuId?: string
        /**
         * 成本价
         */
        commoditySkuCost: number
        /**
         * SKU价格
         */
        commoditySkuPrice: number
        /**
         * 默认展示：0-否 1-是
         */
        defaultShow: number
        /**
         * sku能效级别
         */
        efficiencyLevel?: number
        /**
         * 商品单日限购量（0不限制）
         */
        singleDayLimitPurchases: number
        /**
         * SKU唯一参数标识
         */
        skuId: string
        /**
         * SKU商品图
         */
        skuPic: string
        /**
         * sku规格
         */
        skuSpecs: {
          /**
           * sku属性名称
           */
          attributeName?: string
          selected: {
            /**
             * 参数ID
             */
            id: string
            /**
             * 参数键(2.0废弃)
             */
            key?: string
            /**
             * 参数值
             */
            value: string
          }
          /**
           * sku属性ID
           */
          skuAttributeId?: string
        }[]
        /**
         * SKU状态:0-无效 1-有效
         */
        skuStatus: number
        /**
         * 用户单日限购量（0不限制）
         */
        userDayLimitPurchases: number
        /**
         * 用户限购
         */
        userLimitPurchases?: number
        /**
         * 重量(千克)
         */
        weight: number
      }[]
      /**
       * 库存预警
       */
      stockAlertCount?: number
      /**
       * 库存类型： 0-标准库存 3-日期库存
       */
      stockType: number
      /**
       * 剩余库存
       */
      surplusStock?: number
      taxRateDetail?: {
        /**
         * 税率名称
         */
        taxName: string
        /**
         * 税率编号
         */
        taxNo: string
        /**
         * 税率
         */
        taxRate: string
      }
      /**
       * 是否涉税：0-否 1-是
       */
      texFlag?: number
      /**
       * 店铺机构编码
       */
      unitOrgCode?: string
      /**
       * 上下架状态：-2-草稿 -1-待入库 0-待上架 1-上架 2-下架
       */
      upDownShelfStatus?: number
      /**
       * 上架时间
       */
      upShelfTime?: string
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases?: number
      /**
       * 用户限购
       */
      userLimitPurchases?: number
      /**
       * 套餐详情
       */
      writeOffCombos?: {
        /**
         * 分组详情列表
         */
        groupDetails?: {
          /**
           * 数量
           */
          num?: number
          /**
           * 价格
           */
          price?: number
          /**
           * 服务名称
           */
          serviceName?: string
        }[]
        /**
         * 分组名称
         */
        groupName?: string
      }[]
      writeOffRefund?: {
        /**
         * 过期后退款比例
         */
        expireRate?: number
        /**
         * 退款无需审批
         */
        notApproveFlag?: boolean
        /**
         * 未使用退款比例
         */
        unusedRate?: number
      }
      /**
       * 购买xxx天内有效
       */
      writeOffValidDay?: number
      /**
       * 核销有效期结束时间
       */
      writeOffValidEndTime?: string
      /**
       * 核销有效期开始时间
       */
      writeOffValidStartTime?: string
      /**
       * 核销有效期类型：0-相对时间 1-固定时间
       */
      writeOffValidType?: '0' | '1' | '2' | '3' | '4'
      /**
       * 可配送范围
       */
      zoneLimit?: {
        /**
         * 邮费结算价
         */
        postFeeCost?: number
        /**
         * 配送区域
         */
        zones?: {
          /**
           * 市级编码
           */
          cityCode?: string
          /**
           * 省份名称
           */
          cityName?: string
          /**
           * 区级编码
           */
          districtCode?: string
          /**
           * 区县名称
           */
          districtName?: string
          /**
           * 省份编码
           */
          provinceCode?: string
          /**
           * 省份名称
           */
          provinceName?: string
        }[]
      }[]
    }[]
    /**
     * 记录总数
     */
    total: number
    /**
     * 总页数
     */
    totalPage: number
  }
}[]

/**
 * 接口 [批量查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118300) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/batchCommodityList`
 */
type ApiCommodityCommodityGroupBatchCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodityGroup/batchCommodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118300) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/batchCommodityList`
 */
const apiCommodityCommodityGroupBatchCommodityListRequestConfig: ApiCommodityCommodityGroupBatchCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/commodity/api/commodityGroup/batchCommodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGroupBatchCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量查询商品分组下商品列表', author: '张彬' },
  }

/**
 * 接口 [批量查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118300) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/batchCommodityList`
 */
export const apiCommodityCommodityGroupBatchCommodityList = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGroupBatchCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGroupBatchCommodityListResponse>(
    prepare(
      apiCommodityCommodityGroupBatchCommodityListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommodityGroupBatchCommodityList.requestConfig =
  apiCommodityCommodityGroupBatchCommodityListRequestConfig

/**
 * 接口 [查询商品分组下分类基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118306) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/classifyBaseInfo`
 */
export interface ApiCommodityCommodityGroupClassifyBaseInfoRequest {
  /**
   * 商品分组分类ID
   */
  id: string
}

/**
 * 接口 [查询商品分组下分类基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118306) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/classifyBaseInfo`
 */
export interface ApiCommodityCommodityGroupClassifyBaseInfoResponse {
  /**
   * 分类图标
   */
  classifyPic: string
  /**
   * 分类名称
   */
  classifyTitle: string
  /**
   * 商品分组ID
   */
  refCommodityGroupId: string
}

/**
 * 接口 [查询商品分组下分类基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118306) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/classifyBaseInfo`
 */
type ApiCommodityCommodityGroupClassifyBaseInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodityGroup/classifyBaseInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品分组下分类基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118306) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/classifyBaseInfo`
 */
const apiCommodityCommodityGroupClassifyBaseInfoRequestConfig: ApiCommodityCommodityGroupClassifyBaseInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/commodity/api/commodityGroup/classifyBaseInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGroupClassifyBaseInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品分组下分类基本信息', author: '张彬' },
  }

/**
 * 接口 [查询商品分组下分类基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118306) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/classifyBaseInfo`
 */
export const apiCommodityCommodityGroupClassifyBaseInfo = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGroupClassifyBaseInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGroupClassifyBaseInfoResponse>(
    prepare(
      apiCommodityCommodityGroupClassifyBaseInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommodityGroupClassifyBaseInfo.requestConfig =
  apiCommodityCommodityGroupClassifyBaseInfoRequestConfig

/**
 * 接口 [查询商品分组下分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/118312) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityClassifyList`
 */
export interface ApiCommodityCommodityGroupCommodityClassifyListRequest {
  /**
   * 商品分组ID
   */
  id: string
}

/**
 * 接口 [查询商品分组下分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/118312) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityClassifyList`
 */
export type ApiCommodityCommodityGroupCommodityClassifyListResponse = {
  /**
   * 分组图标
   */
  classifyPic: string
  /**
   * 分组名称
   */
  classifyTitle: string
  /**
   * 数据源，0=默认，1=搜索
   */
  dataSource: number
  /**
   * 分组ID
   */
  id: string
}[]

/**
 * 接口 [查询商品分组下分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/118312) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityClassifyList`
 */
type ApiCommodityCommodityGroupCommodityClassifyListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodityGroup/commodityClassifyList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品分组下分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/118312) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityClassifyList`
 */
const apiCommodityCommodityGroupCommodityClassifyListRequestConfig: ApiCommodityCommodityGroupCommodityClassifyListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/commodity/api/commodityGroup/commodityClassifyList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGroupCommodityClassifyList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品分组下分类列表', author: '张彬' },
  }

/**
 * 接口 [查询商品分组下分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/118312) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityClassifyList`
 */
export const apiCommodityCommodityGroupCommodityClassifyList = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGroupCommodityClassifyListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGroupCommodityClassifyListResponse>(
    prepare(
      apiCommodityCommodityGroupCommodityClassifyListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommodityGroupCommodityClassifyList.requestConfig =
  apiCommodityCommodityGroupCommodityClassifyListRequestConfig

/**
 * 接口 [查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118318) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityList`
 */
export interface ApiCommodityCommodityGroupCommodityListRequest {
  /**
   * 分类ID
   */
  classifyId: string
  /**
   * 商品分组ID
   */
  id: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 价格排序方式；0=默认，1=升序，2=降序
   */
  priceSortType: number
  /**
   * 销量排序方式；0=默认，1=升序，2=降序
   */
  salesSortType: number
}

/**
 * 接口 [查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118318) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityList`
 */
export interface ApiCommodityCommodityGroupCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品自动下架日期
     */
    autoDownDate?: string
    /**
     * 起售数量
     */
    beginSaleQuantity?: number
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 类目名称
     */
    categoryName?: string
    /**
     * 商品种类：0-套餐券 1-代金券
     */
    commodityClassifyType?: '0' | '1' | '2'
    /**
     * 商品合同标题
     */
    commodityContractTitle?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品标签
     */
    commodityLabel?: string[]
    /**
     * 商品参数json
     */
    commodityParams?: {
      /**
       * 类目参数ID
       */
      categoryParamsId?: string
      /**
       * 类目参数名称
       */
      categoryParamsName?: string
      /**
       * 类目参数值
       */
      categoryParamsValue?: string
      /**
       * 组件类型 0-文本框 1-下拉框
       */
      componentType?: number
      /**
       * 类目参数键值数组
       */
      options?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 是否新搜索页展示 0：不展示  1：展示
       */
      pageShowFlag?: number
      /**
       * 是否必输 0-否 1-是
       */
      requiredFlag?: number
      /**
       * 选中类目参数键值数组
       */
      selected?: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
    }[]
    /**
     * 商品规格
     */
    commoditySpecs?: {
      /**
       * sku属性名称
       */
      attributeName: string
      /**
       * 属性下拉参数
       */
      options: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * 选中下拉参数
       */
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }[]
      /**
       * sku属性ID
       */
      skuAttributeId: string
    }[]
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
     */
    commodityTradeType?: number
    /**
     * 商品类型 0-标准电商 1-标准核销 2-标准虚拟 3-组合核销
     */
    commodityType?: number
    /**
     * 优惠券列表
     */
    couponList?: string[]
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 所属商城ID
     */
    martId?: string
    /**
     * 商户ID
     */
    merchantId?: string
    /**
     * 商户名称
     */
    merchantName?: string
    /**
     * 包邮类型: 1-包邮 2-运费模板
     */
    postType?: number
    /**
     * 预览路由
     */
    previewUrl?: string
    /**
     * 最低价(2.0之后用lowestPrice代替)
     */
    price?: number
    /**
     * 是否提供发票
     */
    provideInvoiceFlag?: number
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 购买须知ID
     */
    purchaseNotesId?: string
    /**
     * 类目ID
     */
    refCategoryId?: string
    /**
     * 运费模板ID
     */
    refDeliverTemplateId?: string
    /**
     * 运营渠道Id
     */
    refUserGroupId?: string
    /**
     * 售后服务: 1-换货  2-仅退款 3-退货退款
     */
    saleAfterServiceType?: number[]
    saleAfterServiceTypeSwitch?: {
      /**
       * 是否关闭换货申请 0-否 1-是
       */
      exchangeCloseFlag?: number
      /**
       * 是否关闭退货退款申请 0-否 1-是
       */
      refundAndReturnCloseFlag?: number
      /**
       * 是否关闭仅退款申请 0-否 1-是
       */
      refundOnlyCloseFlag?: number
    }
    /**
     * 销量
     */
    sales?: number
    /**
     * 搜索词
     */
    searchWord?: string[]
    /**
     * 价格区间
     */
    sellPrices?: number[]
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType?: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases?: number
    /**
     * 发货/服务（小时内）时间
     */
    sippingOrServiceTime?: number
    /**
     * 商品规格详情
     */
    skuList?: {
      /**
       * 13位69码
       */
      barCode?: string
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 商品来源sku编号
       */
      commodityResourceSkuId?: string
      /**
       * 成本价
       */
      commoditySkuCost: number
      /**
       * SKU价格
       */
      commoditySkuPrice: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * sku能效级别
       */
      efficiencyLevel?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * SKU商品图
       */
      skuPic: string
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * SKU状态:0-无效 1-有效
       */
      skuStatus: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases?: number
      /**
       * 重量(千克)
       */
      weight: number
    }[]
    /**
     * 库存预警
     */
    stockAlertCount?: number
    /**
     * 库存类型： 0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 剩余库存
     */
    surplusStock?: number
    taxRateDetail?: {
      /**
       * 税率名称
       */
      taxName: string
      /**
       * 税率编号
       */
      taxNo: string
      /**
       * 税率
       */
      taxRate: string
    }
    /**
     * 是否涉税：0-否 1-是
     */
    texFlag?: number
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
    /**
     * 上下架状态：-2-草稿 -1-待入库 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 上架时间
     */
    upShelfTime?: string
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases?: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3' | '4'
    /**
     * 可配送范围
     */
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118318) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityList`
 */
type ApiCommodityCommodityGroupCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodityGroup/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118318) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityList`
 */
const apiCommodityCommodityGroupCommodityListRequestConfig: ApiCommodityCommodityGroupCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_2,
    devUrl: devUrl_0_4_0_2,
    prodUrl: prodUrl_0_4_0_2,
    path: '/commodity/api/commodityGroup/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGroupCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品分组下商品列表', author: '张彬' },
  }

/**
 * 接口 [查询商品分组下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/118318) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-商品分组↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23775)
 * @请求头 `POST /commodity/api/commodityGroup/commodityList`
 */
export const apiCommodityCommodityGroupCommodityList = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGroupCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGroupCommodityListResponse>(
    prepare(apiCommodityCommodityGroupCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityGroupCommodityList.requestConfig =
  apiCommodityCommodityGroupCommodityListRequestConfig

const mockUrl_0_4_0_4 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_4 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_4 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_4 = 'data' as any

/**
 * 接口 [批量店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118342) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchBookingStoreDetail`
 */
export type ApiCommodityWriteOffCommodityBatchBookingStoreDetailRequest = {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}[]

/**
 * 接口 [批量店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118342) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchBookingStoreDetail`
 */
export type ApiCommodityWriteOffCommodityBatchBookingStoreDetailResponse = {
  /**
   * 订-套餐券信息
   */
  bookingCoupons?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  /**
   * 券-套餐券信息
   */
  comboCoupons?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  store?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }
  /**
   * 惠-代金券信息
   */
  vouchers?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
}[]

/**
 * 接口 [批量店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118342) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchBookingStoreDetail`
 */
type ApiCommodityWriteOffCommodityBatchBookingStoreDetailRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/939',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/commodity/api/writeOffCommodity/batchBookingStoreDetail',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [批量店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118342) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchBookingStoreDetail`
 */
const apiCommodityWriteOffCommodityBatchBookingStoreDetailRequestConfig: ApiCommodityWriteOffCommodityBatchBookingStoreDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/batchBookingStoreDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityBatchBookingStoreDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量店铺详情（订、惠、券）', author: '张彬' },
  }

/**
 * 接口 [批量店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118342) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchBookingStoreDetail`
 */
export const apiCommodityWriteOffCommodityBatchBookingStoreDetail =
  /*#__PURE__*/ (
    requestData: ApiCommodityWriteOffCommodityBatchBookingStoreDetailRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityWriteOffCommodityBatchBookingStoreDetailResponse>(
      prepare(
        apiCommodityWriteOffCommodityBatchBookingStoreDetailRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityWriteOffCommodityBatchBookingStoreDetail.requestConfig =
  apiCommodityWriteOffCommodityBatchBookingStoreDetailRequestConfig

/**
 * 接口 [批量店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118348) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchStoreDetail`
 */
export type ApiCommodityWriteOffCommodityBatchStoreDetailRequest = {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}[]

/**
 * 接口 [批量店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118348) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchStoreDetail`
 */
export type ApiCommodityWriteOffCommodityBatchStoreDetailResponse = {
  /**
   * 套餐券信息
   */
  comboCoupons?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  store?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }
  /**
   * 代金券信息
   */
  vouchers?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
}[]

/**
 * 接口 [批量店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118348) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchStoreDetail`
 */
type ApiCommodityWriteOffCommodityBatchStoreDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/batchStoreDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118348) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchStoreDetail`
 */
const apiCommodityWriteOffCommodityBatchStoreDetailRequestConfig: ApiCommodityWriteOffCommodityBatchStoreDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/batchStoreDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityBatchStoreDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量店铺详情', author: '张彬' },
  }

/**
 * 接口 [批量店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118348) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/batchStoreDetail`
 */
export const apiCommodityWriteOffCommodityBatchStoreDetail = /*#__PURE__*/ (
  requestData: ApiCommodityWriteOffCommodityBatchStoreDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityWriteOffCommodityBatchStoreDetailResponse>(
    prepare(
      apiCommodityWriteOffCommodityBatchStoreDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityWriteOffCommodityBatchStoreDetail.requestConfig =
  apiCommodityWriteOffCommodityBatchStoreDetailRequestConfig

/**
 * 接口 [店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118354) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/bookingStoreDetail`
 */
export interface ApiCommodityWriteOffCommodityBookingStoreDetailRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118354) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/bookingStoreDetail`
 */
export interface ApiCommodityWriteOffCommodityBookingStoreDetailResponse {
  /**
   * 订-套餐券信息
   */
  bookingCoupons?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  /**
   * 券-套餐券信息
   */
  comboCoupons?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  store?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }
  /**
   * 惠-代金券信息
   */
  vouchers?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
}

/**
 * 接口 [店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118354) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/bookingStoreDetail`
 */
type ApiCommodityWriteOffCommodityBookingStoreDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/bookingStoreDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118354) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/bookingStoreDetail`
 */
const apiCommodityWriteOffCommodityBookingStoreDetailRequestConfig: ApiCommodityWriteOffCommodityBookingStoreDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/bookingStoreDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityBookingStoreDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺详情（订、惠、券）', author: '张彬' },
  }

/**
 * 接口 [店铺详情（订、惠、券）↗](https://yapi.gogpay.cn/project/939/interface/api/118354) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/bookingStoreDetail`
 */
export const apiCommodityWriteOffCommodityBookingStoreDetail = /*#__PURE__*/ (
  requestData: ApiCommodityWriteOffCommodityBookingStoreDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityWriteOffCommodityBookingStoreDetailResponse>(
    prepare(
      apiCommodityWriteOffCommodityBookingStoreDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityWriteOffCommodityBookingStoreDetail.requestConfig =
  apiCommodityWriteOffCommodityBookingStoreDetailRequestConfig

/**
 * 接口 [清空用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118360) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/delStoreUserFootprint`
 */
export interface ApiCommodityWriteOffCommodityDelStoreUserFootprintRequest {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 店铺ID(为空全部清空)
   */
  storeId?: string[]
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [清空用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118360) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/delStoreUserFootprint`
 */
export interface ApiCommodityWriteOffCommodityDelStoreUserFootprintResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [清空用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118360) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/delStoreUserFootprint`
 */
type ApiCommodityWriteOffCommodityDelStoreUserFootprintRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/delStoreUserFootprint',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [清空用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118360) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/delStoreUserFootprint`
 */
const apiCommodityWriteOffCommodityDelStoreUserFootprintRequestConfig: ApiCommodityWriteOffCommodityDelStoreUserFootprintRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/delStoreUserFootprint',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityDelStoreUserFootprint',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '清空用户足迹(服务端)', author: '张彬' },
  }

/**
 * 接口 [清空用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118360) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/delStoreUserFootprint`
 */
export const apiCommodityWriteOffCommodityDelStoreUserFootprint =
  /*#__PURE__*/ (
    requestData: ApiCommodityWriteOffCommodityDelStoreUserFootprintRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityWriteOffCommodityDelStoreUserFootprintResponse>(
      prepare(
        apiCommodityWriteOffCommodityDelStoreUserFootprintRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityWriteOffCommodityDelStoreUserFootprint.requestConfig =
  apiCommodityWriteOffCommodityDelStoreUserFootprintRequestConfig

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/118366) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/detail`
 */
export interface ApiCommodityWriteOffCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/118366) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/detail`
 */
export interface ApiCommodityWriteOffCommodityDetailResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay: number
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay: 0 | 1
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 默认价格
   */
  price?: number
  /**
   * 购买须知
   */
  purchaseNotesDetail?: string
  /**
   * 同店推荐商品
   */
  recommendCommodity?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 销售价区间
   */
  sellPrices?: number[]
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 标销商品规格信息
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 库存
     */
    commodityStock: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: number
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: number
    /**
     * 规格名称
     */
    specName: string
    /**
     * 规格值
     */
    specValue: string
    /**
     * 库存日期
     */
    stockDate: string
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存类型： 0-标准库存 3-日期库存
   */
  stockType: number
  store?: {
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
  }
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 套餐总价
   */
  writeOffCombosPrice?: number
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  writeOffStores?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic?: string
    /**
     * 主店店铺url
     */
    storeUrl: string
  }[]
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/118366) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/detail`
 */
type ApiCommodityWriteOffCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/118366) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/detail`
 */
const apiCommodityWriteOffCommodityDetailRequestConfig: ApiCommodityWriteOffCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '详情', author: '张彬' },
  }

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/118366) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/detail`
 */
export const apiCommodityWriteOffCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityWriteOffCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityWriteOffCommodityDetailResponse>(
    prepare(apiCommodityWriteOffCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityWriteOffCommodityDetail.requestConfig =
  apiCommodityWriteOffCommodityDetailRequestConfig

/**
 * 接口 [获取店铺用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118372) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/getStoreUserFootprint`
 */
export interface ApiCommodityWriteOffCommodityGetStoreUserFootprintRequest {
  /**
   * 运营渠道ID
   */
  businessChannelId?: string
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [获取店铺用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118372) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/getStoreUserFootprint`
 */
export type ApiCommodityWriteOffCommodityGetStoreUserFootprintResponse = {
  /**
   * 发生时间
   */
  createTime?: string
  /**
   * 足迹店铺
   */
  storeList?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }[]
}[]

/**
 * 接口 [获取店铺用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118372) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/getStoreUserFootprint`
 */
type ApiCommodityWriteOffCommodityGetStoreUserFootprintRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/getStoreUserFootprint',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取店铺用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118372) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/getStoreUserFootprint`
 */
const apiCommodityWriteOffCommodityGetStoreUserFootprintRequestConfig: ApiCommodityWriteOffCommodityGetStoreUserFootprintRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/getStoreUserFootprint',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityGetStoreUserFootprint',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取店铺用户足迹(服务端)', author: '张彬' },
  }

/**
 * 接口 [获取店铺用户足迹(服务端)↗](https://yapi.gogpay.cn/project/939/interface/api/118372) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/getStoreUserFootprint`
 */
export const apiCommodityWriteOffCommodityGetStoreUserFootprint =
  /*#__PURE__*/ (
    requestData: ApiCommodityWriteOffCommodityGetStoreUserFootprintRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityWriteOffCommodityGetStoreUserFootprintResponse>(
      prepare(
        apiCommodityWriteOffCommodityGetStoreUserFootprintRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityWriteOffCommodityGetStoreUserFootprint.requestConfig =
  apiCommodityWriteOffCommodityGetStoreUserFootprintRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118378) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/marketingDetail`
 */
export interface ApiCommodityWriteOffCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118378) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/marketingDetail`
 */
export interface ApiCommodityWriteOffCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 满减活动优惠
   */
  fullReductions?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  /**
   * 积分活动优惠
   */
  integrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 减去积分后的价格
     */
    discountPrice?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 所需积分（多彩豆）
     */
    integral?: number
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 当前库存
     */
    stock?: number
  }[]
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 折扣活动优惠
   */
  marketingDiscountCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 折扣比例
     */
    discountRatio?: number
    /**
     * 单笔优惠上限制
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118378) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/marketingDetail`
 */
type ApiCommodityWriteOffCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118378) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/marketingDetail`
 */
const apiCommodityWriteOffCommodityMarketingDetailRequestConfig: ApiCommodityWriteOffCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '张彬' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118378) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/marketingDetail`
 */
export const apiCommodityWriteOffCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityWriteOffCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityWriteOffCommodityMarketingDetailResponse>(
    prepare(
      apiCommodityWriteOffCommodityMarketingDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityWriteOffCommodityMarketingDetail.requestConfig =
  apiCommodityWriteOffCommodityMarketingDetailRequestConfig

/**
 * 接口 [规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118384) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/skuDetail`
 */
export interface ApiCommodityWriteOffCommoditySkuDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 库存日期
   */
  stockDate?: string
}

/**
 * 接口 [规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118384) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/skuDetail`
 */
export type ApiCommodityWriteOffCommoditySkuDetailResponse = {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 单次核销价格
   */
  onePrice?: number
  /**
   * 商品售价
   */
  sellPrice?: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType?: number
  /**
   * 结算值
   */
  settlementValue?: number
  /**
   * 规格名称
   */
  skuName?: string
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存类型：0-标准库存 3-日期库存
   */
  stockType?: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 可核销次数
   */
  writeOffNum?: number
}[]

/**
 * 接口 [规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118384) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/skuDetail`
 */
type ApiCommodityWriteOffCommoditySkuDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/skuDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118384) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/skuDetail`
 */
const apiCommodityWriteOffCommoditySkuDetailRequestConfig: ApiCommodityWriteOffCommoditySkuDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/skuDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommoditySkuDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '规格信息', author: '张彬' },
  }

/**
 * 接口 [规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118384) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/skuDetail`
 */
export const apiCommodityWriteOffCommoditySkuDetail = /*#__PURE__*/ (
  requestData: ApiCommodityWriteOffCommoditySkuDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityWriteOffCommoditySkuDetailResponse>(
    prepare(apiCommodityWriteOffCommoditySkuDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityWriteOffCommoditySkuDetail.requestConfig =
  apiCommodityWriteOffCommoditySkuDetailRequestConfig

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118390) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/storeDetail`
 */
export interface ApiCommodityWriteOffCommodityStoreDetailRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118390) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/storeDetail`
 */
export interface ApiCommodityWriteOffCommodityStoreDetailResponse {
  /**
   * 套餐券信息
   */
  comboCoupons?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  store?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }
  /**
   * 代金券信息
   */
  vouchers?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
}

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118390) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/storeDetail`
 */
type ApiCommodityWriteOffCommodityStoreDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/writeOffCommodity/storeDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118390) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/storeDetail`
 */
const apiCommodityWriteOffCommodityStoreDetailRequestConfig: ApiCommodityWriteOffCommodityStoreDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_4,
    devUrl: devUrl_0_4_0_4,
    prodUrl: prodUrl_0_4_0_4,
    path: '/commodity/api/writeOffCommodity/storeDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityWriteOffCommodityStoreDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺详情', author: '张彬' },
  }

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/118390) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23781)
 * @请求头 `POST /commodity/api/writeOffCommodity/storeDetail`
 */
export const apiCommodityWriteOffCommodityStoreDetail = /*#__PURE__*/ (
  requestData: ApiCommodityWriteOffCommodityStoreDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityWriteOffCommodityStoreDetailResponse>(
    prepare(apiCommodityWriteOffCommodityStoreDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityWriteOffCommodityStoreDetail.requestConfig =
  apiCommodityWriteOffCommodityStoreDetailRequestConfig

const mockUrl_0_4_0_5 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_5 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_5 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_5 = 'data' as any

/**
 * 接口 [根据类目ID列表获取类目参数(搜索页使用)↗](https://yapi.gogpay.cn/project/939/interface/api/118216) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchCategoryParamsByCategoryIds`
 */
export interface ApiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequest {
  /**
   * 类目参数ID
   */
  categoryIds: string[]
}

/**
 * 接口 [根据类目ID列表获取类目参数(搜索页使用)↗](https://yapi.gogpay.cn/project/939/interface/api/118216) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchCategoryParamsByCategoryIds`
 */
export type ApiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsResponse =
  {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]

/**
 * 接口 [根据类目ID列表获取类目参数(搜索页使用)↗](https://yapi.gogpay.cn/project/939/interface/api/118216) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchCategoryParamsByCategoryIds`
 */
type ApiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/939',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/commodity/api/categoryParams/batchCategoryParamsByCategoryIds',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [根据类目ID列表获取类目参数(搜索页使用)↗](https://yapi.gogpay.cn/project/939/interface/api/118216) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchCategoryParamsByCategoryIds`
 */
const apiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequestConfig: ApiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_5,
    devUrl: devUrl_0_4_0_5,
    prodUrl: prodUrl_0_4_0_5,
    path: '/commodity/api/categoryParams/batchCategoryParamsByCategoryIds',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiCommodityCategoryParamsBatchCategoryParamsByCategoryIds',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '根据类目ID列表获取类目参数(搜索页使用)',
      author: '张彬',
    },
  }

/**
 * 接口 [根据类目ID列表获取类目参数(搜索页使用)↗](https://yapi.gogpay.cn/project/939/interface/api/118216) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchCategoryParamsByCategoryIds`
 */
export const apiCommodityCategoryParamsBatchCategoryParamsByCategoryIds =
  /*#__PURE__*/ (
    requestData: ApiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsResponse>(
      prepare(
        apiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityCategoryParamsBatchCategoryParamsByCategoryIds.requestConfig =
  apiCommodityCategoryParamsBatchCategoryParamsByCategoryIdsRequestConfig

/**
 * 接口 [批量获取类目参数详情↗](https://yapi.gogpay.cn/project/939/interface/api/118222) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchDetail`
 */
export interface ApiCommodityCategoryParamsBatchDetailRequest {
  /**
   * 类目参数ID集合
   */
  categoryParamsIds: string[]
}

/**
 * 接口 [批量获取类目参数详情↗](https://yapi.gogpay.cn/project/939/interface/api/118222) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchDetail`
 */
export type ApiCommodityCategoryParamsBatchDetailResponse = {
  /**
   * 类目参数ID
   */
  categoryParamsId?: string
  /**
   * 类目参数名称
   */
  categoryParamsName?: string
  /**
   * 类目参数值
   */
  categoryParamsValue?: string
  /**
   * 组件类型 0-文本框 1-下拉框
   */
  componentType?: number
  /**
   * 是否新搜索页展示 0：不展示  1：展示
   */
  pageShowFlag?: number
  /**
   * 是否必输 0-否 1-是
   */
  requiredFlag?: number
}[]

/**
 * 接口 [批量获取类目参数详情↗](https://yapi.gogpay.cn/project/939/interface/api/118222) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchDetail`
 */
type ApiCommodityCategoryParamsBatchDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/categoryParams/batchDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量获取类目参数详情↗](https://yapi.gogpay.cn/project/939/interface/api/118222) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchDetail`
 */
const apiCommodityCategoryParamsBatchDetailRequestConfig: ApiCommodityCategoryParamsBatchDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_5,
    devUrl: devUrl_0_4_0_5,
    prodUrl: prodUrl_0_4_0_5,
    path: '/commodity/api/categoryParams/batchDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCategoryParamsBatchDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量获取类目参数详情', author: '张彬' },
  }

/**
 * 接口 [批量获取类目参数详情↗](https://yapi.gogpay.cn/project/939/interface/api/118222) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/batchDetail`
 */
export const apiCommodityCategoryParamsBatchDetail = /*#__PURE__*/ (
  requestData: ApiCommodityCategoryParamsBatchDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCategoryParamsBatchDetailResponse>(
    prepare(apiCommodityCategoryParamsBatchDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCategoryParamsBatchDetail.requestConfig =
  apiCommodityCategoryParamsBatchDetailRequestConfig

/**
 * 接口 [根据类目ID获取类目参数↗](https://yapi.gogpay.cn/project/939/interface/api/118228) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/getCategoryParamsByCategoryId`
 */
export interface ApiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequest {
  /**
   * 类目参数ID
   */
  categoryId: string
}

/**
 * 接口 [根据类目ID获取类目参数↗](https://yapi.gogpay.cn/project/939/interface/api/118228) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/getCategoryParamsByCategoryId`
 */
export type ApiCommodityCategoryParamsGetCategoryParamsByCategoryIdResponse = {
  /**
   * 类目参数ID
   */
  categoryParamsId?: string
  /**
   * 类目参数名称
   */
  categoryParamsName?: string
  /**
   * 类目参数值
   */
  categoryParamsValue?: string
  /**
   * 组件类型 0-文本框 1-下拉框
   */
  componentType?: number
  /**
   * 类目参数键值数组
   */
  options?: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * 是否新搜索页展示 0：不展示  1：展示
   */
  pageShowFlag?: number
  /**
   * 是否必输 0-否 1-是
   */
  requiredFlag?: number
  /**
   * 选中类目参数键值数组
   */
  selected?: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
}[]

/**
 * 接口 [根据类目ID获取类目参数↗](https://yapi.gogpay.cn/project/939/interface/api/118228) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/getCategoryParamsByCategoryId`
 */
type ApiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/939',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/commodity/api/categoryParams/getCategoryParamsByCategoryId',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [根据类目ID获取类目参数↗](https://yapi.gogpay.cn/project/939/interface/api/118228) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/getCategoryParamsByCategoryId`
 */
const apiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequestConfig: ApiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_5,
    devUrl: devUrl_0_4_0_5,
    prodUrl: prodUrl_0_4_0_5,
    path: '/commodity/api/categoryParams/getCategoryParamsByCategoryId',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiCommodityCategoryParamsGetCategoryParamsByCategoryId',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '根据类目ID获取类目参数', author: '张彬' },
  }

/**
 * 接口 [根据类目ID获取类目参数↗](https://yapi.gogpay.cn/project/939/interface/api/118228) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-类目参数管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23784)
 * @请求头 `POST /commodity/api/categoryParams/getCategoryParamsByCategoryId`
 */
export const apiCommodityCategoryParamsGetCategoryParamsByCategoryId =
  /*#__PURE__*/ (
    requestData: ApiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityCategoryParamsGetCategoryParamsByCategoryIdResponse>(
      prepare(
        apiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityCategoryParamsGetCategoryParamsByCategoryId.requestConfig =
  apiCommodityCategoryParamsGetCategoryParamsByCategoryIdRequestConfig

const mockUrl_0_4_0_6 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_6 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_6 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_6 = 'data' as any

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118822) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detail`
 */
export interface ApiCommodityOpenApiSkuStockDetailRequest {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * SKU业务唯一索引
   */
  skuId: string
}

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118822) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detail`
 */
export interface ApiCommodityOpenApiSkuStockDetailResponse {
  /**
   * sku能效级别
   */
  barCode?: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 成本价
   */
  commoditySkuCost: number
  /**
   * SKU价格
   */
  commoditySkuPrice: number
  /**
   * sku库存-(2.0版本之后使用surplusStock代替)
   */
  commodityStock: number
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow?: number
  /**
   * sku能效级别
   */
  efficiencyLevel?: number
  /**
   * SKU主键
   */
  id: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 商品单日限购量（0不限制）
   */
  singleDayLimitPurchases: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * SKU状态:0-无效 1-有效
   */
  skuStatus: number
  /**
   * 库存预警值
   */
  stockAlertCount: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 用户单日限购量（0不限制）
   */
  userDayLimitPurchases: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 重量(千克)
   */
  weight: number
}

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118822) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detail`
 */
type ApiCommodityOpenApiSkuStockDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/openApi/skuStock/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118822) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detail`
 */
const apiCommodityOpenApiSkuStockDetailRequestConfig: ApiCommodityOpenApiSkuStockDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/commodity/openApi/skuStock/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityOpenApiSkuStockDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询SKU详情', author: '张彬' },
  }

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118822) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detail`
 */
export const apiCommodityOpenApiSkuStockDetail = /*#__PURE__*/ (
  requestData: ApiCommodityOpenApiSkuStockDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityOpenApiSkuStockDetailResponse>(
    prepare(apiCommodityOpenApiSkuStockDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityOpenApiSkuStockDetail.requestConfig =
  apiCommodityOpenApiSkuStockDetailRequestConfig

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118828) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detailByCommodity`
 */
export interface ApiCommodityOpenApiSkuStockDetailByCommodityRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 省份代码
   */
  provinceCode: string
}

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118828) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detailByCommodity`
 */
export type ApiCommodityOpenApiSkuStockDetailByCommodityResponse = {
  /**
   * sku能效级别
   */
  barCode?: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 成本价
   */
  commoditySkuCost: number
  /**
   * SKU价格
   */
  commoditySkuPrice: number
  /**
   * sku库存-(2.0版本之后使用surplusStock代替)
   */
  commodityStock: number
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow?: number
  /**
   * sku能效级别
   */
  efficiencyLevel?: number
  /**
   * SKU主键
   */
  id: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 商品单日限购量（0不限制）
   */
  singleDayLimitPurchases: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * SKU状态:0-无效 1-有效
   */
  skuStatus: number
  /**
   * 库存预警值
   */
  stockAlertCount: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 用户单日限购量（0不限制）
   */
  userDayLimitPurchases: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 重量(千克)
   */
  weight: number
}[]

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118828) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detailByCommodity`
 */
type ApiCommodityOpenApiSkuStockDetailByCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/openApi/skuStock/detailByCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118828) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detailByCommodity`
 */
const apiCommodityOpenApiSkuStockDetailByCommodityRequestConfig: ApiCommodityOpenApiSkuStockDetailByCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_6,
    devUrl: devUrl_0_4_0_6,
    prodUrl: prodUrl_0_4_0_6,
    path: '/commodity/openApi/skuStock/detailByCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityOpenApiSkuStockDetailByCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品SKU列表', author: '张彬' },
  }

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118828) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [开放接口-SKU库存管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23787)
 * @请求头 `POST /commodity/openApi/skuStock/detailByCommodity`
 */
export const apiCommodityOpenApiSkuStockDetailByCommodity = /*#__PURE__*/ (
  requestData: ApiCommodityOpenApiSkuStockDetailByCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityOpenApiSkuStockDetailByCommodityResponse>(
    prepare(
      apiCommodityOpenApiSkuStockDetailByCommodityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityOpenApiSkuStockDetailByCommodity.requestConfig =
  apiCommodityOpenApiSkuStockDetailByCommodityRequestConfig

const mockUrl_0_4_0_7 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_7 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_7 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_7 = 'data' as any

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118810) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/detail`
 */
export interface ApiCommodityOpenApiCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 库存日期
   */
  stockDate?: string
}

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118810) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/detail`
 */
export interface ApiCommodityOpenApiCommodityDetailResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 商品自动下架日期
   */
  autoDownDate?: string
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 商品是否品牌升级：0-否 1-是
   */
  brandStatus: number
  /**
   * 校验资格接口地址
   */
  businessCheckUrl?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 是否校验购买资格：0-否 1-是
   */
  checkBuyFlag?: 0 | 1
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 商品种类：0-套餐券 1-代金券 2-堆售兑换券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 配送地址
   */
  deliveryAddress?: string
  /**
   * 配送地址类型：0-黑名单 1-白名单
   */
  deliveryAddressType?: 0 | 1
  deliveryCommodity: {
    /**
     * 封面标签
     */
    coverLabel?: string
    /**
     * 是否支持售后：0-否 1-是
     */
    isAfterSales?: 0 | 1
    multipleSku?: boolean
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * SKU唯一参数标识
       */
      skuId: string
    }[]
    /**
     * 包装费用
     */
    wrapPrice?: number
  }
  /**
   * 使用渠道多选：0-TV 1-移动端
   */
  distributeChannel?: number[]
  /**
   * 特征标签
   */
  featureLabel?: {
    /**
     * 标签CODE
     */
    code?: string
    /**
     * 标签名称
     */
    label?: string
  }[]
  /**
   * 是否支持售后：0-否 1-是
   */
  isAfterSales?: 0 | 1
  /**
   * 是否推荐商品： 0-否 1-是
   */
  isRecommend: 0 | 1
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 核销类组合商品信息
   */
  jointChildWriteOffCommodityList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品邮费价格
     */
    childPostPrice?: number
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单次核销价格
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  jointStandardCommodity: {
    /**
     * 包邮类型  1-包邮 2-运费模板
     */
    postType: 0 | 1 | 2
    /**
     * 是佛提供发票：0-不提供 1-提供
     */
    provideInvoiceFlag: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType: 0 | 1 | 2
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
     */
    zoneLimitType: 0 | 1 | 2
  }
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 不配送地址
   */
  noDeliveryAddress?: string
  /**
   * 是否不显示购物车
   */
  noShowCart?: boolean
  /**
   * 是否不显示库存
   */
  noShowStock?: boolean
  /**
   * 包邮类型: 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 预览状态
   */
  previewStatus?: number
  /**
   * 预览路由
   */
  previewUrl?: string
  /**
   * 最低价(2.0之后用lowestPrice代替)
   */
  price?: number
  /**
   * 供应商绑定商品ID
   */
  provideCommodityId?: string
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 供应商 0=多彩宝 1=京东
   */
  provideSource?: number
  /**
   * 购买须知信息
   */
  purchaseNotesDetail: string
  /**
   * 购买须知ID
   */
  purchaseNotesId?: string
  /**
   * 实名制类型 0-自动回填 1-手动填写
   */
  realNameInputType: number
  /**
   * 是否实名制购买：0-否 1-是
   */
  realNamePurchase?: '0' | '1'
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  ruleDetailLink?: {
    /**
     * 实名部分的规则详情链接
     */
    moreDetailLink?: string
    /**
     * 需要确认的规则详情链接
     */
    needSureLink?: string
  }
  /**
   * 售后服务: 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 自提地址id列表
   */
  selfPickupAddressId?: string[]
  /**
   * 是否支持自提：0-否 1-是
   */
  selfPickupStatus?: number
  /**
   * 推荐渠道Id
   */
  sellChannelId?: string
  /**
   * 价格区间
   */
  sellPrices?: number[]
  /**
   * 服务保障
   */
  serviceSafeguard?: {
    /**
     * 内容
     */
    content: string
    /**
     * 名称
     */
    name: string
    /**
     * 备注
     */
    remark: string
  }[]
  /**
   * 发货地址
   */
  shipAddress?: string
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 是否显示同店好货
   */
  showRecommend?: boolean
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 标电，虚拟商品规格详情
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
  /**
   * 标销商品规格详情
   */
  skuListWriteOff?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 库存
     */
    commodityStock: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: number
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: number
    /**
     * 规格名称
     */
    specName: string
    /**
     * 规格值
     */
    specValue: string
    /**
     * 库存日期
     */
    stockDate: string
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存预警
   */
  stockAlertCount?: number
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段库存
   */
  stockType: number
  /**
   * 商家资质
   */
  storeQualification?: string[]
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 核销提货类型
   */
  takeDeliveryType?: '1' | '2'
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  travelCommodity: {
    /**
     * 仅当isValidDay=0有效，需要提前x天预约购买
     */
    advanceDay?: number
    /**
     * 商品种类：0-套餐券
     */
    commodityClassifyType?: '0' | '1' | '2'
    /**
     * 结束标题
     */
    endTitle?: string
    /**
     * 是否实名：0-否 1-是
     */
    isAuth: 0 | 1
    /**
     * 可选日期区间：0-否 1-是
     */
    isDateInterval: 0 | 1
    /**
     * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
     */
    isIncludeLastDay?: 0 | 1
    /**
     * 是否当日有效：0-否 1-是
     */
    isValidDay?: 0 | 1
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 初始库存
       */
      initStock: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存日期
       */
      stockDate?: string
      /**
       * 库存ID:第三方下单需要，非第三方和skuId一致
       */
      stockId: string
      /**
       * 剩余库存
       */
      surplusStock: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * 开始标题
     */
    startTitle?: string
    /**
     * 库存类型： 0-标准库存 3-日期库存 5-时段库存
     */
    stockType: number
    /**
     * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
     */
    writeOffChannel:
      | '0'
      | '1'
      | '2'
      | '3'
      | '4'
      | '5'
      | '6'
      | '7'
      | '8'
      | '9'
      | '10'
      | '11'
      | '12'
      | '13'
    /**
     * 核销渠道商品ID
     */
    writeOffChannelCommodityId: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  }
  /**
   * TV轮播图
   */
  tvCarousePic?: string[]
  /**
   * TV商品详情
   */
  tvCommodityDetail: string
  /**
   * TV封面图
   */
  tvCoverPic?: string
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 虚拟商品类型：0-普通虚拟商品 1-兑换虚拟商品
   */
  virtualCommodityType: 0 | 1
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  /**
   * 购买xxx天内有效
   */
  writeOffValidDay?: number
  /**
   * 核销有效期结束时间
   */
  writeOffValidEndTime?: string
  /**
   * 核销有效期开始时间
   */
  writeOffValidStartTime?: string
  /**
   * 核销有效期类型：0-相对时间 1-固定时间
   */
  writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  zoneLimit?: {
    /**
     * 邮费结算价
     */
    postFeeCost?: number
    /**
     * 配送区域
     */
    zones?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 省份名称
       */
      cityName?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 区县名称
       */
      districtName?: string
      /**
       * 省份编码
       */
      provinceCode?: string
      /**
       * 省份名称
       */
      provinceName?: string
    }[]
  }
  /**
   * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
   */
  zoneLimitType?: '0' | '1' | '2'
  /**
   * 优惠描述
   */
  discountDescList?: string[]
  /**
   * 优惠后价格
   */
  discountAfterAmt?: number
  /**
   * 优惠前价格
   */
  discountBeforeAmt?: number
}

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118810) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/detail`
 */
type ApiCommodityOpenApiCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/openApi/commodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118810) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/detail`
 */
const apiCommodityOpenApiCommodityDetailRequestConfig: ApiCommodityOpenApiCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/commodity/openApi/commodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityOpenApiCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商品详情信息', author: '张彬' },
  }

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118810) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/detail`
 */
export const apiCommodityOpenApiCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityOpenApiCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityOpenApiCommodityDetailResponse>(
    prepare(apiCommodityOpenApiCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityOpenApiCommodityDetail.requestConfig =
  apiCommodityOpenApiCommodityDetailRequestConfig

/**
 * 接口 [获取商品规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118816) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/getCommoditySpecInfo`
 */
export interface ApiCommodityOpenApiCommodityGetCommoditySpecInfoRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [获取商品规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118816) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/getCommoditySpecInfo`
 */
export type ApiCommodityOpenApiCommodityGetCommoditySpecInfoResponse = {
  /**
   * sku属性名称
   */
  attributeName: string
  /**
   * 属性下拉参数
   */
  options: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * 选中下拉参数
   */
  selected: {
    /**
     * 参数ID
     */
    id: string
    /**
     * 参数键(2.0废弃)
     */
    key?: string
    /**
     * 参数值
     */
    value: string
  }[]
  /**
   * sku属性ID
   */
  skuAttributeId: string
}[]

/**
 * 接口 [获取商品规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118816) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/getCommoditySpecInfo`
 */
type ApiCommodityOpenApiCommodityGetCommoditySpecInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/openApi/commodity/getCommoditySpecInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118816) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/getCommoditySpecInfo`
 */
const apiCommodityOpenApiCommodityGetCommoditySpecInfoRequestConfig: ApiCommodityOpenApiCommodityGetCommoditySpecInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_7,
    devUrl: devUrl_0_4_0_7,
    prodUrl: prodUrl_0_4_0_7,
    path: '/commodity/openApi/commodity/getCommoditySpecInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityOpenApiCommodityGetCommoditySpecInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品规格信息', author: '张彬' },
  }

/**
 * 接口 [获取商品规格信息↗](https://yapi.gogpay.cn/project/939/interface/api/118816) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [开放接口-商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_23790)
 * @请求头 `POST /commodity/openApi/commodity/getCommoditySpecInfo`
 */
export const apiCommodityOpenApiCommodityGetCommoditySpecInfo = /*#__PURE__*/ (
  requestData: ApiCommodityOpenApiCommodityGetCommoditySpecInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityOpenApiCommodityGetCommoditySpecInfoResponse>(
    prepare(
      apiCommodityOpenApiCommodityGetCommoditySpecInfoRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityOpenApiCommodityGetCommoditySpecInfo.requestConfig =
  apiCommodityOpenApiCommodityGetCommoditySpecInfoRequestConfig

const mockUrl_0_4_0_21 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_21 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_21 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_21 = 'data' as any

/**
 * 接口 [批量获取店铺商品(最多抢10)↗](https://yapi.gogpay.cn/project/939/interface/api/151110) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/batchStoreCommodity`
 */
export interface ApiCommodityCommonCommodityBatchStoreCommodityRequest {
  /**
   * 获取条数
   */
  num?: number
  /**
   * 店铺ID集合
   */
  storeIds?: string[]
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 机构号集合
   */
  unitOrgCodes?: string[]
}

/**
 * 接口 [批量获取店铺商品(最多抢10)↗](https://yapi.gogpay.cn/project/939/interface/api/151110) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/batchStoreCommodity`
 */
export type ApiCommodityCommonCommodityBatchStoreCommodityResponse = {
  /**
   * 商品列表
   */
  commodityList?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 商品类型 0-标准电商 1-标准核销 2-标准虚拟 3-组合核销
     */
    commodityType?: number
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 预览路由
     */
    previewUrl?: string
    /**
     * 运营渠道Id
     */
    refUserGroupId?: string
    /**
     * 价格区间
     */
    sellPrices?: number[]
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * TV轮播图
     */
    tvCarousePic?: string[]
    /**
     * TV封面图
     */
    tvCoverPic?: string
    /**
     * 店铺机构编码
     */
    unitOrgCode?: string
  }[]
  /**
   * 店铺封面图
   */
  storeCover?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺路由
   */
  storeUrl?: string
}[]

/**
 * 接口 [批量获取店铺商品(最多抢10)↗](https://yapi.gogpay.cn/project/939/interface/api/151110) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/batchStoreCommodity`
 */
type ApiCommodityCommonCommodityBatchStoreCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commonCommodity/batchStoreCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量获取店铺商品(最多抢10)↗](https://yapi.gogpay.cn/project/939/interface/api/151110) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/batchStoreCommodity`
 */
const apiCommodityCommonCommodityBatchStoreCommodityRequestConfig: ApiCommodityCommonCommodityBatchStoreCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_21,
    devUrl: devUrl_0_4_0_21,
    prodUrl: prodUrl_0_4_0_21,
    path: '/commodity/api/commonCommodity/batchStoreCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommonCommodityBatchStoreCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量获取店铺商品(最多抢10)', author: '张彬' },
  }

/**
 * 接口 [批量获取店铺商品(最多抢10)↗](https://yapi.gogpay.cn/project/939/interface/api/151110) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/batchStoreCommodity`
 */
export const apiCommodityCommonCommodityBatchStoreCommodity = /*#__PURE__*/ (
  requestData: ApiCommodityCommonCommodityBatchStoreCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommonCommodityBatchStoreCommodityResponse>(
    prepare(
      apiCommodityCommonCommodityBatchStoreCommodityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommonCommodityBatchStoreCommodity.requestConfig =
  apiCommodityCommonCommodityBatchStoreCommodityRequestConfig

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/151533) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/baseInfo`
 */
export interface ApiCommodityCommonCommodityBaseInfoRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/151533) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/baseInfo`
 */
export interface ApiCommodityCommonCommodityBaseInfoResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 商品自动下架日期
   */
  autoDownDate?: string
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 校验资格接口地址
   */
  businessCheckUrl?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 是否校验购买资格：0-否 1-是
   */
  checkBuyFlag?: 0 | 1
  /**
   * 商品种类：0-套餐券 1-代金券 2-堆售兑换券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 配送地址
   */
  deliveryAddress?: string
  /**
   * 配送地址类型：0-黑名单 1-白名单
   */
  deliveryAddressType?: 0 | 1
  deliveryCommodity: {
    /**
     * 封面标签
     */
    coverLabel?: string
    /**
     * 是否支持售后：0-否 1-是
     */
    isAfterSales?: 0 | 1
    multipleSku?: boolean
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * SKU唯一参数标识
       */
      skuId: string
    }[]
    /**
     * 包装费用
     */
    wrapPrice?: number
  }
  /**
   * 使用渠道多选：0-TV 1-移动端
   */
  distributeChannel?: number[]
  /**
   * 特征标签
   */
  featureLabel?: {
    /**
     * 标签CODE
     */
    code?: string
    /**
     * 标签名称
     */
    label?: string
  }[]
  /**
   * 是否支持售后：0-否 1-是
   */
  isAfterSales?: 0 | 1
  /**
   * 是否推荐商品： 0-否 1-是
   */
  isRecommend: 0 | 1
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 核销类组合商品信息
   */
  jointChildWriteOffCommodityList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品邮费价格
     */
    childPostPrice?: number
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单次核销价格
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  jointStandardCommodity: {
    /**
     * 包邮类型  1-包邮 2-运费模板
     */
    postType: 0 | 1 | 2
    /**
     * 是佛提供发票：0-不提供 1-提供
     */
    provideInvoiceFlag: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType: 0 | 1 | 2
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
     */
    zoneLimitType: 0 | 1 | 2
  }
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 不配送地址
   */
  noDeliveryAddress?: string
  /**
   * 包邮类型: 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 预览路由
   */
  previewUrl?: string
  /**
   * 最低价(2.0之后用lowestPrice代替)
   */
  price?: number
  /**
   * 供应商绑定商品ID
   */
  provideCommodityId?: string
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 供应商 0=多彩宝 1=京东
   */
  provideSource?: number
  /**
   * 购买须知信息
   */
  purchaseNotesDetail: string
  /**
   * 购买须知ID
   */
  purchaseNotesId?: string
  /**
   * 实名制类型 0-自动回填 1-手动填写
   */
  realNameInputType: number
  /**
   * 是否实名制购买：0-否 1-是
   */
  realNamePurchase?: '0' | '1'
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  ruleDetailLink?: {
    /**
     * 实名部分的规则详情链接
     */
    moreDetailLink?: string
    /**
     * 需要确认的规则详情链接
     */
    needSureLink?: string
  }
  /**
   * 售后服务: 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 自提地址id列表
   */
  selfPickupAddressId?: string[]
  /**
   * 是否支持自提：0-否 1-是
   */
  selfPickupStatus?: number
  /**
   * 价格区间
   */
  sellPrices?: number[]
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 标电，虚拟商品规格详情
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
  /**
   * 标销商品规格详情
   */
  skuListWriteOff?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 库存
     */
    commodityStock: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: number
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: number
    /**
     * 规格名称
     */
    specName: string
    /**
     * 规格值
     */
    specValue: string
    /**
     * 库存日期
     */
    stockDate: string
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存预警
   */
  stockAlertCount?: number
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段库存
   */
  stockType: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 核销提货类型
   */
  takeDeliveryType?: '1' | '2'
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  travelCommodity: {
    /**
     * 仅当isValidDay=0有效，需要提前x天预约购买
     */
    advanceDay?: number
    /**
     * 商品种类：0-套餐券
     */
    commodityClassifyType?: '0' | '1' | '2'
    /**
     * 结束标题
     */
    endTitle?: string
    /**
     * 是否实名：0-否 1-是
     */
    isAuth: 0 | 1
    /**
     * 可选日期区间：0-否 1-是
     */
    isDateInterval: 0 | 1
    /**
     * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
     */
    isIncludeLastDay?: 0 | 1
    /**
     * 是否当日有效：0-否 1-是
     */
    isValidDay?: 0 | 1
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 初始库存
       */
      initStock: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存日期
       */
      stockDate?: string
      /**
       * 库存ID:第三方下单需要，非第三方和skuId一致
       */
      stockId: string
      /**
       * 剩余库存
       */
      surplusStock: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * 开始标题
     */
    startTitle?: string
    /**
     * 库存类型： 0-标准库存 3-日期库存 5-时段库存
     */
    stockType: number
    /**
     * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
     */
    writeOffChannel:
      | '0'
      | '1'
      | '2'
      | '3'
      | '4'
      | '5'
      | '6'
      | '7'
      | '8'
      | '9'
      | '10'
      | '11'
      | '12'
      | '13'
    /**
     * 核销渠道商品ID
     */
    writeOffChannelCommodityId: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  }
  /**
   * TV轮播图
   */
  tvCarousePic?: string[]
  /**
   * TV封面图
   */
  tvCoverPic?: string
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 虚拟商品类型：0-普通虚拟商品 1-兑换虚拟商品
   */
  virtualCommodityType: 0 | 1
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  /**
   * 购买xxx天内有效
   */
  writeOffValidDay?: number
  /**
   * 核销有效期结束时间
   */
  writeOffValidEndTime?: string
  /**
   * 核销有效期开始时间
   */
  writeOffValidStartTime?: string
  /**
   * 核销有效期类型：0-相对时间 1-固定时间
   */
  writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  zoneLimit?: {
    /**
     * 邮费结算价
     */
    postFeeCost?: number
    /**
     * 配送区域
     */
    zones?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 省份名称
       */
      cityName?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 区县名称
       */
      districtName?: string
      /**
       * 省份编码
       */
      provinceCode?: string
      /**
       * 省份名称
       */
      provinceName?: string
    }[]
  }
  /**
   * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
   */
  zoneLimitType?: '0' | '1' | '2'
  /**
   * 优惠描述
   */
  discountDescList?: string[]
  /**
   * 优惠后价格
   */
  discountAfterAmt?: number
  /**
   * 优惠前价格
   */
  discountBeforeAmt?: number
}

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/151533) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/baseInfo`
 */
type ApiCommodityCommonCommodityBaseInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commonCommodity/baseInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/151533) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/baseInfo`
 */
const apiCommodityCommonCommodityBaseInfoRequestConfig: ApiCommodityCommonCommodityBaseInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_21,
    devUrl: devUrl_0_4_0_21,
    prodUrl: prodUrl_0_4_0_21,
    path: '/commodity/api/commonCommodity/baseInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommonCommodityBaseInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品基本信息', author: '张彬' },
  }

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/151533) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/baseInfo`
 */
export const apiCommodityCommonCommodityBaseInfo = /*#__PURE__*/ (
  requestData: ApiCommodityCommonCommodityBaseInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommonCommodityBaseInfoResponse>(
    prepare(apiCommodityCommonCommodityBaseInfoRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommonCommodityBaseInfo.requestConfig =
  apiCommodityCommonCommodityBaseInfoRequestConfig

/**
 * 接口 [收货地址列表↗](https://yapi.gogpay.cn/project/939/interface/api/182164) 的 **请求类型**
 *
 * @作者 杨大鑫
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList`
 */
export interface ApiCommodityCommonCommodityAddressListRequest {
  /**
   * 商品ID列表
   */
  commodityIds?: string[]
  /**
   * 区划编码,多个编码用","隔开,不限制则不传
   */
  districtCode?: string
}

/**
 * 接口 [收货地址列表↗](https://yapi.gogpay.cn/project/939/interface/api/182164) 的 **返回类型**
 *
 * @作者 杨大鑫
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList`
 */
export interface ApiCommodityCommonCommodityAddressListResponse {
  /**
   * 数据列表
   */
  list?: {
    city?: string
    cityCode?: string
    county?: string
    dcbUserId?: string
    defaultFlag?: number
    detail?: string
    districtCode?: string
    id?: string
    phoneNo?: string
    province?: string
    provinceCode?: string
    receiver?: string
    serviceFlag?: number
    /**
     * 街道信息
     */
    street?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [收货地址列表↗](https://yapi.gogpay.cn/project/939/interface/api/182164) 的 **请求配置的类型**
 *
 * @作者 杨大鑫
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList`
 */
type ApiCommodityCommonCommodityAddressListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commonCommodity/addressList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [收货地址列表↗](https://yapi.gogpay.cn/project/939/interface/api/182164) 的 **请求配置**
 *
 * @作者 杨大鑫
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList`
 */
const apiCommodityCommonCommodityAddressListRequestConfig: ApiCommodityCommonCommodityAddressListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_21,
    devUrl: devUrl_0_4_0_21,
    prodUrl: prodUrl_0_4_0_21,
    path: '/commodity/api/commonCommodity/addressList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommonCommodityAddressList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '收货地址列表', author: '杨大鑫' },
  }

/**
 * 接口 [收货地址列表↗](https://yapi.gogpay.cn/project/939/interface/api/182164) 的 **请求函数**
 *
 * @作者 杨大鑫
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList`
 */
export const apiCommodityCommonCommodityAddressList = /*#__PURE__*/ (
  requestData: ApiCommodityCommonCommodityAddressListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommonCommodityAddressListResponse>(
    prepare(apiCommodityCommonCommodityAddressListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommonCommodityAddressList.requestConfig =
  apiCommodityCommonCommodityAddressListRequestConfig

/**
 * 接口 [【中国红】看了又看↗](https://yapi.gogpay.cn/project/939/interface/api/267084) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/otherRecommends`
 */
export interface ApiCommodityCommonCommodityOtherRecommendsRequest {
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [【中国红】看了又看↗](https://yapi.gogpay.cn/project/939/interface/api/267084) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/otherRecommends`
 */
export type ApiCommodityCommonCommodityOtherRecommendsResponse = {
  /**
   * 原价
   */
  amt?: string
  /**
   * 类目ID
   */
  categoryId?: string
  /**
   * 嵌套资源位资源信息
   */
  childList?: unknown[]
  /**
   * 优惠价格
   */
  discountAmt?: string
  /**
   * 区划id
   */
  divisionId?: string
  /**
   * 区划名称
   */
  divisionName?: string
  /**
   * 扩展数据
   */
  extendData?: {}
  /**
   * 服务图标
   */
  icon?: string
  /**
   * 服务图标(高度)
   */
  iconHeight?: number
  /**
   * 服务图标(宽度)
   */
  iconWidth?: number
  /**
   * 资源ID
   */
  id: string
  /**
   * 专区id（商品专用）
   */
  regionId?: string
  /**
   * 自由字段键值对
   */
  remarkMap?: {}
  /**
   * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
   */
  resType?: string
  /**
   * 根类目ID
   */
  rootCategoryId?: string
  /**
   * 根类目名称
   */
  rootCategoryIdMsg?: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 资源位ID
   */
  stateId: string
  /**
   * 资源位名称
   */
  stateName?: string
  /**
   * 分发系统算法ID
   */
  strategyId?: string
  /**
   * 分发系统算法名称
   */
  strategyName?: string
  /**
   * 副标题
   */
  subTitle?: string
  /**
   * 标签数据
   */
  tags?: string[]
  /**
   * 路由
   */
  targetUrl?: string
  /**
   * 主标题
   */
  title?: string
  /**
   * 版本号
   */
  version?: number
}[]

/**
 * 接口 [【中国红】看了又看↗](https://yapi.gogpay.cn/project/939/interface/api/267084) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/otherRecommends`
 */
type ApiCommodityCommonCommodityOtherRecommendsRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commonCommodity/otherRecommends',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【中国红】看了又看↗](https://yapi.gogpay.cn/project/939/interface/api/267084) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/otherRecommends`
 */
const apiCommodityCommonCommodityOtherRecommendsRequestConfig: ApiCommodityCommonCommodityOtherRecommendsRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_21,
    devUrl: devUrl_0_4_0_21,
    prodUrl: prodUrl_0_4_0_21,
    path: '/commodity/api/commonCommodity/otherRecommends',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommonCommodityOtherRecommends',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '【中国红】看了又看', author: '成龙' },
  }

/**
 * 接口 [【中国红】看了又看↗](https://yapi.gogpay.cn/project/939/interface/api/267084) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/otherRecommends`
 */
export const apiCommodityCommonCommodityOtherRecommends = /*#__PURE__*/ (
  requestData: ApiCommodityCommonCommodityOtherRecommendsRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommonCommodityOtherRecommendsResponse>(
    prepare(
      apiCommodityCommonCommodityOtherRecommendsRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommonCommodityOtherRecommends.requestConfig =
  apiCommodityCommonCommodityOtherRecommendsRequestConfig

/**
 * 接口 [收货地址列表_copy↗](https://yapi.gogpay.cn/project/939/interface/api/395497) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList_1711333769780`
 */
export interface ApiCommodityCommonCommodityAddressList_1711333769780Request {
  /**
   * 商品ID列表
   */
  commodityIds?: string[]
  /**
   * 区划编码,多个编码用","隔开,不限制则不传
   */
  districtCode?: string
}

/**
 * 接口 [收货地址列表_copy↗](https://yapi.gogpay.cn/project/939/interface/api/395497) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList_1711333769780`
 */
export interface ApiCommodityCommonCommodityAddressList_1711333769780Response {
  /**
   * 数据列表
   */
  list?: {
    city?: string
    cityCode?: string
    county?: string
    dcbUserId?: string
    defaultFlag?: number
    detail?: string
    districtCode?: string
    id?: string
    phoneNo?: string
    province?: string
    provinceCode?: string
    receiver?: string
    serviceFlag?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [收货地址列表_copy↗](https://yapi.gogpay.cn/project/939/interface/api/395497) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList_1711333769780`
 */
type ApiCommodityCommonCommodityAddressList_1711333769780RequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/939',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/commodity/api/commonCommodity/addressList_1711333769780',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [收货地址列表_copy↗](https://yapi.gogpay.cn/project/939/interface/api/395497) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList_1711333769780`
 */
const apiCommodityCommonCommodityAddressList_1711333769780RequestConfig: ApiCommodityCommonCommodityAddressList_1711333769780RequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_21,
    devUrl: devUrl_0_4_0_21,
    prodUrl: prodUrl_0_4_0_21,
    path: '/commodity/api/commonCommodity/addressList_1711333769780',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommonCommodityAddressList_1711333769780',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '收货地址列表_copy', author: '511号开发' },
  }

/**
 * 接口 [收货地址列表_copy↗](https://yapi.gogpay.cn/project/939/interface/api/395497) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [前台-公共商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27749)
 * @请求头 `POST /commodity/api/commonCommodity/addressList_1711333769780`
 */
export const apiCommodityCommonCommodityAddressList_1711333769780 =
  /*#__PURE__*/ (
    requestData: ApiCommodityCommonCommodityAddressList_1711333769780Request,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityCommonCommodityAddressList_1711333769780Response>(
      prepare(
        apiCommodityCommonCommodityAddressList_1711333769780RequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityCommonCommodityAddressList_1711333769780.requestConfig =
  apiCommodityCommonCommodityAddressList_1711333769780RequestConfig

const mockUrl_0_4_0_22 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_22 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_22 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_22 = 'data' as any

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118234) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfo`
 */
export interface ApiCommodityCommodityBaseInfoRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118234) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfo`
 */
export interface ApiCommodityCommodityBaseInfoResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 商品自动下架日期
   */
  autoDownDate?: string
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 校验资格接口地址
   */
  businessCheckUrl?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 是否校验购买资格：0-否 1-是
   */
  checkBuyFlag?: 0 | 1
  /**
   * 商品种类：0-套餐券 1-代金券 2-堆售兑换券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 配送地址
   */
  deliveryAddress?: string
  /**
   * 配送地址类型：0-黑名单 1-白名单
   */
  deliveryAddressType?: 0 | 1
  deliveryCommodity: {
    /**
     * 封面标签
     */
    coverLabel?: string
    /**
     * 是否支持售后：0-否 1-是
     */
    isAfterSales?: 0 | 1
    multipleSku?: boolean
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * SKU唯一参数标识
       */
      skuId: string
    }[]
    /**
     * 包装费用
     */
    wrapPrice?: number
  }
  /**
   * 使用渠道多选：0-TV 1-移动端
   */
  distributeChannel?: number[]
  /**
   * 特征标签
   */
  featureLabel?: {
    /**
     * 标签CODE
     */
    code?: string
    /**
     * 标签名称
     */
    label?: string
  }[]
  /**
   * 是否支持售后：0-否 1-是
   */
  isAfterSales?: 0 | 1
  /**
   * 是否推荐商品： 0-否 1-是
   */
  isRecommend: 0 | 1
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 核销类组合商品信息
   */
  jointChildWriteOffCommodityList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品邮费价格
     */
    childPostPrice?: number
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单次核销价格
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  jointStandardCommodity: {
    /**
     * 包邮类型  1-包邮 2-运费模板
     */
    postType: 0 | 1 | 2
    /**
     * 是佛提供发票：0-不提供 1-提供
     */
    provideInvoiceFlag: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType: 0 | 1 | 2
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
     */
    zoneLimitType: 0 | 1 | 2
  }
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 不配送地址
   */
  noDeliveryAddress?: string
  /**
   * 包邮类型: 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 预览路由
   */
  previewUrl?: string
  /**
   * 最低价(2.0之后用lowestPrice代替)
   */
  price?: number
  /**
   * 供应商绑定商品ID
   */
  provideCommodityId?: string
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 供应商 0=多彩宝 1=京东
   */
  provideSource?: number
  /**
   * 购买须知信息
   */
  purchaseNotesDetail: string
  /**
   * 购买须知ID
   */
  purchaseNotesId?: string
  /**
   * 实名制类型 0-自动回填 1-手动填写
   */
  realNameInputType: number
  /**
   * 是否实名制购买：0-否 1-是
   */
  realNamePurchase?: '0' | '1'
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  ruleDetailLink?: {
    /**
     * 实名部分的规则详情链接
     */
    moreDetailLink?: string
    /**
     * 需要确认的规则详情链接
     */
    needSureLink?: string
  }
  /**
   * 售后服务: 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 自提地址id列表
   */
  selfPickupAddressId?: string[]
  /**
   * 是否支持自提：0-否 1-是
   */
  selfPickupStatus?: number
  /**
   * 价格区间
   */
  sellPrices?: number[]
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 标电，虚拟商品规格详情
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
  /**
   * 标销商品规格详情
   */
  skuListWriteOff?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 库存
     */
    commodityStock: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: number
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: number
    /**
     * 规格名称
     */
    specName: string
    /**
     * 规格值
     */
    specValue: string
    /**
     * 库存日期
     */
    stockDate: string
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存预警
   */
  stockAlertCount?: number
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段库存
   */
  stockType: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 核销提货类型
   */
  takeDeliveryType?: '1' | '2'
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  travelCommodity: {
    /**
     * 仅当isValidDay=0有效，需要提前x天预约购买
     */
    advanceDay?: number
    /**
     * 商品种类：0-套餐券
     */
    commodityClassifyType?: '0' | '1' | '2'
    /**
     * 结束标题
     */
    endTitle?: string
    /**
     * 是否实名：0-否 1-是
     */
    isAuth: 0 | 1
    /**
     * 可选日期区间：0-否 1-是
     */
    isDateInterval: 0 | 1
    /**
     * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
     */
    isIncludeLastDay?: 0 | 1
    /**
     * 是否当日有效：0-否 1-是
     */
    isValidDay?: 0 | 1
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 初始库存
       */
      initStock: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存日期
       */
      stockDate?: string
      /**
       * 库存ID:第三方下单需要，非第三方和skuId一致
       */
      stockId: string
      /**
       * 剩余库存
       */
      surplusStock: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * 开始标题
     */
    startTitle?: string
    /**
     * 库存类型： 0-标准库存 3-日期库存 5-时段库存
     */
    stockType: number
    /**
     * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
     */
    writeOffChannel:
      | '0'
      | '1'
      | '2'
      | '3'
      | '4'
      | '5'
      | '6'
      | '7'
      | '8'
      | '9'
      | '10'
      | '11'
      | '12'
      | '13'
    /**
     * 核销渠道商品ID
     */
    writeOffChannelCommodityId: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  }
  /**
   * TV轮播图
   */
  tvCarousePic?: string[]
  /**
   * TV封面图
   */
  tvCoverPic?: string
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 虚拟商品类型：0-普通虚拟商品 1-兑换虚拟商品
   */
  virtualCommodityType: 0 | 1
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  /**
   * 购买xxx天内有效
   */
  writeOffValidDay?: number
  /**
   * 核销有效期结束时间
   */
  writeOffValidEndTime?: string
  /**
   * 核销有效期开始时间
   */
  writeOffValidStartTime?: string
  /**
   * 核销有效期类型：0-相对时间 1-固定时间
   */
  writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  zoneLimit?: {
    /**
     * 邮费结算价
     */
    postFeeCost?: number
    /**
     * 配送区域
     */
    zones?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 省份名称
       */
      cityName?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 区县名称
       */
      districtName?: string
      /**
       * 省份编码
       */
      provinceCode?: string
      /**
       * 省份名称
       */
      provinceName?: string
    }[]
  }
  /**
   * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
   */
  zoneLimitType?: '0' | '1' | '2'
  /**
   * 优惠描述
   */
  discountDescList?: string[]
  /**
   * 优惠后价格
   */
  discountAfterAmt?: number
  /**
   * 优惠前价格
   */
  discountBeforeAmt?: number
}

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118234) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfo`
 */
type ApiCommodityCommodityBaseInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/baseInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118234) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfo`
 */
const apiCommodityCommodityBaseInfoRequestConfig: ApiCommodityCommodityBaseInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/baseInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityBaseInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品基本信息', author: '张彬' },
  }

/**
 * 接口 [查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118234) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfo`
 */
export const apiCommodityCommodityBaseInfo = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityBaseInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityBaseInfoResponse>(
    prepare(apiCommodityCommodityBaseInfoRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityBaseInfo.requestConfig =
  apiCommodityCommodityBaseInfoRequestConfig

/**
 * 接口 [批量查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118240) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfoList`
 */
export interface ApiCommodityCommodityBaseInfoListRequest {
  /**
   * 商品ID集合
   */
  commodityId: string[]
}

/**
 * 接口 [批量查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118240) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfoList`
 */
export type ApiCommodityCommodityBaseInfoListResponse = {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 商品自动下架日期
   */
  autoDownDate?: string
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 校验资格接口地址
   */
  businessCheckUrl?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 是否校验购买资格：0-否 1-是
   */
  checkBuyFlag?: 0 | 1
  /**
   * 商品种类：0-套餐券 1-代金券 2-堆售兑换券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 配送地址
   */
  deliveryAddress?: string
  /**
   * 配送地址类型：0-黑名单 1-白名单
   */
  deliveryAddressType?: 0 | 1
  deliveryCommodity: {
    /**
     * 封面标签
     */
    coverLabel?: string
    /**
     * 是否支持售后：0-否 1-是
     */
    isAfterSales?: 0 | 1
    multipleSku?: boolean
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * SKU唯一参数标识
       */
      skuId: string
    }[]
    /**
     * 包装费用
     */
    wrapPrice?: number
  }
  /**
   * 使用渠道多选：0-TV 1-移动端
   */
  distributeChannel?: number[]
  /**
   * 特征标签
   */
  featureLabel?: {
    /**
     * 标签CODE
     */
    code?: string
    /**
     * 标签名称
     */
    label?: string
  }[]
  /**
   * 是否支持售后：0-否 1-是
   */
  isAfterSales?: 0 | 1
  /**
   * 是否推荐商品： 0-否 1-是
   */
  isRecommend: 0 | 1
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 核销类组合商品信息
   */
  jointChildWriteOffCommodityList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品邮费价格
     */
    childPostPrice?: number
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单次核销价格
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  jointStandardCommodity: {
    /**
     * 包邮类型  1-包邮 2-运费模板
     */
    postType: 0 | 1 | 2
    /**
     * 是佛提供发票：0-不提供 1-提供
     */
    provideInvoiceFlag: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType: 0 | 1 | 2
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
     */
    zoneLimitType: 0 | 1 | 2
  }
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 不配送地址
   */
  noDeliveryAddress?: string
  /**
   * 包邮类型: 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 预览路由
   */
  previewUrl?: string
  /**
   * 最低价(2.0之后用lowestPrice代替)
   */
  price?: number
  /**
   * 供应商绑定商品ID
   */
  provideCommodityId?: string
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 供应商 0=多彩宝 1=京东
   */
  provideSource?: number
  /**
   * 购买须知信息
   */
  purchaseNotesDetail: string
  /**
   * 购买须知ID
   */
  purchaseNotesId?: string
  /**
   * 实名制类型 0-自动回填 1-手动填写
   */
  realNameInputType: number
  /**
   * 是否实名制购买：0-否 1-是
   */
  realNamePurchase?: '0' | '1'
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  ruleDetailLink?: {
    /**
     * 实名部分的规则详情链接
     */
    moreDetailLink?: string
    /**
     * 需要确认的规则详情链接
     */
    needSureLink?: string
  }
  /**
   * 售后服务: 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 自提地址id列表
   */
  selfPickupAddressId?: string[]
  /**
   * 是否支持自提：0-否 1-是
   */
  selfPickupStatus?: number
  /**
   * 价格区间
   */
  sellPrices?: number[]
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 标电，虚拟商品规格详情
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
  /**
   * 标销商品规格详情
   */
  skuListWriteOff?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 库存
     */
    commodityStock: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: number
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: number
    /**
     * 规格名称
     */
    specName: string
    /**
     * 规格值
     */
    specValue: string
    /**
     * 库存日期
     */
    stockDate: string
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存预警
   */
  stockAlertCount?: number
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段库存
   */
  stockType: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 核销提货类型
   */
  takeDeliveryType?: '1' | '2'
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  travelCommodity: {
    /**
     * 仅当isValidDay=0有效，需要提前x天预约购买
     */
    advanceDay?: number
    /**
     * 商品种类：0-套餐券
     */
    commodityClassifyType?: '0' | '1' | '2'
    /**
     * 结束标题
     */
    endTitle?: string
    /**
     * 是否实名：0-否 1-是
     */
    isAuth: 0 | 1
    /**
     * 可选日期区间：0-否 1-是
     */
    isDateInterval: 0 | 1
    /**
     * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
     */
    isIncludeLastDay?: 0 | 1
    /**
     * 是否当日有效：0-否 1-是
     */
    isValidDay?: 0 | 1
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 初始库存
       */
      initStock: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存日期
       */
      stockDate?: string
      /**
       * 库存ID:第三方下单需要，非第三方和skuId一致
       */
      stockId: string
      /**
       * 剩余库存
       */
      surplusStock: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * 开始标题
     */
    startTitle?: string
    /**
     * 库存类型： 0-标准库存 3-日期库存 5-时段库存
     */
    stockType: number
    /**
     * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
     */
    writeOffChannel:
      | '0'
      | '1'
      | '2'
      | '3'
      | '4'
      | '5'
      | '6'
      | '7'
      | '8'
      | '9'
      | '10'
      | '11'
      | '12'
      | '13'
    /**
     * 核销渠道商品ID
     */
    writeOffChannelCommodityId: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  }
  /**
   * TV轮播图
   */
  tvCarousePic?: string[]
  /**
   * TV封面图
   */
  tvCoverPic?: string
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 虚拟商品类型：0-普通虚拟商品 1-兑换虚拟商品
   */
  virtualCommodityType: 0 | 1
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  /**
   * 购买xxx天内有效
   */
  writeOffValidDay?: number
  /**
   * 核销有效期结束时间
   */
  writeOffValidEndTime?: string
  /**
   * 核销有效期开始时间
   */
  writeOffValidStartTime?: string
  /**
   * 核销有效期类型：0-相对时间 1-固定时间
   */
  writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  zoneLimit?: {
    /**
     * 邮费结算价
     */
    postFeeCost?: number
    /**
     * 配送区域
     */
    zones?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 省份名称
       */
      cityName?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 区县名称
       */
      districtName?: string
      /**
       * 省份编码
       */
      provinceCode?: string
      /**
       * 省份名称
       */
      provinceName?: string
    }[]
  }
  /**
   * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
   */
  zoneLimitType?: '0' | '1' | '2'
  /**
   * 优惠描述
   */
  discountDescList?: string[]
  /**
   * 优惠后价格
   */
  discountAfterAmt?: number
  /**
   * 优惠前价格
   */
  discountBeforeAmt?: number
}[]

/**
 * 接口 [批量查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118240) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfoList`
 */
type ApiCommodityCommodityBaseInfoListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/baseInfoList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118240) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfoList`
 */
const apiCommodityCommodityBaseInfoListRequestConfig: ApiCommodityCommodityBaseInfoListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/baseInfoList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityBaseInfoList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量查询商品基本信息', author: '张彬' },
  }

/**
 * 接口 [批量查询商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/118240) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/baseInfoList`
 */
export const apiCommodityCommodityBaseInfoList = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityBaseInfoListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityBaseInfoListResponse>(
    prepare(apiCommodityCommodityBaseInfoListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityBaseInfoList.requestConfig =
  apiCommodityCommodityBaseInfoListRequestConfig

/**
 * 接口 [V4批量获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118246) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/batchRewardBySku`
 */
export interface ApiCommodityCommodityBatchRewardBySkuRequest {
  /**
   * SKU集合
   */
  skuList?: {
    /**
     * sku单价
     */
    salePrice: number
    /**
     * 所属业务类型
     */
    serviceType: string
    /**
     * sku数量
     */
    skuAmount: number
    /**
     * skuId
     */
    skuId: string
    /**
     * 所属商户
     */
    unitOrgCode: string
  }[]
}

/**
 * 接口 [V4批量获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118246) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/batchRewardBySku`
 */
export type ApiCommodityCommodityBatchRewardBySkuResponse = {
  /**
   * 奖励统计
   */
  rewardList?: {
    /**
     * 奖励数量
     */
    rewardAmount?: number
    /**
     * 奖励名称
     */
    rewardName?: string
    /**
     * 奖励类型:0-成长值 1-黔贝 2-优惠券
     */
    rewardType?: number
  }[]
  /**
   * skuId
   */
  skuId?: string
}[]

/**
 * 接口 [V4批量获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118246) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/batchRewardBySku`
 */
type ApiCommodityCommodityBatchRewardBySkuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/batchRewardBySku',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [V4批量获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118246) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/batchRewardBySku`
 */
const apiCommodityCommodityBatchRewardBySkuRequestConfig: ApiCommodityCommodityBatchRewardBySkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/batchRewardBySku',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityBatchRewardBySku',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'V4批量获取下单商品可获得奖励', author: '张彬' },
  }

/**
 * 接口 [V4批量获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118246) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/batchRewardBySku`
 */
export const apiCommodityCommodityBatchRewardBySku = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityBatchRewardBySkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityBatchRewardBySkuResponse>(
    prepare(apiCommodityCommodityBatchRewardBySkuRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityBatchRewardBySku.requestConfig =
  apiCommodityCommodityBatchRewardBySkuRequestConfig

/**
 * 接口 [清空用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118252) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/delUserFootprint`
 */
export interface ApiCommodityCommodityDelUserFootprintRequest {
  /**
   * 商品ID(为空全部清空)
   */
  commodityIds?: string[]
}

/**
 * 接口 [清空用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118252) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/delUserFootprint`
 */
export interface ApiCommodityCommodityDelUserFootprintResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [清空用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118252) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/delUserFootprint`
 */
type ApiCommodityCommodityDelUserFootprintRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/delUserFootprint',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [清空用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118252) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/delUserFootprint`
 */
const apiCommodityCommodityDelUserFootprintRequestConfig: ApiCommodityCommodityDelUserFootprintRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/delUserFootprint',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityDelUserFootprint',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '清空用户足迹', author: '张彬' },
  }

/**
 * 接口 [清空用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118252) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/delUserFootprint`
 */
export const apiCommodityCommodityDelUserFootprint = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityDelUserFootprintRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityDelUserFootprintResponse>(
    prepare(apiCommodityCommodityDelUserFootprintRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityDelUserFootprint.requestConfig =
  apiCommodityCommodityDelUserFootprintRequestConfig

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118258) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/detail`
 */
export interface ApiCommodityCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118258) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/detail`
 */
export interface ApiCommodityCommodityDetailResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 商品自动下架日期
   */
  autoDownDate?: string
  /**
   * 起售数量
   */
  beginSaleQuantity?: number
  /**
   * 商品是否品牌升级：0-否 1-是
   */
  brandStatus: number
  /**
   * 校验资格接口地址
   */
  businessCheckUrl?: string
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 类目名称
   */
  categoryName?: string
  /**
   * 是否校验购买资格：0-否 1-是
   */
  checkBuyFlag?: 0 | 1
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 商品种类：0-套餐券 1-代金券 2-堆售兑换券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品合同标题
   */
  commodityContractTitle?: string
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品参数json
   */
  commodityParams?: {
    /**
     * 类目参数ID
     */
    categoryParamsId?: string
    /**
     * 类目参数名称
     */
    categoryParamsName?: string
    /**
     * 类目参数值
     */
    categoryParamsValue?: string
    /**
     * 组件类型 0-文本框 1-下拉框
     */
    componentType?: number
    /**
     * 类目参数键值数组
     */
    options?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 是否新搜索页展示 0：不展示  1：展示
     */
    pageShowFlag?: number
    /**
     * 是否必输 0-否 1-是
     */
    requiredFlag?: number
    /**
     * 选中类目参数键值数组
     */
    selected?: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
  }[]
  /**
   * 商品来源：0-多彩宝 1-跨境电商
   */
  commodityResource?: '0' | '1'
  /**
   * 商品规格
   */
  commoditySpecs?: {
    /**
     * sku属性名称
     */
    attributeName: string
    /**
     * 属性下拉参数
     */
    options: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * 选中下拉参数
     */
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }[]
    /**
     * sku属性ID
     */
    skuAttributeId: string
  }[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 商品交易类型: 0-中台下单 1-业务下单(2.1.0弃用)
   */
  commodityTradeType?: number
  /**
   * 商品类型：0-标准电商 1-派单核销 2-标准虚拟
   */
  commodityType?: number
  /**
   * 优惠券列表
   */
  couponList?: string[]
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 配送地址
   */
  deliveryAddress?: string
  /**
   * 配送地址类型：0-黑名单 1-白名单
   */
  deliveryAddressType?: 0 | 1
  deliveryCommodity: {
    /**
     * 封面标签
     */
    coverLabel?: string
    /**
     * 是否支持售后：0-否 1-是
     */
    isAfterSales?: 0 | 1
    multipleSku?: boolean
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * SKU唯一参数标识
       */
      skuId: string
    }[]
    /**
     * 包装费用
     */
    wrapPrice?: number
  }
  /**
   * 使用渠道多选：0-TV 1-移动端
   */
  distributeChannel?: number[]
  /**
   * 特征标签
   */
  featureLabel?: {
    /**
     * 标签CODE
     */
    code?: string
    /**
     * 标签名称
     */
    label?: string
  }[]
  /**
   * 是否支持售后：0-否 1-是
   */
  isAfterSales?: 0 | 1
  /**
   * 是否推荐商品： 0-否 1-是
   */
  isRecommend: 0 | 1
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 核销类组合商品信息
   */
  jointChildWriteOffCommodityList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品邮费价格
     */
    childPostPrice?: number
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单次核销价格
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  jointStandardCommodity: {
    /**
     * 包邮类型  1-包邮 2-运费模板
     */
    postType: 0 | 1 | 2
    /**
     * 是佛提供发票：0-不提供 1-提供
     */
    provideInvoiceFlag: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 发货类型 0-快递发货 1-同城配送 2-到店自提
     */
    shippingType: 0 | 1 | 2
    zoneLimit?: {
      /**
       * 邮费结算价
       */
      postFeeCost?: number
      /**
       * 配送区域
       */
      zones?: {
        /**
         * 市级编码
         */
        cityCode?: string
        /**
         * 省份名称
         */
        cityName?: string
        /**
         * 区级编码
         */
        districtCode?: string
        /**
         * 区县名称
         */
        districtName?: string
        /**
         * 省份编码
         */
        provinceCode?: string
        /**
         * 省份名称
         */
        provinceName?: string
      }[]
    }
    /**
     * 配送范围类型: 0-偏远地区除外 1-全国 2-自定义
     */
    zoneLimitType: 0 | 1 | 2
  }
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 所属商城ID
   */
  martId?: string
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 不配送地址
   */
  noDeliveryAddress?: string
  /**
   * 是否不显示购物车
   */
  noShowCart?: boolean
  /**
   * 是否不显示库存
   */
  noShowStock?: boolean
  /**
   * 包邮类型: 1-包邮 2-运费模板
   */
  postType?: number
  /**
   * 预览状态
   */
  previewStatus?: number
  /**
   * 预览路由
   */
  previewUrl?: string
  /**
   * 最低价(2.0之后用lowestPrice代替)
   */
  price?: number
  /**
   * 供应商绑定商品ID
   */
  provideCommodityId?: string
  /**
   * 是否提供发票
   */
  provideInvoiceFlag?: number
  /**
   * 供应商 0=多彩宝 1=京东
   */
  provideSource?: number
  /**
   * 购买须知信息
   */
  purchaseNotesDetail: string
  /**
   * 购买须知ID
   */
  purchaseNotesId?: string
  /**
   * 实名制类型 0-自动回填 1-手动填写
   */
  realNameInputType: number
  /**
   * 是否实名制购买：0-否 1-是
   */
  realNamePurchase?: '0' | '1'
  /**
   * 类目ID
   */
  refCategoryId?: string
  /**
   * 运费模板ID
   */
  refDeliverTemplateId?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  ruleDetailLink?: {
    /**
     * 实名部分的规则详情链接
     */
    moreDetailLink?: string
    /**
     * 需要确认的规则详情链接
     */
    needSureLink?: string
  }
  /**
   * 售后服务: 1-换货  2-仅退款 3-退货退款
   */
  saleAfterServiceType?: number[]
  saleAfterServiceTypeSwitch?: {
    /**
     * 是否关闭换货申请 0-否 1-是
     */
    exchangeCloseFlag?: number
    /**
     * 是否关闭退货退款申请 0-否 1-是
     */
    refundAndReturnCloseFlag?: number
    /**
     * 是否关闭仅退款申请 0-否 1-是
     */
    refundOnlyCloseFlag?: number
  }
  /**
   * 销量
   */
  sales?: number
  /**
   * 搜索词
   */
  searchWord?: string[]
  /**
   * 自提地址id列表
   */
  selfPickupAddressId?: string[]
  /**
   * 是否支持自提：0-否 1-是
   */
  selfPickupStatus?: number
  /**
   * 推荐渠道Id
   */
  sellChannelId?: string
  /**
   * 价格区间
   */
  sellPrices?: number[]
  /**
   * 服务保障
   */
  serviceSafeguard?: {
    /**
     * 内容
     */
    content: string
    /**
     * 名称
     */
    name: string
    /**
     * 备注
     */
    remark: string
  }[]
  /**
   * 发货地址
   */
  shipAddress?: string
  /**
   * 发货类型 0-快递发货 1-同城配送 2-到店自提
   */
  shippingType?: number
  /**
   * 是否显示同店好货
   */
  showRecommend?: boolean
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 发货/服务（小时内）时间
   */
  sippingOrServiceTime?: number
  /**
   * 标电，虚拟商品规格详情
   */
  skuList?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 商品来源sku编号
     */
    commodityResourceSkuId?: string
    /**
     * 成本价
     */
    commoditySkuCost: number
    /**
     * SKU价格
     */
    commoditySkuPrice: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 商品单日限购量（0不限制）
     */
    singleDayLimitPurchases: number
    /**
     * SKU唯一参数标识
     */
    skuId: string
    /**
     * SKU商品图
     */
    skuPic: string
    /**
     * sku规格
     */
    skuSpecs: {
      /**
       * sku属性名称
       */
      attributeName?: string
      selected: {
        /**
         * 参数ID
         */
        id: string
        /**
         * 参数键(2.0废弃)
         */
        key?: string
        /**
         * 参数值
         */
        value: string
      }
      /**
       * sku属性ID
       */
      skuAttributeId?: string
    }[]
    /**
     * SKU状态:0-无效 1-有效
     */
    skuStatus: number
    /**
     * 用户单日限购量（0不限制）
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases?: number
    /**
     * 重量(千克)
     */
    weight: number
  }[]
  /**
   * 标销商品规格详情
   */
  skuListWriteOff?: {
    /**
     * 13位69码
     */
    barCode?: string
    /**
     * 库存
     */
    commodityStock: number
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    /**
     * sku能效级别
     */
    efficiencyLevel?: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: number
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: number
    /**
     * 规格名称
     */
    specName: string
    /**
     * 规格值
     */
    specValue: string
    /**
     * 库存日期
     */
    stockDate: string
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存预警
   */
  stockAlertCount?: number
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段库存
   */
  stockType: number
  /**
   * 商家资质
   */
  storeQualification?: string[]
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 核销提货类型
   */
  takeDeliveryType?: '1' | '2'
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  travelCommodity: {
    /**
     * 仅当isValidDay=0有效，需要提前x天预约购买
     */
    advanceDay?: number
    /**
     * 商品种类：0-套餐券
     */
    commodityClassifyType?: '0' | '1' | '2'
    /**
     * 结束标题
     */
    endTitle?: string
    /**
     * 是否实名：0-否 1-是
     */
    isAuth: 0 | 1
    /**
     * 可选日期区间：0-否 1-是
     */
    isDateInterval: 0 | 1
    /**
     * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
     */
    isIncludeLastDay?: 0 | 1
    /**
     * 是否当日有效：0-否 1-是
     */
    isValidDay?: 0 | 1
    /**
     * 购买须知信息
     */
    purchaseNotesDetail: string
    /**
     * 规格列表
     */
    skuList?: {
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      endTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 初始库存
       */
      initStock: number
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      startTime?: {
        hour?: number
        minute?: number
        nano?: number
        second?: number
      }
      /**
       * 库存日期
       */
      stockDate?: string
      /**
       * 库存ID:第三方下单需要，非第三方和skuId一致
       */
      stockId: string
      /**
       * 剩余库存
       */
      surplusStock: number
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
    /**
     * 开始标题
     */
    startTitle?: string
    /**
     * 库存类型： 0-标准库存 3-日期库存 5-时段库存
     */
    stockType: number
    /**
     * 核销渠道：0-多彩宝 1-智游宝 2-天使同城 3-镇远九洲
     */
    writeOffChannel:
      | '0'
      | '1'
      | '2'
      | '3'
      | '4'
      | '5'
      | '6'
      | '7'
      | '8'
      | '9'
      | '10'
      | '11'
      | '12'
      | '13'
    /**
     * 核销渠道商品ID
     */
    writeOffChannelCommodityId: string
    /**
     * 套餐详情
     */
    writeOffCombos?: {
      /**
       * 分组详情列表
       */
      groupDetails?: {
        /**
         * 数量
         */
        num?: number
        /**
         * 价格
         */
        price?: number
        /**
         * 服务名称
         */
        serviceName?: string
      }[]
      /**
       * 分组名称
       */
      groupName?: string
    }[]
    writeOffRefund?: {
      /**
       * 过期后退款比例
       */
      expireRate?: number
      /**
       * 退款无需审批
       */
      notApproveFlag?: boolean
      /**
       * 未使用退款比例
       */
      unusedRate?: number
    }
    /**
     * 购买xxx天内有效
     */
    writeOffValidDay?: number
    /**
     * 核销有效期结束时间
     */
    writeOffValidEndTime?: string
    /**
     * 核销有效期开始时间
     */
    writeOffValidStartTime?: string
    /**
     * 核销有效期类型：0-相对时间 1-固定时间
     */
    writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  }
  /**
   * TV轮播图
   */
  tvCarousePic?: string[]
  /**
   * TV商品详情
   */
  tvCommodityDetail: string
  /**
   * TV封面图
   */
  tvCoverPic?: string
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 上下架状态 0-待上架 1-上架 2-下架
   */
  upDownShelfStatus?: number
  /**
   * 上架时间
   */
  upShelfTime?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 虚拟商品类型：0-普通虚拟商品 1-兑换虚拟商品
   */
  virtualCommodityType: 0 | 1
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  /**
   * 购买xxx天内有效
   */
  writeOffValidDay?: number
  /**
   * 核销有效期结束时间
   */
  writeOffValidEndTime?: string
  /**
   * 核销有效期开始时间
   */
  writeOffValidStartTime?: string
  /**
   * 核销有效期类型：0-相对时间 1-固定时间
   */
  writeOffValidType?: '0' | '1' | '2' | '3' | '4'
  zoneLimit?: {
    /**
     * 邮费结算价
     */
    postFeeCost?: number
    /**
     * 配送区域
     */
    zones?: {
      /**
       * 市级编码
       */
      cityCode?: string
      /**
       * 省份名称
       */
      cityName?: string
      /**
       * 区级编码
       */
      districtCode?: string
      /**
       * 区县名称
       */
      districtName?: string
      /**
       * 省份编码
       */
      provinceCode?: string
      /**
       * 省份名称
       */
      provinceName?: string
    }[]
  }
  /**
   * 配送范围类型：0-不支持偏远地区 1-全国 2-自定义
   */
  zoneLimitType?: '0' | '1' | '2'
  /**
   * 优惠描述
   */
  discountDescList?: string[]
  /**
   * 优惠后价格
   */
  discountAfterAmt?: number
  /**
   * 优惠前价格
   */
  discountBeforeAmt?: number
  /**
   * 最低级别类目名称
   */
  simpleCategoryName?: string
}

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118258) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/detail`
 */
type ApiCommodityCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118258) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/detail`
 */
const apiCommodityCommodityDetailRequestConfig: ApiCommodityCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商品详情信息', author: '张彬' },
  }

/**
 * 接口 [商品详情信息↗](https://yapi.gogpay.cn/project/939/interface/api/118258) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/detail`
 */
export const apiCommodityCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityDetailResponse>(
    prepare(apiCommodityCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityDetail.requestConfig =
  apiCommodityCommodityDetailRequestConfig

/**
 * 接口 [V4获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118264) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/findRewardBySku`
 */
export interface ApiCommodityCommodityFindRewardBySkuRequest {
  /**
   * sku单价
   */
  salePrice: number
  /**
   * 所属业务类型
   */
  serviceType: string
  /**
   * sku数量
   */
  skuAmount: number
  /**
   * skuId
   */
  skuId: string
  /**
   * 所属商户
   */
  unitOrgCode: string
}

/**
 * 接口 [V4获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118264) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/findRewardBySku`
 */
export interface ApiCommodityCommodityFindRewardBySkuResponse {
  /**
   * 奖励统计
   */
  rewardList?: {
    /**
     * 奖励数量
     */
    rewardAmount?: number
    /**
     * 奖励名称
     */
    rewardName?: string
    /**
     * 奖励类型:0-成长值 1-黔贝 2-优惠券
     */
    rewardType?: number
  }[]
  /**
   * skuId
   */
  skuId?: string
}

/**
 * 接口 [V4获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118264) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/findRewardBySku`
 */
type ApiCommodityCommodityFindRewardBySkuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/findRewardBySku',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [V4获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118264) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/findRewardBySku`
 */
const apiCommodityCommodityFindRewardBySkuRequestConfig: ApiCommodityCommodityFindRewardBySkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/findRewardBySku',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityFindRewardBySku',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'V4获取下单商品可获得奖励', author: '张彬' },
  }

/**
 * 接口 [V4获取下单商品可获得奖励↗](https://yapi.gogpay.cn/project/939/interface/api/118264) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/findRewardBySku`
 */
export const apiCommodityCommodityFindRewardBySku = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityFindRewardBySkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityFindRewardBySkuResponse>(
    prepare(apiCommodityCommodityFindRewardBySkuRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityFindRewardBySku.requestConfig =
  apiCommodityCommodityFindRewardBySkuRequestConfig

/**
 * 接口 [V4获取商品是否支持黔币兑换↗](https://yapi.gogpay.cn/project/939/interface/api/118270) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getIntegralInfo`
 */
export interface ApiCommodityCommodityGetIntegralInfoRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [V4获取商品是否支持黔币兑换↗](https://yapi.gogpay.cn/project/939/interface/api/118270) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getIntegralInfo`
 */
export interface ApiCommodityCommodityGetIntegralInfoResponse {
  /**
   * 是否属于黔贝商品，如果不是，下面所有参数都为空 0不属于 1属于
   */
  belongToPoint?: number
  /**
   * 黔贝商品Id
   */
  commodityId?: string
  /**
   * 等级限制 0不限制
   */
  levelLimit?: number
  /**
   * 等级限制文案 如D1、D2
   */
  levelLimitText?: string
  /**
   * 积分限制
   */
  pointLimit?: number
  /**
   * 积分类型文案，如 黔贝
   */
  pointText?: string
  /**
   * 商品资源Id
   */
  resourceId?: string
}

/**
 * 接口 [V4获取商品是否支持黔币兑换↗](https://yapi.gogpay.cn/project/939/interface/api/118270) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getIntegralInfo`
 */
type ApiCommodityCommodityGetIntegralInfoRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/getIntegralInfo',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [V4获取商品是否支持黔币兑换↗](https://yapi.gogpay.cn/project/939/interface/api/118270) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getIntegralInfo`
 */
const apiCommodityCommodityGetIntegralInfoRequestConfig: ApiCommodityCommodityGetIntegralInfoRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/getIntegralInfo',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGetIntegralInfo',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'V4获取商品是否支持黔币兑换', author: '张彬' },
  }

/**
 * 接口 [V4获取商品是否支持黔币兑换↗](https://yapi.gogpay.cn/project/939/interface/api/118270) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getIntegralInfo`
 */
export const apiCommodityCommodityGetIntegralInfo = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGetIntegralInfoRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGetIntegralInfoResponse>(
    prepare(apiCommodityCommodityGetIntegralInfoRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityGetIntegralInfo.requestConfig =
  apiCommodityCommodityGetIntegralInfoRequestConfig

/**
 * 接口 [获取商品商户信息↗](https://yapi.gogpay.cn/project/939/interface/api/118276) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getMerchantDetail`
 */
export interface ApiCommodityCommodityGetMerchantDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [获取商品商户信息↗](https://yapi.gogpay.cn/project/939/interface/api/118276) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getMerchantDetail`
 */
export interface ApiCommodityCommodityGetMerchantDetailResponse {
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 商户路由
   */
  merchantUrl?: string
  /**
   * 商户机构号
   */
  unitOrgCode?: string
}

/**
 * 接口 [获取商品商户信息↗](https://yapi.gogpay.cn/project/939/interface/api/118276) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getMerchantDetail`
 */
type ApiCommodityCommodityGetMerchantDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/getMerchantDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品商户信息↗](https://yapi.gogpay.cn/project/939/interface/api/118276) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getMerchantDetail`
 */
const apiCommodityCommodityGetMerchantDetailRequestConfig: ApiCommodityCommodityGetMerchantDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/getMerchantDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGetMerchantDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品商户信息', author: '张彬' },
  }

/**
 * 接口 [获取商品商户信息↗](https://yapi.gogpay.cn/project/939/interface/api/118276) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getMerchantDetail`
 */
export const apiCommodityCommodityGetMerchantDetail = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityGetMerchantDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGetMerchantDetailResponse>(
    prepare(apiCommodityCommodityGetMerchantDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityGetMerchantDetail.requestConfig =
  apiCommodityCommodityGetMerchantDetailRequestConfig

/**
 * 接口 [获取用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118282) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getUserFootprint`
 */
export interface ApiCommodityCommodityGetUserFootprintRequest {}

/**
 * 接口 [获取用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118282) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getUserFootprint`
 */
export type ApiCommodityCommodityGetUserFootprintResponse = {
  /**
   * 发生时间
   */
  createTime?: string
  /**
   * 足迹店铺
   */
  storeList?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }[]
}[]

/**
 * 接口 [获取用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118282) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getUserFootprint`
 */
type ApiCommodityCommodityGetUserFootprintRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/getUserFootprint',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118282) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getUserFootprint`
 */
const apiCommodityCommodityGetUserFootprintRequestConfig: ApiCommodityCommodityGetUserFootprintRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/getUserFootprint',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityGetUserFootprint',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取用户足迹', author: '张彬' },
  }

/**
 * 接口 [获取用户足迹↗](https://yapi.gogpay.cn/project/939/interface/api/118282) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/getUserFootprint`
 */
export const apiCommodityCommodityGetUserFootprint = /*#__PURE__*/ (
  requestData?: ApiCommodityCommodityGetUserFootprintRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityGetUserFootprintResponse>(
    prepare(apiCommodityCommodityGetUserFootprintRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityGetUserFootprint.requestConfig =
  apiCommodityCommodityGetUserFootprintRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118288) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/marketingDetail`
 */
export interface ApiCommodityCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118288) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/marketingDetail`
 */
export interface ApiCommodityCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 满减活动优惠
   */
  fullReductions?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  /**
   * 积分活动优惠
   */
  integrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 减去积分后的价格
     */
    discountPrice?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 所需积分（多彩豆）
     */
    integral?: number
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 当前库存
     */
    stock?: number
  }[]
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 折扣活动优惠
   */
  marketingDiscountCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 折扣比例
     */
    discountRatio?: number
    /**
     * 单笔优惠上限制
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118288) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/marketingDetail`
 */
type ApiCommodityCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118288) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/marketingDetail`
 */
const apiCommodityCommodityMarketingDetailRequestConfig: ApiCommodityCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '张彬' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/118288) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/marketingDetail`
 */
export const apiCommodityCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityMarketingDetailResponse>(
    prepare(apiCommodityCommodityMarketingDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityMarketingDetail.requestConfig =
  apiCommodityCommodityMarketingDetailRequestConfig

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/123244) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeDetail`
 */
export interface ApiCommodityCommodityStoreDetailRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/123244) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeDetail`
 */
export interface ApiCommodityCommodityStoreDetailResponse {
  /**
   * 满减券信息
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  store?: {
    /**
     * 是否仅显示核销店铺地址:0-否 1-是
     */
    onlyShowWriteOffStoreAddress?: boolean
    /**
     * 商家资质
     */
    storeQualification?: string[]
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺链接
     */
    storeUrl?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 营业时间
     */
    openPeriod?: string
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 营销标签
     */
    marketingTag?: string
    /**
     * 活动标签
     */
    activityTags?: string[]
    /**
     * 特点标签
     */
    featureTags?: string[]
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
    /**
     * 距离用户的距离（米）
     */
    distance: number
    /**
     * 店铺公告
     */
    storeNotice?: string
    /**
     * 店铺活动列表
     */
    storeActivityList?: {
      /**
       * 活动ID
       */
      id?: string
      /**
       * 活动图片地址
       */
      imgUrl?: string
      /**
       * 资源跳转地址
       */
      resourceUrl?: string
      /**
       * 资源ID
       */
      resourceId?: string
      /**
       * 资源名称
       */
      resourceName?: string
      /**
       * 排序值
       */
      sortIndex?: number
    }[]
  }
}

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/123244) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeDetail`
 */
type ApiCommodityCommodityStoreDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/storeDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/123244) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeDetail`
 */
const apiCommodityCommodityStoreDetailRequestConfig: ApiCommodityCommodityStoreDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/storeDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityStoreDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺详情', author: '张彬' },
  }

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/123244) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeDetail`
 */
export const apiCommodityCommodityStoreDetail = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityStoreDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityStoreDetailResponse>(
    prepare(apiCommodityCommodityStoreDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityStoreDetail.requestConfig =
  apiCommodityCommodityStoreDetailRequestConfig

/**
 * 接口 [同店好物↗](https://yapi.gogpay.cn/project/939/interface/api/276906) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeRecommend`
 */
export interface ApiCommodityCommodityStoreRecommendRequest {
  clientType?: '1' | '2' | '3' | '4'
  /**
   * 本商品ID
   */
  commodityId: string
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [同店好物↗](https://yapi.gogpay.cn/project/939/interface/api/276906) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeRecommend`
 */
export interface ApiCommodityCommodityStoreRecommendResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 原价
     */
    amt?: string
    /**
     * 类目ID
     */
    categoryId?: string
    /**
     * 嵌套资源位资源信息
     */
    childList?: unknown[]
    /**
     * 优惠价格
     */
    discountAmt?: string
    /**
     * 区划id
     */
    divisionId?: string
    /**
     * 区划名称
     */
    divisionName?: string
    /**
     * 扩展数据
     */
    extendData?: {}
    /**
     * 服务图标
     */
    icon?: string
    /**
     * 服务图标(高度)
     */
    iconHeight?: number
    /**
     * 服务图标(宽度)
     */
    iconWidth?: number
    /**
     * 资源ID
     */
    id: string
    /**
     * 专区id（商品专用）
     */
    regionId?: string
    /**
     * 自由字段键值对
     */
    remarkMap?: {}
    /**
     * 资源类型 01:商品 02:功能 03:专题 04:专区 05:广告 101:满减券 102：折扣优惠
     */
    resType?: string
    /**
     * 根类目ID
     */
    rootCategoryId?: string
    /**
     * 根类目名称
     */
    rootCategoryIdMsg?: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 资源位ID
     */
    stateId: string
    /**
     * 资源位名称
     */
    stateName?: string
    /**
     * 分发系统算法ID
     */
    strategyId?: string
    /**
     * 分发系统算法名称
     */
    strategyName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 标签数据
     */
    tags?: string[]
    /**
     * 路由
     */
    targetUrl?: string
    /**
     * 主标题
     */
    title?: string
    /**
     * 版本号
     */
    version?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [同店好物↗](https://yapi.gogpay.cn/project/939/interface/api/276906) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeRecommend`
 */
type ApiCommodityCommodityStoreRecommendRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/storeRecommend',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [同店好物↗](https://yapi.gogpay.cn/project/939/interface/api/276906) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeRecommend`
 */
const apiCommodityCommodityStoreRecommendRequestConfig: ApiCommodityCommodityStoreRecommendRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/storeRecommend',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityStoreRecommend',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '同店好物', author: '成龙' },
  }

/**
 * 接口 [同店好物↗](https://yapi.gogpay.cn/project/939/interface/api/276906) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/storeRecommend`
 */
export const apiCommodityCommodityStoreRecommend = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityStoreRecommendRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityStoreRecommendResponse>(
    prepare(apiCommodityCommodityStoreRecommendRequestConfig, requestData),
    ...args,
  )
}

apiCommodityCommodityStoreRecommend.requestConfig =
  apiCommodityCommodityStoreRecommendRequestConfig

/**
 * 接口 [产品分类展示↗](https://yapi.gogpay.cn/project/939/interface/api/481794) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/categoryCommodityList`
 */
export interface ApiCommodityCommodityCategoryCommodityListRequest {
  /**
   * 分类Id
   */
  categoryId?: string
  /**
   * 关键字
   */
  keyword?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 页面类型 0多彩宝 1京东
   */
  pageType?: number
  /**
   * 排序方式 0升序 1降序
   */
  sortOrderByType?: number
  /**
   * 排序类型 0综合 1销量 2价格
   */
  sortType?: number
}

/**
 * 接口 [产品分类展示↗](https://yapi.gogpay.cn/project/939/interface/api/481794) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/categoryCommodityList`
 */
export interface ApiCommodityCommodityCategoryCommodityListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品图片
     */
    commodityCoverPic?: string
    /**
     * 商品Id
     */
    commodityId?: string
    /**
     * 商品价格
     */
    commodityPrice?: number
    /**
     * 商品名称
     */
    commodityTitle?: string
    /**
     * 商品销量
     */
    saleCount?: number
    /**
     * 店铺名称
     */
    storeName?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [产品分类展示↗](https://yapi.gogpay.cn/project/939/interface/api/481794) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/categoryCommodityList`
 */
type ApiCommodityCommodityCategoryCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commodity/categoryCommodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [产品分类展示↗](https://yapi.gogpay.cn/project/939/interface/api/481794) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/categoryCommodityList`
 */
const apiCommodityCommodityCategoryCommodityListRequestConfig: ApiCommodityCommodityCategoryCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_22,
    devUrl: devUrl_0_4_0_22,
    prodUrl: prodUrl_0_4_0_22,
    path: '/commodity/api/commodity/categoryCommodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommodityCategoryCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '产品分类展示', author: '511号开发' },
  }

/**
 * 接口 [产品分类展示↗](https://yapi.gogpay.cn/project/939/interface/api/481794) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [前台-标准商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27826)
 * @请求头 `POST /commodity/api/commodity/categoryCommodityList`
 */
export const apiCommodityCommodityCategoryCommodityList = /*#__PURE__*/ (
  requestData: ApiCommodityCommodityCategoryCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommodityCategoryCommodityListResponse>(
    prepare(
      apiCommodityCommodityCategoryCommodityListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommodityCategoryCommodityList.requestConfig =
  apiCommodityCommodityCategoryCommodityListRequestConfig

const mockUrl_0_4_0_23 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_23 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_23 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_23 = 'data' as any

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118324) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detail`
 */
export interface ApiCommoditySkuStockDetailRequest {
  /**
   * 活动Id
   */
  activityId?: string
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * SKU业务唯一索引
   */
  skuId: string
}

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118324) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detail`
 */
export interface ApiCommoditySkuStockDetailResponse {
  /**
   * sku能效级别
   */
  barCode?: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 成本价
   */
  commoditySkuCost: number
  /**
   * SKU价格
   */
  commoditySkuPrice: number
  /**
   * sku库存-(2.0版本之后使用surplusStock代替)
   */
  commodityStock: number
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow?: number
  /**
   * sku能效级别
   */
  efficiencyLevel?: number
  /**
   * SKU主键
   */
  id: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 商品单日限购量（0不限制）
   */
  singleDayLimitPurchases: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * SKU状态:0-无效 1-有效
   */
  skuStatus: number
  /**
   * 库存预警值
   */
  stockAlertCount: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 用户单日限购量（0不限制）
   */
  userDayLimitPurchases: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 重量(千克)
   */
  weight: number
}

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118324) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detail`
 */
type ApiCommoditySkuStockDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/skuStock/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118324) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detail`
 */
const apiCommoditySkuStockDetailRequestConfig: ApiCommoditySkuStockDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_23,
    devUrl: devUrl_0_4_0_23,
    prodUrl: prodUrl_0_4_0_23,
    path: '/commodity/api/skuStock/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommoditySkuStockDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询SKU详情', author: '张彬' },
  }

/**
 * 接口 [查询SKU详情↗](https://yapi.gogpay.cn/project/939/interface/api/118324) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detail`
 */
export const apiCommoditySkuStockDetail = /*#__PURE__*/ (
  requestData: ApiCommoditySkuStockDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommoditySkuStockDetailResponse>(
    prepare(apiCommoditySkuStockDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommoditySkuStockDetail.requestConfig =
  apiCommoditySkuStockDetailRequestConfig

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118330) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detailByCommodity`
 */
export interface ApiCommoditySkuStockDetailByCommodityRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 省份代码
   */
  provinceCode: string
}

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118330) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detailByCommodity`
 */
export type ApiCommoditySkuStockDetailByCommodityResponse = {
  /**
   * sku能效级别
   */
  barCode?: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 成本价
   */
  commoditySkuCost: number
  /**
   * SKU价格
   */
  commoditySkuPrice: number
  /**
   * sku库存-(2.0版本之后使用surplusStock代替)
   */
  commodityStock: number
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow?: number
  /**
   * sku能效级别
   */
  efficiencyLevel?: number
  /**
   * SKU主键
   */
  id: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 商品单日限购量（0不限制）
   */
  singleDayLimitPurchases: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * SKU状态:0-无效 1-有效
   */
  skuStatus: number
  /**
   * 库存预警值
   */
  stockAlertCount: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 用户单日限购量（0不限制）
   */
  userDayLimitPurchases: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 重量(千克)
   */
  weight: number
}[]

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118330) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detailByCommodity`
 */
type ApiCommoditySkuStockDetailByCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/skuStock/detailByCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118330) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detailByCommodity`
 */
const apiCommoditySkuStockDetailByCommodityRequestConfig: ApiCommoditySkuStockDetailByCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_23,
    devUrl: devUrl_0_4_0_23,
    prodUrl: prodUrl_0_4_0_23,
    path: '/commodity/api/skuStock/detailByCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommoditySkuStockDetailByCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询商品SKU列表', author: '张彬' },
  }

/**
 * 接口 [查询商品SKU列表↗](https://yapi.gogpay.cn/project/939/interface/api/118330) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-标准库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27833)
 * @请求头 `POST /commodity/api/skuStock/detailByCommodity`
 */
export const apiCommoditySkuStockDetailByCommodity = /*#__PURE__*/ (
  requestData: ApiCommoditySkuStockDetailByCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommoditySkuStockDetailByCommodityResponse>(
    prepare(apiCommoditySkuStockDetailByCommodityRequestConfig, requestData),
    ...args,
  )
}

apiCommoditySkuStockDetailByCommodity.requestConfig =
  apiCommoditySkuStockDetailByCommodityRequestConfig

const mockUrl_0_4_0_24 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_24 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_24 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_24 = 'data' as any

/**
 * 接口 [核销商品库存信息↗](https://yapi.gogpay.cn/project/939/interface/api/118336) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffCommodityStock`
 */
export interface ApiCommoditySkuStockWriteOffCommodityStockRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 库存日期-(如果是日期库存传入获取当天库存信息)
   */
  stockDate?: string
}

/**
 * 接口 [核销商品库存信息↗](https://yapi.gogpay.cn/project/939/interface/api/118336) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffCommodityStock`
 */
export interface ApiCommoditySkuStockWriteOffCommodityStockResponse {
  /**
   * 是否售罄
   */
  soldOutFlag?: boolean
  /**
   * 库存列表
   */
  stockList?: {
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 库存日期
     */
    stockDate?: string
    /**
     * 剩余库存
     */
    surplus?: number
  }[]
  /**
   * 总库存
   */
  totalStock?: number
}

/**
 * 接口 [核销商品库存信息↗](https://yapi.gogpay.cn/project/939/interface/api/118336) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffCommodityStock`
 */
type ApiCommoditySkuStockWriteOffCommodityStockRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/skuStock/writeOffCommodityStock',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [核销商品库存信息↗](https://yapi.gogpay.cn/project/939/interface/api/118336) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffCommodityStock`
 */
const apiCommoditySkuStockWriteOffCommodityStockRequestConfig: ApiCommoditySkuStockWriteOffCommodityStockRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_24,
    devUrl: devUrl_0_4_0_24,
    prodUrl: prodUrl_0_4_0_24,
    path: '/commodity/api/skuStock/writeOffCommodityStock',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommoditySkuStockWriteOffCommodityStock',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '核销商品库存信息', author: '张彬' },
  }

/**
 * 接口 [核销商品库存信息↗](https://yapi.gogpay.cn/project/939/interface/api/118336) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffCommodityStock`
 */
export const apiCommoditySkuStockWriteOffCommodityStock = /*#__PURE__*/ (
  requestData: ApiCommoditySkuStockWriteOffCommodityStockRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommoditySkuStockWriteOffCommodityStockResponse>(
    prepare(
      apiCommoditySkuStockWriteOffCommodityStockRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommoditySkuStockWriteOffCommodityStock.requestConfig =
  apiCommoditySkuStockWriteOffCommodityStockRequestConfig

/**
 * 接口 [查询核销类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/153558) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffList`
 */
export interface ApiCommoditySkuStockWriteOffListRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 库存日期
   */
  stockDate?: string
}

/**
 * 接口 [查询核销类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/153558) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffList`
 */
export type ApiCommoditySkuStockWriteOffListResponse = {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * sku能效级别
   */
  efficiencyLevel?: number
  /**
   * 单次核销价格
   */
  onePrice?: number
  /**
   * 商品售价
   */
  sellPrice?: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType?: number
  /**
   * 结算值
   */
  settlementValue?: number
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 规格名称
   */
  skuName?: string
  /**
   * 规格状态： 0-无效 1-有效
   */
  skuStatus: 0 | 1
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存类型：0-标准库存 3-日期库存
   */
  stockType?: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 可核销次数
   */
  writeOffNum?: number
}[]

/**
 * 接口 [查询核销类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/153558) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffList`
 */
type ApiCommoditySkuStockWriteOffListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/skuStock/writeOffList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询核销类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/153558) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffList`
 */
const apiCommoditySkuStockWriteOffListRequestConfig: ApiCommoditySkuStockWriteOffListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_24,
    devUrl: devUrl_0_4_0_24,
    prodUrl: prodUrl_0_4_0_24,
    path: '/commodity/api/skuStock/writeOffList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommoditySkuStockWriteOffList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询核销类商品规格列表', author: '张彬' },
  }

/**
 * 接口 [查询核销类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/153558) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffList`
 */
export const apiCommoditySkuStockWriteOffList = /*#__PURE__*/ (
  requestData: ApiCommoditySkuStockWriteOffListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommoditySkuStockWriteOffListResponse>(
    prepare(apiCommoditySkuStockWriteOffListRequestConfig, requestData),
    ...args,
  )
}

apiCommoditySkuStockWriteOffList.requestConfig =
  apiCommoditySkuStockWriteOffListRequestConfig

/**
 * 接口 [查询核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/157644) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffDetail`
 */
export interface ApiCommoditySkuStockWriteOffDetailRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * 规格ID
   */
  skuId: string
  /**
   * 库存日期
   */
  stockDate?: string
}

/**
 * 接口 [查询核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/157644) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffDetail`
 */
export interface ApiCommoditySkuStockWriteOffDetailResponse {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * sku能效级别
   */
  efficiencyLevel?: number
  /**
   * 单次核销价格
   */
  onePrice?: number
  /**
   * 商品售价
   */
  sellPrice?: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType?: number
  /**
   * 结算值
   */
  settlementValue?: number
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 规格名称
   */
  skuName?: string
  /**
   * 规格状态： 0-无效 1-有效
   */
  skuStatus: 0 | 1
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存类型：0-标准库存 3-日期库存
   */
  stockType?: number
  /**
   * 剩余库存
   */
  surplusStock?: number
  /**
   * 可核销次数
   */
  writeOffNum?: number
}

/**
 * 接口 [查询核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/157644) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffDetail`
 */
type ApiCommoditySkuStockWriteOffDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/skuStock/writeOffDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/157644) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffDetail`
 */
const apiCommoditySkuStockWriteOffDetailRequestConfig: ApiCommoditySkuStockWriteOffDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_24,
    devUrl: devUrl_0_4_0_24,
    prodUrl: prodUrl_0_4_0_24,
    path: '/commodity/api/skuStock/writeOffDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommoditySkuStockWriteOffDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询核销类商品规格详情', author: '张彬' },
  }

/**
 * 接口 [查询核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/157644) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27840)
 * @请求头 `POST /commodity/api/skuStock/writeOffDetail`
 */
export const apiCommoditySkuStockWriteOffDetail = /*#__PURE__*/ (
  requestData: ApiCommoditySkuStockWriteOffDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommoditySkuStockWriteOffDetailResponse>(
    prepare(apiCommoditySkuStockWriteOffDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommoditySkuStockWriteOffDetail.requestConfig =
  apiCommoditySkuStockWriteOffDetailRequestConfig

const mockUrl_0_4_0_25 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_25 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_25 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_25 = 'data' as any

/**
 * 接口 [查询组合核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/151317) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27847)
 * @请求头 `POST /commodity/api/jointWriteOff/sku/detail`
 */
export interface ApiCommodityJointWriteOffSkuDetailRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * 规格ID
   */
  skuId: string
}

/**
 * 接口 [查询组合核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/151317) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27847)
 * @请求头 `POST /commodity/api/jointWriteOff/sku/detail`
 */
export interface ApiCommodityJointWriteOffSkuDetailResponse {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 剩余库存
   */
  surplusStock?: number
}

/**
 * 接口 [查询组合核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/151317) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27847)
 * @请求头 `POST /commodity/api/jointWriteOff/sku/detail`
 */
type ApiCommodityJointWriteOffSkuDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/jointWriteOff/sku/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询组合核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/151317) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-组合核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27847)
 * @请求头 `POST /commodity/api/jointWriteOff/sku/detail`
 */
const apiCommodityJointWriteOffSkuDetailRequestConfig: ApiCommodityJointWriteOffSkuDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_25,
    devUrl: devUrl_0_4_0_25,
    prodUrl: prodUrl_0_4_0_25,
    path: '/commodity/api/jointWriteOff/sku/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityJointWriteOffSkuDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询组合核销类商品规格详情', author: '张彬' },
  }

/**
 * 接口 [查询组合核销类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/151317) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-组合核销库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27847)
 * @请求头 `POST /commodity/api/jointWriteOff/sku/detail`
 */
export const apiCommodityJointWriteOffSkuDetail = /*#__PURE__*/ (
  requestData: ApiCommodityJointWriteOffSkuDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityJointWriteOffSkuDetailResponse>(
    prepare(apiCommodityJointWriteOffSkuDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityJointWriteOffSkuDetail.requestConfig =
  apiCommodityJointWriteOffSkuDetailRequestConfig

const mockUrl_0_4_0_26 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_26 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_26 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_26 = 'data' as any

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/151551) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/detail`
 */
export interface ApiCommodityJointWriteOffCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/151551) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/detail`
 */
export interface ApiCommodityJointWriteOffCommodityDetailResponse {
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 子商品列表
   */
  childList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品邮费价格
     */
    childPostPrice?: number
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单次核销价格
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 默认价格
   */
  price?: number
  /**
   * 购买须知
   */
  purchaseNotesDetail?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 销售价区间
   */
  sellPrices?: number[]
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/151551) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/detail`
 */
type ApiCommodityJointWriteOffCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/jointWriteOffCommodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/151551) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/detail`
 */
const apiCommodityJointWriteOffCommodityDetailRequestConfig: ApiCommodityJointWriteOffCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_26,
    devUrl: devUrl_0_4_0_26,
    prodUrl: prodUrl_0_4_0_26,
    path: '/commodity/api/jointWriteOffCommodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityJointWriteOffCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '详情', author: '张彬' },
  }

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/151551) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/detail`
 */
export const apiCommodityJointWriteOffCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityJointWriteOffCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityJointWriteOffCommodityDetailResponse>(
    prepare(apiCommodityJointWriteOffCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityJointWriteOffCommodityDetail.requestConfig =
  apiCommodityJointWriteOffCommodityDetailRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/151560) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/marketingDetail`
 */
export interface ApiCommodityJointWriteOffCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/151560) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/marketingDetail`
 */
export interface ApiCommodityJointWriteOffCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 满减活动优惠
   */
  fullReductions?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  /**
   * 积分活动优惠
   */
  integrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 减去积分后的价格
     */
    discountPrice?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 所需积分（多彩豆）
     */
    integral?: number
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 当前库存
     */
    stock?: number
  }[]
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 折扣活动优惠
   */
  marketingDiscountCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 折扣比例
     */
    discountRatio?: number
    /**
     * 单笔优惠上限制
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/151560) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/marketingDetail`
 */
type ApiCommodityJointWriteOffCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/jointWriteOffCommodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/151560) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/marketingDetail`
 */
const apiCommodityJointWriteOffCommodityMarketingDetailRequestConfig: ApiCommodityJointWriteOffCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_26,
    devUrl: devUrl_0_4_0_26,
    prodUrl: prodUrl_0_4_0_26,
    path: '/commodity/api/jointWriteOffCommodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityJointWriteOffCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '张彬' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/151560) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-组合核销商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_27938)
 * @请求头 `POST /commodity/api/jointWriteOffCommodity/marketingDetail`
 */
export const apiCommodityJointWriteOffCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityJointWriteOffCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityJointWriteOffCommodityMarketingDetailResponse>(
    prepare(
      apiCommodityJointWriteOffCommodityMarketingDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityJointWriteOffCommodityMarketingDetail.requestConfig =
  apiCommodityJointWriteOffCommodityMarketingDetailRequestConfig

const mockUrl_0_4_0_29 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_29 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_29 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_29 = 'data' as any

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/163197) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/detail`
 */
export interface ApiCommodityTravelCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/163197) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/detail`
 */
export interface ApiCommodityTravelCommodityDetailResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: '0' | '1' | '2'
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 结束标题
   */
  endTitle?: string
  /**
   * 可选日期区间：0-否 1-是
   */
  isDateInterval: 0 | 1
  /**
   * 包含最后一天(当可选日期区间选择是时)：0-否 1-是
   */
  isIncludeLastDay?: 0 | 1
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 默认价格
   */
  price?: number
  /**
   * 购买须知
   */
  purchaseNotesDetail?: string
  /**
   * 同店推荐商品
   */
  recommendCommodity?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 关联商品列表
   */
  relatedCommodities?: {
    /**
     * 关联商品名称
     */
    commodityTitle?: string
    /**
     * 关联商品ID
     */
    relatedCommodityId?: string
  }[]
  /**
   * 销量
   */
  sales?: number
  /**
   * 销售价区间
   */
  sellPrices?: number[]
  /**
   * 旅游商品规格信息
   */
  skuList?: {
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 初始库存
     */
    initStock: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: 0 | 1
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 商品单日限购量
     */
    singleDayLimitPurchases: number
    /**
     * 规格ID
     */
    skuId: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: 0 | 1
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 库存日期
     */
    stockDate?: string
    /**
     * 库存ID:第三方下单需要，非第三方和skuId一致
     */
    stockId: string
    /**
     * 剩余库存
     */
    surplusStock: number
    /**
     * 用户单日限购量
     */
    userDayLimitPurchases: number
    /**
     * 用户限购
     */
    userLimitPurchases: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 开始标题
   */
  startTitle?: string
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段
   */
  stockType: number
  store?: {
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
  }
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 套餐总价
   */
  writeOffCombosPrice?: number
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  writeOffStores?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺Id
     */
    storeId?: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic?: string
    /**
     * 主店店铺url
     */
    storeUrl: string
  }[]
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/163197) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/detail`
 */
type ApiCommodityTravelCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/travelCommodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/163197) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/detail`
 */
const apiCommodityTravelCommodityDetailRequestConfig: ApiCommodityTravelCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_29,
    devUrl: devUrl_0_4_0_29,
    prodUrl: prodUrl_0_4_0_29,
    path: '/commodity/api/travelCommodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityTravelCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '详情', author: '张彬' },
  }

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/163197) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/detail`
 */
export const apiCommodityTravelCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityTravelCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityTravelCommodityDetailResponse>(
    prepare(apiCommodityTravelCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityTravelCommodityDetail.requestConfig =
  apiCommodityTravelCommodityDetailRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/163206) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/marketingDetail`
 */
export interface ApiCommodityTravelCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/163206) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/marketingDetail`
 */
export interface ApiCommodityTravelCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 满减活动优惠
   */
  fullReductions?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  /**
   * 积分活动优惠
   */
  integrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 减去积分后的价格
     */
    discountPrice?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 所需积分（多彩豆）
     */
    integral?: number
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 当前库存
     */
    stock?: number
  }[]
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 折扣活动优惠
   */
  marketingDiscountCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 折扣比例
     */
    discountRatio?: number
    /**
     * 单笔优惠上限制
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/163206) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/marketingDetail`
 */
type ApiCommodityTravelCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/travelCommodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/163206) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/marketingDetail`
 */
const apiCommodityTravelCommodityMarketingDetailRequestConfig: ApiCommodityTravelCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_29,
    devUrl: devUrl_0_4_0_29,
    prodUrl: prodUrl_0_4_0_29,
    path: '/commodity/api/travelCommodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityTravelCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '张彬' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/163206) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30528)
 * @请求头 `POST /commodity/api/travelCommodity/marketingDetail`
 */
export const apiCommodityTravelCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityTravelCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityTravelCommodityMarketingDetailResponse>(
    prepare(
      apiCommodityTravelCommodityMarketingDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityTravelCommodityMarketingDetail.requestConfig =
  apiCommodityTravelCommodityMarketingDetailRequestConfig

const mockUrl_0_4_0_30 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_30 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_30 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_30 = 'data' as any

/**
 * 接口 [查询旅游类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/163215) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/detail`
 */
export interface ApiCommodityTravelSkuDetailRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  endTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * 规格ID
   */
  skuId: string
  startTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 库存日期
   */
  stockDate?: string
}

/**
 * 接口 [查询旅游类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/163215) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/detail`
 */
export interface ApiCommodityTravelSkuDetailResponse {
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow: number
  endTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 初始库存
   */
  initStock: number
  /**
   * 单次核销价格
   */
  onePrice: number
  /**
   * 商品售价
   */
  sellPrice: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType: 0 | 1
  /**
   * 结算值
   */
  settlementValue: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases: number
  /**
   * 规格ID
   */
  skuId: string
  /**
   * SKU图
   */
  skuPic: string
  /**
   * 规格状态： 0-无效 1-有效
   */
  skuStatus: 0 | 1
  startTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存ID:第三方下单需要，非第三方和skuId一致
   */
  stockId: string
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases: number
  /**
   * 用户限购
   */
  userLimitPurchases: number
  /**
   * 可核销次数
   */
  writeOffNum: number
}

/**
 * 接口 [查询旅游类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/163215) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/detail`
 */
type ApiCommodityTravelSkuDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/travelSku/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询旅游类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/163215) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/detail`
 */
const apiCommodityTravelSkuDetailRequestConfig: ApiCommodityTravelSkuDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_30,
    devUrl: devUrl_0_4_0_30,
    prodUrl: prodUrl_0_4_0_30,
    path: '/commodity/api/travelSku/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityTravelSkuDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询旅游类商品规格详情', author: '张彬' },
  }

/**
 * 接口 [查询旅游类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/163215) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/detail`
 */
export const apiCommodityTravelSkuDetail = /*#__PURE__*/ (
  requestData: ApiCommodityTravelSkuDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityTravelSkuDetailResponse>(
    prepare(apiCommodityTravelSkuDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityTravelSkuDetail.requestConfig =
  apiCommodityTravelSkuDetailRequestConfig

/**
 * 接口 [查询核销类商品库存列表↗](https://yapi.gogpay.cn/project/939/interface/api/163224) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/list`
 */
export interface ApiCommodityTravelSkuListRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  endTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * 规格ID
   */
  skuId: string
  startTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 库存日期
   */
  stockDate?: string
}

/**
 * 接口 [查询核销类商品库存列表↗](https://yapi.gogpay.cn/project/939/interface/api/163224) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/list`
 */
export type ApiCommodityTravelSkuListResponse = {
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow: number
  endTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 初始库存
   */
  initStock: number
  /**
   * 单次核销价格
   */
  onePrice: number
  /**
   * 商品售价
   */
  sellPrice: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType: 0 | 1
  /**
   * 结算值
   */
  settlementValue: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases: number
  /**
   * 规格ID
   */
  skuId: string
  /**
   * SKU图
   */
  skuPic: string
  /**
   * 规格状态： 0-无效 1-有效
   */
  skuStatus: 0 | 1
  startTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存ID:第三方下单需要，非第三方和skuId一致
   */
  stockId: string
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases: number
  /**
   * 用户限购
   */
  userLimitPurchases: number
  /**
   * 可核销次数
   */
  writeOffNum: number
}[]

/**
 * 接口 [查询核销类商品库存列表↗](https://yapi.gogpay.cn/project/939/interface/api/163224) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/list`
 */
type ApiCommodityTravelSkuListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/travelSku/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询核销类商品库存列表↗](https://yapi.gogpay.cn/project/939/interface/api/163224) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/list`
 */
const apiCommodityTravelSkuListRequestConfig: ApiCommodityTravelSkuListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_30,
    devUrl: devUrl_0_4_0_30,
    prodUrl: prodUrl_0_4_0_30,
    path: '/commodity/api/travelSku/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityTravelSkuList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询核销类商品库存列表', author: '张彬' },
  }

/**
 * 接口 [查询核销类商品库存列表↗](https://yapi.gogpay.cn/project/939/interface/api/163224) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-旅游商品库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_30535)
 * @请求头 `POST /commodity/api/travelSku/list`
 */
export const apiCommodityTravelSkuList = /*#__PURE__*/ (
  requestData: ApiCommodityTravelSkuListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityTravelSkuListResponse>(
    prepare(apiCommodityTravelSkuListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityTravelSkuList.requestConfig = apiCommodityTravelSkuListRequestConfig

const mockUrl_0_4_0_31 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_31 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_31 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_31 = 'data' as any

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/169700) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/detail`
 */
export interface ApiCommodityJointStandardCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/169700) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/detail`
 */
export interface ApiCommodityJointStandardCommodityDetailResponse {
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 子商品列表
   */
  childList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单价
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 默认价格
   */
  price?: number
  /**
   * 购买须知
   */
  purchaseNotesDetail?: string
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 销售价区间
   */
  sellPrices?: number[]
  /**
   * 发货地址
   */
  shipAddress?: string
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 商家资质
   */
  storeQualification?: string[]
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/169700) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/detail`
 */
type ApiCommodityJointStandardCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/jointStandardCommodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/169700) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/detail`
 */
const apiCommodityJointStandardCommodityDetailRequestConfig: ApiCommodityJointStandardCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_31,
    devUrl: devUrl_0_4_0_31,
    prodUrl: prodUrl_0_4_0_31,
    path: '/commodity/api/jointStandardCommodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityJointStandardCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '详情', author: '张彬' },
  }

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/169700) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/detail`
 */
export const apiCommodityJointStandardCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityJointStandardCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityJointStandardCommodityDetailResponse>(
    prepare(apiCommodityJointStandardCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityJointStandardCommodityDetail.requestConfig =
  apiCommodityJointStandardCommodityDetailRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/169708) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/marketingDetail`
 */
export interface ApiCommodityJointStandardCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/169708) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/marketingDetail`
 */
export interface ApiCommodityJointStandardCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 满减活动优惠
   */
  fullReductions?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  /**
   * 积分活动优惠
   */
  integrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 减去积分后的价格
     */
    discountPrice?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 所需积分（多彩豆）
     */
    integral?: number
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 当前库存
     */
    stock?: number
  }[]
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 折扣活动优惠
   */
  marketingDiscountCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 折扣比例
     */
    discountRatio?: number
    /**
     * 单笔优惠上限制
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/169708) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/marketingDetail`
 */
type ApiCommodityJointStandardCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/jointStandardCommodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/169708) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/marketingDetail`
 */
const apiCommodityJointStandardCommodityMarketingDetailRequestConfig: ApiCommodityJointStandardCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_31,
    devUrl: devUrl_0_4_0_31,
    prodUrl: prodUrl_0_4_0_31,
    path: '/commodity/api/jointStandardCommodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityJointStandardCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '张彬' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/169708) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-组合标电商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31668)
 * @请求头 `POST /commodity/api/jointStandardCommodity/marketingDetail`
 */
export const apiCommodityJointStandardCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityJointStandardCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityJointStandardCommodityMarketingDetailResponse>(
    prepare(
      apiCommodityJointStandardCommodityMarketingDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityJointStandardCommodityMarketingDetail.requestConfig =
  apiCommodityJointStandardCommodityMarketingDetailRequestConfig

const mockUrl_0_4_0_32 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_32 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_32 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_32 = 'data' as any

/**
 * 接口 [查询组合标电类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/169692) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31670)
 * @请求头 `POST /commodity/api/jointStandard/sku/detail`
 */
export interface ApiCommodityJointStandardSkuDetailRequest {
  /**
   * 规格ID
   */
  skuId?: string
}

/**
 * 接口 [查询组合标电类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/169692) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31670)
 * @请求头 `POST /commodity/api/jointStandard/sku/detail`
 */
export interface ApiCommodityJointStandardSkuDetailResponse {
  /**
   * 子商品列表
   */
  childList?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品邮费类型：0-包邮 1-子商品运费模板 2-自定义运费
     */
    childPostType?: 0 | 1 | 2
    /**
     * 子商品规格ID
     */
    childSkuId?: string
    /**
     * 组合商品名称
     */
    commodityTitle?: string
    /**
     * 数量
     */
    num?: number
    /**
     * 单价
     */
    onePrice?: number
    /**
     * 商品原名称
     */
    originalCommodityTitle?: string
    /**
     * 组合商品ID
     */
    refCommodityId?: string
    /**
     * 运费模板
     */
    refDeliverTemplateId?: string
    /**
     * 销售价格
     */
    sellPrice?: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType?: 0 | 1
    /**
     * 结算值
     */
    settlementValue?: number
    /**
     * 剩余库存
     */
    surplusStock?: number
  }[]
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 售价
   */
  sellPrice?: number
  /**
   * 规格ID
   */
  skuId?: string
  /**
   * 剩余库存
   */
  surplusStock?: number
}

/**
 * 接口 [查询组合标电类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/169692) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-组合标电库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31670)
 * @请求头 `POST /commodity/api/jointStandard/sku/detail`
 */
type ApiCommodityJointStandardSkuDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/jointStandard/sku/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询组合标电类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/169692) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-组合标电库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31670)
 * @请求头 `POST /commodity/api/jointStandard/sku/detail`
 */
const apiCommodityJointStandardSkuDetailRequestConfig: ApiCommodityJointStandardSkuDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_32,
    devUrl: devUrl_0_4_0_32,
    prodUrl: prodUrl_0_4_0_32,
    path: '/commodity/api/jointStandard/sku/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_32,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityJointStandardSkuDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询组合标电类商品规格详情', author: '张彬' },
  }

/**
 * 接口 [查询组合标电类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/169692) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-组合标电库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_31670)
 * @请求头 `POST /commodity/api/jointStandard/sku/detail`
 */
export const apiCommodityJointStandardSkuDetail = /*#__PURE__*/ (
  requestData: ApiCommodityJointStandardSkuDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityJointStandardSkuDetailResponse>(
    prepare(apiCommodityJointStandardSkuDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityJointStandardSkuDetail.requestConfig =
  apiCommodityJointStandardSkuDetailRequestConfig

const mockUrl_0_4_0_33 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_33 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_33 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_33 = 'data' as any

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/188694) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/detail`
 */
export interface ApiCommodityDeliveryCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/188694) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/detail`
 */
export interface ApiCommodityDeliveryCommodityDetailResponse {
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品标签
   */
  commodityLabel?: string[]
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 头图标签
   */
  coverLabel?: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 是否支持售后：0-否 1-是
   */
  isAfterSales?: 0 | 1
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 商户ID
   */
  merchantId?: string
  multipleSku?: boolean
  /**
   * 默认价格
   */
  price?: number
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 销售价区间
   */
  sellPrices?: number[]
  /**
   * 商家资质
   */
  storeQualification?: string[]
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 是否支持积分支付
   */
  supportIntegral?: boolean
  /**
   * 包装费用
   */
  wrapPrice?: number
}

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/188694) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/detail`
 */
type ApiCommodityDeliveryCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/deliveryCommodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/188694) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/detail`
 */
const apiCommodityDeliveryCommodityDetailRequestConfig: ApiCommodityDeliveryCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_33,
    devUrl: devUrl_0_4_0_33,
    prodUrl: prodUrl_0_4_0_33,
    path: '/commodity/api/deliveryCommodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityDeliveryCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '详情', author: '张彬' },
  }

/**
 * 接口 [详情↗](https://yapi.gogpay.cn/project/939/interface/api/188694) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/detail`
 */
export const apiCommodityDeliveryCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityDeliveryCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityDeliveryCommodityDetailResponse>(
    prepare(apiCommodityDeliveryCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityDeliveryCommodityDetail.requestConfig =
  apiCommodityDeliveryCommodityDetailRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/188698) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/marketingDetail`
 */
export interface ApiCommodityDeliveryCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/188698) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/marketingDetail`
 */
export interface ApiCommodityDeliveryCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 满减活动优惠
   */
  fullReductions?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  /**
   * 积分活动优惠
   */
  integrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 减去积分后的价格
     */
    discountPrice?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 所需积分（多彩豆）
     */
    integral?: number
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 当前库存
     */
    stock?: number
  }[]
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 折扣活动优惠
   */
  marketingDiscountCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 折扣比例
     */
    discountRatio?: number
    /**
     * 单笔优惠上限制
     */
    discountSingleOrderMaxLimit?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/188698) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/marketingDetail`
 */
type ApiCommodityDeliveryCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/deliveryCommodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/188698) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/marketingDetail`
 */
const apiCommodityDeliveryCommodityMarketingDetailRequestConfig: ApiCommodityDeliveryCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_33,
    devUrl: devUrl_0_4_0_33,
    prodUrl: prodUrl_0_4_0_33,
    path: '/commodity/api/deliveryCommodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityDeliveryCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '张彬' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/188698) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/marketingDetail`
 */
export const apiCommodityDeliveryCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityDeliveryCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityDeliveryCommodityMarketingDetailResponse>(
    prepare(
      apiCommodityDeliveryCommodityMarketingDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityDeliveryCommodityMarketingDetail.requestConfig =
  apiCommodityDeliveryCommodityMarketingDetailRequestConfig

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/188766) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/storeDetail`
 */
export interface ApiCommodityDeliveryCommodityStoreDetailRequest {
  clientType?: '1' | '2' | '3' | '4'
  headerChannel?: string[]
  /**
   * 用户纬度
   */
  latitude?: string
  /**
   * 用户经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 店铺ID
   */
  storeId: string
}

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/188766) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/storeDetail`
 */
export interface ApiCommodityDeliveryCommodityStoreDetailResponse {
  /**
   * 折扣信息
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减券信息
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取（继续领取） 2=已领取（不可领取）
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 优惠券可用时间
     */
    useTimeType?: number
    /**
     * 优惠券可用时间值
     */
    useTimeVal?: string
  }[]
  /**
   * 商家资质
   */
  storeQualification?: string[]
  /**
   * 店铺Id
   */
  storeId?: string
  /**
   * 店铺名称
   */
  storeName?: string
  /**
   * 店铺链接
   */
  storeUrl?: string
  /**
   * 店铺logo(店铺封面)
   */
  storeLogo?: string
  /**
   * 店铺相册(url列表)
   */
  photoAlbum?: string[]
  /**
   * 最低配送价格
   */
  minDeliveryPrice?: number
  /**
   * 营业时间
   */
  openPeriod?: string
  /**
   * 商家联系电话
   */
  storePhone?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 详细地址
   */
  address?: string
  /**
   * 特点标签
   */
  featureTags?: string[]
  /**
   * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
   */
  storeStatus?: number
  /**
   * 距离用户的距离（米）
   */
  distance: number
  /**
   * 店铺公告
   */
  storeNotice?: string
  /**
   * 配送范围
   */
  deliverZone?: {
    /**
     * 区县编码
     */
    districtCode?: string
    /**
     * 区县名称
     */
    districtName?: string
    /**
     * 初始配送价格
     */
    initPrice?: number
    /**
     * 初始阶梯
     */
    initStep?: number
    /**
     * 满xx件|满xxKG
     */
    step?: number
    /**
     * 满加配送价格
     */
    stepPrice?: number
  }[]
}

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/188766) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/storeDetail`
 */
type ApiCommodityDeliveryCommodityStoreDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/deliveryCommodity/storeDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/188766) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/storeDetail`
 */
const apiCommodityDeliveryCommodityStoreDetailRequestConfig: ApiCommodityDeliveryCommodityStoreDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_33,
    devUrl: devUrl_0_4_0_33,
    prodUrl: prodUrl_0_4_0_33,
    path: '/commodity/api/deliveryCommodity/storeDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityDeliveryCommodityStoreDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺详情', author: '张彬' },
  }

/**
 * 接口 [店铺详情↗](https://yapi.gogpay.cn/project/939/interface/api/188766) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-配送商品↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33681)
 * @请求头 `POST /commodity/api/deliveryCommodity/storeDetail`
 */
export const apiCommodityDeliveryCommodityStoreDetail = /*#__PURE__*/ (
  requestData: ApiCommodityDeliveryCommodityStoreDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityDeliveryCommodityStoreDetailResponse>(
    prepare(apiCommodityDeliveryCommodityStoreDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityDeliveryCommodityStoreDetail.requestConfig =
  apiCommodityDeliveryCommodityStoreDetailRequestConfig

const mockUrl_0_4_0_34 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_34 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_34 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_34 = 'data' as any

/**
 * 接口 [批量查询SKU↗](https://yapi.gogpay.cn/project/939/interface/api/188686) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/batchSku`
 */
export interface ApiCommodityDeliverySkuBatchSkuRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * SKU业务唯一索引
   */
  skuIds: string[]
}

/**
 * 接口 [批量查询SKU↗](https://yapi.gogpay.cn/project/939/interface/api/188686) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/batchSku`
 */
export type ApiCommodityDeliverySkuBatchSkuResponse = {
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow: number
  /**
   * 销量：查询时候返回
   */
  sales?: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 成本价
   */
  skuCost: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * 规格名称
   */
  skuName: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * SKU价格
   */
  skuPrice: number
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * SKU状态:0-无效 1-有效
   */
  skuStatus: 0 | 1
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 重量(千克)
   */
  weight: number
}[]

/**
 * 接口 [批量查询SKU↗](https://yapi.gogpay.cn/project/939/interface/api/188686) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/batchSku`
 */
type ApiCommodityDeliverySkuBatchSkuRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/delivery/sku/batchSku',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量查询SKU↗](https://yapi.gogpay.cn/project/939/interface/api/188686) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/batchSku`
 */
const apiCommodityDeliverySkuBatchSkuRequestConfig: ApiCommodityDeliverySkuBatchSkuRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_34,
    devUrl: devUrl_0_4_0_34,
    prodUrl: prodUrl_0_4_0_34,
    path: '/commodity/api/delivery/sku/batchSku',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityDeliverySkuBatchSku',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量查询SKU', author: '张彬' },
  }

/**
 * 接口 [批量查询SKU↗](https://yapi.gogpay.cn/project/939/interface/api/188686) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/batchSku`
 */
export const apiCommodityDeliverySkuBatchSku = /*#__PURE__*/ (
  requestData: ApiCommodityDeliverySkuBatchSkuRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityDeliverySkuBatchSkuResponse>(
    prepare(apiCommodityDeliverySkuBatchSkuRequestConfig, requestData),
    ...args,
  )
}

apiCommodityDeliverySkuBatchSku.requestConfig =
  apiCommodityDeliverySkuBatchSkuRequestConfig

/**
 * 接口 [获取商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/188690) 的 **请求类型**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/getSkuList`
 */
export interface ApiCommodityDeliverySkuGetSkuListRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 是否预览0否 1是
   */
  previewStatus: number
}

/**
 * 接口 [获取商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/188690) 的 **返回类型**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/getSkuList`
 */
export type ApiCommodityDeliverySkuGetSkuListResponse = {
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow: number
  /**
   * 销量：查询时候返回
   */
  sales?: number
  /**
   * 商品单日限购量
   */
  singleDayLimitPurchases?: number
  /**
   * 成本价
   */
  skuCost: number
  /**
   * SKU唯一参数标识
   */
  skuId: string
  /**
   * 规格名称
   */
  skuName: string
  /**
   * SKU商品图
   */
  skuPic: string
  /**
   * SKU价格
   */
  skuPrice: number
  /**
   * sku规格
   */
  skuSpecs: {
    /**
     * sku属性名称
     */
    attributeName?: string
    selected: {
      /**
       * 参数ID
       */
      id: string
      /**
       * 参数键(2.0废弃)
       */
      key?: string
      /**
       * 参数值
       */
      value: string
    }
    /**
     * sku属性ID
     */
    skuAttributeId?: string
  }[]
  /**
   * SKU状态:0-无效 1-有效
   */
  skuStatus: 0 | 1
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 用户单日限购量
   */
  userDayLimitPurchases?: number
  /**
   * 用户限购
   */
  userLimitPurchases?: number
  /**
   * 重量(千克)
   */
  weight: number
}[]

/**
 * 接口 [获取商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/188690) 的 **请求配置的类型**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/getSkuList`
 */
type ApiCommodityDeliverySkuGetSkuListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/delivery/sku/getSkuList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/188690) 的 **请求配置**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/getSkuList`
 */
const apiCommodityDeliverySkuGetSkuListRequestConfig: ApiCommodityDeliverySkuGetSkuListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_34,
    devUrl: devUrl_0_4_0_34,
    prodUrl: prodUrl_0_4_0_34,
    path: '/commodity/api/delivery/sku/getSkuList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityDeliverySkuGetSkuList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品规格列表', author: '张彬' },
  }

/**
 * 接口 [获取商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/188690) 的 **请求函数**
 *
 * @作者 张彬
 * @分类 [前台-配送库存↗](https://yapi.gogpay.cn/project/939/interface/api/cat_33684)
 * @请求头 `POST /commodity/api/delivery/sku/getSkuList`
 */
export const apiCommodityDeliverySkuGetSkuList = /*#__PURE__*/ (
  requestData: ApiCommodityDeliverySkuGetSkuListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityDeliverySkuGetSkuListResponse>(
    prepare(apiCommodityDeliverySkuGetSkuListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityDeliverySkuGetSkuList.requestConfig =
  apiCommodityDeliverySkuGetSkuListRequestConfig

const mockUrl_0_4_0_38 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_38 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_38 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_38 = 'data' as any

/**
 * 接口 [获取类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/271731) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/list`
 */
export interface ApiCommodityFrontCategoryListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 三级分类名称-查询三级分类
   */
  categoryName?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 父级ID,一级分类非必传其他分类，必传
   */
  parentId?: string
}

/**
 * 接口 [获取类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/271731) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/list`
 */
export type ApiCommodityFrontCategoryListResponse = {
  /**
   * 一级分类id
   */
  categoryId?: string
  /**
   * 一级分类名称
   */
  categoryName?: string
  /**
   * 分类图片
   */
  categoryPic?: string
  /**
   * 分类级别
   */
  frontCategoryLevelEnum?: number
  /**
   * 二级分类集合
   */
  frontCategoryListVOS?: unknown[]
  /**
   * 父级id
   */
  parentId?: string
  /**
   * 一级排序
   */
  sortNo?: number
}[]

/**
 * 接口 [获取类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/271731) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/list`
 */
type ApiCommodityFrontCategoryListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/271731) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/list`
 */
const apiCommodityFrontCategoryListRequestConfig: ApiCommodityFrontCategoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_38,
    devUrl: devUrl_0_4_0_38,
    prodUrl: prodUrl_0_4_0_38,
    path: '/commodity/api/frontCategory/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取类目树数据', author: '成龙' },
  }

/**
 * 接口 [获取类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/271731) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/list`
 */
export const apiCommodityFrontCategoryList = /*#__PURE__*/ (
  requestData: ApiCommodityFrontCategoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryListResponse>(
    prepare(apiCommodityFrontCategoryListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityFrontCategoryList.requestConfig =
  apiCommodityFrontCategoryListRequestConfig

/**
 * 接口 [获取适老化类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/481801) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/getWebCategoryTree`
 */
export interface ApiCommodityFrontCategoryGetWebCategoryTreeRequest {
  /**
   * 类目ID
   */
  categoryId?: string
}

/**
 * 接口 [获取适老化类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/481801) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/getWebCategoryTree`
 */
export type ApiCommodityFrontCategoryGetWebCategoryTreeResponse = {
  categoryName?: string
  categoryPic?: string
  children?: unknown[]
  id?: string
  parentId?: string
  sortNum?: number
}[]

/**
 * 接口 [获取适老化类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/481801) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/getWebCategoryTree`
 */
type ApiCommodityFrontCategoryGetWebCategoryTreeRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/getWebCategoryTree',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取适老化类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/481801) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/getWebCategoryTree`
 */
const apiCommodityFrontCategoryGetWebCategoryTreeRequestConfig: ApiCommodityFrontCategoryGetWebCategoryTreeRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_38,
    devUrl: devUrl_0_4_0_38,
    prodUrl: prodUrl_0_4_0_38,
    path: '/commodity/api/frontCategory/getWebCategoryTree',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryGetWebCategoryTree',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取适老化类目树数据', author: '511号开发' },
  }

/**
 * 接口 [获取适老化类目树数据↗](https://yapi.gogpay.cn/project/939/interface/api/481801) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [前台-商品分级管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_39351)
 * @请求头 `POST /commodity/api/frontCategory/getWebCategoryTree`
 */
export const apiCommodityFrontCategoryGetWebCategoryTree = /*#__PURE__*/ (
  requestData: ApiCommodityFrontCategoryGetWebCategoryTreeRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryGetWebCategoryTreeResponse>(
    prepare(
      apiCommodityFrontCategoryGetWebCategoryTreeRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityFrontCategoryGetWebCategoryTree.requestConfig =
  apiCommodityFrontCategoryGetWebCategoryTreeRequestConfig

const mockUrl_0_4_0_39 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_39 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_39 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_39 = 'data' as any

/**
 * 接口 [回答问题↗](https://yapi.gogpay.cn/project/939/interface/api/267048) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/answer`
 */
export interface ApiCommodityQaAnswerRequest {
  /**
   * 回答内容
   */
  answer?: string
  /**
   * 问题Id
   */
  id: string
  /**
   * 图片列表
   */
  pics?: string[]
}

/**
 * 接口 [回答问题↗](https://yapi.gogpay.cn/project/939/interface/api/267048) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/answer`
 */
export interface ApiCommodityQaAnswerResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [回答问题↗](https://yapi.gogpay.cn/project/939/interface/api/267048) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/answer`
 */
type ApiCommodityQaAnswerRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/qa/answer',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [回答问题↗](https://yapi.gogpay.cn/project/939/interface/api/267048) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/answer`
 */
const apiCommodityQaAnswerRequestConfig: ApiCommodityQaAnswerRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_39,
    devUrl: devUrl_0_4_0_39,
    prodUrl: prodUrl_0_4_0_39,
    path: '/commodity/api/qa/answer',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityQaAnswer',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '回答问题', author: '成龙' },
  }

/**
 * 接口 [回答问题↗](https://yapi.gogpay.cn/project/939/interface/api/267048) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/answer`
 */
export const apiCommodityQaAnswer = /*#__PURE__*/ (
  requestData: ApiCommodityQaAnswerRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityQaAnswerResponse>(
    prepare(apiCommodityQaAnswerRequestConfig, requestData),
    ...args,
  )
}

apiCommodityQaAnswer.requestConfig = apiCommodityQaAnswerRequestConfig

/**
 * 接口 [获取商品详情QA列表↗](https://yapi.gogpay.cn/project/939/interface/api/267051) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/commodityIndex`
 */
export interface ApiCommodityQaCommodityIndexRequest {
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 用户ID
   */
  userId?: string
}

/**
 * 接口 [获取商品详情QA列表↗](https://yapi.gogpay.cn/project/939/interface/api/267051) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/commodityIndex`
 */
export interface ApiCommodityQaCommodityIndexResponse {
  /**
   * 问题列表
   */
  items?: {
    /**
     * 回答数量
     */
    answerCount?: number
    /**
     * Id
     */
    id?: string
    /**
     * 问题
     */
    question?: string
  }[]
  /**
   * 总问题数量
   */
  quantity?: number
}

/**
 * 接口 [获取商品详情QA列表↗](https://yapi.gogpay.cn/project/939/interface/api/267051) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/commodityIndex`
 */
type ApiCommodityQaCommodityIndexRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/qa/commodityIndex',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取商品详情QA列表↗](https://yapi.gogpay.cn/project/939/interface/api/267051) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/commodityIndex`
 */
const apiCommodityQaCommodityIndexRequestConfig: ApiCommodityQaCommodityIndexRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_39,
    devUrl: devUrl_0_4_0_39,
    prodUrl: prodUrl_0_4_0_39,
    path: '/commodity/api/qa/commodityIndex',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityQaCommodityIndex',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取商品详情QA列表', author: '成龙' },
  }

/**
 * 接口 [获取商品详情QA列表↗](https://yapi.gogpay.cn/project/939/interface/api/267051) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/commodityIndex`
 */
export const apiCommodityQaCommodityIndex = /*#__PURE__*/ (
  requestData: ApiCommodityQaCommodityIndexRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityQaCommodityIndexResponse>(
    prepare(apiCommodityQaCommodityIndexRequestConfig, requestData),
    ...args,
  )
}

apiCommodityQaCommodityIndex.requestConfig =
  apiCommodityQaCommodityIndexRequestConfig

/**
 * 接口 [获取问题详情↗](https://yapi.gogpay.cn/project/939/interface/api/267054) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/detail`
 */
export interface ApiCommodityQaDetailRequest {
  /**
   * 数据id
   */
  id: string
}

/**
 * 接口 [获取问题详情↗](https://yapi.gogpay.cn/project/939/interface/api/267054) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/detail`
 */
export interface ApiCommodityQaDetailResponse {
  /**
   * 提问用户头像
   */
  avatar?: string
  /**
   * Id
   */
  id?: string
  /**
   * 回答列表
   */
  items?: {
    /**
     * 回答内容
     */
    answer?: string
    /**
     * 头像
     */
    avatar?: string
    /**
     * 回答时间
     */
    createDate?: string
    /**
     * 回答Id
     */
    id?: string
    /**
     * 图片列表
     */
    pics?: string[]
    /**
     * 用户名
     */
    userName?: string
  }[]
  /**
   * 问题
   */
  question?: string
  /**
   * 用户昵称
   */
  userName?: string
}

/**
 * 接口 [获取问题详情↗](https://yapi.gogpay.cn/project/939/interface/api/267054) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/detail`
 */
type ApiCommodityQaDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/qa/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取问题详情↗](https://yapi.gogpay.cn/project/939/interface/api/267054) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/detail`
 */
const apiCommodityQaDetailRequestConfig: ApiCommodityQaDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_39,
    devUrl: devUrl_0_4_0_39,
    prodUrl: prodUrl_0_4_0_39,
    path: '/commodity/api/qa/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityQaDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取问题详情', author: '成龙' },
  }

/**
 * 接口 [获取问题详情↗](https://yapi.gogpay.cn/project/939/interface/api/267054) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/detail`
 */
export const apiCommodityQaDetail = /*#__PURE__*/ (
  requestData: ApiCommodityQaDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityQaDetailResponse>(
    prepare(apiCommodityQaDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityQaDetail.requestConfig = apiCommodityQaDetailRequestConfig

/**
 * 接口 [获取问题列表↗](https://yapi.gogpay.cn/project/939/interface/api/267057) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/list`
 */
export interface ApiCommodityQaListRequest {
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [获取问题列表↗](https://yapi.gogpay.cn/project/939/interface/api/267057) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/list`
 */
export interface ApiCommodityQaListResponse {
  /**
   * 商品id
   */
  commodityId?: string
  /**
   * 商品图片
   */
  commodityPic?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 问题列表
   */
  items?: {
    /**
     * 回答内容
     */
    answer?: string
    /**
     * 回答数量
     */
    answerCount?: number
    auserAvatar?: string
    /**
     * Id
     */
    id?: string
    /**
     * 问题
     */
    question?: string
    quserAvatar?: string
  }[]
  /**
   * 问题数量
   */
  quantity?: number
}

/**
 * 接口 [获取问题列表↗](https://yapi.gogpay.cn/project/939/interface/api/267057) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/list`
 */
type ApiCommodityQaListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/qa/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [获取问题列表↗](https://yapi.gogpay.cn/project/939/interface/api/267057) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/list`
 */
const apiCommodityQaListRequestConfig: ApiCommodityQaListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_39,
    devUrl: devUrl_0_4_0_39,
    prodUrl: prodUrl_0_4_0_39,
    path: '/commodity/api/qa/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityQaList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取问题列表', author: '成龙' },
  }

/**
 * 接口 [获取问题列表↗](https://yapi.gogpay.cn/project/939/interface/api/267057) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/list`
 */
export const apiCommodityQaList = /*#__PURE__*/ (
  requestData: ApiCommodityQaListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityQaListResponse>(
    prepare(apiCommodityQaListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityQaList.requestConfig = apiCommodityQaListRequestConfig

/**
 * 接口 [发布问题↗](https://yapi.gogpay.cn/project/939/interface/api/267060) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/question`
 */
export interface ApiCommodityQaQuestionRequest {
  /**
   * 商品Id
   */
  id: string
  /**
   * 问题内容
   */
  question: string
}

/**
 * 接口 [发布问题↗](https://yapi.gogpay.cn/project/939/interface/api/267060) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/question`
 */
export interface ApiCommodityQaQuestionResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [发布问题↗](https://yapi.gogpay.cn/project/939/interface/api/267060) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/question`
 */
type ApiCommodityQaQuestionRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/qa/question',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [发布问题↗](https://yapi.gogpay.cn/project/939/interface/api/267060) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/question`
 */
const apiCommodityQaQuestionRequestConfig: ApiCommodityQaQuestionRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_39,
    devUrl: devUrl_0_4_0_39,
    prodUrl: prodUrl_0_4_0_39,
    path: '/commodity/api/qa/question',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityQaQuestion',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '发布问题', author: '成龙' },
  }

/**
 * 接口 [发布问题↗](https://yapi.gogpay.cn/project/939/interface/api/267060) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [客户端-【中国红】问大家↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46408)
 * @请求头 `POST /commodity/api/qa/question`
 */
export const apiCommodityQaQuestion = /*#__PURE__*/ (
  requestData: ApiCommodityQaQuestionRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityQaQuestionResponse>(
    prepare(apiCommodityQaQuestionRequestConfig, requestData),
    ...args,
  )
}

apiCommodityQaQuestion.requestConfig = apiCommodityQaQuestionRequestConfig

const mockUrl_0_4_0_45 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_45 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_45 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_45 = 'data' as any

/**
 * 接口 [三级分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267141) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/commodityList`
 */
export interface ApiCommodityFrontCategoryCommodityListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 排序方式：true-正序 false-倒序
   */
  asc?: boolean
  /**
   * 分类id
   */
  categoryId?: string
  /**
   * 店铺id:子机构编码:unitOrgCode
   */
  merchantId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序类型：1-默认排序 2-销量排序 3-价格排序
   */
  sortType?: number
}

/**
 * 接口 [三级分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267141) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/commodityList`
 */
export type ApiCommodityFrontCategoryCommodityListResponse = {
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 商品Id
   */
  id?: string
  /**
   * 商品价格
   */
  price?: number
  /**
   * 销量
   */
  sales?: number
  /**
   * 店铺名称
   */
  store?: string
  /**
   * 副标题
   */
  subTitle?: string
  /**
   * 商品名称
   */
  title?: string
  /**
   * 跳转链接
   */
  url?: string
}[]

/**
 * 接口 [三级分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267141) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/commodityList`
 */
type ApiCommodityFrontCategoryCommodityListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/commodityList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [三级分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267141) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/commodityList`
 */
const apiCommodityFrontCategoryCommodityListRequestConfig: ApiCommodityFrontCategoryCommodityListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_45,
    devUrl: devUrl_0_4_0_45,
    prodUrl: prodUrl_0_4_0_45,
    path: '/commodity/api/frontCategory/commodityList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryCommodityList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '三级分类下商品列表', author: '520号开发' },
  }

/**
 * 接口 [三级分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267141) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/commodityList`
 */
export const apiCommodityFrontCategoryCommodityList = /*#__PURE__*/ (
  requestData: ApiCommodityFrontCategoryCommodityListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryCommodityListResponse>(
    prepare(apiCommodityFrontCategoryCommodityListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityFrontCategoryCommodityList.requestConfig =
  apiCommodityFrontCategoryCommodityListRequestConfig

/**
 * 接口 [店铺分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/267144) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategory`
 */
export interface ApiCommodityFrontCategoryOrgCategoryRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 排序方式：true-正序 false-倒序
   */
  asc?: boolean
  /**
   * 分类id
   */
  categoryId?: string
  /**
   * 店铺id:子机构编码:unitOrgCode
   */
  merchantId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序类型：1-默认排序 2-销量排序 3-价格排序
   */
  sortType?: number
}

/**
 * 接口 [店铺分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/267144) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategory`
 */
export type ApiCommodityFrontCategoryOrgCategoryResponse = {
  /**
   * 三级分类id
   */
  categoryId?: string
  /**
   * 三级分类名称
   */
  categoryName?: string
  /**
   * 分类图片
   */
  categoryPic?: string
  /**
   * 所拥有数据权限分组-店铺
   */
  selectUnitOrgCode?: string
  /**
   * 三级排序
   */
  sortNo?: number
}[]

/**
 * 接口 [店铺分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/267144) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategory`
 */
type ApiCommodityFrontCategoryOrgCategoryRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/orgCategory',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/267144) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategory`
 */
const apiCommodityFrontCategoryOrgCategoryRequestConfig: ApiCommodityFrontCategoryOrgCategoryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_45,
    devUrl: devUrl_0_4_0_45,
    prodUrl: prodUrl_0_4_0_45,
    path: '/commodity/api/frontCategory/orgCategory',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryOrgCategory',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺分类列表', author: '520号开发' },
  }

/**
 * 接口 [店铺分类列表↗](https://yapi.gogpay.cn/project/939/interface/api/267144) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategory`
 */
export const apiCommodityFrontCategoryOrgCategory = /*#__PURE__*/ (
  requestData: ApiCommodityFrontCategoryOrgCategoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryOrgCategoryResponse>(
    prepare(apiCommodityFrontCategoryOrgCategoryRequestConfig, requestData),
    ...args,
  )
}

apiCommodityFrontCategoryOrgCategory.requestConfig =
  apiCommodityFrontCategoryOrgCategoryRequestConfig

/**
 * 接口 [店铺分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267147) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategoryCommodity`
 */
export interface ApiCommodityFrontCategoryOrgCategoryCommodityRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 排序方式：true-正序 false-倒序
   */
  asc?: boolean
  /**
   * 分类id
   */
  categoryId?: string
  /**
   * 店铺id:子机构编码:unitOrgCode
   */
  merchantId?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序类型：1-默认排序 2-销量排序 3-价格排序
   */
  sortType?: number
}

/**
 * 接口 [店铺分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267147) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategoryCommodity`
 */
export type ApiCommodityFrontCategoryOrgCategoryCommodityResponse = {
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 商品Id
   */
  id?: string
  /**
   * 商品价格
   */
  price?: number
  /**
   * 销量
   */
  sales?: number
  /**
   * 店铺名称
   */
  store?: string
  /**
   * 副标题
   */
  subTitle?: string
  /**
   * 商品名称
   */
  title?: string
  /**
   * 跳转链接
   */
  url?: string
}[]

/**
 * 接口 [店铺分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267147) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategoryCommodity`
 */
type ApiCommodityFrontCategoryOrgCategoryCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/orgCategoryCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [店铺分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267147) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategoryCommodity`
 */
const apiCommodityFrontCategoryOrgCategoryCommodityRequestConfig: ApiCommodityFrontCategoryOrgCategoryCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_45,
    devUrl: devUrl_0_4_0_45,
    prodUrl: prodUrl_0_4_0_45,
    path: '/commodity/api/frontCategory/orgCategoryCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryOrgCategoryCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '店铺分类下商品列表', author: '520号开发' },
  }

/**
 * 接口 [店铺分类下商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/267147) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/orgCategoryCommodity`
 */
export const apiCommodityFrontCategoryOrgCategoryCommodity = /*#__PURE__*/ (
  requestData: ApiCommodityFrontCategoryOrgCategoryCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryOrgCategoryCommodityResponse>(
    prepare(
      apiCommodityFrontCategoryOrgCategoryCommodityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityFrontCategoryOrgCategoryCommodity.requestConfig =
  apiCommodityFrontCategoryOrgCategoryCommodityRequestConfig

/**
 * 接口 [查询三级分类信息↗](https://yapi.gogpay.cn/project/939/interface/api/267207) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/CategoryList`
 */
export interface ApiCommodityFrontCategoryCategoryListRequest {
  /**
   * 请求来源
   */
  adminSource?: 'IMS' | 'BUSINESS' | 'OPEN'
  /**
   * 三级分类Id
   */
  categoryId?: string
  /**
   * 三级分类名称-查询三级分类
   */
  categoryName?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [查询三级分类信息↗](https://yapi.gogpay.cn/project/939/interface/api/267207) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/CategoryList`
 */
export type ApiCommodityFrontCategoryCategoryListResponse = {
  /**
   * 三级分类id
   */
  categoryId?: string
  /**
   * 三级分类名称
   */
  categoryName?: string
  /**
   * 分类图片
   */
  categoryPic?: string
  /**
   * 分类级别
   */
  frontCategoryLevel?: number
  /**
   * 分类级别名称
   */
  frontCategoryLevelName?: string
  /**
   * 三级排序
   */
  sortNo?: number
}[]

/**
 * 接口 [查询三级分类信息↗](https://yapi.gogpay.cn/project/939/interface/api/267207) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/CategoryList`
 */
type ApiCommodityFrontCategoryCategoryListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/CategoryList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询三级分类信息↗](https://yapi.gogpay.cn/project/939/interface/api/267207) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/CategoryList`
 */
const apiCommodityFrontCategoryCategoryListRequestConfig: ApiCommodityFrontCategoryCategoryListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_45,
    devUrl: devUrl_0_4_0_45,
    prodUrl: prodUrl_0_4_0_45,
    path: '/commodity/api/frontCategory/CategoryList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryCategoryList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询三级分类信息', author: '520号开发' },
  }

/**
 * 接口 [查询三级分类信息↗](https://yapi.gogpay.cn/project/939/interface/api/267207) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/CategoryList`
 */
export const apiCommodityFrontCategoryCategoryList = /*#__PURE__*/ (
  requestData: ApiCommodityFrontCategoryCategoryListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryCategoryListResponse>(
    prepare(apiCommodityFrontCategoryCategoryListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityFrontCategoryCategoryList.requestConfig =
  apiCommodityFrontCategoryCategoryListRequestConfig

/**
 * 接口 [首页三级分类↗](https://yapi.gogpay.cn/project/939/interface/api/267666) 的 **请求类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/getHomeCategory`
 */
export interface ApiCommodityFrontCategoryGetHomeCategoryRequest {}

/**
 * 接口 [首页三级分类↗](https://yapi.gogpay.cn/project/939/interface/api/267666) 的 **返回类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/getHomeCategory`
 */
export type ApiCommodityFrontCategoryGetHomeCategoryResponse = {
  /**
   * 三级分类id
   */
  categoryId?: string
  /**
   * 三级分类名称
   */
  categoryName?: string
  /**
   * 分类图片
   */
  categoryPic?: string
  /**
   * 分类级别
   */
  frontCategoryLevel?: number
  /**
   * 分类级别名称
   */
  frontCategoryLevelName?: string
  /**
   * 三级排序
   */
  sortNo?: number
}[]

/**
 * 接口 [首页三级分类↗](https://yapi.gogpay.cn/project/939/interface/api/267666) 的 **请求配置的类型**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/getHomeCategory`
 */
type ApiCommodityFrontCategoryGetHomeCategoryRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/frontCategory/getHomeCategory',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [首页三级分类↗](https://yapi.gogpay.cn/project/939/interface/api/267666) 的 **请求配置**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/getHomeCategory`
 */
const apiCommodityFrontCategoryGetHomeCategoryRequestConfig: ApiCommodityFrontCategoryGetHomeCategoryRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_45,
    devUrl: devUrl_0_4_0_45,
    prodUrl: prodUrl_0_4_0_45,
    path: '/commodity/api/frontCategory/getHomeCategory',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityFrontCategoryGetHomeCategory',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '首页三级分类', author: '520号开发' },
  }

/**
 * 接口 [首页三级分类↗](https://yapi.gogpay.cn/project/939/interface/api/267666) 的 **请求函数**
 *
 * @作者 520号开发
 * @分类 [客户端-【中国红】类目管理/商品分类管理/平台↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46456)
 * @请求头 `POST /commodity/api/frontCategory/getHomeCategory`
 */
export const apiCommodityFrontCategoryGetHomeCategory = /*#__PURE__*/ (
  requestData?: ApiCommodityFrontCategoryGetHomeCategoryRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityFrontCategoryGetHomeCategoryResponse>(
    prepare(apiCommodityFrontCategoryGetHomeCategoryRequestConfig, requestData),
    ...args,
  )
}

apiCommodityFrontCategoryGetHomeCategory.requestConfig =
  apiCommodityFrontCategoryGetHomeCategoryRequestConfig

const mockUrl_0_4_0_48 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_48 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_48 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_48 = 'data' as any

/**
 * 接口 [Banner列表↗](https://yapi.gogpay.cn/project/939/interface/api/267063) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [移动端-【中国红】Banner管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46488)
 * @请求头 `POST /commodity/api/banner/list`
 */
export interface ApiCommodityBannerListRequest {}

/**
 * 接口 [Banner列表↗](https://yapi.gogpay.cn/project/939/interface/api/267063) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [移动端-【中国红】Banner管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46488)
 * @请求头 `POST /commodity/api/banner/list`
 */
export type ApiCommodityBannerListResponse = {
  /**
   * 图片
   */
  bannerImg?: string
  /**
   * 标题
   */
  bannerTitle?: string
  /**
   * banner数据ID
   */
  id?: string
  /**
   * 跳转地址
   */
  jumpAddress?: string
  /**
   * 所拥有数据权限分组
   */
  selectUserGroupId?: string
}[]

/**
 * 接口 [Banner列表↗](https://yapi.gogpay.cn/project/939/interface/api/267063) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [移动端-【中国红】Banner管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46488)
 * @请求头 `POST /commodity/api/banner/list`
 */
type ApiCommodityBannerListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/banner/list',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [Banner列表↗](https://yapi.gogpay.cn/project/939/interface/api/267063) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [移动端-【中国红】Banner管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46488)
 * @请求头 `POST /commodity/api/banner/list`
 */
const apiCommodityBannerListRequestConfig: ApiCommodityBannerListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_48,
    devUrl: devUrl_0_4_0_48,
    prodUrl: prodUrl_0_4_0_48,
    path: '/commodity/api/banner/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_48,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityBannerList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: 'Banner列表', author: '成龙' },
  }

/**
 * 接口 [Banner列表↗](https://yapi.gogpay.cn/project/939/interface/api/267063) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [移动端-【中国红】Banner管理↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46488)
 * @请求头 `POST /commodity/api/banner/list`
 */
export const apiCommodityBannerList = /*#__PURE__*/ (
  requestData?: ApiCommodityBannerListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityBannerListResponse>(
    prepare(apiCommodityBannerListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityBannerList.requestConfig = apiCommodityBannerListRequestConfig

const mockUrl_0_4_0_52 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_52 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_52 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_52 = 'data' as any

/**
 * 接口 [列表↗](https://yapi.gogpay.cn/project/939/interface/api/267615) 的 **请求类型**
 *
 * @作者 李诗凡
 * @分类 [移动端-【中国红】精选风物/超值推荐↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46636)
 * @请求头 `POST /commodity/api/handpick/pageList`
 */
export interface ApiCommodityHandpickPageListRequest {
  /**
   * 精选类型：0-精选风物 1-超值推荐
   */
  handpickType: number
}

/**
 * 接口 [列表↗](https://yapi.gogpay.cn/project/939/interface/api/267615) 的 **返回类型**
 *
 * @作者 李诗凡
 * @分类 [移动端-【中国红】精选风物/超值推荐↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46636)
 * @请求头 `POST /commodity/api/handpick/pageList`
 */
export type ApiCommodityHandpickPageListResponse = {
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品名称
   */
  commodityName?: string
  /**
   * 商品封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * ID
   */
  id?: string
  /**
   * 价格
   */
  price?: number
  /**
   * 序号
   */
  sortNo?: string
  /**
   * 虚拟销量
   */
  virtualSales?: number
}[]

/**
 * 接口 [列表↗](https://yapi.gogpay.cn/project/939/interface/api/267615) 的 **请求配置的类型**
 *
 * @作者 李诗凡
 * @分类 [移动端-【中国红】精选风物/超值推荐↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46636)
 * @请求头 `POST /commodity/api/handpick/pageList`
 */
type ApiCommodityHandpickPageListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/handpick/pageList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [列表↗](https://yapi.gogpay.cn/project/939/interface/api/267615) 的 **请求配置**
 *
 * @作者 李诗凡
 * @分类 [移动端-【中国红】精选风物/超值推荐↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46636)
 * @请求头 `POST /commodity/api/handpick/pageList`
 */
const apiCommodityHandpickPageListRequestConfig: ApiCommodityHandpickPageListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_52,
    devUrl: devUrl_0_4_0_52,
    prodUrl: prodUrl_0_4_0_52,
    path: '/commodity/api/handpick/pageList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_52,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityHandpickPageList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '列表', author: '李诗凡' },
  }

/**
 * 接口 [列表↗](https://yapi.gogpay.cn/project/939/interface/api/267615) 的 **请求函数**
 *
 * @作者 李诗凡
 * @分类 [移动端-【中国红】精选风物/超值推荐↗](https://yapi.gogpay.cn/project/939/interface/api/cat_46636)
 * @请求头 `POST /commodity/api/handpick/pageList`
 */
export const apiCommodityHandpickPageList = /*#__PURE__*/ (
  requestData: ApiCommodityHandpickPageListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityHandpickPageListResponse>(
    prepare(apiCommodityHandpickPageListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityHandpickPageList.requestConfig =
  apiCommodityHandpickPageListRequestConfig

const mockUrl_0_4_0_55 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_55 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_55 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_55 = 'data' as any

/**
 * 接口 [商品详情↗](https://yapi.gogpay.cn/project/939/interface/api/312090) 的 **请求类型**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/detail`
 */
export interface ApiCommodityHotelCommodityDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
}

/**
 * 接口 [商品详情↗](https://yapi.gogpay.cn/project/939/interface/api/312090) 的 **返回类型**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/detail`
 */
export interface ApiCommodityHotelCommodityDetailResponse {
  /**
   * 仅当isValidDay=0有效，需要提前x天预约购买
   */
  advanceDay?: number
  /**
   * 轮播图
   */
  carousePic?: string[]
  /**
   * 商品种类：0-套餐券 1-代金券
   */
  commodityClassifyType?: '0' | '1'
  /**
   * 商品详情
   */
  commodityDetail: string
  /**
   * 商品ID
   */
  commodityId?: string
  /**
   * 商品副标题
   */
  commoditySubTitle?: string
  /**
   * 商品标题
   */
  commodityTitle?: string
  /**
   * 封面图
   */
  coverPic?: string
  /**
   * 划线价格
   */
  dashPrice?: number
  /**
   * 是否当日有效：0-否 1-是
   */
  isValidDay?: 0 | 1
  /**
   * 最低价
   */
  lowestPrice?: number
  /**
   * 商户ID
   */
  merchantId?: string
  /**
   * 商户名称
   */
  merchantName?: string
  /**
   * 默认价格
   */
  price?: number
  /**
   * 购买须知
   */
  purchaseNotesDetail?: string
  /**
   * 同店推荐商品
   */
  recommendCommodity?: {
    /**
     * 轮播图
     */
    carousePic?: string[]
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 商品副标题
     */
    commoditySubTitle?: string
    /**
     * 商品标题
     */
    commodityTitle?: string
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价
     */
    dashPrice?: number
    /**
     * 最低价
     */
    lowestPrice?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * skuId集合
     */
    skuIds?: string[]
    /**
     * 库存类型：0-标准库存 3-日期库存
     */
    stockType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
  }[]
  /**
   * 运营渠道Id
   */
  refUserGroupId?: string
  /**
   * 关联商品列表
   */
  relatedCommodities?: {
    /**
     * 关联商品名称
     */
    commodityTitle?: string
    /**
     * 关联商品ID
     */
    relatedCommodityId?: string
  }[]
  /**
   * 销量
   */
  sales?: number
  /**
   * 销售价区间
   */
  sellPrices?: number[]
  /**
   * 旅游商品规格信息
   */
  skuList?: {
    /**
     * 默认展示：0-否 1-是
     */
    defaultShow: number
    endTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 初始库存
     */
    initStock: number
    /**
     * 单次核销价格
     */
    onePrice: number
    /**
     * 商品ID
     */
    refCommodityId: string
    /**
     * 店铺主键
     */
    refMerchantId: string
    /**
     * 销量
     */
    sales?: number
    /**
     * 商品售价
     */
    sellPrice: number
    /**
     * 结算方式：0-固定金额 1-分层比例
     */
    settlementType: 0 | 1
    /**
     * 结算值
     */
    settlementValue: number
    /**
     * 规格ID
     */
    skuId: string
    /**
     * SKU图
     */
    skuPic: string
    /**
     * 规格状态： 0-无效 1-有效
     */
    skuStatus: 0 | 1
    startTime?: {
      hour?: number
      minute?: number
      nano?: number
      second?: number
    }
    /**
     * 库存日期
     */
    stockDate?: string
    /**
     * 库存ID:第三方下单需要，非第三方和skuId一致
     */
    stockId: string
    /**
     * 剩余库存
     */
    surplusStock: number
    /**
     * 可核销次数
     */
    writeOffNum: number
  }[]
  /**
   * 库存类型： 0-标准库存 3-日期库存 5-时段
   */
  stockType: number
  store?: {
    /**
     * 店铺ID
     */
    storeId?: string
    /**
     * 评价星级
     */
    evaluateStat?: number
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺logo(店铺封面)
     */
    storeLogo?: string
    /**
     * 店铺相册(url列表)
     */
    photoAlbum?: string[]
    /**
     * 人均消费
     */
    consumeAvgAmt?: number
    /**
     * 商家联系电话
     */
    storePhone?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 详细地址
     */
    address?: string
    /**
     * 店铺状态 1-待上线 2-营业中 3-已停业 4-休息中
     */
    storeStatus?: number
  }
  taxRateDetail?: {
    /**
     * 税率名称
     */
    taxName: string
    /**
     * 税率编号
     */
    taxNo: string
    /**
     * 税率
     */
    taxRate: string
  }
  /**
   * 是否涉税：0-否 1-是
   */
  texFlag?: number
  /**
   * 店铺机构编码
   */
  unitOrgCode?: string
  /**
   * 套餐详情
   */
  writeOffCombos?: {
    /**
     * 分组详情列表
     */
    groupDetails?: {
      /**
       * 数量
       */
      num?: number
      /**
       * 价格
       */
      price?: number
      /**
       * 服务名称
       */
      serviceName?: string
    }[]
    /**
     * 分组名称
     */
    groupName?: string
  }[]
  /**
   * 套餐总价
   */
  writeOffCombosPrice?: number
  writeOffRefund?: {
    /**
     * 过期后退款比例
     */
    expireRate?: number
    /**
     * 退款无需审批
     */
    notApproveFlag?: boolean
    /**
     * 未使用退款比例
     */
    unusedRate?: number
  }
  writeOffStores?: {
    /**
     * 店铺联系电话
     */
    contactPhone: string
    /**
     * 店铺纬度
     */
    latitude: number
    /**
     * 店铺经度
     */
    longitude: number
    /**
     * 店铺地址
     */
    storeAddress: string
    /**
     * 店铺名称
     */
    storeName?: string
    /**
     * 店铺图片
     */
    storePic?: string
  }[]
}

/**
 * 接口 [商品详情↗](https://yapi.gogpay.cn/project/939/interface/api/312090) 的 **请求配置的类型**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/detail`
 */
type ApiCommodityHotelCommodityDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/hotelCommodity/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [商品详情↗](https://yapi.gogpay.cn/project/939/interface/api/312090) 的 **请求配置**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/detail`
 */
const apiCommodityHotelCommodityDetailRequestConfig: ApiCommodityHotelCommodityDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_55,
    devUrl: devUrl_0_4_0_55,
    prodUrl: prodUrl_0_4_0_55,
    path: '/commodity/api/hotelCommodity/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_55,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityHotelCommodityDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '商品详情', author: '514号开发' },
  }

/**
 * 接口 [商品详情↗](https://yapi.gogpay.cn/project/939/interface/api/312090) 的 **请求函数**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/detail`
 */
export const apiCommodityHotelCommodityDetail = /*#__PURE__*/ (
  requestData: ApiCommodityHotelCommodityDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityHotelCommodityDetailResponse>(
    prepare(apiCommodityHotelCommodityDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityHotelCommodityDetail.requestConfig =
  apiCommodityHotelCommodityDetailRequestConfig

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/312106) 的 **请求类型**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/marketingDetail`
 */
export interface ApiCommodityHotelCommodityMarketingDetailRequest {
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * skuId
   */
  skuId: string
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/312106) 的 **返回类型**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/marketingDetail`
 */
export interface ApiCommodityHotelCommodityMarketingDetailResponse {
  /**
   * 渠道积分抵扣
   */
  channelIntegrals?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  commodityBrand?: {
    /**
     * 背景色
     */
    backgroundColor: string
    /**
     * 按钮文案
     */
    buttonText: string
    /**
     * 产品介绍
     */
    commodityDetails: string[]
    /**
     * 商品ID
     */
    commodityId: string
    /**
     * 主图
     */
    mainImage: string
    /**
     * 商品是否品牌升级：0-否 1-是
     */
    status: number
    /**
     * 产品故事
     */
    story: string[]
    /**
     * 故事类型：0-图片 1-视频
     */
    storyType?: number
    /**
     * 跳转路由
     */
    targetUrl: string
    /**
     * 主题色
     */
    topicColor: string
  }
  /**
   * 折扣优惠
   */
  discounts?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullCoupons?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 优惠金额
     */
    discountAmt?: number
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 使用门槛；0表示无门槛
     */
    minPoint?: number
    /**
     * 领取状态：0=未领取，1=已领取
     */
    receiveStatus: number
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  /**
   * 满减优惠
   */
  fullReduce?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  groupBuying?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 商品Id
     */
    commodityId?: string
    groupData?: {
      /**
       * 团单信息
       */
      groupItems?: {
        /**
         * 团单购买商品Id
         */
        commodityId?: string
        /**
         * 拼团倒计时（秒),groupStatus=（0,1时返回）
         */
        finishCountDown?: number
        /**
         * 团单状态 1拼团中 2已成团 3拼团完成 4拼团失败
         */
        groupStatus?: number
        /**
         * 头像
         */
        headImg?: string
        /**
         * 下一阶段成团人数差距，groupStatus=(0,1)时返回
         */
        nextLevelCount?: number
        /**
         * 下一阶段退还金额,groupStatus=1时返回
         */
        nextLevelReturnAmount?: number
        /**
         * 团单订单Id
         */
        orderId?: string
        /**
         * 手机号码
         */
        userPhone?: string
      }[]
      /**
       * 正在拼单人数
       */
      userCount?: number
    }
    /**
     * 是否具备活动
     */
    hasActivity?: boolean
    /**
     * 规格列表
     */
    skuInfos?: {
      /**
       * 阶梯配置
       */
      ladderConfig?: {
        /**
         * 阶梯：1-一阶 2-...
         */
        ladder?: number
        /**
         * 阶梯价格
         */
        ladderPrice?: number
        /**
         * 阶梯人数
         */
        userNum?: number
      }[]
      /**
       * 最高价格
       */
      maxPrice?: number
      /**
       * 规格Id
       */
      skuId?: string
    }[]
  }
  limitPaymentChannel?: {
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 标签
     */
    label?: string
  }
  /**
   * 支付渠道优惠
   */
  payChannels?: {
    /**
     * 活动ID
     */
    activityId?: string
    /**
     * 活动名称
     */
    activityName?: string
    /**
     * 商品ID
     */
    commodityId?: string
    /**
     * 描述
     */
    describe?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 标签
     */
    label?: string
    /**
     * 规格ID
     */
    skuId?: string
    /**
     * 活动开始时间
     */
    startTime?: string
  }[]
  showTemplate?: {
    /**
     * 活动展示模板名称
     */
    activityShowTemplateName?: string
    /**
     * 背景图
     */
    backgroundImgUrl?: string
    /**
     * 划线价背景色
     */
    dashPriceBackgroundColor?: string
    /**
     * 划线价标签
     */
    dashPriceTag?: string
    /**
     * 划线价文字色
     */
    dashPriceTextColor?: string
    /**
     * 优惠后价格
     */
    discountPrice?: string
    /**
     * 活动结束时间
     */
    endTime?: string
    /**
     * 是否存在模板：0-否 1-是
     */
    hasTemplate?: number
    /**
     * 是否进行活动预告 0否1是
     */
    noticeFlag?: string
    /**
     * 活动预告时间
     */
    noticeTime?: string
    /**
     * 业务ID
     */
    refId?: string
    /**
     * 售价背景色
     */
    sellingPriceBackgroundColor?: string
    /**
     * 售价标签
     */
    sellingPriceTag?: string
    /**
     * 售价文字色
     */
    sellingPriceTextColor?: string
    /**
     * 活动开始时间
     */
    startTime?: string
    /**
     * 模板来源：0-折扣活动 1-通用活动
     */
    templateSource?: number
    /**
     * 模板类型：0-图片 1-图文并茂
     */
    templateType?: number
  }
}

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/312106) 的 **请求配置的类型**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/marketingDetail`
 */
type ApiCommodityHotelCommodityMarketingDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/hotelCommodity/marketingDetail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/312106) 的 **请求配置**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/marketingDetail`
 */
const apiCommodityHotelCommodityMarketingDetailRequestConfig: ApiCommodityHotelCommodityMarketingDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_55,
    devUrl: devUrl_0_4_0_55,
    prodUrl: prodUrl_0_4_0_55,
    path: '/commodity/api/hotelCommodity/marketingDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_55,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityHotelCommodityMarketingDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询营销信息', author: '514号开发' },
  }

/**
 * 接口 [查询营销信息↗](https://yapi.gogpay.cn/project/939/interface/api/312106) 的 **请求函数**
 *
 * @作者 514号开发
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/marketingDetail`
 */
export const apiCommodityHotelCommodityMarketingDetail = /*#__PURE__*/ (
  requestData: ApiCommodityHotelCommodityMarketingDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityHotelCommodityMarketingDetailResponse>(
    prepare(
      apiCommodityHotelCommodityMarketingDetailRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityHotelCommodityMarketingDetail.requestConfig =
  apiCommodityHotelCommodityMarketingDetailRequestConfig

/**
 * 接口 [查询类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/312858) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/sku/detail`
 */
export interface ApiCommodityHotelCommoditySkuDetailRequest {
  /**
   * 区县代码
   */
  areaCode: string
  /**
   * 城市代码
   */
  cityCode: string
  /**
   * 省份代码
   */
  provinceCode: string
  /**
   * 规格ID
   */
  skuId: string
  /**
   * 库存结束日期
   */
  stockEndDate?: string
  /**
   * 库存开始日期
   */
  stockStartDate?: string
}

/**
 * 接口 [查询类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/312858) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/sku/detail`
 */
export type ApiCommodityHotelCommoditySkuDetailResponse = {
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow: number
  endTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 初始库存
   */
  initStock: number
  /**
   * 单次核销价格
   */
  onePrice: number
  /**
   * 商品ID
   */
  refCommodityId: string
  /**
   * 店铺主键
   */
  refMerchantId: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 商品售价
   */
  sellPrice: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType: 0 | 1
  /**
   * 结算值
   */
  settlementValue: number
  /**
   * 规格ID
   */
  skuId: string
  /**
   * SKU图
   */
  skuPic: string
  /**
   * 规格状态： 0-无效 1-有效
   */
  skuStatus: 0 | 1
  startTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存ID:第三方下单需要，非第三方和skuId一致
   */
  stockId: string
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 可核销次数
   */
  writeOffNum: number
}[]

/**
 * 接口 [查询类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/312858) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/sku/detail`
 */
type ApiCommodityHotelCommoditySkuDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/hotelCommodity/sku/detail',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/312858) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/sku/detail`
 */
const apiCommodityHotelCommoditySkuDetailRequestConfig: ApiCommodityHotelCommoditySkuDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_55,
    devUrl: devUrl_0_4_0_55,
    prodUrl: prodUrl_0_4_0_55,
    path: '/commodity/api/hotelCommodity/sku/detail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_55,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityHotelCommoditySkuDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询类商品规格详情', author: '成龙' },
  }

/**
 * 接口 [查询类商品规格详情↗](https://yapi.gogpay.cn/project/939/interface/api/312858) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [前台-酒店商品基本信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_53936)
 * @请求头 `POST /commodity/api/hotelCommodity/sku/detail`
 */
export const apiCommodityHotelCommoditySkuDetail = /*#__PURE__*/ (
  requestData: ApiCommodityHotelCommoditySkuDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityHotelCommoditySkuDetailResponse>(
    prepare(apiCommodityHotelCommoditySkuDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityHotelCommoditySkuDetail.requestConfig =
  apiCommodityHotelCommoditySkuDetailRequestConfig

const mockUrl_0_4_0_56 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_56 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_56 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_56 = 'data' as any

/**
 * 接口 [获取场景热搜词↗](https://yapi.gogpay.cn/project/939/interface/api/268053) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSceneDetail`
 */
export interface ApiCommodityMartSearchFindSceneDetailRequest {}

/**
 * 接口 [获取场景热搜词↗](https://yapi.gogpay.cn/project/939/interface/api/268053) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSceneDetail`
 */
export type ApiCommodityMartSearchFindSceneDetailResponse = string

/**
 * 接口 [获取场景热搜词↗](https://yapi.gogpay.cn/project/939/interface/api/268053) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSceneDetail`
 */
type ApiCommodityMartSearchFindSceneDetailRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/martSearch/findSceneDetail',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取场景热搜词↗](https://yapi.gogpay.cn/project/939/interface/api/268053) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSceneDetail`
 */
const apiCommodityMartSearchFindSceneDetailRequestConfig: ApiCommodityMartSearchFindSceneDetailRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_56,
    devUrl: devUrl_0_4_0_56,
    prodUrl: prodUrl_0_4_0_56,
    path: '/commodity/api/martSearch/findSceneDetail',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_56,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityMartSearchFindSceneDetail',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取场景热搜词', author: '成龙' },
  }

/**
 * 接口 [获取场景热搜词↗](https://yapi.gogpay.cn/project/939/interface/api/268053) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSceneDetail`
 */
export const apiCommodityMartSearchFindSceneDetail = /*#__PURE__*/ (
  requestData?: ApiCommodityMartSearchFindSceneDetailRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityMartSearchFindSceneDetailResponse>(
    prepare(apiCommodityMartSearchFindSceneDetailRequestConfig, requestData),
    ...args,
  )
}

apiCommodityMartSearchFindSceneDetail.requestConfig =
  apiCommodityMartSearchFindSceneDetailRequestConfig

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/939/interface/api/268056) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSearchFilter`
 */
export interface ApiCommodityMartSearchFindSearchFilterRequest {}

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/939/interface/api/268056) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSearchFilter`
 */
export type ApiCommodityMartSearchFindSearchFilterResponse = string[]

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/939/interface/api/268056) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSearchFilter`
 */
type ApiCommodityMartSearchFindSearchFilterRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/martSearch/findSearchFilter',
    'data',
    string,
    string,
    true
  >
>

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/939/interface/api/268056) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSearchFilter`
 */
const apiCommodityMartSearchFindSearchFilterRequestConfig: ApiCommodityMartSearchFindSearchFilterRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_56,
    devUrl: devUrl_0_4_0_56,
    prodUrl: prodUrl_0_4_0_56,
    path: '/commodity/api/martSearch/findSearchFilter',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_56,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityMartSearchFindSearchFilter',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '获取搜索条件', author: '成龙' },
  }

/**
 * 接口 [获取搜索条件↗](https://yapi.gogpay.cn/project/939/interface/api/268056) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/findSearchFilter`
 */
export const apiCommodityMartSearchFindSearchFilter = /*#__PURE__*/ (
  requestData?: ApiCommodityMartSearchFindSearchFilterRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityMartSearchFindSearchFilterResponse>(
    prepare(apiCommodityMartSearchFindSearchFilterRequestConfig, requestData),
    ...args,
  )
}

apiCommodityMartSearchFindSearchFilter.requestConfig =
  apiCommodityMartSearchFindSearchFilterRequestConfig

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/939/interface/api/268059) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchCommodity`
 */
export interface ApiCommodityMartSearchSearchCommodityRequest {
  clientType?: '1' | '2'
  headerChannel?: string[]
  /**
   * 搜索关键词
   */
  keyword?: string
  /**
   * 最高价
   */
  maxPrice?: number
  /**
   * 最低价
   */
  minPrice?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 排序类型 1综合 2好评 3销量 4低价优先 5高价优先
   */
  sortType?: number
  /**
   * 筛选类型 1商品 2店铺
   */
  type?: number
}

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/939/interface/api/268059) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchCommodity`
 */
export interface ApiCommodityMartSearchSearchCommodityResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 数据Id
     */
    id?: string
    /**
     * 封面图
     */
    image?: string
    /**
     * 价格
     */
    price?: number
    /**
     * 评价分数
     */
    stars?: number
    /**
     * 所属店铺Id
     */
    storeId?: string
    /**
     * 所属店铺名称
     */
    storeName?: string
    /**
     * 副标题
     */
    subTitle?: string
    /**
     * 商品名称/店铺名称
     */
    title?: string
    /**
     * 数据类型 1商品 2店铺
     */
    type?: number
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/939/interface/api/268059) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchCommodity`
 */
type ApiCommodityMartSearchSearchCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/martSearch/searchCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/939/interface/api/268059) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchCommodity`
 */
const apiCommodityMartSearchSearchCommodityRequestConfig: ApiCommodityMartSearchSearchCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_56,
    devUrl: devUrl_0_4_0_56,
    prodUrl: prodUrl_0_4_0_56,
    path: '/commodity/api/martSearch/searchCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_56,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityMartSearchSearchCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '搜索商品', author: '成龙' },
  }

/**
 * 接口 [搜索商品↗](https://yapi.gogpay.cn/project/939/interface/api/268059) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchCommodity`
 */
export const apiCommodityMartSearchSearchCommodity = /*#__PURE__*/ (
  requestData: ApiCommodityMartSearchSearchCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityMartSearchSearchCommodityResponse>(
    prepare(apiCommodityMartSearchSearchCommodityRequestConfig, requestData),
    ...args,
  )
}

apiCommodityMartSearchSearchCommodity.requestConfig =
  apiCommodityMartSearchSearchCommodityRequestConfig

/**
 * 接口 [关键词搜索↗](https://yapi.gogpay.cn/project/939/interface/api/268062) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchKeyword`
 */
export interface ApiCommodityMartSearchSearchKeywordRequest {
  /**
   * 关键词
   */
  keyword?: string
}

/**
 * 接口 [关键词搜索↗](https://yapi.gogpay.cn/project/939/interface/api/268062) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchKeyword`
 */
export type ApiCommodityMartSearchSearchKeywordResponse = {
  /**
   * 关键词
   */
  keywords?: string[]
  /**
   * 标题
   */
  title?: string
}[]

/**
 * 接口 [关键词搜索↗](https://yapi.gogpay.cn/project/939/interface/api/268062) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchKeyword`
 */
type ApiCommodityMartSearchSearchKeywordRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/martSearch/searchKeyword',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [关键词搜索↗](https://yapi.gogpay.cn/project/939/interface/api/268062) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchKeyword`
 */
const apiCommodityMartSearchSearchKeywordRequestConfig: ApiCommodityMartSearchSearchKeywordRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_56,
    devUrl: devUrl_0_4_0_56,
    prodUrl: prodUrl_0_4_0_56,
    path: '/commodity/api/martSearch/searchKeyword',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_56,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityMartSearchSearchKeyword',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '关键词搜索', author: '成龙' },
  }

/**
 * 接口 [关键词搜索↗](https://yapi.gogpay.cn/project/939/interface/api/268062) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/searchKeyword`
 */
export const apiCommodityMartSearchSearchKeyword = /*#__PURE__*/ (
  requestData: ApiCommodityMartSearchSearchKeywordRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityMartSearchSearchKeywordResponse>(
    prepare(apiCommodityMartSearchSearchKeywordRequestConfig, requestData),
    ...args,
  )
}

apiCommodityMartSearchSearchKeyword.requestConfig =
  apiCommodityMartSearchSearchKeywordRequestConfig

/**
 * 接口 [【酒店及门票搜索使用】查询酒店类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/312866) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/sku/list`
 */
export interface ApiCommodityMartSearchSkuListRequest {
  /**
   * 市级地区编码
   */
  cityCode?: string
  /**
   * 商品类型 7酒店 4门票
   */
  commodityType?: number
  /**
   * 区县编码
   */
  countyCode?: string
  /**
   * 距离
   */
  distance?: number
  /**
   * 星级 1-5星
   */
  evaluateStat?: number[]
  /**
   * 关键字
   */
  keyword?: string
  /**
   * 纬度
   */
  lat?: string
  /**
   * 经度
   */
  lng?: string
  /**
   * 最高价
   */
  maxPrice?: number
  /**
   * 最低价
   */
  minPrice?: number
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
  /**
   * 省级地区编码
   */
  provinceCode?: string
  /**
   * 排序 0-好评率 1-评分星级  2-位置距离 3-低价格 4-高价格 5-销量
   */
  sort?: string
  /**
   * 库存结束时间
   */
  stockDateEnd?: string
  /**
   * 库存开始时间
   */
  stockDateStart?: string
}

/**
 * 接口 [【酒店及门票搜索使用】查询酒店类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/312866) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/sku/list`
 */
export type ApiCommodityMartSearchSkuListResponse = {
  /**
   * 默认展示：0-否 1-是
   */
  defaultShow: number
  endTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 初始库存
   */
  initStock: number
  /**
   * 单次核销价格
   */
  onePrice: number
  /**
   * 商品ID
   */
  refCommodityId: string
  /**
   * 店铺主键
   */
  refMerchantId: string
  /**
   * 销量
   */
  sales?: number
  /**
   * 商品售价
   */
  sellPrice: number
  /**
   * 结算方式：0-固定金额 1-分层比例
   */
  settlementType: 0 | 1
  /**
   * 结算值
   */
  settlementValue: number
  /**
   * 规格ID
   */
  skuId: string
  /**
   * SKU图
   */
  skuPic: string
  /**
   * 规格状态： 0-无效 1-有效
   */
  skuStatus: 0 | 1
  startTime?: {
    hour?: number
    minute?: number
    nano?: number
    second?: number
  }
  /**
   * 库存日期
   */
  stockDate?: string
  /**
   * 库存ID:第三方下单需要，非第三方和skuId一致
   */
  stockId: string
  /**
   * 剩余库存
   */
  surplusStock: number
  /**
   * 可核销次数
   */
  writeOffNum: number
}[]

/**
 * 接口 [【酒店及门票搜索使用】查询酒店类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/312866) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/sku/list`
 */
type ApiCommodityMartSearchSkuListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/martSearch/sku/list',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [【酒店及门票搜索使用】查询酒店类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/312866) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/sku/list`
 */
const apiCommodityMartSearchSkuListRequestConfig: ApiCommodityMartSearchSkuListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_56,
    devUrl: devUrl_0_4_0_56,
    prodUrl: prodUrl_0_4_0_56,
    path: '/commodity/api/martSearch/sku/list',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_56,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityMartSearchSkuList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {
      title: '【酒店及门票搜索使用】查询酒店类商品规格列表',
      author: '成龙',
    },
  }

/**
 * 接口 [【酒店及门票搜索使用】查询酒店类商品规格列表↗](https://yapi.gogpay.cn/project/939/interface/api/312866) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [【中国红】-客户端-搜索↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54160)
 * @请求头 `POST /commodity/api/martSearch/sku/list`
 */
export const apiCommodityMartSearchSkuList = /*#__PURE__*/ (
  requestData: ApiCommodityMartSearchSkuListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityMartSearchSkuListResponse>(
    prepare(apiCommodityMartSearchSkuListRequestConfig, requestData),
    ...args,
  )
}

apiCommodityMartSearchSkuList.requestConfig =
  apiCommodityMartSearchSkuListRequestConfig

const mockUrl_0_4_0_57 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_57 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_57 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_57 = 'data' as any

/**
 * 接口 [提交定制游需求↗](https://yapi.gogpay.cn/project/939/interface/api/315594) 的 **请求类型**
 *
 * @作者 成龙
 * @分类 [中国红-定制游↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54728)
 * @请求头 `POST /commodity/api/travel/custom/submit`
 */
export interface ApiCommodityTravelCustomSubmitRequest {
  /**
   * 游玩天数
   */
  days: number
  /**
   * 区县编码
   */
  districtCode: string
  /**
   * 区县名称
   */
  districtName: string
  /**
   * 游玩人数
   */
  personCount: number
  /**
   * 联系电话
   */
  phone: string
  /**
   * 类型 1个人  2团建
   */
  type: number
}

/**
 * 接口 [提交定制游需求↗](https://yapi.gogpay.cn/project/939/interface/api/315594) 的 **返回类型**
 *
 * @作者 成龙
 * @分类 [中国红-定制游↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54728)
 * @请求头 `POST /commodity/api/travel/custom/submit`
 */
export interface ApiCommodityTravelCustomSubmitResponse {
  msg?: string
  status?: number
  success?: boolean
}

/**
 * 接口 [提交定制游需求↗](https://yapi.gogpay.cn/project/939/interface/api/315594) 的 **请求配置的类型**
 *
 * @作者 成龙
 * @分类 [中国红-定制游↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54728)
 * @请求头 `POST /commodity/api/travel/custom/submit`
 */
type ApiCommodityTravelCustomSubmitRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/travel/custom/submit',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [提交定制游需求↗](https://yapi.gogpay.cn/project/939/interface/api/315594) 的 **请求配置**
 *
 * @作者 成龙
 * @分类 [中国红-定制游↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54728)
 * @请求头 `POST /commodity/api/travel/custom/submit`
 */
const apiCommodityTravelCustomSubmitRequestConfig: ApiCommodityTravelCustomSubmitRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_57,
    devUrl: devUrl_0_4_0_57,
    prodUrl: prodUrl_0_4_0_57,
    path: '/commodity/api/travel/custom/submit',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_57,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityTravelCustomSubmit',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '提交定制游需求', author: '成龙' },
  }

/**
 * 接口 [提交定制游需求↗](https://yapi.gogpay.cn/project/939/interface/api/315594) 的 **请求函数**
 *
 * @作者 成龙
 * @分类 [中国红-定制游↗](https://yapi.gogpay.cn/project/939/interface/api/cat_54728)
 * @请求头 `POST /commodity/api/travel/custom/submit`
 */
export const apiCommodityTravelCustomSubmit = /*#__PURE__*/ (
  requestData: ApiCommodityTravelCustomSubmitRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityTravelCustomSubmitResponse>(
    prepare(apiCommodityTravelCustomSubmitRequestConfig, requestData),
    ...args,
  )
}

apiCommodityTravelCustomSubmit.requestConfig =
  apiCommodityTravelCustomSubmitRequestConfig

const mockUrl_0_4_0_62 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_62 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_62 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_62 = 'data' as any

/**
 * 接口 [查询85券可兑换商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/406363) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeGoodsList`
 */
export interface ApiCommodityVirtualExchangeFindExchangeGoodsListRequest {
  /**
   * 数据Id(商品id、skuId、专题id、分类Id)
   */
  id?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [查询85券可兑换商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/406363) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeGoodsList`
 */
export interface ApiCommodityVirtualExchangeFindExchangeGoodsListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 可兑换商品列表
     */
    commodityInfos?: {
      /**
       * 子商品ID
       */
      childCommodityId?: string
      /**
       * 子商品图片
       */
      childCommodityPic?: string
      /**
       * 子商品规格ID
       */
      childSkuId?: string
      /**
       * 子商品名称
       */
      commodityName?: string
      /**
       * 商品剩余库存（可划拨库存）
       */
      commodityStock?: number
      /**
       * 划拨库存
       */
      cutStock: number
      /**
       * 兑换商品类型 0标电 1标销 1001消费券 1002券池堆售
       */
      exchangeCommodityType?: number
      /**
       * 店铺名称
       */
      merchantName?: string
      /**
       * 库存活动Id
       */
      stockActivityId?: string
      /**
       * 商品总库存 当前剩余加上已划拨
       */
      totalStock?: number
      /**
       * 可以核销次数/兑换券张数
       */
      writeOffNum?: number
    }[]
    /**
     * 配置商品名称
     */
    commodityName?: string
    /**
     * 配置商品图片
     */
    commodityPic?: string
    /**
     * 配置商品单价
     */
    commodityPrice?: number
    /**
     * 可兑换商品总库存
     */
    commodityTotalStock?: number
    /**
     * 有效期结束时间
     */
    endTime?: string
    id?: string
    /**
     * 配置套餐内容
     */
    packageContent?: string
    /**
     * 有效期开始时间
     */
    startTime?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [查询85券可兑换商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/406363) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeGoodsList`
 */
type ApiCommodityVirtualExchangeFindExchangeGoodsListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/virtualExchange/findExchangeGoodsList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [查询85券可兑换商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/406363) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeGoodsList`
 */
const apiCommodityVirtualExchangeFindExchangeGoodsListRequestConfig: ApiCommodityVirtualExchangeFindExchangeGoodsListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_62,
    devUrl: devUrl_0_4_0_62,
    prodUrl: prodUrl_0_4_0_62,
    path: '/commodity/api/virtualExchange/findExchangeGoodsList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_62,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityVirtualExchangeFindExchangeGoodsList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '查询85券可兑换商品列表', author: '511号开发' },
  }

/**
 * 接口 [查询85券可兑换商品列表↗](https://yapi.gogpay.cn/project/939/interface/api/406363) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeGoodsList`
 */
export const apiCommodityVirtualExchangeFindExchangeGoodsList = /*#__PURE__*/ (
  requestData: ApiCommodityVirtualExchangeFindExchangeGoodsListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityVirtualExchangeFindExchangeGoodsListResponse>(
    prepare(
      apiCommodityVirtualExchangeFindExchangeGoodsListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityVirtualExchangeFindExchangeGoodsList.requestConfig =
  apiCommodityVirtualExchangeFindExchangeGoodsListRequestConfig

/**
 * 接口 [85券兑换商品详情库存↗](https://yapi.gogpay.cn/project/939/interface/api/406373) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/getSkuStock`
 */
export interface ApiCommodityVirtualExchangeGetSkuStockRequest {
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品类型
   */
  commodityType?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '1001' | '1002'
  /**
   * 划拨的库存信息
   */
  cutStock?: number
  /**
   * 父级商品Id
   */
  parentCommodityId?: string
  /**
   * skuId
   */
  skuId?: string
}

/**
 * 接口 [85券兑换商品详情库存↗](https://yapi.gogpay.cn/project/939/interface/api/406373) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/getSkuStock`
 */
export interface ApiCommodityVirtualExchangeGetSkuStockResponse {
  /**
   * 商品Id
   */
  commodityId?: string
  /**
   * 商品类型
   */
  commodityType?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '1001' | '1002'
  /**
   * 划拨的库存信息
   */
  cutStock?: number
  /**
   * 父级商品Id
   */
  parentCommodityId?: string
  /**
   * skuId
   */
  skuId?: string
}

/**
 * 接口 [85券兑换商品详情库存↗](https://yapi.gogpay.cn/project/939/interface/api/406373) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/getSkuStock`
 */
type ApiCommodityVirtualExchangeGetSkuStockRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/virtualExchange/getSkuStock',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [85券兑换商品详情库存↗](https://yapi.gogpay.cn/project/939/interface/api/406373) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/getSkuStock`
 */
const apiCommodityVirtualExchangeGetSkuStockRequestConfig: ApiCommodityVirtualExchangeGetSkuStockRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_62,
    devUrl: devUrl_0_4_0_62,
    prodUrl: prodUrl_0_4_0_62,
    path: '/commodity/api/virtualExchange/getSkuStock',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_62,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityVirtualExchangeGetSkuStock',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '85券兑换商品详情库存', author: '511号开发' },
  }

/**
 * 接口 [85券兑换商品详情库存↗](https://yapi.gogpay.cn/project/939/interface/api/406373) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/getSkuStock`
 */
export const apiCommodityVirtualExchangeGetSkuStock = /*#__PURE__*/ (
  requestData: ApiCommodityVirtualExchangeGetSkuStockRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityVirtualExchangeGetSkuStockResponse>(
    prepare(apiCommodityVirtualExchangeGetSkuStockRequestConfig, requestData),
    ...args,
  )
}

apiCommodityVirtualExchangeGetSkuStock.requestConfig =
  apiCommodityVirtualExchangeGetSkuStockRequestConfig

/**
 * 接口 [85券商品可兑换店铺列表↗](https://yapi.gogpay.cn/project/939/interface/api/406448) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeStoreList`
 */
export interface ApiCommodityVirtualExchangeFindExchangeStoreListRequest {
  /**
   * 数据Id(商品id、skuId、专题id、分类Id)
   */
  id?: string
  /**
   * 关键字
   */
  keyWord?: string
  /**
   * 纬度
   */
  latitude?: string
  /**
   * 经度
   */
  longitude?: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [85券商品可兑换店铺列表↗](https://yapi.gogpay.cn/project/939/interface/api/406448) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeStoreList`
 */
export interface ApiCommodityVirtualExchangeFindExchangeStoreListResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 子商品ID
     */
    childCommodityId?: string
    /**
     * 子商品图片
     */
    childCommodityPic?: string
    /**
     * 子商品名称
     */
    commodityName?: string
    /**
     * 商品类型
     */
    commodityType?: number
    /**
     * 剩余库存
     */
    cutStock: number
    /**
     * 配置兑换商品Id
     */
    exchangeCommodityId: string
    /**
     * 纬度
     */
    latitude?: string
    /**
     * 经度
     */
    longitude?: string
    /**
     * 店铺地址
     */
    merchantAddress?: string
    /**
     * 店铺距离
     */
    merchantDistance?: string
    /**
     * 店铺名称
     */
    merchantName?: string
    /**
     * 店铺联系电话
     */
    merchantPhone?: string
    /**
     * 子商品规格ID
     */
    skuId?: string
    /**
     * 库存活动Id
     */
    stockActivityId?: string
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [85券商品可兑换店铺列表↗](https://yapi.gogpay.cn/project/939/interface/api/406448) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeStoreList`
 */
type ApiCommodityVirtualExchangeFindExchangeStoreListRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/virtualExchange/findExchangeStoreList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [85券商品可兑换店铺列表↗](https://yapi.gogpay.cn/project/939/interface/api/406448) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeStoreList`
 */
const apiCommodityVirtualExchangeFindExchangeStoreListRequestConfig: ApiCommodityVirtualExchangeFindExchangeStoreListRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_62,
    devUrl: devUrl_0_4_0_62,
    prodUrl: prodUrl_0_4_0_62,
    path: '/commodity/api/virtualExchange/findExchangeStoreList',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_62,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityVirtualExchangeFindExchangeStoreList',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '85券商品可兑换店铺列表', author: '511号开发' },
  }

/**
 * 接口 [85券商品可兑换店铺列表↗](https://yapi.gogpay.cn/project/939/interface/api/406448) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [客户端-85兑换券相关↗](https://yapi.gogpay.cn/project/939/interface/api/cat_72013)
 * @请求头 `POST /commodity/api/virtualExchange/findExchangeStoreList`
 */
export const apiCommodityVirtualExchangeFindExchangeStoreList = /*#__PURE__*/ (
  requestData: ApiCommodityVirtualExchangeFindExchangeStoreListRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityVirtualExchangeFindExchangeStoreListResponse>(
    prepare(
      apiCommodityVirtualExchangeFindExchangeStoreListRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityVirtualExchangeFindExchangeStoreList.requestConfig =
  apiCommodityVirtualExchangeFindExchangeStoreListRequestConfig

const mockUrl_0_4_0_67 = 'https://yapi.gogpay.cn/mock/939' as any
const devUrl_0_4_0_67 = 'https://mall-gw.duotest.cn' as any
const prodUrl_0_4_0_67 = 'https://mall-gw.gogpay.cn' as any
const dataKey_0_4_0_67 = 'data' as any

/**
 * 接口 [批量获取店铺商品↗](https://yapi.gogpay.cn/project/939/interface/api/458638) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantCommodity`
 */
export interface ApiCommodityCommonCommodityBatchMerchantCommodityRequest {
  /**
   * 商品上下架状态
   */
  commodityStatus: number
  /**
   * 商品类型
   */
  commodityType: number
  /**
   * 商品门店Id
   */
  merchantId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [批量获取店铺商品↗](https://yapi.gogpay.cn/project/939/interface/api/458638) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantCommodity`
 */
export interface ApiCommodityCommonCommodityBatchMerchantCommodityResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品类型 0-标准电商 1-标准核销 2-标准虚拟 3-组合核销
     */
    commodityType?: number
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 商品ID
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * sku最低价格
     */
    price?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * 标准电商虚拟规格列表
     */
    skuList?: {
      /**
       * 13位国家69码
       */
      barCode?: string
      /**
       * 渠道款式 1 线上款 2 线下款
       */
      channelStyle: 1 | 2
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 商品来源sku编号
       */
      commodityResourceSkuId?: string
      /**
       * 成本价
       */
      commoditySkuCost: number
      /**
       * SKU价格
       */
      commoditySkuPrice: number
      /**
       * sku库存
       */
      commodityStock: number
      /**
       * 默认展示:0-否 1-是
       */
      defaultShow: number
      /**
       * 是否第三方库存:0-否 1-是
       */
      edgeStockStatus?: number
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * SKU主键
       */
      id: string
      /**
       * 发票sku型号
       */
      invoiceSkuCode?: string
      saleVoucher: {
        /**
         * 商品sku截图 线上款必填
         */
        commodityPics: string[]
        /**
         * 比价链接 线上款必填
         */
        comparePriceUrl: string
        /**
         * 销售凭证图片链接 线下款必填
         */
        saleVoucherPics: string[]
      }
      /**
       * 销量
       */
      sales?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * 规格名称
       */
      skuName?: string
      /**
       * SKU商品图
       */
      skuPic: string
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * SKU状态:0-无效 1-有效
       */
      skuStatus: number
      /**
       * 库存预警值
       */
      stockAlertCount: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 用户限购量不能为空（0不限制）
       */
      userLimitPurchases: number
      /**
       * 重量(千克)
       */
      weight: number
    }[]
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 上下架状态：-2-草稿 -1-待入库 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 标准核销商品规格列表
     */
    writeOffSkuList?: {
      /**
       * 13位国家69码
       */
      barCode?: string
      /**
       * 库存
       */
      commodityStock: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 是否第三方库存:0-否 1-是
       */
      edgeStockStatus?: number
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * 结束库存日期
       */
      endStockDate: string
      /**
       * id
       */
      id?: string
      /**
       * 发票sku型号
       */
      invoiceSkuCode?: string
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 真实销量
       */
      sales?: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId?: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      /**
       * 规格名称
       */
      specName: string
      /**
       * 规格值
       */
      specValue: string
      /**
       * 特殊时间：0-无 1-周一至周五 2-周末 3-指定时间
       */
      specialTimeType: 0 | 1 | 2 | 3
      /**
       * 指定日期集合
       */
      specifyDates: unknown[]
      /**
       * 开始库存日期
       */
      startStockDate: string
      /**
       * 库存日期
       */
      stockDate: string
      /**
       * 库存类型：0-标准库存 3-日期库存
       */
      stockType: 0 | 1 | 2 | 3 | 4 | 5
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [批量获取店铺商品↗](https://yapi.gogpay.cn/project/939/interface/api/458638) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantCommodity`
 */
type ApiCommodityCommonCommodityBatchMerchantCommodityRequestConfig = Readonly<
  RequestConfig<
    'https://yapi.gogpay.cn/mock/939',
    'https://mall-gw.duotest.cn',
    'https://mall-gw.gogpay.cn',
    '/commodity/api/commonCommodity/batchMerchantCommodity',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 [批量获取店铺商品↗](https://yapi.gogpay.cn/project/939/interface/api/458638) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantCommodity`
 */
const apiCommodityCommonCommodityBatchMerchantCommodityRequestConfig: ApiCommodityCommonCommodityBatchMerchantCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_67,
    devUrl: devUrl_0_4_0_67,
    prodUrl: prodUrl_0_4_0_67,
    path: '/commodity/api/commonCommodity/batchMerchantCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_67,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: 'apiCommodityCommonCommodityBatchMerchantCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量获取店铺商品', author: '511号开发' },
  }

/**
 * 接口 [批量获取店铺商品↗](https://yapi.gogpay.cn/project/939/interface/api/458638) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantCommodity`
 */
export const apiCommodityCommonCommodityBatchMerchantCommodity = /*#__PURE__*/ (
  requestData: ApiCommodityCommonCommodityBatchMerchantCommodityRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ApiCommodityCommonCommodityBatchMerchantCommodityResponse>(
    prepare(
      apiCommodityCommonCommodityBatchMerchantCommodityRequestConfig,
      requestData,
    ),
    ...args,
  )
}

apiCommodityCommonCommodityBatchMerchantCommodity.requestConfig =
  apiCommodityCommonCommodityBatchMerchantCommodityRequestConfig

/**
 * 接口 [批量获取店铺线下商品↗](https://yapi.gogpay.cn/project/939/interface/api/477335) 的 **请求类型**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantOfflineCommodity`
 */
export interface ApiCommodityCommonCommodityBatchMerchantOfflineCommodityRequest {
  /**
   * 商品上下架状态
   */
  commodityStatus: number
  /**
   * 商品类型
   */
  commodityType: number
  /**
   * 商品门店Id
   */
  merchantId: string
  /**
   * 当前页数，从1开始
   */
  pageIndex?: number
  /**
   * 显示条数
   */
  pageSize?: number
}

/**
 * 接口 [批量获取店铺线下商品↗](https://yapi.gogpay.cn/project/939/interface/api/477335) 的 **返回类型**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantOfflineCommodity`
 */
export interface ApiCommodityCommonCommodityBatchMerchantOfflineCommodityResponse {
  /**
   * 数据列表
   */
  list?: {
    /**
     * 商品类型 0-标准电商 1-标准核销 2-标准虚拟 3-组合核销
     */
    commodityType?: number
    /**
     * 封面图
     */
    coverPic?: string
    /**
     * 划线价格
     */
    dashPrice?: number
    /**
     * 商品ID
     */
    id?: string
    /**
     * 商品名称
     */
    name?: string
    /**
     * sku最低价格
     */
    price?: number
    /**
     * 销量
     */
    sales?: number
    /**
     * 标准电商虚拟规格列表
     */
    skuList?: {
      /**
       * 13位国家69码
       */
      barCode?: string
      /**
       * 渠道款式 1 线上款 2 线下款
       */
      channelStyle: 1 | 2
      /**
       * 商品ID
       */
      commodityId: string
      /**
       * 商品来源sku编号
       */
      commodityResourceSkuId?: string
      /**
       * 成本价
       */
      commoditySkuCost: number
      /**
       * SKU价格
       */
      commoditySkuPrice: number
      /**
       * sku库存
       */
      commodityStock: number
      /**
       * 默认展示:0-否 1-是
       */
      defaultShow: number
      /**
       * 是否第三方库存:0-否 1-是
       */
      edgeStockStatus?: number
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * SKU主键
       */
      id: string
      /**
       * 发票sku型号
       */
      invoiceSkuCode?: string
      saleVoucher: {
        /**
         * 商品sku截图 线上款必填
         */
        commodityPics: string[]
        /**
         * 比价链接 线上款必填
         */
        comparePriceUrl: string
        /**
         * 销售凭证图片链接 线下款必填
         */
        saleVoucherPics: string[]
      }
      /**
       * 销量
       */
      sales?: number
      /**
       * 商品单日限购量（0不限制）
       */
      singleDayLimitPurchases: number
      /**
       * SKU唯一参数标识
       */
      skuId: string
      /**
       * 规格名称
       */
      skuName?: string
      /**
       * SKU商品图
       */
      skuPic: string
      /**
       * sku规格
       */
      skuSpecs: {
        /**
         * sku属性名称
         */
        attributeName?: string
        selected: {
          /**
           * 参数ID
           */
          id: string
          /**
           * 参数键(2.0废弃)
           */
          key?: string
          /**
           * 参数值
           */
          value: string
        }
        /**
         * sku属性ID
         */
        skuAttributeId?: string
      }[]
      /**
       * SKU状态:0-无效 1-有效
       */
      skuStatus: number
      /**
       * 库存预警值
       */
      stockAlertCount: number
      /**
       * 用户单日限购量（0不限制）
       */
      userDayLimitPurchases: number
      /**
       * 用户限购量不能为空（0不限制）
       */
      userLimitPurchases: number
      /**
       * 重量(千克)
       */
      weight: number
    }[]
    /**
     * 剩余库存
     */
    surplusStock?: number
    /**
     * 上下架状态：-2-草稿 -1-待入库 0-待上架 1-上架 2-下架
     */
    upDownShelfStatus?: number
    /**
     * 标准核销商品规格列表
     */
    writeOffSkuList?: {
      /**
       * 13位国家69码
       */
      barCode?: string
      /**
       * 库存
       */
      commodityStock: number
      /**
       * 默认展示：0-否 1-是
       */
      defaultShow: number
      /**
       * 是否第三方库存:0-否 1-是
       */
      edgeStockStatus?: number
      /**
       * 能效级别
       */
      efficiencyLevel?: number
      /**
       * 结束库存日期
       */
      endStockDate: string
      /**
       * id
       */
      id?: string
      /**
       * 发票sku型号
       */
      invoiceSkuCode?: string
      /**
       * 单次核销价格
       */
      onePrice: number
      /**
       * 真实销量
       */
      sales?: number
      /**
       * 商品售价
       */
      sellPrice: number
      /**
       * 结算方式：0-固定金额 1-分层比例
       */
      settlementType: 0 | 1
      /**
       * 结算值
       */
      settlementValue: number
      /**
       * 商品单日限购量
       */
      singleDayLimitPurchases: number
      /**
       * 规格ID
       */
      skuId?: string
      /**
       * SKU图
       */
      skuPic: string
      /**
       * 规格状态： 0-无效 1-有效
       */
      skuStatus: 0 | 1
      /**
       * 规格名称
       */
      specName: string
      /**
       * 规格值
       */
      specValue: string
      /**
       * 特殊时间：0-无 1-周一至周五 2-周末 3-指定时间
       */
      specialTimeType: 0 | 1 | 2 | 3
      /**
       * 指定日期集合
       */
      specifyDates: unknown[]
      /**
       * 开始库存日期
       */
      startStockDate: string
      /**
       * 库存日期
       */
      stockDate: string
      /**
       * 库存类型：0-标准库存 3-日期库存
       */
      stockType: 0 | 1 | 2 | 3 | 4 | 5
      /**
       * 用户单日限购量
       */
      userDayLimitPurchases: number
      /**
       * 用户限购
       */
      userLimitPurchases: number
      /**
       * 可核销次数
       */
      writeOffNum: number
    }[]
  }[]
  /**
   * 记录总数
   */
  total: number
  /**
   * 总页数
   */
  totalPage: number
}

/**
 * 接口 [批量获取店铺线下商品↗](https://yapi.gogpay.cn/project/939/interface/api/477335) 的 **请求配置的类型**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantOfflineCommodity`
 */
type ApiCommodityCommonCommodityBatchMerchantOfflineCommodityRequestConfig =
  Readonly<
    RequestConfig<
      'https://yapi.gogpay.cn/mock/939',
      'https://mall-gw.duotest.cn',
      'https://mall-gw.gogpay.cn',
      '/commodity/api/commonCommodity/batchMerchantOfflineCommodity',
      'data',
      string,
      string,
      false
    >
  >

/**
 * 接口 [批量获取店铺线下商品↗](https://yapi.gogpay.cn/project/939/interface/api/477335) 的 **请求配置**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantOfflineCommodity`
 */
const apiCommodityCommonCommodityBatchMerchantOfflineCommodityRequestConfig: ApiCommodityCommonCommodityBatchMerchantOfflineCommodityRequestConfig =
  /*#__PURE__*/ {
    mockUrl: mockUrl_0_4_0_67,
    devUrl: devUrl_0_4_0_67,
    prodUrl: prodUrl_0_4_0_67,
    path: '/commodity/api/commonCommodity/batchMerchantOfflineCommodity',
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_4_0_67,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName:
      'apiCommodityCommonCommodityBatchMerchantOfflineCommodity',
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: { title: '批量获取店铺线下商品', author: '511号开发' },
  }

/**
 * 接口 [批量获取店铺线下商品↗](https://yapi.gogpay.cn/project/939/interface/api/477335) 的 **请求函数**
 *
 * @作者 511号开发
 * @分类 [前台-商家端门店商品信息↗](https://yapi.gogpay.cn/project/939/interface/api/cat_80671)
 * @请求头 `POST /commodity/api/commonCommodity/batchMerchantOfflineCommodity`
 */
export const apiCommodityCommonCommodityBatchMerchantOfflineCommodity =
  /*#__PURE__*/ (
    requestData: ApiCommodityCommonCommodityBatchMerchantOfflineCommodityRequest,
    ...args: UserRequestRestArgs
  ) => {
    return request<ApiCommodityCommonCommodityBatchMerchantOfflineCommodityResponse>(
      prepare(
        apiCommodityCommonCommodityBatchMerchantOfflineCommodityRequestConfig,
        requestData,
      ),
      ...args,
    )
  }

apiCommodityCommonCommodityBatchMerchantOfflineCommodity.requestConfig =
  apiCommodityCommonCommodityBatchMerchantOfflineCommodityRequestConfig

/* prettier-ignore-end */
